import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React$1 from 'react';
import React__default$1, { useState, useRef, useEffect, useCallback, useReducer, useMemo, useLayoutEffect, createContext, useContext, Children, isValidElement, cloneElement, Fragment as Fragment$1, memo, createElement } from 'react';
import { Box, Button as Button$1, Avatar, Spinner } from '@aicon-dev/caas-core';
import { GroupChannelListOrder, GroupChannelHandler, MessageCollectionInitPolicy, MessageFilter, GroupChannelModule } from '@sendbird/chat/groupChannel';
import { SendingStatus, ReplyType } from '@sendbird/chat/message';
import SendbirdChat, { CollectionEventSource, UserOnlineState } from '@sendbird/chat';
import styled, { css, createGlobalStyle } from 'styled-components';
import { OpenChannelModule } from '@sendbird/chat/openChannel';
import Axios from 'axios';
import { Modal, message as message$1 } from 'antd';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';
import List$4 from 'antd/es/list';
import Skeleton from 'antd/es/skeleton';
import message from 'antd/es/message';
import Popover from 'antd/es/popover';
import Empty from 'antd/es/empty';
import FroalaEditor from 'react-froala-wysiwyg';
import Image from 'antd/es/image';
import Tooltip from 'antd/es/tooltip';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function () {
  __assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$2(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const sbuConstants = {
  collection: {
    groupChannel: {
      defaultLimit: 20,
      defaultOrder: GroupChannelListOrder.LATEST_LAST_MESSAGE,
      defaultIncludeEmpty: false
    },
    message: {
      defaultLimit: {
        next: 25,
        prev: 25
      },
      searchLimit: {
        next: 10,
        prev: 10
      }
    }
  }
};

undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

let id$1 = 0;
function useUniqId() {
  return useState(() => `${id$1++}`)[0];
}

const useGroupChannelHandler = (sdk, hookHandler, handlerId) => {
  const handlerRef = useRef(hookHandler);
  const id = useUniqId();
  const internalHandlerId = handlerId !== null && handlerId !== void 0 ? handlerId : id;
  handlerRef.current = hookHandler;
  useEffect(() => {
    var _a;
    const handlerMapper = handler => {
      const handlerKeys = Object.keys(handler);
      handlerKeys.forEach(key => {
        // @ts-ignore
        handler[key] = (...args) => {
          var _a, _b;
          return (_b = (_a = handlerRef.current) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
        };
      });
      return handler;
    };
    (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.addGroupChannelHandler(internalHandlerId, handlerMapper(new GroupChannelHandler()));
    return () => {
      var _a;
      (_a = sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel) === null || _a === void 0 ? void 0 : _a.removeGroupChannelHandler(internalHandlerId);
    };
  }, [sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel, internalHandlerId]);
};

/**
 * Preserves a reference to the given callback function as an argument while the component is mounted.
 * Wraps the given callback in React's Ref to preserve the reference.
 * @param callback want to be preserved
 */
function usePreservedCallback(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  // useEffect(() => {
  //   callbackRef.current = callback;
  // });
  return useCallback((...args) => callbackRef.current(...args), [callbackRef]);
}

undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

/**
 * Diff utils for channel
 * @param {BaseChannel} [a]
 * @param {BaseChannel} [b]
 * @returns {boolean}
 * */
function isDifferentChannel(a, b) {
  if (!a || !b) return true;
  return a.url !== b.url;
}

function isSendableMessage(msg) {
  return msg !== undefined && msg !== null && 'sendingStatus' in msg;
}
function isMyMessage(msg, currentUserId = '##__USER_ID_IS_NOT_PROVIDED__##') {
  var _a;
  if (!isSendableMessage(msg)) return false;
  return ((_a = msg.sender) === null || _a === void 0 ? void 0 : _a.userId) === currentUserId;
}
function isNewMessage(msg, currentUserId) {
  const myMessage = isMyMessage(msg, currentUserId);
  if (myMessage) return false;
  if (msg.isAdminMessage()) return false;
  return msg.updatedAt === 0;
}
function getMessageUniqId(msg) {
  if ('sendingStatus' in msg) {
    if (msg.sendingStatus === 'succeeded') return String(msg.messageId);
    return msg.reqId;
  }
  return String(msg.messageId);
}

// NOTE: type guard fix for optional chaining - https://github.com/microsoft/TypeScript/pull/55613
function isNotEmptyArray(arr) {
  if (!arr || !Array.isArray(arr)) return false;
  return arr.length !== 0;
}

const useForceUpdate = () => {
  const [, updater] = useState(0);
  return useCallback(() => updater(prev => prev + 1), []);
};

function arrayToMapWithGetter(arr, getSelector) {
  return arr.reduce((accum, curr) => {
    const _key = getSelector(curr);
    accum[_key] = curr;
    return accum;
  }, {});
}

var __rest$1 = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const defaultReducer = (_a, action) => {
  var draft = __rest$1(_a, []);
  switch (action.type) {
    case 'update_initialized':
      {
        draft['initialized'] = action.value.status;
        return draft;
      }
    case 'update_refreshing':
      {
        draft['refreshing'] = action.value.status;
        return draft;
      }
    case 'update_loading':
      {
        draft['loading'] = action.value.status;
        return draft;
      }
    case 'update_messages':
      {
        const userId = action.value.currentUserId;
        if (action.value.clearBeforeAction) {
          draft['messageMap'] = messagesToObject(action.value.messages);
        } else {
          // Filtering meaningless message updates
          const nextMessages = action.value.messages.filter(next => {
            var _a;
            if (isMyMessage(next, userId)) {
              const prev = (_a = draft['messageMap'][next.reqId]) !== null && _a !== void 0 ? _a : draft['messageMap'][next.messageId];
              if (isMyMessage(prev, userId)) {
                const shouldUpdate = shouldUpdateMessage(prev, next);
                if (shouldUpdate) {
                  // Remove existing messages before update to prevent duplicate display
                  delete draft['messageMap'][prev.reqId];
                  delete draft['messageMap'][prev.messageId];
                }
                return shouldUpdate;
              }
            }
            return true;
          });
          const obj = messagesToObject(nextMessages);
          draft['messageMap'] = Object.assign(Object.assign({}, draft['messageMap']), obj);
        }
        return draft;
      }
    case 'update_new_messages':
      {
        const userId = action.value.currentUserId;
        const newMessages = action.value.messages.filter(it => isNewMessage(it, userId));
        if (action.value.clearBeforeAction) {
          draft['newMessageMap'] = arrayToMapWithGetter(newMessages, getMessageUniqId);
        } else {
          // Remove existing messages before update to prevent duplicate display
          const messageKeys = newMessages.map(it => it.messageId);
          messageKeys.forEach(key => delete draft['newMessageMap'][key]);
          draft['newMessageMap'] = Object.assign(Object.assign({}, draft['newMessageMap']), arrayToMapWithGetter(newMessages, getMessageUniqId));
        }
        return draft;
      }
    case 'delete_messages':
    case 'delete_new_messages':
      {
        const key = action.type === 'delete_messages' ? 'messageMap' : 'newMessageMap';
        draft[key] = Object.assign({}, draft[key]);
        action.value.messageIds.forEach(msgId => {
          const message = draft[key][msgId];
          if (message) {
            if (isSendableMessage(message)) delete draft[key][message.reqId];
            delete draft[key][message.messageId];
          }
        });
        action.value.reqIds.forEach(reqId => {
          const message = draft[key][reqId];
          if (message) {
            if (isSendableMessage(message)) delete draft[key][message.reqId];
            delete draft[key][message.messageId];
          }
        });
        return draft;
      }
  }
};
const messagesToObject = messages => {
  return messages.reduce((accum, curr) => {
    if (isSendableMessage(curr)) {
      accum[curr.reqId] = curr;
      if (curr.sendingStatus === SendingStatus.SUCCEEDED) {
        accum[curr.messageId] = curr;
      }
    } else {
      accum[curr.messageId] = curr;
    }
    return accum;
  }, {});
};
const shouldUpdateMessage = (prev, next) => {
  // message data update (e.g. reactions)
  if (prev.sendingStatus === SendingStatus.SUCCEEDED) return next.sendingStatus === SendingStatus.SUCCEEDED;
  // message sending status update
  return prev.sendingStatus !== next.sendingStatus;
};
const useChannelMessagesReducer = (sortComparator = defaultMessageComparator) => {
  const [{
    initialized,
    loading,
    refreshing,
    messageMap,
    newMessageMap
  }, dispatch] = useReducer(defaultReducer, {
    initialized: false,
    loading: true,
    refreshing: false,
    messageMap: {},
    newMessageMap: {}
  });
  const updateMessages = (messages, clearBeforeAction, currentUserId) => {
    dispatch({
      type: 'update_messages',
      value: {
        messages,
        clearBeforeAction,
        currentUserId
      }
    });
  };
  const deleteMessages = (messageIds, reqIds) => {
    dispatch({
      type: 'delete_messages',
      value: {
        messageIds,
        reqIds
      }
    });
  };
  const updateNewMessages = (messages, clearBeforeAction, currentUserId) => {
    dispatch({
      type: 'update_new_messages',
      value: {
        messages,
        clearBeforeAction,
        currentUserId
      }
    });
  };
  const deleteNewMessages = (messageIds, reqIds) => {
    dispatch({
      type: 'delete_new_messages',
      value: {
        messageIds,
        reqIds
      }
    });
  };
  const updateInitialized = status => {
    dispatch({
      type: 'update_initialized',
      value: {
        status
      }
    });
  };
  const updateLoading = status => {
    dispatch({
      type: 'update_loading',
      value: {
        status
      }
    });
  };
  const updateRefreshing = status => {
    dispatch({
      type: 'update_refreshing',
      value: {
        status
      }
    });
  };
  const newMessages = Object.values(newMessageMap);
  const messages = useMemo(() => Array.from(new Set(Object.values(messageMap))).sort(sortComparator), [messageMap]);
  return {
    updateInitialized,
    updateLoading,
    updateRefreshing,
    updateMessages,
    deleteMessages,
    initialized,
    loading,
    refreshing,
    messages,
    newMessages,
    updateNewMessages,
    deleteNewMessages
  };
};
const LARGE_OFFSET = Math.floor(Number.MAX_SAFE_INTEGER / 10);
function defaultMessageComparator(a, b) {
  let aStatusOffset = 0;
  let bStatusOffset = 0;
  if (isSendableMessage(a) && a.sendingStatus !== 'succeeded') aStatusOffset = LARGE_OFFSET;
  if (isSendableMessage(b) && b.sendingStatus !== 'succeeded') bStatusOffset = LARGE_OFFSET;
  return a.createdAt + aStatusOffset - (b.createdAt + bStatusOffset);
}

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const createMessageCollection = (channel, limit, options) => {
  var _a;
  const basicParams = {
    prevResultLimit: limit.prev,
    nextResultLimit: limit.next,
    startingPoint: options === null || options === void 0 ? void 0 : options.startingPoint,
    replyType: options === null || options === void 0 ? void 0 : options.replyType
  };
  const passedCollection = (_a = options === null || options === void 0 ? void 0 : options.collectionCreator) === null || _a === void 0 ? void 0 : _a.call(options, basicParams);
  if (passedCollection) return passedCollection;
  return channel.createMessageCollection(Object.assign(Object.assign({}, basicParams), {
    filter: new MessageFilter(basicParams)
  }));
};
// NOTE: In React-Native's FlatList, the bidirectional message loading doesn't work reliably, causing a bug
//  where scrolling jumps to a random position when loading a large number of messages at once.
//  Therefore, in the message search that explores past messages, a small number of messages is loaded to address this issue.
function getCollectionLimitBy(startingPoint) {
  return startingPoint < Date.now() ? sbuConstants.collection.message.searchLimit : sbuConstants.collection.message.defaultLimit;
}
/**
 * group channel messages hook
 * - Receive new messages from other users & should count new messages -> append to state(newMessages)
 * - onTopReached -> prev() -> fetch prev messages and append to state(messages)
 * - onBottomReached -> next() -> fetch next messages and append to state(messages)
 * */
const useGroupChannelMessages = (sdk, channel, options = {}) => {
  var _a, _b, _c;
  const internalOptions = useRef(options); // to keep reference of options in event handler
  internalOptions.current = options;
  const channelRef = useRef(channel); // to keep reference of channel in event handler
  channelRef.current = channel;
  const logger = internalOptions.current.logger;
  const initialStartingPoint = (_a = internalOptions.current.startingPoint) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER;
  const initialLimit = getCollectionLimitBy(initialStartingPoint);
  const isFetching = useRef({
    prev: false,
    next: false
  });
  const forceUpdate = useForceUpdate();
  const collectionRef = useRef({
    initialized: false,
    apiInitialized: false,
    instance: null
  });
  const {
    initialized,
    loading,
    refreshing,
    messages,
    newMessages,
    updateMessages,
    updateNewMessages,
    deleteNewMessages,
    deleteMessages,
    updateInitialized,
    updateLoading,
    updateRefreshing
  } = useChannelMessagesReducer(options === null || options === void 0 ? void 0 : options.sortComparator);
  const markAsReadBySource = usePreservedCallback(source => {
    var _a, _b, _c, _d;
    if (!channelRef.current || !channelRef.current.url) return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
    try {
      switch (source) {
        case CollectionEventSource.EVENT_MESSAGE_RECEIVED:
        case CollectionEventSource.EVENT_MESSAGE_SENT_SUCCESS:
        case CollectionEventSource.SYNC_MESSAGE_FILL:
        case undefined:
          (_c = (_b = internalOptions.current).markAsRead) === null || _c === void 0 ? void 0 : _c.call(_b, [channelRef.current]);
          break;
      }
    } catch (e) {
      (_d = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _d === void 0 ? void 0 : _d.call(logger, '[useGroupChannelMessages/markAsReadBySource]', e);
    }
  });
  const updateNewMessagesReceived = usePreservedCallback((source, messages) => {
    var _a, _b, _c, _d, _e;
    const incomingMessages = messages.filter(it => {
      var _a;
      return !isMyMessage(it, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
    });
    if (incomingMessages.length > 0) {
      switch (source) {
        case CollectionEventSource.EVENT_MESSAGE_RECEIVED:
        case CollectionEventSource.SYNC_MESSAGE_FILL:
          {
            if ((_b = (_a = internalOptions.current).shouldCountNewMessages) === null || _b === void 0 ? void 0 : _b.call(_a)) {
              updateNewMessages(incomingMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
            }
            (_e = (_d = internalOptions.current).onMessagesReceived) === null || _e === void 0 ? void 0 : _e.call(_d, incomingMessages);
            break;
          }
      }
    }
  });
  const init = usePreservedCallback((startingPoint, limit) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise(resolve => {
      var _a, _b;
      if (!channelRef.current || !channelRef.current.url) return (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
      if (collectionRef.current.instance) collectionRef.current.instance.dispose();
      markAsReadBySource();
      updateNewMessages([], true, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId);
      const updateUnsentMessages = () => {
        var _a, _b, _c;
        const {
          pendingMessages,
          failedMessages
        } = (_a = collectionRef.current.instance) !== null && _a !== void 0 ? _a : {};
        if (isNotEmptyArray(pendingMessages)) updateMessages(pendingMessages, false, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId);
        if (isNotEmptyArray(failedMessages)) updateMessages(failedMessages, false, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
      };
      const collectionInstance = createMessageCollection(channelRef.current, limit, Object.assign(Object.assign({}, internalOptions.current), {
        startingPoint
      }));
      collectionRef.current = {
        apiInitialized: false,
        initialized: false,
        instance: collectionInstance
      };
      collectionInstance.setMessageCollectionHandler({
        onMessagesAdded: (ctx, __, messages) => {
          var _a;
          markAsReadBySource(ctx.source);
          updateNewMessagesReceived(ctx.source, messages);
          updateMessages(messages, false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        },
        onMessagesUpdated: (ctx, __, messages) => {
          var _a, _b, _c;
          markAsReadBySource(ctx.source);
          updateNewMessagesReceived(ctx.source, messages); // NOTE: admin message is not added via onMessagesAdded handler, not checked yet is this a bug.
          updateMessages(messages, false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
          if (ctx.source === CollectionEventSource.EVENT_MESSAGE_UPDATED) {
            (_c = (_b = internalOptions.current).onMessagesUpdated) === null || _c === void 0 ? void 0 : _c.call(_b, messages);
          }
        },
        onMessagesDeleted: (_, __, ___, messages) => {
          const msgIds = messages.map(it => it.messageId);
          const reqIds = messages.filter(isSendableMessage).map(it => it.reqId);
          deleteMessages(msgIds, reqIds);
          deleteNewMessages(msgIds, reqIds);
        },
        onChannelDeleted: (_, channelUrl) => {
          var _a, _b;
          (_b = (_a = internalOptions.current).onChannelDeleted) === null || _b === void 0 ? void 0 : _b.call(_a, channelUrl);
        },
        onChannelUpdated: (_, channel) => {
          var _a, _b;
          forceUpdate();
          (_b = (_a = internalOptions.current).onChannelUpdated) === null || _b === void 0 ? void 0 : _b.call(_a, channel);
        },
        onHugeGapDetected: () => {
          init(Number.MAX_SAFE_INTEGER, sbuConstants.collection.message.defaultLimit);
        }
      });
      collectionInstance.initialize(MessageCollectionInitPolicy.CACHE_AND_REPLACE_BY_API).onCacheResult((err, messages) => {
        var _a, _b, _c;
        if (err) sdk.isCacheEnabled && ((_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages/onCacheResult]', err));else if (messages) {
          (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelMessages/onCacheResult]', 'message length:', messages.length);
          updateMessages(messages, true, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
          updateUnsentMessages();
          // Note: If there are messages exchanged in the channel but no cached messages have been saved yet,
          //  to prevent the API-retrieved messages from appearing immediately after the 'no messages' UI is displayed,
          //  resolve only when there are messages present in the cache
          if (messages.length > 0) {
            collectionRef.current.initialized = true;
            resolve();
          }
        }
      }).onApiResult((err, messages) => {
        var _a, _b, _c, _d, _e;
        if (err) (_a = logger === null || logger === void 0 ? void 0 : logger.warn) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages/onApiResult]', err);else if (messages) {
          (_b = logger === null || logger === void 0 ? void 0 : logger.debug) === null || _b === void 0 ? void 0 : _b.call(logger, '[useGroupChannelMessages/onApiResult]', 'message length:', messages.length);
          updateMessages(messages, true, (_c = sdk.currentUser) === null || _c === void 0 ? void 0 : _c.userId);
          if (!internalOptions.current.startingPoint) (_e = (_d = internalOptions.current).onMessagesReceived) === null || _e === void 0 ? void 0 : _e.call(_d, messages);
          if (sdk.isCacheEnabled) updateUnsentMessages();
        }
        collectionRef.current.initialized = true;
        collectionRef.current.apiInitialized = true;
        resolve();
      });
    });
  }));
  useGroupChannelHandler(sdk, {
    onUserBanned(eventChannel, bannedUser) {
      var _a, _b, _c;
      if (eventChannel.isGroupChannel() && !isDifferentChannel(eventChannel, channelRef.current)) {
        if (bannedUser.userId === ((_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId)) {
          (_c = (_b = internalOptions.current).onCurrentUserBanned) === null || _c === void 0 ? void 0 : _c.call(_b);
        } else {
          forceUpdate();
        }
      }
    }
  });
  useLayoutEffect(() => {
    const timeout = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
      if (sdk.currentUser && channelRef.current) {
        updateInitialized(false);
        updateLoading(true);
        yield init(initialStartingPoint, initialLimit);
        updateLoading(false);
        updateInitialized(true);
      }
    }));
    return () => clearTimeout(timeout);
  }, [sdk, (_b = sdk.currentUser) === null || _b === void 0 ? void 0 : _b.userId, (_c = channelRef.current) === null || _c === void 0 ? void 0 : _c.url, internalOptions.current.replyType]);
  useEffect(() => {
    return () => {
      if (collectionRef.current.instance) collectionRef.current.instance.dispose();
    };
  }, []);
  const refresh = usePreservedCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (sdk.currentUser && channelRef.current) {
      updateRefreshing(true);
      yield init(Number.MAX_SAFE_INTEGER, sbuConstants.collection.message.defaultLimit);
      updateRefreshing(false);
    }
  }));
  const loadPrevious = usePreservedCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    var _d;
    const collection = collectionRef.current.instance;
    if ((collection === null || collection === void 0 ? void 0 : collection.hasPrevious) && !isFetching.current.prev) {
      try {
        isFetching.current.prev = true;
        const list = yield collection.loadPrevious();
        updateMessages(list, false, (_d = sdk.currentUser) === null || _d === void 0 ? void 0 : _d.userId);
      } catch (_e) {
        // noop
      } finally {
        isFetching.current.prev = false;
      }
    }
  }));
  const hasPrevious = usePreservedCallback(() => {
    const {
      initialized,
      instance
    } = collectionRef.current;
    if (initialized && instance) {
      return instance.hasPrevious;
    } else {
      return false;
    }
  });
  const loadNext = usePreservedCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    var _f;
    const collection = collectionRef.current.instance;
    if ((collection === null || collection === void 0 ? void 0 : collection.hasNext) && !isFetching.current.next) {
      try {
        isFetching.current.next = true;
        const list = yield collection.loadNext();
        updateMessages(list, false, (_f = sdk.currentUser) === null || _f === void 0 ? void 0 : _f.userId);
      } catch (_g) {
        // noop
      } finally {
        isFetching.current.next = false;
      }
    }
  }));
  const hasNext = usePreservedCallback(() => {
    // When the API is not initialized, the default value of collection.hasNext is true.
    // Due to this, there is an issue with UI elements such as the scroll to bottom button appearing and disappearing.
    // To address this, we additionally check the API initialized state.
    const {
      initialized,
      apiInitialized,
      instance
    } = collectionRef.current;
    if (apiInitialized && initialized && instance) {
      return instance.hasNext;
    } else {
      return false;
    }
  });
  const sendUserMessage = usePreservedCallback((params, onPending) => {
    var _a;
    if (!channelRef.current || !channelRef.current.url) {
      (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    return new Promise((resolve, reject) => {
      channelRef.current.sendUserMessage(params).onPending(pendingMessage => {
        var _a;
        if (pendingMessage.channelUrl === channelRef.current.url) {
          updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
      }).onSucceeded(sentMessage => {
        var _a;
        if (sentMessage.channelUrl === channelRef.current.url) {
          updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        resolve(sentMessage);
      }).onFailed((err, failedMessage) => {
        var _a;
        if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
          updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        reject(err);
      });
    });
  });
  const sendFileMessage = usePreservedCallback((params, onPending) => {
    var _a;
    if (!channelRef.current || !channelRef.current.url) {
      (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    return new Promise((resolve, reject) => {
      channelRef.current.sendFileMessage(params).onPending(pendingMessage => {
        var _a;
        if (pendingMessage.channelUrl === channelRef.current.url) {
          updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
      }).onSucceeded(sentMessage => {
        var _a;
        if (sentMessage.channelUrl === channelRef.current.url) {
          updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        resolve(sentMessage);
      }).onFailed((err, failedMessage) => {
        var _a;
        if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
          updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        reject(err);
      });
    });
  });
  const sendFileMessages = usePreservedCallback((paramsList, onPending) => __awaiter(void 0, void 0, void 0, function* () {
    var _h;
    if (!channelRef.current || !channelRef.current.url) {
      (_h = logger === null || logger === void 0 ? void 0 : logger.error) === null || _h === void 0 ? void 0 : _h.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    return new Promise(resolve => {
      const messages = [];
      channelRef.current.sendFileMessages(paramsList).onPending(pendingMessage => {
        var _a;
        if (pendingMessage.channelUrl === channelRef.current.url) {
          updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
      }).onSucceeded(sentMessage => {
        var _a;
        if (sentMessage.isFileMessage() && sentMessage.channelUrl === channelRef.current.url) {
          updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
          messages.push(sentMessage);
        }
        if (messages.length === paramsList.length) resolve(messages);
      }).onFailed((_, failedMessage) => {
        var _a;
        if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
          updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
          messages.push(failedMessage);
        } else {
          // NOTE: Since failedMessage is nullable by type, to resolve the promise, handle pushing null even when there is no failedMessage.
          messages.push(null);
        }
        if (messages.length === paramsList.length) resolve(messages);
      });
    });
  }));
  const sendMultipleFilesMessage = usePreservedCallback((params, onPending) => {
    var _a;
    if (!channelRef.current || !channelRef.current.url) {
      (_a = logger === null || logger === void 0 ? void 0 : logger.error) === null || _a === void 0 ? void 0 : _a.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    return new Promise((resolve, reject) => {
      channelRef.current.sendMultipleFilesMessage(params).onPending(pendingMessage => {
        var _a;
        if (pendingMessage.channelUrl === channelRef.current.url) {
          updateMessages([pendingMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        onPending === null || onPending === void 0 ? void 0 : onPending(pendingMessage);
      }).onFileUploaded(() => {
        // Just re-render to use updated message.messageParams
        forceUpdate();
      }).onSucceeded(sentMessage => {
        var _a;
        if (sentMessage.channelUrl === channelRef.current.url) {
          updateMessages([sentMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        resolve(sentMessage);
      }).onFailed((err, failedMessage) => {
        var _a;
        if (failedMessage && failedMessage.channelUrl === channelRef.current.url) {
          updateMessages([failedMessage], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
        }
        reject(err);
      });
    });
  });
  const updateUserMessage = usePreservedCallback((messageId, params) => __awaiter(void 0, void 0, void 0, function* () {
    var _j, _k;
    if (!channelRef.current || !channelRef.current.url) {
      (_j = logger === null || logger === void 0 ? void 0 : logger.error) === null || _j === void 0 ? void 0 : _j.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    const updatedMessage = yield channelRef.current.updateUserMessage(messageId, params);
    if (updatedMessage.channelUrl === channelRef.current.url) {
      updateMessages([updatedMessage], false, (_k = sdk.currentUser) === null || _k === void 0 ? void 0 : _k.userId);
    }
    return updatedMessage;
  }));
  const updateFileMessage = usePreservedCallback((messageId, params) => __awaiter(void 0, void 0, void 0, function* () {
    var _l, _m;
    if (!channelRef.current || !channelRef.current.url) {
      (_l = logger === null || logger === void 0 ? void 0 : logger.error) === null || _l === void 0 ? void 0 : _l.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    const updatedMessage = yield channelRef.current.updateFileMessage(messageId, params);
    if (updatedMessage.channelUrl === channelRef.current.url) {
      updateMessages([updatedMessage], false, (_m = sdk.currentUser) === null || _m === void 0 ? void 0 : _m.userId);
    }
    return updatedMessage;
  }));
  const resendMessage = usePreservedCallback(failedMessage => __awaiter(void 0, void 0, void 0, function* () {
    var _o;
    if (!channelRef.current || !channelRef.current.url) {
      (_o = logger === null || logger === void 0 ? void 0 : logger.error) === null || _o === void 0 ? void 0 : _o.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    return new Promise((resolve, reject) => {
      let handler = undefined;
      if (failedMessage.isUserMessage()) handler = channelRef.current.resendMessage(failedMessage);
      if (failedMessage.isFileMessage()) handler = channelRef.current.resendMessage(failedMessage);
      if (failedMessage.isMultipleFilesMessage()) handler = channelRef.current.resendMessage(failedMessage);
      if (handler) {
        if ('onPending' in handler) {
          handler.onPending(message => {
            var _a;
            if (message.channelUrl === channelRef.current.url) {
              updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
            }
          });
        }
        if ('onFileUploaded' in handler) {
          handler.onFileUploaded(() => {
            // Just re-render to use updated message.messageParams
            forceUpdate();
          });
        }
        if ('onSucceeded' in handler) {
          handler.onSucceeded(message => {
            var _a;
            if (message.channelUrl === channelRef.current.url) {
              updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
            }
            resolve(message);
          });
        }
        if ('onFailed' in handler) {
          handler.onFailed((err, message) => {
            var _a;
            if (message && message.channelUrl === channelRef.current.url) {
              updateMessages([message], false, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
            }
            reject(err);
          });
        }
      }
    });
  }));
  const deleteMessage = usePreservedCallback(message => __awaiter(void 0, void 0, void 0, function* () {
    var _p, _q;
    if (!channelRef.current || !channelRef.current.url) {
      (_p = logger === null || logger === void 0 ? void 0 : logger.error) === null || _p === void 0 ? void 0 : _p.call(logger, '[useGroupChannelMessages] channel is required');
      throw new Error('Channel is required');
    }
    if (message.sendingStatus === 'succeeded') {
      if (message.isUserMessage()) yield channelRef.current.deleteMessage(message);
      if (message.isFileMessage()) yield channelRef.current.deleteMessage(message);
      if (message.isMultipleFilesMessage()) yield channelRef.current.deleteMessage(message);
    } else {
      try {
        yield (_q = collectionRef.current.instance) === null || _q === void 0 ? void 0 : _q.removeFailedMessage(message.reqId);
      } finally {
        deleteMessages([message.messageId], [message.reqId]);
      }
    }
  }));
  const resetNewMessages = usePreservedCallback(() => {
    var _a;
    updateNewMessages([], true, (_a = sdk.currentUser) === null || _a === void 0 ? void 0 : _a.userId);
  });
  const resetWithStartingPoint = usePreservedCallback(startingPoint => __awaiter(void 0, void 0, void 0, function* () {
    var _r;
    if (sdk.currentUser && channelRef.current) {
      const limit = getCollectionLimitBy(startingPoint);
      updateLoading(true);
      updateMessages([], true, (_r = sdk.currentUser) === null || _r === void 0 ? void 0 : _r.userId);
      yield init(startingPoint, limit);
      updateLoading(false);
    }
  }));
  return {
    /**
     * Initialized state, only available on first render
     * */
    initialized,
    /**
     * Loading state, status is changes on first mount or when the resetWithStartingPoint is called.
     * */
    loading,
    /**
     * Refreshing state, status is changes when the refresh is called.
     * */
    refreshing,
    /**
     * Get messages, this state is for render
     * For example, if a user receives a new messages while searching for an old message
     * for this case, new messages will be included here.
     * */
    messages,
    /**
     * If the `shouldCountNewMessages()` is true, only then push in the newMessages state.
     * (Return false for the `shouldCountNewMessages()` if the message scroll is the most recent; otherwise, return true.)
     *
     * A new message means a message that meets the below conditions
     * - Not admin message
     * - Not updated message
     * - Not current user's message
     * */
    newMessages,
    /**
     * Reset new message list
     * @return {void}
     * */
    resetNewMessages,
    /**
     * Reset message list and create a new collection for latest messages
     * @return {Promise<void>}
     * */
    refresh,
    /**
     * Load previous messages to state
     * @return {Promise<void>}
     * */
    loadPrevious,
    /**
     * Check if there are more previous messages to fetch
     * @return {boolean}
     * */
    hasPrevious,
    /**
     * Load next messages to state
     * @return {Promise<void>}
     * */
    loadNext,
    /**
     * Check if there are more next messages to fetch
     * @return {boolean}
     * */
    hasNext,
    /**
     * Send user message
     * @param {UserMessageCreateParams} params user message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<UserMessage>} succeeded message
     * */
    sendUserMessage,
    /**
     * Send file message
     * @param {FileMessageCreateParams} params file message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<FileMessage>} succeeded message
     * */
    sendFileMessage,
    /**
     * Send file messages
     * @param {FileMessageCreateParams[]} paramList file message create params
     * @param {function} [onPending] pending message callback for each message request
     * @return {Promise<FileMessage[]>} succeeded or failed message
     * */
    sendFileMessages,
    /**
     * Send multiple files message
     * @param {MultipleFilesMessageCreateParams} params multiple files message create params
     * @param {function} [onPending] pending message callback
     * @return {Promise<MultipleFilesMessage>} succeeded message
     * */
    sendMultipleFilesMessage,
    /**
     * Update user message
     * @param {number} messageId
     * @param {UserMessageUpdateParams} params user message update params
     * @return {Promise<UserMessage>}
     * */
    updateUserMessage,
    /**
     * Update file message
     * @param {number} messageId
     * @param {FileMessageUpdateParams} params file message update params
     * @return {Promise<FileMessage>}
     * */
    updateFileMessage,
    /**
     * Resend failed message
     * @template {UserMessage | FileMessage | MultipleFilesMessage} T
     * @param {T} failedMessage message to resend
     * @return {Promise<T>}
     * */
    resendMessage,
    /**
     * Delete a message
     * @template {UserMessage | FileMessage | MultipleFilesMessage} T
     * @param {T} message succeeded or failed message
     * @return {Promise<void>}
     * */
    deleteMessage,
    /**
     * Reset message list and create a new collection with starting point
     * @param {number} startingPoint
     * @param {function} callback
     * @return {void}
     * */
    resetWithStartingPoint,
    /**
     * Do not use this api
     * */
    _dangerous_reducer_updateMessages: updateMessages,
    /**
     * Do not use this api
     * */
    _dangerous_reducer_deleteMessages: deleteMessages
  };
};

const createInitialConfig = () => ({
  common: {
    enableUsingDefaultUserProfile: false
  },
  groupChannel: {
    channel: {
      enableMention: false,
      enableOgtag: true,
      enableReactions: true,
      enableReactionsSupergroup: false,
      enableTypingIndicator: true,
      enableVoiceMessage: false,
      input: {
        camera: {
          enablePhoto: true,
          enableVideo: true
        },
        enableDocument: true,
        gallery: {
          enablePhoto: true,
          enableVideo: true
        }
      },
      replyType: 'quote_reply',
      threadReplySelectType: 'thread',
      typingIndicatorTypes: new Set(['text']),
      enableFeedback: false,
      enableSuggestedReplies: false,
      showSuggestedRepliesFor: 'last_message_only',
      suggestedRepliesDirection: 'vertical'
    },
    channelList: {
      enableMessageReceiptStatus: false,
      enableTypingIndicator: false
    },
    setting: {
      enableMessageSearch: false
    }
  },
  openChannel: {
    channel: {
      enableOgtag: true,
      input: {
        camera: {
          enablePhoto: true,
          enableVideo: true
        },
        enableDocument: true,
        gallery: {
          enablePhoto: true,
          enableVideo: true
        }
      }
    }
  }
});
function deleteLocalConfigs(config) {
  // @ts-ignore
  delete config.groupChannel.channel.typingIndicatorTypes;
  // @ts-ignore
  delete config.groupChannel.channel.enableFeedback;
  // @ts-ignore
  delete config.groupChannel.channel.enableSuggestedReplies;
  // @ts-ignore
  delete config.groupChannel.channel.showSuggestedRepliesFor;
  // @ts-ignore
  delete config.groupChannel.channel.suggestedRepliesDirection;
  return config;
}
const createInitialRemoteConfig = () => {
  const config = createInitialConfig();
  return deleteLocalConfigs(config);
};
const initialConfig = createInitialConfig();
createInitialRemoteConfig();

undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
createContext({
  initDashboardConfigs: () => Promise.resolve(),
  configs: initialConfig,
  configsWithAppAttr: () => initialConfig
});

var ChannelMessagesContext = React__default$1.createContext(null);
var ChannelMessagesProvider = function (props) {
  var sdk = props.sdk,
    children = props.children,
    channel = props.channel,
    startingPoint = props.startingPoint;
  var messageDataSource = useGroupChannelMessages(sdk, channel, {
    startingPoint: startingPoint,
    collectionCreator: getCollectionCreator(channel, {
      startingPoint: startingPoint,
      replyType: ReplyType.ALL
    }),
    // shouldCountNewMessages() {
    //   return true;
    // },
    markAsRead: function (channels) {
      channels.forEach(function (it) {
        if (it.url === channel.url) {
          channel.markAsRead();
        } else {
          it.markAsRead();
        }
      });
    }
  });
  useEffect(function () {
    if (startingPoint) {
      messageDataSource.resetWithStartingPoint(startingPoint);
    } else {
      messageDataSource.resetWithStartingPoint(Number.MAX_SAFE_INTEGER);
    }
  }, [startingPoint]);
  return jsx(ChannelMessagesContext.Provider, {
    value: {
      sdk: sdk,
      channel: channel,
      startingPoint: startingPoint,
      messageDataSource: messageDataSource
    },
    children: children
  });
};
var useChannelMessagesContext = function () {
  var context = useContext(ChannelMessagesContext);
  if (!context) throw new Error('ChannelMessagesContext not found. Use within the ChannelMessages module.');
  return context;
};
function getCollectionCreator(groupChannel, messageListQueryParams) {
  return function (defaultParams) {
    var params = __assign$1(__assign$1(__assign$1({}, defaultParams), {
      prevResultLimit: 30,
      nextResultLimit: 30
    }), messageListQueryParams);
    return groupChannel.createMessageCollection(__assign$1(__assign$1({}, params), {
      filter: new MessageFilter(params)
    }));
  };
}

var breakPoint = {
  small: 414,
  medium: 768,
  large: 1024,
  xLarge: 1200,
  xxLarge: 1400,
  wide: 1600,
  xWide: 1920
};
var mobileStyle = function (literals) {
  var args = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }
  return css(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  @media (max-width: ", "px) {\n    ", "\n  }\n"], ["\n  @media (max-width: ", "px) {\n    ", "\n  }\n"])), breakPoint.large, css.apply(void 0, __spreadArray([literals], args, false)));
};
var templateObject_1$R;

css(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    border: 4px solid transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(107, 110, 113, 0.5);\n    background-clip: padding-box;\n    border: 2px solid transparent;\n    border-radius: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n"], ["\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    border: 4px solid transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(107, 110, 113, 0.5);\n    background-clip: padding-box;\n    border: 2px solid transparent;\n    border-radius: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n"])));
var chatCustomScrollBar = css(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  overflow: auto;\n  overflow-x: hidden;\n  padding-right: 0;\n\n  &::-webkit-scrollbar {\n    width: var(--scroll-padding, 4px);\n    height: var(--scroll-padding, 4px);\n  }\n\n  &::-webkit-scrollbar-track {\n    border: 0;\n  }\n\n  &::-webkit-scrollbar-button {\n    width: 0;\n    height: 0;\n    display: none;\n  }\n\n  &::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    min-height: 20%;\n    min-height: 65px;\n    /* border: 4px solid var(--scroll-background, rgba(255, 255, 255)); */\n    border-radius: 8px;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.1) !important;\n    }\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n"], ["\n  overflow: auto;\n  overflow-x: hidden;\n  padding-right: 0;\n\n  &::-webkit-scrollbar {\n    width: var(--scroll-padding, 4px);\n    height: var(--scroll-padding, 4px);\n  }\n\n  &::-webkit-scrollbar-track {\n    border: 0;\n  }\n\n  &::-webkit-scrollbar-button {\n    width: 0;\n    height: 0;\n    display: none;\n  }\n\n  &::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    min-height: 20%;\n    min-height: 65px;\n    /* border: 4px solid var(--scroll-background, rgba(255, 255, 255)); */\n    border-radius: 8px;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.1) !important;\n    }\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n"])));
var ChatGlobalStyle = createGlobalStyle(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  :root {\n    --chat-header-height: 70px;\n    --chat-aside-width: 340px;\n\n    --chat-color-primary: #1890FF;\n    --chat-color-secondary: #1982C4;\n    --chat-background: white;\n    --chat-border-color: #E9E9E9;\n\n    --chat-channel-background: #DBE7EF;\n    --chat-channel-border: #D7DEE2;\n\n    --chat-message-max-width: 260px;\n    --chat-message-border-radius: 8px;\n    --chat-message-text: #2C384A;\n    --chat-message-background: white;\n    --chat-message-text-me: white;\n    --chat-message-background-me: var(--chat-color-primary);\n\n    ", "\n  }\n\n  .caas-scroll {\n    ", "\n  }\n"], ["\n  :root {\n    --chat-header-height: 70px;\n    --chat-aside-width: 340px;\n\n    --chat-color-primary: #1890FF;\n    --chat-color-secondary: #1982C4;\n    --chat-background: white;\n    --chat-border-color: #E9E9E9;\n\n    --chat-channel-background: #DBE7EF;\n    --chat-channel-border: #D7DEE2;\n\n    --chat-message-max-width: 260px;\n    --chat-message-border-radius: 8px;\n    --chat-message-text: #2C384A;\n    --chat-message-background: white;\n    --chat-message-text-me: white;\n    --chat-message-background-me: var(--chat-color-primary);\n\n    ", "\n  }\n\n  .caas-scroll {\n    ", "\n  }\n"])), mobileStyle(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n      --chat-header-height: 60px;\n    "], ["\n      --chat-header-height: 60px;\n    "]))), chatCustomScrollBar);
var ChatLayout = styled.div(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n\n  .chat-channel-list {\n    position: relative;\n    flex: 0 0 auto;\n    width: 400px;\n    height: 100%;\n    border-right: 1px solid var(--chat-border-color);\n\n    overflow: overlay;\n    ", "\n\n    .chat-list-header {\n      display: flex;\n      align-items: center;\n      padding: 0 8px 0 24px;\n      height: var(--chat-header-height);\n\n      color: #262626;\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 25px;\n    }\n\n    & > ul {\n      padding-right: 0;\n    }\n  }\n\n  .chat-channel {\n    flex: 1;\n    height: 100%;\n  }\n"], ["\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n\n  .chat-channel-list {\n    position: relative;\n    flex: 0 0 auto;\n    width: 400px;\n    height: 100%;\n    border-right: 1px solid var(--chat-border-color);\n\n    overflow: overlay;\n    ", "\n\n    .chat-list-header {\n      display: flex;\n      align-items: center;\n      padding: 0 8px 0 24px;\n      height: var(--chat-header-height);\n\n      color: #262626;\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 25px;\n    }\n\n    & > ul {\n      padding-right: 0;\n    }\n  }\n\n  .chat-channel {\n    flex: 1;\n    height: 100%;\n  }\n"])), chatCustomScrollBar);
var ChannelScrollArea = styled.div(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  padding: 1rem 0 1.5rem;\n  --scroll-background: var(--chat-channel-background);\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  padding: 1rem 0 1.5rem;\n  --scroll-background: var(--chat-channel-background);\n  ", "\n"])), chatCustomScrollBar);
var templateObject_1$Q, templateObject_2$C, templateObject_3$u, templateObject_4$k, templateObject_5$g, templateObject_6$b;

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Note: `leading` has higher priority rather than `trailing`
 * */
function useThrottleCallback(callback, delay, options) {
  if (options === void 0) {
    options = {
      leading: true,
      trailing: false
    };
  }
  var timer = useRef(null);
  var trailingArgs = useRef(null);
  useEffect(function () {
    return function () {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
  return usePreservedCallback(function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (timer.current) {
      trailingArgs.current = args;
      return;
    }
    if (options.leading) {
      callback.apply(void 0, args);
    } else {
      trailingArgs.current = args;
    }
    var invoke = function () {
      if (options.trailing && trailingArgs.current) {
        callback.apply(void 0, trailingArgs.current);
        trailingArgs.current = null;
        timer.current = setTimeout(invoke, delay);
      } else {
        timer.current = null;
      }
    };
    timer.current = setTimeout(invoke, delay);
  });
}

var sanitizeHtml = function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '');
};

var serializeUserMessage = function (message) {
  if (!message) return undefined;
  return {
    type: message === null || message === void 0 ? void 0 : message.messageType,
    message: message.message,
    message_id: message.messageId,
    channel_url: message.channelUrl,
    data: message.data,
    custom_type: message.customType,
    created_at: message.createdAt,
    updated_at: message.updatedAt
  };
};
var serializeGroupChannel = function (channel, metadata) {
  return {
    channel_url: channel.url,
    name: channel.name,
    cover_url: channel.coverUrl,
    created_at: channel.createdAt,
    last_message: serializeUserMessage(channel.lastMessage),
    unread_message_count: channel.unreadMessageCount,
    member_count: channel.memberCount,
    metadata: metadata,
    custom_type: channel.customType
  };
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var dayjs_min = {exports: {}};

var hasRequiredDayjs_min;

function requireDayjs_min () {
	if (hasRequiredDayjs_min) return dayjs_min.exports;
	hasRequiredDayjs_min = 1;
	(function (module, exports) {
		!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof b},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new b(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var b=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,f=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=O.p(f),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return O.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return O.s(e.$y,4,"0");case"M":return a+1;case"MM":return O.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return O.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return O.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return O.s(u,2,"0");case"s":return String(e.$s);case"ss":return O.s(e.$s,2,"0");case"SSS":return O.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=O.p(d),m=w(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return O.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g;}return l?$:O.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),_=b.prototype;return w.prototype=_,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){_[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,b,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));
} (dayjs_min));
	return dayjs_min.exports;
}

var dayjs_minExports = requireDayjs_min();

var localizedFormat$1 = {exports: {}};

(function (module, exports) {
	!function(e,t){module.exports=t();}(commonjsGlobal,(function(){var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,o,n){var r=o.prototype,i=r.format;n.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var o=this.$locale().formats,n=function(t,o){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(t,n,r){var i=r&&r.toUpperCase();return n||o[r]||e[r]||o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(e,t,o){return t||o.slice(1)}))}))}(t,void 0===o?{}:o);return i.call(this,n)};}}));
} (localizedFormat$1));

var localizedFormat = localizedFormat$1.exports;

var relativeTime$1 = {exports: {}};

(function (module, exports) {
	!function(r,e){module.exports=e();}(commonjsGlobal,(function(){return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return "function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)};}}));
} (relativeTime$1));

var relativeTime = relativeTime$1.exports;

var updateLocale$1 = {exports: {}};

(function (module, exports) {
	!function(e,n){module.exports=n();}(commonjsGlobal,(function(){return function(e,n,t){t.updateLocale=function(e,n){var o=t.Ls[e];if(o)return (n?Object.keys(n):[]).forEach((function(e){o[e]=n[e];})),o};}}));
} (updateLocale$1));

var updateLocale = updateLocale$1.exports;

var ko = {exports: {}};

(function (module, exports) {
	!function(e,_){module.exports=_(requireDayjs_min());}(commonjsGlobal,(function(e){function _(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var d=_(e),t={name:"ko",weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),ordinal:function(e){return e},formats:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},meridiem:function(e){return e<12?"오전":"오후"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"}};return d.default.locale(t,null,!0),t}));
} (ko));

var en = {exports: {}};

(function (module, exports) {
	!function(e,n){module.exports=n();}(commonjsGlobal,(function(){return {name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(e){var n=["th","st","nd","rd"],t=e%100;return "["+e+(n[(t-20)%10]||n[t]||n[0])+"]"}}}));
} (en));

var vi = {exports: {}};

(function (module, exports) {
	!function(t,n){module.exports=n(requireDayjs_min());}(commonjsGlobal,(function(t){function n(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var h=n(t),_={name:"vi",weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),weekStart:1,weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),ordinal:function(t){return t},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"}};return h.default.locale(_,null,!0),_}));
} (vi));

var pl = {exports: {}};

(function (module, exports) {
	!function(e,t){module.exports=t(requireDayjs_min());}(commonjsGlobal,(function(e){function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(e);function a(e){return e%10<5&&e%10>1&&~~(e/10)%10!=1}function n(e,t,i){var n=e+" ";switch(i){case"m":return t?"minuta":"minutę";case"mm":return n+(a(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return n+(a(e)?"godziny":"godzin");case"MM":return n+(a(e)?"miesiące":"miesięcy");case"yy":return n+(a(e)?"lata":"lat")}}var r="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),_="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),s=/D MMMM/,d=function(e,t){return s.test(t)?r[e.month()]:_[e.month()]};d.s=_,d.f=r;var o={name:"pl",weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),months:d,monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",m:n,mm:n,h:n,hh:n,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:n,y:"rok",yy:n},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"}};return i.default.locale(o,null,!0),o}));
} (pl));

var de = {exports: {}};

(function (module, exports) {
	!function(e,n){module.exports=n(requireDayjs_min());}(commonjsGlobal,(function(e){function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=n(e),a={s:"ein paar Sekunden",m:["eine Minute","einer Minute"],mm:"%d Minuten",h:["eine Stunde","einer Stunde"],hh:"%d Stunden",d:["ein Tag","einem Tag"],dd:["%d Tage","%d Tagen"],M:["ein Monat","einem Monat"],MM:["%d Monate","%d Monaten"],y:["ein Jahr","einem Jahr"],yy:["%d Jahre","%d Jahren"]};function i(e,n,t){var i=a[t];return Array.isArray(i)&&(i=i[n?0:1]),i.replace("%d",e)}var r={name:"de",weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,formats:{LTS:"HH:mm:ss",LT:"HH:mm",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},relativeTime:{future:"in %s",past:"vor %s",s:i,m:i,mm:i,h:i,hh:i,d:i,dd:i,M:i,MM:i,y:i,yy:i}};return t.default.locale(r,null,!0),r}));
} (de));

var id = {exports: {}};

(function (module, exports) {
	!function(e,a){module.exports=a(requireDayjs_min());}(commonjsGlobal,(function(e){function a(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=a(e),_={name:"id",weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),weekStart:1,formats:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},ordinal:function(e){return e+"."}};return t.default.locale(_,null,!0),_}));
} (id));

var ja = {exports: {}};

(function (module, exports) {
	!function(e,_){module.exports=_(requireDayjs_min());}(commonjsGlobal,(function(e){function _(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=_(e),d={name:"ja",weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),ordinal:function(e){return e+"日"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日(ddd) HH:mm"},meridiem:function(e){return e<12?"午前":"午後"},relativeTime:{future:"%s後",past:"%s前",s:"数秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}};return t.default.locale(d,null,!0),d}));
} (ja));

var th = {exports: {}};

(function (module, exports) {
	!function(_,e){module.exports=e(requireDayjs_min());}(commonjsGlobal,(function(_){function e(_){return _&&"object"==typeof _&&"default"in _?_:{default:_}}var t=e(_),d={name:"th",weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"},ordinal:function(_){return _+"."}};return t.default.locale(d,null,!0),d}));
} (th));

var es = {exports: {}};

(function (module, exports) {
	!function(e,o){module.exports=o(requireDayjs_min());}(commonjsGlobal,(function(e){function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(e),d={name:"es",monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),weekStart:1,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"}};return s.default.locale(d,null,!0),d}));
} (es));

var zhCn = {exports: {}};

(function (module, exports) {
	!function(e,_){module.exports=_(requireDayjs_min());}(commonjsGlobal,(function(e){function _(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=_(e),d={name:"zh-cn",weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),ordinal:function(e,_){return "W"===_?e+"周":e+"日"},weekStart:1,yearStart:4,formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah点mm分",LLLL:"YYYY年M月D日ddddAh点mm分",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},relativeTime:{future:"%s内",past:"%s前",s:"几秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},meridiem:function(e,_){var t=100*e+_;return t<600?"凌晨":t<900?"早上":t<1100?"上午":t<1300?"中午":t<1800?"下午":"晚上"}};return t.default.locale(d,null,!0),d}));
} (zhCn));

var zhTw = {exports: {}};

(function (module, exports) {
	!function(_,e){module.exports=e(requireDayjs_min());}(commonjsGlobal,(function(_){function e(_){return _&&"object"==typeof _&&"default"in _?_:{default:_}}var t=e(_),d={name:"zh-tw",weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),ordinal:function(_,e){return "W"===e?_+"週":_+"日"},formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"},meridiem:function(_,e){var t=100*_+e;return t<600?"凌晨":t<900?"早上":t<1100?"上午":t<1300?"中午":t<1800?"下午":"晚上"}};return t.default.locale(d,null,!0),d}));
} (zhTw));

var withSendbirdSdk = function (Component) {
  return function (props) {
    var appId = props.appId;
    var newSdk = SendbirdChat.init({
      appId: appId,
      modules: [new OpenChannelModule(), new GroupChannelModule()]
      // logLevel: LogLevel.VERBOSE,
      // localCacheEnabled: true,
    });

    if (!newSdk) return jsx("div", {
      children: "Loading Sendbird SDK"
    });
    return jsx(Component, __assign$1({}, props, {
      sb: newSdk
    }));
  };
};

var initialLocale = {
  dayjsLocale: 'ko',
  emojiPickerLocale: 'kr',
  title: '실시간 채팅방',
  today: '오늘',
  yesterday: '어제',
  channel_list_search_placeholder: '채팅방 검색',
  search_result_boundary_prev: '이전 대화는 불러올 수 없습니다.',
  search_result_boundary_next: '이후 대화는 불러올 수 없습니다.',
  seach_result: '검색 결과',
  search_result_close: '닫기',
  not_membered_channel: '참여되지 않은 채팅방입니다.',
  channel_connection_failed: '채널 접속에 실패했습니다.',
  channel_loading: '불러오는 중...',
  send_button: '전송',
  message_input_placeholder: '메시지를 입력해 주세요',
  typing_user_indicator: '{{name}}이 작성 중입니다.',
  typing_user_indicator_plural: '{{name}} 외 {{count}}이 작성 중입니다.',
  not_supported_message: '현재 버전에서 지원하지 않는 메시지입니다.',
  file_and_image: '파일 및 이미지',
  channel_info_craeted_at: '생성일자: {{created_at}}',
  channel_info_leave: '채팅방 나가기',
  channel_info_leave_confirm: '정말로 나가시겠습니까?',
  channel_members: '참여 중인 멤버',
  channel_member_online: '접속 중',
  channel_member_invite: '참여자 초대',
  channel_member_invite_cancel: '취소',
  channel_member_invite_ok: '확인',
  channel_member_invite_success_message: '멤버를 초대했습니다.',
  channel_member_invite_fail_message: '멤버 초대에 실패했습니다.',
  channel_member_invite_message_format: '{{inviter}}님이 {{members}}님을 초대했습니다.',
  channel_member_leave_message_format: '{{name}}님이 채널을 나갔습니다.',
  channel_member_remove_message_format: '{{operator}}님이 {{name}}님을 내보냈습니다.',
  search_result_title: '“{{search_query}}”에 대한 검색 결과',
  search_result_go_to_chat: '채팅하기',
  input_send: '보내기',
  input_reply: '답장',
  file_message_preview_button: '바로보기',
  file_message_preview_title: '바로보기',
  file_preview_title: '바로보기',
  file_preview_download_button: '다운로드',
  extension_attachment: '파일첨부',
  extension_share_document: '문서공유',
  extention_share_document_send_message: '공유하기',
  extention_share_document_cancel: '취소',
  extention_share_document_tab_report: '작업보고',
  extention_share_document_tab_rfi: '요청사항',
  extention_share_document_tab_minutes: '회의록',
  extention_share_document_search_placeholder: '제목 및 내용을 검색할 수 있습니다.',
  extention_share_document_photo_extra: '{{count}}장',
  extention_share_document_report_writer: '작성자',
  extention_share_document_rfi_assignee: '담당자',
  extention_share_document_rfi_due_date: '마감일',
  extention_share_document_rfi_writer: '작성자',
  extention_share_document_rfi_created_at: '작성일',
  extention_share_document_minutes_writer: '작성자',
  extention_share_document_minutes_created_at: '작성일',
  extention_share_document_empty: '검색 결과가 없습니다.',
  extention_share_document_message_auth: '열람 권한이 없습니다.',
  extention_gpt_cancel: '취소',
  extention_gpt_message_select_start: '시작',
  extention_gpt_message_select_end: '끝',
  extention_gpt_message_select_done: '선택완료',
  extention_gpt_post_doc_title: '제목',
  extention_gpt_post_doc_content: '내용',
  extention_gpt_post_doc_submit: '등록',
  extention_gpt_minutes_button: 'AI 회의록',
  extention_gpt_minutes_select_title: 'AI 회의록 작성 영역 선택',
  extention_gpt_minutes_help_1: '회의록 작성을 시작할 말풍선을 선택해주세요.',
  extention_gpt_minutes_help_2: '회의록을 작성할 영역을 지정해주세요.',
  extention_gpt_minutes_help_3: '텍스트 메시지만 변환할 수 있어요.',
  extention_gpt_minutes_help_4: '선택완료 버튼을 눌러주세요.',
  extention_gpt_minutes_title: 'AI 회의록 작성',
  extention_gpt_minutes_loading: 'AI가 회의록을 작성중입니다. <br />잠시만 기다려주세요.',
  extention_gpt_minutes_result_title: '회의록',
  extention_gpt_rfi_button: 'AI 요청사항',
  extention_gpt_rfi_select_title: 'AI 요청사항 작성 영역 선택',
  extention_gpt_rfi_help_1: '요청사항 작성을 시작할 말풍선을 선택해주세요.',
  extention_gpt_rfi_help_2: '요청사항을 작성할 영역을 지정해주세요.',
  extention_gpt_rfi_help_3: '텍스트 메시지만 변환할 수 있어요.',
  extention_gpt_rfi_help_4: '선택완료 버튼을 눌러주세요.',
  extention_gpt_rfi_title: 'AI 요청사항 작성',
  extention_gpt_rfi_loading: 'AI가 요청사항을 작성중입니다. <br />잠시만 기다려주세요.',
  extention_gpt_rfi_result_title: '요청사항',
  channel_meta_type_project: '프로젝트 채팅방',
  channel_meta_type_general: '개인 채팅방',
  channel_meta_type_estimate: '견적 채팅방',
  channel_create_select_members_title: '대화상대 선택',
  channel_create_select_members_search_placeholder: '검색어를 입력해 주세요.',
  channel_create_select_members_empty: '직원을 초대하여, 함께 채팅해 보세요.',
  channel_create_select_members_submit: '다음',
  channel_create_profile_title: '프로필 설정',
  channel_create_profile_name_input_label: '채팅방 이름',
  channel_create_profile_members_title: '참여 멤버',
  channel_create_profile_submit: '저장'
};

dayjs_minExports.locale('ko');
dayjs_minExports.extend(updateLocale);
dayjs_minExports.extend(localizedFormat);
dayjs_minExports.extend(relativeTime);
var ChatRootContext = createContext({
  sb: null,
  connected: false,
  caasApiUrl: '',
  caasAuthToken: '',
  language: 'ko',
  locale: initialLocale,
  totalUnreadMessageCount: 0,
  froalaEditorKey: '',
  setTotalUnreadMessageCount: function () {},
  updateTotalUnreadMessageCount: function () {}
});
var ChatRootProvider = withSendbirdSdk(function (props) {
  var sb = props.sb,
    userId = props.userId,
    caasApiUrl = props.caasApiUrl,
    caasAuthToken = props.caasAuthToken,
    _a = props.language,
    language = _a === void 0 ? 'ko' : _a,
    _b = props.locale,
    locale = _b === void 0 ? initialLocale : _b,
    froalaEditorKey = props.froalaEditorKey,
    children = props.children;
  /**
   * Sendbird 연결 상태
   */
  var _c = useState(false),
    connected = _c[0],
    setConnected = _c[1];
  /**
   * 전체 안읽은 메시지 갯수
   */
  var _d = useState(0),
    totalUnreadMessageCount = _d[0],
    setTotalUnreadMessageCount = _d[1];
  /**
   * Sendbird 연결
   */
  var connectUser = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!userId) return [2 /*return*/];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, sb === null || sb === void 0 ? void 0 : sb.connect(userId)];
          case 2:
            _a.sent();
            setConnected(true);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            console.error(error_1);
            setConnected(false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * userId가 변경될 때마다
   * Sendbird를 다시 연결
   */
  useEffect(function () {
    connectUser();
  }, [sb, userId]);
  var getTotalUnreadMessageCount = function (params) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var response, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !connected) return [2 /*return*/];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, sb.groupChannel.getTotalUnreadMessageCount(params)];
          case 2:
            response = _a.sent();
            return [2 /*return*/, response];
          case 3:
            error_2 = _a.sent();
            console.error('updateTotalUnreadMessageCount', error_2);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 전체 안읽은 메시지 갯수를 갱신합니다.
   */
  var updateTotalUnreadMessageCount = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var totalUnreadMessageCount;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !connected) return [2 /*return*/];
            return [4 /*yield*/, getTotalUnreadMessageCount()];
          case 1:
            totalUnreadMessageCount = _a.sent();
            setTotalUnreadMessageCount(totalUnreadMessageCount || 0);
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 전역적으로 채팅에 접속해있지 않아도 전체 안읽은 메시지를 갱신합니다.
   */
  useEffect(function () {
    if (!sb || !connected) return;
    updateTotalUnreadMessageCount();
    var params = {
      /**
       * 메세지를 받았을 경우
       * 채널 목록과 메시지를 갱신한다.
       * 이때 메시지는 상태만 갱신한다.
       */
      onMessageReceived: function () {
        updateTotalUnreadMessageCount();
      }
    };
    var groupChannelHandler = new GroupChannelHandler(params);
    sb.groupChannel.addGroupChannelHandler('chat-root', groupChannelHandler);
    return function () {
      sb.groupChannel.removeGroupChannelHandler('chat-root');
    };
  }, [sb, connected]);
  var value = useMemo(function () {
    return {
      sb: sb,
      userId: userId,
      caasApiUrl: caasApiUrl,
      caasAuthToken: caasAuthToken,
      language: language,
      locale: __assign$1(__assign$1({}, initialLocale), locale),
      connected: connected,
      totalUnreadMessageCount: totalUnreadMessageCount,
      froalaEditorKey: froalaEditorKey,
      setTotalUnreadMessageCount: setTotalUnreadMessageCount,
      getTotalUnreadMessageCount: getTotalUnreadMessageCount,
      updateTotalUnreadMessageCount: updateTotalUnreadMessageCount
    };
  }, [sb, userId, caasApiUrl, caasAuthToken, language, locale, connected, totalUnreadMessageCount, froalaEditorKey, getTotalUnreadMessageCount, updateTotalUnreadMessageCount]);
  return jsx(ChatRootContext.Provider, {
    value: value,
    children: children
  });
});

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$5;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();
var _root = root$9;

var root$8 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function () {
  return root$8.Date.now();
};
var now_1 = now$1;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
var _baseTrim = baseTrim$1;

var root$7 = _root;

/** Built-in value references. */
var Symbol$5 = root$7.Symbol;
var _Symbol = Symbol$5;

var Symbol$4 = _Symbol;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$c.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$b.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;

var Symbol$3 = _Symbol,
  getRawTag = _getRawTag,
  objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike$5;

var baseGetTag$4 = _baseGetTag,
  isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' || isObjectLike$4(value) && baseGetTag$4(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$4;

var baseTrim = _baseTrim,
  isObject$4 = isObject_1,
  isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$3(value)) {
    return NAN;
  }
  if (isObject$4(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$4(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;

var isObject$3 = isObject_1,
  now = now_1,
  toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce$2;

function useLatest$1(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
}

var isFunction$3 = function (value) {
  return typeof value === 'function';
};
var isString = function (value) {
  return typeof value === 'string';
};
var isNumber = function (value) {
  return typeof value === 'number';
};

var isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
var isDev$1 = isDev;

var useUnmount = function (fn) {
  if (isDev$1) {
    if (!isFunction$3(fn)) {
      console.error("useUnmount expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest$1(fn);
  useEffect(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};
var useUnmount$1 = useUnmount;

function useDebounceFn(fn, options) {
  var _a;
  if (isDev$1) {
    if (!isFunction$3(fn)) {
      console.error("useDebounceFn expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest$1(fn);
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var debounced = useMemo(function () {
    return debounce_1(function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fnRef.current.apply(fnRef, __spreadArray([], __read(args), false));
    }, wait, options);
  }, []);
  useUnmount$1(function () {
    debounced.cancel();
  });
  return {
    run: debounced,
    cancel: debounced.cancel,
    flush: debounced.flush
  };
}

/**
 * ChatApp의 글로벌 상태와 전체 안읽은 메시지 갯수에 접근할 수
 * 있습니다.
 */
var useChatSensor = function (params) {
  var _a;
  var _b = useContext(ChatRootContext),
    sb = _b.sb,
    connected = _b.connected,
    totalUnreadMessageCount = _b.totalUnreadMessageCount,
    getTotalUnreadMessageCount = _b.getTotalUnreadMessageCount;
  var _c = useState(0),
    _filteredTotalCount = _c[0],
    _setFilteredTotalCount = _c[1];
  var isFilterMode = useMemo(function () {
    var _a;
    return !!((_a = params === null || params === void 0 ? void 0 : params.customType) === null || _a === void 0 ? void 0 : _a.length) && params.listnerKey;
  }, [params === null || params === void 0 ? void 0 : params.customType]);
  var fetchFilteredMessageCount = useDebounceFn(function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !connected || !getTotalUnreadMessageCount || !isFilterMode) {
              _setFilteredTotalCount(0);
              return [2 /*return*/];
            }

            return [4 /*yield*/, getTotalUnreadMessageCount({
              channelCustomTypesFilter: params === null || params === void 0 ? void 0 : params.customType
            })];
          case 1:
            response = _a.sent();
            _setFilteredTotalCount(response || 0);
            return [2 /*return*/];
        }
      });
    });
  }, {
    wait: 1000
  }).run;
  useEffect(function () {
    if (!isFilterMode) {
      _setFilteredTotalCount(0);
      return;
    }
    fetchFilteredMessageCount();
  }, []);
  useEffect(function () {
    if (!sb || !connected || !isFilterMode || !(params === null || params === void 0 ? void 0 : params.listnerKey)) return;
    var uniqKey = params === null || params === void 0 ? void 0 : params.listnerKey;
    var groupChannelHandler = new GroupChannelHandler({
      onChannelChanged: function () {
        fetchFilteredMessageCount();
      }
    });
    sb.groupChannel.addGroupChannelHandler(uniqKey, groupChannelHandler);
    return function () {
      sb.groupChannel.removeGroupChannelHandler(uniqKey);
    };
  }, [sb, connected]);
  return {
    SendbirdInstance: sb,
    connected: connected,
    totalUnreadMessageCount: ((_a = params === null || params === void 0 ? void 0 : params.customType) === null || _a === void 0 ? void 0 : _a.length) ? _filteredTotalCount : totalUnreadMessageCount
  };
};

/**
 * 데이터 페칭을 위한 axios instance를 생성합니다.
 *
 * @returns axiosInstance
 */
var useFetch = function () {
  var _a = useContext(ChatRootContext),
    caasApiUrl = _a.caasApiUrl,
    caasAuthToken = _a.caasAuthToken;
  var axiosInstance = Axios.create({
    baseURL: caasApiUrl,
    headers: {
      Authorization: "Bearer ".concat(caasAuthToken),
      accept: 'application/json'
    }
  });
  return axiosInstance;
};

/**
 * 현재 채널 상태를 확인할 수 있습니다.
 *
 * @param {string} channelUrl
 * channelUrl을 인자로 주입하면 채널의 안읽은 메시지 갯수를 받을 수 있습니다.
 */
var useChannelSensor = function (channelUrl, options) {
  var _a;
  var axios = useFetch();
  var _b = useContext(ChatRootContext),
    sb = _b.sb,
    connected = _b.connected;
  var channelRef = useRef(null);
  var _c = useState(0),
    unreadMessageCount = _c[0],
    setUnreadMessageCount = _c[1];
  var _d = useState([]),
    members = _d[0],
    setMembers = _d[1];
  var fetchData = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var response, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!channelUrl || !connected || !sb) return [2 /*return*/];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, sb.groupChannel.getChannel(channelUrl)];
          case 2:
            response = _a.sent();
            channelRef.current = response;
            if (!response) {
              console.error('채널 정보를 불러올 수 없습니다.');
              return [2 /*return*/];
            }

            setUnreadMessageCount(response.unreadMessageCount);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    if (!channelUrl || !connected || !sb) return;
    fetchData();
  }, [channelUrl, sb, connected]);
  useEffect(function () {
    if (!channelUrl || !connected || !sb) return;
    var params = {
      /**
       * 메세지를 받았을 경우
       * 채널 목록과 메시지를 갱신한다.
       * 이때 메시지는 상태만 갱신한다.
       */
      onMessageReceived: function (channel) {
        if (channel.url !== channelUrl) return;
        var groupChannel = channel;
        channelRef.current = groupChannel;
        setUnreadMessageCount(groupChannel.unreadMessageCount);
      },
      onChannelChanged: function (channel) {
        /**
         * 이벤트가 발생한 채널과 현재 채널이 동일한지 검증
         */
        if (channel.url !== channelUrl) return;
        var groupChannel = channel;
        channelRef.current = groupChannel;
        setUnreadMessageCount(groupChannel.unreadMessageCount);
        fetchMembers();
      },
      onUnreadMemberStatusUpdated: function (channel) {
        /**
         * 이벤트가 발생한 채널과 현재 채널이 동일한지 검증
         */
        if (channel.url !== channelUrl) return;
        channelRef.current = channel;
        setUnreadMessageCount(channel.unreadMessageCount);
      }
    };
    var groupChannelHandler = new GroupChannelHandler(params);
    sb.groupChannel.addGroupChannelHandler('for-global-channel-unread', groupChannelHandler);
    return function () {
      sb.groupChannel.removeGroupChannelHandler('for-global-channel-unread');
    };
  }, [channelUrl, sb, connected]);
  var fetchMembers = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(options === null || options === void 0 ? void 0 : options.withMembers)) return [2 /*return*/];
            if (!channelUrl) {
              setMembers([]);
              return [2 /*return*/];
            }

            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, axios.get("/sendbird/".concat(channelUrl, "/users"))];
          case 2:
            data = _a.sent().data;
            setMembers(data || []);
            return [3 /*break*/, 4];
          case 3:
            error_2 = _a.sent();
            console.error(error_2);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    if (!(options === null || options === void 0 ? void 0 : options.withMembers)) return;
    fetchMembers();
  }, [options === null || options === void 0 ? void 0 : options.withMembers, channelUrl, (_a = channelRef.current) === null || _a === void 0 ? void 0 : _a.members]);
  return {
    unreadMessageCount: unreadMessageCount,
    channelRef: channelRef,
    members: members
  };
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$2(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
  listCacheDelete = _listCacheDelete,
  listCacheGet = _listCacheGet,
  listCacheHas = _listCacheHas,
  listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;

var baseGetTag$3 = _baseGetTag,
  isObject$2 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$2(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
  isMasked = _isMasked,
  isObject$1 = isObject_1,
  toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
  getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
var _getNative = getNative$7;

var getNative$6 = _getNative,
  root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$5, 'Map');
var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');
var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}
var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;

var hashClear = _hashClear,
  hashDelete = _hashDelete,
  hashGet = _hashGet,
  hashHas = _hashHas,
  hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;

var Hash = _Hash,
  ListCache$2 = _ListCache,
  Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$3 || ListCache$2)(),
    'string': new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
  mapCacheDelete = _mapCacheDelete,
  mapCacheGet = _mapCacheGet,
  mapCacheHas = _mapCacheHas,
  mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
  Map$2 = _Map,
  MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;

var ListCache = _ListCache,
  stackClear = _stackClear,
  stackDelete = _stackDelete,
  stackGet = _stackGet,
  stackHas = _stackHas,
  stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
  setCacheAdd = _setCacheAdd,
  setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache$1();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas$2(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
  arraySome = _arraySome,
  cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}
var _equalArrays = equalArrays$2;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray$1(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray$3(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$3;

var Symbol$2 = _Symbol,
  Uint8Array = _Uint8Array,
  eq = eq_1,
  equalArrays$1 = _equalArrays,
  mapToArray = _mapToArray,
  setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$9 = Array.isArray;
var isArray_1 = isArray$9;

var arrayPush = _arrayPush,
  isArray$8 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$8(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
  stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;

var baseGetTag$2 = _baseGetTag,
  isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
  isObjectLike$2 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike$2(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments$2;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

(function (module, exports) {
  var root = _root,
    stubFalse = stubFalse_1;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;
  module.exports = isBuffer;
})(isBuffer$2, isBuffer$2.exports);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$2(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex$2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;

var baseGetTag$1 = _baseGetTag,
  isLength$2 = isLength_1,
  isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

(function (module, exports) {
  var freeGlobal = _freeGlobal;

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);

var baseIsTypedArray = _baseIsTypedArray,
  baseUnary = _baseUnary,
  nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
  isArguments$1 = isArguments_1,
  isArray$7 = isArray_1,
  isBuffer$1 = isBuffer$2.exports,
  isIndex$1 = _isIndex,
  isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$7(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}
var _isPrototype = isPrototype$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
  nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;

var isFunction = isFunction_1,
  isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys = _arrayLikeKeys,
  baseKeys = _baseKeys,
  isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$3;

var baseGetAllKeys = _baseGetAllKeys,
  getSymbols = _getSymbols,
  keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}
var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}
var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
  root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$4(root$3, 'DataView');
var _DataView = DataView$1;

var getNative$3 = _getNative,
  root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$2, 'Promise');
var _Promise = Promise$2;

var getNative$2 = _getNative,
  root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$2(root$1, 'Set');
var _Set = Set$3;

var getNative$1 = _getNative,
  root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$1(root, 'WeakMap');
var _WeakMap = WeakMap$2;

var DataView = _DataView,
  Map$1 = _Map,
  Promise$1 = _Promise,
  Set$2 = _Set,
  WeakMap$1 = _WeakMap,
  baseGetTag = _baseGetTag,
  toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$1),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$2 && getTag$1(new Set$2()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function (value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;

var Stack$1 = _Stack,
  equalArrays = _equalArrays,
  equalByTag = _equalByTag,
  equalObjects = _equalObjects,
  getTag = _getTag,
  isArray$6 = isArray_1,
  isBuffer = isBuffer$2.exports,
  isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$6(object),
    othIsArr = isArray$6(other),
    objTag = objIsArr ? arrayTag : getTag(object),
    othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
  isObjectLike = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;

var Stack = _Stack,
  baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;

var isObject = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject(value);
}
var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
  keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable$2(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
  getMatchData = _getMatchData,
  matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;

var isArray$5 = isArray_1,
  isSymbol$2 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$5(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$1;

var Symbol$1 = _Symbol,
  arrayMap = _arrayMap,
  isArray$4 = isArray_1,
  isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$4(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}
var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}
var toString_1 = toString$1;

var isArray$3 = isArray_1,
  isKey$2 = _isKey,
  stringToPath = _stringToPath,
  toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$3(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}
var _castPath = castPath$2;

var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
var _toKey = toKey$4;

var castPath$1 = _castPath,
  toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath$1(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return index && index == length ? object : undefined;
}
var _baseGet = baseGet$2;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}
var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;

var castPath = _castPath,
  isArguments = isArguments_1,
  isArray$2 = isArray_1,
  isIndex = _isIndex,
  isLength = isLength_1,
  toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$2(object) || isArguments(object));
}
var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
  hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;

var baseIsEqual$1 = _baseIsEqual,
  get = get_1,
  hasIn = hasIn_1,
  isKey$1 = _isKey,
  isStrictComparable = _isStrictComparable,
  matchesStrictComparable = _matchesStrictComparable,
  toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}
var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty$1(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}
var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function (object) {
    return baseGet(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
  basePropertyDeep = _basePropertyDeep,
  isKey = _isKey,
  toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;

var baseMatches = _baseMatches,
  baseMatchesProperty = _baseMatchesProperty,
  identity = identity_1,
  isArray$1 = isArray_1,
  property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$2;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
    index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
    length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
  baseIsNaN = _baseIsNaN,
  strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop$3() {
  // No operation performed.
}
var noop_1 = noop$3;

var Set$1 = _Set,
  noop$2 = noop_1,
  setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop$2 : function (values) {
  return new Set$1(values);
};
var _createSet = createSet$1;

var SetCache = _SetCache,
  arrayIncludes = _arrayIncludes,
  arrayIncludesWith = _arrayIncludesWith,
  cacheHas = _cacheHas,
  createSet = _createSet,
  setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
    includes = arrayIncludes,
    length = array.length,
    isCommon = true,
    result = [],
    seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
      computed = iteratee ? iteratee(value) : value;
    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}
var _baseUniq = baseUniq$1;

var baseIteratee$1 = _baseIteratee,
  baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee$1(iteratee)) : [];
}
var uniqBy_1 = uniqBy;

var useIsMobile = function () {
  var _a = useState(false),
    isMobile = _a[0],
    setIsMobile = _a[1];
  var handleResize = function () {
    if (window.innerWidth <= breakPoint.large) {
      setIsMobile(true);
      return;
    }
    setIsMobile(false);
  };
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobile;
};

var useLocale = function () {
  var locale = useContext(ChatRootContext).locale;
  return {
    locale: locale
  };
};

/**
 * 채널과 연결된 프로젝트를 찾습니다.
 */
var useMatchProjectId = function (channelUrl) {
  var _a = useContext(ChatRootContext),
    sb = _a.sb,
    connected = _a.connected;
  var axios = useFetch();
  var _b = useState(''),
    projectId = _b[0],
    setProjectId = _b[1];
  var matchProjectId = function (channelUrl) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var channel, metadata, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !connected || !channelUrl) return [2 /*return*/, ''];
            return [4 /*yield*/, sb.groupChannel.getChannel(channelUrl)];
          case 1:
            channel = _a.sent();
            return [4 /*yield*/, channel.getAllMetaData()];
          case 2:
            metadata = _a.sent();
            // 채널이 프로젝트와 연결되어 있는지 검증합니다.
            if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) !== 'PROJECT') return [2 /*return*/, ''];
            return [4 /*yield*/, axios.get("/sendbird/chatroom/".concat(channelUrl))];
          case 3:
            data = _a.sent().data;
            return [2 /*return*/, data.project_id || ''];
        }
      });
    });
  };
  useEffect(function () {
    if (!channelUrl) {
      setProjectId('');
      return;
    }
    var getProjectId = function () {
      return __awaiter$1(void 0, void 0, void 0, function () {
        var newProjectId;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, matchProjectId(channelUrl)];
            case 1:
              newProjectId = _a.sent();
              setProjectId(newProjectId);
              return [2 /*return*/];
          }
        });
      });
    };

    getProjectId();
  }, [sb, connected, channelUrl]);
  return {
    projectId: projectId,
    matchProjectId: matchProjectId
  };
};

/**
 * 커스텀 메시지를 전송하는 메서드를 제공합니다.
 *
 * @param channelRef
 * 채널 객체 참조
 */
var useMessageSender = function (channelRef) {
  var sendMessage = function (message, customType, data) {
    return new Promise(function (resolve, reject) {
      if (!channelRef.current) {
        reject();
        return;
      }
      var params = {
        message: message,
        customType: customType,
        data: JSON.stringify(data || {})
      };
      channelRef.current.sendUserMessage(params).onSucceeded(function (message) {
        resolve(message);
      }).onFailed(function (error) {
        reject(error);
      });
    });
  };
  return {
    sendMessage: sendMessage
  };
};

var useCreateChannel = function () {
  var axios = useFetch();
  var createChannel = function (payload) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, axios.post('/sendbird/group-channel', payload)];
          case 1:
            data = _a.sent().data;
            return [2 /*return*/, data];
        }
      });
    });
  };
  return {
    createChannel: createChannel
  };
};

/**
 * 채널 목록과 관련된 상태를 불러옵니다.
 */
var useChannelListSensor = function () {
  var _a = useContext(ChannelsStateContext),
    channels = _a.channels,
    isFetching = _a.isFetching,
    isLast = _a.isLast,
    isLoading = _a.isLoading;
  var isEmpty = useMemo(function () {
    if (isFetching || channels.length) return false;
    return true;
  }, [isLoading, isFetching, channels]);
  return {
    channels: channels,
    isFetching: isFetching,
    isLast: isLast,
    isLoading: isLoading,
    isEmpty: isEmpty
  };
};

var useChannels = function (filter, searchParams) {
  var axios = useFetch();
  var _a = useContext(ChatRootContext),
    sb = _a.sb,
    userId = _a.userId,
    connected = _a.connected;
  var _b = useState([]),
    channels = _b[0],
    setChannels = _b[1];
  var _c = useState(true),
    isLoading = _c[0],
    setIsLoading = _c[1];
  var _d = useState(true),
    isFetching = _d[0],
    setIsFetching = _d[1];
  var _e = useState(false),
    isInitialized = _e[0],
    setIsInitialized = _e[1];
  var _f = useState(false),
    isLast = _f[0],
    setIsLast = _f[1];
  var _g = useState(''),
    nextToken = _g[0],
    setNextToken = _g[1];
  var fidnAllChannel = function (params) {
    return axios.get('/sendbird/group-channels', {
      params: params
    });
  };
  var fetchData = function (token, limit) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data, channels_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !userId || !connected) return [2 /*return*/];
            if (!isInitialized) {
              setIsLoading(true);
            }
            setIsFetching(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, fidnAllChannel({
              token: token || undefined,
              limit: limit || 20,
              members_include_in: userId,
              metadata_key: (filter === null || filter === void 0 ? void 0 : filter.channelMetaType) ? 'type' : undefined,
              metadata_values: (filter === null || filter === void 0 ? void 0 : filter.channelMetaType) ? Array.isArray(filter === null || filter === void 0 ? void 0 : filter.channelMetaType) ? filter === null || filter === void 0 ? void 0 : filter.channelMetaType.toString() : filter === null || filter === void 0 ? void 0 : filter.channelMetaType : undefined,
              name_contains: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.name_contains) || undefined
            })];
          case 2:
            data = _a.sent().data;
            channels_1 = data.data;
            /**
             * 요청 시 토큰과 결과물 토큰이 중복되는 경우 더이상 스크롤할 수 없도록 하며,
             * 가져온 결과를 반영하지 않습니다.
             * 이때 token은 빈 문자열 또는 undefined가 아니어야 합니다.
             */
            if (token && token === data.token) {
              setNextToken('');
              setIsLast(true);
              return [2 /*return*/];
            }
            /**
             * 요청 토큰이 있는 경우에만 기존 데이터를 살려둡니다.
             */
            if (token) {
              setChannels(function (prev) {
                return __spreadArray(__spreadArray([], prev, true), channels_1, true);
              });
            } else {
              setChannels(channels_1);
            }
            /**
             * 결과물 토큰이 없는 경우
             * 더이상 스크롤할 수 없도록 합니다.
             */
            if (!data.token) {
              setIsLast(true);
            }
            setNextToken(data.token);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            setChannels([]);
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            setIsInitialized(true);
            setIsLoading(false);
            setIsFetching(false);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchData('', channels.length);
  }, [userId, connected, filter === null || filter === void 0 ? void 0 : filter.channelMetaType]);
  /**
   * 검색어가 변경되면 새로 로드한다.
   */
  useEffect(function () {
    fetchData('', 20);
  }, [searchParams === null || searchParams === void 0 ? void 0 : searchParams.name_contains]);
  return useMemo(function () {
    return {
      channels: channels,
      isLoading: isLoading,
      isFetching: isFetching,
      isLast: isLast,
      /**
       * 현재 로드된 채널의 갯수만큼
       * 데이터를 새로 불러옵니다.
       */
      refetch: function () {
        return __awaiter$1(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, fetchData('', channels.length)];
              case 1:
                _a.sent();
                return [2 /*return*/];
            }
          });
        });
      },

      /**
       * 기존에 불러온 채널을 유지한채 다음 목록을 불러옵니다.
       */
      fetchNext: function () {
        return __awaiter$1(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, fetchData(nextToken)];
              case 1:
                return [2 /*return*/, _a.sent()];
            }
          });
        });
      },
      setChannels: setChannels
    };
  }, [channels, nextToken, isLoading, filter, fetchData]);
};

var ChannelsStateContext = createContext({
  channels: [],
  isLoading: false,
  isFetching: false,
  isLast: false
});
var ChannelsDispatchContext = createContext({
  refetch: function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  fetchNext: function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  setChannels: function () {},
  setSearchParams: function () {},
  updateChannelsItem: function () {}
});
var ChannelsProvider = function (props) {
  var children = props.children;
  var _a = useContext(ChatRootContext),
    sb = _a.sb,
    updateTotalUnreadMessageCount = _a.updateTotalUnreadMessageCount;
  var _b = useContext(ChatContext),
    channelUrl = _b.channelUrl,
    channelListFilter = _b.channelListFilter,
    setChannelUrl = _b.setChannelUrl;
  var _c = useState(null),
    searchParams = _c[0],
    setSearchParams = _c[1];
  var _d = useChannels(channelListFilter, searchParams),
    channels = _d.channels,
    isLoading = _d.isLoading,
    isFetching = _d.isFetching,
    isLast = _d.isLast,
    refetch = _d.refetch,
    fetchNext = _d.fetchNext,
    setChannels = _d.setChannels;
  /**
   * 채널 객체를 교체합니다.
   * - 이때 lastMessage의 createdAt을 사용해 순서를 정렬합니다.
   * - lastMessage가 없다면 이름으로 순서를 정렬합니다.
   *
   * @param channel
   */
  var updateChannelsItem = function (channel) {
    /**
     * 목록 필터가 적용되어 있는 경우
     */
    if (channelListFilter === null || channelListFilter === void 0 ? void 0 : channelListFilter.channelMetaType) {
      var filters = channelListFilter.channelMetaType;
      // 목록 필터와 일치하지 않는 데이터일 경우 모든 작업을 중단한다.
      if (typeof filters === 'string') {
        if (filters !== channel.custom_type) {
          return;
        }
      } else {
        var matchedFilter = filters.find(function (type) {
          return type === channel.custom_type;
        });
        if (!matchedFilter) {
          return;
        }
      }
    }
    setChannels(function (prev) {
      var _a, _b;
      /**
       * 기존 데이터의 길이가 0이라면 그대로 저장한다.
       */
      if (!prev.length) {
        return [channel];
      }
      /**
       * 기존 데이터의 가장 첫번째 채널보다 업데이트된 시간이 최근인지 검사한다.
       */
      var isLatest = false;
      var currentLatestChannel = prev[0];
      if ((((_a = currentLatestChannel.last_message) === null || _a === void 0 ? void 0 : _a.created_at) || 0) < (((_b = channel.last_message) === null || _b === void 0 ? void 0 : _b.created_at) || 0)) {
        isLatest = true;
      }
      /**
       * 기존 데이터에 이미 존재하는 데이터인지 검사한다.
       */
      var matchedChannel = prev.find(function (e) {
        return e.channel_url === channel.channel_url;
      });
      /**
       * 최신 데이터가 아니면서 기존 데이터에도 없다면 아무것도 하지 않는다.
       */
      if (!isLatest && !matchedChannel) {
        return prev;
      }
      /**
       * 이미 존재하는 데이터이면서 가장 최신 채널이라면 기존 데이터를 제거 후 최상단에 위치시킨다.
       */
      if (isLatest && matchedChannel) {
        return __spreadArray([channel], prev.filter(function (e) {
          return e.channel_url !== channel.channel_url;
        }), true);
      }
      /**
       * 이미 존재하는 데이터이지만 최신 채널이 아니라면 기존 데이터를 교체하기만 한다.
       */
      if (!isLatest && matchedChannel) {
        return prev.map(function (e) {
          if (e.channel_url === channel.channel_url) return channel;
          return e;
        });
      }
      /**
       * 새로운 데이터이면서 최신이라면 가장 앞에 위치시킨다.
       */
      if (isLatest && !matchedChannel) {
        return __spreadArray([channel], prev, true);
      }
      return prev;
    });
    updateTotalUnreadMessageCount();
  };
  /**
   * 선택된 채널이 없을 경우 가장 최근 활동이 일어난
   * 채널에 자동 접속
   */
  useEffect(function () {
    var _a, _b;
    // 선택된 채널이 있거나 참여 중인 채널이 없는 경우 중단
    if (channelUrl || !channels.length || !((_a = channels === null || channels === void 0 ? void 0 : channels[0]) === null || _a === void 0 ? void 0 : _a.channel_url)) return;
    setChannelUrl((_b = channels === null || channels === void 0 ? void 0 : channels[0]) === null || _b === void 0 ? void 0 : _b.channel_url);
  }, [channelUrl, channels]);
  var updateChannel = useThrottleCallback(function (channel, withUpdateTotalUnreadMessageCount) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var metadata, groupChannel;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, channel.getAllMetaData()];
          case 1:
            metadata = _a.sent();
            groupChannel = serializeGroupChannel(channel, metadata);
            updateChannelsItem(groupChannel);
            if (withUpdateTotalUnreadMessageCount) {
              updateTotalUnreadMessageCount();
            }
            return [2 /*return*/];
        }
      });
    });
  }, 1000);
  /**
   * 특정 이벤트 시 채널 목록 데이터 업데이트
   */
  useEffect(function () {
    if (!sb) return;
    var params = {
      onMessageReceived: function (_channel) {
        updateChannel(_channel, true);
      },
      onChannelChanged: function (_channel) {
        updateChannel(_channel);
      },
      onMessageUpdated: function (_channel) {
        updateChannel(_channel);
      }
    };
    var groupChannelHandler = new GroupChannelHandler(params);
    sb.groupChannel.addGroupChannelHandler('channelListEvent', groupChannelHandler);
    return function () {
      sb.groupChannel.removeGroupChannelHandler('channelListEvent');
    };
  }, [sb]);
  return jsx(ChannelsStateContext.Provider, {
    value: {
      channels: channels,
      isLoading: isLoading,
      isFetching: isFetching,
      isLast: isLast,
      searchParams: searchParams
    },
    children: jsx(ChannelsDispatchContext.Provider, {
      value: {
        refetch: refetch,
        fetchNext: fetchNext,
        setChannels: setChannels,
        setSearchParams: setSearchParams,
        updateChannelsItem: updateChannelsItem
      },
      children: children
    })
  });
};

var DEFAULT_USABLE_EXTENTIONS = ['share-document', 'attachment', 'gpt-minutes', 'gpt-rfi'];
var ChatContext = createContext({
  channelUrl: '',
  extentions: DEFAULT_USABLE_EXTENTIONS,
  setChannelUrl: function () {},
  renderFilePreview: function () {
    return null;
  }
});
var ChatProvider = function (props) {
  var children = props.children,
    channelUrl = props.channelUrl,
    extentions = props.extentions,
    shareDocument = props.shareDocument,
    gpt = props.gpt,
    invitableUsers = props.invitableUsers,
    _a = props.createChannelType,
    createChannelType = _a === void 0 ? 'GENERAL' : _a,
    channelListFilter = props.channelListFilter,
    onChangeChannel = props.onChangeChannel,
    renderFilePreview = props.renderFilePreview,
    renderCustomMessage = props.renderCustomMessage,
    onClickEstimateOrder = props.onClickEstimateOrder;
  /**
   * 선택된 Sendbird 채널 Url
   */
  var _b = useState(''),
    _channelUrl = _b[0],
    _setChannelUrl = _b[1];
  var computedChannelUrl = channelUrl !== null && channelUrl !== void 0 ? channelUrl : _channelUrl;
  var setChannelUrl = onChangeChannel || _setChannelUrl;
  var value = useMemo(function () {
    return {
      channelUrl: computedChannelUrl,
      extentions: extentions !== null && extentions !== void 0 ? extentions : DEFAULT_USABLE_EXTENTIONS,
      shareDocument: shareDocument,
      gpt: gpt,
      invitableUsers: invitableUsers,
      createChannelType: createChannelType,
      channelListFilter: channelListFilter,
      setChannelUrl: setChannelUrl,
      renderFilePreview: renderFilePreview,
      renderCustomMessage: renderCustomMessage,
      onClickEstimateOrder: onClickEstimateOrder
    };
  }, [computedChannelUrl, extentions, shareDocument, gpt, invitableUsers, createChannelType, channelListFilter, setChannelUrl, renderFilePreview, renderCustomMessage, onClickEstimateOrder]);
  return jsxs(Fragment, {
    children: [jsx(ChatGlobalStyle, {}), jsx(ChatContext.Provider, {
      value: value,
      children: jsx(ChannelsProvider, {
        children: children
      })
    })]
  });
};

var ChannelWrap = styled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  height: 100%;\n  background: var(--chat-channel-background);\n\n  &::selection {\n    color: #fff !important;\n    background: #94cbff !important;\n  }\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n  height: 100%;\n  background: var(--chat-channel-background);\n\n  &::selection {\n    color: #fff !important;\n    background: #94cbff !important;\n  }\n"])));
var ChannelConversationArea = styled.div(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"])));
var HeaderSpace = styled.div(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n  flex: 0 0 auto;\n"], ["\n  flex: 0 0 auto;\n"])));
var FooterSpace = styled.div(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  flex: 0 0 auto;\n"], ["\n  flex: 0 0 auto;\n"])));
var FooterSearchMode = styled.div(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 0 0 auto;\n  background: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 106px;\n\n  color: #1890ff;\n  font-weight: 500;\n  gap: 8px;\n\n  border-top: 1px solid #e9e9e9;\n"], ["\n  cursor: pointer;\n  flex: 0 0 auto;\n  background: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 106px;\n\n  color: #1890ff;\n  font-weight: 500;\n  gap: 8px;\n\n  border-top: 1px solid #e9e9e9;\n"])));
var templateObject_1$P, templateObject_2$B, templateObject_3$t, templateObject_4$j, templateObject_5$f;

var defineProperty$2 = {exports: {}};

var toPropertyKey = {exports: {}};

var _typeof$2 = {exports: {}};

(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }
  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof$2);
var _typeof$1 = /*@__PURE__*/getDefaultExportFromCjs(_typeof$2.exports);

var toPrimitive = {exports: {}};

(function (module) {
  var _typeof = _typeof$2.exports["default"];
  function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toPrimitive);

(function (module) {
  var _typeof = _typeof$2.exports["default"];
  var toPrimitive$1 = toPrimitive.exports;
  function _toPropertyKey(arg) {
    var key = toPrimitive$1(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
  }
  module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(toPropertyKey);

(function (module) {
  var toPropertyKey$1 = toPropertyKey.exports;
  function _defineProperty(obj, key, value) {
    key = toPropertyKey$1(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(defineProperty$2);
var _defineProperty$2 = /*@__PURE__*/getDefaultExportFromCjs(defineProperty$2.exports);

var objectWithoutProperties = {exports: {}};

var objectWithoutPropertiesLoose = {exports: {}};

(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(objectWithoutPropertiesLoose);

(function (module) {
  var objectWithoutPropertiesLoose$1 = objectWithoutPropertiesLoose.exports;
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(objectWithoutProperties);

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */
var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};

var e;
  (e = voidElements) && "object" == typeof e && "default" in e ? e.default : e;

function warn() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  };
};
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};
var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape
};
function getDefaults() {
  return defaultOptions;
}

var i18nInstance;
function getI18n() {
  return i18nInstance;
}

var classCallCheck = {exports: {}};

(function (module) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(classCallCheck);
var _classCallCheck$1 = /*@__PURE__*/getDefaultExportFromCjs(classCallCheck.exports);

var createClass = {exports: {}};

(function (module) {
  var toPropertyKey$1 = toPropertyKey.exports;
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, toPropertyKey$1(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(createClass);
var _createClass$1 = /*@__PURE__*/getDefaultExportFromCjs(createClass.exports);

var I18nContext = createContext();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$1(this, ReportNamespaces);
    this.usedNamespaces = {};
  }
  _createClass$1(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces;
}();

var slicedToArray = {exports: {}};

var arrayWithHoles = {exports: {}};

(function (module) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayWithHoles);

var iterableToArrayLimit = {exports: {}};

(function (module) {
  function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }
  module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(iterableToArrayLimit);

var unsupportedIterableToArray = {exports: {}};

var arrayLikeToArray = {exports: {}};

(function (module) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(arrayLikeToArray);

(function (module) {
  var arrayLikeToArray$1 = arrayLikeToArray.exports;
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray$1(o, minLen);
  }
  module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(unsupportedIterableToArray);

var nonIterableRest = {exports: {}};

(function (module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(nonIterableRest);

(function (module) {
  var arrayWithHoles$1 = arrayWithHoles.exports;
  var iterableToArrayLimit$1 = iterableToArrayLimit.exports;
  var unsupportedIterableToArray$1 = unsupportedIterableToArray.exports;
  var nonIterableRest$1 = nonIterableRest.exports;
  function _slicedToArray(arr, i) {
    return arrayWithHoles$1(arr) || iterableToArrayLimit$1(arr, i) || unsupportedIterableToArray$1(arr, i) || nonIterableRest$1();
  }
  module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(slicedToArray);
var _slicedToArray$1 = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray.exports);

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var usePrevious = function usePrevious(value, ignore) {
  var ref = useRef();
  useEffect(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {},
    i18nFromContext = _ref.i18n,
    defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && _typeof$1(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense,
    keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT),
    _useState2 = _slicedToArray$1(_useState, 2),
    t = _useState2[0],
    setT = _useState2[1];
  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
      bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      loadNamespaces(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}

/**
 * It's Tabs component
 * Inspired by Antd Tabs
 *
 * @param props
 * @returns
 */
var Tabs = function (props) {
  var defaultActiveKey = props.defaultActiveKey,
    items = props.items,
    style = props.style,
    onChange = props.onChange;
  var _a = useState(defaultActiveKey),
    activeKey = _a[0],
    setActiveKey = _a[1];
  var currentIndex = useMemo(function () {
    return items.findIndex(function (e) {
      return e.key === activeKey;
    });
  }, [items, activeKey]);
  var currentChildren = useMemo(function () {
    var _a;
    return (_a = items.find(function (e) {
      return e.key === activeKey;
    })) === null || _a === void 0 ? void 0 : _a.children;
  }, [items, activeKey]);
  var handleChange = function (value) {
    setActiveKey(value);
    onChange && onChange(value);
  };
  return jsxs(Fragment, {
    children: [jsxs(Box, {
      position: "relative",
      display: "flex",
      height: "42px",
      style: style,
      children: [items.map(function (item) {
        return jsx(TabItem, {
          active: activeKey === item.key,
          onClick: function () {
            return handleChange(item.key);
          },
          children: item.label
        }, item.key);
      }), jsx(BottomBar, {
        width: "100%",
        background: "#eeeeee"
      }), jsx(BottomBar, {
        width: 100 / items.length + '%',
        background: "var(--chat-color-primary)",
        style: {
          transform: "translateX(".concat(currentIndex * 100, "%)")
        }
      })]
    }), currentChildren]
  });
};
var BottomBar = styled(Box)(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  height: 2px;\n  transition:\n    backgroundColor 0.2s,\n    transform 0.2s;\n"], ["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  height: 2px;\n  transition:\n    backgroundColor 0.2s,\n    transform 0.2s;\n"])));
var TabItem = styled.a(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  color: #5c5c5c;\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n  transition: color 0.2s;\n\n  & > svg {\n    margin-right: 6px;\n  }\n\n  ", "\n\n  &:hover,\n  &:active {\n    color: ", ";\n    opacity: 1;\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  color: #5c5c5c;\n  text-decoration: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n  transition: color 0.2s;\n\n  & > svg {\n    margin-right: 6px;\n  }\n\n  ", "\n\n  &:hover,\n  &:active {\n    color: ", ";\n    opacity: 1;\n  }\n\n  ", ";\n"])), function (p) {
  if (!p.active) return '';
  if (!p.color) return "color: var(--chat-color-primary);";
  return "color: ".concat(p.color, ";");
}, function (p) {
  if (!p.active) return '#5c5c5c;';
  if (!p.color) return "var(--chat-color-primary)";
  return p.color;
}, function (_a) {
  var active = _a.active;
  if (!active) return '';
  return "\n        font-weight: 500;\n      ";
});
var templateObject_1$O, templateObject_2$A;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }
      return false;
    });
    return result;
  }
  return (/** @class */function () {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function () {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */
      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */
      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);
        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype.delete = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);
        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */
      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */
      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */
      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$3 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }
  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }
  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  }
  // eslint-disable-next-line no-new-func
  return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }
  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
  var leadingCall = false,
    trailingCall = false,
    lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */
  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */
  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);
    // Remove observer if it's present in registry.
    if (~index) {
      observers.splice(index, 1);
    }
    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */
  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();
    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */
  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser$3 || this.connected_) {
      return;
    }
    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */
  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser$3 || !this.connected_) {
      return;
    }
    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */
  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
      propertyName = _b === void 0 ? '' : _b;
    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */
  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }
    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */
  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function (target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function (target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  // Return the local global object if it's not possible extract one from
  // provided element.
  return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
    clientHeight = target.clientHeight;
  // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.
  var width = toFloat(styles.width),
    height = toFloat(styles.height);
  // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).
  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  }
  // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.
  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens
  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
  if (!isBrowser$3) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
  var x = _a.x,
    y = _a.y,
    width = _a.width,
    height = _a.height;
  // If DOMRectReadOnly is available use it as a prototype for the rectangle.
  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  // Rectangle's properties are not writable and non-enumerable.
  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */
  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */
  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }
  return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();
    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is already being observed.
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    // Force the update of observations.
    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */
  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */
  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */
  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver$1.prototype[method] = function () {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$4 = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();

function useRafState(initialState) {
  var ref = useRef(0);
  var _a = __read(useState(initialState), 2),
    state = _a[0],
    setState = _a[1];
  var setRafState = useCallback(function (value) {
    cancelAnimationFrame(ref.current);
    ref.current = requestAnimationFrame(function () {
      setState(value);
    });
  }, []);
  useUnmount$1(function () {
    cancelAnimationFrame(ref.current);
  });
  return [state, setRafState];
}

var isBrowser$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var isBrowser$2 = isBrowser$1;

function getTargetElement(target, defaultElement) {
  if (!isBrowser$2) {
    return undefined;
  }
  if (!target) {
    return defaultElement;
  }
  var targetElement;
  if (isFunction$3(target)) {
    targetElement = target();
  } else if ('current' in target) {
    targetElement = target.current;
  } else {
    targetElement = target;
  }
  return targetElement;
}

function depsAreSame(oldDeps, deps) {
  if (oldDeps === deps) return true;
  for (var i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) return false;
  }
  return true;
}

var createEffectWithTarget = function (useEffectType) {
  /**
   *
   * @param effect
   * @param deps
   * @param target target should compare ref.current vs ref.current, dom vs dom, ()=>dom vs ()=>dom
   */
  var useEffectWithTarget = function (effect, deps, target) {
    var hasInitRef = useRef(false);
    var lastElementRef = useRef([]);
    var lastDepsRef = useRef([]);
    var unLoadRef = useRef();
    useEffectType(function () {
      var _a;
      var targets = Array.isArray(target) ? target : [target];
      var els = targets.map(function (item) {
        return getTargetElement(item);
      });
      // init run
      if (!hasInitRef.current) {
        hasInitRef.current = true;
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
        return;
      }
      if (els.length !== lastElementRef.current.length || !depsAreSame(els, lastElementRef.current) || !depsAreSame(deps, lastDepsRef.current)) {
        (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
        lastElementRef.current = els;
        lastDepsRef.current = deps;
        unLoadRef.current = effect();
      }
    });
    useUnmount$1(function () {
      var _a;
      (_a = unLoadRef.current) === null || _a === void 0 ? void 0 : _a.call(unLoadRef);
      // for react-refresh
      hasInitRef.current = false;
    });
  };
  return useEffectWithTarget;
};
var createEffectWithTarget$1 = createEffectWithTarget;

var useEffectWithTarget$1 = createEffectWithTarget$1(useEffect);
var useEffectWithTarget$2 = useEffectWithTarget$1;

var useEffectWithTarget = createEffectWithTarget$1(useLayoutEffect);
var useLayoutEffectWithTarget = useEffectWithTarget;

var useIsomorphicLayoutEffectWithTarget = isBrowser$2 ? useLayoutEffectWithTarget : useEffectWithTarget$2;
var useIsomorphicLayoutEffectWithTarget$1 = useIsomorphicLayoutEffectWithTarget;

function useSize(target) {
  var _a = __read(useRafState(function () {
      var el = getTargetElement(target);
      return el ? {
        width: el.clientWidth,
        height: el.clientHeight
      } : undefined;
    }), 2),
    state = _a[0],
    setState = _a[1];
  useIsomorphicLayoutEffectWithTarget$1(function () {
    var el = getTargetElement(target);
    if (!el) {
      return;
    }
    var resizeObserver = new index$4(function (entries) {
      entries.forEach(function (entry) {
        var _a = entry.target,
          clientWidth = _a.clientWidth,
          clientHeight = _a.clientHeight;
        setState({
          width: clientWidth,
          height: clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [], target);
  return state;
}

var ChannelContext = createContext({
  channel: null,
  isLoading: true,
  isFailed: false,
  channelWrapRef: null,
  messageListRef: null,
  scrollRef: null,
  asideRef: null,
  headerRef: null,
  footerRef: null,
  asideKey: null,
  parentMessage: null,
  setParentMessage: function () {},
  toScrollBottom: function () {},
  setAsideKey: function () {},
  refreshChannel: function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  onLeaveChannel: function () {}
});
var ChannelProvider = function (props) {
  var children = props.children,
    channelUrl = props.channelUrl,
    onLeaveChannel = props.onLeaveChannel,
    searchQuery = props.searchQuery,
    searchWithTimestamp = props.searchWithTimestamp,
    onCloseSearchMode = props.onCloseSearchMode,
    onSearchPayloadChange = props.onSearchPayloadChange;
  var _a = useContext(ChatRootContext),
    sb = _a.sb,
    connected = _a.connected,
    updateTotalUnreadMessageCount = _a.updateTotalUnreadMessageCount;
  var updateChannelsItem = useContext(ChannelsDispatchContext).updateChannelsItem;
  var _b = useState(null),
    channel = _b[0],
    setChannel = _b[1];
  var _c = useState(false),
    isLoading = _c[0],
    setIsLoading = _c[1];
  var _d = useState(false),
    isFailed = _d[0],
    setIsFailed = _d[1];
  var _e = useState(null),
    asideKey = _e[0],
    setAsideKey = _e[1];
  var _f = useState(null),
    parentMessage = _f[0],
    setParentMessage = _f[1];
  var scrollRef = useRef(null);
  var channelWrapRef = useRef(null);
  var messageListRef = useRef(null);
  var headerRef = useRef(null);
  var footerRef = useRef(null);
  var asideRef = useRef(null);
  var toScrollBottom = function () {
    var _a, _b;
    var scrollHeight = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
    (_b = scrollRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
      top: scrollHeight
    });
  };
  var onAfterEnter = function (groupChannel) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var metadata, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);
            // 메시지 전체 읽음 처리
            return [4 /*yield*/, groupChannel.markAsRead()];
          case 1:
            // 메시지 전체 읽음 처리
            _a.sent();
            return [4 /*yield*/, groupChannel.refresh()];
          case 2:
            _a.sent();
            return [4 /*yield*/, groupChannel.getAllMetaData()];
          case 3:
            metadata = _a.sent();
            // 채널 목록 갱신
            updateChannelsItem(__assign$1(__assign$1({}, serializeGroupChannel(groupChannel, metadata)), {
              unread_message_count: 0
            }));
            // 전체 안읽은 메시지 갯수 갱신
            updateTotalUnreadMessageCount();
            return [3 /*break*/, 5];
          case 4:
            error_1 = _a.sent();
            console.error('[onAfterEnter] ', error_1);
            return [3 /*break*/, 5];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 채널 접속
   */
  var enterChannel = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var groupChannel, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!sb || !connected || !channelUrl) return [2 /*return*/];
            setIsFailed(false);
            // 답글 모드 초기화
            setParentMessage(null);
            /**
             * 현재 선택된 channelUrl와 일치하는 채널 정보가
             * 존재할 경우 로딩 미표시
             */
            if ((channel === null || channel === void 0 ? void 0 : channel.url) !== channelUrl) {
              setIsLoading(true);
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 4,, 5]);
            return [4 /*yield*/, sb.groupChannel.getChannel(channelUrl)];
          case 2:
            groupChannel = _a.sent();
            if (!groupChannel) {
              console.error('채널을 찾을 수 없습니다.');
            }
            return [4 /*yield*/, onAfterEnter(groupChannel)];
          case 3:
            _a.sent();
            setChannel(groupChannel);
            return [3 /*break*/, 5];
          case 4:
            error_2 = _a.sent();
            console.error('[enterChannel] ', error_2);
            setChannel(null);
            setIsFailed(true);
            return [3 /*break*/, 5];
          case 5:
            setIsLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    if (!sb || !connected || !channelUrl) return;
    /**
     * 이미 대상 채널의 데이터가 존재할 경우
     * onAfterEnter만 동작시킵니다.
     */
    if ((channel === null || channel === void 0 ? void 0 : channel.url) === channelUrl) {
      onAfterEnter(channel);
      return;
    }
    enterChannel();
  }, [sb, connected, channelUrl]);
  return jsx(ChannelContext.Provider, {
    value: {
      channel: channel,
      isLoading: isLoading,
      isFailed: isFailed,
      channelWrapRef: channelWrapRef,
      messageListRef: messageListRef,
      scrollRef: scrollRef,
      asideRef: asideRef,
      headerRef: headerRef,
      footerRef: footerRef,
      asideKey: asideKey,
      parentMessage: parentMessage,
      setParentMessage: setParentMessage,
      toScrollBottom: toScrollBottom,
      setAsideKey: setAsideKey,
      refreshChannel: enterChannel,
      onLeaveChannel: onLeaveChannel,
      searchQuery: searchQuery,
      searchWithTimestamp: searchWithTimestamp,
      onCloseSearchMode: onCloseSearchMode,
      onSearchPayloadChange: onSearchPayloadChange
    },
    children: children
  });
};
var useChannelContext = function () {
  return useContext(ChannelContext);
};

var AsideHeader = function (props) {
  var children = props.children,
    style = props.style,
    onClose = props.onClose;
  return jsxs(Header$6, {
    style: style,
    children: [jsx("div", {
      children: children
    }), jsx(Button$1, {
      variant: "plain",
      icon: jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [jsx("path", {
          d: "M5.11326 15.8079L15.8091 5.11204C16.0636 4.85761 16.0636 4.44513 15.8092 4.19076C15.5549 3.93638 15.1424 3.93642 14.888 4.19085L4.19207 14.8867C3.93764 15.1412 3.9376 15.5536 4.19198 15.808C4.44636 16.0624 4.85883 16.0624 5.11326 15.8079Z",
          fill: "#404040"
        }), jsx("path", {
          d: "M15.8079 14.8868L5.11204 4.19095C4.85761 3.93652 4.44513 3.93647 4.19076 4.19085C3.93638 4.44523 3.93642 4.8577 4.19085 5.11213L14.8867 15.808C15.1412 16.0625 15.5536 16.0625 15.808 15.8081C16.0624 15.5537 16.0624 15.1413 15.8079 14.8868Z",
          fill: "#404040"
        })]
      }),
      onClick: onClose,
      style: {
        marginTop: '-6px'
      }
    })]
  });
};
var Header$6 = styled.div(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: var(--chat-header-height);\n\n  padding: 22px 0.875rem 0 1rem;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  color: #2c384a;\n"], ["\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: var(--chat-header-height);\n\n  padding: 22px 0.875rem 0 1rem;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  color: #2c384a;\n"])));
var templateObject_1$N;

var ChannelAside = function (props) {
  var children = props.children,
    nonScroll = props.nonScroll,
    title = props.title,
    headerWithBorder = props.headerWithBorder,
    onClose = props.onClose;
  var _a = useContext(ChannelContext),
    channelWrapRef = _a.channelWrapRef,
    asideRef = _a.asideRef;
  var size = useSize(channelWrapRef);
  var isDrawerMode = useMemo(function () {
    if (((size === null || size === void 0 ? void 0 : size.width) || 0) > breakPoint.medium) return false;
    return true;
  }, [size === null || size === void 0 ? void 0 : size.width]);
  if (!(asideRef === null || asideRef === void 0 ? void 0 : asideRef.current)) return null;
  return createPortal(jsxs(ChannelAsideArea, {
    isDrawerMode: isDrawerMode,
    children: [jsxs(ChannelAsideDialog, {
      nonScroll: nonScroll,
      isDrawerMode: isDrawerMode,
      children: [!!title && jsx(AsideHeader, {
        onClose: onClose,
        style: {
          borderBottom: headerWithBorder ? '1px solid var(--chat-border-color)' : undefined
        },
        children: title
      }), children]
    }), isDrawerMode && jsx(Dim$1, {
      onClick: onClose
    })]
  }), asideRef === null || asideRef === void 0 ? void 0 : asideRef.current);
};
var ChannelAsideArea = styled.div(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  flex: 0 0 auto;\n  height: 100%;\n  overflow: hidden;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  ", "\n"], ["\n  flex: 0 0 auto;\n  height: 100%;\n  overflow: hidden;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  ", "\n"])), function (_a) {
  var isDrawerMode = _a.isDrawerMode;
  if (!isDrawerMode) return "\n        width: var(--chat-aside-width);\n      ";
  return "\n      position: absolute;\n      top: 0;\n      right: 0;\n      z-index: 100;\n      width: 100%;\n      background: rgba(0 0 0 / 50%);\n\n      animation-name: fadeIn;\n      animation-duration: 0.3s;\n      animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);\n      animation-direction: alternate;\n    ";
});
var ChannelAsideDialog = styled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  width: var(--chat-aside-width);\n  height: 100%;\n  background-color: var(--chat-background);\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  width: var(--chat-aside-width);\n  height: 100%;\n  background-color: var(--chat-background);\n\n  ", "\n\n  ", "\n"])), function (_a) {
  var nonScroll = _a.nonScroll;
  if (!nonScroll) return "\n      overflow: overlay;\n      ".concat(chatCustomScrollBar, "\n    ");
  return '';
}, function (_a) {
  var isDrawerMode = _a.isDrawerMode;
  if (!isDrawerMode) return "\n      border-left: 1px solid var(--chat-border-color);  \n    ";
  return "\n      --chat-aside-width: 100%;\n      \n      @keyframes slideIn {\n        from {\n          transform: translateX(100%);\n        }\n\n        to {\n          transform: translateX(0);\n        }\n      }\n      \n      animation-name: slideIn;\n      animation-duration: 250ms;\n      animation-timing-function: ease;\n      animation-direction: alternate;\n    ";
});
var Dim$1 = styled.div(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1$M, templateObject_2$z, templateObject_3$s;

var Card = function (props) {
  var thumbnailUrl = props.thumbnailUrl,
    title = props.title,
    description = props.description,
    meta = props.meta,
    children = props.children,
    args = __rest$2(props, ["thumbnailUrl", "title", "description", "meta", "children"]);
  return jsxs(CardLink$1, __assign$1({}, args, {
    children: [thumbnailUrl && jsx(Thumbnail$1, {
      children: jsx("img", {
        alt: title === null || title === void 0 ? void 0 : title.toString(),
        src: thumbnailUrl
      })
    }), jsxs(CardBody$1, {
      children: [jsx(Title$4, {
        children: title
      }), jsx(Description$2, {
        hasThumbnail: !!thumbnailUrl,
        children: description
      }), !!meta && jsx(Meta$1, {
        children: meta
      }), children]
    })]
  }));
};
var CardLink$1 = styled.a(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  position: relative;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n\n  width: var(--chat-message-max-width);\n  border: 1px solid #eeeeee;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--chat-message-background);\n\n  transition: all 250ms ease;\n\n  &:hover {\n    border-color: #dadada;\n  }\n  &:active {\n    border-color: #dadada;\n    background-color: #f9f9f9;\n  }\n"], ["\n  position: relative;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n\n  width: var(--chat-message-max-width);\n  border: 1px solid #eeeeee;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--chat-message-background);\n\n  transition: all 250ms ease;\n\n  &:hover {\n    border-color: #dadada;\n  }\n  &:active {\n    border-color: #dadada;\n    background-color: #f9f9f9;\n  }\n"])));
var Thumbnail$1 = styled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: 56.25%;\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"], ["\n  position: relative;\n  padding-bottom: 56.25%;\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"])));
var CardBody$1 = styled.div(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 1rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 1rem;\n"])));
var Title$4 = styled.h4(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  display: block;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  color: #2c384a;\n  font-size: var(--font-size-16, 16px);\n  font-weight: 500 !important;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n"], ["\n  display: block;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  color: #2c384a;\n  font-size: var(--font-size-16, 16px);\n  font-weight: 500 !important;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n"])));
var Description$2 = styled.div(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  color: #414c5c;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n\n  margin: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"], ["\n  color: #414c5c;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n\n  margin: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", "\n"])), function (_a) {
  var hasThumbnail = _a.hasThumbnail;
  if (!hasThumbnail) return "\n      -webkit-line-clamp: 4;\n    ";
  return "\n      -webkit-line-clamp: 2;\n    ";
});
var Meta$1 = styled.div(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  color: #7f8892;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 1.125;\n  letter-spacing: -0.02em;\n"], ["\n  color: #7f8892;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 1.125;\n  letter-spacing: -0.02em;\n"])));
var templateObject_1$L, templateObject_2$y, templateObject_3$r, templateObject_4$i, templateObject_5$e, templateObject_6$a;

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function () {

  // Exit early if we're not running in a browser.
  if (typeof window !== 'object') {
    return;
  }

  // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function () {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */
  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }

  /**
   * A local reference to the root document.
   */
  var document = function (startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);
    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }
    return doc;
  }(window.document);

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */
  var crossOriginUpdater = null;

  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect|ClientRect}
   */
  var crossOriginRect = null;

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};
    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }
    if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
      throw new Error('root must be a Document or Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');

    /** @private @const {!Array<!Document>} */
    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */
    this._monitoringUnsubscribes = [];
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */
  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect|ClientRect} boundingClientRect
       * @param {DOMRect|ClientRect} intersectionRect
       */
      crossOriginUpdater = function (boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }
        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }
    return crossOriginUpdater;
  };

  /**
   * Resets the cross-origin mode.
   */
  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });
    if (isTargetAlreadyObserved) {
      return;
    }
    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }
    this._registerInstance();
    this._observationTargets.push({
      element: target,
      entry: null
    });
    this._monitorIntersections(target.ownerDocument);
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });
    this._unmonitorIntersections(target.ownerDocument);
    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorAllIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;
    if (!win) {
      // Already destroyed.
      return;
    }
    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    }

    // Private state for monitoring.
    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);
      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
    this._monitoringDocuments.push(doc);
    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;
      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }
        removeEvent(win, 'resize', callback, true);
      }
      removeEvent(doc, 'scroll', callback, true);
      if (domObserver) {
        domObserver.disconnect();
      }
    });

    // Also monitor the parent.
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);
    if (index == -1) {
      return;
    }
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;

    // Check if any dependent targets are still remaining.
    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument;
      // Target is in this context.
      if (itemDoc == doc) {
        return true;
      }
      // Target is nested in this context.
      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;
        if (itemDoc == doc) {
          return true;
        }
      }
      return false;
    });
    if (hasDependentTargets) {
      return;
    }

    // Unsubscribe.
    var unsubscribe = this._monitoringUnsubscribes[index];
    this._monitoringDocuments.splice(index, 1);
    this._monitoringUnsubscribes.splice(index, 1);
    unsubscribe();

    // Also unmonitor the parent.
    if (doc != rootDoc) {
      var frame = getFrameElement(doc);
      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */
  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;
    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);
      var rootBounds = null;
      if (!this._rootContainsTarget(target)) {
        rootBounds = getEmptyRect();
      } else if (!crossOriginUpdater || this.root) {
        rootBounds = rootRect;
      }
      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootBounds,
        intersectionRect: intersectionRect
      });
      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);
    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;
    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return null;
      if (parent == this.root || parent.nodeType == /* DOCUMENT */9) {
        atRoot = true;
        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);
          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;
        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }
      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {ClientRect} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root && !isDoc(this.root)) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var doc = isDoc(this.root) ? this.root : document;
      var html = doc.documentElement;
      var body = doc.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {DOMRect|ClientRect} rect The rect object to expand.
   * @return {ClientRect} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;
    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
    return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detachEvent == 'function') {
      node.detachEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object|?ClientRect} The intersection rect or undefined if no
   *     intersection is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;
    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }
    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {ClientRect} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Ensure that the result has all of the necessary fields of the DOMRect.
   * Specifically this ensures that `x` and `y` fields are set.
   *
   * @param {?DOMRect|?ClientRect} rect
   * @return {?DOMRect}
   */
  function ensureDOMRect(rect) {
    // A `DOMRect` object has `x` and `y` fields.
    if (!rect || 'x' in rect) {
      return rect;
    }
    // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
    // for internally calculated Rect objects. For the purposes of
    // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
    // for these fields.
    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }

  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
   * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
   * @return {ClientRect} The local root bounding rect for the parent's children.
   */
  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }

  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;
    if (node.nodeType == /* DOCUMENT */9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    }

    // If the parent has element that is assigned through shadow root slot
    if (parent && parent.assignedSlot) {
      parent = parent.assignedSlot.parentNode;
    }
    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }
    return parent;
  }

  /**
   * Returns true if `node` is a Document.
   * @param {!Node} node
   * @returns {boolean}
   */
  function isDoc(node) {
    return node && node.nodeType === 9;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();

function useInViewport(target, options) {
  var _a = __read(useState(), 2),
    state = _a[0],
    setState = _a[1];
  var _b = __read(useState(), 2),
    ratio = _b[0],
    setRatio = _b[1];
  useEffectWithTarget$2(function () {
    var el = getTargetElement(target);
    if (!el) {
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      var e_1, _a;
      try {
        for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
          var entry = entries_1_1.value;
          setRatio(entry.intersectionRatio);
          setState(entry.isIntersecting);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }, __assign$1(__assign$1({}, options), {
      root: getTargetElement(options === null || options === void 0 ? void 0 : options.root)
    }));
    observer.observe(el);
    return function () {
      observer.disconnect();
    };
  }, [options === null || options === void 0 ? void 0 : options.rootMargin, options === null || options === void 0 ? void 0 : options.threshold], target);
  return [state, ratio];
}

/**
 * Infinite Scroll Component
 * inspired by antd mobile InfiniteScroll
 *
 * @example
 * ```tsx
 * <List>
 *   {data.map((item, index) => (
 *     <List.Item key={index}>{item}</List.Item>
 *   ))}
 * </List>
 * <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
 * ```
 */
var InfiniteScroll = function (props) {
  var hasMore = props.hasMore,
    children = props.children,
    disableInitFetch = props.disableInitFetch,
    style = props.style,
    loadMore = props.loadMore;
  var _a = useState(false),
    isLoading = _a[0],
    setIsLoading = _a[1];
  var _b = useState(disableInitFetch),
    isInit = _b[0],
    setIsInit = _b[1];
  var targetRef = useRef(null);
  var inViewport = useInViewport(targetRef)[0];
  var handleLoad = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setIsLoading(true);
            return [4 /*yield*/, loadMore(false)];
          case 1:
            _a.sent();
            setIsLoading(false);
            setTimeout(function () {
              return setIsInit(true);
            }, 1000);
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 최초 한 번은 무조건 fetch를 진행한다.
   */
  useEffect(function () {
    if (isInit) return;
    handleLoad();
  }, [isInit]);
  /**
   * 최초 로드 이후 타겟 엘리먼트가 화면에 보여질 때마다
   * fetch를 진행한다.
   */
  useEffect(function () {
    if (!inViewport || isLoading || !isInit) return;
    handleLoad();
  }, [inViewport, isInit]);
  var renderTarget = function () {
    if (children) return children;
    var skeletonTemplate = jsx(List$4.Item, {
      children: jsx(Skeleton, {
        avatar: true,
        title: false,
        loading: true,
        active: true
      })
    });
    return jsxs(Box, {
      p: "1rem",
      children: [skeletonTemplate, skeletonTemplate, skeletonTemplate, skeletonTemplate]
    });
  };
  if (!hasMore) return null;
  if (!isInit) return jsx(Box, {
    style: style,
    children: renderTarget()
  });
  return jsx(Box, {
    ref: targetRef,
    style: style,
    children: renderTarget()
  });
};

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$1(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */

var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized$1(_this);
  }
  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV

  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare

function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends$2({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends$2({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
} // prettier-ignore

var curriedMix = /*#__PURE__*/curry
/* ::<number | string, string, string, string> */(mix);
var mix$1 = curriedMix;

var Fab = function (props) {
  var disabled = props.disabled,
    okText = props.okText,
    cancelText = props.cancelText,
    onOk = props.onOk,
    onCancel = props.onCancel;
  return jsxs(ButtonWrap$1, {
    children: [jsx(PrimaryButton, {
      type: "submit",
      disabled: disabled,
      onClick: onOk,
      children: okText
    }), !!cancelText && !!onCancel && jsx(CommonButton, {
      onClick: onCancel,
      children: cancelText
    })]
  });
};
var ButtonWrap$1 = styled.div(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  display: flex;\n  align-items: stretch;\n  height: 48px;\n"], ["\n  display: flex;\n  align-items: stretch;\n  height: 48px;\n"])));
var CommonButton = styled.button(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: #262626;\n  background-color: #f5f5f5;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: color-mix(in srgb, black 10%, #f5f5f5);\n  }\n  &:active:not(:disabled) {\n    background-color: color-mix(in srgb, black 20%, #f5f5f5);\n  }\n\n  &:disabled {\n    color: #bfbfbf;\n    background: #ededed;\n  }\n"], ["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: #262626;\n  background-color: #f5f5f5;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: color-mix(in srgb, black 10%, #f5f5f5);\n  }\n  &:active:not(:disabled) {\n    background-color: color-mix(in srgb, black 20%, #f5f5f5);\n  }\n\n  &:disabled {\n    color: #bfbfbf;\n    background: #ededed;\n  }\n"])));
var PrimaryButton = styled(CommonButton)(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  color: white;\n  background-color: var(--chat-color-primary);\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n"], ["\n  color: white;\n  background-color: var(--chat-color-primary);\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n"])), mix$1(0.1, 'white', '#1890ff'), mix$1(0.1, 'black', '#1890ff'));
var templateObject_1$K, templateObject_2$x, templateObject_3$q;

var UserProfile = function (props) {
  var thumbnailUrl = props.thumbnailUrl,
    companyName = props.companyName,
    userName = props.userName,
    size = props.size,
    layout = props.layout,
    textColor = props.textColor,
    style = props.style,
    _a = props.textOverflow,
    textOverflow = _a === void 0 ? true : _a,
    placeholder = props.placeholder;
  var layoutStyle = layout !== null && layout !== void 0 ? layout : 'column';
  return jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [jsx(Box, {
      flex: "0 0 auto",
      children: jsx(Avatar, {
        src: thumbnailUrl || undefined,
        size: size || 38,
        name: userName
      })
    }), layoutStyle === 'column' ? jsxs(ContentArea, {
      textOverflow: textOverflow,
      style: __assign$1({
        color: textColor
      }, style),
      children: [companyName ? jsx(Box, {
        color: "#414C5C",
        fontWeight: 400,
        fontSize: "var(--font-size-14, 14px)",
        lineHeight: "var(--font-size-18, 18px)",
        mb: "2px",
        children: companyName
      }) : null, jsx(Box, {
        color: "#2C384A",
        fontSize: "var(--font-size-16, 16px)",
        fontWeight: 400,
        lineHeight: "var(--font-size-20, 20px)",
        children: userName || placeholder
      })]
    }) : jsx(Box, {
      alignItems: "center",
      paddingLeft: "8px",
      lineHeight: "1.5rem",
      style: style,
      children: companyName ? "".concat(companyName, " ").concat(userName) : "".concat(userName)
    })]
  });
};
var ContentArea = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  flex: 0 0 auto;\n  padding-left: 8px;\n  color: #262626;\n  text-align: left;\n  line-height: 1.3;\n\n  min-width: 0;\n  max-width: 150px;\n\n  & > div {\n    white-space: nowrap;\n  }\n\n  ", "\n"], ["\n  flex: 0 0 auto;\n  padding-left: 8px;\n  color: #262626;\n  text-align: left;\n  line-height: 1.3;\n\n  min-width: 0;\n  max-width: 150px;\n\n  & > div {\n    white-space: nowrap;\n  }\n\n  ", "\n"])), function (p) {
  if (!p.textOverflow) return '';
  return "\n        max-width: 100%;\n        & > div {\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      ";
});
var templateObject_1$J;

var IconsManifest = [{
  "id": "fa",
  "name": "Font Awesome",
  "projectUrl": "https://fontawesome.com/",
  "license": "CC BY 4.0 License",
  "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
}, {
  "id": "io",
  "name": "Ionicons 4",
  "projectUrl": "https://ionicons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
}, {
  "id": "io5",
  "name": "Ionicons 5",
  "projectUrl": "https://ionicons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
}, {
  "id": "md",
  "name": "Material Design icons",
  "projectUrl": "http://google.github.io/material-design-icons/",
  "license": "Apache License Version 2.0",
  "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
}, {
  "id": "ti",
  "name": "Typicons",
  "projectUrl": "http://s-ings.com/typicons/",
  "license": "CC BY-SA 3.0",
  "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
}, {
  "id": "go",
  "name": "Github Octicons icons",
  "projectUrl": "https://octicons.github.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
}, {
  "id": "fi",
  "name": "Feather",
  "projectUrl": "https://feathericons.com/",
  "license": "MIT",
  "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
}, {
  "id": "gi",
  "name": "Game Icons",
  "projectUrl": "https://game-icons.net/",
  "license": "CC BY 3.0",
  "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
}, {
  "id": "wi",
  "name": "Weather Icons",
  "projectUrl": "https://erikflowers.github.io/weather-icons/",
  "license": "SIL OFL 1.1",
  "licenseUrl": "http://scripts.sil.org/OFL"
}, {
  "id": "di",
  "name": "Devicons",
  "projectUrl": "https://vorillaz.github.io/devicons/",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "ai",
  "name": "Ant Design Icons",
  "projectUrl": "https://github.com/ant-design/ant-design-icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "bs",
  "name": "Bootstrap Icons",
  "projectUrl": "https://github.com/twbs/icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "ri",
  "name": "Remix Icon",
  "projectUrl": "https://github.com/Remix-Design/RemixIcon",
  "license": "Apache License Version 2.0",
  "licenseUrl": "http://www.apache.org/licenses/"
}, {
  "id": "fc",
  "name": "Flat Color Icons",
  "projectUrl": "https://github.com/icons8/flat-color-icons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "gr",
  "name": "Grommet-Icons",
  "projectUrl": "https://github.com/grommet/grommet-icons",
  "license": "Apache License Version 2.0",
  "licenseUrl": "http://www.apache.org/licenses/"
}, {
  "id": "hi",
  "name": "Heroicons",
  "projectUrl": "https://github.com/refactoringui/heroicons",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "si",
  "name": "Simple Icons",
  "projectUrl": "https://simpleicons.org/",
  "license": "CC0 1.0 Universal",
  "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
}, {
  "id": "im",
  "name": "IcoMoon Free",
  "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
  "license": "CC BY 4.0 License"
}, {
  "id": "bi",
  "name": "BoxIcons",
  "projectUrl": "https://github.com/atisawd/boxicons",
  "license": "CC BY 4.0 License"
}, {
  "id": "cg",
  "name": "css.gg",
  "projectUrl": "https://github.com/astrit/css.gg",
  "license": "MIT",
  "licenseUrl": "https://opensource.org/licenses/MIT"
}, {
  "id": "vsc",
  "name": "VS Code Icons",
  "projectUrl": "https://github.com/microsoft/vscode-codicons",
  "license": "CC BY 4.0",
  "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
}];

var DefaultContext$1 = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext$1 = React__default$1.createContext && React__default$1.createContext(DefaultContext$1);

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React__default$1.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon$8(data) {
  return function (props) {
    return React__default$1.createElement(IconBase$1, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase$1(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return React__default$1.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default$1.createElement("title", null, title), props.children);
  };
  return IconContext$1 !== undefined ? React__default$1.createElement(IconContext$1.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext$1);
}

var esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    IconsManifest: IconsManifest,
    GenIcon: GenIcon$8,
    IconBase: IconBase$1,
    DefaultContext: DefaultContext$1,
    IconContext: IconContext$1
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(esm);

// THIS FILE IS AUTO GENERATED
var GenIcon$7 = require$$0.GenIcon;
var AiFillCheckCircle_1 = function AiFillCheckCircle(props) {
  return GenIcon$7({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
      }
    }]
  })(props);
};

// THIS FILE IS AUTO GENERATED
var GenIcon$6 = require$$0.GenIcon;
var MdError_1 = function MdError(props) {
  return GenIcon$6({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      }
    }]
  })(props);
};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classNames = classnames.exports;

var Result = function (props) {
  var status = props.status,
    size = props.size,
    icon = props.icon,
    title = props.title,
    description = props.description,
    extra = props.extra,
    children = props.children,
    withPage = props.withPage,
    withSpace = props.withSpace,
    style = props.style,
    args = __rest$2(props, ["status", "size", "icon", "title", "description", "extra", "children", "withPage", "withSpace", "style"]);
  var computedIcon = useMemo(function () {
    if (icon) return icon;
    switch (status) {
      case 'loading':
        return jsx(Spinner, {
          style: {
            color: '#1890FF',
            width: '2.5rem',
            height: '2.5rem'
          }
        });
      case 'empty':
        return jsxs("svg", {
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          style: {
            marginBottom: size === 'large' ? '-1rem' : 0
          },
          children: [jsx("path", {
            d: "M30 6.25H10C7.96875 6.25 6.64062 7.34375 6.25 9.375L3.75 21.25V30C3.75289 30.9937 4.1489 31.9458 4.85154 32.6485C5.55417 33.3511 6.50633 33.7471 7.5 33.75H32.5C33.4937 33.7471 34.4458 33.3511 35.1485 32.6485C35.8511 31.9458 36.2471 30.9937 36.25 30V21.25L33.75 9.375C33.3594 7.26562 31.9531 6.25 30 6.25Z",
            stroke: "#C4C4C4",
            strokeWidth: "2.5",
            strokeLinejoin: "round"
          }), jsx("path", {
            d: "M3.75 21.25H15C15 22.5761 15.5268 23.8479 16.4645 24.7855C17.4021 25.7232 18.6739 26.25 20 26.25C21.3261 26.25 22.5979 25.7232 23.5355 24.7855C24.4732 23.8479 25 22.5761 25 21.25H36.25",
            stroke: "#C4C4C4",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        });
      case 'error':
        return jsx(MdError_1, {
          color: "#FF6661"
        });
      case 'success':
      default:
        return jsx(AiFillCheckCircle_1, {
          color: "#60CA21"
        });
    }
  }, [icon, status]);
  return jsxs(Wrapper, __assign$1({
    className: classNames("size-".concat(size)),
    withPage: withPage,
    withSpace: withSpace,
    style: style
  }, args, {
    children: [jsx(IconWrapper, {
      children: computedIcon
    }), jsx(Title$3, {
      smallEmptyMode: size === 'small' && status === 'empty',
      children: title
    }), jsx(Description$1, {
      children: description
    }), !!extra && jsx(Extra, {
      children: extra
    }), children]
  }));
};
var Wrapper = styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  ", "\n\n  ", "\n"])), function (_a) {
  var withPage = _a.withPage;
  if (!withPage) return '';
  return "\n      padding-top: 20vh;\n      padding-bottom: 20vh;\n    ";
}, function (_a) {
  var withSpace = _a.withSpace;
  if (!withSpace) return '';
  return "\n      padding-top: 3rem;\n      padding-bottom: 3rem;\n    ";
});
var IconWrapper = styled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 32px;\n  & > svg {\n    width: 100px;\n    height: 100px;\n  }\n\n  .size-medium & {\n    margin-bottom: 1rem;\n    & > svg {\n      width: 4rem;\n      height: 4rem;\n    }\n  }\n  .size-small & {\n    margin-bottom: 0.75rem;\n    & > svg {\n      width: 2.5rem;\n      height: 2.5rem;\n    }\n  }\n"], ["\n  display: flex;\n  margin-bottom: 32px;\n  & > svg {\n    width: 100px;\n    height: 100px;\n  }\n\n  .size-medium & {\n    margin-bottom: 1rem;\n    & > svg {\n      width: 4rem;\n      height: 4rem;\n    }\n  }\n  .size-small & {\n    margin-bottom: 0.75rem;\n    & > svg {\n      width: 2.5rem;\n      height: 2.5rem;\n    }\n  }\n"])));
var Title$3 = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  max-width: 420px;\n  margin-bottom: 4px;\n\n  font-weight: 400;\n  font-size: var(--font-size-20, 20px);\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #262626;\n\n  ", "\n\n  .size-medium & {\n    font-size: var(--font-size-18, 18px);\n  }\n\n  .size-small & {\n    font-size: var(--font-size-16, 16px);\n  }\n"], ["\n  max-width: 420px;\n  margin-bottom: 4px;\n\n  font-weight: 400;\n  font-size: var(--font-size-20, 20px);\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #262626;\n\n  ", "\n\n  .size-medium & {\n    font-size: var(--font-size-18, 18px);\n  }\n\n  .size-small & {\n    font-size: var(--font-size-16, 16px);\n  }\n"])), function (_a) {
  var smallEmptyMode = _a.smallEmptyMode;
  if (!smallEmptyMode) return '';
  return "\n      color: #939393;\n    ";
});
var Description$1 = styled.p(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  max-width: 420px;\n  margin: 0 0 1rem 0;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #939393;\n\n  .size-medium & {\n    font-size: var(--font-size-16, 16px);\n  }\n  .size-small & {\n    font-size: var(--font-size-14, 14px);\n  }\n"], ["\n  max-width: 420px;\n  margin: 0 0 1rem 0;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #939393;\n\n  .size-medium & {\n    font-size: var(--font-size-16, 16px);\n  }\n  .size-small & {\n    font-size: var(--font-size-14, 14px);\n  }\n"])));
var Extra = styled.div(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n"])));
var templateObject_1$I, templateObject_2$w, templateObject_3$p, templateObject_4$h, templateObject_5$d;

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  (function (module) {

    if (process.env.NODE_ENV === 'production') {
      module.exports = requireReactIs_production_min();
    } else {
      module.exports = requireReactIs_development();
    }
  })(reactIs);
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.number, propTypes.exports.shape({
  enter: propTypes.exports.number,
  exit: propTypes.exports.number,
  appear: propTypes.exports.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.shape({
  enter: propTypes.exports.string,
  exit: propTypes.exports.string,
  active: propTypes.exports.string
}), propTypes.exports.shape({
  enter: propTypes.exports.string,
  enterDone: propTypes.exports.string,
  enterActive: propTypes.exports.string,
  exit: propTypes.exports.string,
  exitDone: propTypes.exports.string,
  exitActive: propTypes.exports.string
})]) : null;

var TransitionGroupContext = React__default$1.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      React__default$1.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default$1.cloneElement(React__default$1.Children.only(children), childProps))
    );
  };
  return Transition;
}(React__default$1.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.exports.shape({
    current: typeof Element === 'undefined' ? propTypes.exports.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.exports.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.exports.oneOfType([propTypes.exports.func.isRequired, propTypes.exports.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.exports.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.exports.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.exports.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.exports.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.exports.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.exports.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.exports.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.exports.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.exports.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.exports.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.exports.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.exports.func
} : {}; // Name the function so it is clearer in the documentation

function noop$1() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
      _this$props.classNames;
      var props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);
    return /*#__PURE__*/React__default$1.createElement(Transition, _extends$2({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React__default$1.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$2({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: propTypes.exports.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: propTypes.exports.func
}) : {};

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$2({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default$1.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default$1.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default$1.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default$1.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: propTypes.exports.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: propTypes.exports.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: propTypes.exports.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: propTypes.exports.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: propTypes.exports.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: propTypes.exports.func
} : {};
TransitionGroup.defaultProps = defaultProps;

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);
  function ReplaceTransition() {
    var _this;
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _this.handleLifecycle('onEnter', 0, args);
    };
    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return _this.handleLifecycle('onEntering', 0, args);
    };
    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return _this.handleLifecycle('onEntered', 0, args);
    };
    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return _this.handleLifecycle('onExit', 1, args);
    };
    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return _this.handleLifecycle('onExiting', 1, args);
    };
    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return _this.handleLifecycle('onExited', 1, args);
    };
    return _this;
  }
  var _proto = ReplaceTransition.prototype;
  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;
    var children = this.props.children;
    var child = React__default$1.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      inProp = _this$props.in,
      props = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in"]);
    var _React$Children$toArr = React__default$1.Children.toArray(children),
      first = _React$Children$toArr[0],
      second = _React$Children$toArr[1];
    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/React__default$1.createElement(TransitionGroup, props, inProp ? React__default$1.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : React__default$1.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };
  return ReplaceTransition;
}(React__default$1.Component);
ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: propTypes.exports.bool.isRequired,
  children: function children(props, propName) {
    if (React__default$1.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};

var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (React__default$1.isValidElement(oldChildren) && React__default$1.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return React__default$1.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, React__default$1.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return React__default$1.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, React__default$1.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [React__default$1.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, React__default$1.cloneElement(children, {
        in: true
      }));
    })
  }), React__default$1.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: React__default$1.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/React__default$1.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(React__default$1.Component);
SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: propTypes.exports.oneOf([modes.in, modes.out]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: propTypes.exports.oneOfType([propTypes.exports.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};

var MessageSelectContext = createContext({
  enabled: false,
  mode: null,
  startAt: null,
  endAt: null,
  selectedMessageIds: [],
  generatedMessage: '',
  setMode: function () {},
  setStartAt: function () {},
  setEndAt: function () {},
  setGeneratedMessage: function () {}
});
var MessageSelectProvider = function (props) {
  var children = props.children;
  var channel = useContext(ChannelContext).channel;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var _a = useState(null),
    mode = _a[0],
    setMode = _a[1];
  var _b = useState(null),
    startAt = _b[0],
    setStartAt = _b[1];
  var _c = useState(null),
    endAt = _c[0],
    setEndAt = _c[1];
  var _d = useState(''),
    generatedMessage = _d[0],
    setGeneratedMessage = _d[1];
  useEffect(function () {
    setMode(null);
    setStartAt(null);
    setEndAt(null);
    setGeneratedMessage('');
  }, [channel === null || channel === void 0 ? void 0 : channel.url]);
  var selectedMessageIds = useMemo(function () {
    var _a;
    var filteredMessages = (_a = messageDataSource === null || messageDataSource === void 0 ? void 0 : messageDataSource.messages) === null || _a === void 0 ? void 0 : _a.filter(function (message) {
      // 시작일이 없다면 모두 false
      if (!startAt) return false;
      // 시작일은 있지만 종료일은 없는 경우
      if (!endAt) {
        // 시작일과 현재 메시지가 정확히 일치해야만 true
        if (startAt === message.createdAt) return true;
        return false;
      }
      // 시작일과 종료일이 모두 있는 경우
      // 시작일 이후, 시작일 이전인 메시지만 true
      if (startAt <= message.createdAt && endAt >= message.createdAt) return true;
      return false;
    });
    return filteredMessages.map(function (message) {
      return message.messageId;
    });
  }, [startAt, endAt]);
  var enabled = useMemo(function () {
    return !!mode;
  }, [mode]);
  return jsx(MessageSelectContext.Provider, {
    value: {
      enabled: enabled,
      mode: mode,
      startAt: startAt,
      endAt: endAt,
      selectedMessageIds: selectedMessageIds,
      generatedMessage: generatedMessage,
      setMode: setMode,
      setStartAt: setStartAt,
      setEndAt: setEndAt,
      setGeneratedMessage: setGeneratedMessage
    },
    children: children
  });
};

var Confirm = function (props) {
  var open = props.open,
    _a = props.type,
    type = _a === void 0 ? 'info' : _a,
    title = props.title,
    _b = props.okText,
    okText = _b === void 0 ? '확인' : _b,
    _c = props.cancelText,
    cancelText = _c === void 0 ? '취소' : _c,
    onOk = props.onOk,
    onCancel = props.onCancel;
  var channelWrapRef = useContext(ChannelContext).channelWrapRef;
  var nodeRef = useRef(null);
  if (!(channelWrapRef === null || channelWrapRef === void 0 ? void 0 : channelWrapRef.current)) return null;
  return createPortal(jsx(CSSTransition, {
    nodeRef: nodeRef,
    in: open,
    timeout: 200,
    unmountOnExit: true,
    children: jsx(Overlay$1, {
      ref: nodeRef,
      children: jsxs(Dialog$3, {
        children: [jsx(DialogContent, {
          children: title
        }), jsxs(DialogFooter, {
          children: [jsx(DialogButton, {
            onClick: onCancel,
            children: cancelText
          }), jsx(DialogButton, {
            confirmType: type,
            onClick: onOk,
            children: okText
          })]
        })]
      })
    })
  }), channelWrapRef.current);
};
var Dialog$3 = styled.div(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  width: 270px;\n  border-radius: 8px;\n  background: #fff;\n"], ["\n  width: 270px;\n  border-radius: 8px;\n  background: #fff;\n"])));
var Overlay$1 = styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 400;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n\n  &.enter {\n    opacity: 0;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 400;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n\n  &.enter {\n    opacity: 0;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n"])), Dialog$3, Dialog$3, Dialog$3, Dialog$3);
var DialogContent = styled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  padding: 28px 24px;\n  color: #262626;\n  text-align: center;\n  font-size: var(--font-size-16, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n"], ["\n  padding: 28px 24px;\n  color: #262626;\n  text-align: center;\n  font-size: var(--font-size-16, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n"])));
var DialogFooter = styled.div(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  display: flex;\n  border-top: 1px solid #eeeeee;\n"], ["\n  display: flex;\n  border-top: 1px solid #eeeeee;\n"])));
var DialogButton = styled.button(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 42px;\n\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n\n  &:not(:last-of-type) {\n    border-right: 1px solid #eeeeee;\n  }\n\n  color: #999;\n  font-size: var(--font-size-16, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n\n  transform: 150ms ease;\n\n  &:hover {\n    background: rgba(0 0 0 / 5%);\n  }\n\n  ", "\n"], ["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 42px;\n\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n\n  &:not(:last-of-type) {\n    border-right: 1px solid #eeeeee;\n  }\n\n  color: #999;\n  font-size: var(--font-size-16, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-align: center;\n\n  transform: 150ms ease;\n\n  &:hover {\n    background: rgba(0 0 0 / 5%);\n  }\n\n  ", "\n"])), function (_a) {
  var confirmType = _a.confirmType;
  switch (confirmType) {
    case 'danger':
      return "color: #FF6661;";
    case 'warning':
      return "color: #ffb361;";
    case 'info':
    default:
      return "\n          color: var(--chat-color-primary);\n        ";
  }
});
var templateObject_1$H, templateObject_2$v, templateObject_3$o, templateObject_4$g, templateObject_5$c;

var ChannelPortal = function (props) {
  var children = props.children;
  var channelWrapRef = useContext(ChannelContext).channelWrapRef;
  if (!(channelWrapRef === null || channelWrapRef === void 0 ? void 0 : channelWrapRef.current)) return null;
  return createPortal(jsx(Fragment, {
    children: children
  }), channelWrapRef.current);
};

var InputWrapper = styled.div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 46px;\n\n  & > input {\n    display: block;\n    width: 100%;\n    height: 100%;\n    padding: 0 46px 0 1rem;\n    margin: 0;\n\n    background: white;\n    border: 1px solid #eeeeee;\n    border-radius: 6px;\n\n    color: #262626;\n    font-size: 1rem;\n    font-weight: 400;\n\n    outline: none;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: 1rem;\n      font-weight: 400;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 46px;\n\n  & > input {\n    display: block;\n    width: 100%;\n    height: 100%;\n    padding: 0 46px 0 1rem;\n    margin: 0;\n\n    background: white;\n    border: 1px solid #eeeeee;\n    border-radius: 6px;\n\n    color: #262626;\n    font-size: 1rem;\n    font-weight: 400;\n\n    outline: none;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: 1rem;\n      font-weight: 400;\n    }\n  }\n"])));
var StyledButton$1 = styled.button(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"])));
var RightButtonArea = styled.div(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1$G, templateObject_2$u, templateObject_3$n;

var InputSearch = function (props) {
  var value = props.value,
    placeholder = props.placeholder,
    onChange = props.onChange,
    onSearch = props.onSearch;
  var handleClear = function () {
    onChange('');
    onSearch('');
  };
  return jsxs(InputWrapper, {
    children: [jsx("input", {
      value: value,
      placeholder: placeholder,
      onChange: function (e) {
        return onChange(e.target.value);
      },
      onKeyDown: function (e) {
        if (e.key === 'Enter') {
          onSearch(value);
        }
      },
      style: {
        paddingRight: value ? 46 * 2 : undefined
      }
    }), jsxs(RightButtonArea, {
      children: [!!value && jsx(StyledButton$1, {
        onClick: handleClear,
        children: jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "46",
          height: "46",
          viewBox: "0 0 46 46",
          fill: "none",
          children: [jsx("circle", {
            cx: "23",
            cy: "23",
            r: "8",
            fill: "#D9D9D9"
          }), jsx("path", {
            d: "M20 26.0003L26 20M26 26.0003L20 20",
            stroke: "white",
            strokeWidth: "1.3",
            strokeLinecap: "round"
          })]
        })
      }), jsx(StyledButton$1, {
        onClick: function () {
          return onSearch(value);
        },
        children: jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "46",
          height: "46",
          viewBox: "0 0 46 46",
          fill: "none",
          children: [jsx("path", {
            d: "M21.5 29C25.6421 29 29 25.6421 29 21.5C29 17.3579 25.6421 14 21.5 14C17.3579 14 14 17.3579 14 21.5C14 25.6421 17.3579 29 21.5 29Z",
            stroke: "#404040",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), jsx("path", {
            d: "M32 32L27 27",
            stroke: "#404040",
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        })
      })]
    })]
  });
};

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React$1.createContext && React$1.createContext(DefaultContext);

function GenIcon$5(element) {
  return function (props) {
    var _a;
    return jsx(IconBase, __assign$1({
      attr: __assign$1({}, element.props)
    }, props, {
      children: (_a = element.props) === null || _a === void 0 ? void 0 : _a.children
    }));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest$2(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || '1em';
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return jsxs("svg", __assign$1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign$1(__assign$1({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg",
      children: [title && jsx("title", {
        children: title
      }), props.children]
    }));
  };
  return IconContext !== undefined ? jsx(IconContext.Consumer, {
    children: function (conf) {
      return elem(conf);
    }
  }) : elem(DefaultContext);
}

GenIcon$5(jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54038 4.54036C3.79422 4.28652 4.20578 4.28652 4.45962 4.54036L9.5 9.58074L14.5404 4.54036C14.7942 4.28652 15.2058 4.28652 15.4596 4.54036C15.7135 4.7942 15.7135 5.20575 15.4596 5.45959L10.4192 10.5L15.4596 15.5404C15.7135 15.7942 15.7135 16.2058 15.4596 16.4596C15.2058 16.7134 14.7942 16.7134 14.5404 16.4596L9.5 11.4192L4.45962 16.4596C4.20578 16.7134 3.79422 16.7134 3.54038 16.4596C3.28654 16.2058 3.28654 15.7942 3.54038 15.5404L8.58076 10.5L3.54038 5.45959C3.28654 5.20575 3.28654 4.7942 3.54038 4.54036Z",
    fill: "currentColor"
  })
}));
var IconPlus = GenIcon$5(jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M2 8.5H14",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M8 14.5L8 2.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })]
}));

styled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n\n  color: white;\n  font-size: 1.5rem;\n  background-color: #5292fa;\n  overflow: hidden;\n\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n\n  svg {\n    path {\n      stroke-width: 2.5rem;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n\n  color: white;\n  font-size: 1.5rem;\n  background-color: #5292fa;\n  overflow: hidden;\n\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n\n  svg {\n    path {\n      stroke-width: 2.5rem;\n    }\n  }\n"])));
var templateObject_1$F;

var Overlay = function (props) {
  var children = props.children,
    open = props.open,
    onClose = props.onClose;
  if (!open) return null;
  return createPortal(jsxs(OverlayContainer, {
    children: [children, jsx(Dim, {
      onClick: onClose
    })]
  }), document.body);
};
var OverlayContainer = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 300;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n  overflow: auto;\n  padding: 1rem;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  animation-name: fadeIn;\n  animation-duration: 250ms;\n  animation-timing-function: ease;\n  animation-direction: alternate;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 300;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n  overflow: auto;\n  padding: 1rem;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  animation-name: fadeIn;\n  animation-duration: 250ms;\n  animation-timing-function: ease;\n  animation-direction: alternate;\n"])));
var Dim = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1$E, templateObject_2$t;

var UserProfileModal = function (props) {
  var _a, _b, _c;
  var channel = props.channel,
    userId = props.userId,
    onClose = props.onClose;
  var _d = useContext(ChatRootContext),
    locale = _d.locale,
    caasApiUrl = _d.caasApiUrl,
    caasAuthToken = _d.caasAuthToken,
    myUserId = _d.userId,
    sb = _d.sb;
  var _e = useContext(ChatContext),
    createChannelType = _e.createChannelType,
    setChannelUrl = _e.setChannelUrl;
  var setChannels = useContext(ChannelsDispatchContext).setChannels;
  var refreshChannel = useContext(ChannelContext).refreshChannel;
  var createChannel = useCreateChannel().createChannel;
  var axios = useFetch();
  var t = useTranslation().t;
  var _f = useState(null),
    data = _f[0],
    setData = _f[1];
  var _g = useState(null),
    channelMetaType = _g[0],
    setChannelMetaType = _g[1];
  var fetchMetaData = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var metadata;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.getMetaData(['type'])];
          case 1:
            metadata = _a.sent();
            setChannelMetaType(metadata === null || metadata === void 0 ? void 0 : metadata.type);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchMetaData();
  }, [channel]);
  var isMe = useMemo(function () {
    if (!myUserId) return false;
    if (myUserId !== userId) return false;
    return true;
  }, [userId, myUserId]);
  /**
   * 나와 회사가 똑같은 사용자만 내보내기가 가능하도록 수정
   */
  var canRemove = useMemo(function () {
    // return true;
    // if (channelMetaType !== 'ESTIMATE') return false;
    var _a, _b;
    var myMetadata = (_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.metaData;
    if ((myMetadata === null || myMetadata === void 0 ? void 0 : myMetadata.company_id) !== ((_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.company_id)) {
      return false;
    }
    return true;
  }, [channelMetaType, (_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.metaData, (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.company_id]);
  var fetchData = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, axios.get("".concat(caasApiUrl, "/sendbird/user/").concat(userId), {
              headers: {
                Authorization: "Bearer ".concat(caasAuthToken)
              }
            })];
          case 1:
            data_1 = _a.sent().data;
            setData(data_1);
            return [3 /*break*/, 3];
          case 2:
            error_1 = _a.sent();
            console.error(error_1);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    fetchData();
  }, [userId]);
  var getChatList = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, axios.get("/sendbird/group-channels", {
              params: {
                limit: 100,
                members_include_in: userId,
                metadata_key: 'type',
                metadata_values: 'GENERAL'
              }
            })];
          case 1:
            res = _a.sent();
            return [2 /*return*/, res.data.data.filter(function (el) {
              return el.member_count === 2;
            })];
        }
      });
    });
  };
  var handleCreateChannel = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var res, newChannel, groupChannel_1, messageData, inviteMessage, error_2;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!myUserId || !sb) return [2 /*return*/];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 7,, 8]);
            return [4 /*yield*/, getChatList()];
          case 2:
            res = _b.sent();
            if (!res.length) return [3 /*break*/, 3];
            setChannelUrl(res[0].channel_url);
            onClose();
            return [3 /*break*/, 6];
          case 3:
            return [4 /*yield*/, createChannel({
              channelName: data === null || data === void 0 ? void 0 : data.nickname,
              user_ids: [myUserId, userId],
              type: createChannelType || 'GENERAL'
            })];
          case 4:
            newChannel = _b.sent();
            return [4 /*yield*/, sb.groupChannel.getChannel(newChannel._id)];
          case 5:
            groupChannel_1 = _b.sent();
            messageData = (data === null || data === void 0 ? void 0 : data.nickname) || '';
            inviteMessage = locale.channel_member_invite_message_format.replace('{{inviter}}', ((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || '').replace('{{members}}', messageData);
            groupChannel_1.sendUserMessage({
              customType: 'invite',
              message: inviteMessage,
              data: messageData
            }).onSucceeded(function () {
              // setChannels((prev) => [
              //   serializeGroupChannel(groupChannel),
              //   ...prev,
              // ]);
              setChannelUrl(groupChannel_1.url);
              onClose();
            });
            _b.label = 6;
          case 6:
            return [3 /*break*/, 8];
          case 7:
            error_2 = _b.sent();
            console.error(error_2);
            return [3 /*break*/, 8];
          case 8:
            return [2 /*return*/];
        }
      });
    });
  };

  var removeUser = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var removeMessage, error_3;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!(data === null || data === void 0 ? void 0 : data.user_id) || !channel) return [2 /*return*/];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            removeMessage = locale.channel_member_remove_message_format.replace('{{operator}}', ((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || '').replace('{{name}}', data.nickname);
            channel.sendUserMessage({
              customType: 'member-remove',
              message: removeMessage,
              data: data.nickname
            });
            return [4 /*yield*/, axios.put("/sendbird/".concat(channel === null || channel === void 0 ? void 0 : channel.url, "/leave"), {
              user_ids: [data === null || data === void 0 ? void 0 : data.user_id]
            })];
          case 2:
            _b.sent();
            channel === null || channel === void 0 ? void 0 : channel.removeMember(data === null || data === void 0 ? void 0 : data.user_id);
            refreshChannel();
            return [3 /*break*/, 4];
          case 3:
            error_3 = _b.sent();
            console.error(error_3);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var handleRemoveMember = function () {
    Modal.confirm({
      type: 'warn',
      content: isMe ? '정말로 나가시겠습니까?' : '정말로 내보내시겠습니까?',
      onOk: function () {
        return __awaiter$1(void 0, void 0, void 0, function () {
          var removeMessage;
          var _a;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                if (!channel) return [2 /*return*/];
                if (!isMe) return [3 /*break*/, 2];
                setChannels(function (prev) {
                  return prev.filter(function (e) {
                    return e.channel_url !== (channel === null || channel === void 0 ? void 0 : channel.url);
                  });
                });
                setChannelUrl('');
                removeMessage = locale.channel_member_remove_message_format.replace('{{operator}}', ((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || '').replace('{{name}}', (data === null || data === void 0 ? void 0 : data.nickname) || '');
                channel.sendUserMessage({
                  customType: 'member-remove',
                  message: removeMessage,
                  data: data === null || data === void 0 ? void 0 : data.nickname
                });
                return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.leave()];
              case 1:
                _b.sent();
                onClose();
                return [2 /*return*/];
              case 2:
                return [4 /*yield*/, removeUser()];
              case 3:
                _b.sent();
                onClose();
                return [2 /*return*/];
            }
          });
        });
      }
    });
  };

  return jsx(Overlay, {
    open: true,
    onClose: onClose,
    children: jsx(Dialog$2, {
      children: jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        children: [jsx(Avatar, {
          size: 90,
          src: data === null || data === void 0 ? void 0 : data.profile_url,
          name: data === null || data === void 0 ? void 0 : data.nickname,
          style: {
            marginBottom: '1rem'
          }
        }), jsx(Box, {
          color: "#414C5C",
          fontSize: "0.875rem",
          fontWeight: 400,
          lineHeight: "1.125rem",
          mb: "3px",
          children: (_c = data === null || data === void 0 ? void 0 : data.metadata) === null || _c === void 0 ? void 0 : _c.companyName
        }), jsx(Box, {
          color: "#2C384A",
          fontSize: "1rem",
          fontWeight: 500,
          lineHeight: "1.25rem",
          mb: "1rem",
          children: data === null || data === void 0 ? void 0 : data.nickname
        }), jsx(Box, {
          color: (data === null || data === void 0 ? void 0 : data.is_online) ? 'var(--chat-color-primary)' : ((data === null || data === void 0 ? void 0 : data.last_seen_at) || 0) > 0 ? '#7F8892' : 'var(--chat-color-primary)',
          fontSize: "1rem",
          fontWeight: 500,
          lineHeight: "20px",
          children: (data === null || data === void 0 ? void 0 : data.is_online) ? t(locale.channel_member_online) : ((data === null || data === void 0 ? void 0 : data.last_seen_at) || 0) > 0 ? dayjs_minExports(data === null || data === void 0 ? void 0 : data.last_seen_at).locale(locale.dayjsLocale).fromNow() : ''
        }), !!channel && jsxs(Box, {
          display: "flex",
          mt: "40px",
          style: {
            gap: '40px'
          },
          children: [(isMe || canRemove) && jsx(ActionItem, {
            icon: jsxs("svg", {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [jsxs("g", {
                clipPath: "url(#clip0_89_42403)",
                children: [jsx("path", {
                  d: "M21.8585 12.1242C21.8585 7.36011 17.4443 3.49805 11.9998 3.49805C6.55534 3.49805 2.14111 7.36011 2.14111 12.1242C2.14111 14.2931 3.05674 16.2771 4.56882 17.7929C4.44928 19.0449 4.05493 20.4177 3.61868 21.4479C3.52133 21.6771 3.70988 21.9334 3.95511 21.894C6.73526 21.438 8.38783 20.7381 9.10628 20.3733C10.0501 20.6251 11.023 20.7518 11.9998 20.7504C12.696 20.7504 13.3753 20.6873 14.0307 20.5672",
                  stroke: "#FF6661",
                  strokeWidth: "1.8",
                  strokeLinecap: "round"
                }), jsx("path", {
                  d: "M16.8486 15.3477L22.1519 20.651",
                  stroke: "#FF6661",
                  strokeWidth: "1.6",
                  strokeLinecap: "round"
                }), jsx("path", {
                  d: "M16.8486 20.6523L22.1519 15.349",
                  stroke: "#FF6661",
                  strokeWidth: "1.6",
                  strokeLinecap: "round"
                })]
              }), jsx("defs", {
                children: jsx("clipPath", {
                  id: "clip0_89_42403",
                  children: jsx("rect", {
                    width: "24",
                    height: "24",
                    fill: "white"
                  })
                })
              })]
            }),
            title: isMe ? '나가기' : '내보내기',
            color: "#FF6661",
            onClick: handleRemoveMember
          }), !isMe && jsx(ActionItem, {
            icon: jsxs("svg", {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [jsxs("g", {
                clipPath: "url(#clip0_89_42410)",
                children: [jsx("path", {
                  d: "M21.8585 12.1242C21.8585 7.36011 17.4443 3.49805 11.9998 3.49805C6.55534 3.49805 2.14111 7.36011 2.14111 12.1242C2.14111 14.2931 3.05674 16.2771 4.56882 17.7929C4.44928 19.0449 4.05493 20.4177 3.61868 21.4479C3.52133 21.6771 3.70988 21.9334 3.95511 21.894C6.73526 21.438 8.38783 20.7381 9.10628 20.3733C10.0501 20.6251 11.023 20.7518 11.9998 20.7504C12.696 20.7504 13.3753 20.6873 14.0307 20.5672",
                  stroke: "#1890FF",
                  strokeWidth: "1.8",
                  strokeLinecap: "round"
                }), jsx("path", {
                  d: "M19.5 14.25V21.75",
                  stroke: "#1890FF",
                  strokeWidth: "1.8",
                  strokeLinecap: "round"
                }), jsx("path", {
                  d: "M15.75 18H23.25",
                  stroke: "#1890FF",
                  strokeWidth: "1.8",
                  strokeLinecap: "round"
                })]
              }), jsx("defs", {
                children: jsx("clipPath", {
                  id: "clip0_89_42410",
                  children: jsx("rect", {
                    width: "24",
                    height: "24",
                    fill: "white"
                  })
                })
              })]
            }),
            title: "\uCC44\uD305\uD558\uAE30",
            color: "#1890FF",
            onClick: handleCreateChannel
          })]
        })]
      })
    })
  });
};
var ActionItem = function (props) {
  var color = props.color,
    icon = props.icon,
    title = props.title,
    onClick = props.onClick;
  return jsxs(ActionItemButton, {
    color: color,
    onClick: onClick,
    children: [icon, jsx("span", {
      children: title
    })]
  });
};
var ActionItemButton = styled.button(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0;\n  margin: 0;\n\n  color: ", ";\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n\n  background: none;\n  border: none;\n  outline: none;\n  border-radius: 6px;\n\n  transition:\n    opacity 250ms ease,\n    background-color 250ms ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  &:active {\n    background-color: #f9f9f9;\n  }\n\n  svg {\n    width: 24px;\n    height: 24px;\n    margin-bottom: 6px;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 0;\n  margin: 0;\n\n  color: ", ";\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: center;\n\n  background: none;\n  border: none;\n  outline: none;\n  border-radius: 6px;\n\n  transition:\n    opacity 250ms ease,\n    background-color 250ms ease;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  &:active {\n    background-color: #f9f9f9;\n  }\n\n  svg {\n    width: 24px;\n    height: 24px;\n    margin-bottom: 6px;\n  }\n"])), function (_a) {
  var color = _a.color;
  return color;
});
var Dialog$2 = styled.div(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 450px;\n  background: white;\n  padding: 56px 1rem 40px;\n  border-radius: 8px;\n\n  @keyframes SlideDown {\n    from {\n      transform: translateY(-2rem);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  animation-name: SlideDown;\n  animation-duration: 0.3s;\n  animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);\n  animation-direction: alternate;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 450px;\n  background: white;\n  padding: 56px 1rem 40px;\n  border-radius: 8px;\n\n  @keyframes SlideDown {\n    from {\n      transform: translateY(-2rem);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  animation-name: SlideDown;\n  animation-duration: 0.3s;\n  animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);\n  animation-direction: alternate;\n"])));
var templateObject_1$D, templateObject_2$s;

var FilePreviewModal = function (props) {
  var _a;
  var _b = props.originData,
    originData = _b === void 0 ? '{}' : _b,
    onClose = props.onClose,
    fileType = __rest$2(props, ["originData", "onClose"]);
  var locale = useLocale().locale;
  var renderFilePreview = useContext(ChatContext).renderFilePreview;
  var parsedFile = JSON.parse(originData);
  if (!renderFilePreview) return null;
  var formattedFileData = {
    type: parsedFile.type || '',
    name: parsedFile.name || '',
    url: parsedFile.url || '',
    thumbnailUrl: parsedFile.thumbnailUrl,
    size: parsedFile.size || 0,
    urn: parsedFile.url
  };
  var filePreviewSource = __assign$1(__assign$1({}, fileType), parsedFile);
  return jsx(Overlay, {
    open: true,
    onClose: onClose,
    children: jsxs(Dialog$1, {
      children: [jsxs(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "64px",
        background: "#F5F5F5",
        pl: "24px",
        borderRadius: "6px 6px 0 0",
        children: [jsx(Box, {
          color: "#262626",
          fontSize: "var(--font-size-18, 18px)",
          fontWeight: 400,
          letterSpacing: "-0.01em",
          children: locale.file_preview_title
        }), jsx(CloseButton$1, {
          onClick: onClose,
          children: jsxs("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [jsx("path", {
              d: "M4.80005 6L18 19.2",
              stroke: "#404040",
              strokeWidth: "1.56",
              strokeLinecap: "round"
            }), jsx("path", {
              d: "M18 6L4.8 19.2",
              stroke: "#404040",
              strokeWidth: "1.56",
              strokeLinecap: "round"
            })]
          })
        })]
      }), jsx(Box, {
        children: ((_a = filePreviewSource === null || filePreviewSource === void 0 ? void 0 : filePreviewSource.type) === null || _a === void 0 ? void 0 : _a.includes('video')) ? jsx(Box, {
          position: "relative",
          pb: "56.25%",
          children: jsx("video", {
            controls: true,
            poster: filePreviewSource === null || filePreviewSource === void 0 ? void 0 : filePreviewSource.thumbnailUrl,
            src: (filePreviewSource === null || filePreviewSource === void 0 ? void 0 : filePreviewSource.thumbnailUrl) ? filePreviewSource === null || filePreviewSource === void 0 ? void 0 : filePreviewSource.url : "".concat(filePreviewSource === null || filePreviewSource === void 0 ? void 0 : filePreviewSource.url, "#t=0.1"),
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }
          })
        }) : renderFilePreview(filePreviewSource)
      }), jsx(Box, {
        display: "flex",
        justifyContent: "flex-end",
        p: "12px 16px",
        children: jsx("a", {
          href: formattedFileData.url,
          children: jsx(Button$1, {
            icon: jsxs("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [jsx("path", {
                d: "M10.6 3.4375C10.6 3.10613 10.3314 2.8375 10 2.8375C9.66863 2.8375 9.4 3.10613 9.4 3.4375L10.6 3.4375ZM9.57574 13.2368C9.81005 13.4711 10.1899 13.4711 10.4243 13.2368L14.2426 9.41839C14.477 9.18407 14.477 8.80417 14.2426 8.56986C14.0083 8.33554 13.6284 8.33554 13.3941 8.56986L10 11.964L6.60589 8.56986C6.37157 8.33554 5.99167 8.33554 5.75736 8.56986C5.52304 8.80417 5.52304 9.18407 5.75736 9.41839L9.57574 13.2368ZM9.4 3.4375L9.4 12.8125L10.6 12.8125L10.6 3.4375L9.4 3.4375Z",
                fill: "#404040"
              }), jsx("path", {
                d: "M2.5 11.875V14.6875C2.5 15.723 3.33947 16.5625 4.375 16.5625H15.625C16.6605 16.5625 17.5 15.723 17.5 14.6875V11.875",
                stroke: "#404040",
                strokeWidth: "1.2",
                strokeLinecap: "round"
              })]
            }),
            style: {
              color: '#505050',
              fontWeight: 500,
              borderColor: '#D9D9D9',
              padding: '0 24px',
              height: '40px'
            },
            children: locale.file_preview_download_button
          })
        })
      })]
    })
  });
};
var Dialog$1 = styled.div(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 800px;\n  background: white;\n  padding: 0;\n  border-radius: 6px;\n\n  @keyframes FilePreviewOpenAnimation {\n    from {\n      transform: translateY(-2rem);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  animation-name: FilePreviewOpenAnimation;\n  animation-duration: 0.3s;\n  animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);\n  animation-direction: alternate;\n"], ["\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 800px;\n  background: white;\n  padding: 0;\n  border-radius: 6px;\n\n  @keyframes FilePreviewOpenAnimation {\n    from {\n      transform: translateY(-2rem);\n    }\n\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  animation-name: FilePreviewOpenAnimation;\n  animation-duration: 0.3s;\n  animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);\n  animation-direction: alternate;\n"])));
var CloseButton$1 = styled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 64px;\n  height: 64px;\n\n  background: none;\n  border: none;\n  outline: none;\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 64px;\n  height: 64px;\n\n  background: none;\n  border: none;\n  outline: none;\n"])));
var templateObject_1$C, templateObject_2$r;

var ChannelUserProfile = function (props) {
  var channel = props.channel,
    user = props.user,
    onClose = props.onClose;
  // const metaData = user?.metaData as {
  //   companyName?: string;
  // };
  if (!user) return null;
  return jsx(UserProfileModal, {
    channel: channel,
    userId: user.userId,
    // thumbnailUrl={user.profileUrl || user.plainProfileUrl}
    // name={user.nickname}
    // companyName={metaData.companyName}
    // lastSeenAt={user.lastSeenAt}
    onClose: onClose
  });
};

function useScroll(target, shouldUpdate) {
  if (shouldUpdate === void 0) {
    shouldUpdate = function () {
      return true;
    };
  }
  var _a = __read(useRafState(), 2),
    position = _a[0],
    setPosition = _a[1];
  var shouldUpdateRef = useLatest$1(shouldUpdate);
  useEffectWithTarget$2(function () {
    var el = getTargetElement(target, document);
    if (!el) {
      return;
    }
    var updatePosition = function () {
      var newPosition;
      if (el === document) {
        if (document.scrollingElement) {
          newPosition = {
            left: document.scrollingElement.scrollLeft,
            top: document.scrollingElement.scrollTop
          };
        } else {
          // When in quirks mode, the scrollingElement attribute returns the HTML body element if it exists and is potentially scrollable, otherwise it returns null.
          // https://developer.mozilla.org/zh-CN/docs/Web/API/Document/scrollingElement
          // https://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
          newPosition = {
            left: Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft),
            top: Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
          };
        }
      } else {
        newPosition = {
          left: el.scrollLeft,
          top: el.scrollTop
        };
      }
      if (shouldUpdateRef.current(newPosition)) {
        setPosition(newPosition);
      }
    };
    updatePosition();
    el.addEventListener('scroll', updatePosition);
    return function () {
      el.removeEventListener('scroll', updatePosition);
    };
  }, [], target);
  return position;
}

/**
 * 메시지가 추가되거나 이전 메시지를 불러왔을 때 현재 스크롤 위치를
 * 유지시켜 줍니다.
 *
 * @param ref
 * @param scrollTop
 * @param disabled
 */
var useSaveScrollPosition = function (ref, disabled) {
  var _a, _b;
  var _c = useState(0),
    prevScrollHeight = _c[0],
    setPrevScrollHeight = _c[1];
  var scroll = useScroll(ref);
  var scrollTop = (_a = scroll === null || scroll === void 0 ? void 0 : scroll.top) !== null && _a !== void 0 ? _a : 0;
  useLayoutEffect(function () {
    var _a, _b;
    if (!(ref === null || ref === void 0 ? void 0 : ref.current) || disabled) return;
    /**
     * 이전 스크롤 길이를 기억합니다.
     */
    var scrollHeight = ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
    setPrevScrollHeight(scrollHeight);
    /**
     * 기록된 스크롤 길이가 0이라면 아무것도 하지 않습니다.
     */
    if (!prevScrollHeight) return;
    /**
     * 추가된 스크롤 길이를 찾습니다.
     */
    var scrollHeightDistance = scrollHeight - prevScrollHeight;
    /**
     * 추가된 스크롤 길이 또는 현재 스크롤 길이가 0이라면 아무것도 하지 않습니다.
     */
    if (!scrollHeightDistance || !scrollHeight) return;
    /**
     * 추가된 스크롤 길이가 음수라면 오히려 스크롤 길이가 줄어든 경우입니다.
     * 이런 경우는 메시지가 삭제되는 케이스 밖에 없기 때문에 스크롤 위치를 변경하지 않습니다.
     */
    if (scrollHeightDistance < 0) return;
    /**
     * 현재 스크롤 위치에서 추가된 스크롤 길이만큼 내려가도록 합니다.
     */
    (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
      top: scrollTop + scrollHeightDistance
    });
  }, [(_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.scrollHeight]);
};

var useSendCustomMessage = function () {
  var _a = useContext(ChannelContext),
    channel = _a.channel,
    toScrollBottom = _a.toScrollBottom;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var send = function (customType, message, data) {
    if (!channel) return;
    var params = {
      message: message,
      customType: customType,
      data: typeof data === 'string' ? data : JSON.stringify(data)
    };
    channel.sendUserMessage(params).onSucceeded(function () {
      toScrollBottom();
    }).onFailed(function (error) {});
  };
  return {
    send: send
  };
};

var ChannelInvite = function (props) {
  var channel = props.channel,
    onClose = props.onClose;
  var locale = useLocale().locale;
  var sb = useContext(ChatRootContext).sb;
  var _a = useContext(ChatContext).invitableUsers,
    invitableUsers = _a === void 0 ? [] : _a;
  var send = useSendCustomMessage().send;
  var _b = useState([]),
    checkedIds = _b[0],
    setCheckedIds = _b[1];
  var _c = useState(false),
    isLoading = _c[0],
    setIsLoading = _c[1];
  var computedUsers = useMemo(function () {
    return invitableUsers.filter(function (user) {
      return !channel.members.find(function (e) {
        return e.userId === user._id;
      });
    });
  }, [invitableUsers, channel.members]);
  var handleInvite = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var matchedUsers, data, inviteMessage;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setIsLoading(true);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4 /*yield*/, channel.inviteWithUserIds(checkedIds)];
          case 2:
            _b.sent();
            message.success(locale.channel_member_invite_success_message);
            matchedUsers = checkedIds.map(function (id) {
              var _a;
              return (_a = invitableUsers.find(function (user) {
                return user._id === id;
              })) === null || _a === void 0 ? void 0 : _a.name;
            });
            data = matchedUsers.toString().replaceAll(',', ', ');
            inviteMessage = locale.channel_member_invite_message_format.replace('{{inviter}}', ((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || '').replace('{{members}}', data);
            send('invite', inviteMessage, data);
            return [3 /*break*/, 4];
          case 3:
            _b.sent();
            message.error(locale.channel_member_invite_fail_message);
            return [3 /*break*/, 4];
          case 4:
            setIsLoading(false);
            onClose();
            return [2 /*return*/];
        }
      });
    });
  };

  return jsxs(Fragment, {
    children: [jsxs(Header$5, {
      children: [jsx(Title$2, {
        children: locale.channel_member_invite
      }), jsxs(Box, {
        display: "flex",
        children: [jsx(Button, {
          onClick: onClose,
          children: locale.channel_member_invite_cancel
        }), jsx(Button, {
          onClick: handleInvite,
          children: isLoading ? jsx(Spinner, {}) : locale.channel_member_invite_ok
        })]
      })]
    }), checkedIds.length ? jsx(Fragment, {
      children: jsx(TagsGrid, {
        children: checkedIds.map(function (checkedId) {
          var matchedUser = invitableUsers.find(function (e) {
            return e._id === checkedId;
          });
          if (!matchedUser) return null;
          return jsx(TagItem, __assign$1({}, matchedUser, {
            onRemove: function () {
              return setCheckedIds(function (prev) {
                return prev.filter(function (id) {
                  return id !== checkedId;
                });
              });
            }
          }), checkedId);
        })
      })
    }) : null, jsx(Box, {
      mt: "-14px",
      children: computedUsers.length ? computedUsers.map(function (user) {
        var checked = !!checkedIds.find(function (id) {
          return id === user._id;
        });
        return jsx(ListItem$4, __assign$1({
          checked: checked,
          onChange: function (value) {
            if (!value) {
              setCheckedIds(function (prev) {
                return prev.filter(function (id) {
                  return id !== user._id;
                });
              });
              return;
            }
            setCheckedIds(function (prev) {
              return __spreadArray(__spreadArray([], prev, true), [user._id], false);
            });
          }
        }, user), user._id);
      }) : jsx(Result, {
        withSpace: true,
        size: "small",
        status: "empty",
        title: "\uCD08\uB300\uD560 \uC218 \uC788\uB294 \uC0AC\uC6A9\uC790\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
      })
    })]
  });
};
var TagItem = function (props) {
  var companyName = props.companyName,
    name = props.name,
    onRemove = props.onRemove;
  return jsxs(TagItemWrap, {
    onClick: onRemove,
    children: [jsx("span", {
      children: companyName ? "".concat(companyName, " ").concat(name) : name
    }), jsxs("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("circle", {
        cx: "6",
        cy: "6",
        r: "6",
        fill: "#C8CACC"
      }), jsx("path", {
        d: "M3.66259 8.77882L8.77971 3.6617C8.90137 3.54004 8.90137 3.34278 8.77971 3.22111L8.77942 3.22083C8.65776 3.09916 8.4605 3.09916 8.33883 3.22083L3.22171 8.33795C3.10005 8.45961 3.10005 8.65687 3.22171 8.77854L3.222 8.77882C3.34366 8.90048 3.54092 8.90048 3.66259 8.77882Z",
        fill: "white"
      }), jsx("path", {
        d: "M8.77882 8.33741L3.6617 3.22029C3.54004 3.09863 3.34278 3.09863 3.22111 3.22029L3.22083 3.22058C3.09916 3.34224 3.09916 3.5395 3.22083 3.66117L8.33795 8.77829C8.45961 8.89995 8.65687 8.89995 8.77854 8.77829L8.77882 8.778C8.90048 8.65634 8.90048 8.45908 8.77882 8.33741Z",
        fill: "white"
      })]
    })]
  });
};
var ListItem$4 = function (props) {
  var checked = props.checked,
    name = props.name,
    companyName = props.companyName,
    thumbnailUrl = props.thumbnailUrl,
    onChange = props.onChange;
  var handleClick = function () {
    if (!checked) return onChange(true);
    onChange(false);
  };
  return jsxs(ListItemWrap, {
    onClick: handleClick,
    children: [jsx(UserProfile, {
      thumbnailUrl: thumbnailUrl,
      userName: name,
      companyName: companyName
    }), jsx(Box, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "20px",
      height: "20px",
      borderRadius: "100%",
      border: "1px solid ".concat(checked ? 'var(--chat-color-primary)' : '#D9D9D9'),
      background: checked ? 'var(--chat-color-primary)' : 'white',
      children: jsx("svg", {
        width: "13",
        height: "9",
        viewBox: "0 0 13 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
          d: "M1 3.74286L4.42857 7.17143L11.2 1",
          stroke: "white",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })
    })]
  });
};
var Header$5 = styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 12px 14px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 12px 14px;\n"])));
var Title$2 = styled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n"], ["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n"])));
var Button = styled.a(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 40px;\n  padding: 0 8px;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #7f8892;\n\n  &:hover,\n  &:active {\n    color: var(--chat-color-primary);\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 40px;\n  padding: 0 8px;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #7f8892;\n\n  &:hover,\n  &:active {\n    color: var(--chat-color-primary);\n  }\n"])));
var ListItemWrap = styled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px 10px 12px;\n\n  transition: 250ms ease;\n\n  &:hover {\n    background: #f9f9f9;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px 10px 12px;\n\n  transition: 250ms ease;\n\n  &:hover {\n    background: #f9f9f9;\n  }\n"])));
var TagsGrid = styled.div(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0 19px 18px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0 19px 18px;\n"])));
var TagItemWrap = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 10px;\n  gap: 8px;\n\n  border-radius: 4px;\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  /* identical to box height */\n\n  color: #414c5c;\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 10px;\n  gap: 8px;\n\n  border-radius: 4px;\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 18px;\n  /* identical to box height */\n\n  color: #414c5c;\n"])));
var templateObject_1$B, templateObject_2$q, templateObject_3$m, templateObject_4$f, templateObject_5$b, templateObject_6$9;

var ChannelMembers = function (props) {
  var channel = props.channel;
  var locale = useLocale().locale;
  var invitableUsers = useContext(ChatContext).invitableUsers;
  var _a = useState(false),
    visibleInvite = _a[0],
    setVisibleInvite = _a[1];
  return jsxs(Fragment, {
    children: [channel === null || channel === void 0 ? void 0 : channel.members.map(function (member) {
      return jsx(ChannelMemberItem, {
        channel: channel,
        user: member
      }, member.userId);
    }), !!channel && !!invitableUsers && jsxs(Fragment, {
      children: [jsxs(InviteButton, {
        onClick: function () {
          return setVisibleInvite(true);
        },
        children: [jsx(Box, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "40px",
          height: "40px",
          border: "1px dashed #D9D9D9",
          borderRadius: "100%",
          children: jsx(IconPlus, {
            color: "#1982C4"
          })
        }), jsx("span", {
          children: locale.channel_member_invite
        })]
      }), visibleInvite && jsx(ChannelAside, {
        onClose: function () {
          return setVisibleInvite(false);
        },
        children: jsx(ChannelInvite, {
          channel: channel,
          onClose: function () {
            return setVisibleInvite(false);
          }
        })
      })]
    })]
  });
};
var ChannelMemberItem = function (props) {
  var channel = props.channel,
    user = props.user;
  var locale = useLocale().locale;
  var t = useTranslation().t;
  var _a = useState(false),
    openProfile = _a[0],
    setOpenProfile = _a[1];
  var metaData = user === null || user === void 0 ? void 0 : user.metaData;
  if (!user) return null;
  return jsxs(Fragment, {
    children: [jsxs(ListItem$3, {
      onClick: function () {
        return setOpenProfile(true);
      },
      children: [jsx(UserProfile, {
        thumbnailUrl: user.profileUrl || user.plainProfileUrl,
        userName: user.nickname,
        companyName: metaData.companyName
      }), jsx(Status, {
        isOnline: user.connectionStatus === UserOnlineState.ONLINE,
        children: user.connectionStatus === UserOnlineState.ONLINE ? t(locale.channel_member_online) : (user.lastSeenAt || 0) > 0 ? dayjs_minExports(user.lastSeenAt).locale(locale.dayjsLocale).fromNow() : ''
      })]
    }), openProfile && jsx(ChannelUserProfile, {
      channel: channel,
      user: user,
      onClose: function () {
        return setOpenProfile(false);
      }
    })]
  });
};
var ListItem$3 = styled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0 1rem;\n  margin-bottom: 20px;\n  gap: 8px;\n\n  font-weight: 500;\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  color: #414c5c;\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 0 1rem;\n  margin-bottom: 20px;\n  gap: 8px;\n\n  font-weight: 500;\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  color: #414c5c;\n"])));
var Status = styled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  flex: 0 0 auto;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 18px;\n  color: ", ";\n"], ["\n  flex: 0 0 auto;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 18px;\n  color: ", ";\n"])), function (_a) {
  var isOnline = _a.isOnline;
  return isOnline ? 'var(--chat-color-primary)' : '#7f8892';
});
var InviteButton = styled.a(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 0.5rem;\n  margin-top: -10px;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  margin-bottom: 10px;\n\n  color: #1982c4;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  border-radius: 8px;\n\n  transition: background 250ms ease;\n\n  &:hover {\n    color: #1982c4;\n    background: #fbfbfb;\n  }\n  &:active {\n    color: #1982c4;\n    background: #f9f9f9;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 0.5rem;\n  margin-top: -10px;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  margin-bottom: 10px;\n\n  color: #1982c4;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  border-radius: 8px;\n\n  transition: background 250ms ease;\n\n  &:hover {\n    color: #1982c4;\n    background: #fbfbfb;\n  }\n  &:active {\n    color: #1982c4;\n    background: #f9f9f9;\n  }\n"])));
var templateObject_1$A, templateObject_2$p, templateObject_3$l;

var ChannelInfo = function (props) {
  var channel = props.channel,
    onClose = props.onClose;
  var t = useTranslation('project_chat').t;
  var _a = useContext(ChatRootContext),
    locale = _a.locale,
    sb = _a.sb;
  var setChannelUrl = useContext(ChatContext).setChannelUrl;
  var channels = useContext(ChannelsStateContext).channels;
  var setChannels = useContext(ChannelsDispatchContext).setChannels;
  var onLeaveChannel = useContext(ChannelContext).onLeaveChannel;
  var _b = useState(false),
    editMode = _b[0],
    setEditMode = _b[1];
  var _c = useState(channel === null || channel === void 0 ? void 0 : channel.name),
    inputValue = _c[0],
    setInputValue = _c[1];
  var _d = useState(null),
    metadata = _d[0],
    setMetadata = _d[1];
  var getMetadata = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.getAllMetaData()];
          case 1:
            data = _a.sent();
            setMetadata(data);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    if (!channel) return;
    getMetadata();
  }, [channel]);
  var handleLeave = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var leaveMessage, recentChannel;
      var _a, _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            if (!channel || !sb) return [2 /*return*/];
            leaveMessage = locale.channel_member_leave_message_format.replace('{{name}}', ((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || '');
            channel.sendUserMessage({
              customType: 'leave',
              message: leaveMessage,
              data: (_b = sb.currentUser) === null || _b === void 0 ? void 0 : _b.nickname
            });
            setChannels(function (prev) {
              return prev.filter(function (e) {
                return e.channel_url !== (channel === null || channel === void 0 ? void 0 : channel.url);
              });
            });
            onClose();
            recentChannel = (_c = channels.filter(function (e) {
              return e.channel_url !== channel.url;
            })) === null || _c === void 0 ? void 0 : _c[0];
            if (recentChannel) {
              setChannelUrl(recentChannel.channel_url);
            } else {
              setChannelUrl('');
            }
            onLeaveChannel === null || onLeaveChannel === void 0 ? void 0 : onLeaveChannel();
            return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.leave()];
          case 1:
            _d.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  var handleSubmit = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.updateChannel({
              name: inputValue
            })];
          case 1:
            _a.sent();
            return [3 /*break*/, 3];
          case 2:
            error_1 = _a.sent();
            console.error(error_1);
            return [3 /*break*/, 3];
          case 3:
            setEditMode(false);
            return [2 /*return*/];
        }
      });
    });
  };

  return jsxs(ChannelAside, {
    onClose: onClose,
    children: [jsxs(Header$4, {
      children: [jsxs("div", {
        className: "title-area",
        children: [editMode ? jsxs(ChannelInputWrap, {
          children: [jsx(ChannelInput$1, {
            value: inputValue,
            onChange: function (e) {
              return setInputValue(e.target.value);
            },
            onKeyDown: function (e) {
              if (e.key !== 'Enter') return;
              handleSubmit();
            }
          }), jsx(ChannelInputClearButton, {
            onClick: function () {
              setEditMode(false);
              setInputValue(channel === null || channel === void 0 ? void 0 : channel.name);
            },
            children: jsxs("svg", {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: [jsx("circle", {
                cx: "6",
                cy: "6",
                r: "6",
                fill: "#D9D9D9"
              }), jsx("path", {
                d: "M3.5 3.5L8.50019 8.49982",
                stroke: "white",
                strokeLinecap: "round"
              }), jsx("path", {
                d: "M8.50012 3.49976L3.50012 8.49976",
                stroke: "white",
                strokeLinecap: "round"
              })]
            })
          })]
        }) : jsxs(ChannelName, {
          onClick: function () {
            /**
             * 프로젝트 채팅방은 이름을 수정할 수 없도록 처리
             */
            if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) === 'PROJECT') {
              return;
            }
            setEditMode(true);
          },
          children: [jsx(Box, {
            children: channel === null || channel === void 0 ? void 0 : channel.name
          }), (metadata === null || metadata === void 0 ? void 0 : metadata.type) !== 'PROJECT' && jsx("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: jsx("path", {
              d: "M7.36443 3.46633H4.1338C3.79108 3.46633 3.46239 3.60248 3.22004 3.84482C2.9777 4.08717 2.84155 4.41586 2.84155 4.75858V11.866C2.84155 12.2087 2.9777 12.5374 3.22004 12.7797C3.46239 13.0221 3.79108 13.1582 4.1338 13.1582H11.2412C11.5839 13.1582 11.9126 13.0221 12.1549 12.7797C12.3973 12.5374 12.5334 12.2087 12.5334 11.866V8.63533M11.6198 2.55271C11.739 2.42929 11.8816 2.33084 12.0393 2.26312C12.1969 2.19539 12.3665 2.15974 12.5381 2.15825C12.7097 2.15676 12.8798 2.18946 13.0386 2.25443C13.1974 2.31941 13.3417 2.41536 13.4631 2.53669C13.5844 2.65803 13.6803 2.80231 13.7453 2.96112C13.8103 3.11993 13.843 3.2901 13.8415 3.46168C13.84 3.63327 13.8044 3.80283 13.7366 3.96049C13.6689 4.11815 13.5705 4.26075 13.447 4.37995L7.89942 9.92758H6.07218V8.10034L11.6198 2.55271Z",
              stroke: "#BFBFBF",
              strokeWidth: "1.2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })]
        }), jsx("time", {
          className: "date",
          children: locale.channel_info_craeted_at.replace('{{created_at}}', dayjs_minExports(channel === null || channel === void 0 ? void 0 : channel.createdAt).locale(locale.dayjsLocale).format('ll'))
        })]
      }), jsx(Button$1, {
        variant: "plain",
        icon: jsxs("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M5.11326 15.8079L15.8091 5.11204C16.0636 4.85761 16.0636 4.44513 15.8092 4.19076C15.5549 3.93638 15.1424 3.93642 14.888 4.19085L4.19207 14.8867C3.93764 15.1412 3.9376 15.5536 4.19198 15.808C4.44636 16.0624 4.85883 16.0624 5.11326 15.8079Z",
            fill: "#404040"
          }), jsx("path", {
            d: "M15.8079 14.8868L5.11204 4.19095C4.85761 3.93652 4.44513 3.93647 4.19076 4.19085C3.93638 4.44523 3.93642 4.8577 4.19085 5.11213L14.8867 15.808C15.1412 16.0625 15.5536 16.0625 15.808 15.8081C16.0624 15.5537 16.0624 15.1413 15.8079 14.8868Z",
            fill: "#404040"
          })]
        }),
        onClick: onClose,
        style: {
          marginTop: '-6px',
          marginRight: '-6px'
        }
      })]
    }), jsx(SectionTitle, {
      children: t(locale.channel_members)
    }), jsx(ChannelMembers, {
      channel: channel
    }), jsx(Box, {
      flex: 1
    }), (channel === null || channel === void 0 ? void 0 : channel.customType) !== 'PROJECT' && jsx(Footer, {
      children: jsxs(LeaveButton, {
        onClick: function () {
          Modal.confirm({
            type: 'warn',
            content: locale.channel_info_leave_confirm,
            onOk: handleLeave
          });
        },
        children: [jsxs("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M9 11.35C8.64101 11.35 8.35 11.641 8.35 12C8.35 12.359 8.64101 12.65 9 12.65L9 11.35ZM21.4596 12.4596C21.7135 12.2058 21.7135 11.7942 21.4596 11.5404L17.323 7.40381C17.0692 7.14996 16.6576 7.14996 16.4038 7.40381C16.15 7.65765 16.15 8.0692 16.4038 8.32304L20.0808 12L16.4038 15.677C16.15 15.9308 16.15 16.3424 16.4038 16.5962C16.6576 16.85 17.0692 16.85 17.323 16.5962L21.4596 12.4596ZM9 12.65L21 12.65L21 11.35L9 11.35L9 12.65Z",
            fill: "#404040"
          }), jsx("path", {
            d: "M13 4L5 4C3.89543 4 3 4.89543 3 6L3 18C3 19.1046 3.89543 20 5 20L13 20",
            stroke: "#404040",
            strokeWidth: "1.3",
            strokeLinecap: "round"
          })]
        }), jsx("span", {
          children: locale.channel_info_leave
        })]
      })
    })]
  });
};
var Header$4 = styled.div(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 0.875rem 1rem 1rem;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title-area {\n    flex: 1;\n  }\n\n  .date {\n    display: block;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: #7f8892;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 0.875rem 1rem 1rem;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title-area {\n    flex: 1;\n  }\n\n  .date {\n    display: block;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: #7f8892;\n  }\n"])));
var ChannelName = styled.div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 23px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #404040;\n\n  & > div {\n    display: -webkit-box;\n    word-break: break-all;\n    overflow-wrap: anywhere;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n  }\n\n  svg {\n    flex: 0 0 auto;\n    margin-left: 4px;\n  }\n"], ["\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 23px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #404040;\n\n  & > div {\n    display: -webkit-box;\n    word-break: break-all;\n    overflow-wrap: anywhere;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n  }\n\n  svg {\n    flex: 0 0 auto;\n    margin-left: 4px;\n  }\n"])));
var ChannelInputWrap = styled.div(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  position: relative;\n  /* margin: 0 1rem 42px; */\n"], ["\n  position: relative;\n  /* margin: 0 1rem 42px; */\n"])));
var ChannelInput$1 = styled.input(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  height: 40px;\n  padding: 0 24px 0 8px;\n  margin: 0;\n\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  background: white;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #2c384a;\n  outline: none;\n"], ["\n  display: block;\n  width: 100%;\n  height: 40px;\n  padding: 0 24px 0 8px;\n  margin: 0;\n\n  border-radius: 4px;\n  border: 1px solid #d9d9d9;\n  background: white;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #2c384a;\n  outline: none;\n"])));
var ChannelInputClearButton = styled.button(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  display: flex;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n"], ["\n  display: flex;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n"])));
var SectionTitle = styled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #2c384a;\n  margin: 24px 1rem;\n"], ["\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #2c384a;\n  margin: 24px 1rem;\n"])));
// const Divider = styled.div`
//   margin-bottom: 1rem;
//   border-bottom: 1px solid var(--chat-border-color);
// `;
var Footer = styled.div(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  height: 48px;\n\n  background: white;\n  border-top: 1px solid var(--chat-border-color);\n"], ["\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  height: 48px;\n\n  background: white;\n  border-top: 1px solid var(--chat-border-color);\n"])));
var LeaveButton = styled.button(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 48px;\n  gap: 4px;\n  padding: 0 1rem;\n  background: white;\n  border: none;\n  outline: none;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #262626;\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 48px;\n  gap: 4px;\n  padding: 0 1rem;\n  background: white;\n  border: none;\n  outline: none;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #262626;\n"])));
var templateObject_1$z, templateObject_2$o, templateObject_3$k, templateObject_4$e, templateObject_5$a, templateObject_6$8, templateObject_7$6, templateObject_8$4;

var useInfiniteFetch$1 = function (payload) {
  var queryKey = payload.queryKey,
    queryUrl = payload.queryUrl,
    params = payload.params,
    _a = payload.enabled,
    enabled = _a === void 0 ? true : _a;
  var axios = useFetch();
  var _b = useState([]),
    data = _b[0],
    setData = _b[1];
  var _c = useState(0),
    total = _c[0],
    setTotal = _c[1];
  var _d = useState(false),
    isLoading = _d[0],
    setIsLoading = _d[1];
  var fetchData = function (offset) {
    if (offset === void 0) {
      offset = 0;
    }
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!enabled) {
              setTotal(0);
              setData([]);
              return [2 /*return*/];
            }

            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, axios.get(queryUrl, {
              params: __assign$1({
                offset: offset
              }, params)
            })];
          case 2:
            data_1 = _a.sent().data;
            if (offset > 0) {
              setData(function (prev) {
                return __spreadArray(__spreadArray([], prev, true), data_1.data, true);
              });
            } else {
              setData(data_1 === null || data_1 === void 0 ? void 0 : data_1.data);
            }
            setTotal(data_1 === null || data_1 === void 0 ? void 0 : data_1.total);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            setData([]);
            setTotal(0);
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var hasMore = useMemo(function () {
    return data.length < total;
  }, [total, data.length]);
  var loadMore = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, fetchData(data.length)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    var firstFetch = function () {
      return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setIsLoading(true);
              setData([]);
              setTotal(0);
              return [4 /*yield*/, fetchData()];
            case 1:
              _a.sent();
              setIsLoading(false);
              return [2 /*return*/];
          }
        });
      });
    };

    firstFetch();
  }, queryKey);
  return {
    data: data,
    hasMore: hasMore,
    isLoading: isLoading,
    loadMore: loadMore
  };
};

var ChannelSearchContext = createContext({
  searchValue: '',
  setSearchValue: function () {},
  keyword: '',
  setKeyword: function () {},
  data: [],
  hasMore: false,
  isLoading: false,
  loadMore: function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/];
      });
    });
  },

  reset: function () {}
});
var ChannelSearchProvider = function (props) {
  var channel = props.channel,
    children = props.children;
  var _a = useState(''),
    searchValue = _a[0],
    setSearchValue = _a[1];
  var _b = useState(''),
    keyword = _b[0],
    setKeyword = _b[1];
  var _c = useInfiniteFetch$1({
      queryKey: [keyword, channel === null || channel === void 0 ? void 0 : channel.url],
      queryUrl: "/sendbird/chatroom/".concat(channel === null || channel === void 0 ? void 0 : channel.url, "/search/msg"),
      params: {
        search: keyword,
        limit: 10
      },
      enabled: !!keyword && !!(channel === null || channel === void 0 ? void 0 : channel.url)
    }),
    data = _c.data,
    hasMore = _c.hasMore,
    isLoading = _c.isLoading,
    loadMore = _c.loadMore;
  var reset = function () {
    setSearchValue('');
    setKeyword('');
  };
  return jsx(ChannelSearchContext.Provider, {
    value: {
      searchValue: searchValue,
      setSearchValue: setSearchValue,
      keyword: keyword,
      setKeyword: setKeyword,
      data: data,
      hasMore: hasMore,
      isLoading: isLoading,
      loadMore: loadMore,
      reset: reset
    },
    children: children
  });
};
var useChannelSearchContext = function () {
  return useContext(ChannelSearchContext);
};

var SearchItem = function (props) {
  var query = props.query,
    payload = props.payload,
    sender = props.sender,
    onClickAfter = props.onClickAfter;
  var onSearchPayloadChange = useContext(ChannelContext).onSearchPayloadChange;
  var locale = useLocale().locale;
  var message = (payload === null || payload === void 0 ? void 0 : payload.message) || '';
  /**
   * 검색어와 동일한 문자열을 강조 표시합니다.
   */
  var highlightedText = useMemo(function () {
    if (!query || !message.includes(query)) return message;
    var parts = message.split(new RegExp("(".concat(query, ")"), 'gi'));
    return jsx(Fragment, {
      children: parts.map(function (part, index) {
        if (part.toLowerCase() !== query.toLowerCase()) return part;
        return jsx("mark", {
          children: part
        }, index);
      })
    });
  }, [message, query]);
  if (!message) return null;
  return jsxs(Item, {
    onClick: function () {
      if (!query || !(payload === null || payload === void 0 ? void 0 : payload.created_at)) return;
      onSearchPayloadChange === null || onSearchPayloadChange === void 0 ? void 0 : onSearchPayloadChange(query, payload === null || payload === void 0 ? void 0 : payload.created_at);
      onClickAfter === null || onClickAfter === void 0 ? void 0 : onClickAfter();
    },
    children: [jsxs(Top, {
      children: [jsxs(Profile, {
        children: [jsx(Avatar, {
          name: sender.nickname,
          src: sender.profile_url || undefined
        }), jsx("span", {
          children: sender.nickname
        })]
      }), jsx(DateText, {
        children: dayjs_minExports().diff(payload === null || payload === void 0 ? void 0 : payload.created_at, 'hour') > 24 ? dayjs_minExports(payload === null || payload === void 0 ? void 0 : payload.created_at).locale(locale.dayjsLocale).format('ll') : dayjs_minExports(payload === null || payload === void 0 ? void 0 : payload.created_at).locale(locale.dayjsLocale).format('LT')
      })]
    }), jsx(Message$1, {
      children: highlightedText
    })]
  });
};
var Item = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  cursor: pointer;\n  transition: background 150ms;\n  padding: 1rem;\n  margin: 0 -1rem;\n  &:hover {\n    background: #fafafa;\n  }\n  &:active {\n    background: #f5f5f5;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  cursor: pointer;\n  transition: background 150ms;\n  padding: 1rem;\n  margin: 0 -1rem;\n  &:hover {\n    background: #fafafa;\n  }\n  &:active {\n    background: #f5f5f5;\n  }\n"])));
var Top = styled.div(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"])));
var Profile = styled.div(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  color: #414c5c;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  color: #414c5c;\n"])));
var DateText = styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  color: #1890ff;\n  font-size: 14px;\n  font-weight: 500;\n"], ["\n  color: #1890ff;\n  font-size: 14px;\n  font-weight: 500;\n"])));
var Message$1 = styled.div(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  color: #2c384a;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.32px;\n  display: -webkit-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n\n  mark {\n    padding: 0;\n    color: #1890ff;\n    background: none;\n    font-weight: 400;\n  }\n"], ["\n  color: #2c384a;\n  font-weight: 400;\n  line-height: 150%;\n  letter-spacing: -0.32px;\n  display: -webkit-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n\n  mark {\n    padding: 0;\n    color: #1890ff;\n    background: none;\n    font-weight: 400;\n  }\n"])));
var templateObject_1$y, templateObject_2$n, templateObject_3$j, templateObject_4$d, templateObject_5$9;

var ChannelSearch = function (props) {
  props.channel;
    var onClose = props.onClose;
  var _a = useContext(ChannelContext),
    channelWrapRef = _a.channelWrapRef,
    onCloseSearchMode = _a.onCloseSearchMode;
  var _b = useChannelSearchContext(),
    searchValue = _b.searchValue,
    setSearchValue = _b.setSearchValue,
    keyword = _b.keyword,
    setKeyword = _b.setKeyword,
    data = _b.data,
    hasMore = _b.hasMore,
    isLoading = _b.isLoading,
    loadMore = _b.loadMore,
    reset = _b.reset;
  var size = useSize(channelWrapRef);
  var isMobileSize = useMemo(function () {
    if (((size === null || size === void 0 ? void 0 : size.width) || 0) > breakPoint.medium) return false;
    return true;
  }, [size === null || size === void 0 ? void 0 : size.width]);
  var handleSearch = function () {
    setKeyword(searchValue);
  };
  var renderListItemSkeleton = function () {
    var skeletonTemplate = jsx(List$4.Item, {
      children: jsx(Skeleton, {
        avatar: true,
        title: false,
        loading: true,
        active: true
      })
    });
    return jsxs(Box, {
      p: "1rem",
      children: [skeletonTemplate, skeletonTemplate, skeletonTemplate, skeletonTemplate]
    });
  };
  var renderContent = function () {
    var _a;
    if (!keyword) return jsx(DefaultMessage, {
      children: "\uCC44\uD305 \uAC80\uC0C9\uC744 \uD574\uBCF4\uC138\uC694."
    });
    if (isLoading) {
      return renderListItemSkeleton();
    }
    if (!(data === null || data === void 0 ? void 0 : data.length)) return jsxs(Fragment, {
      children: [jsx(SearchResultCount, {
        children: "\uAC80\uC0C9\uACB0\uACFC (0)"
      }), jsxs(EmptyMessage, {
        children: [jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "50",
          height: "50",
          viewBox: "0 0 50 50",
          fill: "none",
          children: [jsx("path", {
            d: "M34.5227 16.8594C34.6413 16.9768 34.708 17.1367 34.708 17.3036V45.5913C34.708 45.9365 34.4282 46.2163 34.083 46.2163H7.83301C7.48783 46.2163 7.20801 45.9365 7.20801 45.5913V11.8413C7.20801 11.4961 7.48783 11.2163 7.83301 11.2163H28.564C28.7287 11.2163 28.8867 11.2813 29.0037 11.3971L34.5227 16.8594Z",
            stroke: "#BFBFBF",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), jsx("path", {
            d: "M15.3125 36.2505L26.5625 25M26.5625 36.2505L15.3125 25",
            stroke: "#BFBFBF",
            strokeWidth: "2",
            strokeLinecap: "round"
          }), jsx("path", {
            d: "M34.8035 38.2583H42.0415C42.3867 38.2583 42.6665 37.9785 42.6665 37.6333V9.34562C42.6665 9.17874 42.5998 9.01879 42.4812 8.9014L36.9622 3.43908C36.8452 3.32327 36.6872 3.2583 36.5225 3.2583H15.7915C15.4463 3.2583 15.1665 3.53812 15.1665 3.8833V11.0406",
            stroke: "#BFBFBF",
            strokeWidth: "2",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), jsx("path", {
            d: "M27.5 11.875V18.75H35",
            stroke: "#BFBFBF",
            strokeWidth: "2",
            strokeLinejoin: "round"
          })]
        }), jsx("div", {
          children: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
        })]
      })]
    });
    return jsxs(Fragment, {
      children: [jsxs(SearchResultCount, {
        children: ["\uAC80\uC0C9\uACB0\uACFC (", (_a = data.length) !== null && _a !== void 0 ? _a : 0, ")"]
      }), jsx(SearchList, {
        children: data === null || data === void 0 ? void 0 : data.map(function (item, index) {
          return jsx(SearchItem, __assign$1({
            query: keyword
          }, item, {
            onClickAfter: function () {
              if (isMobileSize) {
                onClose();
              }
            }
          }), index);
        })
      })]
    });
  };
  var handleClose = function () {
    onClose();
    onCloseSearchMode === null || onCloseSearchMode === void 0 ? void 0 : onCloseSearchMode();
    reset();
  };
  return jsxs(ChannelAside, {
    onClose: handleClose,
    children: [jsxs(Header$3, {
      children: [jsx("div", {
        className: "title-area",
        children: "\uCC44\uD305 \uAC80\uC0C9"
      }), jsx(Button$1, {
        variant: "plain",
        icon: jsxs("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M5.11326 15.8079L15.8091 5.11204C16.0636 4.85761 16.0636 4.44513 15.8092 4.19076C15.5549 3.93638 15.1424 3.93642 14.888 4.19085L4.19207 14.8867C3.93764 15.1412 3.9376 15.5536 4.19198 15.808C4.44636 16.0624 4.85883 16.0624 5.11326 15.8079Z",
            fill: "#404040"
          }), jsx("path", {
            d: "M15.8079 14.8868L5.11204 4.19095C4.85761 3.93652 4.44513 3.93647 4.19076 4.19085C3.93638 4.44523 3.93642 4.8577 4.19085 5.11213L14.8867 15.808C15.1412 16.0625 15.5536 16.0625 15.808 15.8081C16.0624 15.5537 16.0624 15.1413 15.8079 14.8868Z",
            fill: "#404040"
          })]
        }),
        onClick: handleClose,
        style: {
          marginTop: '-6px',
          marginRight: '-6px'
        }
      })]
    }), jsxs(Body$1, {
      children: [jsxs(SearchWrapper, {
        onSubmit: function (e) {
          e.preventDefault();
          handleSearch();
        },
        children: [jsx(SearchInput$1, {
          value: searchValue,
          placeholder: "\uCC44\uD305 \uB0B4\uC6A9\uC744 \uAC80\uC0C9 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
          onChange: function (e) {
            return setSearchValue(e.target.value);
          }
        }), jsx(SearchButton$1, {
          type: "submit",
          onClick: handleSearch,
          children: jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            children: jsx("path", {
              d: "M17.9459 16.7062L12.1027 10.863C13.0094 9.69071 13.4999 8.25746 13.4999 6.74997C13.4999 4.94548 12.7957 3.25349 11.5222 1.97774C10.2487 0.701997 8.55221 0 6.74997 0C4.94773 0 3.25124 0.704247 1.97774 1.97774C0.701997 3.25124 0 4.94548 0 6.74997C0 8.55221 0.704247 10.2487 1.97774 11.5222C3.25124 12.7979 4.94548 13.4999 6.74997 13.4999C8.25746 13.4999 9.68846 13.0094 10.8607 12.1049L16.7039 17.9459C16.7211 17.9631 16.7414 17.9767 16.7638 17.9859C16.7862 17.9952 16.8102 18 16.8344 18C16.8587 18 16.8827 17.9952 16.9051 17.9859C16.9274 17.9767 16.9478 17.9631 16.9649 17.9459L17.9459 16.9672C17.9631 16.95 17.9767 16.9297 17.9859 16.9073C17.9952 16.8849 18 16.8609 18 16.8367C18 16.8124 17.9952 16.7884 17.9859 16.766C17.9767 16.7437 17.9631 16.7233 17.9459 16.7062ZM10.314 10.314C9.35996 11.2657 8.09546 11.7899 6.74997 11.7899C5.40448 11.7899 4.13998 11.2657 3.18599 10.314C2.23424 9.35996 1.70999 8.09546 1.70999 6.74997C1.70999 5.40448 2.23424 4.13773 3.18599 3.18599C4.13998 2.23424 5.40448 1.70999 6.74997 1.70999C8.09546 1.70999 9.36221 2.23199 10.314 3.18599C11.2657 4.13998 11.7899 5.40448 11.7899 6.74997C11.7899 8.09546 11.2657 9.36221 10.314 10.314Z",
              fill: "#1890FF"
            })
          })
        })]
      }), renderContent(), jsx(InfiniteScroll, {
        disableInitFetch: true,
        loadMore: loadMore,
        hasMore: hasMore
      })]
    })]
  });
};
var Header$3 = styled.div(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: white;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 0.875rem 1rem 1rem;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title-area {\n    flex: 1;\n  }\n\n  .date {\n    display: block;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: #7f8892;\n  }\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: white;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem 0.875rem 1rem 1rem;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title-area {\n    flex: 1;\n  }\n\n  .date {\n    display: block;\n    margin-top: 8px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: #7f8892;\n  }\n"])));
var Body$1 = styled.div(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  padding: 8px 16px 16px;\n"], ["\n  padding: 8px 16px 16px;\n"])));
var SearchWrapper = styled.form(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  position: relative;\n  padding: 0;\n  margin: 0 0 8px 0;\n"], ["\n  position: relative;\n  padding: 0;\n  margin: 0 0 8px 0;\n"])));
var SearchInput$1 = styled.input(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 0 30px 0 12px;\n  margin: 0;\n\n  outline: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: white;\n\n  color: #2c384a;\n  font-weight: 400;\n  letter-spacing: -0.32px;\n\n  &::placeholder {\n    color: #bfbfbf;\n    font-weight: 400;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 0 30px 0 12px;\n  margin: 0;\n\n  outline: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: white;\n\n  color: #2c384a;\n  font-weight: 400;\n  letter-spacing: -0.32px;\n\n  &::placeholder {\n    color: #bfbfbf;\n    font-weight: 400;\n  }\n"])));
var SearchButton$1 = styled.button(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  display: flex;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  margin: 0;\n\n  border: none;\n  outline: none;\n  background: none;\n  border-radius: 0;\n\n  cursor: pointer;\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  display: flex;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  margin: 0;\n\n  border: none;\n  outline: none;\n  background: none;\n  border-radius: 0;\n\n  cursor: pointer;\n"])));
var SearchResultCount = styled.div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  color: #7f8892;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 8px;\n"], ["\n  color: #7f8892;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 8px;\n"])));
var SearchList = styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var DefaultMessage = styled.div(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  color: #9e9e9e;\n  text-align: center;\n  margin-top: 56px;\n"], ["\n  color: #9e9e9e;\n  text-align: center;\n  margin-top: 56px;\n"])));
var EmptyMessage = styled.div(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 12px;\n\n  color: #9e9e9e;\n  line-height: 150%;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 16px;\n  gap: 12px;\n\n  color: #9e9e9e;\n  line-height: 150%;\n  text-align: center;\n"])));
var templateObject_1$x, templateObject_2$m, templateObject_3$i, templateObject_4$c, templateObject_5$8, templateObject_6$7, templateObject_7$5, templateObject_8$3, templateObject_9$3;

var ChannelFooterSearchCancel = function () {
  var onCloseSearchMode = useChannelContext().onCloseSearchMode;
  var reset = useChannelSearchContext().reset;
  return jsxs(FooterSearchMode, {
    onClick: function () {
      onCloseSearchMode === null || onCloseSearchMode === void 0 ? void 0 : onCloseSearchMode();
      reset();
    },
    children: [jsx("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: jsxs("g", {
        children: [jsx("path", {
          d: "M18.3332 1.66602L9.1665 10.8327",
          stroke: "#1890FF",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M18.3332 1.66602L12.4998 18.3327L9.1665 10.8327L1.6665 7.49935L18.3332 1.66602Z",
          stroke: "#1890FF",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      })
    }), "\uBA54\uC2DC\uC9C0 \uC785\uB825\uD558\uAE30"]
  });
};

var ChannelHeader = function (props) {
  var loading = props.loading,
    name = props.name,
    members = props.members,
    memberCount = props.memberCount,
    onClose = props.onClose,
    onChangeAside = props.onChangeAside;
  var locale = useContext(ChatRootContext).locale;
  var t = useTranslation().t;
  return jsx(HeaderWrap, {
    children: loading ? jsxs(Fragment, {
      children: [jsx(Spinner, {
        style: {
          marginRight: '1rem'
        }
      }), jsx("span", {
        children: t(locale.channel_loading)
      })]
    }) : jsxs(Fragment, {
      children: [onClose && jsx("button", {
        className: "channel-close",
        onClick: onClose,
        children: jsx("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.56501 7.92411L11.886 1.60217C11.9566 1.53332 12.0127 1.45108 12.0513 1.36031C12.09 1.26954 12.1103 1.17217 12.1109 1.07353C12.1115 0.974877 12.0924 0.877022 12.0549 0.785765C12.0174 0.694508 11.9623 0.61137 11.8925 0.541624C11.8227 0.471879 11.7399 0.416956 11.6487 0.379515C11.5574 0.342074 11.4596 0.322868 11.3609 0.323526C11.2623 0.324183 11.1646 0.344443 11.0738 0.383096C10.983 0.421749 10.9011 0.478118 10.8323 0.548786L3.9654 7.42053C3.8836 7.50281 3.82206 7.60299 3.78571 7.71317C3.74936 7.82336 3.7393 7.9405 3.75609 8.0553C3.77288 8.1701 3.81602 8.27947 3.88239 8.37463C3.94877 8.46979 4.03664 8.54807 4.13858 8.60347L10.9833 15.4482C11.0525 15.5173 11.1345 15.5722 11.2248 15.6097C11.3152 15.6471 11.4119 15.6663 11.5097 15.6663C11.6075 15.6663 11.7045 15.6468 11.7948 15.6093C11.8852 15.5719 11.9672 15.517 12.0364 15.4479C12.1055 15.3787 12.1604 15.2967 12.1978 15.2063C12.2352 15.116 12.2545 15.0193 12.2545 14.9215C12.2544 14.8237 12.2349 14.7267 12.1975 14.6364C12.1601 14.546 12.1052 14.464 12.036 14.3948L5.56501 7.92411Z",
            fill: "#404040"
          })
        })
      }), jsxs(Title$1, {
        children: [jsx(Box, {
          as: "span",
          mr: "0.5rem",
          children: name
        }), jsx(Popover, {
          overlayInnerStyle: {
            maxWidth: 264
          },
          content: jsx(Box, {
            display: "flex",
            flexWrap: "wrap",
            style: {
              gap: '0.5rem'
            },
            children: members === null || members === void 0 ? void 0 : members.map(function (member) {
              return jsx(Avatar, {
                src: member.profileUrl || undefined,
                name: member.nickname
              }, member.userId);
            })
          }),
          children: jsx(Box, {
            as: "span",
            color: "#909090",
            fontSize: "0.875rem",
            fontWeight: 500,
            children: memberCount
          })
        })]
      }), jsxs(Box, {
        display: "flex",
        alignItems: "center",
        children: [jsx(Button$1, {
          variant: "plain",
          icon: jsxs("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [jsx("path", {
              d: "M10.6499 17.3999C14.3778 17.3999 17.3999 14.3778 17.3999 10.6499C17.3999 6.92197 14.3778 3.8999 10.6499 3.8999C6.92198 3.8999 3.8999 6.92197 3.8999 10.6499C3.8999 14.3778 6.92198 17.3999 10.6499 17.3999Z",
              stroke: "#404040",
              strokeWidth: "1.62",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), jsx("path", {
              d: "M20.0999 20.1001L15.5999 15.6001",
              stroke: "#404040",
              strokeWidth: "1.62",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })]
          }),
          onClick: function () {
            return onChangeAside && onChangeAside('search');
          }
        }), jsx(Button$1, {
          variant: "plain",
          icon: jsxs("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [jsx("path", {
              d: "M3.30005 6.5H20.0999",
              stroke: "#404040",
              strokeWidth: "1.79999",
              strokeLinecap: "round"
            }), jsx("path", {
              d: "M3.30005 12.5H20.0999",
              stroke: "#404040",
              strokeWidth: "1.79999",
              strokeLinecap: "round"
            }), jsx("path", {
              d: "M3.30005 18.5H20.0999",
              stroke: "#404040",
              strokeWidth: "1.79999",
              strokeLinecap: "round"
            })]
          }),
          onClick: function () {
            return onChangeAside && onChangeAside('info');
          }
        })]
      })]
    })
  });
};
var HeaderWrap = styled.div(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: var(--chat-header-height);\n  padding: 0 0.5rem 0 0.25rem;\n  font-size: 1.125rem;\n  font-weight: 500;\n  background: var(--chat-channel-background);\n\n  .channel-close {\n    flex: 0 0 auto;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 3rem;\n    height: 3rem;\n    padding: 0;\n    margin: 0;\n\n    background-color: transparent;\n    border: none;\n    outline: none;\n\n    font-size: 1.5rem;\n  }\n\n  ", "\n"], ["\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: var(--chat-header-height);\n  padding: 0 0.5rem 0 0.25rem;\n  font-size: 1.125rem;\n  font-weight: 500;\n  background: var(--chat-channel-background);\n\n  .channel-close {\n    flex: 0 0 auto;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 3rem;\n    height: 3rem;\n    padding: 0;\n    margin: 0;\n\n    background-color: transparent;\n    border: none;\n    outline: none;\n\n    font-size: 1.5rem;\n  }\n\n  ", "\n"])), mobileStyle(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n    font-size: 1rem;\n\n    .channel-header-thumbnail {\n      width: 2rem;\n      height: 2rem;\n      font-size: 1.25rem;\n    }\n  "], ["\n    font-size: 1rem;\n\n    .channel-header-thumbnail {\n      width: 2rem;\n      height: 2rem;\n      font-size: 1.25rem;\n    }\n  "]))));
var Title$1 = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  flex: 1;\n  display: -webkit-box;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n"], ["\n  flex: 1;\n  display: -webkit-box;\n  word-break: break-all;\n  overflow-wrap: anywhere;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n"])));
var templateObject_1$w, templateObject_2$l, templateObject_3$h;

// THIS FILE IS AUTO GENERATED
var GenIcon$4 = require$$0.GenIcon;
var RiErrorWarningLine_1 = function RiErrorWarningLine(props) {
  return GenIcon$4({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "g",
      "attr": {},
      "child": [{
        "tag": "path",
        "attr": {
          "fill": "none",
          "d": "M0 0h24v24H0z"
        }
      }, {
        "tag": "path",
        "attr": {
          "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z"
        }
      }]
    }]
  })(props);
};

/**
 * 로딩 상태 또는 에러 등에 대해 표시합니다.
 */
var ChannelPlaceholder = function (props) {
  var type = props.type,
    children = props.children;
  var locale = useLocale().locale;
  var t = useTranslation().t;
  var renderIcon = function () {
    switch (type) {
      case 'loading':
        return jsx(Spinner, {
          style: {
            color: 'var(--color-primary)',
            fontSize: 32
          }
        });
      case 'no-channel':
      case 'error':
        return jsx(RiErrorWarningLine_1, {
          color: "#949494",
          size: 32
        });
    }
  };
  return jsxs(FallbackBox, {
    children: [renderIcon(), jsx(Box, {
      mt: "0.5rem",
      color: "gray",
      fontWeight: "400",
      children: children !== null && children !== void 0 ? children : t(locale.channel_connection_failed)
    })]
  });
};
var FallbackBox = styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  position: relative;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  position: relative;\n"])));
var templateObject_1$v;

var ExtentionButton = function (props) {
  var children = props.children,
    icon = props.icon,
    loading = props.loading,
    args = __rest$2(props, ["children", "icon", "loading"]);
  return jsxs(ButtonWrap, __assign$1({}, args, {
    children: [loading ? jsx(Spinner, {
      style: {
        fontSize: '20px',
        width: '20px',
        height: '20px',
        marginRight: '4px'
      }
    }) : icon, jsx("span", {
      className: "chat-extention-text",
      children: children
    })]
  }));
};
var ButtonWrap = styled.button(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 28px;\n  padding: 0 0.25rem;\n  /* gap: 4px; */\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 144%;\n  letter-spacing: -0.02em;\n  color: #505050;\n\n  background-color: transparent;\n  border: none;\n  outline: none;\n  border-radius: 4px;\n\n  transition: 250ms ease;\n\n  &:first-of-type {\n    margin-left: -0.25rem;\n  }\n\n  & > svg {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  .chat-extention-text {\n  }\n\n  &:hover {\n    color: var(--chat-color-primary);\n    /* background-color: #f9f9f9; */\n  }\n\n  &:disabled {\n    color: gray;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 28px;\n  padding: 0 0.25rem;\n  /* gap: 4px; */\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 144%;\n  letter-spacing: -0.02em;\n  color: #505050;\n\n  background-color: transparent;\n  border: none;\n  outline: none;\n  border-radius: 4px;\n\n  transition: 250ms ease;\n\n  &:first-of-type {\n    margin-left: -0.25rem;\n  }\n\n  & > svg {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n\n  .chat-extention-text {\n  }\n\n  &:hover {\n    color: var(--chat-color-primary);\n    /* background-color: #f9f9f9; */\n  }\n\n  &:disabled {\n    color: gray;\n  }\n"])));
var templateObject_1$u;

var ContentContext = createContext({
  onShare: null,
  setOnShare: function () {}
});
var ContentContainer = function (props) {
  var children = props.children,
    onClose = props.onClose;
  var locale = useLocale().locale;
  var _a = useState(null),
    onShare = _a[0],
    setOnShare = _a[1];
  return jsx(ContentContext.Provider, {
    value: {
      onShare: onShare,
      setOnShare: setOnShare
    },
    children: jsxs(Box, {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      children: [jsx(Box, {
        flex: 1,
        position: "relative",
        children: jsx(ScrollArea$1, {
          children: children
        })
      }), jsxs(Box, {
        display: "flex",
        children: [jsx(ShareButton, {
          disabled: !onShare,
          onClick: function () {
            if (!onShare) return;
            onShare();
            onClose();
          },
          children: locale.extention_share_document_send_message
        }), jsx(CloseButton, {
          onClick: onClose,
          children: locale.extention_share_document_cancel
        })]
      })]
    })
  });
};
var ScrollArea$1 = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 0.75rem;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 0.75rem;\n  overflow-x: hidden;\n  overflow-y: overlay;\n  ", "\n"])), chatCustomScrollBar);
var ShareButton = styled.button(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: white;\n  background-color: var(--chat-color-primary);\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    background-color: #aeb2b5;\n  }\n"], ["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: white;\n  background-color: var(--chat-color-primary);\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: ", ";\n  }\n  &:active:not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    background-color: #aeb2b5;\n  }\n"])), mix$1(0.1, 'white', '#1890ff'), mix$1(0.1, 'black', '#1890ff'));
var CloseButton = styled.button(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: #262626;\n  background-color: #f5f5f5;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: color-mix(in srgb, black 10%, #f5f5f5);\n  }\n  &:active:not(:disabled) {\n    background-color: color-mix(in srgb, black 20%, #f5f5f5);\n  }\n"], ["\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n\n  color: #262626;\n  background-color: #f5f5f5;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  border: none;\n  outline: none;\n\n  transition: background-color 250ms ease;\n\n  &:hover:not(:disabled) {\n    background-color: color-mix(in srgb, black 10%, #f5f5f5);\n  }\n  &:active:not(:disabled) {\n    background-color: color-mix(in srgb, black 20%, #f5f5f5);\n  }\n"])));
var templateObject_1$t, templateObject_2$k, templateObject_3$g;

var SearchInput = function (props) {
  var value = props.value,
    wrapperStyle = props.wrapperStyle,
    onSearch = props.onSearch,
    args = __rest$2(props, ["value", "wrapperStyle", "onSearch"]);
  var _a = useState(value || ''),
    __value = _a[0],
    __setValue = _a[1];
  useEffect(function () {
    __setValue(value || '');
  }, [value]);
  var handleSubmit = function (e) {
    e.preventDefault();
    onSearch(__value);
  };
  return jsx(StickyBox, {
    children: jsxs(InputWrap, {
      style: wrapperStyle,
      onSubmit: handleSubmit,
      children: [jsx(Input, __assign$1({
        value: __value
      }, args, {
        onChange: function (e) {
          return __setValue(e.target.value);
        }
      })), jsx(SearchButton, {
        type: "submit",
        children: jsx("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 18 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            d: "M17.9459 16.7062L12.1027 10.863C13.0094 9.69071 13.4999 8.25746 13.4999 6.74997C13.4999 4.94548 12.7957 3.25349 11.5222 1.97774C10.2487 0.701997 8.55221 0 6.74997 0C4.94773 0 3.25124 0.704247 1.97774 1.97774C0.701997 3.25124 0 4.94548 0 6.74997C0 8.55221 0.704247 10.2487 1.97774 11.5222C3.25124 12.7979 4.94548 13.4999 6.74997 13.4999C8.25746 13.4999 9.68846 13.0094 10.8607 12.1049L16.7039 17.9459C16.7211 17.9631 16.7414 17.9767 16.7638 17.9859C16.7862 17.9952 16.8102 18 16.8344 18C16.8587 18 16.8827 17.9952 16.9051 17.9859C16.9274 17.9767 16.9478 17.9631 16.9649 17.9459L17.9459 16.9672C17.9631 16.95 17.9767 16.9297 17.9859 16.9073C17.9952 16.8849 18 16.8609 18 16.8367C18 16.8124 17.9952 16.7884 17.9859 16.766C17.9767 16.7437 17.9631 16.7233 17.9459 16.7062ZM10.314 10.314C9.35996 11.2657 8.09546 11.7899 6.74997 11.7899C5.40448 11.7899 4.13998 11.2657 3.18599 10.314C2.23424 9.35996 1.70999 8.09546 1.70999 6.74997C1.70999 5.40448 2.23424 4.13773 3.18599 3.18599C4.13998 2.23424 5.40448 1.70999 6.74997 1.70999C8.09546 1.70999 9.36221 2.23199 10.314 3.18599C11.2657 4.13998 11.7899 5.40448 11.7899 6.74997C11.7899 8.09546 11.2657 9.36221 10.314 10.314Z",
            fill: "#1890FF"
          })
        })
      })]
    })
  });
};
var StickyBox = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  position: sticky;\n  top: 42px;\n  z-index: 10;\n  padding: 1rem;\n  background-color: white;\n"], ["\n  position: sticky;\n  top: 42px;\n  z-index: 10;\n  padding: 1rem;\n  background-color: white;\n"])));
var InputWrap = styled.form(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n"])));
var Input = styled.input(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  padding: 0 12px;\n  width: 100%;\n  height: 36px;\n  flex: 1;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #2c384a;\n\n  background: none;\n  border: none;\n  outline: none;\n\n  &::placeholder {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    /* identical to box height */\n\n    letter-spacing: -0.02em;\n\n    color: #bfbfbf;\n  }\n"], ["\n  padding: 0 12px;\n  width: 100%;\n  height: 36px;\n  flex: 1;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #2c384a;\n\n  background: none;\n  border: none;\n  outline: none;\n\n  &::placeholder {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    /* identical to box height */\n\n    letter-spacing: -0.02em;\n\n    color: #bfbfbf;\n  }\n"])));
var SearchButton = styled.button(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  margin-right: 2px;\n\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  cursor: pointer;\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  margin-right: 2px;\n\n  border: none;\n  outline: none;\n  background: none;\n"])));
var templateObject_1$s, templateObject_2$j, templateObject_3$f, templateObject_4$b;

var ShareDocumentEmpty = function () {
  var locale = useLocale().locale;
  return jsx(Empty, {
    style: {
      color: '#BFBFBF',
      fontSize: '1rem',
      fontWeight: 400,
      marginTop: '2rem'
    },
    imageStyle: {
      height: '40px'
    },
    image: jsxs("svg", {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        height: '40px'
      },
      children: [jsx("path", {
        d: "M30 6.25H10C7.96875 6.25 6.64062 7.34375 6.25 9.375L3.75 21.25V30C3.75289 30.9937 4.1489 31.9458 4.85154 32.6485C5.55417 33.3511 6.50633 33.7471 7.5 33.75H32.5C33.4937 33.7471 34.4458 33.3511 35.1485 32.6485C35.8511 31.9458 36.2471 30.9937 36.25 30V21.25L33.75 9.375C33.3594 7.26562 31.9531 6.25 30 6.25Z",
        stroke: "#DADADA",
        strokeWidth: "1.5",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M3.75 21.25H15C15 22.5761 15.5268 23.8479 16.4645 24.7855C17.4021 25.7232 18.6739 26.25 20 26.25C21.3261 26.25 22.5979 25.7232 23.5355 24.7855C24.4732 23.8479 25 22.5761 25 21.25H36.25",
        stroke: "#DADADA",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }),
    description: locale.extention_share_document_empty
  });
};

var genThumbnails = function (files, content) {
  if (!(files === null || files === void 0 ? void 0 : files.length) && !content) return [];
  var getImageFiles = function () {
    return (files === null || files === void 0 ? void 0 : files.filter(function (e) {
      return e.type.includes('image');
    }).map(function (e) {
      return e.thumbnailUrl || e.url;
    })) || [];
  };
  var getInlineImages = function () {
    var _a;
    if (!content) return [];
    var testingBed = document.createElement('div');
    testingBed.innerHTML = content;
    var images = testingBed.getElementsByTagName('img');
    var imageUrls = [];
    for (var i = 0; i < images.length; i++) {
      var src = (_a = images === null || images === void 0 ? void 0 : images[i]) === null || _a === void 0 ? void 0 : _a.src;
      if (src) {
        imageUrls.push(src);
      }
    }
    return imageUrls;
  };
  return __spreadArray(__spreadArray([], getImageFiles(), true), getInlineImages(), true);
};

var ShareDocumentItem = function (props) {
  var selectedId = props.selectedId,
    id = props.id,
    title = props.title,
    children = props.children,
    meta = props.meta,
    photos = props.photos,
    footer = props.footer,
    onChange = props.onChange;
  var locale = useLocale().locale;
  var checked = useMemo(function () {
    return id === selectedId;
  }, [id, selectedId]);
  var slicedPhotos = useMemo(function () {
    if (!(photos === null || photos === void 0 ? void 0 : photos.length)) return [];
    return __spreadArray([], photos, true).slice(0, 4);
  }, [photos]);
  return jsxs(ItemBox, {
    children: [jsxs(TitleWithCheckbox, {
      children: [jsx("input", {
        type: "checkbox",
        checked: checked,
        onChange: function (e) {
          /**
           * 현재 아이템을 선택
           */
          if (e.target.checked) {
            onChange(id);
            return;
          }
          /**
           * 현재 아이템이 이미 선택된 경우 선택을 해제
           */
          if (checked) {
            onChange('');
          }
        },
        hidden: true
      }), jsx(Box, {
        className: classNames('chat-checkbox', {
          checked: checked
        })
      }), jsx(Box, {
        flex: 1,
        children: title
      })]
    }), jsx(Content, {
      children: children
    }), !!meta && jsx(Meta, {
      children: meta
    }), !!(photos === null || photos === void 0 ? void 0 : photos.length) && jsx(Photos, {
      children: slicedPhotos.map(function (url, index) {
        return jsxs(PhotoWrap, {
          children: [jsx("img", {
            src: url,
            alt: url
          }), photos.length > 4 && index === 3 && jsxs(PhotoCover, {
            children: ["+", locale.extention_share_document_photo_extra.replace('{{count}}', (photos.length - 4).toString())]
          })]
        }, index);
      })
    }), !!footer && jsx(Meta, {
      children: footer
    })]
  });
};
var ItemBox = styled.label(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  cursor: pointer;\n  display: block;\n  padding: 0.5rem 1rem;\n\n  transition: background 250ms ease;\n\n  &:active {\n    background-color: #f9f9f9;\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: 1.5rem;\n  }\n  & > *:not(:last-of-type) {\n    margin-bottom: 8px;\n  }\n"], ["\n  cursor: pointer;\n  display: block;\n  padding: 0.5rem 1rem;\n\n  transition: background 250ms ease;\n\n  &:active {\n    background-color: #f9f9f9;\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: 1.5rem;\n  }\n  & > *:not(:last-of-type) {\n    margin-bottom: 8px;\n  }\n"])));
var TitleWithCheckbox = styled.div(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 23px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #2c384a;\n\n  .chat-checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.5rem;\n    border: 1px solid #d9d9d9;\n    border-radius: 100%;\n\n    &.checked {\n      border-color: var(--chat-color-primary);\n      background: var(--chat-color-primary);\n\n      &::after {\n        content: '';\n        display: block;\n        width: 0.5rem;\n        height: 0.5rem;\n        background: white;\n        border-radius: 100%;\n      }\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 23px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #2c384a;\n\n  .chat-checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.5rem;\n    border: 1px solid #d9d9d9;\n    border-radius: 100%;\n\n    &.checked {\n      border-color: var(--chat-color-primary);\n      background: var(--chat-color-primary);\n\n      &::after {\n        content: '';\n        display: block;\n        width: 0.5rem;\n        height: 0.5rem;\n        background: white;\n        border-radius: 100%;\n      }\n    }\n  }\n"])));
var Content = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  margin-bottom: 8px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  margin-bottom: 8px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Meta = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #7f8892;\n\n  & > p {\n    margin: 0 0 8px 0;\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: #7f8892;\n\n  & > p {\n    margin: 0 0 8px 0;\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n"])));
var Photos = styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2px;\n"])));
var PhotoWrap = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: 100%;\n  overflow: hidden;\n\n  & > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"], ["\n  position: relative;\n  padding-bottom: 100%;\n  overflow: hidden;\n\n  & > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"])));
var PhotoCover = styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.3);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  letter-spacing: -0.02em;\n\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.3);\n"])));
var templateObject_1$r, templateObject_2$i, templateObject_3$e, templateObject_4$a, templateObject_5$7, templateObject_6$6, templateObject_7$4;

var SHARE_DOCUMENT_LIMIT = 10;

var useInfiniteFetch = function (queryUrl, params) {
  var axios = useFetch();
  var _a = useState([]),
    data = _a[0],
    setData = _a[1];
  var _b = useState(0),
    total = _b[0],
    setTotal = _b[1];
  var _c = useState(false),
    isLoading = _c[0],
    setIsLoading = _c[1];
  var fetchData = function (offset) {
    if (offset === void 0) {
      offset = 0;
    }
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!params.project_id) {
              setTotal(0);
              setData([]);
              return [2 /*return*/];
            }

            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, axios.get(queryUrl, {
              params: __assign$1({
                limit: SHARE_DOCUMENT_LIMIT,
                offset: offset
              }, params)
            })];
          case 2:
            data_1 = _a.sent().data;
            if (offset > 0) {
              setData(function (prev) {
                return __spreadArray(__spreadArray([], prev, true), data_1.data, true);
              });
            } else {
              setData(data_1 === null || data_1 === void 0 ? void 0 : data_1.data);
            }
            setTotal(data_1 === null || data_1 === void 0 ? void 0 : data_1.total);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            setData([]);
            setTotal(0);
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var hasMore = useMemo(function () {
    return data.length < total;
  }, [total, data.length]);
  var loadMore = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, fetchData(data.length)];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    var firstFetch = function () {
      return __awaiter$1(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setIsLoading(true);
              setData([]);
              setTotal(0);
              return [4 /*yield*/, fetchData()];
            case 1:
              _a.sent();
              setIsLoading(false);
              return [2 /*return*/];
          }
        });
      });
    };

    firstFetch();
  }, [params.search, params.project_id]);
  return {
    data: data,
    hasMore: hasMore,
    isLoading: isLoading,
    loadMore: loadMore
  };
};

var ShareDocumentMinutes = function (props) {
  var projectId = props.projectId;
  var locale = useLocale().locale;
  var setOnShare = useContext(ContentContext).setOnShare;
  var send = useSendCustomMessage().send;
  var _a = useState(''),
    search = _a[0],
    setSearch = _a[1];
  var _b = useState(''),
    selectedId = _b[0],
    setSelectedId = _b[1];
  var _c = useInfiniteFetch('/postings', {
      project_id: projectId,
      search: search,
      type: 'MEETING',
      accessLevel: 'PROJECT'
    }),
    data = _c.data,
    hasMore = _c.hasMore,
    isLoading = _c.isLoading,
    loadMore = _c.loadMore;
  var selectedItem = useMemo(function () {
    return data.find(function (e) {
      return e._id === selectedId;
    });
  }, [data, selectedId]);
  var handleShare = function () {
    var _a;
    if (!selectedItem) return;
    send('share-minutes', "[".concat(locale.extention_share_document_tab_minutes, "] ").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title), __assign$1(__assign$1({}, selectedItem), {
      thumbnailUrl: ((_a = genThumbnails([], selectedItem.content)) === null || _a === void 0 ? void 0 : _a[0]) || ''
    }));
  };
  useEffect(function () {
    if (!selectedItem) {
      setOnShare(null);
      return;
    }
    setOnShare(function () {
      return handleShare;
    });
    return function () {
      setOnShare(null);
    };
  }, [selectedItem, locale.dayjsLocale]);
  var renderListItemSkeleton = function () {
    var skeletonTemplate = jsx(List$4.Item, {
      children: jsx(Skeleton, {
        avatar: true,
        title: false,
        loading: true,
        active: true
      })
    });
    return jsxs(Box, {
      p: "1rem",
      children: [skeletonTemplate, skeletonTemplate, skeletonTemplate, skeletonTemplate]
    });
  };
  return jsxs(Fragment, {
    children: [jsx(SearchInput, {
      value: search,
      placeholder: locale.extention_share_document_search_placeholder,
      onSearch: setSearch
    }), isLoading ? renderListItemSkeleton() : data.length ? data.map(function (item) {
      var photos = genThumbnails([], item.content);
      return jsx(ShareDocumentItem, {
        selectedId: selectedId,
        id: item._id,
        title: item.title,
        meta: jsxs(Fragment, {
          children: [jsxs("p", {
            children: [locale.extention_share_document_minutes_writer, ":", ' ', item.writer.company.name ? "".concat(item.writer.company.name, " ").concat(item.writer.name) : item.writer.name]
          }), jsxs("p", {
            children: [locale.extention_share_document_minutes_created_at, ":", ' ', dayjs_minExports(item.createdAt).locale(locale.dayjsLocale).format('ll')]
          })]
        }),
        photos: photos,
        onChange: setSelectedId,
        children: sanitizeHtml((item === null || item === void 0 ? void 0 : item.content) || '')
      }, item._id);
    }) : jsx(ShareDocumentEmpty, {}), jsx(InfiniteScroll, {
      disableInitFetch: true,
      loadMore: loadMore,
      hasMore: hasMore
    })]
  });
};

var ShareDocumentReport = function (props) {
  var projectId = props.projectId;
  var locale = useLocale().locale;
  var setOnShare = useContext(ContentContext).setOnShare;
  var send = useSendCustomMessage().send;
  var _a = useState(''),
    search = _a[0],
    setSearch = _a[1];
  var _b = useState(''),
    selectedId = _b[0],
    setSelectedId = _b[1];
  var _c = useInfiniteFetch('/reports', {
      project_id: projectId,
      search: search,
      accessLevel: 'PROJECT'
    }),
    data = _c.data,
    hasMore = _c.hasMore,
    isLoading = _c.isLoading,
    loadMore = _c.loadMore;
  var selectedItem = useMemo(function () {
    return data.find(function (e) {
      return e._id === selectedId;
    });
  }, [data, selectedId]);
  var handleShare = function () {
    if (!selectedItem) return;
    send('share-report', "[".concat(locale.extention_share_document_tab_report, "] ").concat(dayjs_minExports(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.workDate).locale(locale.dayjsLocale).format('ll')), selectedItem);
  };
  useEffect(function () {
    if (!selectedItem) {
      setOnShare(null);
      return;
    }
    setOnShare(function () {
      return handleShare;
    });
    return function () {
      setOnShare(null);
    };
  }, [selectedItem, locale.dayjsLocale]);
  var renderListItemSkeleton = function () {
    var skeletonTemplate = jsx(List$4.Item, {
      children: jsx(Skeleton, {
        avatar: true,
        title: false,
        loading: true,
        active: true
      })
    });
    return jsxs(Box, {
      p: "1rem",
      children: [skeletonTemplate, skeletonTemplate, skeletonTemplate, skeletonTemplate]
    });
  };
  return jsxs(Fragment, {
    children: [jsx(SearchInput, {
      value: search,
      placeholder: locale.extention_share_document_search_placeholder,
      onSearch: setSearch
    }), isLoading ? renderListItemSkeleton() : data.length ? data.map(function (item) {
      var _a, _b, _c, _d, _e, _f;
      var photos = item.works.filter(function (e) {
        var _a;
        return (_a = e.photos) === null || _a === void 0 ? void 0 : _a.length;
      }).flatMap(function (e) {
        return e.photos;
      }).map(function (e) {
        return e.thumbnailUrl || e.url;
      });
      return jsx(ShareDocumentItem, {
        selectedId: selectedId,
        id: item._id,
        title: dayjs_minExports(item.workDate).locale(locale.dayjsLocale).format('ll'),
        meta: jsxs(Fragment, {
          children: [locale.extention_share_document_report_writer, ":", ' ', ((_b = (_a = item === null || item === void 0 ? void 0 : item.writer) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.name) ? "".concat((_d = (_c = item === null || item === void 0 ? void 0 : item.writer) === null || _c === void 0 ? void 0 : _c.company) === null || _d === void 0 ? void 0 : _d.name, " ").concat((_e = item === null || item === void 0 ? void 0 : item.writer) === null || _e === void 0 ? void 0 : _e.name) : (_f = item === null || item === void 0 ? void 0 : item.writer) === null || _f === void 0 ? void 0 : _f.name]
        }),
        photos: photos,
        onChange: setSelectedId,
        children: item === null || item === void 0 ? void 0 : item.content
      }, item._id);
    }) : jsx(ShareDocumentEmpty, {}), jsx(InfiniteScroll, {
      disableInitFetch: true,
      loadMore: loadMore,
      hasMore: hasMore
    })]
  });
};

var ShareDocumentRfi = function (props) {
  var projectId = props.projectId;
  var locale = useLocale().locale;
  var setOnShare = useContext(ContentContext).setOnShare;
  var send = useSendCustomMessage().send;
  var _a = useState(''),
    search = _a[0],
    setSearch = _a[1];
  var _b = useState(''),
    selectedId = _b[0],
    setSelectedId = _b[1];
  var _c = useInfiniteFetch('/rfis', {
      project_id: projectId,
      search: search
    }),
    data = _c.data,
    hasMore = _c.hasMore,
    isLoading = _c.isLoading,
    loadMore = _c.loadMore;
  var selectedItem = useMemo(function () {
    return data.find(function (e) {
      return e._id === selectedId;
    });
  }, [data, selectedId]);
  var handleShare = function () {
    var _a;
    if (!selectedItem) return;
    send('share-rfi', "[".concat(locale.extention_share_document_tab_rfi, "] ").concat(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title), __assign$1(__assign$1({}, selectedItem), {
      thumbnailUrl: ((_a = genThumbnails(selectedItem.files, selectedItem.content)) === null || _a === void 0 ? void 0 : _a[0]) || ''
    }));
  };
  useEffect(function () {
    if (!selectedItem) {
      setOnShare(null);
      return;
    }
    setOnShare(function () {
      return handleShare;
    });
    return function () {
      setOnShare(null);
    };
  }, [selectedItem, locale.dayjsLocale]);
  var renderListItemSkeleton = function () {
    var skeletonTemplate = jsx(List$4.Item, {
      children: jsx(Skeleton, {
        avatar: true,
        title: false,
        loading: true,
        active: true
      })
    });
    return jsxs(Box, {
      p: "1rem",
      children: [skeletonTemplate, skeletonTemplate, skeletonTemplate, skeletonTemplate]
    });
  };
  return jsxs(Fragment, {
    children: [jsx(SearchInput, {
      value: search,
      placeholder: locale.extention_share_document_search_placeholder,
      onSearch: setSearch
    }), isLoading ? renderListItemSkeleton() : data.length ? data.map(function (item) {
      var photos = genThumbnails(item.files, item.content);
      return jsx(ShareDocumentItem, {
        selectedId: selectedId,
        id: item._id,
        title: item.title,
        meta: jsxs(Fragment, {
          children: [!!item.assignee && jsxs("p", {
            children: [locale.extention_share_document_rfi_assignee, ":", ' ', item.assignee.company.name ? "".concat(item.assignee.company.name, " ").concat(item.assignee.name) : item.assignee.name]
          }), !!item.dueDate && jsxs("p", {
            children: [locale.extention_share_document_rfi_due_date, ":", ' ', dayjs_minExports(item.dueDate).locale(locale.dayjsLocale).format('ll')]
          }), jsxs("p", {
            children: [locale.extention_share_document_rfi_writer, ":", ' ', item.writer.company.name ? "".concat(item.writer.company.name, " ").concat(item.writer.name) : item.writer.name]
          }), jsxs("p", {
            children: [locale.extention_share_document_rfi_created_at, ":", ' ', dayjs_minExports(item.createdAt).locale(locale.dayjsLocale).format('ll')]
          })]
        }),
        photos: photos,
        onChange: setSelectedId,
        children: sanitizeHtml((item === null || item === void 0 ? void 0 : item.content) || '')
      }, item._id);
    }) : jsx(ShareDocumentEmpty, {}), jsx(InfiniteScroll, {
      disableInitFetch: true,
      loadMore: loadMore,
      hasMore: hasMore
    })]
  });
};

var ShareDocument = function (props) {
  var channel = props.channel;
  var locale = useLocale().locale;
  var _a = useContext(ChannelContext),
    asideKey = _a.asideKey,
    setAsideKey = _a.setAsideKey;
  var projectId = useMatchProjectId(channel.url).projectId;
  var handleClose = function () {
    return setAsideKey(null);
  };
  if (!projectId) return null;
  return jsxs(Fragment, {
    children: [jsx(ExtentionButton, {
      onClick: function () {
        return setAsideKey('share-document');
      },
      icon: jsxs("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [jsx("path", {
          d: "M16 4.24854C15.5858 4.24854 15.25 4.58432 15.25 4.99854C15.25 5.41275 15.5858 5.74854 16 5.74854H19.1893L10.969 13.9689L10.4697 14.4682C10.1768 14.7611 10.1768 15.2359 10.4697 15.5288C10.7626 15.8217 11.2374 15.8217 11.5303 15.5288L12.0296 15.0295L20.25 6.80919V9.99854C20.25 10.4127 20.5858 10.7485 21 10.7485C21.4142 10.7485 21.75 10.4127 21.75 9.99854V4.99854C21.75 4.58432 21.4142 4.24854 21 4.24854H16Z",
          fill: "currentColor"
        }), jsx("path", {
          d: "M6.65385 6.75C5.88371 6.75 5.1451 7.05592 4.60053 7.60051C4.05594 8.14508 3.75 8.8837 3.75 9.65384V19.3462C3.75 20.1163 4.05602 20.8549 4.60053 21.3995C5.14512 21.9441 5.88372 22.25 6.65385 22.25H16.3462C17.1163 22.25 17.855 21.9439 18.3996 21.3995C18.9441 20.8548 19.25 20.1163 19.25 19.3462V13.9615C19.25 13.5473 18.9142 13.2115 18.5 13.2115C18.0858 13.2115 17.75 13.5473 17.75 13.9615V19.3462C17.75 19.7184 17.6022 20.0754 17.3389 20.3388C17.0756 20.602 16.7184 20.75 16.3462 20.75H6.65385C6.28153 20.75 5.92442 20.6021 5.66117 20.3389C5.39786 20.0755 5.25 19.7184 5.25 19.3462V15.4007V9.65384C5.25 9.28151 5.39792 8.92443 5.66119 8.66117C5.92445 8.3979 6.28152 8.25 6.65385 8.25H12.0385C12.4527 8.25 12.7885 7.91421 12.7885 7.5C12.7885 7.08578 12.4527 6.75 12.0385 6.75H6.65385Z",
          fill: "currentColor"
        })]
      }),
      children: locale.extension_share_document
    }), asideKey === 'share-document' && jsx(ChannelAside, {
      nonScroll: true,
      onClose: handleClose,
      children: jsxs(ContentContainer, {
        onClose: handleClose,
        children: [jsx(AsideHeader, {
          onClose: handleClose,
          style: {
            borderBottom: '1px solid #EEEEEE',
            marginBottom: '8px'
          },
          children: locale.extension_share_document
        }), !!projectId && jsx(Tabs, {
          defaultActiveKey: "report",
          items: [{
            key: 'report',
            label: locale.extention_share_document_tab_report,
            children: jsx(ShareDocumentReport, {
              projectId: projectId
            })
          }, {
            key: 'rfi',
            label: locale.extention_share_document_tab_rfi,
            children: jsx(ShareDocumentRfi, {
              projectId: projectId
            })
          }, {
            key: 'minutes',
            label: locale.extention_share_document_tab_minutes,
            children: jsx(ShareDocumentMinutes, {
              projectId: projectId
            })
          }],
          style: {
            position: 'sticky',
            top: 0,
            margin: '0 1rem',
            background: 'white',
            zIndex: 10
          }
        })]
      })
    })]
  });
};

// THIS FILE IS AUTO GENERATED
var GenIcon$3 = require$$0.GenIcon;
var AiOutlinePaperClip_1 = function AiOutlinePaperClip(props) {
  return GenIcon$3({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
      }
    }]
  })(props);
};

/**
 * 채널 파일 업로드
 */
var Attachment = function (props) {
  var channel = props.channel;
  var addMessage = useContext(ChannelContext).addMessage;
  var send = useSendCustomMessage().send;
  /**
   * 단일 파일 메시지를 보냅니다.
   *
   * @param file
   * @returns
   */
  var sendSingleFileMessage = function (file) {
    if (!channel) return;
    var params = {
      data: JSON.stringify(file),
      fileUrl: file.url,
      fileName: file.name || file.filename || 'unkown file',
      fileSize: file.size,
      mimeType: file.type
    };
    channel.sendFileMessage(params).onSucceeded(function (message) {
      addMessage(message, message.channelUrl);
    }).onFailed(function (error) {
      console.error('파일 메시지 전송 실패:', error);
    });
  };
  /**
   * 파일 이미지 파일 메시지를 보냅니다.
   * 이때 `FileMessage` 형식이 아닌
   * 커스텀 메시지를 생성합니다.
   *
   * @param files
   */
  var sendMultipleImageMessages = function (files) {
    send('multiple-image', '사진 메시지입니다.', files);
  };
  /**
   * 다중 파일 메시지를 보냅니다.
   *
   * @param files
   */
  var sendMultipleFileMessages = function (files) {
    files.forEach(function (file) {
      sendSingleFileMessage(file);
    });
  };
  /**
   * 파일이 업로드되면 메시지 전송을 처리합니다.
   *
   * @param files
   * @returns
   */
  var handleFileUpload = function (files) {
    /**
     * 파일이 하나라면 단일 파일 업로드를 실행합니다.
     */
    if (files.length === 1) {
      sendSingleFileMessage(files === null || files === void 0 ? void 0 : files[0]);
      return;
    }
    /**
     * 모든 파일이 이미지라면 멀티 이미지 업로드를 실행합니다.
     *
     * ### 모든 파일이 이미지인지 검증하는 방식
     * 1. type에 `'image'`가 포함되지 않은 파일을 찾는다.
     * 2. 결과물이 없다면 모든 파일은 이미지이다.
     */
    var isAllImages = !files.find(function (e) {
      return !e.type.includes('image');
    });
    if (isAllImages) {
      sendMultipleImageMessages(files);
      return;
    }
    /**
     * 파일이 여러개이고 이미지 외 파일이 섞여있다면
     * 다중 파일 업로드를 실행합니다.
     */
    sendMultipleFileMessages(files);
  };
  return jsx(Fragment, {
    children: jsx(FileUpload, {
      projectId: (channel === null || channel === void 0 ? void 0 : channel.url) || '',
      onUploaded: handleFileUpload
    })
  });
};
/**
 * 파일 업로드 컴포넌트
 */
var FileUpload = function (props) {
  var projectId = props.projectId,
    onUploaded = props.onUploaded;
  var locale = useLocale().locale;
  var axios = useFetch();
  var _a = useState(false),
    isLoading = _a[0],
    setIsLoading = _a[1];
  var inputFileRef = useRef(null);
  var handleClickButton = function () {
    var _a;
    return (_a = inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click();
  };
  var handleChange = function (e) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var files, filesLength, fileUploadAction, fileUploadPromises, i, responses, filteredResponses;
      var _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length)) return [2 /*return*/];
            if (((_b = e.target.files) === null || _b === void 0 ? void 0 : _b.length) === 0) return [2 /*return*/];
            setIsLoading(true);
            files = e.target.files;
            filesLength = files === null || files === void 0 ? void 0 : files.length;
            fileUploadAction = function (file) {
              return __awaiter$1(void 0, void 0, void 0, function () {
                var formData, data, err_1;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      _a.trys.push([0, 2,, 3]);
                      formData = new FormData();
                      formData.append('files', file);
                      formData.append('isEnabled', 'false');
                      formData.append('project_id', projectId);
                      return [4 /*yield*/, axios.post('/upload/files', formData, {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                      })];
                    case 1:
                      data = _a.sent().data;
                      return [2 /*return*/, data === null || data === void 0 ? void 0 : data[0]];
                    case 2:
                      err_1 = _a.sent();
                      console.error(err_1.response);
                      return [3 /*break*/, 3];
                    case 3:
                      return [2 /*return*/];
                  }
                });
              });
            };

            fileUploadPromises = [];
            for (i = 0; i < filesLength; i++) {
              fileUploadPromises.push(fileUploadAction(files[i]));
            }
            return [4 /*yield*/, Promise.all(fileUploadPromises)];
          case 1:
            responses = _c.sent();
            filteredResponses = responses.filter(function (e) {
              return e;
            });
            setIsLoading(false);
            onUploaded(filteredResponses);
            return [2 /*return*/];
        }
      });
    });
  };

  return jsxs("label", {
    children: [jsx("input", {
      ref: inputFileRef,
      type: "file",
      value: "",
      onChange: function (e) {
        return handleChange(e);
      },
      multiple: true,
      hidden: true
    }), jsx(ExtentionButton, {
      icon: jsx(AiOutlinePaperClip_1, {}),
      loading: isLoading,
      onClick: handleClickButton,
      children: locale.extension_attachment
    })]
  });
};

var EstimateOrder = function () {
  var onClickEstimateOrder = useContext(ChatContext).onClickEstimateOrder;
  if (!onClickEstimateOrder) return null;
  return jsx(ExtentionButton, {
    icon: jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      style: {
        width: 20,
        height: 20,
        marginRight: '0.25rem'
      },
      children: [jsx("path", {
        d: "M6.88913 2.74023H4.81517C4.26512 2.74023 3.7376 2.95874 3.34866 3.34768C2.95972 3.73662 2.74121 4.26414 2.74121 4.81418V17.2579C2.74121 17.8079 2.95972 18.3354 3.34866 18.7244C3.7376 19.1133 4.26512 19.3318 4.81517 19.3318H15.185C15.735 19.3318 16.2625 19.1133 16.6515 18.7244C17.0404 18.3354 17.2589 17.8079 17.2589 17.2579V4.81418C17.2589 4.26414 17.0404 3.73662 16.6515 3.34768C16.2625 2.95874 15.735 2.74023 15.185 2.74023H13.111",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M6.89124 2.38077C6.89124 1.92573 7.10974 1.48933 7.49868 1.16757C7.88763 0.845803 8.41515 0.665039 8.9652 0.665039H11.0392C11.5892 0.665039 12.1167 0.845803 12.5057 1.16757C12.8946 1.48933 13.1131 1.92573 13.1131 2.38077C13.1131 2.83581 12.8946 3.27222 12.5057 3.59398C12.1167 3.91574 11.5892 4.0965 11.0392 4.0965H8.9652C8.41515 4.0965 7.88763 3.91574 7.49868 3.59398C7.10974 3.27222 6.89124 2.83581 6.89124 2.38077Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M12.0742 8.39722H9.48171C9.06917 8.39722 8.67353 8.56109 8.38183 8.8528C8.09012 9.14451 7.92624 9.54014 7.92624 9.95268C7.92624 10.3652 8.09012 10.7608 8.38183 11.0526C8.67353 11.3443 9.06917 11.5081 9.48171 11.5081H10.5187C10.9312 11.5081 11.3269 11.672 11.6186 11.9637C11.9103 12.2554 12.0742 12.6511 12.0742 13.0636C12.0742 13.4761 11.9103 13.8718 11.6186 14.1635C11.3269 14.4552 10.9312 14.6191 10.5187 14.6191H9.22246H7.92624",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M10.0006 14.6182V15.6552M10.0006 7.35938V8.39635",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }),
    onClick: onClickEstimateOrder,
    children: "\uACAC\uC801 \uC8FC\uBB38\uC11C \uBCF4\uAE30"
  });
};

var GPTDocForm = function (props) {
  var loading = props.loading,
    loadingText = props.loadingText,
    initialData = props.initialData,
    onSubmit = props.onSubmit,
    onCancel = props.onCancel;
  var locale = useLocale().locale;
  var froalaEditorKey = useContext(ChatRootContext).froalaEditorKey;
  var _a = useState({
      title: '',
      body: ''
    }),
    formData = _a[0],
    setFormData = _a[1];
  var _b = useState(false),
    isSubmitting = _b[0],
    setIsSubmitting = _b[1];
  useEffect(function () {
    return function () {
      onCancel();
    };
  }, []);
  useEffect(function () {
    var parsedBody = ((initialData === null || initialData === void 0 ? void 0 : initialData.body) || '').replaceAll('\n', '<br/>');
    // parsedBody += `<br/><br/><br/>${aiWrittedText}`;
    setFormData({
      title: (initialData === null || initialData === void 0 ? void 0 : initialData.title) || '',
      body: parsedBody
    });
  }, [initialData === null || initialData === void 0 ? void 0 : initialData.title, initialData === null || initialData === void 0 ? void 0 : initialData.body]);
  var handleSubmit = function (e) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.preventDefault();
            setIsSubmitting(true);
            return [4 /*yield*/, onSubmit(formData)];
          case 1:
            _a.sent();
            setIsSubmitting(false);
            return [2 /*return*/];
        }
      });
    });
  };

  return jsxs(Form, {
    onSubmit: handleSubmit,
    children: [jsxs(ContentZone, {
      children: [jsxs(ScrollArea, {
        children: [jsxs(FormItem, {
          children: [jsx("label", {
            children: locale.extention_gpt_post_doc_title
          }), loading ? jsx(InputSkeleton, {
            children: jsx(SkeletonBar, {
              style: {
                width: 210,
                height: 23,
                margin: 0
              }
            })
          }) : jsx("input", {
            value: formData.title,
            onChange: function (e) {
              setFormData(function (prev) {
                return __assign$1(__assign$1({}, prev), {
                  title: e.target.value
                });
              });
            }
          })]
        }), jsxs(FormItem, {
          style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1
          },
          children: [jsx("label", {
            children: locale.extention_gpt_post_doc_content
          }), loading ? jsxs(EditorSkeleton, {
            children: [jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {
              style: {
                marginBottom: '2rem'
              }
            }), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {
              style: {
                width: 116,
                marginBottom: '2rem'
              }
            }), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {}), jsx(SkeletonBar, {
              style: {
                width: 194
              }
            })]
          }) : jsx(FroalaEditor, {
            config: {
              key: froalaEditorKey || undefined,
              charCounterCount: false,
              events: {
                initialized: function () {
                  // this is the editor instance.
                  this.toolbar.hide();
                }
              }
            },
            model: formData.body,
            onModelChange: function (value) {
              setFormData(function (prev) {
                return __assign$1(__assign$1({}, prev), {
                  body: value
                });
              });
            }
          })]
        })]
      }), loading && jsxs(LoadingCover, {
        children: [jsx(Spinner, {
          style: {
            fontSize: 40,
            marginBottom: 24
          }
        }), loadingText]
      })]
    }), jsx(FabWrap, {
      children: jsx(Fab, {
        disabled: loading,
        okText: isSubmitting ? jsx(Spinner, {}) : locale.extention_gpt_post_doc_submit,
        cancelText: locale.extention_gpt_cancel,
        onCancel: onCancel
      })
    })]
  });
};
var LoadingCover = styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #414c5c;\n\n  background-color: rgba(255 255 255 / 30%);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  letter-spacing: -0.02em;\n  color: #414c5c;\n\n  background-color: rgba(255 255 255 / 30%);\n"])));
var Form = styled.form(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  border: none;\n  outline: none;\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  border: none;\n  outline: none;\n"])));
var ContentZone = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n"], ["\n  position: relative;\n  flex: 1;\n"])));
var ScrollArea = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: overlay;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: overlay;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  ", "\n"])), chatCustomScrollBar);
var FormItem = styled.section(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n\n  label {\n    display: block;\n    width: 100%;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    /* identical to box height, or 150% */\n\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n    margin-bottom: 8px;\n  }\n\n  input,\n  .fr-box {\n    background: #ffffff;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #414c5c;\n\n    outline: none;\n\n    transition:\n      border-color 250ms ease,\n      box-shadow 250ms ease;\n\n    &:focus,\n    &:focus-within {\n      border-color: var(--chat-color-primary);\n      box-shadow: #1890ff3d 0 0 0 3px;\n    }\n  }\n\n  input {\n    display: block;\n    width: 100%;\n    height: 42px;\n    padding: 11px 12px;\n  }\n\n  .fr-box {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    &.fr-basic {\n      .fr-wrapper {\n        flex: 1;\n        border: none;\n        display: flex;\n        flex-direction: column;\n      }\n      .fr-element {\n        flex: 1;\n        padding: 1rem;\n\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 150%;\n        letter-spacing: -0.02em;\n        color: #414c5c;\n\n        p {\n          margin: 0;\n        }\n      }\n      .fr-second-toolbar {\n        display: none;\n      }\n    }\n  }\n"], ["\n  margin-bottom: 1rem;\n\n  label {\n    display: block;\n    width: 100%;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    /* identical to box height, or 150% */\n\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n    margin-bottom: 8px;\n  }\n\n  input,\n  .fr-box {\n    background: #ffffff;\n    border: 1px solid #d9d9d9;\n    border-radius: 4px;\n\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    color: #414c5c;\n\n    outline: none;\n\n    transition:\n      border-color 250ms ease,\n      box-shadow 250ms ease;\n\n    &:focus,\n    &:focus-within {\n      border-color: var(--chat-color-primary);\n      box-shadow: #1890ff3d 0 0 0 3px;\n    }\n  }\n\n  input {\n    display: block;\n    width: 100%;\n    height: 42px;\n    padding: 11px 12px;\n  }\n\n  .fr-box {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    &.fr-basic {\n      .fr-wrapper {\n        flex: 1;\n        border: none;\n        display: flex;\n        flex-direction: column;\n      }\n      .fr-element {\n        flex: 1;\n        padding: 1rem;\n\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 150%;\n        letter-spacing: -0.02em;\n        color: #414c5c;\n\n        p {\n          margin: 0;\n        }\n      }\n      .fr-second-toolbar {\n        display: none;\n      }\n    }\n  }\n"])));
var FabWrap = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  flex: 0 0 auto;\n"], ["\n  flex: 0 0 auto;\n"])));
var InputSkeleton = styled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n\n  /* &::after {\n    content: '';\n    display: block;\n    width: 210px;\n    height: 23px;\n\n    background: #f5f5f5;\n    border-radius: 3px;\n  } */\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 42px;\n  padding: 0 12px;\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n\n  /* &::after {\n    content: '';\n    display: block;\n    width: 210px;\n    height: 23px;\n\n    background: #f5f5f5;\n    border-radius: 3px;\n  } */\n"])));
var EditorSkeleton = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n"], ["\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n"])));
var SkeletonBar = styled.div(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 15px;\n  margin-bottom: 9px;\n  background: #f5f5f5;\n  border-radius: 3px;\n\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.06) 25%,\n    rgba(0, 0, 0, 0.15) 37%,\n    rgba(0, 0, 0, 0.06) 63%\n  );\n  background-size: 400% 100%;\n\n  @keyframes skeletonAnimation {\n    from {\n      background-position: 100% 50%;\n    }\n    to {\n      background-position: 0 50%;\n    }\n  }\n\n  animation-name: skeletonAnimation;\n  animation-duration: 1.4s;\n  animation-timing-function: ease;\n  animation-iteration-count: infinite;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 15px;\n  margin-bottom: 9px;\n  background: #f5f5f5;\n  border-radius: 3px;\n\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.06) 25%,\n    rgba(0, 0, 0, 0.15) 37%,\n    rgba(0, 0, 0, 0.06) 63%\n  );\n  background-size: 400% 100%;\n\n  @keyframes skeletonAnimation {\n    from {\n      background-position: 100% 50%;\n    }\n    to {\n      background-position: 0 50%;\n    }\n  }\n\n  animation-name: skeletonAnimation;\n  animation-duration: 1.4s;\n  animation-timing-function: ease;\n  animation-iteration-count: infinite;\n"])));
var templateObject_1$q, templateObject_2$h, templateObject_3$d, templateObject_4$9, templateObject_5$6, templateObject_6$5, templateObject_7$3, templateObject_8$2, templateObject_9$2;

var GPTDocGenerator = function (props) {
  var currentMode = props.mode,
    buttonText = props.buttonText,
    title = props.title,
    icon = props.icon,
    steps = props.steps,
    loading = props.loading,
    onSubmit = props.onSubmit;
  var _a = useContext(ChannelContext),
    headerRef = _a.headerRef,
    footerRef = _a.footerRef,
    setAsideKey = _a.setAsideKey;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var _b = useContext(MessageSelectContext),
    mode = _b.mode,
    selectedMessageIds = _b.selectedMessageIds,
    startAt = _b.startAt,
    endAt = _b.endAt,
    setMode = _b.setMode,
    setStartAt = _b.setStartAt,
    setEndAt = _b.setEndAt;
  var locale = useLocale().locale;
  /**
   * 현재 모드가 활성화되어 있는지 여부
   */
  var enabled = useMemo(function () {
    if (!mode) return false;
    if (mode !== currentMode) return false;
    return true;
  }, [mode, currentMode]);
  /**
   * 현재 선택된 메시지 중
   * 텍스트 메시지만
   */
  var selectedMessages = messageDataSource.messages.filter(function (m) {
    if (!selectedMessageIds.find(function (id) {
      return id === m.messageId;
    })) return false;
    if (!m.isUserMessage() || m.customType) return false;
    return true;
  }).map(function (m) {
    return m;
  });
  /**
   * 선택된 메시지가 있는지
   */
  var hasSelectedMessage = useMemo(function () {
    return !!selectedMessageIds.length;
  }, [selectedMessageIds.length]);
  /**
   * 생성 가능한 상태
   */
  var canSubmit = useMemo(function () {
    return !!selectedMessages.length;
  }, [selectedMessages.length]);
  /**
   * sender를 텍스트로 변환
   *
   * @param sender
   */
  var generateSenderText = function (sender) {
    var metadata = sender.metaData;
    if (!(metadata === null || metadata === void 0 ? void 0 : metadata.companyName)) return sender.nickname;
    return "".concat(metadata.companyName, " ").concat(sender.nickname);
  };
  /**
   * 선택한 대화 내용을 GPT 대화 양식으로 변환
   */
  var generateText = function () {
    var members = uniqBy_1(selectedMessages.map(function (m) {
      return m.sender;
    }), 'userId').map(function (user) {
      return generateSenderText(user);
    });
    var stringifiedMessages = selectedMessages.map(function (m) {
      return "".concat(m.sender.nickname, " : ").concat(m.message);
    });
    var content = '';
    content += "\uCC38\uC5EC\uC790 : ".concat(members.toString().replaceAll(',', ', '), "\n");
    content += "\uC77C\uC2DC : ".concat(dayjs_minExports(startAt).locale(locale.dayjsLocale).format('lll'), " ~ ").concat(dayjs_minExports(endAt || startAt).locale(locale.dayjsLocale).format('lll'), "\n");
    content += "\uB300\uD654\uB0B4\uC6A9\n".concat(stringifiedMessages.toString().replaceAll(',', '\n'));
    return content;
  };
  /**
   * 대화 내용 선택 완료
   */
  var handleSelectDone = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!canSubmit) return [2 /*return*/];
            if (loading) {
              return [2 /*return*/];
            }

            setMode(null);
            setStartAt(null);
            setEndAt(null);
            return [4 /*yield*/, onSubmit(generateText())];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 취소하기
   */
  var handleCancel = function () {
    setMode(null);
    setStartAt(null);
    setEndAt(null);
  };
  var headerDescription = useMemo(function () {
    if (!startAt && !endAt) return steps[0];
    if (startAt && !endAt) return steps[1];
    if (hasSelectedMessage && !canSubmit) return jsx(Box, {
      as: "span",
      color: "#ff2b2b",
      children: steps[2]
    });
    if (canSubmit) return steps[3];
    return jsx(Box, {
      as: "span",
      color: "#ff2b2b",
      children: steps[2]
    });
  }, [steps, startAt, endAt, hasSelectedMessage, canSubmit]);
  /**
   * Render Header
   */
  var renderHeader = function () {
    return createPortal(jsxs(Header$2, {
      children: [jsx("div", {
        className: "title",
        children: title
      }), jsx("div", {
        className: "description",
        children: headerDescription
      }), jsx("button", {
        className: "close-button",
        onClick: handleCancel,
        children: jsxs("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M4 5L15 16",
            stroke: "#404040",
            strokeWidth: "1.3",
            strokeLinecap: "round"
          }), jsx("path", {
            d: "M15 5L4 16",
            stroke: "#404040",
            strokeWidth: "1.3",
            strokeLinecap: "round"
          })]
        })
      })]
    }), headerRef === null || headerRef === void 0 ? void 0 : headerRef.current);
  };
  /**
   * Render Footer
   */
  var renderFooter = function () {
    return createPortal(jsx(Fab, {
      disabled: !canSubmit,
      okText: locale.extention_gpt_message_select_done,
      cancelText: locale.extention_gpt_cancel,
      onOk: handleSelectDone,
      onCancel: handleCancel
    }), footerRef === null || footerRef === void 0 ? void 0 : footerRef.current);
  };
  /**
   * Mark up
   */
  return jsxs(Fragment, {
    children: [jsx(ExtentionButton, {
      disabled: loading || !!mode && !enabled,
      onClick: function () {
        setAsideKey(null);
        setMode(currentMode);
        setStartAt(null);
        setEndAt(null);
      },
      icon: icon,
      children: buttonText
    }), enabled && jsxs(Fragment, {
      children: [renderHeader(), renderFooter()]
    })]
  });
};
var Header$2 = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 20;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: var(--chat-header-height);\n  padding: 0.375rem 1rem;\n\n  color: #6a6a6a;\n  font-size: 0.875rem;\n  text-align: center;\n  background-color: white;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 23px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #2c384a;\n    margin-bottom: 2px;\n  }\n\n  .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #414c5c;\n  }\n\n  .close-button {\n    cursor: pointer;\n    position: absolute;\n    top: 22px;\n    right: 16px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    margin: 0;\n    background: none;\n    outline: none;\n    border: none;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 20;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: var(--chat-header-height);\n  padding: 0.375rem 1rem;\n\n  color: #6a6a6a;\n  font-size: 0.875rem;\n  text-align: center;\n  background-color: white;\n  border-bottom: 1px solid var(--chat-border-color);\n\n  .title {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 23px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #2c384a;\n    margin-bottom: 2px;\n  }\n\n  .description {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #414c5c;\n  }\n\n  .close-button {\n    cursor: pointer;\n    position: absolute;\n    top: 22px;\n    right: 16px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    margin: 0;\n    background: none;\n    outline: none;\n    border: none;\n  }\n"])));
var templateObject_1$p;

var CancelToken$1 = Axios.CancelToken;
var GPTMinutes = function (props) {
  var channel = props.channel;
  var axios = useFetch();
  var locale = useLocale().locale;
  var gpt = useContext(ChatContext).gpt;
  var _a = useContext(ChannelContext),
    asideKey = _a.asideKey,
    setAsideKey = _a.setAsideKey;
  var send = useSendCustomMessage().send;
  var _b = useState(false),
    isLoading = _b[0],
    setIsLoading = _b[1];
  var _c = useState(null),
    data = _c[0],
    setData = _c[1];
  var cancelRef = useRef(null);
  /**
   * 선택완료 클릭 시 이벤트
   *
   * @param data
   */
  var handleGenerate = function (value) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setAsideKey('gpt-minutes');
            setIsLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, axios.post('/openai/translate/minutes', {
              chat: value,
              channelUrl: channel.url
            }, {
              cancelToken: new CancelToken$1(function executor(c) {
                // 실행자 함수는 취소 함수를 파라미터로 받습니다.
                cancelRef.current = c;
              })
            })];
          case 2:
            data_1 = _a.sent().data;
            setData(data_1);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            setData(null);
            setAsideKey(null);
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            setIsLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  var handleCancel = function () {
    setAsideKey(null);
    setIsLoading(false);
    setData(null);
    cancelRef.current && cancelRef.current('Operation canceled by the user.');
  };
  var handlePostDoc = function (value) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var response, error_2;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!gpt) return [2 /*return*/];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            return [4 /*yield*/, gpt.onPostMinutes(value)];
          case 2:
            response = _b.sent();
            if (!response) return [2 /*return*/];
            send('share-minutes', "[".concat(locale.extention_share_document_tab_minutes, "] ").concat(response === null || response === void 0 ? void 0 : response.title), __assign$1(__assign$1({}, response), {
              thumbnailUrl: ((_a = genThumbnails([], response.content)) === null || _a === void 0 ? void 0 : _a[0]) || ''
            }));
            return [3 /*break*/, 4];
          case 3:
            error_2 = _b.sent();
            console.error(error_2);
            return [3 /*break*/, 4];
          case 4:
            setAsideKey(null);
            setData(null);
            return [2 /*return*/];
        }
      });
    });
  };

  if (!gpt) return null;
  return jsxs(Fragment, {
    children: [jsx(GPTDocGenerator, {
      mode: "minutes",
      loading: isLoading,
      icon: jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: jsx("path", {
          d: "M9.32055 19.2934H5.74268C5.29211 19.2934 4.92773 18.9281 4.92773 18.4775V3.7924C4.92773 3.34182 5.293 2.97656 5.74357 2.97656H11.9323C12.1486 2.97656 12.3562 3.06252 12.5092 3.21552L16.9262 7.63266C17.0792 7.78566 17.1652 7.99275 17.1652 8.20913V9.8099M7.85742 10.7861H13.7145M7.85742 13.7139H11.7621M17 13L18.1314 15.8687L21 17.0001L18.1314 18.1314L17 21.0001L15.8686 18.1314L13 17.0001L15.8686 15.8687L17 13Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }),
      buttonText: locale.extention_gpt_minutes_button,
      title: locale.extention_gpt_minutes_select_title,
      steps: [locale.extention_gpt_minutes_help_1, locale.extention_gpt_minutes_help_2, locale.extention_gpt_minutes_help_3, locale.extention_gpt_minutes_help_4],
      onSubmit: handleGenerate
    }), asideKey === 'gpt-minutes' && jsx(ChannelAside, {
      nonScroll: true,
      headerWithBorder: true,
      title: locale.extention_gpt_minutes_title,
      onClose: handleCancel,
      children: jsx(GPTDocForm, {
        loading: isLoading,
        loadingText: jsx("span", {
          dangerouslySetInnerHTML: {
            __html: locale.extention_gpt_minutes_loading
          }
        }),
        initialData: data,
        onCancel: handleCancel,
        onSubmit: handlePostDoc
      })
    })]
  });
};

var CancelToken = Axios.CancelToken;
var GPTRfi = function (props) {
  var channel = props.channel;
  var axios = useFetch();
  var locale = useLocale().locale;
  var gpt = useContext(ChatContext).gpt;
  var _a = useContext(ChannelContext),
    asideKey = _a.asideKey,
    setAsideKey = _a.setAsideKey;
  var send = useSendCustomMessage().send;
  var _b = useState(false),
    isLoading = _b[0],
    setIsLoading = _b[1];
  var _c = useState(null),
    data = _c[0],
    setData = _c[1];
  var cancelRef = useRef(null);
  var handleGenerate = function (value) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data_1, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setAsideKey('gpt-rfi');
            setIsLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, axios.post('/openai/translate/rfis', {
              chat: value,
              channelUrl: channel.url
            }, {
              cancelToken: new CancelToken(function executor(c) {
                // 실행자 함수는 취소 함수를 파라미터로 받습니다.
                cancelRef.current = c;
              })
            })];
          case 2:
            data_1 = _a.sent().data;
            setData(data_1);
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            setData(null);
            setAsideKey(null);
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            setIsLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  var handleCancel = function () {
    setAsideKey(null);
    setIsLoading(false);
    setData(null);
    cancelRef.current && cancelRef.current('Operation canceled by the user.');
  };
  var handlePostDoc = function (value) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var response;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!gpt) return [2 /*return*/];
            return [4 /*yield*/, gpt.onPostRfi(value)];
          case 1:
            response = _b.sent();
            // setResult(value);
            setAsideKey(null);
            setData(null);
            if (response) {
              send('share-rfi', "[".concat(locale.extention_share_document_tab_rfi, "] ").concat(response === null || response === void 0 ? void 0 : response.title), __assign$1(__assign$1({}, response), {
                thumbnailUrl: ((_a = genThumbnails(response.files, response.content)) === null || _a === void 0 ? void 0 : _a[0]) || ''
              }));
            }
            return [2 /*return*/];
        }
      });
    });
  };

  if (!gpt) return null;
  return jsxs(Fragment, {
    children: [jsx(GPTDocGenerator, {
      mode: "rfi",
      loading: isLoading,
      icon: jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: jsx("path", {
          d: "M9.40487 20.6667H6.16667C5.52233 20.6667 5 20.1443 5 19.5V5.16666C5 4.52233 5.52233 4 6.16667 4H17.5C18.1443 4 18.6667 4.52233 18.6667 5.16667V13M8.5 11.2417L10.7418 13.4834L15.2241 9M16 14L17.1314 16.8687L20 18.0001L17.1314 19.1314L16 22.0001L14.8686 19.1314L12 18.0001L14.8686 16.8687L16 14Z",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      }),
      buttonText: locale.extention_gpt_rfi_button,
      title: locale.extention_gpt_rfi_select_title,
      steps: [locale.extention_gpt_rfi_help_1, locale.extention_gpt_rfi_help_2, locale.extention_gpt_rfi_help_3, locale.extention_gpt_rfi_help_4],
      onSubmit: handleGenerate
    }), asideKey === 'gpt-rfi' && jsx(ChannelAside, {
      nonScroll: true,
      headerWithBorder: true,
      title: locale.extention_gpt_rfi_title,
      onClose: handleCancel,
      children: jsx(GPTDocForm, {
        loading: isLoading,
        loadingText: jsx("span", {
          dangerouslySetInnerHTML: {
            __html: locale.extention_gpt_rfi_loading
          }
        }),
        initialData: data,
        // aiWrittedText={locale.extention_gpt_rfi_ai_writted_text}
        onCancel: handleCancel,
        onSubmit: handlePostDoc
      })
    })]
  });
};

var useExtentions = function (props) {
  var channel = props.channel;
  var extentions = useContext(ChatContext).extentions;
  var setAsideKey = useContext(ChannelContext).setAsideKey;
  var _a = useState(null),
    metadata = _a[0],
    setMetadata = _a[1];
  var getMetadata = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, channel === null || channel === void 0 ? void 0 : channel.getAllMetaData()];
          case 1:
            data = _a.sent();
            setMetadata(data);
            return [2 /*return*/];
        }
      });
    });
  };

  useEffect(function () {
    if (!channel) return;
    getMetadata();
  }, [channel]);
  useEffect(function () {
    setAsideKey(null);
  }, [channel === null || channel === void 0 ? void 0 : channel.url]);
  if (!channel) return null;
  if (!extentions.length) return null;
  var renderExtention = function (type) {
    switch (type) {
      case 'share-document':
        return jsx(ShareDocument, {
          channel: channel
        });
      case 'attachment':
        return jsx(Attachment, {
          channel: channel
        });
      case 'gpt-minutes':
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) !== 'PROJECT') return '';
        return jsx(GPTMinutes, {
          channel: channel
        });
      case 'gpt-rfi':
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) !== 'PROJECT') return '';
        return jsx(GPTRfi, {
          channel: channel
        });
      case 'estimate-order':
        return jsx(EstimateOrder, {});
      default:
        return '';
    }
  };
  return jsx(Fragment, {
    children: extentions.map(function (type) {
      return jsx(Fragment$1, {
        children: renderExtention(type)
      }, type);
    })
  });
};

var index$3 = useLayoutEffect;

var useLatest = function useLatest(value) {
  var ref = React$1.useRef(value);
  index$3(function () {
    ref.current = value;
  });
  return ref;
};

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};
var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = useRef();
  return useCallback(function (instance) {
    libRef.current = instance;
    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }
    prevUserRef.current = userRef;
    if (!userRef) {
      return;
    }
    updateRef(userRef, instance);
  }, [userRef]);
};

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};
var forceHiddenStyles$1 = forceHiddenStyles;

// TODO: use labelled tuples once they are avaiable:
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259

var hiddenTextarea = null;
var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;
  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  }

  // remove padding, since height = content
  return height - sizingData.paddingSize;
};
function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }
  if (maxRows === void 0) {
    maxRows = Infinity;
  }
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles$1(hiddenTextarea);
  }
  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }
  var paddingSize = sizingData.paddingSize,
    borderSize = sizingData.borderSize,
    sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles$1(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData);
  // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
  hiddenTextarea.value = value;
  height = getHeight(hiddenTextarea, sizingData);

  // measure height of a textarea with a single row
  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;
  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }
  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;
  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }
  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop = function noop() {};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
// non-standard
'tabSize', 'textIndent',
// non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE$1 = !!document.documentElement.currentStyle ;
var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);
  if (style === null) {
    return null;
  }
  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing;

  // probably node is detached from DOM, can't read computed dimensions
  if (boxSizing === '') {
    return null;
  }

  // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths
  if (isIE$1 && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }
  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};
var getSizingData$1 = getSizingData;

function useListener(target, type, listener) {
  var latestListener = useLatest(listener);
  React$1.useLayoutEffect(function () {
    var handler = function handler(ev) {
      return latestListener.current(ev);
    };

    // might happen if document.fonts is not defined, for instance
    if (!target) {
      return;
    }
    target.addEventListener(type, handler);
    return function () {
      return target.removeEventListener(type, handler);
    };
  }, []);
}
var useWindowResizeListener = function useWindowResizeListener(listener) {
  useListener(window, 'resize', listener);
};
var useFontsLoadedListener = function useFontsLoadedListener(listener) {
  useListener(document.fonts, 'loadingdone', listener);
};

var _excluded = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"];
var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
    maxRows = _ref.maxRows,
    minRows = _ref.minRows,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$onHeightChange = _ref.onHeightChange,
    onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
    props = _objectWithoutPropertiesLoose$1(_ref, _excluded);
  var isControlled = props.value !== undefined;
  var libRef = React$1.useRef(null);
  var ref = useComposedRef(libRef, userRef);
  var heightRef = React$1.useRef(0);
  var measurementsCacheRef = React$1.useRef();
  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData$1(node);
    if (!nodeSizingData) {
      return;
    }
    measurementsCacheRef.current = nodeSizingData;
    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
      height = _calculateNodeHeight[0],
      rowHeight = _calculateNodeHeight[1];
    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };
  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }
    onChange(event);
  };
  {
    React$1.useLayoutEffect(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
    useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/React$1.createElement("textarea", _extends$2({}, props, {
      onChange: handleChange,
      ref: ref
    }));
  }
};
var index$2 = /* #__PURE__ */React$1.forwardRef(TextareaAutosize);

var ParentMessage = function (props) {
  var message = props.message,
    isMine = props.isMine,
    withBorder = props.withBorder,
    onClick = props.onClick;
  if (!message.isUserMessage() && !message.isFileMessage()) return null;
  var checkFileType = function (targetString, types) {
    // 확장자가 대문자인 경우도 있기 때문에 소문자로 변환
    var lowerCasedString = targetString.toLowerCase();
    return !!types.filter(function (type) {
      return lowerCasedString.includes(type);
    }).length;
  };
  var renderThumbnailArea = function () {
    var _a, _b, _c;
    if (message.isFileMessage()) {
      var parsedFile = message.data ? JSON.parse(message.data || '{}') : null;
      if (message.type.includes('image')) {
        // 이미지 파일
        return jsx(ThumbnailArea, {
          children: jsx(Image, {
            src: (parsedFile === null || parsedFile === void 0 ? void 0 : parsedFile.thumbnailUrl) || (parsedFile === null || parsedFile === void 0 ? void 0 : parsedFile.url),
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              borderRadius: 4
            },
            wrapperStyle: {
              position: 'relative',
              cursor: 'pointer',
              overflow: 'hidden',
              width: '100%',
              height: '100%'
            },
            preview: {
              src: parsedFile === null || parsedFile === void 0 ? void 0 : parsedFile.url
            }
          })
        });
      } else if (message.type.includes('video')) {
        // 비디오 파일
        return jsx(ThumbnailArea, {
          children: jsx(Image, {
            src: parsedFile === null || parsedFile === void 0 ? void 0 : parsedFile.thumbnailUrl,
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              borderRadius: 4
            },
            wrapperStyle: {
              position: 'relative',
              cursor: 'pointer',
              overflow: 'hidden',
              width: '100%',
              height: '100%'
            }
          })
        });
      } else if (checkFileType(message.name, ['.xlsx', '.xls'])) {
        // 엑셀 파일
        return jsx(ThumbnailArea, {
          children: jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            children: [jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.00008 1C5.35005 1 4.01504 2.35 4.01504 4L4 28C4 29.65 5.33501 31 6.98507 31H25.0001C26.65 31 28.0001 29.65 28.0001 28V7.99999L21.0001 1H7.00008Z",
              fill: "#4CAF50"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.5 11.4L13 9H15L12.5 13L15 17H13L11.5 14.6L10 17H8L10.5 13L8 9H10L11.5 11.4Z",
              fill: "white"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M19.0001 14H23H24.0001V27H23V18H19.0001V19.9999H23V21H19.0001V23H23V24H19.0001V26H23L23 27L9.00005 27H8V21V19.9999H18.0001V14H19.0001ZM19.0001 15V17H23V15H19.0001ZM14 21V23H18.0001V21H14ZM13 21H9.00005V23H13V21ZM14 24V26H18.0001V24H14ZM13 24H9.00005V26H13V24Z",
              fill: "white"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23 7.99997C21.8954 7.99997 21 7.10453 21 5.99997V0.999947L28 7.99997H23Z",
              fill: "#81C784"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M22 8H28V15L22 8Z",
              fill: "black",
              fillOpacity: "0.15"
            })]
          })
        });
      } else if (checkFileType(message.name, ['.ppt', '.pptx'])) {
        // 파워포인트 파일
        return jsx(ThumbnailArea, {
          children: jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            children: [jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.00008 1C5.35003 1 4.01501 2.35 4.01501 4L4 28C4 29.65 5.33501 31 6.98507 31H25C26.65 31 28.0001 29.65 28.0001 28V7.99999L21.0001 1H7.00008Z",
              fill: "#ECB33E"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23 7.99997C21.8954 7.99997 21 7.10453 21 5.99997V0.999954L28 7.99997H23Z",
              fill: "#FFD888"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M22 8H28V15L22 8Z",
              fill: "black",
              fillOpacity: "0.15"
            }), jsx("path", {
              d: "M7 11H14C14 9.89543 14.8954 9 16 9C17.1046 9 18 9.89543 18 11H25V13H24V23H19.25L21 26H19L17.25 23H14.75L13 26H11L12.75 23H8V13H7V11ZM10 13V21H22V13H10Z",
              fill: "white"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M14 14L19 17L14 20V14Z",
              fill: "white"
            })]
          })
        });
      } else if (checkFileType(message.name, ['.pdf'])) {
        return jsx(ThumbnailArea, {
          children: jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            children: [jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7.0001 1C5.35005 1 4.01504 2.35 4.01504 4L4 28C4 29.65 5.33501 31 6.98507 31H25.0001C26.65 31 28.0001 29.65 28.0001 28V7.99999L21.0001 1H7.0001Z",
              fill: "#F44336"
            }), jsx("path", {
              opacity: "0.35",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23.835 21.5332C22.2001 21.4879 20.6137 20.9691 19.2686 20.04C17.1338 20.408 15.0343 20.9573 12.993 21.6819C12.2448 23.0771 11.3348 24.3795 10.2817 25.5625C9.68603 26.1848 7.99805 26.1073 7.99805 25.4137C7.99805 23.8781 11.7081 21.8316 11.7081 21.8316C11.7081 21.8316 7.87887 25.5625 8.8543 25.5625C10.8167 25.5625 15.2767 15.1144 15.2767 15.1144C14.6767 13.7519 14.3861 12.2736 14.4258 10.7857C14.4258 9.94996 14.6321 8.99519 15.5671 8.99519C16.5021 8.99519 16.7372 9.763 16.4234 11.2339C16.4234 11.2339 16.2107 9.14389 15.7096 9.14389C15.2086 9.14389 15.3161 11.9125 15.7096 13.7944C15.7096 13.7944 16.0862 12.6262 16.4234 11.2456C16.4405 12.4174 16.345 13.5881 16.1383 14.7417C16.1383 15.6975 18.0178 18.5044 19.7058 19.2977C19.7058 19.2977 21.5396 19.149 22.8458 19.149C25.4805 19.1448 25.5911 21.5332 23.835 21.5332ZM15.6299 15.9471C14.9324 17.7702 14.097 19.5379 13.1313 21.2348C14.8207 20.4431 16.6098 19.8836 18.4496 19.5717C17.2734 18.5667 16.3141 17.3336 15.6299 15.9471ZM20.6951 19.8913C21.7791 20.4122 22.9332 20.7731 24.1211 20.9629C24.4087 20.9851 24.6615 20.7746 24.6914 20.4882C24.6934 19.4953 20.6951 19.8913 20.6951 19.8913Z",
              fill: "white"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23.835 21.5332C22.2001 21.4879 20.6137 20.9691 19.2686 20.04C17.1338 20.408 15.0343 20.9573 12.993 21.6819C12.2448 23.0771 11.3348 24.3795 10.2817 25.5625C9.68603 26.1848 7.99805 26.1073 7.99805 25.4137C7.99805 23.8781 11.7081 21.8316 11.7081 21.8316C11.7081 21.8316 7.87887 25.5625 8.8543 25.5625C10.8167 25.5625 15.2767 15.1144 15.2767 15.1144C14.6767 13.7519 14.3861 12.2736 14.4258 10.7857C14.4258 9.94996 14.6321 8.99519 15.5671 8.99519C16.5021 8.99519 16.7372 9.763 16.4234 11.2339C16.4234 11.2339 16.2107 9.14389 15.7096 9.14389C15.2086 9.14389 15.3161 11.9125 15.7096 13.7944C15.7096 13.7944 16.0862 12.6262 16.4234 11.2456C16.4405 12.4174 16.345 13.5881 16.1383 14.7417C16.1383 15.6975 18.0178 18.5044 19.7058 19.2977C19.7058 19.2977 21.5396 19.149 22.8458 19.149C25.4805 19.1448 25.5911 21.5332 23.835 21.5332ZM15.6299 15.9471C14.9324 17.7702 14.097 19.5379 13.1313 21.2348C14.8207 20.4431 16.6098 19.8836 18.4496 19.5717C17.2734 18.5667 16.3141 17.3336 15.6299 15.9471ZM20.6951 19.8913C21.7791 20.4122 22.9332 20.7731 24.1211 20.9629C24.4087 20.9851 24.6615 20.7746 24.6914 20.4882C24.6934 19.4953 20.6951 19.8913 20.6951 19.8913Z",
              fill: "white"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M23 7.99997C21.8954 7.99997 21 7.10453 21 5.99997V0.999954L28 7.99997H23Z",
              fill: "#FF8A80"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M22 8H28V15L22 8Z",
              fill: "black",
              fillOpacity: "0.15"
            })]
          })
        });
      } else {
        // 기타 파일
        return jsx(ThumbnailArea, {
          children: jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            children: [jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M7 1C5.35005 1 4.01501 2.35 4.01501 4L4 28C4 29.65 5.33501 31 6.98507 31H25C26.65 31 28.0001 29.65 28.0001 28V7.99999L21.0001 1H7Z",
              fill: "#3399CC"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M22 8H28V15L22 8Z",
              fill: "black",
              fillOpacity: "0.15"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M22.9999 7.99997C21.8954 7.99997 21 7.10453 21 5.99997V0.999954L28 7.99997H22.9999Z",
              fill: "#6AC0EB"
            }), jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10 11H16V13H10V11ZM10 15H22V17H10V15ZM10 19H22V21H10V19Z",
              fill: "white"
            })]
          })
        });
      }
    }
    if (message.customType === 'multiple-image') {
      var images = JSON.parse(message.data || '[]');
      return jsx(ThumbnailArea, {
        children: jsx(Image, {
          src: ((_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.thumbnailUrl) || ((_b = images === null || images === void 0 ? void 0 : images[0]) === null || _b === void 0 ? void 0 : _b.url),
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            borderRadius: 4
          },
          wrapperStyle: {
            position: 'relative',
            cursor: 'pointer',
            overflow: 'hidden',
            width: '100%',
            height: '100%'
          },
          preview: {
            src: (_c = images === null || images === void 0 ? void 0 : images[0]) === null || _c === void 0 ? void 0 : _c.url
          }
        })
      });
    }
    return null;
  };
  var renderMessage = function () {
    if (message.isFileMessage()) {
      if (message.type.includes('image')) {
        return '이미지';
      } else if (message.type.includes('video')) {
        return '동영상';
      } else {
        return message.name;
      }
    }
    if (!message.isUserMessage()) {
      return '지원하지 않는 메시지입니다.';
    }
    return message.message;
  };
  return jsxs(Container$3, {
    withBorder: withBorder,
    isMine: isMine,
    clickable: !!onClick,
    onClick: onClick,
    children: [renderThumbnailArea(), jsxs("div", {
      children: [jsxs(Sender, {
        children: [jsx("strong", {
          children: message.sender.nickname
        }), "\uB2D8\uC5D0\uAC8C \uB2F5\uC7A5"]
      }), jsx(MessageContent, {
        children: renderMessage()
      })]
    })]
  });
};
var Container$3 = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n\n  color: ", ";\n  line-height: 150%;\n  white-space: initial;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n\n  color: ", ";\n  line-height: 150%;\n  white-space: initial;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
  var isMine = _a.isMine;
  return isMine ? 'white' : '#7f8892';
}, function (_a) {
  var withBorder = _a.withBorder,
    isMine = _a.isMine;
  if (!withBorder) return '';
  if (isMine) return "border-bottom: 1px solid white;";
  return 'border-bottom: 1px solid #E9E9E9;';
}, function (_a) {
  var withBorder = _a.withBorder;
  return withBorder ? "\n        padding-top: 8px;\n        padding-bottom: 8px;\n        margin-bottom: 8px;\n      " : '';
}, function (_a) {
  var clickable = _a.clickable;
  return clickable ? "\n        cursor: pointer;\n      " : '';
});
var Sender = styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  margin-bottom: 7px;\n\n  strong {\n    font-weight: 500;\n  }\n"], ["\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  margin-bottom: 7px;\n\n  strong {\n    font-weight: 500;\n  }\n"])));
var ThumbnailArea = styled.div(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 46px;\n  height: 46px;\n\n  .ant-image-mask {\n    display: none;\n  }\n"], ["\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 46px;\n  height: 46px;\n\n  .ant-image-mask {\n    display: none;\n  }\n"])));
var MessageContent = styled.div(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  word-break: break-all;\n"], ["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  word-break: break-all;\n"])));
var templateObject_1$o, templateObject_2$g, templateObject_3$c, templateObject_4$8;

var ChannelInputParentMessage = function (props) {
  var onCancel = props.onCancel;
  var _a = useContext(ChannelContext),
    parentMessage = _a.parentMessage,
    setParentMessage = _a.setParentMessage;
  if (!parentMessage) return null;
  return jsxs(Container$2, {
    children: [jsx(ParentMessage, {
      message: parentMessage
    }), jsx(CancelButton, {
      onClick: function () {
        setParentMessage(null);
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
      },
      children: jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: jsx("path", {
          d: "M4.10742 15.8925L15.8925 4.10741M15.8925 15.8925L4.10742 4.10741",
          stroke: "#404040",
          strokeWidth: "1.8",
          strokeLinecap: "round"
        })
      })
    })]
  });
};
var Container$2 = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n  gap: 8px;\n  padding-right: 21px;\n\n  border-bottom: 1px solid var(--chat-border-color);\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n  gap: 8px;\n  padding-right: 21px;\n\n  border-bottom: 1px solid var(--chat-border-color);\n"])));
var CancelButton = styled.button(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  margin: 0;\n\n  border: none;\n  outline: none;\n  background: none;\n  border-radius: 0;\n  appearance: none;\n\n  cursor: pointer;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  margin: 0;\n\n  border: none;\n  outline: none;\n  background: none;\n  border-radius: 0;\n  appearance: none;\n\n  cursor: pointer;\n"])));
var templateObject_1$n, templateObject_2$f;

var SendButton = function (props) {
  var children = props.children,
    isReply = props.isReply,
    args = __rest$2(props, ["children", "isReply"]);
  return jsxs(StyledButton, __assign$1({}, args, {
    children: [isReply ? jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      children: [jsx("path", {
        d: "M3.35 3C3.35 2.64101 3.64102 2.35 4 2.35C4.35898 2.35 4.65 2.64101 4.65 3H3.35ZM15.5 14.15H8V12.85H15.5V14.15ZM8 14.15C6.46537 14.15 5.21544 13.9033 4.39404 12.9997C3.59152 12.117 3.35 10.7668 3.35 9H4.65C4.65 10.7332 4.90848 11.633 5.35596 12.1253C5.78456 12.5967 6.53463 12.85 8 12.85V14.15ZM3.35 9C3.35 8.99219 3.35 8.98439 3.35 8.97659C3.35 8.9688 3.35 8.96102 3.35 8.95325C3.35 8.94548 3.35 8.93771 3.35 8.92996C3.35 8.92221 3.35 8.91447 3.35 8.90674C3.35 8.89901 3.35 8.89128 3.35 8.88357C3.35 8.87586 3.35 8.86816 3.35 8.86047C3.35 8.85278 3.35 8.8451 3.35 8.83743C3.35 8.82976 3.35 8.8221 3.35 8.81445C3.35 8.80679 3.35 8.79915 3.35 8.79152C3.35 8.78389 3.35 8.77627 3.35 8.76866C3.35 8.76105 3.35 8.75345 3.35 8.74586C3.35 8.73827 3.35 8.73069 3.35 8.72312C3.35 8.71555 3.35 8.70799 3.35 8.70044C3.35 8.69289 3.35 8.68535 3.35 8.67782C3.35 8.67028 3.35 8.66276 3.35 8.65525C3.35 8.64774 3.35 8.64024 3.35 8.63275C3.35 8.62526 3.35 8.61778 3.35 8.61031C3.35 8.60284 3.35 8.59538 3.35 8.58793C3.35 8.58047 3.35 8.57303 3.35 8.5656C3.35 8.55817 3.35 8.55075 3.35 8.54334C3.35 8.53593 3.35 8.52852 3.35 8.52113C3.35 8.51374 3.35 8.50636 3.35 8.49899C3.35 8.49161 3.35 8.48425 3.35 8.4769C3.35 8.46955 3.35 8.4622 3.35 8.45487C3.35 8.44754 3.35 8.44022 3.35 8.4329C3.35 8.42559 3.35 8.41829 3.35 8.41099C3.35 8.4037 3.35 8.39642 3.35 8.38914C3.35 8.38187 3.35 8.3746 3.35 8.36735C3.35 8.36009 3.35 8.35285 3.35 8.34561C3.35 8.33838 3.35 8.33115 3.35 8.32394C3.35 8.31672 3.35 8.30952 3.35 8.30232C3.35 8.29513 3.35 8.28794 3.35 8.28076C3.35 8.27358 3.35 8.26642 3.35 8.25926C3.35 8.2521 3.35 8.24496 3.35 8.23782C3.35 8.23068 3.35 8.22355 3.35 8.21643C3.35 8.20931 3.35 8.20221 3.35 8.19511C3.35 8.18801 3.35 8.18092 3.35 8.17384C3.35 8.16676 3.35 8.15969 3.35 8.15262C3.35 8.14556 3.35 8.13851 3.35 8.13147C3.35 8.12443 3.35 8.1174 3.35 8.11037C3.35 8.10335 3.35 8.09634 3.35 8.08934C3.35 8.08233 3.35 8.07534 3.35 8.06835C3.35 8.06137 3.35 8.0544 3.35 8.04743C3.35 8.04046 3.35 8.03351 3.35 8.02656C3.35 8.01962 3.35 8.01268 3.35 8.00575C3.35 7.99883 3.35 7.99191 3.35 7.985C3.35 7.97809 3.35 7.97119 3.35 7.9643C3.35 7.95741 3.35 7.95053 3.35 7.94366C3.35 7.93679 3.35 7.92993 3.35 7.92308C3.35 7.91623 3.35 7.90939 3.35 7.90256C3.35 7.89572 3.35 7.8889 3.35 7.88209C3.35 7.87527 3.35 7.86847 3.35 7.86167C3.35 7.85488 3.35 7.84809 3.35 7.84132C3.35 7.83454 3.35 7.82778 3.35 7.82102C3.35 7.81426 3.35 7.80751 3.35 7.80077C3.35 7.79404 3.35 7.78731 3.35 7.78059C3.35 7.77387 3.35 7.76716 3.35 7.76045C3.35 7.75375 3.35 7.74706 3.35 7.74038C3.35 7.7337 3.35 7.72702 3.35 7.72036C3.35 7.71369 3.35 7.70704 3.35 7.70039C3.35 7.69375 3.35 7.68711 3.35 7.68049C3.35 7.67386 3.35 7.66724 3.35 7.66063C3.35 7.65402 3.35 7.64743 3.35 7.64084C3.35 7.63425 3.35 7.62767 3.35 7.62109C3.35 7.61452 3.35 7.60796 3.35 7.60141C3.35 7.59485 3.35 7.58831 3.35 7.58178C3.35 7.57524 3.35 7.56872 3.35 7.5622C3.35 7.55568 3.35 7.54918 3.35 7.54268C3.35 7.53618 3.35 7.52969 3.35 7.52321C3.35 7.51673 3.35 7.51026 3.35 7.5038C3.35 7.49734 3.35 7.49089 3.35 7.48444C3.35 7.478 3.35 7.47157 3.35 7.46514C3.35 7.45872 3.35 7.4523 3.35 7.44589C3.35 7.43949 3.35 7.43309 3.35 7.4267C3.35 7.42031 3.35 7.41393 3.35 7.40756C3.35 7.40119 3.35 7.39483 3.35 7.38848C3.35 7.38213 3.35 7.37578 3.35 7.36945C3.35 7.36311 3.35 7.35679 3.35 7.35047C3.35 7.34416 3.35 7.33785 3.35 7.33155C3.35 7.32525 3.35 7.31896 3.35 7.31268C3.35 7.3064 3.35 7.30013 3.35 7.29387C3.35 7.28761 3.35 7.28135 3.35 7.27511C3.35 7.26886 3.35 7.26263 3.35 7.2564C3.35 7.25018 3.35 7.24396 3.35 7.23775C3.35 7.23154 3.35 7.22534 3.35 7.21915C3.35 7.21296 3.35 7.20678 3.35 7.2006C3.35 7.19443 3.35 7.18827 3.35 7.18211C3.35 7.17596 3.35 7.16981 3.35 7.16367C3.35 7.15754 3.35 7.15141 3.35 7.14529C3.35 7.13917 3.35 7.13306 3.35 7.12695C3.35 7.12085 3.35 7.11476 3.35 7.10867C3.35 7.10259 3.35 7.09651 3.35 7.09045C3.35 7.08438 3.35 7.07832 3.35 7.07227C3.35 7.06622 3.35 7.06018 3.35 7.05415C3.35 7.04812 3.35 7.0421 3.35 7.03608C3.35 7.03007 3.35 7.02406 3.35 7.01807C3.35 7.01207 3.35 7.00608 3.35 7.0001C3.35 6.99412 3.35 6.98815 3.35 6.98219C3.35 6.97623 3.35 6.97028 3.35 6.96433C3.35 6.95839 3.35 6.95245 3.35 6.94652C3.35 6.9406 3.35 6.93468 3.35 6.92877C3.35 6.92286 3.35 6.91696 3.35 6.91107C3.35 6.90517 3.35 6.89929 3.35 6.89342C3.35 6.88754 3.35 6.88167 3.35 6.87582C3.35 6.86996 3.35 6.86411 3.35 6.85827C3.35 6.85243 3.35 6.8466 3.35 6.84077C3.35 6.83495 3.35 6.82913 3.35 6.82333C3.35 6.81752 3.35 6.81172 3.35 6.80594C3.35 6.80015 3.35 6.79437 3.35 6.78859C3.35 6.78282 3.35 6.77706 3.35 6.7713C3.35 6.76555 3.35 6.7598 3.35 6.75407C3.35 6.74833 3.35 6.7426 3.35 6.73688C3.35 6.73116 3.35 6.72544 3.35 6.71974C3.35 6.71404 3.35 6.70834 3.35 6.70265C3.35 6.69697 3.35 6.69129 3.35 6.68562C3.35 6.67995 3.35 6.67429 3.35 6.66864C3.35 6.66298 3.35 6.65734 3.35 6.6517C3.35 6.64607 3.35 6.64044 3.35 6.63482C3.35 6.6292 3.35 6.62359 3.35 6.61799C3.35 6.61238 3.35 6.60679 3.35 6.6012C3.35 6.59562 3.35 6.59004 3.35 6.58447C3.35 6.5789 3.35 6.57334 3.35 6.56779C3.35 6.56224 3.35 6.55669 3.35 6.55116C3.35 6.54562 3.35 6.5401 3.35 6.53458C3.35 6.52906 3.35 6.52355 3.35 6.51805C3.35 6.51254 3.35 6.50705 3.35 6.50156C3.35 6.49608 3.35 6.4906 3.35 6.48513C3.35 6.47966 3.35 6.4742 3.35 6.46875C3.35 6.4633 3.35 6.45785 3.35 6.45242C3.35 6.44698 3.35 6.44155 3.35 6.43613C3.35 6.43071 3.35 6.4253 3.35 6.4199C3.35 6.4145 3.35 6.4091 3.35 6.40372C3.35 6.39833 3.35 6.39295 3.35 6.38758C3.35 6.38221 3.35 6.37685 3.35 6.3715C3.35 6.36614 3.35 6.3608 3.35 6.35546C3.35 6.35012 3.35 6.34479 3.35 6.33947C3.35 6.33415 3.35 6.32884 3.35 6.32353C3.35 6.31823 3.35 6.31293 3.35 6.30764C3.35 6.30235 3.35 6.29707 3.35 6.2918C3.35 6.28653 3.35 6.28126 3.35 6.27601C3.35 6.27075 3.35 6.2655 3.35 6.26026C3.35 6.25502 3.35 6.24979 3.35 6.24457C3.35 6.23934 3.35 6.23413 3.35 6.22892C3.35 6.22371 3.35 6.21851 3.35 6.21332C3.35 6.20813 3.35 6.20294 3.35 6.19777C3.35 6.19259 3.35 6.18742 3.35 6.18226C3.35 6.1771 3.35 6.17195 3.35 6.16681C3.35 6.16166 3.35 6.15653 3.35 6.1514C3.35 6.14627 3.35 6.14115 3.35 6.13604C3.35 6.13093 3.35 6.12583 3.35 6.12073C3.35 6.11563 3.35 6.11054 3.35 6.10546C3.35 6.10038 3.35 6.09531 3.35 6.09025C3.35 6.08518 3.35 6.08013 3.35 6.07508C3.35 6.07003 3.35 6.06499 3.35 6.05996C3.35 6.05492 3.35 6.0499 3.35 6.04488C3.35 6.03987 3.35 6.03486 3.35 6.02985C3.35 6.02485 3.35 6.01986 3.35 6.01487C3.35 6.00989 3.35 6.00491 3.35 5.99994C3.35 5.99497 3.35 5.99001 3.35 5.98505C3.35 5.9801 3.35 5.97515 3.35 5.97021C3.35 5.96528 3.35 5.96035 3.35 5.95542C3.35 5.9505 3.35 5.94558 3.35 5.94068C3.35 5.93577 3.35 5.93087 3.35 5.92598C3.35 5.92108 3.35 5.9162 3.35 5.91132C3.35 5.90645 3.35 5.90158 3.35 5.89672C3.35 5.89185 3.35 5.887 3.35 5.88216C3.35 5.87731 3.35 5.87247 3.35 5.86764C3.35 5.86281 3.35 5.85799 3.35 5.85317C3.35 5.84836 3.35 5.84355 3.35 5.83875C3.35 5.83395 3.35 5.82916 3.35 5.82437C3.35 5.81959 3.35 5.81481 3.35 5.81004C3.35 5.80527 3.35 5.80051 3.35 5.79576C3.35 5.791 3.35 5.78626 3.35 5.78152C3.35 5.77678 3.35 5.77205 3.35 5.76733C3.35 5.7626 3.35 5.75789 3.35 5.75318C3.35 5.74847 3.35 5.74377 3.35 5.73907C3.35 5.73438 3.35 5.7297 3.35 5.72502C3.35 5.72034 3.35 5.71567 3.35 5.71101C3.35 5.70634 3.35 5.70169 3.35 5.69704C3.35 5.69239 3.35 5.68775 3.35 5.68312C3.35 5.67848 3.35 5.67386 3.35 5.66924C3.35 5.66462 3.35 5.66001 3.35 5.65541C3.35 5.6508 3.35 5.64621 3.35 5.64162C3.35 5.63703 3.35 5.63245 3.35 5.62788C3.35 5.6233 3.35 5.61874 3.35 5.61418C3.35 5.60962 3.35 5.60507 3.35 5.60052C3.35 5.59598 3.35 5.59144 3.35 5.58692C3.35 5.58239 3.35 5.57786 3.35 5.57335C3.35 5.56884 3.35 5.56433 3.35 5.55983C3.35 5.55533 3.35 5.55084 3.35 5.54635C3.35 5.54187 3.35 5.53739 3.35 5.53292C3.35 5.52845 3.35 5.52399 3.35 5.51953C3.35 5.51508 3.35 5.51063 3.35 5.50619C3.35 5.50175 3.35 5.49731 3.35 5.49289C3.35 5.48846 3.35 5.48404 3.35 5.47963C3.35 5.47522 3.35 5.47081 3.35 5.46641C3.35 5.46202 3.35 5.45763 3.35 5.45324C3.35 5.44886 3.35 5.44449 3.35 5.44012C3.35 5.43575 3.35 5.43139 3.35 5.42703C3.35 5.42268 3.35 5.41833 3.35 5.41399C3.35 5.40965 3.35 5.40532 3.35 5.401C3.35 5.39667 3.35 5.39235 3.35 5.38804C3.35 5.38373 3.35 5.37943 3.35 5.37513C3.35 5.37084 3.35 5.36655 3.35 5.36226C3.35 5.35798 3.35 5.35371 3.35 5.34944C3.35 5.34517 3.35 5.34091 3.35 5.33666C3.35 5.3324 3.35 5.32816 3.35 5.32392C3.35 5.31968 3.35 5.31544 3.35 5.31122C3.35 5.30699 3.35 5.30277 3.35 5.29856C3.35 5.29435 3.35 5.29015 3.35 5.28595C3.35 5.28175 3.35 5.27756 3.35 5.27338C3.35 5.2692 3.35 5.26502 3.35 5.26085C3.35 5.25668 3.35 5.25252 3.35 5.24837C3.35 5.24421 3.35 5.24006 3.35 5.23592C3.35 5.23178 3.35 5.22765 3.35 5.22352C3.35 5.21939 3.35 5.21527 3.35 5.21116C3.35 5.20705 3.35 5.20294 3.35 5.19884C3.35 5.19474 3.35 5.19065 3.35 5.18656C3.35 5.18248 3.35 5.1784 3.35 5.17433C3.35 5.17026 3.35 5.16619 3.35 5.16213C3.35 5.15808 3.35 5.15402 3.35 5.14998C3.35 5.14594 3.35 5.1419 3.35 5.13787C3.35 5.13384 3.35 5.12982 3.35 5.1258C3.35 5.12178 3.35 5.11777 3.35 5.11377C3.35 5.10977 3.35 5.10577 3.35 5.10178C3.35 5.09779 3.35 5.09381 3.35 5.08983C3.35 5.08586 3.35 5.08189 3.35 5.07793C3.35 5.07397 3.35 5.07001 3.35 5.06606C3.35 5.06211 3.35 5.05817 3.35 5.05424C3.35 5.0503 3.35 5.04637 3.35 5.04245C3.35 5.03853 3.35 5.03462 3.35 5.03071C3.35 5.0268 3.35 5.0229 3.35 5.019C3.35 5.01511 3.35 5.01122 3.35 5.00734C3.35 5.00346 3.35 4.99959 3.35 4.99572C3.35 4.99185 3.35 4.98799 3.35 4.98414C3.35 4.98028 3.35 4.97643 3.35 4.97259C3.35 4.96875 3.35 4.96492 3.35 4.96109C3.35 4.95726 3.35 4.95344 3.35 4.94963C3.35 4.94581 3.35 4.942 3.35 4.9382C3.35 4.9344 3.35 4.93061 3.35 4.92682C3.35 4.92303 3.35 4.91925 3.35 4.91547C3.35 4.9117 3.35 4.90793 3.35 4.90417C3.35 4.90041 3.35 4.89665 3.35 4.8929C3.35 4.88916 3.35 4.88541 3.35 4.88168C3.35 4.87794 3.35 4.87421 3.35 4.87049C3.35 4.86677 3.35 4.86305 3.35 4.85934C3.35 4.85563 3.35 4.85193 3.35 4.84824C3.35 4.84454 3.35 4.84085 3.35 4.83717C3.35 4.83348 3.35 4.82981 3.35 4.82614C3.35 4.82246 3.35 4.8188 3.35 4.81514C3.35 4.81149 3.35 4.80783 3.35 4.80419C3.35 4.80054 3.35 4.79691 3.35 4.79327C3.35 4.78964 3.35 4.78602 3.35 4.7824C3.35 4.77878 3.35 4.77517 3.35 4.77156C3.35 4.76795 3.35 4.76435 3.35 4.76076C3.35 4.75717 3.35 4.75358 3.35 4.75C3.35 4.74642 3.35 4.74284 3.35 4.73928C3.35 4.73571 3.35 4.73215 3.35 4.72859C3.35 4.72504 3.35 4.72149 3.35 4.71794C3.35 4.7144 3.35 4.71087 3.35 4.70734C3.35 4.70381 3.35 4.70028 3.35 4.69676C3.35 4.69325 3.35 4.68974 3.35 4.68623C3.35 4.68273 3.35 4.67923 3.35 4.67573C3.35 4.67224 3.35 4.66876 3.35 4.66528C3.35 4.6618 3.35 4.65832 3.35 4.65485C3.35 4.65139 3.35 4.64793 3.35 4.64447C3.35 4.64102 3.35 4.63757 3.35 4.63412C3.35 4.63068 3.35 4.62724 3.35 4.62381C3.35 4.62038 3.35 4.61696 3.35 4.61354C3.35 4.61012 3.35 4.60671 3.35 4.60331C3.35 4.5999 3.35 4.5965 3.35 4.59311C3.35 4.58972 3.35 4.58633 3.35 4.58295C3.35 4.57957 3.35 4.57619 3.35 4.57282C3.35 4.56945 3.35 4.56609 3.35 4.56273C3.35 4.55938 3.35 4.55603 3.35 4.55268C3.35 4.54934 3.35 4.546 3.35 4.54267C3.35 4.53933 3.35 4.53601 3.35 4.53269C3.35 4.52937 3.35 4.52605 3.35 4.52274C3.35 4.51944 3.35 4.51613 3.35 4.51284C3.35 4.50954 3.35 4.50625 3.35 4.50297C3.35 4.49968 3.35 4.49641 3.35 4.49313C3.35 4.48986 3.35 4.4866 3.35 4.48333C3.35 4.48007 3.35 4.47682 3.35 4.47357C3.35 4.47032 3.35 4.46708 3.35 4.46385C3.35 4.46061 3.35 4.45738 3.35 4.45415C3.35 4.45093 3.35 4.44771 3.35 4.4445C3.35 4.44129 3.35 4.43808 3.35 4.43488C3.35 4.43168 3.35 4.42848 3.35 4.42529C3.35 4.4221 3.35 4.41892 3.35 4.41574C3.35 4.41257 3.35 4.40939 3.35 4.40623C3.35 4.40306 3.35 4.3999 3.35 4.39675C3.35 4.3936 3.35 4.39045 3.35 4.38731C3.35 4.38416 3.35 4.38103 3.35 4.3779C3.35 4.37477 3.35 4.37164 3.35 4.36852C3.35 4.3654 3.35 4.36229 3.35 4.35918C3.35 4.35607 3.35 4.35297 3.35 4.34988C3.35 4.34678 3.35 4.34369 3.35 4.34061C3.35 4.33752 3.35 4.33444 3.35 4.33137C3.35 4.3283 3.35 4.32523 3.35 4.32217C3.35 4.31911 3.35 4.31605 3.35 4.313C3.35 4.30995 3.35 4.30691 3.35 4.30387C3.35 4.30083 3.35 4.2978 3.35 4.29477C3.35 4.29174 3.35 4.28872 3.35 4.2857C3.35 4.28269 3.35 4.27968 3.35 4.27667C3.35 4.27367 3.35 4.27067 3.35 4.26768C3.35 4.26468 3.35 4.26169 3.35 4.25871C3.35 4.25573 3.35 4.25275 3.35 4.24978C3.35 4.24681 3.35 4.24385 3.35 4.24089C3.35 4.23793 3.35 4.23497 3.35 4.23202C3.35 4.22907 3.35 4.22613 3.35 4.22319C3.35 4.22026 3.35 4.21732 3.35 4.2144C3.35 4.21147 3.35 4.20855 3.35 4.20564C3.35 4.20272 3.35 4.19981 3.35 4.19691C3.35 4.194 3.35 4.1911 3.35 4.18821C3.35 4.18532 3.35 4.18243 3.35 4.17955C3.35 4.17666 3.35 4.17379 3.35 4.17091C3.35 4.16804 3.35 4.16518 3.35 4.16232C3.35 4.15946 3.35 4.1566 3.35 4.15375C3.35 4.1509 3.35 4.14806 3.35 4.14522C3.35 4.14238 3.35 4.13955 3.35 4.13672C3.35 4.13389 3.35 4.13107 3.35 4.12825C3.35 4.12543 3.35 4.12262 3.35 4.11982C3.35 4.11701 3.35 4.11421 3.35 4.11141C3.35 4.10862 3.35 4.10583 3.35 4.10304C3.35 4.10026 3.35 4.09748 3.35 4.0947C3.35 4.09193 3.35 4.08916 3.35 4.0864C3.35 4.08363 3.35 4.08087 3.35 4.07812C3.35 4.07537 3.35 4.07262 3.35 4.06988C3.35 4.06714 3.35 4.0644 3.35 4.06167C3.35 4.05893 3.35 4.05621 3.35 4.05349C3.35 4.05076 3.35 4.04805 3.35 4.04534C3.35 4.04263 3.35 4.03992 3.35 4.03722C3.35 4.03452 3.35 4.03183 3.35 4.02914C3.35 4.02645 3.35 4.02376 3.35 4.02108C3.35 4.0184 3.35 4.01573 3.35 4.01306C3.35 4.01039 3.35 4.00772 3.35 4.00507C3.35 4.00241 3.35 3.99975 3.35 3.9971C3.35 3.99446 3.35 3.99181 3.35 3.98917C3.35 3.98654 3.35 3.9839 3.35 3.98128C3.35 3.97865 3.35 3.97602 3.35 3.97341C3.35 3.97079 3.35 3.96818 3.35 3.96557C3.35 3.96296 3.35 3.96036 3.35 3.95776C3.35 3.95516 3.35 3.95257 3.35 3.94998C3.35 3.9474 3.35 3.94481 3.35 3.94224C3.35 3.93966 3.35 3.93709 3.35 3.93452C3.35 3.93195 3.35 3.92939 3.35 3.92684C3.35 3.92428 3.35 3.92173 3.35 3.91918C3.35 3.91663 3.35 3.91409 3.35 3.91155C3.35 3.90902 3.35 3.90648 3.35 3.90396C3.35 3.90143 3.35 3.89891 3.35 3.89639C3.35 3.89387 3.35 3.89136 3.35 3.88885C3.35 3.88635 3.35 3.88385 3.35 3.88135C3.35 3.87885 3.35 3.87636 3.35 3.87387C3.35 3.87138 3.35 3.8689 3.35 3.86642C3.35 3.86394 3.35 3.86147 3.35 3.859C3.35 3.85654 3.35 3.85407 3.35 3.85161C3.35 3.84916 3.35 3.8467 3.35 3.84426C3.35 3.84181 3.35 3.83936 3.35 3.83692C3.35 3.83449 3.35 3.83205 3.35 3.82962C3.35 3.82719 3.35 3.82477 3.35 3.82235C3.35 3.81993 3.35 3.81752 3.35 3.81511C3.35 3.8127 3.35 3.81029 3.35 3.80789C3.35 3.80549 3.35 3.80309 3.35 3.8007C3.35 3.79831 3.35 3.79593 3.35 3.79355C3.35 3.79116 3.35 3.78879 3.35 3.78642C3.35 3.78404 3.35 3.78168 3.35 3.77932C3.35 3.77695 3.35 3.7746 3.35 3.77224C3.35 3.76989 3.35 3.76754 3.35 3.7652C3.35 3.76285 3.35 3.76052 3.35 3.75818C3.35 3.75585 3.35 3.75352 3.35 3.75119C3.35 3.74887 3.35 3.74655 3.35 3.74423C3.35 3.74192 3.35 3.73961 3.35 3.7373C3.35 3.73499 3.35 3.73269 3.35 3.7304C3.35 3.7281 3.35 3.72581 3.35 3.72352C3.35 3.72123 3.35 3.71895 3.35 3.71667C3.35 3.71439 3.35 3.71212 3.35 3.70985C3.35 3.70758 3.35 3.70531 3.35 3.70305C3.35 3.70079 3.35 3.69854 3.35 3.69628C3.35 3.69403 3.35 3.69179 3.35 3.68954C3.35 3.6873 3.35 3.68506 3.35 3.68283C3.35 3.6806 3.35 3.67837 3.35 3.67615C3.35 3.67392 3.35 3.6717 3.35 3.66949C3.35 3.66727 3.35 3.66506 3.35 3.66286C3.35 3.66065 3.35 3.65845 3.35 3.65625C3.35 3.65405 3.35 3.65186 3.35 3.64967C3.35 3.64748 3.35 3.6453 3.35 3.64312C3.35 3.64094 3.35 3.63877 3.35 3.63659C3.35 3.63442 3.35 3.63226 3.35 3.6301C3.35 3.62793 3.35 3.62578 3.35 3.62362C3.35 3.62147 3.35 3.61932 3.35 3.61718C3.35 3.61503 3.35 3.61289 3.35 3.61076C3.35 3.60862 3.35 3.60649 3.35 3.60436C3.35 3.60224 3.35 3.60011 3.35 3.59799C3.35 3.59588 3.35 3.59376 3.35 3.59165C3.35 3.58954 3.35 3.58744 3.35 3.58534C3.35 3.58323 3.35 3.58114 3.35 3.57905C3.35 3.57695 3.35 3.57486 3.35 3.57278C3.35 3.5707 3.35 3.56862 3.35 3.56654C3.35 3.56447 3.35 3.56239 3.35 3.56033C3.35 3.55826 3.35 3.5562 3.35 3.55414C3.35 3.55208 3.35 3.55003 3.35 3.54797C3.35 3.54592 3.35 3.54388 3.35 3.54184C3.35 3.53979 3.35 3.53776 3.35 3.53572C3.35 3.53369 3.35 3.53166 3.35 3.52964C3.35 3.52761 3.35 3.52559 3.35 3.52357C3.35 3.52156 3.35 3.51954 3.35 3.51753C3.35 3.51553 3.35 3.51352 3.35 3.51152C3.35 3.50952 3.35 3.50752 3.35 3.50553C3.35 3.50354 3.35 3.50155 3.35 3.49957C3.35 3.49758 3.35 3.4956 3.35 3.49363C3.35 3.49165 3.35 3.48968 3.35 3.48771C3.35 3.48574 3.35 3.48378 3.35 3.48182C3.35 3.47986 3.35 3.4779 3.35 3.47595C3.35 3.474 3.35 3.47205 3.35 3.47011C3.35 3.46817 3.35 3.46623 3.35 3.46429C3.35 3.46236 3.35 3.46042 3.35 3.4585C3.35 3.45657 3.35 3.45464 3.35 3.45272C3.35 3.45081 3.35 3.44889 3.35 3.44698C3.35 3.44507 3.35 3.44316 3.35 3.44125C3.35 3.43935 3.35 3.43745 3.35 3.43555C3.35 3.43366 3.35 3.43177 3.35 3.42988C3.35 3.42799 3.35 3.4261 3.35 3.42422C3.35 3.42234 3.35 3.42047 3.35 3.41859C3.35 3.41672 3.35 3.41485 3.35 3.41299C3.35 3.41112 3.35 3.40926 3.35 3.4074C3.35 3.40555 3.35 3.40369 3.35 3.40184C3.35 3.39999 3.35 3.39815 3.35 3.3963C3.35 3.39446 3.35 3.39262 3.35 3.39079C3.35 3.38896 3.35 3.38712 3.35 3.3853C3.35 3.38347 3.35 3.38165 3.35 3.37983C3.35 3.37801 3.35 3.37619 3.35 3.37438C3.35 3.37257 3.35 3.37076 3.35 3.36896C3.35 3.36715 3.35 3.36535 3.35 3.36356C3.35 3.36176 3.35 3.35997 3.35 3.35818C3.35 3.35639 3.35 3.3546 3.35 3.35282C3.35 3.35104 3.35 3.34926 3.35 3.34748C3.35 3.34571 3.35 3.34394 3.35 3.34217C3.35 3.3404 3.35 3.33864 3.35 3.33688C3.35 3.33512 3.35 3.33336 3.35 3.33161C3.35 3.32986 3.35 3.32811 3.35 3.32636C3.35 3.32462 3.35 3.32288 3.35 3.32114C3.35 3.3194 3.35 3.31766 3.35 3.31593C3.35 3.3142 3.35 3.31247 3.35 3.31075C3.35 3.30903 3.35 3.30731 3.35 3.30559C3.35 3.30387 3.35 3.30216 3.35 3.30045C3.35 3.29874 3.35 3.29703 3.35 3.29533C3.35 3.29363 3.35 3.29193 3.35 3.29023C3.35 3.28854 3.35 3.28684 3.35 3.28516C3.35 3.28347 3.35 3.28178 3.35 3.2801C3.35 3.27842 3.35 3.27674 3.35 3.27507C3.35 3.27339 3.35 3.27172 3.35 3.27005C3.35 3.26838 3.35 3.26672 3.35 3.26506C3.35 3.2634 3.35 3.26174 3.35 3.26009C3.35 3.25843 3.35 3.25678 3.35 3.25514C3.35 3.25349 3.35 3.25184 3.35 3.2502C3.35 3.24856 3.35 3.24693 3.35 3.24529C3.35 3.24366 3.35 3.24203 3.35 3.2404C3.35 3.23877 3.35 3.23715 3.35 3.23553C3.35 3.23391 3.35 3.23229 3.35 3.23068C3.35 3.22907 3.35 3.22746 3.35 3.22585C3.35 3.22424 3.35 3.22264 3.35 3.22104C3.35 3.21944 3.35 3.21784 3.35 3.21625C3.35 3.21465 3.35 3.21306 3.35 3.21148C3.35 3.20989 3.35 3.20831 3.35 3.20673C3.35 3.20515 3.35 3.20357 3.35 3.20199C3.35 3.20042 3.35 3.19885 3.35 3.19728C3.35 3.19571 3.35 3.19415 3.35 3.19259C3.35 3.19103 3.35 3.18947 3.35 3.18791C3.35 3.18636 3.35 3.18481 3.35 3.18326C3.35 3.18171 3.35 3.18017 3.35 3.17862C3.35 3.17708 3.35 3.17554 3.35 3.17401C3.35 3.17247 3.35 3.17094 3.35 3.16941C3.35 3.16788 3.35 3.16636 3.35 3.16483C3.35 3.16331 3.35 3.16179 3.35 3.16027C3.35 3.15876 3.35 3.15724 3.35 3.15573C3.35 3.15422 3.35 3.15271 3.35 3.15121C3.35 3.1497 3.35 3.1482 3.35 3.1467C3.35 3.14521 3.35 3.14371 3.35 3.14222C3.35 3.14073 3.35 3.13924 3.35 3.13775C3.35 3.13626 3.35 3.13478 3.35 3.1333C3.35 3.13182 3.35 3.13034 3.35 3.12887C3.35 3.1274 3.35 3.12592 3.35 3.12446C3.35 3.12299 3.35 3.12152 3.35 3.12006C3.35 3.1186 3.35 3.11714 3.35 3.11568C3.35 3.11423 3.35 3.11277 3.35 3.11132C3.35 3.10987 3.35 3.10843 3.35 3.10698C3.35 3.10554 3.35 3.1041 3.35 3.10266C3.35 3.10122 3.35 3.09978 3.35 3.09835C3.35 3.09692 3.35 3.09549 3.35 3.09406C3.35 3.09263 3.35 3.09121 3.35 3.08979C3.35 3.08837 3.35 3.08695 3.35 3.08553C3.35 3.08412 3.35 3.08271 3.35 3.0813C3.35 3.07989 3.35 3.07848 3.35 3.07708C3.35 3.07567 3.35 3.07427 3.35 3.07287C3.35 3.07147 3.35 3.07008 3.35 3.06868C3.35 3.06729 3.35 3.0659 3.35 3.06451C3.35 3.06313 3.35 3.06174 3.35 3.06036C3.35 3.05898 3.35 3.0576 3.35 3.05622C3.35 3.05485 3.35 3.05347 3.35 3.0521C3.35 3.05073 3.35 3.04936 3.35 3.048C3.35 3.04663 3.35 3.04527 3.35 3.04391C3.35 3.04255 3.35 3.04119 3.35 3.03984C3.35 3.03849 3.35 3.03713 3.35 3.03579C3.35 3.03444 3.35 3.03309 3.35 3.03175C3.35 3.0304 3.35 3.02906 3.35 3.02772C3.35 3.02638 3.35 3.02505 3.35 3.02372C3.35 3.02238 3.35 3.02105 3.35 3.01972C3.35 3.0184 3.35 3.01707 3.35 3.01575C3.35 3.01443 3.35 3.01311 3.35 3.01179C3.35 3.01047 3.35 3.00916 3.35 3.00784C3.35 3.00653 3.35 3.00522 3.35 3.00391C3.35 3.00261 3.35 3.0013 3.35 3H4.65C4.65 3.0013 4.65 3.00261 4.65 3.00391C4.65 3.00522 4.65 3.00653 4.65 3.00784C4.65 3.00916 4.65 3.01047 4.65 3.01179C4.65 3.01311 4.65 3.01443 4.65 3.01575C4.65 3.01707 4.65 3.0184 4.65 3.01972C4.65 3.02105 4.65 3.02238 4.65 3.02372C4.65 3.02505 4.65 3.02638 4.65 3.02772C4.65 3.02906 4.65 3.0304 4.65 3.03175C4.65 3.03309 4.65 3.03444 4.65 3.03579C4.65 3.03713 4.65 3.03849 4.65 3.03984C4.65 3.04119 4.65 3.04255 4.65 3.04391C4.65 3.04527 4.65 3.04663 4.65 3.048C4.65 3.04936 4.65 3.05073 4.65 3.0521C4.65 3.05347 4.65 3.05485 4.65 3.05622C4.65 3.0576 4.65 3.05898 4.65 3.06036C4.65 3.06174 4.65 3.06313 4.65 3.06451C4.65 3.0659 4.65 3.06729 4.65 3.06868C4.65 3.07008 4.65 3.07147 4.65 3.07287C4.65 3.07427 4.65 3.07567 4.65 3.07708C4.65 3.07848 4.65 3.07989 4.65 3.0813C4.65 3.08271 4.65 3.08412 4.65 3.08553C4.65 3.08695 4.65 3.08837 4.65 3.08979C4.65 3.09121 4.65 3.09263 4.65 3.09406C4.65 3.09549 4.65 3.09692 4.65 3.09835C4.65 3.09978 4.65 3.10122 4.65 3.10266C4.65 3.1041 4.65 3.10554 4.65 3.10698C4.65 3.10843 4.65 3.10987 4.65 3.11132C4.65 3.11277 4.65 3.11423 4.65 3.11568C4.65 3.11714 4.65 3.1186 4.65 3.12006C4.65 3.12152 4.65 3.12299 4.65 3.12446C4.65 3.12592 4.65 3.1274 4.65 3.12887C4.65 3.13034 4.65 3.13182 4.65 3.1333C4.65 3.13478 4.65 3.13626 4.65 3.13775C4.65 3.13924 4.65 3.14073 4.65 3.14222C4.65 3.14371 4.65 3.14521 4.65 3.1467C4.65 3.1482 4.65 3.1497 4.65 3.15121C4.65 3.15271 4.65 3.15422 4.65 3.15573C4.65 3.15724 4.65 3.15876 4.65 3.16027C4.65 3.16179 4.65 3.16331 4.65 3.16483C4.65 3.16636 4.65 3.16788 4.65 3.16941C4.65 3.17094 4.65 3.17247 4.65 3.17401C4.65 3.17554 4.65 3.17708 4.65 3.17862C4.65 3.18017 4.65 3.18171 4.65 3.18326C4.65 3.18481 4.65 3.18636 4.65 3.18791C4.65 3.18947 4.65 3.19103 4.65 3.19259C4.65 3.19415 4.65 3.19571 4.65 3.19728C4.65 3.19885 4.65 3.20042 4.65 3.20199C4.65 3.20357 4.65 3.20515 4.65 3.20673C4.65 3.20831 4.65 3.20989 4.65 3.21148C4.65 3.21306 4.65 3.21465 4.65 3.21625C4.65 3.21784 4.65 3.21944 4.65 3.22104C4.65 3.22264 4.65 3.22424 4.65 3.22585C4.65 3.22746 4.65 3.22907 4.65 3.23068C4.65 3.23229 4.65 3.23391 4.65 3.23553C4.65 3.23715 4.65 3.23877 4.65 3.2404C4.65 3.24203 4.65 3.24366 4.65 3.24529C4.65 3.24693 4.65 3.24856 4.65 3.2502C4.65 3.25184 4.65 3.25349 4.65 3.25514C4.65 3.25678 4.65 3.25843 4.65 3.26009C4.65 3.26174 4.65 3.2634 4.65 3.26506C4.65 3.26672 4.65 3.26838 4.65 3.27005C4.65 3.27172 4.65 3.27339 4.65 3.27507C4.65 3.27674 4.65 3.27842 4.65 3.2801C4.65 3.28178 4.65 3.28347 4.65 3.28516C4.65 3.28684 4.65 3.28854 4.65 3.29023C4.65 3.29193 4.65 3.29363 4.65 3.29533C4.65 3.29703 4.65 3.29874 4.65 3.30045C4.65 3.30216 4.65 3.30387 4.65 3.30559C4.65 3.30731 4.65 3.30903 4.65 3.31075C4.65 3.31247 4.65 3.3142 4.65 3.31593C4.65 3.31766 4.65 3.3194 4.65 3.32114C4.65 3.32288 4.65 3.32462 4.65 3.32636C4.65 3.32811 4.65 3.32986 4.65 3.33161C4.65 3.33336 4.65 3.33512 4.65 3.33688C4.65 3.33864 4.65 3.3404 4.65 3.34217C4.65 3.34394 4.65 3.34571 4.65 3.34748C4.65 3.34926 4.65 3.35104 4.65 3.35282C4.65 3.3546 4.65 3.35639 4.65 3.35818C4.65 3.35997 4.65 3.36176 4.65 3.36356C4.65 3.36535 4.65 3.36715 4.65 3.36896C4.65 3.37076 4.65 3.37257 4.65 3.37438C4.65 3.37619 4.65 3.37801 4.65 3.37983C4.65 3.38165 4.65 3.38347 4.65 3.3853C4.65 3.38712 4.65 3.38896 4.65 3.39079C4.65 3.39262 4.65 3.39446 4.65 3.3963C4.65 3.39815 4.65 3.39999 4.65 3.40184C4.65 3.40369 4.65 3.40555 4.65 3.4074C4.65 3.40926 4.65 3.41112 4.65 3.41299C4.65 3.41485 4.65 3.41672 4.65 3.41859C4.65 3.42047 4.65 3.42234 4.65 3.42422C4.65 3.4261 4.65 3.42799 4.65 3.42988C4.65 3.43177 4.65 3.43366 4.65 3.43555C4.65 3.43745 4.65 3.43935 4.65 3.44125C4.65 3.44316 4.65 3.44507 4.65 3.44698C4.65 3.44889 4.65 3.45081 4.65 3.45272C4.65 3.45464 4.65 3.45657 4.65 3.4585C4.65 3.46042 4.65 3.46236 4.65 3.46429C4.65 3.46623 4.65 3.46817 4.65 3.47011C4.65 3.47205 4.65 3.474 4.65 3.47595C4.65 3.4779 4.65 3.47986 4.65 3.48182C4.65 3.48378 4.65 3.48574 4.65 3.48771C4.65 3.48968 4.65 3.49165 4.65 3.49363C4.65 3.4956 4.65 3.49758 4.65 3.49957C4.65 3.50155 4.65 3.50354 4.65 3.50553C4.65 3.50752 4.65 3.50952 4.65 3.51152C4.65 3.51352 4.65 3.51553 4.65 3.51753C4.65 3.51954 4.65 3.52156 4.65 3.52357C4.65 3.52559 4.65 3.52761 4.65 3.52964C4.65 3.53166 4.65 3.53369 4.65 3.53572C4.65 3.53776 4.65 3.53979 4.65 3.54184C4.65 3.54388 4.65 3.54592 4.65 3.54797C4.65 3.55003 4.65 3.55208 4.65 3.55414C4.65 3.5562 4.65 3.55826 4.65 3.56033C4.65 3.56239 4.65 3.56447 4.65 3.56654C4.65 3.56862 4.65 3.5707 4.65 3.57278C4.65 3.57486 4.65 3.57695 4.65 3.57905C4.65 3.58114 4.65 3.58323 4.65 3.58534C4.65 3.58744 4.65 3.58954 4.65 3.59165C4.65 3.59376 4.65 3.59588 4.65 3.59799C4.65 3.60011 4.65 3.60224 4.65 3.60436C4.65 3.60649 4.65 3.60862 4.65 3.61076C4.65 3.61289 4.65 3.61503 4.65 3.61718C4.65 3.61932 4.65 3.62147 4.65 3.62362C4.65 3.62578 4.65 3.62793 4.65 3.6301C4.65 3.63226 4.65 3.63442 4.65 3.63659C4.65 3.63877 4.65 3.64094 4.65 3.64312C4.65 3.6453 4.65 3.64748 4.65 3.64967C4.65 3.65186 4.65 3.65405 4.65 3.65625C4.65 3.65845 4.65 3.66065 4.65 3.66286C4.65 3.66506 4.65 3.66727 4.65 3.66949C4.65 3.6717 4.65 3.67392 4.65 3.67615C4.65 3.67837 4.65 3.6806 4.65 3.68283C4.65 3.68506 4.65 3.6873 4.65 3.68954C4.65 3.69179 4.65 3.69403 4.65 3.69628C4.65 3.69854 4.65 3.70079 4.65 3.70305C4.65 3.70531 4.65 3.70758 4.65 3.70985C4.65 3.71212 4.65 3.71439 4.65 3.71667C4.65 3.71895 4.65 3.72123 4.65 3.72352C4.65 3.72581 4.65 3.7281 4.65 3.7304C4.65 3.73269 4.65 3.73499 4.65 3.7373C4.65 3.73961 4.65 3.74192 4.65 3.74423C4.65 3.74655 4.65 3.74887 4.65 3.75119C4.65 3.75352 4.65 3.75585 4.65 3.75818C4.65 3.76052 4.65 3.76285 4.65 3.7652C4.65 3.76754 4.65 3.76989 4.65 3.77224C4.65 3.7746 4.65 3.77695 4.65 3.77932C4.65 3.78168 4.65 3.78404 4.65 3.78642C4.65 3.78879 4.65 3.79116 4.65 3.79355C4.65 3.79593 4.65 3.79831 4.65 3.8007C4.65 3.80309 4.65 3.80549 4.65 3.80789C4.65 3.81029 4.65 3.8127 4.65 3.81511C4.65 3.81752 4.65 3.81993 4.65 3.82235C4.65 3.82477 4.65 3.82719 4.65 3.82962C4.65 3.83205 4.65 3.83449 4.65 3.83692C4.65 3.83936 4.65 3.84181 4.65 3.84426C4.65 3.8467 4.65 3.84916 4.65 3.85161C4.65 3.85407 4.65 3.85654 4.65 3.859C4.65 3.86147 4.65 3.86394 4.65 3.86642C4.65 3.8689 4.65 3.87138 4.65 3.87387C4.65 3.87636 4.65 3.87885 4.65 3.88135C4.65 3.88385 4.65 3.88635 4.65 3.88885C4.65 3.89136 4.65 3.89387 4.65 3.89639C4.65 3.89891 4.65 3.90143 4.65 3.90396C4.65 3.90648 4.65 3.90902 4.65 3.91155C4.65 3.91409 4.65 3.91663 4.65 3.91918C4.65 3.92173 4.65 3.92428 4.65 3.92684C4.65 3.92939 4.65 3.93195 4.65 3.93452C4.65 3.93709 4.65 3.93966 4.65 3.94224C4.65 3.94481 4.65 3.9474 4.65 3.94998C4.65 3.95257 4.65 3.95516 4.65 3.95776C4.65 3.96036 4.65 3.96296 4.65 3.96557C4.65 3.96818 4.65 3.97079 4.65 3.97341C4.65 3.97602 4.65 3.97865 4.65 3.98128C4.65 3.9839 4.65 3.98654 4.65 3.98917C4.65 3.99181 4.65 3.99446 4.65 3.9971C4.65 3.99975 4.65 4.00241 4.65 4.00507C4.65 4.00772 4.65 4.01039 4.65 4.01306C4.65 4.01573 4.65 4.0184 4.65 4.02108C4.65 4.02376 4.65 4.02645 4.65 4.02914C4.65 4.03183 4.65 4.03452 4.65 4.03722C4.65 4.03992 4.65 4.04263 4.65 4.04534C4.65 4.04805 4.65 4.05076 4.65 4.05349C4.65 4.05621 4.65 4.05893 4.65 4.06167C4.65 4.0644 4.65 4.06714 4.65 4.06988C4.65 4.07262 4.65 4.07537 4.65 4.07812C4.65 4.08087 4.65 4.08363 4.65 4.0864C4.65 4.08916 4.65 4.09193 4.65 4.0947C4.65 4.09748 4.65 4.10026 4.65 4.10304C4.65 4.10583 4.65 4.10862 4.65 4.11141C4.65 4.11421 4.65 4.11701 4.65 4.11982C4.65 4.12262 4.65 4.12543 4.65 4.12825C4.65 4.13107 4.65 4.13389 4.65 4.13672C4.65 4.13955 4.65 4.14238 4.65 4.14522C4.65 4.14806 4.65 4.1509 4.65 4.15375C4.65 4.1566 4.65 4.15946 4.65 4.16232C4.65 4.16518 4.65 4.16804 4.65 4.17091C4.65 4.17379 4.65 4.17666 4.65 4.17955C4.65 4.18243 4.65 4.18532 4.65 4.18821C4.65 4.1911 4.65 4.194 4.65 4.19691C4.65 4.19981 4.65 4.20272 4.65 4.20564C4.65 4.20855 4.65 4.21147 4.65 4.2144C4.65 4.21732 4.65 4.22026 4.65 4.22319C4.65 4.22613 4.65 4.22907 4.65 4.23202C4.65 4.23497 4.65 4.23793 4.65 4.24089C4.65 4.24385 4.65 4.24681 4.65 4.24978C4.65 4.25275 4.65 4.25573 4.65 4.25871C4.65 4.26169 4.65 4.26468 4.65 4.26768C4.65 4.27067 4.65 4.27367 4.65 4.27667C4.65 4.27968 4.65 4.28269 4.65 4.2857C4.65 4.28872 4.65 4.29174 4.65 4.29477C4.65 4.2978 4.65 4.30083 4.65 4.30387C4.65 4.30691 4.65 4.30995 4.65 4.313C4.65 4.31605 4.65 4.31911 4.65 4.32217C4.65 4.32523 4.65 4.3283 4.65 4.33137C4.65 4.33444 4.65 4.33752 4.65 4.34061C4.65 4.34369 4.65 4.34678 4.65 4.34988C4.65 4.35297 4.65 4.35607 4.65 4.35918C4.65 4.36229 4.65 4.3654 4.65 4.36852C4.65 4.37164 4.65 4.37477 4.65 4.3779C4.65 4.38103 4.65 4.38416 4.65 4.38731C4.65 4.39045 4.65 4.3936 4.65 4.39675C4.65 4.3999 4.65 4.40306 4.65 4.40623C4.65 4.40939 4.65 4.41257 4.65 4.41574C4.65 4.41892 4.65 4.4221 4.65 4.42529C4.65 4.42848 4.65 4.43168 4.65 4.43488C4.65 4.43808 4.65 4.44129 4.65 4.4445C4.65 4.44771 4.65 4.45093 4.65 4.45415C4.65 4.45738 4.65 4.46061 4.65 4.46385C4.65 4.46708 4.65 4.47032 4.65 4.47357C4.65 4.47682 4.65 4.48007 4.65 4.48333C4.65 4.4866 4.65 4.48986 4.65 4.49313C4.65 4.49641 4.65 4.49968 4.65 4.50297C4.65 4.50625 4.65 4.50954 4.65 4.51284C4.65 4.51613 4.65 4.51944 4.65 4.52274C4.65 4.52605 4.65 4.52937 4.65 4.53269C4.65 4.53601 4.65 4.53933 4.65 4.54267C4.65 4.546 4.65 4.54934 4.65 4.55268C4.65 4.55603 4.65 4.55938 4.65 4.56273C4.65 4.56609 4.65 4.56945 4.65 4.57282C4.65 4.57619 4.65 4.57957 4.65 4.58295C4.65 4.58633 4.65 4.58972 4.65 4.59311C4.65 4.5965 4.65 4.5999 4.65 4.60331C4.65 4.60671 4.65 4.61012 4.65 4.61354C4.65 4.61696 4.65 4.62038 4.65 4.62381C4.65 4.62724 4.65 4.63068 4.65 4.63412C4.65 4.63757 4.65 4.64102 4.65 4.64447C4.65 4.64793 4.65 4.65139 4.65 4.65485C4.65 4.65832 4.65 4.6618 4.65 4.66528C4.65 4.66876 4.65 4.67224 4.65 4.67573C4.65 4.67923 4.65 4.68273 4.65 4.68623C4.65 4.68974 4.65 4.69325 4.65 4.69676C4.65 4.70028 4.65 4.70381 4.65 4.70734C4.65 4.71087 4.65 4.7144 4.65 4.71794C4.65 4.72149 4.65 4.72504 4.65 4.72859C4.65 4.73215 4.65 4.73571 4.65 4.73928C4.65 4.74284 4.65 4.74642 4.65 4.75C4.65 4.75358 4.65 4.75717 4.65 4.76076C4.65 4.76435 4.65 4.76795 4.65 4.77156C4.65 4.77517 4.65 4.77878 4.65 4.7824C4.65 4.78602 4.65 4.78964 4.65 4.79327C4.65 4.79691 4.65 4.80054 4.65 4.80419C4.65 4.80783 4.65 4.81149 4.65 4.81514C4.65 4.8188 4.65 4.82246 4.65 4.82614C4.65 4.82981 4.65 4.83348 4.65 4.83717C4.65 4.84085 4.65 4.84454 4.65 4.84824C4.65 4.85193 4.65 4.85563 4.65 4.85934C4.65 4.86305 4.65 4.86677 4.65 4.87049C4.65 4.87421 4.65 4.87794 4.65 4.88168C4.65 4.88541 4.65 4.88916 4.65 4.8929C4.65 4.89665 4.65 4.90041 4.65 4.90417C4.65 4.90793 4.65 4.9117 4.65 4.91547C4.65 4.91925 4.65 4.92303 4.65 4.92682C4.65 4.93061 4.65 4.9344 4.65 4.9382C4.65 4.942 4.65 4.94581 4.65 4.94963C4.65 4.95344 4.65 4.95726 4.65 4.96109C4.65 4.96492 4.65 4.96875 4.65 4.97259C4.65 4.97643 4.65 4.98028 4.65 4.98414C4.65 4.98799 4.65 4.99185 4.65 4.99572C4.65 4.99959 4.65 5.00346 4.65 5.00734C4.65 5.01122 4.65 5.01511 4.65 5.019C4.65 5.0229 4.65 5.0268 4.65 5.03071C4.65 5.03462 4.65 5.03853 4.65 5.04245C4.65 5.04637 4.65 5.0503 4.65 5.05424C4.65 5.05817 4.65 5.06211 4.65 5.06606C4.65 5.07001 4.65 5.07397 4.65 5.07793C4.65 5.08189 4.65 5.08586 4.65 5.08983C4.65 5.09381 4.65 5.09779 4.65 5.10178C4.65 5.10577 4.65 5.10977 4.65 5.11377C4.65 5.11777 4.65 5.12178 4.65 5.1258C4.65 5.12982 4.65 5.13384 4.65 5.13787C4.65 5.1419 4.65 5.14594 4.65 5.14998C4.65 5.15402 4.65 5.15808 4.65 5.16213C4.65 5.16619 4.65 5.17026 4.65 5.17433C4.65 5.1784 4.65 5.18248 4.65 5.18656C4.65 5.19065 4.65 5.19474 4.65 5.19884C4.65 5.20294 4.65 5.20705 4.65 5.21116C4.65 5.21527 4.65 5.21939 4.65 5.22352C4.65 5.22765 4.65 5.23178 4.65 5.23592C4.65 5.24006 4.65 5.24421 4.65 5.24837C4.65 5.25252 4.65 5.25668 4.65 5.26085C4.65 5.26502 4.65 5.2692 4.65 5.27338C4.65 5.27756 4.65 5.28175 4.65 5.28595C4.65 5.29015 4.65 5.29435 4.65 5.29856C4.65 5.30277 4.65 5.30699 4.65 5.31122C4.65 5.31544 4.65 5.31968 4.65 5.32392C4.65 5.32816 4.65 5.3324 4.65 5.33666C4.65 5.34091 4.65 5.34517 4.65 5.34944C4.65 5.35371 4.65 5.35798 4.65 5.36226C4.65 5.36655 4.65 5.37084 4.65 5.37513C4.65 5.37943 4.65 5.38373 4.65 5.38804C4.65 5.39235 4.65 5.39667 4.65 5.401C4.65 5.40532 4.65 5.40965 4.65 5.41399C4.65 5.41833 4.65 5.42268 4.65 5.42703C4.65 5.43139 4.65 5.43575 4.65 5.44012C4.65 5.44449 4.65 5.44886 4.65 5.45324C4.65 5.45763 4.65 5.46202 4.65 5.46641C4.65 5.47081 4.65 5.47522 4.65 5.47963C4.65 5.48404 4.65 5.48846 4.65 5.49289C4.65 5.49731 4.65 5.50175 4.65 5.50619C4.65 5.51063 4.65 5.51508 4.65 5.51953C4.65 5.52399 4.65 5.52845 4.65 5.53292C4.65 5.53739 4.65 5.54187 4.65 5.54635C4.65 5.55084 4.65 5.55533 4.65 5.55983C4.65 5.56433 4.65 5.56884 4.65 5.57335C4.65 5.57786 4.65 5.58239 4.65 5.58692C4.65 5.59144 4.65 5.59598 4.65 5.60052C4.65 5.60507 4.65 5.60962 4.65 5.61418C4.65 5.61874 4.65 5.6233 4.65 5.62788C4.65 5.63245 4.65 5.63703 4.65 5.64162C4.65 5.64621 4.65 5.6508 4.65 5.65541C4.65 5.66001 4.65 5.66462 4.65 5.66924C4.65 5.67386 4.65 5.67848 4.65 5.68312C4.65 5.68775 4.65 5.69239 4.65 5.69704C4.65 5.70169 4.65 5.70634 4.65 5.71101C4.65 5.71567 4.65 5.72034 4.65 5.72502C4.65 5.7297 4.65 5.73438 4.65 5.73907C4.65 5.74377 4.65 5.74847 4.65 5.75318C4.65 5.75789 4.65 5.7626 4.65 5.76733C4.65 5.77205 4.65 5.77678 4.65 5.78152C4.65 5.78626 4.65 5.791 4.65 5.79576C4.65 5.80051 4.65 5.80527 4.65 5.81004C4.65 5.81481 4.65 5.81959 4.65 5.82437C4.65 5.82916 4.65 5.83395 4.65 5.83875C4.65 5.84355 4.65 5.84836 4.65 5.85317C4.65 5.85799 4.65 5.86281 4.65 5.86764C4.65 5.87247 4.65 5.87731 4.65 5.88216C4.65 5.887 4.65 5.89185 4.65 5.89672C4.65 5.90158 4.65 5.90645 4.65 5.91132C4.65 5.9162 4.65 5.92108 4.65 5.92598C4.65 5.93087 4.65 5.93577 4.65 5.94068C4.65 5.94558 4.65 5.9505 4.65 5.95542C4.65 5.96035 4.65 5.96528 4.65 5.97021C4.65 5.97515 4.65 5.9801 4.65 5.98505C4.65 5.99001 4.65 5.99497 4.65 5.99994C4.65 6.00491 4.65 6.00989 4.65 6.01487C4.65 6.01986 4.65 6.02485 4.65 6.02985C4.65 6.03486 4.65 6.03987 4.65 6.04488C4.65 6.0499 4.65 6.05492 4.65 6.05996C4.65 6.06499 4.65 6.07003 4.65 6.07508C4.65 6.08013 4.65 6.08518 4.65 6.09025C4.65 6.09531 4.65 6.10038 4.65 6.10546C4.65 6.11054 4.65 6.11563 4.65 6.12073C4.65 6.12583 4.65 6.13093 4.65 6.13604C4.65 6.14115 4.65 6.14627 4.65 6.1514C4.65 6.15653 4.65 6.16166 4.65 6.16681C4.65 6.17195 4.65 6.1771 4.65 6.18226C4.65 6.18742 4.65 6.19259 4.65 6.19777C4.65 6.20294 4.65 6.20813 4.65 6.21332C4.65 6.21851 4.65 6.22371 4.65 6.22892C4.65 6.23413 4.65 6.23934 4.65 6.24457C4.65 6.24979 4.65 6.25502 4.65 6.26026C4.65 6.2655 4.65 6.27075 4.65 6.27601C4.65 6.28126 4.65 6.28653 4.65 6.2918C4.65 6.29707 4.65 6.30235 4.65 6.30764C4.65 6.31293 4.65 6.31823 4.65 6.32353C4.65 6.32884 4.65 6.33415 4.65 6.33947C4.65 6.34479 4.65 6.35012 4.65 6.35546C4.65 6.3608 4.65 6.36614 4.65 6.3715C4.65 6.37685 4.65 6.38221 4.65 6.38758C4.65 6.39295 4.65 6.39833 4.65 6.40372C4.65 6.4091 4.65 6.4145 4.65 6.4199C4.65 6.4253 4.65 6.43071 4.65 6.43613C4.65 6.44155 4.65 6.44698 4.65 6.45242C4.65 6.45785 4.65 6.4633 4.65 6.46875C4.65 6.4742 4.65 6.47966 4.65 6.48513C4.65 6.4906 4.65 6.49608 4.65 6.50156C4.65 6.50705 4.65 6.51254 4.65 6.51805C4.65 6.52355 4.65 6.52906 4.65 6.53458C4.65 6.5401 4.65 6.54562 4.65 6.55116C4.65 6.55669 4.65 6.56224 4.65 6.56779C4.65 6.57334 4.65 6.5789 4.65 6.58447C4.65 6.59004 4.65 6.59562 4.65 6.6012C4.65 6.60679 4.65 6.61238 4.65 6.61799C4.65 6.62359 4.65 6.6292 4.65 6.63482C4.65 6.64044 4.65 6.64607 4.65 6.6517C4.65 6.65734 4.65 6.66298 4.65 6.66864C4.65 6.67429 4.65 6.67995 4.65 6.68562C4.65 6.69129 4.65 6.69697 4.65 6.70265C4.65 6.70834 4.65 6.71404 4.65 6.71974C4.65 6.72544 4.65 6.73116 4.65 6.73688C4.65 6.7426 4.65 6.74833 4.65 6.75407C4.65 6.7598 4.65 6.76555 4.65 6.7713C4.65 6.77706 4.65 6.78282 4.65 6.78859C4.65 6.79437 4.65 6.80015 4.65 6.80594C4.65 6.81172 4.65 6.81752 4.65 6.82333C4.65 6.82913 4.65 6.83495 4.65 6.84077C4.65 6.8466 4.65 6.85243 4.65 6.85827C4.65 6.86411 4.65 6.86996 4.65 6.87582C4.65 6.88167 4.65 6.88754 4.65 6.89342C4.65 6.89929 4.65 6.90517 4.65 6.91107C4.65 6.91696 4.65 6.92286 4.65 6.92877C4.65 6.93468 4.65 6.9406 4.65 6.94652C4.65 6.95245 4.65 6.95839 4.65 6.96433C4.65 6.97028 4.65 6.97623 4.65 6.98219C4.65 6.98815 4.65 6.99412 4.65 7.0001C4.65 7.00608 4.65 7.01207 4.65 7.01807C4.65 7.02406 4.65 7.03007 4.65 7.03608C4.65 7.0421 4.65 7.04812 4.65 7.05415C4.65 7.06018 4.65 7.06622 4.65 7.07227C4.65 7.07832 4.65 7.08438 4.65 7.09045C4.65 7.09651 4.65 7.10259 4.65 7.10867C4.65 7.11476 4.65 7.12085 4.65 7.12695C4.65 7.13306 4.65 7.13917 4.65 7.14529C4.65 7.15141 4.65 7.15754 4.65 7.16367C4.65 7.16981 4.65 7.17596 4.65 7.18211C4.65 7.18827 4.65 7.19443 4.65 7.2006C4.65 7.20678 4.65 7.21296 4.65 7.21915C4.65 7.22534 4.65 7.23154 4.65 7.23775C4.65 7.24396 4.65 7.25018 4.65 7.2564C4.65 7.26263 4.65 7.26886 4.65 7.27511C4.65 7.28135 4.65 7.28761 4.65 7.29387C4.65 7.30013 4.65 7.3064 4.65 7.31268C4.65 7.31896 4.65 7.32525 4.65 7.33155C4.65 7.33785 4.65 7.34416 4.65 7.35047C4.65 7.35679 4.65 7.36311 4.65 7.36945C4.65 7.37578 4.65 7.38213 4.65 7.38848C4.65 7.39483 4.65 7.40119 4.65 7.40756C4.65 7.41393 4.65 7.42031 4.65 7.4267C4.65 7.43309 4.65 7.43949 4.65 7.44589C4.65 7.4523 4.65 7.45872 4.65 7.46514C4.65 7.47157 4.65 7.478 4.65 7.48444C4.65 7.49089 4.65 7.49734 4.65 7.5038C4.65 7.51026 4.65 7.51673 4.65 7.52321C4.65 7.52969 4.65 7.53618 4.65 7.54268C4.65 7.54918 4.65 7.55568 4.65 7.5622C4.65 7.56872 4.65 7.57524 4.65 7.58178C4.65 7.58831 4.65 7.59485 4.65 7.60141C4.65 7.60796 4.65 7.61452 4.65 7.62109C4.65 7.62767 4.65 7.63425 4.65 7.64084C4.65 7.64743 4.65 7.65402 4.65 7.66063C4.65 7.66724 4.65 7.67386 4.65 7.68049C4.65 7.68711 4.65 7.69375 4.65 7.70039C4.65 7.70704 4.65 7.71369 4.65 7.72036C4.65 7.72702 4.65 7.7337 4.65 7.74038C4.65 7.74706 4.65 7.75375 4.65 7.76045C4.65 7.76716 4.65 7.77387 4.65 7.78059C4.65 7.78731 4.65 7.79404 4.65 7.80077C4.65 7.80751 4.65 7.81426 4.65 7.82102C4.65 7.82778 4.65 7.83454 4.65 7.84132C4.65 7.84809 4.65 7.85488 4.65 7.86167C4.65 7.86847 4.65 7.87527 4.65 7.88209C4.65 7.8889 4.65 7.89572 4.65 7.90256C4.65 7.90939 4.65 7.91623 4.65 7.92308C4.65 7.92993 4.65 7.93679 4.65 7.94366C4.65 7.95053 4.65 7.95741 4.65 7.9643C4.65 7.97119 4.65 7.97809 4.65 7.985C4.65 7.99191 4.65 7.99883 4.65 8.00575C4.65 8.01268 4.65 8.01962 4.65 8.02656C4.65 8.03351 4.65 8.04046 4.65 8.04743C4.65 8.0544 4.65 8.06137 4.65 8.06835C4.65 8.07534 4.65 8.08233 4.65 8.08934C4.65 8.09634 4.65 8.10335 4.65 8.11037C4.65 8.1174 4.65 8.12443 4.65 8.13147C4.65 8.13851 4.65 8.14556 4.65 8.15262C4.65 8.15969 4.65 8.16676 4.65 8.17384C4.65 8.18092 4.65 8.18801 4.65 8.19511C4.65 8.20221 4.65 8.20931 4.65 8.21643C4.65 8.22355 4.65 8.23068 4.65 8.23782C4.65 8.24496 4.65 8.2521 4.65 8.25926C4.65 8.26642 4.65 8.27358 4.65 8.28076C4.65 8.28794 4.65 8.29513 4.65 8.30232C4.65 8.30952 4.65 8.31672 4.65 8.32394C4.65 8.33115 4.65 8.33838 4.65 8.34561C4.65 8.35285 4.65 8.36009 4.65 8.36735C4.65 8.3746 4.65 8.38187 4.65 8.38914C4.65 8.39642 4.65 8.4037 4.65 8.41099C4.65 8.41829 4.65 8.42559 4.65 8.4329C4.65 8.44022 4.65 8.44754 4.65 8.45487C4.65 8.4622 4.65 8.46955 4.65 8.4769C4.65 8.48425 4.65 8.49161 4.65 8.49899C4.65 8.50636 4.65 8.51374 4.65 8.52113C4.65 8.52852 4.65 8.53593 4.65 8.54334C4.65 8.55075 4.65 8.55817 4.65 8.5656C4.65 8.57303 4.65 8.58047 4.65 8.58793C4.65 8.59538 4.65 8.60284 4.65 8.61031C4.65 8.61778 4.65 8.62526 4.65 8.63275C4.65 8.64024 4.65 8.64774 4.65 8.65525C4.65 8.66276 4.65 8.67028 4.65 8.67782C4.65 8.68535 4.65 8.69289 4.65 8.70044C4.65 8.70799 4.65 8.71555 4.65 8.72312C4.65 8.73069 4.65 8.73827 4.65 8.74586C4.65 8.75345 4.65 8.76105 4.65 8.76866C4.65 8.77627 4.65 8.78389 4.65 8.79152C4.65 8.79915 4.65 8.80679 4.65 8.81445C4.65 8.8221 4.65 8.82976 4.65 8.83743C4.65 8.8451 4.65 8.85278 4.65 8.86047C4.65 8.86816 4.65 8.87586 4.65 8.88357C4.65 8.89128 4.65 8.89901 4.65 8.90674C4.65 8.91447 4.65 8.92221 4.65 8.92996C4.65 8.93771 4.65 8.94548 4.65 8.95325C4.65 8.96102 4.65 8.9688 4.65 8.97659C4.65 8.98439 4.65 8.99219 4.65 9H3.35Z",
        fill: "currentColor"
      }), jsx("path", {
        d: "M16 13.5L12.5 10",
        stroke: "currentColor",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M16 13.5L12.5 17",
        stroke: "currentColor",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }) : jsxs("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M22 2L11 13",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M22 2L15 22L11 13L2 9L22 2Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), children ? jsx("span", {
      children: children
    }) : undefined]
  }));
};
var StyledButton = styled.button(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n\n  color: var(--chat-color-primary);\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  background-color: transparent;\n  border: none;\n  outline: none;\n  border-radius: 4px;\n\n  transition: 250ms ease;\n\n  svg {\n    font-size: 20px;\n  }\n\n  &:disabled {\n    color: #999da4;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #f9f9f9;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n\n  color: var(--chat-color-primary);\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  background-color: transparent;\n  border: none;\n  outline: none;\n  border-radius: 4px;\n\n  transition: 250ms ease;\n\n  svg {\n    font-size: 20px;\n  }\n\n  &:disabled {\n    color: #999da4;\n  }\n\n  &:hover:not(:disabled) {\n    background-color: #f9f9f9;\n  }\n"])));
var templateObject_1$m;

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual;

var depsEqual = function (aDeps, bDeps) {
  if (aDeps === void 0) {
    aDeps = [];
  }
  if (bDeps === void 0) {
    bDeps = [];
  }
  return isEqual_1(aDeps, bDeps);
};

var useDeepCompareEffectWithTarget = function (effect, deps, target) {
  var ref = useRef();
  var signalRef = useRef(0);
  if (!depsEqual(deps, ref.current)) {
    ref.current = deps;
    signalRef.current += 1;
  }
  useEffectWithTarget$2(effect, [signalRef.current], target);
};
var useDeepCompareEffectWithTarget$1 = useDeepCompareEffectWithTarget;

var isAppleDevice = /(mac|iphone|ipod|ipad)/i.test(typeof navigator !== 'undefined' ? navigator === null || navigator === void 0 ? void 0 : navigator.platform : '');
var isAppleDevice$1 = isAppleDevice;

// 键盘事件 keyCode 别名
var aliasKeyCodeMap = {
  '0': 48,
  '1': 49,
  '2': 50,
  '3': 51,
  '4': 52,
  '5': 53,
  '6': 54,
  '7': 55,
  '8': 56,
  '9': 57,
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pausebreak: 19,
  capslock: 20,
  esc: 27,
  space: 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  leftarrow: 37,
  uparrow: 38,
  rightarrow: 39,
  downarrow: 40,
  insert: 45,
  delete: 46,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftwindowkey: 91,
  rightwindowkey: 92,
  meta: isAppleDevice$1 ? [91, 93] : [91, 92],
  selectkey: 93,
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,
  multiply: 106,
  add: 107,
  subtract: 109,
  decimalpoint: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numlock: 144,
  scrolllock: 145,
  semicolon: 186,
  equalsign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardslash: 191,
  graveaccent: 192,
  openbracket: 219,
  backslash: 220,
  closebracket: 221,
  singlequote: 222
};
// 修饰键
var modifierKey = {
  ctrl: function (event) {
    return event.ctrlKey;
  },
  shift: function (event) {
    return event.shiftKey;
  },
  alt: function (event) {
    return event.altKey;
  },
  meta: function (event) {
    if (event.type === 'keyup') {
      return aliasKeyCodeMap.meta.includes(event.keyCode);
    }
    return event.metaKey;
  }
};
// 根据 event 计算激活键数量
function countKeyByEvent(event) {
  var countOfModifier = Object.keys(modifierKey).reduce(function (total, key) {
    if (modifierKey[key](event)) {
      return total + 1;
    }
    return total;
  }, 0);
  // 16 17 18 91 92 是修饰键的 keyCode，如果 keyCode 是修饰键，那么激活数量就是修饰键的数量，如果不是，那么就需要 +1
  return [16, 17, 18, 91, 92].includes(event.keyCode) ? countOfModifier : countOfModifier + 1;
}
/**
 * 判断按键是否激活
 * @param [event: KeyboardEvent]键盘事件
 * @param [keyFilter: any] 当前键
 * @returns Boolean
 */
function genFilterKey(event, keyFilter, exactMatch) {
  var e_1, _a;
  // 浏览器自动补全 input 的时候，会触发 keyDown、keyUp 事件，但此时 event.key 等为空
  if (!event.key) {
    return false;
  }
  // 数字类型直接匹配事件的 keyCode
  if (isNumber(keyFilter)) {
    return event.keyCode === keyFilter;
  }
  // 字符串依次判断是否有组合键
  var genArr = keyFilter.split('.');
  var genLen = 0;
  try {
    for (var genArr_1 = __values(genArr), genArr_1_1 = genArr_1.next(); !genArr_1_1.done; genArr_1_1 = genArr_1.next()) {
      var key = genArr_1_1.value;
      // 组合键
      var genModifier = modifierKey[key];
      // keyCode 别名
      var aliasKeyCode = aliasKeyCodeMap[key.toLowerCase()];
      if (genModifier && genModifier(event) || aliasKeyCode && aliasKeyCode === event.keyCode) {
        genLen++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (genArr_1_1 && !genArr_1_1.done && (_a = genArr_1.return)) _a.call(genArr_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  /**
   * 需要判断触发的键位和监听的键位完全一致，判断方法就是触发的键位里有且等于监听的键位
   * genLen === genArr.length 能判断出来触发的键位里有监听的键位
   * countKeyByEvent(event) === genArr.length 判断出来触发的键位数量里有且等于监听的键位数量
   * 主要用来防止按组合键其子集也会触发的情况，例如监听 ctrl+a 会触发监听 ctrl 和 a 两个键的事件。
   */
  if (exactMatch) {
    return genLen === genArr.length && countKeyByEvent(event) === genArr.length;
  }
  return genLen === genArr.length;
}
/**
 * 键盘输入预处理方法
 * @param [keyFilter: any] 当前键
 * @returns () => Boolean
 */
function genKeyFormatter(keyFilter, exactMatch) {
  if (isFunction$3(keyFilter)) {
    return keyFilter;
  }
  if (isString(keyFilter) || isNumber(keyFilter)) {
    return function (event) {
      return genFilterKey(event, keyFilter, exactMatch);
    };
  }
  if (Array.isArray(keyFilter)) {
    return function (event) {
      return keyFilter.some(function (item) {
        return genFilterKey(event, item, exactMatch);
      });
    };
  }
  return function () {
    return Boolean(keyFilter);
  };
}
var defaultEvents = ['keydown'];
function useKeyPress(keyFilter, eventHandler, option) {
  var _a = option || {},
    _b = _a.events,
    events = _b === void 0 ? defaultEvents : _b,
    target = _a.target,
    _c = _a.exactMatch,
    exactMatch = _c === void 0 ? false : _c,
    _d = _a.useCapture,
    useCapture = _d === void 0 ? false : _d;
  var eventHandlerRef = useLatest$1(eventHandler);
  var keyFilterRef = useLatest$1(keyFilter);
  useDeepCompareEffectWithTarget$1(function () {
    var e_2, _a;
    var _b;
    var el = getTargetElement(target, window);
    if (!el) {
      return;
    }
    var callbackHandler = function (event) {
      var _a;
      var genGuard = genKeyFormatter(keyFilterRef.current, exactMatch);
      if (genGuard(event)) {
        return (_a = eventHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(eventHandlerRef, event);
      }
    };
    try {
      for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
        var eventName = events_1_1.value;
        (_b = el === null || el === void 0 ? void 0 : el.addEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler, useCapture);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return function () {
      var e_3, _a;
      var _b;
      try {
        for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
          var eventName = events_2_1.value;
          (_b = el === null || el === void 0 ? void 0 : el.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler, useCapture);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (events_2_1 && !events_2_1.done && (_a = events_2.return)) _a.call(events_2);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };
  }, [events], target);
}

/**
 * ChannelInput UI 컴포넌트의 비즈니스 로직을 분리한 훅입니다.
 *
 * @param config
 * @returns
 */
var useInputUI = function (config) {
  var channel = config.channel,
    hiddenInputRef = config.hiddenInputRef,
    targetInputRef = config.targetInputRef,
    isMobile = config.isMobile,
    onSend = config.onSend;
  var generatedMessage = useContext(MessageSelectContext).generatedMessage;
  var _a = useState(''),
    value = _a[0],
    setValue = _a[1];
  useEffect(function () {
    setValue(generatedMessage);
  }, [generatedMessage]);
  var clearText = function () {
    var _a;
    setValue('');
    (_a = hiddenInputRef === null || hiddenInputRef === void 0 ? void 0 : hiddenInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    window.setTimeout(function () {
      var _a;
      (_a = targetInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, 0);
  };
  var handleSendMessage = function (message) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var trimedValue;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!message) return [2 /*return*/];
            trimedValue = message.replaceAll(' ', '');
            if (!trimedValue) return [2 /*return*/];
            clearText();
            return [4 /*yield*/, onSend(value)];
          case 1:
            _a.sent();
            // 메시지가 전송되면 타이핑을 중단한다.
            channel.endTyping();
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * 엔터를 누를 경우 SendMessage
   */
  useKeyPress('enter', function (e) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var value;
      var _a;
      return __generator(this, function (_b) {
        if (isMobile || !(targetInputRef === null || targetInputRef === void 0 ? void 0 : targetInputRef.current)) return [2 /*return*/];
        e.preventDefault();
        value = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
        handleSendMessage(value);
        return [2 /*return*/];
      });
    });
  }, {
    events: ['keydown'],
    exactMatch: true,
    target: targetInputRef === null || targetInputRef === void 0 ? void 0 : targetInputRef.current
  });
  var handleChangeInput = function (e) {
    var value = e.target.value;
    setValue(value);
    // 입력값이 없을 경우 타이핑 중단
    if (!value) {
      channel.endTyping();
      return;
    }
    // 이미 타이핑 중일 경우 아무것도 하지 않음
    if (channel.isTyping) return;
    // 타이핑 시작
    channel.startTyping();
  };
  return {
    value: value,
    handleChangeInput: handleChangeInput,
    handleSendMessage: handleSendMessage,
    setValue: setValue
  };
};

var ChannelInputUI = memo(function (props) {
  var children = props.children;
  var locale = useContext(ChatRootContext).locale;
  var parentMessage = useContext(ChannelContext).parentMessage;
  var t = useTranslation().t;
  var textAreaRef = useRef(null);
  var _a = useInputUI(__assign$1(__assign$1({}, props), {
      targetInputRef: textAreaRef
    })),
    value = _a.value,
    handleChangeInput = _a.handleChangeInput,
    handleSendMessage = _a.handleSendMessage,
    setValue = _a.setValue;
  return jsxs(InputContainer$1, {
    children: [!!children && !parentMessage && jsx(Toolbar$1, {
      children: jsx("div", {
        className: "toolbar-space",
        children: children
      })
    }), !!parentMessage && jsx(Toolbar$1, {
      children: jsx(ChannelInputParentMessage, {
        onCancel: function () {
          return setValue('');
        }
      })
    }), jsxs(Box, {
      display: "flex",
      alignItems: "flex-start",
      pr: "24px",
      style: {
        gap: '20px'
      },
      children: [jsx(index$2, {
        ref: textAreaRef,
        className: "chat-textarea",
        value: value,
        onChange: handleChangeInput,
        placeholder: t(locale.message_input_placeholder).toString(),
        minRows: 2,
        maxRows: 2
      }), jsx(SendButton, {
        isReply: !!parentMessage,
        disabled: !value,
        onClick: function () {
          handleSendMessage(value);
        },
        style: {
          marginTop: '12px'
        },
        children: parentMessage ? locale.input_reply : locale.input_send
      })]
    })]
  });
});
ChannelInputUI.displayName = 'ChannelInput.UI';
var InputContainer$1 = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  flex: 0 0 auto;\n  padding: 0;\n  border-top: 1px solid var(--chat-channel-border);\n\n  .chat-textarea {\n    flex: 1;\n    display: block;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 8px 8px 10px 1rem;\n    background: transparent;\n    resize: none;\n    border: none;\n\n    font-size: var(--font-size, 16px);\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.03em;\n\n    color: #2c384a;\n\n    transition: border 250ms ease;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: var(--font-size, 16px);\n      font-weight: 400;\n      letter-spacing: -0.03em;\n    }\n\n    &::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #bbbfc5;\n      background-clip: padding-box;\n      border-radius: 7px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: #f4f6f8;\n      border-radius: 7px 7px 0 0;\n    }\n  }\n\n  transition:\n    box-shadow 250ms ease,\n    border-color 250ms ease;\n"], ["\n  flex: 0 0 auto;\n  padding: 0;\n  border-top: 1px solid var(--chat-channel-border);\n\n  .chat-textarea {\n    flex: 1;\n    display: block;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 8px 8px 10px 1rem;\n    background: transparent;\n    resize: none;\n    border: none;\n\n    font-size: var(--font-size, 16px);\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.03em;\n\n    color: #2c384a;\n\n    transition: border 250ms ease;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: var(--font-size, 16px);\n      font-weight: 400;\n      letter-spacing: -0.03em;\n    }\n\n    &::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #bbbfc5;\n      background-clip: padding-box;\n      border-radius: 7px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: #f4f6f8;\n      border-radius: 7px 7px 0 0;\n    }\n  }\n\n  transition:\n    box-shadow 250ms ease,\n    border-color 250ms ease;\n"])));
var Toolbar$1 = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  position: relative;\n  padding: 0 1rem;\n  overflow-x: auto;\n  white-space: nowrap;\n\n  .toolbar-space {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    border-bottom: 1px solid var(--chat-border-color);\n  }\n"], ["\n  position: relative;\n  padding: 0 1rem;\n  overflow-x: auto;\n  white-space: nowrap;\n\n  .toolbar-space {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    border-bottom: 1px solid var(--chat-border-color);\n  }\n"])));
var templateObject_1$l, templateObject_2$e;

var ChannelInputUIMobile = memo(function (props) {
  var children = props.children;
  var locale = useContext(ChatRootContext).locale;
  var parentMessage = useContext(ChannelContext).parentMessage;
  var t = useTranslation().t;
  var invisibleInputRef = useRef(null);
  var textAreaRef = useRef(null);
  var _a = useInputUI(__assign$1(__assign$1({}, props), {
      hiddenInputRef: invisibleInputRef,
      targetInputRef: textAreaRef,
      isMobile: true
    })),
    value = _a.value,
    handleChangeInput = _a.handleChangeInput,
    handleSendMessage = _a.handleSendMessage,
    setValue = _a.setValue;
  return jsxs(InputContainer, {
    children: [!!children && !parentMessage && jsx(Toolbar, {
      children: jsx("div", {
        className: "toolbar-space",
        children: children
      })
    }), !!parentMessage && jsx(ParentMessageWrapper, {
      children: jsx(ChannelInputParentMessage, {
        onCancel: function () {
          return setValue('');
        }
      })
    }), jsxs(Box, {
      display: "flex",
      alignItems: "flex-end",
      pr: "0.25rem",
      style: {
        gap: '0.25rem'
      },
      children: [jsx("textarea", {
        ref: invisibleInputRef,
        style: {
          position: 'absolute',
          opacity: 0,
          width: 1,
          height: 1
        }
      }), jsx(index$2, {
        className: "chat-textarea",
        ref: textAreaRef,
        value: value,
        onChange: handleChangeInput,
        placeholder: t(locale.message_input_placeholder).toString(),
        minRows: 1,
        maxRows: 2
      }), jsx(SendButton, {
        isReply: !!parentMessage,
        disabled: !value,
        onClick: function () {
          handleSendMessage(value);
        },
        style: {
          width: '2.75rem',
          height: '2.75rem',
          marginTop: '0.25rem',
          marginBottom: '0.25rem'
        }
      })]
    })]
  });
});
ChannelInputUIMobile.displayName = 'ChannelInput.UI.Mobile';
var InputContainer = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  flex: 0 0 auto;\n  border-top: 1px solid var(--chat-channel-border);\n\n  .chat-textarea {\n    flex: 1;\n    display: block;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 12px 8px 12px 1rem;\n    background: transparent;\n    resize: none;\n    border: none;\n\n    font-size: var(--font-size, 16px);\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.03em;\n\n    color: #2c384a;\n\n    transition: border 250ms ease;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: var(--font-size, 16px);\n      font-weight: 400;\n      letter-spacing: -0.03em;\n    }\n\n    &::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #bbbfc5;\n      background-clip: padding-box;\n      border-radius: 7px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: #f4f6f8;\n      border-radius: 7px 7px 0 0;\n    }\n  }\n\n  transition:\n    box-shadow 250ms ease,\n    border-color 250ms ease;\n"], ["\n  flex: 0 0 auto;\n  border-top: 1px solid var(--chat-channel-border);\n\n  .chat-textarea {\n    flex: 1;\n    display: block;\n    width: 100%;\n    border: none;\n    outline: none;\n    padding: 12px 8px 12px 1rem;\n    background: transparent;\n    resize: none;\n    border: none;\n\n    font-size: var(--font-size, 16px);\n    font-weight: 400;\n    line-height: 150%;\n    letter-spacing: -0.03em;\n\n    color: #2c384a;\n\n    transition: border 250ms ease;\n\n    &::placeholder {\n      color: #bfbfbf;\n      font-size: var(--font-size, 16px);\n      font-weight: 400;\n      letter-spacing: -0.03em;\n    }\n\n    &::-webkit-scrollbar {\n      width: 7px;\n      height: 7px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #bbbfc5;\n      background-clip: padding-box;\n      border-radius: 7px;\n    }\n    &::-webkit-scrollbar-track {\n      background-color: #f4f6f8;\n      border-radius: 7px 7px 0 0;\n    }\n  }\n\n  transition:\n    box-shadow 250ms ease,\n    border-color 250ms ease;\n"])));
var Toolbar = styled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  position: relative;\n  height: 40px;\n\n  .toolbar-space {\n    position: absolute;\n    top: 0;\n    left: 1rem;\n    right: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    border-bottom: 1px solid var(--chat-border-color);\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .toolbar-space-parent-message {\n    position: absolute;\n    top: 0;\n    left: 1rem;\n    right: 1rem;\n    height: 60px;\n    border-bottom: 1px solid var(--chat-border-color);\n  }\n"], ["\n  position: relative;\n  height: 40px;\n\n  .toolbar-space {\n    position: absolute;\n    top: 0;\n    left: 1rem;\n    right: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    height: 40px;\n    border-bottom: 1px solid var(--chat-border-color);\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .toolbar-space-parent-message {\n    position: absolute;\n    top: 0;\n    left: 1rem;\n    right: 1rem;\n    height: 60px;\n    border-bottom: 1px solid var(--chat-border-color);\n  }\n"])));
var ParentMessageWrapper = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  padding-left: 1rem;\n  padding-right: 1rem;\n"], ["\n  padding-left: 1rem;\n  padding-right: 1rem;\n"])));
var templateObject_1$k, templateObject_2$d, templateObject_3$b;

var TypingIndicator = function (props) {
  var _a, _b;
  var isTyping = props.isTyping,
    _c = props.typingUsers,
    typingUsers = _c === void 0 ? [] : _c;
  var locale = useLocale().locale;
  if (!isTyping) return null;
  return jsx(TypingText, {
    dangerouslySetInnerHTML: {
      __html: typingUsers.length > 1 ? locale.typing_user_indicator_plural.replace('{{name}}', "<strong>".concat((_a = typingUsers === null || typingUsers === void 0 ? void 0 : typingUsers[0]) === null || _a === void 0 ? void 0 : _a.nickname, "</strong>")).replace('{{count}}', typingUsers.length.toString()) : locale.typing_user_indicator.replace('{{name}}', "<strong>".concat((_b = typingUsers === null || typingUsers === void 0 ? void 0 : typingUsers[0]) === null || _b === void 0 ? void 0 : _b.nickname, "</strong>"))
    }
  });
};
var TypingText = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  padding: 4px 1rem;\n  color: #7f8892;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.03em;\n\n  strong {\n    font-weight: 500;\n  }\n"], ["\n  padding: 4px 1rem;\n  color: #7f8892;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.03em;\n\n  strong {\n    font-weight: 500;\n  }\n"])));
var templateObject_1$j;

var ChannelInput = function (props) {
  var onSended = props.onSended;
  var sb = useContext(ChatRootContext).sb;
  var _a = useContext(ChannelContext),
    channel = _a.channel,
    parentMessage = _a.parentMessage,
    setParentMessage = _a.setParentMessage,
    onCloseSearchMode = _a.onCloseSearchMode,
    searchWithTimestamp = _a.searchWithTimestamp;
  var enabled = useContext(MessageSelectContext).enabled;
  var isMobile = useIsMobile();
  var _b = useState([]),
    typingUsers = _b[0],
    setTypingUsers = _b[1];
  /**
   * 메시지 전송
   *
   * @param message
   * @returns
   */
  var sendMessage = function (message) {
    return new Promise(function (resolve, reject) {
      if (!channel) return;
      var params = {
        message: message,
        parentMessageId: (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId) || undefined
      };
      channel.sendUserMessage(params)
      /**
       * 메시지가 성공적으로 전달되면 업데이트하고 resolve합니다.
       */.onSucceeded(function (message) {
        channel.markAsRead();
        setParentMessage(null);
        onSended();
        if (searchWithTimestamp) {
          onCloseSearchMode === null || onCloseSearchMode === void 0 ? void 0 : onCloseSearchMode();
        }
        resolve(message);
      })
      /**
       * 실패할 경우 reject합니다.
       */.onFailed(function (err) {
        reject(err);
      });
    });
  };
  useEffect(function () {
    if (!sb || !channel) return;
    var groupChannelHandler = new GroupChannelHandler({
      onTypingStatusUpdated: function (_channel) {
        if (_channel.url !== channel.url) return;
        setTypingUsers(channel.getTypingUsers());
      }
    });
    sb.groupChannel.addGroupChannelHandler('channelInputEventListner', groupChannelHandler);
    return function () {
      sb.groupChannel.removeGroupChannelHandler('channelInputEventListner');
    };
  }, [sb, channel]);
  var extentionsChildren = useExtentions({
    channel: channel
  });
  return jsxs(Wrap, {
    className: "chat-message-input",
    style: {
      display: enabled ? 'none' : undefined
    },
    children: [jsx(TypingIndicator, {
      isTyping: channel === null || channel === void 0 ? void 0 : channel.isTyping,
      typingUsers: typingUsers
    }), channel && (isMobile ? jsx(ChannelInputUIMobile, {
      channel: channel,
      onSend: sendMessage,
      children: extentionsChildren
    }) : jsx(ChannelInputUI, {
      channel: channel,
      onSend: sendMessage,
      children: extentionsChildren
    }))]
  });
};
var Wrap = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  flex: 0 0 auto;\n  background: white;\n"], ["\n  flex: 0 0 auto;\n  background: white;\n"])));
var templateObject_1$i;

var debounce$1 = {exports: {}};

function debounce(function_, wait = 100, options = {}) {
  if (typeof function_ !== 'function') {
    throw new TypeError(`Expected the first parameter to be a function, got \`${typeof function_}\`.`);
  }
  if (wait < 0) {
    throw new RangeError('`wait` must not be negative.');
  }

  // TODO: Deprecate the boolean parameter at some point.
  const {
    immediate
  } = typeof options === 'boolean' ? {
    immediate: options
  } : options;
  let storedContext;
  let storedArguments;
  let timeoutId;
  let timestamp;
  let result;
  function later() {
    const last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeoutId = setTimeout(later, wait - last);
    } else {
      timeoutId = undefined;
      if (!immediate) {
        const callContext = storedContext;
        const callArguments = storedArguments;
        storedContext = undefined;
        storedArguments = undefined;
        result = function_.apply(callContext, callArguments);
      }
    }
  }
  const debounced = function (...arguments_) {
    if (storedContext && this !== storedContext) {
      throw new Error('Debounced method called with different contexts.');
    }
    storedContext = this; // eslint-disable-line unicorn/no-this-assignment
    storedArguments = arguments_;
    timestamp = Date.now();
    const callNow = immediate && !timeoutId;
    if (!timeoutId) {
      timeoutId = setTimeout(later, wait);
    }
    if (callNow) {
      const callContext = storedContext;
      const callArguments = storedArguments;
      storedContext = undefined;
      storedArguments = undefined;
      result = function_.apply(callContext, callArguments);
    }
    return result;
  };
  debounced.clear = () => {
    if (!timeoutId) {
      return;
    }
    clearTimeout(timeoutId);
    timeoutId = undefined;
  };
  debounced.flush = () => {
    if (!timeoutId) {
      return;
    }
    const callContext = storedContext;
    const callArguments = storedArguments;
    storedContext = undefined;
    storedArguments = undefined;
    result = function_.apply(callContext, callArguments);
    clearTimeout(timeoutId);
    timeoutId = undefined;
  };
  return debounced;
}

// Adds compatibility for ES modules
debounce$1.exports.debounce = debounce;
debounce$1.exports = debounce;

function highlightMessageElement(element) {
  element.classList.remove('chat-message-row--highlight');
  element.classList.add('chat-message-row--highlight');
  setTimeout(function () {
    element.classList.remove('chat-message-row--highlight');
  }, 2000);
}

var MessageRowWrap = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject([""], [""])));
var MessageRow = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  padding: 0.25rem 1rem;\n\n  @keyframes messageHighlight {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.02);\n      background: rgba(255 255 255 / 20%);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  /* @keyframes messageHighlightBubble {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.1);\n    }\n    100% {\n      transform: scale(1);\n    }\n  } */\n\n  &.chat-message-row--highlight {\n    animation-name: messageHighlight;\n    animation-duration: 700ms;\n    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    animation-iteration-count: 2;\n    /* .chat-message-bubble {\n      animation-name: messageHighlightBubble;\n      animation-duration: 700ms;\n      animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n      animation-iteration-count: 2;\n    } */\n  }\n"], ["\n  position: relative;\n  display: flex;\n  padding: 0.25rem 1rem;\n\n  @keyframes messageHighlight {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.02);\n      background: rgba(255 255 255 / 20%);\n    }\n    100% {\n      transform: scale(1);\n    }\n  }\n\n  /* @keyframes messageHighlightBubble {\n    0% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.1);\n    }\n    100% {\n      transform: scale(1);\n    }\n  } */\n\n  &.chat-message-row--highlight {\n    animation-name: messageHighlight;\n    animation-duration: 700ms;\n    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    animation-iteration-count: 2;\n    /* .chat-message-bubble {\n      animation-name: messageHighlightBubble;\n      animation-duration: 700ms;\n      animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n      animation-iteration-count: 2;\n    } */\n  }\n"])));
var AvatarArea = styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  cursor: pointer;\n  flex: 0 0 auto;\n  width: 48px;\n  padding-right: 8px;\n"], ["\n  cursor: pointer;\n  flex: 0 0 auto;\n  width: 48px;\n  padding-right: 8px;\n"])));
var MessageArea = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var MessageContents = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n  gap: 8px;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n  gap: 8px;\n\n  ", "\n"])), function (_a) {
  var isMine = _a.isMine;
  if (!isMine) return "\n        justify-content: flex-start;\n      ";
  return "\n      flex-direction: row-reverse;\n    ";
});
var MessageBubble = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  max-width: var(--chat-message-max-width);\n  padding: 8px 12px;\n  color: var(--chat-message-text);\n  background-color: var(--chat-message-background);\n  border-radius: var(--chat-message-border-radius);\n  word-wrap: break-word;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 150%;\n  letter-spacing: -0.02em;\n\n  a {\n    color: inherit;\n    text-decoration: underline;\n    word-break: break-all;\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  & > span::selection {\n    background: #157ad8;\n  }\n  & > span::-moz-selection {\n    background: #157ad8;\n  }\n\n  mark {\n    background: #d5ebff;\n    padding: 0;\n  }\n\n  ", "\n"], ["\n  max-width: var(--chat-message-max-width);\n  padding: 8px 12px;\n  color: var(--chat-message-text);\n  background-color: var(--chat-message-background);\n  border-radius: var(--chat-message-border-radius);\n  word-wrap: break-word;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 150%;\n  letter-spacing: -0.02em;\n\n  a {\n    color: inherit;\n    text-decoration: underline;\n    word-break: break-all;\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  & > span::selection {\n    background: #157ad8;\n  }\n  & > span::-moz-selection {\n    background: #157ad8;\n  }\n\n  mark {\n    background: #d5ebff;\n    padding: 0;\n  }\n\n  ", "\n"])), function (_a) {
  var isMine = _a.isMine;
  if (!isMine) return "";
  return "\n      color: var(--chat-message-text-me);\n      background-color: var(--chat-message-background-me);\n    ";
});
var MessageSelectArea = styled.button(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n  border: none;\n  outline: none;\n  padding: 1rem;\n  margin: 0;\n  text-align: left;\n\n  &:hover {\n    background: rgba(0 0 0 / 40%);\n  }\n  &.selected {\n    background: none;\n  }\n  &.start {\n    border-top: 1px dashed rgba(0 0 0 / 50%);\n  }\n  &.end {\n    border-bottom: 1px dashed rgba(0 0 0 / 50%);\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n  border: none;\n  outline: none;\n  padding: 1rem;\n  margin: 0;\n  text-align: left;\n\n  &:hover {\n    background: rgba(0 0 0 / 40%);\n  }\n  &.selected {\n    background: none;\n  }\n  &.start {\n    border-top: 1px dashed rgba(0 0 0 / 50%);\n  }\n  &.end {\n    border-bottom: 1px dashed rgba(0 0 0 / 50%);\n  }\n"])));
var MessageSelectAreaBadge = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  color: white;\n  text-align: center;\n"], ["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  color: white;\n  text-align: center;\n"])));
var MessageSelectAreaBadgeTop = styled(MessageSelectAreaBadge)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  top: 0;\n  transform: translateY(-100%);\n"], ["\n  top: 0;\n  transform: translateY(-100%);\n"])));
var MessageSelectAreaBadgeBottom = styled(MessageSelectAreaBadge)(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  bottom: 0;\n  transform: translateY(100%);\n"], ["\n  bottom: 0;\n  transform: translateY(100%);\n"])));
// const MessageSelectModeCover = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 10;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0 0 0 / 50%);
// `;
var MessageSystemBlock = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: relative;\n  padding: 0.25rem 1rem;\n  color: #8d8d8d;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: center;\n"], ["\n  position: relative;\n  padding: 0.25rem 1rem;\n  color: #8d8d8d;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: center;\n"])));
var templateObject_1$h, templateObject_2$c, templateObject_3$a, templateObject_4$7, templateObject_5$5, templateObject_6$4, templateObject_7$2, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11;

var FloatingScrollDownButton = function () {
  var _a;
  var _b = useContext(ChannelContext),
    scrollRef = _b.scrollRef,
    toScrollBottom = _b.toScrollBottom,
    searchWithTimestamp = _b.searchWithTimestamp,
    onCloseSearchMode = _b.onCloseSearchMode;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var scroll = useScroll(scrollRef);
  var hasNext = messageDataSource.hasNext();
  var isActive = useMemo(function () {
    var _a, _b, _c, _d, _e;
    if (hasNext) return true;
    var clientHeight = (_b = (_a = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
    var scrollHeight = (_d = (_c = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) !== null && _d !== void 0 ? _d : 0;
    var scrollTop = (_e = scroll === null || scroll === void 0 ? void 0 : scroll.top) !== null && _e !== void 0 ? _e : 0;
    return scrollTop < scrollHeight - clientHeight - 200;
  }, [hasNext, scroll === null || scroll === void 0 ? void 0 : scroll.top, (_a = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight]);
  return jsx(FloatingButton, {
    className: classNames({
      active: isActive
    }),
    onClick: function () {
      if (messageDataSource.hasNext()) {
        if (searchWithTimestamp) {
          onCloseSearchMode === null || onCloseSearchMode === void 0 ? void 0 : onCloseSearchMode();
        } else {
          messageDataSource.refresh();
        }
      } else {
        toScrollBottom();
      }
    },
    children: jsx("svg", {
      stroke: "currentColor",
      fill: "none",
      strokeWidth: "0",
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      viewBox: "0 0 20 20",
      children: jsx("path", {
        d: "M16 7L10 13L4 7",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })
  });
};
var FloatingButton = styled.button(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  right: 1rem;\n  bottom: 1rem;\n  z-index: 100;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  margin: 0;\n  outline: none;\n  border: none;\n\n  background: rgba(255 255 255 / 90%);\n  backdrop-filter: blur(10px);\n  border-radius: 100%;\n  box-shadow:\n    rgba(0 0 0 / 10%) 0 10px 16px,\n    rgba(0 0 0 / 6%) 0 0 0 1px;\n\n  color: #5b5b5b;\n  font-size: 1.25rem;\n\n  transition:\n    opacity 250ms ease,\n    visibility 250ms ease,\n    background 150ms ease;\n  opacity: 0;\n  visibility: hidden;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &:hover {\n    background: rgba(255 255 255 / 70%);\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  right: 1rem;\n  bottom: 1rem;\n  z-index: 100;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  margin: 0;\n  outline: none;\n  border: none;\n\n  background: rgba(255 255 255 / 90%);\n  backdrop-filter: blur(10px);\n  border-radius: 100%;\n  box-shadow:\n    rgba(0 0 0 / 10%) 0 10px 16px,\n    rgba(0 0 0 / 6%) 0 0 0 1px;\n\n  color: #5b5b5b;\n  font-size: 1.25rem;\n\n  transition:\n    opacity 250ms ease,\n    visibility 250ms ease,\n    background 150ms ease;\n  opacity: 0;\n  visibility: hidden;\n\n  &.active {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  &:hover {\n    background: rgba(255 255 255 / 70%);\n  }\n"])));
var templateObject_1$g;

var getNative = _getNative;
var defineProperty$1 = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty$1 = defineProperty$1;

var defineProperty = _defineProperty$1;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$1;

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator$1(array, setter, iteratee, accumulator) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}
var _arrayAggregator = arrayAggregator$1;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor$1(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;

var baseFor = _baseFor,
  keys = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}
var _baseForOwn = baseForOwn$1;

var isArrayLike = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
      index = fromRight ? length : -1,
      iterable = Object(collection);
    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
  createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;

var baseEach = _baseEach;

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator$1(collection, setter, iteratee, accumulator) {
  baseEach(collection, function (value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}
var _baseAggregator = baseAggregator$1;

var arrayAggregator = _arrayAggregator,
  baseAggregator = _baseAggregator,
  baseIteratee = _baseIteratee,
  isArray = isArray_1;

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator$1(setter, initializer) {
  return function (collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
      accumulator = initializer ? initializer() : {};
    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}
var _createAggregator = createAggregator$1;

var baseAssignValue = _baseAssignValue,
  createAggregator = _createAggregator;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function (result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});
var groupBy_1 = groupBy;

function useToggle(defaultValue, reverseValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  var _a = __read(useState(defaultValue), 2),
    state = _a[0],
    setState = _a[1];
  var actions = useMemo(function () {
    var reverseValueOrigin = reverseValue === undefined ? !defaultValue : reverseValue;
    var toggle = function () {
      return setState(function (s) {
        return s === defaultValue ? reverseValueOrigin : defaultValue;
      });
    };
    var set = function (value) {
      return setState(value);
    };
    var setLeft = function () {
      return setState(defaultValue);
    };
    var setRight = function () {
      return setState(reverseValueOrigin);
    };
    return {
      toggle: toggle,
      set: set,
      setLeft: setLeft,
      setRight: setRight
    };
    // useToggle ignore value change
    // }, [defaultValue, reverseValue]);
  }, []);
  return [state, actions];
}

function useBoolean(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  var _a = __read(useToggle(!!defaultValue), 2),
    state = _a[0],
    _b = _a[1],
    toggle = _b.toggle,
    set = _b.set;
  var actions = useMemo(function () {
    var setTrue = function () {
      return set(true);
    };
    var setFalse = function () {
      return set(false);
    };
    return {
      toggle: toggle,
      set: function (v) {
        return set(!!v);
      },
      setTrue: setTrue,
      setFalse: setFalse
    };
  }, []);
  return [state, actions];
}

function useEventListener(eventName, handler, options) {
  if (options === void 0) {
    options = {};
  }
  var handlerRef = useLatest$1(handler);
  useEffectWithTarget$2(function () {
    var targetElement = getTargetElement(options.target, window);
    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }
    var eventListener = function (event) {
      return handlerRef.current(event);
    };
    targetElement.addEventListener(eventName, eventListener, {
      capture: options.capture,
      once: options.once,
      passive: options.passive
    });
    return function () {
      targetElement.removeEventListener(eventName, eventListener, {
        capture: options.capture
      });
    };
  }, [eventName, options.capture, options.once, options.passive], options.target);
}

var useHover = (function (target, options) {
  var _a = options || {},
    onEnter = _a.onEnter,
    onLeave = _a.onLeave,
    onChange = _a.onChange;
  var _b = __read(useBoolean(false), 2),
    state = _b[0],
    _c = _b[1],
    setTrue = _c.setTrue,
    setFalse = _c.setFalse;
  useEventListener('mouseenter', function () {
    onEnter === null || onEnter === void 0 ? void 0 : onEnter();
    setTrue();
    onChange === null || onChange === void 0 ? void 0 : onChange(true);
  }, {
    target: target
  });
  useEventListener('mouseleave', function () {
    onLeave === null || onLeave === void 0 ? void 0 : onLeave();
    setFalse();
    onChange === null || onChange === void 0 ? void 0 : onChange(false);
  }, {
    target: target
  });
  return state;
});

var touchSupported = isBrowser$2 && (
// @ts-ignore
'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);
function useLongPress(onLongPress, target, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.delay,
    delay = _c === void 0 ? 300 : _c,
    moveThreshold = _b.moveThreshold,
    onClick = _b.onClick,
    onLongPressEnd = _b.onLongPressEnd;
  var onLongPressRef = useLatest$1(onLongPress);
  var onClickRef = useLatest$1(onClick);
  var onLongPressEndRef = useLatest$1(onLongPressEnd);
  var timerRef = useRef();
  var isTriggeredRef = useRef(false);
  var pervPositionRef = useRef({
    x: 0,
    y: 0
  });
  var hasMoveThreshold = !!((moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.x) && moveThreshold.x > 0 || (moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.y) && moveThreshold.y > 0);
  useEffectWithTarget$2(function () {
    var targetElement = getTargetElement(target);
    if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener)) {
      return;
    }
    var overThreshold = function (event) {
      var _a = getClientPosition(event),
        clientX = _a.clientX,
        clientY = _a.clientY;
      var offsetX = Math.abs(clientX - pervPositionRef.current.x);
      var offsetY = Math.abs(clientY - pervPositionRef.current.y);
      return !!((moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.x) && offsetX > moveThreshold.x || (moveThreshold === null || moveThreshold === void 0 ? void 0 : moveThreshold.y) && offsetY > moveThreshold.y);
    };
    function getClientPosition(event) {
      if (event instanceof TouchEvent) {
        return {
          clientX: event.touches[0].clientX,
          clientY: event.touches[0].clientY
        };
      }
      if (event instanceof MouseEvent) {
        return {
          clientX: event.clientX,
          clientY: event.clientY
        };
      }
      console.warn('Unsupported event type');
      return {
        clientX: 0,
        clientY: 0
      };
    }
    var onStart = function (event) {
      if (hasMoveThreshold) {
        var _a = getClientPosition(event),
          clientX = _a.clientX,
          clientY = _a.clientY;
        pervPositionRef.current.x = clientX;
        pervPositionRef.current.y = clientY;
      }
      timerRef.current = setTimeout(function () {
        onLongPressRef.current(event);
        isTriggeredRef.current = true;
      }, delay);
    };
    var onMove = function (event) {
      if (timerRef.current && overThreshold(event)) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }
    };
    var onEnd = function (event, shouldTriggerClick) {
      var _a;
      if (shouldTriggerClick === void 0) {
        shouldTriggerClick = false;
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      if (isTriggeredRef.current) {
        (_a = onLongPressEndRef.current) === null || _a === void 0 ? void 0 : _a.call(onLongPressEndRef, event);
      }
      if (shouldTriggerClick && !isTriggeredRef.current && onClickRef.current) {
        onClickRef.current(event);
      }
      isTriggeredRef.current = false;
    };
    var onEndWithClick = function (event) {
      return onEnd(event, true);
    };
    if (!touchSupported) {
      targetElement.addEventListener('mousedown', onStart);
      targetElement.addEventListener('mouseup', onEndWithClick);
      targetElement.addEventListener('mouseleave', onEnd);
      if (hasMoveThreshold) targetElement.addEventListener('mousemove', onMove);
    } else {
      targetElement.addEventListener('touchstart', onStart);
      targetElement.addEventListener('touchend', onEndWithClick);
      if (hasMoveThreshold) targetElement.addEventListener('touchmove', onMove);
    }
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        isTriggeredRef.current = false;
      }
      if (!touchSupported) {
        targetElement.removeEventListener('mousedown', onStart);
        targetElement.removeEventListener('mouseup', onEndWithClick);
        targetElement.removeEventListener('mouseleave', onEnd);
        if (hasMoveThreshold) targetElement.removeEventListener('mousemove', onMove);
      } else {
        targetElement.removeEventListener('touchstart', onStart);
        targetElement.removeEventListener('touchend', onEndWithClick);
        if (hasMoveThreshold) targetElement.removeEventListener('touchmove', onMove);
      }
    };
  }, [], target);
}

/**
 * 대화 내용 중 날짜 구분선 UI를 구성합니다.
 */
var ChannelSeperator = function (props) {
  var date = props.date;
  var locale = useLocale().locale;
  var t = useTranslation().t;
  var enabled = useContext(MessageSelectContext).enabled;
  var today = dayjs_minExports();
  var isToday = today.isSame(date, 'day');
  var isYesterday = today.subtract(1, 'day').isSame(date, 'day');
  var render = function () {
    return jsxs(Fragment, {
      children: [jsx(Box, {
        height: "1rem"
      }), jsx(DayBadge, {
        children: isToday ? t(locale.today) : isYesterday ? t(locale.yesterday) : dayjs_minExports(date).locale(locale.dayjsLocale).format('ll')
      }), jsx(Box, {
        height: "1rem"
      })]
    });
  };
  if (enabled) return jsxs(Box, {
    position: "relative",
    children: [render(), jsx(MessageSelectModeCover, {})]
  });
  return jsx(Fragment, {
    children: render()
  });
};
// const DividerLine = styled.div`
//   position: relative;
//   &::after {
//     content: '';
//     position: absolute;
//     display: block;
//     top: 1rem;
//     left: 0;
//     right: 0;
//     border-bottom: 1px solid #e5e5e5;
//   }
// `;
var DayBadge = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  position: sticky;\n  top: -0.5rem;\n  left: 50%;\n  z-index: 10;\n  transform: translateX(-50%);\n\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  padding: 0 1rem;\n\n  font-weight: 500;\n  font-size: var(--font-size-14, 14px);\n  line-height: 18px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n\n  border-radius: 2.5rem;\n  background: white;\n  border: 1px solid var(--chat-channel-border);\n  box-shadow: rgba(0 0 0 / 5%) 0 2px 6px;\n\n  ", "\n"], ["\n  position: sticky;\n  top: -0.5rem;\n  left: 50%;\n  z-index: 10;\n  transform: translateX(-50%);\n\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  padding: 0 1rem;\n\n  font-weight: 500;\n  font-size: var(--font-size-14, 14px);\n  line-height: 18px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  color: #414c5c;\n\n  border-radius: 2.5rem;\n  background: white;\n  border: 1px solid var(--chat-channel-border);\n  box-shadow: rgba(0 0 0 / 5%) 0 2px 6px;\n\n  ", "\n"])), mobileStyle(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n    height: 1.5rem;\n    padding: 0 0.75rem;\n    font-size: var(--font-size-12, 12px);\n  "], ["\n    height: 1.5rem;\n    padding: 0 0.75rem;\n    font-size: var(--font-size-12, 12px);\n  "]))));
var MessageSelectModeCover = styled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0 0 0 / 50%);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0 0 0 / 50%);\n"])));
var templateObject_1$f, templateObject_2$b, templateObject_3$9;

// THIS FILE IS AUTO GENERATED
var GenIcon$2 = require$$0.GenIcon;
var FiDownloadCloud_1 = function FiDownloadCloud(props) {
  return GenIcon$2({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "8 17 12 21 16 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
      }
    }]
  })(props);
};

var img$2 = "data:image/jpeg;base64,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";

var img$1 = "data:image/jpeg;base64,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";

var img = "data:image/jpeg;base64,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";

function genFileSize(filesize) {
  var text = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
  var e = Math.floor(Math.log(filesize) / Math.log(1024));
  return (filesize / Math.pow(1024, e)).toFixed(2) + ' ' + text[e];
}
var MessageFile = function (props) {
  var message = props.message,
    onClickImage = props.onClickImage;
  var parsedFile = message.data ? JSON.parse(message.data || '{}') : null;
  return jsx(MessageFileUI, {
    type: message.type,
    name: message.name,
    url: message.url,
    thumbnailUrl: parsedFile === null || parsedFile === void 0 ? void 0 : parsedFile.thumbnailUrl,
    size: message.size,
    originData: message.data,
    onClickImage: onClickImage
  });
};
var MessageFileUI = function (props) {
  var _a = props.type,
    type = _a === void 0 ? '' : _a,
    _b = props.url,
    url = _b === void 0 ? '' : _b,
    _c = props.thumbnailUrl,
    thumbnailUrl = _c === void 0 ? '' : _c,
    _d = props.name,
    name = _d === void 0 ? '' : _d,
    _e = props.size,
    size = _e === void 0 ? 0 : _e,
    originData = props.originData,
    onClickImage = props.onClickImage;
  var locale = useContext(ChatRootContext).locale;
  var renderFilePreview = useContext(ChatContext).renderFilePreview;
  var _f = useState(false),
    openPreview = _f[0],
    setOpenPreview = _f[1];
  var pdfTypes = ['.pdf'];
  var msOfficeTypes = ['.ppt', '.pptx', '.xlsx', '.xls', '.doc', '.docx'];
  var autodeskTypes = ['.rvt', '.skp', '.dwg'];
  var videoTypes = ['.mp4', '.webm', '.ogg'];
  var audioTypes = ['.mp3', '.wav', '.ogg'];
  var supportedTypes = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], pdfTypes, true), msOfficeTypes, true), autodeskTypes, true), videoTypes, true), audioTypes, true);
  var checkFileType = function (targetString, types) {
    // 확장자가 대문자인 경우도 있기 때문에 소문자로 변환
    var lowerCasedString = targetString.toLowerCase();
    return !!types.filter(function (type) {
      return lowerCasedString.includes(type);
    }).length;
  };
  /**
   * originData가 없는 경우 미리보기를 표시할 수 없습니다.
   */
  var hasOriginData = useMemo(function () {
    if (!originData) return false;
    return true;
  }, [originData]);
  var previewThumbnail = useMemo(function () {
    if (checkFileType(name, pdfTypes)) {
      return jsx("img", {
        src: img
      });
    } else if (checkFileType(name, msOfficeTypes)) {
      return jsx("img", {
        src: img$1
      });
    } else if (checkFileType(name, autodeskTypes)) {
      return jsx("img", {
        src: img$2
      });
    } else if (checkFileType(name, videoTypes)) {
      return jsx(VideoThumbnail, {
        thumbnailUrl: thumbnailUrl,
        url: url,
        size: size
      });
    } else if (checkFileType(name, audioTypes)) {
      return jsx("audio", {
        controls: true,
        src: url
      });
    }
    return '';
  }, [name, thumbnailUrl, url, size]);
  var renderFileLink = function () {
    return jsxs(FileLink, {
      href: url,
      rel: "noreferrer",
      children: [jsxs(Box, {
        flex: "1",
        minWidth: "0",
        children: [jsx("div", {
          className: "filename",
          children: name
        }), jsx(Box, {
          color: "#7f7f7f",
          fontSize: "0.75rem",
          children: genFileSize(size || 0)
        })]
      }), jsx(Box, {
        flex: "0 0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "42px",
        height: "42px",
        borderRadius: "100%",
        border: "1px solid #E9E9E9",
        children: jsxs("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M12.7505 1.83789C12.7505 1.42368 12.4147 1.08789 12.0005 1.08789C11.5863 1.08789 11.2505 1.42368 11.2505 1.83789L12.7505 1.83789ZM11.4702 15.8716C11.7631 16.1645 12.2379 16.1645 12.5308 15.8716L17.3038 11.0986C17.5967 10.8057 17.5967 10.3309 17.3038 10.038C17.0109 9.74507 16.536 9.74507 16.2431 10.038L12.0005 14.2806L7.75785 10.038C7.46495 9.74507 6.99008 9.74507 6.69719 10.038C6.40429 10.3309 6.40429 10.8057 6.69719 11.0986L11.4702 15.8716ZM11.2505 1.83789L11.2505 15.3413L12.7505 15.3413L12.7505 1.83789L11.2505 1.83789Z",
            fill: "#505050"
          }), jsx("path", {
            d: "M2.9978 15.7627V18.9277C2.9978 20.093 3.94245 21.0376 5.10773 21.0376H18.8923C20.0576 21.0376 21.0022 20.093 21.0022 18.9277V15.7627",
            stroke: "#505050",
            strokeWidth: "1.5",
            strokeLinecap: "round"
          })]
        })
      })]
    });
  };
  if (type === null || type === void 0 ? void 0 : type.includes('image')) {
    return jsxs(ImageWrap, {
      children: [jsx(Image, {
        src: thumbnailUrl || url,
        style: {
          maxWidth: 240,
          height: 200,
          objectFit: 'contain'
        },
        wrapperStyle: {
          cursor: 'pointer',
          borderRadius: 8,
          overflow: 'hidden'
        },
        preview: onClickImage ? false : {
          src: url
        },
        onClick: onClickImage ? function () {
          return onClickImage(url);
        } : undefined
      }), jsx(ImageDownloadButton, {
        href: url,
        children: jsx(FiDownloadCloud_1, {})
      })]
    });
  }
  if (type.includes('audio')) {
    return jsxs(Box, {
      children: [renderFileLink(), jsx("audio", {
        controls: true,
        src: url,
        style: {
          maxWidth: 'var(--chat-message-max-width)',
          marginTop: '4px'
        }
      })]
    });
  }
  return jsxs(Box, {
    children: [renderFileLink(), !!renderFilePreview && checkFileType(name, supportedTypes) && hasOriginData && jsxs(FilePreviewCard, {
      onClick: function () {
        setOpenPreview(true);
      },
      children: [jsx("div", {
        className: "thumbnail",
        children: previewThumbnail
      }), jsx("div", {
        className: "detail-button",
        children: locale.file_message_preview_button
      })]
    }), openPreview && jsx(FilePreviewModal, __assign$1({}, props, {
      onClose: function () {
        return setOpenPreview(false);
      }
    }))]
  });
};
var VideoThumbnail = function (props) {
  var thumbnailUrl = props.thumbnailUrl,
    url = props.url,
    size = props.size;
  return jsxs(Fragment, {
    children: [jsx("video", {
      poster: thumbnailUrl,
      src: thumbnailUrl ? url : "".concat(url, "#t=0.1")
    }), jsxs(VideoThumbnailCover, {
      children: [jsx("div", {
        className: "circle",
        children: jsx("svg", {
          width: "17",
          height: "20",
          viewBox: "0 0 17 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            d: "M16.5 9.13397C17.1667 9.51887 17.1667 10.4811 16.5 10.866L1.5 19.5263C0.833331 19.9112 -9.36737e-07 19.4301 -9.03088e-07 18.6603L-1.45985e-07 1.33974C-1.12336e-07 0.569945 0.833334 0.0888199 1.5 0.47372L16.5 9.13397Z",
            fill: "white"
          })
        })
      }), !!size && jsx("span", {
        className: "file-size",
        children: genFileSize(size)
      })]
    })]
  });
};
var VideoThumbnailCover = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  .circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  .file-size {\n    margin-top: 2px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #ffffff;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  .circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  .file-size {\n    margin-top: 2px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    text-align: center;\n\n    color: #ffffff;\n  }\n"])));
var FileLink = styled.a(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  width: var(--chat-message-max-width);\n  max-width: var(--chat-message-max-width);\n  border-radius: 8px;\n  padding: 1rem 0.75rem 1rem;\n  border: 1px solid #eeeeee;\n  gap: 8px;\n\n  color: #2c384a;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  background-color: white;\n\n  transition: all 250ms ease;\n\n  &:hover {\n    color: inherit;\n    border-color: #d7d7d7;\n  }\n  &:active {\n    color: inherit;\n    background-color: #f7f7f7;\n  }\n\n  .filename {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-bottom: 4px;\n  }\n  .file-size {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n  width: var(--chat-message-max-width);\n  max-width: var(--chat-message-max-width);\n  border-radius: 8px;\n  padding: 1rem 0.75rem 1rem;\n  border: 1px solid #eeeeee;\n  gap: 8px;\n\n  color: #2c384a;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 20px;\n  letter-spacing: -0.02em;\n\n  background-color: white;\n\n  transition: all 250ms ease;\n\n  &:hover {\n    color: inherit;\n    border-color: #d7d7d7;\n  }\n  &:active {\n    color: inherit;\n    background-color: #f7f7f7;\n  }\n\n  .filename {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-bottom: 4px;\n  }\n  .file-size {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    /* identical to box height */\n\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n  }\n"])));
var ImageDownloadButton = styled.a(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  right: 0.375rem;\n  bottom: 0.375rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.75rem;\n  height: 1.75rem;\n\n  color: white;\n  font-size: 1rem;\n  background-color: rgba(0 0 0 / 30%);\n  border: none;\n  box-shadow:\n    rgba(0 0 0 / 40%) 0 0 0 1px,\n    rgba(0 0 0 / 5%) 0 2px 8px;\n\n  border-radius: 6px;\n  outline: none;\n\n  transition: 200ms;\n\n  &:hover {\n    background-color: #ededed !important;\n  }\n  &:active {\n    background-color: #d4d4d4 !important;\n    box-shadow:\n      rgba(0 0 0 / 30%) 0 0 0 1px,\n      rgba(0 0 0 / 10%) 0 2px 16px !important;\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  right: 0.375rem;\n  bottom: 0.375rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 1.75rem;\n  height: 1.75rem;\n\n  color: white;\n  font-size: 1rem;\n  background-color: rgba(0 0 0 / 30%);\n  border: none;\n  box-shadow:\n    rgba(0 0 0 / 40%) 0 0 0 1px,\n    rgba(0 0 0 / 5%) 0 2px 8px;\n\n  border-radius: 6px;\n  outline: none;\n\n  transition: 200ms;\n\n  &:hover {\n    background-color: #ededed !important;\n  }\n  &:active {\n    background-color: #d4d4d4 !important;\n    box-shadow:\n      rgba(0 0 0 / 30%) 0 0 0 1px,\n      rgba(0 0 0 / 10%) 0 2px 16px !important;\n  }\n"])));
var ImageWrap = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    user-select: none;\n    pointer-events: none;\n    border-radius: 8px;\n    box-shadow: rgba(0 0 0 / 10%) 0 0 0 1px inset;\n  }\n\n  .ant-image-mask {\n    display: none;\n  }\n\n  &:hover {\n    ", " {\n      color: rgb(0 0 0 / 70%);\n      background-color: white;\n      box-shadow:\n        rgba(0 0 0 / 10%) 0 0 0 1px,\n        rgba(0 0 0 / 15%) 0 2px 12px;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    user-select: none;\n    pointer-events: none;\n    border-radius: 8px;\n    box-shadow: rgba(0 0 0 / 10%) 0 0 0 1px inset;\n  }\n\n  .ant-image-mask {\n    display: none;\n  }\n\n  &:hover {\n    ", " {\n      color: rgb(0 0 0 / 70%);\n      background-color: white;\n      box-shadow:\n        rgba(0 0 0 / 10%) 0 0 0 1px,\n        rgba(0 0 0 / 15%) 0 2px 12px;\n    }\n  }\n"])), ImageDownloadButton);
var FilePreviewCard = styled.a(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  width: var(--chat-message-max-width);\n  max-width: var(--chat-message-max-width);\n  margin-top: 4px;\n\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #f9f9f9;\n  border: 1px solid #eeeeee;\n\n  color: #2c384a;\n\n  &:hover {\n    color: inherit;\n  }\n\n  .thumbnail {\n    position: relative;\n    padding-bottom: 56.25%;\n    overflow: hidden;\n    img,\n    video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  .detail-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 44px;\n\n    font-weight: 400;\n    font-size: var(--font-size-16, 16px);\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: -0.02em;\n\n    border: none;\n    outline: none;\n    background: none;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  width: var(--chat-message-max-width);\n  max-width: var(--chat-message-max-width);\n  margin-top: 4px;\n\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: #f9f9f9;\n  border: 1px solid #eeeeee;\n\n  color: #2c384a;\n\n  &:hover {\n    color: inherit;\n  }\n\n  .thumbnail {\n    position: relative;\n    padding-bottom: 56.25%;\n    overflow: hidden;\n    img,\n    video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  .detail-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 44px;\n\n    font-weight: 400;\n    font-size: var(--font-size-16, 16px);\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: -0.02em;\n\n    border: none;\n    outline: none;\n    background: none;\n  }\n"])));
var templateObject_1$e, templateObject_2$a, templateObject_3$8, templateObject_4$6, templateObject_5$4;

// THIS FILE IS AUTO GENERATED
var GenIcon$1 = require$$0.GenIcon;
var IoWarning_1 = function IoWarning(props) {
  return GenIcon$1({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M449.07 399.08L278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0080 446.25h340.89a32 32 0 0028.18-47.17zm-198.6-1.83a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.95a21.73 21.73 0 0121.5-22.69h.21a21.74 21.74 0 0121.73 22.7z"
      }
    }]
  })(props);
};

/**
 * 이메일인지 체크합니다.
 *
 * @param text
 * @returns
 */
var emailCheck = function (text) {
  if (!text || typeof text !== 'string') return false;
  var regex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
  return regex.test(text);
};
/**
 * 문자열 내에서 url을 찾습니다.
 *
 * @param text
 * @returns
 */
var detectUrlString = function (text) {
  var matchedUrl = text.match(/(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g);
  return matchedUrl;
};
/**
 * 문자열을 파싱하여 html 형태로 변환합니다.
 *
 * @param message
 * @returns
 */
var messageTextParser = function (message, highlightText) {
  if (!message) return '';
  /**
   * 줄바꿈 태그 생성
   */
  var wrappedText = message === null || message === void 0 ? void 0 : message.replace(/\r?\n/g, '<br />');
  var matchedUrl = detectUrlString(wrappedText);
  var lastHtml = wrappedText;
  matchedUrl === null || matchedUrl === void 0 ? void 0 : matchedUrl.forEach(function (url) {
    if (!url) return '';
    var isEmail = emailCheck(url);
    if (isEmail) {
      lastHtml = lastHtml.replace(url, "<a href=\"mailto:".concat(url, "\" target=\"_blank\">").concat(url, "</a>"));
      return;
    }
    lastHtml = lastHtml.replace(url, "<a href=\"".concat(url, "\" target=\"_blank\">").concat(url, "</a>"));
  });
  var highlightedText = function () {
    if (!highlightText || !lastHtml.includes(highlightText)) return lastHtml;
    return lastHtml.replace(highlightText, "<mark>".concat(highlightText, "</mark>"));
  };
  return jsx("span", {
    dangerouslySetInnerHTML: {
      __html: highlightedText()
    }
  });
};

var MessageMeta = function (props) {
  var ogMetaData = props.ogMetaData;
  return jsxs(CardLink, {
    href: ogMetaData.url || '',
    target: "_blank",
    rel: "noreferrer",
    children: [(ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.defaultImage) && jsx(Thumbnail, {
      children: jsx("img", {
        alt: (ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.title) || '',
        src: ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.defaultImage.url
      })
    }), jsxs(CardBody, {
      children: [jsx(Title, {
        children: ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.title
      }), jsx(Description, {
        children: ogMetaData === null || ogMetaData === void 0 ? void 0 : ogMetaData.description
      }), jsx(SiteUrl, {
        children: ogMetaData.url
      })]
    })]
  });
};
var CardLink = styled.a(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n\n  width: var(--chat-message-max-width);\n  border: 1px solid #eeeeee;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--chat-message-background);\n\n  transition: all 250ms ease;\n\n  &:hover {\n    border-color: #dadada;\n  }\n  &:active {\n    border-color: #dadada;\n    background-color: #f9f9f9;\n  }\n"], ["\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n\n  width: var(--chat-message-max-width);\n  border: 1px solid #eeeeee;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--chat-message-background);\n\n  transition: all 250ms ease;\n\n  &:hover {\n    border-color: #dadada;\n  }\n  &:active {\n    border-color: #dadada;\n    background-color: #f9f9f9;\n  }\n"])));
var Thumbnail = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  position: relative;\n  padding-bottom: 56.25%;\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"], ["\n  position: relative;\n  padding-bottom: 56.25%;\n  img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n  }\n"])));
var CardBody = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 1rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 1rem;\n"])));
var Title = styled.h4(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  display: block;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  color: #2c384a;\n  font-size: var(--font-size-16, 16px);\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n"], ["\n  display: block;\n  margin: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  color: #2c384a;\n  font-size: var(--font-size-16, 16px);\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n"])));
var Description = styled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  color: #414c5c;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n\n  margin: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  color: #414c5c;\n  font-weight: 400;\n  font-size: var(--font-size-16, 16px);\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n\n  margin: 0;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var SiteUrl = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  color: #7f8892;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 1.125;\n  letter-spacing: -0.02em;\n"], ["\n  color: #7f8892;\n  font-weight: 400;\n  font-size: var(--font-size-14, 14px);\n  line-height: 1.125;\n  letter-spacing: -0.02em;\n"])));
var templateObject_1$d, templateObject_2$9, templateObject_3$7, templateObject_4$5, templateObject_5$3, templateObject_6$3;

var MessageNormal = function (props) {
  var text = props.text,
    children = props.children,
    isMine = props.isMine,
    ogMetaData = props.ogMetaData,
    parrentMessage = props.parrentMessage,
    args = __rest$2(props, ["text", "children", "isMine", "ogMetaData", "parrentMessage"]);
  var _a = useContext(ChannelContext),
    onSearchPayloadChange = _a.onSearchPayloadChange,
    searchQuery = _a.searchQuery;
  return jsxs(MessageBox, {
    style: {
      alignItems: isMine ? 'flex-end' : 'flex-start'
    },
    children: [jsxs(MessageBubble, __assign$1({
      className: "chat-message-bubble",
      isMine: isMine
    }, args, {
      children: [parrentMessage && jsx(ParentMessage, {
        withBorder: true,
        isMine: isMine,
        message: parrentMessage,
        onClick: function () {
          var parentMessageElement = document.querySelector(".chat-message-row[data-message-id=\"".concat(parrentMessage.messageId, "\"]"));
          if (parentMessageElement) {
            parentMessageElement === null || parentMessageElement === void 0 ? void 0 : parentMessageElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
            highlightMessageElement(parentMessageElement);
          } else {
            onSearchPayloadChange === null || onSearchPayloadChange === void 0 ? void 0 : onSearchPayloadChange('', parrentMessage.createdAt);
          }
        }
      }), text ? messageTextParser(text, searchQuery) : children]
    })), !!ogMetaData && jsx(MessageMeta, {
      ogMetaData: ogMetaData
    })]
  });
};
var MessageBox = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"])));
var templateObject_1$c;

var MessageNotSupport = function (props) {
  var isMine = props.isMine;
  var locale = useLocale().locale;
  return jsx(MessageNormal, {
    isMine: isMine,
    style: {
      border: '1px solid #e5e5e5',
      background: 'white'
    },
    children: jsxs(Box, {
      display: "flex",
      alignItems: "center",
      color: "grey",
      children: [jsx(IoWarning_1, {
        size: 20,
        style: {
          flex: '0 0 auto',
          marginRight: '0.5rem'
        }
      }), jsx("span", {
        children: locale.not_supported_message
      })]
    })
  });
};

var ShareDocumentCard = function (props) {
  var isMine = props.isMine,
    projectId = props.projectId,
    cardProps = __rest$2(props, ["isMine", "projectId"]);
  var locale = useLocale().locale;
  var shareDocument = useContext(ChatContext).shareDocument;
  var isDisabled = useMemo(function () {
    if (!shareDocument) return true;
    return !shareDocument.checkJoinedProject(projectId);
  }, [shareDocument === null || shareDocument === void 0 ? void 0 : shareDocument.checkJoinedProject, projectId]);
  if (!shareDocument) {
    return jsx(MessageNotSupport, {
      isMine: isMine
    });
  }
  if (!(shareDocument === null || shareDocument === void 0 ? void 0 : shareDocument.onClickReport)) return jsx(MessageNotSupport, {
    isMine: isMine
  });
  return jsx(Card, __assign$1({}, cardProps, {
    style: {
      userSelect: isDisabled ? 'none' : 'auto'
    },
    children: isDisabled && jsx(CoverBackground, {
      children: jsxs(Cover, {
        children: [jsxs("svg", {
          width: "26",
          height: "26",
          viewBox: "0 0 26 26",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
            stroke: "#777777",
            strokeWidth: "1.5"
          }), jsx("path", {
            d: "M14 16.8823H12V19H14V16.8823Z",
            fill: "#777777"
          }), jsx("path", {
            d: "M14 7H12V15.1179H14V7Z",
            fill: "#777777"
          })]
        }), jsx("div", {
          children: locale.extention_share_document_message_auth
        })]
      })
    })
  }));
};
var CoverBackground = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255 255 255 / 90%);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255 255 255 / 90%);\n"])));
var Cover = styled.div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(8px);\n  border-radius: 8px;\n\n  color: #414c5c;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  svg {\n    margin-bottom: 8px;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(8px);\n  border-radius: 8px;\n\n  color: #414c5c;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: -0.02em;\n\n  svg {\n    margin-bottom: 8px;\n  }\n"])));
var templateObject_1$b, templateObject_2$8;

var MessageMinutes = function (props) {
  var isMine = props.isMine,
    message = props.message;
  var locale = useLocale().locale;
  var shareDocument = useContext(ChatContext).shareDocument;
  var data = JSON.parse(message.data || '{}');
  if (!shareDocument) {
    return jsx(MessageNotSupport, {
      isMine: isMine
    });
  }
  return jsx(ShareDocumentCard, {
    isMine: isMine,
    projectId: data.project_id,
    thumbnailUrl: data.thumbnailUrl,
    title: "".concat(locale.extention_share_document_tab_minutes, " | ").concat(data.title),
    description: sanitizeHtml(data.content || ''),
    onClick: function () {
      shareDocument.onClickMinutes(data);
    }
  });
};

var MessageMultipleImage = function (props) {
  var message = props.message;
  var images = JSON.parse(message.data || '[]');
  return jsx(ImagesGrid, {
    children: images.map(function (image, index) {
      return jsx("li", {
        children: jsx(Image, {
          src: image.thumbnailUrl || image.url,
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          },
          wrapperStyle: {
            position: 'relative',
            cursor: 'pointer',
            overflow: 'hidden',
            width: '100%',
            height: '100%'
          },
          preview: {
            src: image.url
          }
        })
      }, index);
    })
  });
};
var ImagesGrid = styled.ul(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  width: var(--chat-message-max-width);\n  gap: 2px;\n  border-radius: 8px;\n  overflow: hidden;\n\n  & > li {\n    position: relative;\n    flex: 1;\n    height: 80px;\n    overflow: hidden;\n    border-radius: 3px;\n    min-width: 25%;\n    .ant-image-mask {\n      display: none;\n    }\n  }\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  width: var(--chat-message-max-width);\n  gap: 2px;\n  border-radius: 8px;\n  overflow: hidden;\n\n  & > li {\n    position: relative;\n    flex: 1;\n    height: 80px;\n    overflow: hidden;\n    border-radius: 3px;\n    min-width: 25%;\n    .ant-image-mask {\n      display: none;\n    }\n  }\n"])));
var templateObject_1$a;

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

var ClassNames;
(function (ClassNames) {
  ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
  ClassNames["searchActive"] = "epr-search-active";
  ClassNames["hidden"] = "epr-hidden";
  ClassNames["visible"] = "epr-visible";
  ClassNames["active"] = "epr-active";
  ClassNames["emoji"] = "epr-emoji";
  ClassNames["category"] = "epr-emoji-category";
  ClassNames["label"] = "epr-emoji-category-label";
  ClassNames["categoryContent"] = "epr-emoji-category-content";
  ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
  ClassNames["scrollBody"] = "epr-body";
  ClassNames["emojiList"] = "epr-emoji-list";
  ClassNames["external"] = "__EmojiPicker__";
  ClassNames["emojiPicker"] = "EmojiPickerReact";
  ClassNames["open"] = "epr-open";
  ClassNames["vertical"] = "epr-vertical";
  ClassNames["horizontal"] = "epr-horizontal";
  ClassNames["variationPicker"] = "epr-emoji-variation-picker";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.map(function (c) {
    return "." + c;
  }).join('');
}
var SuggestionMode;
(function (SuggestionMode) {
  SuggestionMode["RECENT"] = "recent";
  SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function (EmojiStyle) {
  EmojiStyle["NATIVE"] = "native";
  EmojiStyle["APPLE"] = "apple";
  EmojiStyle["TWITTER"] = "twitter";
  EmojiStyle["GOOGLE"] = "google";
  EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
  Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function (SkinTones) {
  SkinTones["NEUTRAL"] = "neutral";
  SkinTones["LIGHT"] = "1f3fb";
  SkinTones["MEDIUM_LIGHT"] = "1f3fc";
  SkinTones["MEDIUM"] = "1f3fd";
  SkinTones["MEDIUM_DARK"] = "1f3fe";
  SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function (Categories) {
  Categories["SUGGESTED"] = "suggested";
  Categories["SMILEYS_PEOPLE"] = "smileys_people";
  Categories["ANIMALS_NATURE"] = "animals_nature";
  Categories["FOOD_DRINK"] = "food_drink";
  Categories["TRAVEL_PLACES"] = "travel_places";
  Categories["ACTIVITIES"] = "activities";
  Categories["OBJECTS"] = "objects";
  Categories["SYMBOLS"] = "symbols";
  Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function (SkinTonePickerLocation) {
  SkinTonePickerLocation["SEARCH"] = "SEARCH";
  SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));
var CDN_URL_APPLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/';
var CDN_URL_FACEBOOK = 'https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/';
var CDN_URL_TWITTER = 'https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/';
var CDN_URL_GOOGLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/';
function cdnUrl(emojiStyle) {
  switch (emojiStyle) {
    case EmojiStyle.TWITTER:
      return CDN_URL_TWITTER;
    case EmojiStyle.GOOGLE:
      return CDN_URL_GOOGLE;
    case EmojiStyle.FACEBOOK:
      return CDN_URL_FACEBOOK;
    case EmojiStyle.APPLE:
    default:
      return CDN_URL_APPLE;
  }
}
var smileys_people = [{
  n: ["grinning", "grinning face"],
  u: "1f600",
  a: "1.0"
}, {
  n: ["smiley", "smiling face with open mouth"],
  u: "1f603",
  a: "0.6"
}, {
  n: ["smile", "smiling face with open mouth and smiling eyes"],
  u: "1f604",
  a: "0.6"
}, {
  n: ["grin", "grinning face with smiling eyes"],
  u: "1f601",
  a: "0.6"
}, {
  n: ["laughing", "satisfied", "smiling face with open mouth and tightly-closed eyes"],
  u: "1f606",
  a: "0.6"
}, {
  n: ["sweat smile", "smiling face with open mouth and cold sweat"],
  u: "1f605",
  a: "0.6"
}, {
  n: ["rolling on the floor laughing"],
  u: "1f923",
  a: "3.0"
}, {
  n: ["joy", "face with tears of joy"],
  u: "1f602",
  a: "0.6"
}, {
  n: ["slightly smiling face"],
  u: "1f642",
  a: "1.0"
}, {
  n: ["upside-down face", "upside down face"],
  u: "1f643",
  a: "1.0"
}, {
  n: ["melting face"],
  u: "1fae0",
  a: "14.0"
}, {
  n: ["wink", "winking face"],
  u: "1f609",
  a: "0.6"
}, {
  n: ["blush", "smiling face with smiling eyes"],
  u: "1f60a",
  a: "0.6"
}, {
  n: ["innocent", "smiling face with halo"],
  u: "1f607",
  a: "1.0"
}, {
  n: ["smiling face with 3 hearts", "smiling face with smiling eyes and three hearts"],
  u: "1f970",
  a: "11.0"
}, {
  n: ["heart eyes", "smiling face with heart-shaped eyes"],
  u: "1f60d",
  a: "0.6"
}, {
  n: ["star-struck", "grinning face with star eyes"],
  u: "1f929",
  a: "5.0"
}, {
  n: ["kissing heart", "face throwing a kiss"],
  u: "1f618",
  a: "0.6"
}, {
  n: ["kissing", "kissing face"],
  u: "1f617",
  a: "1.0"
}, {
  n: ["relaxed", "white smiling face"],
  u: "263a-fe0f",
  a: "0.6"
}, {
  n: ["kissing closed eyes", "kissing face with closed eyes"],
  u: "1f61a",
  a: "0.6"
}, {
  n: ["kissing smiling eyes", "kissing face with smiling eyes"],
  u: "1f619",
  a: "1.0"
}, {
  n: ["smiling face with tear"],
  u: "1f972",
  a: "13.0"
}, {
  n: ["yum", "face savouring delicious food"],
  u: "1f60b",
  a: "0.6"
}, {
  n: ["stuck out tongue", "face with stuck-out tongue"],
  u: "1f61b",
  a: "1.0"
}, {
  n: ["stuck out tongue winking eye", "face with stuck-out tongue and winking eye"],
  u: "1f61c",
  a: "0.6"
}, {
  n: ["zany face", "grinning face with one large and one small eye"],
  u: "1f92a",
  a: "5.0"
}, {
  n: ["stuck out tongue closed eyes", "face with stuck-out tongue and tightly-closed eyes"],
  u: "1f61d",
  a: "0.6"
}, {
  n: ["money-mouth face", "money mouth face"],
  u: "1f911",
  a: "1.0"
}, {
  n: ["hugging face"],
  u: "1f917",
  a: "1.0"
}, {
  n: ["face with hand over mouth", "smiling face with smiling eyes and hand covering mouth"],
  u: "1f92d",
  a: "5.0"
}, {
  n: ["face with open eyes and hand over mouth"],
  u: "1fae2",
  a: "14.0"
}, {
  n: ["face with peeking eye"],
  u: "1fae3",
  a: "14.0"
}, {
  n: ["shushing face", "face with finger covering closed lips"],
  u: "1f92b",
  a: "5.0"
}, {
  n: ["thinking face"],
  u: "1f914",
  a: "1.0"
}, {
  n: ["saluting face"],
  u: "1fae1",
  a: "14.0"
}, {
  n: ["zipper-mouth face", "zipper mouth face"],
  u: "1f910",
  a: "1.0"
}, {
  n: ["face with raised eyebrow", "face with one eyebrow raised"],
  u: "1f928",
  a: "5.0"
}, {
  n: ["neutral face"],
  u: "1f610",
  a: "0.7"
}, {
  n: ["expressionless", "expressionless face"],
  u: "1f611",
  a: "1.0"
}, {
  n: ["no mouth", "face without mouth"],
  u: "1f636",
  a: "1.0"
}, {
  n: ["dotted line face"],
  u: "1fae5",
  a: "14.0"
}, {
  n: ["face in clouds"],
  u: "1f636-200d-1f32b-fe0f",
  a: "13.1"
}, {
  n: ["smirk", "smirking face"],
  u: "1f60f",
  a: "0.6"
}, {
  n: ["unamused", "unamused face"],
  u: "1f612",
  a: "0.6"
}, {
  n: ["face with rolling eyes"],
  u: "1f644",
  a: "1.0"
}, {
  n: ["grimacing", "grimacing face"],
  u: "1f62c",
  a: "1.0"
}, {
  n: ["face exhaling"],
  u: "1f62e-200d-1f4a8",
  a: "13.1"
}, {
  n: ["lying face"],
  u: "1f925",
  a: "3.0"
}, {
  n: ["relieved", "relieved face"],
  u: "1f60c",
  a: "0.6"
}, {
  n: ["pensive", "pensive face"],
  u: "1f614",
  a: "0.6"
}, {
  n: ["sleepy", "sleepy face"],
  u: "1f62a",
  a: "0.6"
}, {
  n: ["drooling face"],
  u: "1f924",
  a: "3.0"
}, {
  n: ["sleeping", "sleeping face"],
  u: "1f634",
  a: "1.0"
}, {
  n: ["mask", "face with medical mask"],
  u: "1f637",
  a: "0.6"
}, {
  n: ["face with thermometer"],
  u: "1f912",
  a: "1.0"
}, {
  n: ["face with head-bandage", "face with head bandage"],
  u: "1f915",
  a: "1.0"
}, {
  n: ["nauseated face"],
  u: "1f922",
  a: "3.0"
}, {
  n: ["face vomiting", "face with open mouth vomiting"],
  u: "1f92e",
  a: "5.0"
}, {
  n: ["sneezing face"],
  u: "1f927",
  a: "3.0"
}, {
  n: ["hot face", "overheated face"],
  u: "1f975",
  a: "11.0"
}, {
  n: ["cold face", "freezing face"],
  u: "1f976",
  a: "11.0"
}, {
  n: ["woozy face", "face with uneven eyes and wavy mouth"],
  u: "1f974",
  a: "11.0"
}, {
  n: ["dizzy face"],
  u: "1f635",
  a: "0.6"
}, {
  n: ["face with spiral eyes"],
  u: "1f635-200d-1f4ab",
  a: "13.1"
}, {
  n: ["exploding head", "shocked face with exploding head"],
  u: "1f92f",
  a: "5.0"
}, {
  n: ["face with cowboy hat"],
  u: "1f920",
  a: "3.0"
}, {
  n: ["partying face", "face with party horn and party hat"],
  u: "1f973",
  a: "11.0"
}, {
  n: ["disguised face"],
  u: "1f978",
  a: "13.0"
}, {
  n: ["sunglasses", "smiling face with sunglasses"],
  u: "1f60e",
  a: "1.0"
}, {
  n: ["nerd face"],
  u: "1f913",
  a: "1.0"
}, {
  n: ["face with monocle"],
  u: "1f9d0",
  a: "5.0"
}, {
  n: ["confused", "confused face"],
  u: "1f615",
  a: "1.0"
}, {
  n: ["face with diagonal mouth"],
  u: "1fae4",
  a: "14.0"
}, {
  n: ["worried", "worried face"],
  u: "1f61f",
  a: "1.0"
}, {
  n: ["slightly frowning face"],
  u: "1f641",
  a: "1.0"
}, {
  n: ["frowning face", "white frowning face"],
  u: "2639-fe0f",
  a: "0.7"
}, {
  n: ["open mouth", "face with open mouth"],
  u: "1f62e",
  a: "1.0"
}, {
  n: ["hushed", "hushed face"],
  u: "1f62f",
  a: "1.0"
}, {
  n: ["astonished", "astonished face"],
  u: "1f632",
  a: "0.6"
}, {
  n: ["flushed", "flushed face"],
  u: "1f633",
  a: "0.6"
}, {
  n: ["pleading face", "face with pleading eyes"],
  u: "1f97a",
  a: "11.0"
}, {
  n: ["face holding back tears"],
  u: "1f979",
  a: "14.0"
}, {
  n: ["frowning", "frowning face with open mouth"],
  u: "1f626",
  a: "1.0"
}, {
  n: ["anguished", "anguished face"],
  u: "1f627",
  a: "1.0"
}, {
  n: ["fearful", "fearful face"],
  u: "1f628",
  a: "0.6"
}, {
  n: ["cold sweat", "face with open mouth and cold sweat"],
  u: "1f630",
  a: "0.6"
}, {
  n: ["disappointed relieved", "disappointed but relieved face"],
  u: "1f625",
  a: "0.6"
}, {
  n: ["cry", "crying face"],
  u: "1f622",
  a: "0.6"
}, {
  n: ["sob", "loudly crying face"],
  u: "1f62d",
  a: "0.6"
}, {
  n: ["scream", "face screaming in fear"],
  u: "1f631",
  a: "0.6"
}, {
  n: ["confounded", "confounded face"],
  u: "1f616",
  a: "0.6"
}, {
  n: ["persevere", "persevering face"],
  u: "1f623",
  a: "0.6"
}, {
  n: ["disappointed", "disappointed face"],
  u: "1f61e",
  a: "0.6"
}, {
  n: ["sweat", "face with cold sweat"],
  u: "1f613",
  a: "0.6"
}, {
  n: ["weary", "weary face"],
  u: "1f629",
  a: "0.6"
}, {
  n: ["tired face"],
  u: "1f62b",
  a: "0.6"
}, {
  n: ["yawning face"],
  u: "1f971",
  a: "12.0"
}, {
  n: ["triumph", "face with look of triumph"],
  u: "1f624",
  a: "0.6"
}, {
  n: ["rage", "pouting face"],
  u: "1f621",
  a: "0.6"
}, {
  n: ["angry", "angry face"],
  u: "1f620",
  a: "0.6"
}, {
  n: ["face with symbols on mouth", "serious face with symbols covering mouth"],
  u: "1f92c",
  a: "5.0"
}, {
  n: ["smiling imp", "smiling face with horns"],
  u: "1f608",
  a: "1.0"
}, {
  n: ["imp"],
  u: "1f47f",
  a: "0.6"
}, {
  n: ["skull"],
  u: "1f480",
  a: "0.6"
}, {
  n: ["skull and crossbones"],
  u: "2620-fe0f",
  a: "1.0"
}, {
  n: ["poop", "shit", "hankey", "pile of poo"],
  u: "1f4a9",
  a: "0.6"
}, {
  n: ["clown face"],
  u: "1f921",
  a: "3.0"
}, {
  n: ["japanese ogre"],
  u: "1f479",
  a: "0.6"
}, {
  n: ["japanese goblin"],
  u: "1f47a",
  a: "0.6"
}, {
  n: ["ghost"],
  u: "1f47b",
  a: "0.6"
}, {
  n: ["alien", "extraterrestrial alien"],
  u: "1f47d",
  a: "0.6"
}, {
  n: ["alien monster", "space invader"],
  u: "1f47e",
  a: "0.6"
}, {
  n: ["robot face"],
  u: "1f916",
  a: "1.0"
}, {
  n: ["smiley cat", "smiling cat face with open mouth"],
  u: "1f63a",
  a: "0.6"
}, {
  n: ["smile cat", "grinning cat face with smiling eyes"],
  u: "1f638",
  a: "0.6"
}, {
  n: ["joy cat", "cat face with tears of joy"],
  u: "1f639",
  a: "0.6"
}, {
  n: ["heart eyes cat", "smiling cat face with heart-shaped eyes"],
  u: "1f63b",
  a: "0.6"
}, {
  n: ["smirk cat", "cat face with wry smile"],
  u: "1f63c",
  a: "0.6"
}, {
  n: ["kissing cat", "kissing cat face with closed eyes"],
  u: "1f63d",
  a: "0.6"
}, {
  n: ["scream cat", "weary cat face"],
  u: "1f640",
  a: "0.6"
}, {
  n: ["crying cat face"],
  u: "1f63f",
  a: "0.6"
}, {
  n: ["pouting cat", "pouting cat face"],
  u: "1f63e",
  a: "0.6"
}, {
  n: ["see no evil", "see-no-evil monkey"],
  u: "1f648",
  a: "0.6"
}, {
  n: ["hear no evil", "hear-no-evil monkey"],
  u: "1f649",
  a: "0.6"
}, {
  n: ["speak no evil", "speak-no-evil monkey"],
  u: "1f64a",
  a: "0.6"
}, {
  n: ["kiss", "kiss mark"],
  u: "1f48b",
  a: "0.6"
}, {
  n: ["love letter"],
  u: "1f48c",
  a: "0.6"
}, {
  n: ["cupid", "heart with arrow"],
  u: "1f498",
  a: "0.6"
}, {
  n: ["gift heart", "heart with ribbon"],
  u: "1f49d",
  a: "0.6"
}, {
  n: ["sparkling heart"],
  u: "1f496",
  a: "0.6"
}, {
  n: ["heartpulse", "growing heart"],
  u: "1f497",
  a: "0.6"
}, {
  n: ["heartbeat", "beating heart"],
  u: "1f493",
  a: "0.6"
}, {
  n: ["revolving hearts"],
  u: "1f49e",
  a: "0.6"
}, {
  n: ["two hearts"],
  u: "1f495",
  a: "0.6"
}, {
  n: ["heart decoration"],
  u: "1f49f",
  a: "0.6"
}, {
  n: ["heart exclamation", "heavy heart exclamation mark ornament"],
  u: "2763-fe0f",
  a: "1.0"
}, {
  n: ["broken heart"],
  u: "1f494",
  a: "0.6"
}, {
  n: ["heart on fire"],
  u: "2764-fe0f-200d-1f525",
  a: "13.1"
}, {
  n: ["mending heart"],
  u: "2764-fe0f-200d-1fa79",
  a: "13.1"
}, {
  n: ["heart", "heavy black heart"],
  u: "2764-fe0f",
  a: "0.6"
}, {
  n: ["orange heart"],
  u: "1f9e1",
  a: "5.0"
}, {
  n: ["yellow heart"],
  u: "1f49b",
  a: "0.6"
}, {
  n: ["green heart"],
  u: "1f49a",
  a: "0.6"
}, {
  n: ["blue heart"],
  u: "1f499",
  a: "0.6"
}, {
  n: ["purple heart"],
  u: "1f49c",
  a: "0.6"
}, {
  n: ["brown heart"],
  u: "1f90e",
  a: "12.0"
}, {
  n: ["black heart"],
  u: "1f5a4",
  a: "3.0"
}, {
  n: ["white heart"],
  u: "1f90d",
  a: "12.0"
}, {
  n: ["100", "hundred points symbol"],
  u: "1f4af",
  a: "0.6"
}, {
  n: ["anger", "anger symbol"],
  u: "1f4a2",
  a: "0.6"
}, {
  n: ["boom", "collision", "collision symbol"],
  u: "1f4a5",
  a: "0.6"
}, {
  n: ["dizzy", "dizzy symbol"],
  u: "1f4ab",
  a: "0.6"
}, {
  n: ["sweat drops", "splashing sweat symbol"],
  u: "1f4a6",
  a: "0.6"
}, {
  n: ["dash", "dash symbol"],
  u: "1f4a8",
  a: "0.6"
}, {
  n: ["hole"],
  u: "1f573-fe0f",
  a: "0.7"
}, {
  n: ["bomb"],
  u: "1f4a3",
  a: "0.6"
}, {
  n: ["speech balloon"],
  u: "1f4ac",
  a: "0.6"
}, {
  n: ["eye in speech bubble", "eye-in-speech-bubble"],
  u: "1f441-fe0f-200d-1f5e8-fe0f",
  a: "2.0"
}, {
  n: ["left speech bubble"],
  u: "1f5e8-fe0f",
  a: "2.0"
}, {
  n: ["right anger bubble"],
  u: "1f5ef-fe0f",
  a: "0.7"
}, {
  n: ["thought balloon"],
  u: "1f4ad",
  a: "1.0"
}, {
  n: ["zzz", "sleeping symbol"],
  u: "1f4a4",
  a: "0.6"
}, {
  n: ["wave", "waving hand sign"],
  u: "1f44b",
  v: ["1f44b-1f3fb", "1f44b-1f3fc", "1f44b-1f3fd", "1f44b-1f3fe", "1f44b-1f3ff"],
  a: "0.6"
}, {
  n: ["raised back of hand"],
  u: "1f91a",
  v: ["1f91a-1f3fb", "1f91a-1f3fc", "1f91a-1f3fd", "1f91a-1f3fe", "1f91a-1f3ff"],
  a: "3.0"
}, {
  n: ["hand with fingers splayed", "raised hand with fingers splayed"],
  u: "1f590-fe0f",
  v: ["1f590-1f3fb", "1f590-1f3fc", "1f590-1f3fd", "1f590-1f3fe", "1f590-1f3ff"],
  a: "0.7"
}, {
  n: ["hand", "raised hand"],
  u: "270b",
  v: ["270b-1f3fb", "270b-1f3fc", "270b-1f3fd", "270b-1f3fe", "270b-1f3ff"],
  a: "0.6"
}, {
  n: ["spock-hand", "raised hand with part between middle and ring fingers"],
  u: "1f596",
  v: ["1f596-1f3fb", "1f596-1f3fc", "1f596-1f3fd", "1f596-1f3fe", "1f596-1f3ff"],
  a: "1.0"
}, {
  n: ["rightwards hand"],
  u: "1faf1",
  v: ["1faf1-1f3fb", "1faf1-1f3fc", "1faf1-1f3fd", "1faf1-1f3fe", "1faf1-1f3ff"],
  a: "14.0"
}, {
  n: ["leftwards hand"],
  u: "1faf2",
  v: ["1faf2-1f3fb", "1faf2-1f3fc", "1faf2-1f3fd", "1faf2-1f3fe", "1faf2-1f3ff"],
  a: "14.0"
}, {
  n: ["palm down hand"],
  u: "1faf3",
  v: ["1faf3-1f3fb", "1faf3-1f3fc", "1faf3-1f3fd", "1faf3-1f3fe", "1faf3-1f3ff"],
  a: "14.0"
}, {
  n: ["palm up hand"],
  u: "1faf4",
  v: ["1faf4-1f3fb", "1faf4-1f3fc", "1faf4-1f3fd", "1faf4-1f3fe", "1faf4-1f3ff"],
  a: "14.0"
}, {
  n: ["ok hand", "ok hand sign"],
  u: "1f44c",
  v: ["1f44c-1f3fb", "1f44c-1f3fc", "1f44c-1f3fd", "1f44c-1f3fe", "1f44c-1f3ff"],
  a: "0.6"
}, {
  n: ["pinched fingers"],
  u: "1f90c",
  v: ["1f90c-1f3fb", "1f90c-1f3fc", "1f90c-1f3fd", "1f90c-1f3fe", "1f90c-1f3ff"],
  a: "13.0"
}, {
  n: ["pinching hand"],
  u: "1f90f",
  v: ["1f90f-1f3fb", "1f90f-1f3fc", "1f90f-1f3fd", "1f90f-1f3fe", "1f90f-1f3ff"],
  a: "12.0"
}, {
  n: ["v", "victory hand"],
  u: "270c-fe0f",
  v: ["270c-1f3fb", "270c-1f3fc", "270c-1f3fd", "270c-1f3fe", "270c-1f3ff"],
  a: "0.6"
}, {
  n: ["crossed fingers", "hand with index and middle fingers crossed"],
  u: "1f91e",
  v: ["1f91e-1f3fb", "1f91e-1f3fc", "1f91e-1f3fd", "1f91e-1f3fe", "1f91e-1f3ff"],
  a: "3.0"
}, {
  n: ["hand with index finger and thumb crossed"],
  u: "1faf0",
  v: ["1faf0-1f3fb", "1faf0-1f3fc", "1faf0-1f3fd", "1faf0-1f3fe", "1faf0-1f3ff"],
  a: "14.0"
}, {
  n: ["i love you hand sign"],
  u: "1f91f",
  v: ["1f91f-1f3fb", "1f91f-1f3fc", "1f91f-1f3fd", "1f91f-1f3fe", "1f91f-1f3ff"],
  a: "5.0"
}, {
  n: ["the horns", "sign of the horns"],
  u: "1f918",
  v: ["1f918-1f3fb", "1f918-1f3fc", "1f918-1f3fd", "1f918-1f3fe", "1f918-1f3ff"],
  a: "1.0"
}, {
  n: ["call me hand"],
  u: "1f919",
  v: ["1f919-1f3fb", "1f919-1f3fc", "1f919-1f3fd", "1f919-1f3fe", "1f919-1f3ff"],
  a: "3.0"
}, {
  n: ["point left", "white left pointing backhand index"],
  u: "1f448",
  v: ["1f448-1f3fb", "1f448-1f3fc", "1f448-1f3fd", "1f448-1f3fe", "1f448-1f3ff"],
  a: "0.6"
}, {
  n: ["point right", "white right pointing backhand index"],
  u: "1f449",
  v: ["1f449-1f3fb", "1f449-1f3fc", "1f449-1f3fd", "1f449-1f3fe", "1f449-1f3ff"],
  a: "0.6"
}, {
  n: ["point up 2", "white up pointing backhand index"],
  u: "1f446",
  v: ["1f446-1f3fb", "1f446-1f3fc", "1f446-1f3fd", "1f446-1f3fe", "1f446-1f3ff"],
  a: "0.6"
}, {
  n: ["middle finger", "reversed hand with middle finger extended"],
  u: "1f595",
  v: ["1f595-1f3fb", "1f595-1f3fc", "1f595-1f3fd", "1f595-1f3fe", "1f595-1f3ff"],
  a: "1.0"
}, {
  n: ["point down", "white down pointing backhand index"],
  u: "1f447",
  v: ["1f447-1f3fb", "1f447-1f3fc", "1f447-1f3fd", "1f447-1f3fe", "1f447-1f3ff"],
  a: "0.6"
}, {
  n: ["point up", "white up pointing index"],
  u: "261d-fe0f",
  v: ["261d-1f3fb", "261d-1f3fc", "261d-1f3fd", "261d-1f3fe", "261d-1f3ff"],
  a: "0.6"
}, {
  n: ["index pointing at the viewer"],
  u: "1faf5",
  v: ["1faf5-1f3fb", "1faf5-1f3fc", "1faf5-1f3fd", "1faf5-1f3fe", "1faf5-1f3ff"],
  a: "14.0"
}, {
  n: ["+1", "thumbsup", "thumbs up sign"],
  u: "1f44d",
  v: ["1f44d-1f3fb", "1f44d-1f3fc", "1f44d-1f3fd", "1f44d-1f3fe", "1f44d-1f3ff"],
  a: "0.6"
}, {
  n: ["-1", "thumbsdown", "thumbs down sign"],
  u: "1f44e",
  v: ["1f44e-1f3fb", "1f44e-1f3fc", "1f44e-1f3fd", "1f44e-1f3fe", "1f44e-1f3ff"],
  a: "0.6"
}, {
  n: ["fist", "raised fist"],
  u: "270a",
  v: ["270a-1f3fb", "270a-1f3fc", "270a-1f3fd", "270a-1f3fe", "270a-1f3ff"],
  a: "0.6"
}, {
  n: ["punch", "facepunch", "fisted hand sign"],
  u: "1f44a",
  v: ["1f44a-1f3fb", "1f44a-1f3fc", "1f44a-1f3fd", "1f44a-1f3fe", "1f44a-1f3ff"],
  a: "0.6"
}, {
  n: ["left-facing fist"],
  u: "1f91b",
  v: ["1f91b-1f3fb", "1f91b-1f3fc", "1f91b-1f3fd", "1f91b-1f3fe", "1f91b-1f3ff"],
  a: "3.0"
}, {
  n: ["right-facing fist"],
  u: "1f91c",
  v: ["1f91c-1f3fb", "1f91c-1f3fc", "1f91c-1f3fd", "1f91c-1f3fe", "1f91c-1f3ff"],
  a: "3.0"
}, {
  n: ["clap", "clapping hands sign"],
  u: "1f44f",
  v: ["1f44f-1f3fb", "1f44f-1f3fc", "1f44f-1f3fd", "1f44f-1f3fe", "1f44f-1f3ff"],
  a: "0.6"
}, {
  n: ["raised hands", "person raising both hands in celebration"],
  u: "1f64c",
  v: ["1f64c-1f3fb", "1f64c-1f3fc", "1f64c-1f3fd", "1f64c-1f3fe", "1f64c-1f3ff"],
  a: "0.6"
}, {
  n: ["heart hands"],
  u: "1faf6",
  v: ["1faf6-1f3fb", "1faf6-1f3fc", "1faf6-1f3fd", "1faf6-1f3fe", "1faf6-1f3ff"],
  a: "14.0"
}, {
  n: ["open hands", "open hands sign"],
  u: "1f450",
  v: ["1f450-1f3fb", "1f450-1f3fc", "1f450-1f3fd", "1f450-1f3fe", "1f450-1f3ff"],
  a: "0.6"
}, {
  n: ["palms up together"],
  u: "1f932",
  v: ["1f932-1f3fb", "1f932-1f3fc", "1f932-1f3fd", "1f932-1f3fe", "1f932-1f3ff"],
  a: "5.0"
}, {
  n: ["handshake"],
  u: "1f91d",
  v: ["1f91d-1f3fb", "1f91d-1f3fc", "1f91d-1f3fd", "1f91d-1f3fe", "1f91d-1f3ff", "1faf1-1f3fb-200d-1faf2-1f3fc", "1faf1-1f3fb-200d-1faf2-1f3fd", "1faf1-1f3fb-200d-1faf2-1f3fe", "1faf1-1f3fb-200d-1faf2-1f3ff", "1faf1-1f3fc-200d-1faf2-1f3fb", "1faf1-1f3fc-200d-1faf2-1f3fd", "1faf1-1f3fc-200d-1faf2-1f3fe", "1faf1-1f3fc-200d-1faf2-1f3ff", "1faf1-1f3fd-200d-1faf2-1f3fb", "1faf1-1f3fd-200d-1faf2-1f3fc", "1faf1-1f3fd-200d-1faf2-1f3fe", "1faf1-1f3fd-200d-1faf2-1f3ff", "1faf1-1f3fe-200d-1faf2-1f3fb", "1faf1-1f3fe-200d-1faf2-1f3fc", "1faf1-1f3fe-200d-1faf2-1f3fd", "1faf1-1f3fe-200d-1faf2-1f3ff", "1faf1-1f3ff-200d-1faf2-1f3fb", "1faf1-1f3ff-200d-1faf2-1f3fc", "1faf1-1f3ff-200d-1faf2-1f3fd", "1faf1-1f3ff-200d-1faf2-1f3fe"],
  a: "3.0"
}, {
  n: ["pray", "person with folded hands"],
  u: "1f64f",
  v: ["1f64f-1f3fb", "1f64f-1f3fc", "1f64f-1f3fd", "1f64f-1f3fe", "1f64f-1f3ff"],
  a: "0.6"
}, {
  n: ["writing hand"],
  u: "270d-fe0f",
  v: ["270d-1f3fb", "270d-1f3fc", "270d-1f3fd", "270d-1f3fe", "270d-1f3ff"],
  a: "0.7"
}, {
  n: ["nail care", "nail polish"],
  u: "1f485",
  v: ["1f485-1f3fb", "1f485-1f3fc", "1f485-1f3fd", "1f485-1f3fe", "1f485-1f3ff"],
  a: "0.6"
}, {
  n: ["selfie"],
  u: "1f933",
  v: ["1f933-1f3fb", "1f933-1f3fc", "1f933-1f3fd", "1f933-1f3fe", "1f933-1f3ff"],
  a: "3.0"
}, {
  n: ["muscle", "flexed biceps"],
  u: "1f4aa",
  v: ["1f4aa-1f3fb", "1f4aa-1f3fc", "1f4aa-1f3fd", "1f4aa-1f3fe", "1f4aa-1f3ff"],
  a: "0.6"
}, {
  n: ["mechanical arm"],
  u: "1f9be",
  a: "12.0"
}, {
  n: ["mechanical leg"],
  u: "1f9bf",
  a: "12.0"
}, {
  n: ["leg"],
  u: "1f9b5",
  v: ["1f9b5-1f3fb", "1f9b5-1f3fc", "1f9b5-1f3fd", "1f9b5-1f3fe", "1f9b5-1f3ff"],
  a: "11.0"
}, {
  n: ["foot"],
  u: "1f9b6",
  v: ["1f9b6-1f3fb", "1f9b6-1f3fc", "1f9b6-1f3fd", "1f9b6-1f3fe", "1f9b6-1f3ff"],
  a: "11.0"
}, {
  n: ["ear"],
  u: "1f442",
  v: ["1f442-1f3fb", "1f442-1f3fc", "1f442-1f3fd", "1f442-1f3fe", "1f442-1f3ff"],
  a: "0.6"
}, {
  n: ["ear with hearing aid"],
  u: "1f9bb",
  v: ["1f9bb-1f3fb", "1f9bb-1f3fc", "1f9bb-1f3fd", "1f9bb-1f3fe", "1f9bb-1f3ff"],
  a: "12.0"
}, {
  n: ["nose"],
  u: "1f443",
  v: ["1f443-1f3fb", "1f443-1f3fc", "1f443-1f3fd", "1f443-1f3fe", "1f443-1f3ff"],
  a: "0.6"
}, {
  n: ["brain"],
  u: "1f9e0",
  a: "5.0"
}, {
  n: ["anatomical heart"],
  u: "1fac0",
  a: "13.0"
}, {
  n: ["lungs"],
  u: "1fac1",
  a: "13.0"
}, {
  n: ["tooth"],
  u: "1f9b7",
  a: "11.0"
}, {
  n: ["bone"],
  u: "1f9b4",
  a: "11.0"
}, {
  n: ["eyes"],
  u: "1f440",
  a: "0.6"
}, {
  n: ["eye"],
  u: "1f441-fe0f",
  a: "0.7"
}, {
  n: ["tongue"],
  u: "1f445",
  a: "0.6"
}, {
  n: ["lips", "mouth"],
  u: "1f444",
  a: "0.6"
}, {
  n: ["biting lip"],
  u: "1fae6",
  a: "14.0"
}, {
  n: ["baby"],
  u: "1f476",
  v: ["1f476-1f3fb", "1f476-1f3fc", "1f476-1f3fd", "1f476-1f3fe", "1f476-1f3ff"],
  a: "0.6"
}, {
  n: ["child"],
  u: "1f9d2",
  v: ["1f9d2-1f3fb", "1f9d2-1f3fc", "1f9d2-1f3fd", "1f9d2-1f3fe", "1f9d2-1f3ff"],
  a: "5.0"
}, {
  n: ["boy"],
  u: "1f466",
  v: ["1f466-1f3fb", "1f466-1f3fc", "1f466-1f3fd", "1f466-1f3fe", "1f466-1f3ff"],
  a: "0.6"
}, {
  n: ["girl"],
  u: "1f467",
  v: ["1f467-1f3fb", "1f467-1f3fc", "1f467-1f3fd", "1f467-1f3fe", "1f467-1f3ff"],
  a: "0.6"
}, {
  n: ["adult"],
  u: "1f9d1",
  v: ["1f9d1-1f3fb", "1f9d1-1f3fc", "1f9d1-1f3fd", "1f9d1-1f3fe", "1f9d1-1f3ff"],
  a: "5.0"
}, {
  n: ["person with blond hair"],
  u: "1f471",
  v: ["1f471-1f3fb", "1f471-1f3fc", "1f471-1f3fd", "1f471-1f3fe", "1f471-1f3ff"],
  a: "0.6"
}, {
  n: ["man"],
  u: "1f468",
  v: ["1f468-1f3fb", "1f468-1f3fc", "1f468-1f3fd", "1f468-1f3fe", "1f468-1f3ff"],
  a: "0.6"
}, {
  n: ["bearded person"],
  u: "1f9d4",
  v: ["1f9d4-1f3fb", "1f9d4-1f3fc", "1f9d4-1f3fd", "1f9d4-1f3fe", "1f9d4-1f3ff"],
  a: "5.0"
}, {
  n: ["man: beard", "man with beard"],
  u: "1f9d4-200d-2642-fe0f",
  v: ["1f9d4-1f3fb-200d-2642-fe0f", "1f9d4-1f3fc-200d-2642-fe0f", "1f9d4-1f3fd-200d-2642-fe0f", "1f9d4-1f3fe-200d-2642-fe0f", "1f9d4-1f3ff-200d-2642-fe0f"],
  a: "13.1"
}, {
  n: ["woman: beard", "woman with beard"],
  u: "1f9d4-200d-2640-fe0f",
  v: ["1f9d4-1f3fb-200d-2640-fe0f", "1f9d4-1f3fc-200d-2640-fe0f", "1f9d4-1f3fd-200d-2640-fe0f", "1f9d4-1f3fe-200d-2640-fe0f", "1f9d4-1f3ff-200d-2640-fe0f"],
  a: "13.1"
}, {
  n: ["man: red hair", "red haired man"],
  u: "1f468-200d-1f9b0",
  v: ["1f468-1f3fb-200d-1f9b0", "1f468-1f3fc-200d-1f9b0", "1f468-1f3fd-200d-1f9b0", "1f468-1f3fe-200d-1f9b0", "1f468-1f3ff-200d-1f9b0"],
  a: "11.0"
}, {
  n: ["man: curly hair", "curly haired man"],
  u: "1f468-200d-1f9b1",
  v: ["1f468-1f3fb-200d-1f9b1", "1f468-1f3fc-200d-1f9b1", "1f468-1f3fd-200d-1f9b1", "1f468-1f3fe-200d-1f9b1", "1f468-1f3ff-200d-1f9b1"],
  a: "11.0"
}, {
  n: ["man: white hair", "white haired man"],
  u: "1f468-200d-1f9b3",
  v: ["1f468-1f3fb-200d-1f9b3", "1f468-1f3fc-200d-1f9b3", "1f468-1f3fd-200d-1f9b3", "1f468-1f3fe-200d-1f9b3", "1f468-1f3ff-200d-1f9b3"],
  a: "11.0"
}, {
  n: ["bald man", "man: bald"],
  u: "1f468-200d-1f9b2",
  v: ["1f468-1f3fb-200d-1f9b2", "1f468-1f3fc-200d-1f9b2", "1f468-1f3fd-200d-1f9b2", "1f468-1f3fe-200d-1f9b2", "1f468-1f3ff-200d-1f9b2"],
  a: "11.0"
}, {
  n: ["woman"],
  u: "1f469",
  v: ["1f469-1f3fb", "1f469-1f3fc", "1f469-1f3fd", "1f469-1f3fe", "1f469-1f3ff"],
  a: "0.6"
}, {
  n: ["woman: red hair", "red haired woman"],
  u: "1f469-200d-1f9b0",
  v: ["1f469-1f3fb-200d-1f9b0", "1f469-1f3fc-200d-1f9b0", "1f469-1f3fd-200d-1f9b0", "1f469-1f3fe-200d-1f9b0", "1f469-1f3ff-200d-1f9b0"],
  a: "11.0"
}, {
  n: ["person: red hair", "red haired person"],
  u: "1f9d1-200d-1f9b0",
  v: ["1f9d1-1f3fb-200d-1f9b0", "1f9d1-1f3fc-200d-1f9b0", "1f9d1-1f3fd-200d-1f9b0", "1f9d1-1f3fe-200d-1f9b0", "1f9d1-1f3ff-200d-1f9b0"],
  a: "12.1"
}, {
  n: ["woman: curly hair", "curly haired woman"],
  u: "1f469-200d-1f9b1",
  v: ["1f469-1f3fb-200d-1f9b1", "1f469-1f3fc-200d-1f9b1", "1f469-1f3fd-200d-1f9b1", "1f469-1f3fe-200d-1f9b1", "1f469-1f3ff-200d-1f9b1"],
  a: "11.0"
}, {
  n: ["person: curly hair", "curly haired person"],
  u: "1f9d1-200d-1f9b1",
  v: ["1f9d1-1f3fb-200d-1f9b1", "1f9d1-1f3fc-200d-1f9b1", "1f9d1-1f3fd-200d-1f9b1", "1f9d1-1f3fe-200d-1f9b1", "1f9d1-1f3ff-200d-1f9b1"],
  a: "12.1"
}, {
  n: ["woman: white hair", "white haired woman"],
  u: "1f469-200d-1f9b3",
  v: ["1f469-1f3fb-200d-1f9b3", "1f469-1f3fc-200d-1f9b3", "1f469-1f3fd-200d-1f9b3", "1f469-1f3fe-200d-1f9b3", "1f469-1f3ff-200d-1f9b3"],
  a: "11.0"
}, {
  n: ["person: white hair", "white haired person"],
  u: "1f9d1-200d-1f9b3",
  v: ["1f9d1-1f3fb-200d-1f9b3", "1f9d1-1f3fc-200d-1f9b3", "1f9d1-1f3fd-200d-1f9b3", "1f9d1-1f3fe-200d-1f9b3", "1f9d1-1f3ff-200d-1f9b3"],
  a: "12.1"
}, {
  n: ["bald woman", "woman: bald"],
  u: "1f469-200d-1f9b2",
  v: ["1f469-1f3fb-200d-1f9b2", "1f469-1f3fc-200d-1f9b2", "1f469-1f3fd-200d-1f9b2", "1f469-1f3fe-200d-1f9b2", "1f469-1f3ff-200d-1f9b2"],
  a: "11.0"
}, {
  n: ["bald person", "person: bald"],
  u: "1f9d1-200d-1f9b2",
  v: ["1f9d1-1f3fb-200d-1f9b2", "1f9d1-1f3fc-200d-1f9b2", "1f9d1-1f3fd-200d-1f9b2", "1f9d1-1f3fe-200d-1f9b2", "1f9d1-1f3ff-200d-1f9b2"],
  a: "12.1"
}, {
  n: ["woman: blond hair", "blond-haired-woman"],
  u: "1f471-200d-2640-fe0f",
  v: ["1f471-1f3fb-200d-2640-fe0f", "1f471-1f3fc-200d-2640-fe0f", "1f471-1f3fd-200d-2640-fe0f", "1f471-1f3fe-200d-2640-fe0f", "1f471-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["man: blond hair", "blond-haired-man"],
  u: "1f471-200d-2642-fe0f",
  v: ["1f471-1f3fb-200d-2642-fe0f", "1f471-1f3fc-200d-2642-fe0f", "1f471-1f3fd-200d-2642-fe0f", "1f471-1f3fe-200d-2642-fe0f", "1f471-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["older adult"],
  u: "1f9d3",
  v: ["1f9d3-1f3fb", "1f9d3-1f3fc", "1f9d3-1f3fd", "1f9d3-1f3fe", "1f9d3-1f3ff"],
  a: "5.0"
}, {
  n: ["older man"],
  u: "1f474",
  v: ["1f474-1f3fb", "1f474-1f3fc", "1f474-1f3fd", "1f474-1f3fe", "1f474-1f3ff"],
  a: "0.6"
}, {
  n: ["older woman"],
  u: "1f475",
  v: ["1f475-1f3fb", "1f475-1f3fc", "1f475-1f3fd", "1f475-1f3fe", "1f475-1f3ff"],
  a: "0.6"
}, {
  n: ["person frowning"],
  u: "1f64d",
  v: ["1f64d-1f3fb", "1f64d-1f3fc", "1f64d-1f3fd", "1f64d-1f3fe", "1f64d-1f3ff"],
  a: "0.6"
}, {
  n: ["man frowning", "man-frowning"],
  u: "1f64d-200d-2642-fe0f",
  v: ["1f64d-1f3fb-200d-2642-fe0f", "1f64d-1f3fc-200d-2642-fe0f", "1f64d-1f3fd-200d-2642-fe0f", "1f64d-1f3fe-200d-2642-fe0f", "1f64d-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman frowning", "woman-frowning"],
  u: "1f64d-200d-2640-fe0f",
  v: ["1f64d-1f3fb-200d-2640-fe0f", "1f64d-1f3fc-200d-2640-fe0f", "1f64d-1f3fd-200d-2640-fe0f", "1f64d-1f3fe-200d-2640-fe0f", "1f64d-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["person with pouting face"],
  u: "1f64e",
  v: ["1f64e-1f3fb", "1f64e-1f3fc", "1f64e-1f3fd", "1f64e-1f3fe", "1f64e-1f3ff"],
  a: "0.6"
}, {
  n: ["man pouting", "man-pouting"],
  u: "1f64e-200d-2642-fe0f",
  v: ["1f64e-1f3fb-200d-2642-fe0f", "1f64e-1f3fc-200d-2642-fe0f", "1f64e-1f3fd-200d-2642-fe0f", "1f64e-1f3fe-200d-2642-fe0f", "1f64e-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman pouting", "woman-pouting"],
  u: "1f64e-200d-2640-fe0f",
  v: ["1f64e-1f3fb-200d-2640-fe0f", "1f64e-1f3fc-200d-2640-fe0f", "1f64e-1f3fd-200d-2640-fe0f", "1f64e-1f3fe-200d-2640-fe0f", "1f64e-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["no good", "face with no good gesture"],
  u: "1f645",
  v: ["1f645-1f3fb", "1f645-1f3fc", "1f645-1f3fd", "1f645-1f3fe", "1f645-1f3ff"],
  a: "0.6"
}, {
  n: ["man gesturing no", "man-gesturing-no"],
  u: "1f645-200d-2642-fe0f",
  v: ["1f645-1f3fb-200d-2642-fe0f", "1f645-1f3fc-200d-2642-fe0f", "1f645-1f3fd-200d-2642-fe0f", "1f645-1f3fe-200d-2642-fe0f", "1f645-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman gesturing no", "woman-gesturing-no"],
  u: "1f645-200d-2640-fe0f",
  v: ["1f645-1f3fb-200d-2640-fe0f", "1f645-1f3fc-200d-2640-fe0f", "1f645-1f3fd-200d-2640-fe0f", "1f645-1f3fe-200d-2640-fe0f", "1f645-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["ok woman", "face with ok gesture"],
  u: "1f646",
  v: ["1f646-1f3fb", "1f646-1f3fc", "1f646-1f3fd", "1f646-1f3fe", "1f646-1f3ff"],
  a: "0.6"
}, {
  n: ["man gesturing ok", "man-gesturing-ok"],
  u: "1f646-200d-2642-fe0f",
  v: ["1f646-1f3fb-200d-2642-fe0f", "1f646-1f3fc-200d-2642-fe0f", "1f646-1f3fd-200d-2642-fe0f", "1f646-1f3fe-200d-2642-fe0f", "1f646-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman gesturing ok", "woman-gesturing-ok"],
  u: "1f646-200d-2640-fe0f",
  v: ["1f646-1f3fb-200d-2640-fe0f", "1f646-1f3fc-200d-2640-fe0f", "1f646-1f3fd-200d-2640-fe0f", "1f646-1f3fe-200d-2640-fe0f", "1f646-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["information desk person"],
  u: "1f481",
  v: ["1f481-1f3fb", "1f481-1f3fc", "1f481-1f3fd", "1f481-1f3fe", "1f481-1f3ff"],
  a: "0.6"
}, {
  n: ["man tipping hand", "man-tipping-hand"],
  u: "1f481-200d-2642-fe0f",
  v: ["1f481-1f3fb-200d-2642-fe0f", "1f481-1f3fc-200d-2642-fe0f", "1f481-1f3fd-200d-2642-fe0f", "1f481-1f3fe-200d-2642-fe0f", "1f481-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman tipping hand", "woman-tipping-hand"],
  u: "1f481-200d-2640-fe0f",
  v: ["1f481-1f3fb-200d-2640-fe0f", "1f481-1f3fc-200d-2640-fe0f", "1f481-1f3fd-200d-2640-fe0f", "1f481-1f3fe-200d-2640-fe0f", "1f481-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["raising hand", "happy person raising one hand"],
  u: "1f64b",
  v: ["1f64b-1f3fb", "1f64b-1f3fc", "1f64b-1f3fd", "1f64b-1f3fe", "1f64b-1f3ff"],
  a: "0.6"
}, {
  n: ["man raising hand", "man-raising-hand"],
  u: "1f64b-200d-2642-fe0f",
  v: ["1f64b-1f3fb-200d-2642-fe0f", "1f64b-1f3fc-200d-2642-fe0f", "1f64b-1f3fd-200d-2642-fe0f", "1f64b-1f3fe-200d-2642-fe0f", "1f64b-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman raising hand", "woman-raising-hand"],
  u: "1f64b-200d-2640-fe0f",
  v: ["1f64b-1f3fb-200d-2640-fe0f", "1f64b-1f3fc-200d-2640-fe0f", "1f64b-1f3fd-200d-2640-fe0f", "1f64b-1f3fe-200d-2640-fe0f", "1f64b-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["deaf person"],
  u: "1f9cf",
  v: ["1f9cf-1f3fb", "1f9cf-1f3fc", "1f9cf-1f3fd", "1f9cf-1f3fe", "1f9cf-1f3ff"],
  a: "12.0"
}, {
  n: ["deaf man"],
  u: "1f9cf-200d-2642-fe0f",
  v: ["1f9cf-1f3fb-200d-2642-fe0f", "1f9cf-1f3fc-200d-2642-fe0f", "1f9cf-1f3fd-200d-2642-fe0f", "1f9cf-1f3fe-200d-2642-fe0f", "1f9cf-1f3ff-200d-2642-fe0f"],
  a: "12.0"
}, {
  n: ["deaf woman"],
  u: "1f9cf-200d-2640-fe0f",
  v: ["1f9cf-1f3fb-200d-2640-fe0f", "1f9cf-1f3fc-200d-2640-fe0f", "1f9cf-1f3fd-200d-2640-fe0f", "1f9cf-1f3fe-200d-2640-fe0f", "1f9cf-1f3ff-200d-2640-fe0f"],
  a: "12.0"
}, {
  n: ["bow", "person bowing deeply"],
  u: "1f647",
  v: ["1f647-1f3fb", "1f647-1f3fc", "1f647-1f3fd", "1f647-1f3fe", "1f647-1f3ff"],
  a: "0.6"
}, {
  n: ["man bowing", "man-bowing"],
  u: "1f647-200d-2642-fe0f",
  v: ["1f647-1f3fb-200d-2642-fe0f", "1f647-1f3fc-200d-2642-fe0f", "1f647-1f3fd-200d-2642-fe0f", "1f647-1f3fe-200d-2642-fe0f", "1f647-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman bowing", "woman-bowing"],
  u: "1f647-200d-2640-fe0f",
  v: ["1f647-1f3fb-200d-2640-fe0f", "1f647-1f3fc-200d-2640-fe0f", "1f647-1f3fd-200d-2640-fe0f", "1f647-1f3fe-200d-2640-fe0f", "1f647-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["face palm"],
  u: "1f926",
  v: ["1f926-1f3fb", "1f926-1f3fc", "1f926-1f3fd", "1f926-1f3fe", "1f926-1f3ff"],
  a: "3.0"
}, {
  n: ["man facepalming", "man-facepalming"],
  u: "1f926-200d-2642-fe0f",
  v: ["1f926-1f3fb-200d-2642-fe0f", "1f926-1f3fc-200d-2642-fe0f", "1f926-1f3fd-200d-2642-fe0f", "1f926-1f3fe-200d-2642-fe0f", "1f926-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman facepalming", "woman-facepalming"],
  u: "1f926-200d-2640-fe0f",
  v: ["1f926-1f3fb-200d-2640-fe0f", "1f926-1f3fc-200d-2640-fe0f", "1f926-1f3fd-200d-2640-fe0f", "1f926-1f3fe-200d-2640-fe0f", "1f926-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["shrug"],
  u: "1f937",
  v: ["1f937-1f3fb", "1f937-1f3fc", "1f937-1f3fd", "1f937-1f3fe", "1f937-1f3ff"],
  a: "3.0"
}, {
  n: ["man shrugging", "man-shrugging"],
  u: "1f937-200d-2642-fe0f",
  v: ["1f937-1f3fb-200d-2642-fe0f", "1f937-1f3fc-200d-2642-fe0f", "1f937-1f3fd-200d-2642-fe0f", "1f937-1f3fe-200d-2642-fe0f", "1f937-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman shrugging", "woman-shrugging"],
  u: "1f937-200d-2640-fe0f",
  v: ["1f937-1f3fb-200d-2640-fe0f", "1f937-1f3fc-200d-2640-fe0f", "1f937-1f3fd-200d-2640-fe0f", "1f937-1f3fe-200d-2640-fe0f", "1f937-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["health worker"],
  u: "1f9d1-200d-2695-fe0f",
  v: ["1f9d1-1f3fb-200d-2695-fe0f", "1f9d1-1f3fc-200d-2695-fe0f", "1f9d1-1f3fd-200d-2695-fe0f", "1f9d1-1f3fe-200d-2695-fe0f", "1f9d1-1f3ff-200d-2695-fe0f"],
  a: "12.1"
}, {
  n: ["male-doctor", "man health worker"],
  u: "1f468-200d-2695-fe0f",
  v: ["1f468-1f3fb-200d-2695-fe0f", "1f468-1f3fc-200d-2695-fe0f", "1f468-1f3fd-200d-2695-fe0f", "1f468-1f3fe-200d-2695-fe0f", "1f468-1f3ff-200d-2695-fe0f"],
  a: "4.0"
}, {
  n: ["female-doctor", "woman health worker"],
  u: "1f469-200d-2695-fe0f",
  v: ["1f469-1f3fb-200d-2695-fe0f", "1f469-1f3fc-200d-2695-fe0f", "1f469-1f3fd-200d-2695-fe0f", "1f469-1f3fe-200d-2695-fe0f", "1f469-1f3ff-200d-2695-fe0f"],
  a: "4.0"
}, {
  n: ["student"],
  u: "1f9d1-200d-1f393",
  v: ["1f9d1-1f3fb-200d-1f393", "1f9d1-1f3fc-200d-1f393", "1f9d1-1f3fd-200d-1f393", "1f9d1-1f3fe-200d-1f393", "1f9d1-1f3ff-200d-1f393"],
  a: "12.1"
}, {
  n: ["man student", "male-student"],
  u: "1f468-200d-1f393",
  v: ["1f468-1f3fb-200d-1f393", "1f468-1f3fc-200d-1f393", "1f468-1f3fd-200d-1f393", "1f468-1f3fe-200d-1f393", "1f468-1f3ff-200d-1f393"],
  a: "4.0"
}, {
  n: ["woman student", "female-student"],
  u: "1f469-200d-1f393",
  v: ["1f469-1f3fb-200d-1f393", "1f469-1f3fc-200d-1f393", "1f469-1f3fd-200d-1f393", "1f469-1f3fe-200d-1f393", "1f469-1f3ff-200d-1f393"],
  a: "4.0"
}, {
  n: ["teacher"],
  u: "1f9d1-200d-1f3eb",
  v: ["1f9d1-1f3fb-200d-1f3eb", "1f9d1-1f3fc-200d-1f3eb", "1f9d1-1f3fd-200d-1f3eb", "1f9d1-1f3fe-200d-1f3eb", "1f9d1-1f3ff-200d-1f3eb"],
  a: "12.1"
}, {
  n: ["man teacher", "male-teacher"],
  u: "1f468-200d-1f3eb",
  v: ["1f468-1f3fb-200d-1f3eb", "1f468-1f3fc-200d-1f3eb", "1f468-1f3fd-200d-1f3eb", "1f468-1f3fe-200d-1f3eb", "1f468-1f3ff-200d-1f3eb"],
  a: "4.0"
}, {
  n: ["woman teacher", "female-teacher"],
  u: "1f469-200d-1f3eb",
  v: ["1f469-1f3fb-200d-1f3eb", "1f469-1f3fc-200d-1f3eb", "1f469-1f3fd-200d-1f3eb", "1f469-1f3fe-200d-1f3eb", "1f469-1f3ff-200d-1f3eb"],
  a: "4.0"
}, {
  n: ["judge"],
  u: "1f9d1-200d-2696-fe0f",
  v: ["1f9d1-1f3fb-200d-2696-fe0f", "1f9d1-1f3fc-200d-2696-fe0f", "1f9d1-1f3fd-200d-2696-fe0f", "1f9d1-1f3fe-200d-2696-fe0f", "1f9d1-1f3ff-200d-2696-fe0f"],
  a: "12.1"
}, {
  n: ["man judge", "male-judge"],
  u: "1f468-200d-2696-fe0f",
  v: ["1f468-1f3fb-200d-2696-fe0f", "1f468-1f3fc-200d-2696-fe0f", "1f468-1f3fd-200d-2696-fe0f", "1f468-1f3fe-200d-2696-fe0f", "1f468-1f3ff-200d-2696-fe0f"],
  a: "4.0"
}, {
  n: ["woman judge", "female-judge"],
  u: "1f469-200d-2696-fe0f",
  v: ["1f469-1f3fb-200d-2696-fe0f", "1f469-1f3fc-200d-2696-fe0f", "1f469-1f3fd-200d-2696-fe0f", "1f469-1f3fe-200d-2696-fe0f", "1f469-1f3ff-200d-2696-fe0f"],
  a: "4.0"
}, {
  n: ["farmer"],
  u: "1f9d1-200d-1f33e",
  v: ["1f9d1-1f3fb-200d-1f33e", "1f9d1-1f3fc-200d-1f33e", "1f9d1-1f3fd-200d-1f33e", "1f9d1-1f3fe-200d-1f33e", "1f9d1-1f3ff-200d-1f33e"],
  a: "12.1"
}, {
  n: ["man farmer", "male-farmer"],
  u: "1f468-200d-1f33e",
  v: ["1f468-1f3fb-200d-1f33e", "1f468-1f3fc-200d-1f33e", "1f468-1f3fd-200d-1f33e", "1f468-1f3fe-200d-1f33e", "1f468-1f3ff-200d-1f33e"],
  a: "4.0"
}, {
  n: ["woman farmer", "female-farmer"],
  u: "1f469-200d-1f33e",
  v: ["1f469-1f3fb-200d-1f33e", "1f469-1f3fc-200d-1f33e", "1f469-1f3fd-200d-1f33e", "1f469-1f3fe-200d-1f33e", "1f469-1f3ff-200d-1f33e"],
  a: "4.0"
}, {
  n: ["cook"],
  u: "1f9d1-200d-1f373",
  v: ["1f9d1-1f3fb-200d-1f373", "1f9d1-1f3fc-200d-1f373", "1f9d1-1f3fd-200d-1f373", "1f9d1-1f3fe-200d-1f373", "1f9d1-1f3ff-200d-1f373"],
  a: "12.1"
}, {
  n: ["man cook", "male-cook"],
  u: "1f468-200d-1f373",
  v: ["1f468-1f3fb-200d-1f373", "1f468-1f3fc-200d-1f373", "1f468-1f3fd-200d-1f373", "1f468-1f3fe-200d-1f373", "1f468-1f3ff-200d-1f373"],
  a: "4.0"
}, {
  n: ["woman cook", "female-cook"],
  u: "1f469-200d-1f373",
  v: ["1f469-1f3fb-200d-1f373", "1f469-1f3fc-200d-1f373", "1f469-1f3fd-200d-1f373", "1f469-1f3fe-200d-1f373", "1f469-1f3ff-200d-1f373"],
  a: "4.0"
}, {
  n: ["mechanic"],
  u: "1f9d1-200d-1f527",
  v: ["1f9d1-1f3fb-200d-1f527", "1f9d1-1f3fc-200d-1f527", "1f9d1-1f3fd-200d-1f527", "1f9d1-1f3fe-200d-1f527", "1f9d1-1f3ff-200d-1f527"],
  a: "12.1"
}, {
  n: ["man mechanic", "male-mechanic"],
  u: "1f468-200d-1f527",
  v: ["1f468-1f3fb-200d-1f527", "1f468-1f3fc-200d-1f527", "1f468-1f3fd-200d-1f527", "1f468-1f3fe-200d-1f527", "1f468-1f3ff-200d-1f527"],
  a: "4.0"
}, {
  n: ["woman mechanic", "female-mechanic"],
  u: "1f469-200d-1f527",
  v: ["1f469-1f3fb-200d-1f527", "1f469-1f3fc-200d-1f527", "1f469-1f3fd-200d-1f527", "1f469-1f3fe-200d-1f527", "1f469-1f3ff-200d-1f527"],
  a: "4.0"
}, {
  n: ["factory worker"],
  u: "1f9d1-200d-1f3ed",
  v: ["1f9d1-1f3fb-200d-1f3ed", "1f9d1-1f3fc-200d-1f3ed", "1f9d1-1f3fd-200d-1f3ed", "1f9d1-1f3fe-200d-1f3ed", "1f9d1-1f3ff-200d-1f3ed"],
  a: "12.1"
}, {
  n: ["man factory worker", "male-factory-worker"],
  u: "1f468-200d-1f3ed",
  v: ["1f468-1f3fb-200d-1f3ed", "1f468-1f3fc-200d-1f3ed", "1f468-1f3fd-200d-1f3ed", "1f468-1f3fe-200d-1f3ed", "1f468-1f3ff-200d-1f3ed"],
  a: "4.0"
}, {
  n: ["woman factory worker", "female-factory-worker"],
  u: "1f469-200d-1f3ed",
  v: ["1f469-1f3fb-200d-1f3ed", "1f469-1f3fc-200d-1f3ed", "1f469-1f3fd-200d-1f3ed", "1f469-1f3fe-200d-1f3ed", "1f469-1f3ff-200d-1f3ed"],
  a: "4.0"
}, {
  n: ["office worker"],
  u: "1f9d1-200d-1f4bc",
  v: ["1f9d1-1f3fb-200d-1f4bc", "1f9d1-1f3fc-200d-1f4bc", "1f9d1-1f3fd-200d-1f4bc", "1f9d1-1f3fe-200d-1f4bc", "1f9d1-1f3ff-200d-1f4bc"],
  a: "12.1"
}, {
  n: ["man office worker", "male-office-worker"],
  u: "1f468-200d-1f4bc",
  v: ["1f468-1f3fb-200d-1f4bc", "1f468-1f3fc-200d-1f4bc", "1f468-1f3fd-200d-1f4bc", "1f468-1f3fe-200d-1f4bc", "1f468-1f3ff-200d-1f4bc"],
  a: "4.0"
}, {
  n: ["woman office worker", "female-office-worker"],
  u: "1f469-200d-1f4bc",
  v: ["1f469-1f3fb-200d-1f4bc", "1f469-1f3fc-200d-1f4bc", "1f469-1f3fd-200d-1f4bc", "1f469-1f3fe-200d-1f4bc", "1f469-1f3ff-200d-1f4bc"],
  a: "4.0"
}, {
  n: ["scientist"],
  u: "1f9d1-200d-1f52c",
  v: ["1f9d1-1f3fb-200d-1f52c", "1f9d1-1f3fc-200d-1f52c", "1f9d1-1f3fd-200d-1f52c", "1f9d1-1f3fe-200d-1f52c", "1f9d1-1f3ff-200d-1f52c"],
  a: "12.1"
}, {
  n: ["man scientist", "male-scientist"],
  u: "1f468-200d-1f52c",
  v: ["1f468-1f3fb-200d-1f52c", "1f468-1f3fc-200d-1f52c", "1f468-1f3fd-200d-1f52c", "1f468-1f3fe-200d-1f52c", "1f468-1f3ff-200d-1f52c"],
  a: "4.0"
}, {
  n: ["woman scientist", "female-scientist"],
  u: "1f469-200d-1f52c",
  v: ["1f469-1f3fb-200d-1f52c", "1f469-1f3fc-200d-1f52c", "1f469-1f3fd-200d-1f52c", "1f469-1f3fe-200d-1f52c", "1f469-1f3ff-200d-1f52c"],
  a: "4.0"
}, {
  n: ["technologist"],
  u: "1f9d1-200d-1f4bb",
  v: ["1f9d1-1f3fb-200d-1f4bb", "1f9d1-1f3fc-200d-1f4bb", "1f9d1-1f3fd-200d-1f4bb", "1f9d1-1f3fe-200d-1f4bb", "1f9d1-1f3ff-200d-1f4bb"],
  a: "12.1"
}, {
  n: ["man technologist", "male-technologist"],
  u: "1f468-200d-1f4bb",
  v: ["1f468-1f3fb-200d-1f4bb", "1f468-1f3fc-200d-1f4bb", "1f468-1f3fd-200d-1f4bb", "1f468-1f3fe-200d-1f4bb", "1f468-1f3ff-200d-1f4bb"],
  a: "4.0"
}, {
  n: ["woman technologist", "female-technologist"],
  u: "1f469-200d-1f4bb",
  v: ["1f469-1f3fb-200d-1f4bb", "1f469-1f3fc-200d-1f4bb", "1f469-1f3fd-200d-1f4bb", "1f469-1f3fe-200d-1f4bb", "1f469-1f3ff-200d-1f4bb"],
  a: "4.0"
}, {
  n: ["singer"],
  u: "1f9d1-200d-1f3a4",
  v: ["1f9d1-1f3fb-200d-1f3a4", "1f9d1-1f3fc-200d-1f3a4", "1f9d1-1f3fd-200d-1f3a4", "1f9d1-1f3fe-200d-1f3a4", "1f9d1-1f3ff-200d-1f3a4"],
  a: "12.1"
}, {
  n: ["man singer", "male-singer"],
  u: "1f468-200d-1f3a4",
  v: ["1f468-1f3fb-200d-1f3a4", "1f468-1f3fc-200d-1f3a4", "1f468-1f3fd-200d-1f3a4", "1f468-1f3fe-200d-1f3a4", "1f468-1f3ff-200d-1f3a4"],
  a: "4.0"
}, {
  n: ["woman singer", "female-singer"],
  u: "1f469-200d-1f3a4",
  v: ["1f469-1f3fb-200d-1f3a4", "1f469-1f3fc-200d-1f3a4", "1f469-1f3fd-200d-1f3a4", "1f469-1f3fe-200d-1f3a4", "1f469-1f3ff-200d-1f3a4"],
  a: "4.0"
}, {
  n: ["artist"],
  u: "1f9d1-200d-1f3a8",
  v: ["1f9d1-1f3fb-200d-1f3a8", "1f9d1-1f3fc-200d-1f3a8", "1f9d1-1f3fd-200d-1f3a8", "1f9d1-1f3fe-200d-1f3a8", "1f9d1-1f3ff-200d-1f3a8"],
  a: "12.1"
}, {
  n: ["man artist", "male-artist"],
  u: "1f468-200d-1f3a8",
  v: ["1f468-1f3fb-200d-1f3a8", "1f468-1f3fc-200d-1f3a8", "1f468-1f3fd-200d-1f3a8", "1f468-1f3fe-200d-1f3a8", "1f468-1f3ff-200d-1f3a8"],
  a: "4.0"
}, {
  n: ["woman artist", "female-artist"],
  u: "1f469-200d-1f3a8",
  v: ["1f469-1f3fb-200d-1f3a8", "1f469-1f3fc-200d-1f3a8", "1f469-1f3fd-200d-1f3a8", "1f469-1f3fe-200d-1f3a8", "1f469-1f3ff-200d-1f3a8"],
  a: "4.0"
}, {
  n: ["pilot"],
  u: "1f9d1-200d-2708-fe0f",
  v: ["1f9d1-1f3fb-200d-2708-fe0f", "1f9d1-1f3fc-200d-2708-fe0f", "1f9d1-1f3fd-200d-2708-fe0f", "1f9d1-1f3fe-200d-2708-fe0f", "1f9d1-1f3ff-200d-2708-fe0f"],
  a: "12.1"
}, {
  n: ["man pilot", "male-pilot"],
  u: "1f468-200d-2708-fe0f",
  v: ["1f468-1f3fb-200d-2708-fe0f", "1f468-1f3fc-200d-2708-fe0f", "1f468-1f3fd-200d-2708-fe0f", "1f468-1f3fe-200d-2708-fe0f", "1f468-1f3ff-200d-2708-fe0f"],
  a: "4.0"
}, {
  n: ["woman pilot", "female-pilot"],
  u: "1f469-200d-2708-fe0f",
  v: ["1f469-1f3fb-200d-2708-fe0f", "1f469-1f3fc-200d-2708-fe0f", "1f469-1f3fd-200d-2708-fe0f", "1f469-1f3fe-200d-2708-fe0f", "1f469-1f3ff-200d-2708-fe0f"],
  a: "4.0"
}, {
  n: ["astronaut"],
  u: "1f9d1-200d-1f680",
  v: ["1f9d1-1f3fb-200d-1f680", "1f9d1-1f3fc-200d-1f680", "1f9d1-1f3fd-200d-1f680", "1f9d1-1f3fe-200d-1f680", "1f9d1-1f3ff-200d-1f680"],
  a: "12.1"
}, {
  n: ["man astronaut", "male-astronaut"],
  u: "1f468-200d-1f680",
  v: ["1f468-1f3fb-200d-1f680", "1f468-1f3fc-200d-1f680", "1f468-1f3fd-200d-1f680", "1f468-1f3fe-200d-1f680", "1f468-1f3ff-200d-1f680"],
  a: "4.0"
}, {
  n: ["woman astronaut", "female-astronaut"],
  u: "1f469-200d-1f680",
  v: ["1f469-1f3fb-200d-1f680", "1f469-1f3fc-200d-1f680", "1f469-1f3fd-200d-1f680", "1f469-1f3fe-200d-1f680", "1f469-1f3ff-200d-1f680"],
  a: "4.0"
}, {
  n: ["firefighter"],
  u: "1f9d1-200d-1f692",
  v: ["1f9d1-1f3fb-200d-1f692", "1f9d1-1f3fc-200d-1f692", "1f9d1-1f3fd-200d-1f692", "1f9d1-1f3fe-200d-1f692", "1f9d1-1f3ff-200d-1f692"],
  a: "12.1"
}, {
  n: ["man firefighter", "male-firefighter"],
  u: "1f468-200d-1f692",
  v: ["1f468-1f3fb-200d-1f692", "1f468-1f3fc-200d-1f692", "1f468-1f3fd-200d-1f692", "1f468-1f3fe-200d-1f692", "1f468-1f3ff-200d-1f692"],
  a: "4.0"
}, {
  n: ["woman firefighter", "female-firefighter"],
  u: "1f469-200d-1f692",
  v: ["1f469-1f3fb-200d-1f692", "1f469-1f3fc-200d-1f692", "1f469-1f3fd-200d-1f692", "1f469-1f3fe-200d-1f692", "1f469-1f3ff-200d-1f692"],
  a: "4.0"
}, {
  n: ["cop", "police officer"],
  u: "1f46e",
  v: ["1f46e-1f3fb", "1f46e-1f3fc", "1f46e-1f3fd", "1f46e-1f3fe", "1f46e-1f3ff"],
  a: "0.6"
}, {
  n: ["man police officer", "male-police-officer"],
  u: "1f46e-200d-2642-fe0f",
  v: ["1f46e-1f3fb-200d-2642-fe0f", "1f46e-1f3fc-200d-2642-fe0f", "1f46e-1f3fd-200d-2642-fe0f", "1f46e-1f3fe-200d-2642-fe0f", "1f46e-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman police officer", "female-police-officer"],
  u: "1f46e-200d-2640-fe0f",
  v: ["1f46e-1f3fb-200d-2640-fe0f", "1f46e-1f3fc-200d-2640-fe0f", "1f46e-1f3fd-200d-2640-fe0f", "1f46e-1f3fe-200d-2640-fe0f", "1f46e-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["detective", "sleuth or spy"],
  u: "1f575-fe0f",
  v: ["1f575-1f3fb", "1f575-1f3fc", "1f575-1f3fd", "1f575-1f3fe", "1f575-1f3ff"],
  a: "0.7"
}, {
  n: ["man detective", "male-detective"],
  u: "1f575-fe0f-200d-2642-fe0f",
  v: ["1f575-1f3fb-200d-2642-fe0f", "1f575-1f3fc-200d-2642-fe0f", "1f575-1f3fd-200d-2642-fe0f", "1f575-1f3fe-200d-2642-fe0f", "1f575-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman detective", "female-detective"],
  u: "1f575-fe0f-200d-2640-fe0f",
  v: ["1f575-1f3fb-200d-2640-fe0f", "1f575-1f3fc-200d-2640-fe0f", "1f575-1f3fd-200d-2640-fe0f", "1f575-1f3fe-200d-2640-fe0f", "1f575-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["guardsman"],
  u: "1f482",
  v: ["1f482-1f3fb", "1f482-1f3fc", "1f482-1f3fd", "1f482-1f3fe", "1f482-1f3ff"],
  a: "0.6"
}, {
  n: ["man guard", "male-guard"],
  u: "1f482-200d-2642-fe0f",
  v: ["1f482-1f3fb-200d-2642-fe0f", "1f482-1f3fc-200d-2642-fe0f", "1f482-1f3fd-200d-2642-fe0f", "1f482-1f3fe-200d-2642-fe0f", "1f482-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman guard", "female-guard"],
  u: "1f482-200d-2640-fe0f",
  v: ["1f482-1f3fb-200d-2640-fe0f", "1f482-1f3fc-200d-2640-fe0f", "1f482-1f3fd-200d-2640-fe0f", "1f482-1f3fe-200d-2640-fe0f", "1f482-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["ninja"],
  u: "1f977",
  v: ["1f977-1f3fb", "1f977-1f3fc", "1f977-1f3fd", "1f977-1f3fe", "1f977-1f3ff"],
  a: "13.0"
}, {
  n: ["construction worker"],
  u: "1f477",
  v: ["1f477-1f3fb", "1f477-1f3fc", "1f477-1f3fd", "1f477-1f3fe", "1f477-1f3ff"],
  a: "0.6"
}, {
  n: ["man construction worker", "male-construction-worker"],
  u: "1f477-200d-2642-fe0f",
  v: ["1f477-1f3fb-200d-2642-fe0f", "1f477-1f3fc-200d-2642-fe0f", "1f477-1f3fd-200d-2642-fe0f", "1f477-1f3fe-200d-2642-fe0f", "1f477-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman construction worker", "female-construction-worker"],
  u: "1f477-200d-2640-fe0f",
  v: ["1f477-1f3fb-200d-2640-fe0f", "1f477-1f3fc-200d-2640-fe0f", "1f477-1f3fd-200d-2640-fe0f", "1f477-1f3fe-200d-2640-fe0f", "1f477-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["person with crown"],
  u: "1fac5",
  v: ["1fac5-1f3fb", "1fac5-1f3fc", "1fac5-1f3fd", "1fac5-1f3fe", "1fac5-1f3ff"],
  a: "14.0"
}, {
  n: ["prince"],
  u: "1f934",
  v: ["1f934-1f3fb", "1f934-1f3fc", "1f934-1f3fd", "1f934-1f3fe", "1f934-1f3ff"],
  a: "3.0"
}, {
  n: ["princess"],
  u: "1f478",
  v: ["1f478-1f3fb", "1f478-1f3fc", "1f478-1f3fd", "1f478-1f3fe", "1f478-1f3ff"],
  a: "0.6"
}, {
  n: ["man with turban"],
  u: "1f473",
  v: ["1f473-1f3fb", "1f473-1f3fc", "1f473-1f3fd", "1f473-1f3fe", "1f473-1f3ff"],
  a: "0.6"
}, {
  n: ["man wearing turban", "man-wearing-turban"],
  u: "1f473-200d-2642-fe0f",
  v: ["1f473-1f3fb-200d-2642-fe0f", "1f473-1f3fc-200d-2642-fe0f", "1f473-1f3fd-200d-2642-fe0f", "1f473-1f3fe-200d-2642-fe0f", "1f473-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman wearing turban", "woman-wearing-turban"],
  u: "1f473-200d-2640-fe0f",
  v: ["1f473-1f3fb-200d-2640-fe0f", "1f473-1f3fc-200d-2640-fe0f", "1f473-1f3fd-200d-2640-fe0f", "1f473-1f3fe-200d-2640-fe0f", "1f473-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["man with gua pi mao"],
  u: "1f472",
  v: ["1f472-1f3fb", "1f472-1f3fc", "1f472-1f3fd", "1f472-1f3fe", "1f472-1f3ff"],
  a: "0.6"
}, {
  n: ["person with headscarf"],
  u: "1f9d5",
  v: ["1f9d5-1f3fb", "1f9d5-1f3fc", "1f9d5-1f3fd", "1f9d5-1f3fe", "1f9d5-1f3ff"],
  a: "5.0"
}, {
  n: ["man in tuxedo", "person in tuxedo"],
  u: "1f935",
  v: ["1f935-1f3fb", "1f935-1f3fc", "1f935-1f3fd", "1f935-1f3fe", "1f935-1f3ff"],
  a: "3.0"
}, {
  n: ["man in tuxedo"],
  u: "1f935-200d-2642-fe0f",
  v: ["1f935-1f3fb-200d-2642-fe0f", "1f935-1f3fc-200d-2642-fe0f", "1f935-1f3fd-200d-2642-fe0f", "1f935-1f3fe-200d-2642-fe0f", "1f935-1f3ff-200d-2642-fe0f"],
  a: "13.0"
}, {
  n: ["woman in tuxedo"],
  u: "1f935-200d-2640-fe0f",
  v: ["1f935-1f3fb-200d-2640-fe0f", "1f935-1f3fc-200d-2640-fe0f", "1f935-1f3fd-200d-2640-fe0f", "1f935-1f3fe-200d-2640-fe0f", "1f935-1f3ff-200d-2640-fe0f"],
  a: "13.0"
}, {
  n: ["bride with veil"],
  u: "1f470",
  v: ["1f470-1f3fb", "1f470-1f3fc", "1f470-1f3fd", "1f470-1f3fe", "1f470-1f3ff"],
  a: "0.6"
}, {
  n: ["man with veil"],
  u: "1f470-200d-2642-fe0f",
  v: ["1f470-1f3fb-200d-2642-fe0f", "1f470-1f3fc-200d-2642-fe0f", "1f470-1f3fd-200d-2642-fe0f", "1f470-1f3fe-200d-2642-fe0f", "1f470-1f3ff-200d-2642-fe0f"],
  a: "13.0"
}, {
  n: ["woman with veil"],
  u: "1f470-200d-2640-fe0f",
  v: ["1f470-1f3fb-200d-2640-fe0f", "1f470-1f3fc-200d-2640-fe0f", "1f470-1f3fd-200d-2640-fe0f", "1f470-1f3fe-200d-2640-fe0f", "1f470-1f3ff-200d-2640-fe0f"],
  a: "13.0"
}, {
  n: ["pregnant woman"],
  u: "1f930",
  v: ["1f930-1f3fb", "1f930-1f3fc", "1f930-1f3fd", "1f930-1f3fe", "1f930-1f3ff"],
  a: "3.0"
}, {
  n: ["pregnant man"],
  u: "1fac3",
  v: ["1fac3-1f3fb", "1fac3-1f3fc", "1fac3-1f3fd", "1fac3-1f3fe", "1fac3-1f3ff"],
  a: "14.0"
}, {
  n: ["pregnant person"],
  u: "1fac4",
  v: ["1fac4-1f3fb", "1fac4-1f3fc", "1fac4-1f3fd", "1fac4-1f3fe", "1fac4-1f3ff"],
  a: "14.0"
}, {
  n: ["breast-feeding"],
  u: "1f931",
  v: ["1f931-1f3fb", "1f931-1f3fc", "1f931-1f3fd", "1f931-1f3fe", "1f931-1f3ff"],
  a: "5.0"
}, {
  n: ["woman feeding baby"],
  u: "1f469-200d-1f37c",
  v: ["1f469-1f3fb-200d-1f37c", "1f469-1f3fc-200d-1f37c", "1f469-1f3fd-200d-1f37c", "1f469-1f3fe-200d-1f37c", "1f469-1f3ff-200d-1f37c"],
  a: "13.0"
}, {
  n: ["man feeding baby"],
  u: "1f468-200d-1f37c",
  v: ["1f468-1f3fb-200d-1f37c", "1f468-1f3fc-200d-1f37c", "1f468-1f3fd-200d-1f37c", "1f468-1f3fe-200d-1f37c", "1f468-1f3ff-200d-1f37c"],
  a: "13.0"
}, {
  n: ["person feeding baby"],
  u: "1f9d1-200d-1f37c",
  v: ["1f9d1-1f3fb-200d-1f37c", "1f9d1-1f3fc-200d-1f37c", "1f9d1-1f3fd-200d-1f37c", "1f9d1-1f3fe-200d-1f37c", "1f9d1-1f3ff-200d-1f37c"],
  a: "13.0"
}, {
  n: ["angel", "baby angel"],
  u: "1f47c",
  v: ["1f47c-1f3fb", "1f47c-1f3fc", "1f47c-1f3fd", "1f47c-1f3fe", "1f47c-1f3ff"],
  a: "0.6"
}, {
  n: ["santa", "father christmas"],
  u: "1f385",
  v: ["1f385-1f3fb", "1f385-1f3fc", "1f385-1f3fd", "1f385-1f3fe", "1f385-1f3ff"],
  a: "0.6"
}, {
  n: ["mrs claus", "mother christmas"],
  u: "1f936",
  v: ["1f936-1f3fb", "1f936-1f3fc", "1f936-1f3fd", "1f936-1f3fe", "1f936-1f3ff"],
  a: "3.0"
}, {
  n: ["mx claus"],
  u: "1f9d1-200d-1f384",
  v: ["1f9d1-1f3fb-200d-1f384", "1f9d1-1f3fc-200d-1f384", "1f9d1-1f3fd-200d-1f384", "1f9d1-1f3fe-200d-1f384", "1f9d1-1f3ff-200d-1f384"],
  a: "13.0"
}, {
  n: ["superhero"],
  u: "1f9b8",
  v: ["1f9b8-1f3fb", "1f9b8-1f3fc", "1f9b8-1f3fd", "1f9b8-1f3fe", "1f9b8-1f3ff"],
  a: "11.0"
}, {
  n: ["man superhero", "male superhero"],
  u: "1f9b8-200d-2642-fe0f",
  v: ["1f9b8-1f3fb-200d-2642-fe0f", "1f9b8-1f3fc-200d-2642-fe0f", "1f9b8-1f3fd-200d-2642-fe0f", "1f9b8-1f3fe-200d-2642-fe0f", "1f9b8-1f3ff-200d-2642-fe0f"],
  a: "11.0"
}, {
  n: ["woman superhero", "female superhero"],
  u: "1f9b8-200d-2640-fe0f",
  v: ["1f9b8-1f3fb-200d-2640-fe0f", "1f9b8-1f3fc-200d-2640-fe0f", "1f9b8-1f3fd-200d-2640-fe0f", "1f9b8-1f3fe-200d-2640-fe0f", "1f9b8-1f3ff-200d-2640-fe0f"],
  a: "11.0"
}, {
  n: ["supervillain"],
  u: "1f9b9",
  v: ["1f9b9-1f3fb", "1f9b9-1f3fc", "1f9b9-1f3fd", "1f9b9-1f3fe", "1f9b9-1f3ff"],
  a: "11.0"
}, {
  n: ["man supervillain", "male supervillain"],
  u: "1f9b9-200d-2642-fe0f",
  v: ["1f9b9-1f3fb-200d-2642-fe0f", "1f9b9-1f3fc-200d-2642-fe0f", "1f9b9-1f3fd-200d-2642-fe0f", "1f9b9-1f3fe-200d-2642-fe0f", "1f9b9-1f3ff-200d-2642-fe0f"],
  a: "11.0"
}, {
  n: ["woman supervillain", "female supervillain"],
  u: "1f9b9-200d-2640-fe0f",
  v: ["1f9b9-1f3fb-200d-2640-fe0f", "1f9b9-1f3fc-200d-2640-fe0f", "1f9b9-1f3fd-200d-2640-fe0f", "1f9b9-1f3fe-200d-2640-fe0f", "1f9b9-1f3ff-200d-2640-fe0f"],
  a: "11.0"
}, {
  n: ["mage"],
  u: "1f9d9",
  v: ["1f9d9-1f3fb", "1f9d9-1f3fc", "1f9d9-1f3fd", "1f9d9-1f3fe", "1f9d9-1f3ff"],
  a: "5.0"
}, {
  n: ["man mage", "male mage"],
  u: "1f9d9-200d-2642-fe0f",
  v: ["1f9d9-1f3fb-200d-2642-fe0f", "1f9d9-1f3fc-200d-2642-fe0f", "1f9d9-1f3fd-200d-2642-fe0f", "1f9d9-1f3fe-200d-2642-fe0f", "1f9d9-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman mage", "female mage"],
  u: "1f9d9-200d-2640-fe0f",
  v: ["1f9d9-1f3fb-200d-2640-fe0f", "1f9d9-1f3fc-200d-2640-fe0f", "1f9d9-1f3fd-200d-2640-fe0f", "1f9d9-1f3fe-200d-2640-fe0f", "1f9d9-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["fairy"],
  u: "1f9da",
  v: ["1f9da-1f3fb", "1f9da-1f3fc", "1f9da-1f3fd", "1f9da-1f3fe", "1f9da-1f3ff"],
  a: "5.0"
}, {
  n: ["man fairy", "male fairy"],
  u: "1f9da-200d-2642-fe0f",
  v: ["1f9da-1f3fb-200d-2642-fe0f", "1f9da-1f3fc-200d-2642-fe0f", "1f9da-1f3fd-200d-2642-fe0f", "1f9da-1f3fe-200d-2642-fe0f", "1f9da-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman fairy", "female fairy"],
  u: "1f9da-200d-2640-fe0f",
  v: ["1f9da-1f3fb-200d-2640-fe0f", "1f9da-1f3fc-200d-2640-fe0f", "1f9da-1f3fd-200d-2640-fe0f", "1f9da-1f3fe-200d-2640-fe0f", "1f9da-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["vampire"],
  u: "1f9db",
  v: ["1f9db-1f3fb", "1f9db-1f3fc", "1f9db-1f3fd", "1f9db-1f3fe", "1f9db-1f3ff"],
  a: "5.0"
}, {
  n: ["man vampire", "male vampire"],
  u: "1f9db-200d-2642-fe0f",
  v: ["1f9db-1f3fb-200d-2642-fe0f", "1f9db-1f3fc-200d-2642-fe0f", "1f9db-1f3fd-200d-2642-fe0f", "1f9db-1f3fe-200d-2642-fe0f", "1f9db-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman vampire", "female vampire"],
  u: "1f9db-200d-2640-fe0f",
  v: ["1f9db-1f3fb-200d-2640-fe0f", "1f9db-1f3fc-200d-2640-fe0f", "1f9db-1f3fd-200d-2640-fe0f", "1f9db-1f3fe-200d-2640-fe0f", "1f9db-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["merperson"],
  u: "1f9dc",
  v: ["1f9dc-1f3fb", "1f9dc-1f3fc", "1f9dc-1f3fd", "1f9dc-1f3fe", "1f9dc-1f3ff"],
  a: "5.0"
}, {
  n: ["merman"],
  u: "1f9dc-200d-2642-fe0f",
  v: ["1f9dc-1f3fb-200d-2642-fe0f", "1f9dc-1f3fc-200d-2642-fe0f", "1f9dc-1f3fd-200d-2642-fe0f", "1f9dc-1f3fe-200d-2642-fe0f", "1f9dc-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["mermaid"],
  u: "1f9dc-200d-2640-fe0f",
  v: ["1f9dc-1f3fb-200d-2640-fe0f", "1f9dc-1f3fc-200d-2640-fe0f", "1f9dc-1f3fd-200d-2640-fe0f", "1f9dc-1f3fe-200d-2640-fe0f", "1f9dc-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["elf"],
  u: "1f9dd",
  v: ["1f9dd-1f3fb", "1f9dd-1f3fc", "1f9dd-1f3fd", "1f9dd-1f3fe", "1f9dd-1f3ff"],
  a: "5.0"
}, {
  n: ["man elf", "male elf"],
  u: "1f9dd-200d-2642-fe0f",
  v: ["1f9dd-1f3fb-200d-2642-fe0f", "1f9dd-1f3fc-200d-2642-fe0f", "1f9dd-1f3fd-200d-2642-fe0f", "1f9dd-1f3fe-200d-2642-fe0f", "1f9dd-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman elf", "female elf"],
  u: "1f9dd-200d-2640-fe0f",
  v: ["1f9dd-1f3fb-200d-2640-fe0f", "1f9dd-1f3fc-200d-2640-fe0f", "1f9dd-1f3fd-200d-2640-fe0f", "1f9dd-1f3fe-200d-2640-fe0f", "1f9dd-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["genie"],
  u: "1f9de",
  a: "5.0"
}, {
  n: ["man genie", "male genie"],
  u: "1f9de-200d-2642-fe0f",
  a: "5.0"
}, {
  n: ["woman genie", "female genie"],
  u: "1f9de-200d-2640-fe0f",
  a: "5.0"
}, {
  n: ["zombie"],
  u: "1f9df",
  a: "5.0"
}, {
  n: ["man zombie", "male zombie"],
  u: "1f9df-200d-2642-fe0f",
  a: "5.0"
}, {
  n: ["woman zombie", "female zombie"],
  u: "1f9df-200d-2640-fe0f",
  a: "5.0"
}, {
  n: ["troll"],
  u: "1f9cc",
  a: "14.0"
}, {
  n: ["massage", "face massage"],
  u: "1f486",
  v: ["1f486-1f3fb", "1f486-1f3fc", "1f486-1f3fd", "1f486-1f3fe", "1f486-1f3ff"],
  a: "0.6"
}, {
  n: ["man getting massage", "man-getting-massage"],
  u: "1f486-200d-2642-fe0f",
  v: ["1f486-1f3fb-200d-2642-fe0f", "1f486-1f3fc-200d-2642-fe0f", "1f486-1f3fd-200d-2642-fe0f", "1f486-1f3fe-200d-2642-fe0f", "1f486-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman getting massage", "woman-getting-massage"],
  u: "1f486-200d-2640-fe0f",
  v: ["1f486-1f3fb-200d-2640-fe0f", "1f486-1f3fc-200d-2640-fe0f", "1f486-1f3fd-200d-2640-fe0f", "1f486-1f3fe-200d-2640-fe0f", "1f486-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["haircut"],
  u: "1f487",
  v: ["1f487-1f3fb", "1f487-1f3fc", "1f487-1f3fd", "1f487-1f3fe", "1f487-1f3ff"],
  a: "0.6"
}, {
  n: ["man getting haircut", "man-getting-haircut"],
  u: "1f487-200d-2642-fe0f",
  v: ["1f487-1f3fb-200d-2642-fe0f", "1f487-1f3fc-200d-2642-fe0f", "1f487-1f3fd-200d-2642-fe0f", "1f487-1f3fe-200d-2642-fe0f", "1f487-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman getting haircut", "woman-getting-haircut"],
  u: "1f487-200d-2640-fe0f",
  v: ["1f487-1f3fb-200d-2640-fe0f", "1f487-1f3fc-200d-2640-fe0f", "1f487-1f3fd-200d-2640-fe0f", "1f487-1f3fe-200d-2640-fe0f", "1f487-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["walking", "pedestrian"],
  u: "1f6b6",
  v: ["1f6b6-1f3fb", "1f6b6-1f3fc", "1f6b6-1f3fd", "1f6b6-1f3fe", "1f6b6-1f3ff"],
  a: "0.6"
}, {
  n: ["man walking", "man-walking"],
  u: "1f6b6-200d-2642-fe0f",
  v: ["1f6b6-1f3fb-200d-2642-fe0f", "1f6b6-1f3fc-200d-2642-fe0f", "1f6b6-1f3fd-200d-2642-fe0f", "1f6b6-1f3fe-200d-2642-fe0f", "1f6b6-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman walking", "woman-walking"],
  u: "1f6b6-200d-2640-fe0f",
  v: ["1f6b6-1f3fb-200d-2640-fe0f", "1f6b6-1f3fc-200d-2640-fe0f", "1f6b6-1f3fd-200d-2640-fe0f", "1f6b6-1f3fe-200d-2640-fe0f", "1f6b6-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["standing person"],
  u: "1f9cd",
  v: ["1f9cd-1f3fb", "1f9cd-1f3fc", "1f9cd-1f3fd", "1f9cd-1f3fe", "1f9cd-1f3ff"],
  a: "12.0"
}, {
  n: ["man standing"],
  u: "1f9cd-200d-2642-fe0f",
  v: ["1f9cd-1f3fb-200d-2642-fe0f", "1f9cd-1f3fc-200d-2642-fe0f", "1f9cd-1f3fd-200d-2642-fe0f", "1f9cd-1f3fe-200d-2642-fe0f", "1f9cd-1f3ff-200d-2642-fe0f"],
  a: "12.0"
}, {
  n: ["woman standing"],
  u: "1f9cd-200d-2640-fe0f",
  v: ["1f9cd-1f3fb-200d-2640-fe0f", "1f9cd-1f3fc-200d-2640-fe0f", "1f9cd-1f3fd-200d-2640-fe0f", "1f9cd-1f3fe-200d-2640-fe0f", "1f9cd-1f3ff-200d-2640-fe0f"],
  a: "12.0"
}, {
  n: ["kneeling person"],
  u: "1f9ce",
  v: ["1f9ce-1f3fb", "1f9ce-1f3fc", "1f9ce-1f3fd", "1f9ce-1f3fe", "1f9ce-1f3ff"],
  a: "12.0"
}, {
  n: ["man kneeling"],
  u: "1f9ce-200d-2642-fe0f",
  v: ["1f9ce-1f3fb-200d-2642-fe0f", "1f9ce-1f3fc-200d-2642-fe0f", "1f9ce-1f3fd-200d-2642-fe0f", "1f9ce-1f3fe-200d-2642-fe0f", "1f9ce-1f3ff-200d-2642-fe0f"],
  a: "12.0"
}, {
  n: ["woman kneeling"],
  u: "1f9ce-200d-2640-fe0f",
  v: ["1f9ce-1f3fb-200d-2640-fe0f", "1f9ce-1f3fc-200d-2640-fe0f", "1f9ce-1f3fd-200d-2640-fe0f", "1f9ce-1f3fe-200d-2640-fe0f", "1f9ce-1f3ff-200d-2640-fe0f"],
  a: "12.0"
}, {
  n: ["person with white cane", "person with probing cane"],
  u: "1f9d1-200d-1f9af",
  v: ["1f9d1-1f3fb-200d-1f9af", "1f9d1-1f3fc-200d-1f9af", "1f9d1-1f3fd-200d-1f9af", "1f9d1-1f3fe-200d-1f9af", "1f9d1-1f3ff-200d-1f9af"],
  a: "12.1"
}, {
  n: ["man with white cane", "man with probing cane"],
  u: "1f468-200d-1f9af",
  v: ["1f468-1f3fb-200d-1f9af", "1f468-1f3fc-200d-1f9af", "1f468-1f3fd-200d-1f9af", "1f468-1f3fe-200d-1f9af", "1f468-1f3ff-200d-1f9af"],
  a: "12.0"
}, {
  n: ["woman with white cane", "woman with probing cane"],
  u: "1f469-200d-1f9af",
  v: ["1f469-1f3fb-200d-1f9af", "1f469-1f3fc-200d-1f9af", "1f469-1f3fd-200d-1f9af", "1f469-1f3fe-200d-1f9af", "1f469-1f3ff-200d-1f9af"],
  a: "12.0"
}, {
  n: ["person in motorized wheelchair"],
  u: "1f9d1-200d-1f9bc",
  v: ["1f9d1-1f3fb-200d-1f9bc", "1f9d1-1f3fc-200d-1f9bc", "1f9d1-1f3fd-200d-1f9bc", "1f9d1-1f3fe-200d-1f9bc", "1f9d1-1f3ff-200d-1f9bc"],
  a: "12.1"
}, {
  n: ["man in motorized wheelchair"],
  u: "1f468-200d-1f9bc",
  v: ["1f468-1f3fb-200d-1f9bc", "1f468-1f3fc-200d-1f9bc", "1f468-1f3fd-200d-1f9bc", "1f468-1f3fe-200d-1f9bc", "1f468-1f3ff-200d-1f9bc"],
  a: "12.0"
}, {
  n: ["woman in motorized wheelchair"],
  u: "1f469-200d-1f9bc",
  v: ["1f469-1f3fb-200d-1f9bc", "1f469-1f3fc-200d-1f9bc", "1f469-1f3fd-200d-1f9bc", "1f469-1f3fe-200d-1f9bc", "1f469-1f3ff-200d-1f9bc"],
  a: "12.0"
}, {
  n: ["person in manual wheelchair"],
  u: "1f9d1-200d-1f9bd",
  v: ["1f9d1-1f3fb-200d-1f9bd", "1f9d1-1f3fc-200d-1f9bd", "1f9d1-1f3fd-200d-1f9bd", "1f9d1-1f3fe-200d-1f9bd", "1f9d1-1f3ff-200d-1f9bd"],
  a: "12.1"
}, {
  n: ["man in manual wheelchair"],
  u: "1f468-200d-1f9bd",
  v: ["1f468-1f3fb-200d-1f9bd", "1f468-1f3fc-200d-1f9bd", "1f468-1f3fd-200d-1f9bd", "1f468-1f3fe-200d-1f9bd", "1f468-1f3ff-200d-1f9bd"],
  a: "12.0"
}, {
  n: ["woman in manual wheelchair"],
  u: "1f469-200d-1f9bd",
  v: ["1f469-1f3fb-200d-1f9bd", "1f469-1f3fc-200d-1f9bd", "1f469-1f3fd-200d-1f9bd", "1f469-1f3fe-200d-1f9bd", "1f469-1f3ff-200d-1f9bd"],
  a: "12.0"
}, {
  n: ["runner", "running"],
  u: "1f3c3",
  v: ["1f3c3-1f3fb", "1f3c3-1f3fc", "1f3c3-1f3fd", "1f3c3-1f3fe", "1f3c3-1f3ff"],
  a: "0.6"
}, {
  n: ["man running", "man-running"],
  u: "1f3c3-200d-2642-fe0f",
  v: ["1f3c3-1f3fb-200d-2642-fe0f", "1f3c3-1f3fc-200d-2642-fe0f", "1f3c3-1f3fd-200d-2642-fe0f", "1f3c3-1f3fe-200d-2642-fe0f", "1f3c3-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman running", "woman-running"],
  u: "1f3c3-200d-2640-fe0f",
  v: ["1f3c3-1f3fb-200d-2640-fe0f", "1f3c3-1f3fc-200d-2640-fe0f", "1f3c3-1f3fd-200d-2640-fe0f", "1f3c3-1f3fe-200d-2640-fe0f", "1f3c3-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["dancer"],
  u: "1f483",
  v: ["1f483-1f3fb", "1f483-1f3fc", "1f483-1f3fd", "1f483-1f3fe", "1f483-1f3ff"],
  a: "0.6"
}, {
  n: ["man dancing"],
  u: "1f57a",
  v: ["1f57a-1f3fb", "1f57a-1f3fc", "1f57a-1f3fd", "1f57a-1f3fe", "1f57a-1f3ff"],
  a: "3.0"
}, {
  n: ["person in suit levitating", "man in business suit levitating"],
  u: "1f574-fe0f",
  v: ["1f574-1f3fb", "1f574-1f3fc", "1f574-1f3fd", "1f574-1f3fe", "1f574-1f3ff"],
  a: "0.7"
}, {
  n: ["dancers", "woman with bunny ears"],
  u: "1f46f",
  a: "0.6"
}, {
  n: ["men with bunny ears", "men-with-bunny-ears-partying", "man-with-bunny-ears-partying"],
  u: "1f46f-200d-2642-fe0f",
  a: "4.0"
}, {
  n: ["women with bunny ears", "women-with-bunny-ears-partying", "woman-with-bunny-ears-partying"],
  u: "1f46f-200d-2640-fe0f",
  a: "4.0"
}, {
  n: ["person in steamy room"],
  u: "1f9d6",
  v: ["1f9d6-1f3fb", "1f9d6-1f3fc", "1f9d6-1f3fd", "1f9d6-1f3fe", "1f9d6-1f3ff"],
  a: "5.0"
}, {
  n: ["man in steamy room"],
  u: "1f9d6-200d-2642-fe0f",
  v: ["1f9d6-1f3fb-200d-2642-fe0f", "1f9d6-1f3fc-200d-2642-fe0f", "1f9d6-1f3fd-200d-2642-fe0f", "1f9d6-1f3fe-200d-2642-fe0f", "1f9d6-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman in steamy room"],
  u: "1f9d6-200d-2640-fe0f",
  v: ["1f9d6-1f3fb-200d-2640-fe0f", "1f9d6-1f3fc-200d-2640-fe0f", "1f9d6-1f3fd-200d-2640-fe0f", "1f9d6-1f3fe-200d-2640-fe0f", "1f9d6-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["person climbing"],
  u: "1f9d7",
  v: ["1f9d7-1f3fb", "1f9d7-1f3fc", "1f9d7-1f3fd", "1f9d7-1f3fe", "1f9d7-1f3ff"],
  a: "5.0"
}, {
  n: ["man climbing"],
  u: "1f9d7-200d-2642-fe0f",
  v: ["1f9d7-1f3fb-200d-2642-fe0f", "1f9d7-1f3fc-200d-2642-fe0f", "1f9d7-1f3fd-200d-2642-fe0f", "1f9d7-1f3fe-200d-2642-fe0f", "1f9d7-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman climbing"],
  u: "1f9d7-200d-2640-fe0f",
  v: ["1f9d7-1f3fb-200d-2640-fe0f", "1f9d7-1f3fc-200d-2640-fe0f", "1f9d7-1f3fd-200d-2640-fe0f", "1f9d7-1f3fe-200d-2640-fe0f", "1f9d7-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["fencer"],
  u: "1f93a",
  a: "3.0"
}, {
  n: ["horse racing"],
  u: "1f3c7",
  v: ["1f3c7-1f3fb", "1f3c7-1f3fc", "1f3c7-1f3fd", "1f3c7-1f3fe", "1f3c7-1f3ff"],
  a: "1.0"
}, {
  n: ["skier"],
  u: "26f7-fe0f",
  a: "0.7"
}, {
  n: ["snowboarder"],
  u: "1f3c2",
  v: ["1f3c2-1f3fb", "1f3c2-1f3fc", "1f3c2-1f3fd", "1f3c2-1f3fe", "1f3c2-1f3ff"],
  a: "0.6"
}, {
  n: ["golfer", "person golfing"],
  u: "1f3cc-fe0f",
  v: ["1f3cc-1f3fb", "1f3cc-1f3fc", "1f3cc-1f3fd", "1f3cc-1f3fe", "1f3cc-1f3ff"],
  a: "0.7"
}, {
  n: ["man golfing", "man-golfing"],
  u: "1f3cc-fe0f-200d-2642-fe0f",
  v: ["1f3cc-1f3fb-200d-2642-fe0f", "1f3cc-1f3fc-200d-2642-fe0f", "1f3cc-1f3fd-200d-2642-fe0f", "1f3cc-1f3fe-200d-2642-fe0f", "1f3cc-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman golfing", "woman-golfing"],
  u: "1f3cc-fe0f-200d-2640-fe0f",
  v: ["1f3cc-1f3fb-200d-2640-fe0f", "1f3cc-1f3fc-200d-2640-fe0f", "1f3cc-1f3fd-200d-2640-fe0f", "1f3cc-1f3fe-200d-2640-fe0f", "1f3cc-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["surfer"],
  u: "1f3c4",
  v: ["1f3c4-1f3fb", "1f3c4-1f3fc", "1f3c4-1f3fd", "1f3c4-1f3fe", "1f3c4-1f3ff"],
  a: "0.6"
}, {
  n: ["man surfing", "man-surfing"],
  u: "1f3c4-200d-2642-fe0f",
  v: ["1f3c4-1f3fb-200d-2642-fe0f", "1f3c4-1f3fc-200d-2642-fe0f", "1f3c4-1f3fd-200d-2642-fe0f", "1f3c4-1f3fe-200d-2642-fe0f", "1f3c4-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman surfing", "woman-surfing"],
  u: "1f3c4-200d-2640-fe0f",
  v: ["1f3c4-1f3fb-200d-2640-fe0f", "1f3c4-1f3fc-200d-2640-fe0f", "1f3c4-1f3fd-200d-2640-fe0f", "1f3c4-1f3fe-200d-2640-fe0f", "1f3c4-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["rowboat"],
  u: "1f6a3",
  v: ["1f6a3-1f3fb", "1f6a3-1f3fc", "1f6a3-1f3fd", "1f6a3-1f3fe", "1f6a3-1f3ff"],
  a: "1.0"
}, {
  n: ["man rowing boat", "man-rowing-boat"],
  u: "1f6a3-200d-2642-fe0f",
  v: ["1f6a3-1f3fb-200d-2642-fe0f", "1f6a3-1f3fc-200d-2642-fe0f", "1f6a3-1f3fd-200d-2642-fe0f", "1f6a3-1f3fe-200d-2642-fe0f", "1f6a3-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman rowing boat", "woman-rowing-boat"],
  u: "1f6a3-200d-2640-fe0f",
  v: ["1f6a3-1f3fb-200d-2640-fe0f", "1f6a3-1f3fc-200d-2640-fe0f", "1f6a3-1f3fd-200d-2640-fe0f", "1f6a3-1f3fe-200d-2640-fe0f", "1f6a3-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["swimmer"],
  u: "1f3ca",
  v: ["1f3ca-1f3fb", "1f3ca-1f3fc", "1f3ca-1f3fd", "1f3ca-1f3fe", "1f3ca-1f3ff"],
  a: "0.6"
}, {
  n: ["man swimming", "man-swimming"],
  u: "1f3ca-200d-2642-fe0f",
  v: ["1f3ca-1f3fb-200d-2642-fe0f", "1f3ca-1f3fc-200d-2642-fe0f", "1f3ca-1f3fd-200d-2642-fe0f", "1f3ca-1f3fe-200d-2642-fe0f", "1f3ca-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman swimming", "woman-swimming"],
  u: "1f3ca-200d-2640-fe0f",
  v: ["1f3ca-1f3fb-200d-2640-fe0f", "1f3ca-1f3fc-200d-2640-fe0f", "1f3ca-1f3fd-200d-2640-fe0f", "1f3ca-1f3fe-200d-2640-fe0f", "1f3ca-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["person with ball", "person bouncing ball"],
  u: "26f9-fe0f",
  v: ["26f9-1f3fb", "26f9-1f3fc", "26f9-1f3fd", "26f9-1f3fe", "26f9-1f3ff"],
  a: "0.7"
}, {
  n: ["man bouncing ball", "man-bouncing-ball"],
  u: "26f9-fe0f-200d-2642-fe0f",
  v: ["26f9-1f3fb-200d-2642-fe0f", "26f9-1f3fc-200d-2642-fe0f", "26f9-1f3fd-200d-2642-fe0f", "26f9-1f3fe-200d-2642-fe0f", "26f9-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman bouncing ball", "woman-bouncing-ball"],
  u: "26f9-fe0f-200d-2640-fe0f",
  v: ["26f9-1f3fb-200d-2640-fe0f", "26f9-1f3fc-200d-2640-fe0f", "26f9-1f3fd-200d-2640-fe0f", "26f9-1f3fe-200d-2640-fe0f", "26f9-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["weight lifter", "person lifting weights"],
  u: "1f3cb-fe0f",
  v: ["1f3cb-1f3fb", "1f3cb-1f3fc", "1f3cb-1f3fd", "1f3cb-1f3fe", "1f3cb-1f3ff"],
  a: "0.7"
}, {
  n: ["man lifting weights", "man-lifting-weights"],
  u: "1f3cb-fe0f-200d-2642-fe0f",
  v: ["1f3cb-1f3fb-200d-2642-fe0f", "1f3cb-1f3fc-200d-2642-fe0f", "1f3cb-1f3fd-200d-2642-fe0f", "1f3cb-1f3fe-200d-2642-fe0f", "1f3cb-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman lifting weights", "woman-lifting-weights"],
  u: "1f3cb-fe0f-200d-2640-fe0f",
  v: ["1f3cb-1f3fb-200d-2640-fe0f", "1f3cb-1f3fc-200d-2640-fe0f", "1f3cb-1f3fd-200d-2640-fe0f", "1f3cb-1f3fe-200d-2640-fe0f", "1f3cb-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["bicyclist"],
  u: "1f6b4",
  v: ["1f6b4-1f3fb", "1f6b4-1f3fc", "1f6b4-1f3fd", "1f6b4-1f3fe", "1f6b4-1f3ff"],
  a: "1.0"
}, {
  n: ["man biking", "man-biking"],
  u: "1f6b4-200d-2642-fe0f",
  v: ["1f6b4-1f3fb-200d-2642-fe0f", "1f6b4-1f3fc-200d-2642-fe0f", "1f6b4-1f3fd-200d-2642-fe0f", "1f6b4-1f3fe-200d-2642-fe0f", "1f6b4-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman biking", "woman-biking"],
  u: "1f6b4-200d-2640-fe0f",
  v: ["1f6b4-1f3fb-200d-2640-fe0f", "1f6b4-1f3fc-200d-2640-fe0f", "1f6b4-1f3fd-200d-2640-fe0f", "1f6b4-1f3fe-200d-2640-fe0f", "1f6b4-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["mountain bicyclist"],
  u: "1f6b5",
  v: ["1f6b5-1f3fb", "1f6b5-1f3fc", "1f6b5-1f3fd", "1f6b5-1f3fe", "1f6b5-1f3ff"],
  a: "1.0"
}, {
  n: ["man mountain biking", "man-mountain-biking"],
  u: "1f6b5-200d-2642-fe0f",
  v: ["1f6b5-1f3fb-200d-2642-fe0f", "1f6b5-1f3fc-200d-2642-fe0f", "1f6b5-1f3fd-200d-2642-fe0f", "1f6b5-1f3fe-200d-2642-fe0f", "1f6b5-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman mountain biking", "woman-mountain-biking"],
  u: "1f6b5-200d-2640-fe0f",
  v: ["1f6b5-1f3fb-200d-2640-fe0f", "1f6b5-1f3fc-200d-2640-fe0f", "1f6b5-1f3fd-200d-2640-fe0f", "1f6b5-1f3fe-200d-2640-fe0f", "1f6b5-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["person doing cartwheel"],
  u: "1f938",
  v: ["1f938-1f3fb", "1f938-1f3fc", "1f938-1f3fd", "1f938-1f3fe", "1f938-1f3ff"],
  a: "3.0"
}, {
  n: ["man cartwheeling", "man-cartwheeling"],
  u: "1f938-200d-2642-fe0f",
  v: ["1f938-1f3fb-200d-2642-fe0f", "1f938-1f3fc-200d-2642-fe0f", "1f938-1f3fd-200d-2642-fe0f", "1f938-1f3fe-200d-2642-fe0f", "1f938-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman cartwheeling", "woman-cartwheeling"],
  u: "1f938-200d-2640-fe0f",
  v: ["1f938-1f3fb-200d-2640-fe0f", "1f938-1f3fc-200d-2640-fe0f", "1f938-1f3fd-200d-2640-fe0f", "1f938-1f3fe-200d-2640-fe0f", "1f938-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["wrestlers"],
  u: "1f93c",
  a: "3.0"
}, {
  n: ["men wrestling", "man-wrestling"],
  u: "1f93c-200d-2642-fe0f",
  a: "4.0"
}, {
  n: ["women wrestling", "woman-wrestling"],
  u: "1f93c-200d-2640-fe0f",
  a: "4.0"
}, {
  n: ["water polo"],
  u: "1f93d",
  v: ["1f93d-1f3fb", "1f93d-1f3fc", "1f93d-1f3fd", "1f93d-1f3fe", "1f93d-1f3ff"],
  a: "3.0"
}, {
  n: ["man playing water polo", "man-playing-water-polo"],
  u: "1f93d-200d-2642-fe0f",
  v: ["1f93d-1f3fb-200d-2642-fe0f", "1f93d-1f3fc-200d-2642-fe0f", "1f93d-1f3fd-200d-2642-fe0f", "1f93d-1f3fe-200d-2642-fe0f", "1f93d-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman playing water polo", "woman-playing-water-polo"],
  u: "1f93d-200d-2640-fe0f",
  v: ["1f93d-1f3fb-200d-2640-fe0f", "1f93d-1f3fc-200d-2640-fe0f", "1f93d-1f3fd-200d-2640-fe0f", "1f93d-1f3fe-200d-2640-fe0f", "1f93d-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["handball"],
  u: "1f93e",
  v: ["1f93e-1f3fb", "1f93e-1f3fc", "1f93e-1f3fd", "1f93e-1f3fe", "1f93e-1f3ff"],
  a: "3.0"
}, {
  n: ["man playing handball", "man-playing-handball"],
  u: "1f93e-200d-2642-fe0f",
  v: ["1f93e-1f3fb-200d-2642-fe0f", "1f93e-1f3fc-200d-2642-fe0f", "1f93e-1f3fd-200d-2642-fe0f", "1f93e-1f3fe-200d-2642-fe0f", "1f93e-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman playing handball", "woman-playing-handball"],
  u: "1f93e-200d-2640-fe0f",
  v: ["1f93e-1f3fb-200d-2640-fe0f", "1f93e-1f3fc-200d-2640-fe0f", "1f93e-1f3fd-200d-2640-fe0f", "1f93e-1f3fe-200d-2640-fe0f", "1f93e-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["juggling"],
  u: "1f939",
  v: ["1f939-1f3fb", "1f939-1f3fc", "1f939-1f3fd", "1f939-1f3fe", "1f939-1f3ff"],
  a: "3.0"
}, {
  n: ["man juggling", "man-juggling"],
  u: "1f939-200d-2642-fe0f",
  v: ["1f939-1f3fb-200d-2642-fe0f", "1f939-1f3fc-200d-2642-fe0f", "1f939-1f3fd-200d-2642-fe0f", "1f939-1f3fe-200d-2642-fe0f", "1f939-1f3ff-200d-2642-fe0f"],
  a: "4.0"
}, {
  n: ["woman juggling", "woman-juggling"],
  u: "1f939-200d-2640-fe0f",
  v: ["1f939-1f3fb-200d-2640-fe0f", "1f939-1f3fc-200d-2640-fe0f", "1f939-1f3fd-200d-2640-fe0f", "1f939-1f3fe-200d-2640-fe0f", "1f939-1f3ff-200d-2640-fe0f"],
  a: "4.0"
}, {
  n: ["person in lotus position"],
  u: "1f9d8",
  v: ["1f9d8-1f3fb", "1f9d8-1f3fc", "1f9d8-1f3fd", "1f9d8-1f3fe", "1f9d8-1f3ff"],
  a: "5.0"
}, {
  n: ["man in lotus position"],
  u: "1f9d8-200d-2642-fe0f",
  v: ["1f9d8-1f3fb-200d-2642-fe0f", "1f9d8-1f3fc-200d-2642-fe0f", "1f9d8-1f3fd-200d-2642-fe0f", "1f9d8-1f3fe-200d-2642-fe0f", "1f9d8-1f3ff-200d-2642-fe0f"],
  a: "5.0"
}, {
  n: ["woman in lotus position"],
  u: "1f9d8-200d-2640-fe0f",
  v: ["1f9d8-1f3fb-200d-2640-fe0f", "1f9d8-1f3fc-200d-2640-fe0f", "1f9d8-1f3fd-200d-2640-fe0f", "1f9d8-1f3fe-200d-2640-fe0f", "1f9d8-1f3ff-200d-2640-fe0f"],
  a: "5.0"
}, {
  n: ["bath"],
  u: "1f6c0",
  v: ["1f6c0-1f3fb", "1f6c0-1f3fc", "1f6c0-1f3fd", "1f6c0-1f3fe", "1f6c0-1f3ff"],
  a: "0.6"
}, {
  n: ["sleeping accommodation"],
  u: "1f6cc",
  v: ["1f6cc-1f3fb", "1f6cc-1f3fc", "1f6cc-1f3fd", "1f6cc-1f3fe", "1f6cc-1f3ff"],
  a: "1.0"
}, {
  n: ["people holding hands"],
  u: "1f9d1-200d-1f91d-200d-1f9d1",
  v: ["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe", "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"],
  a: "12.0"
}, {
  n: ["women holding hands", "two women holding hands"],
  u: "1f46d",
  v: ["1f46d-1f3fb", "1f46d-1f3fc", "1f46d-1f3fd", "1f46d-1f3fe", "1f46d-1f3ff", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe", "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd", "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"],
  a: "1.0"
}, {
  n: ["couple", "man and woman holding hands", "woman and man holding hands"],
  u: "1f46b",
  v: ["1f46b-1f3fb", "1f46b-1f3fc", "1f46b-1f3fd", "1f46b-1f3fe", "1f46b-1f3ff", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe", "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd", "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"],
  a: "0.6"
}, {
  n: ["men holding hands", "two men holding hands"],
  u: "1f46c",
  v: ["1f46c-1f3fb", "1f46c-1f3fc", "1f46c-1f3fd", "1f46c-1f3fe", "1f46c-1f3ff", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe", "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd", "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"],
  a: "1.0"
}, {
  n: ["kiss", "couplekiss"],
  u: "1f48f",
  v: ["1f48f-1f3fb", "1f48f-1f3fc", "1f48f-1f3fd", "1f48f-1f3fe", "1f48f-1f3ff", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"],
  a: "0.6"
}, {
  n: ["woman-kiss-man", "kiss: woman, man"],
  u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
  v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"],
  a: "2.0"
}, {
  n: ["man-kiss-man", "kiss: man, man"],
  u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
  v: ["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe", "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"],
  a: "2.0"
}, {
  n: ["woman-kiss-woman", "kiss: woman, woman"],
  u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
  v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"],
  a: "2.0"
}, {
  n: ["couple with heart"],
  u: "1f491",
  v: ["1f491-1f3fb", "1f491-1f3fc", "1f491-1f3fd", "1f491-1f3fe", "1f491-1f3ff", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe", "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd", "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"],
  a: "0.6"
}, {
  n: ["woman-heart-man", "couple with heart: woman, man"],
  u: "1f469-200d-2764-fe0f-200d-1f468",
  v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"],
  a: "2.0"
}, {
  n: ["man-heart-man", "couple with heart: man, man"],
  u: "1f468-200d-2764-fe0f-200d-1f468",
  v: ["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe", "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"],
  a: "2.0"
}, {
  n: ["woman-heart-woman", "couple with heart: woman, woman"],
  u: "1f469-200d-2764-fe0f-200d-1f469",
  v: ["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe", "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"],
  a: "2.0"
}, {
  n: ["family"],
  u: "1f46a",
  a: "0.6"
}, {
  n: ["man-woman-boy", "family: man, woman, boy"],
  u: "1f468-200d-1f469-200d-1f466",
  a: "2.0"
}, {
  n: ["man-woman-girl", "family: man, woman, girl"],
  u: "1f468-200d-1f469-200d-1f467",
  a: "2.0"
}, {
  n: ["man-woman-girl-boy", "family: man, woman, girl, boy"],
  u: "1f468-200d-1f469-200d-1f467-200d-1f466",
  a: "2.0"
}, {
  n: ["man-woman-boy-boy", "family: man, woman, boy, boy"],
  u: "1f468-200d-1f469-200d-1f466-200d-1f466",
  a: "2.0"
}, {
  n: ["man-woman-girl-girl", "family: man, woman, girl, girl"],
  u: "1f468-200d-1f469-200d-1f467-200d-1f467",
  a: "2.0"
}, {
  n: ["man-man-boy", "family: man, man, boy"],
  u: "1f468-200d-1f468-200d-1f466",
  a: "2.0"
}, {
  n: ["man-man-girl", "family: man, man, girl"],
  u: "1f468-200d-1f468-200d-1f467",
  a: "2.0"
}, {
  n: ["man-man-girl-boy", "family: man, man, girl, boy"],
  u: "1f468-200d-1f468-200d-1f467-200d-1f466",
  a: "2.0"
}, {
  n: ["man-man-boy-boy", "family: man, man, boy, boy"],
  u: "1f468-200d-1f468-200d-1f466-200d-1f466",
  a: "2.0"
}, {
  n: ["man-man-girl-girl", "family: man, man, girl, girl"],
  u: "1f468-200d-1f468-200d-1f467-200d-1f467",
  a: "2.0"
}, {
  n: ["woman-woman-boy", "family: woman, woman, boy"],
  u: "1f469-200d-1f469-200d-1f466",
  a: "2.0"
}, {
  n: ["woman-woman-girl", "family: woman, woman, girl"],
  u: "1f469-200d-1f469-200d-1f467",
  a: "2.0"
}, {
  n: ["woman-woman-girl-boy", "family: woman, woman, girl, boy"],
  u: "1f469-200d-1f469-200d-1f467-200d-1f466",
  a: "2.0"
}, {
  n: ["woman-woman-boy-boy", "family: woman, woman, boy, boy"],
  u: "1f469-200d-1f469-200d-1f466-200d-1f466",
  a: "2.0"
}, {
  n: ["woman-woman-girl-girl", "family: woman, woman, girl, girl"],
  u: "1f469-200d-1f469-200d-1f467-200d-1f467",
  a: "2.0"
}, {
  n: ["man-boy", "family: man, boy"],
  u: "1f468-200d-1f466",
  a: "4.0"
}, {
  n: ["man-boy-boy", "family: man, boy, boy"],
  u: "1f468-200d-1f466-200d-1f466",
  a: "4.0"
}, {
  n: ["man-girl", "family: man, girl"],
  u: "1f468-200d-1f467",
  a: "4.0"
}, {
  n: ["man-girl-boy", "family: man, girl, boy"],
  u: "1f468-200d-1f467-200d-1f466",
  a: "4.0"
}, {
  n: ["man-girl-girl", "family: man, girl, girl"],
  u: "1f468-200d-1f467-200d-1f467",
  a: "4.0"
}, {
  n: ["woman-boy", "family: woman, boy"],
  u: "1f469-200d-1f466",
  a: "4.0"
}, {
  n: ["woman-boy-boy", "family: woman, boy, boy"],
  u: "1f469-200d-1f466-200d-1f466",
  a: "4.0"
}, {
  n: ["woman-girl", "family: woman, girl"],
  u: "1f469-200d-1f467",
  a: "4.0"
}, {
  n: ["woman-girl-boy", "family: woman, girl, boy"],
  u: "1f469-200d-1f467-200d-1f466",
  a: "4.0"
}, {
  n: ["woman-girl-girl", "family: woman, girl, girl"],
  u: "1f469-200d-1f467-200d-1f467",
  a: "4.0"
}, {
  n: ["speaking head", "speaking head in silhouette"],
  u: "1f5e3-fe0f",
  a: "0.7"
}, {
  n: ["bust in silhouette"],
  u: "1f464",
  a: "0.6"
}, {
  n: ["busts in silhouette"],
  u: "1f465",
  a: "1.0"
}, {
  n: ["people hugging"],
  u: "1fac2",
  a: "13.0"
}, {
  n: ["footprints"],
  u: "1f463",
  a: "0.6"
}];
var animals_nature = [{
  n: ["monkey face"],
  u: "1f435",
  a: "0.6"
}, {
  n: ["monkey"],
  u: "1f412",
  a: "0.6"
}, {
  n: ["gorilla"],
  u: "1f98d",
  a: "3.0"
}, {
  n: ["orangutan"],
  u: "1f9a7",
  a: "12.0"
}, {
  n: ["dog", "dog face"],
  u: "1f436",
  a: "0.6"
}, {
  n: ["dog", "dog2"],
  u: "1f415",
  a: "0.7"
}, {
  n: ["guide dog"],
  u: "1f9ae",
  a: "12.0"
}, {
  n: ["service dog"],
  u: "1f415-200d-1f9ba",
  a: "12.0"
}, {
  n: ["poodle"],
  u: "1f429",
  a: "0.6"
}, {
  n: ["wolf", "wolf face"],
  u: "1f43a",
  a: "0.6"
}, {
  n: ["fox face"],
  u: "1f98a",
  a: "3.0"
}, {
  n: ["raccoon"],
  u: "1f99d",
  a: "11.0"
}, {
  n: ["cat", "cat face"],
  u: "1f431",
  a: "0.6"
}, {
  n: ["cat", "cat2"],
  u: "1f408",
  a: "0.7"
}, {
  n: ["black cat"],
  u: "1f408-200d-2b1b",
  a: "13.0"
}, {
  n: ["lion face"],
  u: "1f981",
  a: "1.0"
}, {
  n: ["tiger", "tiger face"],
  u: "1f42f",
  a: "0.6"
}, {
  n: ["tiger", "tiger2"],
  u: "1f405",
  a: "1.0"
}, {
  n: ["leopard"],
  u: "1f406",
  a: "1.0"
}, {
  n: ["horse", "horse face"],
  u: "1f434",
  a: "0.6"
}, {
  n: ["horse", "racehorse"],
  u: "1f40e",
  a: "0.6"
}, {
  n: ["unicorn face"],
  u: "1f984",
  a: "1.0"
}, {
  n: ["zebra face"],
  u: "1f993",
  a: "5.0"
}, {
  n: ["deer"],
  u: "1f98c",
  a: "3.0"
}, {
  n: ["bison"],
  u: "1f9ac",
  a: "13.0"
}, {
  n: ["cow", "cow face"],
  u: "1f42e",
  a: "0.6"
}, {
  n: ["ox"],
  u: "1f402",
  a: "1.0"
}, {
  n: ["water buffalo"],
  u: "1f403",
  a: "1.0"
}, {
  n: ["cow", "cow2"],
  u: "1f404",
  a: "1.0"
}, {
  n: ["pig", "pig face"],
  u: "1f437",
  a: "0.6"
}, {
  n: ["pig", "pig2"],
  u: "1f416",
  a: "1.0"
}, {
  n: ["boar"],
  u: "1f417",
  a: "0.6"
}, {
  n: ["pig nose"],
  u: "1f43d",
  a: "0.6"
}, {
  n: ["ram"],
  u: "1f40f",
  a: "1.0"
}, {
  n: ["sheep"],
  u: "1f411",
  a: "0.6"
}, {
  n: ["goat"],
  u: "1f410",
  a: "1.0"
}, {
  n: ["dromedary camel"],
  u: "1f42a",
  a: "1.0"
}, {
  n: ["camel", "bactrian camel"],
  u: "1f42b",
  a: "0.6"
}, {
  n: ["llama"],
  u: "1f999",
  a: "11.0"
}, {
  n: ["giraffe face"],
  u: "1f992",
  a: "5.0"
}, {
  n: ["elephant"],
  u: "1f418",
  a: "0.6"
}, {
  n: ["mammoth"],
  u: "1f9a3",
  a: "13.0"
}, {
  n: ["rhinoceros"],
  u: "1f98f",
  a: "3.0"
}, {
  n: ["hippopotamus"],
  u: "1f99b",
  a: "11.0"
}, {
  n: ["mouse", "mouse face"],
  u: "1f42d",
  a: "0.6"
}, {
  n: ["mouse", "mouse2"],
  u: "1f401",
  a: "1.0"
}, {
  n: ["rat"],
  u: "1f400",
  a: "1.0"
}, {
  n: ["hamster", "hamster face"],
  u: "1f439",
  a: "0.6"
}, {
  n: ["rabbit", "rabbit face"],
  u: "1f430",
  a: "0.6"
}, {
  n: ["rabbit", "rabbit2"],
  u: "1f407",
  a: "1.0"
}, {
  n: ["chipmunk"],
  u: "1f43f-fe0f",
  a: "0.7"
}, {
  n: ["beaver"],
  u: "1f9ab",
  a: "13.0"
}, {
  n: ["hedgehog"],
  u: "1f994",
  a: "5.0"
}, {
  n: ["bat"],
  u: "1f987",
  a: "3.0"
}, {
  n: ["bear", "bear face"],
  u: "1f43b",
  a: "0.6"
}, {
  n: ["polar bear"],
  u: "1f43b-200d-2744-fe0f",
  a: "13.0"
}, {
  n: ["koala"],
  u: "1f428",
  a: "0.6"
}, {
  n: ["panda face"],
  u: "1f43c",
  a: "0.6"
}, {
  n: ["sloth"],
  u: "1f9a5",
  a: "12.0"
}, {
  n: ["otter"],
  u: "1f9a6",
  a: "12.0"
}, {
  n: ["skunk"],
  u: "1f9a8",
  a: "12.0"
}, {
  n: ["kangaroo"],
  u: "1f998",
  a: "11.0"
}, {
  n: ["badger"],
  u: "1f9a1",
  a: "11.0"
}, {
  n: ["feet", "paw prints"],
  u: "1f43e",
  a: "0.6"
}, {
  n: ["turkey"],
  u: "1f983",
  a: "1.0"
}, {
  n: ["chicken"],
  u: "1f414",
  a: "0.6"
}, {
  n: ["rooster"],
  u: "1f413",
  a: "1.0"
}, {
  n: ["hatching chick"],
  u: "1f423",
  a: "0.6"
}, {
  n: ["baby chick"],
  u: "1f424",
  a: "0.6"
}, {
  n: ["hatched chick", "front-facing baby chick"],
  u: "1f425",
  a: "0.6"
}, {
  n: ["bird"],
  u: "1f426",
  a: "0.6"
}, {
  n: ["penguin"],
  u: "1f427",
  a: "0.6"
}, {
  n: ["dove", "dove of peace"],
  u: "1f54a-fe0f",
  a: "0.7"
}, {
  n: ["eagle"],
  u: "1f985",
  a: "3.0"
}, {
  n: ["duck"],
  u: "1f986",
  a: "3.0"
}, {
  n: ["swan"],
  u: "1f9a2",
  a: "11.0"
}, {
  n: ["owl"],
  u: "1f989",
  a: "3.0"
}, {
  n: ["dodo"],
  u: "1f9a4",
  a: "13.0"
}, {
  n: ["feather"],
  u: "1fab6",
  a: "13.0"
}, {
  n: ["flamingo"],
  u: "1f9a9",
  a: "12.0"
}, {
  n: ["peacock"],
  u: "1f99a",
  a: "11.0"
}, {
  n: ["parrot"],
  u: "1f99c",
  a: "11.0"
}, {
  n: ["frog", "frog face"],
  u: "1f438",
  a: "0.6"
}, {
  n: ["crocodile"],
  u: "1f40a",
  a: "1.0"
}, {
  n: ["turtle"],
  u: "1f422",
  a: "0.6"
}, {
  n: ["lizard"],
  u: "1f98e",
  a: "3.0"
}, {
  n: ["snake"],
  u: "1f40d",
  a: "0.6"
}, {
  n: ["dragon face"],
  u: "1f432",
  a: "0.6"
}, {
  n: ["dragon"],
  u: "1f409",
  a: "1.0"
}, {
  n: ["sauropod"],
  u: "1f995",
  a: "5.0"
}, {
  n: ["t-rex"],
  u: "1f996",
  a: "5.0"
}, {
  n: ["whale", "spouting whale"],
  u: "1f433",
  a: "0.6"
}, {
  n: ["whale", "whale2"],
  u: "1f40b",
  a: "1.0"
}, {
  n: ["dolphin", "flipper"],
  u: "1f42c",
  a: "0.6"
}, {
  n: ["seal"],
  u: "1f9ad",
  a: "13.0"
}, {
  n: ["fish"],
  u: "1f41f",
  a: "0.6"
}, {
  n: ["tropical fish"],
  u: "1f420",
  a: "0.6"
}, {
  n: ["blowfish"],
  u: "1f421",
  a: "0.6"
}, {
  n: ["shark"],
  u: "1f988",
  a: "3.0"
}, {
  n: ["octopus"],
  u: "1f419",
  a: "0.6"
}, {
  n: ["shell", "spiral shell"],
  u: "1f41a",
  a: "0.6"
}, {
  n: ["coral"],
  u: "1fab8",
  a: "14.0"
}, {
  n: ["snail"],
  u: "1f40c",
  a: "0.6"
}, {
  n: ["butterfly"],
  u: "1f98b",
  a: "3.0"
}, {
  n: ["bug"],
  u: "1f41b",
  a: "0.6"
}, {
  n: ["ant"],
  u: "1f41c",
  a: "0.6"
}, {
  n: ["bee", "honeybee"],
  u: "1f41d",
  a: "0.6"
}, {
  n: ["beetle"],
  u: "1fab2",
  a: "13.0"
}, {
  n: ["ladybug", "lady beetle"],
  u: "1f41e",
  a: "0.6"
}, {
  n: ["cricket"],
  u: "1f997",
  a: "5.0"
}, {
  n: ["cockroach"],
  u: "1fab3",
  a: "13.0"
}, {
  n: ["spider"],
  u: "1f577-fe0f",
  a: "0.7"
}, {
  n: ["spider web"],
  u: "1f578-fe0f",
  a: "0.7"
}, {
  n: ["scorpion"],
  u: "1f982",
  a: "1.0"
}, {
  n: ["mosquito"],
  u: "1f99f",
  a: "11.0"
}, {
  n: ["fly"],
  u: "1fab0",
  a: "13.0"
}, {
  n: ["worm"],
  u: "1fab1",
  a: "13.0"
}, {
  n: ["microbe"],
  u: "1f9a0",
  a: "11.0"
}, {
  n: ["bouquet"],
  u: "1f490",
  a: "0.6"
}, {
  n: ["cherry blossom"],
  u: "1f338",
  a: "0.6"
}, {
  n: ["white flower"],
  u: "1f4ae",
  a: "0.6"
}, {
  n: ["lotus"],
  u: "1fab7",
  a: "14.0"
}, {
  n: ["rosette"],
  u: "1f3f5-fe0f",
  a: "0.7"
}, {
  n: ["rose"],
  u: "1f339",
  a: "0.6"
}, {
  n: ["wilted flower"],
  u: "1f940",
  a: "3.0"
}, {
  n: ["hibiscus"],
  u: "1f33a",
  a: "0.6"
}, {
  n: ["sunflower"],
  u: "1f33b",
  a: "0.6"
}, {
  n: ["blossom"],
  u: "1f33c",
  a: "0.6"
}, {
  n: ["tulip"],
  u: "1f337",
  a: "0.6"
}, {
  n: ["seedling"],
  u: "1f331",
  a: "0.6"
}, {
  n: ["potted plant"],
  u: "1fab4",
  a: "13.0"
}, {
  n: ["evergreen tree"],
  u: "1f332",
  a: "1.0"
}, {
  n: ["deciduous tree"],
  u: "1f333",
  a: "1.0"
}, {
  n: ["palm tree"],
  u: "1f334",
  a: "0.6"
}, {
  n: ["cactus"],
  u: "1f335",
  a: "0.6"
}, {
  n: ["ear of rice"],
  u: "1f33e",
  a: "0.6"
}, {
  n: ["herb"],
  u: "1f33f",
  a: "0.6"
}, {
  n: ["shamrock"],
  u: "2618-fe0f",
  a: "1.0"
}, {
  n: ["four leaf clover"],
  u: "1f340",
  a: "0.6"
}, {
  n: ["maple leaf"],
  u: "1f341",
  a: "0.6"
}, {
  n: ["fallen leaf"],
  u: "1f342",
  a: "0.6"
}, {
  n: ["leaves", "leaf fluttering in wind"],
  u: "1f343",
  a: "0.6"
}, {
  n: ["empty nest"],
  u: "1fab9",
  a: "14.0"
}, {
  n: ["nest with eggs"],
  u: "1faba",
  a: "14.0"
}];
var food_drink = [{
  n: ["grapes"],
  u: "1f347",
  a: "0.6"
}, {
  n: ["melon"],
  u: "1f348",
  a: "0.6"
}, {
  n: ["watermelon"],
  u: "1f349",
  a: "0.6"
}, {
  n: ["tangerine"],
  u: "1f34a",
  a: "0.6"
}, {
  n: ["lemon"],
  u: "1f34b",
  a: "1.0"
}, {
  n: ["banana"],
  u: "1f34c",
  a: "0.6"
}, {
  n: ["pineapple"],
  u: "1f34d",
  a: "0.6"
}, {
  n: ["mango"],
  u: "1f96d",
  a: "11.0"
}, {
  n: ["apple", "red apple"],
  u: "1f34e",
  a: "0.6"
}, {
  n: ["green apple"],
  u: "1f34f",
  a: "0.6"
}, {
  n: ["pear"],
  u: "1f350",
  a: "1.0"
}, {
  n: ["peach"],
  u: "1f351",
  a: "0.6"
}, {
  n: ["cherries"],
  u: "1f352",
  a: "0.6"
}, {
  n: ["strawberry"],
  u: "1f353",
  a: "0.6"
}, {
  n: ["blueberries"],
  u: "1fad0",
  a: "13.0"
}, {
  n: ["kiwifruit"],
  u: "1f95d",
  a: "3.0"
}, {
  n: ["tomato"],
  u: "1f345",
  a: "0.6"
}, {
  n: ["olive"],
  u: "1fad2",
  a: "13.0"
}, {
  n: ["coconut"],
  u: "1f965",
  a: "5.0"
}, {
  n: ["avocado"],
  u: "1f951",
  a: "3.0"
}, {
  n: ["eggplant", "aubergine"],
  u: "1f346",
  a: "0.6"
}, {
  n: ["potato"],
  u: "1f954",
  a: "3.0"
}, {
  n: ["carrot"],
  u: "1f955",
  a: "3.0"
}, {
  n: ["corn", "ear of maize"],
  u: "1f33d",
  a: "0.6"
}, {
  n: ["hot pepper"],
  u: "1f336-fe0f",
  a: "0.7"
}, {
  n: ["bell pepper"],
  u: "1fad1",
  a: "13.0"
}, {
  n: ["cucumber"],
  u: "1f952",
  a: "3.0"
}, {
  n: ["leafy green"],
  u: "1f96c",
  a: "11.0"
}, {
  n: ["broccoli"],
  u: "1f966",
  a: "5.0"
}, {
  n: ["garlic"],
  u: "1f9c4",
  a: "12.0"
}, {
  n: ["onion"],
  u: "1f9c5",
  a: "12.0"
}, {
  n: ["mushroom"],
  u: "1f344",
  a: "0.6"
}, {
  n: ["peanuts"],
  u: "1f95c",
  a: "3.0"
}, {
  n: ["beans"],
  u: "1fad8",
  a: "14.0"
}, {
  n: ["chestnut"],
  u: "1f330",
  a: "0.6"
}, {
  n: ["bread"],
  u: "1f35e",
  a: "0.6"
}, {
  n: ["croissant"],
  u: "1f950",
  a: "3.0"
}, {
  n: ["baguette bread"],
  u: "1f956",
  a: "3.0"
}, {
  n: ["flatbread"],
  u: "1fad3",
  a: "13.0"
}, {
  n: ["pretzel"],
  u: "1f968",
  a: "5.0"
}, {
  n: ["bagel"],
  u: "1f96f",
  a: "11.0"
}, {
  n: ["pancakes"],
  u: "1f95e",
  a: "3.0"
}, {
  n: ["waffle"],
  u: "1f9c7",
  a: "12.0"
}, {
  n: ["cheese wedge"],
  u: "1f9c0",
  a: "1.0"
}, {
  n: ["meat on bone"],
  u: "1f356",
  a: "0.6"
}, {
  n: ["poultry leg"],
  u: "1f357",
  a: "0.6"
}, {
  n: ["cut of meat"],
  u: "1f969",
  a: "5.0"
}, {
  n: ["bacon"],
  u: "1f953",
  a: "3.0"
}, {
  n: ["hamburger"],
  u: "1f354",
  a: "0.6"
}, {
  n: ["fries", "french fries"],
  u: "1f35f",
  a: "0.6"
}, {
  n: ["pizza", "slice of pizza"],
  u: "1f355",
  a: "0.6"
}, {
  n: ["hotdog", "hot dog"],
  u: "1f32d",
  a: "1.0"
}, {
  n: ["sandwich"],
  u: "1f96a",
  a: "5.0"
}, {
  n: ["taco"],
  u: "1f32e",
  a: "1.0"
}, {
  n: ["burrito"],
  u: "1f32f",
  a: "1.0"
}, {
  n: ["tamale"],
  u: "1fad4",
  a: "13.0"
}, {
  n: ["stuffed flatbread"],
  u: "1f959",
  a: "3.0"
}, {
  n: ["falafel"],
  u: "1f9c6",
  a: "12.0"
}, {
  n: ["egg"],
  u: "1f95a",
  a: "3.0"
}, {
  n: ["cooking", "fried egg"],
  u: "1f373",
  a: "0.6"
}, {
  n: ["shallow pan of food"],
  u: "1f958",
  a: "3.0"
}, {
  n: ["stew", "pot of food"],
  u: "1f372",
  a: "0.6"
}, {
  n: ["fondue"],
  u: "1fad5",
  a: "13.0"
}, {
  n: ["bowl with spoon"],
  u: "1f963",
  a: "5.0"
}, {
  n: ["green salad"],
  u: "1f957",
  a: "3.0"
}, {
  n: ["popcorn"],
  u: "1f37f",
  a: "1.0"
}, {
  n: ["butter"],
  u: "1f9c8",
  a: "12.0"
}, {
  n: ["salt", "salt shaker"],
  u: "1f9c2",
  a: "11.0"
}, {
  n: ["canned food"],
  u: "1f96b",
  a: "5.0"
}, {
  n: ["bento", "bento box"],
  u: "1f371",
  a: "0.6"
}, {
  n: ["rice cracker"],
  u: "1f358",
  a: "0.6"
}, {
  n: ["rice ball"],
  u: "1f359",
  a: "0.6"
}, {
  n: ["rice", "cooked rice"],
  u: "1f35a",
  a: "0.6"
}, {
  n: ["curry", "curry and rice"],
  u: "1f35b",
  a: "0.6"
}, {
  n: ["ramen", "steaming bowl"],
  u: "1f35c",
  a: "0.6"
}, {
  n: ["spaghetti"],
  u: "1f35d",
  a: "0.6"
}, {
  n: ["sweet potato", "roasted sweet potato"],
  u: "1f360",
  a: "0.6"
}, {
  n: ["oden"],
  u: "1f362",
  a: "0.6"
}, {
  n: ["sushi"],
  u: "1f363",
  a: "0.6"
}, {
  n: ["fried shrimp"],
  u: "1f364",
  a: "0.6"
}, {
  n: ["fish cake", "fish cake with swirl design"],
  u: "1f365",
  a: "0.6"
}, {
  n: ["moon cake"],
  u: "1f96e",
  a: "11.0"
}, {
  n: ["dango"],
  u: "1f361",
  a: "0.6"
}, {
  n: ["dumpling"],
  u: "1f95f",
  a: "5.0"
}, {
  n: ["fortune cookie"],
  u: "1f960",
  a: "5.0"
}, {
  n: ["takeout box"],
  u: "1f961",
  a: "5.0"
}, {
  n: ["crab"],
  u: "1f980",
  a: "1.0"
}, {
  n: ["lobster"],
  u: "1f99e",
  a: "11.0"
}, {
  n: ["shrimp"],
  u: "1f990",
  a: "3.0"
}, {
  n: ["squid"],
  u: "1f991",
  a: "3.0"
}, {
  n: ["oyster"],
  u: "1f9aa",
  a: "12.0"
}, {
  n: ["icecream", "soft ice cream"],
  u: "1f366",
  a: "0.6"
}, {
  n: ["shaved ice"],
  u: "1f367",
  a: "0.6"
}, {
  n: ["ice cream"],
  u: "1f368",
  a: "0.6"
}, {
  n: ["doughnut"],
  u: "1f369",
  a: "0.6"
}, {
  n: ["cookie"],
  u: "1f36a",
  a: "0.6"
}, {
  n: ["birthday", "birthday cake"],
  u: "1f382",
  a: "0.6"
}, {
  n: ["cake", "shortcake"],
  u: "1f370",
  a: "0.6"
}, {
  n: ["cupcake"],
  u: "1f9c1",
  a: "11.0"
}, {
  n: ["pie"],
  u: "1f967",
  a: "5.0"
}, {
  n: ["chocolate bar"],
  u: "1f36b",
  a: "0.6"
}, {
  n: ["candy"],
  u: "1f36c",
  a: "0.6"
}, {
  n: ["lollipop"],
  u: "1f36d",
  a: "0.6"
}, {
  n: ["custard"],
  u: "1f36e",
  a: "0.6"
}, {
  n: ["honey pot"],
  u: "1f36f",
  a: "0.6"
}, {
  n: ["baby bottle"],
  u: "1f37c",
  a: "1.0"
}, {
  n: ["glass of milk"],
  u: "1f95b",
  a: "3.0"
}, {
  n: ["coffee", "hot beverage"],
  u: "2615",
  a: "0.6"
}, {
  n: ["teapot"],
  u: "1fad6",
  a: "13.0"
}, {
  n: ["tea", "teacup without handle"],
  u: "1f375",
  a: "0.6"
}, {
  n: ["sake", "sake bottle and cup"],
  u: "1f376",
  a: "0.6"
}, {
  n: ["champagne", "bottle with popping cork"],
  u: "1f37e",
  a: "1.0"
}, {
  n: ["wine glass"],
  u: "1f377",
  a: "0.6"
}, {
  n: ["cocktail", "cocktail glass"],
  u: "1f378",
  a: "0.6"
}, {
  n: ["tropical drink"],
  u: "1f379",
  a: "0.6"
}, {
  n: ["beer", "beer mug"],
  u: "1f37a",
  a: "0.6"
}, {
  n: ["beers", "clinking beer mugs"],
  u: "1f37b",
  a: "0.6"
}, {
  n: ["clinking glasses"],
  u: "1f942",
  a: "3.0"
}, {
  n: ["tumbler glass"],
  u: "1f943",
  a: "3.0"
}, {
  n: ["pouring liquid"],
  u: "1fad7",
  a: "14.0"
}, {
  n: ["cup with straw"],
  u: "1f964",
  a: "5.0"
}, {
  n: ["bubble tea"],
  u: "1f9cb",
  a: "13.0"
}, {
  n: ["beverage box"],
  u: "1f9c3",
  a: "12.0"
}, {
  n: ["mate drink"],
  u: "1f9c9",
  a: "12.0"
}, {
  n: ["ice cube"],
  u: "1f9ca",
  a: "12.0"
}, {
  n: ["chopsticks"],
  u: "1f962",
  a: "5.0"
}, {
  n: ["knife fork plate", "fork and knife with plate"],
  u: "1f37d-fe0f",
  a: "0.7"
}, {
  n: ["fork and knife"],
  u: "1f374",
  a: "0.6"
}, {
  n: ["spoon"],
  u: "1f944",
  a: "3.0"
}, {
  n: ["hocho", "knife"],
  u: "1f52a",
  a: "0.6"
}, {
  n: ["jar"],
  u: "1fad9",
  a: "14.0"
}, {
  n: ["amphora"],
  u: "1f3fa",
  a: "1.0"
}];
var travel_places = [{
  n: ["earth africa", "earth globe europe-africa"],
  u: "1f30d",
  a: "0.7"
}, {
  n: ["earth americas", "earth globe americas"],
  u: "1f30e",
  a: "0.7"
}, {
  n: ["earth asia", "earth globe asia-australia"],
  u: "1f30f",
  a: "0.6"
}, {
  n: ["globe with meridians"],
  u: "1f310",
  a: "1.0"
}, {
  n: ["world map"],
  u: "1f5fa-fe0f",
  a: "0.7"
}, {
  n: ["japan", "silhouette of japan"],
  u: "1f5fe",
  a: "0.6"
}, {
  n: ["compass"],
  u: "1f9ed",
  a: "11.0"
}, {
  n: ["snow-capped mountain", "snow capped mountain"],
  u: "1f3d4-fe0f",
  a: "0.7"
}, {
  n: ["mountain"],
  u: "26f0-fe0f",
  a: "0.7"
}, {
  n: ["volcano"],
  u: "1f30b",
  a: "0.6"
}, {
  n: ["mount fuji"],
  u: "1f5fb",
  a: "0.6"
}, {
  n: ["camping"],
  u: "1f3d5-fe0f",
  a: "0.7"
}, {
  n: ["beach with umbrella"],
  u: "1f3d6-fe0f",
  a: "0.7"
}, {
  n: ["desert"],
  u: "1f3dc-fe0f",
  a: "0.7"
}, {
  n: ["desert island"],
  u: "1f3dd-fe0f",
  a: "0.7"
}, {
  n: ["national park"],
  u: "1f3de-fe0f",
  a: "0.7"
}, {
  n: ["stadium"],
  u: "1f3df-fe0f",
  a: "0.7"
}, {
  n: ["classical building"],
  u: "1f3db-fe0f",
  a: "0.7"
}, {
  n: ["building construction"],
  u: "1f3d7-fe0f",
  a: "0.7"
}, {
  n: ["brick", "bricks"],
  u: "1f9f1",
  a: "11.0"
}, {
  n: ["rock"],
  u: "1faa8",
  a: "13.0"
}, {
  n: ["wood"],
  u: "1fab5",
  a: "13.0"
}, {
  n: ["hut"],
  u: "1f6d6",
  a: "13.0"
}, {
  n: ["houses", "house buildings"],
  u: "1f3d8-fe0f",
  a: "0.7"
}, {
  n: ["derelict house", "derelict house building"],
  u: "1f3da-fe0f",
  a: "0.7"
}, {
  n: ["house", "house building"],
  u: "1f3e0",
  a: "0.6"
}, {
  n: ["house with garden"],
  u: "1f3e1",
  a: "0.6"
}, {
  n: ["office", "office building"],
  u: "1f3e2",
  a: "0.6"
}, {
  n: ["post office", "japanese post office"],
  u: "1f3e3",
  a: "0.6"
}, {
  n: ["european post office"],
  u: "1f3e4",
  a: "1.0"
}, {
  n: ["hospital"],
  u: "1f3e5",
  a: "0.6"
}, {
  n: ["bank"],
  u: "1f3e6",
  a: "0.6"
}, {
  n: ["hotel"],
  u: "1f3e8",
  a: "0.6"
}, {
  n: ["love hotel"],
  u: "1f3e9",
  a: "0.6"
}, {
  n: ["convenience store"],
  u: "1f3ea",
  a: "0.6"
}, {
  n: ["school"],
  u: "1f3eb",
  a: "0.6"
}, {
  n: ["department store"],
  u: "1f3ec",
  a: "0.6"
}, {
  n: ["factory"],
  u: "1f3ed",
  a: "0.6"
}, {
  n: ["japanese castle"],
  u: "1f3ef",
  a: "0.6"
}, {
  n: ["european castle"],
  u: "1f3f0",
  a: "0.6"
}, {
  n: ["wedding"],
  u: "1f492",
  a: "0.6"
}, {
  n: ["tokyo tower"],
  u: "1f5fc",
  a: "0.6"
}, {
  n: ["statue of liberty"],
  u: "1f5fd",
  a: "0.6"
}, {
  n: ["church"],
  u: "26ea",
  a: "0.6"
}, {
  n: ["mosque"],
  u: "1f54c",
  a: "1.0"
}, {
  n: ["hindu temple"],
  u: "1f6d5",
  a: "12.0"
}, {
  n: ["synagogue"],
  u: "1f54d",
  a: "1.0"
}, {
  n: ["shinto shrine"],
  u: "26e9-fe0f",
  a: "0.7"
}, {
  n: ["kaaba"],
  u: "1f54b",
  a: "1.0"
}, {
  n: ["fountain"],
  u: "26f2",
  a: "0.6"
}, {
  n: ["tent"],
  u: "26fa",
  a: "0.6"
}, {
  n: ["foggy"],
  u: "1f301",
  a: "0.6"
}, {
  n: ["night with stars"],
  u: "1f303",
  a: "0.6"
}, {
  n: ["cityscape"],
  u: "1f3d9-fe0f",
  a: "0.7"
}, {
  n: ["sunrise over mountains"],
  u: "1f304",
  a: "0.6"
}, {
  n: ["sunrise"],
  u: "1f305",
  a: "0.6"
}, {
  n: ["city sunset", "cityscape at dusk"],
  u: "1f306",
  a: "0.6"
}, {
  n: ["city sunrise", "sunset over buildings"],
  u: "1f307",
  a: "0.6"
}, {
  n: ["bridge at night"],
  u: "1f309",
  a: "0.6"
}, {
  n: ["hotsprings", "hot springs"],
  u: "2668-fe0f",
  a: "0.6"
}, {
  n: ["carousel horse"],
  u: "1f3a0",
  a: "0.6"
}, {
  n: ["playground slide"],
  u: "1f6dd",
  a: "14.0"
}, {
  n: ["ferris wheel"],
  u: "1f3a1",
  a: "0.6"
}, {
  n: ["roller coaster"],
  u: "1f3a2",
  a: "0.6"
}, {
  n: ["barber", "barber pole"],
  u: "1f488",
  a: "0.6"
}, {
  n: ["circus tent"],
  u: "1f3aa",
  a: "0.6"
}, {
  n: ["steam locomotive"],
  u: "1f682",
  a: "1.0"
}, {
  n: ["railway car"],
  u: "1f683",
  a: "0.6"
}, {
  n: ["high-speed train", "bullettrain side"],
  u: "1f684",
  a: "0.6"
}, {
  n: ["bullettrain front", "high-speed train with bullet nose"],
  u: "1f685",
  a: "0.6"
}, {
  n: ["train", "train2"],
  u: "1f686",
  a: "1.0"
}, {
  n: ["metro"],
  u: "1f687",
  a: "0.6"
}, {
  n: ["light rail"],
  u: "1f688",
  a: "1.0"
}, {
  n: ["station"],
  u: "1f689",
  a: "0.6"
}, {
  n: ["tram"],
  u: "1f68a",
  a: "1.0"
}, {
  n: ["monorail"],
  u: "1f69d",
  a: "1.0"
}, {
  n: ["mountain railway"],
  u: "1f69e",
  a: "1.0"
}, {
  n: ["train", "tram car"],
  u: "1f68b",
  a: "1.0"
}, {
  n: ["bus"],
  u: "1f68c",
  a: "0.6"
}, {
  n: ["oncoming bus"],
  u: "1f68d",
  a: "0.7"
}, {
  n: ["trolleybus"],
  u: "1f68e",
  a: "1.0"
}, {
  n: ["minibus"],
  u: "1f690",
  a: "1.0"
}, {
  n: ["ambulance"],
  u: "1f691",
  a: "0.6"
}, {
  n: ["fire engine"],
  u: "1f692",
  a: "0.6"
}, {
  n: ["police car"],
  u: "1f693",
  a: "0.6"
}, {
  n: ["oncoming police car"],
  u: "1f694",
  a: "0.7"
}, {
  n: ["taxi"],
  u: "1f695",
  a: "0.6"
}, {
  n: ["oncoming taxi"],
  u: "1f696",
  a: "1.0"
}, {
  n: ["car", "red car", "automobile"],
  u: "1f697",
  a: "0.6"
}, {
  n: ["oncoming automobile"],
  u: "1f698",
  a: "0.7"
}, {
  n: ["blue car", "recreational vehicle"],
  u: "1f699",
  a: "0.6"
}, {
  n: ["pickup truck"],
  u: "1f6fb",
  a: "13.0"
}, {
  n: ["truck", "delivery truck"],
  u: "1f69a",
  a: "0.6"
}, {
  n: ["articulated lorry"],
  u: "1f69b",
  a: "1.0"
}, {
  n: ["tractor"],
  u: "1f69c",
  a: "1.0"
}, {
  n: ["racing car"],
  u: "1f3ce-fe0f",
  a: "0.7"
}, {
  n: ["motorcycle", "racing motorcycle"],
  u: "1f3cd-fe0f",
  a: "0.7"
}, {
  n: ["motor scooter"],
  u: "1f6f5",
  a: "3.0"
}, {
  n: ["manual wheelchair"],
  u: "1f9bd",
  a: "12.0"
}, {
  n: ["motorized wheelchair"],
  u: "1f9bc",
  a: "12.0"
}, {
  n: ["auto rickshaw"],
  u: "1f6fa",
  a: "12.0"
}, {
  n: ["bike", "bicycle"],
  u: "1f6b2",
  a: "0.6"
}, {
  n: ["scooter"],
  u: "1f6f4",
  a: "3.0"
}, {
  n: ["skateboard"],
  u: "1f6f9",
  a: "11.0"
}, {
  n: ["roller skate"],
  u: "1f6fc",
  a: "13.0"
}, {
  n: ["busstop", "bus stop"],
  u: "1f68f",
  a: "0.6"
}, {
  n: ["motorway"],
  u: "1f6e3-fe0f",
  a: "0.7"
}, {
  n: ["railway track"],
  u: "1f6e4-fe0f",
  a: "0.7"
}, {
  n: ["oil drum"],
  u: "1f6e2-fe0f",
  a: "0.7"
}, {
  n: ["fuelpump", "fuel pump"],
  u: "26fd",
  a: "0.6"
}, {
  n: ["wheel"],
  u: "1f6de",
  a: "14.0"
}, {
  n: ["rotating light", "police cars revolving light"],
  u: "1f6a8",
  a: "0.6"
}, {
  n: ["traffic light", "horizontal traffic light"],
  u: "1f6a5",
  a: "0.6"
}, {
  n: ["vertical traffic light"],
  u: "1f6a6",
  a: "1.0"
}, {
  n: ["octagonal sign"],
  u: "1f6d1",
  a: "3.0"
}, {
  n: ["construction", "construction sign"],
  u: "1f6a7",
  a: "0.6"
}, {
  n: ["anchor"],
  u: "2693",
  a: "0.6"
}, {
  n: ["ring buoy"],
  u: "1f6df",
  a: "14.0"
}, {
  n: ["boat", "sailboat"],
  u: "26f5",
  a: "0.6"
}, {
  n: ["canoe"],
  u: "1f6f6",
  a: "3.0"
}, {
  n: ["speedboat"],
  u: "1f6a4",
  a: "0.6"
}, {
  n: ["passenger ship"],
  u: "1f6f3-fe0f",
  a: "0.7"
}, {
  n: ["ferry"],
  u: "26f4-fe0f",
  a: "0.7"
}, {
  n: ["motor boat"],
  u: "1f6e5-fe0f",
  a: "0.7"
}, {
  n: ["ship"],
  u: "1f6a2",
  a: "0.6"
}, {
  n: ["airplane"],
  u: "2708-fe0f",
  a: "0.6"
}, {
  n: ["small airplane"],
  u: "1f6e9-fe0f",
  a: "0.7"
}, {
  n: ["airplane departure"],
  u: "1f6eb",
  a: "1.0"
}, {
  n: ["airplane arriving"],
  u: "1f6ec",
  a: "1.0"
}, {
  n: ["parachute"],
  u: "1fa82",
  a: "12.0"
}, {
  n: ["seat"],
  u: "1f4ba",
  a: "0.6"
}, {
  n: ["helicopter"],
  u: "1f681",
  a: "1.0"
}, {
  n: ["suspension railway"],
  u: "1f69f",
  a: "1.0"
}, {
  n: ["mountain cableway"],
  u: "1f6a0",
  a: "1.0"
}, {
  n: ["aerial tramway"],
  u: "1f6a1",
  a: "1.0"
}, {
  n: ["satellite"],
  u: "1f6f0-fe0f",
  a: "0.7"
}, {
  n: ["rocket"],
  u: "1f680",
  a: "0.6"
}, {
  n: ["flying saucer"],
  u: "1f6f8",
  a: "5.0"
}, {
  n: ["bellhop bell"],
  u: "1f6ce-fe0f",
  a: "0.7"
}, {
  n: ["luggage"],
  u: "1f9f3",
  a: "11.0"
}, {
  n: ["hourglass"],
  u: "231b",
  a: "0.6"
}, {
  n: ["hourglass flowing sand", "hourglass with flowing sand"],
  u: "23f3",
  a: "0.6"
}, {
  n: ["watch"],
  u: "231a",
  a: "0.6"
}, {
  n: ["alarm clock"],
  u: "23f0",
  a: "0.6"
}, {
  n: ["stopwatch"],
  u: "23f1-fe0f",
  a: "1.0"
}, {
  n: ["timer clock"],
  u: "23f2-fe0f",
  a: "1.0"
}, {
  n: ["mantelpiece clock"],
  u: "1f570-fe0f",
  a: "0.7"
}, {
  n: ["clock12", "clock face twelve oclock"],
  u: "1f55b",
  a: "0.6"
}, {
  n: ["clock1230", "clock face twelve-thirty"],
  u: "1f567",
  a: "0.7"
}, {
  n: ["clock1", "clock face one oclock"],
  u: "1f550",
  a: "0.6"
}, {
  n: ["clock130", "clock face one-thirty"],
  u: "1f55c",
  a: "0.7"
}, {
  n: ["clock2", "clock face two oclock"],
  u: "1f551",
  a: "0.6"
}, {
  n: ["clock230", "clock face two-thirty"],
  u: "1f55d",
  a: "0.7"
}, {
  n: ["clock3", "clock face three oclock"],
  u: "1f552",
  a: "0.6"
}, {
  n: ["clock330", "clock face three-thirty"],
  u: "1f55e",
  a: "0.7"
}, {
  n: ["clock4", "clock face four oclock"],
  u: "1f553",
  a: "0.6"
}, {
  n: ["clock430", "clock face four-thirty"],
  u: "1f55f",
  a: "0.7"
}, {
  n: ["clock5", "clock face five oclock"],
  u: "1f554",
  a: "0.6"
}, {
  n: ["clock530", "clock face five-thirty"],
  u: "1f560",
  a: "0.7"
}, {
  n: ["clock6", "clock face six oclock"],
  u: "1f555",
  a: "0.6"
}, {
  n: ["clock630", "clock face six-thirty"],
  u: "1f561",
  a: "0.7"
}, {
  n: ["clock7", "clock face seven oclock"],
  u: "1f556",
  a: "0.6"
}, {
  n: ["clock730", "clock face seven-thirty"],
  u: "1f562",
  a: "0.7"
}, {
  n: ["clock8", "clock face eight oclock"],
  u: "1f557",
  a: "0.6"
}, {
  n: ["clock830", "clock face eight-thirty"],
  u: "1f563",
  a: "0.7"
}, {
  n: ["clock9", "clock face nine oclock"],
  u: "1f558",
  a: "0.6"
}, {
  n: ["clock930", "clock face nine-thirty"],
  u: "1f564",
  a: "0.7"
}, {
  n: ["clock10", "clock face ten oclock"],
  u: "1f559",
  a: "0.6"
}, {
  n: ["clock1030", "clock face ten-thirty"],
  u: "1f565",
  a: "0.7"
}, {
  n: ["clock11", "clock face eleven oclock"],
  u: "1f55a",
  a: "0.6"
}, {
  n: ["clock1130", "clock face eleven-thirty"],
  u: "1f566",
  a: "0.7"
}, {
  n: ["new moon", "new moon symbol"],
  u: "1f311",
  a: "0.6"
}, {
  n: ["waxing crescent moon", "waxing crescent moon symbol"],
  u: "1f312",
  a: "1.0"
}, {
  n: ["first quarter moon", "first quarter moon symbol"],
  u: "1f313",
  a: "0.6"
}, {
  n: ["moon", "waxing gibbous moon", "waxing gibbous moon symbol"],
  u: "1f314",
  a: "0.6"
}, {
  n: ["full moon", "full moon symbol"],
  u: "1f315",
  a: "0.6"
}, {
  n: ["waning gibbous moon", "waning gibbous moon symbol"],
  u: "1f316",
  a: "1.0"
}, {
  n: ["last quarter moon", "last quarter moon symbol"],
  u: "1f317",
  a: "1.0"
}, {
  n: ["waning crescent moon", "waning crescent moon symbol"],
  u: "1f318",
  a: "1.0"
}, {
  n: ["crescent moon"],
  u: "1f319",
  a: "0.6"
}, {
  n: ["new moon with face"],
  u: "1f31a",
  a: "1.0"
}, {
  n: ["first quarter moon with face"],
  u: "1f31b",
  a: "0.6"
}, {
  n: ["last quarter moon with face"],
  u: "1f31c",
  a: "0.7"
}, {
  n: ["thermometer"],
  u: "1f321-fe0f",
  a: "0.7"
}, {
  n: ["sunny", "black sun with rays"],
  u: "2600-fe0f",
  a: "0.6"
}, {
  n: ["full moon with face"],
  u: "1f31d",
  a: "1.0"
}, {
  n: ["sun with face"],
  u: "1f31e",
  a: "1.0"
}, {
  n: ["ringed planet"],
  u: "1fa90",
  a: "12.0"
}, {
  n: ["star", "white medium star"],
  u: "2b50",
  a: "0.6"
}, {
  n: ["star2", "glowing star"],
  u: "1f31f",
  a: "0.6"
}, {
  n: ["stars", "shooting star"],
  u: "1f320",
  a: "0.6"
}, {
  n: ["milky way"],
  u: "1f30c",
  a: "0.6"
}, {
  n: ["cloud"],
  u: "2601-fe0f",
  a: "0.6"
}, {
  n: ["partly sunny", "sun behind cloud"],
  u: "26c5",
  a: "0.6"
}, {
  n: ["thunder cloud and rain", "cloud with lightning and rain"],
  u: "26c8-fe0f",
  a: "0.7"
}, {
  n: ["mostly sunny", "sun small cloud", "sun behind small cloud"],
  u: "1f324-fe0f",
  a: "0.7"
}, {
  n: ["barely sunny", "sun behind cloud", "sun behind large cloud"],
  u: "1f325-fe0f",
  a: "0.7"
}, {
  n: ["partly sunny rain", "sun behind rain cloud"],
  u: "1f326-fe0f",
  a: "0.7"
}, {
  n: ["rain cloud", "cloud with rain"],
  u: "1f327-fe0f",
  a: "0.7"
}, {
  n: ["snow cloud", "cloud with snow"],
  u: "1f328-fe0f",
  a: "0.7"
}, {
  n: ["lightning", "lightning cloud", "cloud with lightning"],
  u: "1f329-fe0f",
  a: "0.7"
}, {
  n: ["tornado", "tornado cloud"],
  u: "1f32a-fe0f",
  a: "0.7"
}, {
  n: ["fog"],
  u: "1f32b-fe0f",
  a: "0.7"
}, {
  n: ["wind face", "wind blowing face"],
  u: "1f32c-fe0f",
  a: "0.7"
}, {
  n: ["cyclone"],
  u: "1f300",
  a: "0.6"
}, {
  n: ["rainbow"],
  u: "1f308",
  a: "0.6"
}, {
  n: ["closed umbrella"],
  u: "1f302",
  a: "0.6"
}, {
  n: ["umbrella"],
  u: "2602-fe0f",
  a: "0.7"
}, {
  n: ["umbrella with rain drops"],
  u: "2614",
  a: "0.6"
}, {
  n: ["umbrella on ground"],
  u: "26f1-fe0f",
  a: "0.7"
}, {
  n: ["zap", "high voltage sign"],
  u: "26a1",
  a: "0.6"
}, {
  n: ["snowflake"],
  u: "2744-fe0f",
  a: "0.6"
}, {
  n: ["snowman"],
  u: "2603-fe0f",
  a: "0.7"
}, {
  n: ["snowman without snow"],
  u: "26c4",
  a: "0.6"
}, {
  n: ["comet"],
  u: "2604-fe0f",
  a: "1.0"
}, {
  n: ["fire"],
  u: "1f525",
  a: "0.6"
}, {
  n: ["droplet"],
  u: "1f4a7",
  a: "0.6"
}, {
  n: ["ocean", "water wave"],
  u: "1f30a",
  a: "0.6"
}];
var activities = [{
  n: ["jack-o-lantern", "jack o lantern"],
  u: "1f383",
  a: "0.6"
}, {
  n: ["christmas tree"],
  u: "1f384",
  a: "0.6"
}, {
  n: ["fireworks"],
  u: "1f386",
  a: "0.6"
}, {
  n: ["sparkler", "firework sparkler"],
  u: "1f387",
  a: "0.6"
}, {
  n: ["firecracker"],
  u: "1f9e8",
  a: "11.0"
}, {
  n: ["sparkles"],
  u: "2728",
  a: "0.6"
}, {
  n: ["balloon"],
  u: "1f388",
  a: "0.6"
}, {
  n: ["tada", "party popper"],
  u: "1f389",
  a: "0.6"
}, {
  n: ["confetti ball"],
  u: "1f38a",
  a: "0.6"
}, {
  n: ["tanabata tree"],
  u: "1f38b",
  a: "0.6"
}, {
  n: ["bamboo", "pine decoration"],
  u: "1f38d",
  a: "0.6"
}, {
  n: ["dolls", "japanese dolls"],
  u: "1f38e",
  a: "0.6"
}, {
  n: ["flags", "carp streamer"],
  u: "1f38f",
  a: "0.6"
}, {
  n: ["wind chime"],
  u: "1f390",
  a: "0.6"
}, {
  n: ["rice scene", "moon viewing ceremony"],
  u: "1f391",
  a: "0.6"
}, {
  n: ["red envelope", "red gift envelope"],
  u: "1f9e7",
  a: "11.0"
}, {
  n: ["ribbon"],
  u: "1f380",
  a: "0.6"
}, {
  n: ["gift", "wrapped present"],
  u: "1f381",
  a: "0.6"
}, {
  n: ["reminder ribbon"],
  u: "1f397-fe0f",
  a: "0.7"
}, {
  n: ["admission tickets"],
  u: "1f39f-fe0f",
  a: "0.7"
}, {
  n: ["ticket"],
  u: "1f3ab",
  a: "0.6"
}, {
  n: ["medal", "military medal"],
  u: "1f396-fe0f",
  a: "0.7"
}, {
  n: ["trophy"],
  u: "1f3c6",
  a: "0.6"
}, {
  n: ["sports medal"],
  u: "1f3c5",
  a: "1.0"
}, {
  n: ["first place medal"],
  u: "1f947",
  a: "3.0"
}, {
  n: ["second place medal"],
  u: "1f948",
  a: "3.0"
}, {
  n: ["third place medal"],
  u: "1f949",
  a: "3.0"
}, {
  n: ["soccer", "soccer ball"],
  u: "26bd",
  a: "0.6"
}, {
  n: ["baseball"],
  u: "26be",
  a: "0.6"
}, {
  n: ["softball"],
  u: "1f94e",
  a: "11.0"
}, {
  n: ["basketball", "basketball and hoop"],
  u: "1f3c0",
  a: "0.6"
}, {
  n: ["volleyball"],
  u: "1f3d0",
  a: "1.0"
}, {
  n: ["football", "american football"],
  u: "1f3c8",
  a: "0.6"
}, {
  n: ["rugby football"],
  u: "1f3c9",
  a: "1.0"
}, {
  n: ["tennis", "tennis racquet and ball"],
  u: "1f3be",
  a: "0.6"
}, {
  n: ["flying disc"],
  u: "1f94f",
  a: "11.0"
}, {
  n: ["bowling"],
  u: "1f3b3",
  a: "0.6"
}, {
  n: ["cricket bat and ball"],
  u: "1f3cf",
  a: "1.0"
}, {
  n: ["field hockey stick and ball"],
  u: "1f3d1",
  a: "1.0"
}, {
  n: ["ice hockey stick and puck"],
  u: "1f3d2",
  a: "1.0"
}, {
  n: ["lacrosse", "lacrosse stick and ball"],
  u: "1f94d",
  a: "11.0"
}, {
  n: ["table tennis paddle and ball"],
  u: "1f3d3",
  a: "1.0"
}, {
  n: ["badminton racquet and shuttlecock"],
  u: "1f3f8",
  a: "1.0"
}, {
  n: ["boxing glove"],
  u: "1f94a",
  a: "3.0"
}, {
  n: ["martial arts uniform"],
  u: "1f94b",
  a: "3.0"
}, {
  n: ["goal net"],
  u: "1f945",
  a: "3.0"
}, {
  n: ["golf", "flag in hole"],
  u: "26f3",
  a: "0.6"
}, {
  n: ["ice skate"],
  u: "26f8-fe0f",
  a: "0.7"
}, {
  n: ["fishing pole and fish"],
  u: "1f3a3",
  a: "0.6"
}, {
  n: ["diving mask"],
  u: "1f93f",
  a: "12.0"
}, {
  n: ["running shirt with sash"],
  u: "1f3bd",
  a: "0.6"
}, {
  n: ["ski", "ski and ski boot"],
  u: "1f3bf",
  a: "0.6"
}, {
  n: ["sled"],
  u: "1f6f7",
  a: "5.0"
}, {
  n: ["curling stone"],
  u: "1f94c",
  a: "5.0"
}, {
  n: ["dart", "direct hit"],
  u: "1f3af",
  a: "0.6"
}, {
  n: ["yo-yo"],
  u: "1fa80",
  a: "12.0"
}, {
  n: ["kite"],
  u: "1fa81",
  a: "12.0"
}, {
  n: ["8ball", "billiards"],
  u: "1f3b1",
  a: "0.6"
}, {
  n: ["crystal ball"],
  u: "1f52e",
  a: "0.6"
}, {
  n: ["magic wand"],
  u: "1fa84",
  a: "13.0"
}, {
  n: ["nazar amulet"],
  u: "1f9ff",
  a: "11.0"
}, {
  n: ["hamsa"],
  u: "1faac",
  a: "14.0"
}, {
  n: ["video game"],
  u: "1f3ae",
  a: "0.6"
}, {
  n: ["joystick"],
  u: "1f579-fe0f",
  a: "0.7"
}, {
  n: ["slot machine"],
  u: "1f3b0",
  a: "0.6"
}, {
  n: ["game die"],
  u: "1f3b2",
  a: "0.6"
}, {
  n: ["jigsaw", "jigsaw puzzle piece"],
  u: "1f9e9",
  a: "11.0"
}, {
  n: ["teddy bear"],
  u: "1f9f8",
  a: "11.0"
}, {
  n: ["pinata"],
  u: "1fa85",
  a: "13.0"
}, {
  n: ["mirror ball"],
  u: "1faa9",
  a: "14.0"
}, {
  n: ["nesting dolls"],
  u: "1fa86",
  a: "13.0"
}, {
  n: ["spades", "black spade suit"],
  u: "2660-fe0f",
  a: "0.6"
}, {
  n: ["hearts", "black heart suit"],
  u: "2665-fe0f",
  a: "0.6"
}, {
  n: ["diamonds", "black diamond suit"],
  u: "2666-fe0f",
  a: "0.6"
}, {
  n: ["clubs", "black club suit"],
  u: "2663-fe0f",
  a: "0.6"
}, {
  n: ["chess pawn"],
  u: "265f-fe0f",
  a: "11.0"
}, {
  n: ["black joker", "playing card black joker"],
  u: "1f0cf",
  a: "0.6"
}, {
  n: ["mahjong", "mahjong tile red dragon"],
  u: "1f004",
  a: "0.6"
}, {
  n: ["flower playing cards"],
  u: "1f3b4",
  a: "0.6"
}, {
  n: ["performing arts"],
  u: "1f3ad",
  a: "0.6"
}, {
  n: ["framed picture", "frame with picture"],
  u: "1f5bc-fe0f",
  a: "0.7"
}, {
  n: ["art", "artist palette"],
  u: "1f3a8",
  a: "0.6"
}, {
  n: ["thread", "spool of thread"],
  u: "1f9f5",
  a: "11.0"
}, {
  n: ["sewing needle"],
  u: "1faa1",
  a: "13.0"
}, {
  n: ["yarn", "ball of yarn"],
  u: "1f9f6",
  a: "11.0"
}, {
  n: ["knot"],
  u: "1faa2",
  a: "13.0"
}];
var objects = [{
  n: ["eyeglasses"],
  u: "1f453",
  a: "0.6"
}, {
  n: ["sunglasses", "dark sunglasses"],
  u: "1f576-fe0f",
  a: "0.7"
}, {
  n: ["goggles"],
  u: "1f97d",
  a: "11.0"
}, {
  n: ["lab coat"],
  u: "1f97c",
  a: "11.0"
}, {
  n: ["safety vest"],
  u: "1f9ba",
  a: "12.0"
}, {
  n: ["necktie"],
  u: "1f454",
  a: "0.6"
}, {
  n: ["shirt", "tshirt", "t-shirt"],
  u: "1f455",
  a: "0.6"
}, {
  n: ["jeans"],
  u: "1f456",
  a: "0.6"
}, {
  n: ["scarf"],
  u: "1f9e3",
  a: "5.0"
}, {
  n: ["gloves"],
  u: "1f9e4",
  a: "5.0"
}, {
  n: ["coat"],
  u: "1f9e5",
  a: "5.0"
}, {
  n: ["socks"],
  u: "1f9e6",
  a: "5.0"
}, {
  n: ["dress"],
  u: "1f457",
  a: "0.6"
}, {
  n: ["kimono"],
  u: "1f458",
  a: "0.6"
}, {
  n: ["sari"],
  u: "1f97b",
  a: "12.0"
}, {
  n: ["one-piece swimsuit"],
  u: "1fa71",
  a: "12.0"
}, {
  n: ["briefs"],
  u: "1fa72",
  a: "12.0"
}, {
  n: ["shorts"],
  u: "1fa73",
  a: "12.0"
}, {
  n: ["bikini"],
  u: "1f459",
  a: "0.6"
}, {
  n: ["womans clothes"],
  u: "1f45a",
  a: "0.6"
}, {
  n: ["purse"],
  u: "1f45b",
  a: "0.6"
}, {
  n: ["handbag"],
  u: "1f45c",
  a: "0.6"
}, {
  n: ["pouch"],
  u: "1f45d",
  a: "0.6"
}, {
  n: ["shopping bags"],
  u: "1f6cd-fe0f",
  a: "0.7"
}, {
  n: ["school satchel"],
  u: "1f392",
  a: "0.6"
}, {
  n: ["thong sandal"],
  u: "1fa74",
  a: "13.0"
}, {
  n: ["shoe", "mans shoe"],
  u: "1f45e",
  a: "0.6"
}, {
  n: ["athletic shoe"],
  u: "1f45f",
  a: "0.6"
}, {
  n: ["hiking boot"],
  u: "1f97e",
  a: "11.0"
}, {
  n: ["flat shoe", "womans flat shoe"],
  u: "1f97f",
  a: "11.0"
}, {
  n: ["high heel", "high-heeled shoe"],
  u: "1f460",
  a: "0.6"
}, {
  n: ["sandal", "womans sandal"],
  u: "1f461",
  a: "0.6"
}, {
  n: ["ballet shoes"],
  u: "1fa70",
  a: "12.0"
}, {
  n: ["boot", "womans boots"],
  u: "1f462",
  a: "0.6"
}, {
  n: ["crown"],
  u: "1f451",
  a: "0.6"
}, {
  n: ["womans hat"],
  u: "1f452",
  a: "0.6"
}, {
  n: ["tophat", "top hat"],
  u: "1f3a9",
  a: "0.6"
}, {
  n: ["mortar board", "graduation cap"],
  u: "1f393",
  a: "0.6"
}, {
  n: ["billed cap"],
  u: "1f9e2",
  a: "5.0"
}, {
  n: ["military helmet"],
  u: "1fa96",
  a: "13.0"
}, {
  n: ["rescue worker’s helmet", "helmet with white cross"],
  u: "26d1-fe0f",
  a: "0.7"
}, {
  n: ["prayer beads"],
  u: "1f4ff",
  a: "1.0"
}, {
  n: ["lipstick"],
  u: "1f484",
  a: "0.6"
}, {
  n: ["ring"],
  u: "1f48d",
  a: "0.6"
}, {
  n: ["gem", "gem stone"],
  u: "1f48e",
  a: "0.6"
}, {
  n: ["mute", "speaker with cancellation stroke"],
  u: "1f507",
  a: "1.0"
}, {
  n: ["speaker"],
  u: "1f508",
  a: "0.7"
}, {
  n: ["sound", "speaker with one sound wave"],
  u: "1f509",
  a: "1.0"
}, {
  n: ["loud sound", "speaker with three sound waves"],
  u: "1f50a",
  a: "0.6"
}, {
  n: ["loudspeaker", "public address loudspeaker"],
  u: "1f4e2",
  a: "0.6"
}, {
  n: ["mega", "cheering megaphone"],
  u: "1f4e3",
  a: "0.6"
}, {
  n: ["postal horn"],
  u: "1f4ef",
  a: "1.0"
}, {
  n: ["bell"],
  u: "1f514",
  a: "0.6"
}, {
  n: ["no bell", "bell with cancellation stroke"],
  u: "1f515",
  a: "1.0"
}, {
  n: ["musical score"],
  u: "1f3bc",
  a: "0.6"
}, {
  n: ["musical note"],
  u: "1f3b5",
  a: "0.6"
}, {
  n: ["notes", "multiple musical notes"],
  u: "1f3b6",
  a: "0.6"
}, {
  n: ["studio microphone"],
  u: "1f399-fe0f",
  a: "0.7"
}, {
  n: ["level slider"],
  u: "1f39a-fe0f",
  a: "0.7"
}, {
  n: ["control knobs"],
  u: "1f39b-fe0f",
  a: "0.7"
}, {
  n: ["microphone"],
  u: "1f3a4",
  a: "0.6"
}, {
  n: ["headphone", "headphones"],
  u: "1f3a7",
  a: "0.6"
}, {
  n: ["radio"],
  u: "1f4fb",
  a: "0.6"
}, {
  n: ["saxophone"],
  u: "1f3b7",
  a: "0.6"
}, {
  n: ["accordion"],
  u: "1fa97",
  a: "13.0"
}, {
  n: ["guitar"],
  u: "1f3b8",
  a: "0.6"
}, {
  n: ["musical keyboard"],
  u: "1f3b9",
  a: "0.6"
}, {
  n: ["trumpet"],
  u: "1f3ba",
  a: "0.6"
}, {
  n: ["violin"],
  u: "1f3bb",
  a: "0.6"
}, {
  n: ["banjo"],
  u: "1fa95",
  a: "12.0"
}, {
  n: ["drum with drumsticks"],
  u: "1f941",
  a: "3.0"
}, {
  n: ["long drum"],
  u: "1fa98",
  a: "13.0"
}, {
  n: ["iphone", "mobile phone"],
  u: "1f4f1",
  a: "0.6"
}, {
  n: ["calling", "mobile phone with rightwards arrow at left"],
  u: "1f4f2",
  a: "0.6"
}, {
  n: ["phone", "telephone", "black telephone"],
  u: "260e-fe0f",
  a: "0.6"
}, {
  n: ["telephone receiver"],
  u: "1f4de",
  a: "0.6"
}, {
  n: ["pager"],
  u: "1f4df",
  a: "0.6"
}, {
  n: ["fax", "fax machine"],
  u: "1f4e0",
  a: "0.6"
}, {
  n: ["battery"],
  u: "1f50b",
  a: "0.6"
}, {
  n: ["low battery"],
  u: "1faab",
  a: "14.0"
}, {
  n: ["electric plug"],
  u: "1f50c",
  a: "0.6"
}, {
  n: ["computer", "personal computer"],
  u: "1f4bb",
  a: "0.6"
}, {
  n: ["desktop computer"],
  u: "1f5a5-fe0f",
  a: "0.7"
}, {
  n: ["printer"],
  u: "1f5a8-fe0f",
  a: "0.7"
}, {
  n: ["keyboard"],
  u: "2328-fe0f",
  a: "1.0"
}, {
  n: ["computer mouse", "three button mouse"],
  u: "1f5b1-fe0f",
  a: "0.7"
}, {
  n: ["trackball"],
  u: "1f5b2-fe0f",
  a: "0.7"
}, {
  n: ["minidisc"],
  u: "1f4bd",
  a: "0.6"
}, {
  n: ["floppy disk"],
  u: "1f4be",
  a: "0.6"
}, {
  n: ["cd", "optical disc"],
  u: "1f4bf",
  a: "0.6"
}, {
  n: ["dvd"],
  u: "1f4c0",
  a: "0.6"
}, {
  n: ["abacus"],
  u: "1f9ee",
  a: "11.0"
}, {
  n: ["movie camera"],
  u: "1f3a5",
  a: "0.6"
}, {
  n: ["film frames"],
  u: "1f39e-fe0f",
  a: "0.7"
}, {
  n: ["film projector"],
  u: "1f4fd-fe0f",
  a: "0.7"
}, {
  n: ["clapper", "clapper board"],
  u: "1f3ac",
  a: "0.6"
}, {
  n: ["tv", "television"],
  u: "1f4fa",
  a: "0.6"
}, {
  n: ["camera"],
  u: "1f4f7",
  a: "0.6"
}, {
  n: ["camera with flash"],
  u: "1f4f8",
  a: "1.0"
}, {
  n: ["video camera"],
  u: "1f4f9",
  a: "0.6"
}, {
  n: ["vhs", "videocassette"],
  u: "1f4fc",
  a: "0.6"
}, {
  n: ["mag", "left-pointing magnifying glass"],
  u: "1f50d",
  a: "0.6"
}, {
  n: ["mag right", "right-pointing magnifying glass"],
  u: "1f50e",
  a: "0.6"
}, {
  n: ["candle"],
  u: "1f56f-fe0f",
  a: "0.7"
}, {
  n: ["bulb", "electric light bulb"],
  u: "1f4a1",
  a: "0.6"
}, {
  n: ["flashlight", "electric torch"],
  u: "1f526",
  a: "0.6"
}, {
  n: ["lantern", "izakaya lantern"],
  u: "1f3ee",
  a: "0.6"
}, {
  n: ["diya lamp"],
  u: "1fa94",
  a: "12.0"
}, {
  n: ["notebook with decorative cover"],
  u: "1f4d4",
  a: "0.6"
}, {
  n: ["closed book"],
  u: "1f4d5",
  a: "0.6"
}, {
  n: ["book", "open book"],
  u: "1f4d6",
  a: "0.6"
}, {
  n: ["green book"],
  u: "1f4d7",
  a: "0.6"
}, {
  n: ["blue book"],
  u: "1f4d8",
  a: "0.6"
}, {
  n: ["orange book"],
  u: "1f4d9",
  a: "0.6"
}, {
  n: ["books"],
  u: "1f4da",
  a: "0.6"
}, {
  n: ["notebook"],
  u: "1f4d3",
  a: "0.6"
}, {
  n: ["ledger"],
  u: "1f4d2",
  a: "0.6"
}, {
  n: ["page with curl"],
  u: "1f4c3",
  a: "0.6"
}, {
  n: ["scroll"],
  u: "1f4dc",
  a: "0.6"
}, {
  n: ["page facing up"],
  u: "1f4c4",
  a: "0.6"
}, {
  n: ["newspaper"],
  u: "1f4f0",
  a: "0.6"
}, {
  n: ["rolled-up newspaper", "rolled up newspaper"],
  u: "1f5de-fe0f",
  a: "0.7"
}, {
  n: ["bookmark tabs"],
  u: "1f4d1",
  a: "0.6"
}, {
  n: ["bookmark"],
  u: "1f516",
  a: "0.6"
}, {
  n: ["label"],
  u: "1f3f7-fe0f",
  a: "0.7"
}, {
  n: ["moneybag", "money bag"],
  u: "1f4b0",
  a: "0.6"
}, {
  n: ["coin"],
  u: "1fa99",
  a: "13.0"
}, {
  n: ["yen", "banknote with yen sign"],
  u: "1f4b4",
  a: "0.6"
}, {
  n: ["dollar", "banknote with dollar sign"],
  u: "1f4b5",
  a: "0.6"
}, {
  n: ["euro", "banknote with euro sign"],
  u: "1f4b6",
  a: "1.0"
}, {
  n: ["pound", "banknote with pound sign"],
  u: "1f4b7",
  a: "1.0"
}, {
  n: ["money with wings"],
  u: "1f4b8",
  a: "0.6"
}, {
  n: ["credit card"],
  u: "1f4b3",
  a: "0.6"
}, {
  n: ["receipt"],
  u: "1f9fe",
  a: "11.0"
}, {
  n: ["chart", "chart with upwards trend and yen sign"],
  u: "1f4b9",
  a: "0.6"
}, {
  n: ["email", "envelope"],
  u: "2709-fe0f",
  a: "0.6"
}, {
  n: ["e-mail", "e-mail symbol"],
  u: "1f4e7",
  a: "0.6"
}, {
  n: ["incoming envelope"],
  u: "1f4e8",
  a: "0.6"
}, {
  n: ["envelope with arrow", "envelope with downwards arrow above"],
  u: "1f4e9",
  a: "0.6"
}, {
  n: ["outbox tray"],
  u: "1f4e4",
  a: "0.6"
}, {
  n: ["inbox tray"],
  u: "1f4e5",
  a: "0.6"
}, {
  n: ["package"],
  u: "1f4e6",
  a: "0.6"
}, {
  n: ["mailbox", "closed mailbox with raised flag"],
  u: "1f4eb",
  a: "0.6"
}, {
  n: ["mailbox closed", "closed mailbox with lowered flag"],
  u: "1f4ea",
  a: "0.6"
}, {
  n: ["mailbox with mail", "open mailbox with raised flag"],
  u: "1f4ec",
  a: "0.7"
}, {
  n: ["mailbox with no mail", "open mailbox with lowered flag"],
  u: "1f4ed",
  a: "0.7"
}, {
  n: ["postbox"],
  u: "1f4ee",
  a: "0.6"
}, {
  n: ["ballot box with ballot"],
  u: "1f5f3-fe0f",
  a: "0.7"
}, {
  n: ["pencil", "pencil2"],
  u: "270f-fe0f",
  a: "0.6"
}, {
  n: ["black nib"],
  u: "2712-fe0f",
  a: "0.6"
}, {
  n: ["fountain pen", "lower left fountain pen"],
  u: "1f58b-fe0f",
  a: "0.7"
}, {
  n: ["pen", "lower left ballpoint pen"],
  u: "1f58a-fe0f",
  a: "0.7"
}, {
  n: ["paintbrush", "lower left paintbrush"],
  u: "1f58c-fe0f",
  a: "0.7"
}, {
  n: ["crayon", "lower left crayon"],
  u: "1f58d-fe0f",
  a: "0.7"
}, {
  n: ["memo", "pencil"],
  u: "1f4dd",
  a: "0.6"
}, {
  n: ["briefcase"],
  u: "1f4bc",
  a: "0.6"
}, {
  n: ["file folder"],
  u: "1f4c1",
  a: "0.6"
}, {
  n: ["open file folder"],
  u: "1f4c2",
  a: "0.6"
}, {
  n: ["card index dividers"],
  u: "1f5c2-fe0f",
  a: "0.7"
}, {
  n: ["date", "calendar"],
  u: "1f4c5",
  a: "0.6"
}, {
  n: ["calendar", "tear-off calendar"],
  u: "1f4c6",
  a: "0.6"
}, {
  n: ["spiral notepad", "spiral note pad"],
  u: "1f5d2-fe0f",
  a: "0.7"
}, {
  n: ["spiral calendar", "spiral calendar pad"],
  u: "1f5d3-fe0f",
  a: "0.7"
}, {
  n: ["card index"],
  u: "1f4c7",
  a: "0.6"
}, {
  n: ["chart with upwards trend"],
  u: "1f4c8",
  a: "0.6"
}, {
  n: ["chart with downwards trend"],
  u: "1f4c9",
  a: "0.6"
}, {
  n: ["bar chart"],
  u: "1f4ca",
  a: "0.6"
}, {
  n: ["clipboard"],
  u: "1f4cb",
  a: "0.6"
}, {
  n: ["pushpin"],
  u: "1f4cc",
  a: "0.6"
}, {
  n: ["round pushpin"],
  u: "1f4cd",
  a: "0.6"
}, {
  n: ["paperclip"],
  u: "1f4ce",
  a: "0.6"
}, {
  n: ["linked paperclips"],
  u: "1f587-fe0f",
  a: "0.7"
}, {
  n: ["straight ruler"],
  u: "1f4cf",
  a: "0.6"
}, {
  n: ["triangular ruler"],
  u: "1f4d0",
  a: "0.6"
}, {
  n: ["scissors", "black scissors"],
  u: "2702-fe0f",
  a: "0.6"
}, {
  n: ["card file box"],
  u: "1f5c3-fe0f",
  a: "0.7"
}, {
  n: ["file cabinet"],
  u: "1f5c4-fe0f",
  a: "0.7"
}, {
  n: ["wastebasket"],
  u: "1f5d1-fe0f",
  a: "0.7"
}, {
  n: ["lock"],
  u: "1f512",
  a: "0.6"
}, {
  n: ["unlock", "open lock"],
  u: "1f513",
  a: "0.6"
}, {
  n: ["lock with ink pen"],
  u: "1f50f",
  a: "0.6"
}, {
  n: ["closed lock with key"],
  u: "1f510",
  a: "0.6"
}, {
  n: ["key"],
  u: "1f511",
  a: "0.6"
}, {
  n: ["old key"],
  u: "1f5dd-fe0f",
  a: "0.7"
}, {
  n: ["hammer"],
  u: "1f528",
  a: "0.6"
}, {
  n: ["axe"],
  u: "1fa93",
  a: "12.0"
}, {
  n: ["pick"],
  u: "26cf-fe0f",
  a: "0.7"
}, {
  n: ["hammer and pick"],
  u: "2692-fe0f",
  a: "1.0"
}, {
  n: ["hammer and wrench"],
  u: "1f6e0-fe0f",
  a: "0.7"
}, {
  n: ["dagger", "dagger knife"],
  u: "1f5e1-fe0f",
  a: "0.7"
}, {
  n: ["crossed swords"],
  u: "2694-fe0f",
  a: "1.0"
}, {
  n: ["gun", "pistol"],
  u: "1f52b",
  a: "0.6"
}, {
  n: ["boomerang"],
  u: "1fa83",
  a: "13.0"
}, {
  n: ["bow and arrow"],
  u: "1f3f9",
  a: "1.0"
}, {
  n: ["shield"],
  u: "1f6e1-fe0f",
  a: "0.7"
}, {
  n: ["carpentry saw"],
  u: "1fa9a",
  a: "13.0"
}, {
  n: ["wrench"],
  u: "1f527",
  a: "0.6"
}, {
  n: ["screwdriver"],
  u: "1fa9b",
  a: "13.0"
}, {
  n: ["nut and bolt"],
  u: "1f529",
  a: "0.6"
}, {
  n: ["gear"],
  u: "2699-fe0f",
  a: "1.0"
}, {
  n: ["clamp", "compression"],
  u: "1f5dc-fe0f",
  a: "0.7"
}, {
  n: ["scales", "balance scale"],
  u: "2696-fe0f",
  a: "1.0"
}, {
  n: ["probing cane"],
  u: "1f9af",
  a: "12.0"
}, {
  n: ["link", "link symbol"],
  u: "1f517",
  a: "0.6"
}, {
  n: ["chains"],
  u: "26d3-fe0f",
  a: "0.7"
}, {
  n: ["hook"],
  u: "1fa9d",
  a: "13.0"
}, {
  n: ["toolbox"],
  u: "1f9f0",
  a: "11.0"
}, {
  n: ["magnet"],
  u: "1f9f2",
  a: "11.0"
}, {
  n: ["ladder"],
  u: "1fa9c",
  a: "13.0"
}, {
  n: ["alembic"],
  u: "2697-fe0f",
  a: "1.0"
}, {
  n: ["test tube"],
  u: "1f9ea",
  a: "11.0"
}, {
  n: ["petri dish"],
  u: "1f9eb",
  a: "11.0"
}, {
  n: ["dna", "dna double helix"],
  u: "1f9ec",
  a: "11.0"
}, {
  n: ["microscope"],
  u: "1f52c",
  a: "1.0"
}, {
  n: ["telescope"],
  u: "1f52d",
  a: "1.0"
}, {
  n: ["satellite antenna"],
  u: "1f4e1",
  a: "0.6"
}, {
  n: ["syringe"],
  u: "1f489",
  a: "0.6"
}, {
  n: ["drop of blood"],
  u: "1fa78",
  a: "12.0"
}, {
  n: ["pill"],
  u: "1f48a",
  a: "0.6"
}, {
  n: ["adhesive bandage"],
  u: "1fa79",
  a: "12.0"
}, {
  n: ["crutch"],
  u: "1fa7c",
  a: "14.0"
}, {
  n: ["stethoscope"],
  u: "1fa7a",
  a: "12.0"
}, {
  n: ["x-ray"],
  u: "1fa7b",
  a: "14.0"
}, {
  n: ["door"],
  u: "1f6aa",
  a: "0.6"
}, {
  n: ["elevator"],
  u: "1f6d7",
  a: "13.0"
}, {
  n: ["mirror"],
  u: "1fa9e",
  a: "13.0"
}, {
  n: ["window"],
  u: "1fa9f",
  a: "13.0"
}, {
  n: ["bed"],
  u: "1f6cf-fe0f",
  a: "0.7"
}, {
  n: ["couch and lamp"],
  u: "1f6cb-fe0f",
  a: "0.7"
}, {
  n: ["chair"],
  u: "1fa91",
  a: "12.0"
}, {
  n: ["toilet"],
  u: "1f6bd",
  a: "0.6"
}, {
  n: ["plunger"],
  u: "1faa0",
  a: "13.0"
}, {
  n: ["shower"],
  u: "1f6bf",
  a: "1.0"
}, {
  n: ["bathtub"],
  u: "1f6c1",
  a: "1.0"
}, {
  n: ["mouse trap"],
  u: "1faa4",
  a: "13.0"
}, {
  n: ["razor"],
  u: "1fa92",
  a: "12.0"
}, {
  n: ["lotion bottle"],
  u: "1f9f4",
  a: "11.0"
}, {
  n: ["safety pin"],
  u: "1f9f7",
  a: "11.0"
}, {
  n: ["broom"],
  u: "1f9f9",
  a: "11.0"
}, {
  n: ["basket"],
  u: "1f9fa",
  a: "11.0"
}, {
  n: ["roll of paper"],
  u: "1f9fb",
  a: "11.0"
}, {
  n: ["bucket"],
  u: "1faa3",
  a: "13.0"
}, {
  n: ["soap", "bar of soap"],
  u: "1f9fc",
  a: "11.0"
}, {
  n: ["bubbles"],
  u: "1fae7",
  a: "14.0"
}, {
  n: ["toothbrush"],
  u: "1faa5",
  a: "13.0"
}, {
  n: ["sponge"],
  u: "1f9fd",
  a: "11.0"
}, {
  n: ["fire extinguisher"],
  u: "1f9ef",
  a: "11.0"
}, {
  n: ["shopping trolley"],
  u: "1f6d2",
  a: "3.0"
}, {
  n: ["smoking", "smoking symbol"],
  u: "1f6ac",
  a: "0.6"
}, {
  n: ["coffin"],
  u: "26b0-fe0f",
  a: "1.0"
}, {
  n: ["headstone"],
  u: "1faa6",
  a: "13.0"
}, {
  n: ["funeral urn"],
  u: "26b1-fe0f",
  a: "1.0"
}, {
  n: ["moyai"],
  u: "1f5ff",
  a: "0.6"
}, {
  n: ["placard"],
  u: "1faa7",
  a: "13.0"
}, {
  n: ["identification card"],
  u: "1faaa",
  a: "14.0"
}];
var symbols = [{
  n: ["atm", "automated teller machine"],
  u: "1f3e7",
  a: "0.6"
}, {
  n: ["put litter in its place", "put litter in its place symbol"],
  u: "1f6ae",
  a: "1.0"
}, {
  n: ["potable water", "potable water symbol"],
  u: "1f6b0",
  a: "1.0"
}, {
  n: ["wheelchair", "wheelchair symbol"],
  u: "267f",
  a: "0.6"
}, {
  n: ["mens", "mens symbol"],
  u: "1f6b9",
  a: "0.6"
}, {
  n: ["womens", "womens symbol"],
  u: "1f6ba",
  a: "0.6"
}, {
  n: ["restroom"],
  u: "1f6bb",
  a: "0.6"
}, {
  n: ["baby symbol"],
  u: "1f6bc",
  a: "0.6"
}, {
  n: ["wc", "water closet"],
  u: "1f6be",
  a: "0.6"
}, {
  n: ["passport control"],
  u: "1f6c2",
  a: "1.0"
}, {
  n: ["customs"],
  u: "1f6c3",
  a: "1.0"
}, {
  n: ["baggage claim"],
  u: "1f6c4",
  a: "1.0"
}, {
  n: ["left luggage"],
  u: "1f6c5",
  a: "1.0"
}, {
  n: ["warning", "warning sign"],
  u: "26a0-fe0f",
  a: "0.6"
}, {
  n: ["children crossing"],
  u: "1f6b8",
  a: "1.0"
}, {
  n: ["no entry"],
  u: "26d4",
  a: "0.6"
}, {
  n: ["no entry sign"],
  u: "1f6ab",
  a: "0.6"
}, {
  n: ["no bicycles"],
  u: "1f6b3",
  a: "1.0"
}, {
  n: ["no smoking", "no smoking symbol"],
  u: "1f6ad",
  a: "0.6"
}, {
  n: ["do not litter", "do not litter symbol"],
  u: "1f6af",
  a: "1.0"
}, {
  n: ["non-potable water", "non-potable water symbol"],
  u: "1f6b1",
  a: "1.0"
}, {
  n: ["no pedestrians"],
  u: "1f6b7",
  a: "1.0"
}, {
  n: ["no mobile phones"],
  u: "1f4f5",
  a: "1.0"
}, {
  n: ["underage", "no one under eighteen symbol"],
  u: "1f51e",
  a: "0.6"
}, {
  n: ["radioactive", "radioactive sign"],
  u: "2622-fe0f",
  a: "1.0"
}, {
  n: ["biohazard", "biohazard sign"],
  u: "2623-fe0f",
  a: "1.0"
}, {
  n: ["arrow up", "upwards black arrow"],
  u: "2b06-fe0f",
  a: "0.6"
}, {
  n: ["north east arrow", "arrow upper right"],
  u: "2197-fe0f",
  a: "0.6"
}, {
  n: ["arrow right", "black rightwards arrow"],
  u: "27a1-fe0f",
  a: "0.6"
}, {
  n: ["south east arrow", "arrow lower right"],
  u: "2198-fe0f",
  a: "0.6"
}, {
  n: ["arrow down", "downwards black arrow"],
  u: "2b07-fe0f",
  a: "0.6"
}, {
  n: ["south west arrow", "arrow lower left"],
  u: "2199-fe0f",
  a: "0.6"
}, {
  n: ["arrow left", "leftwards black arrow"],
  u: "2b05-fe0f",
  a: "0.6"
}, {
  n: ["north west arrow", "arrow upper left"],
  u: "2196-fe0f",
  a: "0.6"
}, {
  n: ["up down arrow", "arrow up down"],
  u: "2195-fe0f",
  a: "0.6"
}, {
  n: ["left right arrow"],
  u: "2194-fe0f",
  a: "0.6"
}, {
  n: ["leftwards arrow with hook"],
  u: "21a9-fe0f",
  a: "0.6"
}, {
  n: ["arrow right hook", "rightwards arrow with hook"],
  u: "21aa-fe0f",
  a: "0.6"
}, {
  n: ["arrow heading up", "arrow pointing rightwards then curving upwards"],
  u: "2934-fe0f",
  a: "0.6"
}, {
  n: ["arrow heading down", "arrow pointing rightwards then curving downwards"],
  u: "2935-fe0f",
  a: "0.6"
}, {
  n: ["arrows clockwise", "clockwise downwards and upwards open circle arrows"],
  u: "1f503",
  a: "0.6"
}, {
  n: ["arrows counterclockwise", "anticlockwise downwards and upwards open circle arrows"],
  u: "1f504",
  a: "1.0"
}, {
  n: ["back", "back with leftwards arrow above"],
  u: "1f519",
  a: "0.6"
}, {
  n: ["end", "end with leftwards arrow above"],
  u: "1f51a",
  a: "0.6"
}, {
  n: ["on", "on with exclamation mark with left right arrow above"],
  u: "1f51b",
  a: "0.6"
}, {
  n: ["soon", "soon with rightwards arrow above"],
  u: "1f51c",
  a: "0.6"
}, {
  n: ["top", "top with upwards arrow above"],
  u: "1f51d",
  a: "0.6"
}, {
  n: ["place of worship"],
  u: "1f6d0",
  a: "1.0"
}, {
  n: ["atom symbol"],
  u: "269b-fe0f",
  a: "1.0"
}, {
  n: ["om", "om symbol"],
  u: "1f549-fe0f",
  a: "0.7"
}, {
  n: ["star of david"],
  u: "2721-fe0f",
  a: "0.7"
}, {
  n: ["wheel of dharma"],
  u: "2638-fe0f",
  a: "0.7"
}, {
  n: ["yin yang"],
  u: "262f-fe0f",
  a: "0.7"
}, {
  n: ["latin cross"],
  u: "271d-fe0f",
  a: "0.7"
}, {
  n: ["orthodox cross"],
  u: "2626-fe0f",
  a: "1.0"
}, {
  n: ["star and crescent"],
  u: "262a-fe0f",
  a: "0.7"
}, {
  n: ["peace symbol"],
  u: "262e-fe0f",
  a: "1.0"
}, {
  n: ["menorah with nine branches"],
  u: "1f54e",
  a: "1.0"
}, {
  n: ["six pointed star", "six pointed star with middle dot"],
  u: "1f52f",
  a: "0.6"
}, {
  n: ["aries"],
  u: "2648",
  a: "0.6"
}, {
  n: ["taurus"],
  u: "2649",
  a: "0.6"
}, {
  n: ["gemini"],
  u: "264a",
  a: "0.6"
}, {
  n: ["cancer"],
  u: "264b",
  a: "0.6"
}, {
  n: ["leo"],
  u: "264c",
  a: "0.6"
}, {
  n: ["virgo"],
  u: "264d",
  a: "0.6"
}, {
  n: ["libra"],
  u: "264e",
  a: "0.6"
}, {
  n: ["scorpius"],
  u: "264f",
  a: "0.6"
}, {
  n: ["sagittarius"],
  u: "2650",
  a: "0.6"
}, {
  n: ["capricorn"],
  u: "2651",
  a: "0.6"
}, {
  n: ["aquarius"],
  u: "2652",
  a: "0.6"
}, {
  n: ["pisces"],
  u: "2653",
  a: "0.6"
}, {
  n: ["ophiuchus"],
  u: "26ce",
  a: "0.6"
}, {
  n: ["twisted rightwards arrows"],
  u: "1f500",
  a: "1.0"
}, {
  n: ["repeat", "clockwise rightwards and leftwards open circle arrows"],
  u: "1f501",
  a: "1.0"
}, {
  n: ["repeat one", "clockwise rightwards and leftwards open circle arrows with circled one overlay"],
  u: "1f502",
  a: "1.0"
}, {
  n: ["arrow forward", "black right-pointing triangle"],
  u: "25b6-fe0f",
  a: "0.6"
}, {
  n: ["fast forward", "black right-pointing double triangle"],
  u: "23e9",
  a: "0.6"
}, {
  n: ["next track button", "black right pointing double triangle with vertical bar"],
  u: "23ed-fe0f",
  a: "0.7"
}, {
  n: ["play or pause button", "black right pointing triangle with double vertical bar"],
  u: "23ef-fe0f",
  a: "1.0"
}, {
  n: ["arrow backward", "black left-pointing triangle"],
  u: "25c0-fe0f",
  a: "0.6"
}, {
  n: ["rewind", "black left-pointing double triangle"],
  u: "23ea",
  a: "0.6"
}, {
  n: ["last track button", "black left pointing double triangle with vertical bar"],
  u: "23ee-fe0f",
  a: "0.7"
}, {
  n: ["arrow up small", "up-pointing small red triangle"],
  u: "1f53c",
  a: "0.6"
}, {
  n: ["arrow double up", "black up-pointing double triangle"],
  u: "23eb",
  a: "0.6"
}, {
  n: ["arrow down small", "down-pointing small red triangle"],
  u: "1f53d",
  a: "0.6"
}, {
  n: ["arrow double down", "black down-pointing double triangle"],
  u: "23ec",
  a: "0.6"
}, {
  n: ["pause button", "double vertical bar"],
  u: "23f8-fe0f",
  a: "0.7"
}, {
  n: ["stop button", "black square for stop"],
  u: "23f9-fe0f",
  a: "0.7"
}, {
  n: ["record button", "black circle for record"],
  u: "23fa-fe0f",
  a: "0.7"
}, {
  n: ["eject", "eject button"],
  u: "23cf-fe0f",
  a: "1.0"
}, {
  n: ["cinema"],
  u: "1f3a6",
  a: "0.6"
}, {
  n: ["low brightness", "low brightness symbol"],
  u: "1f505",
  a: "1.0"
}, {
  n: ["high brightness", "high brightness symbol"],
  u: "1f506",
  a: "1.0"
}, {
  n: ["signal strength", "antenna with bars"],
  u: "1f4f6",
  a: "0.6"
}, {
  n: ["vibration mode"],
  u: "1f4f3",
  a: "0.6"
}, {
  n: ["mobile phone off"],
  u: "1f4f4",
  a: "0.6"
}, {
  n: ["female sign"],
  u: "2640-fe0f",
  a: "4.0"
}, {
  n: ["male sign"],
  u: "2642-fe0f",
  a: "4.0"
}, {
  n: ["transgender symbol"],
  u: "26a7-fe0f",
  a: "13.0"
}, {
  n: ["heavy multiplication x"],
  u: "2716-fe0f",
  a: "0.6"
}, {
  n: ["heavy plus sign"],
  u: "2795",
  a: "0.6"
}, {
  n: ["heavy minus sign"],
  u: "2796",
  a: "0.6"
}, {
  n: ["heavy division sign"],
  u: "2797",
  a: "0.6"
}, {
  n: ["heavy equals sign"],
  u: "1f7f0",
  a: "14.0"
}, {
  n: ["infinity"],
  u: "267e-fe0f",
  a: "11.0"
}, {
  n: ["bangbang", "double exclamation mark"],
  u: "203c-fe0f",
  a: "0.6"
}, {
  n: ["interrobang", "exclamation question mark"],
  u: "2049-fe0f",
  a: "0.6"
}, {
  n: ["question", "black question mark ornament"],
  u: "2753",
  a: "0.6"
}, {
  n: ["grey question", "white question mark ornament"],
  u: "2754",
  a: "0.6"
}, {
  n: ["grey exclamation", "white exclamation mark ornament"],
  u: "2755",
  a: "0.6"
}, {
  n: ["exclamation", "heavy exclamation mark", "heavy exclamation mark symbol"],
  u: "2757",
  a: "0.6"
}, {
  n: ["wavy dash"],
  u: "3030-fe0f",
  a: "0.6"
}, {
  n: ["currency exchange"],
  u: "1f4b1",
  a: "0.6"
}, {
  n: ["heavy dollar sign"],
  u: "1f4b2",
  a: "0.6"
}, {
  n: ["medical symbol", "staff of aesculapius"],
  u: "2695-fe0f",
  a: "4.0"
}, {
  n: ["recycle", "black universal recycling symbol"],
  u: "267b-fe0f",
  a: "0.6"
}, {
  n: ["fleur-de-lis", "fleur de lis"],
  u: "269c-fe0f",
  a: "1.0"
}, {
  n: ["trident", "trident emblem"],
  u: "1f531",
  a: "0.6"
}, {
  n: ["name badge"],
  u: "1f4db",
  a: "0.6"
}, {
  n: ["beginner", "japanese symbol for beginner"],
  u: "1f530",
  a: "0.6"
}, {
  n: ["o", "heavy large circle"],
  u: "2b55",
  a: "0.6"
}, {
  n: ["white check mark", "white heavy check mark"],
  u: "2705",
  a: "0.6"
}, {
  n: ["ballot box with check"],
  u: "2611-fe0f",
  a: "0.6"
}, {
  n: ["heavy check mark"],
  u: "2714-fe0f",
  a: "0.6"
}, {
  n: ["x", "cross mark"],
  u: "274c",
  a: "0.6"
}, {
  n: ["negative squared cross mark"],
  u: "274e",
  a: "0.6"
}, {
  n: ["curly loop"],
  u: "27b0",
  a: "0.6"
}, {
  n: ["loop", "double curly loop"],
  u: "27bf",
  a: "1.0"
}, {
  n: ["part alternation mark"],
  u: "303d-fe0f",
  a: "0.6"
}, {
  n: ["eight spoked asterisk"],
  u: "2733-fe0f",
  a: "0.6"
}, {
  n: ["eight pointed black star"],
  u: "2734-fe0f",
  a: "0.6"
}, {
  n: ["sparkle"],
  u: "2747-fe0f",
  a: "0.6"
}, {
  n: ["copyright", "copyright sign"],
  u: "00a9-fe0f",
  a: "0.6"
}, {
  n: ["registered", "registered sign"],
  u: "00ae-fe0f",
  a: "0.6"
}, {
  n: ["tm", "trade mark sign"],
  u: "2122-fe0f",
  a: "0.6"
}, {
  n: ["hash", "hash key"],
  u: "0023-fe0f-20e3",
  a: "0.6"
}, {
  n: ["keycap: *", "keycap star"],
  u: "002a-fe0f-20e3",
  a: "2.0"
}, {
  n: ["zero", "keycap 0"],
  u: "0030-fe0f-20e3",
  a: "0.6"
}, {
  n: ["one", "keycap 1"],
  u: "0031-fe0f-20e3",
  a: "0.6"
}, {
  n: ["two", "keycap 2"],
  u: "0032-fe0f-20e3",
  a: "0.6"
}, {
  n: ["three", "keycap 3"],
  u: "0033-fe0f-20e3",
  a: "0.6"
}, {
  n: ["four", "keycap 4"],
  u: "0034-fe0f-20e3",
  a: "0.6"
}, {
  n: ["five", "keycap 5"],
  u: "0035-fe0f-20e3",
  a: "0.6"
}, {
  n: ["six", "keycap 6"],
  u: "0036-fe0f-20e3",
  a: "0.6"
}, {
  n: ["seven", "keycap 7"],
  u: "0037-fe0f-20e3",
  a: "0.6"
}, {
  n: ["eight", "keycap 8"],
  u: "0038-fe0f-20e3",
  a: "0.6"
}, {
  n: ["nine", "keycap 9"],
  u: "0039-fe0f-20e3",
  a: "0.6"
}, {
  n: ["keycap ten"],
  u: "1f51f",
  a: "0.6"
}, {
  n: ["capital abcd", "input symbol for latin capital letters"],
  u: "1f520",
  a: "0.6"
}, {
  n: ["abcd", "input symbol for latin small letters"],
  u: "1f521",
  a: "0.6"
}, {
  n: ["1234", "input symbol for numbers"],
  u: "1f522",
  a: "0.6"
}, {
  n: ["symbols", "input symbol for symbols"],
  u: "1f523",
  a: "0.6"
}, {
  n: ["abc", "input symbol for latin letters"],
  u: "1f524",
  a: "0.6"
}, {
  n: ["a", "negative squared latin capital letter a"],
  u: "1f170-fe0f",
  a: "0.6"
}, {
  n: ["ab", "negative squared ab"],
  u: "1f18e",
  a: "0.6"
}, {
  n: ["b", "negative squared latin capital letter b"],
  u: "1f171-fe0f",
  a: "0.6"
}, {
  n: ["cl", "squared cl"],
  u: "1f191",
  a: "0.6"
}, {
  n: ["cool", "squared cool"],
  u: "1f192",
  a: "0.6"
}, {
  n: ["free", "squared free"],
  u: "1f193",
  a: "0.6"
}, {
  n: ["information source"],
  u: "2139-fe0f",
  a: "0.6"
}, {
  n: ["id", "squared id"],
  u: "1f194",
  a: "0.6"
}, {
  n: ["m", "circled latin capital letter m"],
  u: "24c2-fe0f",
  a: "0.6"
}, {
  n: ["new", "squared new"],
  u: "1f195",
  a: "0.6"
}, {
  n: ["ng", "squared ng"],
  u: "1f196",
  a: "0.6"
}, {
  n: ["o2", "negative squared latin capital letter o"],
  u: "1f17e-fe0f",
  a: "0.6"
}, {
  n: ["ok", "squared ok"],
  u: "1f197",
  a: "0.6"
}, {
  n: ["parking", "negative squared latin capital letter p"],
  u: "1f17f-fe0f",
  a: "0.6"
}, {
  n: ["sos", "squared sos"],
  u: "1f198",
  a: "0.6"
}, {
  n: ["up", "squared up with exclamation mark"],
  u: "1f199",
  a: "0.6"
}, {
  n: ["vs", "squared vs"],
  u: "1f19a",
  a: "0.6"
}, {
  n: ["koko", "squared katakana koko"],
  u: "1f201",
  a: "0.6"
}, {
  n: ["sa", "squared katakana sa"],
  u: "1f202-fe0f",
  a: "0.6"
}, {
  n: ["u6708", "squared cjk unified ideograph-6708"],
  u: "1f237-fe0f",
  a: "0.6"
}, {
  n: ["u6709", "squared cjk unified ideograph-6709"],
  u: "1f236",
  a: "0.6"
}, {
  n: ["u6307", "squared cjk unified ideograph-6307"],
  u: "1f22f",
  a: "0.6"
}, {
  n: ["ideograph advantage", "circled ideograph advantage"],
  u: "1f250",
  a: "0.6"
}, {
  n: ["u5272", "squared cjk unified ideograph-5272"],
  u: "1f239",
  a: "0.6"
}, {
  n: ["u7121", "squared cjk unified ideograph-7121"],
  u: "1f21a",
  a: "0.6"
}, {
  n: ["u7981", "squared cjk unified ideograph-7981"],
  u: "1f232",
  a: "0.6"
}, {
  n: ["accept", "circled ideograph accept"],
  u: "1f251",
  a: "0.6"
}, {
  n: ["u7533", "squared cjk unified ideograph-7533"],
  u: "1f238",
  a: "0.6"
}, {
  n: ["u5408", "squared cjk unified ideograph-5408"],
  u: "1f234",
  a: "0.6"
}, {
  n: ["u7a7a", "squared cjk unified ideograph-7a7a"],
  u: "1f233",
  a: "0.6"
}, {
  n: ["congratulations", "circled ideograph congratulation"],
  u: "3297-fe0f",
  a: "0.6"
}, {
  n: ["secret", "circled ideograph secret"],
  u: "3299-fe0f",
  a: "0.6"
}, {
  n: ["u55b6", "squared cjk unified ideograph-55b6"],
  u: "1f23a",
  a: "0.6"
}, {
  n: ["u6e80", "squared cjk unified ideograph-6e80"],
  u: "1f235",
  a: "0.6"
}, {
  n: ["red circle", "large red circle"],
  u: "1f534",
  a: "0.6"
}, {
  n: ["large orange circle"],
  u: "1f7e0",
  a: "12.0"
}, {
  n: ["large yellow circle"],
  u: "1f7e1",
  a: "12.0"
}, {
  n: ["large green circle"],
  u: "1f7e2",
  a: "12.0"
}, {
  n: ["large blue circle"],
  u: "1f535",
  a: "0.6"
}, {
  n: ["large purple circle"],
  u: "1f7e3",
  a: "12.0"
}, {
  n: ["large brown circle"],
  u: "1f7e4",
  a: "12.0"
}, {
  n: ["black circle", "medium black circle"],
  u: "26ab",
  a: "0.6"
}, {
  n: ["white circle", "medium white circle"],
  u: "26aa",
  a: "0.6"
}, {
  n: ["large red square"],
  u: "1f7e5",
  a: "12.0"
}, {
  n: ["large orange square"],
  u: "1f7e7",
  a: "12.0"
}, {
  n: ["large yellow square"],
  u: "1f7e8",
  a: "12.0"
}, {
  n: ["large green square"],
  u: "1f7e9",
  a: "12.0"
}, {
  n: ["large blue square"],
  u: "1f7e6",
  a: "12.0"
}, {
  n: ["large purple square"],
  u: "1f7ea",
  a: "12.0"
}, {
  n: ["large brown square"],
  u: "1f7eb",
  a: "12.0"
}, {
  n: ["black large square"],
  u: "2b1b",
  a: "0.6"
}, {
  n: ["white large square"],
  u: "2b1c",
  a: "0.6"
}, {
  n: ["black medium square"],
  u: "25fc-fe0f",
  a: "0.6"
}, {
  n: ["white medium square"],
  u: "25fb-fe0f",
  a: "0.6"
}, {
  n: ["black medium small square"],
  u: "25fe",
  a: "0.6"
}, {
  n: ["white medium small square"],
  u: "25fd",
  a: "0.6"
}, {
  n: ["black small square"],
  u: "25aa-fe0f",
  a: "0.6"
}, {
  n: ["white small square"],
  u: "25ab-fe0f",
  a: "0.6"
}, {
  n: ["large orange diamond"],
  u: "1f536",
  a: "0.6"
}, {
  n: ["large blue diamond"],
  u: "1f537",
  a: "0.6"
}, {
  n: ["small orange diamond"],
  u: "1f538",
  a: "0.6"
}, {
  n: ["small blue diamond"],
  u: "1f539",
  a: "0.6"
}, {
  n: ["small red triangle", "up-pointing red triangle"],
  u: "1f53a",
  a: "0.6"
}, {
  n: ["small red triangle down", "down-pointing red triangle"],
  u: "1f53b",
  a: "0.6"
}, {
  n: ["diamond shape with a dot inside"],
  u: "1f4a0",
  a: "0.6"
}, {
  n: ["radio button"],
  u: "1f518",
  a: "0.6"
}, {
  n: ["white square button"],
  u: "1f533",
  a: "0.6"
}, {
  n: ["black square button"],
  u: "1f532",
  a: "0.6"
}];
var flags = [{
  n: ["chequered flag", "checkered flag"],
  u: "1f3c1",
  a: "0.6"
}, {
  n: ["triangular flag on post"],
  u: "1f6a9",
  a: "0.6"
}, {
  n: ["crossed flags"],
  u: "1f38c",
  a: "0.6"
}, {
  n: ["waving black flag"],
  u: "1f3f4",
  a: "1.0"
}, {
  n: ["white flag", "waving white flag"],
  u: "1f3f3-fe0f",
  a: "0.7"
}, {
  n: ["rainbow flag", "rainbow-flag"],
  u: "1f3f3-fe0f-200d-1f308",
  a: "4.0"
}, {
  n: ["transgender flag"],
  u: "1f3f3-fe0f-200d-26a7-fe0f",
  a: "13.0"
}, {
  n: ["pirate flag"],
  u: "1f3f4-200d-2620-fe0f",
  a: "11.0"
}, {
  n: ["flag-ac", "ascension island flag"],
  u: "1f1e6-1f1e8",
  a: "2.0"
}, {
  n: ["flag-ad", "andorra flag"],
  u: "1f1e6-1f1e9",
  a: "2.0"
}, {
  n: ["flag-ae", "united arab emirates flag"],
  u: "1f1e6-1f1ea",
  a: "2.0"
}, {
  n: ["flag-af", "afghanistan flag"],
  u: "1f1e6-1f1eb",
  a: "2.0"
}, {
  n: ["flag-ag", "antigua & barbuda flag"],
  u: "1f1e6-1f1ec",
  a: "2.0"
}, {
  n: ["flag-ai", "anguilla flag"],
  u: "1f1e6-1f1ee",
  a: "2.0"
}, {
  n: ["flag-al", "albania flag"],
  u: "1f1e6-1f1f1",
  a: "2.0"
}, {
  n: ["flag-am", "armenia flag"],
  u: "1f1e6-1f1f2",
  a: "2.0"
}, {
  n: ["flag-ao", "angola flag"],
  u: "1f1e6-1f1f4",
  a: "2.0"
}, {
  n: ["flag-aq", "antarctica flag"],
  u: "1f1e6-1f1f6",
  a: "2.0"
}, {
  n: ["flag-ar", "argentina flag"],
  u: "1f1e6-1f1f7",
  a: "2.0"
}, {
  n: ["flag-as", "american samoa flag"],
  u: "1f1e6-1f1f8",
  a: "2.0"
}, {
  n: ["flag-at", "austria flag"],
  u: "1f1e6-1f1f9",
  a: "2.0"
}, {
  n: ["flag-au", "australia flag"],
  u: "1f1e6-1f1fa",
  a: "2.0"
}, {
  n: ["flag-aw", "aruba flag"],
  u: "1f1e6-1f1fc",
  a: "2.0"
}, {
  n: ["flag-ax", "åland islands flag"],
  u: "1f1e6-1f1fd",
  a: "2.0"
}, {
  n: ["flag-az", "azerbaijan flag"],
  u: "1f1e6-1f1ff",
  a: "2.0"
}, {
  n: ["flag-ba", "bosnia & herzegovina flag"],
  u: "1f1e7-1f1e6",
  a: "2.0"
}, {
  n: ["flag-bb", "barbados flag"],
  u: "1f1e7-1f1e7",
  a: "2.0"
}, {
  n: ["flag-bd", "bangladesh flag"],
  u: "1f1e7-1f1e9",
  a: "2.0"
}, {
  n: ["flag-be", "belgium flag"],
  u: "1f1e7-1f1ea",
  a: "2.0"
}, {
  n: ["flag-bf", "burkina faso flag"],
  u: "1f1e7-1f1eb",
  a: "2.0"
}, {
  n: ["flag-bg", "bulgaria flag"],
  u: "1f1e7-1f1ec",
  a: "2.0"
}, {
  n: ["flag-bh", "bahrain flag"],
  u: "1f1e7-1f1ed",
  a: "2.0"
}, {
  n: ["flag-bi", "burundi flag"],
  u: "1f1e7-1f1ee",
  a: "2.0"
}, {
  n: ["flag-bj", "benin flag"],
  u: "1f1e7-1f1ef",
  a: "2.0"
}, {
  n: ["flag-bl", "st. barthélemy flag"],
  u: "1f1e7-1f1f1",
  a: "2.0"
}, {
  n: ["flag-bm", "bermuda flag"],
  u: "1f1e7-1f1f2",
  a: "2.0"
}, {
  n: ["flag-bn", "brunei flag"],
  u: "1f1e7-1f1f3",
  a: "2.0"
}, {
  n: ["flag-bo", "bolivia flag"],
  u: "1f1e7-1f1f4",
  a: "2.0"
}, {
  n: ["flag-bq", "caribbean netherlands flag"],
  u: "1f1e7-1f1f6",
  a: "2.0"
}, {
  n: ["flag-br", "brazil flag"],
  u: "1f1e7-1f1f7",
  a: "2.0"
}, {
  n: ["flag-bs", "bahamas flag"],
  u: "1f1e7-1f1f8",
  a: "2.0"
}, {
  n: ["flag-bt", "bhutan flag"],
  u: "1f1e7-1f1f9",
  a: "2.0"
}, {
  n: ["flag-bv", "bouvet island flag"],
  u: "1f1e7-1f1fb",
  a: "2.0"
}, {
  n: ["flag-bw", "botswana flag"],
  u: "1f1e7-1f1fc",
  a: "2.0"
}, {
  n: ["flag-by", "belarus flag"],
  u: "1f1e7-1f1fe",
  a: "2.0"
}, {
  n: ["flag-bz", "belize flag"],
  u: "1f1e7-1f1ff",
  a: "2.0"
}, {
  n: ["flag-ca", "canada flag"],
  u: "1f1e8-1f1e6",
  a: "2.0"
}, {
  n: ["flag-cc", "cocos (keeling) islands flag"],
  u: "1f1e8-1f1e8",
  a: "2.0"
}, {
  n: ["flag-cd", "congo - kinshasa flag"],
  u: "1f1e8-1f1e9",
  a: "2.0"
}, {
  n: ["flag-cf", "central african republic flag"],
  u: "1f1e8-1f1eb",
  a: "2.0"
}, {
  n: ["flag-cg", "congo - brazzaville flag"],
  u: "1f1e8-1f1ec",
  a: "2.0"
}, {
  n: ["flag-ch", "switzerland flag"],
  u: "1f1e8-1f1ed",
  a: "2.0"
}, {
  n: ["flag-ci", "côte d’ivoire flag"],
  u: "1f1e8-1f1ee",
  a: "2.0"
}, {
  n: ["flag-ck", "cook islands flag"],
  u: "1f1e8-1f1f0",
  a: "2.0"
}, {
  n: ["flag-cl", "chile flag"],
  u: "1f1e8-1f1f1",
  a: "2.0"
}, {
  n: ["flag-cm", "cameroon flag"],
  u: "1f1e8-1f1f2",
  a: "2.0"
}, {
  n: ["cn", "flag-cn", "china flag"],
  u: "1f1e8-1f1f3",
  a: "0.6"
}, {
  n: ["flag-co", "colombia flag"],
  u: "1f1e8-1f1f4",
  a: "2.0"
}, {
  n: ["flag-cp", "clipperton island flag"],
  u: "1f1e8-1f1f5",
  a: "2.0"
}, {
  n: ["flag-cr", "costa rica flag"],
  u: "1f1e8-1f1f7",
  a: "2.0"
}, {
  n: ["flag-cu", "cuba flag"],
  u: "1f1e8-1f1fa",
  a: "2.0"
}, {
  n: ["flag-cv", "cape verde flag"],
  u: "1f1e8-1f1fb",
  a: "2.0"
}, {
  n: ["flag-cw", "curaçao flag"],
  u: "1f1e8-1f1fc",
  a: "2.0"
}, {
  n: ["flag-cx", "christmas island flag"],
  u: "1f1e8-1f1fd",
  a: "2.0"
}, {
  n: ["flag-cy", "cyprus flag"],
  u: "1f1e8-1f1fe",
  a: "2.0"
}, {
  n: ["flag-cz", "czechia flag"],
  u: "1f1e8-1f1ff",
  a: "2.0"
}, {
  n: ["de", "flag-de", "germany flag"],
  u: "1f1e9-1f1ea",
  a: "0.6"
}, {
  n: ["flag-dg", "diego garcia flag"],
  u: "1f1e9-1f1ec",
  a: "2.0"
}, {
  n: ["flag-dj", "djibouti flag"],
  u: "1f1e9-1f1ef",
  a: "2.0"
}, {
  n: ["flag-dk", "denmark flag"],
  u: "1f1e9-1f1f0",
  a: "2.0"
}, {
  n: ["flag-dm", "dominica flag"],
  u: "1f1e9-1f1f2",
  a: "2.0"
}, {
  n: ["flag-do", "dominican republic flag"],
  u: "1f1e9-1f1f4",
  a: "2.0"
}, {
  n: ["flag-dz", "algeria flag"],
  u: "1f1e9-1f1ff",
  a: "2.0"
}, {
  n: ["flag-ea", "ceuta & melilla flag"],
  u: "1f1ea-1f1e6",
  a: "2.0"
}, {
  n: ["flag-ec", "ecuador flag"],
  u: "1f1ea-1f1e8",
  a: "2.0"
}, {
  n: ["flag-ee", "estonia flag"],
  u: "1f1ea-1f1ea",
  a: "2.0"
}, {
  n: ["flag-eg", "egypt flag"],
  u: "1f1ea-1f1ec",
  a: "2.0"
}, {
  n: ["flag-eh", "western sahara flag"],
  u: "1f1ea-1f1ed",
  a: "2.0"
}, {
  n: ["flag-er", "eritrea flag"],
  u: "1f1ea-1f1f7",
  a: "2.0"
}, {
  n: ["es", "flag-es", "spain flag"],
  u: "1f1ea-1f1f8",
  a: "0.6"
}, {
  n: ["flag-et", "ethiopia flag"],
  u: "1f1ea-1f1f9",
  a: "2.0"
}, {
  n: ["flag-eu", "european union flag"],
  u: "1f1ea-1f1fa",
  a: "2.0"
}, {
  n: ["flag-fi", "finland flag"],
  u: "1f1eb-1f1ee",
  a: "2.0"
}, {
  n: ["flag-fj", "fiji flag"],
  u: "1f1eb-1f1ef",
  a: "2.0"
}, {
  n: ["flag-fk", "falkland islands flag"],
  u: "1f1eb-1f1f0",
  a: "2.0"
}, {
  n: ["flag-fm", "micronesia flag"],
  u: "1f1eb-1f1f2",
  a: "2.0"
}, {
  n: ["flag-fo", "faroe islands flag"],
  u: "1f1eb-1f1f4",
  a: "2.0"
}, {
  n: ["fr", "flag-fr", "france flag"],
  u: "1f1eb-1f1f7",
  a: "0.6"
}, {
  n: ["flag-ga", "gabon flag"],
  u: "1f1ec-1f1e6",
  a: "2.0"
}, {
  n: ["gb", "uk", "flag-gb", "united kingdom flag"],
  u: "1f1ec-1f1e7",
  a: "0.6"
}, {
  n: ["flag-gd", "grenada flag"],
  u: "1f1ec-1f1e9",
  a: "2.0"
}, {
  n: ["flag-ge", "georgia flag"],
  u: "1f1ec-1f1ea",
  a: "2.0"
}, {
  n: ["flag-gf", "french guiana flag"],
  u: "1f1ec-1f1eb",
  a: "2.0"
}, {
  n: ["flag-gg", "guernsey flag"],
  u: "1f1ec-1f1ec",
  a: "2.0"
}, {
  n: ["flag-gh", "ghana flag"],
  u: "1f1ec-1f1ed",
  a: "2.0"
}, {
  n: ["flag-gi", "gibraltar flag"],
  u: "1f1ec-1f1ee",
  a: "2.0"
}, {
  n: ["flag-gl", "greenland flag"],
  u: "1f1ec-1f1f1",
  a: "2.0"
}, {
  n: ["flag-gm", "gambia flag"],
  u: "1f1ec-1f1f2",
  a: "2.0"
}, {
  n: ["flag-gn", "guinea flag"],
  u: "1f1ec-1f1f3",
  a: "2.0"
}, {
  n: ["flag-gp", "guadeloupe flag"],
  u: "1f1ec-1f1f5",
  a: "2.0"
}, {
  n: ["flag-gq", "equatorial guinea flag"],
  u: "1f1ec-1f1f6",
  a: "2.0"
}, {
  n: ["flag-gr", "greece flag"],
  u: "1f1ec-1f1f7",
  a: "2.0"
}, {
  n: ["flag-gs", "south georgia & south sandwich islands flag"],
  u: "1f1ec-1f1f8",
  a: "2.0"
}, {
  n: ["flag-gt", "guatemala flag"],
  u: "1f1ec-1f1f9",
  a: "2.0"
}, {
  n: ["flag-gu", "guam flag"],
  u: "1f1ec-1f1fa",
  a: "2.0"
}, {
  n: ["flag-gw", "guinea-bissau flag"],
  u: "1f1ec-1f1fc",
  a: "2.0"
}, {
  n: ["flag-gy", "guyana flag"],
  u: "1f1ec-1f1fe",
  a: "2.0"
}, {
  n: ["flag-hk", "hong kong sar china flag"],
  u: "1f1ed-1f1f0",
  a: "2.0"
}, {
  n: ["flag-hm", "heard & mcdonald islands flag"],
  u: "1f1ed-1f1f2",
  a: "2.0"
}, {
  n: ["flag-hn", "honduras flag"],
  u: "1f1ed-1f1f3",
  a: "2.0"
}, {
  n: ["flag-hr", "croatia flag"],
  u: "1f1ed-1f1f7",
  a: "2.0"
}, {
  n: ["flag-ht", "haiti flag"],
  u: "1f1ed-1f1f9",
  a: "2.0"
}, {
  n: ["flag-hu", "hungary flag"],
  u: "1f1ed-1f1fa",
  a: "2.0"
}, {
  n: ["flag-ic", "canary islands flag"],
  u: "1f1ee-1f1e8",
  a: "2.0"
}, {
  n: ["flag-id", "indonesia flag"],
  u: "1f1ee-1f1e9",
  a: "2.0"
}, {
  n: ["flag-ie", "ireland flag"],
  u: "1f1ee-1f1ea",
  a: "2.0"
}, {
  n: ["flag-il", "israel flag"],
  u: "1f1ee-1f1f1",
  a: "2.0"
}, {
  n: ["flag-im", "isle of man flag"],
  u: "1f1ee-1f1f2",
  a: "2.0"
}, {
  n: ["flag-in", "india flag"],
  u: "1f1ee-1f1f3",
  a: "2.0"
}, {
  n: ["flag-io", "british indian ocean territory flag"],
  u: "1f1ee-1f1f4",
  a: "2.0"
}, {
  n: ["flag-iq", "iraq flag"],
  u: "1f1ee-1f1f6",
  a: "2.0"
}, {
  n: ["flag-ir", "iran flag"],
  u: "1f1ee-1f1f7",
  a: "2.0"
}, {
  n: ["flag-is", "iceland flag"],
  u: "1f1ee-1f1f8",
  a: "2.0"
}, {
  n: ["it", "flag-it", "italy flag"],
  u: "1f1ee-1f1f9",
  a: "0.6"
}, {
  n: ["flag-je", "jersey flag"],
  u: "1f1ef-1f1ea",
  a: "2.0"
}, {
  n: ["flag-jm", "jamaica flag"],
  u: "1f1ef-1f1f2",
  a: "2.0"
}, {
  n: ["flag-jo", "jordan flag"],
  u: "1f1ef-1f1f4",
  a: "2.0"
}, {
  n: ["jp", "flag-jp", "japan flag"],
  u: "1f1ef-1f1f5",
  a: "0.6"
}, {
  n: ["flag-ke", "kenya flag"],
  u: "1f1f0-1f1ea",
  a: "2.0"
}, {
  n: ["flag-kg", "kyrgyzstan flag"],
  u: "1f1f0-1f1ec",
  a: "2.0"
}, {
  n: ["flag-kh", "cambodia flag"],
  u: "1f1f0-1f1ed",
  a: "2.0"
}, {
  n: ["flag-ki", "kiribati flag"],
  u: "1f1f0-1f1ee",
  a: "2.0"
}, {
  n: ["flag-km", "comoros flag"],
  u: "1f1f0-1f1f2",
  a: "2.0"
}, {
  n: ["flag-kn", "st. kitts & nevis flag"],
  u: "1f1f0-1f1f3",
  a: "2.0"
}, {
  n: ["flag-kp", "north korea flag"],
  u: "1f1f0-1f1f5",
  a: "2.0"
}, {
  n: ["kr", "flag-kr", "south korea flag"],
  u: "1f1f0-1f1f7",
  a: "0.6"
}, {
  n: ["flag-kw", "kuwait flag"],
  u: "1f1f0-1f1fc",
  a: "2.0"
}, {
  n: ["flag-ky", "cayman islands flag"],
  u: "1f1f0-1f1fe",
  a: "2.0"
}, {
  n: ["flag-kz", "kazakhstan flag"],
  u: "1f1f0-1f1ff",
  a: "2.0"
}, {
  n: ["flag-la", "laos flag"],
  u: "1f1f1-1f1e6",
  a: "2.0"
}, {
  n: ["flag-lb", "lebanon flag"],
  u: "1f1f1-1f1e7",
  a: "2.0"
}, {
  n: ["flag-lc", "st. lucia flag"],
  u: "1f1f1-1f1e8",
  a: "2.0"
}, {
  n: ["flag-li", "liechtenstein flag"],
  u: "1f1f1-1f1ee",
  a: "2.0"
}, {
  n: ["flag-lk", "sri lanka flag"],
  u: "1f1f1-1f1f0",
  a: "2.0"
}, {
  n: ["flag-lr", "liberia flag"],
  u: "1f1f1-1f1f7",
  a: "2.0"
}, {
  n: ["flag-ls", "lesotho flag"],
  u: "1f1f1-1f1f8",
  a: "2.0"
}, {
  n: ["flag-lt", "lithuania flag"],
  u: "1f1f1-1f1f9",
  a: "2.0"
}, {
  n: ["flag-lu", "luxembourg flag"],
  u: "1f1f1-1f1fa",
  a: "2.0"
}, {
  n: ["flag-lv", "latvia flag"],
  u: "1f1f1-1f1fb",
  a: "2.0"
}, {
  n: ["flag-ly", "libya flag"],
  u: "1f1f1-1f1fe",
  a: "2.0"
}, {
  n: ["flag-ma", "morocco flag"],
  u: "1f1f2-1f1e6",
  a: "2.0"
}, {
  n: ["flag-mc", "monaco flag"],
  u: "1f1f2-1f1e8",
  a: "2.0"
}, {
  n: ["flag-md", "moldova flag"],
  u: "1f1f2-1f1e9",
  a: "2.0"
}, {
  n: ["flag-me", "montenegro flag"],
  u: "1f1f2-1f1ea",
  a: "2.0"
}, {
  n: ["flag-mf", "st. martin flag"],
  u: "1f1f2-1f1eb",
  a: "2.0"
}, {
  n: ["flag-mg", "madagascar flag"],
  u: "1f1f2-1f1ec",
  a: "2.0"
}, {
  n: ["flag-mh", "marshall islands flag"],
  u: "1f1f2-1f1ed",
  a: "2.0"
}, {
  n: ["flag-mk", "north macedonia flag"],
  u: "1f1f2-1f1f0",
  a: "2.0"
}, {
  n: ["flag-ml", "mali flag"],
  u: "1f1f2-1f1f1",
  a: "2.0"
}, {
  n: ["flag-mm", "myanmar (burma) flag"],
  u: "1f1f2-1f1f2",
  a: "2.0"
}, {
  n: ["flag-mn", "mongolia flag"],
  u: "1f1f2-1f1f3",
  a: "2.0"
}, {
  n: ["flag-mo", "macao sar china flag"],
  u: "1f1f2-1f1f4",
  a: "2.0"
}, {
  n: ["flag-mp", "northern mariana islands flag"],
  u: "1f1f2-1f1f5",
  a: "2.0"
}, {
  n: ["flag-mq", "martinique flag"],
  u: "1f1f2-1f1f6",
  a: "2.0"
}, {
  n: ["flag-mr", "mauritania flag"],
  u: "1f1f2-1f1f7",
  a: "2.0"
}, {
  n: ["flag-ms", "montserrat flag"],
  u: "1f1f2-1f1f8",
  a: "2.0"
}, {
  n: ["flag-mt", "malta flag"],
  u: "1f1f2-1f1f9",
  a: "2.0"
}, {
  n: ["flag-mu", "mauritius flag"],
  u: "1f1f2-1f1fa",
  a: "2.0"
}, {
  n: ["flag-mv", "maldives flag"],
  u: "1f1f2-1f1fb",
  a: "2.0"
}, {
  n: ["flag-mw", "malawi flag"],
  u: "1f1f2-1f1fc",
  a: "2.0"
}, {
  n: ["flag-mx", "mexico flag"],
  u: "1f1f2-1f1fd",
  a: "2.0"
}, {
  n: ["flag-my", "malaysia flag"],
  u: "1f1f2-1f1fe",
  a: "2.0"
}, {
  n: ["flag-mz", "mozambique flag"],
  u: "1f1f2-1f1ff",
  a: "2.0"
}, {
  n: ["flag-na", "namibia flag"],
  u: "1f1f3-1f1e6",
  a: "2.0"
}, {
  n: ["flag-nc", "new caledonia flag"],
  u: "1f1f3-1f1e8",
  a: "2.0"
}, {
  n: ["flag-ne", "niger flag"],
  u: "1f1f3-1f1ea",
  a: "2.0"
}, {
  n: ["flag-nf", "norfolk island flag"],
  u: "1f1f3-1f1eb",
  a: "2.0"
}, {
  n: ["flag-ng", "nigeria flag"],
  u: "1f1f3-1f1ec",
  a: "2.0"
}, {
  n: ["flag-ni", "nicaragua flag"],
  u: "1f1f3-1f1ee",
  a: "2.0"
}, {
  n: ["flag-nl", "netherlands flag"],
  u: "1f1f3-1f1f1",
  a: "2.0"
}, {
  n: ["flag-no", "norway flag"],
  u: "1f1f3-1f1f4",
  a: "2.0"
}, {
  n: ["flag-np", "nepal flag"],
  u: "1f1f3-1f1f5",
  a: "2.0"
}, {
  n: ["flag-nr", "nauru flag"],
  u: "1f1f3-1f1f7",
  a: "2.0"
}, {
  n: ["flag-nu", "niue flag"],
  u: "1f1f3-1f1fa",
  a: "2.0"
}, {
  n: ["flag-nz", "new zealand flag"],
  u: "1f1f3-1f1ff",
  a: "2.0"
}, {
  n: ["flag-om", "oman flag"],
  u: "1f1f4-1f1f2",
  a: "2.0"
}, {
  n: ["flag-pa", "panama flag"],
  u: "1f1f5-1f1e6",
  a: "2.0"
}, {
  n: ["flag-pe", "peru flag"],
  u: "1f1f5-1f1ea",
  a: "2.0"
}, {
  n: ["flag-pf", "french polynesia flag"],
  u: "1f1f5-1f1eb",
  a: "2.0"
}, {
  n: ["flag-pg", "papua new guinea flag"],
  u: "1f1f5-1f1ec",
  a: "2.0"
}, {
  n: ["flag-ph", "philippines flag"],
  u: "1f1f5-1f1ed",
  a: "2.0"
}, {
  n: ["flag-pk", "pakistan flag"],
  u: "1f1f5-1f1f0",
  a: "2.0"
}, {
  n: ["flag-pl", "poland flag"],
  u: "1f1f5-1f1f1",
  a: "2.0"
}, {
  n: ["flag-pm", "st. pierre & miquelon flag"],
  u: "1f1f5-1f1f2",
  a: "2.0"
}, {
  n: ["flag-pn", "pitcairn islands flag"],
  u: "1f1f5-1f1f3",
  a: "2.0"
}, {
  n: ["flag-pr", "puerto rico flag"],
  u: "1f1f5-1f1f7",
  a: "2.0"
}, {
  n: ["flag-ps", "palestinian territories flag"],
  u: "1f1f5-1f1f8",
  a: "2.0"
}, {
  n: ["flag-pt", "portugal flag"],
  u: "1f1f5-1f1f9",
  a: "2.0"
}, {
  n: ["flag-pw", "palau flag"],
  u: "1f1f5-1f1fc",
  a: "2.0"
}, {
  n: ["flag-py", "paraguay flag"],
  u: "1f1f5-1f1fe",
  a: "2.0"
}, {
  n: ["flag-qa", "qatar flag"],
  u: "1f1f6-1f1e6",
  a: "2.0"
}, {
  n: ["flag-re", "réunion flag"],
  u: "1f1f7-1f1ea",
  a: "2.0"
}, {
  n: ["flag-ro", "romania flag"],
  u: "1f1f7-1f1f4",
  a: "2.0"
}, {
  n: ["flag-rs", "serbia flag"],
  u: "1f1f7-1f1f8",
  a: "2.0"
}, {
  n: ["ru", "flag-ru", "russia flag"],
  u: "1f1f7-1f1fa",
  a: "0.6"
}, {
  n: ["flag-rw", "rwanda flag"],
  u: "1f1f7-1f1fc",
  a: "2.0"
}, {
  n: ["flag-sa", "saudi arabia flag"],
  u: "1f1f8-1f1e6",
  a: "2.0"
}, {
  n: ["flag-sb", "solomon islands flag"],
  u: "1f1f8-1f1e7",
  a: "2.0"
}, {
  n: ["flag-sc", "seychelles flag"],
  u: "1f1f8-1f1e8",
  a: "2.0"
}, {
  n: ["flag-sd", "sudan flag"],
  u: "1f1f8-1f1e9",
  a: "2.0"
}, {
  n: ["flag-se", "sweden flag"],
  u: "1f1f8-1f1ea",
  a: "2.0"
}, {
  n: ["flag-sg", "singapore flag"],
  u: "1f1f8-1f1ec",
  a: "2.0"
}, {
  n: ["flag-sh", "st. helena flag"],
  u: "1f1f8-1f1ed",
  a: "2.0"
}, {
  n: ["flag-si", "slovenia flag"],
  u: "1f1f8-1f1ee",
  a: "2.0"
}, {
  n: ["flag-sj", "svalbard & jan mayen flag"],
  u: "1f1f8-1f1ef",
  a: "2.0"
}, {
  n: ["flag-sk", "slovakia flag"],
  u: "1f1f8-1f1f0",
  a: "2.0"
}, {
  n: ["flag-sl", "sierra leone flag"],
  u: "1f1f8-1f1f1",
  a: "2.0"
}, {
  n: ["flag-sm", "san marino flag"],
  u: "1f1f8-1f1f2",
  a: "2.0"
}, {
  n: ["flag-sn", "senegal flag"],
  u: "1f1f8-1f1f3",
  a: "2.0"
}, {
  n: ["flag-so", "somalia flag"],
  u: "1f1f8-1f1f4",
  a: "2.0"
}, {
  n: ["flag-sr", "suriname flag"],
  u: "1f1f8-1f1f7",
  a: "2.0"
}, {
  n: ["flag-ss", "south sudan flag"],
  u: "1f1f8-1f1f8",
  a: "2.0"
}, {
  n: ["flag-st", "são tomé & príncipe flag"],
  u: "1f1f8-1f1f9",
  a: "2.0"
}, {
  n: ["flag-sv", "el salvador flag"],
  u: "1f1f8-1f1fb",
  a: "2.0"
}, {
  n: ["flag-sx", "sint maarten flag"],
  u: "1f1f8-1f1fd",
  a: "2.0"
}, {
  n: ["flag-sy", "syria flag"],
  u: "1f1f8-1f1fe",
  a: "2.0"
}, {
  n: ["flag-sz", "eswatini flag"],
  u: "1f1f8-1f1ff",
  a: "2.0"
}, {
  n: ["flag-ta", "tristan da cunha flag"],
  u: "1f1f9-1f1e6",
  a: "2.0"
}, {
  n: ["flag-tc", "turks & caicos islands flag"],
  u: "1f1f9-1f1e8",
  a: "2.0"
}, {
  n: ["flag-td", "chad flag"],
  u: "1f1f9-1f1e9",
  a: "2.0"
}, {
  n: ["flag-tf", "french southern territories flag"],
  u: "1f1f9-1f1eb",
  a: "2.0"
}, {
  n: ["flag-tg", "togo flag"],
  u: "1f1f9-1f1ec",
  a: "2.0"
}, {
  n: ["flag-th", "thailand flag"],
  u: "1f1f9-1f1ed",
  a: "2.0"
}, {
  n: ["flag-tj", "tajikistan flag"],
  u: "1f1f9-1f1ef",
  a: "2.0"
}, {
  n: ["flag-tk", "tokelau flag"],
  u: "1f1f9-1f1f0",
  a: "2.0"
}, {
  n: ["flag-tl", "timor-leste flag"],
  u: "1f1f9-1f1f1",
  a: "2.0"
}, {
  n: ["flag-tm", "turkmenistan flag"],
  u: "1f1f9-1f1f2",
  a: "2.0"
}, {
  n: ["flag-tn", "tunisia flag"],
  u: "1f1f9-1f1f3",
  a: "2.0"
}, {
  n: ["flag-to", "tonga flag"],
  u: "1f1f9-1f1f4",
  a: "2.0"
}, {
  n: ["flag-tr", "turkey flag"],
  u: "1f1f9-1f1f7",
  a: "2.0"
}, {
  n: ["flag-tt", "trinidad & tobago flag"],
  u: "1f1f9-1f1f9",
  a: "2.0"
}, {
  n: ["flag-tv", "tuvalu flag"],
  u: "1f1f9-1f1fb",
  a: "2.0"
}, {
  n: ["flag-tw", "taiwan flag"],
  u: "1f1f9-1f1fc",
  a: "2.0"
}, {
  n: ["flag-tz", "tanzania flag"],
  u: "1f1f9-1f1ff",
  a: "2.0"
}, {
  n: ["flag-ua", "ukraine flag"],
  u: "1f1fa-1f1e6",
  a: "2.0"
}, {
  n: ["flag-ug", "uganda flag"],
  u: "1f1fa-1f1ec",
  a: "2.0"
}, {
  n: ["flag-um", "u.s. outlying islands flag"],
  u: "1f1fa-1f1f2",
  a: "2.0"
}, {
  n: ["flag-un", "united nations flag"],
  u: "1f1fa-1f1f3",
  a: "4.0"
}, {
  n: ["us", "flag-us", "united states flag"],
  u: "1f1fa-1f1f8",
  a: "0.6"
}, {
  n: ["flag-uy", "uruguay flag"],
  u: "1f1fa-1f1fe",
  a: "2.0"
}, {
  n: ["flag-uz", "uzbekistan flag"],
  u: "1f1fa-1f1ff",
  a: "2.0"
}, {
  n: ["flag-va", "vatican city flag"],
  u: "1f1fb-1f1e6",
  a: "2.0"
}, {
  n: ["flag-vc", "st. vincent & grenadines flag"],
  u: "1f1fb-1f1e8",
  a: "2.0"
}, {
  n: ["flag-ve", "venezuela flag"],
  u: "1f1fb-1f1ea",
  a: "2.0"
}, {
  n: ["flag-vg", "british virgin islands flag"],
  u: "1f1fb-1f1ec",
  a: "2.0"
}, {
  n: ["flag-vi", "u.s. virgin islands flag"],
  u: "1f1fb-1f1ee",
  a: "2.0"
}, {
  n: ["flag-vn", "vietnam flag"],
  u: "1f1fb-1f1f3",
  a: "2.0"
}, {
  n: ["flag-vu", "vanuatu flag"],
  u: "1f1fb-1f1fa",
  a: "2.0"
}, {
  n: ["flag-wf", "wallis & futuna flag"],
  u: "1f1fc-1f1eb",
  a: "2.0"
}, {
  n: ["flag-ws", "samoa flag"],
  u: "1f1fc-1f1f8",
  a: "2.0"
}, {
  n: ["flag-xk", "kosovo flag"],
  u: "1f1fd-1f1f0",
  a: "2.0"
}, {
  n: ["flag-ye", "yemen flag"],
  u: "1f1fe-1f1ea",
  a: "2.0"
}, {
  n: ["flag-yt", "mayotte flag"],
  u: "1f1fe-1f1f9",
  a: "2.0"
}, {
  n: ["flag-za", "south africa flag"],
  u: "1f1ff-1f1e6",
  a: "2.0"
}, {
  n: ["flag-zm", "zambia flag"],
  u: "1f1ff-1f1f2",
  a: "2.0"
}, {
  n: ["flag-zw", "zimbabwe flag"],
  u: "1f1ff-1f1fc",
  a: "2.0"
}, {
  n: ["england flag", "flag-england"],
  u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
  a: "5.0"
}, {
  n: ["scotland flag", "flag-scotland"],
  u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
  a: "5.0"
}, {
  n: ["wales flag", "flag-wales"],
  u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
  a: "5.0"
}];
var emojis$1 = {
  smileys_people: smileys_people,
  animals_nature: animals_nature,
  food_drink: food_drink,
  travel_places: travel_places,
  activities: activities,
  objects: objects,
  symbols: symbols,
  flags: flags
};
var skinToneVariations = [SkinTones.NEUTRAL, SkinTones.LIGHT, SkinTones.MEDIUM_LIGHT, SkinTones.MEDIUM, SkinTones.MEDIUM_DARK, SkinTones.DARK];
var skinTonesMapped = /*#__PURE__*/skinToneVariations.reduce(function (mapped, skinTone) {
  var _Object$assign;
  return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var EmojiProperties;
(function (EmojiProperties) {
  EmojiProperties["name"] = "n";
  EmojiProperties["unified"] = "u";
  EmojiProperties["variations"] = "v";
  EmojiProperties["added_in"] = "a";
})(EmojiProperties || (EmojiProperties = {}));
function emojiNames(emoji) {
  var _emoji$EmojiPropertie;
  return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function emojiName(emoji) {
  if (!emoji) {
    return '';
  }
  return emojiNames(emoji)[0];
}
function unifiedWithoutSkinTone(unified) {
  var splat = unified.split('-');
  var _splat$splice = splat.splice(1, 1),
    skinTone = _splat$splice[0];
  if (skinTonesMapped[skinTone]) {
    return splat.join('-');
  }
  return unified;
}
function emojiUnified(emoji, skinTone) {
  var _emojiVariationUnifie;
  var unified = emoji[EmojiProperties.unified];
  if (!skinTone || !emojiHasVariations(emoji)) {
    return unified;
  }
  return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}

function emojiUrlByUnified(unified, emojiStyle) {
  return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
  var _emoji$EmojiPropertie2;
  return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
  return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
  return skinTone ? emojiVariations(emoji).find(function (variation) {
    return variation.includes(skinTone);
  }) : emojiUnified(emoji);
}
function emojiByUnified(unified) {
  if (!unified) {
    return;
  }
  if (allEmojisByUnified[unified]) {
    return allEmojisByUnified[unified];
  }
  var withoutSkinTone = unifiedWithoutSkinTone(unified);
  return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/Object.values(emojis$1).flat();
var allEmojisByUnified = {};
setTimeout(function () {
  allEmojis.reduce(function (allEmojis, Emoji) {
    allEmojis[emojiUnified(Emoji)] = Emoji;
    return allEmojis;
  }, allEmojisByUnified);
});
var _configByCategory;
[Categories.SUGGESTED, Categories.SMILEYS_PEOPLE, Categories.ANIMALS_NATURE, Categories.FOOD_DRINK, Categories.TRAVEL_PLACES, Categories.ACTIVITIES, Categories.OBJECTS, Categories.SYMBOLS, Categories.FLAGS];
({
  name: 'Recently Used',
  category: Categories.SUGGESTED
});
(_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
  category: Categories.SUGGESTED,
  name: 'Frequently Used'
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
  category: Categories.SMILEYS_PEOPLE,
  name: 'Smileys & People'
}, _configByCategory[Categories.ANIMALS_NATURE] = {
  category: Categories.ANIMALS_NATURE,
  name: 'Animals & Nature'
}, _configByCategory[Categories.FOOD_DRINK] = {
  category: Categories.FOOD_DRINK,
  name: 'Food & Drink'
}, _configByCategory[Categories.TRAVEL_PLACES] = {
  category: Categories.TRAVEL_PLACES,
  name: 'Travel & Places'
}, _configByCategory[Categories.ACTIVITIES] = {
  category: Categories.ACTIVITIES,
  name: 'Activities'
}, _configByCategory[Categories.OBJECTS] = {
  category: Categories.OBJECTS,
  name: 'Objects'
}, _configByCategory[Categories.SYMBOLS] = {
  category: Categories.SYMBOLS,
  name: 'Symbols'
}, _configByCategory[Categories.FLAGS] = {
  category: Categories.FLAGS,
  name: 'Flags'
}, _configByCategory);
var alphaNumericEmojiIndex = {};
setTimeout(function () {
  allEmojis.reduce(function (searchIndex, emoji) {
    var joinedNameString = emojiNames(emoji).flat().join('').replace(/[^a-zA-Z\d]/g, '').split('');
    joinedNameString.forEach(function (_char) {
      var _searchIndex$_char;
      searchIndex[_char] = (_searchIndex$_char = searchIndex[_char]) != null ? _searchIndex$_char : {};
      searchIndex[_char][emojiUnified(emoji)] = emoji;
    });
    return searchIndex;
  }, alphaNumericEmojiIndex);
});
var PickerContext = /*#__PURE__*/createContext({
  activeCategoryState: [null, function () {}],
  activeSkinTone: [SkinTones.NEUTRAL, function () {}],
  disallowClickRef: {
    current: false
  },
  disallowMouseRef: {
    current: false
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function () {}],
  emojisThatFailedToLoadState: [/*#__PURE__*/new Set(), function () {}],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: true,
  searchTerm: ['', function () {
    return new Promise(function () {
      return undefined;
    });
  }],
  skinToneFanOpenState: [false, function () {}],
  suggestedUpdateState: [/*#__PURE__*/Date.now(), function () {}]
});
function useEmojisThatFailedToLoadState() {
  var _React$useContext6 = useContext(PickerContext),
    emojisThatFailedToLoadState = _React$useContext6.emojisThatFailedToLoadState;
  return emojisThatFailedToLoadState;
}
"button" + /*#__PURE__*/asSelectors(ClassNames.emoji);
function parseNativeEmoji(unified) {
  return unified.split('-').map(function (hex) {
    return String.fromCodePoint(parseInt(hex, 16));
  }).join('');
}
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".EmojiPickerReact button.epr-emoji{align-items:center;border-radius:8px;box-sizing:border-box;display:flex;height:var(--epr-emoji-fullsize);justify-content:center;max-height:var(--epr-emoji-fullsize);max-width:var(--epr-emoji-fullsize);overflow:hidden;position:relative;width:var(--epr-emoji-fullsize)}.EmojiPickerReact button.epr-emoji.epr-emoji-has-variations:after{border-bottom:4px solid var(--epr-emoji-variation-indicator-color);border-left:4px solid transparent;border-right:4px solid transparent;bottom:1px;content:\"\";display:block;height:0;position:absolute;right:0;transform:rotate(135deg);width:0;z-index:var(--epr-emoji-variations-indictator-z-index)}.EmojiPickerReact button.epr-emoji .epr-emoji-img{max-height:var(--epr-emoji-fullsize);max-width:var(--epr-emoji-fullsize);padding:var(--epr-emoji-padding)}.EmojiPickerReact button.epr-emoji .epr-emoji-native{padding:var(--epr-emoji-padding)}.EmojiPickerReact button.epr-emoji>*{align-self:center;display:block;justify-self:center}.EmojiPickerReact button.epr-emoji.epr-emoji-has-variations:hover:after{border-bottom:4px solid var(--epr-emoji-variation-indicator-color-hover)}.__EmojiPicker__.epr-emoji-img{font-size:0}.__EmojiPicker__.epr-emoji-native{align-self:center;font-family:Segoe UI Emoji,Segoe UI Symbol,Segoe UI,Apple Color Emoji,Twemoji Mozilla,Noto Color Emoji,Android Emoji,Times,Symbola,Aegyptus,Code2000,Code2001,Code2002,Musica,serif,LastResort;font-size:var(--epr-emoji-size);justify-self:center;letter-spacing:0;line-height:100%;position:relative;text-align:center}.EmojiPickerReact button.epr-emoji:hover>*{background-color:var(--epr-emoji-hover-color)}.EmojiPickerReact button.epr-emoji:focus>*{background-color:var(--epr-focus-bg-color)}";
styleInject(css_248z);
function ViewOnlyEmoji(_ref2) {
  var emoji = _ref2.emoji,
    unified = _ref2.unified,
    emojiStyle = _ref2.emojiStyle,
    size = _ref2.size,
    lazyLoad = _ref2.lazyLoad,
    _ref2$getEmojiUrl = _ref2.getEmojiUrl,
    getEmojiUrl = _ref2$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref2$getEmojiUrl;
  var style = {};
  if (size) {
    style.width = style.height = style.fontSize = size + "px";
  }
  var emojiToRender = emoji ? emoji : emojiByUnified(unified);
  if (!emojiToRender) {
    return null;
  }
  return createElement(Fragment$1, null, emojiStyle === EmojiStyle.NATIVE ? createElement(NativeEmoji, {
    unified: unified,
    style: style
  }) : createElement(EmojiImg, {
    unified: unified,
    style: style,
    emoji: emojiToRender,
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    getEmojiUrl: getEmojiUrl
  }));
}
function NativeEmoji(_ref3) {
  var unified = _ref3.unified,
    style = _ref3.style;
  return createElement("span", {
    className: clsx(ClassNames.external, 'epr-emoji-native'),
    "data-unified": unified,
    style: style
  }, parseNativeEmoji(unified));
}
function EmojiImg(_ref4) {
  var emoji = _ref4.emoji,
    unified = _ref4.unified,
    emojiStyle = _ref4.emojiStyle,
    style = _ref4.style,
    _ref4$lazyLoad = _ref4.lazyLoad,
    lazyLoad = _ref4$lazyLoad === void 0 ? false : _ref4$lazyLoad,
    getEmojiUrl = _ref4.getEmojiUrl;
  var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(),
    setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
  return createElement("img", {
    src: getEmojiUrl(unified, emojiStyle),
    alt: emojiName(emoji),
    className: clsx(ClassNames.external, 'epr-emoji-img'),
    loading: lazyLoad ? 'lazy' : 'eager',
    onError: onError,
    style: style
  });
  function onError() {
    setEmojisThatFailedToLoad(function (prev) {
      return new Set(prev).add(unified);
    });
  }
}
var css_248z$1 = ".EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-content{grid-gap:0;display:grid;grid-template-columns:repeat(auto-fill,var(--epr-emoji-fullsize));justify-content:space-between;margin:var(--epr-category-padding);position:relative}.EmojiPickerReact li.epr-emoji-category:not(:has(.epr-visible)){display:none}.EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-label{align-items:center;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);background-color:var(--epr-category-label-bg-color);color:var(--epr-category-label-text-color);display:flex;font-weight:700;height:var(--epr-category-label-height);padding:var(--epr-category-label-padding);position:-webkit-sticky;position:sticky;text-transform:capitalize;top:0;width:100%;z-index:var(--epr-category-label-z-index)}";
styleInject(css_248z$1);
var css_248z$2 = ".EmojiPickerReact ul.epr-emoji-list{list-style:none;margin:0;padding:0}";
styleInject(css_248z$2);
var css_248z$3 = ".EmojiPickerReact .epr-emoji-variation-picker{align-items:center;background:var(--epr-emoji-variation-picker-bg-color);border:1px solid var(--epr-picker-border-color);border-radius:3px;box-shadow:0 2px 5px rgba(0,0,0,.2);display:flex;height:0;height:var(--epr-emoji-variation-picker-height);justify-content:space-around;left:15px;opacity:0;padding:5px;pointer-events:none;position:absolute;right:15px;top:0;top:-100%;transform:scale(.9);transition:transform .1s ease-out,opacity .2s ease-out;visibility:hidden;z-index:var(--epr-skin-variation-picker-z-index)}.EmojiPickerReact .epr-emoji-variation-picker.pointing-up{transform:scale(.9);transform-origin:center 0}.EmojiPickerReact .epr-emoji-variation-picker.visible{opacity:1;pointer-events:all;transform:scale(1);visibility:visible}.EmojiPickerReact .epr-emoji-variation-picker .EmojiPickerReact .epr-emoji-variation-picker button.epr-emoji:hover{background:none}.EmojiPickerReact .epr-emoji-variation-picker .epr-emoji-pointer{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='15' xml:space='preserve'%3E%3Cg stroke-miterlimit='10'%3E%3Cpath fill='%23FFF' stroke='%23E8E7E7' d='m1.86-.43 9.83 11.53c.59.69 1.56.69 2.14 0L23.66-.43'/%3E%3Cpath fill='%23010202' stroke='%23151617' d='m26.86-.43 9.83 11.53c.59.69 1.56.69 2.14 0L48.66-.43'/%3E%3C/g%3E%3C/svg%3E\");background-position:0 0;background-repeat:no-repeat;background-size:50px 15px;content:\"\";height:15px;position:absolute;top:-10px;width:25px}.EmojiPickerReact.epr-dark-theme .epr-emoji-variation-picker .epr-emoji-pointer{background-position:-25px 0}.EmojiPickerReact .epr-emoji-variation-picker .epr-emoji-pointer{top:100%;transform:translateX(-18px)}.EmojiPickerReact .epr-emoji-variation-picker.pointing-up .epr-emoji-pointer{top:0;transform:rotate(180deg) translateY(100%) translateX(18px)}";
styleInject(css_248z$3);
var Direction;
(function (Direction) {
  Direction[Direction["Up"] = 0] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
var css_248z$4 = ".EmojiPickerReact .epr-body{flex:1;overflow-x:hidden;overflow-y:scroll;position:relative}";
styleInject(css_248z$4);
var css_248z$5 = ".EmojiPickerReact .Flex{display:flex}.EmojiPickerReact .Flex.FlexRow{flex-direction:row}.EmojiPickerReact .Flex.FlexColumn{flex-direction:column}";
styleInject(css_248z$5);
var FlexDirection;
(function (FlexDirection) {
  FlexDirection["ROW"] = "FlexRow";
  FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
var css_248z$6 = ".EmojiPickerReact .epr-preview{align-items:center;border-top:1px solid var(--epr-preview-border-color);height:var(--epr-preview-height);padding:0 var(--epr-horizontal-padding);position:relative;z-index:1;z-index:var(--epr-preview-z-index)}.EmojiPickerReact .epr-preview .epr-preview-emoji-label{color:var(--epr-preview-text-color);font-size:var(--epr-preview-text-size);padding:var(--epr-preview-text-padding);text-transform:capitalize}";
styleInject(css_248z$6);
var css_248z$7 = ".EmojiPickerReact .epr-skin-tones{--epr-skin-tone-size:15px;align-items:center;display:flex;justify-content:flex-end;padding:10px 0;transition:all .3s ease-in-out}.EmojiPickerReact .epr-skin-tones.epr-vertical{align-items:flex-end;border:1px solid var(--epr-bg-color);border-radius:6px;flex-direction:column;padding:5px}.EmojiPickerReact .epr-skin-tones.epr-vertical.epr-open{-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background:var(--epr-skin-tone-picker-menu-color);border:1px solid var(--epr-picker-border-color)}.EmojiPickerReact .epr-skin-tone-select{height:var(--epr-skin-tone-size);position:relative;width:var(--epr-skin-tone-size)}.EmojiPickerReact .epr-skin-tones.epr-open .epr-tone{transition:transform .3s ease-in-out,opacity .3s ease-in-out}.EmojiPickerReact .epr-skin-tones:not(.epr-open) .epr-tone{opacity:0;z-index:0}.EmojiPickerReact .epr-skin-tones .epr-tone{border-radius:4px;box-shadow:0 0 0 0 var(--epr-active-skin-hover-color);cursor:pointer;display:block;height:var(--epr-skin-tone-size);position:absolute;right:0;transition:transform .3s ease-in-out,opacity .5s ease-in-out;width:var(--epr-skin-tone-size);z-index:1}.EmojiPickerReact .epr-skin-tones .epr-tone:hover{box-shadow:0 0 0 3px var(--epr-active-skin-hover-color)}.EmojiPickerReact .epr-skin-tones .epr-tone:focus{box-shadow:0 0 0 3px var(--epr-focus-bg-color)}.EmojiPickerReact .epr-skin-tones.epr-open .epr-skin-tone-select .epr-tone.epr-active:after{border:1px solid var(--epr-active-skin-tone-indicator-border-color);border-radius:5px;bottom:-2px;content:\"\";left:-2px;position:absolute;right:-2px;top:-2px}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-active{opacity:1;z-index:1}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-neutral{background-color:#ffd225}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fb{background-color:#ffdfbd}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fc{background-color:#e9c197}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fd{background-color:#c88e62}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fe{background-color:#a86637}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3ff{background-color:#60463a}";
styleInject(css_248z$7);
var SkinTonePickerDirection;
(function (SkinTonePickerDirection) {
  SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
  SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var css_248z$8 = ".EmojiPickerReact .epr-category-nav{display:flex;flex-direction:row;justify-content:space-around;padding:var(--epr-header-padding)}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn{background-size:calc(var(--epr-category-navigation-button-size)*10);display:inline-block;height:var(--epr-category-navigation-button-size);outline:none;position:relative;transition:opacity .2s ease-in-out;width:var(--epr-category-navigation-button-size)}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn:focus:before{border:2px solid var(--epr-category-icon-active-color);border-radius:50%;bottom:-2px;content:\"\";left:-2px;position:absolute;right:-2px;top:-2px}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}.EmojiPickerReact.epr-search-active .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}.EmojiPickerReact:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn.epr-active,.EmojiPickerReact:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='80' xml:space='preserve'%3E%3Cg fill='%233371B7' stroke='%233371B7' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 29.5c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 23c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3Cpath d='M14.6 31.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 34.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm-2.8-4.6c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%233371B7' d='M64.1 33.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4v2c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%233371B7' d='M65.5 23.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Cellipse fill='%233371B7' cx='66.2' cy='30.9' rx='.9' ry='1'/%3E%3Cellipse fill='%233371B7' cx='73.8' cy='30.9' rx='.9' ry='1'/%3E%3Cg fill='none' stroke='%233371B7'%3E%3Cpath d='M96.4 30c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 28.6v.1c-.9.1-2.9.1-4.6-1.1-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1-.1-.1-.1-.1-.1-.2.5-.1 1.2-.2 2-.1 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.2.3.6.4.9zM84 32.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%233371B7'%3E%3Cpath stroke-linecap='round' d='m116.3 26.8-1.4 2-.8-.8-.6-.6v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.6-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 27.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 34.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%233371B7'/%3E%3Cg fill='%233371B7'%3E%3Cpath d='M170.8 23.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.5 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 27.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6 0-.4-.3-.6-.6-.6h-1.8v-2.6z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%233371B7' d='M186.2 23.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.5 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%233371B7' cx='186' cy='28.9' r='.7'/%3E%3Ccircle fill='%233371B7' cx='194' cy='26.7' r='.7'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m186 33.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%233371B7' stroke='%233371B7' stroke-width='.25' stroke-miterlimit='10' d='M156 24.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%233371B7' d='M48.1 23.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 28.8c-.2.1-.5 1.2 0 1.5 1.4 1 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m43.5 30.6-.2.4c-.2.5.2 1 .7.9.3-.1.5 0 .7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2 0l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 32.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.5.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 33.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%233371B7' cx='51.6' cy='26.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='53' cy='25' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='53' cy='27.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='54.3' cy='26.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='50.9' cy='25' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%233371B7' d='M24.2 31v-7.6c.1.1.8.9 2.8 3.1 2.5-1.6 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m21.2 30 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 30l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%233371B7' d='m29.5 32.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m32.4 32.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%233371B7' cx='27.6' cy='29.7' r='.7'/%3E%3Ccircle fill='%233371B7' cx='32.4' cy='29.7' r='.7'/%3E%3Cg fill='%23C0C0BF' stroke='%23C0C0BF' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 49.5c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4zm1.8 3.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 54.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm-2.8-4.6c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 43c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M64.1 53.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4v2c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M65.5 43.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Cellipse fill='%23C0C0BF' cx='66.2' cy='50.9' rx='.9' ry='1'/%3E%3Cellipse fill='%23C0C0BF' cx='73.8' cy='50.9' rx='.9' ry='1'/%3E%3Cg fill='none' stroke='%23C0C0BF'%3E%3Cpath d='M96.4 50c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 48.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.4.3.8.4 1.1zM84 52.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23C0C0BF'%3E%3Cpath stroke-linecap='round' d='m116.3 46.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 47.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 54.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%23C0C0BF'/%3E%3Cg fill='%23C0C0BF'%3E%3Cpath d='M170.8 43.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.5 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 47.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.6-.6h-1.8v-2.6z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M186.2 43.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.4 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%23C0C0BF' cx='186' cy='48.9' r='.7'/%3E%3Ccircle fill='%23C0C0BF' cx='194' cy='46.7' r='.7'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m186 53.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%23C0C0BF' stroke='%23C0C0BF' stroke-width='.25' stroke-miterlimit='10' d='M156 44.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M48.1 43.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 48.8c-.2.1-.5 1.2 0 1.5 1.4 1 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m43.5 50.6-.2.4c-.2.5.2 1 .7.9.3-.1.5 0 .7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2 0l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 52.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.5.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 53.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%23C0C0BF' cx='51.6' cy='46.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='53' cy='45' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='53' cy='47.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='54.3' cy='46.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='50.9' cy='45' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M24.2 51v-7.6c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m21.2 50 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 50l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23C0C0BF' d='m29.5 52.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m32.4 52.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%23C0C0BF' cx='27.6' cy='49.7' r='.7'/%3E%3Ccircle fill='%23C0C0BF' cx='32.4' cy='49.7' r='.7'/%3E%3Cg fill='%236AA9DD' stroke='%236AA9DD' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M14.6 71.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 74.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm2.8-4.6c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4zm-5.6 1.5c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 63c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%236AA9DD' d='M64.1 73.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4V76c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2.1c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M65.5 63.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Ccircle fill='%236AA9DD' cx='66.2' cy='70.9' r='.9'/%3E%3Ccircle fill='%236AA9DD' cx='73.8' cy='70.9' r='.9'/%3E%3Cg fill='none' stroke='%236AA9DD'%3E%3Cpath d='M96.4 70c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 68.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1.1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.5.3.9.4 1.2zM84 72.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.9-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%236AA9DD'%3E%3Cpath stroke-linecap='round' d='m116.3 66.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 67.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 74.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%236AA9DD'/%3E%3Cg fill='%236AA9DD'%3E%3Cpath d='M170.8 63.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.4 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 67.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.7-.6h-1.8v-.2l.1-2.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%236AA9DD' d='M186.2 63.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.4 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%236AA9DD' cx='186' cy='68.9' r='.7'/%3E%3Ccircle fill='%236AA9DD' cx='194' cy='66.7' r='.7'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m186 73.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%236AA9DD' stroke='%236AA9DD' stroke-width='.25' stroke-miterlimit='10' d='M156 64.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M48.1 63.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 68.8c-.2.1-.5 1.2 0 1.5 1.4.9 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m43.5 70.6-.2.4c-.2.5.2 1 .7.9.3-.1.5.1.7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2-.1l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 72.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.4.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 73.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%236AA9DD' cx='51.6' cy='66.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='53' cy='65' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='53' cy='67.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='54.3' cy='66.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='50.9' cy='65' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M24.2 71v-7.6c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m21.2 70.1 5.4 1.2m-5.4 2.8 5.4-1.2m12.2-2.8-5.4 1.2m5.4 2.8-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%236AA9DD' d='m29.5 72.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m32.4 72.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%236AA9DD' cx='27.6' cy='69.7' r='.7'/%3E%3Ccircle fill='%236AA9DD' cx='32.4' cy='69.7' r='.7'/%3E%3Cg fill='%23868686' stroke='%23868686' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 9.5c.6 0 1.1-.5 1.1-1.2 0-.6-.5-1.1-1.1-1.1-.6 0-1.2.5-1.2 1.1s.6 1.2 1.2 1.2zm0-1.6c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zM7.2 9.5c.6 0 1.2-.5 1.2-1.2 0-.6-.5-1.1-1.2-1.1-.6 0-1.1.5-1.1 1.1s.5 1.2 1.1 1.2zm0-1.6c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zm7.4 3.3c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.2.1-.3 0-.4zM10 14.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2z'/%3E%3Cpath d='M10 3c-3.8 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2S6.6 3.8 10 3.8s6.2 2.8 6.2 6.2-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23868686' d='M64.1 13.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4 0h2.4c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2.1c0-.2.2-.4.4-.4zm-9.8-5h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%23868686' d='M65.5 3.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7V5.5c0-1.1.8-1.9 1.8-1.9z'/%3E%3Ccircle fill='%23868686' cx='66.2' cy='10.9' r='.9'/%3E%3Ccircle fill='%23868686' cx='73.8' cy='10.9' r='.9'/%3E%3Cg fill='none' stroke='%23868686'%3E%3Cpath d='M96.4 10c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 8.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1.1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.5.3.9.4 1.2zM84 12.1V12c.9-.2 2.9-.4 4.7.6 1.1.6 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8-1.1-.6-1.9-1.6-2.4-2.5-.3-.4-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23868686'%3E%3Cpath stroke-linecap='round' d='m116.3 6.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 7.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 14.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9M126.8 3.5h10.8v2.7h-10.8V3.5z' fill='none' stroke='%23868686'/%3E%3Cg fill='%23868686'%3E%3Cpath d='M170.8 3.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.4 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.3c-.2 3.8 2.6 7.1 6.3 7.4 3.9.4 7.3-2.6 7.6-6.5.3-3.6-2.5-6.9-6.1-7.3z'/%3E%3Cpath d='M170.3 7.4c0-.3-.3-.6-.6-.6s-.7.3-.7.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.6-.6h-1.8v-.2l.1-2.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23868686' d='M186.2 3.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7V6.1c-.1-1.5 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%23868686' cx='186' cy='8.9' r='.7'/%3E%3Ccircle fill='%23868686' cx='194' cy='6.7' r='.7'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m186 13.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%23868686' stroke='%23868686' stroke-width='.25' stroke-miterlimit='10' d='M156 4.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.1s-2.4-.1-3.8-.6c-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4V4.7c-.3-.2-.4-.3-.5-.4zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1V4.7c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%23868686' d='M48.1 3.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 8.7c-.2.1-.5 1.2 0 1.5 1.4.9 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m43.5 10.6-.2.4c-.2.5.2 1 .7.9.3-.1.5.1.7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.1.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.1 1.2-.1l.2-.1c.3-.2.8-.1 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.4.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 12.1c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.4.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 13.3c0 .5.6 2.4 1.3 2.6 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%23868686' cx='51.6' cy='6.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='53' cy='4.9' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='53' cy='7.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='54.3' cy='6.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='50.9' cy='4.9' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%23868686' d='M24.2 11V3.5c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.7-.6-1.7-.6-2.6z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m21.2 10 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 10l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23868686' d='m29.5 12.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.6 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m32.4 12.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%23868686' cx='27.6' cy='9.7' r='.7'/%3E%3Ccircle fill='%23868686' cx='32.4' cy='9.7' r='.7'/%3E%3C/svg%3E\");background-position:0 0}.EmojiPickerReact.epr-dark-theme .epr-category-nav>button.epr-cat-btn{background-position-y:calc(var(--epr-category-navigation-button-size)*2)}aside.EmojiPickerReact.epr-main:has(input:-moz-placeholder-shown) .epr-category-nav{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}aside.EmojiPickerReact.epr-main:has(input:placeholder-shown) .epr-category-nav{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}.EmojiPickerReact.epr-dark-theme:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn.epr-active,.EmojiPickerReact.epr-dark-theme:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}.EmojiPickerReact button.epr-cat-btn.epr-icn-suggested{background-position-x:calc(var(--epr-category-navigation-button-size)*-8)}.EmojiPickerReact button.epr-cat-btn.epr-icn-activities{background-position-x:calc(var(--epr-category-navigation-button-size)*-4)}.EmojiPickerReact button.epr-cat-btn.epr-icn-animals_nature{background-position-x:calc(var(--epr-category-navigation-button-size)*-1)}.EmojiPickerReact button.epr-cat-btn.epr-icn-flags{background-position-x:calc(var(--epr-category-navigation-button-size)*-7)}.EmojiPickerReact button.epr-cat-btn.epr-icn-food_drink{background-position-x:calc(var(--epr-category-navigation-button-size)*-2)}.EmojiPickerReact button.epr-cat-btn.epr-icn-objects{background-position-x:calc(var(--epr-category-navigation-button-size)*-5)}.EmojiPickerReact button.epr-cat-btn.epr-icn-smileys_people{background-position-x:0}.EmojiPickerReact button.epr-cat-btn.epr-icn-symbols{background-position-x:calc(var(--epr-category-navigation-button-size)*-6)}.EmojiPickerReact button.epr-cat-btn.epr-icn-travel_places{background-position-x:calc(var(--epr-category-navigation-button-size)*-3)}";
styleInject(css_248z$8);
var css_248z$9 = ".EmojiPickerReact .epr-header .epr-header-overlay{padding:var(--epr-header-padding);z-index:var(--epr-header-overlay-z-index)}";
styleInject(css_248z$9);
var css_248z$a = ".EmojiPickerReact .epr-search-container{display:block;flex:1;min-width:0}.EmojiPickerReact .epr-search-container input.epr-search{background-color:var(--epr-search-input-bg-color);border:1px solid var(--epr-search-input-bg-color);border-radius:var(--epr-search-input-border-radius);color:var(--epr-search-input-text-color);height:var(--epr-search-input-height);outline:none;padding:var(--epr-search-input-padding);transition:all .2s ease-in-out;width:100%}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search .epr-icn-clear-search{background-color:transparent;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' xml:space='preserve'%3E%3Cpath fill='%23868686' d='M6.98 13.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 8c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.4a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.2-.21.54 0 .74z'/%3E%3Cpath fill='%23868686' d='M10.15 18.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%233371B7' d='M6.98 33.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 28c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%233371B7' d='M10.15 38.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%23C0C0BF' d='M6.98 53.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 48c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%23C0C0BF' d='M10.15 58.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%236AA9DD' d='M6.98 73.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 68c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%236AA9DD' d='M10.15 78.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:20px;height:20px;width:20px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search{align-items:center;border-radius:50%;display:flex;height:30px;justify-content:center;padding:0;position:absolute;right:var(--epr-search-bar-inner-padding);top:50%;transform:translateY(-50%);width:30px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:focus .epr-icn-clear-search,.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:hover .epr-icn-clear-search{background-position-y:-20px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:focus,.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:hover{background:var(--epr-hover-bg-color)}.EmojiPickerReact..epr-dark-theme .epr-search-container button.epr-btn-clear-search .epr-icn-clear-search{background-position-y:-40px}.EmojiPickerReact..epr-dark-theme .epr-search-container button.epr-btn-clear-search:hover .epr-icn-clear-search{background-position-y:-60px}.EmojiPickerReact .epr-search-container .epr-icn-search{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='40' xml:space='preserve'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23868686' d='M12 8.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 6.73 12 8.81zm-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92 0-2.72 2.2-4.92 4.92-4.92 2.72 0 4.92 2.2 4.92 4.92 0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0l-3.94-3.93z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23C0C0BF' d='M12 28.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 26.73 12 28.81zm-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92 0-2.72 2.2-4.92 4.92-4.92 2.72 0 4.92 2.2 4.92 4.92 0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0l-3.94-3.93z'/%3E%3C/svg%3E\");background-position:0 0;background-repeat:no-repeat;background-size:20px;content:\"\";height:20px;left:var(--epr-search-bar-inner-padding);position:absolute;top:50%;transform:translateY(-50%);width:20px}.EmojiPickerReact.epr-dark-theme .epr-search-container .epr-icn-search{background-position-y:-20px}.EmojiPickerReact .epr-search-container input.epr-search::-moz-placeholder{color:var(--epr-search-input-placeholder-color)}.EmojiPickerReact .epr-search-container input.epr-search::placeholder{color:var(--epr-search-input-placeholder-color)}.EmojiPickerReact .epr-search-container input.epr-search:focus{background-color:var(--epr-search-input-bg-color-active);border:1px solid var(--epr-search-border-color)}";
styleInject(css_248z$a);
/*#__PURE__*/asSelectors(ClassNames.emojiPicker) + " " + /*#__PURE__*/asSelectors(ClassNames.emojiList);
var KeyboardEvents;
(function (KeyboardEvents) {
  KeyboardEvents["ArrowDown"] = "ArrowDown";
  KeyboardEvents["ArrowUp"] = "ArrowUp";
  KeyboardEvents["ArrowLeft"] = "ArrowLeft";
  KeyboardEvents["ArrowRight"] = "ArrowRight";
  KeyboardEvents["Escape"] = "Escape";
  KeyboardEvents["Enter"] = "Enter";
  KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
var css_248z$b = "aside.EmojiPickerReact.epr-main{border-color:var(--epr-picker-border-color);border-radius:var(--epr-picker-border-radius);border-style:solid;border-width:1px;display:flex;flex-direction:column;position:relative}";
styleInject(css_248z$b);
var css_248z$c = ".EmojiPickerReact{--epr-highlight-color:#007aeb;--epr-hover-bg-color:#f1f8ff;--epr-focus-bg-color:#e0f0ff;--epr-text-color:#858585;--epr-search-input-bg-color:#f6f6f6;--epr-picker-border-color:#e7e7e7;--epr-bg-color:#fff;--epr-category-icon-active-color:#6aa8de;--epr-skin-tone-picker-menu-color:#ffffff95;--epr-horizontal-padding:10px;--epr-picker-border-radius:8px;--epr-search-border-color:var(--epr-highlight-color);--epr-header-padding:15px var(--epr-horizontal-padding);--epr-active-skin-tone-indicator-border-color:var(--epr-highlight-color);--epr-active-skin-hover-color:var(--epr-hover-bg-color);--epr-search-input-bg-color-active:var(--epr-search-input-bg-color);--epr-search-input-padding:0 30px;--epr-search-input-border-radius:8px;--epr-search-input-height:40px;--epr-search-input-text-color:var(--epr-text-color);--epr-search-input-placeholder-color:var(--epr-text-color);--epr-search-bar-inner-padding:var(--epr-horizontal-padding);--epr-category-navigation-button-size:30px;--epr-emoji-variation-picker-height:45px;--epr-emoji-variation-picker-bg-color:var(--epr-bg-color);--epr-preview-height:70px;--epr-preview-text-size:14px;--epr-preview-text-padding:0 var(--epr-horizontal-padding);--epr-preview-border-color:var(--epr-picker-border-color);--epr-preview-text-color:var(--epr-text-color);--epr-category-padding:0 var(--epr-horizontal-padding);--epr-category-label-bg-color:#ffffffe6;--epr-category-label-text-color:var(--epr-text-color);--epr-category-label-padding:0 var(--epr-horizontal-padding);--epr-category-label-height:40px;--epr-emoji-size:30px;--epr-emoji-padding:5px;--epr-emoji-fullsize:calc(var(--epr-emoji-size) + var(--epr-emoji-padding)*2);--epr-emoji-hover-color:var(--epr-hover-bg-color);--epr-emoji-variation-indicator-color:var(--epr-picker-border-color);--epr-emoji-variation-indicator-color-hover:var(--epr-text-color);--epr-header-overlay-z-index:3;--epr-emoji-variations-indictator-z-index:1;--epr-category-label-z-index:2;--epr-skin-variation-picker-z-index:5;--epr-preview-z-index:6}.EmojiPickerReact.epr-dark-theme{--epr-dark:#000;--epr-emoji-variation-picker-bg-color:var(--epr-dark);--epr-highlight-color:silver;--epr-text-color:var(--epr-highlight-color);--epr-hover-bg-color:#363636f6;--epr-focus-bg-color:#474747;--epr-search-input-bg-color:#333;--epr-category-label-bg-color:#222222e6;--epr-picker-border-color:#151617;--epr-bg-color:#222;--epr-search-input-bg-color-active:var(--epr-dark);--epr-emoji-variation-indicator-color:#444;--epr-category-icon-active-color:#3271b7;--epr-skin-tone-picker-menu-color:#22222295}.EmojiPickerReact{background-color:var(--epr-bg-color);overflow:hidden}.EmojiPickerReact .epr-hidden,.EmojiPickerReact.epr-search-active .epr-hidden-on-search,.EmojiPickerReact:not(.epr-search-active) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-hidden-on-search{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-hidden-on-search{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:-moz-placeholder-shown) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:placeholder-shown) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}.EmojiPickerReact *{box-sizing:border-box;font-family:sans-serif}.EmojiPickerReact button.epr-btn{background:none;border:0;cursor:pointer;outline:none}";
styleInject(css_248z$c);
function ExportedEmoji(_ref) {
  var unified = _ref.unified,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$emojiStyle = _ref.emojiStyle,
    emojiStyle = _ref$emojiStyle === void 0 ? EmojiStyle.APPLE : _ref$emojiStyle,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    getEmojiUrl = _ref.getEmojiUrl;
  if (!unified) {
    return null;
  }
  return createElement(ViewOnlyEmoji, {
    unified: unified,
    size: size,
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    getEmojiUrl: getEmojiUrl
  });
}

var IconAddEmoji = jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M17.6191 10C17.6191 14.2079 14.2079 17.619 10 17.619C5.79215 17.619 2.38098 14.2079 2.38098 10C2.38098 5.79211 5.79215 2.38095 10 2.38095",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7.61902 8.99998C8.1713 8.99998 8.61902 8.55227 8.61902 7.99999C8.61902 7.44771 8.1713 7 7.61902 7C7.06673 7 6.61902 7.44771 6.61902 7.99999C6.61902 8.55227 7.06673 8.99998 7.61902 8.99998Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M12.381 8.99998C12.9333 8.99998 13.381 8.55227 13.381 7.99999C13.381 7.44771 12.9333 7 12.381 7C11.8287 7 11.381 7.44771 11.381 7.99999C11.381 8.55227 11.8287 8.99998 12.381 8.99998Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M7.14294 11.3333C7.71723 12.6028 8.66961 13.2381 10.0001 13.2381C11.3306 13.2381 12.2829 12.6028 12.8572 11.3333",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("line", {
    x1: "13.65",
    y1: "3.35",
    x2: "19.35",
    y2: "3.35",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("line", {
    x1: "16.65",
    y1: "0.65",
    x2: "16.65",
    y2: "6.35",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  })]
});
var IconDelete = jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [jsx("path", {
    d: "M3.46558 5.82355H15.7009L14.7597 18.0589H4.40675L3.46558 5.82355Z",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M7.44751 8.64706L7.9543 15.2353",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M11.5017 8.64706L10.9949 15.2353",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M1.58325 5.82355H17.5833",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinecap: "round"
  }), jsx("path", {
    d: "M13.8185 5.82354V3.94118C13.8185 3.42138 13.3971 3 12.8773 3H6.28908C5.76928 3 5.3479 3.42138 5.3479 3.94118V5.82354",
    stroke: "currentColor",
    strokeWidth: "1.3",
    strokeLinejoin: "round"
  })]
});
var IconReply = jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  children: [jsx("path", {
    d: "M3.35 3C3.35 2.64101 3.64102 2.35 4 2.35C4.35898 2.35 4.65 2.64101 4.65 3H3.35ZM15.5 14.15H8V12.85H15.5V14.15ZM8 14.15C6.46537 14.15 5.21544 13.9033 4.39404 12.9997C3.59152 12.117 3.35 10.7668 3.35 9H4.65C4.65 10.7332 4.90848 11.633 5.35596 12.1253C5.78456 12.5967 6.53463 12.85 8 12.85V14.15ZM3.35 9C3.35 8.99219 3.35 8.98439 3.35 8.97659C3.35 8.9688 3.35 8.96102 3.35 8.95325C3.35 8.94548 3.35 8.93771 3.35 8.92996C3.35 8.92221 3.35 8.91447 3.35 8.90674C3.35 8.89901 3.35 8.89128 3.35 8.88357C3.35 8.87586 3.35 8.86816 3.35 8.86047C3.35 8.85278 3.35 8.8451 3.35 8.83743C3.35 8.82976 3.35 8.8221 3.35 8.81445C3.35 8.80679 3.35 8.79915 3.35 8.79152C3.35 8.78389 3.35 8.77627 3.35 8.76866C3.35 8.76105 3.35 8.75345 3.35 8.74586C3.35 8.73827 3.35 8.73069 3.35 8.72312C3.35 8.71555 3.35 8.70799 3.35 8.70044C3.35 8.69289 3.35 8.68535 3.35 8.67782C3.35 8.67028 3.35 8.66276 3.35 8.65525C3.35 8.64774 3.35 8.64024 3.35 8.63275C3.35 8.62526 3.35 8.61778 3.35 8.61031C3.35 8.60284 3.35 8.59538 3.35 8.58793C3.35 8.58047 3.35 8.57303 3.35 8.5656C3.35 8.55817 3.35 8.55075 3.35 8.54334C3.35 8.53593 3.35 8.52852 3.35 8.52113C3.35 8.51374 3.35 8.50636 3.35 8.49899C3.35 8.49161 3.35 8.48425 3.35 8.4769C3.35 8.46955 3.35 8.4622 3.35 8.45487C3.35 8.44754 3.35 8.44022 3.35 8.4329C3.35 8.42559 3.35 8.41829 3.35 8.41099C3.35 8.4037 3.35 8.39642 3.35 8.38914C3.35 8.38187 3.35 8.3746 3.35 8.36735C3.35 8.36009 3.35 8.35285 3.35 8.34561C3.35 8.33838 3.35 8.33115 3.35 8.32394C3.35 8.31672 3.35 8.30952 3.35 8.30232C3.35 8.29513 3.35 8.28794 3.35 8.28076C3.35 8.27358 3.35 8.26642 3.35 8.25926C3.35 8.2521 3.35 8.24496 3.35 8.23782C3.35 8.23068 3.35 8.22355 3.35 8.21643C3.35 8.20931 3.35 8.20221 3.35 8.19511C3.35 8.18801 3.35 8.18092 3.35 8.17384C3.35 8.16676 3.35 8.15969 3.35 8.15262C3.35 8.14556 3.35 8.13851 3.35 8.13147C3.35 8.12443 3.35 8.1174 3.35 8.11037C3.35 8.10335 3.35 8.09634 3.35 8.08934C3.35 8.08233 3.35 8.07534 3.35 8.06835C3.35 8.06137 3.35 8.0544 3.35 8.04743C3.35 8.04046 3.35 8.03351 3.35 8.02656C3.35 8.01962 3.35 8.01268 3.35 8.00575C3.35 7.99883 3.35 7.99191 3.35 7.985C3.35 7.97809 3.35 7.97119 3.35 7.9643C3.35 7.95741 3.35 7.95053 3.35 7.94366C3.35 7.93679 3.35 7.92993 3.35 7.92308C3.35 7.91623 3.35 7.90939 3.35 7.90256C3.35 7.89572 3.35 7.8889 3.35 7.88209C3.35 7.87527 3.35 7.86847 3.35 7.86167C3.35 7.85488 3.35 7.84809 3.35 7.84132C3.35 7.83454 3.35 7.82778 3.35 7.82102C3.35 7.81426 3.35 7.80751 3.35 7.80077C3.35 7.79404 3.35 7.78731 3.35 7.78059C3.35 7.77387 3.35 7.76716 3.35 7.76045C3.35 7.75375 3.35 7.74706 3.35 7.74038C3.35 7.7337 3.35 7.72702 3.35 7.72036C3.35 7.71369 3.35 7.70704 3.35 7.70039C3.35 7.69375 3.35 7.68711 3.35 7.68049C3.35 7.67386 3.35 7.66724 3.35 7.66063C3.35 7.65402 3.35 7.64743 3.35 7.64084C3.35 7.63425 3.35 7.62767 3.35 7.62109C3.35 7.61452 3.35 7.60796 3.35 7.60141C3.35 7.59485 3.35 7.58831 3.35 7.58178C3.35 7.57524 3.35 7.56872 3.35 7.5622C3.35 7.55568 3.35 7.54918 3.35 7.54268C3.35 7.53618 3.35 7.52969 3.35 7.52321C3.35 7.51673 3.35 7.51026 3.35 7.5038C3.35 7.49734 3.35 7.49089 3.35 7.48444C3.35 7.478 3.35 7.47157 3.35 7.46514C3.35 7.45872 3.35 7.4523 3.35 7.44589C3.35 7.43949 3.35 7.43309 3.35 7.4267C3.35 7.42031 3.35 7.41393 3.35 7.40756C3.35 7.40119 3.35 7.39483 3.35 7.38848C3.35 7.38213 3.35 7.37578 3.35 7.36945C3.35 7.36311 3.35 7.35679 3.35 7.35047C3.35 7.34416 3.35 7.33785 3.35 7.33155C3.35 7.32525 3.35 7.31896 3.35 7.31268C3.35 7.3064 3.35 7.30013 3.35 7.29387C3.35 7.28761 3.35 7.28135 3.35 7.27511C3.35 7.26886 3.35 7.26263 3.35 7.2564C3.35 7.25018 3.35 7.24396 3.35 7.23775C3.35 7.23154 3.35 7.22534 3.35 7.21915C3.35 7.21296 3.35 7.20678 3.35 7.2006C3.35 7.19443 3.35 7.18827 3.35 7.18211C3.35 7.17596 3.35 7.16981 3.35 7.16367C3.35 7.15754 3.35 7.15141 3.35 7.14529C3.35 7.13917 3.35 7.13306 3.35 7.12695C3.35 7.12085 3.35 7.11476 3.35 7.10867C3.35 7.10259 3.35 7.09651 3.35 7.09045C3.35 7.08438 3.35 7.07832 3.35 7.07227C3.35 7.06622 3.35 7.06018 3.35 7.05415C3.35 7.04812 3.35 7.0421 3.35 7.03608C3.35 7.03007 3.35 7.02406 3.35 7.01807C3.35 7.01207 3.35 7.00608 3.35 7.0001C3.35 6.99412 3.35 6.98815 3.35 6.98219C3.35 6.97623 3.35 6.97028 3.35 6.96433C3.35 6.95839 3.35 6.95245 3.35 6.94652C3.35 6.9406 3.35 6.93468 3.35 6.92877C3.35 6.92286 3.35 6.91696 3.35 6.91107C3.35 6.90517 3.35 6.89929 3.35 6.89342C3.35 6.88754 3.35 6.88167 3.35 6.87582C3.35 6.86996 3.35 6.86411 3.35 6.85827C3.35 6.85243 3.35 6.8466 3.35 6.84077C3.35 6.83495 3.35 6.82913 3.35 6.82333C3.35 6.81752 3.35 6.81172 3.35 6.80594C3.35 6.80015 3.35 6.79437 3.35 6.78859C3.35 6.78282 3.35 6.77706 3.35 6.7713C3.35 6.76555 3.35 6.7598 3.35 6.75407C3.35 6.74833 3.35 6.7426 3.35 6.73688C3.35 6.73116 3.35 6.72544 3.35 6.71974C3.35 6.71404 3.35 6.70834 3.35 6.70265C3.35 6.69697 3.35 6.69129 3.35 6.68562C3.35 6.67995 3.35 6.67429 3.35 6.66864C3.35 6.66298 3.35 6.65734 3.35 6.6517C3.35 6.64607 3.35 6.64044 3.35 6.63482C3.35 6.6292 3.35 6.62359 3.35 6.61799C3.35 6.61238 3.35 6.60679 3.35 6.6012C3.35 6.59562 3.35 6.59004 3.35 6.58447C3.35 6.5789 3.35 6.57334 3.35 6.56779C3.35 6.56224 3.35 6.55669 3.35 6.55116C3.35 6.54562 3.35 6.5401 3.35 6.53458C3.35 6.52906 3.35 6.52355 3.35 6.51805C3.35 6.51254 3.35 6.50705 3.35 6.50156C3.35 6.49608 3.35 6.4906 3.35 6.48513C3.35 6.47966 3.35 6.4742 3.35 6.46875C3.35 6.4633 3.35 6.45785 3.35 6.45242C3.35 6.44698 3.35 6.44155 3.35 6.43613C3.35 6.43071 3.35 6.4253 3.35 6.4199C3.35 6.4145 3.35 6.4091 3.35 6.40372C3.35 6.39833 3.35 6.39295 3.35 6.38758C3.35 6.38221 3.35 6.37685 3.35 6.3715C3.35 6.36614 3.35 6.3608 3.35 6.35546C3.35 6.35012 3.35 6.34479 3.35 6.33947C3.35 6.33415 3.35 6.32884 3.35 6.32353C3.35 6.31823 3.35 6.31293 3.35 6.30764C3.35 6.30235 3.35 6.29707 3.35 6.2918C3.35 6.28653 3.35 6.28126 3.35 6.27601C3.35 6.27075 3.35 6.2655 3.35 6.26026C3.35 6.25502 3.35 6.24979 3.35 6.24457C3.35 6.23934 3.35 6.23413 3.35 6.22892C3.35 6.22371 3.35 6.21851 3.35 6.21332C3.35 6.20813 3.35 6.20294 3.35 6.19777C3.35 6.19259 3.35 6.18742 3.35 6.18226C3.35 6.1771 3.35 6.17195 3.35 6.16681C3.35 6.16166 3.35 6.15653 3.35 6.1514C3.35 6.14627 3.35 6.14115 3.35 6.13604C3.35 6.13093 3.35 6.12583 3.35 6.12073C3.35 6.11563 3.35 6.11054 3.35 6.10546C3.35 6.10038 3.35 6.09531 3.35 6.09025C3.35 6.08518 3.35 6.08013 3.35 6.07508C3.35 6.07003 3.35 6.06499 3.35 6.05996C3.35 6.05492 3.35 6.0499 3.35 6.04488C3.35 6.03987 3.35 6.03486 3.35 6.02985C3.35 6.02485 3.35 6.01986 3.35 6.01487C3.35 6.00989 3.35 6.00491 3.35 5.99994C3.35 5.99497 3.35 5.99001 3.35 5.98505C3.35 5.9801 3.35 5.97515 3.35 5.97021C3.35 5.96528 3.35 5.96035 3.35 5.95542C3.35 5.9505 3.35 5.94558 3.35 5.94068C3.35 5.93577 3.35 5.93087 3.35 5.92598C3.35 5.92108 3.35 5.9162 3.35 5.91132C3.35 5.90645 3.35 5.90158 3.35 5.89672C3.35 5.89185 3.35 5.887 3.35 5.88216C3.35 5.87731 3.35 5.87247 3.35 5.86764C3.35 5.86281 3.35 5.85799 3.35 5.85317C3.35 5.84836 3.35 5.84355 3.35 5.83875C3.35 5.83395 3.35 5.82916 3.35 5.82437C3.35 5.81959 3.35 5.81481 3.35 5.81004C3.35 5.80527 3.35 5.80051 3.35 5.79576C3.35 5.791 3.35 5.78626 3.35 5.78152C3.35 5.77678 3.35 5.77205 3.35 5.76733C3.35 5.7626 3.35 5.75789 3.35 5.75318C3.35 5.74847 3.35 5.74377 3.35 5.73907C3.35 5.73438 3.35 5.7297 3.35 5.72502C3.35 5.72034 3.35 5.71567 3.35 5.71101C3.35 5.70634 3.35 5.70169 3.35 5.69704C3.35 5.69239 3.35 5.68775 3.35 5.68312C3.35 5.67848 3.35 5.67386 3.35 5.66924C3.35 5.66462 3.35 5.66001 3.35 5.65541C3.35 5.6508 3.35 5.64621 3.35 5.64162C3.35 5.63703 3.35 5.63245 3.35 5.62788C3.35 5.6233 3.35 5.61874 3.35 5.61418C3.35 5.60962 3.35 5.60507 3.35 5.60052C3.35 5.59598 3.35 5.59144 3.35 5.58692C3.35 5.58239 3.35 5.57786 3.35 5.57335C3.35 5.56884 3.35 5.56433 3.35 5.55983C3.35 5.55533 3.35 5.55084 3.35 5.54635C3.35 5.54187 3.35 5.53739 3.35 5.53292C3.35 5.52845 3.35 5.52399 3.35 5.51953C3.35 5.51508 3.35 5.51063 3.35 5.50619C3.35 5.50175 3.35 5.49731 3.35 5.49289C3.35 5.48846 3.35 5.48404 3.35 5.47963C3.35 5.47522 3.35 5.47081 3.35 5.46641C3.35 5.46202 3.35 5.45763 3.35 5.45324C3.35 5.44886 3.35 5.44449 3.35 5.44012C3.35 5.43575 3.35 5.43139 3.35 5.42703C3.35 5.42268 3.35 5.41833 3.35 5.41399C3.35 5.40965 3.35 5.40532 3.35 5.401C3.35 5.39667 3.35 5.39235 3.35 5.38804C3.35 5.38373 3.35 5.37943 3.35 5.37513C3.35 5.37084 3.35 5.36655 3.35 5.36226C3.35 5.35798 3.35 5.35371 3.35 5.34944C3.35 5.34517 3.35 5.34091 3.35 5.33666C3.35 5.3324 3.35 5.32816 3.35 5.32392C3.35 5.31968 3.35 5.31544 3.35 5.31122C3.35 5.30699 3.35 5.30277 3.35 5.29856C3.35 5.29435 3.35 5.29015 3.35 5.28595C3.35 5.28175 3.35 5.27756 3.35 5.27338C3.35 5.2692 3.35 5.26502 3.35 5.26085C3.35 5.25668 3.35 5.25252 3.35 5.24837C3.35 5.24421 3.35 5.24006 3.35 5.23592C3.35 5.23178 3.35 5.22765 3.35 5.22352C3.35 5.21939 3.35 5.21527 3.35 5.21116C3.35 5.20705 3.35 5.20294 3.35 5.19884C3.35 5.19474 3.35 5.19065 3.35 5.18656C3.35 5.18248 3.35 5.1784 3.35 5.17433C3.35 5.17026 3.35 5.16619 3.35 5.16213C3.35 5.15808 3.35 5.15402 3.35 5.14998C3.35 5.14594 3.35 5.1419 3.35 5.13787C3.35 5.13384 3.35 5.12982 3.35 5.1258C3.35 5.12178 3.35 5.11777 3.35 5.11377C3.35 5.10977 3.35 5.10577 3.35 5.10178C3.35 5.09779 3.35 5.09381 3.35 5.08983C3.35 5.08586 3.35 5.08189 3.35 5.07793C3.35 5.07397 3.35 5.07001 3.35 5.06606C3.35 5.06211 3.35 5.05817 3.35 5.05424C3.35 5.0503 3.35 5.04637 3.35 5.04245C3.35 5.03853 3.35 5.03462 3.35 5.03071C3.35 5.0268 3.35 5.0229 3.35 5.019C3.35 5.01511 3.35 5.01122 3.35 5.00734C3.35 5.00346 3.35 4.99959 3.35 4.99572C3.35 4.99185 3.35 4.98799 3.35 4.98414C3.35 4.98028 3.35 4.97643 3.35 4.97259C3.35 4.96875 3.35 4.96492 3.35 4.96109C3.35 4.95726 3.35 4.95344 3.35 4.94963C3.35 4.94581 3.35 4.942 3.35 4.9382C3.35 4.9344 3.35 4.93061 3.35 4.92682C3.35 4.92303 3.35 4.91925 3.35 4.91547C3.35 4.9117 3.35 4.90793 3.35 4.90417C3.35 4.90041 3.35 4.89665 3.35 4.8929C3.35 4.88916 3.35 4.88541 3.35 4.88168C3.35 4.87794 3.35 4.87421 3.35 4.87049C3.35 4.86677 3.35 4.86305 3.35 4.85934C3.35 4.85563 3.35 4.85193 3.35 4.84824C3.35 4.84454 3.35 4.84085 3.35 4.83717C3.35 4.83348 3.35 4.82981 3.35 4.82614C3.35 4.82246 3.35 4.8188 3.35 4.81514C3.35 4.81149 3.35 4.80783 3.35 4.80419C3.35 4.80054 3.35 4.79691 3.35 4.79327C3.35 4.78964 3.35 4.78602 3.35 4.7824C3.35 4.77878 3.35 4.77517 3.35 4.77156C3.35 4.76795 3.35 4.76435 3.35 4.76076C3.35 4.75717 3.35 4.75358 3.35 4.75C3.35 4.74642 3.35 4.74284 3.35 4.73928C3.35 4.73571 3.35 4.73215 3.35 4.72859C3.35 4.72504 3.35 4.72149 3.35 4.71794C3.35 4.7144 3.35 4.71087 3.35 4.70734C3.35 4.70381 3.35 4.70028 3.35 4.69676C3.35 4.69325 3.35 4.68974 3.35 4.68623C3.35 4.68273 3.35 4.67923 3.35 4.67573C3.35 4.67224 3.35 4.66876 3.35 4.66528C3.35 4.6618 3.35 4.65832 3.35 4.65485C3.35 4.65139 3.35 4.64793 3.35 4.64447C3.35 4.64102 3.35 4.63757 3.35 4.63412C3.35 4.63068 3.35 4.62724 3.35 4.62381C3.35 4.62038 3.35 4.61696 3.35 4.61354C3.35 4.61012 3.35 4.60671 3.35 4.60331C3.35 4.5999 3.35 4.5965 3.35 4.59311C3.35 4.58972 3.35 4.58633 3.35 4.58295C3.35 4.57957 3.35 4.57619 3.35 4.57282C3.35 4.56945 3.35 4.56609 3.35 4.56273C3.35 4.55938 3.35 4.55603 3.35 4.55268C3.35 4.54934 3.35 4.546 3.35 4.54267C3.35 4.53933 3.35 4.53601 3.35 4.53269C3.35 4.52937 3.35 4.52605 3.35 4.52274C3.35 4.51944 3.35 4.51613 3.35 4.51284C3.35 4.50954 3.35 4.50625 3.35 4.50297C3.35 4.49968 3.35 4.49641 3.35 4.49313C3.35 4.48986 3.35 4.4866 3.35 4.48333C3.35 4.48007 3.35 4.47682 3.35 4.47357C3.35 4.47032 3.35 4.46708 3.35 4.46385C3.35 4.46061 3.35 4.45738 3.35 4.45415C3.35 4.45093 3.35 4.44771 3.35 4.4445C3.35 4.44129 3.35 4.43808 3.35 4.43488C3.35 4.43168 3.35 4.42848 3.35 4.42529C3.35 4.4221 3.35 4.41892 3.35 4.41574C3.35 4.41257 3.35 4.40939 3.35 4.40623C3.35 4.40306 3.35 4.3999 3.35 4.39675C3.35 4.3936 3.35 4.39045 3.35 4.38731C3.35 4.38416 3.35 4.38103 3.35 4.3779C3.35 4.37477 3.35 4.37164 3.35 4.36852C3.35 4.3654 3.35 4.36229 3.35 4.35918C3.35 4.35607 3.35 4.35297 3.35 4.34988C3.35 4.34678 3.35 4.34369 3.35 4.34061C3.35 4.33752 3.35 4.33444 3.35 4.33137C3.35 4.3283 3.35 4.32523 3.35 4.32217C3.35 4.31911 3.35 4.31605 3.35 4.313C3.35 4.30995 3.35 4.30691 3.35 4.30387C3.35 4.30083 3.35 4.2978 3.35 4.29477C3.35 4.29174 3.35 4.28872 3.35 4.2857C3.35 4.28269 3.35 4.27968 3.35 4.27667C3.35 4.27367 3.35 4.27067 3.35 4.26768C3.35 4.26468 3.35 4.26169 3.35 4.25871C3.35 4.25573 3.35 4.25275 3.35 4.24978C3.35 4.24681 3.35 4.24385 3.35 4.24089C3.35 4.23793 3.35 4.23497 3.35 4.23202C3.35 4.22907 3.35 4.22613 3.35 4.22319C3.35 4.22026 3.35 4.21732 3.35 4.2144C3.35 4.21147 3.35 4.20855 3.35 4.20564C3.35 4.20272 3.35 4.19981 3.35 4.19691C3.35 4.194 3.35 4.1911 3.35 4.18821C3.35 4.18532 3.35 4.18243 3.35 4.17955C3.35 4.17666 3.35 4.17379 3.35 4.17091C3.35 4.16804 3.35 4.16518 3.35 4.16232C3.35 4.15946 3.35 4.1566 3.35 4.15375C3.35 4.1509 3.35 4.14806 3.35 4.14522C3.35 4.14238 3.35 4.13955 3.35 4.13672C3.35 4.13389 3.35 4.13107 3.35 4.12825C3.35 4.12543 3.35 4.12262 3.35 4.11982C3.35 4.11701 3.35 4.11421 3.35 4.11141C3.35 4.10862 3.35 4.10583 3.35 4.10304C3.35 4.10026 3.35 4.09748 3.35 4.0947C3.35 4.09193 3.35 4.08916 3.35 4.0864C3.35 4.08363 3.35 4.08087 3.35 4.07812C3.35 4.07537 3.35 4.07262 3.35 4.06988C3.35 4.06714 3.35 4.0644 3.35 4.06167C3.35 4.05893 3.35 4.05621 3.35 4.05349C3.35 4.05076 3.35 4.04805 3.35 4.04534C3.35 4.04263 3.35 4.03992 3.35 4.03722C3.35 4.03452 3.35 4.03183 3.35 4.02914C3.35 4.02645 3.35 4.02376 3.35 4.02108C3.35 4.0184 3.35 4.01573 3.35 4.01306C3.35 4.01039 3.35 4.00772 3.35 4.00507C3.35 4.00241 3.35 3.99975 3.35 3.9971C3.35 3.99446 3.35 3.99181 3.35 3.98917C3.35 3.98654 3.35 3.9839 3.35 3.98128C3.35 3.97865 3.35 3.97602 3.35 3.97341C3.35 3.97079 3.35 3.96818 3.35 3.96557C3.35 3.96296 3.35 3.96036 3.35 3.95776C3.35 3.95516 3.35 3.95257 3.35 3.94998C3.35 3.9474 3.35 3.94481 3.35 3.94224C3.35 3.93966 3.35 3.93709 3.35 3.93452C3.35 3.93195 3.35 3.92939 3.35 3.92684C3.35 3.92428 3.35 3.92173 3.35 3.91918C3.35 3.91663 3.35 3.91409 3.35 3.91155C3.35 3.90902 3.35 3.90648 3.35 3.90396C3.35 3.90143 3.35 3.89891 3.35 3.89639C3.35 3.89387 3.35 3.89136 3.35 3.88885C3.35 3.88635 3.35 3.88385 3.35 3.88135C3.35 3.87885 3.35 3.87636 3.35 3.87387C3.35 3.87138 3.35 3.8689 3.35 3.86642C3.35 3.86394 3.35 3.86147 3.35 3.859C3.35 3.85654 3.35 3.85407 3.35 3.85161C3.35 3.84916 3.35 3.8467 3.35 3.84426C3.35 3.84181 3.35 3.83936 3.35 3.83692C3.35 3.83449 3.35 3.83205 3.35 3.82962C3.35 3.82719 3.35 3.82477 3.35 3.82235C3.35 3.81993 3.35 3.81752 3.35 3.81511C3.35 3.8127 3.35 3.81029 3.35 3.80789C3.35 3.80549 3.35 3.80309 3.35 3.8007C3.35 3.79831 3.35 3.79593 3.35 3.79355C3.35 3.79116 3.35 3.78879 3.35 3.78642C3.35 3.78404 3.35 3.78168 3.35 3.77932C3.35 3.77695 3.35 3.7746 3.35 3.77224C3.35 3.76989 3.35 3.76754 3.35 3.7652C3.35 3.76285 3.35 3.76052 3.35 3.75818C3.35 3.75585 3.35 3.75352 3.35 3.75119C3.35 3.74887 3.35 3.74655 3.35 3.74423C3.35 3.74192 3.35 3.73961 3.35 3.7373C3.35 3.73499 3.35 3.73269 3.35 3.7304C3.35 3.7281 3.35 3.72581 3.35 3.72352C3.35 3.72123 3.35 3.71895 3.35 3.71667C3.35 3.71439 3.35 3.71212 3.35 3.70985C3.35 3.70758 3.35 3.70531 3.35 3.70305C3.35 3.70079 3.35 3.69854 3.35 3.69628C3.35 3.69403 3.35 3.69179 3.35 3.68954C3.35 3.6873 3.35 3.68506 3.35 3.68283C3.35 3.6806 3.35 3.67837 3.35 3.67615C3.35 3.67392 3.35 3.6717 3.35 3.66949C3.35 3.66727 3.35 3.66506 3.35 3.66286C3.35 3.66065 3.35 3.65845 3.35 3.65625C3.35 3.65405 3.35 3.65186 3.35 3.64967C3.35 3.64748 3.35 3.6453 3.35 3.64312C3.35 3.64094 3.35 3.63877 3.35 3.63659C3.35 3.63442 3.35 3.63226 3.35 3.6301C3.35 3.62793 3.35 3.62578 3.35 3.62362C3.35 3.62147 3.35 3.61932 3.35 3.61718C3.35 3.61503 3.35 3.61289 3.35 3.61076C3.35 3.60862 3.35 3.60649 3.35 3.60436C3.35 3.60224 3.35 3.60011 3.35 3.59799C3.35 3.59588 3.35 3.59376 3.35 3.59165C3.35 3.58954 3.35 3.58744 3.35 3.58534C3.35 3.58323 3.35 3.58114 3.35 3.57905C3.35 3.57695 3.35 3.57486 3.35 3.57278C3.35 3.5707 3.35 3.56862 3.35 3.56654C3.35 3.56447 3.35 3.56239 3.35 3.56033C3.35 3.55826 3.35 3.5562 3.35 3.55414C3.35 3.55208 3.35 3.55003 3.35 3.54797C3.35 3.54592 3.35 3.54388 3.35 3.54184C3.35 3.53979 3.35 3.53776 3.35 3.53572C3.35 3.53369 3.35 3.53166 3.35 3.52964C3.35 3.52761 3.35 3.52559 3.35 3.52357C3.35 3.52156 3.35 3.51954 3.35 3.51753C3.35 3.51553 3.35 3.51352 3.35 3.51152C3.35 3.50952 3.35 3.50752 3.35 3.50553C3.35 3.50354 3.35 3.50155 3.35 3.49957C3.35 3.49758 3.35 3.4956 3.35 3.49363C3.35 3.49165 3.35 3.48968 3.35 3.48771C3.35 3.48574 3.35 3.48378 3.35 3.48182C3.35 3.47986 3.35 3.4779 3.35 3.47595C3.35 3.474 3.35 3.47205 3.35 3.47011C3.35 3.46817 3.35 3.46623 3.35 3.46429C3.35 3.46236 3.35 3.46042 3.35 3.4585C3.35 3.45657 3.35 3.45464 3.35 3.45272C3.35 3.45081 3.35 3.44889 3.35 3.44698C3.35 3.44507 3.35 3.44316 3.35 3.44125C3.35 3.43935 3.35 3.43745 3.35 3.43555C3.35 3.43366 3.35 3.43177 3.35 3.42988C3.35 3.42799 3.35 3.4261 3.35 3.42422C3.35 3.42234 3.35 3.42047 3.35 3.41859C3.35 3.41672 3.35 3.41485 3.35 3.41299C3.35 3.41112 3.35 3.40926 3.35 3.4074C3.35 3.40555 3.35 3.40369 3.35 3.40184C3.35 3.39999 3.35 3.39815 3.35 3.3963C3.35 3.39446 3.35 3.39262 3.35 3.39079C3.35 3.38896 3.35 3.38712 3.35 3.3853C3.35 3.38347 3.35 3.38165 3.35 3.37983C3.35 3.37801 3.35 3.37619 3.35 3.37438C3.35 3.37257 3.35 3.37076 3.35 3.36896C3.35 3.36715 3.35 3.36535 3.35 3.36356C3.35 3.36176 3.35 3.35997 3.35 3.35818C3.35 3.35639 3.35 3.3546 3.35 3.35282C3.35 3.35104 3.35 3.34926 3.35 3.34748C3.35 3.34571 3.35 3.34394 3.35 3.34217C3.35 3.3404 3.35 3.33864 3.35 3.33688C3.35 3.33512 3.35 3.33336 3.35 3.33161C3.35 3.32986 3.35 3.32811 3.35 3.32636C3.35 3.32462 3.35 3.32288 3.35 3.32114C3.35 3.3194 3.35 3.31766 3.35 3.31593C3.35 3.3142 3.35 3.31247 3.35 3.31075C3.35 3.30903 3.35 3.30731 3.35 3.30559C3.35 3.30387 3.35 3.30216 3.35 3.30045C3.35 3.29874 3.35 3.29703 3.35 3.29533C3.35 3.29363 3.35 3.29193 3.35 3.29023C3.35 3.28854 3.35 3.28684 3.35 3.28516C3.35 3.28347 3.35 3.28178 3.35 3.2801C3.35 3.27842 3.35 3.27674 3.35 3.27507C3.35 3.27339 3.35 3.27172 3.35 3.27005C3.35 3.26838 3.35 3.26672 3.35 3.26506C3.35 3.2634 3.35 3.26174 3.35 3.26009C3.35 3.25843 3.35 3.25678 3.35 3.25514C3.35 3.25349 3.35 3.25184 3.35 3.2502C3.35 3.24856 3.35 3.24693 3.35 3.24529C3.35 3.24366 3.35 3.24203 3.35 3.2404C3.35 3.23877 3.35 3.23715 3.35 3.23553C3.35 3.23391 3.35 3.23229 3.35 3.23068C3.35 3.22907 3.35 3.22746 3.35 3.22585C3.35 3.22424 3.35 3.22264 3.35 3.22104C3.35 3.21944 3.35 3.21784 3.35 3.21625C3.35 3.21465 3.35 3.21306 3.35 3.21148C3.35 3.20989 3.35 3.20831 3.35 3.20673C3.35 3.20515 3.35 3.20357 3.35 3.20199C3.35 3.20042 3.35 3.19885 3.35 3.19728C3.35 3.19571 3.35 3.19415 3.35 3.19259C3.35 3.19103 3.35 3.18947 3.35 3.18791C3.35 3.18636 3.35 3.18481 3.35 3.18326C3.35 3.18171 3.35 3.18017 3.35 3.17862C3.35 3.17708 3.35 3.17554 3.35 3.17401C3.35 3.17247 3.35 3.17094 3.35 3.16941C3.35 3.16788 3.35 3.16636 3.35 3.16483C3.35 3.16331 3.35 3.16179 3.35 3.16027C3.35 3.15876 3.35 3.15724 3.35 3.15573C3.35 3.15422 3.35 3.15271 3.35 3.15121C3.35 3.1497 3.35 3.1482 3.35 3.1467C3.35 3.14521 3.35 3.14371 3.35 3.14222C3.35 3.14073 3.35 3.13924 3.35 3.13775C3.35 3.13626 3.35 3.13478 3.35 3.1333C3.35 3.13182 3.35 3.13034 3.35 3.12887C3.35 3.1274 3.35 3.12592 3.35 3.12446C3.35 3.12299 3.35 3.12152 3.35 3.12006C3.35 3.1186 3.35 3.11714 3.35 3.11568C3.35 3.11423 3.35 3.11277 3.35 3.11132C3.35 3.10987 3.35 3.10843 3.35 3.10698C3.35 3.10554 3.35 3.1041 3.35 3.10266C3.35 3.10122 3.35 3.09978 3.35 3.09835C3.35 3.09692 3.35 3.09549 3.35 3.09406C3.35 3.09263 3.35 3.09121 3.35 3.08979C3.35 3.08837 3.35 3.08695 3.35 3.08553C3.35 3.08412 3.35 3.08271 3.35 3.0813C3.35 3.07989 3.35 3.07848 3.35 3.07708C3.35 3.07567 3.35 3.07427 3.35 3.07287C3.35 3.07147 3.35 3.07008 3.35 3.06868C3.35 3.06729 3.35 3.0659 3.35 3.06451C3.35 3.06313 3.35 3.06174 3.35 3.06036C3.35 3.05898 3.35 3.0576 3.35 3.05622C3.35 3.05485 3.35 3.05347 3.35 3.0521C3.35 3.05073 3.35 3.04936 3.35 3.048C3.35 3.04663 3.35 3.04527 3.35 3.04391C3.35 3.04255 3.35 3.04119 3.35 3.03984C3.35 3.03849 3.35 3.03713 3.35 3.03579C3.35 3.03444 3.35 3.03309 3.35 3.03175C3.35 3.0304 3.35 3.02906 3.35 3.02772C3.35 3.02638 3.35 3.02505 3.35 3.02372C3.35 3.02238 3.35 3.02105 3.35 3.01972C3.35 3.0184 3.35 3.01707 3.35 3.01575C3.35 3.01443 3.35 3.01311 3.35 3.01179C3.35 3.01047 3.35 3.00916 3.35 3.00784C3.35 3.00653 3.35 3.00522 3.35 3.00391C3.35 3.00261 3.35 3.0013 3.35 3H4.65C4.65 3.0013 4.65 3.00261 4.65 3.00391C4.65 3.00522 4.65 3.00653 4.65 3.00784C4.65 3.00916 4.65 3.01047 4.65 3.01179C4.65 3.01311 4.65 3.01443 4.65 3.01575C4.65 3.01707 4.65 3.0184 4.65 3.01972C4.65 3.02105 4.65 3.02238 4.65 3.02372C4.65 3.02505 4.65 3.02638 4.65 3.02772C4.65 3.02906 4.65 3.0304 4.65 3.03175C4.65 3.03309 4.65 3.03444 4.65 3.03579C4.65 3.03713 4.65 3.03849 4.65 3.03984C4.65 3.04119 4.65 3.04255 4.65 3.04391C4.65 3.04527 4.65 3.04663 4.65 3.048C4.65 3.04936 4.65 3.05073 4.65 3.0521C4.65 3.05347 4.65 3.05485 4.65 3.05622C4.65 3.0576 4.65 3.05898 4.65 3.06036C4.65 3.06174 4.65 3.06313 4.65 3.06451C4.65 3.0659 4.65 3.06729 4.65 3.06868C4.65 3.07008 4.65 3.07147 4.65 3.07287C4.65 3.07427 4.65 3.07567 4.65 3.07708C4.65 3.07848 4.65 3.07989 4.65 3.0813C4.65 3.08271 4.65 3.08412 4.65 3.08553C4.65 3.08695 4.65 3.08837 4.65 3.08979C4.65 3.09121 4.65 3.09263 4.65 3.09406C4.65 3.09549 4.65 3.09692 4.65 3.09835C4.65 3.09978 4.65 3.10122 4.65 3.10266C4.65 3.1041 4.65 3.10554 4.65 3.10698C4.65 3.10843 4.65 3.10987 4.65 3.11132C4.65 3.11277 4.65 3.11423 4.65 3.11568C4.65 3.11714 4.65 3.1186 4.65 3.12006C4.65 3.12152 4.65 3.12299 4.65 3.12446C4.65 3.12592 4.65 3.1274 4.65 3.12887C4.65 3.13034 4.65 3.13182 4.65 3.1333C4.65 3.13478 4.65 3.13626 4.65 3.13775C4.65 3.13924 4.65 3.14073 4.65 3.14222C4.65 3.14371 4.65 3.14521 4.65 3.1467C4.65 3.1482 4.65 3.1497 4.65 3.15121C4.65 3.15271 4.65 3.15422 4.65 3.15573C4.65 3.15724 4.65 3.15876 4.65 3.16027C4.65 3.16179 4.65 3.16331 4.65 3.16483C4.65 3.16636 4.65 3.16788 4.65 3.16941C4.65 3.17094 4.65 3.17247 4.65 3.17401C4.65 3.17554 4.65 3.17708 4.65 3.17862C4.65 3.18017 4.65 3.18171 4.65 3.18326C4.65 3.18481 4.65 3.18636 4.65 3.18791C4.65 3.18947 4.65 3.19103 4.65 3.19259C4.65 3.19415 4.65 3.19571 4.65 3.19728C4.65 3.19885 4.65 3.20042 4.65 3.20199C4.65 3.20357 4.65 3.20515 4.65 3.20673C4.65 3.20831 4.65 3.20989 4.65 3.21148C4.65 3.21306 4.65 3.21465 4.65 3.21625C4.65 3.21784 4.65 3.21944 4.65 3.22104C4.65 3.22264 4.65 3.22424 4.65 3.22585C4.65 3.22746 4.65 3.22907 4.65 3.23068C4.65 3.23229 4.65 3.23391 4.65 3.23553C4.65 3.23715 4.65 3.23877 4.65 3.2404C4.65 3.24203 4.65 3.24366 4.65 3.24529C4.65 3.24693 4.65 3.24856 4.65 3.2502C4.65 3.25184 4.65 3.25349 4.65 3.25514C4.65 3.25678 4.65 3.25843 4.65 3.26009C4.65 3.26174 4.65 3.2634 4.65 3.26506C4.65 3.26672 4.65 3.26838 4.65 3.27005C4.65 3.27172 4.65 3.27339 4.65 3.27507C4.65 3.27674 4.65 3.27842 4.65 3.2801C4.65 3.28178 4.65 3.28347 4.65 3.28516C4.65 3.28684 4.65 3.28854 4.65 3.29023C4.65 3.29193 4.65 3.29363 4.65 3.29533C4.65 3.29703 4.65 3.29874 4.65 3.30045C4.65 3.30216 4.65 3.30387 4.65 3.30559C4.65 3.30731 4.65 3.30903 4.65 3.31075C4.65 3.31247 4.65 3.3142 4.65 3.31593C4.65 3.31766 4.65 3.3194 4.65 3.32114C4.65 3.32288 4.65 3.32462 4.65 3.32636C4.65 3.32811 4.65 3.32986 4.65 3.33161C4.65 3.33336 4.65 3.33512 4.65 3.33688C4.65 3.33864 4.65 3.3404 4.65 3.34217C4.65 3.34394 4.65 3.34571 4.65 3.34748C4.65 3.34926 4.65 3.35104 4.65 3.35282C4.65 3.3546 4.65 3.35639 4.65 3.35818C4.65 3.35997 4.65 3.36176 4.65 3.36356C4.65 3.36535 4.65 3.36715 4.65 3.36896C4.65 3.37076 4.65 3.37257 4.65 3.37438C4.65 3.37619 4.65 3.37801 4.65 3.37983C4.65 3.38165 4.65 3.38347 4.65 3.3853C4.65 3.38712 4.65 3.38896 4.65 3.39079C4.65 3.39262 4.65 3.39446 4.65 3.3963C4.65 3.39815 4.65 3.39999 4.65 3.40184C4.65 3.40369 4.65 3.40555 4.65 3.4074C4.65 3.40926 4.65 3.41112 4.65 3.41299C4.65 3.41485 4.65 3.41672 4.65 3.41859C4.65 3.42047 4.65 3.42234 4.65 3.42422C4.65 3.4261 4.65 3.42799 4.65 3.42988C4.65 3.43177 4.65 3.43366 4.65 3.43555C4.65 3.43745 4.65 3.43935 4.65 3.44125C4.65 3.44316 4.65 3.44507 4.65 3.44698C4.65 3.44889 4.65 3.45081 4.65 3.45272C4.65 3.45464 4.65 3.45657 4.65 3.4585C4.65 3.46042 4.65 3.46236 4.65 3.46429C4.65 3.46623 4.65 3.46817 4.65 3.47011C4.65 3.47205 4.65 3.474 4.65 3.47595C4.65 3.4779 4.65 3.47986 4.65 3.48182C4.65 3.48378 4.65 3.48574 4.65 3.48771C4.65 3.48968 4.65 3.49165 4.65 3.49363C4.65 3.4956 4.65 3.49758 4.65 3.49957C4.65 3.50155 4.65 3.50354 4.65 3.50553C4.65 3.50752 4.65 3.50952 4.65 3.51152C4.65 3.51352 4.65 3.51553 4.65 3.51753C4.65 3.51954 4.65 3.52156 4.65 3.52357C4.65 3.52559 4.65 3.52761 4.65 3.52964C4.65 3.53166 4.65 3.53369 4.65 3.53572C4.65 3.53776 4.65 3.53979 4.65 3.54184C4.65 3.54388 4.65 3.54592 4.65 3.54797C4.65 3.55003 4.65 3.55208 4.65 3.55414C4.65 3.5562 4.65 3.55826 4.65 3.56033C4.65 3.56239 4.65 3.56447 4.65 3.56654C4.65 3.56862 4.65 3.5707 4.65 3.57278C4.65 3.57486 4.65 3.57695 4.65 3.57905C4.65 3.58114 4.65 3.58323 4.65 3.58534C4.65 3.58744 4.65 3.58954 4.65 3.59165C4.65 3.59376 4.65 3.59588 4.65 3.59799C4.65 3.60011 4.65 3.60224 4.65 3.60436C4.65 3.60649 4.65 3.60862 4.65 3.61076C4.65 3.61289 4.65 3.61503 4.65 3.61718C4.65 3.61932 4.65 3.62147 4.65 3.62362C4.65 3.62578 4.65 3.62793 4.65 3.6301C4.65 3.63226 4.65 3.63442 4.65 3.63659C4.65 3.63877 4.65 3.64094 4.65 3.64312C4.65 3.6453 4.65 3.64748 4.65 3.64967C4.65 3.65186 4.65 3.65405 4.65 3.65625C4.65 3.65845 4.65 3.66065 4.65 3.66286C4.65 3.66506 4.65 3.66727 4.65 3.66949C4.65 3.6717 4.65 3.67392 4.65 3.67615C4.65 3.67837 4.65 3.6806 4.65 3.68283C4.65 3.68506 4.65 3.6873 4.65 3.68954C4.65 3.69179 4.65 3.69403 4.65 3.69628C4.65 3.69854 4.65 3.70079 4.65 3.70305C4.65 3.70531 4.65 3.70758 4.65 3.70985C4.65 3.71212 4.65 3.71439 4.65 3.71667C4.65 3.71895 4.65 3.72123 4.65 3.72352C4.65 3.72581 4.65 3.7281 4.65 3.7304C4.65 3.73269 4.65 3.73499 4.65 3.7373C4.65 3.73961 4.65 3.74192 4.65 3.74423C4.65 3.74655 4.65 3.74887 4.65 3.75119C4.65 3.75352 4.65 3.75585 4.65 3.75818C4.65 3.76052 4.65 3.76285 4.65 3.7652C4.65 3.76754 4.65 3.76989 4.65 3.77224C4.65 3.7746 4.65 3.77695 4.65 3.77932C4.65 3.78168 4.65 3.78404 4.65 3.78642C4.65 3.78879 4.65 3.79116 4.65 3.79355C4.65 3.79593 4.65 3.79831 4.65 3.8007C4.65 3.80309 4.65 3.80549 4.65 3.80789C4.65 3.81029 4.65 3.8127 4.65 3.81511C4.65 3.81752 4.65 3.81993 4.65 3.82235C4.65 3.82477 4.65 3.82719 4.65 3.82962C4.65 3.83205 4.65 3.83449 4.65 3.83692C4.65 3.83936 4.65 3.84181 4.65 3.84426C4.65 3.8467 4.65 3.84916 4.65 3.85161C4.65 3.85407 4.65 3.85654 4.65 3.859C4.65 3.86147 4.65 3.86394 4.65 3.86642C4.65 3.8689 4.65 3.87138 4.65 3.87387C4.65 3.87636 4.65 3.87885 4.65 3.88135C4.65 3.88385 4.65 3.88635 4.65 3.88885C4.65 3.89136 4.65 3.89387 4.65 3.89639C4.65 3.89891 4.65 3.90143 4.65 3.90396C4.65 3.90648 4.65 3.90902 4.65 3.91155C4.65 3.91409 4.65 3.91663 4.65 3.91918C4.65 3.92173 4.65 3.92428 4.65 3.92684C4.65 3.92939 4.65 3.93195 4.65 3.93452C4.65 3.93709 4.65 3.93966 4.65 3.94224C4.65 3.94481 4.65 3.9474 4.65 3.94998C4.65 3.95257 4.65 3.95516 4.65 3.95776C4.65 3.96036 4.65 3.96296 4.65 3.96557C4.65 3.96818 4.65 3.97079 4.65 3.97341C4.65 3.97602 4.65 3.97865 4.65 3.98128C4.65 3.9839 4.65 3.98654 4.65 3.98917C4.65 3.99181 4.65 3.99446 4.65 3.9971C4.65 3.99975 4.65 4.00241 4.65 4.00507C4.65 4.00772 4.65 4.01039 4.65 4.01306C4.65 4.01573 4.65 4.0184 4.65 4.02108C4.65 4.02376 4.65 4.02645 4.65 4.02914C4.65 4.03183 4.65 4.03452 4.65 4.03722C4.65 4.03992 4.65 4.04263 4.65 4.04534C4.65 4.04805 4.65 4.05076 4.65 4.05349C4.65 4.05621 4.65 4.05893 4.65 4.06167C4.65 4.0644 4.65 4.06714 4.65 4.06988C4.65 4.07262 4.65 4.07537 4.65 4.07812C4.65 4.08087 4.65 4.08363 4.65 4.0864C4.65 4.08916 4.65 4.09193 4.65 4.0947C4.65 4.09748 4.65 4.10026 4.65 4.10304C4.65 4.10583 4.65 4.10862 4.65 4.11141C4.65 4.11421 4.65 4.11701 4.65 4.11982C4.65 4.12262 4.65 4.12543 4.65 4.12825C4.65 4.13107 4.65 4.13389 4.65 4.13672C4.65 4.13955 4.65 4.14238 4.65 4.14522C4.65 4.14806 4.65 4.1509 4.65 4.15375C4.65 4.1566 4.65 4.15946 4.65 4.16232C4.65 4.16518 4.65 4.16804 4.65 4.17091C4.65 4.17379 4.65 4.17666 4.65 4.17955C4.65 4.18243 4.65 4.18532 4.65 4.18821C4.65 4.1911 4.65 4.194 4.65 4.19691C4.65 4.19981 4.65 4.20272 4.65 4.20564C4.65 4.20855 4.65 4.21147 4.65 4.2144C4.65 4.21732 4.65 4.22026 4.65 4.22319C4.65 4.22613 4.65 4.22907 4.65 4.23202C4.65 4.23497 4.65 4.23793 4.65 4.24089C4.65 4.24385 4.65 4.24681 4.65 4.24978C4.65 4.25275 4.65 4.25573 4.65 4.25871C4.65 4.26169 4.65 4.26468 4.65 4.26768C4.65 4.27067 4.65 4.27367 4.65 4.27667C4.65 4.27968 4.65 4.28269 4.65 4.2857C4.65 4.28872 4.65 4.29174 4.65 4.29477C4.65 4.2978 4.65 4.30083 4.65 4.30387C4.65 4.30691 4.65 4.30995 4.65 4.313C4.65 4.31605 4.65 4.31911 4.65 4.32217C4.65 4.32523 4.65 4.3283 4.65 4.33137C4.65 4.33444 4.65 4.33752 4.65 4.34061C4.65 4.34369 4.65 4.34678 4.65 4.34988C4.65 4.35297 4.65 4.35607 4.65 4.35918C4.65 4.36229 4.65 4.3654 4.65 4.36852C4.65 4.37164 4.65 4.37477 4.65 4.3779C4.65 4.38103 4.65 4.38416 4.65 4.38731C4.65 4.39045 4.65 4.3936 4.65 4.39675C4.65 4.3999 4.65 4.40306 4.65 4.40623C4.65 4.40939 4.65 4.41257 4.65 4.41574C4.65 4.41892 4.65 4.4221 4.65 4.42529C4.65 4.42848 4.65 4.43168 4.65 4.43488C4.65 4.43808 4.65 4.44129 4.65 4.4445C4.65 4.44771 4.65 4.45093 4.65 4.45415C4.65 4.45738 4.65 4.46061 4.65 4.46385C4.65 4.46708 4.65 4.47032 4.65 4.47357C4.65 4.47682 4.65 4.48007 4.65 4.48333C4.65 4.4866 4.65 4.48986 4.65 4.49313C4.65 4.49641 4.65 4.49968 4.65 4.50297C4.65 4.50625 4.65 4.50954 4.65 4.51284C4.65 4.51613 4.65 4.51944 4.65 4.52274C4.65 4.52605 4.65 4.52937 4.65 4.53269C4.65 4.53601 4.65 4.53933 4.65 4.54267C4.65 4.546 4.65 4.54934 4.65 4.55268C4.65 4.55603 4.65 4.55938 4.65 4.56273C4.65 4.56609 4.65 4.56945 4.65 4.57282C4.65 4.57619 4.65 4.57957 4.65 4.58295C4.65 4.58633 4.65 4.58972 4.65 4.59311C4.65 4.5965 4.65 4.5999 4.65 4.60331C4.65 4.60671 4.65 4.61012 4.65 4.61354C4.65 4.61696 4.65 4.62038 4.65 4.62381C4.65 4.62724 4.65 4.63068 4.65 4.63412C4.65 4.63757 4.65 4.64102 4.65 4.64447C4.65 4.64793 4.65 4.65139 4.65 4.65485C4.65 4.65832 4.65 4.6618 4.65 4.66528C4.65 4.66876 4.65 4.67224 4.65 4.67573C4.65 4.67923 4.65 4.68273 4.65 4.68623C4.65 4.68974 4.65 4.69325 4.65 4.69676C4.65 4.70028 4.65 4.70381 4.65 4.70734C4.65 4.71087 4.65 4.7144 4.65 4.71794C4.65 4.72149 4.65 4.72504 4.65 4.72859C4.65 4.73215 4.65 4.73571 4.65 4.73928C4.65 4.74284 4.65 4.74642 4.65 4.75C4.65 4.75358 4.65 4.75717 4.65 4.76076C4.65 4.76435 4.65 4.76795 4.65 4.77156C4.65 4.77517 4.65 4.77878 4.65 4.7824C4.65 4.78602 4.65 4.78964 4.65 4.79327C4.65 4.79691 4.65 4.80054 4.65 4.80419C4.65 4.80783 4.65 4.81149 4.65 4.81514C4.65 4.8188 4.65 4.82246 4.65 4.82614C4.65 4.82981 4.65 4.83348 4.65 4.83717C4.65 4.84085 4.65 4.84454 4.65 4.84824C4.65 4.85193 4.65 4.85563 4.65 4.85934C4.65 4.86305 4.65 4.86677 4.65 4.87049C4.65 4.87421 4.65 4.87794 4.65 4.88168C4.65 4.88541 4.65 4.88916 4.65 4.8929C4.65 4.89665 4.65 4.90041 4.65 4.90417C4.65 4.90793 4.65 4.9117 4.65 4.91547C4.65 4.91925 4.65 4.92303 4.65 4.92682C4.65 4.93061 4.65 4.9344 4.65 4.9382C4.65 4.942 4.65 4.94581 4.65 4.94963C4.65 4.95344 4.65 4.95726 4.65 4.96109C4.65 4.96492 4.65 4.96875 4.65 4.97259C4.65 4.97643 4.65 4.98028 4.65 4.98414C4.65 4.98799 4.65 4.99185 4.65 4.99572C4.65 4.99959 4.65 5.00346 4.65 5.00734C4.65 5.01122 4.65 5.01511 4.65 5.019C4.65 5.0229 4.65 5.0268 4.65 5.03071C4.65 5.03462 4.65 5.03853 4.65 5.04245C4.65 5.04637 4.65 5.0503 4.65 5.05424C4.65 5.05817 4.65 5.06211 4.65 5.06606C4.65 5.07001 4.65 5.07397 4.65 5.07793C4.65 5.08189 4.65 5.08586 4.65 5.08983C4.65 5.09381 4.65 5.09779 4.65 5.10178C4.65 5.10577 4.65 5.10977 4.65 5.11377C4.65 5.11777 4.65 5.12178 4.65 5.1258C4.65 5.12982 4.65 5.13384 4.65 5.13787C4.65 5.1419 4.65 5.14594 4.65 5.14998C4.65 5.15402 4.65 5.15808 4.65 5.16213C4.65 5.16619 4.65 5.17026 4.65 5.17433C4.65 5.1784 4.65 5.18248 4.65 5.18656C4.65 5.19065 4.65 5.19474 4.65 5.19884C4.65 5.20294 4.65 5.20705 4.65 5.21116C4.65 5.21527 4.65 5.21939 4.65 5.22352C4.65 5.22765 4.65 5.23178 4.65 5.23592C4.65 5.24006 4.65 5.24421 4.65 5.24837C4.65 5.25252 4.65 5.25668 4.65 5.26085C4.65 5.26502 4.65 5.2692 4.65 5.27338C4.65 5.27756 4.65 5.28175 4.65 5.28595C4.65 5.29015 4.65 5.29435 4.65 5.29856C4.65 5.30277 4.65 5.30699 4.65 5.31122C4.65 5.31544 4.65 5.31968 4.65 5.32392C4.65 5.32816 4.65 5.3324 4.65 5.33666C4.65 5.34091 4.65 5.34517 4.65 5.34944C4.65 5.35371 4.65 5.35798 4.65 5.36226C4.65 5.36655 4.65 5.37084 4.65 5.37513C4.65 5.37943 4.65 5.38373 4.65 5.38804C4.65 5.39235 4.65 5.39667 4.65 5.401C4.65 5.40532 4.65 5.40965 4.65 5.41399C4.65 5.41833 4.65 5.42268 4.65 5.42703C4.65 5.43139 4.65 5.43575 4.65 5.44012C4.65 5.44449 4.65 5.44886 4.65 5.45324C4.65 5.45763 4.65 5.46202 4.65 5.46641C4.65 5.47081 4.65 5.47522 4.65 5.47963C4.65 5.48404 4.65 5.48846 4.65 5.49289C4.65 5.49731 4.65 5.50175 4.65 5.50619C4.65 5.51063 4.65 5.51508 4.65 5.51953C4.65 5.52399 4.65 5.52845 4.65 5.53292C4.65 5.53739 4.65 5.54187 4.65 5.54635C4.65 5.55084 4.65 5.55533 4.65 5.55983C4.65 5.56433 4.65 5.56884 4.65 5.57335C4.65 5.57786 4.65 5.58239 4.65 5.58692C4.65 5.59144 4.65 5.59598 4.65 5.60052C4.65 5.60507 4.65 5.60962 4.65 5.61418C4.65 5.61874 4.65 5.6233 4.65 5.62788C4.65 5.63245 4.65 5.63703 4.65 5.64162C4.65 5.64621 4.65 5.6508 4.65 5.65541C4.65 5.66001 4.65 5.66462 4.65 5.66924C4.65 5.67386 4.65 5.67848 4.65 5.68312C4.65 5.68775 4.65 5.69239 4.65 5.69704C4.65 5.70169 4.65 5.70634 4.65 5.71101C4.65 5.71567 4.65 5.72034 4.65 5.72502C4.65 5.7297 4.65 5.73438 4.65 5.73907C4.65 5.74377 4.65 5.74847 4.65 5.75318C4.65 5.75789 4.65 5.7626 4.65 5.76733C4.65 5.77205 4.65 5.77678 4.65 5.78152C4.65 5.78626 4.65 5.791 4.65 5.79576C4.65 5.80051 4.65 5.80527 4.65 5.81004C4.65 5.81481 4.65 5.81959 4.65 5.82437C4.65 5.82916 4.65 5.83395 4.65 5.83875C4.65 5.84355 4.65 5.84836 4.65 5.85317C4.65 5.85799 4.65 5.86281 4.65 5.86764C4.65 5.87247 4.65 5.87731 4.65 5.88216C4.65 5.887 4.65 5.89185 4.65 5.89672C4.65 5.90158 4.65 5.90645 4.65 5.91132C4.65 5.9162 4.65 5.92108 4.65 5.92598C4.65 5.93087 4.65 5.93577 4.65 5.94068C4.65 5.94558 4.65 5.9505 4.65 5.95542C4.65 5.96035 4.65 5.96528 4.65 5.97021C4.65 5.97515 4.65 5.9801 4.65 5.98505C4.65 5.99001 4.65 5.99497 4.65 5.99994C4.65 6.00491 4.65 6.00989 4.65 6.01487C4.65 6.01986 4.65 6.02485 4.65 6.02985C4.65 6.03486 4.65 6.03987 4.65 6.04488C4.65 6.0499 4.65 6.05492 4.65 6.05996C4.65 6.06499 4.65 6.07003 4.65 6.07508C4.65 6.08013 4.65 6.08518 4.65 6.09025C4.65 6.09531 4.65 6.10038 4.65 6.10546C4.65 6.11054 4.65 6.11563 4.65 6.12073C4.65 6.12583 4.65 6.13093 4.65 6.13604C4.65 6.14115 4.65 6.14627 4.65 6.1514C4.65 6.15653 4.65 6.16166 4.65 6.16681C4.65 6.17195 4.65 6.1771 4.65 6.18226C4.65 6.18742 4.65 6.19259 4.65 6.19777C4.65 6.20294 4.65 6.20813 4.65 6.21332C4.65 6.21851 4.65 6.22371 4.65 6.22892C4.65 6.23413 4.65 6.23934 4.65 6.24457C4.65 6.24979 4.65 6.25502 4.65 6.26026C4.65 6.2655 4.65 6.27075 4.65 6.27601C4.65 6.28126 4.65 6.28653 4.65 6.2918C4.65 6.29707 4.65 6.30235 4.65 6.30764C4.65 6.31293 4.65 6.31823 4.65 6.32353C4.65 6.32884 4.65 6.33415 4.65 6.33947C4.65 6.34479 4.65 6.35012 4.65 6.35546C4.65 6.3608 4.65 6.36614 4.65 6.3715C4.65 6.37685 4.65 6.38221 4.65 6.38758C4.65 6.39295 4.65 6.39833 4.65 6.40372C4.65 6.4091 4.65 6.4145 4.65 6.4199C4.65 6.4253 4.65 6.43071 4.65 6.43613C4.65 6.44155 4.65 6.44698 4.65 6.45242C4.65 6.45785 4.65 6.4633 4.65 6.46875C4.65 6.4742 4.65 6.47966 4.65 6.48513C4.65 6.4906 4.65 6.49608 4.65 6.50156C4.65 6.50705 4.65 6.51254 4.65 6.51805C4.65 6.52355 4.65 6.52906 4.65 6.53458C4.65 6.5401 4.65 6.54562 4.65 6.55116C4.65 6.55669 4.65 6.56224 4.65 6.56779C4.65 6.57334 4.65 6.5789 4.65 6.58447C4.65 6.59004 4.65 6.59562 4.65 6.6012C4.65 6.60679 4.65 6.61238 4.65 6.61799C4.65 6.62359 4.65 6.6292 4.65 6.63482C4.65 6.64044 4.65 6.64607 4.65 6.6517C4.65 6.65734 4.65 6.66298 4.65 6.66864C4.65 6.67429 4.65 6.67995 4.65 6.68562C4.65 6.69129 4.65 6.69697 4.65 6.70265C4.65 6.70834 4.65 6.71404 4.65 6.71974C4.65 6.72544 4.65 6.73116 4.65 6.73688C4.65 6.7426 4.65 6.74833 4.65 6.75407C4.65 6.7598 4.65 6.76555 4.65 6.7713C4.65 6.77706 4.65 6.78282 4.65 6.78859C4.65 6.79437 4.65 6.80015 4.65 6.80594C4.65 6.81172 4.65 6.81752 4.65 6.82333C4.65 6.82913 4.65 6.83495 4.65 6.84077C4.65 6.8466 4.65 6.85243 4.65 6.85827C4.65 6.86411 4.65 6.86996 4.65 6.87582C4.65 6.88167 4.65 6.88754 4.65 6.89342C4.65 6.89929 4.65 6.90517 4.65 6.91107C4.65 6.91696 4.65 6.92286 4.65 6.92877C4.65 6.93468 4.65 6.9406 4.65 6.94652C4.65 6.95245 4.65 6.95839 4.65 6.96433C4.65 6.97028 4.65 6.97623 4.65 6.98219C4.65 6.98815 4.65 6.99412 4.65 7.0001C4.65 7.00608 4.65 7.01207 4.65 7.01807C4.65 7.02406 4.65 7.03007 4.65 7.03608C4.65 7.0421 4.65 7.04812 4.65 7.05415C4.65 7.06018 4.65 7.06622 4.65 7.07227C4.65 7.07832 4.65 7.08438 4.65 7.09045C4.65 7.09651 4.65 7.10259 4.65 7.10867C4.65 7.11476 4.65 7.12085 4.65 7.12695C4.65 7.13306 4.65 7.13917 4.65 7.14529C4.65 7.15141 4.65 7.15754 4.65 7.16367C4.65 7.16981 4.65 7.17596 4.65 7.18211C4.65 7.18827 4.65 7.19443 4.65 7.2006C4.65 7.20678 4.65 7.21296 4.65 7.21915C4.65 7.22534 4.65 7.23154 4.65 7.23775C4.65 7.24396 4.65 7.25018 4.65 7.2564C4.65 7.26263 4.65 7.26886 4.65 7.27511C4.65 7.28135 4.65 7.28761 4.65 7.29387C4.65 7.30013 4.65 7.3064 4.65 7.31268C4.65 7.31896 4.65 7.32525 4.65 7.33155C4.65 7.33785 4.65 7.34416 4.65 7.35047C4.65 7.35679 4.65 7.36311 4.65 7.36945C4.65 7.37578 4.65 7.38213 4.65 7.38848C4.65 7.39483 4.65 7.40119 4.65 7.40756C4.65 7.41393 4.65 7.42031 4.65 7.4267C4.65 7.43309 4.65 7.43949 4.65 7.44589C4.65 7.4523 4.65 7.45872 4.65 7.46514C4.65 7.47157 4.65 7.478 4.65 7.48444C4.65 7.49089 4.65 7.49734 4.65 7.5038C4.65 7.51026 4.65 7.51673 4.65 7.52321C4.65 7.52969 4.65 7.53618 4.65 7.54268C4.65 7.54918 4.65 7.55568 4.65 7.5622C4.65 7.56872 4.65 7.57524 4.65 7.58178C4.65 7.58831 4.65 7.59485 4.65 7.60141C4.65 7.60796 4.65 7.61452 4.65 7.62109C4.65 7.62767 4.65 7.63425 4.65 7.64084C4.65 7.64743 4.65 7.65402 4.65 7.66063C4.65 7.66724 4.65 7.67386 4.65 7.68049C4.65 7.68711 4.65 7.69375 4.65 7.70039C4.65 7.70704 4.65 7.71369 4.65 7.72036C4.65 7.72702 4.65 7.7337 4.65 7.74038C4.65 7.74706 4.65 7.75375 4.65 7.76045C4.65 7.76716 4.65 7.77387 4.65 7.78059C4.65 7.78731 4.65 7.79404 4.65 7.80077C4.65 7.80751 4.65 7.81426 4.65 7.82102C4.65 7.82778 4.65 7.83454 4.65 7.84132C4.65 7.84809 4.65 7.85488 4.65 7.86167C4.65 7.86847 4.65 7.87527 4.65 7.88209C4.65 7.8889 4.65 7.89572 4.65 7.90256C4.65 7.90939 4.65 7.91623 4.65 7.92308C4.65 7.92993 4.65 7.93679 4.65 7.94366C4.65 7.95053 4.65 7.95741 4.65 7.9643C4.65 7.97119 4.65 7.97809 4.65 7.985C4.65 7.99191 4.65 7.99883 4.65 8.00575C4.65 8.01268 4.65 8.01962 4.65 8.02656C4.65 8.03351 4.65 8.04046 4.65 8.04743C4.65 8.0544 4.65 8.06137 4.65 8.06835C4.65 8.07534 4.65 8.08233 4.65 8.08934C4.65 8.09634 4.65 8.10335 4.65 8.11037C4.65 8.1174 4.65 8.12443 4.65 8.13147C4.65 8.13851 4.65 8.14556 4.65 8.15262C4.65 8.15969 4.65 8.16676 4.65 8.17384C4.65 8.18092 4.65 8.18801 4.65 8.19511C4.65 8.20221 4.65 8.20931 4.65 8.21643C4.65 8.22355 4.65 8.23068 4.65 8.23782C4.65 8.24496 4.65 8.2521 4.65 8.25926C4.65 8.26642 4.65 8.27358 4.65 8.28076C4.65 8.28794 4.65 8.29513 4.65 8.30232C4.65 8.30952 4.65 8.31672 4.65 8.32394C4.65 8.33115 4.65 8.33838 4.65 8.34561C4.65 8.35285 4.65 8.36009 4.65 8.36735C4.65 8.3746 4.65 8.38187 4.65 8.38914C4.65 8.39642 4.65 8.4037 4.65 8.41099C4.65 8.41829 4.65 8.42559 4.65 8.4329C4.65 8.44022 4.65 8.44754 4.65 8.45487C4.65 8.4622 4.65 8.46955 4.65 8.4769C4.65 8.48425 4.65 8.49161 4.65 8.49899C4.65 8.50636 4.65 8.51374 4.65 8.52113C4.65 8.52852 4.65 8.53593 4.65 8.54334C4.65 8.55075 4.65 8.55817 4.65 8.5656C4.65 8.57303 4.65 8.58047 4.65 8.58793C4.65 8.59538 4.65 8.60284 4.65 8.61031C4.65 8.61778 4.65 8.62526 4.65 8.63275C4.65 8.64024 4.65 8.64774 4.65 8.65525C4.65 8.66276 4.65 8.67028 4.65 8.67782C4.65 8.68535 4.65 8.69289 4.65 8.70044C4.65 8.70799 4.65 8.71555 4.65 8.72312C4.65 8.73069 4.65 8.73827 4.65 8.74586C4.65 8.75345 4.65 8.76105 4.65 8.76866C4.65 8.77627 4.65 8.78389 4.65 8.79152C4.65 8.79915 4.65 8.80679 4.65 8.81445C4.65 8.8221 4.65 8.82976 4.65 8.83743C4.65 8.8451 4.65 8.85278 4.65 8.86047C4.65 8.86816 4.65 8.87586 4.65 8.88357C4.65 8.89128 4.65 8.89901 4.65 8.90674C4.65 8.91447 4.65 8.92221 4.65 8.92996C4.65 8.93771 4.65 8.94548 4.65 8.95325C4.65 8.96102 4.65 8.9688 4.65 8.97659C4.65 8.98439 4.65 8.99219 4.65 9H3.35Z",
    fill: "#404040"
  }), jsx("path", {
    d: "M16 13.5L12.5 10",
    stroke: "#404040",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), jsx("path", {
    d: "M16 13.5L12.5 17",
    stroke: "#404040",
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});

var categories = [
	{
		id: "people",
		emojis: [
			"grinning",
			"smiley",
			"smile",
			"grin",
			"laughing",
			"sweat_smile",
			"rolling_on_the_floor_laughing",
			"joy",
			"slightly_smiling_face",
			"upside_down_face",
			"melting_face",
			"wink",
			"blush",
			"innocent",
			"smiling_face_with_3_hearts",
			"heart_eyes",
			"star-struck",
			"kissing_heart",
			"kissing",
			"relaxed",
			"kissing_closed_eyes",
			"kissing_smiling_eyes",
			"smiling_face_with_tear",
			"yum",
			"stuck_out_tongue",
			"stuck_out_tongue_winking_eye",
			"zany_face",
			"stuck_out_tongue_closed_eyes",
			"money_mouth_face",
			"hugging_face",
			"face_with_hand_over_mouth",
			"face_with_open_eyes_and_hand_over_mouth",
			"face_with_peeking_eye",
			"shushing_face",
			"thinking_face",
			"saluting_face",
			"zipper_mouth_face",
			"face_with_raised_eyebrow",
			"neutral_face",
			"expressionless",
			"no_mouth",
			"dotted_line_face",
			"face_in_clouds",
			"smirk",
			"unamused",
			"face_with_rolling_eyes",
			"grimacing",
			"face_exhaling",
			"lying_face",
			"relieved",
			"pensive",
			"sleepy",
			"drooling_face",
			"sleeping",
			"mask",
			"face_with_thermometer",
			"face_with_head_bandage",
			"nauseated_face",
			"face_vomiting",
			"sneezing_face",
			"hot_face",
			"cold_face",
			"woozy_face",
			"dizzy_face",
			"face_with_spiral_eyes",
			"exploding_head",
			"face_with_cowboy_hat",
			"partying_face",
			"disguised_face",
			"sunglasses",
			"nerd_face",
			"face_with_monocle",
			"confused",
			"face_with_diagonal_mouth",
			"worried",
			"slightly_frowning_face",
			"white_frowning_face",
			"open_mouth",
			"hushed",
			"astonished",
			"flushed",
			"pleading_face",
			"face_holding_back_tears",
			"frowning",
			"anguished",
			"fearful",
			"cold_sweat",
			"disappointed_relieved",
			"cry",
			"sob",
			"scream",
			"confounded",
			"persevere",
			"disappointed",
			"sweat",
			"weary",
			"tired_face",
			"yawning_face",
			"triumph",
			"rage",
			"angry",
			"face_with_symbols_on_mouth",
			"smiling_imp",
			"imp",
			"skull",
			"skull_and_crossbones",
			"hankey",
			"clown_face",
			"japanese_ogre",
			"japanese_goblin",
			"ghost",
			"alien",
			"space_invader",
			"robot_face",
			"wave",
			"raised_back_of_hand",
			"raised_hand_with_fingers_splayed",
			"hand",
			"spock-hand",
			"rightwards_hand",
			"leftwards_hand",
			"palm_down_hand",
			"palm_up_hand",
			"ok_hand",
			"pinched_fingers",
			"pinching_hand",
			"v",
			"crossed_fingers",
			"hand_with_index_finger_and_thumb_crossed",
			"i_love_you_hand_sign",
			"the_horns",
			"call_me_hand",
			"point_left",
			"point_right",
			"point_up_2",
			"middle_finger",
			"point_down",
			"point_up",
			"index_pointing_at_the_viewer",
			"+1",
			"-1",
			"fist",
			"facepunch",
			"left-facing_fist",
			"right-facing_fist",
			"clap",
			"raised_hands",
			"heart_hands",
			"open_hands",
			"palms_up_together",
			"handshake",
			"pray",
			"writing_hand",
			"nail_care",
			"selfie",
			"muscle",
			"mechanical_arm",
			"mechanical_leg",
			"leg",
			"foot",
			"ear",
			"ear_with_hearing_aid",
			"nose",
			"brain",
			"anatomical_heart",
			"lungs",
			"tooth",
			"bone",
			"eyes",
			"eye",
			"tongue",
			"lips",
			"biting_lip",
			"baby",
			"child",
			"boy",
			"girl",
			"adult",
			"person_with_blond_hair",
			"man",
			"bearded_person",
			"man_with_beard",
			"woman_with_beard",
			"red_haired_man",
			"curly_haired_man",
			"white_haired_man",
			"bald_man",
			"woman",
			"red_haired_woman",
			"red_haired_person",
			"curly_haired_woman",
			"curly_haired_person",
			"white_haired_woman",
			"white_haired_person",
			"bald_woman",
			"bald_person",
			"blond-haired-woman",
			"blond-haired-man",
			"older_adult",
			"older_man",
			"older_woman",
			"person_frowning",
			"man-frowning",
			"woman-frowning",
			"person_with_pouting_face",
			"man-pouting",
			"woman-pouting",
			"no_good",
			"man-gesturing-no",
			"woman-gesturing-no",
			"ok_woman",
			"man-gesturing-ok",
			"woman-gesturing-ok",
			"information_desk_person",
			"man-tipping-hand",
			"woman-tipping-hand",
			"raising_hand",
			"man-raising-hand",
			"woman-raising-hand",
			"deaf_person",
			"deaf_man",
			"deaf_woman",
			"bow",
			"man-bowing",
			"woman-bowing",
			"face_palm",
			"man-facepalming",
			"woman-facepalming",
			"shrug",
			"man-shrugging",
			"woman-shrugging",
			"health_worker",
			"male-doctor",
			"female-doctor",
			"student",
			"male-student",
			"female-student",
			"teacher",
			"male-teacher",
			"female-teacher",
			"judge",
			"male-judge",
			"female-judge",
			"farmer",
			"male-farmer",
			"female-farmer",
			"cook",
			"male-cook",
			"female-cook",
			"mechanic",
			"male-mechanic",
			"female-mechanic",
			"factory_worker",
			"male-factory-worker",
			"female-factory-worker",
			"office_worker",
			"male-office-worker",
			"female-office-worker",
			"scientist",
			"male-scientist",
			"female-scientist",
			"technologist",
			"male-technologist",
			"female-technologist",
			"singer",
			"male-singer",
			"female-singer",
			"artist",
			"male-artist",
			"female-artist",
			"pilot",
			"male-pilot",
			"female-pilot",
			"astronaut",
			"male-astronaut",
			"female-astronaut",
			"firefighter",
			"male-firefighter",
			"female-firefighter",
			"cop",
			"male-police-officer",
			"female-police-officer",
			"sleuth_or_spy",
			"male-detective",
			"female-detective",
			"guardsman",
			"male-guard",
			"female-guard",
			"ninja",
			"construction_worker",
			"male-construction-worker",
			"female-construction-worker",
			"person_with_crown",
			"prince",
			"princess",
			"man_with_turban",
			"man-wearing-turban",
			"woman-wearing-turban",
			"man_with_gua_pi_mao",
			"person_with_headscarf",
			"person_in_tuxedo",
			"man_in_tuxedo",
			"woman_in_tuxedo",
			"bride_with_veil",
			"man_with_veil",
			"woman_with_veil",
			"pregnant_woman",
			"pregnant_man",
			"pregnant_person",
			"breast-feeding",
			"woman_feeding_baby",
			"man_feeding_baby",
			"person_feeding_baby",
			"angel",
			"santa",
			"mrs_claus",
			"mx_claus",
			"superhero",
			"male_superhero",
			"female_superhero",
			"supervillain",
			"male_supervillain",
			"female_supervillain",
			"mage",
			"male_mage",
			"female_mage",
			"fairy",
			"male_fairy",
			"female_fairy",
			"vampire",
			"male_vampire",
			"female_vampire",
			"merperson",
			"merman",
			"mermaid",
			"elf",
			"male_elf",
			"female_elf",
			"genie",
			"male_genie",
			"female_genie",
			"zombie",
			"male_zombie",
			"female_zombie",
			"troll",
			"massage",
			"man-getting-massage",
			"woman-getting-massage",
			"haircut",
			"man-getting-haircut",
			"woman-getting-haircut",
			"walking",
			"man-walking",
			"woman-walking",
			"standing_person",
			"man_standing",
			"woman_standing",
			"kneeling_person",
			"man_kneeling",
			"woman_kneeling",
			"person_with_probing_cane",
			"man_with_probing_cane",
			"woman_with_probing_cane",
			"person_in_motorized_wheelchair",
			"man_in_motorized_wheelchair",
			"woman_in_motorized_wheelchair",
			"person_in_manual_wheelchair",
			"man_in_manual_wheelchair",
			"woman_in_manual_wheelchair",
			"runner",
			"man-running",
			"woman-running",
			"dancer",
			"man_dancing",
			"man_in_business_suit_levitating",
			"dancers",
			"men-with-bunny-ears-partying",
			"women-with-bunny-ears-partying",
			"person_in_steamy_room",
			"man_in_steamy_room",
			"woman_in_steamy_room",
			"person_climbing",
			"man_climbing",
			"woman_climbing",
			"fencer",
			"horse_racing",
			"skier",
			"snowboarder",
			"golfer",
			"man-golfing",
			"woman-golfing",
			"surfer",
			"man-surfing",
			"woman-surfing",
			"rowboat",
			"man-rowing-boat",
			"woman-rowing-boat",
			"swimmer",
			"man-swimming",
			"woman-swimming",
			"person_with_ball",
			"man-bouncing-ball",
			"woman-bouncing-ball",
			"weight_lifter",
			"man-lifting-weights",
			"woman-lifting-weights",
			"bicyclist",
			"man-biking",
			"woman-biking",
			"mountain_bicyclist",
			"man-mountain-biking",
			"woman-mountain-biking",
			"person_doing_cartwheel",
			"man-cartwheeling",
			"woman-cartwheeling",
			"wrestlers",
			"man-wrestling",
			"woman-wrestling",
			"water_polo",
			"man-playing-water-polo",
			"woman-playing-water-polo",
			"handball",
			"man-playing-handball",
			"woman-playing-handball",
			"juggling",
			"man-juggling",
			"woman-juggling",
			"person_in_lotus_position",
			"man_in_lotus_position",
			"woman_in_lotus_position",
			"bath",
			"sleeping_accommodation",
			"people_holding_hands",
			"two_women_holding_hands",
			"man_and_woman_holding_hands",
			"two_men_holding_hands",
			"couplekiss",
			"woman-kiss-man",
			"man-kiss-man",
			"woman-kiss-woman",
			"couple_with_heart",
			"woman-heart-man",
			"man-heart-man",
			"woman-heart-woman",
			"family",
			"man-woman-boy",
			"man-woman-girl",
			"man-woman-girl-boy",
			"man-woman-boy-boy",
			"man-woman-girl-girl",
			"man-man-boy",
			"man-man-girl",
			"man-man-girl-boy",
			"man-man-boy-boy",
			"man-man-girl-girl",
			"woman-woman-boy",
			"woman-woman-girl",
			"woman-woman-girl-boy",
			"woman-woman-boy-boy",
			"woman-woman-girl-girl",
			"man-boy",
			"man-boy-boy",
			"man-girl",
			"man-girl-boy",
			"man-girl-girl",
			"woman-boy",
			"woman-boy-boy",
			"woman-girl",
			"woman-girl-boy",
			"woman-girl-girl",
			"speaking_head_in_silhouette",
			"bust_in_silhouette",
			"busts_in_silhouette",
			"people_hugging",
			"footprints",
			"smiley_cat",
			"smile_cat",
			"joy_cat",
			"heart_eyes_cat",
			"smirk_cat",
			"kissing_cat",
			"scream_cat",
			"crying_cat_face",
			"pouting_cat",
			"see_no_evil",
			"hear_no_evil",
			"speak_no_evil",
			"kiss",
			"love_letter",
			"cupid",
			"gift_heart",
			"sparkling_heart",
			"heartpulse",
			"heartbeat",
			"revolving_hearts",
			"two_hearts",
			"heart_decoration",
			"heavy_heart_exclamation_mark_ornament",
			"broken_heart",
			"heart_on_fire",
			"mending_heart",
			"heart",
			"orange_heart",
			"yellow_heart",
			"green_heart",
			"blue_heart",
			"purple_heart",
			"brown_heart",
			"black_heart",
			"white_heart",
			"100",
			"anger",
			"boom",
			"dizzy",
			"sweat_drops",
			"dash",
			"hole",
			"bomb",
			"speech_balloon",
			"eye-in-speech-bubble",
			"left_speech_bubble",
			"right_anger_bubble",
			"thought_balloon",
			"zzz"
		]
	},
	{
		id: "nature",
		emojis: [
			"monkey_face",
			"monkey",
			"gorilla",
			"orangutan",
			"dog",
			"dog2",
			"guide_dog",
			"service_dog",
			"poodle",
			"wolf",
			"fox_face",
			"raccoon",
			"cat",
			"cat2",
			"black_cat",
			"lion_face",
			"tiger",
			"tiger2",
			"leopard",
			"horse",
			"racehorse",
			"unicorn_face",
			"zebra_face",
			"deer",
			"bison",
			"cow",
			"ox",
			"water_buffalo",
			"cow2",
			"pig",
			"pig2",
			"boar",
			"pig_nose",
			"ram",
			"sheep",
			"goat",
			"dromedary_camel",
			"camel",
			"llama",
			"giraffe_face",
			"elephant",
			"mammoth",
			"rhinoceros",
			"hippopotamus",
			"mouse",
			"mouse2",
			"rat",
			"hamster",
			"rabbit",
			"rabbit2",
			"chipmunk",
			"beaver",
			"hedgehog",
			"bat",
			"bear",
			"polar_bear",
			"koala",
			"panda_face",
			"sloth",
			"otter",
			"skunk",
			"kangaroo",
			"badger",
			"feet",
			"turkey",
			"chicken",
			"rooster",
			"hatching_chick",
			"baby_chick",
			"hatched_chick",
			"bird",
			"penguin",
			"dove_of_peace",
			"eagle",
			"duck",
			"swan",
			"owl",
			"dodo",
			"feather",
			"flamingo",
			"peacock",
			"parrot",
			"frog",
			"crocodile",
			"turtle",
			"lizard",
			"snake",
			"dragon_face",
			"dragon",
			"sauropod",
			"t-rex",
			"whale",
			"whale2",
			"dolphin",
			"seal",
			"fish",
			"tropical_fish",
			"blowfish",
			"shark",
			"octopus",
			"shell",
			"coral",
			"snail",
			"butterfly",
			"bug",
			"ant",
			"bee",
			"beetle",
			"ladybug",
			"cricket",
			"cockroach",
			"spider",
			"spider_web",
			"scorpion",
			"mosquito",
			"fly",
			"worm",
			"microbe",
			"bouquet",
			"cherry_blossom",
			"white_flower",
			"lotus",
			"rosette",
			"rose",
			"wilted_flower",
			"hibiscus",
			"sunflower",
			"blossom",
			"tulip",
			"seedling",
			"potted_plant",
			"evergreen_tree",
			"deciduous_tree",
			"palm_tree",
			"cactus",
			"ear_of_rice",
			"herb",
			"shamrock",
			"four_leaf_clover",
			"maple_leaf",
			"fallen_leaf",
			"leaves",
			"empty_nest",
			"nest_with_eggs"
		]
	},
	{
		id: "foods",
		emojis: [
			"grapes",
			"melon",
			"watermelon",
			"tangerine",
			"lemon",
			"banana",
			"pineapple",
			"mango",
			"apple",
			"green_apple",
			"pear",
			"peach",
			"cherries",
			"strawberry",
			"blueberries",
			"kiwifruit",
			"tomato",
			"olive",
			"coconut",
			"avocado",
			"eggplant",
			"potato",
			"carrot",
			"corn",
			"hot_pepper",
			"bell_pepper",
			"cucumber",
			"leafy_green",
			"broccoli",
			"garlic",
			"onion",
			"mushroom",
			"peanuts",
			"beans",
			"chestnut",
			"bread",
			"croissant",
			"baguette_bread",
			"flatbread",
			"pretzel",
			"bagel",
			"pancakes",
			"waffle",
			"cheese_wedge",
			"meat_on_bone",
			"poultry_leg",
			"cut_of_meat",
			"bacon",
			"hamburger",
			"fries",
			"pizza",
			"hotdog",
			"sandwich",
			"taco",
			"burrito",
			"tamale",
			"stuffed_flatbread",
			"falafel",
			"egg",
			"fried_egg",
			"shallow_pan_of_food",
			"stew",
			"fondue",
			"bowl_with_spoon",
			"green_salad",
			"popcorn",
			"butter",
			"salt",
			"canned_food",
			"bento",
			"rice_cracker",
			"rice_ball",
			"rice",
			"curry",
			"ramen",
			"spaghetti",
			"sweet_potato",
			"oden",
			"sushi",
			"fried_shrimp",
			"fish_cake",
			"moon_cake",
			"dango",
			"dumpling",
			"fortune_cookie",
			"takeout_box",
			"crab",
			"lobster",
			"shrimp",
			"squid",
			"oyster",
			"icecream",
			"shaved_ice",
			"ice_cream",
			"doughnut",
			"cookie",
			"birthday",
			"cake",
			"cupcake",
			"pie",
			"chocolate_bar",
			"candy",
			"lollipop",
			"custard",
			"honey_pot",
			"baby_bottle",
			"glass_of_milk",
			"coffee",
			"teapot",
			"tea",
			"sake",
			"champagne",
			"wine_glass",
			"cocktail",
			"tropical_drink",
			"beer",
			"beers",
			"clinking_glasses",
			"tumbler_glass",
			"pouring_liquid",
			"cup_with_straw",
			"bubble_tea",
			"beverage_box",
			"mate_drink",
			"ice_cube",
			"chopsticks",
			"knife_fork_plate",
			"fork_and_knife",
			"spoon",
			"hocho",
			"jar",
			"amphora"
		]
	},
	{
		id: "activity",
		emojis: [
			"jack_o_lantern",
			"christmas_tree",
			"fireworks",
			"sparkler",
			"firecracker",
			"sparkles",
			"balloon",
			"tada",
			"confetti_ball",
			"tanabata_tree",
			"bamboo",
			"dolls",
			"flags",
			"wind_chime",
			"rice_scene",
			"red_envelope",
			"ribbon",
			"gift",
			"reminder_ribbon",
			"admission_tickets",
			"ticket",
			"medal",
			"trophy",
			"sports_medal",
			"first_place_medal",
			"second_place_medal",
			"third_place_medal",
			"soccer",
			"baseball",
			"softball",
			"basketball",
			"volleyball",
			"football",
			"rugby_football",
			"tennis",
			"flying_disc",
			"bowling",
			"cricket_bat_and_ball",
			"field_hockey_stick_and_ball",
			"ice_hockey_stick_and_puck",
			"lacrosse",
			"table_tennis_paddle_and_ball",
			"badminton_racquet_and_shuttlecock",
			"boxing_glove",
			"martial_arts_uniform",
			"goal_net",
			"golf",
			"ice_skate",
			"fishing_pole_and_fish",
			"diving_mask",
			"running_shirt_with_sash",
			"ski",
			"sled",
			"curling_stone",
			"dart",
			"yo-yo",
			"kite",
			"8ball",
			"crystal_ball",
			"magic_wand",
			"nazar_amulet",
			"hamsa",
			"video_game",
			"joystick",
			"slot_machine",
			"game_die",
			"jigsaw",
			"teddy_bear",
			"pinata",
			"mirror_ball",
			"nesting_dolls",
			"spades",
			"hearts",
			"diamonds",
			"clubs",
			"chess_pawn",
			"black_joker",
			"mahjong",
			"flower_playing_cards",
			"performing_arts",
			"frame_with_picture",
			"art",
			"thread",
			"sewing_needle",
			"yarn",
			"knot"
		]
	},
	{
		id: "places",
		emojis: [
			"earth_africa",
			"earth_americas",
			"earth_asia",
			"globe_with_meridians",
			"world_map",
			"japan",
			"compass",
			"snow_capped_mountain",
			"mountain",
			"volcano",
			"mount_fuji",
			"camping",
			"beach_with_umbrella",
			"desert",
			"desert_island",
			"national_park",
			"stadium",
			"classical_building",
			"building_construction",
			"bricks",
			"rock",
			"wood",
			"hut",
			"house_buildings",
			"derelict_house_building",
			"house",
			"house_with_garden",
			"office",
			"post_office",
			"european_post_office",
			"hospital",
			"bank",
			"hotel",
			"love_hotel",
			"convenience_store",
			"school",
			"department_store",
			"factory",
			"japanese_castle",
			"european_castle",
			"wedding",
			"tokyo_tower",
			"statue_of_liberty",
			"church",
			"mosque",
			"hindu_temple",
			"synagogue",
			"shinto_shrine",
			"kaaba",
			"fountain",
			"tent",
			"foggy",
			"night_with_stars",
			"cityscape",
			"sunrise_over_mountains",
			"sunrise",
			"city_sunset",
			"city_sunrise",
			"bridge_at_night",
			"hotsprings",
			"carousel_horse",
			"playground_slide",
			"ferris_wheel",
			"roller_coaster",
			"barber",
			"circus_tent",
			"steam_locomotive",
			"railway_car",
			"bullettrain_side",
			"bullettrain_front",
			"train2",
			"metro",
			"light_rail",
			"station",
			"tram",
			"monorail",
			"mountain_railway",
			"train",
			"bus",
			"oncoming_bus",
			"trolleybus",
			"minibus",
			"ambulance",
			"fire_engine",
			"police_car",
			"oncoming_police_car",
			"taxi",
			"oncoming_taxi",
			"car",
			"oncoming_automobile",
			"blue_car",
			"pickup_truck",
			"truck",
			"articulated_lorry",
			"tractor",
			"racing_car",
			"racing_motorcycle",
			"motor_scooter",
			"manual_wheelchair",
			"motorized_wheelchair",
			"auto_rickshaw",
			"bike",
			"scooter",
			"skateboard",
			"roller_skate",
			"busstop",
			"motorway",
			"railway_track",
			"oil_drum",
			"fuelpump",
			"wheel",
			"rotating_light",
			"traffic_light",
			"vertical_traffic_light",
			"octagonal_sign",
			"construction",
			"anchor",
			"ring_buoy",
			"boat",
			"canoe",
			"speedboat",
			"passenger_ship",
			"ferry",
			"motor_boat",
			"ship",
			"airplane",
			"small_airplane",
			"airplane_departure",
			"airplane_arriving",
			"parachute",
			"seat",
			"helicopter",
			"suspension_railway",
			"mountain_cableway",
			"aerial_tramway",
			"satellite",
			"rocket",
			"flying_saucer",
			"bellhop_bell",
			"luggage",
			"hourglass",
			"hourglass_flowing_sand",
			"watch",
			"alarm_clock",
			"stopwatch",
			"timer_clock",
			"mantelpiece_clock",
			"clock12",
			"clock1230",
			"clock1",
			"clock130",
			"clock2",
			"clock230",
			"clock3",
			"clock330",
			"clock4",
			"clock430",
			"clock5",
			"clock530",
			"clock6",
			"clock630",
			"clock7",
			"clock730",
			"clock8",
			"clock830",
			"clock9",
			"clock930",
			"clock10",
			"clock1030",
			"clock11",
			"clock1130",
			"new_moon",
			"waxing_crescent_moon",
			"first_quarter_moon",
			"moon",
			"full_moon",
			"waning_gibbous_moon",
			"last_quarter_moon",
			"waning_crescent_moon",
			"crescent_moon",
			"new_moon_with_face",
			"first_quarter_moon_with_face",
			"last_quarter_moon_with_face",
			"thermometer",
			"sunny",
			"full_moon_with_face",
			"sun_with_face",
			"ringed_planet",
			"star",
			"star2",
			"stars",
			"milky_way",
			"cloud",
			"partly_sunny",
			"thunder_cloud_and_rain",
			"mostly_sunny",
			"barely_sunny",
			"partly_sunny_rain",
			"rain_cloud",
			"snow_cloud",
			"lightning",
			"tornado",
			"fog",
			"wind_blowing_face",
			"cyclone",
			"rainbow",
			"closed_umbrella",
			"umbrella",
			"umbrella_with_rain_drops",
			"umbrella_on_ground",
			"zap",
			"snowflake",
			"snowman",
			"snowman_without_snow",
			"comet",
			"fire",
			"droplet",
			"ocean"
		]
	},
	{
		id: "objects",
		emojis: [
			"eyeglasses",
			"dark_sunglasses",
			"goggles",
			"lab_coat",
			"safety_vest",
			"necktie",
			"shirt",
			"jeans",
			"scarf",
			"gloves",
			"coat",
			"socks",
			"dress",
			"kimono",
			"sari",
			"one-piece_swimsuit",
			"briefs",
			"shorts",
			"bikini",
			"womans_clothes",
			"purse",
			"handbag",
			"pouch",
			"shopping_bags",
			"school_satchel",
			"thong_sandal",
			"mans_shoe",
			"athletic_shoe",
			"hiking_boot",
			"womans_flat_shoe",
			"high_heel",
			"sandal",
			"ballet_shoes",
			"boot",
			"crown",
			"womans_hat",
			"tophat",
			"mortar_board",
			"billed_cap",
			"military_helmet",
			"helmet_with_white_cross",
			"prayer_beads",
			"lipstick",
			"ring",
			"gem",
			"mute",
			"speaker",
			"sound",
			"loud_sound",
			"loudspeaker",
			"mega",
			"postal_horn",
			"bell",
			"no_bell",
			"musical_score",
			"musical_note",
			"notes",
			"studio_microphone",
			"level_slider",
			"control_knobs",
			"microphone",
			"headphones",
			"radio",
			"saxophone",
			"accordion",
			"guitar",
			"musical_keyboard",
			"trumpet",
			"violin",
			"banjo",
			"drum_with_drumsticks",
			"long_drum",
			"iphone",
			"calling",
			"phone",
			"telephone_receiver",
			"pager",
			"fax",
			"battery",
			"low_battery",
			"electric_plug",
			"computer",
			"desktop_computer",
			"printer",
			"keyboard",
			"three_button_mouse",
			"trackball",
			"minidisc",
			"floppy_disk",
			"cd",
			"dvd",
			"abacus",
			"movie_camera",
			"film_frames",
			"film_projector",
			"clapper",
			"tv",
			"camera",
			"camera_with_flash",
			"video_camera",
			"vhs",
			"mag",
			"mag_right",
			"candle",
			"bulb",
			"flashlight",
			"izakaya_lantern",
			"diya_lamp",
			"notebook_with_decorative_cover",
			"closed_book",
			"book",
			"green_book",
			"blue_book",
			"orange_book",
			"books",
			"notebook",
			"ledger",
			"page_with_curl",
			"scroll",
			"page_facing_up",
			"newspaper",
			"rolled_up_newspaper",
			"bookmark_tabs",
			"bookmark",
			"label",
			"moneybag",
			"coin",
			"yen",
			"dollar",
			"euro",
			"pound",
			"money_with_wings",
			"credit_card",
			"receipt",
			"chart",
			"email",
			"e-mail",
			"incoming_envelope",
			"envelope_with_arrow",
			"outbox_tray",
			"inbox_tray",
			"package",
			"mailbox",
			"mailbox_closed",
			"mailbox_with_mail",
			"mailbox_with_no_mail",
			"postbox",
			"ballot_box_with_ballot",
			"pencil2",
			"black_nib",
			"lower_left_fountain_pen",
			"lower_left_ballpoint_pen",
			"lower_left_paintbrush",
			"lower_left_crayon",
			"memo",
			"briefcase",
			"file_folder",
			"open_file_folder",
			"card_index_dividers",
			"date",
			"calendar",
			"spiral_note_pad",
			"spiral_calendar_pad",
			"card_index",
			"chart_with_upwards_trend",
			"chart_with_downwards_trend",
			"bar_chart",
			"clipboard",
			"pushpin",
			"round_pushpin",
			"paperclip",
			"linked_paperclips",
			"straight_ruler",
			"triangular_ruler",
			"scissors",
			"card_file_box",
			"file_cabinet",
			"wastebasket",
			"lock",
			"unlock",
			"lock_with_ink_pen",
			"closed_lock_with_key",
			"key",
			"old_key",
			"hammer",
			"axe",
			"pick",
			"hammer_and_pick",
			"hammer_and_wrench",
			"dagger_knife",
			"crossed_swords",
			"gun",
			"boomerang",
			"bow_and_arrow",
			"shield",
			"carpentry_saw",
			"wrench",
			"screwdriver",
			"nut_and_bolt",
			"gear",
			"compression",
			"scales",
			"probing_cane",
			"link",
			"chains",
			"hook",
			"toolbox",
			"magnet",
			"ladder",
			"alembic",
			"test_tube",
			"petri_dish",
			"dna",
			"microscope",
			"telescope",
			"satellite_antenna",
			"syringe",
			"drop_of_blood",
			"pill",
			"adhesive_bandage",
			"crutch",
			"stethoscope",
			"x-ray",
			"door",
			"elevator",
			"mirror",
			"window",
			"bed",
			"couch_and_lamp",
			"chair",
			"toilet",
			"plunger",
			"shower",
			"bathtub",
			"mouse_trap",
			"razor",
			"lotion_bottle",
			"safety_pin",
			"broom",
			"basket",
			"roll_of_paper",
			"bucket",
			"soap",
			"bubbles",
			"toothbrush",
			"sponge",
			"fire_extinguisher",
			"shopping_trolley",
			"smoking",
			"coffin",
			"headstone",
			"funeral_urn",
			"moyai",
			"placard",
			"identification_card"
		]
	},
	{
		id: "symbols",
		emojis: [
			"atm",
			"put_litter_in_its_place",
			"potable_water",
			"wheelchair",
			"mens",
			"womens",
			"restroom",
			"baby_symbol",
			"wc",
			"passport_control",
			"customs",
			"baggage_claim",
			"left_luggage",
			"warning",
			"children_crossing",
			"no_entry",
			"no_entry_sign",
			"no_bicycles",
			"no_smoking",
			"do_not_litter",
			"non-potable_water",
			"no_pedestrians",
			"no_mobile_phones",
			"underage",
			"radioactive_sign",
			"biohazard_sign",
			"arrow_up",
			"arrow_upper_right",
			"arrow_right",
			"arrow_lower_right",
			"arrow_down",
			"arrow_lower_left",
			"arrow_left",
			"arrow_upper_left",
			"arrow_up_down",
			"left_right_arrow",
			"leftwards_arrow_with_hook",
			"arrow_right_hook",
			"arrow_heading_up",
			"arrow_heading_down",
			"arrows_clockwise",
			"arrows_counterclockwise",
			"back",
			"end",
			"on",
			"soon",
			"top",
			"place_of_worship",
			"atom_symbol",
			"om_symbol",
			"star_of_david",
			"wheel_of_dharma",
			"yin_yang",
			"latin_cross",
			"orthodox_cross",
			"star_and_crescent",
			"peace_symbol",
			"menorah_with_nine_branches",
			"six_pointed_star",
			"aries",
			"taurus",
			"gemini",
			"cancer",
			"leo",
			"virgo",
			"libra",
			"scorpius",
			"sagittarius",
			"capricorn",
			"aquarius",
			"pisces",
			"ophiuchus",
			"twisted_rightwards_arrows",
			"repeat",
			"repeat_one",
			"arrow_forward",
			"fast_forward",
			"black_right_pointing_double_triangle_with_vertical_bar",
			"black_right_pointing_triangle_with_double_vertical_bar",
			"arrow_backward",
			"rewind",
			"black_left_pointing_double_triangle_with_vertical_bar",
			"arrow_up_small",
			"arrow_double_up",
			"arrow_down_small",
			"arrow_double_down",
			"double_vertical_bar",
			"black_square_for_stop",
			"black_circle_for_record",
			"eject",
			"cinema",
			"low_brightness",
			"high_brightness",
			"signal_strength",
			"vibration_mode",
			"mobile_phone_off",
			"female_sign",
			"male_sign",
			"transgender_symbol",
			"heavy_multiplication_x",
			"heavy_plus_sign",
			"heavy_minus_sign",
			"heavy_division_sign",
			"heavy_equals_sign",
			"infinity",
			"bangbang",
			"interrobang",
			"question",
			"grey_question",
			"grey_exclamation",
			"exclamation",
			"wavy_dash",
			"currency_exchange",
			"heavy_dollar_sign",
			"medical_symbol",
			"recycle",
			"fleur_de_lis",
			"trident",
			"name_badge",
			"beginner",
			"o",
			"white_check_mark",
			"ballot_box_with_check",
			"heavy_check_mark",
			"x",
			"negative_squared_cross_mark",
			"curly_loop",
			"loop",
			"part_alternation_mark",
			"eight_spoked_asterisk",
			"eight_pointed_black_star",
			"sparkle",
			"copyright",
			"registered",
			"tm",
			"hash",
			"keycap_star",
			"zero",
			"one",
			"two",
			"three",
			"four",
			"five",
			"six",
			"seven",
			"eight",
			"nine",
			"keycap_ten",
			"capital_abcd",
			"abcd",
			"1234",
			"symbols",
			"abc",
			"a",
			"ab",
			"b",
			"cl",
			"cool",
			"free",
			"information_source",
			"id",
			"m",
			"new",
			"ng",
			"o2",
			"ok",
			"parking",
			"sos",
			"up",
			"vs",
			"koko",
			"sa",
			"u6708",
			"u6709",
			"u6307",
			"ideograph_advantage",
			"u5272",
			"u7121",
			"u7981",
			"accept",
			"u7533",
			"u5408",
			"u7a7a",
			"congratulations",
			"secret",
			"u55b6",
			"u6e80",
			"red_circle",
			"large_orange_circle",
			"large_yellow_circle",
			"large_green_circle",
			"large_blue_circle",
			"large_purple_circle",
			"large_brown_circle",
			"black_circle",
			"white_circle",
			"large_red_square",
			"large_orange_square",
			"large_yellow_square",
			"large_green_square",
			"large_blue_square",
			"large_purple_square",
			"large_brown_square",
			"black_large_square",
			"white_large_square",
			"black_medium_square",
			"white_medium_square",
			"black_medium_small_square",
			"white_medium_small_square",
			"black_small_square",
			"white_small_square",
			"large_orange_diamond",
			"large_blue_diamond",
			"small_orange_diamond",
			"small_blue_diamond",
			"small_red_triangle",
			"small_red_triangle_down",
			"diamond_shape_with_a_dot_inside",
			"radio_button",
			"white_square_button",
			"black_square_button"
		]
	},
	{
		id: "flags",
		emojis: [
			"checkered_flag",
			"cn",
			"crossed_flags",
			"de",
			"es",
			"flag-ac",
			"flag-ad",
			"flag-ae",
			"flag-af",
			"flag-ag",
			"flag-ai",
			"flag-al",
			"flag-am",
			"flag-ao",
			"flag-aq",
			"flag-ar",
			"flag-as",
			"flag-at",
			"flag-au",
			"flag-aw",
			"flag-ax",
			"flag-az",
			"flag-ba",
			"flag-bb",
			"flag-bd",
			"flag-be",
			"flag-bf",
			"flag-bg",
			"flag-bh",
			"flag-bi",
			"flag-bj",
			"flag-bl",
			"flag-bm",
			"flag-bn",
			"flag-bo",
			"flag-bq",
			"flag-br",
			"flag-bs",
			"flag-bt",
			"flag-bv",
			"flag-bw",
			"flag-by",
			"flag-bz",
			"flag-ca",
			"flag-cc",
			"flag-cd",
			"flag-cf",
			"flag-cg",
			"flag-ch",
			"flag-ci",
			"flag-ck",
			"flag-cl",
			"flag-cm",
			"flag-co",
			"flag-cp",
			"flag-cr",
			"flag-cu",
			"flag-cv",
			"flag-cw",
			"flag-cx",
			"flag-cy",
			"flag-cz",
			"flag-dg",
			"flag-dj",
			"flag-dk",
			"flag-dm",
			"flag-do",
			"flag-dz",
			"flag-ea",
			"flag-ec",
			"flag-ee",
			"flag-eg",
			"flag-eh",
			"flag-england",
			"flag-er",
			"flag-et",
			"flag-eu",
			"flag-fi",
			"flag-fj",
			"flag-fk",
			"flag-fm",
			"flag-fo",
			"flag-ga",
			"flag-gd",
			"flag-ge",
			"flag-gf",
			"flag-gg",
			"flag-gh",
			"flag-gi",
			"flag-gl",
			"flag-gm",
			"flag-gn",
			"flag-gp",
			"flag-gq",
			"flag-gr",
			"flag-gs",
			"flag-gt",
			"flag-gu",
			"flag-gw",
			"flag-gy",
			"flag-hk",
			"flag-hm",
			"flag-hn",
			"flag-hr",
			"flag-ht",
			"flag-hu",
			"flag-ic",
			"flag-id",
			"flag-ie",
			"flag-il",
			"flag-im",
			"flag-in",
			"flag-io",
			"flag-iq",
			"flag-ir",
			"flag-is",
			"flag-je",
			"flag-jm",
			"flag-jo",
			"flag-ke",
			"flag-kg",
			"flag-kh",
			"flag-ki",
			"flag-km",
			"flag-kn",
			"flag-kp",
			"flag-kw",
			"flag-ky",
			"flag-kz",
			"flag-la",
			"flag-lb",
			"flag-lc",
			"flag-li",
			"flag-lk",
			"flag-lr",
			"flag-ls",
			"flag-lt",
			"flag-lu",
			"flag-lv",
			"flag-ly",
			"flag-ma",
			"flag-mc",
			"flag-md",
			"flag-me",
			"flag-mf",
			"flag-mg",
			"flag-mh",
			"flag-mk",
			"flag-ml",
			"flag-mm",
			"flag-mn",
			"flag-mo",
			"flag-mp",
			"flag-mq",
			"flag-mr",
			"flag-ms",
			"flag-mt",
			"flag-mu",
			"flag-mv",
			"flag-mw",
			"flag-mx",
			"flag-my",
			"flag-mz",
			"flag-na",
			"flag-nc",
			"flag-ne",
			"flag-nf",
			"flag-ng",
			"flag-ni",
			"flag-nl",
			"flag-no",
			"flag-np",
			"flag-nr",
			"flag-nu",
			"flag-nz",
			"flag-om",
			"flag-pa",
			"flag-pe",
			"flag-pf",
			"flag-pg",
			"flag-ph",
			"flag-pk",
			"flag-pl",
			"flag-pm",
			"flag-pn",
			"flag-pr",
			"flag-ps",
			"flag-pt",
			"flag-pw",
			"flag-py",
			"flag-qa",
			"flag-re",
			"flag-ro",
			"flag-rs",
			"flag-rw",
			"flag-sa",
			"flag-sb",
			"flag-sc",
			"flag-scotland",
			"flag-sd",
			"flag-se",
			"flag-sg",
			"flag-sh",
			"flag-si",
			"flag-sj",
			"flag-sk",
			"flag-sl",
			"flag-sm",
			"flag-sn",
			"flag-so",
			"flag-sr",
			"flag-ss",
			"flag-st",
			"flag-sv",
			"flag-sx",
			"flag-sy",
			"flag-sz",
			"flag-ta",
			"flag-tc",
			"flag-td",
			"flag-tf",
			"flag-tg",
			"flag-th",
			"flag-tj",
			"flag-tk",
			"flag-tl",
			"flag-tm",
			"flag-tn",
			"flag-to",
			"flag-tr",
			"flag-tt",
			"flag-tv",
			"flag-tw",
			"flag-tz",
			"flag-ua",
			"flag-ug",
			"flag-um",
			"flag-un",
			"flag-uy",
			"flag-uz",
			"flag-va",
			"flag-vc",
			"flag-ve",
			"flag-vg",
			"flag-vi",
			"flag-vn",
			"flag-vu",
			"flag-wales",
			"flag-wf",
			"flag-ws",
			"flag-xk",
			"flag-ye",
			"flag-yt",
			"flag-za",
			"flag-zm",
			"flag-zw",
			"fr",
			"gb",
			"it",
			"jp",
			"kr",
			"pirate_flag",
			"rainbow-flag",
			"ru",
			"transgender_flag",
			"triangular_flag_on_post",
			"us",
			"waving_black_flag",
			"waving_white_flag"
		]
	}
];
var emojis = {
	"100": {
		id: "100",
		name: "Hundred Points",
		keywords: [
			"100",
			"score",
			"perfect",
			"numbers",
			"century",
			"exam",
			"quiz",
			"test",
			"pass"
		],
		skins: [
			{
				unified: "1f4af",
				native: "💯",
				x: 28,
				y: 6
			}
		],
		version: 1
	},
	"1234": {
		id: "1234",
		name: "Input Numbers",
		keywords: [
			"1234",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f522",
				native: "🔢",
				x: 29,
				y: 59
			}
		],
		version: 1
	},
	grinning: {
		id: "grinning",
		name: "Grinning Face",
		emoticons: [
			":D"
		],
		keywords: [
			"smile",
			"happy",
			"joy",
			":D",
			"grin"
		],
		skins: [
			{
				unified: "1f600",
				native: "😀",
				x: 32,
				y: 20
			}
		],
		version: 1
	},
	smiley: {
		id: "smiley",
		name: "Grinning Face with Big Eyes",
		emoticons: [
			":)",
			"=)",
			"=-)"
		],
		keywords: [
			"smiley",
			"happy",
			"joy",
			"haha",
			":D",
			":)",
			"smile",
			"funny"
		],
		skins: [
			{
				unified: "1f603",
				native: "😃",
				x: 32,
				y: 23
			}
		],
		version: 1
	},
	smile: {
		id: "smile",
		name: "Grinning Face with Smiling Eyes",
		emoticons: [
			":)",
			"C:",
			"c:",
			":D",
			":-D"
		],
		keywords: [
			"smile",
			"happy",
			"joy",
			"funny",
			"haha",
			"laugh",
			"like",
			":D",
			":)"
		],
		skins: [
			{
				unified: "1f604",
				native: "😄",
				x: 32,
				y: 24
			}
		],
		version: 1
	},
	grin: {
		id: "grin",
		name: "Beaming Face with Smiling Eyes",
		keywords: [
			"grin",
			"happy",
			"smile",
			"joy",
			"kawaii"
		],
		skins: [
			{
				unified: "1f601",
				native: "😁",
				x: 32,
				y: 21
			}
		],
		version: 1
	},
	laughing: {
		id: "laughing",
		name: "Grinning Squinting Face",
		emoticons: [
			":>",
			":->"
		],
		keywords: [
			"laughing",
			"satisfied",
			"happy",
			"joy",
			"lol",
			"haha",
			"glad",
			"XD",
			"laugh"
		],
		skins: [
			{
				unified: "1f606",
				native: "😆",
				x: 32,
				y: 26
			}
		],
		version: 1
	},
	sweat_smile: {
		id: "sweat_smile",
		name: "Grinning Face with Sweat",
		keywords: [
			"smile",
			"hot",
			"happy",
			"laugh",
			"relief"
		],
		skins: [
			{
				unified: "1f605",
				native: "😅",
				x: 32,
				y: 25
			}
		],
		version: 1
	},
	rolling_on_the_floor_laughing: {
		id: "rolling_on_the_floor_laughing",
		name: "Rolling on the Floor Laughing",
		keywords: [
			"face",
			"lol",
			"haha",
			"rofl"
		],
		skins: [
			{
				unified: "1f923",
				native: "🤣",
				x: 40,
				y: 15
			}
		],
		version: 3
	},
	joy: {
		id: "joy",
		name: "Face with Tears of Joy",
		keywords: [
			"cry",
			"weep",
			"happy",
			"happytears",
			"haha"
		],
		skins: [
			{
				unified: "1f602",
				native: "😂",
				x: 32,
				y: 22
			}
		],
		version: 1
	},
	slightly_smiling_face: {
		id: "slightly_smiling_face",
		name: "Slightly Smiling Face",
		emoticons: [
			":)",
			"(:",
			":-)"
		],
		keywords: [
			"smile"
		],
		skins: [
			{
				unified: "1f642",
				native: "🙂",
				x: 33,
				y: 28
			}
		],
		version: 1
	},
	upside_down_face: {
		id: "upside_down_face",
		name: "Upside-Down Face",
		keywords: [
			"upside",
			"down",
			"flipped",
			"silly",
			"smile"
		],
		skins: [
			{
				unified: "1f643",
				native: "🙃",
				x: 33,
				y: 29
			}
		],
		version: 1
	},
	melting_face: {
		id: "melting_face",
		name: "Melting Face",
		keywords: [
			"hot",
			"heat"
		],
		skins: [
			{
				unified: "1fae0",
				native: "🫠",
				x: 55,
				y: 12
			}
		],
		version: 14
	},
	wink: {
		id: "wink",
		name: "Winking Face",
		emoticons: [
			";)",
			";-)"
		],
		keywords: [
			"wink",
			"happy",
			"mischievous",
			"secret",
			";)",
			"smile",
			"eye"
		],
		skins: [
			{
				unified: "1f609",
				native: "😉",
				x: 32,
				y: 29
			}
		],
		version: 1
	},
	blush: {
		id: "blush",
		name: "Smiling Face with Smiling Eyes",
		emoticons: [
			":)"
		],
		keywords: [
			"blush",
			"smile",
			"happy",
			"flushed",
			"crush",
			"embarrassed",
			"shy",
			"joy"
		],
		skins: [
			{
				unified: "1f60a",
				native: "😊",
				x: 32,
				y: 30
			}
		],
		version: 1
	},
	innocent: {
		id: "innocent",
		name: "Smiling Face with Halo",
		keywords: [
			"innocent",
			"angel",
			"heaven"
		],
		skins: [
			{
				unified: "1f607",
				native: "😇",
				x: 32,
				y: 27
			}
		],
		version: 1
	},
	smiling_face_with_3_hearts: {
		id: "smiling_face_with_3_hearts",
		name: "Smiling Face with Hearts",
		keywords: [
			"3",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush",
			"adore"
		],
		skins: [
			{
				unified: "1f970",
				native: "🥰",
				x: 43,
				y: 58
			}
		],
		version: 11
	},
	heart_eyes: {
		id: "heart_eyes",
		name: "Smiling Face with Heart-Eyes",
		keywords: [
			"heart",
			"eyes",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"crush"
		],
		skins: [
			{
				unified: "1f60d",
				native: "😍",
				x: 32,
				y: 33
			}
		],
		version: 1
	},
	"star-struck": {
		id: "star-struck",
		name: "Star-Struck",
		keywords: [
			"star",
			"struck",
			"grinning",
			"face",
			"with",
			"eyes",
			"smile",
			"starry"
		],
		skins: [
			{
				unified: "1f929",
				native: "🤩",
				x: 40,
				y: 38
			}
		],
		version: 5
	},
	kissing_heart: {
		id: "kissing_heart",
		name: "Face Blowing a Kiss",
		emoticons: [
			":*",
			":-*"
		],
		keywords: [
			"kissing",
			"heart",
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation"
		],
		skins: [
			{
				unified: "1f618",
				native: "😘",
				x: 32,
				y: 44
			}
		],
		version: 1
	},
	kissing: {
		id: "kissing",
		name: "Kissing Face",
		keywords: [
			"love",
			"like",
			"3",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f617",
				native: "😗",
				x: 32,
				y: 43
			}
		],
		version: 1
	},
	relaxed: {
		id: "relaxed",
		name: "Smiling Face",
		keywords: [
			"relaxed",
			"blush",
			"massage",
			"happiness"
		],
		skins: [
			{
				unified: "263a-fe0f",
				native: "☺️",
				x: 57,
				y: 4
			}
		],
		version: 1
	},
	kissing_closed_eyes: {
		id: "kissing_closed_eyes",
		name: "Kissing Face with Closed Eyes",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f61a",
				native: "😚",
				x: 32,
				y: 46
			}
		],
		version: 1
	},
	kissing_smiling_eyes: {
		id: "kissing_smiling_eyes",
		name: "Kissing Face with Smiling Eyes",
		keywords: [
			"affection",
			"valentines",
			"infatuation",
			"kiss"
		],
		skins: [
			{
				unified: "1f619",
				native: "😙",
				x: 32,
				y: 45
			}
		],
		version: 1
	},
	smiling_face_with_tear: {
		id: "smiling_face_with_tear",
		name: "Smiling Face with Tear",
		keywords: [
			"sad",
			"cry",
			"pretend"
		],
		skins: [
			{
				unified: "1f972",
				native: "🥲",
				x: 43,
				y: 60
			}
		],
		version: 13
	},
	yum: {
		id: "yum",
		name: "Face Savoring Food",
		keywords: [
			"yum",
			"happy",
			"joy",
			"tongue",
			"smile",
			"silly",
			"yummy",
			"nom",
			"delicious",
			"savouring"
		],
		skins: [
			{
				unified: "1f60b",
				native: "😋",
				x: 32,
				y: 31
			}
		],
		version: 1
	},
	stuck_out_tongue: {
		id: "stuck_out_tongue",
		name: "Face with Tongue",
		emoticons: [
			":p",
			":-p",
			":P",
			":-P",
			":b",
			":-b"
		],
		keywords: [
			"stuck",
			"out",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile"
		],
		skins: [
			{
				unified: "1f61b",
				native: "😛",
				x: 32,
				y: 47
			}
		],
		version: 1
	},
	stuck_out_tongue_winking_eye: {
		id: "stuck_out_tongue_winking_eye",
		name: "Winking Face with Tongue",
		emoticons: [
			";p",
			";-p",
			";b",
			";-b",
			";P",
			";-P"
		],
		keywords: [
			"stuck",
			"out",
			"eye",
			"prank",
			"childish",
			"playful",
			"mischievous",
			"smile",
			"wink"
		],
		skins: [
			{
				unified: "1f61c",
				native: "😜",
				x: 32,
				y: 48
			}
		],
		version: 1
	},
	zany_face: {
		id: "zany_face",
		name: "Zany Face",
		keywords: [
			"grinning",
			"with",
			"one",
			"large",
			"and",
			"small",
			"eye",
			"goofy",
			"crazy"
		],
		skins: [
			{
				unified: "1f92a",
				native: "🤪",
				x: 40,
				y: 39
			}
		],
		version: 5
	},
	stuck_out_tongue_closed_eyes: {
		id: "stuck_out_tongue_closed_eyes",
		name: "Squinting Face with Tongue",
		keywords: [
			"stuck",
			"out",
			"closed",
			"eyes",
			"prank",
			"playful",
			"mischievous",
			"smile"
		],
		skins: [
			{
				unified: "1f61d",
				native: "😝",
				x: 32,
				y: 49
			}
		],
		version: 1
	},
	money_mouth_face: {
		id: "money_mouth_face",
		name: "Money-Mouth Face",
		keywords: [
			"money",
			"mouth",
			"rich",
			"dollar"
		],
		skins: [
			{
				unified: "1f911",
				native: "🤑",
				x: 38,
				y: 59
			}
		],
		version: 1
	},
	hugging_face: {
		id: "hugging_face",
		name: "Hugging Face",
		keywords: [
			"smile",
			"hug"
		],
		skins: [
			{
				unified: "1f917",
				native: "🤗",
				x: 39,
				y: 4
			}
		],
		version: 1
	},
	face_with_hand_over_mouth: {
		id: "face_with_hand_over_mouth",
		name: "Face with Hand over Mouth",
		keywords: [
			"smiling",
			"eyes",
			"and",
			"covering",
			"whoops",
			"shock",
			"surprise"
		],
		skins: [
			{
				unified: "1f92d",
				native: "🤭",
				x: 40,
				y: 42
			}
		],
		version: 5
	},
	face_with_open_eyes_and_hand_over_mouth: {
		id: "face_with_open_eyes_and_hand_over_mouth",
		name: "Face with Open Eyes and Hand over Mouth",
		keywords: [
			"silence",
			"secret",
			"shock",
			"surprise"
		],
		skins: [
			{
				unified: "1fae2",
				native: "🫢",
				x: 55,
				y: 14
			}
		],
		version: 14
	},
	face_with_peeking_eye: {
		id: "face_with_peeking_eye",
		name: "Face with Peeking Eye",
		keywords: [
			"scared",
			"frightening",
			"embarrassing"
		],
		skins: [
			{
				unified: "1fae3",
				native: "🫣",
				x: 55,
				y: 15
			}
		],
		version: 14
	},
	shushing_face: {
		id: "shushing_face",
		name: "Shushing Face",
		keywords: [
			"with",
			"finger",
			"covering",
			"closed",
			"lips",
			"quiet",
			"shhh"
		],
		skins: [
			{
				unified: "1f92b",
				native: "🤫",
				x: 40,
				y: 40
			}
		],
		version: 5
	},
	thinking_face: {
		id: "thinking_face",
		name: "Thinking Face",
		keywords: [
			"hmmm",
			"think",
			"consider"
		],
		skins: [
			{
				unified: "1f914",
				native: "🤔",
				x: 39,
				y: 1
			}
		],
		version: 1
	},
	saluting_face: {
		id: "saluting_face",
		name: "Saluting Face",
		keywords: [
			"respect",
			"salute"
		],
		skins: [
			{
				unified: "1fae1",
				native: "🫡",
				x: 55,
				y: 13
			}
		],
		version: 14
	},
	zipper_mouth_face: {
		id: "zipper_mouth_face",
		name: "Zipper-Mouth Face",
		keywords: [
			"zipper",
			"mouth",
			"sealed",
			"secret"
		],
		skins: [
			{
				unified: "1f910",
				native: "🤐",
				x: 38,
				y: 58
			}
		],
		version: 1
	},
	face_with_raised_eyebrow: {
		id: "face_with_raised_eyebrow",
		name: "Face with Raised Eyebrow",
		keywords: [
			"one",
			"distrust",
			"scepticism",
			"disapproval",
			"disbelief",
			"surprise"
		],
		skins: [
			{
				unified: "1f928",
				native: "🤨",
				x: 40,
				y: 37
			}
		],
		version: 5
	},
	neutral_face: {
		id: "neutral_face",
		name: "Neutral Face",
		emoticons: [
			":|",
			":-|"
		],
		keywords: [
			"indifference",
			"meh",
			":",
			""
		],
		skins: [
			{
				unified: "1f610",
				native: "😐",
				x: 32,
				y: 36
			}
		],
		version: 1
	},
	expressionless: {
		id: "expressionless",
		name: "Expressionless Face",
		emoticons: [
			"-_-"
		],
		keywords: [
			"indifferent",
			"-",
			"",
			"meh",
			"deadpan"
		],
		skins: [
			{
				unified: "1f611",
				native: "😑",
				x: 32,
				y: 37
			}
		],
		version: 1
	},
	no_mouth: {
		id: "no_mouth",
		name: "Face Without Mouth",
		keywords: [
			"no",
			"hellokitty"
		],
		skins: [
			{
				unified: "1f636",
				native: "😶",
				x: 33,
				y: 16
			}
		],
		version: 1
	},
	dotted_line_face: {
		id: "dotted_line_face",
		name: "Dotted Line Face",
		keywords: [
			"invisible",
			"lonely",
			"isolation",
			"depression"
		],
		skins: [
			{
				unified: "1fae5",
				native: "🫥",
				x: 55,
				y: 17
			}
		],
		version: 14
	},
	face_in_clouds: {
		id: "face_in_clouds",
		name: "Face in Clouds",
		keywords: [
			"shower",
			"steam",
			"dream"
		],
		skins: [
			{
				unified: "1f636-200d-1f32b-fe0f",
				native: "😶‍🌫️",
				x: 33,
				y: 15
			}
		],
		version: 13.1
	},
	smirk: {
		id: "smirk",
		name: "Smirking Face",
		keywords: [
			"smirk",
			"smile",
			"mean",
			"prank",
			"smug",
			"sarcasm"
		],
		skins: [
			{
				unified: "1f60f",
				native: "😏",
				x: 32,
				y: 35
			}
		],
		version: 1
	},
	unamused: {
		id: "unamused",
		name: "Unamused Face",
		emoticons: [
			":("
		],
		keywords: [
			"indifference",
			"bored",
			"straight",
			"serious",
			"sarcasm",
			"unimpressed",
			"skeptical",
			"dubious",
			"side",
			"eye"
		],
		skins: [
			{
				unified: "1f612",
				native: "😒",
				x: 32,
				y: 38
			}
		],
		version: 1
	},
	face_with_rolling_eyes: {
		id: "face_with_rolling_eyes",
		name: "Face with Rolling Eyes",
		keywords: [
			"eyeroll",
			"frustrated"
		],
		skins: [
			{
				unified: "1f644",
				native: "🙄",
				x: 33,
				y: 30
			}
		],
		version: 1
	},
	grimacing: {
		id: "grimacing",
		name: "Grimacing Face",
		keywords: [
			"grimace",
			"teeth"
		],
		skins: [
			{
				unified: "1f62c",
				native: "😬",
				x: 33,
				y: 3
			}
		],
		version: 1
	},
	face_exhaling: {
		id: "face_exhaling",
		name: "Face Exhaling",
		keywords: [
			"relieve",
			"relief",
			"tired",
			"sigh"
		],
		skins: [
			{
				unified: "1f62e-200d-1f4a8",
				native: "😮‍💨",
				x: 33,
				y: 5
			}
		],
		version: 13.1
	},
	lying_face: {
		id: "lying_face",
		name: "Lying Face",
		keywords: [
			"lie",
			"pinocchio"
		],
		skins: [
			{
				unified: "1f925",
				native: "🤥",
				x: 40,
				y: 17
			}
		],
		version: 3
	},
	relieved: {
		id: "relieved",
		name: "Relieved Face",
		keywords: [
			"relaxed",
			"phew",
			"massage",
			"happiness"
		],
		skins: [
			{
				unified: "1f60c",
				native: "😌",
				x: 32,
				y: 32
			}
		],
		version: 1
	},
	pensive: {
		id: "pensive",
		name: "Pensive Face",
		keywords: [
			"sad",
			"depressed",
			"upset"
		],
		skins: [
			{
				unified: "1f614",
				native: "😔",
				x: 32,
				y: 40
			}
		],
		version: 1
	},
	sleepy: {
		id: "sleepy",
		name: "Sleepy Face",
		keywords: [
			"tired",
			"rest",
			"nap"
		],
		skins: [
			{
				unified: "1f62a",
				native: "😪",
				x: 33,
				y: 1
			}
		],
		version: 1
	},
	drooling_face: {
		id: "drooling_face",
		name: "Drooling Face",
		keywords: [
		],
		skins: [
			{
				unified: "1f924",
				native: "🤤",
				x: 40,
				y: 16
			}
		],
		version: 3
	},
	sleeping: {
		id: "sleeping",
		name: "Sleeping Face",
		keywords: [
			"tired",
			"sleepy",
			"night",
			"zzz"
		],
		skins: [
			{
				unified: "1f634",
				native: "😴",
				x: 33,
				y: 12
			}
		],
		version: 1
	},
	mask: {
		id: "mask",
		name: "Face with Medical Mask",
		keywords: [
			"sick",
			"ill",
			"disease"
		],
		skins: [
			{
				unified: "1f637",
				native: "😷",
				x: 33,
				y: 17
			}
		],
		version: 1
	},
	face_with_thermometer: {
		id: "face_with_thermometer",
		name: "Face with Thermometer",
		keywords: [
			"sick",
			"temperature",
			"cold",
			"fever"
		],
		skins: [
			{
				unified: "1f912",
				native: "🤒",
				x: 38,
				y: 60
			}
		],
		version: 1
	},
	face_with_head_bandage: {
		id: "face_with_head_bandage",
		name: "Face with Head-Bandage",
		keywords: [
			"head",
			"bandage",
			"injured",
			"clumsy",
			"hurt"
		],
		skins: [
			{
				unified: "1f915",
				native: "🤕",
				x: 39,
				y: 2
			}
		],
		version: 1
	},
	nauseated_face: {
		id: "nauseated_face",
		name: "Nauseated Face",
		keywords: [
			"vomit",
			"gross",
			"green",
			"sick",
			"throw",
			"up",
			"ill"
		],
		skins: [
			{
				unified: "1f922",
				native: "🤢",
				x: 40,
				y: 14
			}
		],
		version: 3
	},
	face_vomiting: {
		id: "face_vomiting",
		name: "Face Vomiting",
		keywords: [
			"with",
			"open",
			"mouth",
			"sick"
		],
		skins: [
			{
				unified: "1f92e",
				native: "🤮",
				x: 40,
				y: 43
			}
		],
		version: 5
	},
	sneezing_face: {
		id: "sneezing_face",
		name: "Sneezing Face",
		keywords: [
			"gesundheit",
			"sneeze",
			"sick",
			"allergy"
		],
		skins: [
			{
				unified: "1f927",
				native: "🤧",
				x: 40,
				y: 36
			}
		],
		version: 3
	},
	hot_face: {
		id: "hot_face",
		name: "Hot Face",
		keywords: [
			"feverish",
			"heat",
			"red",
			"sweating"
		],
		skins: [
			{
				unified: "1f975",
				native: "🥵",
				x: 44,
				y: 2
			}
		],
		version: 11
	},
	cold_face: {
		id: "cold_face",
		name: "Cold Face",
		keywords: [
			"blue",
			"freezing",
			"frozen",
			"frostbite",
			"icicles"
		],
		skins: [
			{
				unified: "1f976",
				native: "🥶",
				x: 44,
				y: 3
			}
		],
		version: 11
	},
	woozy_face: {
		id: "woozy_face",
		name: "Woozy Face",
		keywords: [
			"dizzy",
			"intoxicated",
			"tipsy",
			"wavy"
		],
		skins: [
			{
				unified: "1f974",
				native: "🥴",
				x: 44,
				y: 1
			}
		],
		version: 11
	},
	dizzy_face: {
		id: "dizzy_face",
		name: "Dizzy Face",
		keywords: [
			"spent",
			"unconscious",
			"xox"
		],
		skins: [
			{
				unified: "1f635",
				native: "😵",
				x: 33,
				y: 14
			}
		],
		version: 1
	},
	face_with_spiral_eyes: {
		id: "face_with_spiral_eyes",
		name: "Face with Spiral Eyes",
		keywords: [
			"sick",
			"ill",
			"confused",
			"nauseous",
			"nausea"
		],
		skins: [
			{
				unified: "1f635-200d-1f4ab",
				native: "😵‍💫",
				x: 33,
				y: 13
			}
		],
		version: 13.1
	},
	exploding_head: {
		id: "exploding_head",
		name: "Exploding Head",
		keywords: [
			"shocked",
			"face",
			"with",
			"mind",
			"blown"
		],
		skins: [
			{
				unified: "1f92f",
				native: "🤯",
				x: 40,
				y: 44
			}
		],
		version: 5
	},
	face_with_cowboy_hat: {
		id: "face_with_cowboy_hat",
		name: "Cowboy Hat Face",
		keywords: [
			"with",
			"cowgirl"
		],
		skins: [
			{
				unified: "1f920",
				native: "🤠",
				x: 40,
				y: 12
			}
		],
		version: 3
	},
	partying_face: {
		id: "partying_face",
		name: "Partying Face",
		keywords: [
			"celebration",
			"woohoo"
		],
		skins: [
			{
				unified: "1f973",
				native: "🥳",
				x: 44,
				y: 0
			}
		],
		version: 11
	},
	disguised_face: {
		id: "disguised_face",
		name: "Disguised Face",
		keywords: [
			"pretent",
			"brows",
			"glasses",
			"moustache"
		],
		skins: [
			{
				unified: "1f978",
				native: "🥸",
				x: 44,
				y: 10
			}
		],
		version: 13
	},
	sunglasses: {
		id: "sunglasses",
		name: "Smiling Face with Sunglasses",
		emoticons: [
			"8)"
		],
		keywords: [
			"cool",
			"smile",
			"summer",
			"beach",
			"sunglass"
		],
		skins: [
			{
				unified: "1f60e",
				native: "😎",
				x: 32,
				y: 34
			}
		],
		version: 1
	},
	nerd_face: {
		id: "nerd_face",
		name: "Nerd Face",
		keywords: [
			"nerdy",
			"geek",
			"dork"
		],
		skins: [
			{
				unified: "1f913",
				native: "🤓",
				x: 39,
				y: 0
			}
		],
		version: 1
	},
	face_with_monocle: {
		id: "face_with_monocle",
		name: "Face with Monocle",
		keywords: [
			"stuffy",
			"wealthy"
		],
		skins: [
			{
				unified: "1f9d0",
				native: "🧐",
				x: 47,
				y: 11
			}
		],
		version: 5
	},
	confused: {
		id: "confused",
		name: "Confused Face",
		emoticons: [
			":\\",
			":-\\",
			":/",
			":-/"
		],
		keywords: [
			"indifference",
			"huh",
			"weird",
			"hmmm",
			":/"
		],
		skins: [
			{
				unified: "1f615",
				native: "😕",
				x: 32,
				y: 41
			}
		],
		version: 1
	},
	face_with_diagonal_mouth: {
		id: "face_with_diagonal_mouth",
		name: "Face with Diagonal Mouth",
		keywords: [
			"skeptic",
			"confuse",
			"frustrated",
			"indifferent"
		],
		skins: [
			{
				unified: "1fae4",
				native: "🫤",
				x: 55,
				y: 16
			}
		],
		version: 14
	},
	worried: {
		id: "worried",
		name: "Worried Face",
		keywords: [
			"concern",
			"nervous",
			":("
		],
		skins: [
			{
				unified: "1f61f",
				native: "😟",
				x: 32,
				y: 51
			}
		],
		version: 1
	},
	slightly_frowning_face: {
		id: "slightly_frowning_face",
		name: "Slightly Frowning Face",
		keywords: [
			"disappointed",
			"sad",
			"upset"
		],
		skins: [
			{
				unified: "1f641",
				native: "🙁",
				x: 33,
				y: 27
			}
		],
		version: 1
	},
	white_frowning_face: {
		id: "white_frowning_face",
		name: "Frowning Face",
		keywords: [
			"white",
			"sad",
			"upset",
			"frown"
		],
		skins: [
			{
				unified: "2639-fe0f",
				native: "☹️",
				x: 57,
				y: 3
			}
		],
		version: 1
	},
	open_mouth: {
		id: "open_mouth",
		name: "Face with Open Mouth",
		emoticons: [
			":o",
			":-o",
			":O",
			":-O"
		],
		keywords: [
			"surprise",
			"impressed",
			"wow",
			"whoa",
			":O"
		],
		skins: [
			{
				unified: "1f62e",
				native: "😮",
				x: 33,
				y: 6
			}
		],
		version: 1
	},
	hushed: {
		id: "hushed",
		name: "Hushed Face",
		keywords: [
			"woo",
			"shh"
		],
		skins: [
			{
				unified: "1f62f",
				native: "😯",
				x: 33,
				y: 7
			}
		],
		version: 1
	},
	astonished: {
		id: "astonished",
		name: "Astonished Face",
		keywords: [
			"xox",
			"surprised",
			"poisoned"
		],
		skins: [
			{
				unified: "1f632",
				native: "😲",
				x: 33,
				y: 10
			}
		],
		version: 1
	},
	flushed: {
		id: "flushed",
		name: "Flushed Face",
		keywords: [
			"blush",
			"shy",
			"flattered"
		],
		skins: [
			{
				unified: "1f633",
				native: "😳",
				x: 33,
				y: 11
			}
		],
		version: 1
	},
	pleading_face: {
		id: "pleading_face",
		name: "Pleading Face",
		keywords: [
			"begging",
			"mercy"
		],
		skins: [
			{
				unified: "1f97a",
				native: "🥺",
				x: 44,
				y: 12
			}
		],
		version: 11
	},
	face_holding_back_tears: {
		id: "face_holding_back_tears",
		name: "Face Holding Back Tears",
		keywords: [
			"touched",
			"gratitude"
		],
		skins: [
			{
				unified: "1f979",
				native: "🥹",
				x: 44,
				y: 11
			}
		],
		version: 14
	},
	frowning: {
		id: "frowning",
		name: "Frowning Face with Open Mouth",
		keywords: [
			"aw",
			"what"
		],
		skins: [
			{
				unified: "1f626",
				native: "😦",
				x: 32,
				y: 58
			}
		],
		version: 1
	},
	anguished: {
		id: "anguished",
		name: "Anguished Face",
		emoticons: [
			"D:"
		],
		keywords: [
			"stunned",
			"nervous"
		],
		skins: [
			{
				unified: "1f627",
				native: "😧",
				x: 32,
				y: 59
			}
		],
		version: 1
	},
	fearful: {
		id: "fearful",
		name: "Fearful Face",
		keywords: [
			"scared",
			"terrified",
			"nervous",
			"oops",
			"huh"
		],
		skins: [
			{
				unified: "1f628",
				native: "😨",
				x: 32,
				y: 60
			}
		],
		version: 1
	},
	cold_sweat: {
		id: "cold_sweat",
		name: "Anxious Face with Sweat",
		keywords: [
			"cold",
			"nervous"
		],
		skins: [
			{
				unified: "1f630",
				native: "😰",
				x: 33,
				y: 8
			}
		],
		version: 1
	},
	disappointed_relieved: {
		id: "disappointed_relieved",
		name: "Sad but Relieved Face",
		keywords: [
			"disappointed",
			"phew",
			"sweat",
			"nervous"
		],
		skins: [
			{
				unified: "1f625",
				native: "😥",
				x: 32,
				y: 57
			}
		],
		version: 1
	},
	cry: {
		id: "cry",
		name: "Crying Face",
		emoticons: [
			":'("
		],
		keywords: [
			"cry",
			"tears",
			"sad",
			"depressed",
			"upset",
			":'("
		],
		skins: [
			{
				unified: "1f622",
				native: "😢",
				x: 32,
				y: 54
			}
		],
		version: 1
	},
	sob: {
		id: "sob",
		name: "Loudly Crying Face",
		emoticons: [
			":'("
		],
		keywords: [
			"sob",
			"cry",
			"tears",
			"sad",
			"upset",
			"depressed"
		],
		skins: [
			{
				unified: "1f62d",
				native: "😭",
				x: 33,
				y: 4
			}
		],
		version: 1
	},
	scream: {
		id: "scream",
		name: "Face Screaming in Fear",
		keywords: [
			"scream",
			"munch",
			"scared",
			"omg"
		],
		skins: [
			{
				unified: "1f631",
				native: "😱",
				x: 33,
				y: 9
			}
		],
		version: 1
	},
	confounded: {
		id: "confounded",
		name: "Confounded Face",
		keywords: [
			"confused",
			"sick",
			"unwell",
			"oops",
			":S"
		],
		skins: [
			{
				unified: "1f616",
				native: "😖",
				x: 32,
				y: 42
			}
		],
		version: 1
	},
	persevere: {
		id: "persevere",
		name: "Persevering Face",
		keywords: [
			"persevere",
			"sick",
			"no",
			"upset",
			"oops"
		],
		skins: [
			{
				unified: "1f623",
				native: "😣",
				x: 32,
				y: 55
			}
		],
		version: 1
	},
	disappointed: {
		id: "disappointed",
		name: "Disappointed Face",
		emoticons: [
			"):",
			":(",
			":-("
		],
		keywords: [
			"sad",
			"upset",
			"depressed",
			":("
		],
		skins: [
			{
				unified: "1f61e",
				native: "😞",
				x: 32,
				y: 50
			}
		],
		version: 1
	},
	sweat: {
		id: "sweat",
		name: "Face with Cold Sweat",
		keywords: [
			"downcast",
			"hot",
			"sad",
			"tired",
			"exercise"
		],
		skins: [
			{
				unified: "1f613",
				native: "😓",
				x: 32,
				y: 39
			}
		],
		version: 1
	},
	weary: {
		id: "weary",
		name: "Weary Face",
		keywords: [
			"tired",
			"sleepy",
			"sad",
			"frustrated",
			"upset"
		],
		skins: [
			{
				unified: "1f629",
				native: "😩",
				x: 33,
				y: 0
			}
		],
		version: 1
	},
	tired_face: {
		id: "tired_face",
		name: "Tired Face",
		keywords: [
			"sick",
			"whine",
			"upset",
			"frustrated"
		],
		skins: [
			{
				unified: "1f62b",
				native: "😫",
				x: 33,
				y: 2
			}
		],
		version: 1
	},
	yawning_face: {
		id: "yawning_face",
		name: "Yawning Face",
		keywords: [
			"tired",
			"sleepy"
		],
		skins: [
			{
				unified: "1f971",
				native: "🥱",
				x: 43,
				y: 59
			}
		],
		version: 12
	},
	triumph: {
		id: "triumph",
		name: "Face with Look of Triumph",
		keywords: [
			"steam",
			"from",
			"nose",
			"gas",
			"phew",
			"proud",
			"pride"
		],
		skins: [
			{
				unified: "1f624",
				native: "😤",
				x: 32,
				y: 56
			}
		],
		version: 1
	},
	rage: {
		id: "rage",
		name: "Pouting Face",
		keywords: [
			"rage",
			"angry",
			"mad",
			"hate",
			"despise"
		],
		skins: [
			{
				unified: "1f621",
				native: "😡",
				x: 32,
				y: 53
			}
		],
		version: 1
	},
	angry: {
		id: "angry",
		name: "Angry Face",
		emoticons: [
			">:(",
			">:-("
		],
		keywords: [
			"mad",
			"annoyed",
			"frustrated"
		],
		skins: [
			{
				unified: "1f620",
				native: "😠",
				x: 32,
				y: 52
			}
		],
		version: 1
	},
	face_with_symbols_on_mouth: {
		id: "face_with_symbols_on_mouth",
		name: "Face with Symbols on Mouth",
		keywords: [
			"serious",
			"covering",
			"swearing",
			"cursing",
			"cussing",
			"profanity",
			"expletive"
		],
		skins: [
			{
				unified: "1f92c",
				native: "🤬",
				x: 40,
				y: 41
			}
		],
		version: 5
	},
	smiling_imp: {
		id: "smiling_imp",
		name: "Smiling Face with Horns",
		keywords: [
			"imp",
			"devil"
		],
		skins: [
			{
				unified: "1f608",
				native: "😈",
				x: 32,
				y: 28
			}
		],
		version: 1
	},
	imp: {
		id: "imp",
		name: "Imp",
		keywords: [
			"angry",
			"face",
			"with",
			"horns",
			"devil"
		],
		skins: [
			{
				unified: "1f47f",
				native: "👿",
				x: 25,
				y: 8
			}
		],
		version: 1
	},
	skull: {
		id: "skull",
		name: "Skull",
		keywords: [
			"dead",
			"skeleton",
			"creepy",
			"death"
		],
		skins: [
			{
				unified: "1f480",
				native: "💀",
				x: 25,
				y: 9
			}
		],
		version: 1
	},
	skull_and_crossbones: {
		id: "skull_and_crossbones",
		name: "Skull and Crossbones",
		keywords: [
			"poison",
			"danger",
			"deadly",
			"scary",
			"death",
			"pirate",
			"evil"
		],
		skins: [
			{
				unified: "2620-fe0f",
				native: "☠️",
				x: 56,
				y: 56
			}
		],
		version: 1
	},
	hankey: {
		id: "hankey",
		name: "Pile of Poo",
		keywords: [
			"hankey",
			"poop",
			"shit",
			"shitface",
			"fail",
			"turd"
		],
		skins: [
			{
				unified: "1f4a9",
				native: "💩",
				x: 27,
				y: 56
			}
		],
		version: 1
	},
	clown_face: {
		id: "clown_face",
		name: "Clown Face",
		keywords: [
		],
		skins: [
			{
				unified: "1f921",
				native: "🤡",
				x: 40,
				y: 13
			}
		],
		version: 3
	},
	japanese_ogre: {
		id: "japanese_ogre",
		name: "Ogre",
		keywords: [
			"japanese",
			"monster",
			"red",
			"mask",
			"halloween",
			"scary",
			"creepy",
			"devil",
			"demon"
		],
		skins: [
			{
				unified: "1f479",
				native: "👹",
				x: 24,
				y: 58
			}
		],
		version: 1
	},
	japanese_goblin: {
		id: "japanese_goblin",
		name: "Goblin",
		keywords: [
			"japanese",
			"red",
			"evil",
			"mask",
			"monster",
			"scary",
			"creepy"
		],
		skins: [
			{
				unified: "1f47a",
				native: "👺",
				x: 24,
				y: 59
			}
		],
		version: 1
	},
	ghost: {
		id: "ghost",
		name: "Ghost",
		keywords: [
			"halloween",
			"spooky",
			"scary"
		],
		skins: [
			{
				unified: "1f47b",
				native: "👻",
				x: 24,
				y: 60
			}
		],
		version: 1
	},
	alien: {
		id: "alien",
		name: "Alien",
		keywords: [
			"UFO",
			"paul",
			"weird",
			"outer",
			"space"
		],
		skins: [
			{
				unified: "1f47d",
				native: "👽",
				x: 25,
				y: 6
			}
		],
		version: 1
	},
	space_invader: {
		id: "space_invader",
		name: "Alien Monster",
		keywords: [
			"space",
			"invader",
			"game",
			"arcade",
			"play"
		],
		skins: [
			{
				unified: "1f47e",
				native: "👾",
				x: 25,
				y: 7
			}
		],
		version: 1
	},
	robot_face: {
		id: "robot_face",
		name: "Robot",
		keywords: [
			"face",
			"computer",
			"machine",
			"bot"
		],
		skins: [
			{
				unified: "1f916",
				native: "🤖",
				x: 39,
				y: 3
			}
		],
		version: 1
	},
	smiley_cat: {
		id: "smiley_cat",
		name: "Grinning Cat",
		keywords: [
			"smiley",
			"animal",
			"cats",
			"happy",
			"smile"
		],
		skins: [
			{
				unified: "1f63a",
				native: "😺",
				x: 33,
				y: 20
			}
		],
		version: 1
	},
	smile_cat: {
		id: "smile_cat",
		name: "Grinning Cat with Smiling Eyes",
		keywords: [
			"smile",
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f638",
				native: "😸",
				x: 33,
				y: 18
			}
		],
		version: 1
	},
	joy_cat: {
		id: "joy_cat",
		name: "Cat with Tears of Joy",
		keywords: [
			"animal",
			"cats",
			"haha",
			"happy"
		],
		skins: [
			{
				unified: "1f639",
				native: "😹",
				x: 33,
				y: 19
			}
		],
		version: 1
	},
	heart_eyes_cat: {
		id: "heart_eyes_cat",
		name: "Smiling Cat with Heart-Eyes",
		keywords: [
			"heart",
			"eyes",
			"animal",
			"love",
			"like",
			"affection",
			"cats",
			"valentines"
		],
		skins: [
			{
				unified: "1f63b",
				native: "😻",
				x: 33,
				y: 21
			}
		],
		version: 1
	},
	smirk_cat: {
		id: "smirk_cat",
		name: "Cat with Wry Smile",
		keywords: [
			"smirk",
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f63c",
				native: "😼",
				x: 33,
				y: 22
			}
		],
		version: 1
	},
	kissing_cat: {
		id: "kissing_cat",
		name: "Kissing Cat",
		keywords: [
			"animal",
			"cats",
			"kiss"
		],
		skins: [
			{
				unified: "1f63d",
				native: "😽",
				x: 33,
				y: 23
			}
		],
		version: 1
	},
	scream_cat: {
		id: "scream_cat",
		name: "Weary Cat",
		keywords: [
			"scream",
			"animal",
			"cats",
			"munch",
			"scared"
		],
		skins: [
			{
				unified: "1f640",
				native: "🙀",
				x: 33,
				y: 26
			}
		],
		version: 1
	},
	crying_cat_face: {
		id: "crying_cat_face",
		name: "Crying Cat",
		keywords: [
			"face",
			"animal",
			"tears",
			"weep",
			"sad",
			"cats",
			"upset",
			"cry"
		],
		skins: [
			{
				unified: "1f63f",
				native: "😿",
				x: 33,
				y: 25
			}
		],
		version: 1
	},
	pouting_cat: {
		id: "pouting_cat",
		name: "Pouting Cat",
		keywords: [
			"animal",
			"cats"
		],
		skins: [
			{
				unified: "1f63e",
				native: "😾",
				x: 33,
				y: 24
			}
		],
		version: 1
	},
	see_no_evil: {
		id: "see_no_evil",
		name: "See-No-Evil Monkey",
		keywords: [
			"see",
			"no",
			"evil",
			"animal",
			"nature",
			"haha"
		],
		skins: [
			{
				unified: "1f648",
				native: "🙈",
				x: 34,
				y: 24
			}
		],
		version: 1
	},
	hear_no_evil: {
		id: "hear_no_evil",
		name: "Hear-No-Evil Monkey",
		keywords: [
			"hear",
			"no",
			"evil",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f649",
				native: "🙉",
				x: 34,
				y: 25
			}
		],
		version: 1
	},
	speak_no_evil: {
		id: "speak_no_evil",
		name: "Speak-No-Evil Monkey",
		keywords: [
			"speak",
			"no",
			"evil",
			"animal",
			"nature",
			"omg"
		],
		skins: [
			{
				unified: "1f64a",
				native: "🙊",
				x: 34,
				y: 26
			}
		],
		version: 1
	},
	kiss: {
		id: "kiss",
		name: "Kiss Mark",
		keywords: [
			"face",
			"lips",
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f48b",
				native: "💋",
				x: 26,
				y: 37
			}
		],
		version: 1
	},
	love_letter: {
		id: "love_letter",
		name: "Love Letter",
		keywords: [
			"email",
			"like",
			"affection",
			"envelope",
			"valentines"
		],
		skins: [
			{
				unified: "1f48c",
				native: "💌",
				x: 26,
				y: 38
			}
		],
		version: 1
	},
	cupid: {
		id: "cupid",
		name: "Heart with Arrow",
		keywords: [
			"cupid",
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f498",
				native: "💘",
				x: 27,
				y: 39
			}
		],
		version: 1
	},
	gift_heart: {
		id: "gift_heart",
		name: "Heart with Ribbon",
		keywords: [
			"gift",
			"love",
			"valentines"
		],
		skins: [
			{
				unified: "1f49d",
				native: "💝",
				x: 27,
				y: 44
			}
		],
		version: 1
	},
	sparkling_heart: {
		id: "sparkling_heart",
		name: "Sparkling Heart",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f496",
				native: "💖",
				x: 27,
				y: 37
			}
		],
		version: 1
	},
	heartpulse: {
		id: "heartpulse",
		name: "Growing Heart",
		keywords: [
			"heartpulse",
			"like",
			"love",
			"affection",
			"valentines",
			"pink"
		],
		skins: [
			{
				unified: "1f497",
				native: "💗",
				x: 27,
				y: 38
			}
		],
		version: 1
	},
	heartbeat: {
		id: "heartbeat",
		name: "Beating Heart",
		keywords: [
			"heartbeat",
			"love",
			"like",
			"affection",
			"valentines",
			"pink"
		],
		skins: [
			{
				unified: "1f493",
				native: "💓",
				x: 27,
				y: 34
			}
		],
		version: 1
	},
	revolving_hearts: {
		id: "revolving_hearts",
		name: "Revolving Hearts",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49e",
				native: "💞",
				x: 27,
				y: 45
			}
		],
		version: 1
	},
	two_hearts: {
		id: "two_hearts",
		name: "Two Hearts",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines",
			"heart"
		],
		skins: [
			{
				unified: "1f495",
				native: "💕",
				x: 27,
				y: 36
			}
		],
		version: 1
	},
	heart_decoration: {
		id: "heart_decoration",
		name: "Heart Decoration",
		keywords: [
			"purple",
			"square",
			"love",
			"like"
		],
		skins: [
			{
				unified: "1f49f",
				native: "💟",
				x: 27,
				y: 46
			}
		],
		version: 1
	},
	heavy_heart_exclamation_mark_ornament: {
		id: "heavy_heart_exclamation_mark_ornament",
		name: "Heart Exclamation",
		keywords: [
			"heavy",
			"mark",
			"ornament",
			"decoration",
			"love"
		],
		skins: [
			{
				unified: "2763-fe0f",
				native: "❣️",
				x: 59,
				y: 7
			}
		],
		version: 1
	},
	broken_heart: {
		id: "broken_heart",
		name: "Broken Heart",
		emoticons: [
			"</3"
		],
		keywords: [
			"sad",
			"sorry",
			"break",
			"heartbreak"
		],
		skins: [
			{
				unified: "1f494",
				native: "💔",
				x: 27,
				y: 35
			}
		],
		version: 1
	},
	heart_on_fire: {
		id: "heart_on_fire",
		name: "Heart on Fire",
		keywords: [
			"passionate",
			"enthusiastic"
		],
		skins: [
			{
				unified: "2764-fe0f-200d-1f525",
				native: "❤️‍🔥",
				x: 59,
				y: 8
			}
		],
		version: 13.1
	},
	mending_heart: {
		id: "mending_heart",
		name: "Mending Heart",
		keywords: [
			"broken",
			"bandage",
			"wounded"
		],
		skins: [
			{
				unified: "2764-fe0f-200d-1fa79",
				native: "❤️‍🩹",
				x: 59,
				y: 9
			}
		],
		version: 13.1
	},
	heart: {
		id: "heart",
		name: "Red Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"valentines"
		],
		skins: [
			{
				unified: "2764-fe0f",
				native: "❤️",
				x: 59,
				y: 10
			}
		],
		version: 1
	},
	orange_heart: {
		id: "orange_heart",
		name: "Orange Heart",
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f9e1",
				native: "🧡",
				x: 53,
				y: 15
			}
		],
		version: 5
	},
	yellow_heart: {
		id: "yellow_heart",
		name: "Yellow Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49b",
				native: "💛",
				x: 27,
				y: 42
			}
		],
		version: 1
	},
	green_heart: {
		id: "green_heart",
		name: "Green Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49a",
				native: "💚",
				x: 27,
				y: 41
			}
		],
		version: 1
	},
	blue_heart: {
		id: "blue_heart",
		name: "Blue Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f499",
				native: "💙",
				x: 27,
				y: 40
			}
		],
		version: 1
	},
	purple_heart: {
		id: "purple_heart",
		name: "Purple Heart",
		emoticons: [
			"<3"
		],
		keywords: [
			"love",
			"like",
			"affection",
			"valentines"
		],
		skins: [
			{
				unified: "1f49c",
				native: "💜",
				x: 27,
				y: 43
			}
		],
		version: 1
	},
	brown_heart: {
		id: "brown_heart",
		name: "Brown Heart",
		keywords: [
			"coffee"
		],
		skins: [
			{
				unified: "1f90e",
				native: "🤎",
				x: 38,
				y: 51
			}
		],
		version: 12
	},
	black_heart: {
		id: "black_heart",
		name: "Black Heart",
		keywords: [
			"evil"
		],
		skins: [
			{
				unified: "1f5a4",
				native: "🖤",
				x: 31,
				y: 55
			}
		],
		version: 3
	},
	white_heart: {
		id: "white_heart",
		name: "White Heart",
		keywords: [
			"pure"
		],
		skins: [
			{
				unified: "1f90d",
				native: "🤍",
				x: 38,
				y: 50
			}
		],
		version: 12
	},
	anger: {
		id: "anger",
		name: "Anger Symbol",
		keywords: [
			"angry",
			"mad"
		],
		skins: [
			{
				unified: "1f4a2",
				native: "💢",
				x: 27,
				y: 49
			}
		],
		version: 1
	},
	boom: {
		id: "boom",
		name: "Collision",
		keywords: [
			"boom",
			"bomb",
			"explode",
			"explosion",
			"blown"
		],
		skins: [
			{
				unified: "1f4a5",
				native: "💥",
				x: 27,
				y: 52
			}
		],
		version: 1
	},
	dizzy: {
		id: "dizzy",
		name: "Dizzy",
		keywords: [
			"star",
			"sparkle",
			"shoot",
			"magic"
		],
		skins: [
			{
				unified: "1f4ab",
				native: "💫",
				x: 28,
				y: 2
			}
		],
		version: 1
	},
	sweat_drops: {
		id: "sweat_drops",
		name: "Sweat Droplets",
		keywords: [
			"drops",
			"water",
			"drip",
			"oops"
		],
		skins: [
			{
				unified: "1f4a6",
				native: "💦",
				x: 27,
				y: 53
			}
		],
		version: 1
	},
	dash: {
		id: "dash",
		name: "Dash Symbol",
		keywords: [
			"dashing",
			"away",
			"wind",
			"air",
			"fast",
			"shoo",
			"fart",
			"smoke",
			"puff"
		],
		skins: [
			{
				unified: "1f4a8",
				native: "💨",
				x: 27,
				y: 55
			}
		],
		version: 1
	},
	hole: {
		id: "hole",
		name: "Hole",
		keywords: [
			"embarrassing"
		],
		skins: [
			{
				unified: "1f573-fe0f",
				native: "🕳️",
				x: 30,
				y: 58
			}
		],
		version: 1
	},
	bomb: {
		id: "bomb",
		name: "Bomb",
		keywords: [
			"boom",
			"explode",
			"explosion",
			"terrorism"
		],
		skins: [
			{
				unified: "1f4a3",
				native: "💣",
				x: 27,
				y: 50
			}
		],
		version: 1
	},
	speech_balloon: {
		id: "speech_balloon",
		name: "Speech Balloon",
		keywords: [
			"bubble",
			"words",
			"message",
			"talk",
			"chatting"
		],
		skins: [
			{
				unified: "1f4ac",
				native: "💬",
				x: 28,
				y: 3
			}
		],
		version: 1
	},
	"eye-in-speech-bubble": {
		id: "eye-in-speech-bubble",
		name: "Eye in Speech Bubble",
		keywords: [
			"in-speech-bubble",
			"info"
		],
		skins: [
			{
				unified: "1f441-fe0f-200d-1f5e8-fe0f",
				native: "👁️‍🗨️",
				x: 11,
				y: 53
			}
		],
		version: 2
	},
	left_speech_bubble: {
		id: "left_speech_bubble",
		name: "Left Speech Bubble",
		keywords: [
			"words",
			"message",
			"talk",
			"chatting"
		],
		skins: [
			{
				unified: "1f5e8-fe0f",
				native: "🗨️",
				x: 32,
				y: 11
			}
		],
		version: 2
	},
	right_anger_bubble: {
		id: "right_anger_bubble",
		name: "Right Anger Bubble",
		keywords: [
			"caption",
			"speech",
			"thinking",
			"mad"
		],
		skins: [
			{
				unified: "1f5ef-fe0f",
				native: "🗯️",
				x: 32,
				y: 12
			}
		],
		version: 1
	},
	thought_balloon: {
		id: "thought_balloon",
		name: "Thought Balloon",
		keywords: [
			"bubble",
			"cloud",
			"speech",
			"thinking",
			"dream"
		],
		skins: [
			{
				unified: "1f4ad",
				native: "💭",
				x: 28,
				y: 4
			}
		],
		version: 1
	},
	zzz: {
		id: "zzz",
		name: "Zzz",
		keywords: [
			"sleepy",
			"tired",
			"dream"
		],
		skins: [
			{
				unified: "1f4a4",
				native: "💤",
				x: 27,
				y: 51
			}
		],
		version: 1
	},
	wave: {
		id: "wave",
		name: "Waving Hand",
		keywords: [
			"wave",
			"hands",
			"gesture",
			"goodbye",
			"solong",
			"farewell",
			"hello",
			"hi",
			"palm"
		],
		skins: [
			{
				unified: "1f44b",
				native: "👋",
				x: 12,
				y: 38
			},
			{
				unified: "1f44b-1f3fb",
				native: "👋🏻",
				x: 12,
				y: 39
			},
			{
				unified: "1f44b-1f3fc",
				native: "👋🏼",
				x: 12,
				y: 40
			},
			{
				unified: "1f44b-1f3fd",
				native: "👋🏽",
				x: 12,
				y: 41
			},
			{
				unified: "1f44b-1f3fe",
				native: "👋🏾",
				x: 12,
				y: 42
			},
			{
				unified: "1f44b-1f3ff",
				native: "👋🏿",
				x: 12,
				y: 43
			}
		],
		version: 1
	},
	raised_back_of_hand: {
		id: "raised_back_of_hand",
		name: "Raised Back of Hand",
		keywords: [
			"fingers",
			"backhand"
		],
		skins: [
			{
				unified: "1f91a",
				native: "🤚",
				x: 39,
				y: 17
			},
			{
				unified: "1f91a-1f3fb",
				native: "🤚🏻",
				x: 39,
				y: 18
			},
			{
				unified: "1f91a-1f3fc",
				native: "🤚🏼",
				x: 39,
				y: 19
			},
			{
				unified: "1f91a-1f3fd",
				native: "🤚🏽",
				x: 39,
				y: 20
			},
			{
				unified: "1f91a-1f3fe",
				native: "🤚🏾",
				x: 39,
				y: 21
			},
			{
				unified: "1f91a-1f3ff",
				native: "🤚🏿",
				x: 39,
				y: 22
			}
		],
		version: 3
	},
	raised_hand_with_fingers_splayed: {
		id: "raised_hand_with_fingers_splayed",
		name: "Hand with Fingers Splayed",
		keywords: [
			"raised",
			"palm"
		],
		skins: [
			{
				unified: "1f590-fe0f",
				native: "🖐️",
				x: 31,
				y: 37
			},
			{
				unified: "1f590-1f3fb",
				native: "🖐🏻",
				x: 31,
				y: 38
			},
			{
				unified: "1f590-1f3fc",
				native: "🖐🏼",
				x: 31,
				y: 39
			},
			{
				unified: "1f590-1f3fd",
				native: "🖐🏽",
				x: 31,
				y: 40
			},
			{
				unified: "1f590-1f3fe",
				native: "🖐🏾",
				x: 31,
				y: 41
			},
			{
				unified: "1f590-1f3ff",
				native: "🖐🏿",
				x: 31,
				y: 42
			}
		],
		version: 1
	},
	hand: {
		id: "hand",
		name: "Raised Hand",
		keywords: [
			"fingers",
			"stop",
			"highfive",
			"high",
			"five",
			"palm",
			"ban"
		],
		skins: [
			{
				unified: "270b",
				native: "✋",
				x: 58,
				y: 33
			},
			{
				unified: "270b-1f3fb",
				native: "✋🏻",
				x: 58,
				y: 34
			},
			{
				unified: "270b-1f3fc",
				native: "✋🏼",
				x: 58,
				y: 35
			},
			{
				unified: "270b-1f3fd",
				native: "✋🏽",
				x: 58,
				y: 36
			},
			{
				unified: "270b-1f3fe",
				native: "✋🏾",
				x: 58,
				y: 37
			},
			{
				unified: "270b-1f3ff",
				native: "✋🏿",
				x: 58,
				y: 38
			}
		],
		version: 1
	},
	"spock-hand": {
		id: "spock-hand",
		name: "Vulcan Salute",
		keywords: [
			"spock",
			"hand",
			"fingers",
			"star",
			"trek"
		],
		skins: [
			{
				unified: "1f596",
				native: "🖖",
				x: 31,
				y: 49
			},
			{
				unified: "1f596-1f3fb",
				native: "🖖🏻",
				x: 31,
				y: 50
			},
			{
				unified: "1f596-1f3fc",
				native: "🖖🏼",
				x: 31,
				y: 51
			},
			{
				unified: "1f596-1f3fd",
				native: "🖖🏽",
				x: 31,
				y: 52
			},
			{
				unified: "1f596-1f3fe",
				native: "🖖🏾",
				x: 31,
				y: 53
			},
			{
				unified: "1f596-1f3ff",
				native: "🖖🏿",
				x: 31,
				y: 54
			}
		],
		version: 1
	},
	rightwards_hand: {
		id: "rightwards_hand",
		name: "Rightwards Hand",
		keywords: [
			"palm",
			"offer"
		],
		skins: [
			{
				unified: "1faf1",
				native: "🫱",
				x: 55,
				y: 26
			},
			{
				unified: "1faf1-1f3fb",
				native: "🫱🏻",
				x: 55,
				y: 27
			},
			{
				unified: "1faf1-1f3fc",
				native: "🫱🏼",
				x: 55,
				y: 28
			},
			{
				unified: "1faf1-1f3fd",
				native: "🫱🏽",
				x: 55,
				y: 29
			},
			{
				unified: "1faf1-1f3fe",
				native: "🫱🏾",
				x: 55,
				y: 30
			},
			{
				unified: "1faf1-1f3ff",
				native: "🫱🏿",
				x: 55,
				y: 31
			}
		],
		version: 14
	},
	leftwards_hand: {
		id: "leftwards_hand",
		name: "Leftwards Hand",
		keywords: [
			"palm",
			"offer"
		],
		skins: [
			{
				unified: "1faf2",
				native: "🫲",
				x: 55,
				y: 32
			},
			{
				unified: "1faf2-1f3fb",
				native: "🫲🏻",
				x: 55,
				y: 33
			},
			{
				unified: "1faf2-1f3fc",
				native: "🫲🏼",
				x: 55,
				y: 34
			},
			{
				unified: "1faf2-1f3fd",
				native: "🫲🏽",
				x: 55,
				y: 35
			},
			{
				unified: "1faf2-1f3fe",
				native: "🫲🏾",
				x: 55,
				y: 36
			},
			{
				unified: "1faf2-1f3ff",
				native: "🫲🏿",
				x: 55,
				y: 37
			}
		],
		version: 14
	},
	palm_down_hand: {
		id: "palm_down_hand",
		name: "Palm Down Hand",
		keywords: [
			"drop"
		],
		skins: [
			{
				unified: "1faf3",
				native: "🫳",
				x: 55,
				y: 38
			},
			{
				unified: "1faf3-1f3fb",
				native: "🫳🏻",
				x: 55,
				y: 39
			},
			{
				unified: "1faf3-1f3fc",
				native: "🫳🏼",
				x: 55,
				y: 40
			},
			{
				unified: "1faf3-1f3fd",
				native: "🫳🏽",
				x: 55,
				y: 41
			},
			{
				unified: "1faf3-1f3fe",
				native: "🫳🏾",
				x: 55,
				y: 42
			},
			{
				unified: "1faf3-1f3ff",
				native: "🫳🏿",
				x: 55,
				y: 43
			}
		],
		version: 14
	},
	palm_up_hand: {
		id: "palm_up_hand",
		name: "Palm Up Hand",
		keywords: [
			"lift",
			"offer",
			"demand"
		],
		skins: [
			{
				unified: "1faf4",
				native: "🫴",
				x: 55,
				y: 44
			},
			{
				unified: "1faf4-1f3fb",
				native: "🫴🏻",
				x: 55,
				y: 45
			},
			{
				unified: "1faf4-1f3fc",
				native: "🫴🏼",
				x: 55,
				y: 46
			},
			{
				unified: "1faf4-1f3fd",
				native: "🫴🏽",
				x: 55,
				y: 47
			},
			{
				unified: "1faf4-1f3fe",
				native: "🫴🏾",
				x: 55,
				y: 48
			},
			{
				unified: "1faf4-1f3ff",
				native: "🫴🏿",
				x: 55,
				y: 49
			}
		],
		version: 14
	},
	ok_hand: {
		id: "ok_hand",
		name: "Ok Hand",
		keywords: [
			"fingers",
			"limbs",
			"perfect",
			"okay"
		],
		skins: [
			{
				unified: "1f44c",
				native: "👌",
				x: 12,
				y: 44
			},
			{
				unified: "1f44c-1f3fb",
				native: "👌🏻",
				x: 12,
				y: 45
			},
			{
				unified: "1f44c-1f3fc",
				native: "👌🏼",
				x: 12,
				y: 46
			},
			{
				unified: "1f44c-1f3fd",
				native: "👌🏽",
				x: 12,
				y: 47
			},
			{
				unified: "1f44c-1f3fe",
				native: "👌🏾",
				x: 12,
				y: 48
			},
			{
				unified: "1f44c-1f3ff",
				native: "👌🏿",
				x: 12,
				y: 49
			}
		],
		version: 1
	},
	pinched_fingers: {
		id: "pinched_fingers",
		name: "Pinched Fingers",
		keywords: [
			"size",
			"tiny",
			"small"
		],
		skins: [
			{
				unified: "1f90c",
				native: "🤌",
				x: 38,
				y: 44
			},
			{
				unified: "1f90c-1f3fb",
				native: "🤌🏻",
				x: 38,
				y: 45
			},
			{
				unified: "1f90c-1f3fc",
				native: "🤌🏼",
				x: 38,
				y: 46
			},
			{
				unified: "1f90c-1f3fd",
				native: "🤌🏽",
				x: 38,
				y: 47
			},
			{
				unified: "1f90c-1f3fe",
				native: "🤌🏾",
				x: 38,
				y: 48
			},
			{
				unified: "1f90c-1f3ff",
				native: "🤌🏿",
				x: 38,
				y: 49
			}
		],
		version: 13
	},
	pinching_hand: {
		id: "pinching_hand",
		name: "Pinching Hand",
		keywords: [
			"tiny",
			"small",
			"size"
		],
		skins: [
			{
				unified: "1f90f",
				native: "🤏",
				x: 38,
				y: 52
			},
			{
				unified: "1f90f-1f3fb",
				native: "🤏🏻",
				x: 38,
				y: 53
			},
			{
				unified: "1f90f-1f3fc",
				native: "🤏🏼",
				x: 38,
				y: 54
			},
			{
				unified: "1f90f-1f3fd",
				native: "🤏🏽",
				x: 38,
				y: 55
			},
			{
				unified: "1f90f-1f3fe",
				native: "🤏🏾",
				x: 38,
				y: 56
			},
			{
				unified: "1f90f-1f3ff",
				native: "🤏🏿",
				x: 38,
				y: 57
			}
		],
		version: 12
	},
	v: {
		id: "v",
		name: "Victory Hand",
		keywords: [
			"v",
			"fingers",
			"ohyeah",
			"peace",
			"two"
		],
		skins: [
			{
				unified: "270c-fe0f",
				native: "✌️",
				x: 58,
				y: 39
			},
			{
				unified: "270c-1f3fb",
				native: "✌🏻",
				x: 58,
				y: 40
			},
			{
				unified: "270c-1f3fc",
				native: "✌🏼",
				x: 58,
				y: 41
			},
			{
				unified: "270c-1f3fd",
				native: "✌🏽",
				x: 58,
				y: 42
			},
			{
				unified: "270c-1f3fe",
				native: "✌🏾",
				x: 58,
				y: 43
			},
			{
				unified: "270c-1f3ff",
				native: "✌🏿",
				x: 58,
				y: 44
			}
		],
		version: 1
	},
	crossed_fingers: {
		id: "crossed_fingers",
		name: "Crossed Fingers",
		keywords: [
			"hand",
			"with",
			"index",
			"and",
			"middle",
			"good",
			"lucky"
		],
		skins: [
			{
				unified: "1f91e",
				native: "🤞",
				x: 40,
				y: 0
			},
			{
				unified: "1f91e-1f3fb",
				native: "🤞🏻",
				x: 40,
				y: 1
			},
			{
				unified: "1f91e-1f3fc",
				native: "🤞🏼",
				x: 40,
				y: 2
			},
			{
				unified: "1f91e-1f3fd",
				native: "🤞🏽",
				x: 40,
				y: 3
			},
			{
				unified: "1f91e-1f3fe",
				native: "🤞🏾",
				x: 40,
				y: 4
			},
			{
				unified: "1f91e-1f3ff",
				native: "🤞🏿",
				x: 40,
				y: 5
			}
		],
		version: 3
	},
	hand_with_index_finger_and_thumb_crossed: {
		id: "hand_with_index_finger_and_thumb_crossed",
		name: "Hand with Index Finger and Thumb Crossed",
		keywords: [
			"heart",
			"love",
			"money",
			"expensive"
		],
		skins: [
			{
				unified: "1faf0",
				native: "🫰",
				x: 55,
				y: 20
			},
			{
				unified: "1faf0-1f3fb",
				native: "🫰🏻",
				x: 55,
				y: 21
			},
			{
				unified: "1faf0-1f3fc",
				native: "🫰🏼",
				x: 55,
				y: 22
			},
			{
				unified: "1faf0-1f3fd",
				native: "🫰🏽",
				x: 55,
				y: 23
			},
			{
				unified: "1faf0-1f3fe",
				native: "🫰🏾",
				x: 55,
				y: 24
			},
			{
				unified: "1faf0-1f3ff",
				native: "🫰🏿",
				x: 55,
				y: 25
			}
		],
		version: 14
	},
	i_love_you_hand_sign: {
		id: "i_love_you_hand_sign",
		name: "Love-You Gesture",
		keywords: [
			"i",
			"love",
			"you",
			"hand",
			"sign",
			"fingers"
		],
		skins: [
			{
				unified: "1f91f",
				native: "🤟",
				x: 40,
				y: 6
			},
			{
				unified: "1f91f-1f3fb",
				native: "🤟🏻",
				x: 40,
				y: 7
			},
			{
				unified: "1f91f-1f3fc",
				native: "🤟🏼",
				x: 40,
				y: 8
			},
			{
				unified: "1f91f-1f3fd",
				native: "🤟🏽",
				x: 40,
				y: 9
			},
			{
				unified: "1f91f-1f3fe",
				native: "🤟🏾",
				x: 40,
				y: 10
			},
			{
				unified: "1f91f-1f3ff",
				native: "🤟🏿",
				x: 40,
				y: 11
			}
		],
		version: 5
	},
	the_horns: {
		id: "the_horns",
		name: "Sign of the Horns",
		keywords: [
			"hand",
			"fingers",
			"evil",
			"eye",
			"rock",
			"on"
		],
		skins: [
			{
				unified: "1f918",
				native: "🤘",
				x: 39,
				y: 5
			},
			{
				unified: "1f918-1f3fb",
				native: "🤘🏻",
				x: 39,
				y: 6
			},
			{
				unified: "1f918-1f3fc",
				native: "🤘🏼",
				x: 39,
				y: 7
			},
			{
				unified: "1f918-1f3fd",
				native: "🤘🏽",
				x: 39,
				y: 8
			},
			{
				unified: "1f918-1f3fe",
				native: "🤘🏾",
				x: 39,
				y: 9
			},
			{
				unified: "1f918-1f3ff",
				native: "🤘🏿",
				x: 39,
				y: 10
			}
		],
		version: 1
	},
	call_me_hand: {
		id: "call_me_hand",
		name: "Call Me Hand",
		keywords: [
			"hands",
			"gesture",
			"shaka"
		],
		skins: [
			{
				unified: "1f919",
				native: "🤙",
				x: 39,
				y: 11
			},
			{
				unified: "1f919-1f3fb",
				native: "🤙🏻",
				x: 39,
				y: 12
			},
			{
				unified: "1f919-1f3fc",
				native: "🤙🏼",
				x: 39,
				y: 13
			},
			{
				unified: "1f919-1f3fd",
				native: "🤙🏽",
				x: 39,
				y: 14
			},
			{
				unified: "1f919-1f3fe",
				native: "🤙🏾",
				x: 39,
				y: 15
			},
			{
				unified: "1f919-1f3ff",
				native: "🤙🏿",
				x: 39,
				y: 16
			}
		],
		version: 3
	},
	point_left: {
		id: "point_left",
		name: "Backhand Index Pointing Left",
		keywords: [
			"point",
			"direction",
			"fingers",
			"hand"
		],
		skins: [
			{
				unified: "1f448",
				native: "👈",
				x: 12,
				y: 20
			},
			{
				unified: "1f448-1f3fb",
				native: "👈🏻",
				x: 12,
				y: 21
			},
			{
				unified: "1f448-1f3fc",
				native: "👈🏼",
				x: 12,
				y: 22
			},
			{
				unified: "1f448-1f3fd",
				native: "👈🏽",
				x: 12,
				y: 23
			},
			{
				unified: "1f448-1f3fe",
				native: "👈🏾",
				x: 12,
				y: 24
			},
			{
				unified: "1f448-1f3ff",
				native: "👈🏿",
				x: 12,
				y: 25
			}
		],
		version: 1
	},
	point_right: {
		id: "point_right",
		name: "Backhand Index Pointing Right",
		keywords: [
			"point",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f449",
				native: "👉",
				x: 12,
				y: 26
			},
			{
				unified: "1f449-1f3fb",
				native: "👉🏻",
				x: 12,
				y: 27
			},
			{
				unified: "1f449-1f3fc",
				native: "👉🏼",
				x: 12,
				y: 28
			},
			{
				unified: "1f449-1f3fd",
				native: "👉🏽",
				x: 12,
				y: 29
			},
			{
				unified: "1f449-1f3fe",
				native: "👉🏾",
				x: 12,
				y: 30
			},
			{
				unified: "1f449-1f3ff",
				native: "👉🏿",
				x: 12,
				y: 31
			}
		],
		version: 1
	},
	point_up_2: {
		id: "point_up_2",
		name: "Backhand Index Pointing Up",
		keywords: [
			"point",
			"2",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f446",
				native: "👆",
				x: 12,
				y: 8
			},
			{
				unified: "1f446-1f3fb",
				native: "👆🏻",
				x: 12,
				y: 9
			},
			{
				unified: "1f446-1f3fc",
				native: "👆🏼",
				x: 12,
				y: 10
			},
			{
				unified: "1f446-1f3fd",
				native: "👆🏽",
				x: 12,
				y: 11
			},
			{
				unified: "1f446-1f3fe",
				native: "👆🏾",
				x: 12,
				y: 12
			},
			{
				unified: "1f446-1f3ff",
				native: "👆🏿",
				x: 12,
				y: 13
			}
		],
		version: 1
	},
	middle_finger: {
		id: "middle_finger",
		name: "Middle Finger",
		keywords: [
			"reversed",
			"hand",
			"with",
			"extended",
			"fingers",
			"rude",
			"flipping"
		],
		skins: [
			{
				unified: "1f595",
				native: "🖕",
				x: 31,
				y: 43
			},
			{
				unified: "1f595-1f3fb",
				native: "🖕🏻",
				x: 31,
				y: 44
			},
			{
				unified: "1f595-1f3fc",
				native: "🖕🏼",
				x: 31,
				y: 45
			},
			{
				unified: "1f595-1f3fd",
				native: "🖕🏽",
				x: 31,
				y: 46
			},
			{
				unified: "1f595-1f3fe",
				native: "🖕🏾",
				x: 31,
				y: 47
			},
			{
				unified: "1f595-1f3ff",
				native: "🖕🏿",
				x: 31,
				y: 48
			}
		],
		version: 1
	},
	point_down: {
		id: "point_down",
		name: "Backhand Index Pointing Down",
		keywords: [
			"point",
			"fingers",
			"hand",
			"direction"
		],
		skins: [
			{
				unified: "1f447",
				native: "👇",
				x: 12,
				y: 14
			},
			{
				unified: "1f447-1f3fb",
				native: "👇🏻",
				x: 12,
				y: 15
			},
			{
				unified: "1f447-1f3fc",
				native: "👇🏼",
				x: 12,
				y: 16
			},
			{
				unified: "1f447-1f3fd",
				native: "👇🏽",
				x: 12,
				y: 17
			},
			{
				unified: "1f447-1f3fe",
				native: "👇🏾",
				x: 12,
				y: 18
			},
			{
				unified: "1f447-1f3ff",
				native: "👇🏿",
				x: 12,
				y: 19
			}
		],
		version: 1
	},
	point_up: {
		id: "point_up",
		name: "Index Pointing Up",
		keywords: [
			"point",
			"hand",
			"fingers",
			"direction"
		],
		skins: [
			{
				unified: "261d-fe0f",
				native: "☝️",
				x: 56,
				y: 50
			},
			{
				unified: "261d-1f3fb",
				native: "☝🏻",
				x: 56,
				y: 51
			},
			{
				unified: "261d-1f3fc",
				native: "☝🏼",
				x: 56,
				y: 52
			},
			{
				unified: "261d-1f3fd",
				native: "☝🏽",
				x: 56,
				y: 53
			},
			{
				unified: "261d-1f3fe",
				native: "☝🏾",
				x: 56,
				y: 54
			},
			{
				unified: "261d-1f3ff",
				native: "☝🏿",
				x: 56,
				y: 55
			}
		],
		version: 1
	},
	index_pointing_at_the_viewer: {
		id: "index_pointing_at_the_viewer",
		name: "Index Pointing at the Viewer",
		keywords: [
			"you",
			"recruit"
		],
		skins: [
			{
				unified: "1faf5",
				native: "🫵",
				x: 55,
				y: 50
			},
			{
				unified: "1faf5-1f3fb",
				native: "🫵🏻",
				x: 55,
				y: 51
			},
			{
				unified: "1faf5-1f3fc",
				native: "🫵🏼",
				x: 55,
				y: 52
			},
			{
				unified: "1faf5-1f3fd",
				native: "🫵🏽",
				x: 55,
				y: 53
			},
			{
				unified: "1faf5-1f3fe",
				native: "🫵🏾",
				x: 55,
				y: 54
			},
			{
				unified: "1faf5-1f3ff",
				native: "🫵🏿",
				x: 55,
				y: 55
			}
		],
		version: 14
	},
	"+1": {
		id: "+1",
		name: "Thumbs Up",
		keywords: [
			"+1",
			"thumbsup",
			"yes",
			"awesome",
			"good",
			"agree",
			"accept",
			"cool",
			"hand",
			"like"
		],
		skins: [
			{
				unified: "1f44d",
				native: "👍",
				x: 12,
				y: 50
			},
			{
				unified: "1f44d-1f3fb",
				native: "👍🏻",
				x: 12,
				y: 51
			},
			{
				unified: "1f44d-1f3fc",
				native: "👍🏼",
				x: 12,
				y: 52
			},
			{
				unified: "1f44d-1f3fd",
				native: "👍🏽",
				x: 12,
				y: 53
			},
			{
				unified: "1f44d-1f3fe",
				native: "👍🏾",
				x: 12,
				y: 54
			},
			{
				unified: "1f44d-1f3ff",
				native: "👍🏿",
				x: 12,
				y: 55
			}
		],
		version: 1
	},
	"-1": {
		id: "-1",
		name: "Thumbs Down",
		keywords: [
			"-1",
			"thumbsdown",
			"no",
			"dislike",
			"hand"
		],
		skins: [
			{
				unified: "1f44e",
				native: "👎",
				x: 12,
				y: 56
			},
			{
				unified: "1f44e-1f3fb",
				native: "👎🏻",
				x: 12,
				y: 57
			},
			{
				unified: "1f44e-1f3fc",
				native: "👎🏼",
				x: 12,
				y: 58
			},
			{
				unified: "1f44e-1f3fd",
				native: "👎🏽",
				x: 12,
				y: 59
			},
			{
				unified: "1f44e-1f3fe",
				native: "👎🏾",
				x: 12,
				y: 60
			},
			{
				unified: "1f44e-1f3ff",
				native: "👎🏿",
				x: 13,
				y: 0
			}
		],
		version: 1
	},
	fist: {
		id: "fist",
		name: "Raised Fist",
		keywords: [
			"fingers",
			"hand",
			"grasp"
		],
		skins: [
			{
				unified: "270a",
				native: "✊",
				x: 58,
				y: 27
			},
			{
				unified: "270a-1f3fb",
				native: "✊🏻",
				x: 58,
				y: 28
			},
			{
				unified: "270a-1f3fc",
				native: "✊🏼",
				x: 58,
				y: 29
			},
			{
				unified: "270a-1f3fd",
				native: "✊🏽",
				x: 58,
				y: 30
			},
			{
				unified: "270a-1f3fe",
				native: "✊🏾",
				x: 58,
				y: 31
			},
			{
				unified: "270a-1f3ff",
				native: "✊🏿",
				x: 58,
				y: 32
			}
		],
		version: 1
	},
	facepunch: {
		id: "facepunch",
		name: "Oncoming Fist",
		keywords: [
			"facepunch",
			"punch",
			"angry",
			"violence",
			"hit",
			"attack",
			"hand"
		],
		skins: [
			{
				unified: "1f44a",
				native: "👊",
				x: 12,
				y: 32
			},
			{
				unified: "1f44a-1f3fb",
				native: "👊🏻",
				x: 12,
				y: 33
			},
			{
				unified: "1f44a-1f3fc",
				native: "👊🏼",
				x: 12,
				y: 34
			},
			{
				unified: "1f44a-1f3fd",
				native: "👊🏽",
				x: 12,
				y: 35
			},
			{
				unified: "1f44a-1f3fe",
				native: "👊🏾",
				x: 12,
				y: 36
			},
			{
				unified: "1f44a-1f3ff",
				native: "👊🏿",
				x: 12,
				y: 37
			}
		],
		version: 1
	},
	"left-facing_fist": {
		id: "left-facing_fist",
		name: "Left-Facing Fist",
		keywords: [
			"left",
			"facing",
			"hand",
			"fistbump"
		],
		skins: [
			{
				unified: "1f91b",
				native: "🤛",
				x: 39,
				y: 23
			},
			{
				unified: "1f91b-1f3fb",
				native: "🤛🏻",
				x: 39,
				y: 24
			},
			{
				unified: "1f91b-1f3fc",
				native: "🤛🏼",
				x: 39,
				y: 25
			},
			{
				unified: "1f91b-1f3fd",
				native: "🤛🏽",
				x: 39,
				y: 26
			},
			{
				unified: "1f91b-1f3fe",
				native: "🤛🏾",
				x: 39,
				y: 27
			},
			{
				unified: "1f91b-1f3ff",
				native: "🤛🏿",
				x: 39,
				y: 28
			}
		],
		version: 3
	},
	"right-facing_fist": {
		id: "right-facing_fist",
		name: "Right-Facing Fist",
		keywords: [
			"right",
			"facing",
			"hand",
			"fistbump"
		],
		skins: [
			{
				unified: "1f91c",
				native: "🤜",
				x: 39,
				y: 29
			},
			{
				unified: "1f91c-1f3fb",
				native: "🤜🏻",
				x: 39,
				y: 30
			},
			{
				unified: "1f91c-1f3fc",
				native: "🤜🏼",
				x: 39,
				y: 31
			},
			{
				unified: "1f91c-1f3fd",
				native: "🤜🏽",
				x: 39,
				y: 32
			},
			{
				unified: "1f91c-1f3fe",
				native: "🤜🏾",
				x: 39,
				y: 33
			},
			{
				unified: "1f91c-1f3ff",
				native: "🤜🏿",
				x: 39,
				y: 34
			}
		],
		version: 3
	},
	clap: {
		id: "clap",
		name: "Clapping Hands",
		keywords: [
			"clap",
			"praise",
			"applause",
			"congrats",
			"yay"
		],
		skins: [
			{
				unified: "1f44f",
				native: "👏",
				x: 13,
				y: 1
			},
			{
				unified: "1f44f-1f3fb",
				native: "👏🏻",
				x: 13,
				y: 2
			},
			{
				unified: "1f44f-1f3fc",
				native: "👏🏼",
				x: 13,
				y: 3
			},
			{
				unified: "1f44f-1f3fd",
				native: "👏🏽",
				x: 13,
				y: 4
			},
			{
				unified: "1f44f-1f3fe",
				native: "👏🏾",
				x: 13,
				y: 5
			},
			{
				unified: "1f44f-1f3ff",
				native: "👏🏿",
				x: 13,
				y: 6
			}
		],
		version: 1
	},
	raised_hands: {
		id: "raised_hands",
		name: "Raising Hands",
		keywords: [
			"raised",
			"gesture",
			"hooray",
			"yea",
			"celebration"
		],
		skins: [
			{
				unified: "1f64c",
				native: "🙌",
				x: 34,
				y: 45
			},
			{
				unified: "1f64c-1f3fb",
				native: "🙌🏻",
				x: 34,
				y: 46
			},
			{
				unified: "1f64c-1f3fc",
				native: "🙌🏼",
				x: 34,
				y: 47
			},
			{
				unified: "1f64c-1f3fd",
				native: "🙌🏽",
				x: 34,
				y: 48
			},
			{
				unified: "1f64c-1f3fe",
				native: "🙌🏾",
				x: 34,
				y: 49
			},
			{
				unified: "1f64c-1f3ff",
				native: "🙌🏿",
				x: 34,
				y: 50
			}
		],
		version: 1
	},
	heart_hands: {
		id: "heart_hands",
		name: "Heart Hands",
		keywords: [
			"love",
			"appreciation",
			"support"
		],
		skins: [
			{
				unified: "1faf6",
				native: "🫶",
				x: 55,
				y: 56
			},
			{
				unified: "1faf6-1f3fb",
				native: "🫶🏻",
				x: 55,
				y: 57
			},
			{
				unified: "1faf6-1f3fc",
				native: "🫶🏼",
				x: 55,
				y: 58
			},
			{
				unified: "1faf6-1f3fd",
				native: "🫶🏽",
				x: 55,
				y: 59
			},
			{
				unified: "1faf6-1f3fe",
				native: "🫶🏾",
				x: 55,
				y: 60
			},
			{
				unified: "1faf6-1f3ff",
				native: "🫶🏿",
				x: 56,
				y: 0
			}
		],
		version: 14
	},
	open_hands: {
		id: "open_hands",
		name: "Open Hands",
		keywords: [
			"fingers",
			"butterfly"
		],
		skins: [
			{
				unified: "1f450",
				native: "👐",
				x: 13,
				y: 7
			},
			{
				unified: "1f450-1f3fb",
				native: "👐🏻",
				x: 13,
				y: 8
			},
			{
				unified: "1f450-1f3fc",
				native: "👐🏼",
				x: 13,
				y: 9
			},
			{
				unified: "1f450-1f3fd",
				native: "👐🏽",
				x: 13,
				y: 10
			},
			{
				unified: "1f450-1f3fe",
				native: "👐🏾",
				x: 13,
				y: 11
			},
			{
				unified: "1f450-1f3ff",
				native: "👐🏿",
				x: 13,
				y: 12
			}
		],
		version: 1
	},
	palms_up_together: {
		id: "palms_up_together",
		name: "Palms Up Together",
		keywords: [
			"hands",
			"gesture",
			"cupped",
			"prayer"
		],
		skins: [
			{
				unified: "1f932",
				native: "🤲",
				x: 40,
				y: 57
			},
			{
				unified: "1f932-1f3fb",
				native: "🤲🏻",
				x: 40,
				y: 58
			},
			{
				unified: "1f932-1f3fc",
				native: "🤲🏼",
				x: 40,
				y: 59
			},
			{
				unified: "1f932-1f3fd",
				native: "🤲🏽",
				x: 40,
				y: 60
			},
			{
				unified: "1f932-1f3fe",
				native: "🤲🏾",
				x: 41,
				y: 0
			},
			{
				unified: "1f932-1f3ff",
				native: "🤲🏿",
				x: 41,
				y: 1
			}
		],
		version: 5
	},
	handshake: {
		id: "handshake",
		name: "Handshake",
		keywords: [
			"agreement",
			"shake"
		],
		skins: [
			{
				unified: "1f91d",
				native: "🤝",
				x: 39,
				y: 35
			},
			{
				unified: "1f91d-1f3fb",
				native: "🤝🏻",
				x: 39,
				y: 36
			},
			{
				unified: "1f91d-1f3fc",
				native: "🤝🏼",
				x: 39,
				y: 37
			},
			{
				unified: "1f91d-1f3fd",
				native: "🤝🏽",
				x: 39,
				y: 38
			},
			{
				unified: "1f91d-1f3fe",
				native: "🤝🏾",
				x: 39,
				y: 39
			},
			{
				unified: "1f91d-1f3ff",
				native: "🤝🏿",
				x: 39,
				y: 40
			}
		],
		version: 3
	},
	pray: {
		id: "pray",
		name: "Folded Hands",
		keywords: [
			"pray",
			"please",
			"hope",
			"wish",
			"namaste",
			"highfive",
			"high",
			"five"
		],
		skins: [
			{
				unified: "1f64f",
				native: "🙏",
				x: 35,
				y: 26
			},
			{
				unified: "1f64f-1f3fb",
				native: "🙏🏻",
				x: 35,
				y: 27
			},
			{
				unified: "1f64f-1f3fc",
				native: "🙏🏼",
				x: 35,
				y: 28
			},
			{
				unified: "1f64f-1f3fd",
				native: "🙏🏽",
				x: 35,
				y: 29
			},
			{
				unified: "1f64f-1f3fe",
				native: "🙏🏾",
				x: 35,
				y: 30
			},
			{
				unified: "1f64f-1f3ff",
				native: "🙏🏿",
				x: 35,
				y: 31
			}
		],
		version: 1
	},
	writing_hand: {
		id: "writing_hand",
		name: "Writing Hand",
		keywords: [
			"lower",
			"left",
			"ballpoint",
			"pen",
			"stationery",
			"write",
			"compose"
		],
		skins: [
			{
				unified: "270d-fe0f",
				native: "✍️",
				x: 58,
				y: 45
			},
			{
				unified: "270d-1f3fb",
				native: "✍🏻",
				x: 58,
				y: 46
			},
			{
				unified: "270d-1f3fc",
				native: "✍🏼",
				x: 58,
				y: 47
			},
			{
				unified: "270d-1f3fd",
				native: "✍🏽",
				x: 58,
				y: 48
			},
			{
				unified: "270d-1f3fe",
				native: "✍🏾",
				x: 58,
				y: 49
			},
			{
				unified: "270d-1f3ff",
				native: "✍🏿",
				x: 58,
				y: 50
			}
		],
		version: 1
	},
	nail_care: {
		id: "nail_care",
		name: "Nail Polish",
		keywords: [
			"care",
			"beauty",
			"manicure",
			"finger",
			"fashion"
		],
		skins: [
			{
				unified: "1f485",
				native: "💅",
				x: 25,
				y: 53
			},
			{
				unified: "1f485-1f3fb",
				native: "💅🏻",
				x: 25,
				y: 54
			},
			{
				unified: "1f485-1f3fc",
				native: "💅🏼",
				x: 25,
				y: 55
			},
			{
				unified: "1f485-1f3fd",
				native: "💅🏽",
				x: 25,
				y: 56
			},
			{
				unified: "1f485-1f3fe",
				native: "💅🏾",
				x: 25,
				y: 57
			},
			{
				unified: "1f485-1f3ff",
				native: "💅🏿",
				x: 25,
				y: 58
			}
		],
		version: 1
	},
	selfie: {
		id: "selfie",
		name: "Selfie",
		keywords: [
			"camera",
			"phone"
		],
		skins: [
			{
				unified: "1f933",
				native: "🤳",
				x: 41,
				y: 2
			},
			{
				unified: "1f933-1f3fb",
				native: "🤳🏻",
				x: 41,
				y: 3
			},
			{
				unified: "1f933-1f3fc",
				native: "🤳🏼",
				x: 41,
				y: 4
			},
			{
				unified: "1f933-1f3fd",
				native: "🤳🏽",
				x: 41,
				y: 5
			},
			{
				unified: "1f933-1f3fe",
				native: "🤳🏾",
				x: 41,
				y: 6
			},
			{
				unified: "1f933-1f3ff",
				native: "🤳🏿",
				x: 41,
				y: 7
			}
		],
		version: 3
	},
	muscle: {
		id: "muscle",
		name: "Flexed Biceps",
		keywords: [
			"muscle",
			"arm",
			"flex",
			"hand",
			"summer",
			"strong"
		],
		skins: [
			{
				unified: "1f4aa",
				native: "💪",
				x: 27,
				y: 57
			},
			{
				unified: "1f4aa-1f3fb",
				native: "💪🏻",
				x: 27,
				y: 58
			},
			{
				unified: "1f4aa-1f3fc",
				native: "💪🏼",
				x: 27,
				y: 59
			},
			{
				unified: "1f4aa-1f3fd",
				native: "💪🏽",
				x: 27,
				y: 60
			},
			{
				unified: "1f4aa-1f3fe",
				native: "💪🏾",
				x: 28,
				y: 0
			},
			{
				unified: "1f4aa-1f3ff",
				native: "💪🏿",
				x: 28,
				y: 1
			}
		],
		version: 1
	},
	mechanical_arm: {
		id: "mechanical_arm",
		name: "Mechanical Arm",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9be",
				native: "🦾",
				x: 46,
				y: 3
			}
		],
		version: 12
	},
	mechanical_leg: {
		id: "mechanical_leg",
		name: "Mechanical Leg",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bf",
				native: "🦿",
				x: 46,
				y: 4
			}
		],
		version: 12
	},
	leg: {
		id: "leg",
		name: "Leg",
		keywords: [
			"kick",
			"limb"
		],
		skins: [
			{
				unified: "1f9b5",
				native: "🦵",
				x: 45,
				y: 6
			},
			{
				unified: "1f9b5-1f3fb",
				native: "🦵🏻",
				x: 45,
				y: 7
			},
			{
				unified: "1f9b5-1f3fc",
				native: "🦵🏼",
				x: 45,
				y: 8
			},
			{
				unified: "1f9b5-1f3fd",
				native: "🦵🏽",
				x: 45,
				y: 9
			},
			{
				unified: "1f9b5-1f3fe",
				native: "🦵🏾",
				x: 45,
				y: 10
			},
			{
				unified: "1f9b5-1f3ff",
				native: "🦵🏿",
				x: 45,
				y: 11
			}
		],
		version: 11
	},
	foot: {
		id: "foot",
		name: "Foot",
		keywords: [
			"kick",
			"stomp"
		],
		skins: [
			{
				unified: "1f9b6",
				native: "🦶",
				x: 45,
				y: 12
			},
			{
				unified: "1f9b6-1f3fb",
				native: "🦶🏻",
				x: 45,
				y: 13
			},
			{
				unified: "1f9b6-1f3fc",
				native: "🦶🏼",
				x: 45,
				y: 14
			},
			{
				unified: "1f9b6-1f3fd",
				native: "🦶🏽",
				x: 45,
				y: 15
			},
			{
				unified: "1f9b6-1f3fe",
				native: "🦶🏾",
				x: 45,
				y: 16
			},
			{
				unified: "1f9b6-1f3ff",
				native: "🦶🏿",
				x: 45,
				y: 17
			}
		],
		version: 11
	},
	ear: {
		id: "ear",
		name: "Ear",
		keywords: [
			"face",
			"hear",
			"sound",
			"listen"
		],
		skins: [
			{
				unified: "1f442",
				native: "👂",
				x: 11,
				y: 55
			},
			{
				unified: "1f442-1f3fb",
				native: "👂🏻",
				x: 11,
				y: 56
			},
			{
				unified: "1f442-1f3fc",
				native: "👂🏼",
				x: 11,
				y: 57
			},
			{
				unified: "1f442-1f3fd",
				native: "👂🏽",
				x: 11,
				y: 58
			},
			{
				unified: "1f442-1f3fe",
				native: "👂🏾",
				x: 11,
				y: 59
			},
			{
				unified: "1f442-1f3ff",
				native: "👂🏿",
				x: 11,
				y: 60
			}
		],
		version: 1
	},
	ear_with_hearing_aid: {
		id: "ear_with_hearing_aid",
		name: "Ear with Hearing Aid",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bb",
				native: "🦻",
				x: 45,
				y: 56
			},
			{
				unified: "1f9bb-1f3fb",
				native: "🦻🏻",
				x: 45,
				y: 57
			},
			{
				unified: "1f9bb-1f3fc",
				native: "🦻🏼",
				x: 45,
				y: 58
			},
			{
				unified: "1f9bb-1f3fd",
				native: "🦻🏽",
				x: 45,
				y: 59
			},
			{
				unified: "1f9bb-1f3fe",
				native: "🦻🏾",
				x: 45,
				y: 60
			},
			{
				unified: "1f9bb-1f3ff",
				native: "🦻🏿",
				x: 46,
				y: 0
			}
		],
		version: 12
	},
	nose: {
		id: "nose",
		name: "Nose",
		keywords: [
			"smell",
			"sniff"
		],
		skins: [
			{
				unified: "1f443",
				native: "👃",
				x: 12,
				y: 0
			},
			{
				unified: "1f443-1f3fb",
				native: "👃🏻",
				x: 12,
				y: 1
			},
			{
				unified: "1f443-1f3fc",
				native: "👃🏼",
				x: 12,
				y: 2
			},
			{
				unified: "1f443-1f3fd",
				native: "👃🏽",
				x: 12,
				y: 3
			},
			{
				unified: "1f443-1f3fe",
				native: "👃🏾",
				x: 12,
				y: 4
			},
			{
				unified: "1f443-1f3ff",
				native: "👃🏿",
				x: 12,
				y: 5
			}
		],
		version: 1
	},
	brain: {
		id: "brain",
		name: "Brain",
		keywords: [
			"smart",
			"intelligent"
		],
		skins: [
			{
				unified: "1f9e0",
				native: "🧠",
				x: 53,
				y: 14
			}
		],
		version: 5
	},
	anatomical_heart: {
		id: "anatomical_heart",
		name: "Anatomical Heart",
		keywords: [
			"health",
			"heartbeat"
		],
		skins: [
			{
				unified: "1fac0",
				native: "🫀",
				x: 54,
				y: 42
			}
		],
		version: 13
	},
	lungs: {
		id: "lungs",
		name: "Lungs",
		keywords: [
			"breathe"
		],
		skins: [
			{
				unified: "1fac1",
				native: "🫁",
				x: 54,
				y: 43
			}
		],
		version: 13
	},
	tooth: {
		id: "tooth",
		name: "Tooth",
		keywords: [
			"teeth",
			"dentist"
		],
		skins: [
			{
				unified: "1f9b7",
				native: "🦷",
				x: 45,
				y: 18
			}
		],
		version: 11
	},
	bone: {
		id: "bone",
		name: "Bone",
		keywords: [
			"skeleton"
		],
		skins: [
			{
				unified: "1f9b4",
				native: "🦴",
				x: 45,
				y: 5
			}
		],
		version: 11
	},
	eyes: {
		id: "eyes",
		name: "Eyes",
		keywords: [
			"look",
			"watch",
			"stalk",
			"peek",
			"see"
		],
		skins: [
			{
				unified: "1f440",
				native: "👀",
				x: 11,
				y: 52
			}
		],
		version: 1
	},
	eye: {
		id: "eye",
		name: "Eye",
		keywords: [
			"face",
			"look",
			"see",
			"watch",
			"stare"
		],
		skins: [
			{
				unified: "1f441-fe0f",
				native: "👁️",
				x: 11,
				y: 54
			}
		],
		version: 1
	},
	tongue: {
		id: "tongue",
		name: "Tongue",
		keywords: [
			"mouth",
			"playful"
		],
		skins: [
			{
				unified: "1f445",
				native: "👅",
				x: 12,
				y: 7
			}
		],
		version: 1
	},
	lips: {
		id: "lips",
		name: "Mouth",
		keywords: [
			"lips",
			"kiss"
		],
		skins: [
			{
				unified: "1f444",
				native: "👄",
				x: 12,
				y: 6
			}
		],
		version: 1
	},
	biting_lip: {
		id: "biting_lip",
		name: "Biting Lip",
		keywords: [
			"flirt",
			"sexy",
			"pain",
			"worry"
		],
		skins: [
			{
				unified: "1fae6",
				native: "🫦",
				x: 55,
				y: 18
			}
		],
		version: 14
	},
	baby: {
		id: "baby",
		name: "Baby",
		keywords: [
			"child",
			"boy",
			"girl",
			"toddler"
		],
		skins: [
			{
				unified: "1f476",
				native: "👶",
				x: 24,
				y: 28
			},
			{
				unified: "1f476-1f3fb",
				native: "👶🏻",
				x: 24,
				y: 29
			},
			{
				unified: "1f476-1f3fc",
				native: "👶🏼",
				x: 24,
				y: 30
			},
			{
				unified: "1f476-1f3fd",
				native: "👶🏽",
				x: 24,
				y: 31
			},
			{
				unified: "1f476-1f3fe",
				native: "👶🏾",
				x: 24,
				y: 32
			},
			{
				unified: "1f476-1f3ff",
				native: "👶🏿",
				x: 24,
				y: 33
			}
		],
		version: 1
	},
	child: {
		id: "child",
		name: "Child",
		keywords: [
			"gender",
			"neutral",
			"young"
		],
		skins: [
			{
				unified: "1f9d2",
				native: "🧒",
				x: 50,
				y: 11
			},
			{
				unified: "1f9d2-1f3fb",
				native: "🧒🏻",
				x: 50,
				y: 12
			},
			{
				unified: "1f9d2-1f3fc",
				native: "🧒🏼",
				x: 50,
				y: 13
			},
			{
				unified: "1f9d2-1f3fd",
				native: "🧒🏽",
				x: 50,
				y: 14
			},
			{
				unified: "1f9d2-1f3fe",
				native: "🧒🏾",
				x: 50,
				y: 15
			},
			{
				unified: "1f9d2-1f3ff",
				native: "🧒🏿",
				x: 50,
				y: 16
			}
		],
		version: 5
	},
	boy: {
		id: "boy",
		name: "Boy",
		keywords: [
			"man",
			"male",
			"guy",
			"teenager"
		],
		skins: [
			{
				unified: "1f466",
				native: "👦",
				x: 13,
				y: 34
			},
			{
				unified: "1f466-1f3fb",
				native: "👦🏻",
				x: 13,
				y: 35
			},
			{
				unified: "1f466-1f3fc",
				native: "👦🏼",
				x: 13,
				y: 36
			},
			{
				unified: "1f466-1f3fd",
				native: "👦🏽",
				x: 13,
				y: 37
			},
			{
				unified: "1f466-1f3fe",
				native: "👦🏾",
				x: 13,
				y: 38
			},
			{
				unified: "1f466-1f3ff",
				native: "👦🏿",
				x: 13,
				y: 39
			}
		],
		version: 1
	},
	girl: {
		id: "girl",
		name: "Girl",
		keywords: [
			"female",
			"woman",
			"teenager"
		],
		skins: [
			{
				unified: "1f467",
				native: "👧",
				x: 13,
				y: 40
			},
			{
				unified: "1f467-1f3fb",
				native: "👧🏻",
				x: 13,
				y: 41
			},
			{
				unified: "1f467-1f3fc",
				native: "👧🏼",
				x: 13,
				y: 42
			},
			{
				unified: "1f467-1f3fd",
				native: "👧🏽",
				x: 13,
				y: 43
			},
			{
				unified: "1f467-1f3fe",
				native: "👧🏾",
				x: 13,
				y: 44
			},
			{
				unified: "1f467-1f3ff",
				native: "👧🏿",
				x: 13,
				y: 45
			}
		],
		version: 1
	},
	adult: {
		id: "adult",
		name: "Adult",
		keywords: [
			"person",
			"gender",
			"neutral"
		],
		skins: [
			{
				unified: "1f9d1",
				native: "🧑",
				x: 50,
				y: 5
			},
			{
				unified: "1f9d1-1f3fb",
				native: "🧑🏻",
				x: 50,
				y: 6
			},
			{
				unified: "1f9d1-1f3fc",
				native: "🧑🏼",
				x: 50,
				y: 7
			},
			{
				unified: "1f9d1-1f3fd",
				native: "🧑🏽",
				x: 50,
				y: 8
			},
			{
				unified: "1f9d1-1f3fe",
				native: "🧑🏾",
				x: 50,
				y: 9
			},
			{
				unified: "1f9d1-1f3ff",
				native: "🧑🏿",
				x: 50,
				y: 10
			}
		],
		version: 5
	},
	person_with_blond_hair: {
		id: "person_with_blond_hair",
		name: "Person Blond Hair",
		keywords: [
			"with",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f471",
				native: "👱",
				x: 23,
				y: 47
			},
			{
				unified: "1f471-1f3fb",
				native: "👱🏻",
				x: 23,
				y: 48
			},
			{
				unified: "1f471-1f3fc",
				native: "👱🏼",
				x: 23,
				y: 49
			},
			{
				unified: "1f471-1f3fd",
				native: "👱🏽",
				x: 23,
				y: 50
			},
			{
				unified: "1f471-1f3fe",
				native: "👱🏾",
				x: 23,
				y: 51
			},
			{
				unified: "1f471-1f3ff",
				native: "👱🏿",
				x: 23,
				y: 52
			}
		],
		version: 1
	},
	man: {
		id: "man",
		name: "Man",
		keywords: [
			"mustache",
			"father",
			"dad",
			"guy",
			"classy",
			"sir",
			"moustache"
		],
		skins: [
			{
				unified: "1f468",
				native: "👨",
				x: 17,
				y: 13
			},
			{
				unified: "1f468-1f3fb",
				native: "👨🏻",
				x: 17,
				y: 14
			},
			{
				unified: "1f468-1f3fc",
				native: "👨🏼",
				x: 17,
				y: 15
			},
			{
				unified: "1f468-1f3fd",
				native: "👨🏽",
				x: 17,
				y: 16
			},
			{
				unified: "1f468-1f3fe",
				native: "👨🏾",
				x: 17,
				y: 17
			},
			{
				unified: "1f468-1f3ff",
				native: "👨🏿",
				x: 17,
				y: 18
			}
		],
		version: 1
	},
	bearded_person: {
		id: "bearded_person",
		name: "Person Beard",
		keywords: [
			"bearded",
			"man",
			"bewhiskered"
		],
		skins: [
			{
				unified: "1f9d4",
				native: "🧔",
				x: 50,
				y: 35
			},
			{
				unified: "1f9d4-1f3fb",
				native: "🧔🏻",
				x: 50,
				y: 36
			},
			{
				unified: "1f9d4-1f3fc",
				native: "🧔🏼",
				x: 50,
				y: 37
			},
			{
				unified: "1f9d4-1f3fd",
				native: "🧔🏽",
				x: 50,
				y: 38
			},
			{
				unified: "1f9d4-1f3fe",
				native: "🧔🏾",
				x: 50,
				y: 39
			},
			{
				unified: "1f9d4-1f3ff",
				native: "🧔🏿",
				x: 50,
				y: 40
			}
		],
		version: 5
	},
	man_with_beard: {
		id: "man_with_beard",
		name: "Man: Beard",
		keywords: [
			"man",
			"with",
			"facial",
			"hair"
		],
		skins: [
			{
				unified: "1f9d4-200d-2642-fe0f",
				native: "🧔‍♂️",
				x: 50,
				y: 29
			},
			{
				unified: "1f9d4-1f3fb-200d-2642-fe0f",
				native: "🧔🏻‍♂️",
				x: 50,
				y: 30
			},
			{
				unified: "1f9d4-1f3fc-200d-2642-fe0f",
				native: "🧔🏼‍♂️",
				x: 50,
				y: 31
			},
			{
				unified: "1f9d4-1f3fd-200d-2642-fe0f",
				native: "🧔🏽‍♂️",
				x: 50,
				y: 32
			},
			{
				unified: "1f9d4-1f3fe-200d-2642-fe0f",
				native: "🧔🏾‍♂️",
				x: 50,
				y: 33
			},
			{
				unified: "1f9d4-1f3ff-200d-2642-fe0f",
				native: "🧔🏿‍♂️",
				x: 50,
				y: 34
			}
		],
		version: 13.1
	},
	woman_with_beard: {
		id: "woman_with_beard",
		name: "Woman: Beard",
		keywords: [
			"woman",
			"with",
			"facial",
			"hair"
		],
		skins: [
			{
				unified: "1f9d4-200d-2640-fe0f",
				native: "🧔‍♀️",
				x: 50,
				y: 23
			},
			{
				unified: "1f9d4-1f3fb-200d-2640-fe0f",
				native: "🧔🏻‍♀️",
				x: 50,
				y: 24
			},
			{
				unified: "1f9d4-1f3fc-200d-2640-fe0f",
				native: "🧔🏼‍♀️",
				x: 50,
				y: 25
			},
			{
				unified: "1f9d4-1f3fd-200d-2640-fe0f",
				native: "🧔🏽‍♀️",
				x: 50,
				y: 26
			},
			{
				unified: "1f9d4-1f3fe-200d-2640-fe0f",
				native: "🧔🏾‍♀️",
				x: 50,
				y: 27
			},
			{
				unified: "1f9d4-1f3ff-200d-2640-fe0f",
				native: "🧔🏿‍♀️",
				x: 50,
				y: 28
			}
		],
		version: 13.1
	},
	red_haired_man: {
		id: "red_haired_man",
		name: "Man: Red Hair",
		keywords: [
			"haired",
			"man",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b0",
				native: "👨‍🦰",
				x: 15,
				y: 29
			},
			{
				unified: "1f468-1f3fb-200d-1f9b0",
				native: "👨🏻‍🦰",
				x: 15,
				y: 30
			},
			{
				unified: "1f468-1f3fc-200d-1f9b0",
				native: "👨🏼‍🦰",
				x: 15,
				y: 31
			},
			{
				unified: "1f468-1f3fd-200d-1f9b0",
				native: "👨🏽‍🦰",
				x: 15,
				y: 32
			},
			{
				unified: "1f468-1f3fe-200d-1f9b0",
				native: "👨🏾‍🦰",
				x: 15,
				y: 33
			},
			{
				unified: "1f468-1f3ff-200d-1f9b0",
				native: "👨🏿‍🦰",
				x: 15,
				y: 34
			}
		],
		version: 11
	},
	curly_haired_man: {
		id: "curly_haired_man",
		name: "Man: Curly Hair",
		keywords: [
			"haired",
			"man",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b1",
				native: "👨‍🦱",
				x: 15,
				y: 35
			},
			{
				unified: "1f468-1f3fb-200d-1f9b1",
				native: "👨🏻‍🦱",
				x: 15,
				y: 36
			},
			{
				unified: "1f468-1f3fc-200d-1f9b1",
				native: "👨🏼‍🦱",
				x: 15,
				y: 37
			},
			{
				unified: "1f468-1f3fd-200d-1f9b1",
				native: "👨🏽‍🦱",
				x: 15,
				y: 38
			},
			{
				unified: "1f468-1f3fe-200d-1f9b1",
				native: "👨🏾‍🦱",
				x: 15,
				y: 39
			},
			{
				unified: "1f468-1f3ff-200d-1f9b1",
				native: "👨🏿‍🦱",
				x: 15,
				y: 40
			}
		],
		version: 11
	},
	white_haired_man: {
		id: "white_haired_man",
		name: "Man: White Hair",
		keywords: [
			"haired",
			"man",
			"old",
			"elder"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b3",
				native: "👨‍🦳",
				x: 15,
				y: 47
			},
			{
				unified: "1f468-1f3fb-200d-1f9b3",
				native: "👨🏻‍🦳",
				x: 15,
				y: 48
			},
			{
				unified: "1f468-1f3fc-200d-1f9b3",
				native: "👨🏼‍🦳",
				x: 15,
				y: 49
			},
			{
				unified: "1f468-1f3fd-200d-1f9b3",
				native: "👨🏽‍🦳",
				x: 15,
				y: 50
			},
			{
				unified: "1f468-1f3fe-200d-1f9b3",
				native: "👨🏾‍🦳",
				x: 15,
				y: 51
			},
			{
				unified: "1f468-1f3ff-200d-1f9b3",
				native: "👨🏿‍🦳",
				x: 15,
				y: 52
			}
		],
		version: 11
	},
	bald_man: {
		id: "bald_man",
		name: "Man: Bald",
		keywords: [
			"man",
			"hairless"
		],
		skins: [
			{
				unified: "1f468-200d-1f9b2",
				native: "👨‍🦲",
				x: 15,
				y: 41
			},
			{
				unified: "1f468-1f3fb-200d-1f9b2",
				native: "👨🏻‍🦲",
				x: 15,
				y: 42
			},
			{
				unified: "1f468-1f3fc-200d-1f9b2",
				native: "👨🏼‍🦲",
				x: 15,
				y: 43
			},
			{
				unified: "1f468-1f3fd-200d-1f9b2",
				native: "👨🏽‍🦲",
				x: 15,
				y: 44
			},
			{
				unified: "1f468-1f3fe-200d-1f9b2",
				native: "👨🏾‍🦲",
				x: 15,
				y: 45
			},
			{
				unified: "1f468-1f3ff-200d-1f9b2",
				native: "👨🏿‍🦲",
				x: 15,
				y: 46
			}
		],
		version: 11
	},
	woman: {
		id: "woman",
		name: "Woman",
		keywords: [
			"female",
			"girls",
			"lady"
		],
		skins: [
			{
				unified: "1f469",
				native: "👩",
				x: 21,
				y: 33
			},
			{
				unified: "1f469-1f3fb",
				native: "👩🏻",
				x: 21,
				y: 34
			},
			{
				unified: "1f469-1f3fc",
				native: "👩🏼",
				x: 21,
				y: 35
			},
			{
				unified: "1f469-1f3fd",
				native: "👩🏽",
				x: 21,
				y: 36
			},
			{
				unified: "1f469-1f3fe",
				native: "👩🏾",
				x: 21,
				y: 37
			},
			{
				unified: "1f469-1f3ff",
				native: "👩🏿",
				x: 21,
				y: 38
			}
		],
		version: 1
	},
	red_haired_woman: {
		id: "red_haired_woman",
		name: "Woman: Red Hair",
		keywords: [
			"haired",
			"woman",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b0",
				native: "👩‍🦰",
				x: 18,
				y: 58
			},
			{
				unified: "1f469-1f3fb-200d-1f9b0",
				native: "👩🏻‍🦰",
				x: 18,
				y: 59
			},
			{
				unified: "1f469-1f3fc-200d-1f9b0",
				native: "👩🏼‍🦰",
				x: 18,
				y: 60
			},
			{
				unified: "1f469-1f3fd-200d-1f9b0",
				native: "👩🏽‍🦰",
				x: 19,
				y: 0
			},
			{
				unified: "1f469-1f3fe-200d-1f9b0",
				native: "👩🏾‍🦰",
				x: 19,
				y: 1
			},
			{
				unified: "1f469-1f3ff-200d-1f9b0",
				native: "👩🏿‍🦰",
				x: 19,
				y: 2
			}
		],
		version: 11
	},
	red_haired_person: {
		id: "red_haired_person",
		name: "Person: Red Hair",
		keywords: [
			"haired",
			"person",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b0",
				native: "🧑‍🦰",
				x: 49,
				y: 12
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b0",
				native: "🧑🏻‍🦰",
				x: 49,
				y: 13
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b0",
				native: "🧑🏼‍🦰",
				x: 49,
				y: 14
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b0",
				native: "🧑🏽‍🦰",
				x: 49,
				y: 15
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b0",
				native: "🧑🏾‍🦰",
				x: 49,
				y: 16
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b0",
				native: "🧑🏿‍🦰",
				x: 49,
				y: 17
			}
		],
		version: 12.1
	},
	curly_haired_woman: {
		id: "curly_haired_woman",
		name: "Woman: Curly Hair",
		keywords: [
			"haired",
			"woman",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b1",
				native: "👩‍🦱",
				x: 19,
				y: 3
			},
			{
				unified: "1f469-1f3fb-200d-1f9b1",
				native: "👩🏻‍🦱",
				x: 19,
				y: 4
			},
			{
				unified: "1f469-1f3fc-200d-1f9b1",
				native: "👩🏼‍🦱",
				x: 19,
				y: 5
			},
			{
				unified: "1f469-1f3fd-200d-1f9b1",
				native: "👩🏽‍🦱",
				x: 19,
				y: 6
			},
			{
				unified: "1f469-1f3fe-200d-1f9b1",
				native: "👩🏾‍🦱",
				x: 19,
				y: 7
			},
			{
				unified: "1f469-1f3ff-200d-1f9b1",
				native: "👩🏿‍🦱",
				x: 19,
				y: 8
			}
		],
		version: 11
	},
	curly_haired_person: {
		id: "curly_haired_person",
		name: "Person: Curly Hair",
		keywords: [
			"haired",
			"person",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b1",
				native: "🧑‍🦱",
				x: 49,
				y: 18
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b1",
				native: "🧑🏻‍🦱",
				x: 49,
				y: 19
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b1",
				native: "🧑🏼‍🦱",
				x: 49,
				y: 20
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b1",
				native: "🧑🏽‍🦱",
				x: 49,
				y: 21
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b1",
				native: "🧑🏾‍🦱",
				x: 49,
				y: 22
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b1",
				native: "🧑🏿‍🦱",
				x: 49,
				y: 23
			}
		],
		version: 12.1
	},
	white_haired_woman: {
		id: "white_haired_woman",
		name: "Woman: White Hair",
		keywords: [
			"haired",
			"woman",
			"old",
			"elder"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b3",
				native: "👩‍🦳",
				x: 19,
				y: 15
			},
			{
				unified: "1f469-1f3fb-200d-1f9b3",
				native: "👩🏻‍🦳",
				x: 19,
				y: 16
			},
			{
				unified: "1f469-1f3fc-200d-1f9b3",
				native: "👩🏼‍🦳",
				x: 19,
				y: 17
			},
			{
				unified: "1f469-1f3fd-200d-1f9b3",
				native: "👩🏽‍🦳",
				x: 19,
				y: 18
			},
			{
				unified: "1f469-1f3fe-200d-1f9b3",
				native: "👩🏾‍🦳",
				x: 19,
				y: 19
			},
			{
				unified: "1f469-1f3ff-200d-1f9b3",
				native: "👩🏿‍🦳",
				x: 19,
				y: 20
			}
		],
		version: 11
	},
	white_haired_person: {
		id: "white_haired_person",
		name: "Person: White Hair",
		keywords: [
			"haired",
			"person",
			"elder",
			"old"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b3",
				native: "🧑‍🦳",
				x: 49,
				y: 30
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b3",
				native: "🧑🏻‍🦳",
				x: 49,
				y: 31
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b3",
				native: "🧑🏼‍🦳",
				x: 49,
				y: 32
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b3",
				native: "🧑🏽‍🦳",
				x: 49,
				y: 33
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b3",
				native: "🧑🏾‍🦳",
				x: 49,
				y: 34
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b3",
				native: "🧑🏿‍🦳",
				x: 49,
				y: 35
			}
		],
		version: 12.1
	},
	bald_woman: {
		id: "bald_woman",
		name: "Woman: Bald",
		keywords: [
			"woman",
			"hairless"
		],
		skins: [
			{
				unified: "1f469-200d-1f9b2",
				native: "👩‍🦲",
				x: 19,
				y: 9
			},
			{
				unified: "1f469-1f3fb-200d-1f9b2",
				native: "👩🏻‍🦲",
				x: 19,
				y: 10
			},
			{
				unified: "1f469-1f3fc-200d-1f9b2",
				native: "👩🏼‍🦲",
				x: 19,
				y: 11
			},
			{
				unified: "1f469-1f3fd-200d-1f9b2",
				native: "👩🏽‍🦲",
				x: 19,
				y: 12
			},
			{
				unified: "1f469-1f3fe-200d-1f9b2",
				native: "👩🏾‍🦲",
				x: 19,
				y: 13
			},
			{
				unified: "1f469-1f3ff-200d-1f9b2",
				native: "👩🏿‍🦲",
				x: 19,
				y: 14
			}
		],
		version: 11
	},
	bald_person: {
		id: "bald_person",
		name: "Person: Bald",
		keywords: [
			"person",
			"hairless"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9b2",
				native: "🧑‍🦲",
				x: 49,
				y: 24
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9b2",
				native: "🧑🏻‍🦲",
				x: 49,
				y: 25
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9b2",
				native: "🧑🏼‍🦲",
				x: 49,
				y: 26
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9b2",
				native: "🧑🏽‍🦲",
				x: 49,
				y: 27
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9b2",
				native: "🧑🏾‍🦲",
				x: 49,
				y: 28
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9b2",
				native: "🧑🏿‍🦲",
				x: 49,
				y: 29
			}
		],
		version: 12.1
	},
	"blond-haired-woman": {
		id: "blond-haired-woman",
		name: "Woman: Blond Hair",
		keywords: [
			"haired-woman",
			"woman",
			"female",
			"girl",
			"blonde",
			"person"
		],
		skins: [
			{
				unified: "1f471-200d-2640-fe0f",
				native: "👱‍♀️",
				x: 23,
				y: 35
			},
			{
				unified: "1f471-1f3fb-200d-2640-fe0f",
				native: "👱🏻‍♀️",
				x: 23,
				y: 36
			},
			{
				unified: "1f471-1f3fc-200d-2640-fe0f",
				native: "👱🏼‍♀️",
				x: 23,
				y: 37
			},
			{
				unified: "1f471-1f3fd-200d-2640-fe0f",
				native: "👱🏽‍♀️",
				x: 23,
				y: 38
			},
			{
				unified: "1f471-1f3fe-200d-2640-fe0f",
				native: "👱🏾‍♀️",
				x: 23,
				y: 39
			},
			{
				unified: "1f471-1f3ff-200d-2640-fe0f",
				native: "👱🏿‍♀️",
				x: 23,
				y: 40
			}
		],
		version: 4
	},
	"blond-haired-man": {
		id: "blond-haired-man",
		name: "Man: Blond Hair",
		keywords: [
			"haired-man",
			"man",
			"male",
			"boy",
			"blonde",
			"guy",
			"person"
		],
		skins: [
			{
				unified: "1f471-200d-2642-fe0f",
				native: "👱‍♂️",
				x: 23,
				y: 41
			},
			{
				unified: "1f471-1f3fb-200d-2642-fe0f",
				native: "👱🏻‍♂️",
				x: 23,
				y: 42
			},
			{
				unified: "1f471-1f3fc-200d-2642-fe0f",
				native: "👱🏼‍♂️",
				x: 23,
				y: 43
			},
			{
				unified: "1f471-1f3fd-200d-2642-fe0f",
				native: "👱🏽‍♂️",
				x: 23,
				y: 44
			},
			{
				unified: "1f471-1f3fe-200d-2642-fe0f",
				native: "👱🏾‍♂️",
				x: 23,
				y: 45
			},
			{
				unified: "1f471-1f3ff-200d-2642-fe0f",
				native: "👱🏿‍♂️",
				x: 23,
				y: 46
			}
		],
		version: 4
	},
	older_adult: {
		id: "older_adult",
		name: "Older Adult",
		keywords: [
			"person",
			"human",
			"elder",
			"senior",
			"gender",
			"neutral"
		],
		skins: [
			{
				unified: "1f9d3",
				native: "🧓",
				x: 50,
				y: 17
			},
			{
				unified: "1f9d3-1f3fb",
				native: "🧓🏻",
				x: 50,
				y: 18
			},
			{
				unified: "1f9d3-1f3fc",
				native: "🧓🏼",
				x: 50,
				y: 19
			},
			{
				unified: "1f9d3-1f3fd",
				native: "🧓🏽",
				x: 50,
				y: 20
			},
			{
				unified: "1f9d3-1f3fe",
				native: "🧓🏾",
				x: 50,
				y: 21
			},
			{
				unified: "1f9d3-1f3ff",
				native: "🧓🏿",
				x: 50,
				y: 22
			}
		],
		version: 5
	},
	older_man: {
		id: "older_man",
		name: "Old Man",
		keywords: [
			"older",
			"human",
			"male",
			"men",
			"elder",
			"senior"
		],
		skins: [
			{
				unified: "1f474",
				native: "👴",
				x: 24,
				y: 16
			},
			{
				unified: "1f474-1f3fb",
				native: "👴🏻",
				x: 24,
				y: 17
			},
			{
				unified: "1f474-1f3fc",
				native: "👴🏼",
				x: 24,
				y: 18
			},
			{
				unified: "1f474-1f3fd",
				native: "👴🏽",
				x: 24,
				y: 19
			},
			{
				unified: "1f474-1f3fe",
				native: "👴🏾",
				x: 24,
				y: 20
			},
			{
				unified: "1f474-1f3ff",
				native: "👴🏿",
				x: 24,
				y: 21
			}
		],
		version: 1
	},
	older_woman: {
		id: "older_woman",
		name: "Old Woman",
		keywords: [
			"older",
			"human",
			"female",
			"women",
			"lady",
			"elder",
			"senior"
		],
		skins: [
			{
				unified: "1f475",
				native: "👵",
				x: 24,
				y: 22
			},
			{
				unified: "1f475-1f3fb",
				native: "👵🏻",
				x: 24,
				y: 23
			},
			{
				unified: "1f475-1f3fc",
				native: "👵🏼",
				x: 24,
				y: 24
			},
			{
				unified: "1f475-1f3fd",
				native: "👵🏽",
				x: 24,
				y: 25
			},
			{
				unified: "1f475-1f3fe",
				native: "👵🏾",
				x: 24,
				y: 26
			},
			{
				unified: "1f475-1f3ff",
				native: "👵🏿",
				x: 24,
				y: 27
			}
		],
		version: 1
	},
	person_frowning: {
		id: "person_frowning",
		name: "Person Frowning",
		keywords: [
			"worried"
		],
		skins: [
			{
				unified: "1f64d",
				native: "🙍",
				x: 35,
				y: 2
			},
			{
				unified: "1f64d-1f3fb",
				native: "🙍🏻",
				x: 35,
				y: 3
			},
			{
				unified: "1f64d-1f3fc",
				native: "🙍🏼",
				x: 35,
				y: 4
			},
			{
				unified: "1f64d-1f3fd",
				native: "🙍🏽",
				x: 35,
				y: 5
			},
			{
				unified: "1f64d-1f3fe",
				native: "🙍🏾",
				x: 35,
				y: 6
			},
			{
				unified: "1f64d-1f3ff",
				native: "🙍🏿",
				x: 35,
				y: 7
			}
		],
		version: 1
	},
	"man-frowning": {
		id: "man-frowning",
		name: "Man Frowning",
		keywords: [
			"male",
			"boy",
			"sad",
			"depressed",
			"discouraged",
			"unhappy"
		],
		skins: [
			{
				unified: "1f64d-200d-2642-fe0f",
				native: "🙍‍♂️",
				x: 34,
				y: 57
			},
			{
				unified: "1f64d-1f3fb-200d-2642-fe0f",
				native: "🙍🏻‍♂️",
				x: 34,
				y: 58
			},
			{
				unified: "1f64d-1f3fc-200d-2642-fe0f",
				native: "🙍🏼‍♂️",
				x: 34,
				y: 59
			},
			{
				unified: "1f64d-1f3fd-200d-2642-fe0f",
				native: "🙍🏽‍♂️",
				x: 34,
				y: 60
			},
			{
				unified: "1f64d-1f3fe-200d-2642-fe0f",
				native: "🙍🏾‍♂️",
				x: 35,
				y: 0
			},
			{
				unified: "1f64d-1f3ff-200d-2642-fe0f",
				native: "🙍🏿‍♂️",
				x: 35,
				y: 1
			}
		],
		version: 4
	},
	"woman-frowning": {
		id: "woman-frowning",
		name: "Woman Frowning",
		keywords: [
			"female",
			"girl",
			"sad",
			"depressed",
			"discouraged",
			"unhappy"
		],
		skins: [
			{
				unified: "1f64d-200d-2640-fe0f",
				native: "🙍‍♀️",
				x: 34,
				y: 51
			},
			{
				unified: "1f64d-1f3fb-200d-2640-fe0f",
				native: "🙍🏻‍♀️",
				x: 34,
				y: 52
			},
			{
				unified: "1f64d-1f3fc-200d-2640-fe0f",
				native: "🙍🏼‍♀️",
				x: 34,
				y: 53
			},
			{
				unified: "1f64d-1f3fd-200d-2640-fe0f",
				native: "🙍🏽‍♀️",
				x: 34,
				y: 54
			},
			{
				unified: "1f64d-1f3fe-200d-2640-fe0f",
				native: "🙍🏾‍♀️",
				x: 34,
				y: 55
			},
			{
				unified: "1f64d-1f3ff-200d-2640-fe0f",
				native: "🙍🏿‍♀️",
				x: 34,
				y: 56
			}
		],
		version: 4
	},
	person_with_pouting_face: {
		id: "person_with_pouting_face",
		name: "Person Pouting",
		keywords: [
			"with",
			"face",
			"upset"
		],
		skins: [
			{
				unified: "1f64e",
				native: "🙎",
				x: 35,
				y: 20
			},
			{
				unified: "1f64e-1f3fb",
				native: "🙎🏻",
				x: 35,
				y: 21
			},
			{
				unified: "1f64e-1f3fc",
				native: "🙎🏼",
				x: 35,
				y: 22
			},
			{
				unified: "1f64e-1f3fd",
				native: "🙎🏽",
				x: 35,
				y: 23
			},
			{
				unified: "1f64e-1f3fe",
				native: "🙎🏾",
				x: 35,
				y: 24
			},
			{
				unified: "1f64e-1f3ff",
				native: "🙎🏿",
				x: 35,
				y: 25
			}
		],
		version: 1
	},
	"man-pouting": {
		id: "man-pouting",
		name: "Man Pouting",
		keywords: [
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f64e-200d-2642-fe0f",
				native: "🙎‍♂️",
				x: 35,
				y: 14
			},
			{
				unified: "1f64e-1f3fb-200d-2642-fe0f",
				native: "🙎🏻‍♂️",
				x: 35,
				y: 15
			},
			{
				unified: "1f64e-1f3fc-200d-2642-fe0f",
				native: "🙎🏼‍♂️",
				x: 35,
				y: 16
			},
			{
				unified: "1f64e-1f3fd-200d-2642-fe0f",
				native: "🙎🏽‍♂️",
				x: 35,
				y: 17
			},
			{
				unified: "1f64e-1f3fe-200d-2642-fe0f",
				native: "🙎🏾‍♂️",
				x: 35,
				y: 18
			},
			{
				unified: "1f64e-1f3ff-200d-2642-fe0f",
				native: "🙎🏿‍♂️",
				x: 35,
				y: 19
			}
		],
		version: 4
	},
	"woman-pouting": {
		id: "woman-pouting",
		name: "Woman Pouting",
		keywords: [
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f64e-200d-2640-fe0f",
				native: "🙎‍♀️",
				x: 35,
				y: 8
			},
			{
				unified: "1f64e-1f3fb-200d-2640-fe0f",
				native: "🙎🏻‍♀️",
				x: 35,
				y: 9
			},
			{
				unified: "1f64e-1f3fc-200d-2640-fe0f",
				native: "🙎🏼‍♀️",
				x: 35,
				y: 10
			},
			{
				unified: "1f64e-1f3fd-200d-2640-fe0f",
				native: "🙎🏽‍♀️",
				x: 35,
				y: 11
			},
			{
				unified: "1f64e-1f3fe-200d-2640-fe0f",
				native: "🙎🏾‍♀️",
				x: 35,
				y: 12
			},
			{
				unified: "1f64e-1f3ff-200d-2640-fe0f",
				native: "🙎🏿‍♀️",
				x: 35,
				y: 13
			}
		],
		version: 4
	},
	no_good: {
		id: "no_good",
		name: "Person Gesturing No",
		keywords: [
			"good",
			"decline"
		],
		skins: [
			{
				unified: "1f645",
				native: "🙅",
				x: 33,
				y: 43
			},
			{
				unified: "1f645-1f3fb",
				native: "🙅🏻",
				x: 33,
				y: 44
			},
			{
				unified: "1f645-1f3fc",
				native: "🙅🏼",
				x: 33,
				y: 45
			},
			{
				unified: "1f645-1f3fd",
				native: "🙅🏽",
				x: 33,
				y: 46
			},
			{
				unified: "1f645-1f3fe",
				native: "🙅🏾",
				x: 33,
				y: 47
			},
			{
				unified: "1f645-1f3ff",
				native: "🙅🏿",
				x: 33,
				y: 48
			}
		],
		version: 1
	},
	"man-gesturing-no": {
		id: "man-gesturing-no",
		name: "Man Gesturing No",
		keywords: [
			"gesturing-no",
			"male",
			"boy",
			"nope"
		],
		skins: [
			{
				unified: "1f645-200d-2642-fe0f",
				native: "🙅‍♂️",
				x: 33,
				y: 37
			},
			{
				unified: "1f645-1f3fb-200d-2642-fe0f",
				native: "🙅🏻‍♂️",
				x: 33,
				y: 38
			},
			{
				unified: "1f645-1f3fc-200d-2642-fe0f",
				native: "🙅🏼‍♂️",
				x: 33,
				y: 39
			},
			{
				unified: "1f645-1f3fd-200d-2642-fe0f",
				native: "🙅🏽‍♂️",
				x: 33,
				y: 40
			},
			{
				unified: "1f645-1f3fe-200d-2642-fe0f",
				native: "🙅🏾‍♂️",
				x: 33,
				y: 41
			},
			{
				unified: "1f645-1f3ff-200d-2642-fe0f",
				native: "🙅🏿‍♂️",
				x: 33,
				y: 42
			}
		],
		version: 4
	},
	"woman-gesturing-no": {
		id: "woman-gesturing-no",
		name: "Woman Gesturing No",
		keywords: [
			"gesturing-no",
			"female",
			"girl",
			"nope"
		],
		skins: [
			{
				unified: "1f645-200d-2640-fe0f",
				native: "🙅‍♀️",
				x: 33,
				y: 31
			},
			{
				unified: "1f645-1f3fb-200d-2640-fe0f",
				native: "🙅🏻‍♀️",
				x: 33,
				y: 32
			},
			{
				unified: "1f645-1f3fc-200d-2640-fe0f",
				native: "🙅🏼‍♀️",
				x: 33,
				y: 33
			},
			{
				unified: "1f645-1f3fd-200d-2640-fe0f",
				native: "🙅🏽‍♀️",
				x: 33,
				y: 34
			},
			{
				unified: "1f645-1f3fe-200d-2640-fe0f",
				native: "🙅🏾‍♀️",
				x: 33,
				y: 35
			},
			{
				unified: "1f645-1f3ff-200d-2640-fe0f",
				native: "🙅🏿‍♀️",
				x: 33,
				y: 36
			}
		],
		version: 4
	},
	ok_woman: {
		id: "ok_woman",
		name: "Person Gesturing Ok",
		keywords: [
			"woman",
			"agree"
		],
		skins: [
			{
				unified: "1f646",
				native: "🙆",
				x: 34,
				y: 0
			},
			{
				unified: "1f646-1f3fb",
				native: "🙆🏻",
				x: 34,
				y: 1
			},
			{
				unified: "1f646-1f3fc",
				native: "🙆🏼",
				x: 34,
				y: 2
			},
			{
				unified: "1f646-1f3fd",
				native: "🙆🏽",
				x: 34,
				y: 3
			},
			{
				unified: "1f646-1f3fe",
				native: "🙆🏾",
				x: 34,
				y: 4
			},
			{
				unified: "1f646-1f3ff",
				native: "🙆🏿",
				x: 34,
				y: 5
			}
		],
		version: 1
	},
	"man-gesturing-ok": {
		id: "man-gesturing-ok",
		name: "Man Gesturing Ok",
		keywords: [
			"gesturing-ok",
			"men",
			"boy",
			"male",
			"blue",
			"human"
		],
		skins: [
			{
				unified: "1f646-200d-2642-fe0f",
				native: "🙆‍♂️",
				x: 33,
				y: 55
			},
			{
				unified: "1f646-1f3fb-200d-2642-fe0f",
				native: "🙆🏻‍♂️",
				x: 33,
				y: 56
			},
			{
				unified: "1f646-1f3fc-200d-2642-fe0f",
				native: "🙆🏼‍♂️",
				x: 33,
				y: 57
			},
			{
				unified: "1f646-1f3fd-200d-2642-fe0f",
				native: "🙆🏽‍♂️",
				x: 33,
				y: 58
			},
			{
				unified: "1f646-1f3fe-200d-2642-fe0f",
				native: "🙆🏾‍♂️",
				x: 33,
				y: 59
			},
			{
				unified: "1f646-1f3ff-200d-2642-fe0f",
				native: "🙆🏿‍♂️",
				x: 33,
				y: 60
			}
		],
		version: 4
	},
	"woman-gesturing-ok": {
		id: "woman-gesturing-ok",
		name: "Woman Gesturing Ok",
		keywords: [
			"gesturing-ok",
			"women",
			"girl",
			"female",
			"pink",
			"human"
		],
		skins: [
			{
				unified: "1f646-200d-2640-fe0f",
				native: "🙆‍♀️",
				x: 33,
				y: 49
			},
			{
				unified: "1f646-1f3fb-200d-2640-fe0f",
				native: "🙆🏻‍♀️",
				x: 33,
				y: 50
			},
			{
				unified: "1f646-1f3fc-200d-2640-fe0f",
				native: "🙆🏼‍♀️",
				x: 33,
				y: 51
			},
			{
				unified: "1f646-1f3fd-200d-2640-fe0f",
				native: "🙆🏽‍♀️",
				x: 33,
				y: 52
			},
			{
				unified: "1f646-1f3fe-200d-2640-fe0f",
				native: "🙆🏾‍♀️",
				x: 33,
				y: 53
			},
			{
				unified: "1f646-1f3ff-200d-2640-fe0f",
				native: "🙆🏿‍♀️",
				x: 33,
				y: 54
			}
		],
		version: 4
	},
	information_desk_person: {
		id: "information_desk_person",
		name: "Person Tipping Hand",
		keywords: [
			"information",
			"desk"
		],
		skins: [
			{
				unified: "1f481",
				native: "💁",
				x: 25,
				y: 22
			},
			{
				unified: "1f481-1f3fb",
				native: "💁🏻",
				x: 25,
				y: 23
			},
			{
				unified: "1f481-1f3fc",
				native: "💁🏼",
				x: 25,
				y: 24
			},
			{
				unified: "1f481-1f3fd",
				native: "💁🏽",
				x: 25,
				y: 25
			},
			{
				unified: "1f481-1f3fe",
				native: "💁🏾",
				x: 25,
				y: 26
			},
			{
				unified: "1f481-1f3ff",
				native: "💁🏿",
				x: 25,
				y: 27
			}
		],
		version: 1
	},
	"man-tipping-hand": {
		id: "man-tipping-hand",
		name: "Man Tipping Hand",
		keywords: [
			"tipping-hand",
			"male",
			"boy",
			"human",
			"information"
		],
		skins: [
			{
				unified: "1f481-200d-2642-fe0f",
				native: "💁‍♂️",
				x: 25,
				y: 16
			},
			{
				unified: "1f481-1f3fb-200d-2642-fe0f",
				native: "💁🏻‍♂️",
				x: 25,
				y: 17
			},
			{
				unified: "1f481-1f3fc-200d-2642-fe0f",
				native: "💁🏼‍♂️",
				x: 25,
				y: 18
			},
			{
				unified: "1f481-1f3fd-200d-2642-fe0f",
				native: "💁🏽‍♂️",
				x: 25,
				y: 19
			},
			{
				unified: "1f481-1f3fe-200d-2642-fe0f",
				native: "💁🏾‍♂️",
				x: 25,
				y: 20
			},
			{
				unified: "1f481-1f3ff-200d-2642-fe0f",
				native: "💁🏿‍♂️",
				x: 25,
				y: 21
			}
		],
		version: 4
	},
	"woman-tipping-hand": {
		id: "woman-tipping-hand",
		name: "Woman Tipping Hand",
		keywords: [
			"tipping-hand",
			"female",
			"girl",
			"human",
			"information"
		],
		skins: [
			{
				unified: "1f481-200d-2640-fe0f",
				native: "💁‍♀️",
				x: 25,
				y: 10
			},
			{
				unified: "1f481-1f3fb-200d-2640-fe0f",
				native: "💁🏻‍♀️",
				x: 25,
				y: 11
			},
			{
				unified: "1f481-1f3fc-200d-2640-fe0f",
				native: "💁🏼‍♀️",
				x: 25,
				y: 12
			},
			{
				unified: "1f481-1f3fd-200d-2640-fe0f",
				native: "💁🏽‍♀️",
				x: 25,
				y: 13
			},
			{
				unified: "1f481-1f3fe-200d-2640-fe0f",
				native: "💁🏾‍♀️",
				x: 25,
				y: 14
			},
			{
				unified: "1f481-1f3ff-200d-2640-fe0f",
				native: "💁🏿‍♀️",
				x: 25,
				y: 15
			}
		],
		version: 4
	},
	raising_hand: {
		id: "raising_hand",
		name: "Person Raising Hand",
		keywords: [
			"question"
		],
		skins: [
			{
				unified: "1f64b",
				native: "🙋",
				x: 34,
				y: 39
			},
			{
				unified: "1f64b-1f3fb",
				native: "🙋🏻",
				x: 34,
				y: 40
			},
			{
				unified: "1f64b-1f3fc",
				native: "🙋🏼",
				x: 34,
				y: 41
			},
			{
				unified: "1f64b-1f3fd",
				native: "🙋🏽",
				x: 34,
				y: 42
			},
			{
				unified: "1f64b-1f3fe",
				native: "🙋🏾",
				x: 34,
				y: 43
			},
			{
				unified: "1f64b-1f3ff",
				native: "🙋🏿",
				x: 34,
				y: 44
			}
		],
		version: 1
	},
	"man-raising-hand": {
		id: "man-raising-hand",
		name: "Man Raising Hand",
		keywords: [
			"raising-hand",
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f64b-200d-2642-fe0f",
				native: "🙋‍♂️",
				x: 34,
				y: 33
			},
			{
				unified: "1f64b-1f3fb-200d-2642-fe0f",
				native: "🙋🏻‍♂️",
				x: 34,
				y: 34
			},
			{
				unified: "1f64b-1f3fc-200d-2642-fe0f",
				native: "🙋🏼‍♂️",
				x: 34,
				y: 35
			},
			{
				unified: "1f64b-1f3fd-200d-2642-fe0f",
				native: "🙋🏽‍♂️",
				x: 34,
				y: 36
			},
			{
				unified: "1f64b-1f3fe-200d-2642-fe0f",
				native: "🙋🏾‍♂️",
				x: 34,
				y: 37
			},
			{
				unified: "1f64b-1f3ff-200d-2642-fe0f",
				native: "🙋🏿‍♂️",
				x: 34,
				y: 38
			}
		],
		version: 4
	},
	"woman-raising-hand": {
		id: "woman-raising-hand",
		name: "Woman Raising Hand",
		keywords: [
			"raising-hand",
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f64b-200d-2640-fe0f",
				native: "🙋‍♀️",
				x: 34,
				y: 27
			},
			{
				unified: "1f64b-1f3fb-200d-2640-fe0f",
				native: "🙋🏻‍♀️",
				x: 34,
				y: 28
			},
			{
				unified: "1f64b-1f3fc-200d-2640-fe0f",
				native: "🙋🏼‍♀️",
				x: 34,
				y: 29
			},
			{
				unified: "1f64b-1f3fd-200d-2640-fe0f",
				native: "🙋🏽‍♀️",
				x: 34,
				y: 30
			},
			{
				unified: "1f64b-1f3fe-200d-2640-fe0f",
				native: "🙋🏾‍♀️",
				x: 34,
				y: 31
			},
			{
				unified: "1f64b-1f3ff-200d-2640-fe0f",
				native: "🙋🏿‍♀️",
				x: 34,
				y: 32
			}
		],
		version: 4
	},
	deaf_person: {
		id: "deaf_person",
		name: "Deaf Person",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf",
				native: "🧏",
				x: 47,
				y: 5
			},
			{
				unified: "1f9cf-1f3fb",
				native: "🧏🏻",
				x: 47,
				y: 6
			},
			{
				unified: "1f9cf-1f3fc",
				native: "🧏🏼",
				x: 47,
				y: 7
			},
			{
				unified: "1f9cf-1f3fd",
				native: "🧏🏽",
				x: 47,
				y: 8
			},
			{
				unified: "1f9cf-1f3fe",
				native: "🧏🏾",
				x: 47,
				y: 9
			},
			{
				unified: "1f9cf-1f3ff",
				native: "🧏🏿",
				x: 47,
				y: 10
			}
		],
		version: 12
	},
	deaf_man: {
		id: "deaf_man",
		name: "Deaf Man",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf-200d-2642-fe0f",
				native: "🧏‍♂️",
				x: 46,
				y: 60
			},
			{
				unified: "1f9cf-1f3fb-200d-2642-fe0f",
				native: "🧏🏻‍♂️",
				x: 47,
				y: 0
			},
			{
				unified: "1f9cf-1f3fc-200d-2642-fe0f",
				native: "🧏🏼‍♂️",
				x: 47,
				y: 1
			},
			{
				unified: "1f9cf-1f3fd-200d-2642-fe0f",
				native: "🧏🏽‍♂️",
				x: 47,
				y: 2
			},
			{
				unified: "1f9cf-1f3fe-200d-2642-fe0f",
				native: "🧏🏾‍♂️",
				x: 47,
				y: 3
			},
			{
				unified: "1f9cf-1f3ff-200d-2642-fe0f",
				native: "🧏🏿‍♂️",
				x: 47,
				y: 4
			}
		],
		version: 12
	},
	deaf_woman: {
		id: "deaf_woman",
		name: "Deaf Woman",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9cf-200d-2640-fe0f",
				native: "🧏‍♀️",
				x: 46,
				y: 54
			},
			{
				unified: "1f9cf-1f3fb-200d-2640-fe0f",
				native: "🧏🏻‍♀️",
				x: 46,
				y: 55
			},
			{
				unified: "1f9cf-1f3fc-200d-2640-fe0f",
				native: "🧏🏼‍♀️",
				x: 46,
				y: 56
			},
			{
				unified: "1f9cf-1f3fd-200d-2640-fe0f",
				native: "🧏🏽‍♀️",
				x: 46,
				y: 57
			},
			{
				unified: "1f9cf-1f3fe-200d-2640-fe0f",
				native: "🧏🏾‍♀️",
				x: 46,
				y: 58
			},
			{
				unified: "1f9cf-1f3ff-200d-2640-fe0f",
				native: "🧏🏿‍♀️",
				x: 46,
				y: 59
			}
		],
		version: 12
	},
	bow: {
		id: "bow",
		name: "Person Bowing",
		keywords: [
			"bow",
			"respectiful"
		],
		skins: [
			{
				unified: "1f647",
				native: "🙇",
				x: 34,
				y: 18
			},
			{
				unified: "1f647-1f3fb",
				native: "🙇🏻",
				x: 34,
				y: 19
			},
			{
				unified: "1f647-1f3fc",
				native: "🙇🏼",
				x: 34,
				y: 20
			},
			{
				unified: "1f647-1f3fd",
				native: "🙇🏽",
				x: 34,
				y: 21
			},
			{
				unified: "1f647-1f3fe",
				native: "🙇🏾",
				x: 34,
				y: 22
			},
			{
				unified: "1f647-1f3ff",
				native: "🙇🏿",
				x: 34,
				y: 23
			}
		],
		version: 1
	},
	"man-bowing": {
		id: "man-bowing",
		name: "Man Bowing",
		keywords: [
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f647-200d-2642-fe0f",
				native: "🙇‍♂️",
				x: 34,
				y: 12
			},
			{
				unified: "1f647-1f3fb-200d-2642-fe0f",
				native: "🙇🏻‍♂️",
				x: 34,
				y: 13
			},
			{
				unified: "1f647-1f3fc-200d-2642-fe0f",
				native: "🙇🏼‍♂️",
				x: 34,
				y: 14
			},
			{
				unified: "1f647-1f3fd-200d-2642-fe0f",
				native: "🙇🏽‍♂️",
				x: 34,
				y: 15
			},
			{
				unified: "1f647-1f3fe-200d-2642-fe0f",
				native: "🙇🏾‍♂️",
				x: 34,
				y: 16
			},
			{
				unified: "1f647-1f3ff-200d-2642-fe0f",
				native: "🙇🏿‍♂️",
				x: 34,
				y: 17
			}
		],
		version: 4
	},
	"woman-bowing": {
		id: "woman-bowing",
		name: "Woman Bowing",
		keywords: [
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f647-200d-2640-fe0f",
				native: "🙇‍♀️",
				x: 34,
				y: 6
			},
			{
				unified: "1f647-1f3fb-200d-2640-fe0f",
				native: "🙇🏻‍♀️",
				x: 34,
				y: 7
			},
			{
				unified: "1f647-1f3fc-200d-2640-fe0f",
				native: "🙇🏼‍♀️",
				x: 34,
				y: 8
			},
			{
				unified: "1f647-1f3fd-200d-2640-fe0f",
				native: "🙇🏽‍♀️",
				x: 34,
				y: 9
			},
			{
				unified: "1f647-1f3fe-200d-2640-fe0f",
				native: "🙇🏾‍♀️",
				x: 34,
				y: 10
			},
			{
				unified: "1f647-1f3ff-200d-2640-fe0f",
				native: "🙇🏿‍♀️",
				x: 34,
				y: 11
			}
		],
		version: 4
	},
	face_palm: {
		id: "face_palm",
		name: "Face Palm",
		keywords: [
			"person",
			"facepalming",
			"disappointed"
		],
		skins: [
			{
				unified: "1f926",
				native: "🤦",
				x: 40,
				y: 30
			},
			{
				unified: "1f926-1f3fb",
				native: "🤦🏻",
				x: 40,
				y: 31
			},
			{
				unified: "1f926-1f3fc",
				native: "🤦🏼",
				x: 40,
				y: 32
			},
			{
				unified: "1f926-1f3fd",
				native: "🤦🏽",
				x: 40,
				y: 33
			},
			{
				unified: "1f926-1f3fe",
				native: "🤦🏾",
				x: 40,
				y: 34
			},
			{
				unified: "1f926-1f3ff",
				native: "🤦🏿",
				x: 40,
				y: 35
			}
		],
		version: 3
	},
	"man-facepalming": {
		id: "man-facepalming",
		name: "Man Facepalming",
		keywords: [
			"male",
			"boy",
			"disbelief"
		],
		skins: [
			{
				unified: "1f926-200d-2642-fe0f",
				native: "🤦‍♂️",
				x: 40,
				y: 24
			},
			{
				unified: "1f926-1f3fb-200d-2642-fe0f",
				native: "🤦🏻‍♂️",
				x: 40,
				y: 25
			},
			{
				unified: "1f926-1f3fc-200d-2642-fe0f",
				native: "🤦🏼‍♂️",
				x: 40,
				y: 26
			},
			{
				unified: "1f926-1f3fd-200d-2642-fe0f",
				native: "🤦🏽‍♂️",
				x: 40,
				y: 27
			},
			{
				unified: "1f926-1f3fe-200d-2642-fe0f",
				native: "🤦🏾‍♂️",
				x: 40,
				y: 28
			},
			{
				unified: "1f926-1f3ff-200d-2642-fe0f",
				native: "🤦🏿‍♂️",
				x: 40,
				y: 29
			}
		],
		version: 4
	},
	"woman-facepalming": {
		id: "woman-facepalming",
		name: "Woman Facepalming",
		keywords: [
			"female",
			"girl",
			"disbelief"
		],
		skins: [
			{
				unified: "1f926-200d-2640-fe0f",
				native: "🤦‍♀️",
				x: 40,
				y: 18
			},
			{
				unified: "1f926-1f3fb-200d-2640-fe0f",
				native: "🤦🏻‍♀️",
				x: 40,
				y: 19
			},
			{
				unified: "1f926-1f3fc-200d-2640-fe0f",
				native: "🤦🏼‍♀️",
				x: 40,
				y: 20
			},
			{
				unified: "1f926-1f3fd-200d-2640-fe0f",
				native: "🤦🏽‍♀️",
				x: 40,
				y: 21
			},
			{
				unified: "1f926-1f3fe-200d-2640-fe0f",
				native: "🤦🏾‍♀️",
				x: 40,
				y: 22
			},
			{
				unified: "1f926-1f3ff-200d-2640-fe0f",
				native: "🤦🏿‍♀️",
				x: 40,
				y: 23
			}
		],
		version: 4
	},
	shrug: {
		id: "shrug",
		name: "Shrug",
		keywords: [
			"person",
			"shrugging",
			"regardless"
		],
		skins: [
			{
				unified: "1f937",
				native: "🤷",
				x: 41,
				y: 50
			},
			{
				unified: "1f937-1f3fb",
				native: "🤷🏻",
				x: 41,
				y: 51
			},
			{
				unified: "1f937-1f3fc",
				native: "🤷🏼",
				x: 41,
				y: 52
			},
			{
				unified: "1f937-1f3fd",
				native: "🤷🏽",
				x: 41,
				y: 53
			},
			{
				unified: "1f937-1f3fe",
				native: "🤷🏾",
				x: 41,
				y: 54
			},
			{
				unified: "1f937-1f3ff",
				native: "🤷🏿",
				x: 41,
				y: 55
			}
		],
		version: 3
	},
	"man-shrugging": {
		id: "man-shrugging",
		name: "Man Shrugging",
		keywords: [
			"male",
			"boy",
			"confused",
			"indifferent",
			"doubt"
		],
		skins: [
			{
				unified: "1f937-200d-2642-fe0f",
				native: "🤷‍♂️",
				x: 41,
				y: 44
			},
			{
				unified: "1f937-1f3fb-200d-2642-fe0f",
				native: "🤷🏻‍♂️",
				x: 41,
				y: 45
			},
			{
				unified: "1f937-1f3fc-200d-2642-fe0f",
				native: "🤷🏼‍♂️",
				x: 41,
				y: 46
			},
			{
				unified: "1f937-1f3fd-200d-2642-fe0f",
				native: "🤷🏽‍♂️",
				x: 41,
				y: 47
			},
			{
				unified: "1f937-1f3fe-200d-2642-fe0f",
				native: "🤷🏾‍♂️",
				x: 41,
				y: 48
			},
			{
				unified: "1f937-1f3ff-200d-2642-fe0f",
				native: "🤷🏿‍♂️",
				x: 41,
				y: 49
			}
		],
		version: 4
	},
	"woman-shrugging": {
		id: "woman-shrugging",
		name: "Woman Shrugging",
		keywords: [
			"female",
			"girl",
			"confused",
			"indifferent",
			"doubt"
		],
		skins: [
			{
				unified: "1f937-200d-2640-fe0f",
				native: "🤷‍♀️",
				x: 41,
				y: 38
			},
			{
				unified: "1f937-1f3fb-200d-2640-fe0f",
				native: "🤷🏻‍♀️",
				x: 41,
				y: 39
			},
			{
				unified: "1f937-1f3fc-200d-2640-fe0f",
				native: "🤷🏼‍♀️",
				x: 41,
				y: 40
			},
			{
				unified: "1f937-1f3fd-200d-2640-fe0f",
				native: "🤷🏽‍♀️",
				x: 41,
				y: 41
			},
			{
				unified: "1f937-1f3fe-200d-2640-fe0f",
				native: "🤷🏾‍♀️",
				x: 41,
				y: 42
			},
			{
				unified: "1f937-1f3ff-200d-2640-fe0f",
				native: "🤷🏿‍♀️",
				x: 41,
				y: 43
			}
		],
		version: 4
	},
	health_worker: {
		id: "health_worker",
		name: "Health Worker",
		keywords: [
			"hospital"
		],
		skins: [
			{
				unified: "1f9d1-200d-2695-fe0f",
				native: "🧑‍⚕️",
				x: 49,
				y: 48
			},
			{
				unified: "1f9d1-1f3fb-200d-2695-fe0f",
				native: "🧑🏻‍⚕️",
				x: 49,
				y: 49
			},
			{
				unified: "1f9d1-1f3fc-200d-2695-fe0f",
				native: "🧑🏼‍⚕️",
				x: 49,
				y: 50
			},
			{
				unified: "1f9d1-1f3fd-200d-2695-fe0f",
				native: "🧑🏽‍⚕️",
				x: 49,
				y: 51
			},
			{
				unified: "1f9d1-1f3fe-200d-2695-fe0f",
				native: "🧑🏾‍⚕️",
				x: 49,
				y: 52
			},
			{
				unified: "1f9d1-1f3ff-200d-2695-fe0f",
				native: "🧑🏿‍⚕️",
				x: 49,
				y: 53
			}
		],
		version: 12.1
	},
	"male-doctor": {
		id: "male-doctor",
		name: "Man Health Worker",
		keywords: [
			"male",
			"doctor",
			"nurse",
			"therapist",
			"healthcare",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2695-fe0f",
				native: "👨‍⚕️",
				x: 16,
				y: 4
			},
			{
				unified: "1f468-1f3fb-200d-2695-fe0f",
				native: "👨🏻‍⚕️",
				x: 16,
				y: 5
			},
			{
				unified: "1f468-1f3fc-200d-2695-fe0f",
				native: "👨🏼‍⚕️",
				x: 16,
				y: 6
			},
			{
				unified: "1f468-1f3fd-200d-2695-fe0f",
				native: "👨🏽‍⚕️",
				x: 16,
				y: 7
			},
			{
				unified: "1f468-1f3fe-200d-2695-fe0f",
				native: "👨🏾‍⚕️",
				x: 16,
				y: 8
			},
			{
				unified: "1f468-1f3ff-200d-2695-fe0f",
				native: "👨🏿‍⚕️",
				x: 16,
				y: 9
			}
		],
		version: 4
	},
	"female-doctor": {
		id: "female-doctor",
		name: "Woman Health Worker",
		keywords: [
			"female",
			"doctor",
			"nurse",
			"therapist",
			"healthcare",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2695-fe0f",
				native: "👩‍⚕️",
				x: 19,
				y: 33
			},
			{
				unified: "1f469-1f3fb-200d-2695-fe0f",
				native: "👩🏻‍⚕️",
				x: 19,
				y: 34
			},
			{
				unified: "1f469-1f3fc-200d-2695-fe0f",
				native: "👩🏼‍⚕️",
				x: 19,
				y: 35
			},
			{
				unified: "1f469-1f3fd-200d-2695-fe0f",
				native: "👩🏽‍⚕️",
				x: 19,
				y: 36
			},
			{
				unified: "1f469-1f3fe-200d-2695-fe0f",
				native: "👩🏾‍⚕️",
				x: 19,
				y: 37
			},
			{
				unified: "1f469-1f3ff-200d-2695-fe0f",
				native: "👩🏿‍⚕️",
				x: 19,
				y: 38
			}
		],
		version: 4
	},
	student: {
		id: "student",
		name: "Student",
		keywords: [
			"learn"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f393",
				native: "🧑‍🎓",
				x: 47,
				y: 36
			},
			{
				unified: "1f9d1-1f3fb-200d-1f393",
				native: "🧑🏻‍🎓",
				x: 47,
				y: 37
			},
			{
				unified: "1f9d1-1f3fc-200d-1f393",
				native: "🧑🏼‍🎓",
				x: 47,
				y: 38
			},
			{
				unified: "1f9d1-1f3fd-200d-1f393",
				native: "🧑🏽‍🎓",
				x: 47,
				y: 39
			},
			{
				unified: "1f9d1-1f3fe-200d-1f393",
				native: "🧑🏾‍🎓",
				x: 47,
				y: 40
			},
			{
				unified: "1f9d1-1f3ff-200d-1f393",
				native: "🧑🏿‍🎓",
				x: 47,
				y: 41
			}
		],
		version: 12.1
	},
	"male-student": {
		id: "male-student",
		name: "Man Student",
		keywords: [
			"male",
			"graduate",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f393",
				native: "👨‍🎓",
				x: 14,
				y: 3
			},
			{
				unified: "1f468-1f3fb-200d-1f393",
				native: "👨🏻‍🎓",
				x: 14,
				y: 4
			},
			{
				unified: "1f468-1f3fc-200d-1f393",
				native: "👨🏼‍🎓",
				x: 14,
				y: 5
			},
			{
				unified: "1f468-1f3fd-200d-1f393",
				native: "👨🏽‍🎓",
				x: 14,
				y: 6
			},
			{
				unified: "1f468-1f3fe-200d-1f393",
				native: "👨🏾‍🎓",
				x: 14,
				y: 7
			},
			{
				unified: "1f468-1f3ff-200d-1f393",
				native: "👨🏿‍🎓",
				x: 14,
				y: 8
			}
		],
		version: 4
	},
	"female-student": {
		id: "female-student",
		name: "Woman Student",
		keywords: [
			"female",
			"graduate",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f393",
				native: "👩‍🎓",
				x: 17,
				y: 37
			},
			{
				unified: "1f469-1f3fb-200d-1f393",
				native: "👩🏻‍🎓",
				x: 17,
				y: 38
			},
			{
				unified: "1f469-1f3fc-200d-1f393",
				native: "👩🏼‍🎓",
				x: 17,
				y: 39
			},
			{
				unified: "1f469-1f3fd-200d-1f393",
				native: "👩🏽‍🎓",
				x: 17,
				y: 40
			},
			{
				unified: "1f469-1f3fe-200d-1f393",
				native: "👩🏾‍🎓",
				x: 17,
				y: 41
			},
			{
				unified: "1f469-1f3ff-200d-1f393",
				native: "👩🏿‍🎓",
				x: 17,
				y: 42
			}
		],
		version: 4
	},
	teacher: {
		id: "teacher",
		name: "Teacher",
		keywords: [
			"professor"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3eb",
				native: "🧑‍🏫",
				x: 47,
				y: 54
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3eb",
				native: "🧑🏻‍🏫",
				x: 47,
				y: 55
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3eb",
				native: "🧑🏼‍🏫",
				x: 47,
				y: 56
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3eb",
				native: "🧑🏽‍🏫",
				x: 47,
				y: 57
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3eb",
				native: "🧑🏾‍🏫",
				x: 47,
				y: 58
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3eb",
				native: "🧑🏿‍🏫",
				x: 47,
				y: 59
			}
		],
		version: 12.1
	},
	"male-teacher": {
		id: "male-teacher",
		name: "Man Teacher",
		keywords: [
			"male",
			"instructor",
			"professor",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3eb",
				native: "👨‍🏫",
				x: 14,
				y: 21
			},
			{
				unified: "1f468-1f3fb-200d-1f3eb",
				native: "👨🏻‍🏫",
				x: 14,
				y: 22
			},
			{
				unified: "1f468-1f3fc-200d-1f3eb",
				native: "👨🏼‍🏫",
				x: 14,
				y: 23
			},
			{
				unified: "1f468-1f3fd-200d-1f3eb",
				native: "👨🏽‍🏫",
				x: 14,
				y: 24
			},
			{
				unified: "1f468-1f3fe-200d-1f3eb",
				native: "👨🏾‍🏫",
				x: 14,
				y: 25
			},
			{
				unified: "1f468-1f3ff-200d-1f3eb",
				native: "👨🏿‍🏫",
				x: 14,
				y: 26
			}
		],
		version: 4
	},
	"female-teacher": {
		id: "female-teacher",
		name: "Woman Teacher",
		keywords: [
			"female",
			"instructor",
			"professor",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3eb",
				native: "👩‍🏫",
				x: 17,
				y: 55
			},
			{
				unified: "1f469-1f3fb-200d-1f3eb",
				native: "👩🏻‍🏫",
				x: 17,
				y: 56
			},
			{
				unified: "1f469-1f3fc-200d-1f3eb",
				native: "👩🏼‍🏫",
				x: 17,
				y: 57
			},
			{
				unified: "1f469-1f3fd-200d-1f3eb",
				native: "👩🏽‍🏫",
				x: 17,
				y: 58
			},
			{
				unified: "1f469-1f3fe-200d-1f3eb",
				native: "👩🏾‍🏫",
				x: 17,
				y: 59
			},
			{
				unified: "1f469-1f3ff-200d-1f3eb",
				native: "👩🏿‍🏫",
				x: 17,
				y: 60
			}
		],
		version: 4
	},
	judge: {
		id: "judge",
		name: "Judge",
		keywords: [
			"law"
		],
		skins: [
			{
				unified: "1f9d1-200d-2696-fe0f",
				native: "🧑‍⚖️",
				x: 49,
				y: 54
			},
			{
				unified: "1f9d1-1f3fb-200d-2696-fe0f",
				native: "🧑🏻‍⚖️",
				x: 49,
				y: 55
			},
			{
				unified: "1f9d1-1f3fc-200d-2696-fe0f",
				native: "🧑🏼‍⚖️",
				x: 49,
				y: 56
			},
			{
				unified: "1f9d1-1f3fd-200d-2696-fe0f",
				native: "🧑🏽‍⚖️",
				x: 49,
				y: 57
			},
			{
				unified: "1f9d1-1f3fe-200d-2696-fe0f",
				native: "🧑🏾‍⚖️",
				x: 49,
				y: 58
			},
			{
				unified: "1f9d1-1f3ff-200d-2696-fe0f",
				native: "🧑🏿‍⚖️",
				x: 49,
				y: 59
			}
		],
		version: 12.1
	},
	"male-judge": {
		id: "male-judge",
		name: "Man Judge",
		keywords: [
			"male",
			"justice",
			"court",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2696-fe0f",
				native: "👨‍⚖️",
				x: 16,
				y: 10
			},
			{
				unified: "1f468-1f3fb-200d-2696-fe0f",
				native: "👨🏻‍⚖️",
				x: 16,
				y: 11
			},
			{
				unified: "1f468-1f3fc-200d-2696-fe0f",
				native: "👨🏼‍⚖️",
				x: 16,
				y: 12
			},
			{
				unified: "1f468-1f3fd-200d-2696-fe0f",
				native: "👨🏽‍⚖️",
				x: 16,
				y: 13
			},
			{
				unified: "1f468-1f3fe-200d-2696-fe0f",
				native: "👨🏾‍⚖️",
				x: 16,
				y: 14
			},
			{
				unified: "1f468-1f3ff-200d-2696-fe0f",
				native: "👨🏿‍⚖️",
				x: 16,
				y: 15
			}
		],
		version: 4
	},
	"female-judge": {
		id: "female-judge",
		name: "Woman Judge",
		keywords: [
			"female",
			"justice",
			"court",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2696-fe0f",
				native: "👩‍⚖️",
				x: 19,
				y: 39
			},
			{
				unified: "1f469-1f3fb-200d-2696-fe0f",
				native: "👩🏻‍⚖️",
				x: 19,
				y: 40
			},
			{
				unified: "1f469-1f3fc-200d-2696-fe0f",
				native: "👩🏼‍⚖️",
				x: 19,
				y: 41
			},
			{
				unified: "1f469-1f3fd-200d-2696-fe0f",
				native: "👩🏽‍⚖️",
				x: 19,
				y: 42
			},
			{
				unified: "1f469-1f3fe-200d-2696-fe0f",
				native: "👩🏾‍⚖️",
				x: 19,
				y: 43
			},
			{
				unified: "1f469-1f3ff-200d-2696-fe0f",
				native: "👩🏿‍⚖️",
				x: 19,
				y: 44
			}
		],
		version: 4
	},
	farmer: {
		id: "farmer",
		name: "Farmer",
		keywords: [
			"crops"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f33e",
				native: "🧑‍🌾",
				x: 47,
				y: 12
			},
			{
				unified: "1f9d1-1f3fb-200d-1f33e",
				native: "🧑🏻‍🌾",
				x: 47,
				y: 13
			},
			{
				unified: "1f9d1-1f3fc-200d-1f33e",
				native: "🧑🏼‍🌾",
				x: 47,
				y: 14
			},
			{
				unified: "1f9d1-1f3fd-200d-1f33e",
				native: "🧑🏽‍🌾",
				x: 47,
				y: 15
			},
			{
				unified: "1f9d1-1f3fe-200d-1f33e",
				native: "🧑🏾‍🌾",
				x: 47,
				y: 16
			},
			{
				unified: "1f9d1-1f3ff-200d-1f33e",
				native: "🧑🏿‍🌾",
				x: 47,
				y: 17
			}
		],
		version: 12.1
	},
	"male-farmer": {
		id: "male-farmer",
		name: "Man Farmer",
		keywords: [
			"male",
			"rancher",
			"gardener",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f33e",
				native: "👨‍🌾",
				x: 13,
				y: 46
			},
			{
				unified: "1f468-1f3fb-200d-1f33e",
				native: "👨🏻‍🌾",
				x: 13,
				y: 47
			},
			{
				unified: "1f468-1f3fc-200d-1f33e",
				native: "👨🏼‍🌾",
				x: 13,
				y: 48
			},
			{
				unified: "1f468-1f3fd-200d-1f33e",
				native: "👨🏽‍🌾",
				x: 13,
				y: 49
			},
			{
				unified: "1f468-1f3fe-200d-1f33e",
				native: "👨🏾‍🌾",
				x: 13,
				y: 50
			},
			{
				unified: "1f468-1f3ff-200d-1f33e",
				native: "👨🏿‍🌾",
				x: 13,
				y: 51
			}
		],
		version: 4
	},
	"female-farmer": {
		id: "female-farmer",
		name: "Woman Farmer",
		keywords: [
			"female",
			"rancher",
			"gardener",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f33e",
				native: "👩‍🌾",
				x: 17,
				y: 19
			},
			{
				unified: "1f469-1f3fb-200d-1f33e",
				native: "👩🏻‍🌾",
				x: 17,
				y: 20
			},
			{
				unified: "1f469-1f3fc-200d-1f33e",
				native: "👩🏼‍🌾",
				x: 17,
				y: 21
			},
			{
				unified: "1f469-1f3fd-200d-1f33e",
				native: "👩🏽‍🌾",
				x: 17,
				y: 22
			},
			{
				unified: "1f469-1f3fe-200d-1f33e",
				native: "👩🏾‍🌾",
				x: 17,
				y: 23
			},
			{
				unified: "1f469-1f3ff-200d-1f33e",
				native: "👩🏿‍🌾",
				x: 17,
				y: 24
			}
		],
		version: 4
	},
	cook: {
		id: "cook",
		name: "Cook",
		keywords: [
			"food",
			"kitchen",
			"culinary"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f373",
				native: "🧑‍🍳",
				x: 47,
				y: 18
			},
			{
				unified: "1f9d1-1f3fb-200d-1f373",
				native: "🧑🏻‍🍳",
				x: 47,
				y: 19
			},
			{
				unified: "1f9d1-1f3fc-200d-1f373",
				native: "🧑🏼‍🍳",
				x: 47,
				y: 20
			},
			{
				unified: "1f9d1-1f3fd-200d-1f373",
				native: "🧑🏽‍🍳",
				x: 47,
				y: 21
			},
			{
				unified: "1f9d1-1f3fe-200d-1f373",
				native: "🧑🏾‍🍳",
				x: 47,
				y: 22
			},
			{
				unified: "1f9d1-1f3ff-200d-1f373",
				native: "🧑🏿‍🍳",
				x: 47,
				y: 23
			}
		],
		version: 12.1
	},
	"male-cook": {
		id: "male-cook",
		name: "Man Cook",
		keywords: [
			"male",
			"chef",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f373",
				native: "👨‍🍳",
				x: 13,
				y: 52
			},
			{
				unified: "1f468-1f3fb-200d-1f373",
				native: "👨🏻‍🍳",
				x: 13,
				y: 53
			},
			{
				unified: "1f468-1f3fc-200d-1f373",
				native: "👨🏼‍🍳",
				x: 13,
				y: 54
			},
			{
				unified: "1f468-1f3fd-200d-1f373",
				native: "👨🏽‍🍳",
				x: 13,
				y: 55
			},
			{
				unified: "1f468-1f3fe-200d-1f373",
				native: "👨🏾‍🍳",
				x: 13,
				y: 56
			},
			{
				unified: "1f468-1f3ff-200d-1f373",
				native: "👨🏿‍🍳",
				x: 13,
				y: 57
			}
		],
		version: 4
	},
	"female-cook": {
		id: "female-cook",
		name: "Woman Cook",
		keywords: [
			"female",
			"chef",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f373",
				native: "👩‍🍳",
				x: 17,
				y: 25
			},
			{
				unified: "1f469-1f3fb-200d-1f373",
				native: "👩🏻‍🍳",
				x: 17,
				y: 26
			},
			{
				unified: "1f469-1f3fc-200d-1f373",
				native: "👩🏼‍🍳",
				x: 17,
				y: 27
			},
			{
				unified: "1f469-1f3fd-200d-1f373",
				native: "👩🏽‍🍳",
				x: 17,
				y: 28
			},
			{
				unified: "1f469-1f3fe-200d-1f373",
				native: "👩🏾‍🍳",
				x: 17,
				y: 29
			},
			{
				unified: "1f469-1f3ff-200d-1f373",
				native: "👩🏿‍🍳",
				x: 17,
				y: 30
			}
		],
		version: 4
	},
	mechanic: {
		id: "mechanic",
		name: "Mechanic",
		keywords: [
			"worker",
			"technician"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f527",
				native: "🧑‍🔧",
				x: 48,
				y: 17
			},
			{
				unified: "1f9d1-1f3fb-200d-1f527",
				native: "🧑🏻‍🔧",
				x: 48,
				y: 18
			},
			{
				unified: "1f9d1-1f3fc-200d-1f527",
				native: "🧑🏼‍🔧",
				x: 48,
				y: 19
			},
			{
				unified: "1f9d1-1f3fd-200d-1f527",
				native: "🧑🏽‍🔧",
				x: 48,
				y: 20
			},
			{
				unified: "1f9d1-1f3fe-200d-1f527",
				native: "🧑🏾‍🔧",
				x: 48,
				y: 21
			},
			{
				unified: "1f9d1-1f3ff-200d-1f527",
				native: "🧑🏿‍🔧",
				x: 48,
				y: 22
			}
		],
		version: 12.1
	},
	"male-mechanic": {
		id: "male-mechanic",
		name: "Man Mechanic",
		keywords: [
			"male",
			"plumber",
			"human",
			"wrench"
		],
		skins: [
			{
				unified: "1f468-200d-1f527",
				native: "👨‍🔧",
				x: 14,
				y: 60
			},
			{
				unified: "1f468-1f3fb-200d-1f527",
				native: "👨🏻‍🔧",
				x: 15,
				y: 0
			},
			{
				unified: "1f468-1f3fc-200d-1f527",
				native: "👨🏼‍🔧",
				x: 15,
				y: 1
			},
			{
				unified: "1f468-1f3fd-200d-1f527",
				native: "👨🏽‍🔧",
				x: 15,
				y: 2
			},
			{
				unified: "1f468-1f3fe-200d-1f527",
				native: "👨🏾‍🔧",
				x: 15,
				y: 3
			},
			{
				unified: "1f468-1f3ff-200d-1f527",
				native: "👨🏿‍🔧",
				x: 15,
				y: 4
			}
		],
		version: 4
	},
	"female-mechanic": {
		id: "female-mechanic",
		name: "Woman Mechanic",
		keywords: [
			"female",
			"plumber",
			"human",
			"wrench"
		],
		skins: [
			{
				unified: "1f469-200d-1f527",
				native: "👩‍🔧",
				x: 18,
				y: 28
			},
			{
				unified: "1f469-1f3fb-200d-1f527",
				native: "👩🏻‍🔧",
				x: 18,
				y: 29
			},
			{
				unified: "1f469-1f3fc-200d-1f527",
				native: "👩🏼‍🔧",
				x: 18,
				y: 30
			},
			{
				unified: "1f469-1f3fd-200d-1f527",
				native: "👩🏽‍🔧",
				x: 18,
				y: 31
			},
			{
				unified: "1f469-1f3fe-200d-1f527",
				native: "👩🏾‍🔧",
				x: 18,
				y: 32
			},
			{
				unified: "1f469-1f3ff-200d-1f527",
				native: "👩🏿‍🔧",
				x: 18,
				y: 33
			}
		],
		version: 4
	},
	factory_worker: {
		id: "factory_worker",
		name: "Factory Worker",
		keywords: [
			"labor"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3ed",
				native: "🧑‍🏭",
				x: 47,
				y: 60
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3ed",
				native: "🧑🏻‍🏭",
				x: 48,
				y: 0
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3ed",
				native: "🧑🏼‍🏭",
				x: 48,
				y: 1
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3ed",
				native: "🧑🏽‍🏭",
				x: 48,
				y: 2
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3ed",
				native: "🧑🏾‍🏭",
				x: 48,
				y: 3
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3ed",
				native: "🧑🏿‍🏭",
				x: 48,
				y: 4
			}
		],
		version: 12.1
	},
	"male-factory-worker": {
		id: "male-factory-worker",
		name: "Man Factory Worker",
		keywords: [
			"male",
			"factory-worker",
			"assembly",
			"industrial",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3ed",
				native: "👨‍🏭",
				x: 14,
				y: 27
			},
			{
				unified: "1f468-1f3fb-200d-1f3ed",
				native: "👨🏻‍🏭",
				x: 14,
				y: 28
			},
			{
				unified: "1f468-1f3fc-200d-1f3ed",
				native: "👨🏼‍🏭",
				x: 14,
				y: 29
			},
			{
				unified: "1f468-1f3fd-200d-1f3ed",
				native: "👨🏽‍🏭",
				x: 14,
				y: 30
			},
			{
				unified: "1f468-1f3fe-200d-1f3ed",
				native: "👨🏾‍🏭",
				x: 14,
				y: 31
			},
			{
				unified: "1f468-1f3ff-200d-1f3ed",
				native: "👨🏿‍🏭",
				x: 14,
				y: 32
			}
		],
		version: 4
	},
	"female-factory-worker": {
		id: "female-factory-worker",
		name: "Woman Factory Worker",
		keywords: [
			"female",
			"factory-worker",
			"assembly",
			"industrial",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3ed",
				native: "👩‍🏭",
				x: 18,
				y: 0
			},
			{
				unified: "1f469-1f3fb-200d-1f3ed",
				native: "👩🏻‍🏭",
				x: 18,
				y: 1
			},
			{
				unified: "1f469-1f3fc-200d-1f3ed",
				native: "👩🏼‍🏭",
				x: 18,
				y: 2
			},
			{
				unified: "1f469-1f3fd-200d-1f3ed",
				native: "👩🏽‍🏭",
				x: 18,
				y: 3
			},
			{
				unified: "1f469-1f3fe-200d-1f3ed",
				native: "👩🏾‍🏭",
				x: 18,
				y: 4
			},
			{
				unified: "1f469-1f3ff-200d-1f3ed",
				native: "👩🏿‍🏭",
				x: 18,
				y: 5
			}
		],
		version: 4
	},
	office_worker: {
		id: "office_worker",
		name: "Office Worker",
		keywords: [
			"business"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f4bc",
				native: "🧑‍💼",
				x: 48,
				y: 11
			},
			{
				unified: "1f9d1-1f3fb-200d-1f4bc",
				native: "🧑🏻‍💼",
				x: 48,
				y: 12
			},
			{
				unified: "1f9d1-1f3fc-200d-1f4bc",
				native: "🧑🏼‍💼",
				x: 48,
				y: 13
			},
			{
				unified: "1f9d1-1f3fd-200d-1f4bc",
				native: "🧑🏽‍💼",
				x: 48,
				y: 14
			},
			{
				unified: "1f9d1-1f3fe-200d-1f4bc",
				native: "🧑🏾‍💼",
				x: 48,
				y: 15
			},
			{
				unified: "1f9d1-1f3ff-200d-1f4bc",
				native: "🧑🏿‍💼",
				x: 48,
				y: 16
			}
		],
		version: 12.1
	},
	"male-office-worker": {
		id: "male-office-worker",
		name: "Man Office Worker",
		keywords: [
			"male",
			"office-worker",
			"business",
			"manager",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f4bc",
				native: "👨‍💼",
				x: 14,
				y: 54
			},
			{
				unified: "1f468-1f3fb-200d-1f4bc",
				native: "👨🏻‍💼",
				x: 14,
				y: 55
			},
			{
				unified: "1f468-1f3fc-200d-1f4bc",
				native: "👨🏼‍💼",
				x: 14,
				y: 56
			},
			{
				unified: "1f468-1f3fd-200d-1f4bc",
				native: "👨🏽‍💼",
				x: 14,
				y: 57
			},
			{
				unified: "1f468-1f3fe-200d-1f4bc",
				native: "👨🏾‍💼",
				x: 14,
				y: 58
			},
			{
				unified: "1f468-1f3ff-200d-1f4bc",
				native: "👨🏿‍💼",
				x: 14,
				y: 59
			}
		],
		version: 4
	},
	"female-office-worker": {
		id: "female-office-worker",
		name: "Woman Office Worker",
		keywords: [
			"female",
			"office-worker",
			"business",
			"manager",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f4bc",
				native: "👩‍💼",
				x: 18,
				y: 22
			},
			{
				unified: "1f469-1f3fb-200d-1f4bc",
				native: "👩🏻‍💼",
				x: 18,
				y: 23
			},
			{
				unified: "1f469-1f3fc-200d-1f4bc",
				native: "👩🏼‍💼",
				x: 18,
				y: 24
			},
			{
				unified: "1f469-1f3fd-200d-1f4bc",
				native: "👩🏽‍💼",
				x: 18,
				y: 25
			},
			{
				unified: "1f469-1f3fe-200d-1f4bc",
				native: "👩🏾‍💼",
				x: 18,
				y: 26
			},
			{
				unified: "1f469-1f3ff-200d-1f4bc",
				native: "👩🏿‍💼",
				x: 18,
				y: 27
			}
		],
		version: 4
	},
	scientist: {
		id: "scientist",
		name: "Scientist",
		keywords: [
			"chemistry"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f52c",
				native: "🧑‍🔬",
				x: 48,
				y: 23
			},
			{
				unified: "1f9d1-1f3fb-200d-1f52c",
				native: "🧑🏻‍🔬",
				x: 48,
				y: 24
			},
			{
				unified: "1f9d1-1f3fc-200d-1f52c",
				native: "🧑🏼‍🔬",
				x: 48,
				y: 25
			},
			{
				unified: "1f9d1-1f3fd-200d-1f52c",
				native: "🧑🏽‍🔬",
				x: 48,
				y: 26
			},
			{
				unified: "1f9d1-1f3fe-200d-1f52c",
				native: "🧑🏾‍🔬",
				x: 48,
				y: 27
			},
			{
				unified: "1f9d1-1f3ff-200d-1f52c",
				native: "🧑🏿‍🔬",
				x: 48,
				y: 28
			}
		],
		version: 12.1
	},
	"male-scientist": {
		id: "male-scientist",
		name: "Man Scientist",
		keywords: [
			"male",
			"biologist",
			"chemist",
			"engineer",
			"physicist",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f52c",
				native: "👨‍🔬",
				x: 15,
				y: 5
			},
			{
				unified: "1f468-1f3fb-200d-1f52c",
				native: "👨🏻‍🔬",
				x: 15,
				y: 6
			},
			{
				unified: "1f468-1f3fc-200d-1f52c",
				native: "👨🏼‍🔬",
				x: 15,
				y: 7
			},
			{
				unified: "1f468-1f3fd-200d-1f52c",
				native: "👨🏽‍🔬",
				x: 15,
				y: 8
			},
			{
				unified: "1f468-1f3fe-200d-1f52c",
				native: "👨🏾‍🔬",
				x: 15,
				y: 9
			},
			{
				unified: "1f468-1f3ff-200d-1f52c",
				native: "👨🏿‍🔬",
				x: 15,
				y: 10
			}
		],
		version: 4
	},
	"female-scientist": {
		id: "female-scientist",
		name: "Woman Scientist",
		keywords: [
			"female",
			"biologist",
			"chemist",
			"engineer",
			"physicist",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f52c",
				native: "👩‍🔬",
				x: 18,
				y: 34
			},
			{
				unified: "1f469-1f3fb-200d-1f52c",
				native: "👩🏻‍🔬",
				x: 18,
				y: 35
			},
			{
				unified: "1f469-1f3fc-200d-1f52c",
				native: "👩🏼‍🔬",
				x: 18,
				y: 36
			},
			{
				unified: "1f469-1f3fd-200d-1f52c",
				native: "👩🏽‍🔬",
				x: 18,
				y: 37
			},
			{
				unified: "1f469-1f3fe-200d-1f52c",
				native: "👩🏾‍🔬",
				x: 18,
				y: 38
			},
			{
				unified: "1f469-1f3ff-200d-1f52c",
				native: "👩🏿‍🔬",
				x: 18,
				y: 39
			}
		],
		version: 4
	},
	technologist: {
		id: "technologist",
		name: "Technologist",
		keywords: [
			"computer"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f4bb",
				native: "🧑‍💻",
				x: 48,
				y: 5
			},
			{
				unified: "1f9d1-1f3fb-200d-1f4bb",
				native: "🧑🏻‍💻",
				x: 48,
				y: 6
			},
			{
				unified: "1f9d1-1f3fc-200d-1f4bb",
				native: "🧑🏼‍💻",
				x: 48,
				y: 7
			},
			{
				unified: "1f9d1-1f3fd-200d-1f4bb",
				native: "🧑🏽‍💻",
				x: 48,
				y: 8
			},
			{
				unified: "1f9d1-1f3fe-200d-1f4bb",
				native: "🧑🏾‍💻",
				x: 48,
				y: 9
			},
			{
				unified: "1f9d1-1f3ff-200d-1f4bb",
				native: "🧑🏿‍💻",
				x: 48,
				y: 10
			}
		],
		version: 12.1
	},
	"male-technologist": {
		id: "male-technologist",
		name: "Man Technologist",
		keywords: [
			"male",
			"coder",
			"developer",
			"engineer",
			"programmer",
			"software",
			"human",
			"laptop",
			"computer"
		],
		skins: [
			{
				unified: "1f468-200d-1f4bb",
				native: "👨‍💻",
				x: 14,
				y: 48
			},
			{
				unified: "1f468-1f3fb-200d-1f4bb",
				native: "👨🏻‍💻",
				x: 14,
				y: 49
			},
			{
				unified: "1f468-1f3fc-200d-1f4bb",
				native: "👨🏼‍💻",
				x: 14,
				y: 50
			},
			{
				unified: "1f468-1f3fd-200d-1f4bb",
				native: "👨🏽‍💻",
				x: 14,
				y: 51
			},
			{
				unified: "1f468-1f3fe-200d-1f4bb",
				native: "👨🏾‍💻",
				x: 14,
				y: 52
			},
			{
				unified: "1f468-1f3ff-200d-1f4bb",
				native: "👨🏿‍💻",
				x: 14,
				y: 53
			}
		],
		version: 4
	},
	"female-technologist": {
		id: "female-technologist",
		name: "Woman Technologist",
		keywords: [
			"female",
			"coder",
			"developer",
			"engineer",
			"programmer",
			"software",
			"human",
			"laptop",
			"computer"
		],
		skins: [
			{
				unified: "1f469-200d-1f4bb",
				native: "👩‍💻",
				x: 18,
				y: 16
			},
			{
				unified: "1f469-1f3fb-200d-1f4bb",
				native: "👩🏻‍💻",
				x: 18,
				y: 17
			},
			{
				unified: "1f469-1f3fc-200d-1f4bb",
				native: "👩🏼‍💻",
				x: 18,
				y: 18
			},
			{
				unified: "1f469-1f3fd-200d-1f4bb",
				native: "👩🏽‍💻",
				x: 18,
				y: 19
			},
			{
				unified: "1f469-1f3fe-200d-1f4bb",
				native: "👩🏾‍💻",
				x: 18,
				y: 20
			},
			{
				unified: "1f469-1f3ff-200d-1f4bb",
				native: "👩🏿‍💻",
				x: 18,
				y: 21
			}
		],
		version: 4
	},
	singer: {
		id: "singer",
		name: "Singer",
		keywords: [
			"song",
			"artist",
			"performer"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3a4",
				native: "🧑‍🎤",
				x: 47,
				y: 42
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3a4",
				native: "🧑🏻‍🎤",
				x: 47,
				y: 43
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3a4",
				native: "🧑🏼‍🎤",
				x: 47,
				y: 44
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3a4",
				native: "🧑🏽‍🎤",
				x: 47,
				y: 45
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3a4",
				native: "🧑🏾‍🎤",
				x: 47,
				y: 46
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3a4",
				native: "🧑🏿‍🎤",
				x: 47,
				y: 47
			}
		],
		version: 12.1
	},
	"male-singer": {
		id: "male-singer",
		name: "Man Singer",
		keywords: [
			"male",
			"rockstar",
			"entertainer",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3a4",
				native: "👨‍🎤",
				x: 14,
				y: 9
			},
			{
				unified: "1f468-1f3fb-200d-1f3a4",
				native: "👨🏻‍🎤",
				x: 14,
				y: 10
			},
			{
				unified: "1f468-1f3fc-200d-1f3a4",
				native: "👨🏼‍🎤",
				x: 14,
				y: 11
			},
			{
				unified: "1f468-1f3fd-200d-1f3a4",
				native: "👨🏽‍🎤",
				x: 14,
				y: 12
			},
			{
				unified: "1f468-1f3fe-200d-1f3a4",
				native: "👨🏾‍🎤",
				x: 14,
				y: 13
			},
			{
				unified: "1f468-1f3ff-200d-1f3a4",
				native: "👨🏿‍🎤",
				x: 14,
				y: 14
			}
		],
		version: 4
	},
	"female-singer": {
		id: "female-singer",
		name: "Woman Singer",
		keywords: [
			"female",
			"rockstar",
			"entertainer",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3a4",
				native: "👩‍🎤",
				x: 17,
				y: 43
			},
			{
				unified: "1f469-1f3fb-200d-1f3a4",
				native: "👩🏻‍🎤",
				x: 17,
				y: 44
			},
			{
				unified: "1f469-1f3fc-200d-1f3a4",
				native: "👩🏼‍🎤",
				x: 17,
				y: 45
			},
			{
				unified: "1f469-1f3fd-200d-1f3a4",
				native: "👩🏽‍🎤",
				x: 17,
				y: 46
			},
			{
				unified: "1f469-1f3fe-200d-1f3a4",
				native: "👩🏾‍🎤",
				x: 17,
				y: 47
			},
			{
				unified: "1f469-1f3ff-200d-1f3a4",
				native: "👩🏿‍🎤",
				x: 17,
				y: 48
			}
		],
		version: 4
	},
	artist: {
		id: "artist",
		name: "Artist",
		keywords: [
			"painting",
			"draw",
			"creativity"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f3a8",
				native: "🧑‍🎨",
				x: 47,
				y: 48
			},
			{
				unified: "1f9d1-1f3fb-200d-1f3a8",
				native: "🧑🏻‍🎨",
				x: 47,
				y: 49
			},
			{
				unified: "1f9d1-1f3fc-200d-1f3a8",
				native: "🧑🏼‍🎨",
				x: 47,
				y: 50
			},
			{
				unified: "1f9d1-1f3fd-200d-1f3a8",
				native: "🧑🏽‍🎨",
				x: 47,
				y: 51
			},
			{
				unified: "1f9d1-1f3fe-200d-1f3a8",
				native: "🧑🏾‍🎨",
				x: 47,
				y: 52
			},
			{
				unified: "1f9d1-1f3ff-200d-1f3a8",
				native: "🧑🏿‍🎨",
				x: 47,
				y: 53
			}
		],
		version: 12.1
	},
	"male-artist": {
		id: "male-artist",
		name: "Man Artist",
		keywords: [
			"male",
			"painter",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f3a8",
				native: "👨‍🎨",
				x: 14,
				y: 15
			},
			{
				unified: "1f468-1f3fb-200d-1f3a8",
				native: "👨🏻‍🎨",
				x: 14,
				y: 16
			},
			{
				unified: "1f468-1f3fc-200d-1f3a8",
				native: "👨🏼‍🎨",
				x: 14,
				y: 17
			},
			{
				unified: "1f468-1f3fd-200d-1f3a8",
				native: "👨🏽‍🎨",
				x: 14,
				y: 18
			},
			{
				unified: "1f468-1f3fe-200d-1f3a8",
				native: "👨🏾‍🎨",
				x: 14,
				y: 19
			},
			{
				unified: "1f468-1f3ff-200d-1f3a8",
				native: "👨🏿‍🎨",
				x: 14,
				y: 20
			}
		],
		version: 4
	},
	"female-artist": {
		id: "female-artist",
		name: "Woman Artist",
		keywords: [
			"female",
			"painter",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f3a8",
				native: "👩‍🎨",
				x: 17,
				y: 49
			},
			{
				unified: "1f469-1f3fb-200d-1f3a8",
				native: "👩🏻‍🎨",
				x: 17,
				y: 50
			},
			{
				unified: "1f469-1f3fc-200d-1f3a8",
				native: "👩🏼‍🎨",
				x: 17,
				y: 51
			},
			{
				unified: "1f469-1f3fd-200d-1f3a8",
				native: "👩🏽‍🎨",
				x: 17,
				y: 52
			},
			{
				unified: "1f469-1f3fe-200d-1f3a8",
				native: "👩🏾‍🎨",
				x: 17,
				y: 53
			},
			{
				unified: "1f469-1f3ff-200d-1f3a8",
				native: "👩🏿‍🎨",
				x: 17,
				y: 54
			}
		],
		version: 4
	},
	pilot: {
		id: "pilot",
		name: "Pilot",
		keywords: [
			"fly",
			"plane",
			"airplane"
		],
		skins: [
			{
				unified: "1f9d1-200d-2708-fe0f",
				native: "🧑‍✈️",
				x: 49,
				y: 60
			},
			{
				unified: "1f9d1-1f3fb-200d-2708-fe0f",
				native: "🧑🏻‍✈️",
				x: 50,
				y: 0
			},
			{
				unified: "1f9d1-1f3fc-200d-2708-fe0f",
				native: "🧑🏼‍✈️",
				x: 50,
				y: 1
			},
			{
				unified: "1f9d1-1f3fd-200d-2708-fe0f",
				native: "🧑🏽‍✈️",
				x: 50,
				y: 2
			},
			{
				unified: "1f9d1-1f3fe-200d-2708-fe0f",
				native: "🧑🏾‍✈️",
				x: 50,
				y: 3
			},
			{
				unified: "1f9d1-1f3ff-200d-2708-fe0f",
				native: "🧑🏿‍✈️",
				x: 50,
				y: 4
			}
		],
		version: 12.1
	},
	"male-pilot": {
		id: "male-pilot",
		name: "Man Pilot",
		keywords: [
			"male",
			"aviator",
			"plane",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-2708-fe0f",
				native: "👨‍✈️",
				x: 16,
				y: 16
			},
			{
				unified: "1f468-1f3fb-200d-2708-fe0f",
				native: "👨🏻‍✈️",
				x: 16,
				y: 17
			},
			{
				unified: "1f468-1f3fc-200d-2708-fe0f",
				native: "👨🏼‍✈️",
				x: 16,
				y: 18
			},
			{
				unified: "1f468-1f3fd-200d-2708-fe0f",
				native: "👨🏽‍✈️",
				x: 16,
				y: 19
			},
			{
				unified: "1f468-1f3fe-200d-2708-fe0f",
				native: "👨🏾‍✈️",
				x: 16,
				y: 20
			},
			{
				unified: "1f468-1f3ff-200d-2708-fe0f",
				native: "👨🏿‍✈️",
				x: 16,
				y: 21
			}
		],
		version: 4
	},
	"female-pilot": {
		id: "female-pilot",
		name: "Woman Pilot",
		keywords: [
			"female",
			"aviator",
			"plane",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-2708-fe0f",
				native: "👩‍✈️",
				x: 19,
				y: 45
			},
			{
				unified: "1f469-1f3fb-200d-2708-fe0f",
				native: "👩🏻‍✈️",
				x: 19,
				y: 46
			},
			{
				unified: "1f469-1f3fc-200d-2708-fe0f",
				native: "👩🏼‍✈️",
				x: 19,
				y: 47
			},
			{
				unified: "1f469-1f3fd-200d-2708-fe0f",
				native: "👩🏽‍✈️",
				x: 19,
				y: 48
			},
			{
				unified: "1f469-1f3fe-200d-2708-fe0f",
				native: "👩🏾‍✈️",
				x: 19,
				y: 49
			},
			{
				unified: "1f469-1f3ff-200d-2708-fe0f",
				native: "👩🏿‍✈️",
				x: 19,
				y: 50
			}
		],
		version: 4
	},
	astronaut: {
		id: "astronaut",
		name: "Astronaut",
		keywords: [
			"outerspace"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f680",
				native: "🧑‍🚀",
				x: 48,
				y: 29
			},
			{
				unified: "1f9d1-1f3fb-200d-1f680",
				native: "🧑🏻‍🚀",
				x: 48,
				y: 30
			},
			{
				unified: "1f9d1-1f3fc-200d-1f680",
				native: "🧑🏼‍🚀",
				x: 48,
				y: 31
			},
			{
				unified: "1f9d1-1f3fd-200d-1f680",
				native: "🧑🏽‍🚀",
				x: 48,
				y: 32
			},
			{
				unified: "1f9d1-1f3fe-200d-1f680",
				native: "🧑🏾‍🚀",
				x: 48,
				y: 33
			},
			{
				unified: "1f9d1-1f3ff-200d-1f680",
				native: "🧑🏿‍🚀",
				x: 48,
				y: 34
			}
		],
		version: 12.1
	},
	"male-astronaut": {
		id: "male-astronaut",
		name: "Man Astronaut",
		keywords: [
			"male",
			"space",
			"rocket",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f680",
				native: "👨‍🚀",
				x: 15,
				y: 11
			},
			{
				unified: "1f468-1f3fb-200d-1f680",
				native: "👨🏻‍🚀",
				x: 15,
				y: 12
			},
			{
				unified: "1f468-1f3fc-200d-1f680",
				native: "👨🏼‍🚀",
				x: 15,
				y: 13
			},
			{
				unified: "1f468-1f3fd-200d-1f680",
				native: "👨🏽‍🚀",
				x: 15,
				y: 14
			},
			{
				unified: "1f468-1f3fe-200d-1f680",
				native: "👨🏾‍🚀",
				x: 15,
				y: 15
			},
			{
				unified: "1f468-1f3ff-200d-1f680",
				native: "👨🏿‍🚀",
				x: 15,
				y: 16
			}
		],
		version: 4
	},
	"female-astronaut": {
		id: "female-astronaut",
		name: "Woman Astronaut",
		keywords: [
			"female",
			"space",
			"rocket",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f680",
				native: "👩‍🚀",
				x: 18,
				y: 40
			},
			{
				unified: "1f469-1f3fb-200d-1f680",
				native: "👩🏻‍🚀",
				x: 18,
				y: 41
			},
			{
				unified: "1f469-1f3fc-200d-1f680",
				native: "👩🏼‍🚀",
				x: 18,
				y: 42
			},
			{
				unified: "1f469-1f3fd-200d-1f680",
				native: "👩🏽‍🚀",
				x: 18,
				y: 43
			},
			{
				unified: "1f469-1f3fe-200d-1f680",
				native: "👩🏾‍🚀",
				x: 18,
				y: 44
			},
			{
				unified: "1f469-1f3ff-200d-1f680",
				native: "👩🏿‍🚀",
				x: 18,
				y: 45
			}
		],
		version: 4
	},
	firefighter: {
		id: "firefighter",
		name: "Firefighter",
		keywords: [
			"fire"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f692",
				native: "🧑‍🚒",
				x: 48,
				y: 35
			},
			{
				unified: "1f9d1-1f3fb-200d-1f692",
				native: "🧑🏻‍🚒",
				x: 48,
				y: 36
			},
			{
				unified: "1f9d1-1f3fc-200d-1f692",
				native: "🧑🏼‍🚒",
				x: 48,
				y: 37
			},
			{
				unified: "1f9d1-1f3fd-200d-1f692",
				native: "🧑🏽‍🚒",
				x: 48,
				y: 38
			},
			{
				unified: "1f9d1-1f3fe-200d-1f692",
				native: "🧑🏾‍🚒",
				x: 48,
				y: 39
			},
			{
				unified: "1f9d1-1f3ff-200d-1f692",
				native: "🧑🏿‍🚒",
				x: 48,
				y: 40
			}
		],
		version: 12.1
	},
	"male-firefighter": {
		id: "male-firefighter",
		name: "Man Firefighter",
		keywords: [
			"male",
			"fireman",
			"human"
		],
		skins: [
			{
				unified: "1f468-200d-1f692",
				native: "👨‍🚒",
				x: 15,
				y: 17
			},
			{
				unified: "1f468-1f3fb-200d-1f692",
				native: "👨🏻‍🚒",
				x: 15,
				y: 18
			},
			{
				unified: "1f468-1f3fc-200d-1f692",
				native: "👨🏼‍🚒",
				x: 15,
				y: 19
			},
			{
				unified: "1f468-1f3fd-200d-1f692",
				native: "👨🏽‍🚒",
				x: 15,
				y: 20
			},
			{
				unified: "1f468-1f3fe-200d-1f692",
				native: "👨🏾‍🚒",
				x: 15,
				y: 21
			},
			{
				unified: "1f468-1f3ff-200d-1f692",
				native: "👨🏿‍🚒",
				x: 15,
				y: 22
			}
		],
		version: 4
	},
	"female-firefighter": {
		id: "female-firefighter",
		name: "Woman Firefighter",
		keywords: [
			"female",
			"fireman",
			"human"
		],
		skins: [
			{
				unified: "1f469-200d-1f692",
				native: "👩‍🚒",
				x: 18,
				y: 46
			},
			{
				unified: "1f469-1f3fb-200d-1f692",
				native: "👩🏻‍🚒",
				x: 18,
				y: 47
			},
			{
				unified: "1f469-1f3fc-200d-1f692",
				native: "👩🏼‍🚒",
				x: 18,
				y: 48
			},
			{
				unified: "1f469-1f3fd-200d-1f692",
				native: "👩🏽‍🚒",
				x: 18,
				y: 49
			},
			{
				unified: "1f469-1f3fe-200d-1f692",
				native: "👩🏾‍🚒",
				x: 18,
				y: 50
			},
			{
				unified: "1f469-1f3ff-200d-1f692",
				native: "👩🏿‍🚒",
				x: 18,
				y: 51
			}
		],
		version: 4
	},
	cop: {
		id: "cop",
		name: "Police Officer",
		keywords: [
			"cop"
		],
		skins: [
			{
				unified: "1f46e",
				native: "👮",
				x: 23,
				y: 8
			},
			{
				unified: "1f46e-1f3fb",
				native: "👮🏻",
				x: 23,
				y: 9
			},
			{
				unified: "1f46e-1f3fc",
				native: "👮🏼",
				x: 23,
				y: 10
			},
			{
				unified: "1f46e-1f3fd",
				native: "👮🏽",
				x: 23,
				y: 11
			},
			{
				unified: "1f46e-1f3fe",
				native: "👮🏾",
				x: 23,
				y: 12
			},
			{
				unified: "1f46e-1f3ff",
				native: "👮🏿",
				x: 23,
				y: 13
			}
		],
		version: 1
	},
	"male-police-officer": {
		id: "male-police-officer",
		name: "Man Police Officer",
		keywords: [
			"male",
			"police-officer",
			"law",
			"legal",
			"enforcement",
			"arrest",
			"911"
		],
		skins: [
			{
				unified: "1f46e-200d-2642-fe0f",
				native: "👮‍♂️",
				x: 23,
				y: 2
			},
			{
				unified: "1f46e-1f3fb-200d-2642-fe0f",
				native: "👮🏻‍♂️",
				x: 23,
				y: 3
			},
			{
				unified: "1f46e-1f3fc-200d-2642-fe0f",
				native: "👮🏼‍♂️",
				x: 23,
				y: 4
			},
			{
				unified: "1f46e-1f3fd-200d-2642-fe0f",
				native: "👮🏽‍♂️",
				x: 23,
				y: 5
			},
			{
				unified: "1f46e-1f3fe-200d-2642-fe0f",
				native: "👮🏾‍♂️",
				x: 23,
				y: 6
			},
			{
				unified: "1f46e-1f3ff-200d-2642-fe0f",
				native: "👮🏿‍♂️",
				x: 23,
				y: 7
			}
		],
		version: 4
	},
	"female-police-officer": {
		id: "female-police-officer",
		name: "Woman Police Officer",
		keywords: [
			"female",
			"police-officer",
			"law",
			"legal",
			"enforcement",
			"arrest",
			"911"
		],
		skins: [
			{
				unified: "1f46e-200d-2640-fe0f",
				native: "👮‍♀️",
				x: 22,
				y: 57
			},
			{
				unified: "1f46e-1f3fb-200d-2640-fe0f",
				native: "👮🏻‍♀️",
				x: 22,
				y: 58
			},
			{
				unified: "1f46e-1f3fc-200d-2640-fe0f",
				native: "👮🏼‍♀️",
				x: 22,
				y: 59
			},
			{
				unified: "1f46e-1f3fd-200d-2640-fe0f",
				native: "👮🏽‍♀️",
				x: 22,
				y: 60
			},
			{
				unified: "1f46e-1f3fe-200d-2640-fe0f",
				native: "👮🏾‍♀️",
				x: 23,
				y: 0
			},
			{
				unified: "1f46e-1f3ff-200d-2640-fe0f",
				native: "👮🏿‍♀️",
				x: 23,
				y: 1
			}
		],
		version: 4
	},
	sleuth_or_spy: {
		id: "sleuth_or_spy",
		name: "Detective",
		keywords: [
			"sleuth",
			"or",
			"spy",
			"human"
		],
		skins: [
			{
				unified: "1f575-fe0f",
				native: "🕵️",
				x: 31,
				y: 16
			},
			{
				unified: "1f575-1f3fb",
				native: "🕵🏻",
				x: 31,
				y: 17
			},
			{
				unified: "1f575-1f3fc",
				native: "🕵🏼",
				x: 31,
				y: 18
			},
			{
				unified: "1f575-1f3fd",
				native: "🕵🏽",
				x: 31,
				y: 19
			},
			{
				unified: "1f575-1f3fe",
				native: "🕵🏾",
				x: 31,
				y: 20
			},
			{
				unified: "1f575-1f3ff",
				native: "🕵🏿",
				x: 31,
				y: 21
			}
		],
		version: 1
	},
	"male-detective": {
		id: "male-detective",
		name: "Man Detective",
		keywords: [
			"male",
			"crime"
		],
		skins: [
			{
				unified: "1f575-fe0f-200d-2642-fe0f",
				native: "🕵️‍♂️",
				x: 31,
				y: 10
			},
			{
				unified: "1f575-1f3fb-200d-2642-fe0f",
				native: "🕵🏻‍♂️",
				x: 31,
				y: 11
			},
			{
				unified: "1f575-1f3fc-200d-2642-fe0f",
				native: "🕵🏼‍♂️",
				x: 31,
				y: 12
			},
			{
				unified: "1f575-1f3fd-200d-2642-fe0f",
				native: "🕵🏽‍♂️",
				x: 31,
				y: 13
			},
			{
				unified: "1f575-1f3fe-200d-2642-fe0f",
				native: "🕵🏾‍♂️",
				x: 31,
				y: 14
			},
			{
				unified: "1f575-1f3ff-200d-2642-fe0f",
				native: "🕵🏿‍♂️",
				x: 31,
				y: 15
			}
		],
		version: 4
	},
	"female-detective": {
		id: "female-detective",
		name: "Woman Detective",
		keywords: [
			"female",
			"human",
			"spy"
		],
		skins: [
			{
				unified: "1f575-fe0f-200d-2640-fe0f",
				native: "🕵️‍♀️",
				x: 31,
				y: 4
			},
			{
				unified: "1f575-1f3fb-200d-2640-fe0f",
				native: "🕵🏻‍♀️",
				x: 31,
				y: 5
			},
			{
				unified: "1f575-1f3fc-200d-2640-fe0f",
				native: "🕵🏼‍♀️",
				x: 31,
				y: 6
			},
			{
				unified: "1f575-1f3fd-200d-2640-fe0f",
				native: "🕵🏽‍♀️",
				x: 31,
				y: 7
			},
			{
				unified: "1f575-1f3fe-200d-2640-fe0f",
				native: "🕵🏾‍♀️",
				x: 31,
				y: 8
			},
			{
				unified: "1f575-1f3ff-200d-2640-fe0f",
				native: "🕵🏿‍♀️",
				x: 31,
				y: 9
			}
		],
		version: 4
	},
	guardsman: {
		id: "guardsman",
		name: "Guard",
		keywords: [
			"guardsman",
			"protect"
		],
		skins: [
			{
				unified: "1f482",
				native: "💂",
				x: 25,
				y: 40
			},
			{
				unified: "1f482-1f3fb",
				native: "💂🏻",
				x: 25,
				y: 41
			},
			{
				unified: "1f482-1f3fc",
				native: "💂🏼",
				x: 25,
				y: 42
			},
			{
				unified: "1f482-1f3fd",
				native: "💂🏽",
				x: 25,
				y: 43
			},
			{
				unified: "1f482-1f3fe",
				native: "💂🏾",
				x: 25,
				y: 44
			},
			{
				unified: "1f482-1f3ff",
				native: "💂🏿",
				x: 25,
				y: 45
			}
		],
		version: 1
	},
	"male-guard": {
		id: "male-guard",
		name: "Man Guard",
		keywords: [
			"male",
			"uk",
			"gb",
			"british",
			"guy",
			"royal"
		],
		skins: [
			{
				unified: "1f482-200d-2642-fe0f",
				native: "💂‍♂️",
				x: 25,
				y: 34
			},
			{
				unified: "1f482-1f3fb-200d-2642-fe0f",
				native: "💂🏻‍♂️",
				x: 25,
				y: 35
			},
			{
				unified: "1f482-1f3fc-200d-2642-fe0f",
				native: "💂🏼‍♂️",
				x: 25,
				y: 36
			},
			{
				unified: "1f482-1f3fd-200d-2642-fe0f",
				native: "💂🏽‍♂️",
				x: 25,
				y: 37
			},
			{
				unified: "1f482-1f3fe-200d-2642-fe0f",
				native: "💂🏾‍♂️",
				x: 25,
				y: 38
			},
			{
				unified: "1f482-1f3ff-200d-2642-fe0f",
				native: "💂🏿‍♂️",
				x: 25,
				y: 39
			}
		],
		version: 4
	},
	"female-guard": {
		id: "female-guard",
		name: "Woman Guard",
		keywords: [
			"female",
			"uk",
			"gb",
			"british",
			"royal"
		],
		skins: [
			{
				unified: "1f482-200d-2640-fe0f",
				native: "💂‍♀️",
				x: 25,
				y: 28
			},
			{
				unified: "1f482-1f3fb-200d-2640-fe0f",
				native: "💂🏻‍♀️",
				x: 25,
				y: 29
			},
			{
				unified: "1f482-1f3fc-200d-2640-fe0f",
				native: "💂🏼‍♀️",
				x: 25,
				y: 30
			},
			{
				unified: "1f482-1f3fd-200d-2640-fe0f",
				native: "💂🏽‍♀️",
				x: 25,
				y: 31
			},
			{
				unified: "1f482-1f3fe-200d-2640-fe0f",
				native: "💂🏾‍♀️",
				x: 25,
				y: 32
			},
			{
				unified: "1f482-1f3ff-200d-2640-fe0f",
				native: "💂🏿‍♀️",
				x: 25,
				y: 33
			}
		],
		version: 4
	},
	ninja: {
		id: "ninja",
		name: "Ninja",
		keywords: [
			"ninjutsu",
			"skills",
			"japanese"
		],
		skins: [
			{
				unified: "1f977",
				native: "🥷",
				x: 44,
				y: 4
			},
			{
				unified: "1f977-1f3fb",
				native: "🥷🏻",
				x: 44,
				y: 5
			},
			{
				unified: "1f977-1f3fc",
				native: "🥷🏼",
				x: 44,
				y: 6
			},
			{
				unified: "1f977-1f3fd",
				native: "🥷🏽",
				x: 44,
				y: 7
			},
			{
				unified: "1f977-1f3fe",
				native: "🥷🏾",
				x: 44,
				y: 8
			},
			{
				unified: "1f977-1f3ff",
				native: "🥷🏿",
				x: 44,
				y: 9
			}
		],
		version: 13
	},
	construction_worker: {
		id: "construction_worker",
		name: "Construction Worker",
		keywords: [
			"labor",
			"build"
		],
		skins: [
			{
				unified: "1f477",
				native: "👷",
				x: 24,
				y: 46
			},
			{
				unified: "1f477-1f3fb",
				native: "👷🏻",
				x: 24,
				y: 47
			},
			{
				unified: "1f477-1f3fc",
				native: "👷🏼",
				x: 24,
				y: 48
			},
			{
				unified: "1f477-1f3fd",
				native: "👷🏽",
				x: 24,
				y: 49
			},
			{
				unified: "1f477-1f3fe",
				native: "👷🏾",
				x: 24,
				y: 50
			},
			{
				unified: "1f477-1f3ff",
				native: "👷🏿",
				x: 24,
				y: 51
			}
		],
		version: 1
	},
	"male-construction-worker": {
		id: "male-construction-worker",
		name: "Man Construction Worker",
		keywords: [
			"male",
			"construction-worker",
			"human",
			"wip",
			"guy",
			"build",
			"labor"
		],
		skins: [
			{
				unified: "1f477-200d-2642-fe0f",
				native: "👷‍♂️",
				x: 24,
				y: 40
			},
			{
				unified: "1f477-1f3fb-200d-2642-fe0f",
				native: "👷🏻‍♂️",
				x: 24,
				y: 41
			},
			{
				unified: "1f477-1f3fc-200d-2642-fe0f",
				native: "👷🏼‍♂️",
				x: 24,
				y: 42
			},
			{
				unified: "1f477-1f3fd-200d-2642-fe0f",
				native: "👷🏽‍♂️",
				x: 24,
				y: 43
			},
			{
				unified: "1f477-1f3fe-200d-2642-fe0f",
				native: "👷🏾‍♂️",
				x: 24,
				y: 44
			},
			{
				unified: "1f477-1f3ff-200d-2642-fe0f",
				native: "👷🏿‍♂️",
				x: 24,
				y: 45
			}
		],
		version: 4
	},
	"female-construction-worker": {
		id: "female-construction-worker",
		name: "Woman Construction Worker",
		keywords: [
			"female",
			"construction-worker",
			"human",
			"wip",
			"build",
			"labor"
		],
		skins: [
			{
				unified: "1f477-200d-2640-fe0f",
				native: "👷‍♀️",
				x: 24,
				y: 34
			},
			{
				unified: "1f477-1f3fb-200d-2640-fe0f",
				native: "👷🏻‍♀️",
				x: 24,
				y: 35
			},
			{
				unified: "1f477-1f3fc-200d-2640-fe0f",
				native: "👷🏼‍♀️",
				x: 24,
				y: 36
			},
			{
				unified: "1f477-1f3fd-200d-2640-fe0f",
				native: "👷🏽‍♀️",
				x: 24,
				y: 37
			},
			{
				unified: "1f477-1f3fe-200d-2640-fe0f",
				native: "👷🏾‍♀️",
				x: 24,
				y: 38
			},
			{
				unified: "1f477-1f3ff-200d-2640-fe0f",
				native: "👷🏿‍♀️",
				x: 24,
				y: 39
			}
		],
		version: 4
	},
	person_with_crown: {
		id: "person_with_crown",
		name: "Person with Crown",
		keywords: [
			"royalty",
			"power"
		],
		skins: [
			{
				unified: "1fac5",
				native: "🫅",
				x: 54,
				y: 57
			},
			{
				unified: "1fac5-1f3fb",
				native: "🫅🏻",
				x: 54,
				y: 58
			},
			{
				unified: "1fac5-1f3fc",
				native: "🫅🏼",
				x: 54,
				y: 59
			},
			{
				unified: "1fac5-1f3fd",
				native: "🫅🏽",
				x: 54,
				y: 60
			},
			{
				unified: "1fac5-1f3fe",
				native: "🫅🏾",
				x: 55,
				y: 0
			},
			{
				unified: "1fac5-1f3ff",
				native: "🫅🏿",
				x: 55,
				y: 1
			}
		],
		version: 14
	},
	prince: {
		id: "prince",
		name: "Prince",
		keywords: [
			"boy",
			"man",
			"male",
			"crown",
			"royal",
			"king"
		],
		skins: [
			{
				unified: "1f934",
				native: "🤴",
				x: 41,
				y: 8
			},
			{
				unified: "1f934-1f3fb",
				native: "🤴🏻",
				x: 41,
				y: 9
			},
			{
				unified: "1f934-1f3fc",
				native: "🤴🏼",
				x: 41,
				y: 10
			},
			{
				unified: "1f934-1f3fd",
				native: "🤴🏽",
				x: 41,
				y: 11
			},
			{
				unified: "1f934-1f3fe",
				native: "🤴🏾",
				x: 41,
				y: 12
			},
			{
				unified: "1f934-1f3ff",
				native: "🤴🏿",
				x: 41,
				y: 13
			}
		],
		version: 3
	},
	princess: {
		id: "princess",
		name: "Princess",
		keywords: [
			"girl",
			"woman",
			"female",
			"blond",
			"crown",
			"royal",
			"queen"
		],
		skins: [
			{
				unified: "1f478",
				native: "👸",
				x: 24,
				y: 52
			},
			{
				unified: "1f478-1f3fb",
				native: "👸🏻",
				x: 24,
				y: 53
			},
			{
				unified: "1f478-1f3fc",
				native: "👸🏼",
				x: 24,
				y: 54
			},
			{
				unified: "1f478-1f3fd",
				native: "👸🏽",
				x: 24,
				y: 55
			},
			{
				unified: "1f478-1f3fe",
				native: "👸🏾",
				x: 24,
				y: 56
			},
			{
				unified: "1f478-1f3ff",
				native: "👸🏿",
				x: 24,
				y: 57
			}
		],
		version: 1
	},
	man_with_turban: {
		id: "man_with_turban",
		name: "Man with Turban",
		keywords: [
			"person",
			"wearing",
			"headdress"
		],
		skins: [
			{
				unified: "1f473",
				native: "👳",
				x: 24,
				y: 10
			},
			{
				unified: "1f473-1f3fb",
				native: "👳🏻",
				x: 24,
				y: 11
			},
			{
				unified: "1f473-1f3fc",
				native: "👳🏼",
				x: 24,
				y: 12
			},
			{
				unified: "1f473-1f3fd",
				native: "👳🏽",
				x: 24,
				y: 13
			},
			{
				unified: "1f473-1f3fe",
				native: "👳🏾",
				x: 24,
				y: 14
			},
			{
				unified: "1f473-1f3ff",
				native: "👳🏿",
				x: 24,
				y: 15
			}
		],
		version: 1
	},
	"man-wearing-turban": {
		id: "man-wearing-turban",
		name: "Man Wearing Turban",
		keywords: [
			"wearing-turban",
			"male",
			"indian",
			"hinduism",
			"arabs"
		],
		skins: [
			{
				unified: "1f473-200d-2642-fe0f",
				native: "👳‍♂️",
				x: 24,
				y: 4
			},
			{
				unified: "1f473-1f3fb-200d-2642-fe0f",
				native: "👳🏻‍♂️",
				x: 24,
				y: 5
			},
			{
				unified: "1f473-1f3fc-200d-2642-fe0f",
				native: "👳🏼‍♂️",
				x: 24,
				y: 6
			},
			{
				unified: "1f473-1f3fd-200d-2642-fe0f",
				native: "👳🏽‍♂️",
				x: 24,
				y: 7
			},
			{
				unified: "1f473-1f3fe-200d-2642-fe0f",
				native: "👳🏾‍♂️",
				x: 24,
				y: 8
			},
			{
				unified: "1f473-1f3ff-200d-2642-fe0f",
				native: "👳🏿‍♂️",
				x: 24,
				y: 9
			}
		],
		version: 4
	},
	"woman-wearing-turban": {
		id: "woman-wearing-turban",
		name: "Woman Wearing Turban",
		keywords: [
			"wearing-turban",
			"female",
			"indian",
			"hinduism",
			"arabs"
		],
		skins: [
			{
				unified: "1f473-200d-2640-fe0f",
				native: "👳‍♀️",
				x: 23,
				y: 59
			},
			{
				unified: "1f473-1f3fb-200d-2640-fe0f",
				native: "👳🏻‍♀️",
				x: 23,
				y: 60
			},
			{
				unified: "1f473-1f3fc-200d-2640-fe0f",
				native: "👳🏼‍♀️",
				x: 24,
				y: 0
			},
			{
				unified: "1f473-1f3fd-200d-2640-fe0f",
				native: "👳🏽‍♀️",
				x: 24,
				y: 1
			},
			{
				unified: "1f473-1f3fe-200d-2640-fe0f",
				native: "👳🏾‍♀️",
				x: 24,
				y: 2
			},
			{
				unified: "1f473-1f3ff-200d-2640-fe0f",
				native: "👳🏿‍♀️",
				x: 24,
				y: 3
			}
		],
		version: 4
	},
	man_with_gua_pi_mao: {
		id: "man_with_gua_pi_mao",
		name: "Man with Gua Pi Mao",
		keywords: [
			"skullcap",
			"male",
			"boy",
			"chinese"
		],
		skins: [
			{
				unified: "1f472",
				native: "👲",
				x: 23,
				y: 53
			},
			{
				unified: "1f472-1f3fb",
				native: "👲🏻",
				x: 23,
				y: 54
			},
			{
				unified: "1f472-1f3fc",
				native: "👲🏼",
				x: 23,
				y: 55
			},
			{
				unified: "1f472-1f3fd",
				native: "👲🏽",
				x: 23,
				y: 56
			},
			{
				unified: "1f472-1f3fe",
				native: "👲🏾",
				x: 23,
				y: 57
			},
			{
				unified: "1f472-1f3ff",
				native: "👲🏿",
				x: 23,
				y: 58
			}
		],
		version: 1
	},
	person_with_headscarf: {
		id: "person_with_headscarf",
		name: "Woman with Headscarf",
		keywords: [
			"person",
			"female",
			"hijab",
			"mantilla",
			"tichel"
		],
		skins: [
			{
				unified: "1f9d5",
				native: "🧕",
				x: 50,
				y: 41
			},
			{
				unified: "1f9d5-1f3fb",
				native: "🧕🏻",
				x: 50,
				y: 42
			},
			{
				unified: "1f9d5-1f3fc",
				native: "🧕🏼",
				x: 50,
				y: 43
			},
			{
				unified: "1f9d5-1f3fd",
				native: "🧕🏽",
				x: 50,
				y: 44
			},
			{
				unified: "1f9d5-1f3fe",
				native: "🧕🏾",
				x: 50,
				y: 45
			},
			{
				unified: "1f9d5-1f3ff",
				native: "🧕🏿",
				x: 50,
				y: 46
			}
		],
		version: 5
	},
	person_in_tuxedo: {
		id: "person_in_tuxedo",
		name: "Man in Tuxedo",
		keywords: [
			"person",
			"couple",
			"marriage",
			"wedding",
			"groom"
		],
		skins: [
			{
				unified: "1f935",
				native: "🤵",
				x: 41,
				y: 26
			},
			{
				unified: "1f935-1f3fb",
				native: "🤵🏻",
				x: 41,
				y: 27
			},
			{
				unified: "1f935-1f3fc",
				native: "🤵🏼",
				x: 41,
				y: 28
			},
			{
				unified: "1f935-1f3fd",
				native: "🤵🏽",
				x: 41,
				y: 29
			},
			{
				unified: "1f935-1f3fe",
				native: "🤵🏾",
				x: 41,
				y: 30
			},
			{
				unified: "1f935-1f3ff",
				native: "🤵🏿",
				x: 41,
				y: 31
			}
		],
		version: 3
	},
	man_in_tuxedo: {
		id: "man_in_tuxedo",
		name: "Man in Tuxedo",
		keywords: [
			"formal",
			"fashion"
		],
		skins: [
			{
				unified: "1f935-200d-2642-fe0f",
				native: "🤵‍♂️",
				x: 41,
				y: 20
			},
			{
				unified: "1f935-1f3fb-200d-2642-fe0f",
				native: "🤵🏻‍♂️",
				x: 41,
				y: 21
			},
			{
				unified: "1f935-1f3fc-200d-2642-fe0f",
				native: "🤵🏼‍♂️",
				x: 41,
				y: 22
			},
			{
				unified: "1f935-1f3fd-200d-2642-fe0f",
				native: "🤵🏽‍♂️",
				x: 41,
				y: 23
			},
			{
				unified: "1f935-1f3fe-200d-2642-fe0f",
				native: "🤵🏾‍♂️",
				x: 41,
				y: 24
			},
			{
				unified: "1f935-1f3ff-200d-2642-fe0f",
				native: "🤵🏿‍♂️",
				x: 41,
				y: 25
			}
		],
		version: 13
	},
	woman_in_tuxedo: {
		id: "woman_in_tuxedo",
		name: "Woman in Tuxedo",
		keywords: [
			"formal",
			"fashion"
		],
		skins: [
			{
				unified: "1f935-200d-2640-fe0f",
				native: "🤵‍♀️",
				x: 41,
				y: 14
			},
			{
				unified: "1f935-1f3fb-200d-2640-fe0f",
				native: "🤵🏻‍♀️",
				x: 41,
				y: 15
			},
			{
				unified: "1f935-1f3fc-200d-2640-fe0f",
				native: "🤵🏼‍♀️",
				x: 41,
				y: 16
			},
			{
				unified: "1f935-1f3fd-200d-2640-fe0f",
				native: "🤵🏽‍♀️",
				x: 41,
				y: 17
			},
			{
				unified: "1f935-1f3fe-200d-2640-fe0f",
				native: "🤵🏾‍♀️",
				x: 41,
				y: 18
			},
			{
				unified: "1f935-1f3ff-200d-2640-fe0f",
				native: "🤵🏿‍♀️",
				x: 41,
				y: 19
			}
		],
		version: 13
	},
	bride_with_veil: {
		id: "bride_with_veil",
		name: "Bride with Veil",
		keywords: [
			"couple",
			"marriage",
			"wedding",
			"woman"
		],
		skins: [
			{
				unified: "1f470",
				native: "👰",
				x: 23,
				y: 29
			},
			{
				unified: "1f470-1f3fb",
				native: "👰🏻",
				x: 23,
				y: 30
			},
			{
				unified: "1f470-1f3fc",
				native: "👰🏼",
				x: 23,
				y: 31
			},
			{
				unified: "1f470-1f3fd",
				native: "👰🏽",
				x: 23,
				y: 32
			},
			{
				unified: "1f470-1f3fe",
				native: "👰🏾",
				x: 23,
				y: 33
			},
			{
				unified: "1f470-1f3ff",
				native: "👰🏿",
				x: 23,
				y: 34
			}
		],
		version: 1
	},
	man_with_veil: {
		id: "man_with_veil",
		name: "Man with Veil",
		keywords: [
			"wedding",
			"marriage"
		],
		skins: [
			{
				unified: "1f470-200d-2642-fe0f",
				native: "👰‍♂️",
				x: 23,
				y: 23
			},
			{
				unified: "1f470-1f3fb-200d-2642-fe0f",
				native: "👰🏻‍♂️",
				x: 23,
				y: 24
			},
			{
				unified: "1f470-1f3fc-200d-2642-fe0f",
				native: "👰🏼‍♂️",
				x: 23,
				y: 25
			},
			{
				unified: "1f470-1f3fd-200d-2642-fe0f",
				native: "👰🏽‍♂️",
				x: 23,
				y: 26
			},
			{
				unified: "1f470-1f3fe-200d-2642-fe0f",
				native: "👰🏾‍♂️",
				x: 23,
				y: 27
			},
			{
				unified: "1f470-1f3ff-200d-2642-fe0f",
				native: "👰🏿‍♂️",
				x: 23,
				y: 28
			}
		],
		version: 13
	},
	woman_with_veil: {
		id: "woman_with_veil",
		name: "Woman with Veil",
		keywords: [
			"wedding",
			"marriage"
		],
		skins: [
			{
				unified: "1f470-200d-2640-fe0f",
				native: "👰‍♀️",
				x: 23,
				y: 17
			},
			{
				unified: "1f470-1f3fb-200d-2640-fe0f",
				native: "👰🏻‍♀️",
				x: 23,
				y: 18
			},
			{
				unified: "1f470-1f3fc-200d-2640-fe0f",
				native: "👰🏼‍♀️",
				x: 23,
				y: 19
			},
			{
				unified: "1f470-1f3fd-200d-2640-fe0f",
				native: "👰🏽‍♀️",
				x: 23,
				y: 20
			},
			{
				unified: "1f470-1f3fe-200d-2640-fe0f",
				native: "👰🏾‍♀️",
				x: 23,
				y: 21
			},
			{
				unified: "1f470-1f3ff-200d-2640-fe0f",
				native: "👰🏿‍♀️",
				x: 23,
				y: 22
			}
		],
		version: 13
	},
	pregnant_woman: {
		id: "pregnant_woman",
		name: "Pregnant Woman",
		keywords: [
			"baby"
		],
		skins: [
			{
				unified: "1f930",
				native: "🤰",
				x: 40,
				y: 45
			},
			{
				unified: "1f930-1f3fb",
				native: "🤰🏻",
				x: 40,
				y: 46
			},
			{
				unified: "1f930-1f3fc",
				native: "🤰🏼",
				x: 40,
				y: 47
			},
			{
				unified: "1f930-1f3fd",
				native: "🤰🏽",
				x: 40,
				y: 48
			},
			{
				unified: "1f930-1f3fe",
				native: "🤰🏾",
				x: 40,
				y: 49
			},
			{
				unified: "1f930-1f3ff",
				native: "🤰🏿",
				x: 40,
				y: 50
			}
		],
		version: 3
	},
	pregnant_man: {
		id: "pregnant_man",
		name: "Pregnant Man",
		keywords: [
			"baby",
			"belly"
		],
		skins: [
			{
				unified: "1fac3",
				native: "🫃",
				x: 54,
				y: 45
			},
			{
				unified: "1fac3-1f3fb",
				native: "🫃🏻",
				x: 54,
				y: 46
			},
			{
				unified: "1fac3-1f3fc",
				native: "🫃🏼",
				x: 54,
				y: 47
			},
			{
				unified: "1fac3-1f3fd",
				native: "🫃🏽",
				x: 54,
				y: 48
			},
			{
				unified: "1fac3-1f3fe",
				native: "🫃🏾",
				x: 54,
				y: 49
			},
			{
				unified: "1fac3-1f3ff",
				native: "🫃🏿",
				x: 54,
				y: 50
			}
		],
		version: 14
	},
	pregnant_person: {
		id: "pregnant_person",
		name: "Pregnant Person",
		keywords: [
			"baby",
			"belly"
		],
		skins: [
			{
				unified: "1fac4",
				native: "🫄",
				x: 54,
				y: 51
			},
			{
				unified: "1fac4-1f3fb",
				native: "🫄🏻",
				x: 54,
				y: 52
			},
			{
				unified: "1fac4-1f3fc",
				native: "🫄🏼",
				x: 54,
				y: 53
			},
			{
				unified: "1fac4-1f3fd",
				native: "🫄🏽",
				x: 54,
				y: 54
			},
			{
				unified: "1fac4-1f3fe",
				native: "🫄🏾",
				x: 54,
				y: 55
			},
			{
				unified: "1fac4-1f3ff",
				native: "🫄🏿",
				x: 54,
				y: 56
			}
		],
		version: 14
	},
	"breast-feeding": {
		id: "breast-feeding",
		name: "Breast-Feeding",
		keywords: [
			"breast",
			"feeding",
			"nursing",
			"baby"
		],
		skins: [
			{
				unified: "1f931",
				native: "🤱",
				x: 40,
				y: 51
			},
			{
				unified: "1f931-1f3fb",
				native: "🤱🏻",
				x: 40,
				y: 52
			},
			{
				unified: "1f931-1f3fc",
				native: "🤱🏼",
				x: 40,
				y: 53
			},
			{
				unified: "1f931-1f3fd",
				native: "🤱🏽",
				x: 40,
				y: 54
			},
			{
				unified: "1f931-1f3fe",
				native: "🤱🏾",
				x: 40,
				y: 55
			},
			{
				unified: "1f931-1f3ff",
				native: "🤱🏿",
				x: 40,
				y: 56
			}
		],
		version: 5
	},
	woman_feeding_baby: {
		id: "woman_feeding_baby",
		name: "Woman Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f469-200d-1f37c",
				native: "👩‍🍼",
				x: 17,
				y: 31
			},
			{
				unified: "1f469-1f3fb-200d-1f37c",
				native: "👩🏻‍🍼",
				x: 17,
				y: 32
			},
			{
				unified: "1f469-1f3fc-200d-1f37c",
				native: "👩🏼‍🍼",
				x: 17,
				y: 33
			},
			{
				unified: "1f469-1f3fd-200d-1f37c",
				native: "👩🏽‍🍼",
				x: 17,
				y: 34
			},
			{
				unified: "1f469-1f3fe-200d-1f37c",
				native: "👩🏾‍🍼",
				x: 17,
				y: 35
			},
			{
				unified: "1f469-1f3ff-200d-1f37c",
				native: "👩🏿‍🍼",
				x: 17,
				y: 36
			}
		],
		version: 13
	},
	man_feeding_baby: {
		id: "man_feeding_baby",
		name: "Man Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f468-200d-1f37c",
				native: "👨‍🍼",
				x: 13,
				y: 58
			},
			{
				unified: "1f468-1f3fb-200d-1f37c",
				native: "👨🏻‍🍼",
				x: 13,
				y: 59
			},
			{
				unified: "1f468-1f3fc-200d-1f37c",
				native: "👨🏼‍🍼",
				x: 13,
				y: 60
			},
			{
				unified: "1f468-1f3fd-200d-1f37c",
				native: "👨🏽‍🍼",
				x: 14,
				y: 0
			},
			{
				unified: "1f468-1f3fe-200d-1f37c",
				native: "👨🏾‍🍼",
				x: 14,
				y: 1
			},
			{
				unified: "1f468-1f3ff-200d-1f37c",
				native: "👨🏿‍🍼",
				x: 14,
				y: 2
			}
		],
		version: 13
	},
	person_feeding_baby: {
		id: "person_feeding_baby",
		name: "Person Feeding Baby",
		keywords: [
			"birth",
			"food"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f37c",
				native: "🧑‍🍼",
				x: 47,
				y: 24
			},
			{
				unified: "1f9d1-1f3fb-200d-1f37c",
				native: "🧑🏻‍🍼",
				x: 47,
				y: 25
			},
			{
				unified: "1f9d1-1f3fc-200d-1f37c",
				native: "🧑🏼‍🍼",
				x: 47,
				y: 26
			},
			{
				unified: "1f9d1-1f3fd-200d-1f37c",
				native: "🧑🏽‍🍼",
				x: 47,
				y: 27
			},
			{
				unified: "1f9d1-1f3fe-200d-1f37c",
				native: "🧑🏾‍🍼",
				x: 47,
				y: 28
			},
			{
				unified: "1f9d1-1f3ff-200d-1f37c",
				native: "🧑🏿‍🍼",
				x: 47,
				y: 29
			}
		],
		version: 13
	},
	angel: {
		id: "angel",
		name: "Baby Angel",
		keywords: [
			"heaven",
			"wings",
			"halo"
		],
		skins: [
			{
				unified: "1f47c",
				native: "👼",
				x: 25,
				y: 0
			},
			{
				unified: "1f47c-1f3fb",
				native: "👼🏻",
				x: 25,
				y: 1
			},
			{
				unified: "1f47c-1f3fc",
				native: "👼🏼",
				x: 25,
				y: 2
			},
			{
				unified: "1f47c-1f3fd",
				native: "👼🏽",
				x: 25,
				y: 3
			},
			{
				unified: "1f47c-1f3fe",
				native: "👼🏾",
				x: 25,
				y: 4
			},
			{
				unified: "1f47c-1f3ff",
				native: "👼🏿",
				x: 25,
				y: 5
			}
		],
		version: 1
	},
	santa: {
		id: "santa",
		name: "Santa Claus",
		keywords: [
			"festival",
			"man",
			"male",
			"xmas",
			"father",
			"christmas"
		],
		skins: [
			{
				unified: "1f385",
				native: "🎅",
				x: 7,
				y: 8
			},
			{
				unified: "1f385-1f3fb",
				native: "🎅🏻",
				x: 7,
				y: 9
			},
			{
				unified: "1f385-1f3fc",
				native: "🎅🏼",
				x: 7,
				y: 10
			},
			{
				unified: "1f385-1f3fd",
				native: "🎅🏽",
				x: 7,
				y: 11
			},
			{
				unified: "1f385-1f3fe",
				native: "🎅🏾",
				x: 7,
				y: 12
			},
			{
				unified: "1f385-1f3ff",
				native: "🎅🏿",
				x: 7,
				y: 13
			}
		],
		version: 1
	},
	mrs_claus: {
		id: "mrs_claus",
		name: "Mrs. Claus",
		keywords: [
			"mrs",
			"mother",
			"christmas",
			"woman",
			"female",
			"xmas"
		],
		skins: [
			{
				unified: "1f936",
				native: "🤶",
				x: 41,
				y: 32
			},
			{
				unified: "1f936-1f3fb",
				native: "🤶🏻",
				x: 41,
				y: 33
			},
			{
				unified: "1f936-1f3fc",
				native: "🤶🏼",
				x: 41,
				y: 34
			},
			{
				unified: "1f936-1f3fd",
				native: "🤶🏽",
				x: 41,
				y: 35
			},
			{
				unified: "1f936-1f3fe",
				native: "🤶🏾",
				x: 41,
				y: 36
			},
			{
				unified: "1f936-1f3ff",
				native: "🤶🏿",
				x: 41,
				y: 37
			}
		],
		version: 3
	},
	mx_claus: {
		id: "mx_claus",
		name: "Mx Claus",
		keywords: [
			"christmas"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f384",
				native: "🧑‍🎄",
				x: 47,
				y: 30
			},
			{
				unified: "1f9d1-1f3fb-200d-1f384",
				native: "🧑🏻‍🎄",
				x: 47,
				y: 31
			},
			{
				unified: "1f9d1-1f3fc-200d-1f384",
				native: "🧑🏼‍🎄",
				x: 47,
				y: 32
			},
			{
				unified: "1f9d1-1f3fd-200d-1f384",
				native: "🧑🏽‍🎄",
				x: 47,
				y: 33
			},
			{
				unified: "1f9d1-1f3fe-200d-1f384",
				native: "🧑🏾‍🎄",
				x: 47,
				y: 34
			},
			{
				unified: "1f9d1-1f3ff-200d-1f384",
				native: "🧑🏿‍🎄",
				x: 47,
				y: 35
			}
		],
		version: 13
	},
	superhero: {
		id: "superhero",
		name: "Superhero",
		keywords: [
			"marvel"
		],
		skins: [
			{
				unified: "1f9b8",
				native: "🦸",
				x: 45,
				y: 31
			},
			{
				unified: "1f9b8-1f3fb",
				native: "🦸🏻",
				x: 45,
				y: 32
			},
			{
				unified: "1f9b8-1f3fc",
				native: "🦸🏼",
				x: 45,
				y: 33
			},
			{
				unified: "1f9b8-1f3fd",
				native: "🦸🏽",
				x: 45,
				y: 34
			},
			{
				unified: "1f9b8-1f3fe",
				native: "🦸🏾",
				x: 45,
				y: 35
			},
			{
				unified: "1f9b8-1f3ff",
				native: "🦸🏿",
				x: 45,
				y: 36
			}
		],
		version: 11
	},
	male_superhero: {
		id: "male_superhero",
		name: "Man Superhero",
		keywords: [
			"male",
			"good",
			"hero",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b8-200d-2642-fe0f",
				native: "🦸‍♂️",
				x: 45,
				y: 25
			},
			{
				unified: "1f9b8-1f3fb-200d-2642-fe0f",
				native: "🦸🏻‍♂️",
				x: 45,
				y: 26
			},
			{
				unified: "1f9b8-1f3fc-200d-2642-fe0f",
				native: "🦸🏼‍♂️",
				x: 45,
				y: 27
			},
			{
				unified: "1f9b8-1f3fd-200d-2642-fe0f",
				native: "🦸🏽‍♂️",
				x: 45,
				y: 28
			},
			{
				unified: "1f9b8-1f3fe-200d-2642-fe0f",
				native: "🦸🏾‍♂️",
				x: 45,
				y: 29
			},
			{
				unified: "1f9b8-1f3ff-200d-2642-fe0f",
				native: "🦸🏿‍♂️",
				x: 45,
				y: 30
			}
		],
		version: 11
	},
	female_superhero: {
		id: "female_superhero",
		name: "Woman Superhero",
		keywords: [
			"female",
			"good",
			"heroine",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b8-200d-2640-fe0f",
				native: "🦸‍♀️",
				x: 45,
				y: 19
			},
			{
				unified: "1f9b8-1f3fb-200d-2640-fe0f",
				native: "🦸🏻‍♀️",
				x: 45,
				y: 20
			},
			{
				unified: "1f9b8-1f3fc-200d-2640-fe0f",
				native: "🦸🏼‍♀️",
				x: 45,
				y: 21
			},
			{
				unified: "1f9b8-1f3fd-200d-2640-fe0f",
				native: "🦸🏽‍♀️",
				x: 45,
				y: 22
			},
			{
				unified: "1f9b8-1f3fe-200d-2640-fe0f",
				native: "🦸🏾‍♀️",
				x: 45,
				y: 23
			},
			{
				unified: "1f9b8-1f3ff-200d-2640-fe0f",
				native: "🦸🏿‍♀️",
				x: 45,
				y: 24
			}
		],
		version: 11
	},
	supervillain: {
		id: "supervillain",
		name: "Supervillain",
		keywords: [
			"marvel"
		],
		skins: [
			{
				unified: "1f9b9",
				native: "🦹",
				x: 45,
				y: 49
			},
			{
				unified: "1f9b9-1f3fb",
				native: "🦹🏻",
				x: 45,
				y: 50
			},
			{
				unified: "1f9b9-1f3fc",
				native: "🦹🏼",
				x: 45,
				y: 51
			},
			{
				unified: "1f9b9-1f3fd",
				native: "🦹🏽",
				x: 45,
				y: 52
			},
			{
				unified: "1f9b9-1f3fe",
				native: "🦹🏾",
				x: 45,
				y: 53
			},
			{
				unified: "1f9b9-1f3ff",
				native: "🦹🏿",
				x: 45,
				y: 54
			}
		],
		version: 11
	},
	male_supervillain: {
		id: "male_supervillain",
		name: "Man Supervillain",
		keywords: [
			"male",
			"evil",
			"bad",
			"criminal",
			"hero",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b9-200d-2642-fe0f",
				native: "🦹‍♂️",
				x: 45,
				y: 43
			},
			{
				unified: "1f9b9-1f3fb-200d-2642-fe0f",
				native: "🦹🏻‍♂️",
				x: 45,
				y: 44
			},
			{
				unified: "1f9b9-1f3fc-200d-2642-fe0f",
				native: "🦹🏼‍♂️",
				x: 45,
				y: 45
			},
			{
				unified: "1f9b9-1f3fd-200d-2642-fe0f",
				native: "🦹🏽‍♂️",
				x: 45,
				y: 46
			},
			{
				unified: "1f9b9-1f3fe-200d-2642-fe0f",
				native: "🦹🏾‍♂️",
				x: 45,
				y: 47
			},
			{
				unified: "1f9b9-1f3ff-200d-2642-fe0f",
				native: "🦹🏿‍♂️",
				x: 45,
				y: 48
			}
		],
		version: 11
	},
	female_supervillain: {
		id: "female_supervillain",
		name: "Woman Supervillain",
		keywords: [
			"female",
			"evil",
			"bad",
			"criminal",
			"heroine",
			"superpowers"
		],
		skins: [
			{
				unified: "1f9b9-200d-2640-fe0f",
				native: "🦹‍♀️",
				x: 45,
				y: 37
			},
			{
				unified: "1f9b9-1f3fb-200d-2640-fe0f",
				native: "🦹🏻‍♀️",
				x: 45,
				y: 38
			},
			{
				unified: "1f9b9-1f3fc-200d-2640-fe0f",
				native: "🦹🏼‍♀️",
				x: 45,
				y: 39
			},
			{
				unified: "1f9b9-1f3fd-200d-2640-fe0f",
				native: "🦹🏽‍♀️",
				x: 45,
				y: 40
			},
			{
				unified: "1f9b9-1f3fe-200d-2640-fe0f",
				native: "🦹🏾‍♀️",
				x: 45,
				y: 41
			},
			{
				unified: "1f9b9-1f3ff-200d-2640-fe0f",
				native: "🦹🏿‍♀️",
				x: 45,
				y: 42
			}
		],
		version: 11
	},
	mage: {
		id: "mage",
		name: "Mage",
		keywords: [
			"magic"
		],
		skins: [
			{
				unified: "1f9d9",
				native: "🧙",
				x: 51,
				y: 52
			},
			{
				unified: "1f9d9-1f3fb",
				native: "🧙🏻",
				x: 51,
				y: 53
			},
			{
				unified: "1f9d9-1f3fc",
				native: "🧙🏼",
				x: 51,
				y: 54
			},
			{
				unified: "1f9d9-1f3fd",
				native: "🧙🏽",
				x: 51,
				y: 55
			},
			{
				unified: "1f9d9-1f3fe",
				native: "🧙🏾",
				x: 51,
				y: 56
			},
			{
				unified: "1f9d9-1f3ff",
				native: "🧙🏿",
				x: 51,
				y: 57
			}
		],
		version: 5
	},
	male_mage: {
		id: "male_mage",
		name: "Man Mage",
		keywords: [
			"male",
			"sorcerer"
		],
		skins: [
			{
				unified: "1f9d9-200d-2642-fe0f",
				native: "🧙‍♂️",
				x: 51,
				y: 46
			},
			{
				unified: "1f9d9-1f3fb-200d-2642-fe0f",
				native: "🧙🏻‍♂️",
				x: 51,
				y: 47
			},
			{
				unified: "1f9d9-1f3fc-200d-2642-fe0f",
				native: "🧙🏼‍♂️",
				x: 51,
				y: 48
			},
			{
				unified: "1f9d9-1f3fd-200d-2642-fe0f",
				native: "🧙🏽‍♂️",
				x: 51,
				y: 49
			},
			{
				unified: "1f9d9-1f3fe-200d-2642-fe0f",
				native: "🧙🏾‍♂️",
				x: 51,
				y: 50
			},
			{
				unified: "1f9d9-1f3ff-200d-2642-fe0f",
				native: "🧙🏿‍♂️",
				x: 51,
				y: 51
			}
		],
		version: 5
	},
	female_mage: {
		id: "female_mage",
		name: "Woman Mage",
		keywords: [
			"female",
			"witch"
		],
		skins: [
			{
				unified: "1f9d9-200d-2640-fe0f",
				native: "🧙‍♀️",
				x: 51,
				y: 40
			},
			{
				unified: "1f9d9-1f3fb-200d-2640-fe0f",
				native: "🧙🏻‍♀️",
				x: 51,
				y: 41
			},
			{
				unified: "1f9d9-1f3fc-200d-2640-fe0f",
				native: "🧙🏼‍♀️",
				x: 51,
				y: 42
			},
			{
				unified: "1f9d9-1f3fd-200d-2640-fe0f",
				native: "🧙🏽‍♀️",
				x: 51,
				y: 43
			},
			{
				unified: "1f9d9-1f3fe-200d-2640-fe0f",
				native: "🧙🏾‍♀️",
				x: 51,
				y: 44
			},
			{
				unified: "1f9d9-1f3ff-200d-2640-fe0f",
				native: "🧙🏿‍♀️",
				x: 51,
				y: 45
			}
		],
		version: 5
	},
	fairy: {
		id: "fairy",
		name: "Fairy",
		keywords: [
			"wings",
			"magical"
		],
		skins: [
			{
				unified: "1f9da",
				native: "🧚",
				x: 52,
				y: 9
			},
			{
				unified: "1f9da-1f3fb",
				native: "🧚🏻",
				x: 52,
				y: 10
			},
			{
				unified: "1f9da-1f3fc",
				native: "🧚🏼",
				x: 52,
				y: 11
			},
			{
				unified: "1f9da-1f3fd",
				native: "🧚🏽",
				x: 52,
				y: 12
			},
			{
				unified: "1f9da-1f3fe",
				native: "🧚🏾",
				x: 52,
				y: 13
			},
			{
				unified: "1f9da-1f3ff",
				native: "🧚🏿",
				x: 52,
				y: 14
			}
		],
		version: 5
	},
	male_fairy: {
		id: "male_fairy",
		name: "Man Fairy",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9da-200d-2642-fe0f",
				native: "🧚‍♂️",
				x: 52,
				y: 3
			},
			{
				unified: "1f9da-1f3fb-200d-2642-fe0f",
				native: "🧚🏻‍♂️",
				x: 52,
				y: 4
			},
			{
				unified: "1f9da-1f3fc-200d-2642-fe0f",
				native: "🧚🏼‍♂️",
				x: 52,
				y: 5
			},
			{
				unified: "1f9da-1f3fd-200d-2642-fe0f",
				native: "🧚🏽‍♂️",
				x: 52,
				y: 6
			},
			{
				unified: "1f9da-1f3fe-200d-2642-fe0f",
				native: "🧚🏾‍♂️",
				x: 52,
				y: 7
			},
			{
				unified: "1f9da-1f3ff-200d-2642-fe0f",
				native: "🧚🏿‍♂️",
				x: 52,
				y: 8
			}
		],
		version: 5
	},
	female_fairy: {
		id: "female_fairy",
		name: "Woman Fairy",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9da-200d-2640-fe0f",
				native: "🧚‍♀️",
				x: 51,
				y: 58
			},
			{
				unified: "1f9da-1f3fb-200d-2640-fe0f",
				native: "🧚🏻‍♀️",
				x: 51,
				y: 59
			},
			{
				unified: "1f9da-1f3fc-200d-2640-fe0f",
				native: "🧚🏼‍♀️",
				x: 51,
				y: 60
			},
			{
				unified: "1f9da-1f3fd-200d-2640-fe0f",
				native: "🧚🏽‍♀️",
				x: 52,
				y: 0
			},
			{
				unified: "1f9da-1f3fe-200d-2640-fe0f",
				native: "🧚🏾‍♀️",
				x: 52,
				y: 1
			},
			{
				unified: "1f9da-1f3ff-200d-2640-fe0f",
				native: "🧚🏿‍♀️",
				x: 52,
				y: 2
			}
		],
		version: 5
	},
	vampire: {
		id: "vampire",
		name: "Vampire",
		keywords: [
			"blood",
			"twilight"
		],
		skins: [
			{
				unified: "1f9db",
				native: "🧛",
				x: 52,
				y: 27
			},
			{
				unified: "1f9db-1f3fb",
				native: "🧛🏻",
				x: 52,
				y: 28
			},
			{
				unified: "1f9db-1f3fc",
				native: "🧛🏼",
				x: 52,
				y: 29
			},
			{
				unified: "1f9db-1f3fd",
				native: "🧛🏽",
				x: 52,
				y: 30
			},
			{
				unified: "1f9db-1f3fe",
				native: "🧛🏾",
				x: 52,
				y: 31
			},
			{
				unified: "1f9db-1f3ff",
				native: "🧛🏿",
				x: 52,
				y: 32
			}
		],
		version: 5
	},
	male_vampire: {
		id: "male_vampire",
		name: "Man Vampire",
		keywords: [
			"male",
			"dracula"
		],
		skins: [
			{
				unified: "1f9db-200d-2642-fe0f",
				native: "🧛‍♂️",
				x: 52,
				y: 21
			},
			{
				unified: "1f9db-1f3fb-200d-2642-fe0f",
				native: "🧛🏻‍♂️",
				x: 52,
				y: 22
			},
			{
				unified: "1f9db-1f3fc-200d-2642-fe0f",
				native: "🧛🏼‍♂️",
				x: 52,
				y: 23
			},
			{
				unified: "1f9db-1f3fd-200d-2642-fe0f",
				native: "🧛🏽‍♂️",
				x: 52,
				y: 24
			},
			{
				unified: "1f9db-1f3fe-200d-2642-fe0f",
				native: "🧛🏾‍♂️",
				x: 52,
				y: 25
			},
			{
				unified: "1f9db-1f3ff-200d-2642-fe0f",
				native: "🧛🏿‍♂️",
				x: 52,
				y: 26
			}
		],
		version: 5
	},
	female_vampire: {
		id: "female_vampire",
		name: "Woman Vampire",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9db-200d-2640-fe0f",
				native: "🧛‍♀️",
				x: 52,
				y: 15
			},
			{
				unified: "1f9db-1f3fb-200d-2640-fe0f",
				native: "🧛🏻‍♀️",
				x: 52,
				y: 16
			},
			{
				unified: "1f9db-1f3fc-200d-2640-fe0f",
				native: "🧛🏼‍♀️",
				x: 52,
				y: 17
			},
			{
				unified: "1f9db-1f3fd-200d-2640-fe0f",
				native: "🧛🏽‍♀️",
				x: 52,
				y: 18
			},
			{
				unified: "1f9db-1f3fe-200d-2640-fe0f",
				native: "🧛🏾‍♀️",
				x: 52,
				y: 19
			},
			{
				unified: "1f9db-1f3ff-200d-2640-fe0f",
				native: "🧛🏿‍♀️",
				x: 52,
				y: 20
			}
		],
		version: 5
	},
	merperson: {
		id: "merperson",
		name: "Merperson",
		keywords: [
			"sea"
		],
		skins: [
			{
				unified: "1f9dc",
				native: "🧜",
				x: 52,
				y: 45
			},
			{
				unified: "1f9dc-1f3fb",
				native: "🧜🏻",
				x: 52,
				y: 46
			},
			{
				unified: "1f9dc-1f3fc",
				native: "🧜🏼",
				x: 52,
				y: 47
			},
			{
				unified: "1f9dc-1f3fd",
				native: "🧜🏽",
				x: 52,
				y: 48
			},
			{
				unified: "1f9dc-1f3fe",
				native: "🧜🏾",
				x: 52,
				y: 49
			},
			{
				unified: "1f9dc-1f3ff",
				native: "🧜🏿",
				x: 52,
				y: 50
			}
		],
		version: 5
	},
	merman: {
		id: "merman",
		name: "Merman",
		keywords: [
			"man",
			"male",
			"triton"
		],
		skins: [
			{
				unified: "1f9dc-200d-2642-fe0f",
				native: "🧜‍♂️",
				x: 52,
				y: 39
			},
			{
				unified: "1f9dc-1f3fb-200d-2642-fe0f",
				native: "🧜🏻‍♂️",
				x: 52,
				y: 40
			},
			{
				unified: "1f9dc-1f3fc-200d-2642-fe0f",
				native: "🧜🏼‍♂️",
				x: 52,
				y: 41
			},
			{
				unified: "1f9dc-1f3fd-200d-2642-fe0f",
				native: "🧜🏽‍♂️",
				x: 52,
				y: 42
			},
			{
				unified: "1f9dc-1f3fe-200d-2642-fe0f",
				native: "🧜🏾‍♂️",
				x: 52,
				y: 43
			},
			{
				unified: "1f9dc-1f3ff-200d-2642-fe0f",
				native: "🧜🏿‍♂️",
				x: 52,
				y: 44
			}
		],
		version: 5
	},
	mermaid: {
		id: "mermaid",
		name: "Mermaid",
		keywords: [
			"woman",
			"female",
			"merwoman",
			"ariel"
		],
		skins: [
			{
				unified: "1f9dc-200d-2640-fe0f",
				native: "🧜‍♀️",
				x: 52,
				y: 33
			},
			{
				unified: "1f9dc-1f3fb-200d-2640-fe0f",
				native: "🧜🏻‍♀️",
				x: 52,
				y: 34
			},
			{
				unified: "1f9dc-1f3fc-200d-2640-fe0f",
				native: "🧜🏼‍♀️",
				x: 52,
				y: 35
			},
			{
				unified: "1f9dc-1f3fd-200d-2640-fe0f",
				native: "🧜🏽‍♀️",
				x: 52,
				y: 36
			},
			{
				unified: "1f9dc-1f3fe-200d-2640-fe0f",
				native: "🧜🏾‍♀️",
				x: 52,
				y: 37
			},
			{
				unified: "1f9dc-1f3ff-200d-2640-fe0f",
				native: "🧜🏿‍♀️",
				x: 52,
				y: 38
			}
		],
		version: 5
	},
	elf: {
		id: "elf",
		name: "Elf",
		keywords: [
			"magical"
		],
		skins: [
			{
				unified: "1f9dd",
				native: "🧝",
				x: 53,
				y: 2
			},
			{
				unified: "1f9dd-1f3fb",
				native: "🧝🏻",
				x: 53,
				y: 3
			},
			{
				unified: "1f9dd-1f3fc",
				native: "🧝🏼",
				x: 53,
				y: 4
			},
			{
				unified: "1f9dd-1f3fd",
				native: "🧝🏽",
				x: 53,
				y: 5
			},
			{
				unified: "1f9dd-1f3fe",
				native: "🧝🏾",
				x: 53,
				y: 6
			},
			{
				unified: "1f9dd-1f3ff",
				native: "🧝🏿",
				x: 53,
				y: 7
			}
		],
		version: 5
	},
	male_elf: {
		id: "male_elf",
		name: "Man Elf",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9dd-200d-2642-fe0f",
				native: "🧝‍♂️",
				x: 52,
				y: 57
			},
			{
				unified: "1f9dd-1f3fb-200d-2642-fe0f",
				native: "🧝🏻‍♂️",
				x: 52,
				y: 58
			},
			{
				unified: "1f9dd-1f3fc-200d-2642-fe0f",
				native: "🧝🏼‍♂️",
				x: 52,
				y: 59
			},
			{
				unified: "1f9dd-1f3fd-200d-2642-fe0f",
				native: "🧝🏽‍♂️",
				x: 52,
				y: 60
			},
			{
				unified: "1f9dd-1f3fe-200d-2642-fe0f",
				native: "🧝🏾‍♂️",
				x: 53,
				y: 0
			},
			{
				unified: "1f9dd-1f3ff-200d-2642-fe0f",
				native: "🧝🏿‍♂️",
				x: 53,
				y: 1
			}
		],
		version: 5
	},
	female_elf: {
		id: "female_elf",
		name: "Woman Elf",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9dd-200d-2640-fe0f",
				native: "🧝‍♀️",
				x: 52,
				y: 51
			},
			{
				unified: "1f9dd-1f3fb-200d-2640-fe0f",
				native: "🧝🏻‍♀️",
				x: 52,
				y: 52
			},
			{
				unified: "1f9dd-1f3fc-200d-2640-fe0f",
				native: "🧝🏼‍♀️",
				x: 52,
				y: 53
			},
			{
				unified: "1f9dd-1f3fd-200d-2640-fe0f",
				native: "🧝🏽‍♀️",
				x: 52,
				y: 54
			},
			{
				unified: "1f9dd-1f3fe-200d-2640-fe0f",
				native: "🧝🏾‍♀️",
				x: 52,
				y: 55
			},
			{
				unified: "1f9dd-1f3ff-200d-2640-fe0f",
				native: "🧝🏿‍♀️",
				x: 52,
				y: 56
			}
		],
		version: 5
	},
	genie: {
		id: "genie",
		name: "Genie",
		keywords: [
			"magical",
			"wishes"
		],
		skins: [
			{
				unified: "1f9de",
				native: "🧞",
				x: 53,
				y: 10
			}
		],
		version: 5
	},
	male_genie: {
		id: "male_genie",
		name: "Man Genie",
		keywords: [
			"male"
		],
		skins: [
			{
				unified: "1f9de-200d-2642-fe0f",
				native: "🧞‍♂️",
				x: 53,
				y: 9
			}
		],
		version: 5
	},
	female_genie: {
		id: "female_genie",
		name: "Woman Genie",
		keywords: [
			"female"
		],
		skins: [
			{
				unified: "1f9de-200d-2640-fe0f",
				native: "🧞‍♀️",
				x: 53,
				y: 8
			}
		],
		version: 5
	},
	zombie: {
		id: "zombie",
		name: "Zombie",
		keywords: [
			"dead"
		],
		skins: [
			{
				unified: "1f9df",
				native: "🧟",
				x: 53,
				y: 13
			}
		],
		version: 5
	},
	male_zombie: {
		id: "male_zombie",
		name: "Man Zombie",
		keywords: [
			"male",
			"dracula",
			"undead",
			"walking",
			"dead"
		],
		skins: [
			{
				unified: "1f9df-200d-2642-fe0f",
				native: "🧟‍♂️",
				x: 53,
				y: 12
			}
		],
		version: 5
	},
	female_zombie: {
		id: "female_zombie",
		name: "Woman Zombie",
		keywords: [
			"female",
			"undead",
			"walking",
			"dead"
		],
		skins: [
			{
				unified: "1f9df-200d-2640-fe0f",
				native: "🧟‍♀️",
				x: 53,
				y: 11
			}
		],
		version: 5
	},
	troll: {
		id: "troll",
		name: "Troll",
		keywords: [
			"mystical",
			"monster"
		],
		skins: [
			{
				unified: "1f9cc",
				native: "🧌",
				x: 46,
				y: 17
			}
		],
		version: 14
	},
	massage: {
		id: "massage",
		name: "Face Massage",
		keywords: [
			"person",
			"getting",
			"relax"
		],
		skins: [
			{
				unified: "1f486",
				native: "💆",
				x: 26,
				y: 10
			},
			{
				unified: "1f486-1f3fb",
				native: "💆🏻",
				x: 26,
				y: 11
			},
			{
				unified: "1f486-1f3fc",
				native: "💆🏼",
				x: 26,
				y: 12
			},
			{
				unified: "1f486-1f3fd",
				native: "💆🏽",
				x: 26,
				y: 13
			},
			{
				unified: "1f486-1f3fe",
				native: "💆🏾",
				x: 26,
				y: 14
			},
			{
				unified: "1f486-1f3ff",
				native: "💆🏿",
				x: 26,
				y: 15
			}
		],
		version: 1
	},
	"man-getting-massage": {
		id: "man-getting-massage",
		name: "Man Getting Massage",
		keywords: [
			"getting-massage",
			"male",
			"boy",
			"head"
		],
		skins: [
			{
				unified: "1f486-200d-2642-fe0f",
				native: "💆‍♂️",
				x: 26,
				y: 4
			},
			{
				unified: "1f486-1f3fb-200d-2642-fe0f",
				native: "💆🏻‍♂️",
				x: 26,
				y: 5
			},
			{
				unified: "1f486-1f3fc-200d-2642-fe0f",
				native: "💆🏼‍♂️",
				x: 26,
				y: 6
			},
			{
				unified: "1f486-1f3fd-200d-2642-fe0f",
				native: "💆🏽‍♂️",
				x: 26,
				y: 7
			},
			{
				unified: "1f486-1f3fe-200d-2642-fe0f",
				native: "💆🏾‍♂️",
				x: 26,
				y: 8
			},
			{
				unified: "1f486-1f3ff-200d-2642-fe0f",
				native: "💆🏿‍♂️",
				x: 26,
				y: 9
			}
		],
		version: 4
	},
	"woman-getting-massage": {
		id: "woman-getting-massage",
		name: "Woman Getting Massage",
		keywords: [
			"getting-massage",
			"female",
			"girl",
			"head"
		],
		skins: [
			{
				unified: "1f486-200d-2640-fe0f",
				native: "💆‍♀️",
				x: 25,
				y: 59
			},
			{
				unified: "1f486-1f3fb-200d-2640-fe0f",
				native: "💆🏻‍♀️",
				x: 25,
				y: 60
			},
			{
				unified: "1f486-1f3fc-200d-2640-fe0f",
				native: "💆🏼‍♀️",
				x: 26,
				y: 0
			},
			{
				unified: "1f486-1f3fd-200d-2640-fe0f",
				native: "💆🏽‍♀️",
				x: 26,
				y: 1
			},
			{
				unified: "1f486-1f3fe-200d-2640-fe0f",
				native: "💆🏾‍♀️",
				x: 26,
				y: 2
			},
			{
				unified: "1f486-1f3ff-200d-2640-fe0f",
				native: "💆🏿‍♀️",
				x: 26,
				y: 3
			}
		],
		version: 4
	},
	haircut: {
		id: "haircut",
		name: "Haircut",
		keywords: [
			"person",
			"getting",
			"hairstyle"
		],
		skins: [
			{
				unified: "1f487",
				native: "💇",
				x: 26,
				y: 28
			},
			{
				unified: "1f487-1f3fb",
				native: "💇🏻",
				x: 26,
				y: 29
			},
			{
				unified: "1f487-1f3fc",
				native: "💇🏼",
				x: 26,
				y: 30
			},
			{
				unified: "1f487-1f3fd",
				native: "💇🏽",
				x: 26,
				y: 31
			},
			{
				unified: "1f487-1f3fe",
				native: "💇🏾",
				x: 26,
				y: 32
			},
			{
				unified: "1f487-1f3ff",
				native: "💇🏿",
				x: 26,
				y: 33
			}
		],
		version: 1
	},
	"man-getting-haircut": {
		id: "man-getting-haircut",
		name: "Man Getting Haircut",
		keywords: [
			"getting-haircut",
			"male",
			"boy"
		],
		skins: [
			{
				unified: "1f487-200d-2642-fe0f",
				native: "💇‍♂️",
				x: 26,
				y: 22
			},
			{
				unified: "1f487-1f3fb-200d-2642-fe0f",
				native: "💇🏻‍♂️",
				x: 26,
				y: 23
			},
			{
				unified: "1f487-1f3fc-200d-2642-fe0f",
				native: "💇🏼‍♂️",
				x: 26,
				y: 24
			},
			{
				unified: "1f487-1f3fd-200d-2642-fe0f",
				native: "💇🏽‍♂️",
				x: 26,
				y: 25
			},
			{
				unified: "1f487-1f3fe-200d-2642-fe0f",
				native: "💇🏾‍♂️",
				x: 26,
				y: 26
			},
			{
				unified: "1f487-1f3ff-200d-2642-fe0f",
				native: "💇🏿‍♂️",
				x: 26,
				y: 27
			}
		],
		version: 4
	},
	"woman-getting-haircut": {
		id: "woman-getting-haircut",
		name: "Woman Getting Haircut",
		keywords: [
			"getting-haircut",
			"female",
			"girl"
		],
		skins: [
			{
				unified: "1f487-200d-2640-fe0f",
				native: "💇‍♀️",
				x: 26,
				y: 16
			},
			{
				unified: "1f487-1f3fb-200d-2640-fe0f",
				native: "💇🏻‍♀️",
				x: 26,
				y: 17
			},
			{
				unified: "1f487-1f3fc-200d-2640-fe0f",
				native: "💇🏼‍♀️",
				x: 26,
				y: 18
			},
			{
				unified: "1f487-1f3fd-200d-2640-fe0f",
				native: "💇🏽‍♀️",
				x: 26,
				y: 19
			},
			{
				unified: "1f487-1f3fe-200d-2640-fe0f",
				native: "💇🏾‍♀️",
				x: 26,
				y: 20
			},
			{
				unified: "1f487-1f3ff-200d-2640-fe0f",
				native: "💇🏿‍♀️",
				x: 26,
				y: 21
			}
		],
		version: 4
	},
	walking: {
		id: "walking",
		name: "Pedestrian",
		keywords: [
			"walking",
			"person",
			"move"
		],
		skins: [
			{
				unified: "1f6b6",
				native: "🚶",
				x: 37,
				y: 27
			},
			{
				unified: "1f6b6-1f3fb",
				native: "🚶🏻",
				x: 37,
				y: 28
			},
			{
				unified: "1f6b6-1f3fc",
				native: "🚶🏼",
				x: 37,
				y: 29
			},
			{
				unified: "1f6b6-1f3fd",
				native: "🚶🏽",
				x: 37,
				y: 30
			},
			{
				unified: "1f6b6-1f3fe",
				native: "🚶🏾",
				x: 37,
				y: 31
			},
			{
				unified: "1f6b6-1f3ff",
				native: "🚶🏿",
				x: 37,
				y: 32
			}
		],
		version: 1
	},
	"man-walking": {
		id: "man-walking",
		name: "Man Walking",
		keywords: [
			"human",
			"feet",
			"steps"
		],
		skins: [
			{
				unified: "1f6b6-200d-2642-fe0f",
				native: "🚶‍♂️",
				x: 37,
				y: 21
			},
			{
				unified: "1f6b6-1f3fb-200d-2642-fe0f",
				native: "🚶🏻‍♂️",
				x: 37,
				y: 22
			},
			{
				unified: "1f6b6-1f3fc-200d-2642-fe0f",
				native: "🚶🏼‍♂️",
				x: 37,
				y: 23
			},
			{
				unified: "1f6b6-1f3fd-200d-2642-fe0f",
				native: "🚶🏽‍♂️",
				x: 37,
				y: 24
			},
			{
				unified: "1f6b6-1f3fe-200d-2642-fe0f",
				native: "🚶🏾‍♂️",
				x: 37,
				y: 25
			},
			{
				unified: "1f6b6-1f3ff-200d-2642-fe0f",
				native: "🚶🏿‍♂️",
				x: 37,
				y: 26
			}
		],
		version: 4
	},
	"woman-walking": {
		id: "woman-walking",
		name: "Woman Walking",
		keywords: [
			"human",
			"feet",
			"steps",
			"female"
		],
		skins: [
			{
				unified: "1f6b6-200d-2640-fe0f",
				native: "🚶‍♀️",
				x: 37,
				y: 15
			},
			{
				unified: "1f6b6-1f3fb-200d-2640-fe0f",
				native: "🚶🏻‍♀️",
				x: 37,
				y: 16
			},
			{
				unified: "1f6b6-1f3fc-200d-2640-fe0f",
				native: "🚶🏼‍♀️",
				x: 37,
				y: 17
			},
			{
				unified: "1f6b6-1f3fd-200d-2640-fe0f",
				native: "🚶🏽‍♀️",
				x: 37,
				y: 18
			},
			{
				unified: "1f6b6-1f3fe-200d-2640-fe0f",
				native: "🚶🏾‍♀️",
				x: 37,
				y: 19
			},
			{
				unified: "1f6b6-1f3ff-200d-2640-fe0f",
				native: "🚶🏿‍♀️",
				x: 37,
				y: 20
			}
		],
		version: 4
	},
	standing_person: {
		id: "standing_person",
		name: "Standing Person",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd",
				native: "🧍",
				x: 46,
				y: 30
			},
			{
				unified: "1f9cd-1f3fb",
				native: "🧍🏻",
				x: 46,
				y: 31
			},
			{
				unified: "1f9cd-1f3fc",
				native: "🧍🏼",
				x: 46,
				y: 32
			},
			{
				unified: "1f9cd-1f3fd",
				native: "🧍🏽",
				x: 46,
				y: 33
			},
			{
				unified: "1f9cd-1f3fe",
				native: "🧍🏾",
				x: 46,
				y: 34
			},
			{
				unified: "1f9cd-1f3ff",
				native: "🧍🏿",
				x: 46,
				y: 35
			}
		],
		version: 12
	},
	man_standing: {
		id: "man_standing",
		name: "Man Standing",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd-200d-2642-fe0f",
				native: "🧍‍♂️",
				x: 46,
				y: 24
			},
			{
				unified: "1f9cd-1f3fb-200d-2642-fe0f",
				native: "🧍🏻‍♂️",
				x: 46,
				y: 25
			},
			{
				unified: "1f9cd-1f3fc-200d-2642-fe0f",
				native: "🧍🏼‍♂️",
				x: 46,
				y: 26
			},
			{
				unified: "1f9cd-1f3fd-200d-2642-fe0f",
				native: "🧍🏽‍♂️",
				x: 46,
				y: 27
			},
			{
				unified: "1f9cd-1f3fe-200d-2642-fe0f",
				native: "🧍🏾‍♂️",
				x: 46,
				y: 28
			},
			{
				unified: "1f9cd-1f3ff-200d-2642-fe0f",
				native: "🧍🏿‍♂️",
				x: 46,
				y: 29
			}
		],
		version: 12
	},
	woman_standing: {
		id: "woman_standing",
		name: "Woman Standing",
		keywords: [
			"still"
		],
		skins: [
			{
				unified: "1f9cd-200d-2640-fe0f",
				native: "🧍‍♀️",
				x: 46,
				y: 18
			},
			{
				unified: "1f9cd-1f3fb-200d-2640-fe0f",
				native: "🧍🏻‍♀️",
				x: 46,
				y: 19
			},
			{
				unified: "1f9cd-1f3fc-200d-2640-fe0f",
				native: "🧍🏼‍♀️",
				x: 46,
				y: 20
			},
			{
				unified: "1f9cd-1f3fd-200d-2640-fe0f",
				native: "🧍🏽‍♀️",
				x: 46,
				y: 21
			},
			{
				unified: "1f9cd-1f3fe-200d-2640-fe0f",
				native: "🧍🏾‍♀️",
				x: 46,
				y: 22
			},
			{
				unified: "1f9cd-1f3ff-200d-2640-fe0f",
				native: "🧍🏿‍♀️",
				x: 46,
				y: 23
			}
		],
		version: 12
	},
	kneeling_person: {
		id: "kneeling_person",
		name: "Kneeling Person",
		keywords: [
			"pray",
			"respectful"
		],
		skins: [
			{
				unified: "1f9ce",
				native: "🧎",
				x: 46,
				y: 48
			},
			{
				unified: "1f9ce-1f3fb",
				native: "🧎🏻",
				x: 46,
				y: 49
			},
			{
				unified: "1f9ce-1f3fc",
				native: "🧎🏼",
				x: 46,
				y: 50
			},
			{
				unified: "1f9ce-1f3fd",
				native: "🧎🏽",
				x: 46,
				y: 51
			},
			{
				unified: "1f9ce-1f3fe",
				native: "🧎🏾",
				x: 46,
				y: 52
			},
			{
				unified: "1f9ce-1f3ff",
				native: "🧎🏿",
				x: 46,
				y: 53
			}
		],
		version: 12
	},
	man_kneeling: {
		id: "man_kneeling",
		name: "Man Kneeling",
		keywords: [
			"pray",
			"respectful"
		],
		skins: [
			{
				unified: "1f9ce-200d-2642-fe0f",
				native: "🧎‍♂️",
				x: 46,
				y: 42
			},
			{
				unified: "1f9ce-1f3fb-200d-2642-fe0f",
				native: "🧎🏻‍♂️",
				x: 46,
				y: 43
			},
			{
				unified: "1f9ce-1f3fc-200d-2642-fe0f",
				native: "🧎🏼‍♂️",
				x: 46,
				y: 44
			},
			{
				unified: "1f9ce-1f3fd-200d-2642-fe0f",
				native: "🧎🏽‍♂️",
				x: 46,
				y: 45
			},
			{
				unified: "1f9ce-1f3fe-200d-2642-fe0f",
				native: "🧎🏾‍♂️",
				x: 46,
				y: 46
			},
			{
				unified: "1f9ce-1f3ff-200d-2642-fe0f",
				native: "🧎🏿‍♂️",
				x: 46,
				y: 47
			}
		],
		version: 12
	},
	woman_kneeling: {
		id: "woman_kneeling",
		name: "Woman Kneeling",
		keywords: [
			"respectful",
			"pray"
		],
		skins: [
			{
				unified: "1f9ce-200d-2640-fe0f",
				native: "🧎‍♀️",
				x: 46,
				y: 36
			},
			{
				unified: "1f9ce-1f3fb-200d-2640-fe0f",
				native: "🧎🏻‍♀️",
				x: 46,
				y: 37
			},
			{
				unified: "1f9ce-1f3fc-200d-2640-fe0f",
				native: "🧎🏼‍♀️",
				x: 46,
				y: 38
			},
			{
				unified: "1f9ce-1f3fd-200d-2640-fe0f",
				native: "🧎🏽‍♀️",
				x: 46,
				y: 39
			},
			{
				unified: "1f9ce-1f3fe-200d-2640-fe0f",
				native: "🧎🏾‍♀️",
				x: 46,
				y: 40
			},
			{
				unified: "1f9ce-1f3ff-200d-2640-fe0f",
				native: "🧎🏿‍♀️",
				x: 46,
				y: 41
			}
		],
		version: 12
	},
	person_with_probing_cane: {
		id: "person_with_probing_cane",
		name: "Person with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9af",
				native: "🧑‍🦯",
				x: 49,
				y: 6
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9af",
				native: "🧑🏻‍🦯",
				x: 49,
				y: 7
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9af",
				native: "🧑🏼‍🦯",
				x: 49,
				y: 8
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9af",
				native: "🧑🏽‍🦯",
				x: 49,
				y: 9
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9af",
				native: "🧑🏾‍🦯",
				x: 49,
				y: 10
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9af",
				native: "🧑🏿‍🦯",
				x: 49,
				y: 11
			}
		],
		version: 12.1
	},
	man_with_probing_cane: {
		id: "man_with_probing_cane",
		name: "Man with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f468-200d-1f9af",
				native: "👨‍🦯",
				x: 15,
				y: 23
			},
			{
				unified: "1f468-1f3fb-200d-1f9af",
				native: "👨🏻‍🦯",
				x: 15,
				y: 24
			},
			{
				unified: "1f468-1f3fc-200d-1f9af",
				native: "👨🏼‍🦯",
				x: 15,
				y: 25
			},
			{
				unified: "1f468-1f3fd-200d-1f9af",
				native: "👨🏽‍🦯",
				x: 15,
				y: 26
			},
			{
				unified: "1f468-1f3fe-200d-1f9af",
				native: "👨🏾‍🦯",
				x: 15,
				y: 27
			},
			{
				unified: "1f468-1f3ff-200d-1f9af",
				native: "👨🏿‍🦯",
				x: 15,
				y: 28
			}
		],
		version: 12
	},
	woman_with_probing_cane: {
		id: "woman_with_probing_cane",
		name: "Woman with White Cane",
		keywords: [
			"probing",
			"blind"
		],
		skins: [
			{
				unified: "1f469-200d-1f9af",
				native: "👩‍🦯",
				x: 18,
				y: 52
			},
			{
				unified: "1f469-1f3fb-200d-1f9af",
				native: "👩🏻‍🦯",
				x: 18,
				y: 53
			},
			{
				unified: "1f469-1f3fc-200d-1f9af",
				native: "👩🏼‍🦯",
				x: 18,
				y: 54
			},
			{
				unified: "1f469-1f3fd-200d-1f9af",
				native: "👩🏽‍🦯",
				x: 18,
				y: 55
			},
			{
				unified: "1f469-1f3fe-200d-1f9af",
				native: "👩🏾‍🦯",
				x: 18,
				y: 56
			},
			{
				unified: "1f469-1f3ff-200d-1f9af",
				native: "👩🏿‍🦯",
				x: 18,
				y: 57
			}
		],
		version: 12
	},
	person_in_motorized_wheelchair: {
		id: "person_in_motorized_wheelchair",
		name: "Person in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9bc",
				native: "🧑‍🦼",
				x: 49,
				y: 36
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9bc",
				native: "🧑🏻‍🦼",
				x: 49,
				y: 37
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9bc",
				native: "🧑🏼‍🦼",
				x: 49,
				y: 38
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9bc",
				native: "🧑🏽‍🦼",
				x: 49,
				y: 39
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9bc",
				native: "🧑🏾‍🦼",
				x: 49,
				y: 40
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9bc",
				native: "🧑🏿‍🦼",
				x: 49,
				y: 41
			}
		],
		version: 12.1
	},
	man_in_motorized_wheelchair: {
		id: "man_in_motorized_wheelchair",
		name: "Man in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f468-200d-1f9bc",
				native: "👨‍🦼",
				x: 15,
				y: 53
			},
			{
				unified: "1f468-1f3fb-200d-1f9bc",
				native: "👨🏻‍🦼",
				x: 15,
				y: 54
			},
			{
				unified: "1f468-1f3fc-200d-1f9bc",
				native: "👨🏼‍🦼",
				x: 15,
				y: 55
			},
			{
				unified: "1f468-1f3fd-200d-1f9bc",
				native: "👨🏽‍🦼",
				x: 15,
				y: 56
			},
			{
				unified: "1f468-1f3fe-200d-1f9bc",
				native: "👨🏾‍🦼",
				x: 15,
				y: 57
			},
			{
				unified: "1f468-1f3ff-200d-1f9bc",
				native: "👨🏿‍🦼",
				x: 15,
				y: 58
			}
		],
		version: 12
	},
	woman_in_motorized_wheelchair: {
		id: "woman_in_motorized_wheelchair",
		name: "Woman in Motorized Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f469-200d-1f9bc",
				native: "👩‍🦼",
				x: 19,
				y: 21
			},
			{
				unified: "1f469-1f3fb-200d-1f9bc",
				native: "👩🏻‍🦼",
				x: 19,
				y: 22
			},
			{
				unified: "1f469-1f3fc-200d-1f9bc",
				native: "👩🏼‍🦼",
				x: 19,
				y: 23
			},
			{
				unified: "1f469-1f3fd-200d-1f9bc",
				native: "👩🏽‍🦼",
				x: 19,
				y: 24
			},
			{
				unified: "1f469-1f3fe-200d-1f9bc",
				native: "👩🏾‍🦼",
				x: 19,
				y: 25
			},
			{
				unified: "1f469-1f3ff-200d-1f9bc",
				native: "👩🏿‍🦼",
				x: 19,
				y: 26
			}
		],
		version: 12
	},
	person_in_manual_wheelchair: {
		id: "person_in_manual_wheelchair",
		name: "Person in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f9bd",
				native: "🧑‍🦽",
				x: 49,
				y: 42
			},
			{
				unified: "1f9d1-1f3fb-200d-1f9bd",
				native: "🧑🏻‍🦽",
				x: 49,
				y: 43
			},
			{
				unified: "1f9d1-1f3fc-200d-1f9bd",
				native: "🧑🏼‍🦽",
				x: 49,
				y: 44
			},
			{
				unified: "1f9d1-1f3fd-200d-1f9bd",
				native: "🧑🏽‍🦽",
				x: 49,
				y: 45
			},
			{
				unified: "1f9d1-1f3fe-200d-1f9bd",
				native: "🧑🏾‍🦽",
				x: 49,
				y: 46
			},
			{
				unified: "1f9d1-1f3ff-200d-1f9bd",
				native: "🧑🏿‍🦽",
				x: 49,
				y: 47
			}
		],
		version: 12.1
	},
	man_in_manual_wheelchair: {
		id: "man_in_manual_wheelchair",
		name: "Man in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f468-200d-1f9bd",
				native: "👨‍🦽",
				x: 15,
				y: 59
			},
			{
				unified: "1f468-1f3fb-200d-1f9bd",
				native: "👨🏻‍🦽",
				x: 15,
				y: 60
			},
			{
				unified: "1f468-1f3fc-200d-1f9bd",
				native: "👨🏼‍🦽",
				x: 16,
				y: 0
			},
			{
				unified: "1f468-1f3fd-200d-1f9bd",
				native: "👨🏽‍🦽",
				x: 16,
				y: 1
			},
			{
				unified: "1f468-1f3fe-200d-1f9bd",
				native: "👨🏾‍🦽",
				x: 16,
				y: 2
			},
			{
				unified: "1f468-1f3ff-200d-1f9bd",
				native: "👨🏿‍🦽",
				x: 16,
				y: 3
			}
		],
		version: 12
	},
	woman_in_manual_wheelchair: {
		id: "woman_in_manual_wheelchair",
		name: "Woman in Manual Wheelchair",
		keywords: [
			"disability",
			"accessibility"
		],
		skins: [
			{
				unified: "1f469-200d-1f9bd",
				native: "👩‍🦽",
				x: 19,
				y: 27
			},
			{
				unified: "1f469-1f3fb-200d-1f9bd",
				native: "👩🏻‍🦽",
				x: 19,
				y: 28
			},
			{
				unified: "1f469-1f3fc-200d-1f9bd",
				native: "👩🏼‍🦽",
				x: 19,
				y: 29
			},
			{
				unified: "1f469-1f3fd-200d-1f9bd",
				native: "👩🏽‍🦽",
				x: 19,
				y: 30
			},
			{
				unified: "1f469-1f3fe-200d-1f9bd",
				native: "👩🏾‍🦽",
				x: 19,
				y: 31
			},
			{
				unified: "1f469-1f3ff-200d-1f9bd",
				native: "👩🏿‍🦽",
				x: 19,
				y: 32
			}
		],
		version: 12
	},
	runner: {
		id: "runner",
		name: "Runner",
		keywords: [
			"running",
			"person",
			"move"
		],
		skins: [
			{
				unified: "1f3c3",
				native: "🏃",
				x: 8,
				y: 26
			},
			{
				unified: "1f3c3-1f3fb",
				native: "🏃🏻",
				x: 8,
				y: 27
			},
			{
				unified: "1f3c3-1f3fc",
				native: "🏃🏼",
				x: 8,
				y: 28
			},
			{
				unified: "1f3c3-1f3fd",
				native: "🏃🏽",
				x: 8,
				y: 29
			},
			{
				unified: "1f3c3-1f3fe",
				native: "🏃🏾",
				x: 8,
				y: 30
			},
			{
				unified: "1f3c3-1f3ff",
				native: "🏃🏿",
				x: 8,
				y: 31
			}
		],
		version: 1
	},
	"man-running": {
		id: "man-running",
		name: "Man Running",
		keywords: [
			"walking",
			"exercise",
			"race"
		],
		skins: [
			{
				unified: "1f3c3-200d-2642-fe0f",
				native: "🏃‍♂️",
				x: 8,
				y: 20
			},
			{
				unified: "1f3c3-1f3fb-200d-2642-fe0f",
				native: "🏃🏻‍♂️",
				x: 8,
				y: 21
			},
			{
				unified: "1f3c3-1f3fc-200d-2642-fe0f",
				native: "🏃🏼‍♂️",
				x: 8,
				y: 22
			},
			{
				unified: "1f3c3-1f3fd-200d-2642-fe0f",
				native: "🏃🏽‍♂️",
				x: 8,
				y: 23
			},
			{
				unified: "1f3c3-1f3fe-200d-2642-fe0f",
				native: "🏃🏾‍♂️",
				x: 8,
				y: 24
			},
			{
				unified: "1f3c3-1f3ff-200d-2642-fe0f",
				native: "🏃🏿‍♂️",
				x: 8,
				y: 25
			}
		],
		version: 4
	},
	"woman-running": {
		id: "woman-running",
		name: "Woman Running",
		keywords: [
			"walking",
			"exercise",
			"race",
			"female"
		],
		skins: [
			{
				unified: "1f3c3-200d-2640-fe0f",
				native: "🏃‍♀️",
				x: 8,
				y: 14
			},
			{
				unified: "1f3c3-1f3fb-200d-2640-fe0f",
				native: "🏃🏻‍♀️",
				x: 8,
				y: 15
			},
			{
				unified: "1f3c3-1f3fc-200d-2640-fe0f",
				native: "🏃🏼‍♀️",
				x: 8,
				y: 16
			},
			{
				unified: "1f3c3-1f3fd-200d-2640-fe0f",
				native: "🏃🏽‍♀️",
				x: 8,
				y: 17
			},
			{
				unified: "1f3c3-1f3fe-200d-2640-fe0f",
				native: "🏃🏾‍♀️",
				x: 8,
				y: 18
			},
			{
				unified: "1f3c3-1f3ff-200d-2640-fe0f",
				native: "🏃🏿‍♀️",
				x: 8,
				y: 19
			}
		],
		version: 4
	},
	dancer: {
		id: "dancer",
		name: "Dancer",
		keywords: [
			"woman",
			"dancing",
			"female",
			"girl",
			"fun"
		],
		skins: [
			{
				unified: "1f483",
				native: "💃",
				x: 25,
				y: 46
			},
			{
				unified: "1f483-1f3fb",
				native: "💃🏻",
				x: 25,
				y: 47
			},
			{
				unified: "1f483-1f3fc",
				native: "💃🏼",
				x: 25,
				y: 48
			},
			{
				unified: "1f483-1f3fd",
				native: "💃🏽",
				x: 25,
				y: 49
			},
			{
				unified: "1f483-1f3fe",
				native: "💃🏾",
				x: 25,
				y: 50
			},
			{
				unified: "1f483-1f3ff",
				native: "💃🏿",
				x: 25,
				y: 51
			}
		],
		version: 1
	},
	man_dancing: {
		id: "man_dancing",
		name: "Man Dancing",
		keywords: [
			"male",
			"boy",
			"fun",
			"dancer"
		],
		skins: [
			{
				unified: "1f57a",
				native: "🕺",
				x: 31,
				y: 26
			},
			{
				unified: "1f57a-1f3fb",
				native: "🕺🏻",
				x: 31,
				y: 27
			},
			{
				unified: "1f57a-1f3fc",
				native: "🕺🏼",
				x: 31,
				y: 28
			},
			{
				unified: "1f57a-1f3fd",
				native: "🕺🏽",
				x: 31,
				y: 29
			},
			{
				unified: "1f57a-1f3fe",
				native: "🕺🏾",
				x: 31,
				y: 30
			},
			{
				unified: "1f57a-1f3ff",
				native: "🕺🏿",
				x: 31,
				y: 31
			}
		],
		version: 3
	},
	man_in_business_suit_levitating: {
		id: "man_in_business_suit_levitating",
		name: "Person in Suit Levitating",
		keywords: [
			"man",
			"business",
			"levitate",
			"hover",
			"jump"
		],
		skins: [
			{
				unified: "1f574-fe0f",
				native: "🕴️",
				x: 30,
				y: 59
			},
			{
				unified: "1f574-1f3fb",
				native: "🕴🏻",
				x: 30,
				y: 60
			},
			{
				unified: "1f574-1f3fc",
				native: "🕴🏼",
				x: 31,
				y: 0
			},
			{
				unified: "1f574-1f3fd",
				native: "🕴🏽",
				x: 31,
				y: 1
			},
			{
				unified: "1f574-1f3fe",
				native: "🕴🏾",
				x: 31,
				y: 2
			},
			{
				unified: "1f574-1f3ff",
				native: "🕴🏿",
				x: 31,
				y: 3
			}
		],
		version: 1
	},
	dancers: {
		id: "dancers",
		name: "Woman with Bunny Ears",
		keywords: [
			"dancers",
			"people",
			"perform",
			"costume"
		],
		skins: [
			{
				unified: "1f46f",
				native: "👯",
				x: 23,
				y: 16
			}
		],
		version: 1
	},
	"men-with-bunny-ears-partying": {
		id: "men-with-bunny-ears-partying",
		name: "Men with Bunny Ears",
		keywords: [
			"with-bunny-ears-partying",
			"man",
			"male",
			"boys"
		],
		skins: [
			{
				unified: "1f46f-200d-2642-fe0f",
				native: "👯‍♂️",
				x: 23,
				y: 15
			}
		],
		version: 4
	},
	"women-with-bunny-ears-partying": {
		id: "women-with-bunny-ears-partying",
		name: "Women with Bunny Ears",
		keywords: [
			"with-bunny-ears-partying",
			"woman",
			"female",
			"girls"
		],
		skins: [
			{
				unified: "1f46f-200d-2640-fe0f",
				native: "👯‍♀️",
				x: 23,
				y: 14
			}
		],
		version: 4
	},
	person_in_steamy_room: {
		id: "person_in_steamy_room",
		name: "Person in Steamy Room",
		keywords: [
			"relax",
			"spa"
		],
		skins: [
			{
				unified: "1f9d6",
				native: "🧖",
				x: 50,
				y: 59
			},
			{
				unified: "1f9d6-1f3fb",
				native: "🧖🏻",
				x: 50,
				y: 60
			},
			{
				unified: "1f9d6-1f3fc",
				native: "🧖🏼",
				x: 51,
				y: 0
			},
			{
				unified: "1f9d6-1f3fd",
				native: "🧖🏽",
				x: 51,
				y: 1
			},
			{
				unified: "1f9d6-1f3fe",
				native: "🧖🏾",
				x: 51,
				y: 2
			},
			{
				unified: "1f9d6-1f3ff",
				native: "🧖🏿",
				x: 51,
				y: 3
			}
		],
		version: 5
	},
	man_in_steamy_room: {
		id: "man_in_steamy_room",
		name: "Man in Steamy Room",
		keywords: [
			"male",
			"spa",
			"steamroom",
			"sauna"
		],
		skins: [
			{
				unified: "1f9d6-200d-2642-fe0f",
				native: "🧖‍♂️",
				x: 50,
				y: 53
			},
			{
				unified: "1f9d6-1f3fb-200d-2642-fe0f",
				native: "🧖🏻‍♂️",
				x: 50,
				y: 54
			},
			{
				unified: "1f9d6-1f3fc-200d-2642-fe0f",
				native: "🧖🏼‍♂️",
				x: 50,
				y: 55
			},
			{
				unified: "1f9d6-1f3fd-200d-2642-fe0f",
				native: "🧖🏽‍♂️",
				x: 50,
				y: 56
			},
			{
				unified: "1f9d6-1f3fe-200d-2642-fe0f",
				native: "🧖🏾‍♂️",
				x: 50,
				y: 57
			},
			{
				unified: "1f9d6-1f3ff-200d-2642-fe0f",
				native: "🧖🏿‍♂️",
				x: 50,
				y: 58
			}
		],
		version: 5
	},
	woman_in_steamy_room: {
		id: "woman_in_steamy_room",
		name: "Woman in Steamy Room",
		keywords: [
			"female",
			"spa",
			"steamroom",
			"sauna"
		],
		skins: [
			{
				unified: "1f9d6-200d-2640-fe0f",
				native: "🧖‍♀️",
				x: 50,
				y: 47
			},
			{
				unified: "1f9d6-1f3fb-200d-2640-fe0f",
				native: "🧖🏻‍♀️",
				x: 50,
				y: 48
			},
			{
				unified: "1f9d6-1f3fc-200d-2640-fe0f",
				native: "🧖🏼‍♀️",
				x: 50,
				y: 49
			},
			{
				unified: "1f9d6-1f3fd-200d-2640-fe0f",
				native: "🧖🏽‍♀️",
				x: 50,
				y: 50
			},
			{
				unified: "1f9d6-1f3fe-200d-2640-fe0f",
				native: "🧖🏾‍♀️",
				x: 50,
				y: 51
			},
			{
				unified: "1f9d6-1f3ff-200d-2640-fe0f",
				native: "🧖🏿‍♀️",
				x: 50,
				y: 52
			}
		],
		version: 5
	},
	person_climbing: {
		id: "person_climbing",
		name: "Person Climbing",
		keywords: [
			"sport"
		],
		skins: [
			{
				unified: "1f9d7",
				native: "🧗",
				x: 51,
				y: 16
			},
			{
				unified: "1f9d7-1f3fb",
				native: "🧗🏻",
				x: 51,
				y: 17
			},
			{
				unified: "1f9d7-1f3fc",
				native: "🧗🏼",
				x: 51,
				y: 18
			},
			{
				unified: "1f9d7-1f3fd",
				native: "🧗🏽",
				x: 51,
				y: 19
			},
			{
				unified: "1f9d7-1f3fe",
				native: "🧗🏾",
				x: 51,
				y: 20
			},
			{
				unified: "1f9d7-1f3ff",
				native: "🧗🏿",
				x: 51,
				y: 21
			}
		],
		version: 5
	},
	man_climbing: {
		id: "man_climbing",
		name: "Man Climbing",
		keywords: [
			"sports",
			"hobby",
			"male",
			"rock"
		],
		skins: [
			{
				unified: "1f9d7-200d-2642-fe0f",
				native: "🧗‍♂️",
				x: 51,
				y: 10
			},
			{
				unified: "1f9d7-1f3fb-200d-2642-fe0f",
				native: "🧗🏻‍♂️",
				x: 51,
				y: 11
			},
			{
				unified: "1f9d7-1f3fc-200d-2642-fe0f",
				native: "🧗🏼‍♂️",
				x: 51,
				y: 12
			},
			{
				unified: "1f9d7-1f3fd-200d-2642-fe0f",
				native: "🧗🏽‍♂️",
				x: 51,
				y: 13
			},
			{
				unified: "1f9d7-1f3fe-200d-2642-fe0f",
				native: "🧗🏾‍♂️",
				x: 51,
				y: 14
			},
			{
				unified: "1f9d7-1f3ff-200d-2642-fe0f",
				native: "🧗🏿‍♂️",
				x: 51,
				y: 15
			}
		],
		version: 5
	},
	woman_climbing: {
		id: "woman_climbing",
		name: "Woman Climbing",
		keywords: [
			"sports",
			"hobby",
			"female",
			"rock"
		],
		skins: [
			{
				unified: "1f9d7-200d-2640-fe0f",
				native: "🧗‍♀️",
				x: 51,
				y: 4
			},
			{
				unified: "1f9d7-1f3fb-200d-2640-fe0f",
				native: "🧗🏻‍♀️",
				x: 51,
				y: 5
			},
			{
				unified: "1f9d7-1f3fc-200d-2640-fe0f",
				native: "🧗🏼‍♀️",
				x: 51,
				y: 6
			},
			{
				unified: "1f9d7-1f3fd-200d-2640-fe0f",
				native: "🧗🏽‍♀️",
				x: 51,
				y: 7
			},
			{
				unified: "1f9d7-1f3fe-200d-2640-fe0f",
				native: "🧗🏾‍♀️",
				x: 51,
				y: 8
			},
			{
				unified: "1f9d7-1f3ff-200d-2640-fe0f",
				native: "🧗🏿‍♀️",
				x: 51,
				y: 9
			}
		],
		version: 5
	},
	fencer: {
		id: "fencer",
		name: "Fencer",
		keywords: [
			"person",
			"fencing",
			"sports",
			"sword"
		],
		skins: [
			{
				unified: "1f93a",
				native: "🤺",
				x: 42,
				y: 31
			}
		],
		version: 3
	},
	horse_racing: {
		id: "horse_racing",
		name: "Horse Racing",
		keywords: [
			"animal",
			"betting",
			"competition",
			"gambling",
			"luck"
		],
		skins: [
			{
				unified: "1f3c7",
				native: "🏇",
				x: 8,
				y: 52
			},
			{
				unified: "1f3c7-1f3fb",
				native: "🏇🏻",
				x: 8,
				y: 53
			},
			{
				unified: "1f3c7-1f3fc",
				native: "🏇🏼",
				x: 8,
				y: 54
			},
			{
				unified: "1f3c7-1f3fd",
				native: "🏇🏽",
				x: 8,
				y: 55
			},
			{
				unified: "1f3c7-1f3fe",
				native: "🏇🏾",
				x: 8,
				y: 56
			},
			{
				unified: "1f3c7-1f3ff",
				native: "🏇🏿",
				x: 8,
				y: 57
			}
		],
		version: 1
	},
	skier: {
		id: "skier",
		name: "Skier",
		keywords: [
			"sports",
			"winter",
			"snow"
		],
		skins: [
			{
				unified: "26f7-fe0f",
				native: "⛷️",
				x: 58,
				y: 1
			}
		],
		version: 1
	},
	snowboarder: {
		id: "snowboarder",
		name: "Snowboarder",
		keywords: [
			"sports",
			"winter"
		],
		skins: [
			{
				unified: "1f3c2",
				native: "🏂",
				x: 8,
				y: 8
			},
			{
				unified: "1f3c2-1f3fb",
				native: "🏂🏻",
				x: 8,
				y: 9
			},
			{
				unified: "1f3c2-1f3fc",
				native: "🏂🏼",
				x: 8,
				y: 10
			},
			{
				unified: "1f3c2-1f3fd",
				native: "🏂🏽",
				x: 8,
				y: 11
			},
			{
				unified: "1f3c2-1f3fe",
				native: "🏂🏾",
				x: 8,
				y: 12
			},
			{
				unified: "1f3c2-1f3ff",
				native: "🏂🏿",
				x: 8,
				y: 13
			}
		],
		version: 1
	},
	golfer: {
		id: "golfer",
		name: "Person Golfing",
		keywords: [
			"golfer",
			"sports",
			"business"
		],
		skins: [
			{
				unified: "1f3cc-fe0f",
				native: "🏌️",
				x: 9,
				y: 47
			},
			{
				unified: "1f3cc-1f3fb",
				native: "🏌🏻",
				x: 9,
				y: 48
			},
			{
				unified: "1f3cc-1f3fc",
				native: "🏌🏼",
				x: 9,
				y: 49
			},
			{
				unified: "1f3cc-1f3fd",
				native: "🏌🏽",
				x: 9,
				y: 50
			},
			{
				unified: "1f3cc-1f3fe",
				native: "🏌🏾",
				x: 9,
				y: 51
			},
			{
				unified: "1f3cc-1f3ff",
				native: "🏌🏿",
				x: 9,
				y: 52
			}
		],
		version: 1
	},
	"man-golfing": {
		id: "man-golfing",
		name: "Man Golfing",
		keywords: [
			"sport"
		],
		skins: [
			{
				unified: "1f3cc-fe0f-200d-2642-fe0f",
				native: "🏌️‍♂️",
				x: 9,
				y: 41
			},
			{
				unified: "1f3cc-1f3fb-200d-2642-fe0f",
				native: "🏌🏻‍♂️",
				x: 9,
				y: 42
			},
			{
				unified: "1f3cc-1f3fc-200d-2642-fe0f",
				native: "🏌🏼‍♂️",
				x: 9,
				y: 43
			},
			{
				unified: "1f3cc-1f3fd-200d-2642-fe0f",
				native: "🏌🏽‍♂️",
				x: 9,
				y: 44
			},
			{
				unified: "1f3cc-1f3fe-200d-2642-fe0f",
				native: "🏌🏾‍♂️",
				x: 9,
				y: 45
			},
			{
				unified: "1f3cc-1f3ff-200d-2642-fe0f",
				native: "🏌🏿‍♂️",
				x: 9,
				y: 46
			}
		],
		version: 4
	},
	"woman-golfing": {
		id: "woman-golfing",
		name: "Woman Golfing",
		keywords: [
			"sports",
			"business",
			"female"
		],
		skins: [
			{
				unified: "1f3cc-fe0f-200d-2640-fe0f",
				native: "🏌️‍♀️",
				x: 9,
				y: 35
			},
			{
				unified: "1f3cc-1f3fb-200d-2640-fe0f",
				native: "🏌🏻‍♀️",
				x: 9,
				y: 36
			},
			{
				unified: "1f3cc-1f3fc-200d-2640-fe0f",
				native: "🏌🏼‍♀️",
				x: 9,
				y: 37
			},
			{
				unified: "1f3cc-1f3fd-200d-2640-fe0f",
				native: "🏌🏽‍♀️",
				x: 9,
				y: 38
			},
			{
				unified: "1f3cc-1f3fe-200d-2640-fe0f",
				native: "🏌🏾‍♀️",
				x: 9,
				y: 39
			},
			{
				unified: "1f3cc-1f3ff-200d-2640-fe0f",
				native: "🏌🏿‍♀️",
				x: 9,
				y: 40
			}
		],
		version: 4
	},
	surfer: {
		id: "surfer",
		name: "Surfer",
		keywords: [
			"person",
			"surfing",
			"sport",
			"sea"
		],
		skins: [
			{
				unified: "1f3c4",
				native: "🏄",
				x: 8,
				y: 44
			},
			{
				unified: "1f3c4-1f3fb",
				native: "🏄🏻",
				x: 8,
				y: 45
			},
			{
				unified: "1f3c4-1f3fc",
				native: "🏄🏼",
				x: 8,
				y: 46
			},
			{
				unified: "1f3c4-1f3fd",
				native: "🏄🏽",
				x: 8,
				y: 47
			},
			{
				unified: "1f3c4-1f3fe",
				native: "🏄🏾",
				x: 8,
				y: 48
			},
			{
				unified: "1f3c4-1f3ff",
				native: "🏄🏿",
				x: 8,
				y: 49
			}
		],
		version: 1
	},
	"man-surfing": {
		id: "man-surfing",
		name: "Man Surfing",
		keywords: [
			"sports",
			"ocean",
			"sea",
			"summer",
			"beach"
		],
		skins: [
			{
				unified: "1f3c4-200d-2642-fe0f",
				native: "🏄‍♂️",
				x: 8,
				y: 38
			},
			{
				unified: "1f3c4-1f3fb-200d-2642-fe0f",
				native: "🏄🏻‍♂️",
				x: 8,
				y: 39
			},
			{
				unified: "1f3c4-1f3fc-200d-2642-fe0f",
				native: "🏄🏼‍♂️",
				x: 8,
				y: 40
			},
			{
				unified: "1f3c4-1f3fd-200d-2642-fe0f",
				native: "🏄🏽‍♂️",
				x: 8,
				y: 41
			},
			{
				unified: "1f3c4-1f3fe-200d-2642-fe0f",
				native: "🏄🏾‍♂️",
				x: 8,
				y: 42
			},
			{
				unified: "1f3c4-1f3ff-200d-2642-fe0f",
				native: "🏄🏿‍♂️",
				x: 8,
				y: 43
			}
		],
		version: 4
	},
	"woman-surfing": {
		id: "woman-surfing",
		name: "Woman Surfing",
		keywords: [
			"sports",
			"ocean",
			"sea",
			"summer",
			"beach",
			"female"
		],
		skins: [
			{
				unified: "1f3c4-200d-2640-fe0f",
				native: "🏄‍♀️",
				x: 8,
				y: 32
			},
			{
				unified: "1f3c4-1f3fb-200d-2640-fe0f",
				native: "🏄🏻‍♀️",
				x: 8,
				y: 33
			},
			{
				unified: "1f3c4-1f3fc-200d-2640-fe0f",
				native: "🏄🏼‍♀️",
				x: 8,
				y: 34
			},
			{
				unified: "1f3c4-1f3fd-200d-2640-fe0f",
				native: "🏄🏽‍♀️",
				x: 8,
				y: 35
			},
			{
				unified: "1f3c4-1f3fe-200d-2640-fe0f",
				native: "🏄🏾‍♀️",
				x: 8,
				y: 36
			},
			{
				unified: "1f3c4-1f3ff-200d-2640-fe0f",
				native: "🏄🏿‍♀️",
				x: 8,
				y: 37
			}
		],
		version: 4
	},
	rowboat: {
		id: "rowboat",
		name: "Rowboat",
		keywords: [
			"person",
			"rowing",
			"boat",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6a3",
				native: "🚣",
				x: 36,
				y: 18
			},
			{
				unified: "1f6a3-1f3fb",
				native: "🚣🏻",
				x: 36,
				y: 19
			},
			{
				unified: "1f6a3-1f3fc",
				native: "🚣🏼",
				x: 36,
				y: 20
			},
			{
				unified: "1f6a3-1f3fd",
				native: "🚣🏽",
				x: 36,
				y: 21
			},
			{
				unified: "1f6a3-1f3fe",
				native: "🚣🏾",
				x: 36,
				y: 22
			},
			{
				unified: "1f6a3-1f3ff",
				native: "🚣🏿",
				x: 36,
				y: 23
			}
		],
		version: 1
	},
	"man-rowing-boat": {
		id: "man-rowing-boat",
		name: "Man Rowing Boat",
		keywords: [
			"rowing-boat",
			"sports",
			"hobby",
			"water",
			"ship"
		],
		skins: [
			{
				unified: "1f6a3-200d-2642-fe0f",
				native: "🚣‍♂️",
				x: 36,
				y: 12
			},
			{
				unified: "1f6a3-1f3fb-200d-2642-fe0f",
				native: "🚣🏻‍♂️",
				x: 36,
				y: 13
			},
			{
				unified: "1f6a3-1f3fc-200d-2642-fe0f",
				native: "🚣🏼‍♂️",
				x: 36,
				y: 14
			},
			{
				unified: "1f6a3-1f3fd-200d-2642-fe0f",
				native: "🚣🏽‍♂️",
				x: 36,
				y: 15
			},
			{
				unified: "1f6a3-1f3fe-200d-2642-fe0f",
				native: "🚣🏾‍♂️",
				x: 36,
				y: 16
			},
			{
				unified: "1f6a3-1f3ff-200d-2642-fe0f",
				native: "🚣🏿‍♂️",
				x: 36,
				y: 17
			}
		],
		version: 4
	},
	"woman-rowing-boat": {
		id: "woman-rowing-boat",
		name: "Woman Rowing Boat",
		keywords: [
			"rowing-boat",
			"sports",
			"hobby",
			"water",
			"ship",
			"female"
		],
		skins: [
			{
				unified: "1f6a3-200d-2640-fe0f",
				native: "🚣‍♀️",
				x: 36,
				y: 6
			},
			{
				unified: "1f6a3-1f3fb-200d-2640-fe0f",
				native: "🚣🏻‍♀️",
				x: 36,
				y: 7
			},
			{
				unified: "1f6a3-1f3fc-200d-2640-fe0f",
				native: "🚣🏼‍♀️",
				x: 36,
				y: 8
			},
			{
				unified: "1f6a3-1f3fd-200d-2640-fe0f",
				native: "🚣🏽‍♀️",
				x: 36,
				y: 9
			},
			{
				unified: "1f6a3-1f3fe-200d-2640-fe0f",
				native: "🚣🏾‍♀️",
				x: 36,
				y: 10
			},
			{
				unified: "1f6a3-1f3ff-200d-2640-fe0f",
				native: "🚣🏿‍♀️",
				x: 36,
				y: 11
			}
		],
		version: 4
	},
	swimmer: {
		id: "swimmer",
		name: "Swimmer",
		keywords: [
			"person",
			"swimming",
			"sport",
			"pool"
		],
		skins: [
			{
				unified: "1f3ca",
				native: "🏊",
				x: 9,
				y: 11
			},
			{
				unified: "1f3ca-1f3fb",
				native: "🏊🏻",
				x: 9,
				y: 12
			},
			{
				unified: "1f3ca-1f3fc",
				native: "🏊🏼",
				x: 9,
				y: 13
			},
			{
				unified: "1f3ca-1f3fd",
				native: "🏊🏽",
				x: 9,
				y: 14
			},
			{
				unified: "1f3ca-1f3fe",
				native: "🏊🏾",
				x: 9,
				y: 15
			},
			{
				unified: "1f3ca-1f3ff",
				native: "🏊🏿",
				x: 9,
				y: 16
			}
		],
		version: 1
	},
	"man-swimming": {
		id: "man-swimming",
		name: "Man Swimming",
		keywords: [
			"sports",
			"exercise",
			"human",
			"athlete",
			"water",
			"summer"
		],
		skins: [
			{
				unified: "1f3ca-200d-2642-fe0f",
				native: "🏊‍♂️",
				x: 9,
				y: 5
			},
			{
				unified: "1f3ca-1f3fb-200d-2642-fe0f",
				native: "🏊🏻‍♂️",
				x: 9,
				y: 6
			},
			{
				unified: "1f3ca-1f3fc-200d-2642-fe0f",
				native: "🏊🏼‍♂️",
				x: 9,
				y: 7
			},
			{
				unified: "1f3ca-1f3fd-200d-2642-fe0f",
				native: "🏊🏽‍♂️",
				x: 9,
				y: 8
			},
			{
				unified: "1f3ca-1f3fe-200d-2642-fe0f",
				native: "🏊🏾‍♂️",
				x: 9,
				y: 9
			},
			{
				unified: "1f3ca-1f3ff-200d-2642-fe0f",
				native: "🏊🏿‍♂️",
				x: 9,
				y: 10
			}
		],
		version: 4
	},
	"woman-swimming": {
		id: "woman-swimming",
		name: "Woman Swimming",
		keywords: [
			"sports",
			"exercise",
			"human",
			"athlete",
			"water",
			"summer",
			"female"
		],
		skins: [
			{
				unified: "1f3ca-200d-2640-fe0f",
				native: "🏊‍♀️",
				x: 8,
				y: 60
			},
			{
				unified: "1f3ca-1f3fb-200d-2640-fe0f",
				native: "🏊🏻‍♀️",
				x: 9,
				y: 0
			},
			{
				unified: "1f3ca-1f3fc-200d-2640-fe0f",
				native: "🏊🏼‍♀️",
				x: 9,
				y: 1
			},
			{
				unified: "1f3ca-1f3fd-200d-2640-fe0f",
				native: "🏊🏽‍♀️",
				x: 9,
				y: 2
			},
			{
				unified: "1f3ca-1f3fe-200d-2640-fe0f",
				native: "🏊🏾‍♀️",
				x: 9,
				y: 3
			},
			{
				unified: "1f3ca-1f3ff-200d-2640-fe0f",
				native: "🏊🏿‍♀️",
				x: 9,
				y: 4
			}
		],
		version: 4
	},
	person_with_ball: {
		id: "person_with_ball",
		name: "Person Bouncing Ball",
		keywords: [
			"with",
			"sports",
			"human"
		],
		skins: [
			{
				unified: "26f9-fe0f",
				native: "⛹️",
				x: 58,
				y: 15
			},
			{
				unified: "26f9-1f3fb",
				native: "⛹🏻",
				x: 58,
				y: 16
			},
			{
				unified: "26f9-1f3fc",
				native: "⛹🏼",
				x: 58,
				y: 17
			},
			{
				unified: "26f9-1f3fd",
				native: "⛹🏽",
				x: 58,
				y: 18
			},
			{
				unified: "26f9-1f3fe",
				native: "⛹🏾",
				x: 58,
				y: 19
			},
			{
				unified: "26f9-1f3ff",
				native: "⛹🏿",
				x: 58,
				y: 20
			}
		],
		version: 1
	},
	"man-bouncing-ball": {
		id: "man-bouncing-ball",
		name: "Man Bouncing Ball",
		keywords: [
			"bouncing-ball",
			"sport"
		],
		skins: [
			{
				unified: "26f9-fe0f-200d-2642-fe0f",
				native: "⛹️‍♂️",
				x: 58,
				y: 9
			},
			{
				unified: "26f9-1f3fb-200d-2642-fe0f",
				native: "⛹🏻‍♂️",
				x: 58,
				y: 10
			},
			{
				unified: "26f9-1f3fc-200d-2642-fe0f",
				native: "⛹🏼‍♂️",
				x: 58,
				y: 11
			},
			{
				unified: "26f9-1f3fd-200d-2642-fe0f",
				native: "⛹🏽‍♂️",
				x: 58,
				y: 12
			},
			{
				unified: "26f9-1f3fe-200d-2642-fe0f",
				native: "⛹🏾‍♂️",
				x: 58,
				y: 13
			},
			{
				unified: "26f9-1f3ff-200d-2642-fe0f",
				native: "⛹🏿‍♂️",
				x: 58,
				y: 14
			}
		],
		version: 4
	},
	"woman-bouncing-ball": {
		id: "woman-bouncing-ball",
		name: "Woman Bouncing Ball",
		keywords: [
			"bouncing-ball",
			"sports",
			"human",
			"female"
		],
		skins: [
			{
				unified: "26f9-fe0f-200d-2640-fe0f",
				native: "⛹️‍♀️",
				x: 58,
				y: 3
			},
			{
				unified: "26f9-1f3fb-200d-2640-fe0f",
				native: "⛹🏻‍♀️",
				x: 58,
				y: 4
			},
			{
				unified: "26f9-1f3fc-200d-2640-fe0f",
				native: "⛹🏼‍♀️",
				x: 58,
				y: 5
			},
			{
				unified: "26f9-1f3fd-200d-2640-fe0f",
				native: "⛹🏽‍♀️",
				x: 58,
				y: 6
			},
			{
				unified: "26f9-1f3fe-200d-2640-fe0f",
				native: "⛹🏾‍♀️",
				x: 58,
				y: 7
			},
			{
				unified: "26f9-1f3ff-200d-2640-fe0f",
				native: "⛹🏿‍♀️",
				x: 58,
				y: 8
			}
		],
		version: 4
	},
	weight_lifter: {
		id: "weight_lifter",
		name: "Person Lifting Weights",
		keywords: [
			"weight",
			"lifter",
			"sports",
			"training",
			"exercise"
		],
		skins: [
			{
				unified: "1f3cb-fe0f",
				native: "🏋️",
				x: 9,
				y: 29
			},
			{
				unified: "1f3cb-1f3fb",
				native: "🏋🏻",
				x: 9,
				y: 30
			},
			{
				unified: "1f3cb-1f3fc",
				native: "🏋🏼",
				x: 9,
				y: 31
			},
			{
				unified: "1f3cb-1f3fd",
				native: "🏋🏽",
				x: 9,
				y: 32
			},
			{
				unified: "1f3cb-1f3fe",
				native: "🏋🏾",
				x: 9,
				y: 33
			},
			{
				unified: "1f3cb-1f3ff",
				native: "🏋🏿",
				x: 9,
				y: 34
			}
		],
		version: 1
	},
	"man-lifting-weights": {
		id: "man-lifting-weights",
		name: "Man Lifting Weights",
		keywords: [
			"lifting-weights",
			"sport"
		],
		skins: [
			{
				unified: "1f3cb-fe0f-200d-2642-fe0f",
				native: "🏋️‍♂️",
				x: 9,
				y: 23
			},
			{
				unified: "1f3cb-1f3fb-200d-2642-fe0f",
				native: "🏋🏻‍♂️",
				x: 9,
				y: 24
			},
			{
				unified: "1f3cb-1f3fc-200d-2642-fe0f",
				native: "🏋🏼‍♂️",
				x: 9,
				y: 25
			},
			{
				unified: "1f3cb-1f3fd-200d-2642-fe0f",
				native: "🏋🏽‍♂️",
				x: 9,
				y: 26
			},
			{
				unified: "1f3cb-1f3fe-200d-2642-fe0f",
				native: "🏋🏾‍♂️",
				x: 9,
				y: 27
			},
			{
				unified: "1f3cb-1f3ff-200d-2642-fe0f",
				native: "🏋🏿‍♂️",
				x: 9,
				y: 28
			}
		],
		version: 4
	},
	"woman-lifting-weights": {
		id: "woman-lifting-weights",
		name: "Woman Lifting Weights",
		keywords: [
			"lifting-weights",
			"sports",
			"training",
			"exercise",
			"female"
		],
		skins: [
			{
				unified: "1f3cb-fe0f-200d-2640-fe0f",
				native: "🏋️‍♀️",
				x: 9,
				y: 17
			},
			{
				unified: "1f3cb-1f3fb-200d-2640-fe0f",
				native: "🏋🏻‍♀️",
				x: 9,
				y: 18
			},
			{
				unified: "1f3cb-1f3fc-200d-2640-fe0f",
				native: "🏋🏼‍♀️",
				x: 9,
				y: 19
			},
			{
				unified: "1f3cb-1f3fd-200d-2640-fe0f",
				native: "🏋🏽‍♀️",
				x: 9,
				y: 20
			},
			{
				unified: "1f3cb-1f3fe-200d-2640-fe0f",
				native: "🏋🏾‍♀️",
				x: 9,
				y: 21
			},
			{
				unified: "1f3cb-1f3ff-200d-2640-fe0f",
				native: "🏋🏿‍♀️",
				x: 9,
				y: 22
			}
		],
		version: 4
	},
	bicyclist: {
		id: "bicyclist",
		name: "Bicyclist",
		keywords: [
			"person",
			"biking",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6b4",
				native: "🚴",
				x: 36,
				y: 52
			},
			{
				unified: "1f6b4-1f3fb",
				native: "🚴🏻",
				x: 36,
				y: 53
			},
			{
				unified: "1f6b4-1f3fc",
				native: "🚴🏼",
				x: 36,
				y: 54
			},
			{
				unified: "1f6b4-1f3fd",
				native: "🚴🏽",
				x: 36,
				y: 55
			},
			{
				unified: "1f6b4-1f3fe",
				native: "🚴🏾",
				x: 36,
				y: 56
			},
			{
				unified: "1f6b4-1f3ff",
				native: "🚴🏿",
				x: 36,
				y: 57
			}
		],
		version: 1
	},
	"man-biking": {
		id: "man-biking",
		name: "Man Biking",
		keywords: [
			"sports",
			"bike",
			"exercise",
			"hipster"
		],
		skins: [
			{
				unified: "1f6b4-200d-2642-fe0f",
				native: "🚴‍♂️",
				x: 36,
				y: 46
			},
			{
				unified: "1f6b4-1f3fb-200d-2642-fe0f",
				native: "🚴🏻‍♂️",
				x: 36,
				y: 47
			},
			{
				unified: "1f6b4-1f3fc-200d-2642-fe0f",
				native: "🚴🏼‍♂️",
				x: 36,
				y: 48
			},
			{
				unified: "1f6b4-1f3fd-200d-2642-fe0f",
				native: "🚴🏽‍♂️",
				x: 36,
				y: 49
			},
			{
				unified: "1f6b4-1f3fe-200d-2642-fe0f",
				native: "🚴🏾‍♂️",
				x: 36,
				y: 50
			},
			{
				unified: "1f6b4-1f3ff-200d-2642-fe0f",
				native: "🚴🏿‍♂️",
				x: 36,
				y: 51
			}
		],
		version: 4
	},
	"woman-biking": {
		id: "woman-biking",
		name: "Woman Biking",
		keywords: [
			"sports",
			"bike",
			"exercise",
			"hipster",
			"female"
		],
		skins: [
			{
				unified: "1f6b4-200d-2640-fe0f",
				native: "🚴‍♀️",
				x: 36,
				y: 40
			},
			{
				unified: "1f6b4-1f3fb-200d-2640-fe0f",
				native: "🚴🏻‍♀️",
				x: 36,
				y: 41
			},
			{
				unified: "1f6b4-1f3fc-200d-2640-fe0f",
				native: "🚴🏼‍♀️",
				x: 36,
				y: 42
			},
			{
				unified: "1f6b4-1f3fd-200d-2640-fe0f",
				native: "🚴🏽‍♀️",
				x: 36,
				y: 43
			},
			{
				unified: "1f6b4-1f3fe-200d-2640-fe0f",
				native: "🚴🏾‍♀️",
				x: 36,
				y: 44
			},
			{
				unified: "1f6b4-1f3ff-200d-2640-fe0f",
				native: "🚴🏿‍♀️",
				x: 36,
				y: 45
			}
		],
		version: 4
	},
	mountain_bicyclist: {
		id: "mountain_bicyclist",
		name: "Mountain Bicyclist",
		keywords: [
			"person",
			"biking",
			"sport",
			"move"
		],
		skins: [
			{
				unified: "1f6b5",
				native: "🚵",
				x: 37,
				y: 9
			},
			{
				unified: "1f6b5-1f3fb",
				native: "🚵🏻",
				x: 37,
				y: 10
			},
			{
				unified: "1f6b5-1f3fc",
				native: "🚵🏼",
				x: 37,
				y: 11
			},
			{
				unified: "1f6b5-1f3fd",
				native: "🚵🏽",
				x: 37,
				y: 12
			},
			{
				unified: "1f6b5-1f3fe",
				native: "🚵🏾",
				x: 37,
				y: 13
			},
			{
				unified: "1f6b5-1f3ff",
				native: "🚵🏿",
				x: 37,
				y: 14
			}
		],
		version: 1
	},
	"man-mountain-biking": {
		id: "man-mountain-biking",
		name: "Man Mountain Biking",
		keywords: [
			"mountain-biking",
			"transportation",
			"sports",
			"human",
			"race",
			"bike"
		],
		skins: [
			{
				unified: "1f6b5-200d-2642-fe0f",
				native: "🚵‍♂️",
				x: 37,
				y: 3
			},
			{
				unified: "1f6b5-1f3fb-200d-2642-fe0f",
				native: "🚵🏻‍♂️",
				x: 37,
				y: 4
			},
			{
				unified: "1f6b5-1f3fc-200d-2642-fe0f",
				native: "🚵🏼‍♂️",
				x: 37,
				y: 5
			},
			{
				unified: "1f6b5-1f3fd-200d-2642-fe0f",
				native: "🚵🏽‍♂️",
				x: 37,
				y: 6
			},
			{
				unified: "1f6b5-1f3fe-200d-2642-fe0f",
				native: "🚵🏾‍♂️",
				x: 37,
				y: 7
			},
			{
				unified: "1f6b5-1f3ff-200d-2642-fe0f",
				native: "🚵🏿‍♂️",
				x: 37,
				y: 8
			}
		],
		version: 4
	},
	"woman-mountain-biking": {
		id: "woman-mountain-biking",
		name: "Woman Mountain Biking",
		keywords: [
			"mountain-biking",
			"transportation",
			"sports",
			"human",
			"race",
			"bike",
			"female"
		],
		skins: [
			{
				unified: "1f6b5-200d-2640-fe0f",
				native: "🚵‍♀️",
				x: 36,
				y: 58
			},
			{
				unified: "1f6b5-1f3fb-200d-2640-fe0f",
				native: "🚵🏻‍♀️",
				x: 36,
				y: 59
			},
			{
				unified: "1f6b5-1f3fc-200d-2640-fe0f",
				native: "🚵🏼‍♀️",
				x: 36,
				y: 60
			},
			{
				unified: "1f6b5-1f3fd-200d-2640-fe0f",
				native: "🚵🏽‍♀️",
				x: 37,
				y: 0
			},
			{
				unified: "1f6b5-1f3fe-200d-2640-fe0f",
				native: "🚵🏾‍♀️",
				x: 37,
				y: 1
			},
			{
				unified: "1f6b5-1f3ff-200d-2640-fe0f",
				native: "🚵🏿‍♀️",
				x: 37,
				y: 2
			}
		],
		version: 4
	},
	person_doing_cartwheel: {
		id: "person_doing_cartwheel",
		name: "Person Cartwheeling",
		keywords: [
			"doing",
			"cartwheel",
			"sport",
			"gymnastic"
		],
		skins: [
			{
				unified: "1f938",
				native: "🤸",
				x: 42,
				y: 7
			},
			{
				unified: "1f938-1f3fb",
				native: "🤸🏻",
				x: 42,
				y: 8
			},
			{
				unified: "1f938-1f3fc",
				native: "🤸🏼",
				x: 42,
				y: 9
			},
			{
				unified: "1f938-1f3fd",
				native: "🤸🏽",
				x: 42,
				y: 10
			},
			{
				unified: "1f938-1f3fe",
				native: "🤸🏾",
				x: 42,
				y: 11
			},
			{
				unified: "1f938-1f3ff",
				native: "🤸🏿",
				x: 42,
				y: 12
			}
		],
		version: 3
	},
	"man-cartwheeling": {
		id: "man-cartwheeling",
		name: "Man Cartwheeling",
		keywords: [
			"gymnastics"
		],
		skins: [
			{
				unified: "1f938-200d-2642-fe0f",
				native: "🤸‍♂️",
				x: 42,
				y: 1
			},
			{
				unified: "1f938-1f3fb-200d-2642-fe0f",
				native: "🤸🏻‍♂️",
				x: 42,
				y: 2
			},
			{
				unified: "1f938-1f3fc-200d-2642-fe0f",
				native: "🤸🏼‍♂️",
				x: 42,
				y: 3
			},
			{
				unified: "1f938-1f3fd-200d-2642-fe0f",
				native: "🤸🏽‍♂️",
				x: 42,
				y: 4
			},
			{
				unified: "1f938-1f3fe-200d-2642-fe0f",
				native: "🤸🏾‍♂️",
				x: 42,
				y: 5
			},
			{
				unified: "1f938-1f3ff-200d-2642-fe0f",
				native: "🤸🏿‍♂️",
				x: 42,
				y: 6
			}
		],
		version: 4
	},
	"woman-cartwheeling": {
		id: "woman-cartwheeling",
		name: "Woman Cartwheeling",
		keywords: [
			"gymnastics"
		],
		skins: [
			{
				unified: "1f938-200d-2640-fe0f",
				native: "🤸‍♀️",
				x: 41,
				y: 56
			},
			{
				unified: "1f938-1f3fb-200d-2640-fe0f",
				native: "🤸🏻‍♀️",
				x: 41,
				y: 57
			},
			{
				unified: "1f938-1f3fc-200d-2640-fe0f",
				native: "🤸🏼‍♀️",
				x: 41,
				y: 58
			},
			{
				unified: "1f938-1f3fd-200d-2640-fe0f",
				native: "🤸🏽‍♀️",
				x: 41,
				y: 59
			},
			{
				unified: "1f938-1f3fe-200d-2640-fe0f",
				native: "🤸🏾‍♀️",
				x: 41,
				y: 60
			},
			{
				unified: "1f938-1f3ff-200d-2640-fe0f",
				native: "🤸🏿‍♀️",
				x: 42,
				y: 0
			}
		],
		version: 4
	},
	wrestlers: {
		id: "wrestlers",
		name: "Wrestlers",
		keywords: [
			"people",
			"wrestling",
			"sport"
		],
		skins: [
			{
				unified: "1f93c",
				native: "🤼",
				x: 42,
				y: 34
			}
		],
		version: 3
	},
	"man-wrestling": {
		id: "man-wrestling",
		name: "Men Wrestling",
		keywords: [
			"man",
			"sports",
			"wrestlers"
		],
		skins: [
			{
				unified: "1f93c-200d-2642-fe0f",
				native: "🤼‍♂️",
				x: 42,
				y: 33
			}
		],
		version: 4
	},
	"woman-wrestling": {
		id: "woman-wrestling",
		name: "Women Wrestling",
		keywords: [
			"woman",
			"sports",
			"wrestlers"
		],
		skins: [
			{
				unified: "1f93c-200d-2640-fe0f",
				native: "🤼‍♀️",
				x: 42,
				y: 32
			}
		],
		version: 4
	},
	water_polo: {
		id: "water_polo",
		name: "Water Polo",
		keywords: [
			"person",
			"playing",
			"sport"
		],
		skins: [
			{
				unified: "1f93d",
				native: "🤽",
				x: 42,
				y: 47
			},
			{
				unified: "1f93d-1f3fb",
				native: "🤽🏻",
				x: 42,
				y: 48
			},
			{
				unified: "1f93d-1f3fc",
				native: "🤽🏼",
				x: 42,
				y: 49
			},
			{
				unified: "1f93d-1f3fd",
				native: "🤽🏽",
				x: 42,
				y: 50
			},
			{
				unified: "1f93d-1f3fe",
				native: "🤽🏾",
				x: 42,
				y: 51
			},
			{
				unified: "1f93d-1f3ff",
				native: "🤽🏿",
				x: 42,
				y: 52
			}
		],
		version: 3
	},
	"man-playing-water-polo": {
		id: "man-playing-water-polo",
		name: "Man Playing Water Polo",
		keywords: [
			"playing-water-polo",
			"sports",
			"pool"
		],
		skins: [
			{
				unified: "1f93d-200d-2642-fe0f",
				native: "🤽‍♂️",
				x: 42,
				y: 41
			},
			{
				unified: "1f93d-1f3fb-200d-2642-fe0f",
				native: "🤽🏻‍♂️",
				x: 42,
				y: 42
			},
			{
				unified: "1f93d-1f3fc-200d-2642-fe0f",
				native: "🤽🏼‍♂️",
				x: 42,
				y: 43
			},
			{
				unified: "1f93d-1f3fd-200d-2642-fe0f",
				native: "🤽🏽‍♂️",
				x: 42,
				y: 44
			},
			{
				unified: "1f93d-1f3fe-200d-2642-fe0f",
				native: "🤽🏾‍♂️",
				x: 42,
				y: 45
			},
			{
				unified: "1f93d-1f3ff-200d-2642-fe0f",
				native: "🤽🏿‍♂️",
				x: 42,
				y: 46
			}
		],
		version: 4
	},
	"woman-playing-water-polo": {
		id: "woman-playing-water-polo",
		name: "Woman Playing Water Polo",
		keywords: [
			"playing-water-polo",
			"sports",
			"pool"
		],
		skins: [
			{
				unified: "1f93d-200d-2640-fe0f",
				native: "🤽‍♀️",
				x: 42,
				y: 35
			},
			{
				unified: "1f93d-1f3fb-200d-2640-fe0f",
				native: "🤽🏻‍♀️",
				x: 42,
				y: 36
			},
			{
				unified: "1f93d-1f3fc-200d-2640-fe0f",
				native: "🤽🏼‍♀️",
				x: 42,
				y: 37
			},
			{
				unified: "1f93d-1f3fd-200d-2640-fe0f",
				native: "🤽🏽‍♀️",
				x: 42,
				y: 38
			},
			{
				unified: "1f93d-1f3fe-200d-2640-fe0f",
				native: "🤽🏾‍♀️",
				x: 42,
				y: 39
			},
			{
				unified: "1f93d-1f3ff-200d-2640-fe0f",
				native: "🤽🏿‍♀️",
				x: 42,
				y: 40
			}
		],
		version: 4
	},
	handball: {
		id: "handball",
		name: "Handball",
		keywords: [
			"person",
			"playing",
			"sport"
		],
		skins: [
			{
				unified: "1f93e",
				native: "🤾",
				x: 43,
				y: 4
			},
			{
				unified: "1f93e-1f3fb",
				native: "🤾🏻",
				x: 43,
				y: 5
			},
			{
				unified: "1f93e-1f3fc",
				native: "🤾🏼",
				x: 43,
				y: 6
			},
			{
				unified: "1f93e-1f3fd",
				native: "🤾🏽",
				x: 43,
				y: 7
			},
			{
				unified: "1f93e-1f3fe",
				native: "🤾🏾",
				x: 43,
				y: 8
			},
			{
				unified: "1f93e-1f3ff",
				native: "🤾🏿",
				x: 43,
				y: 9
			}
		],
		version: 3
	},
	"man-playing-handball": {
		id: "man-playing-handball",
		name: "Man Playing Handball",
		keywords: [
			"playing-handball",
			"sports"
		],
		skins: [
			{
				unified: "1f93e-200d-2642-fe0f",
				native: "🤾‍♂️",
				x: 42,
				y: 59
			},
			{
				unified: "1f93e-1f3fb-200d-2642-fe0f",
				native: "🤾🏻‍♂️",
				x: 42,
				y: 60
			},
			{
				unified: "1f93e-1f3fc-200d-2642-fe0f",
				native: "🤾🏼‍♂️",
				x: 43,
				y: 0
			},
			{
				unified: "1f93e-1f3fd-200d-2642-fe0f",
				native: "🤾🏽‍♂️",
				x: 43,
				y: 1
			},
			{
				unified: "1f93e-1f3fe-200d-2642-fe0f",
				native: "🤾🏾‍♂️",
				x: 43,
				y: 2
			},
			{
				unified: "1f93e-1f3ff-200d-2642-fe0f",
				native: "🤾🏿‍♂️",
				x: 43,
				y: 3
			}
		],
		version: 4
	},
	"woman-playing-handball": {
		id: "woman-playing-handball",
		name: "Woman Playing Handball",
		keywords: [
			"playing-handball",
			"sports"
		],
		skins: [
			{
				unified: "1f93e-200d-2640-fe0f",
				native: "🤾‍♀️",
				x: 42,
				y: 53
			},
			{
				unified: "1f93e-1f3fb-200d-2640-fe0f",
				native: "🤾🏻‍♀️",
				x: 42,
				y: 54
			},
			{
				unified: "1f93e-1f3fc-200d-2640-fe0f",
				native: "🤾🏼‍♀️",
				x: 42,
				y: 55
			},
			{
				unified: "1f93e-1f3fd-200d-2640-fe0f",
				native: "🤾🏽‍♀️",
				x: 42,
				y: 56
			},
			{
				unified: "1f93e-1f3fe-200d-2640-fe0f",
				native: "🤾🏾‍♀️",
				x: 42,
				y: 57
			},
			{
				unified: "1f93e-1f3ff-200d-2640-fe0f",
				native: "🤾🏿‍♀️",
				x: 42,
				y: 58
			}
		],
		version: 4
	},
	juggling: {
		id: "juggling",
		name: "Juggling",
		keywords: [
			"person",
			"performance",
			"balance"
		],
		skins: [
			{
				unified: "1f939",
				native: "🤹",
				x: 42,
				y: 25
			},
			{
				unified: "1f939-1f3fb",
				native: "🤹🏻",
				x: 42,
				y: 26
			},
			{
				unified: "1f939-1f3fc",
				native: "🤹🏼",
				x: 42,
				y: 27
			},
			{
				unified: "1f939-1f3fd",
				native: "🤹🏽",
				x: 42,
				y: 28
			},
			{
				unified: "1f939-1f3fe",
				native: "🤹🏾",
				x: 42,
				y: 29
			},
			{
				unified: "1f939-1f3ff",
				native: "🤹🏿",
				x: 42,
				y: 30
			}
		],
		version: 3
	},
	"man-juggling": {
		id: "man-juggling",
		name: "Man Juggling",
		keywords: [
			"juggle",
			"balance",
			"skill",
			"multitask"
		],
		skins: [
			{
				unified: "1f939-200d-2642-fe0f",
				native: "🤹‍♂️",
				x: 42,
				y: 19
			},
			{
				unified: "1f939-1f3fb-200d-2642-fe0f",
				native: "🤹🏻‍♂️",
				x: 42,
				y: 20
			},
			{
				unified: "1f939-1f3fc-200d-2642-fe0f",
				native: "🤹🏼‍♂️",
				x: 42,
				y: 21
			},
			{
				unified: "1f939-1f3fd-200d-2642-fe0f",
				native: "🤹🏽‍♂️",
				x: 42,
				y: 22
			},
			{
				unified: "1f939-1f3fe-200d-2642-fe0f",
				native: "🤹🏾‍♂️",
				x: 42,
				y: 23
			},
			{
				unified: "1f939-1f3ff-200d-2642-fe0f",
				native: "🤹🏿‍♂️",
				x: 42,
				y: 24
			}
		],
		version: 4
	},
	"woman-juggling": {
		id: "woman-juggling",
		name: "Woman Juggling",
		keywords: [
			"juggle",
			"balance",
			"skill",
			"multitask"
		],
		skins: [
			{
				unified: "1f939-200d-2640-fe0f",
				native: "🤹‍♀️",
				x: 42,
				y: 13
			},
			{
				unified: "1f939-1f3fb-200d-2640-fe0f",
				native: "🤹🏻‍♀️",
				x: 42,
				y: 14
			},
			{
				unified: "1f939-1f3fc-200d-2640-fe0f",
				native: "🤹🏼‍♀️",
				x: 42,
				y: 15
			},
			{
				unified: "1f939-1f3fd-200d-2640-fe0f",
				native: "🤹🏽‍♀️",
				x: 42,
				y: 16
			},
			{
				unified: "1f939-1f3fe-200d-2640-fe0f",
				native: "🤹🏾‍♀️",
				x: 42,
				y: 17
			},
			{
				unified: "1f939-1f3ff-200d-2640-fe0f",
				native: "🤹🏿‍♀️",
				x: 42,
				y: 18
			}
		],
		version: 4
	},
	person_in_lotus_position: {
		id: "person_in_lotus_position",
		name: "Person in Lotus Position",
		keywords: [
			"meditate"
		],
		skins: [
			{
				unified: "1f9d8",
				native: "🧘",
				x: 51,
				y: 34
			},
			{
				unified: "1f9d8-1f3fb",
				native: "🧘🏻",
				x: 51,
				y: 35
			},
			{
				unified: "1f9d8-1f3fc",
				native: "🧘🏼",
				x: 51,
				y: 36
			},
			{
				unified: "1f9d8-1f3fd",
				native: "🧘🏽",
				x: 51,
				y: 37
			},
			{
				unified: "1f9d8-1f3fe",
				native: "🧘🏾",
				x: 51,
				y: 38
			},
			{
				unified: "1f9d8-1f3ff",
				native: "🧘🏿",
				x: 51,
				y: 39
			}
		],
		version: 5
	},
	man_in_lotus_position: {
		id: "man_in_lotus_position",
		name: "Man in Lotus Position",
		keywords: [
			"male",
			"meditation",
			"yoga",
			"serenity",
			"zen",
			"mindfulness"
		],
		skins: [
			{
				unified: "1f9d8-200d-2642-fe0f",
				native: "🧘‍♂️",
				x: 51,
				y: 28
			},
			{
				unified: "1f9d8-1f3fb-200d-2642-fe0f",
				native: "🧘🏻‍♂️",
				x: 51,
				y: 29
			},
			{
				unified: "1f9d8-1f3fc-200d-2642-fe0f",
				native: "🧘🏼‍♂️",
				x: 51,
				y: 30
			},
			{
				unified: "1f9d8-1f3fd-200d-2642-fe0f",
				native: "🧘🏽‍♂️",
				x: 51,
				y: 31
			},
			{
				unified: "1f9d8-1f3fe-200d-2642-fe0f",
				native: "🧘🏾‍♂️",
				x: 51,
				y: 32
			},
			{
				unified: "1f9d8-1f3ff-200d-2642-fe0f",
				native: "🧘🏿‍♂️",
				x: 51,
				y: 33
			}
		],
		version: 5
	},
	woman_in_lotus_position: {
		id: "woman_in_lotus_position",
		name: "Woman in Lotus Position",
		keywords: [
			"female",
			"meditation",
			"yoga",
			"serenity",
			"zen",
			"mindfulness"
		],
		skins: [
			{
				unified: "1f9d8-200d-2640-fe0f",
				native: "🧘‍♀️",
				x: 51,
				y: 22
			},
			{
				unified: "1f9d8-1f3fb-200d-2640-fe0f",
				native: "🧘🏻‍♀️",
				x: 51,
				y: 23
			},
			{
				unified: "1f9d8-1f3fc-200d-2640-fe0f",
				native: "🧘🏼‍♀️",
				x: 51,
				y: 24
			},
			{
				unified: "1f9d8-1f3fd-200d-2640-fe0f",
				native: "🧘🏽‍♀️",
				x: 51,
				y: 25
			},
			{
				unified: "1f9d8-1f3fe-200d-2640-fe0f",
				native: "🧘🏾‍♀️",
				x: 51,
				y: 26
			},
			{
				unified: "1f9d8-1f3ff-200d-2640-fe0f",
				native: "🧘🏿‍♀️",
				x: 51,
				y: 27
			}
		],
		version: 5
	},
	bath: {
		id: "bath",
		name: "Bath",
		keywords: [
			"person",
			"taking",
			"clean",
			"shower",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6c0",
				native: "🛀",
				x: 37,
				y: 42
			},
			{
				unified: "1f6c0-1f3fb",
				native: "🛀🏻",
				x: 37,
				y: 43
			},
			{
				unified: "1f6c0-1f3fc",
				native: "🛀🏼",
				x: 37,
				y: 44
			},
			{
				unified: "1f6c0-1f3fd",
				native: "🛀🏽",
				x: 37,
				y: 45
			},
			{
				unified: "1f6c0-1f3fe",
				native: "🛀🏾",
				x: 37,
				y: 46
			},
			{
				unified: "1f6c0-1f3ff",
				native: "🛀🏿",
				x: 37,
				y: 47
			}
		],
		version: 1
	},
	sleeping_accommodation: {
		id: "sleeping_accommodation",
		name: "Person in Bed",
		keywords: [
			"sleeping",
			"accommodation",
			"rest"
		],
		skins: [
			{
				unified: "1f6cc",
				native: "🛌",
				x: 37,
				y: 54
			},
			{
				unified: "1f6cc-1f3fb",
				native: "🛌🏻",
				x: 37,
				y: 55
			},
			{
				unified: "1f6cc-1f3fc",
				native: "🛌🏼",
				x: 37,
				y: 56
			},
			{
				unified: "1f6cc-1f3fd",
				native: "🛌🏽",
				x: 37,
				y: 57
			},
			{
				unified: "1f6cc-1f3fe",
				native: "🛌🏾",
				x: 37,
				y: 58
			},
			{
				unified: "1f6cc-1f3ff",
				native: "🛌🏿",
				x: 37,
				y: 59
			}
		],
		version: 1
	},
	people_holding_hands: {
		id: "people_holding_hands",
		name: "People Holding Hands",
		keywords: [
			"friendship"
		],
		skins: [
			{
				unified: "1f9d1-200d-1f91d-200d-1f9d1",
				native: "🧑‍🤝‍🧑",
				x: 48,
				y: 41
			},
			{
				unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
				native: "🧑🏻‍🤝‍🧑🏻",
				x: 48,
				y: 42
			},
			{
				unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
				native: "🧑🏼‍🤝‍🧑🏼",
				x: 48,
				y: 48
			},
			{
				unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
				native: "🧑🏽‍🤝‍🧑🏽",
				x: 48,
				y: 54
			},
			{
				unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
				native: "🧑🏾‍🤝‍🧑🏾",
				x: 48,
				y: 60
			},
			{
				unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
				native: "🧑🏿‍🤝‍🧑🏿",
				x: 49,
				y: 5
			}
		],
		version: 12
	},
	two_women_holding_hands: {
		id: "two_women_holding_hands",
		name: "Women Holding Hands",
		keywords: [
			"two",
			"pair",
			"friendship",
			"couple",
			"love",
			"like",
			"female",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46d",
				native: "👭",
				x: 22,
				y: 31
			},
			{
				unified: "1f46d-1f3fb",
				native: "👭🏻",
				x: 22,
				y: 32
			},
			{
				unified: "1f46d-1f3fc",
				native: "👭🏼",
				x: 22,
				y: 33
			},
			{
				unified: "1f46d-1f3fd",
				native: "👭🏽",
				x: 22,
				y: 34
			},
			{
				unified: "1f46d-1f3fe",
				native: "👭🏾",
				x: 22,
				y: 35
			},
			{
				unified: "1f46d-1f3ff",
				native: "👭🏿",
				x: 22,
				y: 36
			}
		],
		version: 1
	},
	man_and_woman_holding_hands: {
		id: "man_and_woman_holding_hands",
		name: "Man and Woman Holding Hands",
		keywords: [
			"couple",
			"pair",
			"people",
			"human",
			"love",
			"date",
			"dating",
			"like",
			"affection",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f46b",
				native: "👫",
				x: 21,
				y: 40
			},
			{
				unified: "1f46b-1f3fb",
				native: "👫🏻",
				x: 21,
				y: 41
			},
			{
				unified: "1f46b-1f3fc",
				native: "👫🏼",
				x: 21,
				y: 42
			},
			{
				unified: "1f46b-1f3fd",
				native: "👫🏽",
				x: 21,
				y: 43
			},
			{
				unified: "1f46b-1f3fe",
				native: "👫🏾",
				x: 21,
				y: 44
			},
			{
				unified: "1f46b-1f3ff",
				native: "👫🏿",
				x: 21,
				y: 45
			}
		],
		version: 1
	},
	two_men_holding_hands: {
		id: "two_men_holding_hands",
		name: "Men Holding Hands",
		keywords: [
			"two",
			"pair",
			"couple",
			"love",
			"like",
			"bromance",
			"friendship",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46c",
				native: "👬",
				x: 22,
				y: 5
			},
			{
				unified: "1f46c-1f3fb",
				native: "👬🏻",
				x: 22,
				y: 6
			},
			{
				unified: "1f46c-1f3fc",
				native: "👬🏼",
				x: 22,
				y: 7
			},
			{
				unified: "1f46c-1f3fd",
				native: "👬🏽",
				x: 22,
				y: 8
			},
			{
				unified: "1f46c-1f3fe",
				native: "👬🏾",
				x: 22,
				y: 9
			},
			{
				unified: "1f46c-1f3ff",
				native: "👬🏿",
				x: 22,
				y: 10
			}
		],
		version: 1
	},
	couplekiss: {
		id: "couplekiss",
		name: "Kiss",
		keywords: [
			"couplekiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f48f",
				native: "💏",
				x: 26,
				y: 41
			},
			{
				unified: "1f48f-1f3fb",
				native: "💏🏻",
				x: 26,
				y: 42
			},
			{
				unified: "1f48f-1f3fc",
				native: "💏🏼",
				x: 26,
				y: 43
			},
			{
				unified: "1f48f-1f3fd",
				native: "💏🏽",
				x: 26,
				y: 44
			},
			{
				unified: "1f48f-1f3fe",
				native: "💏🏾",
				x: 26,
				y: 45
			},
			{
				unified: "1f48f-1f3ff",
				native: "💏🏿",
				x: 26,
				y: 46
			}
		],
		version: 1
	},
	"woman-kiss-man": {
		id: "woman-kiss-man",
		name: "Kiss: Woman, Man",
		keywords: [
			"woman",
			"kiss-man",
			"kiss",
			"love"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
				native: "👩‍❤️‍💋‍👨",
				x: 20,
				y: 42
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				native: "👩🏻‍❤️‍💋‍👨🏻",
				x: 20,
				y: 43
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				native: "👩🏼‍❤️‍💋‍👨🏼",
				x: 20,
				y: 49
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				native: "👩🏽‍❤️‍💋‍👨🏽",
				x: 20,
				y: 55
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				native: "👩🏾‍❤️‍💋‍👨🏾",
				x: 21,
				y: 0
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				native: "👩🏿‍❤️‍💋‍👨🏿",
				x: 21,
				y: 6
			}
		],
		version: 2
	},
	"man-kiss-man": {
		id: "man-kiss-man",
		name: "Kiss: Man, Man",
		keywords: [
			"kiss-man",
			"kiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
				native: "👨‍❤️‍💋‍👨",
				x: 16,
				y: 48
			},
			{
				unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				native: "👨🏻‍❤️‍💋‍👨🏻",
				x: 16,
				y: 49
			},
			{
				unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				native: "👨🏼‍❤️‍💋‍👨🏼",
				x: 16,
				y: 55
			},
			{
				unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				native: "👨🏽‍❤️‍💋‍👨🏽",
				x: 17,
				y: 0
			},
			{
				unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				native: "👨🏾‍❤️‍💋‍👨🏾",
				x: 17,
				y: 6
			},
			{
				unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				native: "👨🏿‍❤️‍💋‍👨🏿",
				x: 17,
				y: 12
			}
		],
		version: 2
	},
	"woman-kiss-woman": {
		id: "woman-kiss-woman",
		name: "Kiss: Woman, Woman",
		keywords: [
			"kiss-woman",
			"kiss",
			"pair",
			"valentines",
			"love",
			"like",
			"dating",
			"marriage"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
				native: "👩‍❤️‍💋‍👩",
				x: 21,
				y: 7
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				native: "👩🏻‍❤️‍💋‍👩🏻",
				x: 21,
				y: 8
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				native: "👩🏼‍❤️‍💋‍👩🏼",
				x: 21,
				y: 14
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				native: "👩🏽‍❤️‍💋‍👩🏽",
				x: 21,
				y: 20
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				native: "👩🏾‍❤️‍💋‍👩🏾",
				x: 21,
				y: 26
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				native: "👩🏿‍❤️‍💋‍👩🏿",
				x: 21,
				y: 32
			}
		],
		version: 2
	},
	couple_with_heart: {
		id: "couple_with_heart",
		name: "Couple with Heart",
		keywords: [
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f491",
				native: "💑",
				x: 27,
				y: 7
			},
			{
				unified: "1f491-1f3fb",
				native: "💑🏻",
				x: 27,
				y: 8
			},
			{
				unified: "1f491-1f3fc",
				native: "💑🏼",
				x: 27,
				y: 9
			},
			{
				unified: "1f491-1f3fd",
				native: "💑🏽",
				x: 27,
				y: 10
			},
			{
				unified: "1f491-1f3fe",
				native: "💑🏾",
				x: 27,
				y: 11
			},
			{
				unified: "1f491-1f3ff",
				native: "💑🏿",
				x: 27,
				y: 12
			}
		],
		version: 1
	},
	"woman-heart-man": {
		id: "woman-heart-man",
		name: "Couple with Heart: Woman, Man",
		keywords: [
			"woman",
			"heart-man",
			"heart",
			"love"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f468",
				native: "👩‍❤️‍👨",
				x: 19,
				y: 51
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				native: "👩🏻‍❤️‍👨🏻",
				x: 19,
				y: 52
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				native: "👩🏼‍❤️‍👨🏼",
				x: 19,
				y: 58
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				native: "👩🏽‍❤️‍👨🏽",
				x: 20,
				y: 3
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				native: "👩🏾‍❤️‍👨🏾",
				x: 20,
				y: 9
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
				native: "👩🏿‍❤️‍👨🏿",
				x: 20,
				y: 15
			}
		],
		version: 2
	},
	"man-heart-man": {
		id: "man-heart-man",
		name: "Couple with Heart: Man, Man",
		keywords: [
			"heart-man",
			"heart",
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f468-200d-2764-fe0f-200d-1f468",
				native: "👨‍❤️‍👨",
				x: 16,
				y: 22
			},
			{
				unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				native: "👨🏻‍❤️‍👨🏻",
				x: 16,
				y: 23
			},
			{
				unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				native: "👨🏼‍❤️‍👨🏼",
				x: 16,
				y: 29
			},
			{
				unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				native: "👨🏽‍❤️‍👨🏽",
				x: 16,
				y: 35
			},
			{
				unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				native: "👨🏾‍❤️‍👨🏾",
				x: 16,
				y: 41
			},
			{
				unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
				native: "👨🏿‍❤️‍👨🏿",
				x: 16,
				y: 47
			}
		],
		version: 2
	},
	"woman-heart-woman": {
		id: "woman-heart-woman",
		name: "Couple with Heart: Woman, Woman",
		keywords: [
			"heart-woman",
			"heart",
			"pair",
			"love",
			"like",
			"affection",
			"human",
			"dating",
			"valentines",
			"marriage"
		],
		skins: [
			{
				unified: "1f469-200d-2764-fe0f-200d-1f469",
				native: "👩‍❤️‍👩",
				x: 20,
				y: 16
			},
			{
				unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
				native: "👩🏻‍❤️‍👩🏻",
				x: 20,
				y: 17
			},
			{
				unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
				native: "👩🏼‍❤️‍👩🏼",
				x: 20,
				y: 23
			},
			{
				unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
				native: "👩🏽‍❤️‍👩🏽",
				x: 20,
				y: 29
			},
			{
				unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
				native: "👩🏾‍❤️‍👩🏾",
				x: 20,
				y: 35
			},
			{
				unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
				native: "👩🏿‍❤️‍👩🏿",
				x: 20,
				y: 41
			}
		],
		version: 2
	},
	family: {
		id: "family",
		name: "Family",
		keywords: [
			"home",
			"parents",
			"child",
			"mom",
			"dad",
			"father",
			"mother",
			"people",
			"human"
		],
		skins: [
			{
				unified: "1f46a",
				native: "👪",
				x: 21,
				y: 39
			}
		],
		version: 1
	},
	"man-woman-boy": {
		id: "man-woman-boy",
		name: "Family: Man, Woman, Boy",
		keywords: [
			"man",
			"woman-boy",
			"family",
			"woman",
			"love"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f466",
				native: "👨‍👩‍👦",
				x: 14,
				y: 43
			}
		],
		version: 2
	},
	"man-woman-girl": {
		id: "man-woman-girl",
		name: "Family: Man, Woman, Girl",
		keywords: [
			"man",
			"woman-girl",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467",
				native: "👨‍👩‍👧",
				x: 14,
				y: 45
			}
		],
		version: 2
	},
	"man-woman-girl-boy": {
		id: "man-woman-girl-boy",
		name: "Family: Man, Woman, Girl, Boy",
		keywords: [
			"man",
			"woman-girl-boy",
			"family",
			"woman",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
				native: "👨‍👩‍👧‍👦",
				x: 14,
				y: 46
			}
		],
		version: 2
	},
	"man-woman-boy-boy": {
		id: "man-woman-boy-boy",
		name: "Family: Man, Woman, Boy, Boy",
		keywords: [
			"man",
			"woman-boy-boy",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
				native: "👨‍👩‍👦‍👦",
				x: 14,
				y: 44
			}
		],
		version: 2
	},
	"man-woman-girl-girl": {
		id: "man-woman-girl-girl",
		name: "Family: Man, Woman, Girl, Girl",
		keywords: [
			"man",
			"woman-girl-girl",
			"family",
			"woman",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
				native: "👨‍👩‍👧‍👧",
				x: 14,
				y: 47
			}
		],
		version: 2
	},
	"man-man-boy": {
		id: "man-man-boy",
		name: "Family: Man, Man, Boy",
		keywords: [
			"man",
			"man-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f466",
				native: "👨‍👨‍👦",
				x: 14,
				y: 38
			}
		],
		version: 2
	},
	"man-man-girl": {
		id: "man-man-girl",
		name: "Family: Man, Man, Girl",
		keywords: [
			"man",
			"man-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467",
				native: "👨‍👨‍👧",
				x: 14,
				y: 40
			}
		],
		version: 2
	},
	"man-man-girl-boy": {
		id: "man-man-girl-boy",
		name: "Family: Man, Man, Girl, Boy",
		keywords: [
			"man",
			"man-girl-boy",
			"family",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
				native: "👨‍👨‍👧‍👦",
				x: 14,
				y: 41
			}
		],
		version: 2
	},
	"man-man-boy-boy": {
		id: "man-man-boy-boy",
		name: "Family: Man, Man, Boy, Boy",
		keywords: [
			"man",
			"man-boy-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
				native: "👨‍👨‍👦‍👦",
				x: 14,
				y: 39
			}
		],
		version: 2
	},
	"man-man-girl-girl": {
		id: "man-man-girl-girl",
		name: "Family: Man, Man, Girl, Girl",
		keywords: [
			"man",
			"man-girl-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
				native: "👨‍👨‍👧‍👧",
				x: 14,
				y: 42
			}
		],
		version: 2
	},
	"woman-woman-boy": {
		id: "woman-woman-boy",
		name: "Family: Woman, Woman, Boy",
		keywords: [
			"woman",
			"woman-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f466",
				native: "👩‍👩‍👦",
				x: 18,
				y: 11
			}
		],
		version: 2
	},
	"woman-woman-girl": {
		id: "woman-woman-girl",
		name: "Family: Woman, Woman, Girl",
		keywords: [
			"woman",
			"woman-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467",
				native: "👩‍👩‍👧",
				x: 18,
				y: 13
			}
		],
		version: 2
	},
	"woman-woman-girl-boy": {
		id: "woman-woman-girl-boy",
		name: "Family: Woman, Woman, Girl, Boy",
		keywords: [
			"woman",
			"woman-girl-boy",
			"family",
			"girl",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
				native: "👩‍👩‍👧‍👦",
				x: 18,
				y: 14
			}
		],
		version: 2
	},
	"woman-woman-boy-boy": {
		id: "woman-woman-boy-boy",
		name: "Family: Woman, Woman, Boy, Boy",
		keywords: [
			"woman",
			"woman-boy-boy",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
				native: "👩‍👩‍👦‍👦",
				x: 18,
				y: 12
			}
		],
		version: 2
	},
	"woman-woman-girl-girl": {
		id: "woman-woman-girl-girl",
		name: "Family: Woman, Woman, Girl, Girl",
		keywords: [
			"woman",
			"woman-girl-girl",
			"family",
			"home",
			"parents",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
				native: "👩‍👩‍👧‍👧",
				x: 18,
				y: 15
			}
		],
		version: 2
	},
	"man-boy": {
		id: "man-boy",
		name: "Family: Man, Boy",
		keywords: [
			"man",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f466",
				native: "👨‍👦",
				x: 14,
				y: 34
			}
		],
		version: 4
	},
	"man-boy-boy": {
		id: "man-boy-boy",
		name: "Family: Man, Boy, Boy",
		keywords: [
			"man",
			"boy-boy",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f466-200d-1f466",
				native: "👨‍👦‍👦",
				x: 14,
				y: 33
			}
		],
		version: 4
	},
	"man-girl": {
		id: "man-girl",
		name: "Family: Man, Girl",
		keywords: [
			"man",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f468-200d-1f467",
				native: "👨‍👧",
				x: 14,
				y: 37
			}
		],
		version: 4
	},
	"man-girl-boy": {
		id: "man-girl-boy",
		name: "Family: Man, Girl, Boy",
		keywords: [
			"man",
			"girl-boy",
			"family",
			"girl",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f467-200d-1f466",
				native: "👨‍👧‍👦",
				x: 14,
				y: 35
			}
		],
		version: 4
	},
	"man-girl-girl": {
		id: "man-girl-girl",
		name: "Family: Man, Girl, Girl",
		keywords: [
			"man",
			"girl-girl",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f468-200d-1f467-200d-1f467",
				native: "👨‍👧‍👧",
				x: 14,
				y: 36
			}
		],
		version: 4
	},
	"woman-boy": {
		id: "woman-boy",
		name: "Family: Woman, Boy",
		keywords: [
			"woman",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f469-200d-1f466",
				native: "👩‍👦",
				x: 18,
				y: 7
			}
		],
		version: 4
	},
	"woman-boy-boy": {
		id: "woman-boy-boy",
		name: "Family: Woman, Boy, Boy",
		keywords: [
			"woman",
			"boy-boy",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f466-200d-1f466",
				native: "👩‍👦‍👦",
				x: 18,
				y: 6
			}
		],
		version: 4
	},
	"woman-girl": {
		id: "woman-girl",
		name: "Family: Woman, Girl",
		keywords: [
			"woman",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"child"
		],
		skins: [
			{
				unified: "1f469-200d-1f467",
				native: "👩‍👧",
				x: 18,
				y: 10
			}
		],
		version: 4
	},
	"woman-girl-boy": {
		id: "woman-girl-boy",
		name: "Family: Woman, Girl, Boy",
		keywords: [
			"woman",
			"girl-boy",
			"family",
			"girl",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f467-200d-1f466",
				native: "👩‍👧‍👦",
				x: 18,
				y: 8
			}
		],
		version: 4
	},
	"woman-girl-girl": {
		id: "woman-girl-girl",
		name: "Family: Woman, Girl, Girl",
		keywords: [
			"woman",
			"girl-girl",
			"family",
			"home",
			"parent",
			"people",
			"human",
			"children"
		],
		skins: [
			{
				unified: "1f469-200d-1f467-200d-1f467",
				native: "👩‍👧‍👧",
				x: 18,
				y: 9
			}
		],
		version: 4
	},
	speaking_head_in_silhouette: {
		id: "speaking_head_in_silhouette",
		name: "Speaking Head",
		keywords: [
			"in",
			"silhouette",
			"user",
			"person",
			"human",
			"sing",
			"say",
			"talk"
		],
		skins: [
			{
				unified: "1f5e3-fe0f",
				native: "🗣️",
				x: 32,
				y: 10
			}
		],
		version: 1
	},
	bust_in_silhouette: {
		id: "bust_in_silhouette",
		name: "Bust in Silhouette",
		keywords: [
			"user",
			"person",
			"human"
		],
		skins: [
			{
				unified: "1f464",
				native: "👤",
				x: 13,
				y: 32
			}
		],
		version: 1
	},
	busts_in_silhouette: {
		id: "busts_in_silhouette",
		name: "Busts in Silhouette",
		keywords: [
			"user",
			"person",
			"human",
			"group",
			"team"
		],
		skins: [
			{
				unified: "1f465",
				native: "👥",
				x: 13,
				y: 33
			}
		],
		version: 1
	},
	people_hugging: {
		id: "people_hugging",
		name: "People Hugging",
		keywords: [
			"care"
		],
		skins: [
			{
				unified: "1fac2",
				native: "🫂",
				x: 54,
				y: 44
			}
		],
		version: 13
	},
	footprints: {
		id: "footprints",
		name: "Footprints",
		keywords: [
			"feet",
			"tracking",
			"walking",
			"beach"
		],
		skins: [
			{
				unified: "1f463",
				native: "👣",
				x: 13,
				y: 31
			}
		],
		version: 1
	},
	monkey_face: {
		id: "monkey_face",
		name: "Monkey Face",
		emoticons: [
			":o)"
		],
		keywords: [
			"animal",
			"nature",
			"circus"
		],
		skins: [
			{
				unified: "1f435",
				native: "🐵",
				x: 11,
				y: 40
			}
		],
		version: 1
	},
	monkey: {
		id: "monkey",
		name: "Monkey",
		keywords: [
			"animal",
			"nature",
			"banana",
			"circus"
		],
		skins: [
			{
				unified: "1f412",
				native: "🐒",
				x: 11,
				y: 4
			}
		],
		version: 1
	},
	gorilla: {
		id: "gorilla",
		name: "Gorilla",
		keywords: [
			"animal",
			"nature",
			"circus"
		],
		skins: [
			{
				unified: "1f98d",
				native: "🦍",
				x: 44,
				y: 31
			}
		],
		version: 3
	},
	orangutan: {
		id: "orangutan",
		name: "Orangutan",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a7",
				native: "🦧",
				x: 44,
				y: 57
			}
		],
		version: 12
	},
	dog: {
		id: "dog",
		name: "Dog Face",
		keywords: [
			"animal",
			"friend",
			"nature",
			"woof",
			"puppy",
			"pet",
			"faithful"
		],
		skins: [
			{
				unified: "1f436",
				native: "🐶",
				x: 11,
				y: 41
			}
		],
		version: 1
	},
	dog2: {
		id: "dog2",
		name: "Dog",
		keywords: [
			"dog2",
			"animal",
			"nature",
			"friend",
			"doge",
			"pet",
			"faithful"
		],
		skins: [
			{
				unified: "1f415",
				native: "🐕",
				x: 11,
				y: 8
			}
		],
		version: 1
	},
	guide_dog: {
		id: "guide_dog",
		name: "Guide Dog",
		keywords: [
			"animal",
			"blind"
		],
		skins: [
			{
				unified: "1f9ae",
				native: "🦮",
				x: 45,
				y: 3
			}
		],
		version: 12
	},
	service_dog: {
		id: "service_dog",
		name: "Service Dog",
		keywords: [
			"blind",
			"animal"
		],
		skins: [
			{
				unified: "1f415-200d-1f9ba",
				native: "🐕‍🦺",
				x: 11,
				y: 7
			}
		],
		version: 12
	},
	poodle: {
		id: "poodle",
		name: "Poodle",
		keywords: [
			"dog",
			"animal",
			"101",
			"nature",
			"pet"
		],
		skins: [
			{
				unified: "1f429",
				native: "🐩",
				x: 11,
				y: 28
			}
		],
		version: 1
	},
	wolf: {
		id: "wolf",
		name: "Wolf",
		keywords: [
			"animal",
			"nature",
			"wild"
		],
		skins: [
			{
				unified: "1f43a",
				native: "🐺",
				x: 11,
				y: 45
			}
		],
		version: 1
	},
	fox_face: {
		id: "fox_face",
		name: "Fox",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f98a",
				native: "🦊",
				x: 44,
				y: 28
			}
		],
		version: 3
	},
	raccoon: {
		id: "raccoon",
		name: "Raccoon",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f99d",
				native: "🦝",
				x: 44,
				y: 47
			}
		],
		version: 11
	},
	cat: {
		id: "cat",
		name: "Cat Face",
		keywords: [
			"animal",
			"meow",
			"nature",
			"pet",
			"kitten"
		],
		skins: [
			{
				unified: "1f431",
				native: "🐱",
				x: 11,
				y: 36
			}
		],
		version: 1
	},
	cat2: {
		id: "cat2",
		name: "Cat",
		keywords: [
			"cat2",
			"animal",
			"meow",
			"pet",
			"cats"
		],
		skins: [
			{
				unified: "1f408",
				native: "🐈",
				x: 10,
				y: 55
			}
		],
		version: 1
	},
	black_cat: {
		id: "black_cat",
		name: "Black Cat",
		keywords: [
			"superstition",
			"luck"
		],
		skins: [
			{
				unified: "1f408-200d-2b1b",
				native: "🐈‍⬛",
				x: 10,
				y: 54
			}
		],
		version: 13
	},
	lion_face: {
		id: "lion_face",
		name: "Lion",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f981",
				native: "🦁",
				x: 44,
				y: 19
			}
		],
		version: 1
	},
	tiger: {
		id: "tiger",
		name: "Tiger Face",
		keywords: [
			"animal",
			"cat",
			"danger",
			"wild",
			"nature",
			"roar"
		],
		skins: [
			{
				unified: "1f42f",
				native: "🐯",
				x: 11,
				y: 34
			}
		],
		version: 1
	},
	tiger2: {
		id: "tiger2",
		name: "Tiger",
		keywords: [
			"tiger2",
			"animal",
			"nature",
			"roar"
		],
		skins: [
			{
				unified: "1f405",
				native: "🐅",
				x: 10,
				y: 51
			}
		],
		version: 1
	},
	leopard: {
		id: "leopard",
		name: "Leopard",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f406",
				native: "🐆",
				x: 10,
				y: 52
			}
		],
		version: 1
	},
	horse: {
		id: "horse",
		name: "Horse Face",
		keywords: [
			"animal",
			"brown",
			"nature"
		],
		skins: [
			{
				unified: "1f434",
				native: "🐴",
				x: 11,
				y: 39
			}
		],
		version: 1
	},
	racehorse: {
		id: "racehorse",
		name: "Horse",
		keywords: [
			"racehorse",
			"animal",
			"gamble",
			"luck"
		],
		skins: [
			{
				unified: "1f40e",
				native: "🐎",
				x: 11,
				y: 0
			}
		],
		version: 1
	},
	unicorn_face: {
		id: "unicorn_face",
		name: "Unicorn",
		keywords: [
			"face",
			"animal",
			"nature",
			"mystical"
		],
		skins: [
			{
				unified: "1f984",
				native: "🦄",
				x: 44,
				y: 22
			}
		],
		version: 1
	},
	zebra_face: {
		id: "zebra_face",
		name: "Zebra",
		keywords: [
			"face",
			"animal",
			"nature",
			"stripes",
			"safari"
		],
		skins: [
			{
				unified: "1f993",
				native: "🦓",
				x: 44,
				y: 37
			}
		],
		version: 5
	},
	deer: {
		id: "deer",
		name: "Deer",
		keywords: [
			"animal",
			"nature",
			"horns",
			"venison"
		],
		skins: [
			{
				unified: "1f98c",
				native: "🦌",
				x: 44,
				y: 30
			}
		],
		version: 3
	},
	bison: {
		id: "bison",
		name: "Bison",
		keywords: [
			"ox"
		],
		skins: [
			{
				unified: "1f9ac",
				native: "🦬",
				x: 45,
				y: 1
			}
		],
		version: 13
	},
	cow: {
		id: "cow",
		name: "Cow Face",
		keywords: [
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		skins: [
			{
				unified: "1f42e",
				native: "🐮",
				x: 11,
				y: 33
			}
		],
		version: 1
	},
	ox: {
		id: "ox",
		name: "Ox",
		keywords: [
			"animal",
			"cow",
			"beef"
		],
		skins: [
			{
				unified: "1f402",
				native: "🐂",
				x: 10,
				y: 48
			}
		],
		version: 1
	},
	water_buffalo: {
		id: "water_buffalo",
		name: "Water Buffalo",
		keywords: [
			"animal",
			"nature",
			"ox",
			"cow"
		],
		skins: [
			{
				unified: "1f403",
				native: "🐃",
				x: 10,
				y: 49
			}
		],
		version: 1
	},
	cow2: {
		id: "cow2",
		name: "Cow",
		keywords: [
			"cow2",
			"beef",
			"ox",
			"animal",
			"nature",
			"moo",
			"milk"
		],
		skins: [
			{
				unified: "1f404",
				native: "🐄",
				x: 10,
				y: 50
			}
		],
		version: 1
	},
	pig: {
		id: "pig",
		name: "Pig Face",
		keywords: [
			"animal",
			"oink",
			"nature"
		],
		skins: [
			{
				unified: "1f437",
				native: "🐷",
				x: 11,
				y: 42
			}
		],
		version: 1
	},
	pig2: {
		id: "pig2",
		name: "Pig",
		keywords: [
			"pig2",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f416",
				native: "🐖",
				x: 11,
				y: 9
			}
		],
		version: 1
	},
	boar: {
		id: "boar",
		name: "Boar",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f417",
				native: "🐗",
				x: 11,
				y: 10
			}
		],
		version: 1
	},
	pig_nose: {
		id: "pig_nose",
		name: "Pig Nose",
		keywords: [
			"animal",
			"oink"
		],
		skins: [
			{
				unified: "1f43d",
				native: "🐽",
				x: 11,
				y: 49
			}
		],
		version: 1
	},
	ram: {
		id: "ram",
		name: "Ram",
		keywords: [
			"animal",
			"sheep",
			"nature"
		],
		skins: [
			{
				unified: "1f40f",
				native: "🐏",
				x: 11,
				y: 1
			}
		],
		version: 1
	},
	sheep: {
		id: "sheep",
		name: "Ewe",
		keywords: [
			"sheep",
			"animal",
			"nature",
			"wool",
			"shipit"
		],
		skins: [
			{
				unified: "1f411",
				native: "🐑",
				x: 11,
				y: 3
			}
		],
		version: 1
	},
	goat: {
		id: "goat",
		name: "Goat",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f410",
				native: "🐐",
				x: 11,
				y: 2
			}
		],
		version: 1
	},
	dromedary_camel: {
		id: "dromedary_camel",
		name: "Camel",
		keywords: [
			"dromedary",
			"animal",
			"hot",
			"desert",
			"hump"
		],
		skins: [
			{
				unified: "1f42a",
				native: "🐪",
				x: 11,
				y: 29
			}
		],
		version: 1
	},
	camel: {
		id: "camel",
		name: "Bactrian Camel",
		keywords: [
			"two",
			"hump",
			"animal",
			"nature",
			"hot",
			"desert"
		],
		skins: [
			{
				unified: "1f42b",
				native: "🐫",
				x: 11,
				y: 30
			}
		],
		version: 1
	},
	llama: {
		id: "llama",
		name: "Llama",
		keywords: [
			"animal",
			"nature",
			"alpaca"
		],
		skins: [
			{
				unified: "1f999",
				native: "🦙",
				x: 44,
				y: 43
			}
		],
		version: 11
	},
	giraffe_face: {
		id: "giraffe_face",
		name: "Giraffe",
		keywords: [
			"face",
			"animal",
			"nature",
			"spots",
			"safari"
		],
		skins: [
			{
				unified: "1f992",
				native: "🦒",
				x: 44,
				y: 36
			}
		],
		version: 5
	},
	elephant: {
		id: "elephant",
		name: "Elephant",
		keywords: [
			"animal",
			"nature",
			"nose",
			"th",
			"circus"
		],
		skins: [
			{
				unified: "1f418",
				native: "🐘",
				x: 11,
				y: 11
			}
		],
		version: 1
	},
	mammoth: {
		id: "mammoth",
		name: "Mammoth",
		keywords: [
			"elephant",
			"tusks"
		],
		skins: [
			{
				unified: "1f9a3",
				native: "🦣",
				x: 44,
				y: 53
			}
		],
		version: 13
	},
	rhinoceros: {
		id: "rhinoceros",
		name: "Rhinoceros",
		keywords: [
			"animal",
			"nature",
			"horn"
		],
		skins: [
			{
				unified: "1f98f",
				native: "🦏",
				x: 44,
				y: 33
			}
		],
		version: 3
	},
	hippopotamus: {
		id: "hippopotamus",
		name: "Hippopotamus",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f99b",
				native: "🦛",
				x: 44,
				y: 45
			}
		],
		version: 11
	},
	mouse: {
		id: "mouse",
		name: "Mouse Face",
		keywords: [
			"animal",
			"nature",
			"cheese",
			"wedge",
			"rodent"
		],
		skins: [
			{
				unified: "1f42d",
				native: "🐭",
				x: 11,
				y: 32
			}
		],
		version: 1
	},
	mouse2: {
		id: "mouse2",
		name: "Mouse",
		keywords: [
			"mouse2",
			"animal",
			"nature",
			"rodent"
		],
		skins: [
			{
				unified: "1f401",
				native: "🐁",
				x: 10,
				y: 47
			}
		],
		version: 1
	},
	rat: {
		id: "rat",
		name: "Rat",
		keywords: [
			"animal",
			"mouse",
			"rodent"
		],
		skins: [
			{
				unified: "1f400",
				native: "🐀",
				x: 10,
				y: 46
			}
		],
		version: 1
	},
	hamster: {
		id: "hamster",
		name: "Hamster",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f439",
				native: "🐹",
				x: 11,
				y: 44
			}
		],
		version: 1
	},
	rabbit: {
		id: "rabbit",
		name: "Rabbit Face",
		keywords: [
			"animal",
			"nature",
			"pet",
			"spring",
			"magic",
			"bunny"
		],
		skins: [
			{
				unified: "1f430",
				native: "🐰",
				x: 11,
				y: 35
			}
		],
		version: 1
	},
	rabbit2: {
		id: "rabbit2",
		name: "Rabbit",
		keywords: [
			"rabbit2",
			"animal",
			"nature",
			"pet",
			"magic",
			"spring"
		],
		skins: [
			{
				unified: "1f407",
				native: "🐇",
				x: 10,
				y: 53
			}
		],
		version: 1
	},
	chipmunk: {
		id: "chipmunk",
		name: "Chipmunk",
		keywords: [
			"animal",
			"nature",
			"rodent",
			"squirrel"
		],
		skins: [
			{
				unified: "1f43f-fe0f",
				native: "🐿️",
				x: 11,
				y: 51
			}
		],
		version: 1
	},
	beaver: {
		id: "beaver",
		name: "Beaver",
		keywords: [
			"animal",
			"rodent"
		],
		skins: [
			{
				unified: "1f9ab",
				native: "🦫",
				x: 45,
				y: 0
			}
		],
		version: 13
	},
	hedgehog: {
		id: "hedgehog",
		name: "Hedgehog",
		keywords: [
			"animal",
			"nature",
			"spiny"
		],
		skins: [
			{
				unified: "1f994",
				native: "🦔",
				x: 44,
				y: 38
			}
		],
		version: 5
	},
	bat: {
		id: "bat",
		name: "Bat",
		keywords: [
			"animal",
			"nature",
			"blind",
			"vampire"
		],
		skins: [
			{
				unified: "1f987",
				native: "🦇",
				x: 44,
				y: 25
			}
		],
		version: 3
	},
	bear: {
		id: "bear",
		name: "Bear",
		keywords: [
			"animal",
			"nature",
			"wild"
		],
		skins: [
			{
				unified: "1f43b",
				native: "🐻",
				x: 11,
				y: 47
			}
		],
		version: 1
	},
	polar_bear: {
		id: "polar_bear",
		name: "Polar Bear",
		keywords: [
			"animal",
			"arctic"
		],
		skins: [
			{
				unified: "1f43b-200d-2744-fe0f",
				native: "🐻‍❄️",
				x: 11,
				y: 46
			}
		],
		version: 13
	},
	koala: {
		id: "koala",
		name: "Koala",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f428",
				native: "🐨",
				x: 11,
				y: 27
			}
		],
		version: 1
	},
	panda_face: {
		id: "panda_face",
		name: "Panda",
		keywords: [
			"face",
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f43c",
				native: "🐼",
				x: 11,
				y: 48
			}
		],
		version: 1
	},
	sloth: {
		id: "sloth",
		name: "Sloth",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a5",
				native: "🦥",
				x: 44,
				y: 55
			}
		],
		version: 12
	},
	otter: {
		id: "otter",
		name: "Otter",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a6",
				native: "🦦",
				x: 44,
				y: 56
			}
		],
		version: 12
	},
	skunk: {
		id: "skunk",
		name: "Skunk",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a8",
				native: "🦨",
				x: 44,
				y: 58
			}
		],
		version: 12
	},
	kangaroo: {
		id: "kangaroo",
		name: "Kangaroo",
		keywords: [
			"animal",
			"nature",
			"australia",
			"joey",
			"hop",
			"marsupial"
		],
		skins: [
			{
				unified: "1f998",
				native: "🦘",
				x: 44,
				y: 42
			}
		],
		version: 11
	},
	badger: {
		id: "badger",
		name: "Badger",
		keywords: [
			"animal",
			"nature",
			"honey"
		],
		skins: [
			{
				unified: "1f9a1",
				native: "🦡",
				x: 44,
				y: 51
			}
		],
		version: 11
	},
	feet: {
		id: "feet",
		name: "Paw Prints",
		keywords: [
			"feet",
			"animal",
			"tracking",
			"footprints",
			"dog",
			"cat",
			"pet"
		],
		skins: [
			{
				unified: "1f43e",
				native: "🐾",
				x: 11,
				y: 50
			}
		],
		version: 1
	},
	turkey: {
		id: "turkey",
		name: "Turkey",
		keywords: [
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f983",
				native: "🦃",
				x: 44,
				y: 21
			}
		],
		version: 1
	},
	chicken: {
		id: "chicken",
		name: "Chicken",
		keywords: [
			"animal",
			"cluck",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f414",
				native: "🐔",
				x: 11,
				y: 6
			}
		],
		version: 1
	},
	rooster: {
		id: "rooster",
		name: "Rooster",
		keywords: [
			"animal",
			"nature",
			"chicken"
		],
		skins: [
			{
				unified: "1f413",
				native: "🐓",
				x: 11,
				y: 5
			}
		],
		version: 1
	},
	hatching_chick: {
		id: "hatching_chick",
		name: "Hatching Chick",
		keywords: [
			"animal",
			"chicken",
			"egg",
			"born",
			"baby",
			"bird"
		],
		skins: [
			{
				unified: "1f423",
				native: "🐣",
				x: 11,
				y: 22
			}
		],
		version: 1
	},
	baby_chick: {
		id: "baby_chick",
		name: "Baby Chick",
		keywords: [
			"animal",
			"chicken",
			"bird"
		],
		skins: [
			{
				unified: "1f424",
				native: "🐤",
				x: 11,
				y: 23
			}
		],
		version: 1
	},
	hatched_chick: {
		id: "hatched_chick",
		name: "Front-Facing Baby Chick",
		keywords: [
			"hatched",
			"front",
			"facing",
			"animal",
			"chicken",
			"bird"
		],
		skins: [
			{
				unified: "1f425",
				native: "🐥",
				x: 11,
				y: 24
			}
		],
		version: 1
	},
	bird: {
		id: "bird",
		name: "Bird",
		keywords: [
			"animal",
			"nature",
			"fly",
			"tweet",
			"spring"
		],
		skins: [
			{
				unified: "1f426",
				native: "🐦",
				x: 11,
				y: 25
			}
		],
		version: 1
	},
	penguin: {
		id: "penguin",
		name: "Penguin",
		keywords: [
			"animal",
			"nature"
		],
		skins: [
			{
				unified: "1f427",
				native: "🐧",
				x: 11,
				y: 26
			}
		],
		version: 1
	},
	dove_of_peace: {
		id: "dove_of_peace",
		name: "Dove",
		keywords: [
			"of",
			"peace",
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f54a-fe0f",
				native: "🕊️",
				x: 30,
				y: 27
			}
		],
		version: 1
	},
	eagle: {
		id: "eagle",
		name: "Eagle",
		keywords: [
			"animal",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f985",
				native: "🦅",
				x: 44,
				y: 23
			}
		],
		version: 3
	},
	duck: {
		id: "duck",
		name: "Duck",
		keywords: [
			"animal",
			"nature",
			"bird",
			"mallard"
		],
		skins: [
			{
				unified: "1f986",
				native: "🦆",
				x: 44,
				y: 24
			}
		],
		version: 3
	},
	swan: {
		id: "swan",
		name: "Swan",
		keywords: [
			"animal",
			"nature",
			"bird"
		],
		skins: [
			{
				unified: "1f9a2",
				native: "🦢",
				x: 44,
				y: 52
			}
		],
		version: 11
	},
	owl: {
		id: "owl",
		name: "Owl",
		keywords: [
			"animal",
			"nature",
			"bird",
			"hoot"
		],
		skins: [
			{
				unified: "1f989",
				native: "🦉",
				x: 44,
				y: 27
			}
		],
		version: 3
	},
	dodo: {
		id: "dodo",
		name: "Dodo",
		keywords: [
			"animal",
			"bird"
		],
		skins: [
			{
				unified: "1f9a4",
				native: "🦤",
				x: 44,
				y: 54
			}
		],
		version: 13
	},
	feather: {
		id: "feather",
		name: "Feather",
		keywords: [
			"bird",
			"fly"
		],
		skins: [
			{
				unified: "1fab6",
				native: "🪶",
				x: 54,
				y: 37
			}
		],
		version: 13
	},
	flamingo: {
		id: "flamingo",
		name: "Flamingo",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1f9a9",
				native: "🦩",
				x: 44,
				y: 59
			}
		],
		version: 12
	},
	peacock: {
		id: "peacock",
		name: "Peacock",
		keywords: [
			"animal",
			"nature",
			"peahen",
			"bird"
		],
		skins: [
			{
				unified: "1f99a",
				native: "🦚",
				x: 44,
				y: 44
			}
		],
		version: 11
	},
	parrot: {
		id: "parrot",
		name: "Parrot",
		keywords: [
			"animal",
			"nature",
			"bird",
			"pirate",
			"talk"
		],
		skins: [
			{
				unified: "1f99c",
				native: "🦜",
				x: 44,
				y: 46
			}
		],
		version: 11
	},
	frog: {
		id: "frog",
		name: "Frog",
		keywords: [
			"animal",
			"nature",
			"croak",
			"toad"
		],
		skins: [
			{
				unified: "1f438",
				native: "🐸",
				x: 11,
				y: 43
			}
		],
		version: 1
	},
	crocodile: {
		id: "crocodile",
		name: "Crocodile",
		keywords: [
			"animal",
			"nature",
			"reptile",
			"lizard",
			"alligator"
		],
		skins: [
			{
				unified: "1f40a",
				native: "🐊",
				x: 10,
				y: 57
			}
		],
		version: 1
	},
	turtle: {
		id: "turtle",
		name: "Turtle",
		keywords: [
			"animal",
			"slow",
			"nature",
			"tortoise"
		],
		skins: [
			{
				unified: "1f422",
				native: "🐢",
				x: 11,
				y: 21
			}
		],
		version: 1
	},
	lizard: {
		id: "lizard",
		name: "Lizard",
		keywords: [
			"animal",
			"nature",
			"reptile"
		],
		skins: [
			{
				unified: "1f98e",
				native: "🦎",
				x: 44,
				y: 32
			}
		],
		version: 3
	},
	snake: {
		id: "snake",
		name: "Snake",
		keywords: [
			"animal",
			"evil",
			"nature",
			"hiss",
			"python"
		],
		skins: [
			{
				unified: "1f40d",
				native: "🐍",
				x: 10,
				y: 60
			}
		],
		version: 1
	},
	dragon_face: {
		id: "dragon_face",
		name: "Dragon Face",
		keywords: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		skins: [
			{
				unified: "1f432",
				native: "🐲",
				x: 11,
				y: 37
			}
		],
		version: 1
	},
	dragon: {
		id: "dragon",
		name: "Dragon",
		keywords: [
			"animal",
			"myth",
			"nature",
			"chinese",
			"green"
		],
		skins: [
			{
				unified: "1f409",
				native: "🐉",
				x: 10,
				y: 56
			}
		],
		version: 1
	},
	sauropod: {
		id: "sauropod",
		name: "Sauropod",
		keywords: [
			"animal",
			"nature",
			"dinosaur",
			"brachiosaurus",
			"brontosaurus",
			"diplodocus",
			"extinct"
		],
		skins: [
			{
				unified: "1f995",
				native: "🦕",
				x: 44,
				y: 39
			}
		],
		version: 5
	},
	"t-rex": {
		id: "t-rex",
		name: "T-Rex",
		keywords: [
			"t",
			"rex",
			"animal",
			"nature",
			"dinosaur",
			"tyrannosaurus",
			"extinct"
		],
		skins: [
			{
				unified: "1f996",
				native: "🦖",
				x: 44,
				y: 40
			}
		],
		version: 5
	},
	whale: {
		id: "whale",
		name: "Spouting Whale",
		keywords: [
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f433",
				native: "🐳",
				x: 11,
				y: 38
			}
		],
		version: 1
	},
	whale2: {
		id: "whale2",
		name: "Whale",
		keywords: [
			"whale2",
			"animal",
			"nature",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f40b",
				native: "🐋",
				x: 10,
				y: 58
			}
		],
		version: 1
	},
	dolphin: {
		id: "dolphin",
		name: "Dolphin",
		keywords: [
			"flipper",
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"fins",
			"beach"
		],
		skins: [
			{
				unified: "1f42c",
				native: "🐬",
				x: 11,
				y: 31
			}
		],
		version: 1
	},
	seal: {
		id: "seal",
		name: "Seal",
		keywords: [
			"animal",
			"creature",
			"sea"
		],
		skins: [
			{
				unified: "1f9ad",
				native: "🦭",
				x: 45,
				y: 2
			}
		],
		version: 13
	},
	fish: {
		id: "fish",
		name: "Fish",
		keywords: [
			"animal",
			"food",
			"nature"
		],
		skins: [
			{
				unified: "1f41f",
				native: "🐟",
				x: 11,
				y: 18
			}
		],
		version: 1
	},
	tropical_fish: {
		id: "tropical_fish",
		name: "Tropical Fish",
		keywords: [
			"animal",
			"swim",
			"ocean",
			"beach",
			"nemo"
		],
		skins: [
			{
				unified: "1f420",
				native: "🐠",
				x: 11,
				y: 19
			}
		],
		version: 1
	},
	blowfish: {
		id: "blowfish",
		name: "Blowfish",
		keywords: [
			"animal",
			"nature",
			"food",
			"sea",
			"ocean"
		],
		skins: [
			{
				unified: "1f421",
				native: "🐡",
				x: 11,
				y: 20
			}
		],
		version: 1
	},
	shark: {
		id: "shark",
		name: "Shark",
		keywords: [
			"animal",
			"nature",
			"fish",
			"sea",
			"ocean",
			"jaws",
			"fins",
			"beach"
		],
		skins: [
			{
				unified: "1f988",
				native: "🦈",
				x: 44,
				y: 26
			}
		],
		version: 3
	},
	octopus: {
		id: "octopus",
		name: "Octopus",
		keywords: [
			"animal",
			"creature",
			"ocean",
			"sea",
			"nature",
			"beach"
		],
		skins: [
			{
				unified: "1f419",
				native: "🐙",
				x: 11,
				y: 12
			}
		],
		version: 1
	},
	shell: {
		id: "shell",
		name: "Spiral Shell",
		keywords: [
			"nature",
			"sea",
			"beach"
		],
		skins: [
			{
				unified: "1f41a",
				native: "🐚",
				x: 11,
				y: 13
			}
		],
		version: 1
	},
	coral: {
		id: "coral",
		name: "Coral",
		keywords: [
			"ocean",
			"sea",
			"reef"
		],
		skins: [
			{
				unified: "1fab8",
				native: "🪸",
				x: 54,
				y: 39
			}
		],
		version: 14
	},
	snail: {
		id: "snail",
		name: "Snail",
		keywords: [
			"slow",
			"animal",
			"shell"
		],
		skins: [
			{
				unified: "1f40c",
				native: "🐌",
				x: 10,
				y: 59
			}
		],
		version: 1
	},
	butterfly: {
		id: "butterfly",
		name: "Butterfly",
		keywords: [
			"animal",
			"insect",
			"nature",
			"caterpillar"
		],
		skins: [
			{
				unified: "1f98b",
				native: "🦋",
				x: 44,
				y: 29
			}
		],
		version: 3
	},
	bug: {
		id: "bug",
		name: "Bug",
		keywords: [
			"animal",
			"insect",
			"nature",
			"worm"
		],
		skins: [
			{
				unified: "1f41b",
				native: "🐛",
				x: 11,
				y: 14
			}
		],
		version: 1
	},
	ant: {
		id: "ant",
		name: "Ant",
		keywords: [
			"animal",
			"insect",
			"nature",
			"bug"
		],
		skins: [
			{
				unified: "1f41c",
				native: "🐜",
				x: 11,
				y: 15
			}
		],
		version: 1
	},
	bee: {
		id: "bee",
		name: "Honeybee",
		keywords: [
			"bee",
			"animal",
			"insect",
			"nature",
			"bug",
			"spring",
			"honey"
		],
		skins: [
			{
				unified: "1f41d",
				native: "🐝",
				x: 11,
				y: 16
			}
		],
		version: 1
	},
	beetle: {
		id: "beetle",
		name: "Beetle",
		keywords: [
			"insect"
		],
		skins: [
			{
				unified: "1fab2",
				native: "🪲",
				x: 54,
				y: 33
			}
		],
		version: 13
	},
	ladybug: {
		id: "ladybug",
		name: "Lady Beetle",
		keywords: [
			"ladybug",
			"animal",
			"insect",
			"nature"
		],
		skins: [
			{
				unified: "1f41e",
				native: "🐞",
				x: 11,
				y: 17
			}
		],
		version: 1
	},
	cricket: {
		id: "cricket",
		name: "Cricket",
		keywords: [
			"animal",
			"chirp"
		],
		skins: [
			{
				unified: "1f997",
				native: "🦗",
				x: 44,
				y: 41
			}
		],
		version: 5
	},
	cockroach: {
		id: "cockroach",
		name: "Cockroach",
		keywords: [
			"insect",
			"pests"
		],
		skins: [
			{
				unified: "1fab3",
				native: "🪳",
				x: 54,
				y: 34
			}
		],
		version: 13
	},
	spider: {
		id: "spider",
		name: "Spider",
		keywords: [
			"animal",
			"arachnid"
		],
		skins: [
			{
				unified: "1f577-fe0f",
				native: "🕷️",
				x: 31,
				y: 23
			}
		],
		version: 1
	},
	spider_web: {
		id: "spider_web",
		name: "Spider Web",
		keywords: [
			"animal",
			"insect",
			"arachnid",
			"silk"
		],
		skins: [
			{
				unified: "1f578-fe0f",
				native: "🕸️",
				x: 31,
				y: 24
			}
		],
		version: 1
	},
	scorpion: {
		id: "scorpion",
		name: "Scorpion",
		keywords: [
			"animal",
			"arachnid"
		],
		skins: [
			{
				unified: "1f982",
				native: "🦂",
				x: 44,
				y: 20
			}
		],
		version: 1
	},
	mosquito: {
		id: "mosquito",
		name: "Mosquito",
		keywords: [
			"animal",
			"nature",
			"insect",
			"malaria"
		],
		skins: [
			{
				unified: "1f99f",
				native: "🦟",
				x: 44,
				y: 49
			}
		],
		version: 11
	},
	fly: {
		id: "fly",
		name: "Fly",
		keywords: [
			"insect"
		],
		skins: [
			{
				unified: "1fab0",
				native: "🪰",
				x: 54,
				y: 31
			}
		],
		version: 13
	},
	worm: {
		id: "worm",
		name: "Worm",
		keywords: [
			"animal"
		],
		skins: [
			{
				unified: "1fab1",
				native: "🪱",
				x: 54,
				y: 32
			}
		],
		version: 13
	},
	microbe: {
		id: "microbe",
		name: "Microbe",
		keywords: [
			"amoeba",
			"bacteria",
			"germs",
			"virus"
		],
		skins: [
			{
				unified: "1f9a0",
				native: "🦠",
				x: 44,
				y: 50
			}
		],
		version: 11
	},
	bouquet: {
		id: "bouquet",
		name: "Bouquet",
		keywords: [
			"flowers",
			"nature",
			"spring"
		],
		skins: [
			{
				unified: "1f490",
				native: "💐",
				x: 27,
				y: 6
			}
		],
		version: 1
	},
	cherry_blossom: {
		id: "cherry_blossom",
		name: "Cherry Blossom",
		keywords: [
			"nature",
			"plant",
			"spring",
			"flower"
		],
		skins: [
			{
				unified: "1f338",
				native: "🌸",
				x: 5,
				y: 53
			}
		],
		version: 1
	},
	white_flower: {
		id: "white_flower",
		name: "White Flower",
		keywords: [
			"japanese",
			"spring"
		],
		skins: [
			{
				unified: "1f4ae",
				native: "💮",
				x: 28,
				y: 5
			}
		],
		version: 1
	},
	lotus: {
		id: "lotus",
		name: "Lotus",
		keywords: [
			"flower",
			"calm",
			"meditation"
		],
		skins: [
			{
				unified: "1fab7",
				native: "🪷",
				x: 54,
				y: 38
			}
		],
		version: 14
	},
	rosette: {
		id: "rosette",
		name: "Rosette",
		keywords: [
			"flower",
			"decoration",
			"military"
		],
		skins: [
			{
				unified: "1f3f5-fe0f",
				native: "🏵️",
				x: 10,
				y: 36
			}
		],
		version: 1
	},
	rose: {
		id: "rose",
		name: "Rose",
		keywords: [
			"flowers",
			"valentines",
			"love",
			"spring"
		],
		skins: [
			{
				unified: "1f339",
				native: "🌹",
				x: 5,
				y: 54
			}
		],
		version: 1
	},
	wilted_flower: {
		id: "wilted_flower",
		name: "Wilted Flower",
		keywords: [
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f940",
				native: "🥀",
				x: 43,
				y: 11
			}
		],
		version: 3
	},
	hibiscus: {
		id: "hibiscus",
		name: "Hibiscus",
		keywords: [
			"plant",
			"vegetable",
			"flowers",
			"beach"
		],
		skins: [
			{
				unified: "1f33a",
				native: "🌺",
				x: 5,
				y: 55
			}
		],
		version: 1
	},
	sunflower: {
		id: "sunflower",
		name: "Sunflower",
		keywords: [
			"nature",
			"plant",
			"fall"
		],
		skins: [
			{
				unified: "1f33b",
				native: "🌻",
				x: 5,
				y: 56
			}
		],
		version: 1
	},
	blossom: {
		id: "blossom",
		name: "Blossom",
		keywords: [
			"nature",
			"flowers",
			"yellow"
		],
		skins: [
			{
				unified: "1f33c",
				native: "🌼",
				x: 5,
				y: 57
			}
		],
		version: 1
	},
	tulip: {
		id: "tulip",
		name: "Tulip",
		keywords: [
			"flowers",
			"plant",
			"nature",
			"summer",
			"spring"
		],
		skins: [
			{
				unified: "1f337",
				native: "🌷",
				x: 5,
				y: 52
			}
		],
		version: 1
	},
	seedling: {
		id: "seedling",
		name: "Seedling",
		keywords: [
			"plant",
			"nature",
			"grass",
			"lawn",
			"spring"
		],
		skins: [
			{
				unified: "1f331",
				native: "🌱",
				x: 5,
				y: 46
			}
		],
		version: 1
	},
	potted_plant: {
		id: "potted_plant",
		name: "Potted Plant",
		keywords: [
			"greenery",
			"house"
		],
		skins: [
			{
				unified: "1fab4",
				native: "🪴",
				x: 54,
				y: 35
			}
		],
		version: 13
	},
	evergreen_tree: {
		id: "evergreen_tree",
		name: "Evergreen Tree",
		keywords: [
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f332",
				native: "🌲",
				x: 5,
				y: 47
			}
		],
		version: 1
	},
	deciduous_tree: {
		id: "deciduous_tree",
		name: "Deciduous Tree",
		keywords: [
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f333",
				native: "🌳",
				x: 5,
				y: 48
			}
		],
		version: 1
	},
	palm_tree: {
		id: "palm_tree",
		name: "Palm Tree",
		keywords: [
			"plant",
			"vegetable",
			"nature",
			"summer",
			"beach",
			"mojito",
			"tropical"
		],
		skins: [
			{
				unified: "1f334",
				native: "🌴",
				x: 5,
				y: 49
			}
		],
		version: 1
	},
	cactus: {
		id: "cactus",
		name: "Cactus",
		keywords: [
			"vegetable",
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f335",
				native: "🌵",
				x: 5,
				y: 50
			}
		],
		version: 1
	},
	ear_of_rice: {
		id: "ear_of_rice",
		name: "Ear of Rice",
		keywords: [
			"sheaf",
			"nature",
			"plant"
		],
		skins: [
			{
				unified: "1f33e",
				native: "🌾",
				x: 5,
				y: 59
			}
		],
		version: 1
	},
	herb: {
		id: "herb",
		name: "Herb",
		keywords: [
			"vegetable",
			"plant",
			"medicine",
			"weed",
			"grass",
			"lawn"
		],
		skins: [
			{
				unified: "1f33f",
				native: "🌿",
				x: 5,
				y: 60
			}
		],
		version: 1
	},
	shamrock: {
		id: "shamrock",
		name: "Shamrock",
		keywords: [
			"vegetable",
			"plant",
			"nature",
			"irish",
			"clover"
		],
		skins: [
			{
				unified: "2618-fe0f",
				native: "☘️",
				x: 56,
				y: 49
			}
		],
		version: 1
	},
	four_leaf_clover: {
		id: "four_leaf_clover",
		name: "Four Leaf Clover",
		keywords: [
			"vegetable",
			"plant",
			"nature",
			"lucky",
			"irish"
		],
		skins: [
			{
				unified: "1f340",
				native: "🍀",
				x: 6,
				y: 0
			}
		],
		version: 1
	},
	maple_leaf: {
		id: "maple_leaf",
		name: "Maple Leaf",
		keywords: [
			"nature",
			"plant",
			"vegetable",
			"ca",
			"fall"
		],
		skins: [
			{
				unified: "1f341",
				native: "🍁",
				x: 6,
				y: 1
			}
		],
		version: 1
	},
	fallen_leaf: {
		id: "fallen_leaf",
		name: "Fallen Leaf",
		keywords: [
			"nature",
			"plant",
			"vegetable",
			"leaves"
		],
		skins: [
			{
				unified: "1f342",
				native: "🍂",
				x: 6,
				y: 2
			}
		],
		version: 1
	},
	leaves: {
		id: "leaves",
		name: "Leaf Fluttering in Wind",
		keywords: [
			"leaves",
			"nature",
			"plant",
			"tree",
			"vegetable",
			"grass",
			"lawn",
			"spring"
		],
		skins: [
			{
				unified: "1f343",
				native: "🍃",
				x: 6,
				y: 3
			}
		],
		version: 1
	},
	empty_nest: {
		id: "empty_nest",
		name: "Empty Nest",
		keywords: [
			"bird"
		],
		skins: [
			{
				unified: "1fab9",
				native: "🪹",
				x: 54,
				y: 40
			}
		],
		version: 14
	},
	nest_with_eggs: {
		id: "nest_with_eggs",
		name: "Nest with Eggs",
		keywords: [
			"bird"
		],
		skins: [
			{
				unified: "1faba",
				native: "🪺",
				x: 54,
				y: 41
			}
		],
		version: 14
	},
	grapes: {
		id: "grapes",
		name: "Grapes",
		keywords: [
			"fruit",
			"food",
			"wine"
		],
		skins: [
			{
				unified: "1f347",
				native: "🍇",
				x: 6,
				y: 7
			}
		],
		version: 1
	},
	melon: {
		id: "melon",
		name: "Melon",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f348",
				native: "🍈",
				x: 6,
				y: 8
			}
		],
		version: 1
	},
	watermelon: {
		id: "watermelon",
		name: "Watermelon",
		keywords: [
			"fruit",
			"food",
			"picnic",
			"summer"
		],
		skins: [
			{
				unified: "1f349",
				native: "🍉",
				x: 6,
				y: 9
			}
		],
		version: 1
	},
	tangerine: {
		id: "tangerine",
		name: "Tangerine",
		keywords: [
			"food",
			"fruit",
			"nature",
			"orange"
		],
		skins: [
			{
				unified: "1f34a",
				native: "🍊",
				x: 6,
				y: 10
			}
		],
		version: 1
	},
	lemon: {
		id: "lemon",
		name: "Lemon",
		keywords: [
			"fruit",
			"nature"
		],
		skins: [
			{
				unified: "1f34b",
				native: "🍋",
				x: 6,
				y: 11
			}
		],
		version: 1
	},
	banana: {
		id: "banana",
		name: "Banana",
		keywords: [
			"fruit",
			"food",
			"monkey"
		],
		skins: [
			{
				unified: "1f34c",
				native: "🍌",
				x: 6,
				y: 12
			}
		],
		version: 1
	},
	pineapple: {
		id: "pineapple",
		name: "Pineapple",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f34d",
				native: "🍍",
				x: 6,
				y: 13
			}
		],
		version: 1
	},
	mango: {
		id: "mango",
		name: "Mango",
		keywords: [
			"fruit",
			"food",
			"tropical"
		],
		skins: [
			{
				unified: "1f96d",
				native: "🥭",
				x: 43,
				y: 55
			}
		],
		version: 11
	},
	apple: {
		id: "apple",
		name: "Red Apple",
		keywords: [
			"fruit",
			"mac",
			"school"
		],
		skins: [
			{
				unified: "1f34e",
				native: "🍎",
				x: 6,
				y: 14
			}
		],
		version: 1
	},
	green_apple: {
		id: "green_apple",
		name: "Green Apple",
		keywords: [
			"fruit",
			"nature"
		],
		skins: [
			{
				unified: "1f34f",
				native: "🍏",
				x: 6,
				y: 15
			}
		],
		version: 1
	},
	pear: {
		id: "pear",
		name: "Pear",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f350",
				native: "🍐",
				x: 6,
				y: 16
			}
		],
		version: 1
	},
	peach: {
		id: "peach",
		name: "Peach",
		keywords: [
			"fruit",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f351",
				native: "🍑",
				x: 6,
				y: 17
			}
		],
		version: 1
	},
	cherries: {
		id: "cherries",
		name: "Cherries",
		keywords: [
			"food",
			"fruit"
		],
		skins: [
			{
				unified: "1f352",
				native: "🍒",
				x: 6,
				y: 18
			}
		],
		version: 1
	},
	strawberry: {
		id: "strawberry",
		name: "Strawberry",
		keywords: [
			"fruit",
			"food",
			"nature"
		],
		skins: [
			{
				unified: "1f353",
				native: "🍓",
				x: 6,
				y: 19
			}
		],
		version: 1
	},
	blueberries: {
		id: "blueberries",
		name: "Blueberries",
		keywords: [
			"fruit"
		],
		skins: [
			{
				unified: "1fad0",
				native: "🫐",
				x: 55,
				y: 2
			}
		],
		version: 13
	},
	kiwifruit: {
		id: "kiwifruit",
		name: "Kiwifruit",
		keywords: [
			"kiwi",
			"fruit",
			"food"
		],
		skins: [
			{
				unified: "1f95d",
				native: "🥝",
				x: 43,
				y: 39
			}
		],
		version: 3
	},
	tomato: {
		id: "tomato",
		name: "Tomato",
		keywords: [
			"fruit",
			"vegetable",
			"nature",
			"food"
		],
		skins: [
			{
				unified: "1f345",
				native: "🍅",
				x: 6,
				y: 5
			}
		],
		version: 1
	},
	olive: {
		id: "olive",
		name: "Olive",
		keywords: [
			"fruit"
		],
		skins: [
			{
				unified: "1fad2",
				native: "🫒",
				x: 55,
				y: 4
			}
		],
		version: 13
	},
	coconut: {
		id: "coconut",
		name: "Coconut",
		keywords: [
			"fruit",
			"nature",
			"food",
			"palm"
		],
		skins: [
			{
				unified: "1f965",
				native: "🥥",
				x: 43,
				y: 47
			}
		],
		version: 5
	},
	avocado: {
		id: "avocado",
		name: "Avocado",
		keywords: [
			"fruit",
			"food"
		],
		skins: [
			{
				unified: "1f951",
				native: "🥑",
				x: 43,
				y: 27
			}
		],
		version: 3
	},
	eggplant: {
		id: "eggplant",
		name: "Eggplant",
		keywords: [
			"vegetable",
			"nature",
			"food",
			"aubergine"
		],
		skins: [
			{
				unified: "1f346",
				native: "🍆",
				x: 6,
				y: 6
			}
		],
		version: 1
	},
	potato: {
		id: "potato",
		name: "Potato",
		keywords: [
			"food",
			"tuber",
			"vegatable",
			"starch"
		],
		skins: [
			{
				unified: "1f954",
				native: "🥔",
				x: 43,
				y: 30
			}
		],
		version: 3
	},
	carrot: {
		id: "carrot",
		name: "Carrot",
		keywords: [
			"vegetable",
			"food",
			"orange"
		],
		skins: [
			{
				unified: "1f955",
				native: "🥕",
				x: 43,
				y: 31
			}
		],
		version: 3
	},
	corn: {
		id: "corn",
		name: "Ear of Corn",
		keywords: [
			"food",
			"vegetable",
			"plant"
		],
		skins: [
			{
				unified: "1f33d",
				native: "🌽",
				x: 5,
				y: 58
			}
		],
		version: 1
	},
	hot_pepper: {
		id: "hot_pepper",
		name: "Hot Pepper",
		keywords: [
			"food",
			"spicy",
			"chilli",
			"chili"
		],
		skins: [
			{
				unified: "1f336-fe0f",
				native: "🌶️",
				x: 5,
				y: 51
			}
		],
		version: 1
	},
	bell_pepper: {
		id: "bell_pepper",
		name: "Bell Pepper",
		keywords: [
			"fruit",
			"plant"
		],
		skins: [
			{
				unified: "1fad1",
				native: "🫑",
				x: 55,
				y: 3
			}
		],
		version: 13
	},
	cucumber: {
		id: "cucumber",
		name: "Cucumber",
		keywords: [
			"fruit",
			"food",
			"pickle"
		],
		skins: [
			{
				unified: "1f952",
				native: "🥒",
				x: 43,
				y: 28
			}
		],
		version: 3
	},
	leafy_green: {
		id: "leafy_green",
		name: "Leafy Green",
		keywords: [
			"food",
			"vegetable",
			"plant",
			"bok",
			"choy",
			"cabbage",
			"kale",
			"lettuce"
		],
		skins: [
			{
				unified: "1f96c",
				native: "🥬",
				x: 43,
				y: 54
			}
		],
		version: 11
	},
	broccoli: {
		id: "broccoli",
		name: "Broccoli",
		keywords: [
			"fruit",
			"food",
			"vegetable"
		],
		skins: [
			{
				unified: "1f966",
				native: "🥦",
				x: 43,
				y: 48
			}
		],
		version: 5
	},
	garlic: {
		id: "garlic",
		name: "Garlic",
		keywords: [
			"food",
			"spice",
			"cook"
		],
		skins: [
			{
				unified: "1f9c4",
				native: "🧄",
				x: 46,
				y: 9
			}
		],
		version: 12
	},
	onion: {
		id: "onion",
		name: "Onion",
		keywords: [
			"cook",
			"food",
			"spice"
		],
		skins: [
			{
				unified: "1f9c5",
				native: "🧅",
				x: 46,
				y: 10
			}
		],
		version: 12
	},
	mushroom: {
		id: "mushroom",
		name: "Mushroom",
		keywords: [
			"plant",
			"vegetable"
		],
		skins: [
			{
				unified: "1f344",
				native: "🍄",
				x: 6,
				y: 4
			}
		],
		version: 1
	},
	peanuts: {
		id: "peanuts",
		name: "Peanuts",
		keywords: [
			"food",
			"nut"
		],
		skins: [
			{
				unified: "1f95c",
				native: "🥜",
				x: 43,
				y: 38
			}
		],
		version: 3
	},
	beans: {
		id: "beans",
		name: "Beans",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1fad8",
				native: "🫘",
				x: 55,
				y: 10
			}
		],
		version: 14
	},
	chestnut: {
		id: "chestnut",
		name: "Chestnut",
		keywords: [
			"food",
			"squirrel"
		],
		skins: [
			{
				unified: "1f330",
				native: "🌰",
				x: 5,
				y: 45
			}
		],
		version: 1
	},
	bread: {
		id: "bread",
		name: "Bread",
		keywords: [
			"food",
			"wheat",
			"breakfast",
			"toast"
		],
		skins: [
			{
				unified: "1f35e",
				native: "🍞",
				x: 6,
				y: 30
			}
		],
		version: 1
	},
	croissant: {
		id: "croissant",
		name: "Croissant",
		keywords: [
			"food",
			"bread",
			"french"
		],
		skins: [
			{
				unified: "1f950",
				native: "🥐",
				x: 43,
				y: 26
			}
		],
		version: 3
	},
	baguette_bread: {
		id: "baguette_bread",
		name: "Baguette Bread",
		keywords: [
			"food",
			"french"
		],
		skins: [
			{
				unified: "1f956",
				native: "🥖",
				x: 43,
				y: 32
			}
		],
		version: 3
	},
	flatbread: {
		id: "flatbread",
		name: "Flatbread",
		keywords: [
			"flour",
			"food"
		],
		skins: [
			{
				unified: "1fad3",
				native: "🫓",
				x: 55,
				y: 5
			}
		],
		version: 13
	},
	pretzel: {
		id: "pretzel",
		name: "Pretzel",
		keywords: [
			"food",
			"bread",
			"twisted"
		],
		skins: [
			{
				unified: "1f968",
				native: "🥨",
				x: 43,
				y: 50
			}
		],
		version: 5
	},
	bagel: {
		id: "bagel",
		name: "Bagel",
		keywords: [
			"food",
			"bread",
			"bakery",
			"schmear"
		],
		skins: [
			{
				unified: "1f96f",
				native: "🥯",
				x: 43,
				y: 57
			}
		],
		version: 11
	},
	pancakes: {
		id: "pancakes",
		name: "Pancakes",
		keywords: [
			"food",
			"breakfast",
			"flapjacks",
			"hotcakes"
		],
		skins: [
			{
				unified: "1f95e",
				native: "🥞",
				x: 43,
				y: 40
			}
		],
		version: 3
	},
	waffle: {
		id: "waffle",
		name: "Waffle",
		keywords: [
			"food",
			"breakfast"
		],
		skins: [
			{
				unified: "1f9c7",
				native: "🧇",
				x: 46,
				y: 12
			}
		],
		version: 12
	},
	cheese_wedge: {
		id: "cheese_wedge",
		name: "Cheese Wedge",
		keywords: [
			"food",
			"chadder"
		],
		skins: [
			{
				unified: "1f9c0",
				native: "🧀",
				x: 46,
				y: 5
			}
		],
		version: 1
	},
	meat_on_bone: {
		id: "meat_on_bone",
		name: "Meat on Bone",
		keywords: [
			"good",
			"food",
			"drumstick"
		],
		skins: [
			{
				unified: "1f356",
				native: "🍖",
				x: 6,
				y: 22
			}
		],
		version: 1
	},
	poultry_leg: {
		id: "poultry_leg",
		name: "Poultry Leg",
		keywords: [
			"food",
			"meat",
			"drumstick",
			"bird",
			"chicken",
			"turkey"
		],
		skins: [
			{
				unified: "1f357",
				native: "🍗",
				x: 6,
				y: 23
			}
		],
		version: 1
	},
	cut_of_meat: {
		id: "cut_of_meat",
		name: "Cut of Meat",
		keywords: [
			"food",
			"cow",
			"chop",
			"lambchop",
			"porkchop"
		],
		skins: [
			{
				unified: "1f969",
				native: "🥩",
				x: 43,
				y: 51
			}
		],
		version: 5
	},
	bacon: {
		id: "bacon",
		name: "Bacon",
		keywords: [
			"food",
			"breakfast",
			"pork",
			"pig",
			"meat"
		],
		skins: [
			{
				unified: "1f953",
				native: "🥓",
				x: 43,
				y: 29
			}
		],
		version: 3
	},
	hamburger: {
		id: "hamburger",
		name: "Hamburger",
		keywords: [
			"meat",
			"fast",
			"food",
			"beef",
			"cheeseburger",
			"mcdonalds",
			"burger",
			"king"
		],
		skins: [
			{
				unified: "1f354",
				native: "🍔",
				x: 6,
				y: 20
			}
		],
		version: 1
	},
	fries: {
		id: "fries",
		name: "French Fries",
		keywords: [
			"chips",
			"snack",
			"fast",
			"food"
		],
		skins: [
			{
				unified: "1f35f",
				native: "🍟",
				x: 6,
				y: 31
			}
		],
		version: 1
	},
	pizza: {
		id: "pizza",
		name: "Pizza",
		keywords: [
			"food",
			"party"
		],
		skins: [
			{
				unified: "1f355",
				native: "🍕",
				x: 6,
				y: 21
			}
		],
		version: 1
	},
	hotdog: {
		id: "hotdog",
		name: "Hot Dog",
		keywords: [
			"hotdog",
			"food",
			"frankfurter"
		],
		skins: [
			{
				unified: "1f32d",
				native: "🌭",
				x: 5,
				y: 42
			}
		],
		version: 1
	},
	sandwich: {
		id: "sandwich",
		name: "Sandwich",
		keywords: [
			"food",
			"lunch",
			"bread"
		],
		skins: [
			{
				unified: "1f96a",
				native: "🥪",
				x: 43,
				y: 52
			}
		],
		version: 5
	},
	taco: {
		id: "taco",
		name: "Taco",
		keywords: [
			"food",
			"mexican"
		],
		skins: [
			{
				unified: "1f32e",
				native: "🌮",
				x: 5,
				y: 43
			}
		],
		version: 1
	},
	burrito: {
		id: "burrito",
		name: "Burrito",
		keywords: [
			"food",
			"mexican"
		],
		skins: [
			{
				unified: "1f32f",
				native: "🌯",
				x: 5,
				y: 44
			}
		],
		version: 1
	},
	tamale: {
		id: "tamale",
		name: "Tamale",
		keywords: [
			"food",
			"masa"
		],
		skins: [
			{
				unified: "1fad4",
				native: "🫔",
				x: 55,
				y: 6
			}
		],
		version: 13
	},
	stuffed_flatbread: {
		id: "stuffed_flatbread",
		name: "Stuffed Flatbread",
		keywords: [
			"food",
			"gyro"
		],
		skins: [
			{
				unified: "1f959",
				native: "🥙",
				x: 43,
				y: 35
			}
		],
		version: 3
	},
	falafel: {
		id: "falafel",
		name: "Falafel",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1f9c6",
				native: "🧆",
				x: 46,
				y: 11
			}
		],
		version: 12
	},
	egg: {
		id: "egg",
		name: "Egg",
		keywords: [
			"food",
			"chicken",
			"breakfast"
		],
		skins: [
			{
				unified: "1f95a",
				native: "🥚",
				x: 43,
				y: 36
			}
		],
		version: 3
	},
	fried_egg: {
		id: "fried_egg",
		name: "Cooking",
		keywords: [
			"fried",
			"egg",
			"food",
			"breakfast",
			"kitchen"
		],
		skins: [
			{
				unified: "1f373",
				native: "🍳",
				x: 6,
				y: 51
			}
		],
		version: 1
	},
	shallow_pan_of_food: {
		id: "shallow_pan_of_food",
		name: "Shallow Pan of Food",
		keywords: [
			"cooking",
			"casserole",
			"paella"
		],
		skins: [
			{
				unified: "1f958",
				native: "🥘",
				x: 43,
				y: 34
			}
		],
		version: 3
	},
	stew: {
		id: "stew",
		name: "Pot of Food",
		keywords: [
			"stew",
			"meat",
			"soup"
		],
		skins: [
			{
				unified: "1f372",
				native: "🍲",
				x: 6,
				y: 50
			}
		],
		version: 1
	},
	fondue: {
		id: "fondue",
		name: "Fondue",
		keywords: [
			"cheese",
			"pot",
			"food"
		],
		skins: [
			{
				unified: "1fad5",
				native: "🫕",
				x: 55,
				y: 7
			}
		],
		version: 13
	},
	bowl_with_spoon: {
		id: "bowl_with_spoon",
		name: "Bowl with Spoon",
		keywords: [
			"food",
			"breakfast",
			"cereal",
			"oatmeal",
			"porridge"
		],
		skins: [
			{
				unified: "1f963",
				native: "🥣",
				x: 43,
				y: 45
			}
		],
		version: 5
	},
	green_salad: {
		id: "green_salad",
		name: "Green Salad",
		keywords: [
			"food",
			"healthy",
			"lettuce"
		],
		skins: [
			{
				unified: "1f957",
				native: "🥗",
				x: 43,
				y: 33
			}
		],
		version: 3
	},
	popcorn: {
		id: "popcorn",
		name: "Popcorn",
		keywords: [
			"food",
			"movie",
			"theater",
			"films",
			"snack"
		],
		skins: [
			{
				unified: "1f37f",
				native: "🍿",
				x: 7,
				y: 2
			}
		],
		version: 1
	},
	butter: {
		id: "butter",
		name: "Butter",
		keywords: [
			"food",
			"cook"
		],
		skins: [
			{
				unified: "1f9c8",
				native: "🧈",
				x: 46,
				y: 13
			}
		],
		version: 12
	},
	salt: {
		id: "salt",
		name: "Salt",
		keywords: [
			"condiment",
			"shaker"
		],
		skins: [
			{
				unified: "1f9c2",
				native: "🧂",
				x: 46,
				y: 7
			}
		],
		version: 11
	},
	canned_food: {
		id: "canned_food",
		name: "Canned Food",
		keywords: [
			"soup"
		],
		skins: [
			{
				unified: "1f96b",
				native: "🥫",
				x: 43,
				y: 53
			}
		],
		version: 5
	},
	bento: {
		id: "bento",
		name: "Bento Box",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f371",
				native: "🍱",
				x: 6,
				y: 49
			}
		],
		version: 1
	},
	rice_cracker: {
		id: "rice_cracker",
		name: "Rice Cracker",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f358",
				native: "🍘",
				x: 6,
				y: 24
			}
		],
		version: 1
	},
	rice_ball: {
		id: "rice_ball",
		name: "Rice Ball",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f359",
				native: "🍙",
				x: 6,
				y: 25
			}
		],
		version: 1
	},
	rice: {
		id: "rice",
		name: "Cooked Rice",
		keywords: [
			"food",
			"china",
			"asian"
		],
		skins: [
			{
				unified: "1f35a",
				native: "🍚",
				x: 6,
				y: 26
			}
		],
		version: 1
	},
	curry: {
		id: "curry",
		name: "Curry Rice",
		keywords: [
			"food",
			"spicy",
			"hot",
			"indian"
		],
		skins: [
			{
				unified: "1f35b",
				native: "🍛",
				x: 6,
				y: 27
			}
		],
		version: 1
	},
	ramen: {
		id: "ramen",
		name: "Steaming Bowl",
		keywords: [
			"ramen",
			"food",
			"japanese",
			"noodle",
			"chopsticks"
		],
		skins: [
			{
				unified: "1f35c",
				native: "🍜",
				x: 6,
				y: 28
			}
		],
		version: 1
	},
	spaghetti: {
		id: "spaghetti",
		name: "Spaghetti",
		keywords: [
			"food",
			"italian",
			"noodle"
		],
		skins: [
			{
				unified: "1f35d",
				native: "🍝",
				x: 6,
				y: 29
			}
		],
		version: 1
	},
	sweet_potato: {
		id: "sweet_potato",
		name: "Roasted Sweet Potato",
		keywords: [
			"food",
			"nature"
		],
		skins: [
			{
				unified: "1f360",
				native: "🍠",
				x: 6,
				y: 32
			}
		],
		version: 1
	},
	oden: {
		id: "oden",
		name: "Oden",
		keywords: [
			"food",
			"japanese"
		],
		skins: [
			{
				unified: "1f362",
				native: "🍢",
				x: 6,
				y: 34
			}
		],
		version: 1
	},
	sushi: {
		id: "sushi",
		name: "Sushi",
		keywords: [
			"food",
			"fish",
			"japanese",
			"rice"
		],
		skins: [
			{
				unified: "1f363",
				native: "🍣",
				x: 6,
				y: 35
			}
		],
		version: 1
	},
	fried_shrimp: {
		id: "fried_shrimp",
		name: "Fried Shrimp",
		keywords: [
			"food",
			"animal",
			"appetizer",
			"summer"
		],
		skins: [
			{
				unified: "1f364",
				native: "🍤",
				x: 6,
				y: 36
			}
		],
		version: 1
	},
	fish_cake: {
		id: "fish_cake",
		name: "Fish Cake with Swirl",
		keywords: [
			"food",
			"japan",
			"sea",
			"beach",
			"narutomaki",
			"pink",
			"kamaboko",
			"surimi",
			"ramen"
		],
		skins: [
			{
				unified: "1f365",
				native: "🍥",
				x: 6,
				y: 37
			}
		],
		version: 1
	},
	moon_cake: {
		id: "moon_cake",
		name: "Moon Cake",
		keywords: [
			"food",
			"autumn"
		],
		skins: [
			{
				unified: "1f96e",
				native: "🥮",
				x: 43,
				y: 56
			}
		],
		version: 11
	},
	dango: {
		id: "dango",
		name: "Dango",
		keywords: [
			"food",
			"dessert",
			"sweet",
			"japanese",
			"barbecue",
			"meat"
		],
		skins: [
			{
				unified: "1f361",
				native: "🍡",
				x: 6,
				y: 33
			}
		],
		version: 1
	},
	dumpling: {
		id: "dumpling",
		name: "Dumpling",
		keywords: [
			"food",
			"empanada",
			"pierogi",
			"potsticker"
		],
		skins: [
			{
				unified: "1f95f",
				native: "🥟",
				x: 43,
				y: 41
			}
		],
		version: 5
	},
	fortune_cookie: {
		id: "fortune_cookie",
		name: "Fortune Cookie",
		keywords: [
			"food",
			"prophecy"
		],
		skins: [
			{
				unified: "1f960",
				native: "🥠",
				x: 43,
				y: 42
			}
		],
		version: 5
	},
	takeout_box: {
		id: "takeout_box",
		name: "Takeout Box",
		keywords: [
			"food",
			"leftovers"
		],
		skins: [
			{
				unified: "1f961",
				native: "🥡",
				x: 43,
				y: 43
			}
		],
		version: 5
	},
	crab: {
		id: "crab",
		name: "Crab",
		keywords: [
			"animal",
			"crustacean"
		],
		skins: [
			{
				unified: "1f980",
				native: "🦀",
				x: 44,
				y: 18
			}
		],
		version: 1
	},
	lobster: {
		id: "lobster",
		name: "Lobster",
		keywords: [
			"animal",
			"nature",
			"bisque",
			"claws",
			"seafood"
		],
		skins: [
			{
				unified: "1f99e",
				native: "🦞",
				x: 44,
				y: 48
			}
		],
		version: 11
	},
	shrimp: {
		id: "shrimp",
		name: "Shrimp",
		keywords: [
			"animal",
			"ocean",
			"nature",
			"seafood"
		],
		skins: [
			{
				unified: "1f990",
				native: "🦐",
				x: 44,
				y: 34
			}
		],
		version: 3
	},
	squid: {
		id: "squid",
		name: "Squid",
		keywords: [
			"animal",
			"nature",
			"ocean",
			"sea"
		],
		skins: [
			{
				unified: "1f991",
				native: "🦑",
				x: 44,
				y: 35
			}
		],
		version: 3
	},
	oyster: {
		id: "oyster",
		name: "Oyster",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1f9aa",
				native: "🦪",
				x: 44,
				y: 60
			}
		],
		version: 12
	},
	icecream: {
		id: "icecream",
		name: "Soft Ice Cream",
		keywords: [
			"icecream",
			"food",
			"hot",
			"dessert",
			"summer"
		],
		skins: [
			{
				unified: "1f366",
				native: "🍦",
				x: 6,
				y: 38
			}
		],
		version: 1
	},
	shaved_ice: {
		id: "shaved_ice",
		name: "Shaved Ice",
		keywords: [
			"hot",
			"dessert",
			"summer"
		],
		skins: [
			{
				unified: "1f367",
				native: "🍧",
				x: 6,
				y: 39
			}
		],
		version: 1
	},
	ice_cream: {
		id: "ice_cream",
		name: "Ice Cream",
		keywords: [
			"food",
			"hot",
			"dessert"
		],
		skins: [
			{
				unified: "1f368",
				native: "🍨",
				x: 6,
				y: 40
			}
		],
		version: 1
	},
	doughnut: {
		id: "doughnut",
		name: "Doughnut",
		keywords: [
			"food",
			"dessert",
			"snack",
			"sweet",
			"donut"
		],
		skins: [
			{
				unified: "1f369",
				native: "🍩",
				x: 6,
				y: 41
			}
		],
		version: 1
	},
	cookie: {
		id: "cookie",
		name: "Cookie",
		keywords: [
			"food",
			"snack",
			"oreo",
			"chocolate",
			"sweet",
			"dessert"
		],
		skins: [
			{
				unified: "1f36a",
				native: "🍪",
				x: 6,
				y: 42
			}
		],
		version: 1
	},
	birthday: {
		id: "birthday",
		name: "Birthday Cake",
		keywords: [
			"food",
			"dessert"
		],
		skins: [
			{
				unified: "1f382",
				native: "🎂",
				x: 7,
				y: 5
			}
		],
		version: 1
	},
	cake: {
		id: "cake",
		name: "Shortcake",
		keywords: [
			"cake",
			"food",
			"dessert"
		],
		skins: [
			{
				unified: "1f370",
				native: "🍰",
				x: 6,
				y: 48
			}
		],
		version: 1
	},
	cupcake: {
		id: "cupcake",
		name: "Cupcake",
		keywords: [
			"food",
			"dessert",
			"bakery",
			"sweet"
		],
		skins: [
			{
				unified: "1f9c1",
				native: "🧁",
				x: 46,
				y: 6
			}
		],
		version: 11
	},
	pie: {
		id: "pie",
		name: "Pie",
		keywords: [
			"food",
			"dessert",
			"pastry"
		],
		skins: [
			{
				unified: "1f967",
				native: "🥧",
				x: 43,
				y: 49
			}
		],
		version: 5
	},
	chocolate_bar: {
		id: "chocolate_bar",
		name: "Chocolate Bar",
		keywords: [
			"food",
			"snack",
			"dessert",
			"sweet"
		],
		skins: [
			{
				unified: "1f36b",
				native: "🍫",
				x: 6,
				y: 43
			}
		],
		version: 1
	},
	candy: {
		id: "candy",
		name: "Candy",
		keywords: [
			"snack",
			"dessert",
			"sweet",
			"lolly"
		],
		skins: [
			{
				unified: "1f36c",
				native: "🍬",
				x: 6,
				y: 44
			}
		],
		version: 1
	},
	lollipop: {
		id: "lollipop",
		name: "Lollipop",
		keywords: [
			"food",
			"snack",
			"candy",
			"sweet"
		],
		skins: [
			{
				unified: "1f36d",
				native: "🍭",
				x: 6,
				y: 45
			}
		],
		version: 1
	},
	custard: {
		id: "custard",
		name: "Custard",
		keywords: [
			"dessert",
			"food"
		],
		skins: [
			{
				unified: "1f36e",
				native: "🍮",
				x: 6,
				y: 46
			}
		],
		version: 1
	},
	honey_pot: {
		id: "honey_pot",
		name: "Honey Pot",
		keywords: [
			"bees",
			"sweet",
			"kitchen"
		],
		skins: [
			{
				unified: "1f36f",
				native: "🍯",
				x: 6,
				y: 47
			}
		],
		version: 1
	},
	baby_bottle: {
		id: "baby_bottle",
		name: "Baby Bottle",
		keywords: [
			"food",
			"container",
			"milk"
		],
		skins: [
			{
				unified: "1f37c",
				native: "🍼",
				x: 6,
				y: 60
			}
		],
		version: 1
	},
	glass_of_milk: {
		id: "glass_of_milk",
		name: "Glass of Milk",
		keywords: [
			"beverage",
			"drink",
			"cow"
		],
		skins: [
			{
				unified: "1f95b",
				native: "🥛",
				x: 43,
				y: 37
			}
		],
		version: 3
	},
	coffee: {
		id: "coffee",
		name: "Hot Beverage",
		keywords: [
			"coffee",
			"caffeine",
			"latte",
			"espresso"
		],
		skins: [
			{
				unified: "2615",
				native: "☕",
				x: 56,
				y: 48
			}
		],
		version: 1
	},
	teapot: {
		id: "teapot",
		name: "Teapot",
		keywords: [
			"drink",
			"hot"
		],
		skins: [
			{
				unified: "1fad6",
				native: "🫖",
				x: 55,
				y: 8
			}
		],
		version: 13
	},
	tea: {
		id: "tea",
		name: "Teacup Without Handle",
		keywords: [
			"tea",
			"drink",
			"bowl",
			"breakfast",
			"green",
			"british"
		],
		skins: [
			{
				unified: "1f375",
				native: "🍵",
				x: 6,
				y: 53
			}
		],
		version: 1
	},
	sake: {
		id: "sake",
		name: "Sake",
		keywords: [
			"wine",
			"drink",
			"drunk",
			"beverage",
			"japanese",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f376",
				native: "🍶",
				x: 6,
				y: 54
			}
		],
		version: 1
	},
	champagne: {
		id: "champagne",
		name: "Bottle with Popping Cork",
		keywords: [
			"champagne",
			"drink",
			"wine",
			"celebration"
		],
		skins: [
			{
				unified: "1f37e",
				native: "🍾",
				x: 7,
				y: 1
			}
		],
		version: 1
	},
	wine_glass: {
		id: "wine_glass",
		name: "Wine Glass",
		keywords: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f377",
				native: "🍷",
				x: 6,
				y: 55
			}
		],
		version: 1
	},
	cocktail: {
		id: "cocktail",
		name: "Cocktail Glass",
		keywords: [
			"drink",
			"drunk",
			"alcohol",
			"beverage",
			"booze",
			"mojito"
		],
		skins: [
			{
				unified: "1f378",
				native: "🍸",
				x: 6,
				y: 56
			}
		],
		version: 1
	},
	tropical_drink: {
		id: "tropical_drink",
		name: "Tropical Drink",
		keywords: [
			"beverage",
			"cocktail",
			"summer",
			"beach",
			"alcohol",
			"booze",
			"mojito"
		],
		skins: [
			{
				unified: "1f379",
				native: "🍹",
				x: 6,
				y: 57
			}
		],
		version: 1
	},
	beer: {
		id: "beer",
		name: "Beer Mug",
		keywords: [
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f37a",
				native: "🍺",
				x: 6,
				y: 58
			}
		],
		version: 1
	},
	beers: {
		id: "beers",
		name: "Clinking Beer Mugs",
		keywords: [
			"beers",
			"relax",
			"beverage",
			"drink",
			"drunk",
			"party",
			"pub",
			"summer",
			"alcohol",
			"booze"
		],
		skins: [
			{
				unified: "1f37b",
				native: "🍻",
				x: 6,
				y: 59
			}
		],
		version: 1
	},
	clinking_glasses: {
		id: "clinking_glasses",
		name: "Clinking Glasses",
		keywords: [
			"beverage",
			"drink",
			"party",
			"alcohol",
			"celebrate",
			"cheers",
			"wine",
			"champagne",
			"toast"
		],
		skins: [
			{
				unified: "1f942",
				native: "🥂",
				x: 43,
				y: 13
			}
		],
		version: 3
	},
	tumbler_glass: {
		id: "tumbler_glass",
		name: "Tumbler Glass",
		keywords: [
			"drink",
			"beverage",
			"drunk",
			"alcohol",
			"liquor",
			"booze",
			"bourbon",
			"scotch",
			"whisky",
			"shot"
		],
		skins: [
			{
				unified: "1f943",
				native: "🥃",
				x: 43,
				y: 14
			}
		],
		version: 3
	},
	pouring_liquid: {
		id: "pouring_liquid",
		name: "Pouring Liquid",
		keywords: [
			"cup",
			"water"
		],
		skins: [
			{
				unified: "1fad7",
				native: "🫗",
				x: 55,
				y: 9
			}
		],
		version: 14
	},
	cup_with_straw: {
		id: "cup_with_straw",
		name: "Cup with Straw",
		keywords: [
			"drink",
			"soda"
		],
		skins: [
			{
				unified: "1f964",
				native: "🥤",
				x: 43,
				y: 46
			}
		],
		version: 5
	},
	bubble_tea: {
		id: "bubble_tea",
		name: "Bubble Tea",
		keywords: [
			"taiwan",
			"boba",
			"milk",
			"straw"
		],
		skins: [
			{
				unified: "1f9cb",
				native: "🧋",
				x: 46,
				y: 16
			}
		],
		version: 13
	},
	beverage_box: {
		id: "beverage_box",
		name: "Beverage Box",
		keywords: [
			"drink"
		],
		skins: [
			{
				unified: "1f9c3",
				native: "🧃",
				x: 46,
				y: 8
			}
		],
		version: 12
	},
	mate_drink: {
		id: "mate_drink",
		name: "Mate",
		keywords: [
			"drink",
			"tea",
			"beverage"
		],
		skins: [
			{
				unified: "1f9c9",
				native: "🧉",
				x: 46,
				y: 14
			}
		],
		version: 12
	},
	ice_cube: {
		id: "ice_cube",
		name: "Ice",
		keywords: [
			"cube",
			"water",
			"cold"
		],
		skins: [
			{
				unified: "1f9ca",
				native: "🧊",
				x: 46,
				y: 15
			}
		],
		version: 12
	},
	chopsticks: {
		id: "chopsticks",
		name: "Chopsticks",
		keywords: [
			"food"
		],
		skins: [
			{
				unified: "1f962",
				native: "🥢",
				x: 43,
				y: 44
			}
		],
		version: 5
	},
	knife_fork_plate: {
		id: "knife_fork_plate",
		name: "Fork and Knife with Plate",
		keywords: [
			"food",
			"eat",
			"meal",
			"lunch",
			"dinner",
			"restaurant"
		],
		skins: [
			{
				unified: "1f37d-fe0f",
				native: "🍽️",
				x: 7,
				y: 0
			}
		],
		version: 1
	},
	fork_and_knife: {
		id: "fork_and_knife",
		name: "Fork and Knife",
		keywords: [
			"cutlery",
			"kitchen"
		],
		skins: [
			{
				unified: "1f374",
				native: "🍴",
				x: 6,
				y: 52
			}
		],
		version: 1
	},
	spoon: {
		id: "spoon",
		name: "Spoon",
		keywords: [
			"cutlery",
			"kitchen",
			"tableware"
		],
		skins: [
			{
				unified: "1f944",
				native: "🥄",
				x: 43,
				y: 15
			}
		],
		version: 3
	},
	hocho: {
		id: "hocho",
		name: "Hocho",
		keywords: [
			"knife",
			"kitchen",
			"blade",
			"cutlery",
			"weapon"
		],
		skins: [
			{
				unified: "1f52a",
				native: "🔪",
				x: 30,
				y: 6
			}
		],
		version: 1
	},
	jar: {
		id: "jar",
		name: "Jar",
		keywords: [
			"container",
			"sauce"
		],
		skins: [
			{
				unified: "1fad9",
				native: "🫙",
				x: 55,
				y: 11
			}
		],
		version: 14
	},
	amphora: {
		id: "amphora",
		name: "Amphora",
		keywords: [
			"vase",
			"jar"
		],
		skins: [
			{
				unified: "1f3fa",
				native: "🏺",
				x: 10,
				y: 40
			}
		],
		version: 1
	},
	earth_africa: {
		id: "earth_africa",
		name: "Earth Globe Europe-Africa",
		keywords: [
			"africa",
			"showing",
			"europe",
			"world",
			"international"
		],
		skins: [
			{
				unified: "1f30d",
				native: "🌍",
				x: 5,
				y: 12
			}
		],
		version: 1
	},
	earth_americas: {
		id: "earth_americas",
		name: "Earth Globe Americas",
		keywords: [
			"showing",
			"world",
			"USA",
			"international"
		],
		skins: [
			{
				unified: "1f30e",
				native: "🌎",
				x: 5,
				y: 13
			}
		],
		version: 1
	},
	earth_asia: {
		id: "earth_asia",
		name: "Earth Globe Asia-Australia",
		keywords: [
			"asia",
			"showing",
			"australia",
			"world",
			"east",
			"international"
		],
		skins: [
			{
				unified: "1f30f",
				native: "🌏",
				x: 5,
				y: 14
			}
		],
		version: 1
	},
	globe_with_meridians: {
		id: "globe_with_meridians",
		name: "Globe with Meridians",
		keywords: [
			"earth",
			"international",
			"world",
			"internet",
			"interweb",
			"i18n"
		],
		skins: [
			{
				unified: "1f310",
				native: "🌐",
				x: 5,
				y: 15
			}
		],
		version: 1
	},
	world_map: {
		id: "world_map",
		name: "World Map",
		keywords: [
			"location",
			"direction"
		],
		skins: [
			{
				unified: "1f5fa-fe0f",
				native: "🗺️",
				x: 32,
				y: 14
			}
		],
		version: 1
	},
	japan: {
		id: "japan",
		name: "Map of Japan",
		keywords: [
			"nation",
			"country",
			"japanese",
			"asia"
		],
		skins: [
			{
				unified: "1f5fe",
				native: "🗾",
				x: 32,
				y: 18
			}
		],
		version: 1
	},
	compass: {
		id: "compass",
		name: "Compass",
		keywords: [
			"magnetic",
			"navigation",
			"orienteering"
		],
		skins: [
			{
				unified: "1f9ed",
				native: "🧭",
				x: 53,
				y: 27
			}
		],
		version: 11
	},
	snow_capped_mountain: {
		id: "snow_capped_mountain",
		name: "Snow-Capped Mountain",
		keywords: [
			"snow",
			"capped",
			"photo",
			"nature",
			"environment",
			"winter",
			"cold"
		],
		skins: [
			{
				unified: "1f3d4-fe0f",
				native: "🏔️",
				x: 9,
				y: 60
			}
		],
		version: 1
	},
	mountain: {
		id: "mountain",
		name: "Mountain",
		keywords: [
			"photo",
			"nature",
			"environment"
		],
		skins: [
			{
				unified: "26f0-fe0f",
				native: "⛰️",
				x: 57,
				y: 56
			}
		],
		version: 1
	},
	volcano: {
		id: "volcano",
		name: "Volcano",
		keywords: [
			"photo",
			"nature",
			"disaster"
		],
		skins: [
			{
				unified: "1f30b",
				native: "🌋",
				x: 5,
				y: 10
			}
		],
		version: 1
	},
	mount_fuji: {
		id: "mount_fuji",
		name: "Mount Fuji",
		keywords: [
			"photo",
			"mountain",
			"nature",
			"japanese"
		],
		skins: [
			{
				unified: "1f5fb",
				native: "🗻",
				x: 32,
				y: 15
			}
		],
		version: 1
	},
	camping: {
		id: "camping",
		name: "Camping",
		keywords: [
			"photo",
			"outdoors",
			"tent"
		],
		skins: [
			{
				unified: "1f3d5-fe0f",
				native: "🏕️",
				x: 10,
				y: 0
			}
		],
		version: 1
	},
	beach_with_umbrella: {
		id: "beach_with_umbrella",
		name: "Beach with Umbrella",
		keywords: [
			"weather",
			"summer",
			"sunny",
			"sand",
			"mojito"
		],
		skins: [
			{
				unified: "1f3d6-fe0f",
				native: "🏖️",
				x: 10,
				y: 1
			}
		],
		version: 1
	},
	desert: {
		id: "desert",
		name: "Desert",
		keywords: [
			"photo",
			"warm",
			"saharah"
		],
		skins: [
			{
				unified: "1f3dc-fe0f",
				native: "🏜️",
				x: 10,
				y: 7
			}
		],
		version: 1
	},
	desert_island: {
		id: "desert_island",
		name: "Desert Island",
		keywords: [
			"photo",
			"tropical",
			"mojito"
		],
		skins: [
			{
				unified: "1f3dd-fe0f",
				native: "🏝️",
				x: 10,
				y: 8
			}
		],
		version: 1
	},
	national_park: {
		id: "national_park",
		name: "National Park",
		keywords: [
			"photo",
			"environment",
			"nature"
		],
		skins: [
			{
				unified: "1f3de-fe0f",
				native: "🏞️",
				x: 10,
				y: 9
			}
		],
		version: 1
	},
	stadium: {
		id: "stadium",
		name: "Stadium",
		keywords: [
			"photo",
			"place",
			"sports",
			"concert",
			"venue"
		],
		skins: [
			{
				unified: "1f3df-fe0f",
				native: "🏟️",
				x: 10,
				y: 10
			}
		],
		version: 1
	},
	classical_building: {
		id: "classical_building",
		name: "Classical Building",
		keywords: [
			"art",
			"culture",
			"history"
		],
		skins: [
			{
				unified: "1f3db-fe0f",
				native: "🏛️",
				x: 10,
				y: 6
			}
		],
		version: 1
	},
	building_construction: {
		id: "building_construction",
		name: "Building Construction",
		keywords: [
			"wip",
			"working",
			"progress"
		],
		skins: [
			{
				unified: "1f3d7-fe0f",
				native: "🏗️",
				x: 10,
				y: 2
			}
		],
		version: 1
	},
	bricks: {
		id: "bricks",
		name: "Brick",
		keywords: [
			"bricks"
		],
		skins: [
			{
				unified: "1f9f1",
				native: "🧱",
				x: 53,
				y: 31
			}
		],
		version: 11
	},
	rock: {
		id: "rock",
		name: "Rock",
		keywords: [
			"stone"
		],
		skins: [
			{
				unified: "1faa8",
				native: "🪨",
				x: 54,
				y: 26
			}
		],
		version: 13
	},
	wood: {
		id: "wood",
		name: "Wood",
		keywords: [
			"nature",
			"timber",
			"trunk"
		],
		skins: [
			{
				unified: "1fab5",
				native: "🪵",
				x: 54,
				y: 36
			}
		],
		version: 13
	},
	hut: {
		id: "hut",
		name: "Hut",
		keywords: [
			"house",
			"structure"
		],
		skins: [
			{
				unified: "1f6d6",
				native: "🛖",
				x: 38,
				y: 6
			}
		],
		version: 13
	},
	house_buildings: {
		id: "house_buildings",
		name: "Houses",
		keywords: [
			"house",
			"buildings",
			"photo"
		],
		skins: [
			{
				unified: "1f3d8-fe0f",
				native: "🏘️",
				x: 10,
				y: 3
			}
		],
		version: 1
	},
	derelict_house_building: {
		id: "derelict_house_building",
		name: "Derelict House",
		keywords: [
			"building",
			"abandon",
			"evict",
			"broken"
		],
		skins: [
			{
				unified: "1f3da-fe0f",
				native: "🏚️",
				x: 10,
				y: 5
			}
		],
		version: 1
	},
	house: {
		id: "house",
		name: "House",
		keywords: [
			"building",
			"home"
		],
		skins: [
			{
				unified: "1f3e0",
				native: "🏠",
				x: 10,
				y: 11
			}
		],
		version: 1
	},
	house_with_garden: {
		id: "house_with_garden",
		name: "House with Garden",
		keywords: [
			"home",
			"plant",
			"nature"
		],
		skins: [
			{
				unified: "1f3e1",
				native: "🏡",
				x: 10,
				y: 12
			}
		],
		version: 1
	},
	office: {
		id: "office",
		name: "Office Building",
		keywords: [
			"bureau",
			"work"
		],
		skins: [
			{
				unified: "1f3e2",
				native: "🏢",
				x: 10,
				y: 13
			}
		],
		version: 1
	},
	post_office: {
		id: "post_office",
		name: "Japanese Post Office",
		keywords: [
			"building",
			"envelope",
			"communication"
		],
		skins: [
			{
				unified: "1f3e3",
				native: "🏣",
				x: 10,
				y: 14
			}
		],
		version: 1
	},
	european_post_office: {
		id: "european_post_office",
		name: "Post Office",
		keywords: [
			"european",
			"building",
			"email"
		],
		skins: [
			{
				unified: "1f3e4",
				native: "🏤",
				x: 10,
				y: 15
			}
		],
		version: 1
	},
	hospital: {
		id: "hospital",
		name: "Hospital",
		keywords: [
			"building",
			"health",
			"surgery",
			"doctor"
		],
		skins: [
			{
				unified: "1f3e5",
				native: "🏥",
				x: 10,
				y: 16
			}
		],
		version: 1
	},
	bank: {
		id: "bank",
		name: "Bank",
		keywords: [
			"building",
			"money",
			"sales",
			"cash",
			"business",
			"enterprise"
		],
		skins: [
			{
				unified: "1f3e6",
				native: "🏦",
				x: 10,
				y: 17
			}
		],
		version: 1
	},
	hotel: {
		id: "hotel",
		name: "Hotel",
		keywords: [
			"building",
			"accomodation",
			"checkin"
		],
		skins: [
			{
				unified: "1f3e8",
				native: "🏨",
				x: 10,
				y: 19
			}
		],
		version: 1
	},
	love_hotel: {
		id: "love_hotel",
		name: "Love Hotel",
		keywords: [
			"like",
			"affection",
			"dating"
		],
		skins: [
			{
				unified: "1f3e9",
				native: "🏩",
				x: 10,
				y: 20
			}
		],
		version: 1
	},
	convenience_store: {
		id: "convenience_store",
		name: "Convenience Store",
		keywords: [
			"building",
			"shopping",
			"groceries"
		],
		skins: [
			{
				unified: "1f3ea",
				native: "🏪",
				x: 10,
				y: 21
			}
		],
		version: 1
	},
	school: {
		id: "school",
		name: "School",
		keywords: [
			"building",
			"student",
			"education",
			"learn",
			"teach"
		],
		skins: [
			{
				unified: "1f3eb",
				native: "🏫",
				x: 10,
				y: 22
			}
		],
		version: 1
	},
	department_store: {
		id: "department_store",
		name: "Department Store",
		keywords: [
			"building",
			"shopping",
			"mall"
		],
		skins: [
			{
				unified: "1f3ec",
				native: "🏬",
				x: 10,
				y: 23
			}
		],
		version: 1
	},
	factory: {
		id: "factory",
		name: "Factory",
		keywords: [
			"building",
			"industry",
			"pollution",
			"smoke"
		],
		skins: [
			{
				unified: "1f3ed",
				native: "🏭",
				x: 10,
				y: 24
			}
		],
		version: 1
	},
	japanese_castle: {
		id: "japanese_castle",
		name: "Japanese Castle",
		keywords: [
			"photo",
			"building"
		],
		skins: [
			{
				unified: "1f3ef",
				native: "🏯",
				x: 10,
				y: 26
			}
		],
		version: 1
	},
	european_castle: {
		id: "european_castle",
		name: "Castle",
		keywords: [
			"european",
			"building",
			"royalty",
			"history"
		],
		skins: [
			{
				unified: "1f3f0",
				native: "🏰",
				x: 10,
				y: 27
			}
		],
		version: 1
	},
	wedding: {
		id: "wedding",
		name: "Wedding",
		keywords: [
			"love",
			"like",
			"affection",
			"couple",
			"marriage",
			"bride",
			"groom"
		],
		skins: [
			{
				unified: "1f492",
				native: "💒",
				x: 27,
				y: 33
			}
		],
		version: 1
	},
	tokyo_tower: {
		id: "tokyo_tower",
		name: "Tokyo Tower",
		keywords: [
			"photo",
			"japanese"
		],
		skins: [
			{
				unified: "1f5fc",
				native: "🗼",
				x: 32,
				y: 16
			}
		],
		version: 1
	},
	statue_of_liberty: {
		id: "statue_of_liberty",
		name: "Statue of Liberty",
		keywords: [
			"american",
			"newyork"
		],
		skins: [
			{
				unified: "1f5fd",
				native: "🗽",
				x: 32,
				y: 17
			}
		],
		version: 1
	},
	church: {
		id: "church",
		name: "Church",
		keywords: [
			"building",
			"religion",
			"christ"
		],
		skins: [
			{
				unified: "26ea",
				native: "⛪",
				x: 57,
				y: 55
			}
		],
		version: 1
	},
	mosque: {
		id: "mosque",
		name: "Mosque",
		keywords: [
			"islam",
			"worship",
			"minaret"
		],
		skins: [
			{
				unified: "1f54c",
				native: "🕌",
				x: 30,
				y: 29
			}
		],
		version: 1
	},
	hindu_temple: {
		id: "hindu_temple",
		name: "Hindu Temple",
		keywords: [
			"religion"
		],
		skins: [
			{
				unified: "1f6d5",
				native: "🛕",
				x: 38,
				y: 5
			}
		],
		version: 12
	},
	synagogue: {
		id: "synagogue",
		name: "Synagogue",
		keywords: [
			"judaism",
			"worship",
			"temple",
			"jewish"
		],
		skins: [
			{
				unified: "1f54d",
				native: "🕍",
				x: 30,
				y: 30
			}
		],
		version: 1
	},
	shinto_shrine: {
		id: "shinto_shrine",
		name: "Shinto Shrine",
		keywords: [
			"temple",
			"japan",
			"kyoto"
		],
		skins: [
			{
				unified: "26e9-fe0f",
				native: "⛩️",
				x: 57,
				y: 54
			}
		],
		version: 1
	},
	kaaba: {
		id: "kaaba",
		name: "Kaaba",
		keywords: [
			"mecca",
			"mosque",
			"islam"
		],
		skins: [
			{
				unified: "1f54b",
				native: "🕋",
				x: 30,
				y: 28
			}
		],
		version: 1
	},
	fountain: {
		id: "fountain",
		name: "Fountain",
		keywords: [
			"photo",
			"summer",
			"water",
			"fresh"
		],
		skins: [
			{
				unified: "26f2",
				native: "⛲",
				x: 57,
				y: 58
			}
		],
		version: 1
	},
	tent: {
		id: "tent",
		name: "Tent",
		keywords: [
			"photo",
			"camping",
			"outdoors"
		],
		skins: [
			{
				unified: "26fa",
				native: "⛺",
				x: 58,
				y: 21
			}
		],
		version: 1
	},
	foggy: {
		id: "foggy",
		name: "Foggy",
		keywords: [
			"photo",
			"mountain"
		],
		skins: [
			{
				unified: "1f301",
				native: "🌁",
				x: 5,
				y: 0
			}
		],
		version: 1
	},
	night_with_stars: {
		id: "night_with_stars",
		name: "Night with Stars",
		keywords: [
			"evening",
			"city",
			"downtown"
		],
		skins: [
			{
				unified: "1f303",
				native: "🌃",
				x: 5,
				y: 2
			}
		],
		version: 1
	},
	cityscape: {
		id: "cityscape",
		name: "Cityscape",
		keywords: [
			"photo",
			"night",
			"life",
			"urban"
		],
		skins: [
			{
				unified: "1f3d9-fe0f",
				native: "🏙️",
				x: 10,
				y: 4
			}
		],
		version: 1
	},
	sunrise_over_mountains: {
		id: "sunrise_over_mountains",
		name: "Sunrise over Mountains",
		keywords: [
			"view",
			"vacation",
			"photo"
		],
		skins: [
			{
				unified: "1f304",
				native: "🌄",
				x: 5,
				y: 3
			}
		],
		version: 1
	},
	sunrise: {
		id: "sunrise",
		name: "Sunrise",
		keywords: [
			"morning",
			"view",
			"vacation",
			"photo"
		],
		skins: [
			{
				unified: "1f305",
				native: "🌅",
				x: 5,
				y: 4
			}
		],
		version: 1
	},
	city_sunset: {
		id: "city_sunset",
		name: "Cityscape at Dusk",
		keywords: [
			"city",
			"sunset",
			"photo",
			"evening",
			"sky",
			"buildings"
		],
		skins: [
			{
				unified: "1f306",
				native: "🌆",
				x: 5,
				y: 5
			}
		],
		version: 1
	},
	city_sunrise: {
		id: "city_sunrise",
		name: "Sunset",
		keywords: [
			"city",
			"sunrise",
			"photo",
			"good",
			"morning",
			"dawn"
		],
		skins: [
			{
				unified: "1f307",
				native: "🌇",
				x: 5,
				y: 6
			}
		],
		version: 1
	},
	bridge_at_night: {
		id: "bridge_at_night",
		name: "Bridge at Night",
		keywords: [
			"photo",
			"sanfrancisco"
		],
		skins: [
			{
				unified: "1f309",
				native: "🌉",
				x: 5,
				y: 8
			}
		],
		version: 1
	},
	hotsprings: {
		id: "hotsprings",
		name: "Hot Springs",
		keywords: [
			"hotsprings",
			"bath",
			"warm",
			"relax"
		],
		skins: [
			{
				unified: "2668-fe0f",
				native: "♨️",
				x: 57,
				y: 24
			}
		],
		version: 1
	},
	carousel_horse: {
		id: "carousel_horse",
		name: "Carousel Horse",
		keywords: [
			"photo",
			"carnival"
		],
		skins: [
			{
				unified: "1f3a0",
				native: "🎠",
				x: 7,
				y: 35
			}
		],
		version: 1
	},
	playground_slide: {
		id: "playground_slide",
		name: "Playground Slide",
		keywords: [
			"fun",
			"park"
		],
		skins: [
			{
				unified: "1f6dd",
				native: "🛝",
				x: 38,
				y: 8
			}
		],
		version: 14
	},
	ferris_wheel: {
		id: "ferris_wheel",
		name: "Ferris Wheel",
		keywords: [
			"photo",
			"carnival",
			"londoneye"
		],
		skins: [
			{
				unified: "1f3a1",
				native: "🎡",
				x: 7,
				y: 36
			}
		],
		version: 1
	},
	roller_coaster: {
		id: "roller_coaster",
		name: "Roller Coaster",
		keywords: [
			"carnival",
			"playground",
			"photo",
			"fun"
		],
		skins: [
			{
				unified: "1f3a2",
				native: "🎢",
				x: 7,
				y: 37
			}
		],
		version: 1
	},
	barber: {
		id: "barber",
		name: "Barber Pole",
		keywords: [
			"hair",
			"salon",
			"style"
		],
		skins: [
			{
				unified: "1f488",
				native: "💈",
				x: 26,
				y: 34
			}
		],
		version: 1
	},
	circus_tent: {
		id: "circus_tent",
		name: "Circus Tent",
		keywords: [
			"festival",
			"carnival",
			"party"
		],
		skins: [
			{
				unified: "1f3aa",
				native: "🎪",
				x: 7,
				y: 45
			}
		],
		version: 1
	},
	steam_locomotive: {
		id: "steam_locomotive",
		name: "Locomotive",
		keywords: [
			"steam",
			"transportation",
			"vehicle",
			"train"
		],
		skins: [
			{
				unified: "1f682",
				native: "🚂",
				x: 35,
				y: 34
			}
		],
		version: 1
	},
	railway_car: {
		id: "railway_car",
		name: "Railway Car",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f683",
				native: "🚃",
				x: 35,
				y: 35
			}
		],
		version: 1
	},
	bullettrain_side: {
		id: "bullettrain_side",
		name: "High-Speed Train",
		keywords: [
			"bullettrain",
			"side",
			"high",
			"speed",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f684",
				native: "🚄",
				x: 35,
				y: 36
			}
		],
		version: 1
	},
	bullettrain_front: {
		id: "bullettrain_front",
		name: "Bullet Train",
		keywords: [
			"bullettrain",
			"front",
			"transportation",
			"vehicle",
			"speed",
			"fast",
			"public",
			"travel"
		],
		skins: [
			{
				unified: "1f685",
				native: "🚅",
				x: 35,
				y: 37
			}
		],
		version: 1
	},
	train2: {
		id: "train2",
		name: "Train",
		keywords: [
			"train2",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f686",
				native: "🚆",
				x: 35,
				y: 38
			}
		],
		version: 1
	},
	metro: {
		id: "metro",
		name: "Metro",
		keywords: [
			"transportation",
			"blue",
			"square",
			"mrt",
			"underground",
			"tube"
		],
		skins: [
			{
				unified: "1f687",
				native: "🚇",
				x: 35,
				y: 39
			}
		],
		version: 1
	},
	light_rail: {
		id: "light_rail",
		name: "Light Rail",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f688",
				native: "🚈",
				x: 35,
				y: 40
			}
		],
		version: 1
	},
	station: {
		id: "station",
		name: "Station",
		keywords: [
			"transportation",
			"vehicle",
			"public"
		],
		skins: [
			{
				unified: "1f689",
				native: "🚉",
				x: 35,
				y: 41
			}
		],
		version: 1
	},
	tram: {
		id: "tram",
		name: "Tram",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f68a",
				native: "🚊",
				x: 35,
				y: 42
			}
		],
		version: 1
	},
	monorail: {
		id: "monorail",
		name: "Monorail",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f69d",
				native: "🚝",
				x: 36,
				y: 0
			}
		],
		version: 1
	},
	mountain_railway: {
		id: "mountain_railway",
		name: "Mountain Railway",
		keywords: [
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f69e",
				native: "🚞",
				x: 36,
				y: 1
			}
		],
		version: 1
	},
	train: {
		id: "train",
		name: "Tram Car",
		keywords: [
			"train",
			"transportation",
			"vehicle",
			"carriage",
			"public",
			"travel"
		],
		skins: [
			{
				unified: "1f68b",
				native: "🚋",
				x: 35,
				y: 43
			}
		],
		version: 1
	},
	bus: {
		id: "bus",
		name: "Bus",
		keywords: [
			"car",
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f68c",
				native: "🚌",
				x: 35,
				y: 44
			}
		],
		version: 1
	},
	oncoming_bus: {
		id: "oncoming_bus",
		name: "Oncoming Bus",
		keywords: [
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f68d",
				native: "🚍",
				x: 35,
				y: 45
			}
		],
		version: 1
	},
	trolleybus: {
		id: "trolleybus",
		name: "Trolleybus",
		keywords: [
			"bart",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f68e",
				native: "🚎",
				x: 35,
				y: 46
			}
		],
		version: 1
	},
	minibus: {
		id: "minibus",
		name: "Minibus",
		keywords: [
			"vehicle",
			"car",
			"transportation"
		],
		skins: [
			{
				unified: "1f690",
				native: "🚐",
				x: 35,
				y: 48
			}
		],
		version: 1
	},
	ambulance: {
		id: "ambulance",
		name: "Ambulance",
		keywords: [
			"health",
			"911",
			"hospital"
		],
		skins: [
			{
				unified: "1f691",
				native: "🚑",
				x: 35,
				y: 49
			}
		],
		version: 1
	},
	fire_engine: {
		id: "fire_engine",
		name: "Fire Engine",
		keywords: [
			"transportation",
			"cars",
			"vehicle"
		],
		skins: [
			{
				unified: "1f692",
				native: "🚒",
				x: 35,
				y: 50
			}
		],
		version: 1
	},
	police_car: {
		id: "police_car",
		name: "Police Car",
		keywords: [
			"vehicle",
			"cars",
			"transportation",
			"law",
			"legal",
			"enforcement"
		],
		skins: [
			{
				unified: "1f693",
				native: "🚓",
				x: 35,
				y: 51
			}
		],
		version: 1
	},
	oncoming_police_car: {
		id: "oncoming_police_car",
		name: "Oncoming Police Car",
		keywords: [
			"vehicle",
			"law",
			"legal",
			"enforcement",
			"911"
		],
		skins: [
			{
				unified: "1f694",
				native: "🚔",
				x: 35,
				y: 52
			}
		],
		version: 1
	},
	taxi: {
		id: "taxi",
		name: "Taxi",
		keywords: [
			"uber",
			"vehicle",
			"cars",
			"transportation"
		],
		skins: [
			{
				unified: "1f695",
				native: "🚕",
				x: 35,
				y: 53
			}
		],
		version: 1
	},
	oncoming_taxi: {
		id: "oncoming_taxi",
		name: "Oncoming Taxi",
		keywords: [
			"vehicle",
			"cars",
			"uber"
		],
		skins: [
			{
				unified: "1f696",
				native: "🚖",
				x: 35,
				y: 54
			}
		],
		version: 1
	},
	car: {
		id: "car",
		name: "Automobile",
		keywords: [
			"car",
			"red",
			"transportation",
			"vehicle"
		],
		skins: [
			{
				unified: "1f697",
				native: "🚗",
				x: 35,
				y: 55
			}
		],
		version: 1
	},
	oncoming_automobile: {
		id: "oncoming_automobile",
		name: "Oncoming Automobile",
		keywords: [
			"car",
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f698",
				native: "🚘",
				x: 35,
				y: 56
			}
		],
		version: 1
	},
	blue_car: {
		id: "blue_car",
		name: "Recreational Vehicle",
		keywords: [
			"blue",
			"car",
			"sport",
			"utility",
			"transportation"
		],
		skins: [
			{
				unified: "1f699",
				native: "🚙",
				x: 35,
				y: 57
			}
		],
		version: 1
	},
	pickup_truck: {
		id: "pickup_truck",
		name: "Pickup Truck",
		keywords: [
			"car",
			"transportation"
		],
		skins: [
			{
				unified: "1f6fb",
				native: "🛻",
				x: 38,
				y: 29
			}
		],
		version: 13
	},
	truck: {
		id: "truck",
		name: "Delivery Truck",
		keywords: [
			"cars",
			"transportation"
		],
		skins: [
			{
				unified: "1f69a",
				native: "🚚",
				x: 35,
				y: 58
			}
		],
		version: 1
	},
	articulated_lorry: {
		id: "articulated_lorry",
		name: "Articulated Lorry",
		keywords: [
			"vehicle",
			"cars",
			"transportation",
			"express"
		],
		skins: [
			{
				unified: "1f69b",
				native: "🚛",
				x: 35,
				y: 59
			}
		],
		version: 1
	},
	tractor: {
		id: "tractor",
		name: "Tractor",
		keywords: [
			"vehicle",
			"car",
			"farming",
			"agriculture"
		],
		skins: [
			{
				unified: "1f69c",
				native: "🚜",
				x: 35,
				y: 60
			}
		],
		version: 1
	},
	racing_car: {
		id: "racing_car",
		name: "Racing Car",
		keywords: [
			"sports",
			"race",
			"fast",
			"formula",
			"f1"
		],
		skins: [
			{
				unified: "1f3ce-fe0f",
				native: "🏎️",
				x: 9,
				y: 54
			}
		],
		version: 1
	},
	racing_motorcycle: {
		id: "racing_motorcycle",
		name: "Motorcycle",
		keywords: [
			"racing",
			"race",
			"sports",
			"fast"
		],
		skins: [
			{
				unified: "1f3cd-fe0f",
				native: "🏍️",
				x: 9,
				y: 53
			}
		],
		version: 1
	},
	motor_scooter: {
		id: "motor_scooter",
		name: "Motor Scooter",
		keywords: [
			"vehicle",
			"vespa",
			"sasha"
		],
		skins: [
			{
				unified: "1f6f5",
				native: "🛵",
				x: 38,
				y: 23
			}
		],
		version: 3
	},
	manual_wheelchair: {
		id: "manual_wheelchair",
		name: "Manual Wheelchair",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bd",
				native: "🦽",
				x: 46,
				y: 2
			}
		],
		version: 12
	},
	motorized_wheelchair: {
		id: "motorized_wheelchair",
		name: "Motorized Wheelchair",
		keywords: [
			"accessibility"
		],
		skins: [
			{
				unified: "1f9bc",
				native: "🦼",
				x: 46,
				y: 1
			}
		],
		version: 12
	},
	auto_rickshaw: {
		id: "auto_rickshaw",
		name: "Auto Rickshaw",
		keywords: [
			"move",
			"transportation"
		],
		skins: [
			{
				unified: "1f6fa",
				native: "🛺",
				x: 38,
				y: 28
			}
		],
		version: 12
	},
	bike: {
		id: "bike",
		name: "Bicycle",
		keywords: [
			"bike",
			"sports",
			"exercise",
			"hipster"
		],
		skins: [
			{
				unified: "1f6b2",
				native: "🚲",
				x: 36,
				y: 38
			}
		],
		version: 1
	},
	scooter: {
		id: "scooter",
		name: "Scooter",
		keywords: [
			"kick",
			"vehicle",
			"razor"
		],
		skins: [
			{
				unified: "1f6f4",
				native: "🛴",
				x: 38,
				y: 22
			}
		],
		version: 3
	},
	skateboard: {
		id: "skateboard",
		name: "Skateboard",
		keywords: [
			"board"
		],
		skins: [
			{
				unified: "1f6f9",
				native: "🛹",
				x: 38,
				y: 27
			}
		],
		version: 11
	},
	roller_skate: {
		id: "roller_skate",
		name: "Roller Skate",
		keywords: [
			"footwear",
			"sports"
		],
		skins: [
			{
				unified: "1f6fc",
				native: "🛼",
				x: 38,
				y: 30
			}
		],
		version: 13
	},
	busstop: {
		id: "busstop",
		name: "Bus Stop",
		keywords: [
			"busstop",
			"transportation",
			"wait"
		],
		skins: [
			{
				unified: "1f68f",
				native: "🚏",
				x: 35,
				y: 47
			}
		],
		version: 1
	},
	motorway: {
		id: "motorway",
		name: "Motorway",
		keywords: [
			"road",
			"cupertino",
			"interstate",
			"highway"
		],
		skins: [
			{
				unified: "1f6e3-fe0f",
				native: "🛣️",
				x: 38,
				y: 14
			}
		],
		version: 1
	},
	railway_track: {
		id: "railway_track",
		name: "Railway Track",
		keywords: [
			"train",
			"transportation"
		],
		skins: [
			{
				unified: "1f6e4-fe0f",
				native: "🛤️",
				x: 38,
				y: 15
			}
		],
		version: 1
	},
	oil_drum: {
		id: "oil_drum",
		name: "Oil Drum",
		keywords: [
			"barrell"
		],
		skins: [
			{
				unified: "1f6e2-fe0f",
				native: "🛢️",
				x: 38,
				y: 13
			}
		],
		version: 1
	},
	fuelpump: {
		id: "fuelpump",
		name: "Fuel Pump",
		keywords: [
			"fuelpump",
			"gas",
			"station",
			"petroleum"
		],
		skins: [
			{
				unified: "26fd",
				native: "⛽",
				x: 58,
				y: 22
			}
		],
		version: 1
	},
	wheel: {
		id: "wheel",
		name: "Wheel",
		keywords: [
			"car",
			"transport"
		],
		skins: [
			{
				unified: "1f6de",
				native: "🛞",
				x: 38,
				y: 9
			}
		],
		version: 14
	},
	rotating_light: {
		id: "rotating_light",
		name: "Police Car Light",
		keywords: [
			"rotating",
			"ambulance",
			"911",
			"emergency",
			"alert",
			"error",
			"pinged",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "1f6a8",
				native: "🚨",
				x: 36,
				y: 28
			}
		],
		version: 1
	},
	traffic_light: {
		id: "traffic_light",
		name: "Horizontal Traffic Light",
		keywords: [
			"transportation",
			"signal"
		],
		skins: [
			{
				unified: "1f6a5",
				native: "🚥",
				x: 36,
				y: 25
			}
		],
		version: 1
	},
	vertical_traffic_light: {
		id: "vertical_traffic_light",
		name: "Vertical Traffic Light",
		keywords: [
			"transportation",
			"driving"
		],
		skins: [
			{
				unified: "1f6a6",
				native: "🚦",
				x: 36,
				y: 26
			}
		],
		version: 1
	},
	octagonal_sign: {
		id: "octagonal_sign",
		name: "Stop Sign",
		keywords: [
			"octagonal"
		],
		skins: [
			{
				unified: "1f6d1",
				native: "🛑",
				x: 38,
				y: 3
			}
		],
		version: 3
	},
	construction: {
		id: "construction",
		name: "Construction",
		keywords: [
			"wip",
			"progress",
			"caution",
			"warning"
		],
		skins: [
			{
				unified: "1f6a7",
				native: "🚧",
				x: 36,
				y: 27
			}
		],
		version: 1
	},
	anchor: {
		id: "anchor",
		name: "Anchor",
		keywords: [
			"ship",
			"ferry",
			"sea",
			"boat"
		],
		skins: [
			{
				unified: "2693",
				native: "⚓",
				x: 57,
				y: 29
			}
		],
		version: 1
	},
	ring_buoy: {
		id: "ring_buoy",
		name: "Ring Buoy",
		keywords: [
			"life",
			"saver",
			"preserver"
		],
		skins: [
			{
				unified: "1f6df",
				native: "🛟",
				x: 38,
				y: 10
			}
		],
		version: 14
	},
	boat: {
		id: "boat",
		name: "Sailboat",
		keywords: [
			"boat",
			"ship",
			"summer",
			"transportation",
			"water",
			"sailing"
		],
		skins: [
			{
				unified: "26f5",
				native: "⛵",
				x: 58,
				y: 0
			}
		],
		version: 1
	},
	canoe: {
		id: "canoe",
		name: "Canoe",
		keywords: [
			"boat",
			"paddle",
			"water",
			"ship"
		],
		skins: [
			{
				unified: "1f6f6",
				native: "🛶",
				x: 38,
				y: 24
			}
		],
		version: 3
	},
	speedboat: {
		id: "speedboat",
		name: "Speedboat",
		keywords: [
			"ship",
			"transportation",
			"vehicle",
			"summer"
		],
		skins: [
			{
				unified: "1f6a4",
				native: "🚤",
				x: 36,
				y: 24
			}
		],
		version: 1
	},
	passenger_ship: {
		id: "passenger_ship",
		name: "Passenger Ship",
		keywords: [
			"yacht",
			"cruise",
			"ferry"
		],
		skins: [
			{
				unified: "1f6f3-fe0f",
				native: "🛳️",
				x: 38,
				y: 21
			}
		],
		version: 1
	},
	ferry: {
		id: "ferry",
		name: "Ferry",
		keywords: [
			"boat",
			"ship",
			"yacht"
		],
		skins: [
			{
				unified: "26f4-fe0f",
				native: "⛴️",
				x: 57,
				y: 60
			}
		],
		version: 1
	},
	motor_boat: {
		id: "motor_boat",
		name: "Motor Boat",
		keywords: [
			"ship"
		],
		skins: [
			{
				unified: "1f6e5-fe0f",
				native: "🛥️",
				x: 38,
				y: 16
			}
		],
		version: 1
	},
	ship: {
		id: "ship",
		name: "Ship",
		keywords: [
			"transportation",
			"titanic",
			"deploy"
		],
		skins: [
			{
				unified: "1f6a2",
				native: "🚢",
				x: 36,
				y: 5
			}
		],
		version: 1
	},
	airplane: {
		id: "airplane",
		name: "Airplane",
		keywords: [
			"vehicle",
			"transportation",
			"flight",
			"fly"
		],
		skins: [
			{
				unified: "2708-fe0f",
				native: "✈️",
				x: 58,
				y: 25
			}
		],
		version: 1
	},
	small_airplane: {
		id: "small_airplane",
		name: "Small Airplane",
		keywords: [
			"flight",
			"transportation",
			"fly",
			"vehicle"
		],
		skins: [
			{
				unified: "1f6e9-fe0f",
				native: "🛩️",
				x: 38,
				y: 17
			}
		],
		version: 1
	},
	airplane_departure: {
		id: "airplane_departure",
		name: "Airplane Departure",
		keywords: [
			"airport",
			"flight",
			"landing"
		],
		skins: [
			{
				unified: "1f6eb",
				native: "🛫",
				x: 38,
				y: 18
			}
		],
		version: 1
	},
	airplane_arriving: {
		id: "airplane_arriving",
		name: "Airplane Arrival",
		keywords: [
			"arriving",
			"airport",
			"flight",
			"boarding"
		],
		skins: [
			{
				unified: "1f6ec",
				native: "🛬",
				x: 38,
				y: 19
			}
		],
		version: 1
	},
	parachute: {
		id: "parachute",
		name: "Parachute",
		keywords: [
			"fly",
			"glide"
		],
		skins: [
			{
				unified: "1fa82",
				native: "🪂",
				x: 53,
				y: 58
			}
		],
		version: 12
	},
	seat: {
		id: "seat",
		name: "Seat",
		keywords: [
			"sit",
			"airplane",
			"transport",
			"bus",
			"flight",
			"fly"
		],
		skins: [
			{
				unified: "1f4ba",
				native: "💺",
				x: 28,
				y: 17
			}
		],
		version: 1
	},
	helicopter: {
		id: "helicopter",
		name: "Helicopter",
		keywords: [
			"transportation",
			"vehicle",
			"fly"
		],
		skins: [
			{
				unified: "1f681",
				native: "🚁",
				x: 35,
				y: 33
			}
		],
		version: 1
	},
	suspension_railway: {
		id: "suspension_railway",
		name: "Suspension Railway",
		keywords: [
			"vehicle",
			"transportation"
		],
		skins: [
			{
				unified: "1f69f",
				native: "🚟",
				x: 36,
				y: 2
			}
		],
		version: 1
	},
	mountain_cableway: {
		id: "mountain_cableway",
		name: "Mountain Cableway",
		keywords: [
			"transportation",
			"vehicle",
			"ski"
		],
		skins: [
			{
				unified: "1f6a0",
				native: "🚠",
				x: 36,
				y: 3
			}
		],
		version: 1
	},
	aerial_tramway: {
		id: "aerial_tramway",
		name: "Aerial Tramway",
		keywords: [
			"transportation",
			"vehicle",
			"ski"
		],
		skins: [
			{
				unified: "1f6a1",
				native: "🚡",
				x: 36,
				y: 4
			}
		],
		version: 1
	},
	satellite: {
		id: "satellite",
		name: "Satellite",
		keywords: [
			"communication",
			"gps",
			"orbit",
			"spaceflight",
			"NASA",
			"ISS"
		],
		skins: [
			{
				unified: "1f6f0-fe0f",
				native: "🛰️",
				x: 38,
				y: 20
			}
		],
		version: 1
	},
	rocket: {
		id: "rocket",
		name: "Rocket",
		keywords: [
			"launch",
			"ship",
			"staffmode",
			"NASA",
			"outer",
			"space",
			"fly"
		],
		skins: [
			{
				unified: "1f680",
				native: "🚀",
				x: 35,
				y: 32
			}
		],
		version: 1
	},
	flying_saucer: {
		id: "flying_saucer",
		name: "Flying Saucer",
		keywords: [
			"transportation",
			"vehicle",
			"ufo"
		],
		skins: [
			{
				unified: "1f6f8",
				native: "🛸",
				x: 38,
				y: 26
			}
		],
		version: 5
	},
	bellhop_bell: {
		id: "bellhop_bell",
		name: "Bellhop Bell",
		keywords: [
			"service"
		],
		skins: [
			{
				unified: "1f6ce-fe0f",
				native: "🛎️",
				x: 38,
				y: 0
			}
		],
		version: 1
	},
	luggage: {
		id: "luggage",
		name: "Luggage",
		keywords: [
			"packing",
			"travel"
		],
		skins: [
			{
				unified: "1f9f3",
				native: "🧳",
				x: 53,
				y: 33
			}
		],
		version: 11
	},
	hourglass: {
		id: "hourglass",
		name: "Hourglass",
		keywords: [
			"done",
			"time",
			"clock",
			"oldschool",
			"limit",
			"exam",
			"quiz",
			"test"
		],
		skins: [
			{
				unified: "231b",
				native: "⌛",
				x: 56,
				y: 14
			}
		],
		version: 1
	},
	hourglass_flowing_sand: {
		id: "hourglass_flowing_sand",
		name: "Hourglass Not Done",
		keywords: [
			"flowing",
			"sand",
			"oldschool",
			"time",
			"countdown"
		],
		skins: [
			{
				unified: "23f3",
				native: "⏳",
				x: 56,
				y: 27
			}
		],
		version: 1
	},
	watch: {
		id: "watch",
		name: "Watch",
		keywords: [
			"time",
			"accessories"
		],
		skins: [
			{
				unified: "231a",
				native: "⌚",
				x: 56,
				y: 13
			}
		],
		version: 1
	},
	alarm_clock: {
		id: "alarm_clock",
		name: "Alarm Clock",
		keywords: [
			"time",
			"wake"
		],
		skins: [
			{
				unified: "23f0",
				native: "⏰",
				x: 56,
				y: 24
			}
		],
		version: 1
	},
	stopwatch: {
		id: "stopwatch",
		name: "Stopwatch",
		keywords: [
			"time",
			"deadline"
		],
		skins: [
			{
				unified: "23f1-fe0f",
				native: "⏱️",
				x: 56,
				y: 25
			}
		],
		version: 1
	},
	timer_clock: {
		id: "timer_clock",
		name: "Timer Clock",
		keywords: [
			"alarm"
		],
		skins: [
			{
				unified: "23f2-fe0f",
				native: "⏲️",
				x: 56,
				y: 26
			}
		],
		version: 1
	},
	mantelpiece_clock: {
		id: "mantelpiece_clock",
		name: "Mantelpiece Clock",
		keywords: [
			"time"
		],
		skins: [
			{
				unified: "1f570-fe0f",
				native: "🕰️",
				x: 30,
				y: 57
			}
		],
		version: 1
	},
	clock12: {
		id: "clock12",
		name: "Twelve O’clock",
		keywords: [
			"clock12",
			"o",
			"clock",
			"time",
			"noon",
			"midnight",
			"midday",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55b",
				native: "🕛",
				x: 30,
				y: 43
			}
		],
		version: 1
	},
	clock1230: {
		id: "clock1230",
		name: "Twelve-Thirty",
		keywords: [
			"clock1230",
			"twelve",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f567",
				native: "🕧",
				x: 30,
				y: 55
			}
		],
		version: 1
	},
	clock1: {
		id: "clock1",
		name: "One O’clock",
		keywords: [
			"clock1",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f550",
				native: "🕐",
				x: 30,
				y: 32
			}
		],
		version: 1
	},
	clock130: {
		id: "clock130",
		name: "One-Thirty",
		keywords: [
			"clock130",
			"one",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55c",
				native: "🕜",
				x: 30,
				y: 44
			}
		],
		version: 1
	},
	clock2: {
		id: "clock2",
		name: "Two O’clock",
		keywords: [
			"clock2",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f551",
				native: "🕑",
				x: 30,
				y: 33
			}
		],
		version: 1
	},
	clock230: {
		id: "clock230",
		name: "Two-Thirty",
		keywords: [
			"clock230",
			"two",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55d",
				native: "🕝",
				x: 30,
				y: 45
			}
		],
		version: 1
	},
	clock3: {
		id: "clock3",
		name: "Three O’clock",
		keywords: [
			"clock3",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f552",
				native: "🕒",
				x: 30,
				y: 34
			}
		],
		version: 1
	},
	clock330: {
		id: "clock330",
		name: "Three-Thirty",
		keywords: [
			"clock330",
			"three",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55e",
				native: "🕞",
				x: 30,
				y: 46
			}
		],
		version: 1
	},
	clock4: {
		id: "clock4",
		name: "Four O’clock",
		keywords: [
			"clock4",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f553",
				native: "🕓",
				x: 30,
				y: 35
			}
		],
		version: 1
	},
	clock430: {
		id: "clock430",
		name: "Four-Thirty",
		keywords: [
			"clock430",
			"four",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55f",
				native: "🕟",
				x: 30,
				y: 47
			}
		],
		version: 1
	},
	clock5: {
		id: "clock5",
		name: "Five O’clock",
		keywords: [
			"clock5",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f554",
				native: "🕔",
				x: 30,
				y: 36
			}
		],
		version: 1
	},
	clock530: {
		id: "clock530",
		name: "Five-Thirty",
		keywords: [
			"clock530",
			"five",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f560",
				native: "🕠",
				x: 30,
				y: 48
			}
		],
		version: 1
	},
	clock6: {
		id: "clock6",
		name: "Six O’clock",
		keywords: [
			"clock6",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule",
			"dawn",
			"dusk"
		],
		skins: [
			{
				unified: "1f555",
				native: "🕕",
				x: 30,
				y: 37
			}
		],
		version: 1
	},
	clock630: {
		id: "clock630",
		name: "Six-Thirty",
		keywords: [
			"clock630",
			"six",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f561",
				native: "🕡",
				x: 30,
				y: 49
			}
		],
		version: 1
	},
	clock7: {
		id: "clock7",
		name: "Seven O’clock",
		keywords: [
			"clock7",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f556",
				native: "🕖",
				x: 30,
				y: 38
			}
		],
		version: 1
	},
	clock730: {
		id: "clock730",
		name: "Seven-Thirty",
		keywords: [
			"clock730",
			"seven",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f562",
				native: "🕢",
				x: 30,
				y: 50
			}
		],
		version: 1
	},
	clock8: {
		id: "clock8",
		name: "Eight O’clock",
		keywords: [
			"clock8",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f557",
				native: "🕗",
				x: 30,
				y: 39
			}
		],
		version: 1
	},
	clock830: {
		id: "clock830",
		name: "Eight-Thirty",
		keywords: [
			"clock830",
			"eight",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f563",
				native: "🕣",
				x: 30,
				y: 51
			}
		],
		version: 1
	},
	clock9: {
		id: "clock9",
		name: "Nine O’clock",
		keywords: [
			"clock9",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f558",
				native: "🕘",
				x: 30,
				y: 40
			}
		],
		version: 1
	},
	clock930: {
		id: "clock930",
		name: "Nine-Thirty",
		keywords: [
			"clock930",
			"nine",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f564",
				native: "🕤",
				x: 30,
				y: 52
			}
		],
		version: 1
	},
	clock10: {
		id: "clock10",
		name: "Ten O’clock",
		keywords: [
			"clock10",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f559",
				native: "🕙",
				x: 30,
				y: 41
			}
		],
		version: 1
	},
	clock1030: {
		id: "clock1030",
		name: "Ten-Thirty",
		keywords: [
			"clock1030",
			"ten",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f565",
				native: "🕥",
				x: 30,
				y: 53
			}
		],
		version: 1
	},
	clock11: {
		id: "clock11",
		name: "Eleven O’clock",
		keywords: [
			"clock11",
			"o",
			"clock",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f55a",
				native: "🕚",
				x: 30,
				y: 42
			}
		],
		version: 1
	},
	clock1130: {
		id: "clock1130",
		name: "Eleven-Thirty",
		keywords: [
			"clock1130",
			"eleven",
			"thirty",
			"time",
			"late",
			"early",
			"schedule"
		],
		skins: [
			{
				unified: "1f566",
				native: "🕦",
				x: 30,
				y: 54
			}
		],
		version: 1
	},
	new_moon: {
		id: "new_moon",
		name: "New Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f311",
				native: "🌑",
				x: 5,
				y: 16
			}
		],
		version: 1
	},
	waxing_crescent_moon: {
		id: "waxing_crescent_moon",
		name: "Waxing Crescent Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f312",
				native: "🌒",
				x: 5,
				y: 17
			}
		],
		version: 1
	},
	first_quarter_moon: {
		id: "first_quarter_moon",
		name: "First Quarter Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f313",
				native: "🌓",
				x: 5,
				y: 18
			}
		],
		version: 1
	},
	moon: {
		id: "moon",
		name: "Waxing Gibbous Moon",
		keywords: [
			"nature",
			"night",
			"sky",
			"gray",
			"twilight",
			"planet",
			"space",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f314",
				native: "🌔",
				x: 5,
				y: 19
			}
		],
		version: 1
	},
	full_moon: {
		id: "full_moon",
		name: "Full Moon",
		keywords: [
			"nature",
			"yellow",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f315",
				native: "🌕",
				x: 5,
				y: 20
			}
		],
		version: 1
	},
	waning_gibbous_moon: {
		id: "waning_gibbous_moon",
		name: "Waning Gibbous Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep",
			"waxing"
		],
		skins: [
			{
				unified: "1f316",
				native: "🌖",
				x: 5,
				y: 21
			}
		],
		version: 1
	},
	last_quarter_moon: {
		id: "last_quarter_moon",
		name: "Last Quarter Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f317",
				native: "🌗",
				x: 5,
				y: 22
			}
		],
		version: 1
	},
	waning_crescent_moon: {
		id: "waning_crescent_moon",
		name: "Waning Crescent Moon",
		keywords: [
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f318",
				native: "🌘",
				x: 5,
				y: 23
			}
		],
		version: 1
	},
	crescent_moon: {
		id: "crescent_moon",
		name: "Crescent Moon",
		keywords: [
			"night",
			"sleep",
			"sky",
			"evening",
			"magic"
		],
		skins: [
			{
				unified: "1f319",
				native: "🌙",
				x: 5,
				y: 24
			}
		],
		version: 1
	},
	new_moon_with_face: {
		id: "new_moon_with_face",
		name: "New Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31a",
				native: "🌚",
				x: 5,
				y: 25
			}
		],
		version: 1
	},
	first_quarter_moon_with_face: {
		id: "first_quarter_moon_with_face",
		name: "First Quarter Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31b",
				native: "🌛",
				x: 5,
				y: 26
			}
		],
		version: 1
	},
	last_quarter_moon_with_face: {
		id: "last_quarter_moon_with_face",
		name: "Last Quarter Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31c",
				native: "🌜",
				x: 5,
				y: 27
			}
		],
		version: 1
	},
	thermometer: {
		id: "thermometer",
		name: "Thermometer",
		keywords: [
			"weather",
			"temperature",
			"hot",
			"cold"
		],
		skins: [
			{
				unified: "1f321-fe0f",
				native: "🌡️",
				x: 5,
				y: 32
			}
		],
		version: 1
	},
	sunny: {
		id: "sunny",
		name: "Sun",
		keywords: [
			"sunny",
			"weather",
			"nature",
			"brightness",
			"summer",
			"beach",
			"spring"
		],
		skins: [
			{
				unified: "2600-fe0f",
				native: "☀️",
				x: 56,
				y: 40
			}
		],
		version: 1
	},
	full_moon_with_face: {
		id: "full_moon_with_face",
		name: "Full Moon Face",
		keywords: [
			"with",
			"nature",
			"twilight",
			"planet",
			"space",
			"night",
			"evening",
			"sleep"
		],
		skins: [
			{
				unified: "1f31d",
				native: "🌝",
				x: 5,
				y: 28
			}
		],
		version: 1
	},
	sun_with_face: {
		id: "sun_with_face",
		name: "Sun with Face",
		keywords: [
			"nature",
			"morning",
			"sky"
		],
		skins: [
			{
				unified: "1f31e",
				native: "🌞",
				x: 5,
				y: 29
			}
		],
		version: 1
	},
	ringed_planet: {
		id: "ringed_planet",
		name: "Ringed Planet",
		keywords: [
			"outerspace"
		],
		skins: [
			{
				unified: "1fa90",
				native: "🪐",
				x: 54,
				y: 2
			}
		],
		version: 12
	},
	star: {
		id: "star",
		name: "Star",
		keywords: [
			"night",
			"yellow"
		],
		skins: [
			{
				unified: "2b50",
				native: "⭐",
				x: 59,
				y: 24
			}
		],
		version: 1
	},
	star2: {
		id: "star2",
		name: "Glowing Star",
		keywords: [
			"star2",
			"night",
			"sparkle",
			"awesome",
			"good",
			"magic"
		],
		skins: [
			{
				unified: "1f31f",
				native: "🌟",
				x: 5,
				y: 30
			}
		],
		version: 1
	},
	stars: {
		id: "stars",
		name: "Shooting Star",
		keywords: [
			"stars",
			"night",
			"photo"
		],
		skins: [
			{
				unified: "1f320",
				native: "🌠",
				x: 5,
				y: 31
			}
		],
		version: 1
	},
	milky_way: {
		id: "milky_way",
		name: "Milky Way",
		keywords: [
			"photo",
			"space",
			"stars"
		],
		skins: [
			{
				unified: "1f30c",
				native: "🌌",
				x: 5,
				y: 11
			}
		],
		version: 1
	},
	cloud: {
		id: "cloud",
		name: "Cloud",
		keywords: [
			"weather",
			"sky"
		],
		skins: [
			{
				unified: "2601-fe0f",
				native: "☁️",
				x: 56,
				y: 41
			}
		],
		version: 1
	},
	partly_sunny: {
		id: "partly_sunny",
		name: "Sun Behind Cloud",
		keywords: [
			"partly",
			"sunny",
			"weather",
			"nature",
			"cloudy",
			"morning",
			"fall",
			"spring"
		],
		skins: [
			{
				unified: "26c5",
				native: "⛅",
				x: 57,
				y: 47
			}
		],
		version: 1
	},
	thunder_cloud_and_rain: {
		id: "thunder_cloud_and_rain",
		name: "Cloud with Lightning and Rain",
		keywords: [
			"thunder",
			"weather"
		],
		skins: [
			{
				unified: "26c8-fe0f",
				native: "⛈️",
				x: 57,
				y: 48
			}
		],
		version: 1
	},
	mostly_sunny: {
		id: "mostly_sunny",
		name: "Sun Behind Small Cloud",
		keywords: [
			"mostly",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f324-fe0f",
				native: "🌤️",
				x: 5,
				y: 33
			}
		],
		version: 1
	},
	barely_sunny: {
		id: "barely_sunny",
		name: "Sun Behind Large Cloud",
		keywords: [
			"barely",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f325-fe0f",
				native: "🌥️",
				x: 5,
				y: 34
			}
		],
		version: 1
	},
	partly_sunny_rain: {
		id: "partly_sunny_rain",
		name: "Sun Behind Rain Cloud",
		keywords: [
			"partly",
			"sunny",
			"weather"
		],
		skins: [
			{
				unified: "1f326-fe0f",
				native: "🌦️",
				x: 5,
				y: 35
			}
		],
		version: 1
	},
	rain_cloud: {
		id: "rain_cloud",
		name: "Cloud with Rain",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f327-fe0f",
				native: "🌧️",
				x: 5,
				y: 36
			}
		],
		version: 1
	},
	snow_cloud: {
		id: "snow_cloud",
		name: "Cloud with Snow",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f328-fe0f",
				native: "🌨️",
				x: 5,
				y: 37
			}
		],
		version: 1
	},
	lightning: {
		id: "lightning",
		name: "Cloud with Lightning",
		keywords: [
			"weather",
			"thunder"
		],
		skins: [
			{
				unified: "1f329-fe0f",
				native: "🌩️",
				x: 5,
				y: 38
			}
		],
		version: 1
	},
	tornado: {
		id: "tornado",
		name: "Tornado",
		keywords: [
			"cloud",
			"weather",
			"cyclone",
			"twister"
		],
		skins: [
			{
				unified: "1f32a-fe0f",
				native: "🌪️",
				x: 5,
				y: 39
			}
		],
		version: 1
	},
	fog: {
		id: "fog",
		name: "Fog",
		keywords: [
			"weather"
		],
		skins: [
			{
				unified: "1f32b-fe0f",
				native: "🌫️",
				x: 5,
				y: 40
			}
		],
		version: 1
	},
	wind_blowing_face: {
		id: "wind_blowing_face",
		name: "Wind Face",
		keywords: [
			"blowing",
			"gust",
			"air"
		],
		skins: [
			{
				unified: "1f32c-fe0f",
				native: "🌬️",
				x: 5,
				y: 41
			}
		],
		version: 1
	},
	cyclone: {
		id: "cyclone",
		name: "Cyclone",
		keywords: [
			"weather",
			"swirl",
			"blue",
			"cloud",
			"vortex",
			"spiral",
			"whirlpool",
			"spin",
			"tornado",
			"hurricane",
			"typhoon"
		],
		skins: [
			{
				unified: "1f300",
				native: "🌀",
				x: 4,
				y: 60
			}
		],
		version: 1
	},
	rainbow: {
		id: "rainbow",
		name: "Rainbow",
		keywords: [
			"nature",
			"happy",
			"unicorn",
			"face",
			"photo",
			"sky",
			"spring"
		],
		skins: [
			{
				unified: "1f308",
				native: "🌈",
				x: 5,
				y: 7
			}
		],
		version: 1
	},
	closed_umbrella: {
		id: "closed_umbrella",
		name: "Closed Umbrella",
		keywords: [
			"weather",
			"rain",
			"drizzle"
		],
		skins: [
			{
				unified: "1f302",
				native: "🌂",
				x: 5,
				y: 1
			}
		],
		version: 1
	},
	umbrella: {
		id: "umbrella",
		name: "Umbrella",
		keywords: [
			"weather",
			"spring"
		],
		skins: [
			{
				unified: "2602-fe0f",
				native: "☂️",
				x: 56,
				y: 42
			}
		],
		version: 1
	},
	umbrella_with_rain_drops: {
		id: "umbrella_with_rain_drops",
		name: "Umbrella with Rain Drops",
		keywords: [
			"rainy",
			"weather",
			"spring"
		],
		skins: [
			{
				unified: "2614",
				native: "☔",
				x: 56,
				y: 47
			}
		],
		version: 1
	},
	umbrella_on_ground: {
		id: "umbrella_on_ground",
		name: "Umbrella on Ground",
		keywords: [
			"weather",
			"summer"
		],
		skins: [
			{
				unified: "26f1-fe0f",
				native: "⛱️",
				x: 57,
				y: 57
			}
		],
		version: 1
	},
	zap: {
		id: "zap",
		name: "High Voltage",
		keywords: [
			"zap",
			"thunder",
			"weather",
			"lightning",
			"bolt",
			"fast"
		],
		skins: [
			{
				unified: "26a1",
				native: "⚡",
				x: 57,
				y: 38
			}
		],
		version: 1
	},
	snowflake: {
		id: "snowflake",
		name: "Snowflake",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas"
		],
		skins: [
			{
				unified: "2744-fe0f",
				native: "❄️",
				x: 58,
				y: 60
			}
		],
		version: 1
	},
	snowman: {
		id: "snowman",
		name: "Snowman",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen"
		],
		skins: [
			{
				unified: "2603-fe0f",
				native: "☃️",
				x: 56,
				y: 43
			}
		],
		version: 1
	},
	snowman_without_snow: {
		id: "snowman_without_snow",
		name: "Snowman Without Snow",
		keywords: [
			"winter",
			"season",
			"cold",
			"weather",
			"christmas",
			"xmas",
			"frozen"
		],
		skins: [
			{
				unified: "26c4",
				native: "⛄",
				x: 57,
				y: 46
			}
		],
		version: 1
	},
	comet: {
		id: "comet",
		name: "Comet",
		keywords: [
			"space"
		],
		skins: [
			{
				unified: "2604-fe0f",
				native: "☄️",
				x: 56,
				y: 44
			}
		],
		version: 1
	},
	fire: {
		id: "fire",
		name: "Fire",
		keywords: [
			"hot",
			"cook",
			"flame"
		],
		skins: [
			{
				unified: "1f525",
				native: "🔥",
				x: 30,
				y: 1
			}
		],
		version: 1
	},
	droplet: {
		id: "droplet",
		name: "Droplet",
		keywords: [
			"water",
			"drip",
			"faucet",
			"spring"
		],
		skins: [
			{
				unified: "1f4a7",
				native: "💧",
				x: 27,
				y: 54
			}
		],
		version: 1
	},
	ocean: {
		id: "ocean",
		name: "Water Wave",
		keywords: [
			"ocean",
			"sea",
			"nature",
			"tsunami",
			"disaster"
		],
		skins: [
			{
				unified: "1f30a",
				native: "🌊",
				x: 5,
				y: 9
			}
		],
		version: 1
	},
	jack_o_lantern: {
		id: "jack_o_lantern",
		name: "Jack-O-Lantern",
		keywords: [
			"jack",
			"o",
			"lantern",
			"halloween",
			"light",
			"pumpkin",
			"creepy",
			"fall"
		],
		skins: [
			{
				unified: "1f383",
				native: "🎃",
				x: 7,
				y: 6
			}
		],
		version: 1
	},
	christmas_tree: {
		id: "christmas_tree",
		name: "Christmas Tree",
		keywords: [
			"festival",
			"vacation",
			"december",
			"xmas",
			"celebration"
		],
		skins: [
			{
				unified: "1f384",
				native: "🎄",
				x: 7,
				y: 7
			}
		],
		version: 1
	},
	fireworks: {
		id: "fireworks",
		name: "Fireworks",
		keywords: [
			"photo",
			"festival",
			"carnival",
			"congratulations"
		],
		skins: [
			{
				unified: "1f386",
				native: "🎆",
				x: 7,
				y: 14
			}
		],
		version: 1
	},
	sparkler: {
		id: "sparkler",
		name: "Sparkler",
		keywords: [
			"stars",
			"night",
			"shine"
		],
		skins: [
			{
				unified: "1f387",
				native: "🎇",
				x: 7,
				y: 15
			}
		],
		version: 1
	},
	firecracker: {
		id: "firecracker",
		name: "Firecracker",
		keywords: [
			"dynamite",
			"boom",
			"explode",
			"explosion",
			"explosive"
		],
		skins: [
			{
				unified: "1f9e8",
				native: "🧨",
				x: 53,
				y: 22
			}
		],
		version: 11
	},
	sparkles: {
		id: "sparkles",
		name: "Sparkles",
		keywords: [
			"stars",
			"shine",
			"shiny",
			"cool",
			"awesome",
			"good",
			"magic"
		],
		skins: [
			{
				unified: "2728",
				native: "✨",
				x: 58,
				y: 57
			}
		],
		version: 1
	},
	balloon: {
		id: "balloon",
		name: "Balloon",
		keywords: [
			"party",
			"celebration",
			"birthday",
			"circus"
		],
		skins: [
			{
				unified: "1f388",
				native: "🎈",
				x: 7,
				y: 16
			}
		],
		version: 1
	},
	tada: {
		id: "tada",
		name: "Party Popper",
		keywords: [
			"tada",
			"congratulations",
			"birthday",
			"magic",
			"circus",
			"celebration"
		],
		skins: [
			{
				unified: "1f389",
				native: "🎉",
				x: 7,
				y: 17
			}
		],
		version: 1
	},
	confetti_ball: {
		id: "confetti_ball",
		name: "Confetti Ball",
		keywords: [
			"festival",
			"party",
			"birthday",
			"circus"
		],
		skins: [
			{
				unified: "1f38a",
				native: "🎊",
				x: 7,
				y: 18
			}
		],
		version: 1
	},
	tanabata_tree: {
		id: "tanabata_tree",
		name: "Tanabata Tree",
		keywords: [
			"plant",
			"nature",
			"branch",
			"summer"
		],
		skins: [
			{
				unified: "1f38b",
				native: "🎋",
				x: 7,
				y: 19
			}
		],
		version: 1
	},
	bamboo: {
		id: "bamboo",
		name: "Pine Decoration",
		keywords: [
			"bamboo",
			"plant",
			"nature",
			"vegetable",
			"panda"
		],
		skins: [
			{
				unified: "1f38d",
				native: "🎍",
				x: 7,
				y: 21
			}
		],
		version: 1
	},
	dolls: {
		id: "dolls",
		name: "Japanese Dolls",
		keywords: [
			"toy",
			"kimono"
		],
		skins: [
			{
				unified: "1f38e",
				native: "🎎",
				x: 7,
				y: 22
			}
		],
		version: 1
	},
	flags: {
		id: "flags",
		name: "Carp Streamer",
		keywords: [
			"flags",
			"fish",
			"japanese",
			"koinobori",
			"banner"
		],
		skins: [
			{
				unified: "1f38f",
				native: "🎏",
				x: 7,
				y: 23
			}
		],
		version: 1
	},
	wind_chime: {
		id: "wind_chime",
		name: "Wind Chime",
		keywords: [
			"nature",
			"ding",
			"spring",
			"bell"
		],
		skins: [
			{
				unified: "1f390",
				native: "🎐",
				x: 7,
				y: 24
			}
		],
		version: 1
	},
	rice_scene: {
		id: "rice_scene",
		name: "Moon Viewing Ceremony",
		keywords: [
			"rice",
			"scene",
			"photo",
			"japan",
			"asia",
			"tsukimi"
		],
		skins: [
			{
				unified: "1f391",
				native: "🎑",
				x: 7,
				y: 25
			}
		],
		version: 1
	},
	red_envelope: {
		id: "red_envelope",
		name: "Red Envelope",
		keywords: [
			"gift"
		],
		skins: [
			{
				unified: "1f9e7",
				native: "🧧",
				x: 53,
				y: 21
			}
		],
		version: 11
	},
	ribbon: {
		id: "ribbon",
		name: "Ribbon",
		keywords: [
			"decoration",
			"pink",
			"girl",
			"bowtie"
		],
		skins: [
			{
				unified: "1f380",
				native: "🎀",
				x: 7,
				y: 3
			}
		],
		version: 1
	},
	gift: {
		id: "gift",
		name: "Wrapped Gift",
		keywords: [
			"present",
			"birthday",
			"christmas",
			"xmas"
		],
		skins: [
			{
				unified: "1f381",
				native: "🎁",
				x: 7,
				y: 4
			}
		],
		version: 1
	},
	reminder_ribbon: {
		id: "reminder_ribbon",
		name: "Reminder Ribbon",
		keywords: [
			"sports",
			"cause",
			"support",
			"awareness"
		],
		skins: [
			{
				unified: "1f397-fe0f",
				native: "🎗️",
				x: 7,
				y: 29
			}
		],
		version: 1
	},
	admission_tickets: {
		id: "admission_tickets",
		name: "Admission Tickets",
		keywords: [
			"sports",
			"concert",
			"entrance"
		],
		skins: [
			{
				unified: "1f39f-fe0f",
				native: "🎟️",
				x: 7,
				y: 34
			}
		],
		version: 1
	},
	ticket: {
		id: "ticket",
		name: "Ticket",
		keywords: [
			"event",
			"concert",
			"pass"
		],
		skins: [
			{
				unified: "1f3ab",
				native: "🎫",
				x: 7,
				y: 46
			}
		],
		version: 1
	},
	medal: {
		id: "medal",
		name: "Military Medal",
		keywords: [
			"award",
			"winning",
			"army"
		],
		skins: [
			{
				unified: "1f396-fe0f",
				native: "🎖️",
				x: 7,
				y: 28
			}
		],
		version: 1
	},
	trophy: {
		id: "trophy",
		name: "Trophy",
		keywords: [
			"win",
			"award",
			"contest",
			"place",
			"ftw",
			"ceremony"
		],
		skins: [
			{
				unified: "1f3c6",
				native: "🏆",
				x: 8,
				y: 51
			}
		],
		version: 1
	},
	sports_medal: {
		id: "sports_medal",
		name: "Sports Medal",
		keywords: [
			"award",
			"winning"
		],
		skins: [
			{
				unified: "1f3c5",
				native: "🏅",
				x: 8,
				y: 50
			}
		],
		version: 1
	},
	first_place_medal: {
		id: "first_place_medal",
		name: "1st Place Medal",
		keywords: [
			"first",
			"award",
			"winning"
		],
		skins: [
			{
				unified: "1f947",
				native: "🥇",
				x: 43,
				y: 17
			}
		],
		version: 3
	},
	second_place_medal: {
		id: "second_place_medal",
		name: "2nd Place Medal",
		keywords: [
			"second",
			"award"
		],
		skins: [
			{
				unified: "1f948",
				native: "🥈",
				x: 43,
				y: 18
			}
		],
		version: 3
	},
	third_place_medal: {
		id: "third_place_medal",
		name: "3rd Place Medal",
		keywords: [
			"third",
			"award"
		],
		skins: [
			{
				unified: "1f949",
				native: "🥉",
				x: 43,
				y: 19
			}
		],
		version: 3
	},
	soccer: {
		id: "soccer",
		name: "Soccer Ball",
		keywords: [
			"sports",
			"football"
		],
		skins: [
			{
				unified: "26bd",
				native: "⚽",
				x: 57,
				y: 44
			}
		],
		version: 1
	},
	baseball: {
		id: "baseball",
		name: "Baseball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "26be",
				native: "⚾",
				x: 57,
				y: 45
			}
		],
		version: 1
	},
	softball: {
		id: "softball",
		name: "Softball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "1f94e",
				native: "🥎",
				x: 43,
				y: 24
			}
		],
		version: 11
	},
	basketball: {
		id: "basketball",
		name: "Basketball",
		keywords: [
			"sports",
			"balls",
			"NBA"
		],
		skins: [
			{
				unified: "1f3c0",
				native: "🏀",
				x: 8,
				y: 6
			}
		],
		version: 1
	},
	volleyball: {
		id: "volleyball",
		name: "Volleyball",
		keywords: [
			"sports",
			"balls"
		],
		skins: [
			{
				unified: "1f3d0",
				native: "🏐",
				x: 9,
				y: 56
			}
		],
		version: 1
	},
	football: {
		id: "football",
		name: "American Football",
		keywords: [
			"sports",
			"balls",
			"NFL"
		],
		skins: [
			{
				unified: "1f3c8",
				native: "🏈",
				x: 8,
				y: 58
			}
		],
		version: 1
	},
	rugby_football: {
		id: "rugby_football",
		name: "Rugby Football",
		keywords: [
			"sports",
			"team"
		],
		skins: [
			{
				unified: "1f3c9",
				native: "🏉",
				x: 8,
				y: 59
			}
		],
		version: 1
	},
	tennis: {
		id: "tennis",
		name: "Tennis",
		keywords: [
			"sports",
			"balls",
			"green"
		],
		skins: [
			{
				unified: "1f3be",
				native: "🎾",
				x: 8,
				y: 4
			}
		],
		version: 1
	},
	flying_disc: {
		id: "flying_disc",
		name: "Flying Disc",
		keywords: [
			"sports",
			"frisbee",
			"ultimate"
		],
		skins: [
			{
				unified: "1f94f",
				native: "🥏",
				x: 43,
				y: 25
			}
		],
		version: 11
	},
	bowling: {
		id: "bowling",
		name: "Bowling",
		keywords: [
			"sports",
			"fun",
			"play"
		],
		skins: [
			{
				unified: "1f3b3",
				native: "🎳",
				x: 7,
				y: 54
			}
		],
		version: 1
	},
	cricket_bat_and_ball: {
		id: "cricket_bat_and_ball",
		name: "Cricket Game",
		keywords: [
			"bat",
			"and",
			"ball",
			"sports"
		],
		skins: [
			{
				unified: "1f3cf",
				native: "🏏",
				x: 9,
				y: 55
			}
		],
		version: 1
	},
	field_hockey_stick_and_ball: {
		id: "field_hockey_stick_and_ball",
		name: "Field Hockey",
		keywords: [
			"stick",
			"and",
			"ball",
			"sports"
		],
		skins: [
			{
				unified: "1f3d1",
				native: "🏑",
				x: 9,
				y: 57
			}
		],
		version: 1
	},
	ice_hockey_stick_and_puck: {
		id: "ice_hockey_stick_and_puck",
		name: "Ice Hockey",
		keywords: [
			"stick",
			"and",
			"puck",
			"sports"
		],
		skins: [
			{
				unified: "1f3d2",
				native: "🏒",
				x: 9,
				y: 58
			}
		],
		version: 1
	},
	lacrosse: {
		id: "lacrosse",
		name: "Lacrosse",
		keywords: [
			"sports",
			"ball",
			"stick"
		],
		skins: [
			{
				unified: "1f94d",
				native: "🥍",
				x: 43,
				y: 23
			}
		],
		version: 11
	},
	table_tennis_paddle_and_ball: {
		id: "table_tennis_paddle_and_ball",
		name: "Ping Pong",
		keywords: [
			"table",
			"tennis",
			"paddle",
			"and",
			"ball",
			"sports",
			"pingpong"
		],
		skins: [
			{
				unified: "1f3d3",
				native: "🏓",
				x: 9,
				y: 59
			}
		],
		version: 1
	},
	badminton_racquet_and_shuttlecock: {
		id: "badminton_racquet_and_shuttlecock",
		name: "Badminton",
		keywords: [
			"racquet",
			"and",
			"shuttlecock",
			"sports"
		],
		skins: [
			{
				unified: "1f3f8",
				native: "🏸",
				x: 10,
				y: 38
			}
		],
		version: 1
	},
	boxing_glove: {
		id: "boxing_glove",
		name: "Boxing Glove",
		keywords: [
			"sports",
			"fighting"
		],
		skins: [
			{
				unified: "1f94a",
				native: "🥊",
				x: 43,
				y: 20
			}
		],
		version: 3
	},
	martial_arts_uniform: {
		id: "martial_arts_uniform",
		name: "Martial Arts Uniform",
		keywords: [
			"judo",
			"karate",
			"taekwondo"
		],
		skins: [
			{
				unified: "1f94b",
				native: "🥋",
				x: 43,
				y: 21
			}
		],
		version: 3
	},
	goal_net: {
		id: "goal_net",
		name: "Goal Net",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f945",
				native: "🥅",
				x: 43,
				y: 16
			}
		],
		version: 3
	},
	golf: {
		id: "golf",
		name: "Flag in Hole",
		keywords: [
			"golf",
			"sports",
			"business",
			"summer"
		],
		skins: [
			{
				unified: "26f3",
				native: "⛳",
				x: 57,
				y: 59
			}
		],
		version: 1
	},
	ice_skate: {
		id: "ice_skate",
		name: "Ice Skate",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "26f8-fe0f",
				native: "⛸️",
				x: 58,
				y: 2
			}
		],
		version: 1
	},
	fishing_pole_and_fish: {
		id: "fishing_pole_and_fish",
		name: "Fishing Pole",
		keywords: [
			"and",
			"fish",
			"food",
			"hobby",
			"summer"
		],
		skins: [
			{
				unified: "1f3a3",
				native: "🎣",
				x: 7,
				y: 38
			}
		],
		version: 1
	},
	diving_mask: {
		id: "diving_mask",
		name: "Diving Mask",
		keywords: [
			"sport",
			"ocean"
		],
		skins: [
			{
				unified: "1f93f",
				native: "🤿",
				x: 43,
				y: 10
			}
		],
		version: 12
	},
	running_shirt_with_sash: {
		id: "running_shirt_with_sash",
		name: "Running Shirt",
		keywords: [
			"with",
			"sash",
			"play",
			"pageant"
		],
		skins: [
			{
				unified: "1f3bd",
				native: "🎽",
				x: 8,
				y: 3
			}
		],
		version: 1
	},
	ski: {
		id: "ski",
		name: "Skis",
		keywords: [
			"ski",
			"sports",
			"winter",
			"cold",
			"snow"
		],
		skins: [
			{
				unified: "1f3bf",
				native: "🎿",
				x: 8,
				y: 5
			}
		],
		version: 1
	},
	sled: {
		id: "sled",
		name: "Sled",
		keywords: [
			"sleigh",
			"luge",
			"toboggan"
		],
		skins: [
			{
				unified: "1f6f7",
				native: "🛷",
				x: 38,
				y: 25
			}
		],
		version: 5
	},
	curling_stone: {
		id: "curling_stone",
		name: "Curling Stone",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f94c",
				native: "🥌",
				x: 43,
				y: 22
			}
		],
		version: 5
	},
	dart: {
		id: "dart",
		name: "Bullseye",
		keywords: [
			"dart",
			"direct",
			"hit",
			"game",
			"play",
			"bar",
			"target"
		],
		skins: [
			{
				unified: "1f3af",
				native: "🎯",
				x: 7,
				y: 50
			}
		],
		version: 1
	},
	"yo-yo": {
		id: "yo-yo",
		name: "Yo-Yo",
		keywords: [
			"yo",
			"toy"
		],
		skins: [
			{
				unified: "1fa80",
				native: "🪀",
				x: 53,
				y: 56
			}
		],
		version: 12
	},
	kite: {
		id: "kite",
		name: "Kite",
		keywords: [
			"wind",
			"fly"
		],
		skins: [
			{
				unified: "1fa81",
				native: "🪁",
				x: 53,
				y: 57
			}
		],
		version: 12
	},
	"8ball": {
		id: "8ball",
		name: "Billiards",
		keywords: [
			"8ball",
			"pool",
			"8",
			"ball",
			"hobby",
			"game",
			"luck",
			"magic"
		],
		skins: [
			{
				unified: "1f3b1",
				native: "🎱",
				x: 7,
				y: 52
			}
		],
		version: 1
	},
	crystal_ball: {
		id: "crystal_ball",
		name: "Crystal Ball",
		keywords: [
			"disco",
			"party",
			"magic",
			"circus",
			"fortune",
			"teller"
		],
		skins: [
			{
				unified: "1f52e",
				native: "🔮",
				x: 30,
				y: 10
			}
		],
		version: 1
	},
	magic_wand: {
		id: "magic_wand",
		name: "Magic Wand",
		keywords: [
			"supernature",
			"power"
		],
		skins: [
			{
				unified: "1fa84",
				native: "🪄",
				x: 53,
				y: 60
			}
		],
		version: 13
	},
	nazar_amulet: {
		id: "nazar_amulet",
		name: "Nazar Amulet",
		keywords: [
			"bead",
			"charm"
		],
		skins: [
			{
				unified: "1f9ff",
				native: "🧿",
				x: 53,
				y: 45
			}
		],
		version: 11
	},
	hamsa: {
		id: "hamsa",
		name: "Hamsa",
		keywords: [
			"religion",
			"protection"
		],
		skins: [
			{
				unified: "1faac",
				native: "🪬",
				x: 54,
				y: 30
			}
		],
		version: 14
	},
	video_game: {
		id: "video_game",
		name: "Video Game",
		keywords: [
			"play",
			"console",
			"PS4",
			"controller"
		],
		skins: [
			{
				unified: "1f3ae",
				native: "🎮",
				x: 7,
				y: 49
			}
		],
		version: 1
	},
	joystick: {
		id: "joystick",
		name: "Joystick",
		keywords: [
			"game",
			"play"
		],
		skins: [
			{
				unified: "1f579-fe0f",
				native: "🕹️",
				x: 31,
				y: 25
			}
		],
		version: 1
	},
	slot_machine: {
		id: "slot_machine",
		name: "Slot Machine",
		keywords: [
			"bet",
			"gamble",
			"vegas",
			"fruit",
			"luck",
			"casino"
		],
		skins: [
			{
				unified: "1f3b0",
				native: "🎰",
				x: 7,
				y: 51
			}
		],
		version: 1
	},
	game_die: {
		id: "game_die",
		name: "Game Die",
		keywords: [
			"dice",
			"random",
			"tabletop",
			"play",
			"luck"
		],
		skins: [
			{
				unified: "1f3b2",
				native: "🎲",
				x: 7,
				y: 53
			}
		],
		version: 1
	},
	jigsaw: {
		id: "jigsaw",
		name: "Puzzle Piece",
		keywords: [
			"jigsaw",
			"interlocking"
		],
		skins: [
			{
				unified: "1f9e9",
				native: "🧩",
				x: 53,
				y: 23
			}
		],
		version: 11
	},
	teddy_bear: {
		id: "teddy_bear",
		name: "Teddy Bear",
		keywords: [
			"plush",
			"stuffed"
		],
		skins: [
			{
				unified: "1f9f8",
				native: "🧸",
				x: 53,
				y: 38
			}
		],
		version: 11
	},
	pinata: {
		id: "pinata",
		name: "Pinata",
		keywords: [
			"mexico",
			"candy",
			"celebration"
		],
		skins: [
			{
				unified: "1fa85",
				native: "🪅",
				x: 54,
				y: 0
			}
		],
		version: 13
	},
	mirror_ball: {
		id: "mirror_ball",
		name: "Mirror Ball",
		keywords: [
			"disco",
			"dance",
			"party"
		],
		skins: [
			{
				unified: "1faa9",
				native: "🪩",
				x: 54,
				y: 27
			}
		],
		version: 14
	},
	nesting_dolls: {
		id: "nesting_dolls",
		name: "Nesting Dolls",
		keywords: [
			"matryoshka",
			"toy"
		],
		skins: [
			{
				unified: "1fa86",
				native: "🪆",
				x: 54,
				y: 1
			}
		],
		version: 13
	},
	spades: {
		id: "spades",
		name: "Spade Suit",
		keywords: [
			"spades",
			"poker",
			"cards",
			"suits",
			"magic"
		],
		skins: [
			{
				unified: "2660-fe0f",
				native: "♠️",
				x: 57,
				y: 20
			}
		],
		version: 1
	},
	hearts: {
		id: "hearts",
		name: "Heart Suit",
		keywords: [
			"hearts",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2665-fe0f",
				native: "♥️",
				x: 57,
				y: 22
			}
		],
		version: 1
	},
	diamonds: {
		id: "diamonds",
		name: "Diamond Suit",
		keywords: [
			"diamonds",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2666-fe0f",
				native: "♦️",
				x: 57,
				y: 23
			}
		],
		version: 1
	},
	clubs: {
		id: "clubs",
		name: "Club Suit",
		keywords: [
			"clubs",
			"poker",
			"cards",
			"magic",
			"suits"
		],
		skins: [
			{
				unified: "2663-fe0f",
				native: "♣️",
				x: 57,
				y: 21
			}
		],
		version: 1
	},
	chess_pawn: {
		id: "chess_pawn",
		name: "Chess Pawn",
		keywords: [
			"expendable"
		],
		skins: [
			{
				unified: "265f-fe0f",
				native: "♟️",
				x: 57,
				y: 19
			}
		],
		version: 11
	},
	black_joker: {
		id: "black_joker",
		name: "Joker",
		keywords: [
			"black",
			"poker",
			"cards",
			"game",
			"play",
			"magic"
		],
		skins: [
			{
				unified: "1f0cf",
				native: "🃏",
				x: 0,
				y: 15
			}
		],
		version: 1
	},
	mahjong: {
		id: "mahjong",
		name: "Mahjong Red Dragon",
		keywords: [
			"game",
			"play",
			"chinese",
			"kanji"
		],
		skins: [
			{
				unified: "1f004",
				native: "🀄",
				x: 0,
				y: 14
			}
		],
		version: 1
	},
	flower_playing_cards: {
		id: "flower_playing_cards",
		name: "Flower Playing Cards",
		keywords: [
			"game",
			"sunset",
			"red"
		],
		skins: [
			{
				unified: "1f3b4",
				native: "🎴",
				x: 7,
				y: 55
			}
		],
		version: 1
	},
	performing_arts: {
		id: "performing_arts",
		name: "Performing Arts",
		keywords: [
			"acting",
			"theater",
			"drama"
		],
		skins: [
			{
				unified: "1f3ad",
				native: "🎭",
				x: 7,
				y: 48
			}
		],
		version: 1
	},
	frame_with_picture: {
		id: "frame_with_picture",
		name: "Framed Picture",
		keywords: [
			"frame",
			"with",
			"photography"
		],
		skins: [
			{
				unified: "1f5bc-fe0f",
				native: "🖼️",
				x: 31,
				y: 60
			}
		],
		version: 1
	},
	art: {
		id: "art",
		name: "Artist Palette",
		keywords: [
			"art",
			"design",
			"paint",
			"draw",
			"colors"
		],
		skins: [
			{
				unified: "1f3a8",
				native: "🎨",
				x: 7,
				y: 43
			}
		],
		version: 1
	},
	thread: {
		id: "thread",
		name: "Thread",
		keywords: [
			"needle",
			"sewing",
			"spool",
			"string"
		],
		skins: [
			{
				unified: "1f9f5",
				native: "🧵",
				x: 53,
				y: 35
			}
		],
		version: 11
	},
	sewing_needle: {
		id: "sewing_needle",
		name: "Sewing Needle",
		keywords: [
			"stitches"
		],
		skins: [
			{
				unified: "1faa1",
				native: "🪡",
				x: 54,
				y: 19
			}
		],
		version: 13
	},
	yarn: {
		id: "yarn",
		name: "Yarn",
		keywords: [
			"ball",
			"crochet",
			"knit"
		],
		skins: [
			{
				unified: "1f9f6",
				native: "🧶",
				x: 53,
				y: 36
			}
		],
		version: 11
	},
	knot: {
		id: "knot",
		name: "Knot",
		keywords: [
			"rope",
			"scout"
		],
		skins: [
			{
				unified: "1faa2",
				native: "🪢",
				x: 54,
				y: 20
			}
		],
		version: 13
	},
	eyeglasses: {
		id: "eyeglasses",
		name: "Glasses",
		keywords: [
			"eyeglasses",
			"fashion",
			"accessories",
			"eyesight",
			"nerdy",
			"dork",
			"geek"
		],
		skins: [
			{
				unified: "1f453",
				native: "👓",
				x: 13,
				y: 15
			}
		],
		version: 1
	},
	dark_sunglasses: {
		id: "dark_sunglasses",
		name: "Sunglasses",
		keywords: [
			"dark",
			"face",
			"cool",
			"accessories"
		],
		skins: [
			{
				unified: "1f576-fe0f",
				native: "🕶️",
				x: 31,
				y: 22
			}
		],
		version: 1
	},
	goggles: {
		id: "goggles",
		name: "Goggles",
		keywords: [
			"eyes",
			"protection",
			"safety"
		],
		skins: [
			{
				unified: "1f97d",
				native: "🥽",
				x: 44,
				y: 15
			}
		],
		version: 11
	},
	lab_coat: {
		id: "lab_coat",
		name: "Lab Coat",
		keywords: [
			"doctor",
			"experiment",
			"scientist",
			"chemist"
		],
		skins: [
			{
				unified: "1f97c",
				native: "🥼",
				x: 44,
				y: 14
			}
		],
		version: 11
	},
	safety_vest: {
		id: "safety_vest",
		name: "Safety Vest",
		keywords: [
			"protection"
		],
		skins: [
			{
				unified: "1f9ba",
				native: "🦺",
				x: 45,
				y: 55
			}
		],
		version: 12
	},
	necktie: {
		id: "necktie",
		name: "Necktie",
		keywords: [
			"shirt",
			"suitup",
			"formal",
			"fashion",
			"cloth",
			"business"
		],
		skins: [
			{
				unified: "1f454",
				native: "👔",
				x: 13,
				y: 16
			}
		],
		version: 1
	},
	shirt: {
		id: "shirt",
		name: "T-Shirt",
		keywords: [
			"shirt",
			"tshirt",
			"t",
			"fashion",
			"cloth",
			"casual",
			"tee"
		],
		skins: [
			{
				unified: "1f455",
				native: "👕",
				x: 13,
				y: 17
			}
		],
		version: 1
	},
	jeans: {
		id: "jeans",
		name: "Jeans",
		keywords: [
			"fashion",
			"shopping"
		],
		skins: [
			{
				unified: "1f456",
				native: "👖",
				x: 13,
				y: 18
			}
		],
		version: 1
	},
	scarf: {
		id: "scarf",
		name: "Scarf",
		keywords: [
			"neck",
			"winter",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e3",
				native: "🧣",
				x: 53,
				y: 17
			}
		],
		version: 5
	},
	gloves: {
		id: "gloves",
		name: "Gloves",
		keywords: [
			"hands",
			"winter",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e4",
				native: "🧤",
				x: 53,
				y: 18
			}
		],
		version: 5
	},
	coat: {
		id: "coat",
		name: "Coat",
		keywords: [
			"jacket"
		],
		skins: [
			{
				unified: "1f9e5",
				native: "🧥",
				x: 53,
				y: 19
			}
		],
		version: 5
	},
	socks: {
		id: "socks",
		name: "Socks",
		keywords: [
			"stockings",
			"clothes"
		],
		skins: [
			{
				unified: "1f9e6",
				native: "🧦",
				x: 53,
				y: 20
			}
		],
		version: 5
	},
	dress: {
		id: "dress",
		name: "Dress",
		keywords: [
			"clothes",
			"fashion",
			"shopping"
		],
		skins: [
			{
				unified: "1f457",
				native: "👗",
				x: 13,
				y: 19
			}
		],
		version: 1
	},
	kimono: {
		id: "kimono",
		name: "Kimono",
		keywords: [
			"dress",
			"fashion",
			"women",
			"female",
			"japanese"
		],
		skins: [
			{
				unified: "1f458",
				native: "👘",
				x: 13,
				y: 20
			}
		],
		version: 1
	},
	sari: {
		id: "sari",
		name: "Sari",
		keywords: [
			"dress"
		],
		skins: [
			{
				unified: "1f97b",
				native: "🥻",
				x: 44,
				y: 13
			}
		],
		version: 12
	},
	"one-piece_swimsuit": {
		id: "one-piece_swimsuit",
		name: "One-Piece Swimsuit",
		keywords: [
			"one",
			"piece",
			"fashion"
		],
		skins: [
			{
				unified: "1fa71",
				native: "🩱",
				x: 53,
				y: 47
			}
		],
		version: 12
	},
	briefs: {
		id: "briefs",
		name: "Briefs",
		keywords: [
			"clothing"
		],
		skins: [
			{
				unified: "1fa72",
				native: "🩲",
				x: 53,
				y: 48
			}
		],
		version: 12
	},
	shorts: {
		id: "shorts",
		name: "Shorts",
		keywords: [
			"clothing"
		],
		skins: [
			{
				unified: "1fa73",
				native: "🩳",
				x: 53,
				y: 49
			}
		],
		version: 12
	},
	bikini: {
		id: "bikini",
		name: "Bikini",
		keywords: [
			"swimming",
			"female",
			"woman",
			"girl",
			"fashion",
			"beach",
			"summer"
		],
		skins: [
			{
				unified: "1f459",
				native: "👙",
				x: 13,
				y: 21
			}
		],
		version: 1
	},
	womans_clothes: {
		id: "womans_clothes",
		name: "Womans Clothes",
		keywords: [
			"woman",
			"s",
			"fashion",
			"shopping",
			"bags",
			"female"
		],
		skins: [
			{
				unified: "1f45a",
				native: "👚",
				x: 13,
				y: 22
			}
		],
		version: 1
	},
	purse: {
		id: "purse",
		name: "Purse",
		keywords: [
			"fashion",
			"accessories",
			"money",
			"sales",
			"shopping"
		],
		skins: [
			{
				unified: "1f45b",
				native: "👛",
				x: 13,
				y: 23
			}
		],
		version: 1
	},
	handbag: {
		id: "handbag",
		name: "Handbag",
		keywords: [
			"fashion",
			"accessory",
			"accessories",
			"shopping"
		],
		skins: [
			{
				unified: "1f45c",
				native: "👜",
				x: 13,
				y: 24
			}
		],
		version: 1
	},
	pouch: {
		id: "pouch",
		name: "Pouch",
		keywords: [
			"clutch",
			"bag",
			"accessories",
			"shopping"
		],
		skins: [
			{
				unified: "1f45d",
				native: "👝",
				x: 13,
				y: 25
			}
		],
		version: 1
	},
	shopping_bags: {
		id: "shopping_bags",
		name: "Shopping Bags",
		keywords: [
			"mall",
			"buy",
			"purchase"
		],
		skins: [
			{
				unified: "1f6cd-fe0f",
				native: "🛍️",
				x: 37,
				y: 60
			}
		],
		version: 1
	},
	school_satchel: {
		id: "school_satchel",
		name: "Backpack",
		keywords: [
			"school",
			"satchel",
			"student",
			"education",
			"bag"
		],
		skins: [
			{
				unified: "1f392",
				native: "🎒",
				x: 7,
				y: 26
			}
		],
		version: 1
	},
	thong_sandal: {
		id: "thong_sandal",
		name: "Thong Sandal",
		keywords: [
			"footwear",
			"summer"
		],
		skins: [
			{
				unified: "1fa74",
				native: "🩴",
				x: 53,
				y: 50
			}
		],
		version: 13
	},
	mans_shoe: {
		id: "mans_shoe",
		name: "Mans Shoe",
		keywords: [
			"man",
			"s",
			"fashion",
			"male"
		],
		skins: [
			{
				unified: "1f45e",
				native: "👞",
				x: 13,
				y: 26
			}
		],
		version: 1
	},
	athletic_shoe: {
		id: "athletic_shoe",
		name: "Running Shoe",
		keywords: [
			"athletic",
			"shoes",
			"sports",
			"sneakers"
		],
		skins: [
			{
				unified: "1f45f",
				native: "👟",
				x: 13,
				y: 27
			}
		],
		version: 1
	},
	hiking_boot: {
		id: "hiking_boot",
		name: "Hiking Boot",
		keywords: [
			"backpacking",
			"camping"
		],
		skins: [
			{
				unified: "1f97e",
				native: "🥾",
				x: 44,
				y: 16
			}
		],
		version: 11
	},
	womans_flat_shoe: {
		id: "womans_flat_shoe",
		name: "Flat Shoe",
		keywords: [
			"womans",
			"ballet",
			"slip",
			"on",
			"slipper"
		],
		skins: [
			{
				unified: "1f97f",
				native: "🥿",
				x: 44,
				y: 17
			}
		],
		version: 11
	},
	high_heel: {
		id: "high_heel",
		name: "High-Heeled Shoe",
		keywords: [
			"high",
			"heel",
			"heeled",
			"fashion",
			"shoes",
			"female",
			"pumps",
			"stiletto"
		],
		skins: [
			{
				unified: "1f460",
				native: "👠",
				x: 13,
				y: 28
			}
		],
		version: 1
	},
	sandal: {
		id: "sandal",
		name: "Womans Sandal",
		keywords: [
			"woman",
			"s",
			"shoes",
			"fashion",
			"flip",
			"flops"
		],
		skins: [
			{
				unified: "1f461",
				native: "👡",
				x: 13,
				y: 29
			}
		],
		version: 1
	},
	ballet_shoes: {
		id: "ballet_shoes",
		name: "Ballet Shoes",
		keywords: [
			"dance"
		],
		skins: [
			{
				unified: "1fa70",
				native: "🩰",
				x: 53,
				y: 46
			}
		],
		version: 12
	},
	boot: {
		id: "boot",
		name: "Womans Boots",
		keywords: [
			"boot",
			"woman",
			"s",
			"shoes",
			"fashion"
		],
		skins: [
			{
				unified: "1f462",
				native: "👢",
				x: 13,
				y: 30
			}
		],
		version: 1
	},
	crown: {
		id: "crown",
		name: "Crown",
		keywords: [
			"king",
			"kod",
			"leader",
			"royalty",
			"lord"
		],
		skins: [
			{
				unified: "1f451",
				native: "👑",
				x: 13,
				y: 13
			}
		],
		version: 1
	},
	womans_hat: {
		id: "womans_hat",
		name: "Womans Hat",
		keywords: [
			"woman",
			"s",
			"fashion",
			"accessories",
			"female",
			"lady",
			"spring"
		],
		skins: [
			{
				unified: "1f452",
				native: "👒",
				x: 13,
				y: 14
			}
		],
		version: 1
	},
	tophat: {
		id: "tophat",
		name: "Top Hat",
		keywords: [
			"tophat",
			"magic",
			"gentleman",
			"classy",
			"circus"
		],
		skins: [
			{
				unified: "1f3a9",
				native: "🎩",
				x: 7,
				y: 44
			}
		],
		version: 1
	},
	mortar_board: {
		id: "mortar_board",
		name: "Graduation Cap",
		keywords: [
			"mortar",
			"board",
			"school",
			"college",
			"degree",
			"university",
			"hat",
			"legal",
			"learn",
			"education"
		],
		skins: [
			{
				unified: "1f393",
				native: "🎓",
				x: 7,
				y: 27
			}
		],
		version: 1
	},
	billed_cap: {
		id: "billed_cap",
		name: "Billed Cap",
		keywords: [
			"baseball"
		],
		skins: [
			{
				unified: "1f9e2",
				native: "🧢",
				x: 53,
				y: 16
			}
		],
		version: 5
	},
	military_helmet: {
		id: "military_helmet",
		name: "Military Helmet",
		keywords: [
			"army",
			"protection"
		],
		skins: [
			{
				unified: "1fa96",
				native: "🪖",
				x: 54,
				y: 8
			}
		],
		version: 13
	},
	helmet_with_white_cross: {
		id: "helmet_with_white_cross",
		name: "Rescue Worker’s Helmet",
		keywords: [
			"with",
			"white",
			"cross",
			"worker",
			"s",
			"construction",
			"build"
		],
		skins: [
			{
				unified: "26d1-fe0f",
				native: "⛑️",
				x: 57,
				y: 51
			}
		],
		version: 1
	},
	prayer_beads: {
		id: "prayer_beads",
		name: "Prayer Beads",
		keywords: [
			"dhikr",
			"religious"
		],
		skins: [
			{
				unified: "1f4ff",
				native: "📿",
				x: 29,
				y: 24
			}
		],
		version: 1
	},
	lipstick: {
		id: "lipstick",
		name: "Lipstick",
		keywords: [
			"female",
			"girl",
			"fashion",
			"woman"
		],
		skins: [
			{
				unified: "1f484",
				native: "💄",
				x: 25,
				y: 52
			}
		],
		version: 1
	},
	ring: {
		id: "ring",
		name: "Ring",
		keywords: [
			"wedding",
			"propose",
			"marriage",
			"valentines",
			"diamond",
			"fashion",
			"jewelry",
			"gem",
			"engagement"
		],
		skins: [
			{
				unified: "1f48d",
				native: "💍",
				x: 26,
				y: 39
			}
		],
		version: 1
	},
	gem: {
		id: "gem",
		name: "Gem Stone",
		keywords: [
			"blue",
			"ruby",
			"diamond",
			"jewelry"
		],
		skins: [
			{
				unified: "1f48e",
				native: "💎",
				x: 26,
				y: 40
			}
		],
		version: 1
	},
	mute: {
		id: "mute",
		name: "Muted Speaker",
		keywords: [
			"mute",
			"sound",
			"volume",
			"silence",
			"quiet"
		],
		skins: [
			{
				unified: "1f507",
				native: "🔇",
				x: 29,
				y: 32
			}
		],
		version: 1
	},
	speaker: {
		id: "speaker",
		name: "Speaker",
		keywords: [
			"low",
			"volume",
			"sound",
			"silence",
			"broadcast"
		],
		skins: [
			{
				unified: "1f508",
				native: "🔈",
				x: 29,
				y: 33
			}
		],
		version: 1
	},
	sound: {
		id: "sound",
		name: "Speaker Medium Volume",
		keywords: [
			"sound",
			"broadcast"
		],
		skins: [
			{
				unified: "1f509",
				native: "🔉",
				x: 29,
				y: 34
			}
		],
		version: 1
	},
	loud_sound: {
		id: "loud_sound",
		name: "Speaker High Volume",
		keywords: [
			"loud",
			"sound",
			"noise",
			"noisy",
			"broadcast"
		],
		skins: [
			{
				unified: "1f50a",
				native: "🔊",
				x: 29,
				y: 35
			}
		],
		version: 1
	},
	loudspeaker: {
		id: "loudspeaker",
		name: "Loudspeaker",
		keywords: [
			"volume",
			"sound"
		],
		skins: [
			{
				unified: "1f4e2",
				native: "📢",
				x: 28,
				y: 57
			}
		],
		version: 1
	},
	mega: {
		id: "mega",
		name: "Megaphone",
		keywords: [
			"mega",
			"sound",
			"speaker",
			"volume"
		],
		skins: [
			{
				unified: "1f4e3",
				native: "📣",
				x: 28,
				y: 58
			}
		],
		version: 1
	},
	postal_horn: {
		id: "postal_horn",
		name: "Postal Horn",
		keywords: [
			"instrument",
			"music"
		],
		skins: [
			{
				unified: "1f4ef",
				native: "📯",
				x: 29,
				y: 9
			}
		],
		version: 1
	},
	bell: {
		id: "bell",
		name: "Bell",
		keywords: [
			"sound",
			"notification",
			"christmas",
			"xmas",
			"chime"
		],
		skins: [
			{
				unified: "1f514",
				native: "🔔",
				x: 29,
				y: 45
			}
		],
		version: 1
	},
	no_bell: {
		id: "no_bell",
		name: "Bell with Slash",
		keywords: [
			"no",
			"sound",
			"volume",
			"mute",
			"quiet",
			"silent"
		],
		skins: [
			{
				unified: "1f515",
				native: "🔕",
				x: 29,
				y: 46
			}
		],
		version: 1
	},
	musical_score: {
		id: "musical_score",
		name: "Musical Score",
		keywords: [
			"treble",
			"clef",
			"compose"
		],
		skins: [
			{
				unified: "1f3bc",
				native: "🎼",
				x: 8,
				y: 2
			}
		],
		version: 1
	},
	musical_note: {
		id: "musical_note",
		name: "Musical Note",
		keywords: [
			"score",
			"tone",
			"sound"
		],
		skins: [
			{
				unified: "1f3b5",
				native: "🎵",
				x: 7,
				y: 56
			}
		],
		version: 1
	},
	notes: {
		id: "notes",
		name: "Musical Notes",
		keywords: [
			"music",
			"score"
		],
		skins: [
			{
				unified: "1f3b6",
				native: "🎶",
				x: 7,
				y: 57
			}
		],
		version: 1
	},
	studio_microphone: {
		id: "studio_microphone",
		name: "Studio Microphone",
		keywords: [
			"sing",
			"recording",
			"artist",
			"talkshow"
		],
		skins: [
			{
				unified: "1f399-fe0f",
				native: "🎙️",
				x: 7,
				y: 30
			}
		],
		version: 1
	},
	level_slider: {
		id: "level_slider",
		name: "Level Slider",
		keywords: [
			"scale"
		],
		skins: [
			{
				unified: "1f39a-fe0f",
				native: "🎚️",
				x: 7,
				y: 31
			}
		],
		version: 1
	},
	control_knobs: {
		id: "control_knobs",
		name: "Control Knobs",
		keywords: [
			"dial"
		],
		skins: [
			{
				unified: "1f39b-fe0f",
				native: "🎛️",
				x: 7,
				y: 32
			}
		],
		version: 1
	},
	microphone: {
		id: "microphone",
		name: "Microphone",
		keywords: [
			"sound",
			"music",
			"PA",
			"sing",
			"talkshow"
		],
		skins: [
			{
				unified: "1f3a4",
				native: "🎤",
				x: 7,
				y: 39
			}
		],
		version: 1
	},
	headphones: {
		id: "headphones",
		name: "Headphone",
		keywords: [
			"headphones",
			"music",
			"score",
			"gadgets"
		],
		skins: [
			{
				unified: "1f3a7",
				native: "🎧",
				x: 7,
				y: 42
			}
		],
		version: 1
	},
	radio: {
		id: "radio",
		name: "Radio",
		keywords: [
			"communication",
			"music",
			"podcast",
			"program"
		],
		skins: [
			{
				unified: "1f4fb",
				native: "📻",
				x: 29,
				y: 21
			}
		],
		version: 1
	},
	saxophone: {
		id: "saxophone",
		name: "Saxophone",
		keywords: [
			"music",
			"instrument",
			"jazz",
			"blues"
		],
		skins: [
			{
				unified: "1f3b7",
				native: "🎷",
				x: 7,
				y: 58
			}
		],
		version: 1
	},
	accordion: {
		id: "accordion",
		name: "Accordion",
		keywords: [
			"music"
		],
		skins: [
			{
				unified: "1fa97",
				native: "🪗",
				x: 54,
				y: 9
			}
		],
		version: 13
	},
	guitar: {
		id: "guitar",
		name: "Guitar",
		keywords: [
			"music",
			"instrument"
		],
		skins: [
			{
				unified: "1f3b8",
				native: "🎸",
				x: 7,
				y: 59
			}
		],
		version: 1
	},
	musical_keyboard: {
		id: "musical_keyboard",
		name: "Musical Keyboard",
		keywords: [
			"piano",
			"instrument",
			"compose"
		],
		skins: [
			{
				unified: "1f3b9",
				native: "🎹",
				x: 7,
				y: 60
			}
		],
		version: 1
	},
	trumpet: {
		id: "trumpet",
		name: "Trumpet",
		keywords: [
			"music",
			"brass"
		],
		skins: [
			{
				unified: "1f3ba",
				native: "🎺",
				x: 8,
				y: 0
			}
		],
		version: 1
	},
	violin: {
		id: "violin",
		name: "Violin",
		keywords: [
			"music",
			"instrument",
			"orchestra",
			"symphony"
		],
		skins: [
			{
				unified: "1f3bb",
				native: "🎻",
				x: 8,
				y: 1
			}
		],
		version: 1
	},
	banjo: {
		id: "banjo",
		name: "Banjo",
		keywords: [
			"music",
			"instructment"
		],
		skins: [
			{
				unified: "1fa95",
				native: "🪕",
				x: 54,
				y: 7
			}
		],
		version: 12
	},
	drum_with_drumsticks: {
		id: "drum_with_drumsticks",
		name: "Drum",
		keywords: [
			"with",
			"drumsticks",
			"music",
			"instrument",
			"snare"
		],
		skins: [
			{
				unified: "1f941",
				native: "🥁",
				x: 43,
				y: 12
			}
		],
		version: 3
	},
	long_drum: {
		id: "long_drum",
		name: "Long Drum",
		keywords: [
			"music"
		],
		skins: [
			{
				unified: "1fa98",
				native: "🪘",
				x: 54,
				y: 10
			}
		],
		version: 13
	},
	iphone: {
		id: "iphone",
		name: "Mobile Phone",
		keywords: [
			"iphone",
			"technology",
			"apple",
			"gadgets",
			"dial"
		],
		skins: [
			{
				unified: "1f4f1",
				native: "📱",
				x: 29,
				y: 11
			}
		],
		version: 1
	},
	calling: {
		id: "calling",
		name: "Mobile Phone with Arrow",
		keywords: [
			"calling",
			"iphone",
			"incoming"
		],
		skins: [
			{
				unified: "1f4f2",
				native: "📲",
				x: 29,
				y: 12
			}
		],
		version: 1
	},
	phone: {
		id: "phone",
		name: "Telephone",
		keywords: [
			"phone",
			"technology",
			"communication",
			"dial"
		],
		skins: [
			{
				unified: "260e-fe0f",
				native: "☎️",
				x: 56,
				y: 45
			}
		],
		version: 1
	},
	telephone_receiver: {
		id: "telephone_receiver",
		name: "Telephone Receiver",
		keywords: [
			"technology",
			"communication",
			"dial"
		],
		skins: [
			{
				unified: "1f4de",
				native: "📞",
				x: 28,
				y: 53
			}
		],
		version: 1
	},
	pager: {
		id: "pager",
		name: "Pager",
		keywords: [
			"bbcall",
			"oldschool",
			"90s"
		],
		skins: [
			{
				unified: "1f4df",
				native: "📟",
				x: 28,
				y: 54
			}
		],
		version: 1
	},
	fax: {
		id: "fax",
		name: "Fax Machine",
		keywords: [
			"communication",
			"technology"
		],
		skins: [
			{
				unified: "1f4e0",
				native: "📠",
				x: 28,
				y: 55
			}
		],
		version: 1
	},
	battery: {
		id: "battery",
		name: "Battery",
		keywords: [
			"power",
			"energy",
			"sustain"
		],
		skins: [
			{
				unified: "1f50b",
				native: "🔋",
				x: 29,
				y: 36
			}
		],
		version: 1
	},
	low_battery: {
		id: "low_battery",
		name: "Low Battery",
		keywords: [
			"drained",
			"dead"
		],
		skins: [
			{
				unified: "1faab",
				native: "🪫",
				x: 54,
				y: 29
			}
		],
		version: 14
	},
	electric_plug: {
		id: "electric_plug",
		name: "Electric Plug",
		keywords: [
			"charger",
			"power"
		],
		skins: [
			{
				unified: "1f50c",
				native: "🔌",
				x: 29,
				y: 37
			}
		],
		version: 1
	},
	computer: {
		id: "computer",
		name: "Laptop",
		keywords: [
			"computer",
			"technology",
			"screen",
			"display",
			"monitor"
		],
		skins: [
			{
				unified: "1f4bb",
				native: "💻",
				x: 28,
				y: 18
			}
		],
		version: 1
	},
	desktop_computer: {
		id: "desktop_computer",
		name: "Desktop Computer",
		keywords: [
			"technology",
			"computing",
			"screen"
		],
		skins: [
			{
				unified: "1f5a5-fe0f",
				native: "🖥️",
				x: 31,
				y: 56
			}
		],
		version: 1
	},
	printer: {
		id: "printer",
		name: "Printer",
		keywords: [
			"paper",
			"ink"
		],
		skins: [
			{
				unified: "1f5a8-fe0f",
				native: "🖨️",
				x: 31,
				y: 57
			}
		],
		version: 1
	},
	keyboard: {
		id: "keyboard",
		name: "Keyboard",
		keywords: [
			"technology",
			"computer",
			"type",
			"input",
			"text"
		],
		skins: [
			{
				unified: "2328-fe0f",
				native: "⌨️",
				x: 56,
				y: 15
			}
		],
		version: 1
	},
	three_button_mouse: {
		id: "three_button_mouse",
		name: "Computer Mouse",
		keywords: [
			"three",
			"button",
			"click"
		],
		skins: [
			{
				unified: "1f5b1-fe0f",
				native: "🖱️",
				x: 31,
				y: 58
			}
		],
		version: 1
	},
	trackball: {
		id: "trackball",
		name: "Trackball",
		keywords: [
			"technology",
			"trackpad"
		],
		skins: [
			{
				unified: "1f5b2-fe0f",
				native: "🖲️",
				x: 31,
				y: 59
			}
		],
		version: 1
	},
	minidisc: {
		id: "minidisc",
		name: "Minidisc",
		keywords: [
			"computer",
			"disk",
			"technology",
			"record",
			"data",
			"90s"
		],
		skins: [
			{
				unified: "1f4bd",
				native: "💽",
				x: 28,
				y: 20
			}
		],
		version: 1
	},
	floppy_disk: {
		id: "floppy_disk",
		name: "Floppy Disk",
		keywords: [
			"oldschool",
			"technology",
			"save",
			"90s",
			"80s"
		],
		skins: [
			{
				unified: "1f4be",
				native: "💾",
				x: 28,
				y: 21
			}
		],
		version: 1
	},
	cd: {
		id: "cd",
		name: "Optical Disc",
		keywords: [
			"cd",
			"disk",
			"technology",
			"dvd",
			"90s"
		],
		skins: [
			{
				unified: "1f4bf",
				native: "💿",
				x: 28,
				y: 22
			}
		],
		version: 1
	},
	dvd: {
		id: "dvd",
		name: "Dvd",
		keywords: [
			"cd",
			"disk",
			"disc"
		],
		skins: [
			{
				unified: "1f4c0",
				native: "📀",
				x: 28,
				y: 23
			}
		],
		version: 1
	},
	abacus: {
		id: "abacus",
		name: "Abacus",
		keywords: [
			"calculation"
		],
		skins: [
			{
				unified: "1f9ee",
				native: "🧮",
				x: 53,
				y: 28
			}
		],
		version: 11
	},
	movie_camera: {
		id: "movie_camera",
		name: "Movie Camera",
		keywords: [
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f3a5",
				native: "🎥",
				x: 7,
				y: 40
			}
		],
		version: 1
	},
	film_frames: {
		id: "film_frames",
		name: "Film Frames",
		keywords: [
			"movie"
		],
		skins: [
			{
				unified: "1f39e-fe0f",
				native: "🎞️",
				x: 7,
				y: 33
			}
		],
		version: 1
	},
	film_projector: {
		id: "film_projector",
		name: "Film Projector",
		keywords: [
			"video",
			"tape",
			"record",
			"movie"
		],
		skins: [
			{
				unified: "1f4fd-fe0f",
				native: "📽️",
				x: 29,
				y: 23
			}
		],
		version: 1
	},
	clapper: {
		id: "clapper",
		name: "Clapper Board",
		keywords: [
			"movie",
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f3ac",
				native: "🎬",
				x: 7,
				y: 47
			}
		],
		version: 1
	},
	tv: {
		id: "tv",
		name: "Television",
		keywords: [
			"tv",
			"technology",
			"program",
			"oldschool",
			"show"
		],
		skins: [
			{
				unified: "1f4fa",
				native: "📺",
				x: 29,
				y: 20
			}
		],
		version: 1
	},
	camera: {
		id: "camera",
		name: "Camera",
		keywords: [
			"gadgets",
			"photography"
		],
		skins: [
			{
				unified: "1f4f7",
				native: "📷",
				x: 29,
				y: 17
			}
		],
		version: 1
	},
	camera_with_flash: {
		id: "camera_with_flash",
		name: "Camera with Flash",
		keywords: [
			"photography",
			"gadgets"
		],
		skins: [
			{
				unified: "1f4f8",
				native: "📸",
				x: 29,
				y: 18
			}
		],
		version: 1
	},
	video_camera: {
		id: "video_camera",
		name: "Video Camera",
		keywords: [
			"film",
			"record"
		],
		skins: [
			{
				unified: "1f4f9",
				native: "📹",
				x: 29,
				y: 19
			}
		],
		version: 1
	},
	vhs: {
		id: "vhs",
		name: "Videocassette",
		keywords: [
			"vhs",
			"record",
			"video",
			"oldschool",
			"90s",
			"80s"
		],
		skins: [
			{
				unified: "1f4fc",
				native: "📼",
				x: 29,
				y: 22
			}
		],
		version: 1
	},
	mag: {
		id: "mag",
		name: "Magnifying Glass Tilted Left",
		keywords: [
			"mag",
			"search",
			"zoom",
			"find",
			"detective"
		],
		skins: [
			{
				unified: "1f50d",
				native: "🔍",
				x: 29,
				y: 38
			}
		],
		version: 1
	},
	mag_right: {
		id: "mag_right",
		name: "Magnifying Glass Tilted Right",
		keywords: [
			"mag",
			"search",
			"zoom",
			"find",
			"detective"
		],
		skins: [
			{
				unified: "1f50e",
				native: "🔎",
				x: 29,
				y: 39
			}
		],
		version: 1
	},
	candle: {
		id: "candle",
		name: "Candle",
		keywords: [
			"fire",
			"wax"
		],
		skins: [
			{
				unified: "1f56f-fe0f",
				native: "🕯️",
				x: 30,
				y: 56
			}
		],
		version: 1
	},
	bulb: {
		id: "bulb",
		name: "Light Bulb",
		keywords: [
			"electricity",
			"idea"
		],
		skins: [
			{
				unified: "1f4a1",
				native: "💡",
				x: 27,
				y: 48
			}
		],
		version: 1
	},
	flashlight: {
		id: "flashlight",
		name: "Flashlight",
		keywords: [
			"dark",
			"camping",
			"sight",
			"night"
		],
		skins: [
			{
				unified: "1f526",
				native: "🔦",
				x: 30,
				y: 2
			}
		],
		version: 1
	},
	izakaya_lantern: {
		id: "izakaya_lantern",
		name: "Izakaya Lantern",
		keywords: [
			"red",
			"paper",
			"light",
			"halloween",
			"spooky"
		],
		skins: [
			{
				unified: "1f3ee",
				native: "🏮",
				x: 10,
				y: 25
			}
		],
		version: 1
	},
	diya_lamp: {
		id: "diya_lamp",
		name: "Diya Lamp",
		keywords: [
			"lighting"
		],
		skins: [
			{
				unified: "1fa94",
				native: "🪔",
				x: 54,
				y: 6
			}
		],
		version: 12
	},
	notebook_with_decorative_cover: {
		id: "notebook_with_decorative_cover",
		name: "Notebook with Decorative Cover",
		keywords: [
			"classroom",
			"notes",
			"record",
			"paper",
			"study"
		],
		skins: [
			{
				unified: "1f4d4",
				native: "📔",
				x: 28,
				y: 43
			}
		],
		version: 1
	},
	closed_book: {
		id: "closed_book",
		name: "Closed Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"learn"
		],
		skins: [
			{
				unified: "1f4d5",
				native: "📕",
				x: 28,
				y: 44
			}
		],
		version: 1
	},
	book: {
		id: "book",
		name: "Open Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"literature",
			"learn",
			"study"
		],
		skins: [
			{
				unified: "1f4d6",
				native: "📖",
				x: 28,
				y: 45
			}
		],
		version: 1
	},
	green_book: {
		id: "green_book",
		name: "Green Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"study"
		],
		skins: [
			{
				unified: "1f4d7",
				native: "📗",
				x: 28,
				y: 46
			}
		],
		version: 1
	},
	blue_book: {
		id: "blue_book",
		name: "Blue Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"learn",
			"study"
		],
		skins: [
			{
				unified: "1f4d8",
				native: "📘",
				x: 28,
				y: 47
			}
		],
		version: 1
	},
	orange_book: {
		id: "orange_book",
		name: "Orange Book",
		keywords: [
			"read",
			"library",
			"knowledge",
			"textbook",
			"study"
		],
		skins: [
			{
				unified: "1f4d9",
				native: "📙",
				x: 28,
				y: 48
			}
		],
		version: 1
	},
	books: {
		id: "books",
		name: "Books",
		keywords: [
			"literature",
			"library",
			"study"
		],
		skins: [
			{
				unified: "1f4da",
				native: "📚",
				x: 28,
				y: 49
			}
		],
		version: 1
	},
	notebook: {
		id: "notebook",
		name: "Notebook",
		keywords: [
			"stationery",
			"record",
			"notes",
			"paper",
			"study"
		],
		skins: [
			{
				unified: "1f4d3",
				native: "📓",
				x: 28,
				y: 42
			}
		],
		version: 1
	},
	ledger: {
		id: "ledger",
		name: "Ledger",
		keywords: [
			"notes",
			"paper"
		],
		skins: [
			{
				unified: "1f4d2",
				native: "📒",
				x: 28,
				y: 41
			}
		],
		version: 1
	},
	page_with_curl: {
		id: "page_with_curl",
		name: "Page with Curl",
		keywords: [
			"documents",
			"office",
			"paper"
		],
		skins: [
			{
				unified: "1f4c3",
				native: "📃",
				x: 28,
				y: 26
			}
		],
		version: 1
	},
	scroll: {
		id: "scroll",
		name: "Scroll",
		keywords: [
			"documents",
			"ancient",
			"history",
			"paper"
		],
		skins: [
			{
				unified: "1f4dc",
				native: "📜",
				x: 28,
				y: 51
			}
		],
		version: 1
	},
	page_facing_up: {
		id: "page_facing_up",
		name: "Page Facing Up",
		keywords: [
			"documents",
			"office",
			"paper",
			"information"
		],
		skins: [
			{
				unified: "1f4c4",
				native: "📄",
				x: 28,
				y: 27
			}
		],
		version: 1
	},
	newspaper: {
		id: "newspaper",
		name: "Newspaper",
		keywords: [
			"press",
			"headline"
		],
		skins: [
			{
				unified: "1f4f0",
				native: "📰",
				x: 29,
				y: 10
			}
		],
		version: 1
	},
	rolled_up_newspaper: {
		id: "rolled_up_newspaper",
		name: "Rolled-Up Newspaper",
		keywords: [
			"rolled",
			"up",
			"press",
			"headline"
		],
		skins: [
			{
				unified: "1f5de-fe0f",
				native: "🗞️",
				x: 32,
				y: 8
			}
		],
		version: 1
	},
	bookmark_tabs: {
		id: "bookmark_tabs",
		name: "Bookmark Tabs",
		keywords: [
			"favorite",
			"save",
			"order",
			"tidy"
		],
		skins: [
			{
				unified: "1f4d1",
				native: "📑",
				x: 28,
				y: 40
			}
		],
		version: 1
	},
	bookmark: {
		id: "bookmark",
		name: "Bookmark",
		keywords: [
			"favorite",
			"label",
			"save"
		],
		skins: [
			{
				unified: "1f516",
				native: "🔖",
				x: 29,
				y: 47
			}
		],
		version: 1
	},
	label: {
		id: "label",
		name: "Label",
		keywords: [
			"sale",
			"tag"
		],
		skins: [
			{
				unified: "1f3f7-fe0f",
				native: "🏷️",
				x: 10,
				y: 37
			}
		],
		version: 1
	},
	moneybag: {
		id: "moneybag",
		name: "Money Bag",
		keywords: [
			"moneybag",
			"dollar",
			"payment",
			"coins",
			"sale"
		],
		skins: [
			{
				unified: "1f4b0",
				native: "💰",
				x: 28,
				y: 7
			}
		],
		version: 1
	},
	coin: {
		id: "coin",
		name: "Coin",
		keywords: [
			"money",
			"currency"
		],
		skins: [
			{
				unified: "1fa99",
				native: "🪙",
				x: 54,
				y: 11
			}
		],
		version: 13
	},
	yen: {
		id: "yen",
		name: "Yen Banknote",
		keywords: [
			"money",
			"sales",
			"japanese",
			"dollar",
			"currency"
		],
		skins: [
			{
				unified: "1f4b4",
				native: "💴",
				x: 28,
				y: 11
			}
		],
		version: 1
	},
	dollar: {
		id: "dollar",
		name: "Dollar Banknote",
		keywords: [
			"money",
			"sales",
			"bill",
			"currency"
		],
		skins: [
			{
				unified: "1f4b5",
				native: "💵",
				x: 28,
				y: 12
			}
		],
		version: 1
	},
	euro: {
		id: "euro",
		name: "Euro Banknote",
		keywords: [
			"money",
			"sales",
			"dollar",
			"currency"
		],
		skins: [
			{
				unified: "1f4b6",
				native: "💶",
				x: 28,
				y: 13
			}
		],
		version: 1
	},
	pound: {
		id: "pound",
		name: "Pound Banknote",
		keywords: [
			"british",
			"sterling",
			"money",
			"sales",
			"bills",
			"uk",
			"england",
			"currency"
		],
		skins: [
			{
				unified: "1f4b7",
				native: "💷",
				x: 28,
				y: 14
			}
		],
		version: 1
	},
	money_with_wings: {
		id: "money_with_wings",
		name: "Money with Wings",
		keywords: [
			"dollar",
			"bills",
			"payment",
			"sale"
		],
		skins: [
			{
				unified: "1f4b8",
				native: "💸",
				x: 28,
				y: 15
			}
		],
		version: 1
	},
	credit_card: {
		id: "credit_card",
		name: "Credit Card",
		keywords: [
			"money",
			"sales",
			"dollar",
			"bill",
			"payment",
			"shopping"
		],
		skins: [
			{
				unified: "1f4b3",
				native: "💳",
				x: 28,
				y: 10
			}
		],
		version: 1
	},
	receipt: {
		id: "receipt",
		name: "Receipt",
		keywords: [
			"accounting",
			"expenses"
		],
		skins: [
			{
				unified: "1f9fe",
				native: "🧾",
				x: 53,
				y: 44
			}
		],
		version: 11
	},
	chart: {
		id: "chart",
		name: "Chart Increasing with Yen",
		keywords: [
			"green",
			"square",
			"graph",
			"presentation",
			"stats"
		],
		skins: [
			{
				unified: "1f4b9",
				native: "💹",
				x: 28,
				y: 16
			}
		],
		version: 1
	},
	email: {
		id: "email",
		name: "Envelope",
		keywords: [
			"email",
			"letter",
			"postal",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "2709-fe0f",
				native: "✉️",
				x: 58,
				y: 26
			}
		],
		version: 1
	},
	"e-mail": {
		id: "e-mail",
		name: "E-Mail",
		keywords: [
			"e",
			"mail",
			"communication",
			"inbox"
		],
		skins: [
			{
				unified: "1f4e7",
				native: "📧",
				x: 29,
				y: 1
			}
		],
		version: 1
	},
	incoming_envelope: {
		id: "incoming_envelope",
		name: "Incoming Envelope",
		keywords: [
			"email",
			"inbox"
		],
		skins: [
			{
				unified: "1f4e8",
				native: "📨",
				x: 29,
				y: 2
			}
		],
		version: 1
	},
	envelope_with_arrow: {
		id: "envelope_with_arrow",
		name: "Envelope with Arrow",
		keywords: [
			"email",
			"communication"
		],
		skins: [
			{
				unified: "1f4e9",
				native: "📩",
				x: 29,
				y: 3
			}
		],
		version: 1
	},
	outbox_tray: {
		id: "outbox_tray",
		name: "Outbox Tray",
		keywords: [
			"inbox",
			"email"
		],
		skins: [
			{
				unified: "1f4e4",
				native: "📤",
				x: 28,
				y: 59
			}
		],
		version: 1
	},
	inbox_tray: {
		id: "inbox_tray",
		name: "Inbox Tray",
		keywords: [
			"email",
			"documents"
		],
		skins: [
			{
				unified: "1f4e5",
				native: "📥",
				x: 28,
				y: 60
			}
		],
		version: 1
	},
	"package": {
		id: "package",
		name: "Package",
		keywords: [
			"mail",
			"gift",
			"cardboard",
			"box",
			"moving"
		],
		skins: [
			{
				unified: "1f4e6",
				native: "📦",
				x: 29,
				y: 0
			}
		],
		version: 1
	},
	mailbox: {
		id: "mailbox",
		name: "Closed Mailbox with Raised Flag",
		keywords: [
			"email",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "1f4eb",
				native: "📫",
				x: 29,
				y: 5
			}
		],
		version: 1
	},
	mailbox_closed: {
		id: "mailbox_closed",
		name: "Closed Mailbox with Lowered Flag",
		keywords: [
			"email",
			"communication",
			"inbox"
		],
		skins: [
			{
				unified: "1f4ea",
				native: "📪",
				x: 29,
				y: 4
			}
		],
		version: 1
	},
	mailbox_with_mail: {
		id: "mailbox_with_mail",
		name: "Open Mailbox with Raised Flag",
		keywords: [
			"mail",
			"email",
			"inbox",
			"communication"
		],
		skins: [
			{
				unified: "1f4ec",
				native: "📬",
				x: 29,
				y: 6
			}
		],
		version: 1
	},
	mailbox_with_no_mail: {
		id: "mailbox_with_no_mail",
		name: "Open Mailbox with Lowered Flag",
		keywords: [
			"no",
			"mail",
			"email",
			"inbox"
		],
		skins: [
			{
				unified: "1f4ed",
				native: "📭",
				x: 29,
				y: 7
			}
		],
		version: 1
	},
	postbox: {
		id: "postbox",
		name: "Postbox",
		keywords: [
			"email",
			"letter",
			"envelope"
		],
		skins: [
			{
				unified: "1f4ee",
				native: "📮",
				x: 29,
				y: 8
			}
		],
		version: 1
	},
	ballot_box_with_ballot: {
		id: "ballot_box_with_ballot",
		name: "Ballot Box with Ballot",
		keywords: [
			"election",
			"vote"
		],
		skins: [
			{
				unified: "1f5f3-fe0f",
				native: "🗳️",
				x: 32,
				y: 13
			}
		],
		version: 1
	},
	pencil2: {
		id: "pencil2",
		name: "Pencil",
		keywords: [
			"pencil2",
			"stationery",
			"write",
			"paper",
			"writing",
			"school",
			"study"
		],
		skins: [
			{
				unified: "270f-fe0f",
				native: "✏️",
				x: 58,
				y: 51
			}
		],
		version: 1
	},
	black_nib: {
		id: "black_nib",
		name: "Black Nib",
		keywords: [
			"pen",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "2712-fe0f",
				native: "✒️",
				x: 58,
				y: 52
			}
		],
		version: 1
	},
	lower_left_fountain_pen: {
		id: "lower_left_fountain_pen",
		name: "Fountain Pen",
		keywords: [
			"lower",
			"left",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "1f58b-fe0f",
				native: "🖋️",
				x: 31,
				y: 34
			}
		],
		version: 1
	},
	lower_left_ballpoint_pen: {
		id: "lower_left_ballpoint_pen",
		name: "Pen",
		keywords: [
			"lower",
			"left",
			"ballpoint",
			"stationery",
			"writing",
			"write"
		],
		skins: [
			{
				unified: "1f58a-fe0f",
				native: "🖊️",
				x: 31,
				y: 33
			}
		],
		version: 1
	},
	lower_left_paintbrush: {
		id: "lower_left_paintbrush",
		name: "Paintbrush",
		keywords: [
			"lower",
			"left",
			"drawing",
			"creativity",
			"art"
		],
		skins: [
			{
				unified: "1f58c-fe0f",
				native: "🖌️",
				x: 31,
				y: 35
			}
		],
		version: 1
	},
	lower_left_crayon: {
		id: "lower_left_crayon",
		name: "Crayon",
		keywords: [
			"lower",
			"left",
			"drawing",
			"creativity"
		],
		skins: [
			{
				unified: "1f58d-fe0f",
				native: "🖍️",
				x: 31,
				y: 36
			}
		],
		version: 1
	},
	memo: {
		id: "memo",
		name: "Memo",
		keywords: [
			"pencil",
			"write",
			"documents",
			"stationery",
			"paper",
			"writing",
			"legal",
			"exam",
			"quiz",
			"test",
			"study",
			"compose"
		],
		skins: [
			{
				unified: "1f4dd",
				native: "📝",
				x: 28,
				y: 52
			}
		],
		version: 1
	},
	briefcase: {
		id: "briefcase",
		name: "Briefcase",
		keywords: [
			"business",
			"documents",
			"work",
			"law",
			"legal",
			"job",
			"career"
		],
		skins: [
			{
				unified: "1f4bc",
				native: "💼",
				x: 28,
				y: 19
			}
		],
		version: 1
	},
	file_folder: {
		id: "file_folder",
		name: "File Folder",
		keywords: [
			"documents",
			"business",
			"office"
		],
		skins: [
			{
				unified: "1f4c1",
				native: "📁",
				x: 28,
				y: 24
			}
		],
		version: 1
	},
	open_file_folder: {
		id: "open_file_folder",
		name: "Open File Folder",
		keywords: [
			"documents",
			"load"
		],
		skins: [
			{
				unified: "1f4c2",
				native: "📂",
				x: 28,
				y: 25
			}
		],
		version: 1
	},
	card_index_dividers: {
		id: "card_index_dividers",
		name: "Card Index Dividers",
		keywords: [
			"organizing",
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f5c2-fe0f",
				native: "🗂️",
				x: 32,
				y: 0
			}
		],
		version: 1
	},
	date: {
		id: "date",
		name: "Calendar",
		keywords: [
			"date",
			"schedule"
		],
		skins: [
			{
				unified: "1f4c5",
				native: "📅",
				x: 28,
				y: 28
			}
		],
		version: 1
	},
	calendar: {
		id: "calendar",
		name: "Tear-off Calendar",
		keywords: [
			"tear",
			"off",
			"schedule",
			"date",
			"planning"
		],
		skins: [
			{
				unified: "1f4c6",
				native: "📆",
				x: 28,
				y: 29
			}
		],
		version: 1
	},
	spiral_note_pad: {
		id: "spiral_note_pad",
		name: "Spiral Notepad",
		keywords: [
			"note",
			"pad",
			"memo",
			"stationery"
		],
		skins: [
			{
				unified: "1f5d2-fe0f",
				native: "🗒️",
				x: 32,
				y: 4
			}
		],
		version: 1
	},
	spiral_calendar_pad: {
		id: "spiral_calendar_pad",
		name: "Spiral Calendar",
		keywords: [
			"pad",
			"date",
			"schedule",
			"planning"
		],
		skins: [
			{
				unified: "1f5d3-fe0f",
				native: "🗓️",
				x: 32,
				y: 5
			}
		],
		version: 1
	},
	card_index: {
		id: "card_index",
		name: "Card Index",
		keywords: [
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f4c7",
				native: "📇",
				x: 28,
				y: 30
			}
		],
		version: 1
	},
	chart_with_upwards_trend: {
		id: "chart_with_upwards_trend",
		name: "Chart Increasing",
		keywords: [
			"with",
			"upwards",
			"trend",
			"graph",
			"presentation",
			"stats",
			"recovery",
			"business",
			"economics",
			"money",
			"sales",
			"good",
			"success"
		],
		skins: [
			{
				unified: "1f4c8",
				native: "📈",
				x: 28,
				y: 31
			}
		],
		version: 1
	},
	chart_with_downwards_trend: {
		id: "chart_with_downwards_trend",
		name: "Chart Decreasing",
		keywords: [
			"with",
			"downwards",
			"trend",
			"graph",
			"presentation",
			"stats",
			"recession",
			"business",
			"economics",
			"money",
			"sales",
			"bad",
			"failure"
		],
		skins: [
			{
				unified: "1f4c9",
				native: "📉",
				x: 28,
				y: 32
			}
		],
		version: 1
	},
	bar_chart: {
		id: "bar_chart",
		name: "Bar Chart",
		keywords: [
			"graph",
			"presentation",
			"stats"
		],
		skins: [
			{
				unified: "1f4ca",
				native: "📊",
				x: 28,
				y: 33
			}
		],
		version: 1
	},
	clipboard: {
		id: "clipboard",
		name: "Clipboard",
		keywords: [
			"stationery",
			"documents"
		],
		skins: [
			{
				unified: "1f4cb",
				native: "📋",
				x: 28,
				y: 34
			}
		],
		version: 1
	},
	pushpin: {
		id: "pushpin",
		name: "Pushpin",
		keywords: [
			"stationery",
			"mark",
			"here"
		],
		skins: [
			{
				unified: "1f4cc",
				native: "📌",
				x: 28,
				y: 35
			}
		],
		version: 1
	},
	round_pushpin: {
		id: "round_pushpin",
		name: "Round Pushpin",
		keywords: [
			"stationery",
			"location",
			"map",
			"here"
		],
		skins: [
			{
				unified: "1f4cd",
				native: "📍",
				x: 28,
				y: 36
			}
		],
		version: 1
	},
	paperclip: {
		id: "paperclip",
		name: "Paperclip",
		keywords: [
			"documents",
			"stationery"
		],
		skins: [
			{
				unified: "1f4ce",
				native: "📎",
				x: 28,
				y: 37
			}
		],
		version: 1
	},
	linked_paperclips: {
		id: "linked_paperclips",
		name: "Linked Paperclips",
		keywords: [
			"documents",
			"stationery"
		],
		skins: [
			{
				unified: "1f587-fe0f",
				native: "🖇️",
				x: 31,
				y: 32
			}
		],
		version: 1
	},
	straight_ruler: {
		id: "straight_ruler",
		name: "Straight Ruler",
		keywords: [
			"stationery",
			"calculate",
			"length",
			"math",
			"school",
			"drawing",
			"architect",
			"sketch"
		],
		skins: [
			{
				unified: "1f4cf",
				native: "📏",
				x: 28,
				y: 38
			}
		],
		version: 1
	},
	triangular_ruler: {
		id: "triangular_ruler",
		name: "Triangular Ruler",
		keywords: [
			"stationery",
			"math",
			"architect",
			"sketch"
		],
		skins: [
			{
				unified: "1f4d0",
				native: "📐",
				x: 28,
				y: 39
			}
		],
		version: 1
	},
	scissors: {
		id: "scissors",
		name: "Scissors",
		keywords: [
			"stationery",
			"cut"
		],
		skins: [
			{
				unified: "2702-fe0f",
				native: "✂️",
				x: 58,
				y: 23
			}
		],
		version: 1
	},
	card_file_box: {
		id: "card_file_box",
		name: "Card File Box",
		keywords: [
			"business",
			"stationery"
		],
		skins: [
			{
				unified: "1f5c3-fe0f",
				native: "🗃️",
				x: 32,
				y: 1
			}
		],
		version: 1
	},
	file_cabinet: {
		id: "file_cabinet",
		name: "File Cabinet",
		keywords: [
			"filing",
			"organizing"
		],
		skins: [
			{
				unified: "1f5c4-fe0f",
				native: "🗄️",
				x: 32,
				y: 2
			}
		],
		version: 1
	},
	wastebasket: {
		id: "wastebasket",
		name: "Wastebasket",
		keywords: [
			"bin",
			"trash",
			"rubbish",
			"garbage",
			"toss"
		],
		skins: [
			{
				unified: "1f5d1-fe0f",
				native: "🗑️",
				x: 32,
				y: 3
			}
		],
		version: 1
	},
	lock: {
		id: "lock",
		name: "Lock",
		keywords: [
			"locked",
			"security",
			"password",
			"padlock"
		],
		skins: [
			{
				unified: "1f512",
				native: "🔒",
				x: 29,
				y: 43
			}
		],
		version: 1
	},
	unlock: {
		id: "unlock",
		name: "Unlocked",
		keywords: [
			"unlock",
			"privacy",
			"security"
		],
		skins: [
			{
				unified: "1f513",
				native: "🔓",
				x: 29,
				y: 44
			}
		],
		version: 1
	},
	lock_with_ink_pen: {
		id: "lock_with_ink_pen",
		name: "Locked with Pen",
		keywords: [
			"lock",
			"ink",
			"security",
			"secret"
		],
		skins: [
			{
				unified: "1f50f",
				native: "🔏",
				x: 29,
				y: 40
			}
		],
		version: 1
	},
	closed_lock_with_key: {
		id: "closed_lock_with_key",
		name: "Locked with Key",
		keywords: [
			"closed",
			"lock",
			"security",
			"privacy"
		],
		skins: [
			{
				unified: "1f510",
				native: "🔐",
				x: 29,
				y: 41
			}
		],
		version: 1
	},
	key: {
		id: "key",
		name: "Key",
		keywords: [
			"lock",
			"door",
			"password"
		],
		skins: [
			{
				unified: "1f511",
				native: "🔑",
				x: 29,
				y: 42
			}
		],
		version: 1
	},
	old_key: {
		id: "old_key",
		name: "Old Key",
		keywords: [
			"lock",
			"door",
			"password"
		],
		skins: [
			{
				unified: "1f5dd-fe0f",
				native: "🗝️",
				x: 32,
				y: 7
			}
		],
		version: 1
	},
	hammer: {
		id: "hammer",
		name: "Hammer",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "1f528",
				native: "🔨",
				x: 30,
				y: 4
			}
		],
		version: 1
	},
	axe: {
		id: "axe",
		name: "Axe",
		keywords: [
			"tool",
			"chop",
			"cut"
		],
		skins: [
			{
				unified: "1fa93",
				native: "🪓",
				x: 54,
				y: 5
			}
		],
		version: 12
	},
	pick: {
		id: "pick",
		name: "Pick",
		keywords: [
			"tools",
			"dig"
		],
		skins: [
			{
				unified: "26cf-fe0f",
				native: "⛏️",
				x: 57,
				y: 50
			}
		],
		version: 1
	},
	hammer_and_pick: {
		id: "hammer_and_pick",
		name: "Hammer and Pick",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "2692-fe0f",
				native: "⚒️",
				x: 57,
				y: 28
			}
		],
		version: 1
	},
	hammer_and_wrench: {
		id: "hammer_and_wrench",
		name: "Hammer and Wrench",
		keywords: [
			"tools",
			"build",
			"create"
		],
		skins: [
			{
				unified: "1f6e0-fe0f",
				native: "🛠️",
				x: 38,
				y: 11
			}
		],
		version: 1
	},
	dagger_knife: {
		id: "dagger_knife",
		name: "Dagger",
		keywords: [
			"knife",
			"weapon"
		],
		skins: [
			{
				unified: "1f5e1-fe0f",
				native: "🗡️",
				x: 32,
				y: 9
			}
		],
		version: 1
	},
	crossed_swords: {
		id: "crossed_swords",
		name: "Crossed Swords",
		keywords: [
			"weapon"
		],
		skins: [
			{
				unified: "2694-fe0f",
				native: "⚔️",
				x: 57,
				y: 30
			}
		],
		version: 1
	},
	gun: {
		id: "gun",
		name: "Pistol",
		keywords: [
			"gun",
			"violence",
			"weapon",
			"revolver"
		],
		skins: [
			{
				unified: "1f52b",
				native: "🔫",
				x: 30,
				y: 7
			}
		],
		version: 1
	},
	boomerang: {
		id: "boomerang",
		name: "Boomerang",
		keywords: [
			"weapon"
		],
		skins: [
			{
				unified: "1fa83",
				native: "🪃",
				x: 53,
				y: 59
			}
		],
		version: 13
	},
	bow_and_arrow: {
		id: "bow_and_arrow",
		name: "Bow and Arrow",
		keywords: [
			"sports"
		],
		skins: [
			{
				unified: "1f3f9",
				native: "🏹",
				x: 10,
				y: 39
			}
		],
		version: 1
	},
	shield: {
		id: "shield",
		name: "Shield",
		keywords: [
			"protection",
			"security"
		],
		skins: [
			{
				unified: "1f6e1-fe0f",
				native: "🛡️",
				x: 38,
				y: 12
			}
		],
		version: 1
	},
	carpentry_saw: {
		id: "carpentry_saw",
		name: "Carpentry Saw",
		keywords: [
			"cut",
			"chop"
		],
		skins: [
			{
				unified: "1fa9a",
				native: "🪚",
				x: 54,
				y: 12
			}
		],
		version: 13
	},
	wrench: {
		id: "wrench",
		name: "Wrench",
		keywords: [
			"tools",
			"diy",
			"ikea",
			"fix",
			"maintainer"
		],
		skins: [
			{
				unified: "1f527",
				native: "🔧",
				x: 30,
				y: 3
			}
		],
		version: 1
	},
	screwdriver: {
		id: "screwdriver",
		name: "Screwdriver",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9b",
				native: "🪛",
				x: 54,
				y: 13
			}
		],
		version: 13
	},
	nut_and_bolt: {
		id: "nut_and_bolt",
		name: "Nut and Bolt",
		keywords: [
			"handy",
			"tools",
			"fix"
		],
		skins: [
			{
				unified: "1f529",
				native: "🔩",
				x: 30,
				y: 5
			}
		],
		version: 1
	},
	gear: {
		id: "gear",
		name: "Gear",
		keywords: [
			"cog"
		],
		skins: [
			{
				unified: "2699-fe0f",
				native: "⚙️",
				x: 57,
				y: 34
			}
		],
		version: 1
	},
	compression: {
		id: "compression",
		name: "Clamp",
		keywords: [
			"compression",
			"tool"
		],
		skins: [
			{
				unified: "1f5dc-fe0f",
				native: "🗜️",
				x: 32,
				y: 6
			}
		],
		version: 1
	},
	scales: {
		id: "scales",
		name: "Balance Scale",
		keywords: [
			"scales",
			"law",
			"fairness",
			"weight"
		],
		skins: [
			{
				unified: "2696-fe0f",
				native: "⚖️",
				x: 57,
				y: 32
			}
		],
		version: 1
	},
	probing_cane: {
		id: "probing_cane",
		name: "White Cane",
		keywords: [
			"probing",
			"accessibility"
		],
		skins: [
			{
				unified: "1f9af",
				native: "🦯",
				x: 45,
				y: 4
			}
		],
		version: 12
	},
	link: {
		id: "link",
		name: "Link",
		keywords: [
			"rings",
			"url"
		],
		skins: [
			{
				unified: "1f517",
				native: "🔗",
				x: 29,
				y: 48
			}
		],
		version: 1
	},
	chains: {
		id: "chains",
		name: "Chains",
		keywords: [
			"lock",
			"arrest"
		],
		skins: [
			{
				unified: "26d3-fe0f",
				native: "⛓️",
				x: 57,
				y: 52
			}
		],
		version: 1
	},
	hook: {
		id: "hook",
		name: "Hook",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9d",
				native: "🪝",
				x: 54,
				y: 15
			}
		],
		version: 13
	},
	toolbox: {
		id: "toolbox",
		name: "Toolbox",
		keywords: [
			"tools",
			"diy",
			"fix",
			"maintainer",
			"mechanic"
		],
		skins: [
			{
				unified: "1f9f0",
				native: "🧰",
				x: 53,
				y: 30
			}
		],
		version: 11
	},
	magnet: {
		id: "magnet",
		name: "Magnet",
		keywords: [
			"attraction",
			"magnetic"
		],
		skins: [
			{
				unified: "1f9f2",
				native: "🧲",
				x: 53,
				y: 32
			}
		],
		version: 11
	},
	ladder: {
		id: "ladder",
		name: "Ladder",
		keywords: [
			"tools"
		],
		skins: [
			{
				unified: "1fa9c",
				native: "🪜",
				x: 54,
				y: 14
			}
		],
		version: 13
	},
	alembic: {
		id: "alembic",
		name: "Alembic",
		keywords: [
			"distilling",
			"science",
			"experiment",
			"chemistry"
		],
		skins: [
			{
				unified: "2697-fe0f",
				native: "⚗️",
				x: 57,
				y: 33
			}
		],
		version: 1
	},
	test_tube: {
		id: "test_tube",
		name: "Test Tube",
		keywords: [
			"chemistry",
			"experiment",
			"lab",
			"science"
		],
		skins: [
			{
				unified: "1f9ea",
				native: "🧪",
				x: 53,
				y: 24
			}
		],
		version: 11
	},
	petri_dish: {
		id: "petri_dish",
		name: "Petri Dish",
		keywords: [
			"bacteria",
			"biology",
			"culture",
			"lab"
		],
		skins: [
			{
				unified: "1f9eb",
				native: "🧫",
				x: 53,
				y: 25
			}
		],
		version: 11
	},
	dna: {
		id: "dna",
		name: "Dna",
		keywords: [
			"biologist",
			"genetics",
			"life"
		],
		skins: [
			{
				unified: "1f9ec",
				native: "🧬",
				x: 53,
				y: 26
			}
		],
		version: 11
	},
	microscope: {
		id: "microscope",
		name: "Microscope",
		keywords: [
			"laboratory",
			"experiment",
			"zoomin",
			"science",
			"study"
		],
		skins: [
			{
				unified: "1f52c",
				native: "🔬",
				x: 30,
				y: 8
			}
		],
		version: 1
	},
	telescope: {
		id: "telescope",
		name: "Telescope",
		keywords: [
			"stars",
			"space",
			"zoom",
			"science",
			"astronomy"
		],
		skins: [
			{
				unified: "1f52d",
				native: "🔭",
				x: 30,
				y: 9
			}
		],
		version: 1
	},
	satellite_antenna: {
		id: "satellite_antenna",
		name: "Satellite Antenna",
		keywords: [
			"communication",
			"future",
			"radio",
			"space"
		],
		skins: [
			{
				unified: "1f4e1",
				native: "📡",
				x: 28,
				y: 56
			}
		],
		version: 1
	},
	syringe: {
		id: "syringe",
		name: "Syringe",
		keywords: [
			"health",
			"hospital",
			"drugs",
			"blood",
			"medicine",
			"needle",
			"doctor",
			"nurse"
		],
		skins: [
			{
				unified: "1f489",
				native: "💉",
				x: 26,
				y: 35
			}
		],
		version: 1
	},
	drop_of_blood: {
		id: "drop_of_blood",
		name: "Drop of Blood",
		keywords: [
			"period",
			"hurt",
			"harm",
			"wound"
		],
		skins: [
			{
				unified: "1fa78",
				native: "🩸",
				x: 53,
				y: 51
			}
		],
		version: 12
	},
	pill: {
		id: "pill",
		name: "Pill",
		keywords: [
			"health",
			"medicine",
			"doctor",
			"pharmacy",
			"drug"
		],
		skins: [
			{
				unified: "1f48a",
				native: "💊",
				x: 26,
				y: 36
			}
		],
		version: 1
	},
	adhesive_bandage: {
		id: "adhesive_bandage",
		name: "Adhesive Bandage",
		keywords: [
			"heal"
		],
		skins: [
			{
				unified: "1fa79",
				native: "🩹",
				x: 53,
				y: 52
			}
		],
		version: 12
	},
	crutch: {
		id: "crutch",
		name: "Crutch",
		keywords: [
			"accessibility",
			"assist"
		],
		skins: [
			{
				unified: "1fa7c",
				native: "🩼",
				x: 53,
				y: 55
			}
		],
		version: 14
	},
	stethoscope: {
		id: "stethoscope",
		name: "Stethoscope",
		keywords: [
			"health"
		],
		skins: [
			{
				unified: "1fa7a",
				native: "🩺",
				x: 53,
				y: 53
			}
		],
		version: 12
	},
	"x-ray": {
		id: "x-ray",
		name: "X-Ray",
		keywords: [
			"x",
			"ray",
			"skeleton",
			"medicine"
		],
		skins: [
			{
				unified: "1fa7b",
				native: "🩻",
				x: 53,
				y: 54
			}
		],
		version: 14
	},
	door: {
		id: "door",
		name: "Door",
		keywords: [
			"house",
			"entry",
			"exit"
		],
		skins: [
			{
				unified: "1f6aa",
				native: "🚪",
				x: 36,
				y: 30
			}
		],
		version: 1
	},
	elevator: {
		id: "elevator",
		name: "Elevator",
		keywords: [
			"lift"
		],
		skins: [
			{
				unified: "1f6d7",
				native: "🛗",
				x: 38,
				y: 7
			}
		],
		version: 13
	},
	mirror: {
		id: "mirror",
		name: "Mirror",
		keywords: [
			"reflection"
		],
		skins: [
			{
				unified: "1fa9e",
				native: "🪞",
				x: 54,
				y: 16
			}
		],
		version: 13
	},
	window: {
		id: "window",
		name: "Window",
		keywords: [
			"scenery"
		],
		skins: [
			{
				unified: "1fa9f",
				native: "🪟",
				x: 54,
				y: 17
			}
		],
		version: 13
	},
	bed: {
		id: "bed",
		name: "Bed",
		keywords: [
			"sleep",
			"rest"
		],
		skins: [
			{
				unified: "1f6cf-fe0f",
				native: "🛏️",
				x: 38,
				y: 1
			}
		],
		version: 1
	},
	couch_and_lamp: {
		id: "couch_and_lamp",
		name: "Couch and Lamp",
		keywords: [
			"read",
			"chill"
		],
		skins: [
			{
				unified: "1f6cb-fe0f",
				native: "🛋️",
				x: 37,
				y: 53
			}
		],
		version: 1
	},
	chair: {
		id: "chair",
		name: "Chair",
		keywords: [
			"sit",
			"furniture"
		],
		skins: [
			{
				unified: "1fa91",
				native: "🪑",
				x: 54,
				y: 3
			}
		],
		version: 12
	},
	toilet: {
		id: "toilet",
		name: "Toilet",
		keywords: [
			"restroom",
			"wc",
			"washroom",
			"bathroom",
			"potty"
		],
		skins: [
			{
				unified: "1f6bd",
				native: "🚽",
				x: 37,
				y: 39
			}
		],
		version: 1
	},
	plunger: {
		id: "plunger",
		name: "Plunger",
		keywords: [
			"toilet"
		],
		skins: [
			{
				unified: "1faa0",
				native: "🪠",
				x: 54,
				y: 18
			}
		],
		version: 13
	},
	shower: {
		id: "shower",
		name: "Shower",
		keywords: [
			"clean",
			"water",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6bf",
				native: "🚿",
				x: 37,
				y: 41
			}
		],
		version: 1
	},
	bathtub: {
		id: "bathtub",
		name: "Bathtub",
		keywords: [
			"clean",
			"shower",
			"bathroom"
		],
		skins: [
			{
				unified: "1f6c1",
				native: "🛁",
				x: 37,
				y: 48
			}
		],
		version: 1
	},
	mouse_trap: {
		id: "mouse_trap",
		name: "Mouse Trap",
		keywords: [
			"cheese"
		],
		skins: [
			{
				unified: "1faa4",
				native: "🪤",
				x: 54,
				y: 22
			}
		],
		version: 13
	},
	razor: {
		id: "razor",
		name: "Razor",
		keywords: [
			"cut"
		],
		skins: [
			{
				unified: "1fa92",
				native: "🪒",
				x: 54,
				y: 4
			}
		],
		version: 12
	},
	lotion_bottle: {
		id: "lotion_bottle",
		name: "Lotion Bottle",
		keywords: [
			"moisturizer",
			"sunscreen"
		],
		skins: [
			{
				unified: "1f9f4",
				native: "🧴",
				x: 53,
				y: 34
			}
		],
		version: 11
	},
	safety_pin: {
		id: "safety_pin",
		name: "Safety Pin",
		keywords: [
			"diaper"
		],
		skins: [
			{
				unified: "1f9f7",
				native: "🧷",
				x: 53,
				y: 37
			}
		],
		version: 11
	},
	broom: {
		id: "broom",
		name: "Broom",
		keywords: [
			"cleaning",
			"sweeping",
			"witch"
		],
		skins: [
			{
				unified: "1f9f9",
				native: "🧹",
				x: 53,
				y: 39
			}
		],
		version: 11
	},
	basket: {
		id: "basket",
		name: "Basket",
		keywords: [
			"laundry"
		],
		skins: [
			{
				unified: "1f9fa",
				native: "🧺",
				x: 53,
				y: 40
			}
		],
		version: 11
	},
	roll_of_paper: {
		id: "roll_of_paper",
		name: "Roll of Paper",
		keywords: [
		],
		skins: [
			{
				unified: "1f9fb",
				native: "🧻",
				x: 53,
				y: 41
			}
		],
		version: 11
	},
	bucket: {
		id: "bucket",
		name: "Bucket",
		keywords: [
			"water",
			"container"
		],
		skins: [
			{
				unified: "1faa3",
				native: "🪣",
				x: 54,
				y: 21
			}
		],
		version: 13
	},
	soap: {
		id: "soap",
		name: "Soap",
		keywords: [
			"bar",
			"bathing",
			"cleaning",
			"lather"
		],
		skins: [
			{
				unified: "1f9fc",
				native: "🧼",
				x: 53,
				y: 42
			}
		],
		version: 11
	},
	bubbles: {
		id: "bubbles",
		name: "Bubbles",
		keywords: [
			"soap",
			"fun",
			"carbonation",
			"sparkling"
		],
		skins: [
			{
				unified: "1fae7",
				native: "🫧",
				x: 55,
				y: 19
			}
		],
		version: 14
	},
	toothbrush: {
		id: "toothbrush",
		name: "Toothbrush",
		keywords: [
			"hygiene",
			"dental"
		],
		skins: [
			{
				unified: "1faa5",
				native: "🪥",
				x: 54,
				y: 23
			}
		],
		version: 13
	},
	sponge: {
		id: "sponge",
		name: "Sponge",
		keywords: [
			"absorbing",
			"cleaning",
			"porous"
		],
		skins: [
			{
				unified: "1f9fd",
				native: "🧽",
				x: 53,
				y: 43
			}
		],
		version: 11
	},
	fire_extinguisher: {
		id: "fire_extinguisher",
		name: "Fire Extinguisher",
		keywords: [
			"quench"
		],
		skins: [
			{
				unified: "1f9ef",
				native: "🧯",
				x: 53,
				y: 29
			}
		],
		version: 11
	},
	shopping_trolley: {
		id: "shopping_trolley",
		name: "Shopping Cart",
		keywords: [
			"trolley"
		],
		skins: [
			{
				unified: "1f6d2",
				native: "🛒",
				x: 38,
				y: 4
			}
		],
		version: 3
	},
	smoking: {
		id: "smoking",
		name: "Cigarette",
		keywords: [
			"smoking",
			"kills",
			"tobacco",
			"joint",
			"smoke"
		],
		skins: [
			{
				unified: "1f6ac",
				native: "🚬",
				x: 36,
				y: 32
			}
		],
		version: 1
	},
	coffin: {
		id: "coffin",
		name: "Coffin",
		keywords: [
			"vampire",
			"dead",
			"die",
			"death",
			"rip",
			"graveyard",
			"cemetery",
			"casket",
			"funeral",
			"box"
		],
		skins: [
			{
				unified: "26b0-fe0f",
				native: "⚰️",
				x: 57,
				y: 42
			}
		],
		version: 1
	},
	headstone: {
		id: "headstone",
		name: "Headstone",
		keywords: [
			"death",
			"rip",
			"grave"
		],
		skins: [
			{
				unified: "1faa6",
				native: "🪦",
				x: 54,
				y: 24
			}
		],
		version: 13
	},
	funeral_urn: {
		id: "funeral_urn",
		name: "Funeral Urn",
		keywords: [
			"dead",
			"die",
			"death",
			"rip",
			"ashes"
		],
		skins: [
			{
				unified: "26b1-fe0f",
				native: "⚱️",
				x: 57,
				y: 43
			}
		],
		version: 1
	},
	moyai: {
		id: "moyai",
		name: "Moai",
		keywords: [
			"moyai",
			"rock",
			"easter",
			"island"
		],
		skins: [
			{
				unified: "1f5ff",
				native: "🗿",
				x: 32,
				y: 19
			}
		],
		version: 1
	},
	placard: {
		id: "placard",
		name: "Placard",
		keywords: [
			"announcement"
		],
		skins: [
			{
				unified: "1faa7",
				native: "🪧",
				x: 54,
				y: 25
			}
		],
		version: 13
	},
	identification_card: {
		id: "identification_card",
		name: "Identification Card",
		keywords: [
			"document"
		],
		skins: [
			{
				unified: "1faaa",
				native: "🪪",
				x: 54,
				y: 28
			}
		],
		version: 14
	},
	atm: {
		id: "atm",
		name: "Atm Sign",
		keywords: [
			"money",
			"sales",
			"cash",
			"blue",
			"square",
			"payment",
			"bank"
		],
		skins: [
			{
				unified: "1f3e7",
				native: "🏧",
				x: 10,
				y: 18
			}
		],
		version: 1
	},
	put_litter_in_its_place: {
		id: "put_litter_in_its_place",
		name: "Litter in Bin Sign",
		keywords: [
			"put",
			"its",
			"place",
			"blue",
			"square",
			"human",
			"info"
		],
		skins: [
			{
				unified: "1f6ae",
				native: "🚮",
				x: 36,
				y: 34
			}
		],
		version: 1
	},
	potable_water: {
		id: "potable_water",
		name: "Potable Water",
		keywords: [
			"blue",
			"square",
			"liquid",
			"restroom",
			"cleaning",
			"faucet"
		],
		skins: [
			{
				unified: "1f6b0",
				native: "🚰",
				x: 36,
				y: 36
			}
		],
		version: 1
	},
	wheelchair: {
		id: "wheelchair",
		name: "Wheelchair Symbol",
		keywords: [
			"blue",
			"square",
			"disabled",
			"accessibility"
		],
		skins: [
			{
				unified: "267f",
				native: "♿",
				x: 57,
				y: 27
			}
		],
		version: 1
	},
	mens: {
		id: "mens",
		name: "Men’s Room",
		keywords: [
			"mens",
			"men",
			"s",
			"toilet",
			"restroom",
			"wc",
			"blue",
			"square",
			"gender",
			"male"
		],
		skins: [
			{
				unified: "1f6b9",
				native: "🚹",
				x: 37,
				y: 35
			}
		],
		version: 1
	},
	womens: {
		id: "womens",
		name: "Women’s Room",
		keywords: [
			"womens",
			"women",
			"s",
			"purple",
			"square",
			"woman",
			"female",
			"toilet",
			"loo",
			"restroom",
			"gender"
		],
		skins: [
			{
				unified: "1f6ba",
				native: "🚺",
				x: 37,
				y: 36
			}
		],
		version: 1
	},
	restroom: {
		id: "restroom",
		name: "Restroom",
		keywords: [
			"blue",
			"square",
			"toilet",
			"refresh",
			"wc",
			"gender"
		],
		skins: [
			{
				unified: "1f6bb",
				native: "🚻",
				x: 37,
				y: 37
			}
		],
		version: 1
	},
	baby_symbol: {
		id: "baby_symbol",
		name: "Baby Symbol",
		keywords: [
			"orange",
			"square",
			"child"
		],
		skins: [
			{
				unified: "1f6bc",
				native: "🚼",
				x: 37,
				y: 38
			}
		],
		version: 1
	},
	wc: {
		id: "wc",
		name: "Water Closet",
		keywords: [
			"wc",
			"toilet",
			"restroom",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6be",
				native: "🚾",
				x: 37,
				y: 40
			}
		],
		version: 1
	},
	passport_control: {
		id: "passport_control",
		name: "Passport Control",
		keywords: [
			"custom",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6c2",
				native: "🛂",
				x: 37,
				y: 49
			}
		],
		version: 1
	},
	customs: {
		id: "customs",
		name: "Customs",
		keywords: [
			"passport",
			"border",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f6c3",
				native: "🛃",
				x: 37,
				y: 50
			}
		],
		version: 1
	},
	baggage_claim: {
		id: "baggage_claim",
		name: "Baggage Claim",
		keywords: [
			"blue",
			"square",
			"airport",
			"transport"
		],
		skins: [
			{
				unified: "1f6c4",
				native: "🛄",
				x: 37,
				y: 51
			}
		],
		version: 1
	},
	left_luggage: {
		id: "left_luggage",
		name: "Left Luggage",
		keywords: [
			"blue",
			"square",
			"travel"
		],
		skins: [
			{
				unified: "1f6c5",
				native: "🛅",
				x: 37,
				y: 52
			}
		],
		version: 1
	},
	warning: {
		id: "warning",
		name: "Warning",
		keywords: [
			"exclamation",
			"wip",
			"alert",
			"error",
			"problem",
			"issue"
		],
		skins: [
			{
				unified: "26a0-fe0f",
				native: "⚠️",
				x: 57,
				y: 37
			}
		],
		version: 1
	},
	children_crossing: {
		id: "children_crossing",
		name: "Children Crossing",
		keywords: [
			"school",
			"warning",
			"danger",
			"sign",
			"driving",
			"yellow",
			"diamond"
		],
		skins: [
			{
				unified: "1f6b8",
				native: "🚸",
				x: 37,
				y: 34
			}
		],
		version: 1
	},
	no_entry: {
		id: "no_entry",
		name: "No Entry",
		keywords: [
			"limit",
			"security",
			"privacy",
			"bad",
			"denied",
			"stop",
			"circle"
		],
		skins: [
			{
				unified: "26d4",
				native: "⛔",
				x: 57,
				y: 53
			}
		],
		version: 1
	},
	no_entry_sign: {
		id: "no_entry_sign",
		name: "Prohibited",
		keywords: [
			"no",
			"entry",
			"sign",
			"forbid",
			"stop",
			"limit",
			"denied",
			"disallow",
			"circle"
		],
		skins: [
			{
				unified: "1f6ab",
				native: "🚫",
				x: 36,
				y: 31
			}
		],
		version: 1
	},
	no_bicycles: {
		id: "no_bicycles",
		name: "No Bicycles",
		keywords: [
			"cyclist",
			"prohibited",
			"circle"
		],
		skins: [
			{
				unified: "1f6b3",
				native: "🚳",
				x: 36,
				y: 39
			}
		],
		version: 1
	},
	no_smoking: {
		id: "no_smoking",
		name: "No Smoking",
		keywords: [
			"cigarette",
			"blue",
			"square",
			"smell",
			"smoke"
		],
		skins: [
			{
				unified: "1f6ad",
				native: "🚭",
				x: 36,
				y: 33
			}
		],
		version: 1
	},
	do_not_litter: {
		id: "do_not_litter",
		name: "No Littering",
		keywords: [
			"do",
			"not",
			"litter",
			"trash",
			"bin",
			"garbage",
			"circle"
		],
		skins: [
			{
				unified: "1f6af",
				native: "🚯",
				x: 36,
				y: 35
			}
		],
		version: 1
	},
	"non-potable_water": {
		id: "non-potable_water",
		name: "Non-Potable Water",
		keywords: [
			"non",
			"potable",
			"drink",
			"faucet",
			"tap",
			"circle"
		],
		skins: [
			{
				unified: "1f6b1",
				native: "🚱",
				x: 36,
				y: 37
			}
		],
		version: 1
	},
	no_pedestrians: {
		id: "no_pedestrians",
		name: "No Pedestrians",
		keywords: [
			"rules",
			"crossing",
			"walking",
			"circle"
		],
		skins: [
			{
				unified: "1f6b7",
				native: "🚷",
				x: 37,
				y: 33
			}
		],
		version: 1
	},
	no_mobile_phones: {
		id: "no_mobile_phones",
		name: "No Mobile Phones",
		keywords: [
			"iphone",
			"mute",
			"circle"
		],
		skins: [
			{
				unified: "1f4f5",
				native: "📵",
				x: 29,
				y: 15
			}
		],
		version: 1
	},
	underage: {
		id: "underage",
		name: "No One Under Eighteen",
		keywords: [
			"underage",
			"18",
			"drink",
			"pub",
			"night",
			"minor",
			"circle"
		],
		skins: [
			{
				unified: "1f51e",
				native: "🔞",
				x: 29,
				y: 55
			}
		],
		version: 1
	},
	radioactive_sign: {
		id: "radioactive_sign",
		name: "Radioactive",
		keywords: [
			"sign",
			"nuclear",
			"danger"
		],
		skins: [
			{
				unified: "2622-fe0f",
				native: "☢️",
				x: 56,
				y: 57
			}
		],
		version: 1
	},
	biohazard_sign: {
		id: "biohazard_sign",
		name: "Biohazard",
		keywords: [
			"sign",
			"danger"
		],
		skins: [
			{
				unified: "2623-fe0f",
				native: "☣️",
				x: 56,
				y: 58
			}
		],
		version: 1
	},
	arrow_up: {
		id: "arrow_up",
		name: "Up Arrow",
		keywords: [
			"blue",
			"square",
			"continue",
			"top",
			"direction"
		],
		skins: [
			{
				unified: "2b06-fe0f",
				native: "⬆️",
				x: 59,
				y: 20
			}
		],
		version: 1
	},
	arrow_upper_right: {
		id: "arrow_upper_right",
		name: "Up-Right Arrow",
		keywords: [
			"upper",
			"right",
			"up",
			"blue",
			"square",
			"point",
			"direction",
			"diagonal",
			"northeast"
		],
		skins: [
			{
				unified: "2197-fe0f",
				native: "↗️",
				x: 56,
				y: 8
			}
		],
		version: 1
	},
	arrow_right: {
		id: "arrow_right",
		name: "Right Arrow",
		keywords: [
			"blue",
			"square",
			"next"
		],
		skins: [
			{
				unified: "27a1-fe0f",
				native: "➡️",
				x: 59,
				y: 14
			}
		],
		version: 1
	},
	arrow_lower_right: {
		id: "arrow_lower_right",
		name: "South East Arrow",
		keywords: [
			"lower",
			"right",
			"down",
			"blue",
			"square",
			"direction",
			"diagonal",
			"southeast"
		],
		skins: [
			{
				unified: "2198-fe0f",
				native: "↘️",
				x: 56,
				y: 9
			}
		],
		version: 1
	},
	arrow_down: {
		id: "arrow_down",
		name: "Down Arrow",
		keywords: [
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "2b07-fe0f",
				native: "⬇️",
				x: 59,
				y: 21
			}
		],
		version: 1
	},
	arrow_lower_left: {
		id: "arrow_lower_left",
		name: "Down-Left Arrow",
		keywords: [
			"lower",
			"left",
			"down",
			"blue",
			"square",
			"direction",
			"diagonal",
			"southwest"
		],
		skins: [
			{
				unified: "2199-fe0f",
				native: "↙️",
				x: 56,
				y: 10
			}
		],
		version: 1
	},
	arrow_left: {
		id: "arrow_left",
		name: "Left Arrow",
		keywords: [
			"blue",
			"square",
			"previous",
			"back"
		],
		skins: [
			{
				unified: "2b05-fe0f",
				native: "⬅️",
				x: 59,
				y: 19
			}
		],
		version: 1
	},
	arrow_upper_left: {
		id: "arrow_upper_left",
		name: "Up-Left Arrow",
		keywords: [
			"upper",
			"left",
			"up",
			"blue",
			"square",
			"point",
			"direction",
			"diagonal",
			"northwest"
		],
		skins: [
			{
				unified: "2196-fe0f",
				native: "↖️",
				x: 56,
				y: 7
			}
		],
		version: 1
	},
	arrow_up_down: {
		id: "arrow_up_down",
		name: "Up Down Arrow",
		keywords: [
			"blue",
			"square",
			"direction",
			"way",
			"vertical"
		],
		skins: [
			{
				unified: "2195-fe0f",
				native: "↕️",
				x: 56,
				y: 6
			}
		],
		version: 1
	},
	left_right_arrow: {
		id: "left_right_arrow",
		name: "Left Right Arrow",
		keywords: [
			"shape",
			"direction",
			"horizontal",
			"sideways"
		],
		skins: [
			{
				unified: "2194-fe0f",
				native: "↔️",
				x: 56,
				y: 5
			}
		],
		version: 1
	},
	leftwards_arrow_with_hook: {
		id: "leftwards_arrow_with_hook",
		name: "Right Arrow Curving Left",
		keywords: [
			"leftwards",
			"with",
			"hook",
			"back",
			"return",
			"blue",
			"square",
			"undo",
			"enter"
		],
		skins: [
			{
				unified: "21a9-fe0f",
				native: "↩️",
				x: 56,
				y: 11
			}
		],
		version: 1
	},
	arrow_right_hook: {
		id: "arrow_right_hook",
		name: "Left Arrow Curving Right",
		keywords: [
			"hook",
			"blue",
			"square",
			"return",
			"rotate",
			"direction"
		],
		skins: [
			{
				unified: "21aa-fe0f",
				native: "↪️",
				x: 56,
				y: 12
			}
		],
		version: 1
	},
	arrow_heading_up: {
		id: "arrow_heading_up",
		name: "Right Arrow Curving Up",
		keywords: [
			"heading",
			"blue",
			"square",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "2934-fe0f",
				native: "⤴️",
				x: 59,
				y: 17
			}
		],
		version: 1
	},
	arrow_heading_down: {
		id: "arrow_heading_down",
		name: "Right Arrow Curving Down",
		keywords: [
			"heading",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "2935-fe0f",
				native: "⤵️",
				x: 59,
				y: 18
			}
		],
		version: 1
	},
	arrows_clockwise: {
		id: "arrows_clockwise",
		name: "Clockwise Vertical Arrows",
		keywords: [
			"sync",
			"cycle",
			"round",
			"repeat"
		],
		skins: [
			{
				unified: "1f503",
				native: "🔃",
				x: 29,
				y: 28
			}
		],
		version: 1
	},
	arrows_counterclockwise: {
		id: "arrows_counterclockwise",
		name: "Counterclockwise Arrows Button",
		keywords: [
			"blue",
			"square",
			"sync",
			"cycle"
		],
		skins: [
			{
				unified: "1f504",
				native: "🔄",
				x: 29,
				y: 29
			}
		],
		version: 1
	},
	back: {
		id: "back",
		name: "Back Arrow",
		keywords: [
			"words",
			"return"
		],
		skins: [
			{
				unified: "1f519",
				native: "🔙",
				x: 29,
				y: 50
			}
		],
		version: 1
	},
	end: {
		id: "end",
		name: "End Arrow",
		keywords: [
			"words"
		],
		skins: [
			{
				unified: "1f51a",
				native: "🔚",
				x: 29,
				y: 51
			}
		],
		version: 1
	},
	on: {
		id: "on",
		name: "On! Arrow",
		keywords: [
			"on",
			"words"
		],
		skins: [
			{
				unified: "1f51b",
				native: "🔛",
				x: 29,
				y: 52
			}
		],
		version: 1
	},
	soon: {
		id: "soon",
		name: "Soon Arrow",
		keywords: [
			"words"
		],
		skins: [
			{
				unified: "1f51c",
				native: "🔜",
				x: 29,
				y: 53
			}
		],
		version: 1
	},
	top: {
		id: "top",
		name: "Top Arrow",
		keywords: [
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f51d",
				native: "🔝",
				x: 29,
				y: 54
			}
		],
		version: 1
	},
	place_of_worship: {
		id: "place_of_worship",
		name: "Place of Worship",
		keywords: [
			"religion",
			"church",
			"temple",
			"prayer"
		],
		skins: [
			{
				unified: "1f6d0",
				native: "🛐",
				x: 38,
				y: 2
			}
		],
		version: 1
	},
	atom_symbol: {
		id: "atom_symbol",
		name: "Atom Symbol",
		keywords: [
			"science",
			"physics",
			"chemistry"
		],
		skins: [
			{
				unified: "269b-fe0f",
				native: "⚛️",
				x: 57,
				y: 35
			}
		],
		version: 1
	},
	om_symbol: {
		id: "om_symbol",
		name: "Om",
		keywords: [
			"symbol",
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		skins: [
			{
				unified: "1f549-fe0f",
				native: "🕉️",
				x: 30,
				y: 26
			}
		],
		version: 1
	},
	star_of_david: {
		id: "star_of_david",
		name: "Star of David",
		keywords: [
			"judaism"
		],
		skins: [
			{
				unified: "2721-fe0f",
				native: "✡️",
				x: 58,
				y: 56
			}
		],
		version: 1
	},
	wheel_of_dharma: {
		id: "wheel_of_dharma",
		name: "Wheel of Dharma",
		keywords: [
			"hinduism",
			"buddhism",
			"sikhism",
			"jainism"
		],
		skins: [
			{
				unified: "2638-fe0f",
				native: "☸️",
				x: 57,
				y: 2
			}
		],
		version: 1
	},
	yin_yang: {
		id: "yin_yang",
		name: "Yin Yang",
		keywords: [
			"balance"
		],
		skins: [
			{
				unified: "262f-fe0f",
				native: "☯️",
				x: 57,
				y: 1
			}
		],
		version: 1
	},
	latin_cross: {
		id: "latin_cross",
		name: "Latin Cross",
		keywords: [
			"christianity"
		],
		skins: [
			{
				unified: "271d-fe0f",
				native: "✝️",
				x: 58,
				y: 55
			}
		],
		version: 1
	},
	orthodox_cross: {
		id: "orthodox_cross",
		name: "Orthodox Cross",
		keywords: [
			"suppedaneum",
			"religion"
		],
		skins: [
			{
				unified: "2626-fe0f",
				native: "☦️",
				x: 56,
				y: 59
			}
		],
		version: 1
	},
	star_and_crescent: {
		id: "star_and_crescent",
		name: "Star and Crescent",
		keywords: [
			"islam"
		],
		skins: [
			{
				unified: "262a-fe0f",
				native: "☪️",
				x: 56,
				y: 60
			}
		],
		version: 1
	},
	peace_symbol: {
		id: "peace_symbol",
		name: "Peace Symbol",
		keywords: [
			"hippie"
		],
		skins: [
			{
				unified: "262e-fe0f",
				native: "☮️",
				x: 57,
				y: 0
			}
		],
		version: 1
	},
	menorah_with_nine_branches: {
		id: "menorah_with_nine_branches",
		name: "Menorah",
		keywords: [
			"with",
			"nine",
			"branches",
			"hanukkah",
			"candles",
			"jewish"
		],
		skins: [
			{
				unified: "1f54e",
				native: "🕎",
				x: 30,
				y: 31
			}
		],
		version: 1
	},
	six_pointed_star: {
		id: "six_pointed_star",
		name: "Dotted Six-Pointed Star",
		keywords: [
			"six",
			"pointed",
			"purple",
			"square",
			"religion",
			"jewish",
			"hexagram"
		],
		skins: [
			{
				unified: "1f52f",
				native: "🔯",
				x: 30,
				y: 11
			}
		],
		version: 1
	},
	aries: {
		id: "aries",
		name: "Aries",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2648",
				native: "♈",
				x: 57,
				y: 7
			}
		],
		version: 1
	},
	taurus: {
		id: "taurus",
		name: "Taurus",
		keywords: [
			"purple",
			"square",
			"sign",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2649",
				native: "♉",
				x: 57,
				y: 8
			}
		],
		version: 1
	},
	gemini: {
		id: "gemini",
		name: "Gemini",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264a",
				native: "♊",
				x: 57,
				y: 9
			}
		],
		version: 1
	},
	cancer: {
		id: "cancer",
		name: "Cancer",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264b",
				native: "♋",
				x: 57,
				y: 10
			}
		],
		version: 1
	},
	leo: {
		id: "leo",
		name: "Leo",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "264c",
				native: "♌",
				x: 57,
				y: 11
			}
		],
		version: 1
	},
	virgo: {
		id: "virgo",
		name: "Virgo",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264d",
				native: "♍",
				x: 57,
				y: 12
			}
		],
		version: 1
	},
	libra: {
		id: "libra",
		name: "Libra",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "264e",
				native: "♎",
				x: 57,
				y: 13
			}
		],
		version: 1
	},
	scorpius: {
		id: "scorpius",
		name: "Scorpio",
		keywords: [
			"scorpius",
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "264f",
				native: "♏",
				x: 57,
				y: 14
			}
		],
		version: 1
	},
	sagittarius: {
		id: "sagittarius",
		name: "Sagittarius",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "2650",
				native: "♐",
				x: 57,
				y: 15
			}
		],
		version: 1
	},
	capricorn: {
		id: "capricorn",
		name: "Capricorn",
		keywords: [
			"sign",
			"zodiac",
			"purple",
			"square",
			"astrology"
		],
		skins: [
			{
				unified: "2651",
				native: "♑",
				x: 57,
				y: 16
			}
		],
		version: 1
	},
	aquarius: {
		id: "aquarius",
		name: "Aquarius",
		keywords: [
			"sign",
			"purple",
			"square",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2652",
				native: "♒",
				x: 57,
				y: 17
			}
		],
		version: 1
	},
	pisces: {
		id: "pisces",
		name: "Pisces",
		keywords: [
			"purple",
			"square",
			"sign",
			"zodiac",
			"astrology"
		],
		skins: [
			{
				unified: "2653",
				native: "♓",
				x: 57,
				y: 18
			}
		],
		version: 1
	},
	ophiuchus: {
		id: "ophiuchus",
		name: "Ophiuchus",
		keywords: [
			"sign",
			"purple",
			"square",
			"constellation",
			"astrology"
		],
		skins: [
			{
				unified: "26ce",
				native: "⛎",
				x: 57,
				y: 49
			}
		],
		version: 1
	},
	twisted_rightwards_arrows: {
		id: "twisted_rightwards_arrows",
		name: "Shuffle Tracks Button",
		keywords: [
			"twisted",
			"rightwards",
			"arrows",
			"blue",
			"square",
			"music",
			"random"
		],
		skins: [
			{
				unified: "1f500",
				native: "🔀",
				x: 29,
				y: 25
			}
		],
		version: 1
	},
	repeat: {
		id: "repeat",
		name: "Repeat Button",
		keywords: [
			"loop",
			"record"
		],
		skins: [
			{
				unified: "1f501",
				native: "🔁",
				x: 29,
				y: 26
			}
		],
		version: 1
	},
	repeat_one: {
		id: "repeat_one",
		name: "Repeat Single Button",
		keywords: [
			"one",
			"blue",
			"square",
			"loop"
		],
		skins: [
			{
				unified: "1f502",
				native: "🔂",
				x: 29,
				y: 27
			}
		],
		version: 1
	},
	arrow_forward: {
		id: "arrow_forward",
		name: "Play Button",
		keywords: [
			"arrow",
			"forward",
			"blue",
			"square",
			"right",
			"direction"
		],
		skins: [
			{
				unified: "25b6-fe0f",
				native: "▶️",
				x: 56,
				y: 34
			}
		],
		version: 1
	},
	fast_forward: {
		id: "fast_forward",
		name: "Fast-Forward Button",
		keywords: [
			"fast",
			"forward",
			"blue",
			"square",
			"play",
			"speed",
			"continue"
		],
		skins: [
			{
				unified: "23e9",
				native: "⏩",
				x: 56,
				y: 17
			}
		],
		version: 1
	},
	black_right_pointing_double_triangle_with_vertical_bar: {
		id: "black_right_pointing_double_triangle_with_vertical_bar",
		name: "Next Track Button",
		keywords: [
			"black",
			"right",
			"pointing",
			"double",
			"triangle",
			"with",
			"vertical",
			"bar",
			"forward",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ed-fe0f",
				native: "⏭️",
				x: 56,
				y: 21
			}
		],
		version: 1
	},
	black_right_pointing_triangle_with_double_vertical_bar: {
		id: "black_right_pointing_triangle_with_double_vertical_bar",
		name: "Play or Pause Button",
		keywords: [
			"black",
			"right",
			"pointing",
			"triangle",
			"with",
			"double",
			"vertical",
			"bar",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ef-fe0f",
				native: "⏯️",
				x: 56,
				y: 23
			}
		],
		version: 1
	},
	arrow_backward: {
		id: "arrow_backward",
		name: "Reverse Button",
		keywords: [
			"arrow",
			"backward",
			"blue",
			"square",
			"left",
			"direction"
		],
		skins: [
			{
				unified: "25c0-fe0f",
				native: "◀️",
				x: 56,
				y: 35
			}
		],
		version: 1
	},
	rewind: {
		id: "rewind",
		name: "Fast Reverse Button",
		keywords: [
			"rewind",
			"play",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23ea",
				native: "⏪",
				x: 56,
				y: 18
			}
		],
		version: 1
	},
	black_left_pointing_double_triangle_with_vertical_bar: {
		id: "black_left_pointing_double_triangle_with_vertical_bar",
		name: "Last Track Button",
		keywords: [
			"black",
			"left",
			"pointing",
			"double",
			"triangle",
			"with",
			"vertical",
			"bar",
			"backward"
		],
		skins: [
			{
				unified: "23ee-fe0f",
				native: "⏮️",
				x: 56,
				y: 22
			}
		],
		version: 1
	},
	arrow_up_small: {
		id: "arrow_up_small",
		name: "Upwards Button",
		keywords: [
			"arrow",
			"up",
			"small",
			"blue",
			"square",
			"triangle",
			"direction",
			"point",
			"forward",
			"top"
		],
		skins: [
			{
				unified: "1f53c",
				native: "🔼",
				x: 30,
				y: 24
			}
		],
		version: 1
	},
	arrow_double_up: {
		id: "arrow_double_up",
		name: "Fast Up Button",
		keywords: [
			"arrow",
			"double",
			"blue",
			"square",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "23eb",
				native: "⏫",
				x: 56,
				y: 19
			}
		],
		version: 1
	},
	arrow_down_small: {
		id: "arrow_down_small",
		name: "Downwards Button",
		keywords: [
			"arrow",
			"down",
			"small",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "1f53d",
				native: "🔽",
				x: 30,
				y: 25
			}
		],
		version: 1
	},
	arrow_double_down: {
		id: "arrow_double_down",
		name: "Fast Down Button",
		keywords: [
			"arrow",
			"double",
			"blue",
			"square",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "23ec",
				native: "⏬",
				x: 56,
				y: 20
			}
		],
		version: 1
	},
	double_vertical_bar: {
		id: "double_vertical_bar",
		name: "Pause Button",
		keywords: [
			"double",
			"vertical",
			"bar",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23f8-fe0f",
				native: "⏸️",
				x: 56,
				y: 28
			}
		],
		version: 1
	},
	black_square_for_stop: {
		id: "black_square_for_stop",
		name: "Stop Button",
		keywords: [
			"black",
			"square",
			"for",
			"blue"
		],
		skins: [
			{
				unified: "23f9-fe0f",
				native: "⏹️",
				x: 56,
				y: 29
			}
		],
		version: 1
	},
	black_circle_for_record: {
		id: "black_circle_for_record",
		name: "Record Button",
		keywords: [
			"black",
			"circle",
			"for",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23fa-fe0f",
				native: "⏺️",
				x: 56,
				y: 30
			}
		],
		version: 1
	},
	eject: {
		id: "eject",
		name: "Eject Button",
		keywords: [
			"blue",
			"square"
		],
		skins: [
			{
				unified: "23cf-fe0f",
				native: "⏏️",
				x: 56,
				y: 16
			}
		],
		version: 1
	},
	cinema: {
		id: "cinema",
		name: "Cinema",
		keywords: [
			"blue",
			"square",
			"record",
			"film",
			"movie",
			"curtain",
			"stage",
			"theater"
		],
		skins: [
			{
				unified: "1f3a6",
				native: "🎦",
				x: 7,
				y: 41
			}
		],
		version: 1
	},
	low_brightness: {
		id: "low_brightness",
		name: "Dim Button",
		keywords: [
			"low",
			"brightness",
			"sun",
			"afternoon",
			"warm",
			"summer"
		],
		skins: [
			{
				unified: "1f505",
				native: "🔅",
				x: 29,
				y: 30
			}
		],
		version: 1
	},
	high_brightness: {
		id: "high_brightness",
		name: "Bright Button",
		keywords: [
			"high",
			"brightness",
			"sun",
			"light"
		],
		skins: [
			{
				unified: "1f506",
				native: "🔆",
				x: 29,
				y: 31
			}
		],
		version: 1
	},
	signal_strength: {
		id: "signal_strength",
		name: "Antenna Bars",
		keywords: [
			"signal",
			"strength",
			"blue",
			"square",
			"reception",
			"phone",
			"internet",
			"connection",
			"wifi",
			"bluetooth"
		],
		skins: [
			{
				unified: "1f4f6",
				native: "📶",
				x: 29,
				y: 16
			}
		],
		version: 1
	},
	vibration_mode: {
		id: "vibration_mode",
		name: "Vibration Mode",
		keywords: [
			"orange",
			"square",
			"phone"
		],
		skins: [
			{
				unified: "1f4f3",
				native: "📳",
				x: 29,
				y: 13
			}
		],
		version: 1
	},
	mobile_phone_off: {
		id: "mobile_phone_off",
		name: "Mobile Phone off",
		keywords: [
			"mute",
			"orange",
			"square",
			"silence",
			"quiet"
		],
		skins: [
			{
				unified: "1f4f4",
				native: "📴",
				x: 29,
				y: 14
			}
		],
		version: 1
	},
	female_sign: {
		id: "female_sign",
		name: "Female Sign",
		keywords: [
			"woman",
			"women",
			"lady",
			"girl"
		],
		skins: [
			{
				unified: "2640-fe0f",
				native: "♀️",
				x: 57,
				y: 5
			}
		],
		version: 4
	},
	male_sign: {
		id: "male_sign",
		name: "Male Sign",
		keywords: [
			"man",
			"boy",
			"men"
		],
		skins: [
			{
				unified: "2642-fe0f",
				native: "♂️",
				x: 57,
				y: 6
			}
		],
		version: 4
	},
	transgender_symbol: {
		id: "transgender_symbol",
		name: "Transgender Symbol",
		keywords: [
			"lgbtq"
		],
		skins: [
			{
				unified: "26a7-fe0f",
				native: "⚧️",
				x: 57,
				y: 39
			}
		],
		version: 13
	},
	heavy_multiplication_x: {
		id: "heavy_multiplication_x",
		name: "Multiply",
		keywords: [
			"heavy",
			"multiplication",
			"x",
			"sign",
			"math",
			"calculation"
		],
		skins: [
			{
				unified: "2716-fe0f",
				native: "✖️",
				x: 58,
				y: 54
			}
		],
		version: 1
	},
	heavy_plus_sign: {
		id: "heavy_plus_sign",
		name: "Plus",
		keywords: [
			"heavy",
			"sign",
			"math",
			"calculation",
			"addition",
			"more",
			"increase"
		],
		skins: [
			{
				unified: "2795",
				native: "➕",
				x: 59,
				y: 11
			}
		],
		version: 1
	},
	heavy_minus_sign: {
		id: "heavy_minus_sign",
		name: "Minus",
		keywords: [
			"heavy",
			"sign",
			"math",
			"calculation",
			"subtract",
			"less"
		],
		skins: [
			{
				unified: "2796",
				native: "➖",
				x: 59,
				y: 12
			}
		],
		version: 1
	},
	heavy_division_sign: {
		id: "heavy_division_sign",
		name: "Divide",
		keywords: [
			"heavy",
			"division",
			"sign",
			"math",
			"calculation"
		],
		skins: [
			{
				unified: "2797",
				native: "➗",
				x: 59,
				y: 13
			}
		],
		version: 1
	},
	heavy_equals_sign: {
		id: "heavy_equals_sign",
		name: "Heavy Equals Sign",
		keywords: [
			"math"
		],
		skins: [
			{
				unified: "1f7f0",
				native: "🟰",
				x: 38,
				y: 43
			}
		],
		version: 14
	},
	infinity: {
		id: "infinity",
		name: "Infinity",
		keywords: [
			"forever"
		],
		skins: [
			{
				unified: "267e-fe0f",
				native: "♾️",
				x: 57,
				y: 26
			}
		],
		version: 11
	},
	bangbang: {
		id: "bangbang",
		name: "Double Exclamation Mark",
		keywords: [
			"bangbang",
			"surprise"
		],
		skins: [
			{
				unified: "203c-fe0f",
				native: "‼️",
				x: 56,
				y: 1
			}
		],
		version: 1
	},
	interrobang: {
		id: "interrobang",
		name: "Exclamation Question Mark",
		keywords: [
			"interrobang",
			"wat",
			"punctuation",
			"surprise"
		],
		skins: [
			{
				unified: "2049-fe0f",
				native: "⁉️",
				x: 56,
				y: 2
			}
		],
		version: 1
	},
	question: {
		id: "question",
		name: "Red Question Mark",
		keywords: [
			"doubt",
			"confused"
		],
		skins: [
			{
				unified: "2753",
				native: "❓",
				x: 59,
				y: 3
			}
		],
		version: 1
	},
	grey_question: {
		id: "grey_question",
		name: "White Question Mark",
		keywords: [
			"grey",
			"doubts",
			"gray",
			"huh",
			"confused"
		],
		skins: [
			{
				unified: "2754",
				native: "❔",
				x: 59,
				y: 4
			}
		],
		version: 1
	},
	grey_exclamation: {
		id: "grey_exclamation",
		name: "White Exclamation Mark",
		keywords: [
			"grey",
			"surprise",
			"punctuation",
			"gray",
			"wow",
			"warning"
		],
		skins: [
			{
				unified: "2755",
				native: "❕",
				x: 59,
				y: 5
			}
		],
		version: 1
	},
	exclamation: {
		id: "exclamation",
		name: "Red Exclamation Mark",
		keywords: [
			"heavy",
			"danger",
			"surprise",
			"punctuation",
			"wow",
			"warning"
		],
		skins: [
			{
				unified: "2757",
				native: "❗",
				x: 59,
				y: 6
			}
		],
		version: 1
	},
	wavy_dash: {
		id: "wavy_dash",
		name: "Wavy Dash",
		keywords: [
			"draw",
			"line",
			"moustache",
			"mustache",
			"squiggle",
			"scribble"
		],
		skins: [
			{
				unified: "3030-fe0f",
				native: "〰️",
				x: 59,
				y: 26
			}
		],
		version: 1
	},
	currency_exchange: {
		id: "currency_exchange",
		name: "Currency Exchange",
		keywords: [
			"money",
			"sales",
			"dollar",
			"travel"
		],
		skins: [
			{
				unified: "1f4b1",
				native: "💱",
				x: 28,
				y: 8
			}
		],
		version: 1
	},
	heavy_dollar_sign: {
		id: "heavy_dollar_sign",
		name: "Heavy Dollar Sign",
		keywords: [
			"money",
			"sales",
			"payment",
			"currency",
			"buck"
		],
		skins: [
			{
				unified: "1f4b2",
				native: "💲",
				x: 28,
				y: 9
			}
		],
		version: 1
	},
	medical_symbol: {
		id: "medical_symbol",
		name: "Medical Symbol",
		keywords: [
			"staff",
			"of",
			"aesculapius",
			"health",
			"hospital"
		],
		skins: [
			{
				unified: "2695-fe0f",
				native: "⚕️",
				x: 57,
				y: 31
			}
		],
		version: 4
	},
	recycle: {
		id: "recycle",
		name: "Recycling Symbol",
		keywords: [
			"recycle",
			"arrow",
			"environment",
			"garbage",
			"trash"
		],
		skins: [
			{
				unified: "267b-fe0f",
				native: "♻️",
				x: 57,
				y: 25
			}
		],
		version: 1
	},
	fleur_de_lis: {
		id: "fleur_de_lis",
		name: "Fleur-De-Lis",
		keywords: [
			"fleur",
			"de",
			"lis",
			"decorative",
			"scout"
		],
		skins: [
			{
				unified: "269c-fe0f",
				native: "⚜️",
				x: 57,
				y: 36
			}
		],
		version: 1
	},
	trident: {
		id: "trident",
		name: "Trident Emblem",
		keywords: [
			"weapon",
			"spear"
		],
		skins: [
			{
				unified: "1f531",
				native: "🔱",
				x: 30,
				y: 13
			}
		],
		version: 1
	},
	name_badge: {
		id: "name_badge",
		name: "Name Badge",
		keywords: [
			"fire",
			"forbid"
		],
		skins: [
			{
				unified: "1f4db",
				native: "📛",
				x: 28,
				y: 50
			}
		],
		version: 1
	},
	beginner: {
		id: "beginner",
		name: "Japanese Symbol for Beginner",
		keywords: [
			"badge",
			"shield"
		],
		skins: [
			{
				unified: "1f530",
				native: "🔰",
				x: 30,
				y: 12
			}
		],
		version: 1
	},
	o: {
		id: "o",
		name: "Hollow Red Circle",
		keywords: [
			"o",
			"round"
		],
		skins: [
			{
				unified: "2b55",
				native: "⭕",
				x: 59,
				y: 25
			}
		],
		version: 1
	},
	white_check_mark: {
		id: "white_check_mark",
		name: "Check Mark Button",
		keywords: [
			"white",
			"green",
			"square",
			"ok",
			"agree",
			"vote",
			"election",
			"answer",
			"tick"
		],
		skins: [
			{
				unified: "2705",
				native: "✅",
				x: 58,
				y: 24
			}
		],
		version: 1
	},
	ballot_box_with_check: {
		id: "ballot_box_with_check",
		name: "Check Box with Check",
		keywords: [
			"ballot",
			"ok",
			"agree",
			"confirm",
			"black",
			"square",
			"vote",
			"election",
			"yes",
			"tick"
		],
		skins: [
			{
				unified: "2611-fe0f",
				native: "☑️",
				x: 56,
				y: 46
			}
		],
		version: 1
	},
	heavy_check_mark: {
		id: "heavy_check_mark",
		name: "Check Mark",
		keywords: [
			"heavy",
			"ok",
			"nike",
			"answer",
			"yes",
			"tick"
		],
		skins: [
			{
				unified: "2714-fe0f",
				native: "✔️",
				x: 58,
				y: 53
			}
		],
		version: 1
	},
	x: {
		id: "x",
		name: "Cross Mark",
		keywords: [
			"x",
			"no",
			"delete",
			"remove",
			"cancel",
			"red"
		],
		skins: [
			{
				unified: "274c",
				native: "❌",
				x: 59,
				y: 1
			}
		],
		version: 1
	},
	negative_squared_cross_mark: {
		id: "negative_squared_cross_mark",
		name: "Cross Mark Button",
		keywords: [
			"negative",
			"squared",
			"x",
			"green",
			"square",
			"no",
			"deny"
		],
		skins: [
			{
				unified: "274e",
				native: "❎",
				x: 59,
				y: 2
			}
		],
		version: 1
	},
	curly_loop: {
		id: "curly_loop",
		name: "Curly Loop",
		keywords: [
			"scribble",
			"draw",
			"shape",
			"squiggle"
		],
		skins: [
			{
				unified: "27b0",
				native: "➰",
				x: 59,
				y: 15
			}
		],
		version: 1
	},
	loop: {
		id: "loop",
		name: "Double Curly Loop",
		keywords: [
			"tape",
			"cassette"
		],
		skins: [
			{
				unified: "27bf",
				native: "➿",
				x: 59,
				y: 16
			}
		],
		version: 1
	},
	part_alternation_mark: {
		id: "part_alternation_mark",
		name: "Part Alternation Mark",
		keywords: [
			"graph",
			"presentation",
			"stats",
			"business",
			"economics",
			"bad"
		],
		skins: [
			{
				unified: "303d-fe0f",
				native: "〽️",
				x: 59,
				y: 27
			}
		],
		version: 1
	},
	eight_spoked_asterisk: {
		id: "eight_spoked_asterisk",
		name: "Eight Spoked Asterisk",
		keywords: [
			"star",
			"sparkle",
			"green",
			"square"
		],
		skins: [
			{
				unified: "2733-fe0f",
				native: "✳️",
				x: 58,
				y: 58
			}
		],
		version: 1
	},
	eight_pointed_black_star: {
		id: "eight_pointed_black_star",
		name: "Eight-Pointed Star",
		keywords: [
			"eight",
			"pointed",
			"black",
			"orange",
			"square",
			"shape",
			"polygon"
		],
		skins: [
			{
				unified: "2734-fe0f",
				native: "✴️",
				x: 58,
				y: 59
			}
		],
		version: 1
	},
	sparkle: {
		id: "sparkle",
		name: "Sparkle",
		keywords: [
			"stars",
			"green",
			"square",
			"awesome",
			"good",
			"fireworks"
		],
		skins: [
			{
				unified: "2747-fe0f",
				native: "❇️",
				x: 59,
				y: 0
			}
		],
		version: 1
	},
	copyright: {
		id: "copyright",
		name: "Copyright",
		keywords: [
			"ip",
			"license",
			"circle",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "00a9-fe0f",
				native: "©️",
				x: 0,
				y: 12
			}
		],
		version: 1
	},
	registered: {
		id: "registered",
		name: "Registered",
		keywords: [
			"alphabet",
			"circle"
		],
		skins: [
			{
				unified: "00ae-fe0f",
				native: "®️",
				x: 0,
				y: 13
			}
		],
		version: 1
	},
	tm: {
		id: "tm",
		name: "Trade Mark",
		keywords: [
			"tm",
			"trademark",
			"brand",
			"law",
			"legal"
		],
		skins: [
			{
				unified: "2122-fe0f",
				native: "™️",
				x: 56,
				y: 3
			}
		],
		version: 1
	},
	hash: {
		id: "hash",
		name: "Hash Key",
		keywords: [
			"keycap",
			"",
			"symbol",
			"blue",
			"square",
			"twitter"
		],
		skins: [
			{
				unified: "0023-fe0f-20e3",
				native: "#️⃣",
				x: 0,
				y: 0
			}
		],
		version: 1
	},
	keycap_star: {
		id: "keycap_star",
		name: "Keycap: *",
		keywords: [
			"keycap",
			"star",
			""
		],
		skins: [
			{
				unified: "002a-fe0f-20e3",
				native: "*️⃣",
				x: 0,
				y: 1
			}
		],
		version: 2
	},
	zero: {
		id: "zero",
		name: "Keycap 0",
		keywords: [
			"zero",
			"numbers",
			"blue",
			"square",
			"null"
		],
		skins: [
			{
				unified: "0030-fe0f-20e3",
				native: "0️⃣",
				x: 0,
				y: 2
			}
		],
		version: 1
	},
	one: {
		id: "one",
		name: "Keycap 1",
		keywords: [
			"one",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0031-fe0f-20e3",
				native: "1️⃣",
				x: 0,
				y: 3
			}
		],
		version: 1
	},
	two: {
		id: "two",
		name: "Keycap 2",
		keywords: [
			"two",
			"numbers",
			"prime",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0032-fe0f-20e3",
				native: "2️⃣",
				x: 0,
				y: 4
			}
		],
		version: 1
	},
	three: {
		id: "three",
		name: "Keycap 3",
		keywords: [
			"three",
			"numbers",
			"prime",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0033-fe0f-20e3",
				native: "3️⃣",
				x: 0,
				y: 5
			}
		],
		version: 1
	},
	four: {
		id: "four",
		name: "Keycap 4",
		keywords: [
			"four",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0034-fe0f-20e3",
				native: "4️⃣",
				x: 0,
				y: 6
			}
		],
		version: 1
	},
	five: {
		id: "five",
		name: "Keycap 5",
		keywords: [
			"five",
			"numbers",
			"blue",
			"square",
			"prime"
		],
		skins: [
			{
				unified: "0035-fe0f-20e3",
				native: "5️⃣",
				x: 0,
				y: 7
			}
		],
		version: 1
	},
	six: {
		id: "six",
		name: "Keycap 6",
		keywords: [
			"six",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "0036-fe0f-20e3",
				native: "6️⃣",
				x: 0,
				y: 8
			}
		],
		version: 1
	},
	seven: {
		id: "seven",
		name: "Keycap 7",
		keywords: [
			"seven",
			"numbers",
			"blue",
			"square",
			"prime"
		],
		skins: [
			{
				unified: "0037-fe0f-20e3",
				native: "7️⃣",
				x: 0,
				y: 9
			}
		],
		version: 1
	},
	eight: {
		id: "eight",
		name: "Keycap 8",
		keywords: [
			"eight",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0038-fe0f-20e3",
				native: "8️⃣",
				x: 0,
				y: 10
			}
		],
		version: 1
	},
	nine: {
		id: "nine",
		name: "Keycap 9",
		keywords: [
			"nine",
			"blue",
			"square",
			"numbers"
		],
		skins: [
			{
				unified: "0039-fe0f-20e3",
				native: "9️⃣",
				x: 0,
				y: 11
			}
		],
		version: 1
	},
	keycap_ten: {
		id: "keycap_ten",
		name: "Keycap 10",
		keywords: [
			"ten",
			"numbers",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f51f",
				native: "🔟",
				x: 29,
				y: 56
			}
		],
		version: 1
	},
	capital_abcd: {
		id: "capital_abcd",
		name: "Input Latin Uppercase",
		keywords: [
			"capital",
			"abcd",
			"alphabet",
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f520",
				native: "🔠",
				x: 29,
				y: 57
			}
		],
		version: 1
	},
	abcd: {
		id: "abcd",
		name: "Input Latin Lowercase",
		keywords: [
			"abcd",
			"blue",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f521",
				native: "🔡",
				x: 29,
				y: 58
			}
		],
		version: 1
	},
	symbols: {
		id: "symbols",
		name: "Input Symbols",
		keywords: [
			"blue",
			"square",
			"music",
			"note",
			"ampersand",
			"percent",
			"glyphs",
			"characters"
		],
		skins: [
			{
				unified: "1f523",
				native: "🔣",
				x: 29,
				y: 60
			}
		],
		version: 1
	},
	abc: {
		id: "abc",
		name: "Input Latin Letters",
		keywords: [
			"abc",
			"blue",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f524",
				native: "🔤",
				x: 30,
				y: 0
			}
		],
		version: 1
	},
	a: {
		id: "a",
		name: "A Button (blood Type)",
		keywords: [
			"red",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f170-fe0f",
				native: "🅰️",
				x: 0,
				y: 16
			}
		],
		version: 1
	},
	ab: {
		id: "ab",
		name: "Negative Squared Ab",
		keywords: [
			"button",
			"red",
			"square",
			"alphabet"
		],
		skins: [
			{
				unified: "1f18e",
				native: "🆎",
				x: 0,
				y: 20
			}
		],
		version: 1
	},
	b: {
		id: "b",
		name: "B Button (blood Type)",
		keywords: [
			"red",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f171-fe0f",
				native: "🅱️",
				x: 0,
				y: 17
			}
		],
		version: 1
	},
	cl: {
		id: "cl",
		name: "Cl Button",
		keywords: [
			"alphabet",
			"words",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f191",
				native: "🆑",
				x: 0,
				y: 21
			}
		],
		version: 1
	},
	cool: {
		id: "cool",
		name: "Cool Button",
		keywords: [
			"words",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f192",
				native: "🆒",
				x: 0,
				y: 22
			}
		],
		version: 1
	},
	free: {
		id: "free",
		name: "Free Button",
		keywords: [
			"blue",
			"square",
			"words"
		],
		skins: [
			{
				unified: "1f193",
				native: "🆓",
				x: 0,
				y: 23
			}
		],
		version: 1
	},
	information_source: {
		id: "information_source",
		name: "Information",
		keywords: [
			"source",
			"blue",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "2139-fe0f",
				native: "ℹ️",
				x: 56,
				y: 4
			}
		],
		version: 1
	},
	id: {
		id: "id",
		name: "Id Button",
		keywords: [
			"purple",
			"square",
			"words"
		],
		skins: [
			{
				unified: "1f194",
				native: "🆔",
				x: 0,
				y: 24
			}
		],
		version: 1
	},
	m: {
		id: "m",
		name: "Circled M",
		keywords: [
			"alphabet",
			"blue",
			"circle",
			"letter"
		],
		skins: [
			{
				unified: "24c2-fe0f",
				native: "Ⓜ️",
				x: 56,
				y: 31
			}
		],
		version: 1
	},
	"new": {
		id: "new",
		name: "New Button",
		keywords: [
			"blue",
			"square",
			"words",
			"start"
		],
		skins: [
			{
				unified: "1f195",
				native: "🆕",
				x: 0,
				y: 25
			}
		],
		version: 1
	},
	ng: {
		id: "ng",
		name: "Ng Button",
		keywords: [
			"blue",
			"square",
			"words",
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "1f196",
				native: "🆖",
				x: 0,
				y: 26
			}
		],
		version: 1
	},
	o2: {
		id: "o2",
		name: "O Button (blood Type)",
		keywords: [
			"o2",
			"alphabet",
			"red",
			"square",
			"letter"
		],
		skins: [
			{
				unified: "1f17e-fe0f",
				native: "🅾️",
				x: 0,
				y: 18
			}
		],
		version: 1
	},
	ok: {
		id: "ok",
		name: "Ok Button",
		keywords: [
			"good",
			"agree",
			"yes",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f197",
				native: "🆗",
				x: 0,
				y: 27
			}
		],
		version: 1
	},
	parking: {
		id: "parking",
		name: "P Button",
		keywords: [
			"parking",
			"cars",
			"blue",
			"square",
			"alphabet",
			"letter"
		],
		skins: [
			{
				unified: "1f17f-fe0f",
				native: "🅿️",
				x: 0,
				y: 19
			}
		],
		version: 1
	},
	sos: {
		id: "sos",
		name: "Sos Button",
		keywords: [
			"help",
			"red",
			"square",
			"words",
			"emergency",
			"911"
		],
		skins: [
			{
				unified: "1f198",
				native: "🆘",
				x: 0,
				y: 28
			}
		],
		version: 1
	},
	up: {
		id: "up",
		name: "Up! Button",
		keywords: [
			"up",
			"blue",
			"square",
			"above",
			"high"
		],
		skins: [
			{
				unified: "1f199",
				native: "🆙",
				x: 0,
				y: 29
			}
		],
		version: 1
	},
	vs: {
		id: "vs",
		name: "Vs Button",
		keywords: [
			"words",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f19a",
				native: "🆚",
				x: 0,
				y: 30
			}
		],
		version: 1
	},
	koko: {
		id: "koko",
		name: "Squared Katakana Koko",
		keywords: [
			"japanese",
			"here",
			"button",
			"blue",
			"square",
			"destination"
		],
		skins: [
			{
				unified: "1f201",
				native: "🈁",
				x: 4,
				y: 45
			}
		],
		version: 1
	},
	sa: {
		id: "sa",
		name: "Squared Katakana Sa",
		keywords: [
			"japanese",
			"service",
			"charge",
			"button",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f202-fe0f",
				native: "🈂️",
				x: 4,
				y: 46
			}
		],
		version: 1
	},
	u6708: {
		id: "u6708",
		name: "Japanese “monthly Amount” Button",
		keywords: [
			"u6708",
			"monthly",
			"amount",
			"chinese",
			"month",
			"moon",
			"orange",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f237-fe0f",
				native: "🈷️",
				x: 4,
				y: 54
			}
		],
		version: 1
	},
	u6709: {
		id: "u6709",
		name: "Squared Cjk Unified Ideograph-6709",
		keywords: [
			"u6709",
			"japanese",
			"not",
			"free",
			"of",
			"charge",
			"button",
			"orange",
			"square",
			"chinese",
			"have",
			"kanji"
		],
		skins: [
			{
				unified: "1f236",
				native: "🈶",
				x: 4,
				y: 53
			}
		],
		version: 1
	},
	u6307: {
		id: "u6307",
		name: "Japanese “reserved” Button",
		keywords: [
			"u6307",
			"reserved",
			"chinese",
			"point",
			"green",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f22f",
				native: "🈯",
				x: 4,
				y: 48
			}
		],
		version: 1
	},
	ideograph_advantage: {
		id: "ideograph_advantage",
		name: "Japanese “bargain” Button",
		keywords: [
			"ideograph",
			"advantage",
			"bargain",
			"chinese",
			"kanji",
			"obtain",
			"get",
			"circle"
		],
		skins: [
			{
				unified: "1f250",
				native: "🉐",
				x: 4,
				y: 58
			}
		],
		version: 1
	},
	u5272: {
		id: "u5272",
		name: "Japanese “discount” Button",
		keywords: [
			"u5272",
			"discount",
			"cut",
			"divide",
			"chinese",
			"kanji",
			"pink",
			"square"
		],
		skins: [
			{
				unified: "1f239",
				native: "🈹",
				x: 4,
				y: 56
			}
		],
		version: 1
	},
	u7121: {
		id: "u7121",
		name: "Japanese “free of Charge” Button",
		keywords: [
			"u7121",
			"free",
			"charge",
			"nothing",
			"chinese",
			"kanji",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f21a",
				native: "🈚",
				x: 4,
				y: 47
			}
		],
		version: 1
	},
	u7981: {
		id: "u7981",
		name: "Japanese “prohibited” Button",
		keywords: [
			"u7981",
			"prohibited",
			"kanji",
			"chinese",
			"forbidden",
			"limit",
			"restricted",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f232",
				native: "🈲",
				x: 4,
				y: 49
			}
		],
		version: 1
	},
	accept: {
		id: "accept",
		name: "Circled Ideograph Accept",
		keywords: [
			"japanese",
			"acceptable",
			"button",
			"ok",
			"good",
			"chinese",
			"kanji",
			"agree",
			"yes",
			"orange",
			"circle"
		],
		skins: [
			{
				unified: "1f251",
				native: "🉑",
				x: 4,
				y: 59
			}
		],
		version: 1
	},
	u7533: {
		id: "u7533",
		name: "Japanese “application” Button",
		keywords: [
			"u7533",
			"application",
			"chinese",
			"kanji",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f238",
				native: "🈸",
				x: 4,
				y: 55
			}
		],
		version: 1
	},
	u5408: {
		id: "u5408",
		name: "Japanese “passing Grade” Button",
		keywords: [
			"u5408",
			"passing",
			"grade",
			"chinese",
			"join",
			"kanji",
			"red",
			"square"
		],
		skins: [
			{
				unified: "1f234",
				native: "🈴",
				x: 4,
				y: 51
			}
		],
		version: 1
	},
	u7a7a: {
		id: "u7a7a",
		name: "Japanese “vacancy” Button",
		keywords: [
			"u7a7a",
			"vacancy",
			"kanji",
			"chinese",
			"empty",
			"sky",
			"blue",
			"square"
		],
		skins: [
			{
				unified: "1f233",
				native: "🈳",
				x: 4,
				y: 50
			}
		],
		version: 1
	},
	congratulations: {
		id: "congratulations",
		name: "Circled Ideograph Congratulation",
		keywords: [
			"congratulations",
			"japanese",
			"button",
			"chinese",
			"kanji",
			"red",
			"circle"
		],
		skins: [
			{
				unified: "3297-fe0f",
				native: "㊗️",
				x: 59,
				y: 28
			}
		],
		version: 1
	},
	secret: {
		id: "secret",
		name: "Circled Ideograph Secret",
		keywords: [
			"japanese",
			"button",
			"privacy",
			"chinese",
			"sshh",
			"kanji",
			"red",
			"circle"
		],
		skins: [
			{
				unified: "3299-fe0f",
				native: "㊙️",
				x: 59,
				y: 29
			}
		],
		version: 1
	},
	u55b6: {
		id: "u55b6",
		name: "Squared Cjk Unified Ideograph-55b6",
		keywords: [
			"u55b6",
			"japanese",
			"open",
			"for",
			"business",
			"button",
			"opening",
			"hours",
			"orange",
			"square"
		],
		skins: [
			{
				unified: "1f23a",
				native: "🈺",
				x: 4,
				y: 57
			}
		],
		version: 1
	},
	u6e80: {
		id: "u6e80",
		name: "Japanese “no Vacancy” Button",
		keywords: [
			"u6e80",
			"no",
			"vacancy",
			"full",
			"chinese",
			"red",
			"square",
			"kanji"
		],
		skins: [
			{
				unified: "1f235",
				native: "🈵",
				x: 4,
				y: 52
			}
		],
		version: 1
	},
	red_circle: {
		id: "red_circle",
		name: "Red Circle",
		keywords: [
			"shape",
			"error",
			"danger"
		],
		skins: [
			{
				unified: "1f534",
				native: "🔴",
				x: 30,
				y: 16
			}
		],
		version: 1
	},
	large_orange_circle: {
		id: "large_orange_circle",
		name: "Orange Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e0",
				native: "🟠",
				x: 38,
				y: 31
			}
		],
		version: 12
	},
	large_yellow_circle: {
		id: "large_yellow_circle",
		name: "Yellow Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e1",
				native: "🟡",
				x: 38,
				y: 32
			}
		],
		version: 12
	},
	large_green_circle: {
		id: "large_green_circle",
		name: "Green Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e2",
				native: "🟢",
				x: 38,
				y: 33
			}
		],
		version: 12
	},
	large_blue_circle: {
		id: "large_blue_circle",
		name: "Blue Circle",
		keywords: [
			"large",
			"shape",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "1f535",
				native: "🔵",
				x: 30,
				y: 17
			}
		],
		version: 1
	},
	large_purple_circle: {
		id: "large_purple_circle",
		name: "Purple Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e3",
				native: "🟣",
				x: 38,
				y: 34
			}
		],
		version: 12
	},
	large_brown_circle: {
		id: "large_brown_circle",
		name: "Brown Circle",
		keywords: [
			"large",
			"round"
		],
		skins: [
			{
				unified: "1f7e4",
				native: "🟤",
				x: 38,
				y: 35
			}
		],
		version: 12
	},
	black_circle: {
		id: "black_circle",
		name: "Black Circle",
		keywords: [
			"shape",
			"button",
			"round"
		],
		skins: [
			{
				unified: "26ab",
				native: "⚫",
				x: 57,
				y: 41
			}
		],
		version: 1
	},
	white_circle: {
		id: "white_circle",
		name: "White Circle",
		keywords: [
			"shape",
			"round"
		],
		skins: [
			{
				unified: "26aa",
				native: "⚪",
				x: 57,
				y: 40
			}
		],
		version: 1
	},
	large_red_square: {
		id: "large_red_square",
		name: "Red Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e5",
				native: "🟥",
				x: 38,
				y: 36
			}
		],
		version: 12
	},
	large_orange_square: {
		id: "large_orange_square",
		name: "Orange Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e7",
				native: "🟧",
				x: 38,
				y: 38
			}
		],
		version: 12
	},
	large_yellow_square: {
		id: "large_yellow_square",
		name: "Yellow Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e8",
				native: "🟨",
				x: 38,
				y: 39
			}
		],
		version: 12
	},
	large_green_square: {
		id: "large_green_square",
		name: "Green Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e9",
				native: "🟩",
				x: 38,
				y: 40
			}
		],
		version: 12
	},
	large_blue_square: {
		id: "large_blue_square",
		name: "Blue Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7e6",
				native: "🟦",
				x: 38,
				y: 37
			}
		],
		version: 12
	},
	large_purple_square: {
		id: "large_purple_square",
		name: "Purple Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7ea",
				native: "🟪",
				x: 38,
				y: 41
			}
		],
		version: 12
	},
	large_brown_square: {
		id: "large_brown_square",
		name: "Brown Square",
		keywords: [
			"large"
		],
		skins: [
			{
				unified: "1f7eb",
				native: "🟫",
				x: 38,
				y: 42
			}
		],
		version: 12
	},
	black_large_square: {
		id: "black_large_square",
		name: "Black Large Square",
		keywords: [
			"shape",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "2b1b",
				native: "⬛",
				x: 59,
				y: 22
			}
		],
		version: 1
	},
	white_large_square: {
		id: "white_large_square",
		name: "White Large Square",
		keywords: [
			"shape",
			"icon",
			"stone",
			"button"
		],
		skins: [
			{
				unified: "2b1c",
				native: "⬜",
				x: 59,
				y: 23
			}
		],
		version: 1
	},
	black_medium_square: {
		id: "black_medium_square",
		name: "Black Medium Square",
		keywords: [
			"shape",
			"button",
			"icon"
		],
		skins: [
			{
				unified: "25fc-fe0f",
				native: "◼️",
				x: 56,
				y: 37
			}
		],
		version: 1
	},
	white_medium_square: {
		id: "white_medium_square",
		name: "White Medium Square",
		keywords: [
			"shape",
			"stone",
			"icon"
		],
		skins: [
			{
				unified: "25fb-fe0f",
				native: "◻️",
				x: 56,
				y: 36
			}
		],
		version: 1
	},
	black_medium_small_square: {
		id: "black_medium_small_square",
		name: "Black Medium Small Square",
		keywords: [
			"icon",
			"shape",
			"button"
		],
		skins: [
			{
				unified: "25fe",
				native: "◾",
				x: 56,
				y: 39
			}
		],
		version: 1
	},
	white_medium_small_square: {
		id: "white_medium_small_square",
		name: "White Medium Small Square",
		keywords: [
			"shape",
			"stone",
			"icon",
			"button"
		],
		skins: [
			{
				unified: "25fd",
				native: "◽",
				x: 56,
				y: 38
			}
		],
		version: 1
	},
	black_small_square: {
		id: "black_small_square",
		name: "Black Small Square",
		keywords: [
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "25aa-fe0f",
				native: "▪️",
				x: 56,
				y: 32
			}
		],
		version: 1
	},
	white_small_square: {
		id: "white_small_square",
		name: "White Small Square",
		keywords: [
			"shape",
			"icon"
		],
		skins: [
			{
				unified: "25ab-fe0f",
				native: "▫️",
				x: 56,
				y: 33
			}
		],
		version: 1
	},
	large_orange_diamond: {
		id: "large_orange_diamond",
		name: "Large Orange Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f536",
				native: "🔶",
				x: 30,
				y: 18
			}
		],
		version: 1
	},
	large_blue_diamond: {
		id: "large_blue_diamond",
		name: "Large Blue Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f537",
				native: "🔷",
				x: 30,
				y: 19
			}
		],
		version: 1
	},
	small_orange_diamond: {
		id: "small_orange_diamond",
		name: "Small Orange Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f538",
				native: "🔸",
				x: 30,
				y: 20
			}
		],
		version: 1
	},
	small_blue_diamond: {
		id: "small_blue_diamond",
		name: "Small Blue Diamond",
		keywords: [
			"shape",
			"jewel",
			"gem"
		],
		skins: [
			{
				unified: "1f539",
				native: "🔹",
				x: 30,
				y: 21
			}
		],
		version: 1
	},
	small_red_triangle: {
		id: "small_red_triangle",
		name: "Red Triangle Pointed Up",
		keywords: [
			"small",
			"shape",
			"direction",
			"top"
		],
		skins: [
			{
				unified: "1f53a",
				native: "🔺",
				x: 30,
				y: 22
			}
		],
		version: 1
	},
	small_red_triangle_down: {
		id: "small_red_triangle_down",
		name: "Red Triangle Pointed Down",
		keywords: [
			"small",
			"shape",
			"direction",
			"bottom"
		],
		skins: [
			{
				unified: "1f53b",
				native: "🔻",
				x: 30,
				y: 23
			}
		],
		version: 1
	},
	diamond_shape_with_a_dot_inside: {
		id: "diamond_shape_with_a_dot_inside",
		name: "Diamond with a Dot",
		keywords: [
			"shape",
			"inside",
			"jewel",
			"blue",
			"gem",
			"crystal",
			"fancy"
		],
		skins: [
			{
				unified: "1f4a0",
				native: "💠",
				x: 27,
				y: 47
			}
		],
		version: 1
	},
	radio_button: {
		id: "radio_button",
		name: "Radio Button",
		keywords: [
			"input",
			"old",
			"music",
			"circle"
		],
		skins: [
			{
				unified: "1f518",
				native: "🔘",
				x: 29,
				y: 49
			}
		],
		version: 1
	},
	white_square_button: {
		id: "white_square_button",
		name: "White Square Button",
		keywords: [
			"shape",
			"input"
		],
		skins: [
			{
				unified: "1f533",
				native: "🔳",
				x: 30,
				y: 15
			}
		],
		version: 1
	},
	black_square_button: {
		id: "black_square_button",
		name: "Black Square Button",
		keywords: [
			"shape",
			"input",
			"frame"
		],
		skins: [
			{
				unified: "1f532",
				native: "🔲",
				x: 30,
				y: 14
			}
		],
		version: 1
	},
	checkered_flag: {
		id: "checkered_flag",
		name: "Chequered Flag",
		keywords: [
			"checkered",
			"contest",
			"finishline",
			"race",
			"gokart"
		],
		skins: [
			{
				unified: "1f3c1",
				native: "🏁",
				x: 8,
				y: 7
			}
		],
		version: 1
	},
	triangular_flag_on_post: {
		id: "triangular_flag_on_post",
		name: "Triangular Flag",
		keywords: [
			"on",
			"post",
			"mark",
			"milestone",
			"place"
		],
		skins: [
			{
				unified: "1f6a9",
				native: "🚩",
				x: 36,
				y: 29
			}
		],
		version: 1
	},
	crossed_flags: {
		id: "crossed_flags",
		name: "Crossed Flags",
		keywords: [
			"japanese",
			"nation",
			"country",
			"border"
		],
		skins: [
			{
				unified: "1f38c",
				native: "🎌",
				x: 7,
				y: 20
			}
		],
		version: 1
	},
	waving_black_flag: {
		id: "waving_black_flag",
		name: "Black Flag",
		keywords: [
			"waving",
			"pirate"
		],
		skins: [
			{
				unified: "1f3f4",
				native: "🏴",
				x: 10,
				y: 35
			}
		],
		version: 1
	},
	waving_white_flag: {
		id: "waving_white_flag",
		name: "White Flag",
		keywords: [
			"waving",
			"losing",
			"loser",
			"lost",
			"surrender",
			"give",
			"up",
			"fail"
		],
		skins: [
			{
				unified: "1f3f3-fe0f",
				native: "🏳️",
				x: 10,
				y: 30
			}
		],
		version: 1
	},
	"rainbow-flag": {
		id: "rainbow-flag",
		name: "Rainbow Flag",
		keywords: [
			"pride",
			"gay",
			"lgbt",
			"glbt",
			"queer",
			"homosexual",
			"lesbian",
			"bisexual",
			"transgender"
		],
		skins: [
			{
				unified: "1f3f3-fe0f-200d-1f308",
				native: "🏳️‍🌈",
				x: 10,
				y: 28
			}
		],
		version: 4
	},
	transgender_flag: {
		id: "transgender_flag",
		name: "Transgender Flag",
		keywords: [
			"lgbtq"
		],
		skins: [
			{
				unified: "1f3f3-fe0f-200d-26a7-fe0f",
				native: "🏳️‍⚧️",
				x: 10,
				y: 29
			}
		],
		version: 13
	},
	pirate_flag: {
		id: "pirate_flag",
		name: "Pirate Flag",
		keywords: [
			"skull",
			"crossbones",
			"banner"
		],
		skins: [
			{
				unified: "1f3f4-200d-2620-fe0f",
				native: "🏴‍☠️",
				x: 10,
				y: 31
			}
		],
		version: 11
	},
	"flag-ac": {
		id: "flag-ac",
		name: "Ascension Island Flag",
		keywords: [
			"ac"
		],
		skins: [
			{
				unified: "1f1e6-1f1e8",
				native: "🇦🇨",
				x: 0,
				y: 31
			}
		],
		version: 2
	},
	"flag-ad": {
		id: "flag-ad",
		name: "Andorra Flag",
		keywords: [
			"ad",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1e9",
				native: "🇦🇩",
				x: 0,
				y: 32
			}
		],
		version: 2
	},
	"flag-ae": {
		id: "flag-ae",
		name: "United Arab Emirates Flag",
		keywords: [
			"ae",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ea",
				native: "🇦🇪",
				x: 0,
				y: 33
			}
		],
		version: 2
	},
	"flag-af": {
		id: "flag-af",
		name: "Afghanistan Flag",
		keywords: [
			"af",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1eb",
				native: "🇦🇫",
				x: 0,
				y: 34
			}
		],
		version: 2
	},
	"flag-ag": {
		id: "flag-ag",
		name: "Antigua & Barbuda Flag",
		keywords: [
			"ag",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ec",
				native: "🇦🇬",
				x: 0,
				y: 35
			}
		],
		version: 2
	},
	"flag-ai": {
		id: "flag-ai",
		name: "Anguilla Flag",
		keywords: [
			"ai",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ee",
				native: "🇦🇮",
				x: 0,
				y: 36
			}
		],
		version: 2
	},
	"flag-al": {
		id: "flag-al",
		name: "Albania Flag",
		keywords: [
			"al",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f1",
				native: "🇦🇱",
				x: 0,
				y: 37
			}
		],
		version: 2
	},
	"flag-am": {
		id: "flag-am",
		name: "Armenia Flag",
		keywords: [
			"am",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f2",
				native: "🇦🇲",
				x: 0,
				y: 38
			}
		],
		version: 2
	},
	"flag-ao": {
		id: "flag-ao",
		name: "Angola Flag",
		keywords: [
			"ao",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f4",
				native: "🇦🇴",
				x: 0,
				y: 39
			}
		],
		version: 2
	},
	"flag-aq": {
		id: "flag-aq",
		name: "Antarctica Flag",
		keywords: [
			"aq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f6",
				native: "🇦🇶",
				x: 0,
				y: 40
			}
		],
		version: 2
	},
	"flag-ar": {
		id: "flag-ar",
		name: "Argentina Flag",
		keywords: [
			"ar",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f7",
				native: "🇦🇷",
				x: 0,
				y: 41
			}
		],
		version: 2
	},
	"flag-as": {
		id: "flag-as",
		name: "American Samoa Flag",
		keywords: [
			"as",
			"ws",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f8",
				native: "🇦🇸",
				x: 0,
				y: 42
			}
		],
		version: 2
	},
	"flag-at": {
		id: "flag-at",
		name: "Austria Flag",
		keywords: [
			"at",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1f9",
				native: "🇦🇹",
				x: 0,
				y: 43
			}
		],
		version: 2
	},
	"flag-au": {
		id: "flag-au",
		name: "Australia Flag",
		keywords: [
			"au",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fa",
				native: "🇦🇺",
				x: 0,
				y: 44
			}
		],
		version: 2
	},
	"flag-aw": {
		id: "flag-aw",
		name: "Aruba Flag",
		keywords: [
			"aw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fc",
				native: "🇦🇼",
				x: 0,
				y: 45
			}
		],
		version: 2
	},
	"flag-ax": {
		id: "flag-ax",
		name: "Åland Islands Flag",
		keywords: [
			"ax",
			"aland",
			"Aland",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1fd",
				native: "🇦🇽",
				x: 0,
				y: 46
			}
		],
		version: 2
	},
	"flag-az": {
		id: "flag-az",
		name: "Azerbaijan Flag",
		keywords: [
			"az",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e6-1f1ff",
				native: "🇦🇿",
				x: 0,
				y: 47
			}
		],
		version: 2
	},
	"flag-ba": {
		id: "flag-ba",
		name: "Bosnia & Herzegovina Flag",
		keywords: [
			"ba",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e6",
				native: "🇧🇦",
				x: 0,
				y: 48
			}
		],
		version: 2
	},
	"flag-bb": {
		id: "flag-bb",
		name: "Barbados Flag",
		keywords: [
			"bb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e7",
				native: "🇧🇧",
				x: 0,
				y: 49
			}
		],
		version: 2
	},
	"flag-bd": {
		id: "flag-bd",
		name: "Bangladesh Flag",
		keywords: [
			"bd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1e9",
				native: "🇧🇩",
				x: 0,
				y: 50
			}
		],
		version: 2
	},
	"flag-be": {
		id: "flag-be",
		name: "Belgium Flag",
		keywords: [
			"be",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ea",
				native: "🇧🇪",
				x: 0,
				y: 51
			}
		],
		version: 2
	},
	"flag-bf": {
		id: "flag-bf",
		name: "Burkina Faso Flag",
		keywords: [
			"bf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1eb",
				native: "🇧🇫",
				x: 0,
				y: 52
			}
		],
		version: 2
	},
	"flag-bg": {
		id: "flag-bg",
		name: "Bulgaria Flag",
		keywords: [
			"bg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ec",
				native: "🇧🇬",
				x: 0,
				y: 53
			}
		],
		version: 2
	},
	"flag-bh": {
		id: "flag-bh",
		name: "Bahrain Flag",
		keywords: [
			"bh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ed",
				native: "🇧🇭",
				x: 0,
				y: 54
			}
		],
		version: 2
	},
	"flag-bi": {
		id: "flag-bi",
		name: "Burundi Flag",
		keywords: [
			"bi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ee",
				native: "🇧🇮",
				x: 0,
				y: 55
			}
		],
		version: 2
	},
	"flag-bj": {
		id: "flag-bj",
		name: "Benin Flag",
		keywords: [
			"bj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ef",
				native: "🇧🇯",
				x: 0,
				y: 56
			}
		],
		version: 2
	},
	"flag-bl": {
		id: "flag-bl",
		name: "St. Barthélemy Flag",
		keywords: [
			"bl",
			"st",
			"barthelemy",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f1",
				native: "🇧🇱",
				x: 0,
				y: 57
			}
		],
		version: 2
	},
	"flag-bm": {
		id: "flag-bm",
		name: "Bermuda Flag",
		keywords: [
			"bm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f2",
				native: "🇧🇲",
				x: 0,
				y: 58
			}
		],
		version: 2
	},
	"flag-bn": {
		id: "flag-bn",
		name: "Brunei Flag",
		keywords: [
			"bn",
			"darussalam",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f3",
				native: "🇧🇳",
				x: 0,
				y: 59
			}
		],
		version: 2
	},
	"flag-bo": {
		id: "flag-bo",
		name: "Bolivia Flag",
		keywords: [
			"bo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f4",
				native: "🇧🇴",
				x: 0,
				y: 60
			}
		],
		version: 2
	},
	"flag-bq": {
		id: "flag-bq",
		name: "Caribbean Netherlands Flag",
		keywords: [
			"bq",
			"bonaire",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f6",
				native: "🇧🇶",
				x: 1,
				y: 0
			}
		],
		version: 2
	},
	"flag-br": {
		id: "flag-br",
		name: "Brazil Flag",
		keywords: [
			"br",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f7",
				native: "🇧🇷",
				x: 1,
				y: 1
			}
		],
		version: 2
	},
	"flag-bs": {
		id: "flag-bs",
		name: "Bahamas Flag",
		keywords: [
			"bs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f8",
				native: "🇧🇸",
				x: 1,
				y: 2
			}
		],
		version: 2
	},
	"flag-bt": {
		id: "flag-bt",
		name: "Bhutan Flag",
		keywords: [
			"bt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1f9",
				native: "🇧🇹",
				x: 1,
				y: 3
			}
		],
		version: 2
	},
	"flag-bv": {
		id: "flag-bv",
		name: "Bouvet Island Flag",
		keywords: [
			"bv",
			"norway"
		],
		skins: [
			{
				unified: "1f1e7-1f1fb",
				native: "🇧🇻",
				x: 1,
				y: 4
			}
		],
		version: 2
	},
	"flag-bw": {
		id: "flag-bw",
		name: "Botswana Flag",
		keywords: [
			"bw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1fc",
				native: "🇧🇼",
				x: 1,
				y: 5
			}
		],
		version: 2
	},
	"flag-by": {
		id: "flag-by",
		name: "Belarus Flag",
		keywords: [
			"by",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1fe",
				native: "🇧🇾",
				x: 1,
				y: 6
			}
		],
		version: 2
	},
	"flag-bz": {
		id: "flag-bz",
		name: "Belize Flag",
		keywords: [
			"bz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e7-1f1ff",
				native: "🇧🇿",
				x: 1,
				y: 7
			}
		],
		version: 2
	},
	"flag-ca": {
		id: "flag-ca",
		name: "Canada Flag",
		keywords: [
			"ca",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e6",
				native: "🇨🇦",
				x: 1,
				y: 8
			}
		],
		version: 2
	},
	"flag-cc": {
		id: "flag-cc",
		name: "Cocos (keeling) Islands Flag",
		keywords: [
			"cc",
			"keeling",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e8",
				native: "🇨🇨",
				x: 1,
				y: 9
			}
		],
		version: 2
	},
	"flag-cd": {
		id: "flag-cd",
		name: "Congo - Kinshasa Flag",
		keywords: [
			"cd",
			"democratic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1e9",
				native: "🇨🇩",
				x: 1,
				y: 10
			}
		],
		version: 2
	},
	"flag-cf": {
		id: "flag-cf",
		name: "Central African Republic Flag",
		keywords: [
			"cf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1eb",
				native: "🇨🇫",
				x: 1,
				y: 11
			}
		],
		version: 2
	},
	"flag-cg": {
		id: "flag-cg",
		name: "Congo - Brazzaville Flag",
		keywords: [
			"cg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ec",
				native: "🇨🇬",
				x: 1,
				y: 12
			}
		],
		version: 2
	},
	"flag-ch": {
		id: "flag-ch",
		name: "Switzerland Flag",
		keywords: [
			"ch",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ed",
				native: "🇨🇭",
				x: 1,
				y: 13
			}
		],
		version: 2
	},
	"flag-ci": {
		id: "flag-ci",
		name: "Côte D’ivoire Flag",
		keywords: [
			"ci",
			"cote",
			"d",
			"ivoire",
			"ivory",
			"coast",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ee",
				native: "🇨🇮",
				x: 1,
				y: 14
			}
		],
		version: 2
	},
	"flag-ck": {
		id: "flag-ck",
		name: "Cook Islands Flag",
		keywords: [
			"ck",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f0",
				native: "🇨🇰",
				x: 1,
				y: 15
			}
		],
		version: 2
	},
	"flag-cl": {
		id: "flag-cl",
		name: "Chile Flag",
		keywords: [
			"cl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f1",
				native: "🇨🇱",
				x: 1,
				y: 16
			}
		],
		version: 2
	},
	"flag-cm": {
		id: "flag-cm",
		name: "Cameroon Flag",
		keywords: [
			"cm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f2",
				native: "🇨🇲",
				x: 1,
				y: 17
			}
		],
		version: 2
	},
	cn: {
		id: "cn",
		name: "China Flag",
		keywords: [
			"cn",
			"chinese",
			"prc",
			"country",
			"nation",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f3",
				native: "🇨🇳",
				x: 1,
				y: 18
			}
		],
		version: 1
	},
	"flag-co": {
		id: "flag-co",
		name: "Colombia Flag",
		keywords: [
			"co",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f4",
				native: "🇨🇴",
				x: 1,
				y: 19
			}
		],
		version: 2
	},
	"flag-cp": {
		id: "flag-cp",
		name: "Clipperton Island Flag",
		keywords: [
			"cp"
		],
		skins: [
			{
				unified: "1f1e8-1f1f5",
				native: "🇨🇵",
				x: 1,
				y: 20
			}
		],
		version: 2
	},
	"flag-cr": {
		id: "flag-cr",
		name: "Costa Rica Flag",
		keywords: [
			"cr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1f7",
				native: "🇨🇷",
				x: 1,
				y: 21
			}
		],
		version: 2
	},
	"flag-cu": {
		id: "flag-cu",
		name: "Cuba Flag",
		keywords: [
			"cu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fa",
				native: "🇨🇺",
				x: 1,
				y: 22
			}
		],
		version: 2
	},
	"flag-cv": {
		id: "flag-cv",
		name: "Cape Verde Flag",
		keywords: [
			"cv",
			"cabo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fb",
				native: "🇨🇻",
				x: 1,
				y: 23
			}
		],
		version: 2
	},
	"flag-cw": {
		id: "flag-cw",
		name: "Curaçao Flag",
		keywords: [
			"cw",
			"curacao",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fc",
				native: "🇨🇼",
				x: 1,
				y: 24
			}
		],
		version: 2
	},
	"flag-cx": {
		id: "flag-cx",
		name: "Christmas Island Flag",
		keywords: [
			"cx",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fd",
				native: "🇨🇽",
				x: 1,
				y: 25
			}
		],
		version: 2
	},
	"flag-cy": {
		id: "flag-cy",
		name: "Cyprus Flag",
		keywords: [
			"cy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1fe",
				native: "🇨🇾",
				x: 1,
				y: 26
			}
		],
		version: 2
	},
	"flag-cz": {
		id: "flag-cz",
		name: "Czechia Flag",
		keywords: [
			"cz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e8-1f1ff",
				native: "🇨🇿",
				x: 1,
				y: 27
			}
		],
		version: 2
	},
	de: {
		id: "de",
		name: "Germany Flag",
		keywords: [
			"de",
			"german",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ea",
				native: "🇩🇪",
				x: 1,
				y: 28
			}
		],
		version: 1
	},
	"flag-dg": {
		id: "flag-dg",
		name: "Diego Garcia Flag",
		keywords: [
			"dg"
		],
		skins: [
			{
				unified: "1f1e9-1f1ec",
				native: "🇩🇬",
				x: 1,
				y: 29
			}
		],
		version: 2
	},
	"flag-dj": {
		id: "flag-dj",
		name: "Djibouti Flag",
		keywords: [
			"dj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ef",
				native: "🇩🇯",
				x: 1,
				y: 30
			}
		],
		version: 2
	},
	"flag-dk": {
		id: "flag-dk",
		name: "Denmark Flag",
		keywords: [
			"dk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f0",
				native: "🇩🇰",
				x: 1,
				y: 31
			}
		],
		version: 2
	},
	"flag-dm": {
		id: "flag-dm",
		name: "Dominica Flag",
		keywords: [
			"dm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f2",
				native: "🇩🇲",
				x: 1,
				y: 32
			}
		],
		version: 2
	},
	"flag-do": {
		id: "flag-do",
		name: "Dominican Republic Flag",
		keywords: [
			"do",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1f4",
				native: "🇩🇴",
				x: 1,
				y: 33
			}
		],
		version: 2
	},
	"flag-dz": {
		id: "flag-dz",
		name: "Algeria Flag",
		keywords: [
			"dz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1e9-1f1ff",
				native: "🇩🇿",
				x: 1,
				y: 34
			}
		],
		version: 2
	},
	"flag-ea": {
		id: "flag-ea",
		name: "Ceuta & Melilla Flag",
		keywords: [
			"ea"
		],
		skins: [
			{
				unified: "1f1ea-1f1e6",
				native: "🇪🇦",
				x: 1,
				y: 35
			}
		],
		version: 2
	},
	"flag-ec": {
		id: "flag-ec",
		name: "Ecuador Flag",
		keywords: [
			"ec",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1e8",
				native: "🇪🇨",
				x: 1,
				y: 36
			}
		],
		version: 2
	},
	"flag-ee": {
		id: "flag-ee",
		name: "Estonia Flag",
		keywords: [
			"ee",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ea",
				native: "🇪🇪",
				x: 1,
				y: 37
			}
		],
		version: 2
	},
	"flag-eg": {
		id: "flag-eg",
		name: "Egypt Flag",
		keywords: [
			"eg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ec",
				native: "🇪🇬",
				x: 1,
				y: 38
			}
		],
		version: 2
	},
	"flag-eh": {
		id: "flag-eh",
		name: "Western Sahara Flag",
		keywords: [
			"eh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1ed",
				native: "🇪🇭",
				x: 1,
				y: 39
			}
		],
		version: 2
	},
	"flag-er": {
		id: "flag-er",
		name: "Eritrea Flag",
		keywords: [
			"er",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f7",
				native: "🇪🇷",
				x: 1,
				y: 40
			}
		],
		version: 2
	},
	es: {
		id: "es",
		name: "Spain Flag",
		keywords: [
			"es",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f8",
				native: "🇪🇸",
				x: 1,
				y: 41
			}
		],
		version: 1
	},
	"flag-et": {
		id: "flag-et",
		name: "Ethiopia Flag",
		keywords: [
			"et",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1f9",
				native: "🇪🇹",
				x: 1,
				y: 42
			}
		],
		version: 2
	},
	"flag-eu": {
		id: "flag-eu",
		name: "European Union Flag",
		keywords: [
			"eu",
			"banner"
		],
		skins: [
			{
				unified: "1f1ea-1f1fa",
				native: "🇪🇺",
				x: 1,
				y: 43
			}
		],
		version: 2
	},
	"flag-fi": {
		id: "flag-fi",
		name: "Finland Flag",
		keywords: [
			"fi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1ee",
				native: "🇫🇮",
				x: 1,
				y: 44
			}
		],
		version: 2
	},
	"flag-fj": {
		id: "flag-fj",
		name: "Fiji Flag",
		keywords: [
			"fj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1ef",
				native: "🇫🇯",
				x: 1,
				y: 45
			}
		],
		version: 2
	},
	"flag-fk": {
		id: "flag-fk",
		name: "Falkland Islands Flag",
		keywords: [
			"fk",
			"malvinas",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f0",
				native: "🇫🇰",
				x: 1,
				y: 46
			}
		],
		version: 2
	},
	"flag-fm": {
		id: "flag-fm",
		name: "Micronesia Flag",
		keywords: [
			"fm",
			"federated",
			"states",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f2",
				native: "🇫🇲",
				x: 1,
				y: 47
			}
		],
		version: 2
	},
	"flag-fo": {
		id: "flag-fo",
		name: "Faroe Islands Flag",
		keywords: [
			"fo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1eb-1f1f4",
				native: "🇫🇴",
				x: 1,
				y: 48
			}
		],
		version: 2
	},
	fr: {
		id: "fr",
		name: "France Flag",
		keywords: [
			"fr",
			"banner",
			"nation",
			"french",
			"country"
		],
		skins: [
			{
				unified: "1f1eb-1f1f7",
				native: "🇫🇷",
				x: 1,
				y: 49
			}
		],
		version: 1
	},
	"flag-ga": {
		id: "flag-ga",
		name: "Gabon Flag",
		keywords: [
			"ga",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1e6",
				native: "🇬🇦",
				x: 1,
				y: 50
			}
		],
		version: 2
	},
	gb: {
		id: "gb",
		name: "United Kingdom Flag",
		keywords: [
			"gb",
			"uk",
			"great",
			"britain",
			"northern",
			"ireland",
			"nation",
			"country",
			"banner",
			"british",
			"UK",
			"english",
			"england",
			"union",
			"jack"
		],
		skins: [
			{
				unified: "1f1ec-1f1e7",
				native: "🇬🇧",
				x: 1,
				y: 51
			}
		],
		version: 1
	},
	"flag-gd": {
		id: "flag-gd",
		name: "Grenada Flag",
		keywords: [
			"gd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1e9",
				native: "🇬🇩",
				x: 1,
				y: 52
			}
		],
		version: 2
	},
	"flag-ge": {
		id: "flag-ge",
		name: "Georgia Flag",
		keywords: [
			"ge",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ea",
				native: "🇬🇪",
				x: 1,
				y: 53
			}
		],
		version: 2
	},
	"flag-gf": {
		id: "flag-gf",
		name: "French Guiana Flag",
		keywords: [
			"gf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1eb",
				native: "🇬🇫",
				x: 1,
				y: 54
			}
		],
		version: 2
	},
	"flag-gg": {
		id: "flag-gg",
		name: "Guernsey Flag",
		keywords: [
			"gg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ec",
				native: "🇬🇬",
				x: 1,
				y: 55
			}
		],
		version: 2
	},
	"flag-gh": {
		id: "flag-gh",
		name: "Ghana Flag",
		keywords: [
			"gh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ed",
				native: "🇬🇭",
				x: 1,
				y: 56
			}
		],
		version: 2
	},
	"flag-gi": {
		id: "flag-gi",
		name: "Gibraltar Flag",
		keywords: [
			"gi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1ee",
				native: "🇬🇮",
				x: 1,
				y: 57
			}
		],
		version: 2
	},
	"flag-gl": {
		id: "flag-gl",
		name: "Greenland Flag",
		keywords: [
			"gl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f1",
				native: "🇬🇱",
				x: 1,
				y: 58
			}
		],
		version: 2
	},
	"flag-gm": {
		id: "flag-gm",
		name: "Gambia Flag",
		keywords: [
			"gm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f2",
				native: "🇬🇲",
				x: 1,
				y: 59
			}
		],
		version: 2
	},
	"flag-gn": {
		id: "flag-gn",
		name: "Guinea Flag",
		keywords: [
			"gn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f3",
				native: "🇬🇳",
				x: 1,
				y: 60
			}
		],
		version: 2
	},
	"flag-gp": {
		id: "flag-gp",
		name: "Guadeloupe Flag",
		keywords: [
			"gp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f5",
				native: "🇬🇵",
				x: 2,
				y: 0
			}
		],
		version: 2
	},
	"flag-gq": {
		id: "flag-gq",
		name: "Equatorial Guinea Flag",
		keywords: [
			"gq",
			"gn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f6",
				native: "🇬🇶",
				x: 2,
				y: 1
			}
		],
		version: 2
	},
	"flag-gr": {
		id: "flag-gr",
		name: "Greece Flag",
		keywords: [
			"gr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f7",
				native: "🇬🇷",
				x: 2,
				y: 2
			}
		],
		version: 2
	},
	"flag-gs": {
		id: "flag-gs",
		name: "South Georgia & South Sandwich Islands Flag",
		keywords: [
			"gs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f8",
				native: "🇬🇸",
				x: 2,
				y: 3
			}
		],
		version: 2
	},
	"flag-gt": {
		id: "flag-gt",
		name: "Guatemala Flag",
		keywords: [
			"gt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1f9",
				native: "🇬🇹",
				x: 2,
				y: 4
			}
		],
		version: 2
	},
	"flag-gu": {
		id: "flag-gu",
		name: "Guam Flag",
		keywords: [
			"gu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fa",
				native: "🇬🇺",
				x: 2,
				y: 5
			}
		],
		version: 2
	},
	"flag-gw": {
		id: "flag-gw",
		name: "Guinea-Bissau Flag",
		keywords: [
			"gw",
			"guinea",
			"bissau",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fc",
				native: "🇬🇼",
				x: 2,
				y: 6
			}
		],
		version: 2
	},
	"flag-gy": {
		id: "flag-gy",
		name: "Guyana Flag",
		keywords: [
			"gy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ec-1f1fe",
				native: "🇬🇾",
				x: 2,
				y: 7
			}
		],
		version: 2
	},
	"flag-hk": {
		id: "flag-hk",
		name: "Hong Kong Sar China Flag",
		keywords: [
			"hk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f0",
				native: "🇭🇰",
				x: 2,
				y: 8
			}
		],
		version: 2
	},
	"flag-hm": {
		id: "flag-hm",
		name: "Heard & Mcdonald Islands Flag",
		keywords: [
			"hm"
		],
		skins: [
			{
				unified: "1f1ed-1f1f2",
				native: "🇭🇲",
				x: 2,
				y: 9
			}
		],
		version: 2
	},
	"flag-hn": {
		id: "flag-hn",
		name: "Honduras Flag",
		keywords: [
			"hn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f3",
				native: "🇭🇳",
				x: 2,
				y: 10
			}
		],
		version: 2
	},
	"flag-hr": {
		id: "flag-hr",
		name: "Croatia Flag",
		keywords: [
			"hr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f7",
				native: "🇭🇷",
				x: 2,
				y: 11
			}
		],
		version: 2
	},
	"flag-ht": {
		id: "flag-ht",
		name: "Haiti Flag",
		keywords: [
			"ht",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1f9",
				native: "🇭🇹",
				x: 2,
				y: 12
			}
		],
		version: 2
	},
	"flag-hu": {
		id: "flag-hu",
		name: "Hungary Flag",
		keywords: [
			"hu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ed-1f1fa",
				native: "🇭🇺",
				x: 2,
				y: 13
			}
		],
		version: 2
	},
	"flag-ic": {
		id: "flag-ic",
		name: "Canary Islands Flag",
		keywords: [
			"ic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1e8",
				native: "🇮🇨",
				x: 2,
				y: 14
			}
		],
		version: 2
	},
	"flag-id": {
		id: "flag-id",
		name: "Indonesia Flag",
		keywords: [
			"id",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1e9",
				native: "🇮🇩",
				x: 2,
				y: 15
			}
		],
		version: 2
	},
	"flag-ie": {
		id: "flag-ie",
		name: "Ireland Flag",
		keywords: [
			"ie",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1ea",
				native: "🇮🇪",
				x: 2,
				y: 16
			}
		],
		version: 2
	},
	"flag-il": {
		id: "flag-il",
		name: "Israel Flag",
		keywords: [
			"il",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f1",
				native: "🇮🇱",
				x: 2,
				y: 17
			}
		],
		version: 2
	},
	"flag-im": {
		id: "flag-im",
		name: "Isle of Man Flag",
		keywords: [
			"im",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f2",
				native: "🇮🇲",
				x: 2,
				y: 18
			}
		],
		version: 2
	},
	"flag-in": {
		id: "flag-in",
		name: "India Flag",
		keywords: [
			"in",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f3",
				native: "🇮🇳",
				x: 2,
				y: 19
			}
		],
		version: 2
	},
	"flag-io": {
		id: "flag-io",
		name: "British Indian Ocean Territory Flag",
		keywords: [
			"io",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f4",
				native: "🇮🇴",
				x: 2,
				y: 20
			}
		],
		version: 2
	},
	"flag-iq": {
		id: "flag-iq",
		name: "Iraq Flag",
		keywords: [
			"iq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f6",
				native: "🇮🇶",
				x: 2,
				y: 21
			}
		],
		version: 2
	},
	"flag-ir": {
		id: "flag-ir",
		name: "Iran Flag",
		keywords: [
			"ir",
			"islamic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f7",
				native: "🇮🇷",
				x: 2,
				y: 22
			}
		],
		version: 2
	},
	"flag-is": {
		id: "flag-is",
		name: "Iceland Flag",
		keywords: [
			"is",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f8",
				native: "🇮🇸",
				x: 2,
				y: 23
			}
		],
		version: 2
	},
	it: {
		id: "it",
		name: "Italy Flag",
		keywords: [
			"it",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ee-1f1f9",
				native: "🇮🇹",
				x: 2,
				y: 24
			}
		],
		version: 1
	},
	"flag-je": {
		id: "flag-je",
		name: "Jersey Flag",
		keywords: [
			"je",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1ea",
				native: "🇯🇪",
				x: 2,
				y: 25
			}
		],
		version: 2
	},
	"flag-jm": {
		id: "flag-jm",
		name: "Jamaica Flag",
		keywords: [
			"jm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1f2",
				native: "🇯🇲",
				x: 2,
				y: 26
			}
		],
		version: 2
	},
	"flag-jo": {
		id: "flag-jo",
		name: "Jordan Flag",
		keywords: [
			"jo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1f4",
				native: "🇯🇴",
				x: 2,
				y: 27
			}
		],
		version: 2
	},
	jp: {
		id: "jp",
		name: "Japan Flag",
		keywords: [
			"jp",
			"japanese",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ef-1f1f5",
				native: "🇯🇵",
				x: 2,
				y: 28
			}
		],
		version: 1
	},
	"flag-ke": {
		id: "flag-ke",
		name: "Kenya Flag",
		keywords: [
			"ke",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ea",
				native: "🇰🇪",
				x: 2,
				y: 29
			}
		],
		version: 2
	},
	"flag-kg": {
		id: "flag-kg",
		name: "Kyrgyzstan Flag",
		keywords: [
			"kg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ec",
				native: "🇰🇬",
				x: 2,
				y: 30
			}
		],
		version: 2
	},
	"flag-kh": {
		id: "flag-kh",
		name: "Cambodia Flag",
		keywords: [
			"kh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ed",
				native: "🇰🇭",
				x: 2,
				y: 31
			}
		],
		version: 2
	},
	"flag-ki": {
		id: "flag-ki",
		name: "Kiribati Flag",
		keywords: [
			"ki",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ee",
				native: "🇰🇮",
				x: 2,
				y: 32
			}
		],
		version: 2
	},
	"flag-km": {
		id: "flag-km",
		name: "Comoros Flag",
		keywords: [
			"km",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f2",
				native: "🇰🇲",
				x: 2,
				y: 33
			}
		],
		version: 2
	},
	"flag-kn": {
		id: "flag-kn",
		name: "St. Kitts & Nevis Flag",
		keywords: [
			"kn",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f3",
				native: "🇰🇳",
				x: 2,
				y: 34
			}
		],
		version: 2
	},
	"flag-kp": {
		id: "flag-kp",
		name: "North Korea Flag",
		keywords: [
			"kp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f5",
				native: "🇰🇵",
				x: 2,
				y: 35
			}
		],
		version: 2
	},
	kr: {
		id: "kr",
		name: "South Korea Flag",
		keywords: [
			"kr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1f7",
				native: "🇰🇷",
				x: 2,
				y: 36
			}
		],
		version: 1
	},
	"flag-kw": {
		id: "flag-kw",
		name: "Kuwait Flag",
		keywords: [
			"kw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1fc",
				native: "🇰🇼",
				x: 2,
				y: 37
			}
		],
		version: 2
	},
	"flag-ky": {
		id: "flag-ky",
		name: "Cayman Islands Flag",
		keywords: [
			"ky",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1fe",
				native: "🇰🇾",
				x: 2,
				y: 38
			}
		],
		version: 2
	},
	"flag-kz": {
		id: "flag-kz",
		name: "Kazakhstan Flag",
		keywords: [
			"kz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f0-1f1ff",
				native: "🇰🇿",
				x: 2,
				y: 39
			}
		],
		version: 2
	},
	"flag-la": {
		id: "flag-la",
		name: "Laos Flag",
		keywords: [
			"la",
			"lao",
			"democratic",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e6",
				native: "🇱🇦",
				x: 2,
				y: 40
			}
		],
		version: 2
	},
	"flag-lb": {
		id: "flag-lb",
		name: "Lebanon Flag",
		keywords: [
			"lb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e7",
				native: "🇱🇧",
				x: 2,
				y: 41
			}
		],
		version: 2
	},
	"flag-lc": {
		id: "flag-lc",
		name: "St. Lucia Flag",
		keywords: [
			"lc",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1e8",
				native: "🇱🇨",
				x: 2,
				y: 42
			}
		],
		version: 2
	},
	"flag-li": {
		id: "flag-li",
		name: "Liechtenstein Flag",
		keywords: [
			"li",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1ee",
				native: "🇱🇮",
				x: 2,
				y: 43
			}
		],
		version: 2
	},
	"flag-lk": {
		id: "flag-lk",
		name: "Sri Lanka Flag",
		keywords: [
			"lk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f0",
				native: "🇱🇰",
				x: 2,
				y: 44
			}
		],
		version: 2
	},
	"flag-lr": {
		id: "flag-lr",
		name: "Liberia Flag",
		keywords: [
			"lr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f7",
				native: "🇱🇷",
				x: 2,
				y: 45
			}
		],
		version: 2
	},
	"flag-ls": {
		id: "flag-ls",
		name: "Lesotho Flag",
		keywords: [
			"ls",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f8",
				native: "🇱🇸",
				x: 2,
				y: 46
			}
		],
		version: 2
	},
	"flag-lt": {
		id: "flag-lt",
		name: "Lithuania Flag",
		keywords: [
			"lt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1f9",
				native: "🇱🇹",
				x: 2,
				y: 47
			}
		],
		version: 2
	},
	"flag-lu": {
		id: "flag-lu",
		name: "Luxembourg Flag",
		keywords: [
			"lu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fa",
				native: "🇱🇺",
				x: 2,
				y: 48
			}
		],
		version: 2
	},
	"flag-lv": {
		id: "flag-lv",
		name: "Latvia Flag",
		keywords: [
			"lv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fb",
				native: "🇱🇻",
				x: 2,
				y: 49
			}
		],
		version: 2
	},
	"flag-ly": {
		id: "flag-ly",
		name: "Libya Flag",
		keywords: [
			"ly",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f1-1f1fe",
				native: "🇱🇾",
				x: 2,
				y: 50
			}
		],
		version: 2
	},
	"flag-ma": {
		id: "flag-ma",
		name: "Morocco Flag",
		keywords: [
			"ma",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e6",
				native: "🇲🇦",
				x: 2,
				y: 51
			}
		],
		version: 2
	},
	"flag-mc": {
		id: "flag-mc",
		name: "Monaco Flag",
		keywords: [
			"mc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e8",
				native: "🇲🇨",
				x: 2,
				y: 52
			}
		],
		version: 2
	},
	"flag-md": {
		id: "flag-md",
		name: "Moldova Flag",
		keywords: [
			"md",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1e9",
				native: "🇲🇩",
				x: 2,
				y: 53
			}
		],
		version: 2
	},
	"flag-me": {
		id: "flag-me",
		name: "Montenegro Flag",
		keywords: [
			"me",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ea",
				native: "🇲🇪",
				x: 2,
				y: 54
			}
		],
		version: 2
	},
	"flag-mf": {
		id: "flag-mf",
		name: "St. Martin Flag",
		keywords: [
			"mf",
			"st"
		],
		skins: [
			{
				unified: "1f1f2-1f1eb",
				native: "🇲🇫",
				x: 2,
				y: 55
			}
		],
		version: 2
	},
	"flag-mg": {
		id: "flag-mg",
		name: "Madagascar Flag",
		keywords: [
			"mg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ec",
				native: "🇲🇬",
				x: 2,
				y: 56
			}
		],
		version: 2
	},
	"flag-mh": {
		id: "flag-mh",
		name: "Marshall Islands Flag",
		keywords: [
			"mh",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ed",
				native: "🇲🇭",
				x: 2,
				y: 57
			}
		],
		version: 2
	},
	"flag-mk": {
		id: "flag-mk",
		name: "North Macedonia Flag",
		keywords: [
			"mk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f0",
				native: "🇲🇰",
				x: 2,
				y: 58
			}
		],
		version: 2
	},
	"flag-ml": {
		id: "flag-ml",
		name: "Mali Flag",
		keywords: [
			"ml",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f1",
				native: "🇲🇱",
				x: 2,
				y: 59
			}
		],
		version: 2
	},
	"flag-mm": {
		id: "flag-mm",
		name: "Myanmar (burma) Flag",
		keywords: [
			"mm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f2",
				native: "🇲🇲",
				x: 2,
				y: 60
			}
		],
		version: 2
	},
	"flag-mn": {
		id: "flag-mn",
		name: "Mongolia Flag",
		keywords: [
			"mn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f3",
				native: "🇲🇳",
				x: 3,
				y: 0
			}
		],
		version: 2
	},
	"flag-mo": {
		id: "flag-mo",
		name: "Macao Sar China Flag",
		keywords: [
			"mo",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f4",
				native: "🇲🇴",
				x: 3,
				y: 1
			}
		],
		version: 2
	},
	"flag-mp": {
		id: "flag-mp",
		name: "Northern Mariana Islands Flag",
		keywords: [
			"mp",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f5",
				native: "🇲🇵",
				x: 3,
				y: 2
			}
		],
		version: 2
	},
	"flag-mq": {
		id: "flag-mq",
		name: "Martinique Flag",
		keywords: [
			"mq",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f6",
				native: "🇲🇶",
				x: 3,
				y: 3
			}
		],
		version: 2
	},
	"flag-mr": {
		id: "flag-mr",
		name: "Mauritania Flag",
		keywords: [
			"mr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f7",
				native: "🇲🇷",
				x: 3,
				y: 4
			}
		],
		version: 2
	},
	"flag-ms": {
		id: "flag-ms",
		name: "Montserrat Flag",
		keywords: [
			"ms",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f8",
				native: "🇲🇸",
				x: 3,
				y: 5
			}
		],
		version: 2
	},
	"flag-mt": {
		id: "flag-mt",
		name: "Malta Flag",
		keywords: [
			"mt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1f9",
				native: "🇲🇹",
				x: 3,
				y: 6
			}
		],
		version: 2
	},
	"flag-mu": {
		id: "flag-mu",
		name: "Mauritius Flag",
		keywords: [
			"mu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fa",
				native: "🇲🇺",
				x: 3,
				y: 7
			}
		],
		version: 2
	},
	"flag-mv": {
		id: "flag-mv",
		name: "Maldives Flag",
		keywords: [
			"mv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fb",
				native: "🇲🇻",
				x: 3,
				y: 8
			}
		],
		version: 2
	},
	"flag-mw": {
		id: "flag-mw",
		name: "Malawi Flag",
		keywords: [
			"mw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fc",
				native: "🇲🇼",
				x: 3,
				y: 9
			}
		],
		version: 2
	},
	"flag-mx": {
		id: "flag-mx",
		name: "Mexico Flag",
		keywords: [
			"mx",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fd",
				native: "🇲🇽",
				x: 3,
				y: 10
			}
		],
		version: 2
	},
	"flag-my": {
		id: "flag-my",
		name: "Malaysia Flag",
		keywords: [
			"my",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1fe",
				native: "🇲🇾",
				x: 3,
				y: 11
			}
		],
		version: 2
	},
	"flag-mz": {
		id: "flag-mz",
		name: "Mozambique Flag",
		keywords: [
			"mz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f2-1f1ff",
				native: "🇲🇿",
				x: 3,
				y: 12
			}
		],
		version: 2
	},
	"flag-na": {
		id: "flag-na",
		name: "Namibia Flag",
		keywords: [
			"na",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1e6",
				native: "🇳🇦",
				x: 3,
				y: 13
			}
		],
		version: 2
	},
	"flag-nc": {
		id: "flag-nc",
		name: "New Caledonia Flag",
		keywords: [
			"nc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1e8",
				native: "🇳🇨",
				x: 3,
				y: 14
			}
		],
		version: 2
	},
	"flag-ne": {
		id: "flag-ne",
		name: "Niger Flag",
		keywords: [
			"ne",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ea",
				native: "🇳🇪",
				x: 3,
				y: 15
			}
		],
		version: 2
	},
	"flag-nf": {
		id: "flag-nf",
		name: "Norfolk Island Flag",
		keywords: [
			"nf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1eb",
				native: "🇳🇫",
				x: 3,
				y: 16
			}
		],
		version: 2
	},
	"flag-ng": {
		id: "flag-ng",
		name: "Nigeria Flag",
		keywords: [
			"ng",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ec",
				native: "🇳🇬",
				x: 3,
				y: 17
			}
		],
		version: 2
	},
	"flag-ni": {
		id: "flag-ni",
		name: "Nicaragua Flag",
		keywords: [
			"ni",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ee",
				native: "🇳🇮",
				x: 3,
				y: 18
			}
		],
		version: 2
	},
	"flag-nl": {
		id: "flag-nl",
		name: "Netherlands Flag",
		keywords: [
			"nl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f1",
				native: "🇳🇱",
				x: 3,
				y: 19
			}
		],
		version: 2
	},
	"flag-no": {
		id: "flag-no",
		name: "Norway Flag",
		keywords: [
			"no",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f4",
				native: "🇳🇴",
				x: 3,
				y: 20
			}
		],
		version: 2
	},
	"flag-np": {
		id: "flag-np",
		name: "Nepal Flag",
		keywords: [
			"np",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f5",
				native: "🇳🇵",
				x: 3,
				y: 21
			}
		],
		version: 2
	},
	"flag-nr": {
		id: "flag-nr",
		name: "Nauru Flag",
		keywords: [
			"nr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1f7",
				native: "🇳🇷",
				x: 3,
				y: 22
			}
		],
		version: 2
	},
	"flag-nu": {
		id: "flag-nu",
		name: "Niue Flag",
		keywords: [
			"nu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1fa",
				native: "🇳🇺",
				x: 3,
				y: 23
			}
		],
		version: 2
	},
	"flag-nz": {
		id: "flag-nz",
		name: "New Zealand Flag",
		keywords: [
			"nz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f3-1f1ff",
				native: "🇳🇿",
				x: 3,
				y: 24
			}
		],
		version: 2
	},
	"flag-om": {
		id: "flag-om",
		name: "Oman Flag",
		keywords: [
			"om",
			"symbol",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f4-1f1f2",
				native: "🇴🇲",
				x: 3,
				y: 25
			}
		],
		version: 2
	},
	"flag-pa": {
		id: "flag-pa",
		name: "Panama Flag",
		keywords: [
			"pa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1e6",
				native: "🇵🇦",
				x: 3,
				y: 26
			}
		],
		version: 2
	},
	"flag-pe": {
		id: "flag-pe",
		name: "Peru Flag",
		keywords: [
			"pe",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ea",
				native: "🇵🇪",
				x: 3,
				y: 27
			}
		],
		version: 2
	},
	"flag-pf": {
		id: "flag-pf",
		name: "French Polynesia Flag",
		keywords: [
			"pf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1eb",
				native: "🇵🇫",
				x: 3,
				y: 28
			}
		],
		version: 2
	},
	"flag-pg": {
		id: "flag-pg",
		name: "Papua New Guinea Flag",
		keywords: [
			"pg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ec",
				native: "🇵🇬",
				x: 3,
				y: 29
			}
		],
		version: 2
	},
	"flag-ph": {
		id: "flag-ph",
		name: "Philippines Flag",
		keywords: [
			"ph",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1ed",
				native: "🇵🇭",
				x: 3,
				y: 30
			}
		],
		version: 2
	},
	"flag-pk": {
		id: "flag-pk",
		name: "Pakistan Flag",
		keywords: [
			"pk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f0",
				native: "🇵🇰",
				x: 3,
				y: 31
			}
		],
		version: 2
	},
	"flag-pl": {
		id: "flag-pl",
		name: "Poland Flag",
		keywords: [
			"pl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f1",
				native: "🇵🇱",
				x: 3,
				y: 32
			}
		],
		version: 2
	},
	"flag-pm": {
		id: "flag-pm",
		name: "St. Pierre & Miquelon Flag",
		keywords: [
			"pm",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f2",
				native: "🇵🇲",
				x: 3,
				y: 33
			}
		],
		version: 2
	},
	"flag-pn": {
		id: "flag-pn",
		name: "Pitcairn Islands Flag",
		keywords: [
			"pn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f3",
				native: "🇵🇳",
				x: 3,
				y: 34
			}
		],
		version: 2
	},
	"flag-pr": {
		id: "flag-pr",
		name: "Puerto Rico Flag",
		keywords: [
			"pr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f7",
				native: "🇵🇷",
				x: 3,
				y: 35
			}
		],
		version: 2
	},
	"flag-ps": {
		id: "flag-ps",
		name: "Palestinian Territories Flag",
		keywords: [
			"ps",
			"palestine",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f8",
				native: "🇵🇸",
				x: 3,
				y: 36
			}
		],
		version: 2
	},
	"flag-pt": {
		id: "flag-pt",
		name: "Portugal Flag",
		keywords: [
			"pt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1f9",
				native: "🇵🇹",
				x: 3,
				y: 37
			}
		],
		version: 2
	},
	"flag-pw": {
		id: "flag-pw",
		name: "Palau Flag",
		keywords: [
			"pw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1fc",
				native: "🇵🇼",
				x: 3,
				y: 38
			}
		],
		version: 2
	},
	"flag-py": {
		id: "flag-py",
		name: "Paraguay Flag",
		keywords: [
			"py",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f5-1f1fe",
				native: "🇵🇾",
				x: 3,
				y: 39
			}
		],
		version: 2
	},
	"flag-qa": {
		id: "flag-qa",
		name: "Qatar Flag",
		keywords: [
			"qa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f6-1f1e6",
				native: "🇶🇦",
				x: 3,
				y: 40
			}
		],
		version: 2
	},
	"flag-re": {
		id: "flag-re",
		name: "Réunion Flag",
		keywords: [
			"re",
			"reunion",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1ea",
				native: "🇷🇪",
				x: 3,
				y: 41
			}
		],
		version: 2
	},
	"flag-ro": {
		id: "flag-ro",
		name: "Romania Flag",
		keywords: [
			"ro",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1f4",
				native: "🇷🇴",
				x: 3,
				y: 42
			}
		],
		version: 2
	},
	"flag-rs": {
		id: "flag-rs",
		name: "Serbia Flag",
		keywords: [
			"rs",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1f8",
				native: "🇷🇸",
				x: 3,
				y: 43
			}
		],
		version: 2
	},
	ru: {
		id: "ru",
		name: "Russia Flag",
		keywords: [
			"ru",
			"russian",
			"federation",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1fa",
				native: "🇷🇺",
				x: 3,
				y: 44
			}
		],
		version: 1
	},
	"flag-rw": {
		id: "flag-rw",
		name: "Rwanda Flag",
		keywords: [
			"rw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f7-1f1fc",
				native: "🇷🇼",
				x: 3,
				y: 45
			}
		],
		version: 2
	},
	"flag-sa": {
		id: "flag-sa",
		name: "Saudi Arabia Flag",
		keywords: [
			"sa",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e6",
				native: "🇸🇦",
				x: 3,
				y: 46
			}
		],
		version: 2
	},
	"flag-sb": {
		id: "flag-sb",
		name: "Solomon Islands Flag",
		keywords: [
			"sb",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e7",
				native: "🇸🇧",
				x: 3,
				y: 47
			}
		],
		version: 2
	},
	"flag-sc": {
		id: "flag-sc",
		name: "Seychelles Flag",
		keywords: [
			"sc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e8",
				native: "🇸🇨",
				x: 3,
				y: 48
			}
		],
		version: 2
	},
	"flag-sd": {
		id: "flag-sd",
		name: "Sudan Flag",
		keywords: [
			"sd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1e9",
				native: "🇸🇩",
				x: 3,
				y: 49
			}
		],
		version: 2
	},
	"flag-se": {
		id: "flag-se",
		name: "Sweden Flag",
		keywords: [
			"se",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ea",
				native: "🇸🇪",
				x: 3,
				y: 50
			}
		],
		version: 2
	},
	"flag-sg": {
		id: "flag-sg",
		name: "Singapore Flag",
		keywords: [
			"sg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ec",
				native: "🇸🇬",
				x: 3,
				y: 51
			}
		],
		version: 2
	},
	"flag-sh": {
		id: "flag-sh",
		name: "St. Helena Flag",
		keywords: [
			"sh",
			"st",
			"saint",
			"ascension",
			"tristan",
			"cunha",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ed",
				native: "🇸🇭",
				x: 3,
				y: 52
			}
		],
		version: 2
	},
	"flag-si": {
		id: "flag-si",
		name: "Slovenia Flag",
		keywords: [
			"si",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ee",
				native: "🇸🇮",
				x: 3,
				y: 53
			}
		],
		version: 2
	},
	"flag-sj": {
		id: "flag-sj",
		name: "Svalbard & Jan Mayen Flag",
		keywords: [
			"sj"
		],
		skins: [
			{
				unified: "1f1f8-1f1ef",
				native: "🇸🇯",
				x: 3,
				y: 54
			}
		],
		version: 2
	},
	"flag-sk": {
		id: "flag-sk",
		name: "Slovakia Flag",
		keywords: [
			"sk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f0",
				native: "🇸🇰",
				x: 3,
				y: 55
			}
		],
		version: 2
	},
	"flag-sl": {
		id: "flag-sl",
		name: "Sierra Leone Flag",
		keywords: [
			"sl",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f1",
				native: "🇸🇱",
				x: 3,
				y: 56
			}
		],
		version: 2
	},
	"flag-sm": {
		id: "flag-sm",
		name: "San Marino Flag",
		keywords: [
			"sm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f2",
				native: "🇸🇲",
				x: 3,
				y: 57
			}
		],
		version: 2
	},
	"flag-sn": {
		id: "flag-sn",
		name: "Senegal Flag",
		keywords: [
			"sn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f3",
				native: "🇸🇳",
				x: 3,
				y: 58
			}
		],
		version: 2
	},
	"flag-so": {
		id: "flag-so",
		name: "Somalia Flag",
		keywords: [
			"so",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f4",
				native: "🇸🇴",
				x: 3,
				y: 59
			}
		],
		version: 2
	},
	"flag-sr": {
		id: "flag-sr",
		name: "Suriname Flag",
		keywords: [
			"sr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f7",
				native: "🇸🇷",
				x: 3,
				y: 60
			}
		],
		version: 2
	},
	"flag-ss": {
		id: "flag-ss",
		name: "South Sudan Flag",
		keywords: [
			"ss",
			"sd",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f8",
				native: "🇸🇸",
				x: 4,
				y: 0
			}
		],
		version: 2
	},
	"flag-st": {
		id: "flag-st",
		name: "São Tomé & Príncipe Flag",
		keywords: [
			"st",
			"sao",
			"tome",
			"principe",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1f9",
				native: "🇸🇹",
				x: 4,
				y: 1
			}
		],
		version: 2
	},
	"flag-sv": {
		id: "flag-sv",
		name: "El Salvador Flag",
		keywords: [
			"sv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fb",
				native: "🇸🇻",
				x: 4,
				y: 2
			}
		],
		version: 2
	},
	"flag-sx": {
		id: "flag-sx",
		name: "Sint Maarten Flag",
		keywords: [
			"sx",
			"dutch",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fd",
				native: "🇸🇽",
				x: 4,
				y: 3
			}
		],
		version: 2
	},
	"flag-sy": {
		id: "flag-sy",
		name: "Syria Flag",
		keywords: [
			"sy",
			"syrian",
			"arab",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1fe",
				native: "🇸🇾",
				x: 4,
				y: 4
			}
		],
		version: 2
	},
	"flag-sz": {
		id: "flag-sz",
		name: "Eswatini Flag",
		keywords: [
			"sz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f8-1f1ff",
				native: "🇸🇿",
				x: 4,
				y: 5
			}
		],
		version: 2
	},
	"flag-ta": {
		id: "flag-ta",
		name: "Tristan Da Cunha Flag",
		keywords: [
			"ta"
		],
		skins: [
			{
				unified: "1f1f9-1f1e6",
				native: "🇹🇦",
				x: 4,
				y: 6
			}
		],
		version: 2
	},
	"flag-tc": {
		id: "flag-tc",
		name: "Turks & Caicos Islands Flag",
		keywords: [
			"tc",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1e8",
				native: "🇹🇨",
				x: 4,
				y: 7
			}
		],
		version: 2
	},
	"flag-td": {
		id: "flag-td",
		name: "Chad Flag",
		keywords: [
			"td",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1e9",
				native: "🇹🇩",
				x: 4,
				y: 8
			}
		],
		version: 2
	},
	"flag-tf": {
		id: "flag-tf",
		name: "French Southern Territories Flag",
		keywords: [
			"tf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1eb",
				native: "🇹🇫",
				x: 4,
				y: 9
			}
		],
		version: 2
	},
	"flag-tg": {
		id: "flag-tg",
		name: "Togo Flag",
		keywords: [
			"tg",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ec",
				native: "🇹🇬",
				x: 4,
				y: 10
			}
		],
		version: 2
	},
	"flag-th": {
		id: "flag-th",
		name: "Thailand Flag",
		keywords: [
			"th",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ed",
				native: "🇹🇭",
				x: 4,
				y: 11
			}
		],
		version: 2
	},
	"flag-tj": {
		id: "flag-tj",
		name: "Tajikistan Flag",
		keywords: [
			"tj",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ef",
				native: "🇹🇯",
				x: 4,
				y: 12
			}
		],
		version: 2
	},
	"flag-tk": {
		id: "flag-tk",
		name: "Tokelau Flag",
		keywords: [
			"tk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f0",
				native: "🇹🇰",
				x: 4,
				y: 13
			}
		],
		version: 2
	},
	"flag-tl": {
		id: "flag-tl",
		name: "Timor-Leste Flag",
		keywords: [
			"tl",
			"timor",
			"leste",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f1",
				native: "🇹🇱",
				x: 4,
				y: 14
			}
		],
		version: 2
	},
	"flag-tm": {
		id: "flag-tm",
		name: "Turkmenistan Flag",
		keywords: [
			"tm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f2",
				native: "🇹🇲",
				x: 4,
				y: 15
			}
		],
		version: 2
	},
	"flag-tn": {
		id: "flag-tn",
		name: "Tunisia Flag",
		keywords: [
			"tn",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f3",
				native: "🇹🇳",
				x: 4,
				y: 16
			}
		],
		version: 2
	},
	"flag-to": {
		id: "flag-to",
		name: "Tonga Flag",
		keywords: [
			"to",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f4",
				native: "🇹🇴",
				x: 4,
				y: 17
			}
		],
		version: 2
	},
	"flag-tr": {
		id: "flag-tr",
		name: "Turkey Flag",
		keywords: [
			"tr",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f7",
				native: "🇹🇷",
				x: 4,
				y: 18
			}
		],
		version: 2
	},
	"flag-tt": {
		id: "flag-tt",
		name: "Trinidad & Tobago Flag",
		keywords: [
			"tt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1f9",
				native: "🇹🇹",
				x: 4,
				y: 19
			}
		],
		version: 2
	},
	"flag-tv": {
		id: "flag-tv",
		name: "Tuvalu Flag",
		keywords: [
			"tv",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1fb",
				native: "🇹🇻",
				x: 4,
				y: 20
			}
		],
		version: 2
	},
	"flag-tw": {
		id: "flag-tw",
		name: "Taiwan Flag",
		keywords: [
			"tw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1fc",
				native: "🇹🇼",
				x: 4,
				y: 21
			}
		],
		version: 2
	},
	"flag-tz": {
		id: "flag-tz",
		name: "Tanzania Flag",
		keywords: [
			"tz",
			"united",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1f9-1f1ff",
				native: "🇹🇿",
				x: 4,
				y: 22
			}
		],
		version: 2
	},
	"flag-ua": {
		id: "flag-ua",
		name: "Ukraine Flag",
		keywords: [
			"ua",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1e6",
				native: "🇺🇦",
				x: 4,
				y: 23
			}
		],
		version: 2
	},
	"flag-ug": {
		id: "flag-ug",
		name: "Uganda Flag",
		keywords: [
			"ug",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1ec",
				native: "🇺🇬",
				x: 4,
				y: 24
			}
		],
		version: 2
	},
	"flag-um": {
		id: "flag-um",
		name: "U.s. Outlying Islands Flag",
		keywords: [
			"um",
			"u",
			"s"
		],
		skins: [
			{
				unified: "1f1fa-1f1f2",
				native: "🇺🇲",
				x: 4,
				y: 25
			}
		],
		version: 2
	},
	"flag-un": {
		id: "flag-un",
		name: "United Nations Flag",
		keywords: [
			"un",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1f3",
				native: "🇺🇳",
				x: 4,
				y: 26
			}
		],
		version: 4
	},
	us: {
		id: "us",
		name: "United States Flag",
		keywords: [
			"us",
			"america",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1f8",
				native: "🇺🇸",
				x: 4,
				y: 27
			}
		],
		version: 1
	},
	"flag-uy": {
		id: "flag-uy",
		name: "Uruguay Flag",
		keywords: [
			"uy",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1fe",
				native: "🇺🇾",
				x: 4,
				y: 28
			}
		],
		version: 2
	},
	"flag-uz": {
		id: "flag-uz",
		name: "Uzbekistan Flag",
		keywords: [
			"uz",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fa-1f1ff",
				native: "🇺🇿",
				x: 4,
				y: 29
			}
		],
		version: 2
	},
	"flag-va": {
		id: "flag-va",
		name: "Vatican City Flag",
		keywords: [
			"va",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1e6",
				native: "🇻🇦",
				x: 4,
				y: 30
			}
		],
		version: 2
	},
	"flag-vc": {
		id: "flag-vc",
		name: "St. Vincent & Grenadines Flag",
		keywords: [
			"vc",
			"st",
			"saint",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1e8",
				native: "🇻🇨",
				x: 4,
				y: 31
			}
		],
		version: 2
	},
	"flag-ve": {
		id: "flag-ve",
		name: "Venezuela Flag",
		keywords: [
			"ve",
			"bolivarian",
			"republic",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ea",
				native: "🇻🇪",
				x: 4,
				y: 32
			}
		],
		version: 2
	},
	"flag-vg": {
		id: "flag-vg",
		name: "British Virgin Islands Flag",
		keywords: [
			"vg",
			"bvi",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ec",
				native: "🇻🇬",
				x: 4,
				y: 33
			}
		],
		version: 2
	},
	"flag-vi": {
		id: "flag-vi",
		name: "U.s. Virgin Islands Flag",
		keywords: [
			"vi",
			"u",
			"s",
			"us",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1ee",
				native: "🇻🇮",
				x: 4,
				y: 34
			}
		],
		version: 2
	},
	"flag-vn": {
		id: "flag-vn",
		name: "Vietnam Flag",
		keywords: [
			"vn",
			"viet",
			"nam",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1f3",
				native: "🇻🇳",
				x: 4,
				y: 35
			}
		],
		version: 2
	},
	"flag-vu": {
		id: "flag-vu",
		name: "Vanuatu Flag",
		keywords: [
			"vu",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fb-1f1fa",
				native: "🇻🇺",
				x: 4,
				y: 36
			}
		],
		version: 2
	},
	"flag-wf": {
		id: "flag-wf",
		name: "Wallis & Futuna Flag",
		keywords: [
			"wf",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fc-1f1eb",
				native: "🇼🇫",
				x: 4,
				y: 37
			}
		],
		version: 2
	},
	"flag-ws": {
		id: "flag-ws",
		name: "Samoa Flag",
		keywords: [
			"ws",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fc-1f1f8",
				native: "🇼🇸",
				x: 4,
				y: 38
			}
		],
		version: 2
	},
	"flag-xk": {
		id: "flag-xk",
		name: "Kosovo Flag",
		keywords: [
			"xk",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fd-1f1f0",
				native: "🇽🇰",
				x: 4,
				y: 39
			}
		],
		version: 2
	},
	"flag-ye": {
		id: "flag-ye",
		name: "Yemen Flag",
		keywords: [
			"ye",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fe-1f1ea",
				native: "🇾🇪",
				x: 4,
				y: 40
			}
		],
		version: 2
	},
	"flag-yt": {
		id: "flag-yt",
		name: "Mayotte Flag",
		keywords: [
			"yt",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1fe-1f1f9",
				native: "🇾🇹",
				x: 4,
				y: 41
			}
		],
		version: 2
	},
	"flag-za": {
		id: "flag-za",
		name: "South Africa Flag",
		keywords: [
			"za",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1e6",
				native: "🇿🇦",
				x: 4,
				y: 42
			}
		],
		version: 2
	},
	"flag-zm": {
		id: "flag-zm",
		name: "Zambia Flag",
		keywords: [
			"zm",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1f2",
				native: "🇿🇲",
				x: 4,
				y: 43
			}
		],
		version: 2
	},
	"flag-zw": {
		id: "flag-zw",
		name: "Zimbabwe Flag",
		keywords: [
			"zw",
			"nation",
			"country",
			"banner"
		],
		skins: [
			{
				unified: "1f1ff-1f1fc",
				native: "🇿🇼",
				x: 4,
				y: 44
			}
		],
		version: 2
	},
	"flag-england": {
		id: "flag-england",
		name: "England Flag",
		keywords: [
			"english"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
				native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
				x: 10,
				y: 32
			}
		],
		version: 5
	},
	"flag-scotland": {
		id: "flag-scotland",
		name: "Scotland Flag",
		keywords: [
			"scottish"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
				native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
				x: 10,
				y: 33
			}
		],
		version: 5
	},
	"flag-wales": {
		id: "flag-wales",
		name: "Wales Flag",
		keywords: [
			"welsh"
		],
		skins: [
			{
				unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
				native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
				x: 10,
				y: 34
			}
		],
		version: 5
	}
};
var aliases = {
	satisfied: "laughing",
	grinning_face_with_star_eyes: "star-struck",
	grinning_face_with_one_large_and_one_small_eye: "zany_face",
	smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
	face_with_finger_covering_closed_lips: "shushing_face",
	face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
	face_with_open_mouth_vomiting: "face_vomiting",
	shocked_face_with_exploding_head: "exploding_head",
	serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
	poop: "hankey",
	shit: "hankey",
	collision: "boom",
	raised_hand: "hand",
	hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
	sign_of_the_horns: "the_horns",
	reversed_hand_with_middle_finger_extended: "middle_finger",
	thumbsup: "+1",
	thumbsdown: "-1",
	punch: "facepunch",
	mother_christmas: "mrs_claus",
	running: "runner",
	"man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
	"woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
	women_holding_hands: "two_women_holding_hands",
	woman_and_man_holding_hands: "man_and_woman_holding_hands",
	couple: "man_and_woman_holding_hands",
	men_holding_hands: "two_men_holding_hands",
	paw_prints: "feet",
	flipper: "dolphin",
	honeybee: "bee",
	lady_beetle: "ladybug",
	cooking: "fried_egg",
	knife: "hocho",
	red_car: "car",
	sailboat: "boat",
	waxing_gibbous_moon: "moon",
	sun_small_cloud: "mostly_sunny",
	sun_behind_cloud: "barely_sunny",
	sun_behind_rain_cloud: "partly_sunny_rain",
	lightning_cloud: "lightning",
	tornado_cloud: "tornado",
	tshirt: "shirt",
	shoe: "mans_shoe",
	telephone: "phone",
	lantern: "izakaya_lantern",
	open_book: "book",
	envelope: "email",
	pencil: "memo",
	heavy_exclamation_mark: "exclamation",
	staff_of_aesculapius: "medical_symbol",
	"flag-cn": "cn",
	"flag-de": "de",
	"flag-es": "es",
	"flag-fr": "fr",
	uk: "gb",
	"flag-gb": "gb",
	"flag-it": "it",
	"flag-jp": "jp",
	"flag-kr": "kr",
	"flag-ru": "ru",
	"flag-us": "us"
};
var sheet = {
	cols: 61,
	rows: 61
};
var data = {
	categories: categories,
	emojis: emojis,
	aliases: aliases,
	sheet: sheet
};

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $c770c458706daa72$export$2e2bcd8739ae039(obj, key, value) {
  if (key in obj) Object.defineProperty(obj, key, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: true
  });else obj[key] = value;
  return obj;
}
var $fb96b826c0c5f37a$var$n,
  $fb96b826c0c5f37a$export$41c562ebe57d11e2,
  $fb96b826c0c5f37a$var$u,
  $fb96b826c0c5f37a$var$t,
  $fb96b826c0c5f37a$var$r,
  $fb96b826c0c5f37a$var$o,
  $fb96b826c0c5f37a$var$e = {},
  $fb96b826c0c5f37a$var$c = [],
  $fb96b826c0c5f37a$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $fb96b826c0c5f37a$var$a(n1, l1) {
  for (var u1 in l1) n1[u1] = l1[u1];
  return n1;
}
function $fb96b826c0c5f37a$var$h(n2) {
  var l2 = n2.parentNode;
  l2 && l2.removeChild(n2);
}
function $fb96b826c0c5f37a$export$c8a8987d4410bf2d(l3, u2, i1) {
  var t1,
    r1,
    o1,
    f1 = {};
  for (o1 in u2) "key" == o1 ? t1 = u2[o1] : "ref" == o1 ? r1 = u2[o1] : f1[o1] = u2[o1];
  if (arguments.length > 2 && (f1.children = arguments.length > 3 ? $fb96b826c0c5f37a$var$n.call(arguments, 2) : i1), "function" == typeof l3 && null != l3.defaultProps) for (o1 in l3.defaultProps) void 0 === f1[o1] && (f1[o1] = l3.defaultProps[o1]);
  return $fb96b826c0c5f37a$var$y(l3, f1, t1, r1, null);
}
function $fb96b826c0c5f37a$var$y(n3, i2, t2, r2, o2) {
  var f2 = {
    type: n3,
    props: i2,
    key: t2,
    ref: r2,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == o2 ? ++$fb96b826c0c5f37a$var$u : o2
  };
  return null == o2 && null != $fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode && $fb96b826c0c5f37a$export$41c562ebe57d11e2.vnode(f2), f2;
}
function $fb96b826c0c5f37a$export$7d1e3a5e95ceca43() {
  return {
    current: null
  };
}
function $fb96b826c0c5f37a$export$ffb0004e005737fa(n4) {
  return n4.children;
}
function $fb96b826c0c5f37a$export$16fa2f45be04daa8(n5, l4) {
  this.props = n5, this.context = l4;
}
function $fb96b826c0c5f37a$var$k(n6, l5) {
  if (null == l5) return n6.__ ? $fb96b826c0c5f37a$var$k(n6.__, n6.__.__k.indexOf(n6) + 1) : null;
  for (var u3; l5 < n6.__k.length; l5++) if (null != (u3 = n6.__k[l5]) && null != u3.__e) return u3.__e;
  return "function" == typeof n6.type ? $fb96b826c0c5f37a$var$k(n6) : null;
}
function $fb96b826c0c5f37a$var$b(n7) {
  var l6, u4;
  if (null != (n7 = n7.__) && null != n7.__c) {
    for (n7.__e = n7.__c.base = null, l6 = 0; l6 < n7.__k.length; l6++) if (null != (u4 = n7.__k[l6]) && null != u4.__e) {
      n7.__e = n7.__c.base = u4.__e;
      break;
    }
    return $fb96b826c0c5f37a$var$b(n7);
  }
}
function $fb96b826c0c5f37a$var$m(n8) {
  (!n8.__d && (n8.__d = !0) && $fb96b826c0c5f37a$var$t.push(n8) && !$fb96b826c0c5f37a$var$g.__r++ || $fb96b826c0c5f37a$var$o !== $fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) && (($fb96b826c0c5f37a$var$o = $fb96b826c0c5f37a$export$41c562ebe57d11e2.debounceRendering) || $fb96b826c0c5f37a$var$r)($fb96b826c0c5f37a$var$g);
}
function $fb96b826c0c5f37a$var$g() {
  for (var n9; $fb96b826c0c5f37a$var$g.__r = $fb96b826c0c5f37a$var$t.length;) n9 = $fb96b826c0c5f37a$var$t.sort(function (n10, l7) {
    return n10.__v.__b - l7.__v.__b;
  }), $fb96b826c0c5f37a$var$t = [], n9.some(function (n11) {
    var l8, u5, i3, t3, r3, o3;
    n11.__d && (r3 = (t3 = (l8 = n11).__v).__e, (o3 = l8.__P) && (u5 = [], (i3 = $fb96b826c0c5f37a$var$a({}, t3)).__v = t3.__v + 1, $fb96b826c0c5f37a$var$j(o3, t3, i3, l8.__n, void 0 !== o3.ownerSVGElement, null != t3.__h ? [r3] : null, u5, null == r3 ? $fb96b826c0c5f37a$var$k(t3) : r3, t3.__h), $fb96b826c0c5f37a$var$z(u5, t3), t3.__e != r3 && $fb96b826c0c5f37a$var$b(t3)));
  });
}
function $fb96b826c0c5f37a$var$w(n12, l9, u6, i4, t4, r4, o4, f3, s1, a1) {
  var h1,
    v1,
    p1,
    _1,
    b1,
    m1,
    g1,
    w1 = i4 && i4.__k || $fb96b826c0c5f37a$var$c,
    A1 = w1.length;
  for (u6.__k = [], h1 = 0; h1 < l9.length; h1++) if (null != (_1 = u6.__k[h1] = null == (_1 = l9[h1]) || "boolean" == typeof _1 ? null : "string" == typeof _1 || "number" == typeof _1 || "bigint" == typeof _1 ? $fb96b826c0c5f37a$var$y(null, _1, null, null, _1) : Array.isArray(_1) ? $fb96b826c0c5f37a$var$y($fb96b826c0c5f37a$export$ffb0004e005737fa, {
    children: _1
  }, null, null, null) : _1.__b > 0 ? $fb96b826c0c5f37a$var$y(_1.type, _1.props, _1.key, null, _1.__v) : _1)) {
    if (_1.__ = u6, _1.__b = u6.__b + 1, null === (p1 = w1[h1]) || p1 && _1.key == p1.key && _1.type === p1.type) w1[h1] = void 0;else for (v1 = 0; v1 < A1; v1++) {
      if ((p1 = w1[v1]) && _1.key == p1.key && _1.type === p1.type) {
        w1[v1] = void 0;
        break;
      }
      p1 = null;
    }
    $fb96b826c0c5f37a$var$j(n12, _1, p1 = p1 || $fb96b826c0c5f37a$var$e, t4, r4, o4, f3, s1, a1), b1 = _1.__e, (v1 = _1.ref) && p1.ref != v1 && (g1 || (g1 = []), p1.ref && g1.push(p1.ref, null, _1), g1.push(v1, _1.__c || b1, _1)), null != b1 ? (null == m1 && (m1 = b1), "function" == typeof _1.type && _1.__k === p1.__k ? _1.__d = s1 = $fb96b826c0c5f37a$var$x(_1, s1, n12) : s1 = $fb96b826c0c5f37a$var$P(n12, _1, p1, w1, b1, s1), "function" == typeof u6.type && (u6.__d = s1)) : s1 && p1.__e == s1 && s1.parentNode != n12 && (s1 = $fb96b826c0c5f37a$var$k(p1));
  }
  for (u6.__e = m1, h1 = A1; h1--;) null != w1[h1] && ("function" == typeof u6.type && null != w1[h1].__e && w1[h1].__e == u6.__d && (u6.__d = $fb96b826c0c5f37a$var$k(i4, h1 + 1)), $fb96b826c0c5f37a$var$N(w1[h1], w1[h1]));
  if (g1) for (h1 = 0; h1 < g1.length; h1++) $fb96b826c0c5f37a$var$M(g1[h1], g1[++h1], g1[++h1]);
}
function $fb96b826c0c5f37a$var$x(n13, l10, u7) {
  for (var i5, t5 = n13.__k, r5 = 0; t5 && r5 < t5.length; r5++) (i5 = t5[r5]) && (i5.__ = n13, l10 = "function" == typeof i5.type ? $fb96b826c0c5f37a$var$x(i5, l10, u7) : $fb96b826c0c5f37a$var$P(u7, i5, i5, t5, i5.__e, l10));
  return l10;
}
function $fb96b826c0c5f37a$export$47e4c5b300681277(n14, l11) {
  return l11 = l11 || [], null == n14 || "boolean" == typeof n14 || (Array.isArray(n14) ? n14.some(function (n15) {
    $fb96b826c0c5f37a$export$47e4c5b300681277(n15, l11);
  }) : l11.push(n14)), l11;
}
function $fb96b826c0c5f37a$var$P(n16, l12, u8, i6, t6, r6) {
  var o5, f4, e1;
  if (void 0 !== l12.__d) o5 = l12.__d, l12.__d = void 0;else if (null == u8 || t6 != r6 || null == t6.parentNode) n: if (null == r6 || r6.parentNode !== n16) n16.appendChild(t6), o5 = null;else {
    for (f4 = r6, e1 = 0; (f4 = f4.nextSibling) && e1 < i6.length; e1 += 2) if (f4 == t6) break n;
    n16.insertBefore(t6, r6), o5 = r6;
  }
  return void 0 !== o5 ? o5 : t6.nextSibling;
}
function $fb96b826c0c5f37a$var$C(n17, l13, u9, i7, t7) {
  var r7;
  for (r7 in u9) "children" === r7 || "key" === r7 || r7 in l13 || $fb96b826c0c5f37a$var$H(n17, r7, null, u9[r7], i7);
  for (r7 in l13) t7 && "function" != typeof l13[r7] || "children" === r7 || "key" === r7 || "value" === r7 || "checked" === r7 || u9[r7] === l13[r7] || $fb96b826c0c5f37a$var$H(n17, r7, l13[r7], u9[r7], i7);
}
function $fb96b826c0c5f37a$var$$(n18, l14, u10) {
  "-" === l14[0] ? n18.setProperty(l14, u10) : n18[l14] = null == u10 ? "" : "number" != typeof u10 || $fb96b826c0c5f37a$var$s.test(l14) ? u10 : u10 + "px";
}
function $fb96b826c0c5f37a$var$H(n19, l15, u11, i8, t8) {
  var r8;
  n: if ("style" === l15) {
    if ("string" == typeof u11) n19.style.cssText = u11;else {
      if ("string" == typeof i8 && (n19.style.cssText = i8 = ""), i8) for (l15 in i8) u11 && l15 in u11 || $fb96b826c0c5f37a$var$$(n19.style, l15, "");
      if (u11) for (l15 in u11) i8 && u11[l15] === i8[l15] || $fb96b826c0c5f37a$var$$(n19.style, l15, u11[l15]);
    }
  } else if ("o" === l15[0] && "n" === l15[1]) r8 = l15 !== (l15 = l15.replace(/Capture$/, "")), l15 = l15.toLowerCase() in n19 ? l15.toLowerCase().slice(2) : l15.slice(2), n19.l || (n19.l = {}), n19.l[l15 + r8] = u11, u11 ? i8 || n19.addEventListener(l15, r8 ? $fb96b826c0c5f37a$var$T : $fb96b826c0c5f37a$var$I, r8) : n19.removeEventListener(l15, r8 ? $fb96b826c0c5f37a$var$T : $fb96b826c0c5f37a$var$I, r8);else if ("dangerouslySetInnerHTML" !== l15) {
    if (t8) l15 = l15.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");else if ("href" !== l15 && "list" !== l15 && "form" !== l15 && "tabIndex" !== l15 && "download" !== l15 && l15 in n19) try {
      n19[l15] = null == u11 ? "" : u11;
      break n;
    } catch (n) {}
    "function" == typeof u11 || (null != u11 && (!1 !== u11 || "a" === l15[0] && "r" === l15[1]) ? n19.setAttribute(l15, u11) : n19.removeAttribute(l15));
  }
}
function $fb96b826c0c5f37a$var$I(n20) {
  this.l[n20.type + !1]($fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n20) : n20);
}
function $fb96b826c0c5f37a$var$T(n21) {
  this.l[n21.type + !0]($fb96b826c0c5f37a$export$41c562ebe57d11e2.event ? $fb96b826c0c5f37a$export$41c562ebe57d11e2.event(n21) : n21);
}
function $fb96b826c0c5f37a$var$j(n22, u12, i9, t9, r9, o6, f5, e2, c1) {
  var s2,
    h2,
    v2,
    y1,
    p2,
    k1,
    b2,
    m2,
    g2,
    x1,
    A2,
    P1 = u12.type;
  if (void 0 !== u12.constructor) return null;
  null != i9.__h && (c1 = i9.__h, e2 = u12.__e = i9.__e, u12.__h = null, o6 = [e2]), (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.__b) && s2(u12);
  try {
    n: if ("function" == typeof P1) {
      if (m2 = u12.props, g2 = (s2 = P1.contextType) && t9[s2.__c], x1 = s2 ? g2 ? g2.props.value : s2.__ : t9, i9.__c ? b2 = (h2 = u12.__c = i9.__c).__ = h2.__E : ("prototype" in P1 && P1.prototype.render ? u12.__c = h2 = new P1(m2, x1) : (u12.__c = h2 = new $fb96b826c0c5f37a$export$16fa2f45be04daa8(m2, x1), h2.constructor = P1, h2.render = $fb96b826c0c5f37a$var$O), g2 && g2.sub(h2), h2.props = m2, h2.state || (h2.state = {}), h2.context = x1, h2.__n = t9, v2 = h2.__d = !0, h2.__h = []), null == h2.__s && (h2.__s = h2.state), null != P1.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = $fb96b826c0c5f37a$var$a({}, h2.__s)), $fb96b826c0c5f37a$var$a(h2.__s, P1.getDerivedStateFromProps(m2, h2.__s))), y1 = h2.props, p2 = h2.state, v2) null == P1.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);else {
        if (null == P1.getDerivedStateFromProps && m2 !== y1 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(m2, x1), !h2.__e && null != h2.shouldComponentUpdate && !1 === h2.shouldComponentUpdate(m2, h2.__s, x1) || u12.__v === i9.__v) {
          h2.props = m2, h2.state = h2.__s, u12.__v !== i9.__v && (h2.__d = !1), h2.__v = u12, u12.__e = i9.__e, u12.__k = i9.__k, u12.__k.forEach(function (n23) {
            n23 && (n23.__ = u12);
          }), h2.__h.length && f5.push(h2);
          break n;
        }
        null != h2.componentWillUpdate && h2.componentWillUpdate(m2, h2.__s, x1), null != h2.componentDidUpdate && h2.__h.push(function () {
          h2.componentDidUpdate(y1, p2, k1);
        });
      }
      h2.context = x1, h2.props = m2, h2.state = h2.__s, (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.__r) && s2(u12), h2.__d = !1, h2.__v = u12, h2.__P = n22, s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s, null != h2.getChildContext && (t9 = $fb96b826c0c5f37a$var$a($fb96b826c0c5f37a$var$a({}, t9), h2.getChildContext())), v2 || null == h2.getSnapshotBeforeUpdate || (k1 = h2.getSnapshotBeforeUpdate(y1, p2)), A2 = null != s2 && s2.type === $fb96b826c0c5f37a$export$ffb0004e005737fa && null == s2.key ? s2.props.children : s2, $fb96b826c0c5f37a$var$w(n22, Array.isArray(A2) ? A2 : [A2], u12, i9, t9, r9, o6, f5, e2, c1), h2.base = u12.__e, u12.__h = null, h2.__h.length && f5.push(h2), b2 && (h2.__E = h2.__ = null), h2.__e = !1;
    } else null == o6 && u12.__v === i9.__v ? (u12.__k = i9.__k, u12.__e = i9.__e) : u12.__e = $fb96b826c0c5f37a$var$L(i9.__e, u12, i9, t9, r9, o6, f5, c1);
    (s2 = $fb96b826c0c5f37a$export$41c562ebe57d11e2.diffed) && s2(u12);
  } catch (n24) {
    u12.__v = null, (c1 || null != o6) && (u12.__e = e2, u12.__h = !!c1, o6[o6.indexOf(e2)] = null), $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n24, u12, i9);
  }
}
function $fb96b826c0c5f37a$var$z(n25, u13) {
  $fb96b826c0c5f37a$export$41c562ebe57d11e2.__c && $fb96b826c0c5f37a$export$41c562ebe57d11e2.__c(u13, n25), n25.some(function (u14) {
    try {
      n25 = u14.__h, u14.__h = [], n25.some(function (n26) {
        n26.call(u14);
      });
    } catch (n27) {
      $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n27, u14.__v);
    }
  });
}
function $fb96b826c0c5f37a$var$L(l16, u15, i10, t10, r10, o7, f6, c2) {
  var s3,
    a2,
    v3,
    y2 = i10.props,
    p3 = u15.props,
    d1 = u15.type,
    _2 = 0;
  if ("svg" === d1 && (r10 = !0), null != o7) {
    for (; _2 < o7.length; _2++) if ((s3 = o7[_2]) && "setAttribute" in s3 == !!d1 && (d1 ? s3.localName === d1 : 3 === s3.nodeType)) {
      l16 = s3, o7[_2] = null;
      break;
    }
  }
  if (null == l16) {
    if (null === d1) return document.createTextNode(p3);
    l16 = r10 ? document.createElementNS("http://www.w3.org/2000/svg", d1) : document.createElement(d1, p3.is && p3), o7 = null, c2 = !1;
  }
  if (null === d1) y2 === p3 || c2 && l16.data === p3 || (l16.data = p3);else {
    if (o7 = o7 && $fb96b826c0c5f37a$var$n.call(l16.childNodes), a2 = (y2 = i10.props || $fb96b826c0c5f37a$var$e).dangerouslySetInnerHTML, v3 = p3.dangerouslySetInnerHTML, !c2) {
      if (null != o7) for (y2 = {}, _2 = 0; _2 < l16.attributes.length; _2++) y2[l16.attributes[_2].name] = l16.attributes[_2].value;
      (v3 || a2) && (v3 && (a2 && v3.__html == a2.__html || v3.__html === l16.innerHTML) || (l16.innerHTML = v3 && v3.__html || ""));
    }
    if ($fb96b826c0c5f37a$var$C(l16, p3, y2, r10, c2), v3) u15.__k = [];else if (_2 = u15.props.children, $fb96b826c0c5f37a$var$w(l16, Array.isArray(_2) ? _2 : [_2], u15, i10, t10, r10 && "foreignObject" !== d1, o7, f6, o7 ? o7[0] : i10.__k && $fb96b826c0c5f37a$var$k(i10, 0), c2), null != o7) for (_2 = o7.length; _2--;) null != o7[_2] && $fb96b826c0c5f37a$var$h(o7[_2]);
    c2 || ("value" in p3 && void 0 !== (_2 = p3.value) && (_2 !== y2.value || _2 !== l16.value || "progress" === d1 && !_2) && $fb96b826c0c5f37a$var$H(l16, "value", _2, y2.value, !1), "checked" in p3 && void 0 !== (_2 = p3.checked) && _2 !== l16.checked && $fb96b826c0c5f37a$var$H(l16, "checked", _2, y2.checked, !1));
  }
  return l16;
}
function $fb96b826c0c5f37a$var$M(n28, u16, i11) {
  try {
    "function" == typeof n28 ? n28(u16) : n28.current = u16;
  } catch (n29) {
    $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n29, i11);
  }
}
function $fb96b826c0c5f37a$var$N(n30, u17, i12) {
  var t11, r11;
  if ($fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount && $fb96b826c0c5f37a$export$41c562ebe57d11e2.unmount(n30), (t11 = n30.ref) && (t11.current && t11.current !== n30.__e || $fb96b826c0c5f37a$var$M(t11, null, u17)), null != (t11 = n30.__c)) {
    if (t11.componentWillUnmount) try {
      t11.componentWillUnmount();
    } catch (n31) {
      $fb96b826c0c5f37a$export$41c562ebe57d11e2.__e(n31, u17);
    }
    t11.base = t11.__P = null;
  }
  if (t11 = n30.__k) for (r11 = 0; r11 < t11.length; r11++) t11[r11] && $fb96b826c0c5f37a$var$N(t11[r11], u17, "function" != typeof n30.type);
  i12 || null == n30.__e || $fb96b826c0c5f37a$var$h(n30.__e), n30.__e = n30.__d = void 0;
}
function $fb96b826c0c5f37a$var$O(n32, l, u18) {
  return this.constructor(n32, u18);
}
function $fb96b826c0c5f37a$export$b3890eb0ae9dca99(u19, i13, t12) {
  var r12, o8, f7;
  $fb96b826c0c5f37a$export$41c562ebe57d11e2.__ && $fb96b826c0c5f37a$export$41c562ebe57d11e2.__(u19, i13), o8 = (r12 = "function" == typeof t12) ? null : t12 && t12.__k || i13.__k, f7 = [], $fb96b826c0c5f37a$var$j(i13, u19 = (!r12 && t12 || i13).__k = $fb96b826c0c5f37a$export$c8a8987d4410bf2d($fb96b826c0c5f37a$export$ffb0004e005737fa, null, [u19]), o8 || $fb96b826c0c5f37a$var$e, $fb96b826c0c5f37a$var$e, void 0 !== i13.ownerSVGElement, !r12 && t12 ? [t12] : o8 ? null : i13.firstChild ? $fb96b826c0c5f37a$var$n.call(i13.childNodes) : null, f7, !r12 && t12 ? t12 : o8 ? o8.__e : i13.firstChild, r12), $fb96b826c0c5f37a$var$z(f7, u19);
}
$fb96b826c0c5f37a$var$n = $fb96b826c0c5f37a$var$c.slice, $fb96b826c0c5f37a$export$41c562ebe57d11e2 = {
  __e: function (n39, l22) {
    for (var u23, i16, t14; l22 = l22.__;) if ((u23 = l22.__c) && !u23.__) try {
      if ((i16 = u23.constructor) && null != i16.getDerivedStateFromError && (u23.setState(i16.getDerivedStateFromError(n39)), t14 = u23.__d), null != u23.componentDidCatch && (u23.componentDidCatch(n39), t14 = u23.__d), t14) return u23.__E = u23;
    } catch (l23) {
      n39 = l23;
    }
    throw n39;
  }
}, $fb96b826c0c5f37a$var$u = 0, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.setState = function (n41, l24) {
  var u24;
  u24 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $fb96b826c0c5f37a$var$a({}, this.state), "function" == typeof n41 && (n41 = n41($fb96b826c0c5f37a$var$a({}, u24), this.props)), n41 && $fb96b826c0c5f37a$var$a(u24, n41), null != n41 && this.__v && (l24 && this.__h.push(l24), $fb96b826c0c5f37a$var$m(this));
}, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.forceUpdate = function (n42) {
  this.__v && (this.__e = !0, n42 && this.__h.push(n42), $fb96b826c0c5f37a$var$m(this));
}, $fb96b826c0c5f37a$export$16fa2f45be04daa8.prototype.render = $fb96b826c0c5f37a$export$ffb0004e005737fa, $fb96b826c0c5f37a$var$t = [], $fb96b826c0c5f37a$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $fb96b826c0c5f37a$var$g.__r = 0;
var $bd9dd35321b03dd4$var$o = 0;
function $bd9dd35321b03dd4$export$34b9dba7ce09269b(_1, e1, n, t, f) {
  var l,
    s,
    u = {};
  for (s in e1) "ref" == s ? l = e1[s] : u[s] = e1[s];
  var a = {
    type: _1,
    props: u,
    key: n,
    ref: l,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: --$bd9dd35321b03dd4$var$o,
    __source: t,
    __self: f
  };
  if ("function" == typeof _1 && (l = _1.defaultProps)) for (s in l) void 0 === u[s] && (u[s] = l[s]);
  return ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode && ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode(a), a;
}
function $f72b75cf796873c7$var$set(key, value) {
  try {
    window.localStorage[`emoji-mart.${key}`] = JSON.stringify(value);
  } catch (error) {}
}
function $f72b75cf796873c7$var$get(key) {
  try {
    const value = window.localStorage[`emoji-mart.${key}`];
    if (value) return JSON.parse(value);
  } catch (error) {}
}
var $f72b75cf796873c7$export$2e2bcd8739ae039 = {
  set: $f72b75cf796873c7$var$set,
  get: $f72b75cf796873c7$var$get
};
const $c84d045dcc34faf5$var$CACHE = new Map();
const $c84d045dcc34faf5$var$VERSIONS = [{
  v: 14,
  emoji: "\uD83E\uDEE0"
}, {
  v: 13.1,
  emoji: "\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"
}, {
  v: 13,
  emoji: "\uD83E\uDD78"
}, {
  v: 12.1,
  emoji: "\uD83E\uDDD1\u200D\uD83E\uDDB0"
}, {
  v: 12,
  emoji: "\uD83E\uDD71"
}, {
  v: 11,
  emoji: "\uD83E\uDD70"
}, {
  v: 5,
  emoji: "\uD83E\uDD29"
}, {
  v: 4,
  emoji: "\uD83D\uDC71\u200D\u2640\uFE0F"
}, {
  v: 3,
  emoji: "\uD83E\uDD23"
}, {
  v: 2,
  emoji: "\uD83D\uDC4B\uD83C\uDFFB"
}, {
  v: 1,
  emoji: "\uD83D\uDE43"
}];
function $c84d045dcc34faf5$var$latestVersion() {
  for (const {
    v: v,
    emoji: emoji
  } of $c84d045dcc34faf5$var$VERSIONS) {
    if ($c84d045dcc34faf5$var$isSupported(emoji)) return v;
  }
}
function $c84d045dcc34faf5$var$noCountryFlags() {
  if ($c84d045dcc34faf5$var$isSupported("\uD83C\uDDE8\uD83C\uDDE6")) return false;
  return true;
}
function $c84d045dcc34faf5$var$isSupported(emoji) {
  if ($c84d045dcc34faf5$var$CACHE.has(emoji)) return $c84d045dcc34faf5$var$CACHE.get(emoji);
  const supported = $c84d045dcc34faf5$var$isEmojiSupported(emoji);
  $c84d045dcc34faf5$var$CACHE.set(emoji, supported);
  return supported;
}
// https://github.com/koala-interactive/is-emoji-supported
const $c84d045dcc34faf5$var$isEmojiSupported = (() => {
  let ctx = null;
  try {
    if (!navigator.userAgent.includes("jsdom")) ctx = document.createElement("canvas").getContext("2d", {
      willReadFrequently: true
    });
  } catch {}
  // Not in browser env
  if (!ctx) return () => false;
  const CANVAS_HEIGHT = 25;
  const CANVAS_WIDTH = 20;
  const textSize = Math.floor(CANVAS_HEIGHT / 2);
  // Initialize convas context
  ctx.font = textSize + "px Arial, Sans-Serif";
  ctx.textBaseline = "top";
  ctx.canvas.width = CANVAS_WIDTH * 2;
  ctx.canvas.height = CANVAS_HEIGHT;
  return unicode => {
    ctx.clearRect(0, 0, CANVAS_WIDTH * 2, CANVAS_HEIGHT);
    // Draw in red on the left
    ctx.fillStyle = "#FF0000";
    ctx.fillText(unicode, 0, 22);
    // Draw in blue on right
    ctx.fillStyle = "#0000FF";
    ctx.fillText(unicode, CANVAS_WIDTH, 22);
    const a = ctx.getImageData(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT).data;
    const count = a.length;
    let i = 0;
    // Search the first visible pixel
    for (; i < count && !a[i + 3]; i += 4);
    // No visible pixel
    if (i >= count) return false;
    // Emoji has immutable color, so we check the color of the emoji in two different colors
    // the result show be the same.
    const x = CANVAS_WIDTH + i / 4 % CANVAS_WIDTH;
    const y = Math.floor(i / 4 / CANVAS_WIDTH);
    const b = ctx.getImageData(x, y, 1, 1).data;
    if (a[i] !== b[0] || a[i + 2] !== b[2]) return false;
    // Some emojis are a contraction of different ones, so if it's not
    // supported, it will show multiple characters
    if (ctx.measureText(unicode).width >= CANVAS_WIDTH) return false;
    // Supported
    return true;
  };
})();
var $c84d045dcc34faf5$export$2e2bcd8739ae039 = {
  latestVersion: $c84d045dcc34faf5$var$latestVersion,
  noCountryFlags: $c84d045dcc34faf5$var$noCountryFlags
};
const $b22cfd0a55410b4f$var$DEFAULTS = ["+1", "grinning", "kissing_heart", "heart_eyes", "laughing", "stuck_out_tongue_winking_eye", "sweat_smile", "joy", "scream", "disappointed", "unamused", "weary", "sob", "sunglasses", "heart"];
let $b22cfd0a55410b4f$var$Index = null;
function $b22cfd0a55410b4f$var$add(emoji) {
  $b22cfd0a55410b4f$var$Index || ($b22cfd0a55410b4f$var$Index = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("frequently") || {});
  const emojiId = emoji.id || emoji;
  if (!emojiId) return;
  $b22cfd0a55410b4f$var$Index[emojiId] || ($b22cfd0a55410b4f$var$Index[emojiId] = 0);
  $b22cfd0a55410b4f$var$Index[emojiId] += 1;
  ($f72b75cf796873c7$export$2e2bcd8739ae039).set("last", emojiId);
  ($f72b75cf796873c7$export$2e2bcd8739ae039).set("frequently", $b22cfd0a55410b4f$var$Index);
}
function $b22cfd0a55410b4f$var$get({
  maxFrequentRows: maxFrequentRows,
  perLine: perLine
}) {
  if (!maxFrequentRows) return [];
  $b22cfd0a55410b4f$var$Index || ($b22cfd0a55410b4f$var$Index = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("frequently"));
  let emojiIds = [];
  if (!$b22cfd0a55410b4f$var$Index) {
    $b22cfd0a55410b4f$var$Index = {};
    for (let i in $b22cfd0a55410b4f$var$DEFAULTS.slice(0, perLine)) {
      const emojiId = $b22cfd0a55410b4f$var$DEFAULTS[i];
      $b22cfd0a55410b4f$var$Index[emojiId] = perLine - i;
      emojiIds.push(emojiId);
    }
    return emojiIds;
  }
  const max = maxFrequentRows * perLine;
  const last = ($f72b75cf796873c7$export$2e2bcd8739ae039).get("last");
  for (let emojiId in $b22cfd0a55410b4f$var$Index) emojiIds.push(emojiId);
  emojiIds.sort((a, b) => {
    const aScore = $b22cfd0a55410b4f$var$Index[b];
    const bScore = $b22cfd0a55410b4f$var$Index[a];
    if (aScore == bScore) return a.localeCompare(b);
    return aScore - bScore;
  });
  if (emojiIds.length > max) {
    const removedIds = emojiIds.slice(max);
    emojiIds = emojiIds.slice(0, max);
    for (let removedId of removedIds) {
      if (removedId == last) continue;
      delete $b22cfd0a55410b4f$var$Index[removedId];
    }
    if (last && emojiIds.indexOf(last) == -1) {
      delete $b22cfd0a55410b4f$var$Index[emojiIds[emojiIds.length - 1]];
      emojiIds.splice(-1, 1, last);
    }
    ($f72b75cf796873c7$export$2e2bcd8739ae039).set("frequently", $b22cfd0a55410b4f$var$Index);
  }
  return emojiIds;
}
var $b22cfd0a55410b4f$export$2e2bcd8739ae039 = {
  add: $b22cfd0a55410b4f$var$add,
  get: $b22cfd0a55410b4f$var$get,
  DEFAULTS: $b22cfd0a55410b4f$var$DEFAULTS
};
var $8d50d93417ef682a$exports = {};
$8d50d93417ef682a$exports = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn\u2019t be found","pick":"Pick an emoji\u2026","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var $b247ea80b67298d5$export$2e2bcd8739ae039 = {
  autoFocus: {
    value: false
  },
  dynamicWidth: {
    value: false
  },
  emojiButtonColors: {
    value: null
  },
  emojiButtonRadius: {
    value: "100%"
  },
  emojiButtonSize: {
    value: 36
  },
  emojiSize: {
    value: 24
  },
  emojiVersion: {
    value: 14,
    choices: [1, 2, 3, 4, 5, 11, 12, 12.1, 13, 13.1, 14]
  },
  exceptEmojis: {
    value: []
  },
  icons: {
    value: "auto",
    choices: ["auto", "outline", "solid"]
  },
  locale: {
    value: "en",
    choices: ["en", "ar", "be", "cs", "de", "es", "fa", "fi", "fr", "hi", "it", "ja", "kr", "nl", "pl", "pt", "ru", "sa", "tr", "uk", "vi", "zh"]
  },
  maxFrequentRows: {
    value: 4
  },
  navPosition: {
    value: "top",
    choices: ["top", "bottom", "none"]
  },
  noCountryFlags: {
    value: false
  },
  noResultsEmoji: {
    value: null
  },
  perLine: {
    value: 9
  },
  previewEmoji: {
    value: null
  },
  previewPosition: {
    value: "bottom",
    choices: ["top", "bottom", "none"]
  },
  searchPosition: {
    value: "sticky",
    choices: ["sticky", "static", "none"]
  },
  set: {
    value: "native",
    choices: ["native", "apple", "facebook", "google", "twitter"]
  },
  skin: {
    value: 1,
    choices: [1, 2, 3, 4, 5, 6]
  },
  skinTonePosition: {
    value: "preview",
    choices: ["preview", "search", "none"]
  },
  theme: {
    value: "auto",
    choices: ["auto", "light", "dark"]
  },
  // Data
  categories: null,
  categoryIcons: null,
  custom: null,
  data: null,
  i18n: null,
  // Callbacks
  getImageURL: null,
  getSpritesheetURL: null,
  onAddCustomEmoji: null,
  onClickOutside: null,
  onEmojiSelect: null,
  // Deprecated
  stickySearch: {
    deprecated: true,
    value: true
  }
};
let $7adb23b0109cc36a$export$dbe3113d60765c1a = null;
let $7adb23b0109cc36a$export$2d0294657ab35f1b = null;
const $7adb23b0109cc36a$var$fetchCache = {};
async function $7adb23b0109cc36a$var$fetchJSON(src) {
  if ($7adb23b0109cc36a$var$fetchCache[src]) return $7adb23b0109cc36a$var$fetchCache[src];
  const response = await fetch(src);
  const json = await response.json();
  $7adb23b0109cc36a$var$fetchCache[src] = json;
  return json;
}
let $7adb23b0109cc36a$var$promise = null;
let $7adb23b0109cc36a$var$initCallback = null;
let $7adb23b0109cc36a$var$initialized = false;
function $7adb23b0109cc36a$export$2cd8252107eb640b(options, {
  caller: caller
} = {}) {
  $7adb23b0109cc36a$var$promise || ($7adb23b0109cc36a$var$promise = new Promise(resolve => {
    $7adb23b0109cc36a$var$initCallback = resolve;
  }));
  if (options) $7adb23b0109cc36a$var$_init(options);else if (caller && !$7adb23b0109cc36a$var$initialized) console.warn(`\`${caller}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`);
  return $7adb23b0109cc36a$var$promise;
}
async function $7adb23b0109cc36a$var$_init(props) {
  $7adb23b0109cc36a$var$initialized = true;
  let {
    emojiVersion: emojiVersion,
    set: set,
    locale: locale
  } = props;
  emojiVersion || (emojiVersion = ($b247ea80b67298d5$export$2e2bcd8739ae039).emojiVersion.value);
  set || (set = ($b247ea80b67298d5$export$2e2bcd8739ae039).set.value);
  locale || (locale = ($b247ea80b67298d5$export$2e2bcd8739ae039).locale.value);
  if (!$7adb23b0109cc36a$export$2d0294657ab35f1b) {
    $7adb23b0109cc36a$export$2d0294657ab35f1b = (typeof props.data === "function" ? await props.data() : props.data) || (await $7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${emojiVersion}/${set}.json`));
    $7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons = {};
    $7adb23b0109cc36a$export$2d0294657ab35f1b.natives = {};
    $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.unshift({
      id: "frequent",
      emojis: []
    });
    for (const alias in $7adb23b0109cc36a$export$2d0294657ab35f1b.aliases) {
      const emojiId = $7adb23b0109cc36a$export$2d0294657ab35f1b.aliases[alias];
      const emoji = $7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emojiId];
      if (!emoji) continue;
      emoji.aliases || (emoji.aliases = []);
      emoji.aliases.push(alias);
    }
    $7adb23b0109cc36a$export$2d0294657ab35f1b.originalCategories = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories;
  } else $7adb23b0109cc36a$export$2d0294657ab35f1b.categories = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.filter(c => {
    const isCustom = !!c.name;
    if (!isCustom) return true;
    return false;
  });
  $7adb23b0109cc36a$export$dbe3113d60765c1a = (typeof props.i18n === "function" ? await props.i18n() : props.i18n) || (locale == "en" ? (/*@__PURE__*/$parcel$interopDefault($8d50d93417ef682a$exports)) : await $7adb23b0109cc36a$var$fetchJSON(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${locale}.json`));
  if (props.custom) for (let i in props.custom) {
    i = parseInt(i);
    const category = props.custom[i];
    const prevCategory = props.custom[i - 1];
    if (!category.emojis || !category.emojis.length) continue;
    category.id || (category.id = `custom_${i + 1}`);
    category.name || (category.name = $7adb23b0109cc36a$export$dbe3113d60765c1a.categories.custom);
    if (prevCategory && !category.icon) category.target = prevCategory.target || prevCategory;
    $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.push(category);
    for (const emoji of category.emojis) $7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emoji.id] = emoji;
  }
  if (props.categories) $7adb23b0109cc36a$export$2d0294657ab35f1b.categories = $7adb23b0109cc36a$export$2d0294657ab35f1b.originalCategories.filter(c => {
    return props.categories.indexOf(c.id) != -1;
  }).sort((c1, c2) => {
    const i1 = props.categories.indexOf(c1.id);
    const i2 = props.categories.indexOf(c2.id);
    return i1 - i2;
  });
  let latestVersionSupport = null;
  let noCountryFlags = null;
  if (set == "native") {
    latestVersionSupport = ($c84d045dcc34faf5$export$2e2bcd8739ae039).latestVersion();
    noCountryFlags = props.noCountryFlags || ($c84d045dcc34faf5$export$2e2bcd8739ae039).noCountryFlags();
  }
  let categoryIndex = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.length;
  let resetSearchIndex = false;
  while (categoryIndex--) {
    const category = $7adb23b0109cc36a$export$2d0294657ab35f1b.categories[categoryIndex];
    if (category.id == "frequent") {
      let {
        maxFrequentRows: maxFrequentRows,
        perLine: perLine
      } = props;
      maxFrequentRows = maxFrequentRows >= 0 ? maxFrequentRows : ($b247ea80b67298d5$export$2e2bcd8739ae039).maxFrequentRows.value;
      perLine || (perLine = ($b247ea80b67298d5$export$2e2bcd8739ae039).perLine.value);
      category.emojis = ($b22cfd0a55410b4f$export$2e2bcd8739ae039).get({
        maxFrequentRows: maxFrequentRows,
        perLine: perLine
      });
    }
    if (!category.emojis || !category.emojis.length) {
      $7adb23b0109cc36a$export$2d0294657ab35f1b.categories.splice(categoryIndex, 1);
      continue;
    }
    const {
      categoryIcons: categoryIcons
    } = props;
    if (categoryIcons) {
      const icon = categoryIcons[category.id];
      if (icon && !category.icon) category.icon = icon;
    }
    let emojiIndex = category.emojis.length;
    while (emojiIndex--) {
      const emojiId = category.emojis[emojiIndex];
      const emoji = emojiId.id ? emojiId : $7adb23b0109cc36a$export$2d0294657ab35f1b.emojis[emojiId];
      const ignore = () => {
        category.emojis.splice(emojiIndex, 1);
      };
      if (!emoji || props.exceptEmojis && props.exceptEmojis.includes(emoji.id)) {
        ignore();
        continue;
      }
      if (latestVersionSupport && emoji.version > latestVersionSupport) {
        ignore();
        continue;
      }
      if (noCountryFlags && category.id == "flags") {
        if (!($e6eae5155b87f591$export$bcb25aa587e9cb13).includes(emoji.id)) {
          ignore();
          continue;
        }
      }
      if (!emoji.search) {
        resetSearchIndex = true;
        emoji.search = "," + [[emoji.id, false], [emoji.name, true], [emoji.keywords, false], [emoji.emoticons, false]].map(([strings, split]) => {
          if (!strings) return;
          return (Array.isArray(strings) ? strings : [strings]).map(string => {
            return (split ? string.split(/[-|_|\s]+/) : [string]).map(s => s.toLowerCase());
          }).flat();
        }).flat().filter(a => a && a.trim()).join(",");
        if (emoji.emoticons) for (const emoticon of emoji.emoticons) {
          if ($7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons[emoticon]) continue;
          $7adb23b0109cc36a$export$2d0294657ab35f1b.emoticons[emoticon] = emoji.id;
        }
        let skinIndex = 0;
        for (const skin of emoji.skins) {
          if (!skin) continue;
          skinIndex++;
          const {
            native: native
          } = skin;
          if (native) {
            $7adb23b0109cc36a$export$2d0294657ab35f1b.natives[native] = emoji.id;
            emoji.search += `,${native}`;
          }
          const skinShortcodes = skinIndex == 1 ? "" : `:skin-tone-${skinIndex}:`;
          skin.shortcodes = `:${emoji.id}:${skinShortcodes}`;
        }
      }
    }
  }
  if (resetSearchIndex) ($c4d155af13ad4d4b$export$2e2bcd8739ae039).reset();
  $7adb23b0109cc36a$var$initCallback();
}
function $7adb23b0109cc36a$export$75fe5f91d452f94b(props, defaultProps, element) {
  props || (props = {});
  const _props = {};
  for (let k in defaultProps) _props[k] = $7adb23b0109cc36a$export$88c9ddb45cea7241(k, props, defaultProps, element);
  return _props;
}
function $7adb23b0109cc36a$export$88c9ddb45cea7241(propName, props, defaultProps, element) {
  const defaults = defaultProps[propName];
  let value = element && element.getAttribute(propName) || (props[propName] != null && props[propName] != undefined ? props[propName] : null);
  if (!defaults) return value;
  if (value != null && defaults.value && typeof defaults.value != typeof value) {
    if (typeof defaults.value == "boolean") value = value == "false" ? false : true;else value = defaults.value.constructor(value);
  }
  if (defaults.transform && value) value = defaults.transform(value);
  if (value == null || defaults.choices && defaults.choices.indexOf(value) == -1) value = defaults.value;
  return value;
}
const $c4d155af13ad4d4b$var$SHORTCODES_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let $c4d155af13ad4d4b$var$Pool = null;
function $c4d155af13ad4d4b$var$get(emojiId) {
  if (emojiId.id) return emojiId;
  return ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[emojiId] || ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[($7adb23b0109cc36a$export$2d0294657ab35f1b).aliases[emojiId]] || ($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis[($7adb23b0109cc36a$export$2d0294657ab35f1b).natives[emojiId]];
}
function $c4d155af13ad4d4b$var$reset() {
  $c4d155af13ad4d4b$var$Pool = null;
}
async function $c4d155af13ad4d4b$var$search(value, {
  maxResults: maxResults,
  caller: caller
} = {}) {
  if (!value || !value.trim().length) return null;
  maxResults || (maxResults = 90);
  await ($7adb23b0109cc36a$export$2cd8252107eb640b)(null, {
    caller: caller || "SearchIndex.search"
  });
  const values = value.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((word, i, words) => {
    return word.trim() && words.indexOf(word) == i;
  });
  if (!values.length) return;
  let pool = $c4d155af13ad4d4b$var$Pool || ($c4d155af13ad4d4b$var$Pool = Object.values(($7adb23b0109cc36a$export$2d0294657ab35f1b).emojis));
  let results, scores;
  for (const value1 of values) {
    if (!pool.length) break;
    results = [];
    scores = {};
    for (const emoji of pool) {
      if (!emoji.search) continue;
      const score = emoji.search.indexOf(`,${value1}`);
      if (score == -1) continue;
      results.push(emoji);
      scores[emoji.id] || (scores[emoji.id] = 0);
      scores[emoji.id] += emoji.id == value1 ? 0 : score + 1;
    }
    pool = results;
  }
  if (results.length < 2) return results;
  results.sort((a, b) => {
    const aScore = scores[a.id];
    const bScore = scores[b.id];
    if (aScore == bScore) return a.id.localeCompare(b.id);
    return aScore - bScore;
  });
  if (results.length > maxResults) results = results.slice(0, maxResults);
  return results;
}
var $c4d155af13ad4d4b$export$2e2bcd8739ae039 = {
  search: $c4d155af13ad4d4b$var$search,
  get: $c4d155af13ad4d4b$var$get,
  reset: $c4d155af13ad4d4b$var$reset,
  SHORTCODES_REGEX: $c4d155af13ad4d4b$var$SHORTCODES_REGEX
};
const $e6eae5155b87f591$export$bcb25aa587e9cb13 = ["checkered_flag", "crossed_flags", "pirate_flag", "rainbow-flag", "transgender_flag", "triangular_flag_on_post", "waving_black_flag", "waving_white_flag"];
function $693b183b0a78708f$export$9cb4719e2e525b7a(a, b) {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val == b[index]);
}
async function $693b183b0a78708f$export$e772c8ff12451969(frames = 1) {
  for (let _ in [...Array(frames).keys()]) await new Promise(requestAnimationFrame);
}
function $693b183b0a78708f$export$d10ac59fbe52a745(emoji, {
  skinIndex = 0
} = {}) {
  const skin = emoji.skins[skinIndex] || (() => {
    skinIndex = 0;
    return emoji.skins[skinIndex];
  })();
  const emojiData = {
    id: emoji.id,
    name: emoji.name,
    native: skin.native,
    unified: skin.unified,
    keywords: emoji.keywords,
    shortcodes: skin.shortcodes || emoji.shortcodes
  };
  if (emoji.skins.length > 1) emojiData.skin = skinIndex + 1;
  if (skin.src) emojiData.src = skin.src;
  if (emoji.aliases && emoji.aliases.length) emojiData.aliases = emoji.aliases;
  if (emoji.emoticons && emoji.emoticons.length) emojiData.emoticons = emoji.emoticons;
  return emojiData;
}
const $fcccfb36ed0cde68$var$categories = {
  activity: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
      })
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
      })
    })
  },
  custom: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
      d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
    })
  }),
  flags: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
      })
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
      })
    })
  },
  foods: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
      })
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
      })
    })
  },
  frequent: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
      })]
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
      })
    })
  },
  nature: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
      })]
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
      })
    })
  },
  objects: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
      })]
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
      })
    })
  },
  people: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
      })]
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
      })
    })
  },
  places: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
      })]
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
      })
    })
  },
  symbols: {
    outline: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
      })
    }),
    solid: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
        d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
      })
    })
  }
};
const $fcccfb36ed0cde68$var$search = {
  loupe: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    })
  }),
  delete: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    })
  })
};
var $fcccfb36ed0cde68$export$2e2bcd8739ae039 = {
  categories: $fcccfb36ed0cde68$var$categories,
  search: $fcccfb36ed0cde68$var$search
};
function $254755d3f438722f$export$2e2bcd8739ae039(props) {
  let {
    id: id,
    skin: skin,
    emoji: emoji
  } = props;
  if (props.shortcodes) {
    const matches = props.shortcodes.match(($c4d155af13ad4d4b$export$2e2bcd8739ae039).SHORTCODES_REGEX);
    if (matches) {
      id = matches[1];
      if (matches[2]) skin = matches[2];
    }
  }
  emoji || (emoji = ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(id || props.native));
  if (!emoji) return props.fallback;
  const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
  const imageSrc = emojiSkin.src || (props.set != "native" && !props.spritesheet ? typeof props.getImageURL === "function" ? props.getImageURL(props.set, emojiSkin.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@14.0.0/img/${props.set}/64/${emojiSkin.unified}.png` : undefined);
  const spritesheetSrc = typeof props.getSpritesheetURL === "function" ? props.getSpritesheetURL(props.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${props.set}@14.0.0/img/${props.set}/sheets-256/64.png`;
  return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
    class: "emoji-mart-emoji",
    "data-emoji-set": props.set,
    children: imageSrc ? /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("img", {
      style: {
        maxWidth: props.size || "1em",
        maxHeight: props.size || "1em",
        display: "inline-block"
      },
      alt: emojiSkin.native || emojiSkin.shortcodes,
      src: imageSrc
    }) : props.set == "native" ? /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
      style: {
        fontSize: props.size,
        fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
      },
      children: emojiSkin.native
    }) : /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
      style: {
        display: "block",
        width: props.size,
        height: props.size,
        backgroundImage: `url(${spritesheetSrc})`,
        backgroundSize: `${100 * ($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.cols}% ${100 * ($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.rows}%`,
        backgroundPosition: `${100 / (($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.cols - 1) * emojiSkin.x}% ${100 / (($7adb23b0109cc36a$export$2d0294657ab35f1b).sheet.rows - 1) * emojiSkin.y}%`
      }
    })
  });
}
const $6f57cc9cd54c5aaa$var$WindowHTMLElement = typeof window !== "undefined" && window.HTMLElement ? window.HTMLElement : Object;
class $6f57cc9cd54c5aaa$export$2e2bcd8739ae039 extends $6f57cc9cd54c5aaa$var$WindowHTMLElement {
  static get observedAttributes() {
    return Object.keys(this.Props);
  }
  update(props = {}) {
    for (let k in props) this.attributeChangedCallback(k, null, props[k]);
  }
  attributeChangedCallback(attr, _, newValue) {
    if (!this.component) return;
    const value = ($7adb23b0109cc36a$export$88c9ddb45cea7241)(attr, {
      [attr]: newValue
    }, this.constructor.Props, this);
    if (this.component.componentWillReceiveProps) this.component.componentWillReceiveProps({
      [attr]: value
    });else {
      this.component.props[attr] = value;
      this.component.forceUpdate();
    }
  }
  disconnectedCallback() {
    this.disconnected = true;
    if (this.component && this.component.unregister) this.component.unregister();
  }
  constructor(props = {}) {
    super();
    this.props = props;
    if (props.parent || props.ref) {
      let ref = null;
      const parent = props.parent || (ref = props.ref && props.ref.current);
      if (ref) ref.innerHTML = "";
      if (parent) parent.appendChild(this);
    }
  }
}
class $26f27c338a96b1a6$export$2e2bcd8739ae039 extends ($6f57cc9cd54c5aaa$export$2e2bcd8739ae039) {
  setShadow() {
    this.attachShadow({
      mode: "open"
    });
  }
  injectStyles(styles) {
    if (!styles) return;
    const style = document.createElement("style");
    style.textContent = styles;
    this.shadowRoot.insertBefore(style, this.shadowRoot.firstChild);
  }
  constructor(props, {
    styles: styles
  } = {}) {
    super(props);
    this.setShadow();
    this.injectStyles(styles);
  }
}
var $3d90f6e46fb2dd47$export$2e2bcd8739ae039 = {
  fallback: "",
  id: "",
  native: "",
  shortcodes: "",
  size: {
    value: "",
    transform: value => {
      // If the value is a number, then we assume it’s a pixel value.
      if (!/\D/.test(value)) return `${value}px`;
      return value;
    }
  },
  // Shared
  set: ($b247ea80b67298d5$export$2e2bcd8739ae039).set,
  skin: ($b247ea80b67298d5$export$2e2bcd8739ae039).skin
};
class $331b4160623139bf$export$2e2bcd8739ae039 extends ($6f57cc9cd54c5aaa$export$2e2bcd8739ae039) {
  async connectedCallback() {
    const props = ($7adb23b0109cc36a$export$75fe5f91d452f94b)(this.props, ($3d90f6e46fb2dd47$export$2e2bcd8739ae039), this);
    props.element = this;
    props.ref = component => {
      this.component = component;
    };
    await ($7adb23b0109cc36a$export$2cd8252107eb640b)();
    if (this.disconnected) return;
    ($fb96b826c0c5f37a$export$b3890eb0ae9dca99)( /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
      ...props
    }), this);
  }
  constructor(props) {
    super(props);
  }
}
($c770c458706daa72$export$2e2bcd8739ae039)($331b4160623139bf$export$2e2bcd8739ae039, "Props", ($3d90f6e46fb2dd47$export$2e2bcd8739ae039));
if (typeof customElements !== "undefined" && !customElements.get("em-emoji")) customElements.define("em-emoji", $331b4160623139bf$export$2e2bcd8739ae039);
var $1a9a8ef576b7773d$var$r,
  $1a9a8ef576b7773d$var$i = [],
  $1a9a8ef576b7773d$var$c = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b,
  $1a9a8ef576b7773d$var$f = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r,
  $1a9a8ef576b7773d$var$e = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).diffed,
  $1a9a8ef576b7773d$var$a = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__c,
  $1a9a8ef576b7773d$var$v = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount;
function $1a9a8ef576b7773d$var$x() {
  var t6;
  for ($1a9a8ef576b7773d$var$i.sort(function (n11, t7) {
    return n11.__v.__b - t7.__v.__b;
  }); t6 = $1a9a8ef576b7773d$var$i.pop();) if (t6.__P) try {
    t6.__H.__h.forEach($1a9a8ef576b7773d$var$g), t6.__H.__h.forEach($1a9a8ef576b7773d$var$j), t6.__H.__h = [];
  } catch (u4) {
    t6.__H.__h = [], ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(u4, t6.__v);
  }
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b = function (n12) {
  $1a9a8ef576b7773d$var$c && $1a9a8ef576b7773d$var$c(n12);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r = function (n13) {
  $1a9a8ef576b7773d$var$f && $1a9a8ef576b7773d$var$f(n13);
  var r8 = (n13.__c).__H;
  r8 && (r8.__h.forEach($1a9a8ef576b7773d$var$g), r8.__h.forEach($1a9a8ef576b7773d$var$j), r8.__h = []);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).diffed = function (t8) {
  $1a9a8ef576b7773d$var$e && $1a9a8ef576b7773d$var$e(t8);
  var o6 = t8.__c;
  o6 && o6.__H && o6.__H.__h.length && (1 !== $1a9a8ef576b7773d$var$i.push(o6) && $1a9a8ef576b7773d$var$r === ($fb96b826c0c5f37a$export$41c562ebe57d11e2).requestAnimationFrame || (($1a9a8ef576b7773d$var$r = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).requestAnimationFrame) || function (n14) {
    var t9,
      u5 = function () {
        clearTimeout(r9), $1a9a8ef576b7773d$var$b && cancelAnimationFrame(t9), setTimeout(n14);
      },
      r9 = setTimeout(u5, 100);
    $1a9a8ef576b7773d$var$b && (t9 = requestAnimationFrame(u5));
  })($1a9a8ef576b7773d$var$x));
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__c = function (t10, u6) {
  u6.some(function (t11) {
    try {
      t11.__h.forEach($1a9a8ef576b7773d$var$g), t11.__h = t11.__h.filter(function (n15) {
        return !n15.__ || $1a9a8ef576b7773d$var$j(n15);
      });
    } catch (r10) {
      u6.some(function (n16) {
        n16.__h && (n16.__h = []);
      }), u6 = [], ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(r10, t11.__v);
    }
  }), $1a9a8ef576b7773d$var$a && $1a9a8ef576b7773d$var$a(t10, u6);
}, ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount = function (t12) {
  $1a9a8ef576b7773d$var$v && $1a9a8ef576b7773d$var$v(t12);
  var u7,
    r11 = t12.__c;
  r11 && r11.__H && (r11.__H.__.forEach(function (n17) {
    try {
      $1a9a8ef576b7773d$var$g(n17);
    } catch (n18) {
      u7 = n18;
    }
  }), u7 && ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e(u7, r11.__v));
};
var $1a9a8ef576b7773d$var$b = "function" == typeof requestAnimationFrame;
function $1a9a8ef576b7773d$var$g(n19) {
  var r12 = n19.__c;
  "function" == typeof r12 && (n19.__c = void 0, r12());
}
function $1a9a8ef576b7773d$var$j(n20) {
  n20.__c = n20.__();
}
function $dc040a17866866fa$var$S(n1, t1) {
  for (var e1 in t1) n1[e1] = t1[e1];
  return n1;
}
function $dc040a17866866fa$var$C(n2, t2) {
  for (var e2 in n2) if ("__source" !== e2 && !(e2 in t2)) return !0;
  for (var r1 in t2) if ("__source" !== r1 && n2[r1] !== t2[r1]) return !0;
  return !1;
}
function $dc040a17866866fa$export$221d75b3f55bb0bd(n3) {
  this.props = n3;
}
($dc040a17866866fa$export$221d75b3f55bb0bd.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)()).isPureReactComponent = !0, $dc040a17866866fa$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function (n6, t5) {
  return $dc040a17866866fa$var$C(this.props, n6) || $dc040a17866866fa$var$C(this.state, t5);
};
var $dc040a17866866fa$var$w = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__b = function (n7) {
  n7.type && n7.type.__f && n7.ref && (n7.props.ref = n7.ref, n7.ref = null), $dc040a17866866fa$var$w && $dc040a17866866fa$var$w(n7);
};
var $dc040a17866866fa$var$A = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__e = function (n12, t10, e6) {
  if (n12.then) {
    for (var r5, u1 = t10; u1 = u1.__;) if ((r5 = u1.__c) && r5.__c) return null == t10.__e && (t10.__e = e6.__e, t10.__k = e6.__k), r5.__c(n12, t10);
  }
  $dc040a17866866fa$var$A(n12, t10, e6);
};
var $dc040a17866866fa$var$O = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount;
function $dc040a17866866fa$export$74bf444e3cd11ea5() {
  this.__u = 0, this.t = null, this.__b = null;
}
function $dc040a17866866fa$var$U(n13) {
  var t11 = n13.__.__c;
  return t11 && t11.__e && t11.__e(n13);
}
function $dc040a17866866fa$export$998bcd577473dd93() {
  this.u = null, this.o = null;
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).unmount = function (n17) {
  var t13 = n17.__c;
  t13 && t13.__R && t13.__R(), t13 && !0 === n17.__h && (n17.type = null), $dc040a17866866fa$var$O && $dc040a17866866fa$var$O(n17);
}, ($dc040a17866866fa$export$74bf444e3cd11ea5.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)()).__c = function (n18, t14) {
  var e8 = t14.__c,
    r7 = this;
  null == r7.t && (r7.t = []), r7.t.push(e8);
  var u4 = $dc040a17866866fa$var$U(r7.__v),
    o1 = !1,
    i1 = function () {
      o1 || (o1 = !0, e8.__R = null, u4 ? u4(l1) : l1());
    };
  e8.__R = i1;
  var l1 = function () {
      if (! --r7.__u) {
        if (r7.state.__e) {
          var n19 = r7.state.__e;
          r7.__v.__k[0] = function n22(t17, e9, r8) {
            return t17 && (t17.__v = null, t17.__k = t17.__k && t17.__k.map(function (t18) {
              return n22(t18, e9, r8);
            }), t17.__c && t17.__c.__P === e9 && (t17.__e && r8.insertBefore(t17.__e, t17.__d), t17.__c.__e = !0, t17.__c.__P = r8)), t17;
          }(n19, n19.__c.__P, n19.__c.__O);
        }
        var t15;
        for (r7.setState({
          __e: r7.__b = null
        }); t15 = r7.t.pop();) t15.forceUpdate();
      }
    },
    c1 = !0 === t14.__h;
  r7.__u++ || c1 || r7.setState({
    __e: r7.__b = r7.__v.__k[0]
  }), n18.then(i1, i1);
}, $dc040a17866866fa$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function () {
  this.t = [];
}, $dc040a17866866fa$export$74bf444e3cd11ea5.prototype.render = function (n23, t19) {
  if (this.__b) {
    if (this.__v.__k) {
      var e10 = document.createElement("div"),
        r9 = this.__v.__k[0].__c;
      this.__v.__k[0] = function n24(t20, e13, r12) {
        return t20 && (t20.__c && t20.__c.__H && (t20.__c.__H.__.forEach(function (n25) {
          "function" == typeof n25.__c && n25.__c();
        }), t20.__c.__H = null), null != (t20 = $dc040a17866866fa$var$S({}, t20)).__c && (t20.__c.__P === r12 && (t20.__c.__P = e13), t20.__c = null), t20.__k = t20.__k && t20.__k.map(function (t21) {
          return n24(t21, e13, r12);
        })), t20;
      }(this.__b, e10, r9.__O = r9.__P);
    }
    this.__b = null;
  }
  var u5 = t19.__e && ($fb96b826c0c5f37a$export$c8a8987d4410bf2d)(($fb96b826c0c5f37a$export$ffb0004e005737fa), null, n23.fallback);
  return u5 && (u5.__h = null), [($fb96b826c0c5f37a$export$c8a8987d4410bf2d)(($fb96b826c0c5f37a$export$ffb0004e005737fa), null, t19.__e ? null : n23.children), u5];
};
var $dc040a17866866fa$var$T = function (n26, t22, e14) {
  if (++e14[1] === e14[0] && n26.o.delete(t22), n26.props.revealOrder && ("t" !== n26.props.revealOrder[0] || !n26.o.size)) for (e14 = n26.u; e14;) {
    for (; e14.length > 3;) e14.pop()();
    if (e14[1] < e14[0]) break;
    n26.u = e14 = e14[2];
  }
};
($dc040a17866866fa$export$998bcd577473dd93.prototype = new ($fb96b826c0c5f37a$export$16fa2f45be04daa8)()).__e = function (n33) {
  var t25 = this,
    e16 = $dc040a17866866fa$var$U(t25.__v),
    r13 = t25.o.get(n33);
  return r13[0]++, function (u6) {
    var o2 = function () {
      t25.props.revealOrder ? (r13.push(u6), $dc040a17866866fa$var$T(t25, n33, r13)) : u6();
    };
    e16 ? e16(o2) : o2();
  };
}, $dc040a17866866fa$export$998bcd577473dd93.prototype.render = function (n34) {
  this.u = null, this.o = new Map();
  var t26 = ($fb96b826c0c5f37a$export$47e4c5b300681277)(n34.children);
  n34.revealOrder && "b" === n34.revealOrder[0] && t26.reverse();
  for (var e17 = t26.length; e17--;) this.o.set(t26[e17], this.u = [1, 0, this.u]);
  return n34.children;
}, $dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidUpdate = $dc040a17866866fa$export$998bcd577473dd93.prototype.componentDidMount = function () {
  var n35 = this;
  this.o.forEach(function (t27, e18) {
    $dc040a17866866fa$var$T(n35, e18, t27);
  });
};
var $dc040a17866866fa$var$j = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
  $dc040a17866866fa$var$P = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
  $dc040a17866866fa$var$V = "undefined" != typeof document,
  $dc040a17866866fa$var$z = function (n36) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n36);
  };
($fb96b826c0c5f37a$export$16fa2f45be04daa8).prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (n39) {
  Object.defineProperty(($fb96b826c0c5f37a$export$16fa2f45be04daa8).prototype, n39, {
    configurable: !0,
    get: function () {
      return this["UNSAFE_" + n39];
    },
    set: function (t30) {
      Object.defineProperty(this, n39, {
        configurable: !0,
        writable: !0,
        value: t30
      });
    }
  });
});
var $dc040a17866866fa$var$H = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).event;
function $dc040a17866866fa$var$Z() {}
function $dc040a17866866fa$var$Y() {
  return this.cancelBubble;
}
function $dc040a17866866fa$var$q() {
  return this.defaultPrevented;
}
($fb96b826c0c5f37a$export$41c562ebe57d11e2).event = function (n40) {
  return $dc040a17866866fa$var$H && (n40 = $dc040a17866866fa$var$H(n40)), n40.persist = $dc040a17866866fa$var$Z, n40.isPropagationStopped = $dc040a17866866fa$var$Y, n40.isDefaultPrevented = $dc040a17866866fa$var$q, n40.nativeEvent = n40;
};
var $dc040a17866866fa$var$J = {
    configurable: !0,
    get: function () {
      return this.class;
    }
  },
  $dc040a17866866fa$var$K = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).vnode = function (n41) {
  var t31 = n41.type,
    e21 = n41.props,
    r14 = e21;
  if ("string" == typeof t31) {
    var u7 = -1 === t31.indexOf("-");
    for (var o3 in r14 = {}, e21) {
      var i2 = e21[o3];
      $dc040a17866866fa$var$V && "children" === o3 && "noscript" === t31 || "value" === o3 && "defaultValue" in e21 && null == i2 || ("defaultValue" === o3 && "value" in e21 && null == e21.value ? o3 = "value" : "download" === o3 && !0 === i2 ? i2 = "" : /ondoubleclick/i.test(o3) ? o3 = "ondblclick" : /^onchange(textarea|input)/i.test(o3 + t31) && !$dc040a17866866fa$var$z(e21.type) ? o3 = "oninput" : /^onfocus$/i.test(o3) ? o3 = "onfocusin" : /^onblur$/i.test(o3) ? o3 = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(o3) ? o3 = o3.toLowerCase() : u7 && $dc040a17866866fa$var$P.test(o3) ? o3 = o3.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i2 && (i2 = void 0), r14[o3] = i2);
    }
    "select" == t31 && r14.multiple && Array.isArray(r14.value) && (r14.value = ($fb96b826c0c5f37a$export$47e4c5b300681277)(e21.children).forEach(function (n42) {
      n42.props.selected = -1 != r14.value.indexOf(n42.props.value);
    })), "select" == t31 && null != r14.defaultValue && (r14.value = ($fb96b826c0c5f37a$export$47e4c5b300681277)(e21.children).forEach(function (n43) {
      n43.props.selected = r14.multiple ? -1 != r14.defaultValue.indexOf(n43.props.value) : r14.defaultValue == n43.props.value;
    })), n41.props = r14, e21.class != e21.className && ($dc040a17866866fa$var$J.enumerable = "className" in e21, null != e21.className && (r14.class = e21.className), Object.defineProperty(r14, "className", $dc040a17866866fa$var$J));
  }
  n41.$$typeof = $dc040a17866866fa$var$j, $dc040a17866866fa$var$K && $dc040a17866866fa$var$K(n41);
};
var $dc040a17866866fa$var$Q = ($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r;
($fb96b826c0c5f37a$export$41c562ebe57d11e2).__r = function (n44) {
  $dc040a17866866fa$var$Q && $dc040a17866866fa$var$Q(n44), n44.__c;
};
const $ec8c39fdad15601a$var$THEME_ICONS = {
  light: "outline",
  dark: "solid"
};
class $ec8c39fdad15601a$export$2e2bcd8739ae039 extends ($dc040a17866866fa$export$221d75b3f55bb0bd) {
  renderIcon(category) {
    const {
      icon: icon
    } = category;
    if (icon) {
      if (icon.svg) return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
        class: "flex",
        dangerouslySetInnerHTML: {
          __html: icon.svg
        }
      });
      if (icon.src) return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("img", {
        src: icon.src
      });
    }
    const categoryIcons = ($fcccfb36ed0cde68$export$2e2bcd8739ae039).categories[category.id] || ($fcccfb36ed0cde68$export$2e2bcd8739ae039).categories.custom;
    const style = this.props.icons == "auto" ? $ec8c39fdad15601a$var$THEME_ICONS[this.props.theme] : this.props.icons;
    return categoryIcons[style] || categoryIcons;
  }
  render() {
    let selectedCategoryIndex = null;
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("nav", {
      id: "nav",
      class: "padding",
      "data-position": this.props.position,
      dir: this.props.dir,
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: "flex relative",
        children: [this.categories.map((category, i) => {
          const title = category.name || ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories[category.id];
          const selected = !this.props.unfocused && category.id == this.state.categoryId;
          if (selected) selectedCategoryIndex = i;
          return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
            "aria-label": title,
            "aria-selected": selected || undefined,
            title: title,
            type: "button",
            class: "flex flex-grow flex-center",
            onMouseDown: e => e.preventDefault(),
            onClick: () => {
              this.props.onClick({
                category: category,
                i: i
              });
            },
            children: this.renderIcon(category)
          });
        }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          class: "bar",
          style: {
            width: `${100 / this.categories.length}%`,
            opacity: selectedCategoryIndex == null ? 0 : 1,
            transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${selectedCategoryIndex * 100}%)` : `translateX(${selectedCategoryIndex * 100}%)`
          }
        })]
      })
    });
  }
  constructor() {
    super();
    this.categories = ($7adb23b0109cc36a$export$2d0294657ab35f1b).categories.filter(category => {
      return !category.target;
    });
    this.state = {
      categoryId: this.categories[0].id
    };
  }
}
class $e0d4dda61265ff1e$export$2e2bcd8739ae039 extends ($dc040a17866866fa$export$221d75b3f55bb0bd) {
  shouldComponentUpdate(nextProps) {
    for (let k in nextProps) {
      if (k == "children") continue;
      if (nextProps[k] != this.props[k]) return true;
    }
    return false;
  }
  render() {
    return this.props.children;
  }
}
const $89bd6bb200cc8fef$var$Performance = {
  rowsPerRender: 10
};
class $89bd6bb200cc8fef$export$2e2bcd8739ae039 extends ($fb96b826c0c5f37a$export$16fa2f45be04daa8) {
  getInitialState(props = this.props) {
    return {
      skin: ($f72b75cf796873c7$export$2e2bcd8739ae039).get("skin") || props.skin,
      theme: this.initTheme(props.theme)
    };
  }
  componentWillMount() {
    this.dir = ($7adb23b0109cc36a$export$dbe3113d60765c1a).rtl ? "rtl" : "ltr";
    this.refs = {
      menu: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      navigation: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      scroll: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      search: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      searchInput: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      skinToneButton: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
      skinToneRadio: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)()
    };
    this.initGrid();
    if (this.props.stickySearch == false && this.props.searchPosition == "sticky") {
      console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`.");
      this.props.searchPosition = "static";
    }
  }
  componentDidMount() {
    this.register();
    this.shadowRoot = this.base.parentNode;
    if (this.props.autoFocus) {
      const {
        searchInput: searchInput
      } = this.refs;
      if (searchInput.current) searchInput.current.focus();
    }
  }
  componentWillReceiveProps(nextProps) {
    this.nextState || (this.nextState = {});
    for (const k1 in nextProps) this.nextState[k1] = nextProps[k1];
    clearTimeout(this.nextStateTimer);
    this.nextStateTimer = setTimeout(() => {
      let requiresGridReset = false;
      for (const k in this.nextState) {
        this.props[k] = this.nextState[k];
        if (k === "custom" || k === "categories") requiresGridReset = true;
      }
      delete this.nextState;
      const nextState = this.getInitialState();
      if (requiresGridReset) return this.reset(nextState);
      this.setState(nextState);
    });
  }
  componentWillUnmount() {
    this.unregister();
  }
  async reset(nextState = {}) {
    await ($7adb23b0109cc36a$export$2cd8252107eb640b)(this.props);
    this.initGrid();
    this.unobserve();
    this.setState(nextState, () => {
      this.observeCategories();
      this.observeRows();
    });
  }
  register() {
    document.addEventListener("click", this.handleClickOutside);
    this.observe();
  }
  unregister() {
    document.removeEventListener("click", this.handleClickOutside);
    this.unobserve();
  }
  observe() {
    this.observeCategories();
    this.observeRows();
  }
  unobserve({
    except = []
  } = {}) {
    if (!Array.isArray(except)) except = [except];
    for (const observer of this.observers) {
      if (except.includes(observer)) continue;
      observer.disconnect();
    }
    this.observers = [].concat(except);
  }
  initGrid() {
    const {
      categories: categories
    } = ($7adb23b0109cc36a$export$2d0294657ab35f1b);
    this.refs.categories = new Map();
    const navKey = ($7adb23b0109cc36a$export$2d0294657ab35f1b).categories.map(category => category.id).join(",");
    if (this.navKey && this.navKey != navKey) this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
    this.navKey = navKey;
    this.grid = [];
    this.grid.setsize = 0;
    const addRow = (rows, category) => {
      const row = [];
      row.__categoryId = category.id;
      row.__index = rows.length;
      this.grid.push(row);
      const rowIndex = this.grid.length - 1;
      const rowRef = rowIndex % $89bd6bb200cc8fef$var$Performance.rowsPerRender ? {} : ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)();
      rowRef.index = rowIndex;
      rowRef.posinset = this.grid.setsize + 1;
      rows.push(rowRef);
      return row;
    };
    for (let category1 of categories) {
      const rows = [];
      let row = addRow(rows, category1);
      for (let emoji of category1.emojis) {
        if (row.length == this.getPerLine()) row = addRow(rows, category1);
        this.grid.setsize += 1;
        row.push(emoji);
      }
      this.refs.categories.set(category1.id, {
        root: ($fb96b826c0c5f37a$export$7d1e3a5e95ceca43)(),
        rows: rows
      });
    }
  }
  initTheme(theme) {
    if (theme != "auto") return theme;
    if (!this.darkMedia) {
      this.darkMedia = matchMedia("(prefers-color-scheme: dark)");
      if (this.darkMedia.media.match(/^not/)) return "light";
      this.darkMedia.addListener(() => {
        if (this.props.theme != "auto") return;
        this.setState({
          theme: this.darkMedia.matches ? "dark" : "light"
        });
      });
    }
    return this.darkMedia.matches ? "dark" : "light";
  }
  initDynamicPerLine(props = this.props) {
    if (!props.dynamicWidth) return;
    const {
      element: element,
      emojiButtonSize: emojiButtonSize
    } = props;
    const calculatePerLine = () => {
      const {
        width: width
      } = element.getBoundingClientRect();
      return Math.floor(width / emojiButtonSize);
    };
    const observer = new ResizeObserver(() => {
      this.unobserve({
        except: observer
      });
      this.setState({
        perLine: calculatePerLine()
      }, () => {
        this.initGrid();
        this.forceUpdate(() => {
          this.observeCategories();
          this.observeRows();
        });
      });
    });
    observer.observe(element);
    this.observers.push(observer);
    return calculatePerLine();
  }
  getPerLine() {
    return this.state.perLine || this.props.perLine;
  }
  getEmojiByPos([p1, p2]) {
    const grid = this.state.searchResults || this.grid;
    const emoji = grid[p1] && grid[p1][p2];
    if (!emoji) return;
    return ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(emoji);
  }
  observeCategories() {
    const navigation = this.refs.navigation.current;
    if (!navigation) return;
    const visibleCategories = new Map();
    const setFocusedCategory = categoryId => {
      if (categoryId != navigation.state.categoryId) navigation.setState({
        categoryId: categoryId
      });
    };
    const observerOptions = {
      root: this.refs.scroll.current,
      threshold: [0.0, 1.0]
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const id = entry.target.dataset.id;
        visibleCategories.set(id, entry.intersectionRatio);
      }
      const ratios = [...visibleCategories];
      for (const [id, ratio] of ratios) if (ratio) {
        setFocusedCategory(id);
        break;
      }
    }, observerOptions);
    for (const {
      root: root
    } of this.refs.categories.values()) observer.observe(root.current);
    this.observers.push(observer);
  }
  observeRows() {
    const visibleRows = {
      ...this.state.visibleRows
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        const index = parseInt(entry.target.dataset.index);
        if (entry.isIntersecting) visibleRows[index] = true;else delete visibleRows[index];
      }
      this.setState({
        visibleRows: visibleRows
      });
    }, {
      root: this.refs.scroll.current,
      rootMargin: `${this.props.emojiButtonSize * ($89bd6bb200cc8fef$var$Performance.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * $89bd6bb200cc8fef$var$Performance.rowsPerRender}px`
    });
    for (const {
      rows: rows
    } of this.refs.categories.values()) {
      for (const row of rows) if (row.current) observer.observe(row.current);
    }
    this.observers.push(observer);
  }
  preventDefault(e) {
    e.preventDefault();
  }
  unfocusSearch() {
    const input = this.refs.searchInput.current;
    if (!input) return;
    input.blur();
  }
  navigate({
    e: e,
    input: input,
    left: left,
    right: right,
    up: up,
    down: down
  }) {
    const grid = this.state.searchResults || this.grid;
    if (!grid.length) return;
    let [p1, p2] = this.state.pos;
    const pos = (() => {
      if (p1 == 0) {
        if (p2 == 0 && !e.repeat && (left || up)) return null;
      }
      if (p1 == -1) {
        if (!e.repeat && (right || down) && input.selectionStart == input.value.length) return [0, 0];
        return null;
      }
      if (left || right) {
        let row = grid[p1];
        const increment = left ? -1 : 1;
        p2 += increment;
        if (!row[p2]) {
          p1 += increment;
          row = grid[p1];
          if (!row) {
            p1 = left ? 0 : grid.length - 1;
            p2 = left ? 0 : grid[p1].length - 1;
            return [p1, p2];
          }
          p2 = left ? row.length - 1 : 0;
        }
        return [p1, p2];
      }
      if (up || down) {
        p1 += up ? -1 : 1;
        const row = grid[p1];
        if (!row) {
          p1 = up ? 0 : grid.length - 1;
          p2 = up ? 0 : grid[p1].length - 1;
          return [p1, p2];
        }
        if (!row[p2]) p2 = row.length - 1;
        return [p1, p2];
      }
    })();
    if (pos) e.preventDefault();else {
      if (this.state.pos[0] > -1) this.setState({
        pos: [-1, -1]
      });
      return;
    }
    this.setState({
      pos: pos,
      keyboard: true
    }, () => {
      this.scrollTo({
        row: pos[0]
      });
    });
  }
  scrollTo({
    categoryId: categoryId,
    row: row
  }) {
    const grid = this.state.searchResults || this.grid;
    if (!grid.length) return;
    const scroll = this.refs.scroll.current;
    const scrollRect = scroll.getBoundingClientRect();
    let scrollTop = 0;
    if (row >= 0) categoryId = grid[row].__categoryId;
    if (categoryId) {
      const ref = this.refs[categoryId] || this.refs.categories.get(categoryId).root;
      const categoryRect = ref.current.getBoundingClientRect();
      scrollTop = categoryRect.top - (scrollRect.top - scroll.scrollTop) + 1;
    }
    if (row >= 0) {
      if (!row) scrollTop = 0;else {
        const rowIndex = grid[row].__index;
        const rowTop = scrollTop + rowIndex * this.props.emojiButtonSize;
        const rowBot = rowTop + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
        if (rowTop < scroll.scrollTop) scrollTop = rowTop;else if (rowBot > scroll.scrollTop + scrollRect.height) scrollTop = rowBot - scrollRect.height;else return;
      }
    }
    this.ignoreMouse();
    scroll.scrollTop = scrollTop;
  }
  ignoreMouse() {
    this.mouseIsIgnored = true;
    clearTimeout(this.ignoreMouseTimer);
    this.ignoreMouseTimer = setTimeout(() => {
      delete this.mouseIsIgnored;
    }, 100);
  }
  handleEmojiOver(pos) {
    if (this.mouseIsIgnored || this.state.showSkins) return;
    this.setState({
      pos: pos || [-1, -1],
      keyboard: false
    });
  }
  handleEmojiClick({
    e: e,
    emoji: emoji,
    pos: pos
  }) {
    if (!this.props.onEmojiSelect) return;
    if (!emoji && pos) emoji = this.getEmojiByPos(pos);
    if (emoji) {
      const emojiData = ($693b183b0a78708f$export$d10ac59fbe52a745)(emoji, {
        skinIndex: this.state.skin - 1
      });
      if (this.props.maxFrequentRows) ($b22cfd0a55410b4f$export$2e2bcd8739ae039).add(emojiData, this.props);
      this.props.onEmojiSelect(emojiData, e);
    }
  }
  closeSkins() {
    if (!this.state.showSkins) return;
    this.setState({
      showSkins: null,
      tempSkin: null
    });
    this.base.removeEventListener("click", this.handleBaseClick);
    this.base.removeEventListener("keydown", this.handleBaseKeydown);
  }
  handleSkinMouseOver(tempSkin) {
    this.setState({
      tempSkin: tempSkin
    });
  }
  handleSkinClick(skin) {
    this.ignoreMouse();
    this.closeSkins();
    this.setState({
      skin: skin,
      tempSkin: null
    });
    ($f72b75cf796873c7$export$2e2bcd8739ae039).set("skin", skin);
  }
  renderNav() {
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($ec8c39fdad15601a$export$2e2bcd8739ae039), {
      ref: this.refs.navigation,
      icons: this.props.icons,
      theme: this.state.theme,
      dir: this.dir,
      unfocused: !!this.state.searchResults,
      position: this.props.navPosition,
      onClick: this.handleCategoryClick
    }, this.navKey);
  }
  renderPreview() {
    const emoji = this.getEmojiByPos(this.state.pos);
    const noSearchResults = this.state.searchResults && !this.state.searchResults.length;
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      id: "preview",
      class: "flex flex-middle",
      dir: this.dir,
      "data-position": this.props.previewPosition,
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: "flex flex-middle flex-grow",
        children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          class: "flex flex-auto flex-middle flex-center",
          style: {
            height: this.props.emojiButtonSize,
            fontSize: this.props.emojiButtonSize
          },
          children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
            emoji: emoji,
            id: noSearchResults ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
            set: this.props.set,
            size: this.props.emojiButtonSize,
            skin: this.state.tempSkin || this.state.skin,
            spritesheet: true,
            getSpritesheetURL: this.props.getSpritesheetURL
          })
        }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          class: `margin-${this.dir[0]}`,
          children: emoji || noSearchResults ? /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: `padding-${this.dir[2]} align-${this.dir[0]}`,
            children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
              class: "preview-title ellipsis",
              children: emoji ? emoji.name : ($7adb23b0109cc36a$export$dbe3113d60765c1a).search_no_results_1
            }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
              class: "preview-subtitle ellipsis color-c",
              children: emoji ? emoji.skins[0].shortcodes : ($7adb23b0109cc36a$export$dbe3113d60765c1a).search_no_results_2
            })]
          }) : /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: "preview-placeholder color-c",
            children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).pick
          })
        })]
      }), !emoji && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()]
    });
  }
  renderEmojiButton(emoji, {
    pos: pos,
    posinset: posinset,
    grid: grid
  }) {
    const size = this.props.emojiButtonSize;
    const skin = this.state.tempSkin || this.state.skin;
    const emojiSkin = emoji.skins[skin - 1] || emoji.skins[0];
    const native = emojiSkin.native;
    const selected = ($693b183b0a78708f$export$9cb4719e2e525b7a)(this.state.pos, pos);
    const key = pos.concat(emoji.id).join("");
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($e0d4dda61265ff1e$export$2e2bcd8739ae039), {
      selected: selected,
      skin: skin,
      size: size,
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
        "aria-label": native,
        "aria-selected": selected || undefined,
        "aria-posinset": posinset,
        "aria-setsize": grid.setsize,
        "data-keyboard": this.state.keyboard,
        title: this.props.previewPosition == "none" ? emoji.name : undefined,
        type: "button",
        class: "flex flex-center flex-middle",
        tabindex: "-1",
        onClick: e => this.handleEmojiClick({
          e: e,
          emoji: emoji
        }),
        onMouseEnter: () => this.handleEmojiOver(pos),
        onMouseLeave: () => this.handleEmojiOver(),
        style: {
          width: this.props.emojiButtonSize,
          height: this.props.emojiButtonSize,
          fontSize: this.props.emojiSize,
          lineHeight: 0
        },
        children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          "aria-hidden": "true",
          class: "background",
          style: {
            borderRadius: this.props.emojiButtonRadius,
            backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(posinset - 1) % this.props.emojiButtonColors.length] : undefined
          }
        }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($254755d3f438722f$export$2e2bcd8739ae039), {
          emoji: emoji,
          set: this.props.set,
          size: this.props.emojiSize,
          skin: skin,
          spritesheet: true,
          getSpritesheetURL: this.props.getSpritesheetURL
        })]
      })
    }, key);
  }
  renderSearch() {
    const renderSkinTone = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: "spacer"
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: "flex flex-middle",
        children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          class: "search relative flex-grow",
          children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("input", {
            type: "search",
            ref: this.refs.searchInput,
            placeholder: ($7adb23b0109cc36a$export$dbe3113d60765c1a).search,
            onClick: this.handleSearchClick,
            onInput: this.handleSearchInput,
            onKeyDown: this.handleSearchKeyDown,
            autoComplete: "off"
          }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
            class: "icon loupe flex",
            children: ($fcccfb36ed0cde68$export$2e2bcd8739ae039).search.loupe
          }), this.state.searchResults && /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
            title: "Clear",
            "aria-label": "Clear",
            type: "button",
            class: "icon delete flex",
            onClick: this.clearSearch,
            onMouseDown: this.preventDefault,
            children: ($fcccfb36ed0cde68$export$2e2bcd8739ae039).search.delete
          })]
        }), renderSkinTone && this.renderSkinToneButton()]
      })]
    });
  }
  renderSearchResults() {
    const {
      searchResults: searchResults
    } = this.state;
    if (!searchResults) return null;
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      class: "category",
      ref: this.refs.search,
      children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: `sticky padding-small align-${this.dir[0]}`,
        children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories.search
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        children: !searchResults.length ? /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          class: `padding-small align-${this.dir[0]}`,
          children: this.props.onAddCustomEmoji && /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("a", {
            onClick: this.props.onAddCustomEmoji,
            children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).add_custom
          })
        }) : searchResults.map((row, i) => {
          return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: "flex",
            children: row.map((emoji, ii) => {
              return this.renderEmojiButton(emoji, {
                pos: [i, ii],
                posinset: i * this.props.perLine + ii + 1,
                grid: searchResults
              });
            })
          });
        })
      })]
    });
  }
  renderCategories() {
    const {
      categories: categories
    } = ($7adb23b0109cc36a$export$2d0294657ab35f1b);
    const hidden = !!this.state.searchResults;
    const perLine = this.getPerLine();
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      style: {
        visibility: hidden ? "hidden" : undefined,
        display: hidden ? "none" : undefined,
        height: "100%"
      },
      children: categories.map(category => {
        const {
          root: root,
          rows: rows
        } = this.refs.categories.get(category.id);
        return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          "data-id": category.target ? category.target.id : category.id,
          class: "category",
          ref: root,
          children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: `sticky padding-small align-${this.dir[0]}`,
            children: category.name || ($7adb23b0109cc36a$export$dbe3113d60765c1a).categories[category.id]
          }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
            class: "relative",
            style: {
              height: rows.length * this.props.emojiButtonSize
            },
            children: rows.map((row, i) => {
              const targetRow = row.index - row.index % $89bd6bb200cc8fef$var$Performance.rowsPerRender;
              const visible = this.state.visibleRows[targetRow];
              const ref = "current" in row ? row : undefined;
              if (!visible && !ref) return null;
              const start = i * perLine;
              const end = start + perLine;
              const emojiIds = category.emojis.slice(start, end);
              if (emojiIds.length < perLine) emojiIds.push(...new Array(perLine - emojiIds.length));
              return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                "data-index": row.index,
                ref: ref,
                class: "flex row",
                style: {
                  top: i * this.props.emojiButtonSize
                },
                children: visible && emojiIds.map((emojiId, ii) => {
                  if (!emojiId) return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
                    style: {
                      width: this.props.emojiButtonSize,
                      height: this.props.emojiButtonSize
                    }
                  });
                  const emoji = ($c4d155af13ad4d4b$export$2e2bcd8739ae039).get(emojiId);
                  return this.renderEmojiButton(emoji, {
                    pos: [row.index, ii],
                    posinset: row.posinset + ii,
                    grid: this.grid
                  });
                })
              }, row.index);
            })
          })]
        });
      })
    });
  }
  renderSkinToneButton() {
    if (this.props.skinTonePosition == "none") return null;
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      class: "flex flex-auto flex-center flex-middle",
      style: {
        position: "relative",
        width: this.props.emojiButtonSize,
        height: this.props.emojiButtonSize
      },
      children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
        type: "button",
        ref: this.refs.skinToneButton,
        class: "skin-tone-button flex flex-auto flex-center flex-middle",
        "aria-selected": this.state.showSkins ? "" : undefined,
        "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
        title: ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
        onClick: this.openSkins,
        style: {
          width: this.props.emojiSize,
          height: this.props.emojiSize
        },
        children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
          class: `skin-tone skin-tone-${this.state.skin}`
        })
      })
    });
  }
  renderLiveRegion() {
    const emoji = this.getEmojiByPos(this.state.pos);
    const contents = emoji ? emoji.name : "";
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      "aria-live": "polite",
      class: "sr-only",
      children: contents
    });
  }
  renderSkins() {
    const skinToneButton = this.refs.skinToneButton.current;
    const skinToneButtonRect = skinToneButton.getBoundingClientRect();
    const baseRect = this.base.getBoundingClientRect();
    const position = {};
    if (this.dir == "ltr") position.right = baseRect.right - skinToneButtonRect.right - 3;else position.left = skinToneButtonRect.left - baseRect.left - 3;
    if (this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview") position.bottom = baseRect.bottom - skinToneButtonRect.top + 6;else {
      position.top = skinToneButtonRect.bottom - baseRect.top + 3;
      position.bottom = "auto";
    }
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
      ref: this.refs.menu,
      role: "radiogroup",
      dir: this.dir,
      "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins.choose,
      class: "menu hidden",
      "data-position": position.top ? "top" : "bottom",
      style: position,
      children: [...Array(6).keys()].map(i => {
        const skin = i + 1;
        const checked = this.state.skin == skin;
        return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("input", {
            type: "radio",
            name: "skin-tone",
            value: skin,
            "aria-label": ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins[skin],
            ref: checked ? this.refs.skinToneRadio : null,
            defaultChecked: checked,
            onChange: () => this.handleSkinMouseOver(skin),
            onKeyDown: e => {
              if (e.code == "Enter" || e.code == "Space" || e.code == "Tab") {
                e.preventDefault();
                this.handleSkinClick(skin);
              }
            }
          }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("button", {
            "aria-hidden": "true",
            tabindex: "-1",
            onClick: () => this.handleSkinClick(skin),
            onMouseEnter: () => this.handleSkinMouseOver(skin),
            onMouseLeave: () => this.handleSkinMouseOver(),
            class: "option flex flex-grow flex-middle",
            children: [/*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
              class: `skin-tone skin-tone-${skin}`
            }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("span", {
              class: "margin-small-lr",
              children: ($7adb23b0109cc36a$export$dbe3113d60765c1a).skins[skin]
            })]
          })]
        });
      })
    });
  }
  render() {
    const lineWidth = this.props.perLine * this.props.emojiButtonSize;
    return /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("section", {
      id: "root",
      class: "flex flex-column",
      dir: this.dir,
      style: {
        width: this.props.dynamicWidth ? "100%" : `calc(${lineWidth}px + (var(--padding) + var(--sidebar-width)))`
      },
      "data-emoji-set": this.props.set,
      "data-theme": this.state.theme,
      "data-menu": this.state.showSkins ? "" : undefined,
      children: [this.props.previewPosition == "top" && this.renderPreview(), this.props.navPosition == "top" && this.renderNav(), this.props.searchPosition == "sticky" && /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        class: "padding-lr",
        children: this.renderSearch()
      }), /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
        ref: this.refs.scroll,
        class: "scroll flex-grow padding-lr",
        children: /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)("div", {
          style: {
            width: this.props.dynamicWidth ? "100%" : lineWidth,
            height: "100%"
          },
          children: [this.props.searchPosition == "static" && this.renderSearch(), this.renderSearchResults(), this.renderCategories()]
        })
      }), this.props.navPosition == "bottom" && this.renderNav(), this.props.previewPosition == "bottom" && this.renderPreview(), this.state.showSkins && this.renderSkins(), this.renderLiveRegion()]
    });
  }
  constructor(props) {
    super();
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleClickOutside", e => {
      const {
        element: element
      } = this.props;
      if (e.target != element) {
        if (this.state.showSkins) this.closeSkins();
        if (this.props.onClickOutside) this.props.onClickOutside(e);
      }
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleBaseClick", e => {
      if (!this.state.showSkins) return;
      if (!e.target.closest(".menu")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.closeSkins();
      }
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleBaseKeydown", e => {
      if (!this.state.showSkins) return;
      if (e.key == "Escape") {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.closeSkins();
      }
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchClick", () => {
      const emoji = this.getEmojiByPos(this.state.pos);
      if (!emoji) return;
      this.setState({
        pos: [-1, -1]
      });
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchInput", async () => {
      const input = this.refs.searchInput.current;
      if (!input) return;
      const {
        value: value
      } = input;
      const searchResults = await ($c4d155af13ad4d4b$export$2e2bcd8739ae039).search(value);
      const afterRender = () => {
        if (!this.refs.scroll.current) return;
        this.refs.scroll.current.scrollTop = 0;
      };
      if (!searchResults) return this.setState({
        searchResults: searchResults,
        pos: [-1, -1]
      }, afterRender);
      const pos = input.selectionStart == input.value.length ? [0, 0] : [-1, -1];
      const grid = [];
      grid.setsize = searchResults.length;
      let row = null;
      for (let emoji of searchResults) {
        if (!grid.length || row.length == this.getPerLine()) {
          row = [];
          row.__categoryId = "search";
          row.__index = grid.length;
          grid.push(row);
        }
        row.push(emoji);
      }
      this.ignoreMouse();
      this.setState({
        searchResults: grid,
        pos: pos
      }, afterRender);
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleSearchKeyDown", e => {
      // const specialKey = e.altKey || e.ctrlKey || e.metaKey
      const input = e.currentTarget;
      e.stopImmediatePropagation();
      switch (e.key) {
        case "ArrowLeft":
          // if (specialKey) return
          // e.preventDefault()
          this.navigate({
            e: e,
            input: input,
            left: true
          });
          break;
        case "ArrowRight":
          // if (specialKey) return
          // e.preventDefault()
          this.navigate({
            e: e,
            input: input,
            right: true
          });
          break;
        case "ArrowUp":
          // if (specialKey) return
          // e.preventDefault()
          this.navigate({
            e: e,
            input: input,
            up: true
          });
          break;
        case "ArrowDown":
          // if (specialKey) return
          // e.preventDefault()
          this.navigate({
            e: e,
            input: input,
            down: true
          });
          break;
        case "Enter":
          e.preventDefault();
          this.handleEmojiClick({
            e: e,
            pos: this.state.pos
          });
          break;
        case "Escape":
          e.preventDefault();
          if (this.state.searchResults) this.clearSearch();else this.unfocusSearch();
          break;
      }
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "clearSearch", () => {
      const input = this.refs.searchInput.current;
      if (!input) return;
      input.value = "";
      input.focus();
      this.handleSearchInput();
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "handleCategoryClick", ({
      category: category,
      i: i
    }) => {
      this.scrollTo(i == 0 ? {
        row: -1
      } : {
        categoryId: category.id
      });
    });
    ($c770c458706daa72$export$2e2bcd8739ae039)(this, "openSkins", e => {
      const {
        currentTarget: currentTarget
      } = e;
      const rect = currentTarget.getBoundingClientRect();
      this.setState({
        showSkins: rect
      }, async () => {
        // Firefox requires 2 frames for the transition to consistenly work
        await ($693b183b0a78708f$export$e772c8ff12451969)(2);
        const menu = this.refs.menu.current;
        if (!menu) return;
        menu.classList.remove("hidden");
        this.refs.skinToneRadio.current.focus();
        this.base.addEventListener("click", this.handleBaseClick, true);
        this.base.addEventListener("keydown", this.handleBaseKeydown, true);
      });
    });
    this.observers = [];
    this.state = {
      pos: [-1, -1],
      perLine: this.initDynamicPerLine(props),
      visibleRows: {
        0: true
      },
      ...this.getInitialState(props)
    };
  }
}
class $efa000751917694d$export$2e2bcd8739ae039 extends ($26f27c338a96b1a6$export$2e2bcd8739ae039) {
  async connectedCallback() {
    const props = ($7adb23b0109cc36a$export$75fe5f91d452f94b)(this.props, ($b247ea80b67298d5$export$2e2bcd8739ae039), this);
    props.element = this;
    props.ref = component => {
      this.component = component;
    };
    await ($7adb23b0109cc36a$export$2cd8252107eb640b)(props);
    if (this.disconnected) return;
    ($fb96b826c0c5f37a$export$b3890eb0ae9dca99)( /*#__PURE__*/($bd9dd35321b03dd4$export$34b9dba7ce09269b)(($89bd6bb200cc8fef$export$2e2bcd8739ae039), {
      ...props
    }), this.shadowRoot);
  }
  constructor(props) {
    super(props, {
      styles: (/*@__PURE__*/$parcel$interopDefault($329d53ba9fd7125f$exports))
    });
  }
}
($c770c458706daa72$export$2e2bcd8739ae039)($efa000751917694d$export$2e2bcd8739ae039, "Props", ($b247ea80b67298d5$export$2e2bcd8739ae039));
if (typeof customElements !== "undefined" && !customElements.get("em-emoji-picker")) customElements.define("em-emoji-picker", $efa000751917694d$export$2e2bcd8739ae039);
var $329d53ba9fd7125f$exports = {};
$329d53ba9fd7125f$exports = ":host {\n  width: min-content;\n  height: 435px;\n  min-height: 230px;\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow);\n  --border-radius: 10px;\n  --category-icon-size: 18px;\n  --font-family: -apple-system, BlinkMacSystemFont, \"Helvetica Neue\", sans-serif;\n  --font-size: 15px;\n  --preview-placeholder-size: 21px;\n  --preview-title-size: 1.1em;\n  --preview-subtitle-size: .9em;\n  --shadow-color: 0deg 0% 0%;\n  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);\n  display: flex;\n}\n\n[data-theme=\"light\"] {\n  --em-rgb-color: var(--rgb-color, 34, 36, 39);\n  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);\n  --em-rgb-background: var(--rgb-background, 255, 255, 255);\n  --em-rgb-input: var(--rgb-input, 255, 255, 255);\n  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));\n  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));\n}\n\n[data-theme=\"dark\"] {\n  --em-rgb-color: var(--rgb-color, 222, 222, 221);\n  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);\n  --em-rgb-background: var(--rgb-background, 21, 22, 23);\n  --em-rgb-input: var(--rgb-input, 0, 0, 0);\n  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));\n  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));\n}\n\n#root {\n  --color-a: rgb(var(--em-rgb-color));\n  --color-b: rgba(var(--em-rgb-color), .65);\n  --color-c: rgba(var(--em-rgb-color), .45);\n  --padding: 12px;\n  --padding-small: calc(var(--padding) / 2);\n  --sidebar-width: 16px;\n  --duration: 225ms;\n  --duration-fast: 125ms;\n  --duration-instant: 50ms;\n  --easing: cubic-bezier(.4, 0, .2, 1);\n  width: 100%;\n  text-align: left;\n  border-radius: var(--border-radius);\n  background-color: rgb(var(--em-rgb-background));\n  position: relative;\n}\n\n@media (prefers-reduced-motion) {\n  #root {\n    --duration: 0;\n    --duration-fast: 0;\n    --duration-instant: 0;\n  }\n}\n\n#root[data-menu] button {\n  cursor: auto;\n}\n\n#root[data-menu] .menu button {\n  cursor: pointer;\n}\n\n:host, #root, input, button {\n  color: rgb(var(--em-rgb-color));\n  font-family: var(--font-family);\n  font-size: var(--font-size);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: normal;\n}\n\n*, :before, :after {\n  box-sizing: border-box;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.relative {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-auto {\n  flex: none;\n}\n\n.flex-center {\n  justify-content: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.flex-grow {\n  flex: auto;\n}\n\n.flex-middle {\n  align-items: center;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.padding {\n  padding: var(--padding);\n}\n\n.padding-t {\n  padding-top: var(--padding);\n}\n\n.padding-lr {\n  padding-left: var(--padding);\n  padding-right: var(--padding);\n}\n\n.padding-r {\n  padding-right: var(--padding);\n}\n\n.padding-small {\n  padding: var(--padding-small);\n}\n\n.padding-small-b {\n  padding-bottom: var(--padding-small);\n}\n\n.padding-small-lr {\n  padding-left: var(--padding-small);\n  padding-right: var(--padding-small);\n}\n\n.margin {\n  margin: var(--padding);\n}\n\n.margin-r {\n  margin-right: var(--padding);\n}\n\n.margin-l {\n  margin-left: var(--padding);\n}\n\n.margin-small-l {\n  margin-left: var(--padding-small);\n}\n\n.margin-small-lr {\n  margin-left: var(--padding-small);\n  margin-right: var(--padding-small);\n}\n\n.align-l {\n  text-align: left;\n}\n\n.align-r {\n  text-align: right;\n}\n\n.color-a {\n  color: var(--color-a);\n}\n\n.color-b {\n  color: var(--color-b);\n}\n\n.color-c {\n  color: var(--color-c);\n}\n\n.ellipsis {\n  white-space: nowrap;\n  max-width: 100%;\n  width: auto;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.sr-only {\n  width: 1px;\n  height: 1px;\n  position: absolute;\n  top: auto;\n  left: -10000px;\n  overflow: hidden;\n}\n\na {\n  cursor: pointer;\n  color: rgb(var(--em-rgb-accent));\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.spacer {\n  height: 10px;\n}\n\n[dir=\"rtl\"] .scroll {\n  padding-left: 0;\n  padding-right: var(--padding);\n}\n\n.scroll {\n  padding-right: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.scroll::-webkit-scrollbar {\n  width: var(--sidebar-width);\n  height: var(--sidebar-width);\n}\n\n.scroll::-webkit-scrollbar-track {\n  border: 0;\n}\n\n.scroll::-webkit-scrollbar-button {\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.scroll::-webkit-scrollbar-corner {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.scroll::-webkit-scrollbar-thumb {\n  min-height: 20%;\n  min-height: 65px;\n  border: 4px solid rgb(var(--em-rgb-background));\n  border-radius: 8px;\n}\n\n.scroll::-webkit-scrollbar-thumb:hover {\n  background-color: var(--em-color-border-over) !important;\n}\n\n.scroll:hover::-webkit-scrollbar-thumb {\n  background-color: var(--em-color-border);\n}\n\n.sticky {\n  z-index: 1;\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  font-weight: 500;\n  position: sticky;\n  top: -1px;\n}\n\n[dir=\"rtl\"] .search input[type=\"search\"] {\n  padding: 10px 2.2em 10px 2em;\n}\n\n[dir=\"rtl\"] .search .loupe {\n  left: auto;\n  right: .7em;\n}\n\n[dir=\"rtl\"] .search .delete {\n  left: .7em;\n  right: auto;\n}\n\n.search {\n  z-index: 2;\n  position: relative;\n}\n\n.search input, .search button {\n  font-size: calc(var(--font-size)  - 1px);\n}\n\n.search input[type=\"search\"] {\n  width: 100%;\n  background-color: var(--em-color-border);\n  transition-duration: var(--duration);\n  transition-property: background-color, box-shadow;\n  transition-timing-function: var(--easing);\n  border: 0;\n  border-radius: 10px;\n  outline: 0;\n  padding: 10px 2em 10px 2.2em;\n  display: block;\n}\n\n.search input[type=\"search\"]::-ms-input-placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"]::placeholder {\n  color: inherit;\n  opacity: .6;\n}\n\n.search input[type=\"search\"], .search input[type=\"search\"]::-webkit-search-decoration, .search input[type=\"search\"]::-webkit-search-cancel-button, .search input[type=\"search\"]::-webkit-search-results-button, .search input[type=\"search\"]::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n}\n\n.search input[type=\"search\"]:focus {\n  background-color: rgb(var(--em-rgb-input));\n  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);\n}\n\n.search .icon {\n  z-index: 1;\n  color: rgba(var(--em-rgb-color), .7);\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.search .loupe {\n  pointer-events: none;\n  left: .7em;\n}\n\n.search .delete {\n  right: .7em;\n}\n\nsvg {\n  fill: currentColor;\n  width: 1em;\n  height: 1em;\n}\n\nbutton {\n  -webkit-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  color: currentColor;\n  background-color: rgba(0, 0, 0, 0);\n  border: 0;\n}\n\n#nav {\n  z-index: 2;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#nav button {\n  color: var(--color-b);\n  transition: color var(--duration) var(--easing);\n}\n\n#nav button:hover {\n  color: var(--color-a);\n}\n\n#nav svg, #nav img {\n  width: var(--category-icon-size);\n  height: var(--category-icon-size);\n}\n\n#nav[dir=\"rtl\"] .bar {\n  left: auto;\n  right: 0;\n}\n\n#nav .bar {\n  width: 100%;\n  height: 3px;\n  background-color: rgb(var(--em-rgb-accent));\n  transition: transform var(--duration) var(--easing);\n  border-radius: 3px 3px 0 0;\n  position: absolute;\n  bottom: -12px;\n  left: 0;\n}\n\n#nav button[aria-selected] {\n  color: rgb(var(--em-rgb-accent));\n}\n\n#preview {\n  z-index: 2;\n  padding: calc(var(--padding)  + 4px) var(--padding);\n  padding-right: var(--sidebar-width);\n  position: relative;\n}\n\n#preview .preview-placeholder {\n  font-size: var(--preview-placeholder-size);\n}\n\n#preview .preview-title {\n  font-size: var(--preview-title-size);\n}\n\n#preview .preview-subtitle {\n  font-size: var(--preview-subtitle-size);\n}\n\n#nav:before, #preview:before {\n  content: \"\";\n  height: 2px;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n#nav[data-position=\"top\"]:before, #preview[data-position=\"top\"]:before {\n  background: linear-gradient(to bottom, var(--em-color-border), transparent);\n  top: 100%;\n}\n\n#nav[data-position=\"bottom\"]:before, #preview[data-position=\"bottom\"]:before {\n  background: linear-gradient(to top, var(--em-color-border), transparent);\n  bottom: 100%;\n}\n\n.category:last-child {\n  min-height: calc(100% + 1px);\n}\n\n.category button {\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  position: relative;\n}\n\n.category button > * {\n  position: relative;\n}\n\n.category button .background {\n  opacity: 0;\n  background-color: var(--em-color-border);\n  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.category button:hover .background {\n  transition-duration: var(--duration-instant);\n  transition-delay: 0s;\n}\n\n.category button[aria-selected] .background {\n  opacity: 1;\n}\n\n.category button[data-keyboard] .background {\n  transition: none;\n}\n\n.row {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.skin-tone-button {\n  border: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 100%;\n}\n\n.skin-tone-button:hover {\n  border-color: var(--em-color-border);\n}\n\n.skin-tone-button:active .skin-tone {\n  transform: scale(.85) !important;\n}\n\n.skin-tone-button .skin-tone {\n  transition: transform var(--duration) var(--easing);\n}\n\n.skin-tone-button[aria-selected] {\n  background-color: var(--em-color-border);\n  border-top-color: rgba(0, 0, 0, .05);\n  border-bottom-color: rgba(0, 0, 0, 0);\n  border-left-width: 0;\n  border-right-width: 0;\n}\n\n.skin-tone-button[aria-selected] .skin-tone {\n  transform: scale(.9);\n}\n\n.menu {\n  z-index: 2;\n  white-space: nowrap;\n  border: 1px solid var(--em-color-border);\n  background-color: rgba(var(--em-rgb-background), .9);\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n  transition-property: opacity, transform;\n  transition-duration: var(--duration);\n  transition-timing-function: var(--easing);\n  border-radius: 10px;\n  padding: 4px;\n  position: absolute;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);\n}\n\n.menu.hidden {\n  opacity: 0;\n}\n\n.menu[data-position=\"bottom\"] {\n  transform-origin: 100% 100%;\n}\n\n.menu[data-position=\"bottom\"].hidden {\n  transform: scale(.9)rotate(-3deg)translateY(5%);\n}\n\n.menu[data-position=\"top\"] {\n  transform-origin: 100% 0;\n}\n\n.menu[data-position=\"top\"].hidden {\n  transform: scale(.9)rotate(3deg)translateY(-5%);\n}\n\n.menu input[type=\"radio\"] {\n  clip: rect(0 0 0 0);\n  width: 1px;\n  height: 1px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  overflow: hidden;\n}\n\n.menu input[type=\"radio\"]:checked + .option {\n  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));\n}\n\n.option {\n  width: 100%;\n  border-radius: 6px;\n  padding: 4px 6px;\n}\n\n.option:hover {\n  color: #fff;\n  background-color: rgb(var(--em-rgb-accent));\n}\n\n.skin-tone {\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n}\n\n.skin-tone:after {\n  content: \"\";\n  mix-blend-mode: overlay;\n  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));\n  border: 1px solid rgba(0, 0, 0, .8);\n  border-radius: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;\n}\n\n.skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.skin-tone-2 {\n  background-color: #ffdab7;\n}\n\n.skin-tone-3 {\n  background-color: #e7b98f;\n}\n\n.skin-tone-4 {\n  background-color: #c88c61;\n}\n\n.skin-tone-5 {\n  background-color: #a46134;\n}\n\n.skin-tone-6 {\n  background-color: #5d4437;\n}\n\n[data-index] {\n  justify-content: space-between;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone:after {\n  box-shadow: none;\n  border-color: rgba(0, 0, 0, .5);\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-1 {\n  background-color: #fade72;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-2 {\n  background-color: #f3dfd0;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-3 {\n  background-color: #eed3a8;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-4 {\n  background-color: #cfad8d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-5 {\n  background-color: #a8805d;\n}\n\n[data-emoji-set=\"twitter\"] .skin-tone-6 {\n  background-color: #765542;\n}\n\n[data-emoji-set=\"google\"] .skin-tone:after {\n  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);\n}\n\n[data-emoji-set=\"google\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"google\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone:after {\n  border-color: rgba(0, 0, 0, .4);\n  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-1 {\n  background-color: #f5c748;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-2 {\n  background-color: #f1d5aa;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-3 {\n  background-color: #d4b48d;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-4 {\n  background-color: #aa876b;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-5 {\n  background-color: #916544;\n}\n\n[data-emoji-set=\"facebook\"] .skin-tone-6 {\n  background-color: #61493f;\n}\n\n";

function $e5534fc185f7111e$export$2e2bcd8739ae039(props) {
  const ref = (useRef)(null);
  const instance = (useRef)(null);
  if (instance.current) instance.current.update(props);
  (useEffect)(() => {
    instance.current = new ($efa000751917694d$export$2e2bcd8739ae039)({
      ...props,
      ref: ref
    });
    return () => {
      instance.current = null;
    };
  }, []);
  return /*#__PURE__*/(React__default$1).createElement("div", {
    ref: ref
  });
}

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow$1(node) {
  var _node$ownerDocument;
  return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow$1(value).Node;
}
function isElement$1(value) {
  return value instanceof Element || value instanceof getWindow$1(value).Element;
}
function isHTMLElement$1(value) {
  return value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement;
}
function isShadowRoot$1(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$1(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot$1(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$1(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}

function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement$1(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$1(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$1(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$1(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$1(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow$1(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element).filter(el => isElement$1(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  return getCssDimensions(element);
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$1(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow$1(element);
  if (!isHTMLElement$1(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$1(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

var index$1 = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef(value) {
  const ref = React$1.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React$1.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React$1.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React$1.useState(null);
  const [_floating, _setFloating] = React$1.useState(null);
  const setReference = React$1.useCallback(node => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = React$1.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React$1.useRef(null);
  const floatingRef = React$1.useRef(null);
  const dataRef = React$1.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform);
  const update = React$1.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React$1.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = React$1.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React$1.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React$1.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React$1.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};

/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */
var hasTabIndex = function hasTabIndex(node) {
  return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};

/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */
var getTabIndex = function getTabIndex(node) {
  if (!node) {
    throw new Error('No node provided');
  }
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};

/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */
var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

var index = typeof document !== 'undefined' ? useLayoutEffect : useEffect;

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = React$1.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React$1.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = React$1[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/React$1.createContext(null);
const FloatingTreeContext = /*#__PURE__*/React$1.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React$1.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React$1.useContext(FloatingTreeContext);

function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function getWindow(value) {
  return getDocument(value).defaultView || window;
}
function isElement(value) {
  return value ? value instanceof Element || value instanceof getWindow(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement : false;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function isSafari$1() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}

function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

/**
 * Find the real active element. Traverses into shadowRoots.
 */
function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}

function getChildren(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}

function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}

const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/React$1.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React$1.useState();
  index(() => {
    if (isSafari$1()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/React$1.createElement("span", _extends$1({}, props, restProps));
});

const PortalContext = /*#__PURE__*/React$1.createContext(null);
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = React$1.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const data = React$1.useMemo(() => ({
    id,
    root,
    portalContext,
    uniqueId
  }), [id, root, portalContext, uniqueId]);
  const dataRef = React$1.useRef();
  index(() => {
    return () => {
      portalNode == null ? void 0 : portalNode.remove();
    };
  }, [portalNode, data]);
  index(() => {
    if (dataRef.current === data) return;
    dataRef.current = data;
    const {
      id,
      root,
      portalContext,
      uniqueId
    } = data;
    const existingIdRoot = id ? document.getElementById(id) : null;
    const attr = createAttribute('portal');
    if (existingIdRoot) {
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      existingIdRoot.appendChild(subRoot);
      setPortalNode(subRoot);
    } else {
      let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
      if (container && !isElement(container)) container = container.current;
      container = container || document.body;
      let idWrapper = null;
      if (id) {
        idWrapper = document.createElement('div');
        idWrapper.id = id;
        container.appendChild(idWrapper);
      }
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      container = idWrapper || container;
      container.appendChild(subRoot);
      setPortalNode(subRoot);
    }
  }, [data]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React$1.useState(null);
  const beforeOutsideRef = React$1.useRef(null);
  const afterOutsideRef = React$1.useRef(null);
  const beforeInsideRef = React$1.useRef(null);
  const afterInsideRef = React$1.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React$1.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/React$1.createElement(PortalContext.Provider, {
    value: React$1.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React$1.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null ? void 0 : _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null ? void 0 : prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React$1.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React$1.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null ? void 0 : _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null ? void 0 : nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
const usePortalContext = () => React$1.useContext(PortalContext);

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = React$1.useRef();
  const didKeyDownRef = React$1.useRef(false);
  return React$1.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true, event.nativeEvent);
          }
        },
        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            onOpenChange(true, event.nativeEvent);
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === 'Enter') {
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ' && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = React$1[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = React$1.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React$1.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeBubblesProp = bubbles => {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  return {
    escapeKeyBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
    outsidePressBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles
  } = props;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React$1.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    events.emit('dismiss', {
      type: 'escapeKey',
      data: {
        returnFocus: {
          preventScroll: false
        }
      }
    });
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = getWindow(floating).getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    events.emit('dismiss', {
      type: 'outsidePress',
      data: {
        returnFocus: nested ? {
          preventScroll: true
        } : isVirtualClick(event) || isVirtualPointerEvent(event)
      }
    });
    onOpenChange(false, event);
  });
  React$1.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event);
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener('keydown', closeOnEscapeKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', closeOnEscapeKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, closeOnPressOutside]);
  React$1.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React$1.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            events.emit('dismiss', {
              type: 'referencePress',
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false, event.nativeEvent);
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  var _options$elements;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const [_domReference, setDomReference] = React$1.useState(null);
  const domReference = ((_options$elements = options.elements) == null ? void 0 : _options$elements.reference) || _domReference;
  const position = useFloating$1(options);
  const tree = useFloatingTree();
  const onOpenChange = useEffectEvent((open, event) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    unstable_onOpenChange == null ? void 0 : unstable_onOpenChange(open, event);
  });
  const domReferenceRef = React$1.useRef(null);
  const dataRef = React$1.useRef({});
  const events = React$1.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = React$1.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React$1.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React$1.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React$1.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = React$1.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React$1.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...userProps,
    ...propsList.map(value => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/react#interaction-hooks
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = React$1.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = React$1.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = React$1.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsList.map(key => key == null ? void 0 : key.item));
  return React$1.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const referenceId = useId();
  return React$1.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === 'tooltip') {
      return {
        reference: {
          'aria-describedby': open ? floatingId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
        'aria-controls': open ? floatingId : undefined,
        ...(role === 'listbox' && {
          role: 'combobox'
        }),
        ...(role === 'menu' && {
          id: referenceId
        })
      },
      floating: {
        ...floatingProps,
        ...(role === 'menu' && {
          'aria-labelledby': referenceId
        })
      }
    };
  }, [enabled, role, open, floatingId, referenceId]);
}

var ReactionPicker = function (props) {
  var children = props.children,
    onApplyReaction = props.onApplyReaction;
  var locale = useContext(ChatRootContext).locale;
  var isMobile = useIsMobile();
  var _a = useState(false),
    open = _a[0],
    setOpen = _a[1];
  var _b = useState(false),
    openWithMobile = _b[0],
    setOpenWithMobile = _b[1];
  var triggerRef = useRef(null);
  var _c = useFloating({
      open: open,
      onOpenChange: setOpen,
      placement: 'bottom-start',
      middleware: [offset(6), flip(), shift()],
      whileElementsMounted: autoUpdate
    }),
    refs = _c.refs,
    floatingStyles = _c.floatingStyles,
    context = _c.context,
    placement = _c.placement;
  var click = useClick(context);
  var dismiss = useDismiss(context);
  var role = useRole(context);
  var _d = useInteractions([click, dismiss, role]),
    getFloatingProps = _d.getFloatingProps,
    getReferenceProps = _d.getReferenceProps;
  var renderPicker = function () {
    return jsx($e5534fc185f7111e$export$2e2bcd8739ae039, {
      dynamicWidth: isMobile,
      data: data,
      locale: locale.emojiPickerLocale,
      set: "twitter",
      emojiButtonRadius: "6px",
      emojiButtonColors: ['rgba(155,223,88,.7)', 'rgba(149,211,254,.7)', 'rgba(247,233,34,.7)', 'rgba(238,166,252,.7)', 'rgba(255,213,143,.7)', 'rgba(211,209,255,.7)'],
      onEmojiSelect: function (emoji) {
        onApplyReaction('add', emoji.unified);
        setOpen(false);
        setOpenWithMobile(false);
      }
    });
  };
  /**
   * 모바일뷰인 경우 이모지 선택창을 off-canvas 형식으로 변경합니다.
   */
  if (isMobile) {
    var clonedChildren_1 = cloneElement(children, {
      onClick: function () {
        setOpenWithMobile(true);
      }
    });
    return jsxs(Fragment, {
      children: [clonedChildren_1, jsx(ChannelPortal, {
        children: jsx(CSSTransition, {
          nodeRef: triggerRef,
          in: openWithMobile,
          timeout: 200,
          unmountOnExit: true,
          children: jsxs(MobileOverlay, {
            ref: triggerRef,
            children: [jsx("div", {
              className: "overlay-shadow",
              onClick: function () {
                return setOpenWithMobile(false);
              }
            }), jsx("button", {
              className: "overlay-close",
              onClick: function () {
                return setOpenWithMobile(false);
              },
              children: jsx("svg", {
                stroke: "currentColor",
                fill: "currentColor",
                strokeWidth: "0",
                viewBox: "0 0 1024 1024",
                height: "1em",
                width: "1em",
                xmlns: "http://www.w3.org/2000/svg",
                children: jsx("path", {
                  d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                })
              })
            }), renderPicker()]
          })
        })
      })]
    });
  }
  var clonedChildren = cloneElement(children, getReferenceProps({
    ref: refs.setReference
  }));
  return jsxs(Fragment, {
    children: [clonedChildren, jsx(FloatingPortal, {
      children: jsx(CSSTransition, {
        nodeRef: refs.floating,
        in: open,
        timeout: 200,
        unmountOnExit: true,
        children: jsx(Floating, __assign$1({
          ref: refs.setFloating
        }, getFloatingProps({
          style: floatingStyles
        }), {
          children: jsx("div", {
            className: "dialog",
            "data-placement": placement,
            children: renderPicker()
          })
        }))
      })
    })]
  });
};
var Floating = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  z-index: 100;\n  --rgb-accent: 24, 144, 255;\n\n  .dialog {\n    &[data-placement='top-start'] {\n      transform-origin: bottom left;\n    }\n    &[data-placement='top-end'] {\n      transform-origin: bottom right;\n    }\n    &[data-placement='bottom-start'] {\n      transform-origin: top left;\n    }\n    &[data-placement='bottom-end'] {\n      transform-origin: top right;\n    }\n  }\n\n  &.enter {\n    opacity: 0;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(1rem);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-1rem);\n      }\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    .dialog {\n      transform: scale(1) translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(1rem);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-1rem);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n"], ["\n  z-index: 100;\n  --rgb-accent: 24, 144, 255;\n\n  .dialog {\n    &[data-placement='top-start'] {\n      transform-origin: bottom left;\n    }\n    &[data-placement='top-end'] {\n      transform-origin: bottom right;\n    }\n    &[data-placement='bottom-start'] {\n      transform-origin: top left;\n    }\n    &[data-placement='bottom-end'] {\n      transform-origin: top right;\n    }\n  }\n\n  &.enter {\n    opacity: 0;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(1rem);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-1rem);\n      }\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    .dialog {\n      transform: scale(1) translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    .dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(1rem);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-1rem);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n"])));
var MobileOverlay = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 100;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n  background-color: rgba(0 0 0 / 50%);\n  overflow: hidden;\n\n  & > .overlay-shadow {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  & > button.overlay-close {\n    cursor: pointer;\n    position: absolute;\n    top: 1rem;\n    left: 1rem;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n\n    width: 36px;\n    height: 36px;\n    color: #2c384a;\n    font-size: 1.125rem;\n    background: white;\n\n    border: none;\n    outline: none;\n    border-radius: 100%;\n  }\n\n  & > div:not(.overlay-shadow) {\n    display: flex;\n    align-items: flex-end;\n    width: 100%;\n    height: inherit;\n  }\n\n  em-emoji-picker {\n    position: relative;\n    z-index: 1;\n    margin: 0 auto;\n    width: 100%;\n    height: 80%;\n  }\n\n  &.enter {\n    opacity: 0;\n    em-emoji-picker {\n      transform: translateY(3rem);\n    }\n    .overlay-close {\n      transform: rotate(-180deg) scale(0.6);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    em-emoji-picker {\n      transform: translateY(0);\n      transition: transform 200ms ease;\n    }\n    .overlay-close {\n      transform: rotate(0) scale(1);\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    em-emoji-picker {\n      transform: translateY(0);\n    }\n    .overlay-close {\n      transform: rotate(0) scale(1);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    em-emoji-picker {\n      transform: translateY(3rem);\n      transition: transform 200ms ease;\n    }\n    .overlay-close {\n      transform: rotate(-180deg) scale(0.6);\n      transition: transform 200ms ease;\n    }\n  }\n"], ["\n  position: absolute;\n  z-index: 100;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n  background-color: rgba(0 0 0 / 50%);\n  overflow: hidden;\n\n  & > .overlay-shadow {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n\n  & > button.overlay-close {\n    cursor: pointer;\n    position: absolute;\n    top: 1rem;\n    left: 1rem;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n\n    width: 36px;\n    height: 36px;\n    color: #2c384a;\n    font-size: 1.125rem;\n    background: white;\n\n    border: none;\n    outline: none;\n    border-radius: 100%;\n  }\n\n  & > div:not(.overlay-shadow) {\n    display: flex;\n    align-items: flex-end;\n    width: 100%;\n    height: inherit;\n  }\n\n  em-emoji-picker {\n    position: relative;\n    z-index: 1;\n    margin: 0 auto;\n    width: 100%;\n    height: 80%;\n  }\n\n  &.enter {\n    opacity: 0;\n    em-emoji-picker {\n      transform: translateY(3rem);\n    }\n    .overlay-close {\n      transform: rotate(-180deg) scale(0.6);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    em-emoji-picker {\n      transform: translateY(0);\n      transition: transform 200ms ease;\n    }\n    .overlay-close {\n      transform: rotate(0) scale(1);\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    em-emoji-picker {\n      transform: translateY(0);\n    }\n    .overlay-close {\n      transform: rotate(0) scale(1);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    em-emoji-picker {\n      transform: translateY(3rem);\n      transition: transform 200ms ease;\n    }\n    .overlay-close {\n      transform: rotate(-180deg) scale(0.6);\n      transition: transform 200ms ease;\n    }\n  }\n"])));
var templateObject_1$9, templateObject_2$7;

var MessageReactions = function (props) {
  var currentUserId = props.currentUserId,
    reactions = props.reactions,
    isMyMessage = props.isMyMessage,
    onApplyReaction = props.onApplyReaction;
  var handleAdd = function (key) {
    return onApplyReaction('add', key);
  };
  var handleDelete = function (key) {
    return onApplyReaction('delete', key);
  };
  return jsx(Fragment, {
    children: !!(reactions === null || reactions === void 0 ? void 0 : reactions.length) && jsxs(List$3, {
      className: classNames({
        'is-mine': isMyMessage
      }),
      children: [reactions === null || reactions === void 0 ? void 0 : reactions.map(function (reaction, index) {
        return jsx(Fragment, {
          children: jsx(ReactionIcon, {
            reactKey: reaction.key,
            reactionCount: reaction.userIds.length,
            isActive: reaction.userIds.includes(currentUserId),
            onAdd: handleAdd,
            onDelete: handleDelete
          }, reaction.key + index)
        });
      }), jsx(ReactionPicker, {
        onApplyReaction: onApplyReaction,
        children: jsx("div", {
          children: jsx(Tooltip, {
            title: "\uBC18\uC751\uD558\uAE30",
            children: jsx(Icon, {
              children: IconAddEmoji
            })
          })
        })
      })]
    })
  });
};
var ReactionIcon = function (props) {
  var isActive = props.isActive,
    reactKey = props.reactKey,
    reactionCount = props.reactionCount,
    onAdd = props.onAdd,
    onDelete = props.onDelete;
  var handleClick = function () {
    if (isActive) {
      onDelete(reactKey);
    } else {
      onAdd(reactKey);
    }
  };
  return jsxs(Icon, {
    className: classNames({
      active: isActive
    }),
    onClick: handleClick,
    children: [jsx(ExportedEmoji, {
      emojiStyle: EmojiStyle.TWITTER,
      unified: reactKey,
      size: 20
    }), jsx("span", {
      children: reactionCount
    })]
  });
};
styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var List$3 = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding-top: 5px;\n  gap: 4px;\n\n  &.is-mine {\n    justify-content: flex-end;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding-top: 5px;\n  gap: 4px;\n\n  &.is-mine {\n    justify-content: flex-end;\n  }\n"])));
var Icon = styled.button(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  padding: 0.25rem;\n  justify-content: center;\n  align-items: center;\n  padding: 3px 6px;\n  gap: 4px;\n\n  outline: none;\n\n  color: #505050;\n  font-size: var(--font-size-14px, 14px);\n  font-weight: 400;\n  line-height: normal;\n  border-radius: 50px;\n  background: #f4f7f8;\n  border: 1px solid #f8f9fa;\n\n  &.active {\n    background-color: #e6f7ff;\n    border-color: #1893ff;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  padding: 0.25rem;\n  justify-content: center;\n  align-items: center;\n  padding: 3px 6px;\n  gap: 4px;\n\n  outline: none;\n\n  color: #505050;\n  font-size: var(--font-size-14px, 14px);\n  font-weight: 400;\n  line-height: normal;\n  border-radius: 50px;\n  background: #f4f7f8;\n  border: 1px solid #f8f9fa;\n\n  &.active {\n    background-color: #e6f7ff;\n    border-color: #1893ff;\n  }\n"])));
var templateObject_1$8, templateObject_2$6, templateObject_3$6;

var MessageReport = function (props) {
  var isMine = props.isMine,
    message = props.message;
  var locale = useLocale().locale;
  var shareDocument = useContext(ChatContext).shareDocument;
  var data = JSON.parse(message.data || '{}');
  var isDisabled = useMemo(function () {
    if (!shareDocument) return true;
    return !shareDocument.checkJoinedProject(data.project_id);
  }, [shareDocument === null || shareDocument === void 0 ? void 0 : shareDocument.checkJoinedProject, data.project_id]);
  if (!shareDocument) {
    return jsx(MessageNotSupport, {
      isMine: isMine
    });
  }
  if (!(shareDocument === null || shareDocument === void 0 ? void 0 : shareDocument.onClickReport)) return jsx(MessageNotSupport, {
    isMine: isMine
  });
  return jsx(ShareDocumentCard, {
    isMine: isMine,
    projectId: data.project_id,
    thumbnailUrl: data.thumbnailUrl,
    title: "".concat(locale.extention_share_document_tab_report, " | ").concat(dayjs_minExports(data.workDate).locale(locale.dayjsLocale).format('ll')),
    description: data.content,
    onClick: function () {
      if (isDisabled) return;
      shareDocument.onClickReport(data);
    },
    style: {
      userSelect: isDisabled ? 'none' : 'auto'
    }
  });
};

var MessageRfi = function (props) {
  var isMine = props.isMine,
    message = props.message;
  var locale = useLocale().locale;
  var shareDocument = useContext(ChatContext).shareDocument;
  var data = JSON.parse(message.data || '{}');
  if (!shareDocument) {
    return jsx(MessageNotSupport, {
      isMine: isMine
    });
  }
  return jsx(ShareDocumentCard, {
    isMine: isMine,
    projectId: data.project_id,
    thumbnailUrl: data.thumbnailUrl,
    title: "".concat(locale.extention_share_document_tab_rfi, " | ").concat(data.title),
    description: sanitizeHtml(data.content || ''),
    onClick: function () {
      shareDocument.onClickRfi(data);
    }
  });
};

// THIS FILE IS AUTO GENERATED
var GenIcon = require$$0.GenIcon;
var AiOutlineCopy_1 = function AiOutlineCopy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
      }
    }]
  })(props);
};

var lib = {};

var uaParser_min = {exports: {}};

/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function (module, exports) {
  (function (window, undefined$1) {

    var LIBVERSION = "1.0.35",
      EMPTY = "",
      UNKNOWN = "?",
      FUNC_TYPE = "function",
      UNDEF_TYPE = "undefined",
      OBJ_TYPE = "object",
      STR_TYPE = "string",
      MAJOR = "major",
      MODEL = "model",
      NAME = "name",
      TYPE = "type",
      VENDOR = "vendor",
      VERSION = "version",
      ARCHITECTURE = "architecture",
      CONSOLE = "console",
      MOBILE = "mobile",
      TABLET = "tablet",
      SMARTTV = "smarttv",
      WEARABLE = "wearable",
      EMBEDDED = "embedded",
      UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon",
      APPLE = "Apple",
      ASUS = "ASUS",
      BLACKBERRY = "BlackBerry",
      BROWSER = "Browser",
      CHROME = "Chrome",
      EDGE = "Edge",
      FIREFOX = "Firefox",
      GOOGLE = "Google",
      HUAWEI = "Huawei",
      LG = "LG",
      MICROSOFT = "Microsoft",
      MOTOROLA = "Motorola",
      OPERA = "Opera",
      SAMSUNG = "Samsung",
      SHARP = "Sharp",
      SONY = "Sony",
      XIAOMI = "Xiaomi",
      ZEBRA = "Zebra",
      FACEBOOK = "Facebook",
      CHROMIUM_OS = "Chromium OS",
      MAC_OS = "Mac OS";
    var extend = function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }
        return mergedRegexes;
      },
      enumerize = function (arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      },
      has = function (str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      },
      lowerize = function (str) {
        return str.toLowerCase();
      },
      majorize = function (version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      },
      trim = function (str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };
    var rgxMapper = function (ua, arrays) {
        var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;
        while (i < arrays.length && !matches) {
          var regex = arrays[i],
            props = arrays[i + 1];
          j = k = 0;
          while (j < regex.length && !matches) {
            if (!regex[j]) {
              break;
            }
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      strMapper = function (str, map) {
        for (var i in map) {
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      },
      windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      };
    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [VERSION, [NAME, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i], [VERSION, [NAME, OPERA + " Mini"]], [/\bopr\/([\w\.]+)/i], [VERSION, [NAME, OPERA]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [VERSION, [NAME, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [VERSION, [NAME, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [VERSION, [NAME, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI " + BROWSER]], [/fxios\/([-\w\.]+)/i], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i], [[NAME, "360 " + BROWSER]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 " + BROWSER], VERSION], [/(comodo_dragon)\/([\w\.]+)/i], [[NAME, /_/g, " "], VERSION], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [NAME], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[NAME, FACEBOOK], VERSION], [/(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i], [VERSION, [NAME, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [VERSION, [NAME, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[ARCHITECTURE, "armhf"]], [/windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[ARCHITECTURE, lowerize]]],
      device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [/(pixel c)\b/i], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [/(playbook);[-\w\),; ]+(rim)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [/(nexus 9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/(shield[\w ]+) b/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/Hbbtv.*(technisat) (.*);/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[TYPE, SMARTTV]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [/((pebble))app/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [/droid.+; (glass) \d/i], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2| pro)?)/i], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [VENDOR, [TYPE, EMBEDDED]], [/(aeobc)\b/i], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [VERSION, NAME]],
      os: [[/microsoft (windows) (vista|xp)/i], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, strMapper, windowsVersionMap]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /ios;fbsv\/([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[NAME, MAC_OS], [VERSION, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [VERSION, NAME], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [NAME, VERSION], [/\(bb(10);/i], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [VERSION, [NAME, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [VERSION, [NAME, "watchOS"]], [/crkey\/([\d\.]+)/i], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[NAME, CHROMIUM_OS], VERSION], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [NAME, VERSION]]
    };
    var UAParser = function (ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }
      var _navigator = typeof window !== UNDEF_TYPE && window.navigator ? window.navigator : undefined$1;
      var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION]);
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = "Brave";
        }
        return _browser;
      };
      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }
        return _os;
      };
      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function () {
        return _ua;
      };
      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
    {
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA();
      };
      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser_min, uaParser_min.exports);

Object.defineProperty(lib, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = React__default$1;
var React__default = _interopDefault(React);
var UAParser = uaParser_min.exports;
var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }
  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};
var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };
    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };
    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };
    case DeviceTypes.Console:
      return {
        isConsole: true
      };
    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };
    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };
    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };
    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }
  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};
var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
    device = _ref.device,
    browser = _ref.browser,
    engine = _ref.engine,
    os = _ref.os,
    ua = _ref.ua;
  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
    isMobile = type.isMobile,
    isTablet = type.isTablet,
    isSmartTV = type.isSmartTV,
    isConsole = type.isConsole,
    isWearable = type.isWearable,
    isEmbedded = type.isEmbedded;
  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }
  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }
  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }
  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }
  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }
  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }
  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}
var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};
function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
    device = _ref.device,
    browser = _ref.browser,
    os = _ref.os,
    engine = _ref.engine,
    ua = _ref.ua;
  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}
var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }
  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
    device = _UAHelper$parseUserAg.device,
    browser = _UAHelper$parseUserAg.browser,
    os = _UAHelper$parseUserAg.os,
    engine = _UAHelper$parseUserAg.engine,
    ua = _UAHelper$parseUserAg.ua;
  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};
var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);
  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);
  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);
  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
    children = _ref4.children,
    props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);
  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
    children = _ref5.children,
    props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);
  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
    children = _ref6.children,
    props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);
  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
    children = _ref7.children,
    props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);
  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
    children = _ref8.children;
    _ref8.viewClassName;
    _ref8.style;
    var props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);
  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
    children = _ref9.children,
    props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);
  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
    children = _ref10.children,
    props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);
  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
    children = _ref11.children,
    props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);
  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
    children = _ref12.children;
    _ref12.viewClassName;
    _ref12.style;
    var condition = _ref12.condition,
    props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }
    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }
          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);
    return _class;
  }(React__default.Component);
}
function useMobileOrientation() {
  var _useState = React.useState(function () {
      var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
      return {
        isPortrait: orientation === 0,
        isLandscape: orientation === 90,
        orientation: orientation === 0 ? 'portrait' : 'landscape'
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }
    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}
function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}
function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}
lib.AndroidView = AndroidView;
lib.BrowserTypes = BrowserTypes;
lib.BrowserView = BrowserView;
lib.ConsoleView = ConsoleView;
lib.CustomView = CustomView;
lib.IEView = IEView;
lib.IOSView = IOSView;
lib.MobileOnlyView = MobileOnlyView;
lib.MobileView = MobileView;
lib.OsTypes = OsTypes;
lib.SmartTVView = SmartTVView;
lib.TabletView = TabletView;
lib.WearableView = WearableView;
lib.WinPhoneView = WinPhoneView;
lib.browserName = browserName;
lib.browserVersion = browserVersion;
lib.deviceDetect = deviceDetect;
lib.deviceType = deviceType;
lib.engineName = engineName;
lib.engineVersion = engineVersion;
lib.fullBrowserVersion = fullBrowserVersion;
lib.getSelectorsByUserAgent = getSelectorsByUserAgent;
lib.getUA = getUA;
lib.isAndroid = isAndroid;
lib.isBrowser = isBrowser;
lib.isChrome = isChrome;
lib.isChromium = isChromium;
lib.isConsole = isConsole;
lib.isDesktop = isDesktop;
lib.isEdge = isEdge;
lib.isEdgeChromium = isEdgeChromium;
lib.isElectron = isElectron;
lib.isEmbedded = isEmbedded;
lib.isFirefox = isFirefox;
lib.isIE = isIE;
lib.isIOS = isIOS;
lib.isIOS13 = isIOS13;
lib.isIPad13 = isIPad13;
lib.isIPhone13 = isIPhone13;
lib.isIPod13 = isIPod13;
lib.isLegacyEdge = isLegacyEdge;
lib.isMIUI = isMIUI;
lib.isMacOs = isMacOs;
var isMobile_1 = lib.isMobile = isMobile;
lib.isMobileOnly = isMobileOnly;
lib.isMobileSafari = isMobileSafari;
lib.isOpera = isOpera;
lib.isSafari = isSafari;
lib.isSamsungBrowser = isSamsungBrowser;
lib.isSmartTV = isSmartTV;
lib.isTablet = isTablet;
lib.isWearable = isWearable;
lib.isWinPhone = isWinPhone;
lib.isWindows = isWindows;
lib.isYandex = isYandex;
lib.mobileModel = mobileModel;
lib.mobileVendor = mobileVendor;
lib.osName = osName;
lib.osVersion = osVersion;
lib.parseUserAgent = parseUserAgent;
lib.setUserAgent = setUserAgent;
lib.useDeviceData = useDeviceData;
lib.useDeviceSelectors = useDeviceSelectors;
lib.useMobileOrientation = useMobileOrientation;
lib.withOrientationChange = withOrientationChange;

var SAMPLE_EMOJI_LIST = ['2705', '1f440', '1f44d', '1f601', '1f60d', '1f4af'];
var MessageTools = function (props) {
  var message = props.message,
    messageRef = props.messageRef,
    isHovering = props.isHovering,
    isMyMessage = props.isMyMessage,
    openContextMenu = props.openContextMenu,
    canReply = props.canReply,
    onChangeOpenContextMenu = props.onChangeOpenContextMenu,
    onApplyReaction = props.onApplyReaction,
    onDelete = props.onDelete,
    onReply = props.onReply;
  var _a = useState(240),
    referenceWidth = _a[0],
    setReferenceWidth = _a[1];
  var _b = useState(false),
    showDeleteConfirm = _b[0],
    setShowDeleteConfirm = _b[1];
  var isMobileViewport = useIsMobile();
  useRef(null);
  var _c = useFloating({
      open: openContextMenu,
      onOpenChange: onChangeOpenContextMenu,
      placement: isMyMessage ? 'top-end' : 'top-start',
      middleware: [offset(6), flip(), shift(), size({
        apply: function (_a) {
          var rects = _a.rects;
          setReferenceWidth(rects.reference.width);
        }
      })],
      whileElementsMounted: autoUpdate
    }),
    refs = _c.refs,
    floatingStyles = _c.floatingStyles,
    context = _c.context,
    placement = _c.placement;
  useEffect(function () {
    if (!(messageRef === null || messageRef === void 0 ? void 0 : messageRef.current)) return;
    refs.setPositionReference(messageRef === null || messageRef === void 0 ? void 0 : messageRef.current);
  }, [messageRef]);
  var dismiss = useDismiss(context);
  var getFloatingProps = useInteractions([dismiss]).getFloatingProps;
  var render = function () {
    /**
     * 모바일일 때에는 별도의 기능 동작
     * 이때 실제로 디바이스가 모바일 때, 크기가 모바일일 때를 모두 체크한다.
     */
    if (isMobile_1 || isMobileViewport) return jsx(CSSTransition, {
      nodeRef: refs.floating,
      in: openContextMenu,
      timeout: 200,
      unmountOnExit: true,
      children: jsx(ContextMenu, __assign$1({}, getFloatingProps({
        ref: refs.setFloating,
        style: __assign$1(__assign$1({}, floatingStyles), {
          width: referenceWidth
        })
      }), {
        children: jsxs("div", {
          "data-placement": placement,
          "data-is-mine": isMyMessage,
          className: "context-menu-dialog",
          children: [jsxs(Menu, {
            children: [canReply && jsx("li", {
              children: jsxs("a", {
                onClick: onReply,
                children: [IconReply, jsx("span", {
                  children: "\uB2F5\uAE00 \uB2EC\uAE30"
                })]
              })
            }), jsx("li", {
              children: jsx(ReactionPicker, {
                onApplyReaction: function () {
                  var args = [];
                  for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                  }
                  onApplyReaction.apply(void 0, args);
                  onChangeOpenContextMenu === null || onChangeOpenContextMenu === void 0 ? void 0 : onChangeOpenContextMenu(false);
                },
                children: jsxs("a", {
                  children: [IconAddEmoji, jsx("span", {
                    children: "\uCD94\uAC00 \uC774\uBAA8\uD2F0\uCF58"
                  })]
                })
              })
            }), (isMobile_1 || isMobileViewport) && jsx("li", {
              children: jsxs("a", {
                onClick: function () {
                  navigator.clipboard.writeText(message || '').then(function () {
                    message$1.success('메시지가 복사되었습니다.');
                    onChangeOpenContextMenu === null || onChangeOpenContextMenu === void 0 ? void 0 : onChangeOpenContextMenu(false);
                  }).catch(function (error) {
                    console.log(error);
                  });
                },
                children: [jsx(AiOutlineCopy_1, {
                  size: "20px"
                }), jsx("span", {
                  children: "\uBA54\uC2DC\uC9C0 \uBCF5\uC0AC"
                })]
              })
            }), isMyMessage && jsx("li", {
              children: jsxs("a", {
                onClick: function () {
                  return setShowDeleteConfirm(true);
                },
                style: {
                  color: '#FF6661'
                },
                children: [IconDelete, jsx("span", {
                  children: "\uBA54\uC2DC\uC9C0 \uC0AD\uC81C"
                })]
              })
            })]
          }), jsx(MobileEmojiList, {
            children: SAMPLE_EMOJI_LIST.map(function (unified) {
              return jsx("li", {
                children: jsx("a", {
                  onClick: function () {
                    onApplyReaction('add', unified);
                    onChangeOpenContextMenu === null || onChangeOpenContextMenu === void 0 ? void 0 : onChangeOpenContextMenu(false);
                  },
                  children: jsx(ExportedEmoji, {
                    emojiStyle: EmojiStyle.TWITTER,
                    unified: unified,
                    size: 20
                  })
                })
              }, unified);
            })
          })]
        })
      }))
    });
    return jsx(Fragment, {
      children: jsxs(FloatingPopup, {
        className: classNames({
          active: isHovering,
          'is-mine': isMyMessage
        }),
        children: [canReply && jsx("button", {
          onClick: onReply,
          children: IconReply
        }), __spreadArray([], Array(3), true).map(function (_, index) {
          var unified = SAMPLE_EMOJI_LIST[index];
          return jsx("button", {
            onClick: function () {
              return onApplyReaction('add', unified);
            },
            children: jsx(ExportedEmoji, {
              emojiStyle: EmojiStyle.TWITTER,
              unified: unified,
              size: 20
            })
          }, unified);
        }), jsx(ReactionPicker, {
          onApplyReaction: onApplyReaction,
          children: jsx("button", {
            children: IconAddEmoji
          })
        }), isMyMessage && jsx("button", {
          style: {
            color: '#FF6661'
          },
          onClick: function () {
            return setShowDeleteConfirm(true);
          },
          children: IconDelete
        })]
      })
    });
  };
  return jsxs(Fragment, {
    children: [jsx(Confirm, {
      open: showDeleteConfirm,
      type: "danger",
      title: "\uBA54\uC2DC\uC9C0\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
      onOk: onDelete,
      onCancel: function () {
        return setShowDeleteConfirm(false);
      }
    }), render()]
  });
};
var FloatingPopup = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  bottom: 1px;\n  z-index: 1;\n\n  display: flex;\n  padding: 2px;\n  gap: 8px;\n\n  &.is-mine {\n    left: auto;\n    right: 0;\n  }\n\n  border-radius: 6px;\n  background: rgba(248, 249, 250, 0.584);\n\n  transition: 150ms ease;\n  opacity: 0;\n\n  &.active {\n    opacity: 1;\n  }\n\n  & > button {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    width: 28px;\n    height: 28px;\n\n    color: #404040;\n    font-size: 20px;\n\n    border: none;\n    outline: none;\n    background: none;\n    border-radius: 4px;\n\n    transition: 250ms ease;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  bottom: 1px;\n  z-index: 1;\n\n  display: flex;\n  padding: 2px;\n  gap: 8px;\n\n  &.is-mine {\n    left: auto;\n    right: 0;\n  }\n\n  border-radius: 6px;\n  background: rgba(248, 249, 250, 0.584);\n\n  transition: 150ms ease;\n  opacity: 0;\n\n  &.active {\n    opacity: 1;\n  }\n\n  & > button {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    width: 28px;\n    height: 28px;\n\n    color: #404040;\n    font-size: 20px;\n\n    border: none;\n    outline: none;\n    background: none;\n    border-radius: 4px;\n\n    transition: 250ms ease;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n  }\n"])));
var ContextMenu = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  z-index: 100;\n  min-width: 240px;\n  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.15));\n\n  .context-menu-dialog {\n    &[data-placement='top-start'],\n    &[data-placement='top-end'] {\n      transform-origin: left bottom;\n      &[data-is-mine='true'] {\n        transform-origin: right bottom;\n      }\n    }\n    &[data-placement='bottom-start'],\n    &[data-placement='bottom-end'] {\n      transform-origin: left top;\n      &[data-is-mine='true'] {\n        transform-origin: right top;\n      }\n    }\n  }\n\n  &.enter {\n    opacity: 0;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(5px);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-5px);\n      }\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(5px);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-5px);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n"], ["\n  z-index: 100;\n  min-width: 240px;\n  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1)) drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.15));\n\n  .context-menu-dialog {\n    &[data-placement='top-start'],\n    &[data-placement='top-end'] {\n      transform-origin: left bottom;\n      &[data-is-mine='true'] {\n        transform-origin: right bottom;\n      }\n    }\n    &[data-placement='bottom-start'],\n    &[data-placement='bottom-end'] {\n      transform-origin: left top;\n      &[data-is-mine='true'] {\n        transform-origin: right top;\n      }\n    }\n  }\n\n  &.enter {\n    opacity: 0;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(5px);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-5px);\n      }\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(1) translateY(0);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(1) translateY(0);\n      }\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    .context-menu-dialog {\n      &[data-placement='top-start'],\n      &[data-placement='top-end'] {\n        transform: scale(0.9, 0.95) translateY(5px);\n      }\n      &[data-placement='bottom-start'],\n      &[data-placement='bottom-end'] {\n        transform: scale(0.9, 0.95) translateY(-5px);\n      }\n      transition: transform 200ms ease;\n    }\n  }\n"])));
var Menu = styled.ul(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 4px;\n  background: #ffffff;\n  overflow: hidden;\n\n  & > li {\n    &:not(:last-of-type) {\n      border-bottom: 1px solid #eeeeee;\n    }\n    & > a {\n      display: flex;\n      align-items: center;\n      height: 48px;\n      padding: 0 1rem;\n      gap: 6px;\n\n      color: #505050;\n      font-size: var(--font-size-16, 16px);\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: -0.32px;\n\n      transition: 250ms ease;\n\n      &:hover {\n        background: rgba(0 0 0 / 5%);\n      }\n    }\n  }\n"], ["\n  position: relative;\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  border-radius: 4px;\n  background: #ffffff;\n  overflow: hidden;\n\n  & > li {\n    &:not(:last-of-type) {\n      border-bottom: 1px solid #eeeeee;\n    }\n    & > a {\n      display: flex;\n      align-items: center;\n      height: 48px;\n      padding: 0 1rem;\n      gap: 6px;\n\n      color: #505050;\n      font-size: var(--font-size-16, 16px);\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      letter-spacing: -0.32px;\n\n      transition: 250ms ease;\n\n      &:hover {\n        background: rgba(0 0 0 / 5%);\n      }\n    }\n  }\n"])));
var MobileEmojiList = styled.ul(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  list-style: none;\n\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 6px;\n  margin: 4px 0 0;\n  gap: 2px;\n  border-radius: 6px;\n  background: #f8f9fa;\n\n  & > li {\n    & > a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 36px;\n      height: 36px;\n      padding: 0;\n      border-radius: 4px;\n\n      transition: 150ms ease;\n\n      &:hover {\n        background: rgba(0 0 0 / 10%);\n      }\n    }\n  }\n"], ["\n  list-style: none;\n\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 6px;\n  margin: 4px 0 0;\n  gap: 2px;\n  border-radius: 6px;\n  background: #f8f9fa;\n\n  & > li {\n    & > a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 36px;\n      height: 36px;\n      padding: 0;\n      border-radius: 4px;\n\n      transition: 150ms ease;\n\n      &:hover {\n        background: rgba(0 0 0 / 10%);\n      }\n    }\n  }\n"])));
var templateObject_1$7, templateObject_2$5, templateObject_3$5, templateObject_4$4;

var Message = memo(function (props) {
  var userId = props.userId,
    channel = props.channel,
    message = props.message,
    ogMetaData = props.ogMetaData,
    isPrevMessageHasSameSender = props.isPrevMessageHasSameSender,
    isNextMessageHasSameCreatedAt = props.isNextMessageHasSameCreatedAt,
    onClickImage = props.onClickImage,
    onClickReply = props.onClickReply,
    renderCustomMessage = props.renderCustomMessage;
  var locale = useContext(ChatRootContext).locale;
  var _a = useContext(MessageSelectContext),
    enabled = _a.enabled,
    startAt = _a.startAt,
    endAt = _a.endAt,
    selectedMessageIds = _a.selectedMessageIds,
    setStartAt = _a.setStartAt,
    setEndAt = _a.setEndAt;
  var _b = useState(false),
    showUserProfile = _b[0],
    setShowUserProfile = _b[1];
  var _c = useState(false),
    openContextMenu = _c[0],
    setOpenContextMenu = _c[1];
  var _d = useState(false),
    setForceRerenderState = _d[1];
  var isMobile = useIsMobile();
  var contentRef = useRef(null);
  var messageRef = useRef(null);
  var isHovering = useHover(contentRef);
  useLongPress(function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    setOpenContextMenu(true);
  }, messageRef, {
    moveThreshold: {
      x: 10,
      y: 10
    }
  });
  var sender = useMemo(function () {
    var userMessage = message;
    return userMessage.sender;
  }, [JSON.stringify(message)]);
  var isMine = useMemo(function () {
    return userId === (sender === null || sender === void 0 ? void 0 : sender.userId);
  }, [userId, sender === null || sender === void 0 ? void 0 : sender.userId]);
  /**
   * 실제 메시지 영역에 표시될 메시지 콘텐츠를 렌더링합니다.
   * 여기서 이야기하는 메시지 콘텐츠는 일반적인 말풍선 뿐만 아니라 메시지 카드,
   * 파일, 이미지, 링크 등과 커스텀 메시지의 렌더링 요소를 포함합니다.
   * @returns
   */
  var renderContent = function () {
    if (message.isFileMessage && message.isFileMessage()) {
      return jsx(MessageFile, {
        message: message,
        onClickImage: onClickImage
      });
    }
    if (!message.isUserMessage || !message.isUserMessage()) {
      return jsx(MessageNotSupport, {
        isMine: isMine
      });
    }
    var genCustomMessage = function () {
      switch (message.customType) {
        case 'share-report':
          return jsx(MessageReport, {
            message: message,
            isMine: isMine
          });
        case 'share-rfi':
          return jsx(MessageRfi, {
            message: message,
            isMine: isMine
          });
        case 'share-minutes':
          return jsx(MessageMinutes, {
            message: message,
            isMine: isMine
          });
        case 'multiple-image':
          return jsx(MessageMultipleImage, {
            message: message
          });
        default:
          return jsx(MessageNotSupport, {
            isMine: isMine
          });
      }
    };
    if (message.data && message.customType) {
      var originMessageDOM = genCustomMessage();
      if (renderCustomMessage) {
        return renderCustomMessage(originMessageDOM, message, isMine);
      }
      return originMessageDOM;
    }
    return jsx(MessageNormal, {
      isMine: isMine,
      text: message.message,
      ogMetaData: ogMetaData,
      parrentMessage: message.parentMessage
    });
  };
  /**
   * 이 메시지를 안읽은 사용자 수
   */
  var unreadMemberCount = channel.getUnreadMemberCount(message);
  /**
   * GPT 기능과 관련한 기능으로 메시지의 선택 여부를 결정합니다.
   */
  var isSelected = useMemo(function () {
    return !!selectedMessageIds.find(function (id) {
      return id === message.messageId;
    });
  }, [selectedMessageIds, message.messageId]);
  /**
   * 특수한 상황에 표시되는 커스텀화된 시스템 메시지입니다.
   * 아래의 경우 초대된 사용자를 표시합니다.
   */
  if ((message === null || message === void 0 ? void 0 : message.isUserMessage()) && message.customType === 'invite') {
    return jsxs(MessageSystemBlock, {
      children: [locale.channel_member_invite_message_format.replace('{{inviter}}', sender.nickname).replace('{{members}}', message.data || ''), enabled && jsx(MessageSelectModeCover, {})]
    });
  }
  /**
   * 사옹자가 채팅방에 나갔을 경우 표시되는 메시지입니다.
   */
  if ((message === null || message === void 0 ? void 0 : message.isUserMessage()) && message.customType === 'leave') {
    return jsxs(MessageSystemBlock, {
      children: [locale.channel_member_leave_message_format.replace('{{name}}', sender.nickname), enabled && jsx(MessageSelectModeCover, {})]
    });
  }
  /**
   * 채팅 참여자를 퇴출시켰을 때 메시지입니다.
   */
  if ((message === null || message === void 0 ? void 0 : message.isUserMessage()) && message.customType === 'member-remove') {
    return jsxs(MessageSystemBlock, {
      children: [locale.channel_member_remove_message_format.replace('{{operator}}', sender.nickname).replace('{{name}}', message.data || ''), enabled && jsx(MessageSelectModeCover, {})]
    });
  }
  /**
   * 어드민 메시지입니다.
   */
  if ((message === null || message === void 0 ? void 0 : message.isAdminMessage) && (message === null || message === void 0 ? void 0 : message.isAdminMessage())) {
    return jsxs(MessageSystemBlock, {
      children: [message.message, enabled && jsx(MessageSelectModeCover, {})]
    });
  }
  /**
   * GPT 기능과 관련된 것으로 메시지 선택 기능을 지원합니다.
   */
  var handleSelectMessage = function () {
    // 시작지점이 없을 경우 현재 메시지부터 시작 지점으로 설정
    if (!startAt) {
      setStartAt(message.createdAt);
      return;
    }
    // 시작지점은 있지만 종료 지점이 없는 경우
    if (!endAt) {
      /**
       * 현재 메시지가 시작지점보다 이전인 경우
       * 현재 메시지를 시작지점으로 설정
       */
      if (startAt > message.createdAt) {
        setStartAt(message.createdAt);
        return;
      }
      // 현재 메시지를 종료 지점으로 설정
      setEndAt(message.createdAt);
      return;
    }
    // 시작지점과 종료지점이 모두 설정되어 있는 경우
    /**
     * 현재 메시지가 시작지점보다 이전일 경우
     * 시작지점을 해당 메시지로 변경
     */
    if (startAt > message.createdAt) {
      setStartAt(message.createdAt);
      return;
    }
    /**
     * 현재 메시지가 종료지점보다 이후일 경우
     * 종료지점을 해당 메시지로 변경
     */
    if (endAt < message.createdAt) {
      setEndAt(message.createdAt);
      return;
    }
    /**
     * 현재 메시지가 선택 영역 안쪽일 경우
     * 모든 값을 초기화하고 현재 메시지를 시작 지점으로 설정
     */
    setStartAt(message.createdAt);
    setEndAt(null);
  };
  var handleDelete = function () {
    channel.deleteMessage(message);
  };
  var handleReaction = function (type, emojiKey) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var reactionEvent, reactionEvent;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(type === 'add')) return [3 /*break*/, 2];
            return [4 /*yield*/, channel.addReaction(message, emojiKey)];
          case 1:
            reactionEvent = _a.sent();
            message.applyReactionEvent(reactionEvent);
            // 리액션 값을 변경할 때 강제 리렌더링한다.
            setForceRerenderState(function (prev) {
              return !prev;
            });
            return [3 /*break*/, 4];
          case 2:
            return [4 /*yield*/, channel.deleteReaction(message, emojiKey)];
          case 3:
            reactionEvent = _a.sent();
            message.applyReactionEvent(reactionEvent);
            // 리액션 값을 변경할 때 강제 리렌더링한다.
            setForceRerenderState(function (prev) {
              return !prev;
            });
            _a.label = 4;
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };

  var renderSub = function () {
    // 전송 중 메시지 표시
    if ((message === null || message === void 0 ? void 0 : message.sendingStatus) === 'pending') {
      return jsx(Spinner, {});
    }
    return jsxs(Box, {
      position: "relative",
      children: [jsx(MessageTools, {
        message: message.message,
        messageRef: messageRef,
        isHovering: isHovering,
        isMyMessage: isMine,
        openContextMenu: openContextMenu,
        onApplyReaction: handleReaction,
        onChangeOpenContextMenu: setOpenContextMenu,
        onDelete: handleDelete,
        canReply: !message.parentMessageId,
        onReply: onClickReply
      }), (!isHovering || isMobile) && jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: isMine ? 'flex-end' : 'flex-start',
        lineHeight: 1.3,
        pb: "3px",
        children: [message.channelUrl === (channel === null || channel === void 0 ? void 0 : channel.url) && jsx(Box, {
          color: "var(--chat-color-secondary)",
          fontWeight: 500,
          fontSize: "10px",
          children: unreadMemberCount || ''
        }), !isNextMessageHasSameCreatedAt && jsx(Box, {
          color: "#7F8892",
          fontSize: "12px",
          children: dayjs_minExports(message.createdAt).locale(locale.dayjsLocale).format('LT')
        })]
      })]
    });
  };
  return jsxs(Fragment, {
    children: [jsxs(MessageRow, {
      className: "chat-message-row",
      "data-message-id": message.messageId,
      "data-timestamp": message.createdAt,
      style: {
        paddingBottom: message.isFileMessage() ? '0.75rem' : ''
      },
      children: [enabled && jsx(Fragment, {
        children: jsxs(MessageSelectArea, {
          className: classNames({
            selected: isSelected,
            start: startAt === message.createdAt,
            end: endAt === message.createdAt
          }),
          style: {
            zIndex: endAt === message.createdAt ? 11 : undefined
          },
          onClick: handleSelectMessage,
          children: [startAt === message.createdAt && jsx(MessageSelectAreaBadgeTop, {
            children: locale.extention_gpt_message_select_start
          }), endAt === message.createdAt && jsx(MessageSelectAreaBadgeBottom, {
            children: locale.extention_gpt_message_select_end
          })]
        })
      }), !isMine && jsx(AvatarArea, {
        children: !isPrevMessageHasSameSender && jsx("div", {
          onClick: function () {
            return setShowUserProfile(true);
          },
          children: jsx(Avatar, {
            src: (sender === null || sender === void 0 ? void 0 : sender.plainProfileUrl) || undefined,
            name: sender === null || sender === void 0 ? void 0 : sender.nickname,
            style: {
              boxShadow: '0 0 0 1px rgb(0 0 0 / 10%) inset'
            }
          })
        })
      }), jsxs(MessageArea, {
        children: [!isPrevMessageHasSameSender && !isMine && jsx(Box, {
          color: "#2C384A",
          fontSize: "1rem",
          fontWeight: 400,
          lineHeight: "20px",
          my: "8px",
          children: sender === null || sender === void 0 ? void 0 : sender.nickname
        }), jsxs(MessageContents, {
          ref: contentRef,
          isMine: isMine,
          children: [jsx(Box, {
            ref: messageRef,
            onContextMenu: function (e) {
              e.preventDefault();
              e.stopPropagation();
              setOpenContextMenu(true);
            },
            children: renderContent()
          }), renderSub()]
        }), jsx(MessageReactions, {
          isMyMessage: isMine,
          currentUserId: userId,
          reactions: message.reactions,
          onApplyReaction: handleReaction
        })]
      })]
    }), showUserProfile && jsx(ChannelUserProfile, {
      channel: channel,
      user: message === null || message === void 0 ? void 0 : message.sender,
      onClose: function () {
        return setShowUserProfile(false);
      }
    })]
  });
}, function (prev, next) {
  if (JSON.stringify(prev.channel) !== JSON.stringify(prev.channel)) return false;
  if (JSON.stringify(prev.message) !== JSON.stringify(prev.message)) return false;
  if (JSON.stringify(prev.ogMetaData) !== JSON.stringify(prev.ogMetaData)) return false;
  if (JSON.stringify(prev.message.reactions) !== JSON.stringify(next.message.reactions)) return false;
  return prev.userId === next.userId && prev.isNextMessageHasSameCreatedAt === next.isPrevMessageHasSameSender && prev.onClickImage === next.onClickImage && prev.onClickReply === next.onClickReply;
});
Message.displayName = 'Message';

var genMessagesByDate = function (messages) {
  var groupedObject = groupBy_1(messages, function (item) {
    return dayjs_minExports(item.createdAt).format('YYYY-MM-DD');
  });
  return Object.entries(groupedObject).map(function (_a) {
    var date = _a[0],
      _messages = _a[1];
    return {
      date: date,
      messages: _messages
    };
  });
};
/**
 * 메시지 컴포넌트를 데이터에 맞게 생성합니다.
 */
var messageRenderrer = function (userId, channel, message, index, _messages, onClickReply, onClickImage, renderCustomMessage) {
  var _a, _b;
  var prevMessage = _messages === null || _messages === void 0 ? void 0 : _messages[index - 1];
  var currentMessageUserId = (_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId;
  var prevMessageUserId = (_b = prevMessage === null || prevMessage === void 0 ? void 0 : prevMessage.sender) === null || _b === void 0 ? void 0 : _b.userId;
  var isPrevMessageHasSameSender = prevMessageUserId === currentMessageUserId;
  /**
   * 이전 메시지가 시스템 메시지 형태의 커스텀 메시지일 경우
   */
  var isPevMessageIsSystemMessage = (prevMessage === null || prevMessage === void 0 ? void 0 : prevMessage.customType) ? ['invite', 'leave', 'member-remove'].includes(prevMessage.customType) : false;
  var isPrevMessageHasSameCreatedAt = dayjs_minExports(prevMessage === null || prevMessage === void 0 ? void 0 : prevMessage.createdAt).isSame(message === null || message === void 0 ? void 0 : message.createdAt, 'minute');
  var nextMessage = _messages === null || _messages === void 0 ? void 0 : _messages[index + 1];
  var isNextMessageHasSameCreatedAt = nextMessage ? dayjs_minExports(nextMessage === null || nextMessage === void 0 ? void 0 : nextMessage.createdAt).isSame(message === null || message === void 0 ? void 0 : message.createdAt, 'minute') : false;
  return jsx(Message, {
    userId: userId,
    channel: channel,
    message: message,
    ogMetaData: message.ogMetaData,
    isPrevMessageHasSameSender: isPrevMessageHasSameSender && isPrevMessageHasSameCreatedAt && !isPevMessageIsSystemMessage,
    isNextMessageHasSameCreatedAt: isPrevMessageHasSameSender && isNextMessageHasSameCreatedAt,
    onClickImage: onClickImage,
    renderCustomMessage: renderCustomMessage,
    onClickReply: onClickReply
  }, message.messageId);
};

var MessageListLoading = function () {
  return jsx(Box, {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    color: "#40a9ff",
    fontSize: "3rem",
    background: "var(--chat-channel-background)",
    children: jsx(Spinner, {})
  });
};

var MessageListSearchHeader = function (props) {
  var searchQuery = props.searchQuery;
  var locale = useContext(ChatRootContext).locale;
  useTranslation().t;
  return jsx(Header$1, {
    children: locale.search_result_title.replace('{{search_query}}', searchQuery || '')
  });
};
var Header$1 = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 44px;\n  padding: 0 24px;\n  color: #414c5c;\n  font-weight: 400;\n  font-size: 0.875rem;\n  text-align: center;\n  letter-spacing: -0.02em;\n  border-bottom: 1px solid #eeeeee;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 44px;\n  padding: 0 24px;\n  color: #414c5c;\n  font-weight: 400;\n  font-size: 0.875rem;\n  text-align: center;\n  letter-spacing: -0.02em;\n  border-bottom: 1px solid #eeeeee;\n"])));
var templateObject_1$6;

var OFFSET_TO_START_LOADING_DATA = 500;
var DELAY_UPDATE_FIRST_TIME_SCROLL = 300;
var ChannelConversation = function (props) {
  var messages = props.messages,
    loading = props.loading,
    onClickImage = props.onClickImage,
    args = __rest$2(props, ["messages", "loading", "onClickImage"]);
  useTranslation('project_chat').t;
  var userId = useContext(ChatRootContext).userId;
  var _a = useContext(ChannelContext),
    channel = _a.channel,
    setParentMessage = _a.setParentMessage,
    searchQuery = _a.searchQuery;
  var renderCustomMessage = useContext(ChatContext).renderCustomMessage;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var filteredMessages = useMemo(function () {
    return uniqBy_1(messages, 'messageId');
  }, [messages]);
  var groupedMessagesByDay = useMemo(function () {
    return genMessagesByDate(filteredMessages);
  }, [filteredMessages]);
  if (loading || messageDataSource.refreshing) {
    return jsx(MessageListLoading, {});
  }
  if (!messages.length) return jsx(Box, {
    flex: 1
  });
  return jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      position: 'relative'
    },
    children: [!!searchQuery && jsx(MessageListSearchHeader, {
      searchQuery: searchQuery
    }), jsx(ChannelConversationScroll, __assign$1({}, args, {
      children: groupedMessagesByDay.map(function (_a) {
        var date = _a.date,
          messages = _a.messages;
        return jsxs(MessageRowWrap, {
          className: "chat-message-row-wrap",
          children: [jsx(ChannelSeperator, {
            date: date
          }), messages.map(function (message, index) {
            if (!userId || !channel) return null;
            var onClickReply = function () {
              setParentMessage(message);
            };
            return messageRenderrer(userId, channel, message, index, messages, onClickReply, onClickImage, renderCustomMessage);
          })]
        }, date);
      })
    })), jsx(FloatingScrollDownButton, {})]
  });
};
/**
 * 대화 영역의 스크롤을 관장하는 컴포넌트입니다.
 * children prop을 통해 메시지 컴포넌트를 받을 수 있습니다.
 *
 * 왜 이렇게 설계하나요?
 * - 컴포넌트 안에 또 다른 컴포넌트를 렌더링하는 것과
 * children prop을 통해 자식 컴포넌트를 받아서 렌더링하는 것은
 * 효율의 차이가 있습니다. 쉽게 말해서 이렇게 할 경우
 * 부모 컴포넌트가 리렌더링되더라도 props로 전달 받은 children은
 * 리렌더링되지 않게할 수 있습니다.
 *
 * @param props
 * @returns
 */
var ChannelConversationScroll = memo(function (props) {
  var children = props.children,
    scrollRef = props.scrollRef,
    highlightMessageTimestamp = props.highlightMessageTimestamp;
  var _a = useContext(ChannelContext),
    channelWrapRef = _a.channelWrapRef,
    messageListRef = _a.messageListRef,
    searchWithTimestamp = _a.searchWithTimestamp;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var hasPrevious = messageDataSource.hasPrevious();
  var hasNext = messageDataSource.hasNext();
  var messagesRef = useRef(null);
  var channelWrapSize = useSize(channelWrapRef);
  useSize(messageListRef);
  var _b = useState(true),
    isFirstScroll = _b[0],
    setIsFirstScroll = _b[1];
  var lastRenderMesssages = useRef(messageDataSource.messages);
  var previousScrollPosition = useRef(0);
  var _c = useState(false),
    isScrollBottomReached = _c[0],
    setIsScrollBottomReached = _c[1];
  useLayoutEffect(function () {
    setIsFirstScroll(true);
  }, [searchWithTimestamp]);
  useMemo(function () {
    var container = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (!container) {
      return;
    }
    previousScrollPosition.current = container.scrollHeight - container.scrollTop;
  }, [messageDataSource.messages]);
  useLayoutEffect(function () {
    var _a, _b;
    var container = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (!container || messageDataSource.loading) {
      lastRenderMesssages.current = messageDataSource.messages;
      return;
    }
    if (isFirstScroll) {
      if (highlightMessageTimestamp) {
        var messageEle = container.querySelector(".chat-message-row[data-timestamp=\"".concat(highlightMessageTimestamp, "\"]"));
        if (messageEle) {
          messageEle.scrollIntoView({
            behavior: 'instant',
            block: 'center'
          });
          highlightMessageElement(messageEle);
          messageEle.style.background = 'rgba(255 255 255 / 30%)';
        } else {
          container.scrollTop = container.scrollHeight - previousScrollPosition.current;
        }
      } else {
        container.scrollTop = container.scrollHeight - previousScrollPosition.current;
      }
      setTimeout(function () {
        setIsFirstScroll(false);
      }, DELAY_UPDATE_FIRST_TIME_SCROLL);
    } else if (((_a = lastRenderMesssages.current[0]) === null || _a === void 0 ? void 0 : _a.messageId) !== ((_b = messageDataSource.messages[0]) === null || _b === void 0 ? void 0 : _b.messageId)) {
      container.scrollTop = container.scrollHeight - previousScrollPosition.current;
    }
    lastRenderMesssages.current = messageDataSource.messages;
  }, [messageDataSource.messages, searchWithTimestamp]);
  var handleOnScroll = useCallback(debounce$1.exports(function (e) {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var container, error_1, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (messageDataSource.loading) {
              return [2 /*return*/];
            }

            container = e.target;
            if (!(messageDataSource.hasPrevious() && container.scrollTop <= OFFSET_TO_START_LOADING_DATA)) return [3 /*break*/, 4];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, messageDataSource.loadPrevious()];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            console.error(error_1);
            return [3 /*break*/, 4];
          case 4:
            if (container.scrollTop + container.offsetHeight >= container.scrollHeight) {
              setIsScrollBottomReached(true);
            }
            if (!(messageDataSource.hasNext() && container.scrollTop + container.offsetHeight >= container.scrollHeight - OFFSET_TO_START_LOADING_DATA)) return [3 /*break*/, 8];
            _a.label = 5;
          case 5:
            _a.trys.push([5, 7,, 8]);
            return [4 /*yield*/, messageDataSource.loadNext()];
          case 6:
            _a.sent();
            return [3 /*break*/, 8];
          case 7:
            error_2 = _a.sent();
            console.error(error_2);
            return [3 /*break*/, 8];
          case 8:
            return [2 /*return*/];
        }
      });
    });
  }, 100), [hasPrevious, hasNext, messageDataSource.loading]);
  /**
   * 채널 영역의 크기에 따라 메시지 크기를 조절합니다.
   */
  var messageMaxWidth = useMemo(function () {
    var width = (channelWrapSize === null || channelWrapSize === void 0 ? void 0 : channelWrapSize.width) || 0;
    if (width > breakPoint.medium) return '300px';
    if (width > breakPoint.small) return '250px';
    return '200px';
  }, [channelWrapSize === null || channelWrapSize === void 0 ? void 0 : channelWrapSize.width]);
  /**
   * 스크롤이 최하단에 있고, 다음 메시지가 더이상 없다면 메시지 목록에 변화가 있을 때 스크롤이
   * 최하단 상태를 계속 유지할 수 있도록 합니다.
   */
  useSaveScrollPosition(scrollRef, !isScrollBottomReached || hasNext);
  return jsx(MessageListWrap, {
    ref: messageListRef,
    className: "chat-message-list",
    children: jsx(ChannelScrollArea, {
      ref: scrollRef,
      onScroll: handleOnScroll,
      style: {
        '--chat-message-max-width': messageMaxWidth
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      },
      children: jsx(Image.PreviewGroup, __assign$1({}, {
        children: jsx("div", {
          ref: messagesRef,
          className: "chat-conversation-messages",
          children: children
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }))
    })
  });
});

ChannelConversationScroll.displayName = 'Channel.ConversationScroll';
var MessageListWrap = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--chat-channel-background);\n"], ["\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--chat-channel-background);\n"])));
var templateObject_1$5;

var Channel = function (props) {
  var channelUrl = useContext(ChatContext).channelUrl;
  var _a = useState({
      searchQuery: props.searchQuery,
      searchWithTimestamp: props.searchWithTimestamp
    }),
    _searchPayload = _a[0],
    _setSearchPayload = _a[1];
  useEffect(function () {
    _setSearchPayload({
      searchQuery: props.searchQuery,
      searchWithTimestamp: props.searchWithTimestamp
    });
  }, [props.searchQuery, props.searchWithTimestamp]);
  /**
   * channelUrl이 없는 경우 채널 영역을 렌더링하지 않도록 합니다.
   */
  if (!channelUrl) {
    return jsx(ChannelWrap, {
      children: jsx(ChannelPlaceholder, {
        type: "error",
        children: "\uCC44\uB110\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
      })
    });
  }
  return jsx(ChannelProvider, {
    channelUrl: channelUrl,
    onLeaveChannel: props.onLeaveChannel,
    searchQuery: _searchPayload === null || _searchPayload === void 0 ? void 0 : _searchPayload.searchQuery,
    searchWithTimestamp: _searchPayload === null || _searchPayload === void 0 ? void 0 : _searchPayload.searchWithTimestamp,
    onCloseSearchMode: function () {
      var _a;
      (_a = props.onCloseSearchMode) === null || _a === void 0 ? void 0 : _a.call(props);
      _setSearchPayload(null);
    },
    onSearchPayloadChange: function (searchQuery, searchWithTimestamp) {
      var _a;
      (_a = props.onSearchPayloadChange) === null || _a === void 0 ? void 0 : _a.call(props, searchQuery, searchWithTimestamp);
      _setSearchPayload({
        searchQuery: searchQuery,
        searchWithTimestamp: searchWithTimestamp
      });
    },
    children: jsx(ChannelSuspense, {
      style: props.style,
      children: jsx(MessageSelectProvider, {
        children: jsx(ChannelContainer, __assign$1({}, props))
      })
    })
  });
};
var ChannelSuspense = function (props) {
  var children = props.children,
    style = props.style;
  var _a = useContext(ChatRootContext),
    sb = _a.sb,
    connected = _a.connected,
    userId = _a.userId;
  var _b = useContext(ChannelContext),
    channelWrapRef = _b.channelWrapRef,
    channel = _b.channel,
    isLoading = _b.isLoading,
    isFailed = _b.isFailed,
    searchWithTimestamp = _b.searchWithTimestamp;
  var renderContent = function () {
    if (!sb || !connected || !userId) {
      return jsx(ChannelPlaceholder, {
        type: "error",
        children: "\uC571\uC774 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."
      });
    }
    if (isLoading) {
      return jsx(ChannelPlaceholder, {
        type: "loading",
        children: "\uCC44\uB110 \uC811\uC18D \uC911"
      });
    }
    if (isFailed) {
      return jsx(ChannelPlaceholder, {
        type: "error",
        children: "\uCC44\uB110\uC5D0 \uC811\uC18D\uD558\uB294 \uC911\uC5D0 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."
      });
    }
    if (!channel) {
      return jsx(ChannelPlaceholder, {
        type: "no-channel",
        children: "\uCC44\uB110\uC744 \uCC3E\uC744 \uC218 \uC5C6\uAC70\uB098 \uC811\uADFC \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
      });
    }
    return jsx(ChannelMessagesProvider, {
      sdk: sb,
      channel: channel,
      startingPoint: searchWithTimestamp,
      children: children
    });
  };
  return jsx(ChannelWrap, {
    className: "chat-channel-wrapper",
    ref: channelWrapRef,
    style: style,
    children: renderContent()
  });
};
var ChannelContainer = function (props) {
  var _a = props.showHeader,
    showHeader = _a === void 0 ? true : _a,
    renderHeader = props.renderHeader,
    onClose = props.onClose,
    onClickImage = props.onClickImage;
  var _b = useContext(ChannelContext),
    channel = _b.channel,
    isLoading = _b.isLoading,
    isFailed = _b.isFailed,
    scrollRef = _b.scrollRef,
    asideRef = _b.asideRef,
    headerRef = _b.headerRef,
    footerRef = _b.footerRef,
    asideKey = _b.asideKey,
    toScrollBottom = _b.toScrollBottom,
    setAsideKey = _b.setAsideKey,
    searchWithTimestamp = _b.searchWithTimestamp,
    searchQuery = _b.searchQuery;
    _b.onCloseSearchMode;
  var messageDataSource = useChannelMessagesContext().messageDataSource;
  var renderAside = function () {
    switch (asideKey) {
      case 'search':
        return jsx(ChannelSearch, {
          channel: channel,
          onClose: function () {
            return setAsideKey(null);
          }
        });
      case 'info':
        return jsx(ChannelInfo, {
          channel: channel,
          onClose: function () {
            return setAsideKey(null);
          }
        });
      default:
        return jsx(Fragment, {});
    }
  };
  return jsxs(ChannelSearchProvider, {
    channel: channel,
    children: [jsxs(ChannelConversationArea, {
      children: [jsx(HeaderSpace, {
        ref: headerRef,
        className: "chat-header-space",
        children: showHeader ? renderHeader ? renderHeader({
          channel: channel,
          isLoading: isLoading,
          isFailed: isFailed,
          onChangeAside: setAsideKey
        }) : jsx(ChannelHeader, {
          loading: isLoading,
          channel: channel,
          name: channel === null || channel === void 0 ? void 0 : channel.name,
          memberCount: channel === null || channel === void 0 ? void 0 : channel.memberCount,
          members: channel === null || channel === void 0 ? void 0 : channel.members,
          onClose: onClose,
          onChangeAside: setAsideKey
        }) : null
      }), jsx(ChannelConversation, {
        scrollRef: scrollRef,
        messages: messageDataSource.messages,
        loading: messageDataSource.loading || isLoading,
        highlightMessageTimestamp: searchWithTimestamp,
        onClickImage: onClickImage
      }), jsx(FooterSpace, {
        ref: footerRef,
        className: "chat-footer-space",
        children: searchQuery ? jsx(ChannelFooterSearchCancel, {}) : jsx(ChannelInput, {
          onSended: toScrollBottom
        })
      })]
    }), jsx(Box, {
      ref: asideRef,
      className: "channel-aside-slot",
      flex: "0 0 auto"
    }), renderAside()]
  });
};

var Container$1 = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: white;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: white;\n"])));
var Header = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 52px;\n  padding: 0 4px;\n  background: white;\n"], ["\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 52px;\n  padding: 0 4px;\n  background: white;\n"])));
var HeaderLeftRight = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  width: 48px;\n"], ["\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  width: 48px;\n"])));
var HeaderBack = styled.button(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n\n  cursor: pointer;\n  padding: 0;\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n\n  cursor: pointer;\n  padding: 0;\n  border: none;\n  outline: none;\n  background: none;\n"])));
var HeaderTitle = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  color: #262626;\n  font-size: 1.125rem;\n  font-weight: 500;\n  line-height: 26px;\n  text-align: center;\n  letter-spacing: -0.54px;\n"], ["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  color: #262626;\n  font-size: 1.125rem;\n  font-weight: 500;\n  line-height: 26px;\n  text-align: center;\n  letter-spacing: -0.54px;\n"])));
var BottomCTAArea = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  flex: 0 0 auto;\n  width: 100%;\n  padding: 0 1rem 1.5rem;\n  background: white;\n"], ["\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  flex: 0 0 auto;\n  width: 100%;\n  padding: 0 1rem 1.5rem;\n  background: white;\n"])));
var Body = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  flex: 1;\n  overflow: auto;\n  ", "\n"], ["\n  flex: 1;\n  overflow: auto;\n  ", "\n"])), chatCustomScrollBar);
var templateObject_1$4, templateObject_2$4, templateObject_3$4, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$1;

var InputLabel = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 1rem;\n"], ["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 1rem;\n"])));
var StyledInputWrapper = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  position: relative;\n  height: 40px;\n"], ["\n  position: relative;\n  height: 40px;\n"])));
var StyledInput = styled.input(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  height: 40px;\n  padding-right: 1.75rem;\n  padding: 0 1.75rem 0 0;\n  border: none;\n  outline: none;\n  background: none;\n  border-bottom: 1px solid #eeeeee;\n  border-radius: 0;\n\n  color: #262626;\n  font-size: 1rem;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #bfbfbf;\n    font-size: 1rem;\n    font-weight: 400;\n  }\n  &:focus {\n    border-color: #1890ff;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  height: 40px;\n  padding-right: 1.75rem;\n  padding: 0 1.75rem 0 0;\n  border: none;\n  outline: none;\n  background: none;\n  border-bottom: 1px solid #eeeeee;\n  border-radius: 0;\n\n  color: #262626;\n  font-size: 1rem;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #bfbfbf;\n    font-size: 1rem;\n    font-weight: 400;\n  }\n  &:focus {\n    border-color: #1890ff;\n  }\n"])));
var ClearButton = styled.button(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n\n  position: absolute;\n  top: 8px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n\n  position: absolute;\n  top: 8px;\n  right: 0;\n  width: 24px;\n  height: 24px;\n"])));
var ListTitle = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  padding-left: 1rem;\n  padding-bottom: 0.5rem;\n"], ["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  padding-left: 1rem;\n  padding-bottom: 0.5rem;\n"])));
var List$2 = styled.ul(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"])));
var StyledListItem$1 = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n"])));
var ListItemBody = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-left: 6px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-left: 6px;\n"])));
var ListItemCompany = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  color: #414c5c;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.28px;\n"], ["\n  color: #414c5c;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.28px;\n"])));
var ListItemName = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.32px;\n"], ["\n  color: #2c384a;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: -0.32px;\n"])));
var templateObject_1$3, templateObject_2$3, templateObject_3$3, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var ProfileSetting = function (props) {
  var defaultChannelName = props.defaultChannelName,
    channelName = props.channelName,
    users = props.users,
    onChange = props.onChange;
  var locale = useLocale().locale;
  return jsxs(Fragment, {
    children: [jsxs(Box, {
      p: "1rem 1rem 1.5rem",
      children: [jsx(InputLabel, {
        children: locale.channel_create_profile_name_input_label
      }), jsxs(StyledInputWrapper, {
        children: [jsx(StyledInput, {
          value: channelName,
          onChange: function (e) {
            return onChange(e.target.value);
          },
          placeholder: defaultChannelName
        }), jsx(ClearButton, {
          children: jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            children: [jsx("circle", {
              cx: "12",
              cy: "12",
              r: "8",
              fill: "#D9D9D9"
            }), jsx("path", {
              d: "M9 15.0003L15 9M15 15.0003L9 9",
              stroke: "white",
              strokeWidth: "1.3",
              strokeLinecap: "round"
            })]
          })
        })]
      })]
    }), jsx(ListTitle, {
      children: locale.channel_create_profile_members_title
    }), jsx(List$2, {
      children: users.map(function (user) {
        return jsx(ListItem$2, {
          thumbnail: user.thumbnailUrl,
          companyName: user.companyName,
          name: user.name
        }, user._id);
      })
    })]
  });
};
var ListItem$2 = function (props) {
  var thumbnail = props.thumbnail,
    companyName = props.companyName,
    name = props.name;
  return jsx("li", {
    children: jsxs(StyledListItem$1, {
      children: [jsx(Avatar, {
        src: thumbnail,
        name: name
      }), jsxs(ListItemBody, {
        children: [jsx(ListItemCompany, {
          children: companyName
        }), jsx(ListItemName, {
          children: name
        })]
      })]
    })
  });
};

var List$1 = styled.ul(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n"])));
var StyledListItem = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n\n  transition: 250ms ease;\n  &:hover {\n    background: #f9f9f9;\n  }\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n\n  transition: 250ms ease;\n  &:hover {\n    background: #f9f9f9;\n  }\n"])));
var ChipButtonGrid = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0.5rem 1rem 1rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 1px solid #eeeeee;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0.5rem 1rem 1rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 1px solid #eeeeee;\n"])));
var ChipButton = styled.button(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0 13px;\n  height: 32px;\n  gap: 6px;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: #f5f5f5;\n  border-radius: 6px;\n\n  color: #505050;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: -0.42px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0 13px;\n  height: 32px;\n  gap: 6px;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: #f5f5f5;\n  border-radius: 6px;\n\n  color: #505050;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  letter-spacing: -0.42px;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$2, templateObject_4$1;

var SelectMember = function (props) {
  var userIds = props.userIds,
    onChange = props.onChange;
  var locale = useLocale().locale;
  var myUserId = useContext(ChatRootContext).userId;
  var _a = useContext(ChatContext).invitableUsers,
    invitableUsers = _a === void 0 ? [] : _a;
  var _b = useState(''),
    search = _b[0],
    setSearch = _b[1];
  var handleToggle = function (id) {
    var alreadyExist = userIds.find(function (userId) {
      return userId === id;
    });
    if (alreadyExist) {
      onChange(userIds.filter(function (userId) {
        return userId !== id;
      }));
      return;
    }
    onChange(__spreadArray(__spreadArray([], userIds, true), [id], false));
  };
  var renderList = function () {
    if (!invitableUsers.length) return jsx(Box, {
      py: "5rem",
      color: "#BFBFBF",
      textAlign: "center",
      children: locale.channel_create_select_members_empty
    });
    return jsx(List$1, {
      children: invitableUsers.map(function (item) {
        var _a;
        if (myUserId === item._id) return null;
        if (search) {
          var nameMatched = item.name.includes(search);
          var companyMatched = (_a = item.companyName) === null || _a === void 0 ? void 0 : _a.includes(search);
          if (!nameMatched && !companyMatched) return null;
        }
        var isChecked = !!userIds.find(function (id) {
          return id === item._id;
        });
        return jsx(ListItem$1, {
          item: item,
          checked: isChecked,
          onClick: function () {
            return handleToggle(item._id);
          }
        }, item._id);
      })
    });
  };
  return jsxs(Fragment, {
    children: [jsx(Box, {
      pt: "10px",
      px: "1rem",
      mb: "0.5rem",
      children: jsx(InputSearch, {
        value: search,
        placeholder: locale.channel_create_select_members_search_placeholder,
        onChange: setSearch,
        onSearch: setSearch
      })
    }), !!userIds.length && jsx(ChipButtonGrid, {
      children: userIds.map(function (id) {
        var data = invitableUsers.find(function (e) {
          return e._id === id;
        });
        return jsxs(ChipButton, {
          onClick: function () {
            return handleToggle(id);
          },
          children: [jsx("span", {
            children: data === null || data === void 0 ? void 0 : data.name
          }), jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            children: jsx("path", {
              d: "M2.00006 10L10.0001 2M10.0001 10L2.00006 2",
              stroke: "#505050",
              strokeWidth: "1.5",
              strokeLinecap: "round"
            })
          })]
        }, id);
      })
    }), renderList()]
  });
};
var ListItem$1 = function (props) {
  var item = props.item,
    checked = props.checked,
    onClick = props.onClick;
  return jsx("li", {
    children: jsxs(StyledListItem, {
      onClick: onClick,
      children: [jsx(Avatar, {
        size: 40,
        src: item.thumbnailUrl,
        name: item.name
      }), jsxs(Box, {
        flex: 1,
        pl: "6px",
        pr: "1rem",
        children: [jsx(Box, {
          color: "#414C5C",
          fontSize: "14px",
          lineHeight: "18px",
          letterSpacing: "-0.28px",
          mb: "2px",
          children: item.companyName
        }), jsx(Box, {
          fontSize: "1rem",
          fontWeight: 500,
          lineHeight: "20px",
          letterSpacing: "-0.32px",
          children: item.name
        })]
      }), jsx(Box, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "20px",
        height: "20px",
        borderRadius: "100%",
        border: "1px solid ".concat(checked ? 'var(--chat-color-primary)' : '#D9D9D9'),
        background: checked ? 'var(--chat-color-primary)' : 'white',
        children: jsx("svg", {
          width: "13",
          height: "9",
          viewBox: "0 0 13 9",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            d: "M1 3.74286L4.42857 7.17143L11.2 1",
            stroke: checked ? 'white' : '#EEEEEE',
            strokeWidth: "1.8",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        })
      })]
    })
  }, item._id);
};

var ChannelCreate = function (props) {
  var onClose = props.onClose,
    onCreated = props.onCreated;
  var _a = useContext(ChatRootContext),
    locale = _a.locale,
    myUserId = _a.userId,
    sb = _a.sb;
  var _b = useContext(ChatContext),
    createChannelType = _b.createChannelType,
    _c = _b.invitableUsers,
    invitableUsers = _c === void 0 ? [] : _c,
    setChannelUrl = _b.setChannelUrl;
  var refetch = useContext(ChannelsDispatchContext).refetch;
  var createChannel = useCreateChannel().createChannel;
  var _d = useState(0),
    step = _d[0],
    setStep = _d[1];
  var axios = useFetch();
  var _e = useState(''),
    channelName = _e[0],
    setChannelName = _e[1];
  var _f = useState([]),
    userIds = _f[0],
    setUserIds = _f[1];
  var defaultChannelName = useMemo(function () {
    var _a;
    var memberNames = __spreadArray([((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || 'Me'], userIds.map(function (id) {
      var _a;
      return (_a = invitableUsers.find(function (e) {
        return e._id === id;
      })) === null || _a === void 0 ? void 0 : _a.name;
    }), true);
    var remains = memberNames.length - 3;
    var hasRemains = remains > 0;
    var prefix = "".concat(memberNames.slice(0, 3).toString().replaceAll(',', ', '));
    if (hasRemains) {
      return "".concat(prefix, " \uC678 ").concat(remains, "\uBA85");
    }
    return prefix;
  }, [userIds, invitableUsers]);
  var selectedMembers = useMemo(function () {
    var _a, _b, _c, _d, _e;
    var members = userIds.map(function (id) {
      return invitableUsers.find(function (e) {
        return e._id === id;
      });
    });
    return __spreadArray([{
      _id: (_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.userId,
      name: (_b = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _b === void 0 ? void 0 : _b.nickname,
      thumbnailUrl: (_c = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _c === void 0 ? void 0 : _c.profileUrl,
      companyName: (_e = (_d = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _d === void 0 ? void 0 : _d.metaData) === null || _e === void 0 ? void 0 : _e.companyName
    }], members, true);
  }, [userIds, invitableUsers]);
  var getChatList = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (userIds.length !== 1) return [2 /*return*/, []];
            return [4 /*yield*/, axios.get("/sendbird/group-channels", {
              params: {
                limit: 100,
                members_include_in: userIds[0],
                metadata_key: 'type',
                metadata_values: 'GENERAL'
              }
            })];
          case 1:
            res = _a.sent();
            return [2 /*return*/, res.data.data.filter(function (el) {
              return el.member_count === 2;
            })];
        }
      });
    });
  };
  var handleCreateChannel = function () {
    return __awaiter$1(void 0, void 0, void 0, function () {
      var res, groupChannel, newChannel, groupChannel_1, memberNames, messageData, inviteMessage, error_1;
      var _a, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!myUserId || !sb) return [2 /*return*/];
            _c.label = 1;
          case 1:
            _c.trys.push([1, 8,, 9]);
            return [4 /*yield*/, getChatList()];
          case 2:
            res = _c.sent();
            if (!res.length) return [3 /*break*/, 4];
            setChannelUrl(res[0].channel_url);
            onClose();
            return [4 /*yield*/, sb.groupChannel.getChannel(res[0].channel_url)];
          case 3:
            groupChannel = _c.sent();
            onCreated === null || onCreated === void 0 ? void 0 : onCreated(groupChannel);
            return [3 /*break*/, 7];
          case 4:
            return [4 /*yield*/, createChannel({
              channelName: channelName || defaultChannelName,
              user_ids: __spreadArray([myUserId], userIds, true),
              type: createChannelType || 'GENERAL'
            })];
          case 5:
            newChannel = _c.sent();
            return [4 /*yield*/, sb.groupChannel.getChannel(newChannel._id)];
          case 6:
            groupChannel_1 = _c.sent();
            memberNames = __spreadArray([((_a = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _a === void 0 ? void 0 : _a.nickname) || 'Me'], userIds.map(function (id) {
              var _a;
              return (_a = invitableUsers.find(function (e) {
                return e._id === id;
              })) === null || _a === void 0 ? void 0 : _a.name;
            }), true);
            messageData = memberNames.toString().replaceAll(',', ', ');
            inviteMessage = locale.channel_member_invite_message_format.replace('{{inviter}}', ((_b = sb === null || sb === void 0 ? void 0 : sb.currentUser) === null || _b === void 0 ? void 0 : _b.nickname) || '').replace('{{members}}', messageData);
            groupChannel_1.sendUserMessage({
              customType: 'invite',
              message: inviteMessage,
              data: messageData
            }).onSucceeded(function () {
              return __awaiter$1(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      setChannelUrl(groupChannel_1.url);
                      return [4 /*yield*/, refetch()];
                    case 1:
                      _a.sent();
                      onClose();
                      onCreated === null || onCreated === void 0 ? void 0 : onCreated(groupChannel_1);
                      return [2 /*return*/];
                  }
                });
              });
            });

            _c.label = 7;
          case 7:
            return [3 /*break*/, 9];
          case 8:
            error_1 = _c.sent();
            console.error(error_1);
            return [3 /*break*/, 9];
          case 9:
            return [2 /*return*/];
        }
      });
    });
  };

  var renderStep = function () {
    switch (step) {
      case 0:
        return jsx(PageTemplate, {
          title: locale.channel_create_select_members_title,
          onClose: onClose,
          submitText: locale.channel_create_select_members_submit,
          submitDisabled: !userIds.length,
          onSubmit: function () {
            if (!userIds.length) {
              message.error('초대할 대화상대를 선택해주세요.');
              return;
            }
            setStep(1);
          },
          children: jsx(SelectMember, {
            userIds: userIds,
            onChange: setUserIds
          })
        });
      case 1:
        return jsx(PageTemplate, {
          title: locale.channel_create_profile_title,
          onClose: function () {
            return setStep(0);
          },
          submitText: locale.channel_create_profile_submit,
          onSubmit: function () {
            handleCreateChannel();
          },
          children: jsx(ProfileSetting, {
            users: selectedMembers,
            defaultChannelName: defaultChannelName,
            channelName: channelName,
            onChange: setChannelName
          })
        });
    }
  };
  return jsx(Fragment, {
    children: renderStep()
  });
};
var PageTemplate = function (props) {
  var title = props.title,
    children = props.children,
    submitText = props.submitText,
    submitDisabled = props.submitDisabled,
    onClose = props.onClose,
    onSubmit = props.onSubmit;
  return jsxs(Container$1, {
    children: [jsxs(Header, {
      children: [jsx(HeaderLeftRight, {
        children: jsx(HeaderBack, {
          onClick: onClose,
          children: jsx("svg", {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: jsx("path", {
              d: "M28 32L20 24L28 16",
              stroke: "#404040",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })
        })
      }), jsx(HeaderTitle, {
        children: title
      }), jsx(HeaderLeftRight, {})]
    }), jsx(Body, {
      children: children
    }), jsx(BottomCTAArea, {
      children: jsx(Button$1, {
        block: true,
        color: "primary",
        variant: "fill",
        disabled: submitDisabled,
        onClick: onSubmit,
        style: {
          height: '52px',
          textAlign: 'center',
          borderRadius: '6px',
          '--accent-color': submitDisabled ? '#BFBFBF' : '#1890FF'
        },
        children: submitText
      })
    })]
  });
};

var ChannelListUl = styled.ul(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"])));
var ChannelListItemWrap = styled.a(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  gap: 8px;\n\n  color: #2c384a;\n  font-size: 1rem;\n\n  transition: 250ms ease;\n\n  &:hover,\n  &.active {\n    background-color: #f9f9f9;\n  }\n\n  .title-area {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    margin-right: 0.25rem;\n\n    .title {\n      color: #2c384a;\n      font-weight: 500 !important;\n      font-size: 1rem;\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      margin: 0;\n\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      min-width: 0;\n    }\n\n    .member-count {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      color: #bfbfbf;\n      bottom: 0;\n    }\n  }\n\n  .last-message {\n    flex: 1;\n    color: #7f8892;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    word-break: break-all;\n\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    min-width: 0;\n    margin: 0;\n  }\n\n  .date {\n    flex: 0 0 auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    text-align: right;\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n  }\n\n  .badge {\n    bottom: initial;\n\n    height: 18px;\n    min-width: 18px;\n    line-height: 18px;\n    color: white;\n    font-size: 12px;\n    font-weight: 700;\n    text-align: center;\n    letter-spacing: -0.02em;\n    background-color: #f72585;\n    padding: 0 5px;\n    border-radius: 18px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  gap: 8px;\n\n  color: #2c384a;\n  font-size: 1rem;\n\n  transition: 250ms ease;\n\n  &:hover,\n  &.active {\n    background-color: #f9f9f9;\n  }\n\n  .title-area {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    margin-right: 0.25rem;\n\n    .title {\n      color: #2c384a;\n      font-weight: 500 !important;\n      font-size: 1rem;\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      margin: 0;\n\n      text-overflow: ellipsis;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      min-width: 0;\n    }\n\n    .member-count {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      color: #bfbfbf;\n      bottom: 0;\n    }\n  }\n\n  .last-message {\n    flex: 1;\n    color: #7f8892;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 18px;\n    letter-spacing: -0.02em;\n    word-break: break-all;\n\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    min-width: 0;\n    margin: 0;\n  }\n\n  .date {\n    flex: 0 0 auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    text-align: right;\n    letter-spacing: -0.02em;\n\n    color: #7f8892;\n  }\n\n  .badge {\n    bottom: initial;\n\n    height: 18px;\n    min-width: 18px;\n    line-height: 18px;\n    color: white;\n    font-size: 12px;\n    font-weight: 700;\n    text-align: center;\n    letter-spacing: -0.02em;\n    background-color: #f72585;\n    padding: 0 5px;\n    border-radius: 18px;\n  }\n"])));
var HeaderIcon = styled.button(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1;

var ChannelListHeaderCreate = function (props) {
  var onClick = props.onClick;
  return jsx(HeaderIcon, {
    onClick: onClick,
    children: jsxs("svg", {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M24 31.8149C23.0091 31.8164 22.0224 31.6855 21.065 31.4256C20.3362 31.8022 18.66 32.525 15.84 32.9958C15.5912 33.0365 15.4 32.7719 15.4987 32.5352C15.9412 31.4714 16.3412 30.0538 16.4625 28.761C14.9287 27.1958 14 25.1471 14 22.9075C14 17.988 18.4775 14 24 14C29.5225 14 34 17.988 34 22.9075",
        stroke: "#1890FF",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M31.25 26.25V33.75",
        stroke: "#1890FF",
        strokeWidth: "1.8",
        strokeLinecap: "round"
      }), jsx("path", {
        d: "M27.5 30H35",
        stroke: "#1890FF",
        strokeWidth: "1.8",
        strokeLinecap: "round"
      })]
    })
  });
};

var ChannelTypeIcon = function (props) {
  var type = props.type;
  var color = useMemo(function () {
    switch (type) {
      case 'PROJECT':
        return '#F73A91';
      case 'ESTIMATE':
        return '#FAAD14';
      case 'GENERAL':
      default:
        return '#06D6A6';
    }
  }, [type]);
  var icon = useMemo(function () {
    switch (type) {
      case 'PROJECT':
        return jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "11",
          height: "12",
          viewBox: "0 0 11 12",
          fill: "none",
          children: [jsx("path", {
            d: "M0.75 4.51539C0.75 4.43816 0.785695 4.36527 0.846704 4.31791L5.0872 1.02627C5.18174 0.952886 5.31503 0.956798 5.40511 1.0356L9.66461 4.76212C9.71887 4.80959 9.75 4.87818 9.75 4.95027V10.1792C9.75 10.3173 9.63807 10.4292 9.5 10.4292H0.999998C0.861928 10.4292 0.75 10.3173 0.75 10.1792V4.51539Z",
            stroke: "white",
            strokeWidth: "1.3"
          }), jsx("path", {
            d: "M6.83821 10.5178V7.87071C6.83821 6.99355 6.12714 6.28247 5.24998 6.28247V6.28247C4.37282 6.28247 3.66174 6.99355 3.66174 7.87071V10.5178",
            stroke: "white",
            strokeWidth: "1.3"
          })]
        });
      case 'ESTIMATE':
        return jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "8",
          height: "14",
          viewBox: "0 0 8 14",
          fill: "none",
          children: [jsx("path", {
            d: "M6.75 2.875H3.3125C2.76549 2.875 2.24089 3.09228 1.85409 3.47904C1.4673 3.86581 1.25 4.39037 1.25 4.93733C1.25 5.4843 1.4673 6.00886 1.85409 6.39562C2.24089 6.78238 2.76549 6.99966 3.3125 6.99966H4.6875C5.23451 6.99966 5.75911 7.21694 6.14591 7.60371C6.5327 7.99047 6.75 8.51503 6.75 9.062C6.75 9.60896 6.5327 10.1335 6.14591 10.5203C5.75911 10.907 5.23451 11.1243 4.6875 11.1243H2.96875H1.25",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), jsx("path", {
            d: "M3.9989 11.1245V12.4993M3.9989 1.50024V2.87513",
            stroke: "white",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        });
      case 'GENERAL':
      default:
        return jsx("svg", {
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: jsx("path", {
            d: "M1.5 10.4113L1.65857 9.5327C1.8459 8.5181 2.38274 7.6011 3.17585 6.94113C3.96895 6.28113 4.9682 5.9198 6 5.91992C7.033 5.92017 8.0333 6.28271 8.8265 6.94442C9.6198 7.6061 10.1559 8.5251 10.3414 9.5413L10.5 10.4199M5.99978 5.91138C7.356 5.91138 8.4555 4.81193 8.4555 3.45569C8.4555 2.09945 7.356 1 5.99978 1C4.64353 1 3.54407 2.09945 3.54407 3.45569C3.54407 4.81193 4.64353 5.91138 5.99978 5.91138Z",
            stroke: "white",
            strokeWidth: "1.5",
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });
    }
  }, [type]);
  return jsx(Box, {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: "18px",
    height: "18px",
    borderRadius: "100%",
    background: color,
    children: icon
  });
};

var Dialog = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 250px;\n  background: white;\n  border-radius: 6px;\n"], ["\n  width: 100%;\n  max-width: 250px;\n  background: white;\n  border-radius: 6px;\n"])));
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n\n  &.enter {\n    opacity: 0;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  background: rgba(0 0 0 / 50%);\n\n  &.enter {\n    opacity: 0;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n    }\n  }\n  &.enter-active {\n    opacity: 1;\n    transition: opacity 200ms;\n\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n  &.exit {\n    opacity: 1;\n    ", " {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &.exit-active {\n    opacity: 0;\n    transition: opacity 200ms;\n    ", " {\n      opacity: 0;\n      transform: translateY(1rem);\n      transition-property: opacity, transform;\n      transition-timing-function: ease;\n      transition-duration: 200ms;\n    }\n  }\n"])), Dialog, Dialog, Dialog, Dialog);
var DialogHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 12px 0;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 12px 0;\n"])));
var DialogHeaderClose = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  background: none;\n"])));
var List = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px 24px;\n  margin: 0;\n  gap: 20px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px 24px;\n  margin: 0;\n  gap: 20px;\n"])));
var ListItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #414c5c;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: -0.42px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #414c5c;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: -0.42px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

/**
 * 누르면 채팅방 아이콘을 설명하는 Modal을 띄웁니다.
 */
var ChannelListHeaderHelp = function () {
  var locale = useContext(ChatRootContext).locale;
  var _a = useState(false),
    visible = _a[0],
    setVisible = _a[1];
  var nodeRef = useRef(null);
  var root = document.body;
  return jsxs(Fragment, {
    children: [jsx(HeaderIcon, {
      onClick: function () {
        return setVisible(true);
      },
      children: jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        children: [jsx("path", {
          d: "M24 34.5C29.799 34.5 34.5 29.799 34.5 24C34.5 18.201 29.799 13.5 24 13.5C18.201 13.5 13.5 18.201 13.5 24C13.5 29.799 18.201 34.5 24 34.5Z",
          stroke: "#9E9E9E",
          strokeWidth: "1.8",
          strokeMiterlimit: "10",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M24.3998 28.5V22.5H22.9",
          stroke: "#9E9E9E",
          strokeWidth: "1.8",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M22.4 28.5701H26.22",
          stroke: "#9E9E9E",
          strokeWidth: "1.8",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), jsx("path", {
          d: "M23.7998 19.03H24.3998",
          stroke: "#9E9E9E",
          strokeWidth: "1.8",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      })
    }), createPortal(jsx(CSSTransition, {
      nodeRef: nodeRef,
      in: visible,
      timeout: 200,
      unmountOnExit: true,
      children: jsx(Container, {
        ref: nodeRef,
        onClick: function () {
          return setVisible(false);
        },
        children: jsxs(Dialog, {
          children: [jsx(DialogHeader, {
            children: jsx(DialogHeaderClose, {
              children: jsxs("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [jsx("path", {
                  d: "M6 6L18 17.9998",
                  stroke: "#404040",
                  strokeWidth: "1.5",
                  strokeLinecap: "round"
                }), jsx("path", {
                  d: "M18.0002 6L6.00018 17.9998",
                  stroke: "#404040",
                  strokeWidth: "1.5",
                  strokeLinecap: "round"
                })]
              })
            })
          }), jsxs(List, {
            children: [jsxs(ListItem, {
              children: [jsx(ChannelTypeIcon, {
                type: "PROJECT"
              }), jsx("span", {
                children: locale.channel_meta_type_project
              })]
            }), jsxs(ListItem, {
              children: [jsx(ChannelTypeIcon, {
                type: "GENERAL"
              }), jsx("span", {
                children: locale.channel_meta_type_general
              })]
            }), jsxs(ListItem, {
              children: [jsx(ChannelTypeIcon, {
                type: "ESTIMATE"
              }), jsx("span", {
                children: locale.channel_meta_type_estimate
              })]
            })]
          })]
        })
      })
    }), root)]
  });
};

var ChannelListItem = function (props) {
  var active = props.active;
    props.thumbnailUrl;
    var title = props.title,
    unreadMessageCount = props.unreadMessageCount,
    lastMessage = props.lastMessage,
    memberCount = props.memberCount,
    channelMetaType = props.channelMetaType,
    onClick = props.onClick;
  var _a = useContext(ChatRootContext),
    language = _a.language,
    locale = _a.locale;
  /**
   * 오늘로부터 지난 일수에 따라 다르게 날짜 표현
   * @param timestamp
   * @returns
   */
  var formatDateFromNow = function (timestamp) {
    /**
     * 4개월 이상
     */
    if (dayjs_minExports().diff(timestamp, 'month') > 4) {
      return new Intl.DateTimeFormat(language, {
        dateStyle: 'short'
      }).format(timestamp);
    }
    /**
     * 오늘로부터 하루 경과
     */
    if (dayjs_minExports().diff(timestamp, 'day') > 0) {
      return new Intl.DateTimeFormat(language, {
        month: 'short',
        day: 'numeric'
      }).format(timestamp);
    }
    /**
     * 오늘
     */
    return dayjs_minExports(timestamp).locale(locale.dayjsLocale).format('LT');
  };
  return jsx(ChannelListItemWrap, {
    className: active ? 'active' : '',
    onClick: onClick,
    children: jsxs(Box, {
      flex: 1,
      children: [jsxs(Box, {
        display: "flex",
        alignItems: "center",
        mb: "6px",
        style: {
          gap: '8px'
        },
        children: [jsxs("div", {
          className: "title-area",
          children: [jsxs("h3", {
            className: "title",
            children: [jsx(ChannelTypeIcon, {
              type: channelMetaType
            }), jsx(Box, {
              ml: "5px",
              as: "span",
              children: title
            })]
          }), jsx("sub", {
            className: "member-count",
            children: memberCount
          })]
        }), (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.created_at) ? jsx("time", {
          className: "date",
          children: formatDateFromNow(lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.created_at)
        }) : null]
      }), jsxs(Box, {
        display: "flex",
        alignItems: "flex-start",
        children: [jsx("p", {
          className: "last-message",
          children: (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message) || ''
        }), !!unreadMessageCount && jsx("sub", {
          className: "badge",
          children: unreadMessageCount > 99 ? '99+' : unreadMessageCount
        })]
      })]
    })
  });
};

var ChannelListSearch = function () {
  var _a = useState(''),
    search = _a[0],
    setSearch = _a[1];
  var locale = useLocale().locale;
  var setSearchParams = useContext(ChannelsDispatchContext).setSearchParams;
  return jsx(Box, {
    p: "0.5rem 1rem",
    children: jsx(InputSearch, {
      placeholder: locale.channel_list_search_placeholder,
      value: search,
      onChange: setSearch,
      onSearch: function (value) {
        setSearchParams(function (prev) {
          return __assign$1(__assign$1({}, prev), {
            name_contains: value
          });
        });
      }
    })
  });
};

var ChannelList = function (props) {
  var fallback = props.fallback,
    style = props.style,
    onClickItem = props.onClickItem,
    onClickCreateChannel = props.onClickCreateChannel;
  var _a = useContext(ChatContext),
    channelUrl = _a.channelUrl,
    setChannelUrl = _a.setChannelUrl;
  var _b = useContext(ChannelsStateContext),
    channels = _b.channels,
    isFetching = _b.isFetching,
    isLast = _b.isLast,
    searchParams = _b.searchParams;
  var fetchNext = useContext(ChannelsDispatchContext).fetchNext;
  var handleClickItem = function (channel) {
    setChannelUrl(channel.channel_url);
    onClickItem && onClickItem(channel);
  };
  var renderListInside = function () {
    if (!isFetching && !channels.length) {
      if (fallback) return fallback;
      if (searchParams === null || searchParams === void 0 ? void 0 : searchParams.name_contains) {
        return jsx(Result, {
          withSpace: true,
          size: "small",
          status: "empty",
          icon: jsx("svg", {
            width: "50",
            height: "50",
            viewBox: "0 0 50 50",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: jsx("path", {
              d: "M15.3125 36.2506L20.9375 30.6253M20.9375 30.6253L26.5625 25.0001M20.9375 30.6253L26.5625 36.2506M20.9375 30.6253L15.3125 25.0001M34.8036 38.2583H42.0416C42.3868 38.2583 42.6666 37.9785 42.6666 37.6333V9.34562C42.6666 9.17874 42.5999 9.01879 42.4813 8.9014L36.9623 3.43908C36.8453 3.32327 36.6873 3.2583 36.5227 3.2583H15.7916C15.4464 3.2583 15.1666 3.53812 15.1666 3.8833V11.0406M34.7083 18.4092C31.7792 18.4092 27.5 18.4092 27.5 18.4092V11.2166M28.5643 11.2166H7.83325C7.48807 11.2166 7.20825 11.4964 7.20825 11.8416V45.5916C7.20825 45.9368 7.48807 46.2166 7.83325 46.2166H34.0833C34.4284 46.2166 34.7083 45.9368 34.7083 45.5916V17.3039C34.7083 17.137 34.6415 16.9771 34.5229 16.8597L29.0039 11.3974C28.8869 11.2816 28.7289 11.2166 28.5643 11.2166Z",
              stroke: "#BFBFBF",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          }),
          title: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
        });
      }
      return jsx(Result, {
        withSpace: true,
        size: "small",
        icon: jsxs("svg", {
          width: "50",
          height: "50",
          viewBox: "0 0 50 50",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [jsx("path", {
            d: "M25 42.5675C36.5973 42.5675 46 34.3816 46 24.2838C46 14.1859 36.5973 6 25 6C13.4027 6 4 14.1859 4 24.2838C4 28.8808 5.95038 33.0861 9.17125 36.2988C8.91663 38.9526 8.07663 41.8623 7.14738 44.0459C6.94 44.5317 7.34163 45.075 7.864 44.9914C13.786 44.025 17.3061 42.5414 18.8365 41.7683C20.847 42.3018 22.9192 42.5705 25 42.5675Z",
            stroke: "#BFBFBF",
            strokeWidth: "2"
          }), jsx("path", {
            d: "M19.375 30.1255L30.625 18.875M30.625 30.1255L19.375 18.875",
            stroke: "#BFBFBF",
            strokeWidth: "2",
            strokeLinecap: "round"
          })]
        }),
        title: "\uC0C8\uB85C\uC6B4 \uCC44\uD305\uBC29\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC138\uC694.",
        children: jsx(Button$1, {
          color: "primary",
          variant: "fill",
          style: {
            '--accent-color': '#1890FF',
            height: 32
          },
          onClick: onClickCreateChannel,
          children: "\uCC44\uD305\uBC29 \uB9CC\uB4E4\uAE30"
        })
      });
    }
    return channels === null || channels === void 0 ? void 0 : channels.map(function (channel) {
      var _a;
      var isActive = channelUrl === channel.channel_url;
      return jsx(ChannelListItem, {
        title: channel.name,
        unreadMessageCount: channel.unread_message_count,
        thumbnailUrl: channel.cover_url,
        active: isActive,
        lastMessage: channel.last_message,
        memberCount: channel.member_count,
        channelMetaType: (_a = channel.metadata) === null || _a === void 0 ? void 0 : _a.type,
        onClick: function () {
          return handleClickItem(channel);
        }
      }, channel.channel_url);
    });
  };
  return jsxs(Fragment, {
    children: [jsx(ChannelListSearch, {}), jsxs(ChannelListUl, {
      style: style,
      children: [renderListInside(), jsx(InfiniteScroll, {
        loadMore: fetchNext,
        hasMore: !isLast
      })]
    })]
  });
};
ChannelList.HeaderHelp = ChannelListHeaderHelp;
ChannelList.HeaderCreate = ChannelListHeaderCreate;

var Chat = function (props) {
  var style = props.style,
    channelProps = __rest$2(props, ["style"]);
  var locale = useContext(ChatRootContext).locale;
  var _a = useState(false),
    createMode = _a[0],
    setCreateMode = _a[1];
  var _b = useState({
      searchQuery: channelProps.searchQuery,
      searchWithTimestamp: channelProps.searchWithTimestamp
    }),
    _searchPayload = _b[0],
    _setSearchPayload = _b[1];
  useEffect(function () {
    _setSearchPayload({
      searchQuery: props.searchQuery,
      searchWithTimestamp: props.searchWithTimestamp
    });
  }, [props.searchQuery, props.searchWithTimestamp]);
  return jsxs(ChatLayout, {
    style: __assign$1({}, style),
    children: [jsx("div", {
      className: "chat-channel-list caas-scroll",
      children: createMode ? jsx(ChannelCreate, {
        onClose: function () {
          return setCreateMode(false);
        }
      }) : jsxs(Fragment, {
        children: [jsxs("div", {
          className: "chat-list-header",
          children: [locale.title, jsx(Box, {
            flex: 1
          }), jsx(ChannelList.HeaderHelp, {}), jsx(ChannelList.HeaderCreate, {
            onClick: function () {
              return setCreateMode(true);
            }
          })]
        }), jsx(ChannelList, {
          onClickCreateChannel: function () {
            return setCreateMode(true);
          },
          onClickItem: function () {
            _setSearchPayload(null);
          }
        })]
      })
    }), jsx("div", {
      className: "chat-channel",
      children: jsx(Channel, __assign$1({}, channelProps, {
        searchQuery: _searchPayload === null || _searchPayload === void 0 ? void 0 : _searchPayload.searchQuery,
        searchWithTimestamp: _searchPayload === null || _searchPayload === void 0 ? void 0 : _searchPayload.searchWithTimestamp,
        onCloseSearchMode: function () {
          var _a;
          (_a = channelProps.onCloseSearchMode) === null || _a === void 0 ? void 0 : _a.call(channelProps);
          _setSearchPayload(null);
        },
        onSearchPayloadChange: function (searchQuery, searchWithTimestamp) {
          var _a;
          (_a = channelProps.onSearchPayloadChange) === null || _a === void 0 ? void 0 : _a.call(channelProps, searchQuery, searchWithTimestamp);
          _setSearchPayload({
            searchQuery: searchQuery,
            searchWithTimestamp: searchWithTimestamp
          });
        }
      }))
    })]
  });
};

export { Channel, ChannelCreate, ChannelList, ChannelMembers, Chat, ChatProvider, ChatRootProvider, UserProfileModal, initialLocale, useChannelListSensor, useChannelSensor, useChatSensor, useMatchProjectId, useMessageSender };
//# sourceMappingURL=index.js.map
